import VueI18n from "vue-i18n";
import Vue from "vue";

Vue.use(VueI18n);

const messages = {
    tr: {
        chatWindow: {
            thereIsNoChatContent: "Sohbet içeriği bulunmuyor.",
            thereIsNoChatContentDsc: "Bu kısımda sohbet içeriğini görebilir ve mesaj gönderebilirsiniz.",
            interactions: "Etkileşimler:",
            departments: "Departmanlar",
            channels: "Kanallar",
            date: "Tarih",
            lastChatStatus: "Son Sohbet Durumu",
            all: "Tümü",
            queued: "Sıraya alındı",
            open: "Açık",
            closed: "Kapalı",
            private: "Özel",
            chatbot: "Sohbet robotu",
            lostMissed: "Kayıp / Kaçırılan",
            interaction: "Etkileşim",
            myActiveInbox: "Aktif Gelen Kutum",
            activeQueueInbox: "Aktif + Kuyruktakiler",
            chatbotActiveInbox: "Chatbot Aktif Kutusu",
            myDepartmentsActiveInbox: "Departmanlarım Kutusu",
            notInteractedYesterday: "Dün Kaçan Kutusu",
            queueInbox: "Kuyruktakiler",
            whatsappActiveInbox: "Whatsapp Kutusu",
            socialMediaActiveInbox: "Sosyal Medya Kutusu",
            missedThisMonth: "Bu Ayki Kaçan Kutusu",
            chooseAFileOrDragItHere: "Bir dosya seçin veya buraya sürükleyin!",
            watching: "İzleniyor",
            selectFilter: "Filtre Seç",
            clearAll: "Hepsini temizle",
            me: "Ben",
            today: "Bugün",
            yesterday: "Dün",
            thisWeek: "Bu Hafta",
            lastWeek: "Geçen Hafta",
            last7Days: "Son 7 Gün",
            last30Days: "Son 30 Gün",
            thisMonth: "Bu Ay",
            lastMonth: "Geçen Ay",
            last24h: "Son 24 Saat",
            custom: "Özel",
            startMessage: "Mesaj Başlat",
            goToAgentReport: "Temsilci Raporuna Git",
            agentDetail: "Temsilci Detay",
            agentList: "Temsilci Listesi",
            selectedFilter: "Seçilen Filtre",
            groupBy: "Grupla",
            none: "Grup Yok",
            agent: "Temsilci",
            department: "Departman",
            sortBy: "Sırala",
            lastPostAbove: "Son Mesaj Üstte",
            newChatsAbove: "Yeni Chatler Üstte",
            oldChatsAbove: "Eski Chatler Üstte",
            live: "Canlı",
            systemStatus: "Sistem Durumu",
            refresh: "Yenile",
            close: "Kapat",
            totalCustomers: "Toplam Müşteri",
            totalAnswered: "Toplam Yanıtlanan",
            waitingAnswer: "Yanıt Bekleyen",
            totalAgentInChat: "Sohbetteki Toplam Temsilci",
            onlineAgentCount: "Çevrimiçi Temsilci Sayısı",
            totalCustomer: "Toplam Müşteri",
            answered: "Yanıtlanan",
            unanswered: "Yanıtlanmayan",
            noContactWasFoundMatchingTheCurrentFilters: "Mevcut filtrelere uygun bir kişi bulunamadı.",
            you: "Sen",
            others: "Diğerleri",
            queue: "Kuyruk",
            chatbotContact: "Chatbot",
            closedContact: "Kapalı",
            myInteractions: "Benim Etkileşimlerim",
            special: "Özel",
            allInteractions: "Tüm kişiler",
            waiting: "Bekleyen",
            departmentToWhichItIsAffiliated: "Bağlandığı Departman",
        },
        automation: {
            blocks: {
                START_POINT: "BAŞLANGIÇ NOKTASI",
                AI_ASSISTANT: "YAPAY ZEKA ASISTAN",
                BOT_RESPONSE: "BOT'UN YANITI",
                AI_BOT_RESPONSE: "YZ YANIT (GPT-4o)",
                AI_CLASSIFICATION: "YZ SINIFLANDIR",
                AI_MENU_FLOW: "Hazır Menü Flow",
                OTP_WHATSAPP_FLOW: "OTP Whatsapp",
                OTP_SMS_FLOW: "OTP SMS",
                OTP_MAIL_FLOW: "OTP MAIL",
                AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
                PLATFORM_FLOW: "PLATFORM",
                DEFAULT_FALLBACK: "VARSAYILAN AKSİ DURUM",
                DEFAULT_TIMEOUT: "VARSAYILAN Zaman Aşımı",
                AI_FUNCTIONS: "YZ FONKSIYON",
                FILTER: "FİLTRE",
                FLOW: "AKIŞ",
                ATTACHMENT_INPUT: "DOSYA GİRİŞİ",
                USER_INPUT: "KULLANICI GİRİŞİ",
                GO_TO_STEP: "ADIM'A GİT",
                WEBHOOK: "WEB HOOK",
                SET_ATTRIBUTE: "ÖZELLİK AYARLA",
                QUESTION: "SORU",
                CLOSE_CHAT: "SOHBETİ KAPAT",
                CREATE_TICKET: "TICKET OLUŞTUR",
                TRANSFER_CHAT: "SOHBETİ AKTAR",
                TRANSFER_TO_CHATBOT: "CHATBOTA YÖNLENDİR",
                TAG_CHAT: "ETIKET EKLE",
                REMOVE_TAG: "ETIKET SIL",
                SET_DEPARTMENT: "DEPARTMANA AYARLA",
                SEND_TRANSCRIPT: "TRANSKRİPT GÖNDER",
                SEND_SMS: "SMS GONDER",
                SEND_MAIL: "MAIL GONDER",
                CREATE_EVENT: "ETKİNLİK OLUŞTUR",
                CREATE_RESERVATION: "REZERVASYON OLUŞTUR",
                RESERVATION_OPEN_URL: "Rezervasyon Ekranı Görüntüle",
                RESERVATION_SELECT_DAY: "Rezervasyon günü seç",
                RESERVATION_EVENT_LIST: "Müşteri Rezervasyon Listesi",
                RESERVATION_SELECT_TIME: "Rezervasyon saati seç",
                CREATE_TASK: "GÖREV OLUŞTUR",
                SHOPIFY_SHOW_PRODUCTS: "SHOPIFY ÜRÜNLERİ GÖSTER",
                SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY ÜRÜN VARLIĞI",
                SHOPIFY_ORDER_STATUS: "MAĞAZA SİPARİŞ DURUMU",

                AKINON_SHOW_PRODUCTS: "AKINON ÜRÜN GÖSTER",
                AKINON_FIND_PRODUCT: "AKINON ÜRÜN BUL",
                AKINON_ORDER_STATUS: "AKINON SİPARİŞ DURUMU",
                AKINON_SELECT_ORDER: "AKINON SİPARİŞ SEÇ",
                AKINON_SELECT_SIZE: "AKINON BEDEN SEÇ",
                AKINON_FIND_NEAREST_STOCK: "MAĞAZA STOK GÖSTER",
                AKINON_FIND_NEAREST_STORES: "YAKIN MAĞAZALARI GÖSTER",
                AKINON_SHOW_DISCOUNT_CODES: "İNDİRİM KODU GÖSTER",

                IDEASOFT_SELECT_ORDER: "SİPARİŞ SEÇ",
                IDEASOFT_ORDER_STATUS: "SİPARİŞ DURUMU ÇEK",
                IDEASOFT_GET_MEMBER_INFO: "ÜYE DETAY GETİR",

                GET_LOCATION: "KONUM AL",
                FALLBACK: "AKSİ DURUM",
                TIMEOUT: "ZAMAN AŞIMI",
                SUCCESS: "BAŞARILI",
                FAILURE: "BAŞARISIZ",

                PROBEL_SELECT_BRANCH: "Branş Seç",
                PROBEL_SELECT_CLINIC: "Poliklinik Seç",
                PROBEL_SELECT_DAY: "Randevu Günü Seç",
                PROBEL_SELECT_HOUR: "Randevu Saati Seç",
                PROBEL_MAKE_APPOINTMENT: "Randevu Oluştur",
                PROBEL_CANCEL_APPOINTMENT: "Randevu İptal",
                PROBEL_GET_PATIENT_TOKEN: "Hasta Token Al",
                PROBEL_FILL_INFO: "MERNIS Bilgi Getir",
                PROBEL_SELECT_APPOINTMENT: "Randevu Seç",
                SUPPRESSION_ADD: "Kullanıcı Engelle",
                SUPPRESSION_REMOVE: "Kullanıcı Engel Kaldır",
                SEND_WP_BUSINESS_MESSAGE: "WHATSAPP MESAJ GÖNDER",
                INSTAGRAM_COMMENT_REPLY: "Yorumu Yanıtla",
                INSTAGRAM_COMMENT_DELETE: "Yorumu Sil",
                INSTAGRAM_COMMENT_SHOW: "Yorumu Göster",
                INSTAGRAM_COMMENT_HIDE: "Yorumu Gizle",
                INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "Yoruma DM Yanıt",

                LOOP: "Döngü",
                LOOP_NEXT: "Sıradaki Veri",
                LOOP_BREAK: "Döngüyü Durdur",
                LOOP_CONTINUE: "Sıradakine Ge.",
                LOOP_FINISH: "Döngü Bitti",
                SLEEP: "Uyu ve Bekle",
                NOOP: "Hiçbirşey Yapma",
                CATCH_WEBHOOK: "Webhook Yakala",
                TERMINATE_AUTOMATION: "Otomasyon Sonlandı",
                CREATE_CONTACT: "Kişi Kartı Oluştur",
                UPDATE_CONTACT: "Kişi Güncelle",
                FIND_CONTACTS: "Kişileri Bul",
                FIND_CONTACT: "Kişi Bul",
                FIND_CHATS: "Görüşmeleri Bul",
                FIND_CHAT: "Görüşme Bul",
                WAIT_FOR: "Mesaj Bekle",
                STRING_FORMAT: "Yazıyı Formatla",
                NUMBER_FORMAT: "Sayıları Formatla",
                DATE_FORMAT: "Tarihleri Formatla",
                RECORDS_FROM_CSV: "CSV Kayıt Topla",
                MESSAGE_RECEIVED: "Mesaj Geldi",
            },
        },
        plans: {
            manageWithChatbot: "Chatbot ile Yönetim",
            manageInbox: "Gelen Kutusu Yönetin",
            commentManagement: "Yorumları Yönetin",
            privateReplyMessage: "Yorumlara Özel'den Yanıt",
            mentionTicket: "Etkileri Ticket'a Dönüştürün",
            week: "Hafta",
            readyContents: "Hazır İçerikler",
            webhookIntegration: "Webhook Entegrasyonu",
            businessChannel: "Whatsapp Business Kanalı",
            confirmationFeature: "Yetkilendirme Özelliği",
            specialReporting: "Özel Rapolama",
            aiAssistant: "Yapay Zeka Asistan",
            flexibleBilling: "Esnek Faturalandırma",
            automaticReservation: "Otomatik Rezervasyon",
            taskManagement: "Görev Yönetimi",
            calendarIntegration: "Takvim Entegrasyonu",
            activeChatbot: "Aktif Chatbot",
            smsIntegration: "SMS Entegrasyonu",
            mailIntegration: "Mail Entegrasyonu",
            startChatWithVisitor: "Ziyaretçi ile Chat Başlatma",
            whatsappManaging: "Whatsapp Yönetimi",
            automaticChatbotButton: "Otomatik Buton/Chatbot",
            personalizedBroadcasts: "Kişiselleştirilmiş Yayın Mesajları",
            chatWithNonContacts: "Kayıtlı Olmayan Numaralarla Mesajlaşma",
            broadcastMessaging: "Toplu Mesaj Gönderme",
            perBroadcast: "Toplu Mesaj Başına",
            extraPricePerMessage: "Mesaj Başına Ek Ücret",
            smartTrigger: "Akıllı Tetikleyici",
            telegramIntegration: "Telegram Entegrasyonu",
            instagramIntegration: "Instagram Entegrasyonu",
            ticketFeature: "Ticket Sistemi",
            storage: "Depolama",
            onePanelManagement: "Tek Panelden Yönetim",
            isolatedDatabaseConnection: "İzole Veritabanı Bağlantısı",
            removeLogo: "Supsis Logo Kaldırma",
            chatBaloonCustomization: "Chat balonu özelleştirme",
            chatAndNotifications: "Chat Ve Bildirimler",
            unlimited: "Sınırsız",
            specialCustomerSupport: "Özel Müşteri Desteği",
            softwareSupport: "Yazılım Desteği",
            standardSupport: "Standart Destek",
            teamChatIntegration: "Takım Konuşması Entegrasyonu",
            fileAndVoiceShare: "Dosya ve Ses Paylaşımı",
            instantVisitor: "Anlık Ziyaretçi Takibi",
            detailedReporting: "Detaylı Raporlama",
            normalreporting: "Normal Raporlama",
            noExtraCosts: "Ek Maliyet Gerektirmez",
            accessibleToAllAgents: "Tüm Temsilciler İçin Erişim",
            dataSecurity: "Veri Güvenliği",
            autoTranslate: "Otomatik Çeviri",
            chatbotVersionHistory: "Chatbot Sürüm Geçmişi",
            chatbotStory: "Chatbot Hikayesi",
            freeAgent: "Ücretsiz Temsilci",
            stableAgentCount: "Sabit Temsilci Sayısı",
            stableChannelCount: "Sabit Kanal Sayısı",
            chipPlans: "Uygun Fiyatlı Planlar",
            generalPlan: "Genel Plan",
            specialPlan: "Özel Plan",
            currentPlan: "Mevcut Plan",
            selected: "Seçildi",
            popular: "Popüler",
            trialPkg: "Deneme Paketi",
            support: "7/24 Destek",
            flexiblePricing: "Esnek Fiyatlandırma",
            rightToCancel: "İstenilen Gün Paket İptali",
            unlimitedCBScenario: "Sınırsız Chatbot Senaryosu",
            freeFirstScenario: "Ücretsiz İlk Senaryo",
            unlimitedLearn: "Sınırsız Chatbot Eğitimi",
            allPlatformIntegration: "Tüm Platformlarla Entegrasyon",
            detailedReports: "Detaylı Rapor",
            aiSupport: "Yapay Zeka Desteği",
            creativeAI: "Hızlı ve Gerçekçi AI Chat Asistanı",
            unlimitedSession: "Aynı Anda Sınırsız Oturum",
            assistantFromWebsite: "Web Siteden Asistan Oluşturma",
            assistantFromDoc: "Dökümandan Chatbot Oluşturma",
            mobileApp: "Mobil Uygulama",
        },
        messenger: {
            channel: "Messenger Kanalı",
            manageChannel: "Messenger Kanalını Yönet",
            channelDetail: "Messenger Detayı",
            integrationTitle: "Messenger Entegrasyonu",
            deleteDesc: "Messenger kanalını silmek istediğinizden emin misiniz?",
            channels: "Messenger Kanalları",
            connectMessenger: "Messenger'a Bağlan",
            detail: "Detay",
            visibility: "Görünürlük",
            settings_group: "Ayarlar",
            commentsettings: "Yorum Yönetimi",
            commentSettingsTitle: "Messenger Yorum Yönetimi",
            commentSettingsDesc: "Messenger yorumlarınızı yönetin",
        },
        instagram: {
            channel: "Instagram Kanalı",
            detail: "Detay",
            visibility: "Görünürlük",
            settings_group: "Ayarlar",
            commentsettings: "Yorum Yönetimi",
            commentSettingsTitle: "Instagram Yorum Yönetimi",
            commentSettingsDesc: "Instagram yorumlarınızı yönetin",
            commentSettingsTicket: "Gelen yorumların sistemde ticket olarak kaydedilmesini sağlar.",
            commentSettingsChatbot: "Kanala gelen yorumların hangi chatbot senaryosuna yönlendirileceğini seçiniz.",
            leads: "Leads",
            forms: "Forms",
        },
        calendar: {
            setting: "Ayarlar",
            delete: "Sil",
            cancel: "Vazgeç",
            save: "Kaydet",
            close: "Kapat",
            deleteRepeatEvent: "Düzenli etkinliği silin",
            thisEvent: "Bu etkinlik",
            thisAndOtherEvent: "Bu ve takip eden etkinlikler",
            allEvent: "Tüm etkinlikler",
            ok: "Tamam",
            googleCalendarLink: "Google Takvime Ekle",
            yahooCalendarLink: "Yahoo Takvime Ekle",
            subject: "Konu",
            visitor: "Ziyaretçi",
            allDay: "All Day",
            title: "Başlık",
            deleteEvent: "Etkinliği Sil",
            deleteEvents: "Etkinlikleri Sil",
            deleteEventsSure: "Bu takvime ait etkinlikleri silmek istediğinize emin misiniz?",
            deleteEventConfirm: "Etkinliği silmek istediğinize emin misinz?",
            notEmptyTitle: "Başlık boş bırakılamaz!",
            tasks: "Görevler",
            googleConnect: "Google Entegrasyonu",
            googleDisconnect: "Google Entegrasyon Bağlantısını Kaldır",
            sure: "Emin misin?",
            disconnectGoogleSure: "Google bağlantısını kaldırmak istediğinden emin misin?",
            yes: "Evet",
            no: "Hayır",
            customRepeat: "Özel Yineleme",
            recurrenceFrequency: "Yineleme Sıklığı:",
            repeatDays: "Şu günlerde yinele:",
            never: "Hiçbir zaman",
            thisDate: "Şu Tarihte:",
            recurrenceCount: "Yinelenme sayısı:",
            end: "Bitiş",
            event: "Etkinlik",
            calendars: "Takvimler",
            newCalendar: "Yeni Takvim Oluştur",
            changeColor: "Renk Değiştir",
            addCalendar: "Takvim Ekle",
            nameCalendar: "Takvim Adı",
            description: "Açıklama",
            change: "Değiştir",
            deleteCalendar: "Delete Calandar",
            deleteCalendarSure: "Takvimi silmek istediğinize emin misiniz?",
            notEmptyCalendarName: "Takvim adı boş olamaz",
            myEvents: "Etkinliklerim",
            everyoneEvents: "Tüm Etkinlikler",
            haveEvent: " temsilcisine ait etkinlikler",
            goCalendar: " Takvime Git",
            goReservation: " Rezervasyon Oluştur",
            agents: " Temsilciler",
            today: "Bugün",
            month: "Ay",
            week: "Hafta",
            day: "Gün",
            list: "Liste",
        },
        ticimax: {
            segment: "Segment",
            settings_group: "Ayar",
            waitDayFromLastSend: "Son Gönderilen Mesajdan İtibaren Bekleme Günü Sayısı",
            automationRuleName: "Otomasyon Kuralı Adı",
            time: "Saat",
            year: "Yıl",
            month: "Ay",
            dayOfMonth: "Ayın Günü",
            day: "Gün",
            bySecond: "Saniyeye Göre",
            byMinute: "Dakikaye Göre",
            byHour: "Saate Göre",
            byWeekNo: "Hafta Sayısı",
            byYearDay: "Yılın Günü",
            byMonthDay: "Ayın Günü",
            byMonth: "Aya Göre",
            december: "Aralık",
            november: "Kasım",
            october: "Ekim",
            september: "Eylül",
            august: "Ağustos",
            july: "Temmuz",
            june: "Haziran",
            may: "Mayıs",
            april: "Nisan",
            march: "Mart",
            february: "Şubat",
            january: "Ocak",
            byWeekDay: "Güne Göre",
            interval: "Aralık",
            seconds: "Saniyelik",
            minutes: "Dakikalık",
            hourly: "Saatlik",
            daily: "Günlük",
            weekly: "Haftalık",
            monthly: "Aylık",
            yearly: "Yıllık",
            frequency: "Sıklık",
            attributes: {
                vip: "VIP",
                segment: "Segment",
                province: "Şehir",
                country: "Ülke",
                phone: "Telefon",
                email: "E Posta",
                fullname: "Tam İsim",
                couponPercent: "Kupon %",
                lastOrderDate: "Son Sipariş",
                firstOrderDate: "İlk Sipariş",
                county: "ilçe",
                lastSource: "Son Kaynak",
                firstSource: "İlk Kaynak",
                lastPaymentType: "Son Ödeme Yöntemi",
                firstPaymentType: "İlk Ödeme Yöntemi",
                maxOrderAmount: "En Çok Sipariş Tutarı",
                minOrderAmount: "En Az Sipariş Tutarı",
                totalOrderAmount: "Toplam Sipariş Tutarı",
                totalOrderCount: "Toplam Sipariş Sayısı",
                usedCouponAmount: "Kupon Miktarı",
                usedCouponCount: "Kupon Sayısı",
                tookDayFromLastOrder: "Son Siparişten Geçen Gün",
                isCouponUser: "Kupon kullanıcısı?",
            },
            createAutomation: "Otomasyon Oluştur",
            previous: "Önceki",
            createAutomationDesc: "Mesaj otomasyonununuzu oluşturun ve yönetin",
            newTicimaxChannel: "Yeni Ticimax Kanalı",
            connextToTicimaxXml: "Ticimax XML Servisine Bağlan",
            connectTicimax: "Ticimax'a Bağlan",
            examplePreview: "Örnek Önizleme",
            completeAutomationRule: "Otomasyon Kuralını Tamamla",
            configureMessage: "Mesajı Yapılandır",
            automationTimer: "Otomasyon Zamanlayıcı",
            findTargetMembers: "Hedef Kişileri Bul",
            createAutomationRule: "Otomasyon Kuralı Oluştur",
            action: "Aksiyon",
            status: "Durum",
            triggeredUserCount: "Tetiklenmiş kullanıcı sayısı",
            nextScheduled: "Sonraki Tetikleme",
            timerRule: "Zamanlama Kuralı",
            automationRules: "Otomasyon Kuralları",
            apply: "Uygula",
            searchAMember: "Bir kişi ara",
            segmentedMembersDesc: "Segmente edilmiş kişilerinizi listeleyin ve otomatize edin",
            manageVisibilityDesc: "Kanalı kimlerin görebileceğini yönet",
            xmlOrderListURL: "XML sipariş listesi URL",
            manageIntegrationDesc: "Ticimax entegrasyonunuzu yönetin",
            detail: "Detay",
            ticimaxChannelsTitle: "Ticimax Kanalları",
            ticimaxDetail: "Ticimax Detay",
            settingsGroup: "Ayarlar",
            visibility: "Görünürlük",
            members: "Kişiler",
            automation: "Otomasyon",
            integrationChannel: "Entegrasyon Kanalı",
            channelUpdated: "Kanal Başarıyla Güncellendi",
            channelUpdateFailed: "Kanal Güncellemesi Başarısız",
        },
        notification: {
            mobileApp: "Mobil Uygulama",
            webPanel: "Web Paneli",
            notifications: "Bildirimler",
            whatsappActions: "Whatsapp Aksiyonları",
            chatbotActions: "Chatbot Aksiyonları",
            companyActions: "Şirket Aksiyonları",
            crmActions: "SUPSIS CRM ACTIONS",
            basicActions: "Temel Aksiyonlar",
            notificationSettingsDesc:
                "Hangi bildirimleri almak istediğinizi ve bunları nerede almak istediğinizi seçin.",
            noNotificationDesc2:
                "Burada takip ettiğiniz işler, adaylar ve yetenek havuzlarıyla ilgili tüm bildirimler görüntülenecektir. Bildirimleri ayarları düzenleyerek ayarlayabilirsiniz.",
            noNotificationTitle2: "Henüz bildirim yok.",
            noNotificationTitle1: "Bildirim yok. Sessizliğin tadını çıkarın.",
            adjustSettings: "Ayarları düzenle",
            showAll: "Tümünü göster",
            showOnlyUnread: "Sadece okunmayanları göster",
            mailWasSent: "Mail Gönderildi.",
            mailAdressRemoved: "Mail adresi kaldırıldı.",
            chatbotPublished: "Chatbotun <b>{version}</b> versiyonu <b>{user}</b> tarafından yayınlandı.",
            chatbotDeleted: "<b>{chatbot}</b> isimli chatbot <b>{user}</b> tarafından silindi.",
            settingsUpdatedWoDetail: "Ayarlar <b>{user}</b> tarafından güncellendi.",
            noActivityDesc: "Şu anda sistemde herhangi bir hareket bulunmuyor. Birkaç olayın gerçekleşmesi gerekiyor",
            noActivityTitle: "Henüz hareket yok",
            actionType: "Hareket Tipi",
            dateBetween: "Zaman aralığı",
            selectActor: "Kullanıcı Seçimi",
            activities: "Hareketler",
            chatbotCreated: "<b>{chatbot}</b> isimli chatbot <b>{user}</b> tarafından oluşturuldu.",
            taskStageChanged:
                "<b>{task}</b> görevinin <b>{oldStage}</b> olan durumu <b>{user}</b> tarafından <b>{newStage}</b> olarak değiştirildi.",
            taskCreated: "<b>{task}</b> görevi <b>{user}</b> tarafından oluşturuldu.",
            contactPropRemoved: "<b>{prop}</b> ziyaretçi bilgisi <b>{user}</b> tarafından kaldırıldı.",
            contactPropAdded: "<b>{prop}</b> ziyaretçi bilgisi <b>{user}</b> tarafından oluşturuldu.",
            userRemoved: "<b>{oldUser}</b> kullanıcısı <b>{user}</b> tarafından silindi",
            loginFormUpdated: "Ziyaretçi giriş formu <b>{user}</b> tarafından güncellendi.",
            loginFormDeactivated: "Ziyaretçi giriş formu <b>{user}</b> tarafından devre dışı bırakıldı.",
            loginFormActivated: "Ziyaretçi giriş formu <b>{user}</b> tarafından aktif edildi.",
            invoiceRefunded: "İade işlemi <b>{user}</b> tarafından yapıldı.",
            paymentMethodAdded: "Yeni bir ödeme yöntemi <b>{user}</b> tarafından eklendi.",
            invoicePaymentFailed: "Fatura ödeme işlemi <b>{user}</b> tarafından kabul edilmedi.",
            invoicePaymentReceived: "Fatura ödeme işlemi <b>{user}</b> tarafından kabul edildi.",
            planStarted: "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>({altTitle})</b> aboneliğini başlattı.",
            planStartedAgent:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({details} Temsilci)</b> aboneliğini başlattı.",
            planStartedChatbot:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({chatbot} Session)</b> aboneliğini başlattı.",
            planStartedWhatsapp:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({whatsapp} Whatsapp Channels)</b> aboneliğini başlattı.",
            planStartedWhatsappApi:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({whatsappApi} Whatsapp Business Channels)</b> aboneliğini başlattı.",
            PlanCanceled: "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>({altTitle})</b> aboneliğini iptal etti.",
            planCanceledAgent:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({details} Temsilci)</b> aboneliğini iptal etti.",
            planCanceledChatbot:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({chatbot} Session)</b> aboneliğini iptal etti.",
            planCanceledWhatsapp:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({whatsapp} Whatsapp Channels)</b> aboneliğini iptal etti.",
            planCanceledWhatsappApi:
                "<b>{user}</b> Kullanıcısı <b>{title}</b> <b>{altTitle}</b> <b>({whatsappApi} Whatsapp Business Channels)</b>  aboneliğini iptal etti.",
            invoiceCreated: "Fatura <b>{user}</b> tarafından oluşturuldu.",
            billingAddressUpdated: "Adres bilgileri <b>{user}</b> tarafından güncellendi",
            taskWorkflowDeleted: "<b>{workflow}</b> iş akışı <b>{user}</b> tarafından silindi.",
            whatsappBroadcastFailed: "<b>{title}</b> başlıklı toplu mesaj gönderimi başarısız oldu.",
            whatsappBroadcastCancelled: "<b>{title}</b> başlıklı toplu mesajın gönderimi iptal edildi.",
            whatsappBroadcastCompleted:
                "<b>{title}</b> başlıklı toplu mesaj <b>{numbers}</b> kişiye başarıyla gönderildi.",
            whatsappBroadcastCreated:
                "<b>{title}</b> başlıklı toplu mesaj <b>{user}</b> tarafından <b>{numbers}</b> kişiye gönderildi.",
            ticketAssigned: "<b>{user2}</b> kisisine <b>{user1}</b> tarafından ticket atandı.",
            userLoggenIn: "<b>{user}</b> SUPSIS'e giriş yaptı.",
            chatJoined: "<b>{visitor}</b> ile olan görüşmeye <b>{agent}</b> katıldı.",
            chatForwarded:
                "<b>{visitor}</b> ile olan görüşme <b>{user}</b> tarafından <b>{agent}</b> temsilcisine aktarıldı. ",
            chatAssigned:
                "<b>{visitor}</b> ile olan görüşme sistem tarafından <b>{agent}</b> temsilcisine yönlendirildi.",
            customerGroupUpdated: "<b>{group}</b> isimli grup <b>{user}</b> tarafından güncellendi.",
            customerGroupRemoved: "<b>{group}</b> isimli grup <b>{user}</b> tarafından silindi.",
            customerGroupAdded: "<b>{group}</b> isimli grup <b>{user}</b> tarafından oluşturuldu.",
            contentRemoved: "<b>{content}</b> hazır içeriği <b>{user}</b> tarafından kaldırıldı.",
            contentAdded: "<b>{content}</b> hazır içeriği <b>{user}</b> tarafından eklendi.",
            channelVisibilityChanged:
                "<b>{channel}</b> entegrasyon kanalının görünürlüğü <b>{user}</b> tarafından değiştirildi.",
            taskDeleted: "<b>{task}</b> görevi <b>{user}</b> tarafından silindi.",
            userRemovedToDepartment:
                "<b>{user2}</b> kullanıcısı <b>{user1}</b> tarafından <b>{department}</b> departmanından çıkarıldı.",
            userAddedToDepartment:
                "<b>{user2}</b> kullanıcısı <b>{user1}</b> tarafından <b>{department}</b> departmanına eklendi.",
            mailAddressAdded: "<b>{email}</b> mail adresi <b>{user}</b> tarafından eklendi",
            settingUpdate: "<b>{user}</b> tarafından güncellendi:",
            taskWFlowCreated: "<b>{Wflow}</b> iş akışı <b>{user}</b> tarafından oluşturuldu.",
            bannedWordRemoved: "<b>{bWord}</b> yasaklı kelimesi <b>{user}</b> tarafından silindi.",
            bannedWordCreated: "<b>{bWord}</b> yasaklı kelimesi <b>{user}</b> tarafından eklendi.",
            welcomeMessageRemoved: "<b>{welcome}</b> karşılama mesajı <b>{user}</b> tarafından silindi.",
            welcomeMessageAdded: "<b>{welcome}</b> karşılama mesajı <b>{user}</b> tarafından oluşturuldu.",
            tagRemoved: "<b>{tag}</b> etiketi <b>{user}</b> tarafından kaldırıldı.",
            tagAdded: "<b>{tag}</b> etiketi <b>{user}</b> tarafından eklendi.",
            roleRemoved: "<b>{role}</b> rolü <b>{user}</b> tarafından kaldırıldı.",
            roleAdded: "<b>{role}</b> rolü <b>{user}</b> tarafından eklendi.",
            departmentRemoved: "<b>{department}</b> departmanı <b>{user}</b> tarafından silindi.",
            departmentAdded: "<b>{department}</b> departmanı <b>{user}</b> tarafından eklendi.",
            triggerUpdated: "Bir tetikleyici <b>{user}</b> tarafından güncellendi.",
            triggerRemoved: "Bir tetikleyici <b>{user}</b> tarafından kaldırıldı.",
            triggerAdded: "Yeni bir tetikleyici <b>{user}</b> tarafından oluşturuldu.",
            webhookRemoved: "<b>{user1}</b> ait webhook, <b>{user2}</b> tarafından kaldırıldı.",
            webhookAdded: "<b>{user1}</b> tarafından eklenen webhook, <b>{user2}</b> tarafından eklendi.",
            chatClosed: "<b>{visitor}</b> ile olan konuşma <b>{agent}</b> tarafından sonlandırıldı.",
            chatOpenedByAgent:
                "<b>{visitor}</b> ile bir <b>{platform}</b> konuşması <b>{agent}</b> tarafından başlatıldı.",
            chatOpenedByVisitor: "Bir <b>{platform}</b> konuşması <b>{visitor}</b> tarafından başlatıldı.",
            channelRemoved: "<b>{channel}</b> kanalı <b>{agent}</b> tarafından silindi.",
            userAdded: "<b>{newAgent}</b> isimli temsilci <b>{agent}</b> tarafından oluşturuldu.",
            visitorUnblocked: "<b>{visitor}</b> isimli ziyaretçinin engeli <b>{agent}</b> tarafından kaldırıldı.",
            visitorBlocked: "<b>{visitor}</b> isimli ziyaretçi <b>{agent}</b> tarafından engellendi.",
            userStatusChanged:
                "<b>{name}</b> isimli temsilci <b>{oldStatus}</b> olan durumunu <b>{newStatus}</b> olarak değiştirdi.",
            channelCreated: "<b>{channel}</b> isimli kanal <b>{name}</b> tarafından oluşturuldu.",
            reservationCreatedPlan:
                "<b>{name}</b> Kullanıcıs, <b>{title}</b> adlı randevuyu <b>{date}</b> tarihine planladı.",
            reservationUpdatedPlan: "<b>{name}</b> Kullanıcısı, <b>{title}</b> randevusunu güncelledi.",
            reservationDeletedPlan: "<b>{name}</b> Kullanıcısı, <b>{title}</b> adlı randevuyu sildi.",
            reservationCreated:
                "<b>{name}</b> Kullanıcısı ve <b>{visitor}</b> ziyaretçisi ile <b>{date}</b> tarihine randevu oluşturuldu.",
            reservationDeleted:
                "<b>{name}</b> Kullanıcısı ve <b>{visitor}</b> ziyaretçisi arasında planlanan <b>{date}</b> tarihli randevu iptal edilmiştir.",
            chatAssignedMe: "Bir sohbet bana atanınca",
            ticketAssignedMe: "Bir ticket bana atanınca",
            taskAssignedMe: "Bir görev bana atanınca",
            myChatClosed: "Sahip olduğum bir sohbet kapatıldığında",
            tagActionsToVisitor: "Bir ziyaretçiye etiket eklendi veya kaldırıldı",
            ticketCreated:
                "Ziyaretçi veya sohbet botu bir bilet oluşturdu. Ayrıca, sohbet widget'ından çevrimdışı ileti gönderildiğinde",
            notesActions: "Bir müşteriye not eklendi ya da kaldırıldı.",
            visitorProfileUpdated: "Ziyaretçi profili güncellendi",
            chatStartedByAnyPlatform: "Herhangi bir platformda ziyaretçi veya temsilci tarafından sohbet başlatıldı",
            userActions: "Kullanıcı oluşturuldu, güncellendi veya silindi",
            departmentActions: "Departman oluşturuldu, güncellendi veya silindi",
            settingsActions: "Ayarlar oluşturuldu, güncellendi veya silindi",
            integrationsActions: "Entegrasyon kanalı oluşturuldu, güncellendi veya silindi",
            loginFormActions: "Giriş formu güncellendi veya etkinleştirildi veya devre dışı bırakıldı",
            bannedWordActions: "Yasaklanan kelime oluşturuldu, güncellendi veya silindi",
            emailActions: "E-posta hesabı oluşturuldu veya silindi",
            preparedContentActions: "Hazırlanan içerik oluşturuldu veya silindi",
            roleActions: "Rol oluşturuldu, güncellendi veya silindi",
            tagActions: "Etiket oluşturuldu, güncellendi veya silindi",
            welcomeMessageActions: "Hoş geldiniz mesajı oluşturuldu, güncellendi veya silindi",
            webhookActions: "Web kancası oluşturuldu, güncellendi veya silindi",
            billingEvents: "Fatura Olayları",
            taskWorkflowCrud: "Görev iş akışı oluşturuldu, güncellendi veya silindi",
            taskCrud: "Görev oluşturuldu, güncellendi veya silindi",
            systemStatus: "Sistem çevrimiçi veya çevrimdışı durum değişiklikleri",
            chatbotStoryCrud: "Chatbot hikayesi oluşturuldu, güncellendi veya silindi",
            chatbotForwardAgent: "Chatbot, bir sohbeti bir ajana yönlendirir",
            userSegmentCrud: "Kullanıcı segmenti oluşturuldu, güncellendi veya silindi",
            chatbotCreditLow: "Chatbot kredisi düşük olduğunda",
            wpCreditLow: "Whatsapp kredisi düşük olduğunda",
            wpCustomerGroupCrud: "Whatsapp müşteri grubu oluşturulduğunda, güncellendiğinde veya silindiğinde",
            wpBroadcastMessageStatus: "Whatsapp yayın mesajı gönderildiğinde, tamamlandığında veya iptal edildiğinde",
            wpTemplateMesssageCrud: "Whatsapp şablon mesajı oluşturulduğunda, güncellendiğinde veya silindiğinde",
            reservationMessageCrud: "Rezervasyon Oluşturuldu, Güncellendi, İptal Edildi",
        },
        search: {
            prefix: {
                jump: "Git",
                new: "Yeni",
                visitor: "Kişi",
                dm: "DM",
            },
            calendar: "Takvim",
            soundSettings: "Sesli Bildirimler",
            allNotificationSettings: "Bildirim Ayarları",
            allAuditLogs: "Denetim Logları",
            allNotifications: "Tüm Bildirimler",
            allActivities: "Tüm Aktiviteler",
            workFlow: "İş akışı",
            editTask: "Görev düzenle",
            tasks: "Görevler",
            todo: "Yapılacaklar",
            tapTo: "'{prefix}' işlemleri için ⇥ basın",
            newUsers: "Yeni ⇥ Kullanıcı",
            newTags: "Yeni ⇥ Etiket",
            newRole: "Yeni ⇥ Rol",
            newTrigger: "Yeni ⇥ Tetikleyici",
            newDepartment: "Yeni ⇥ Departman",
            newTicket: "Yeni ⇥ Etiketleri",
            jumpSettings: "Git ⇥ Ayarlar",
            jumpIntegrations: "Git ⇥ Entegrasyonlar",
            jumpTeam: "Git ⇥ Takım",
            jumpUsers: "Git ⇥ Kullanıcılar",
            jumpReport: "Git ⇥ Rapor",
            timingSettings: "Zamanlama ayarları",
            exampleVisitorMail: "Ziyaretçi@mail.com",
            languageAndRegion: "Dil ve Bölge",
            theme: "Tema",
            appearance: "Görünüş - Görünüm",
            color: "Renk",
            background: "Arkaplan",
            smart: "Akıllı",
            teamChat: "Takım Konuşması",
            chatbot: "ChatBot",
            chatbotTraining: "Chatbot Eğitimi",
            chatbotUserSegments: "Chatbot Kullanıcı Bölümleri",
            chatbotIntegration: "Chatbot Entegrasyon",
            chatbotEntities: "Chatbot Varlıklar",
            chatbotIntegrationWebHook: "Chatbot WebHook Entegrasyon",
            chatbotArchive: "Chatbot Arşiv",
            chatbotTemplatesAI: "Chatbot Yapay Zeka Şablonları",
            chatbotTemplates: "Chatbot Şablonları",
            chatbotReportsOverall: "Chatbot Genel Raporlar",
            chatbotReportsAllChats: "Chatbot Tüm Sohbetleri Raporlar",
            chatbotReportsRatingDistribution: "Chatbot Raporlarının Derecelendirme Dağılımı",
            chatbotReportsPaidChats: "Chatbot Reports Paid Chats",
            chatbotReportsBusiestPeriod: "Chatbot En Yoğun Dönemi",
            chatbotTemplatesAllMessages: "Chatbot Şablonları Tüm Mesajlar",
            chatbotTemplatesAvarage: "Chatbot Şablonları Ortalaması",
            chatbotTemplatesPopularity: "Chatbot Şablonlarının Popülerliği",
            chatbotTemplatesAllUser: "Chatbot Şablonları Tüm Kullanıcı",

            ticket: "Destek Talepleri",
            archives: "Arşiv",
            tags: "Etiketler",
            offlineSupportRequests: "Offline Support Requests",
            roles: "Roller",
            users: "Kullanıcılar",
            subjects: "Departmanlar",
            contents: "Hazır İçerikler",
            welcomeMessages: "Sistem Mesajları",
            catalog: "Katalog",
            bannedWords: "Yasaklı Kelimeler",
            bannedVisitors: "Yasaklı Ziyaretciler",
            application: "Uygulama",
            mails: "Mailer",
            visitors: "Ziyaretciler",
            integrationsWebhook: "Webhook Entegrasyonu",
            billing: "Fatura",
            reportNew: "Yeni Rapor",
            integrations: "Entegrasyonlar",
            chatbotStory: "Chatbot Hikayaler",
            searchPlaceHolder: "Ara, Git yada Ekle...",
            searchAreaTitle: "Supsis'te Ara",
            searchAreaDesc1: "Herşeyi arayabilirsin. Sadece",
            searchAreaDesc2: "ya da",
            searchAreaDesc3: "yaz veya herhangi bir şey ara.",
            navigateBtn: "Gezin",
            selectBtn: "Seç",
            cancelBtn: "İptal",
            integration: {
                wpBusinessAPI: "Integrations - Whatsapp Business API Kanalları",
                wpV1: "Integrations - Multi Whatsapp Kanalları",
                instagram: "Integrations - Instagram",
                instagramContactList: "Integrations - Instagram Kişi Listesi",
                mail: "Integrations - Mail",
                whatsapp: "Integrations - Whatsapp",
                whatsappContactList: "Integrations - Whatsapp Kişi Listesi",
                wpBCRequests: "Integrations - Whatsapp Toplu Mesaj İstekleri",
                wpBCCustomerGroups: "Integrations - Whatsapp Toplu Müşteri Grupları",
                wpBCTemplates: "Integrations - Whatsapp Toplu Message Şablonları",
                chatbot: "Integrations - ChatBot",
            },
            settings: {
                settings: "Ayarlar",
                features: "Ayarlar - Özellikler",
                languageAndRegion: "Ayarlar - Dil ve Bölge",
                bubbleSettings: "Ayarlar - Balon Ayarları",
                bubbleActions: "Ayarlar - Balon Eylemleri",
                themeSettings: "Ayarlar - Tema Ayarları",
                visitorLoginForm: "Ayarlar - Ziyaretci Giriş Formu",
                visitorAttribute: "Ayarlar - Ziyaretci Özellikleri",
                autoAssign: "Ayarlar - Otomatik Atama",
                chatTimingSettings: "Ayarlar - Chat Zaman Ayarları",
                availability: "Ayarlar - Kullanılabilirlik",
                websiteIntegration: "Ayarlar - Website Entergasyon",
                developer: "Ayarlar - Geliştirici",
            },
        },
        mail: {
            deleteMailDesc: "Bu işlem geri alınamaz.",
            deleteMailTitle: "Bu mail adresini silmek istediğinize emin misiniz?",
            gmailForwardMail: "Gmail Mail İletme",
            senderMailAddressDesc: "Lütfen Gönderici Mail Adresi Girin",
            verified: "Doğrulandı",
            notForwarded: "Yönlendirilmedi",
            notVerified: "Doğrulanmadı",
            default: "Varsayılan",
            isVerified: "Doğrulanma",
            forwarding: "Yönlendirme",
            mailAdress: "Mail Adresi",
            addSenderAddress: "Gönderen Maili Ekle",
            outlookForward: "Microsoft (Outlook/Exchange) Yönlendirme",
            gmailForward: "Google(Gmail) Yönlendirme",
            senderMail: "Gönderen Mail",
            mailDetail: "Mail Detayı",
            mailNotFound: "Mail Bulunmuyor",
            mailSelecting: "Mail Seçimi",
            newMail: "Yeni E-Posta",
            myMails: "E-Postalarım",
            inbox: "Gelen Kutusu",
            sent: "Gönderilen",
            departmentMails: "Departman E-Postaları",
            newTemplate: "Yeni Şablon",
            unread: "Okunmamış",
            unreply: "Yanıtlanmamış",
            reply: "Yanıtla",
            attachments: "Mail Ekleri",
            To: "Kime",
            From: "Kimden",
            FromName: "Gönderen Kişinin İsmi",
            placeHolders: "Yer Tutucular",
            attacheFiles: "Dosya Ekle",
            replyAll: "Tümünü Yanıtla",
            forward: "İlet",
            deleteThread: "Konuşmayı sil",
            markAsRead: "Okundu Olarak İşaretle",
            markAsAllRead: "Tümünü Okundu Olarak İşaretle",
            emailEditor: "E-Posta Düzenleyici",
            integrateYourMail: "E-Postanı Entegre Et",
            connect: "Bağlan",
            departmentMail: "Departman E-Posta",
            createMailAddress: "Mail Adresi Oluştur",
            createNewMail: "Yeni Mail Oluştur",
        },
        visitor: {
            mail: "Mail",
            visitorDetail: "Ziyaretçi Detayları",
            selectedUser: "{totalUsers} kullanıcıdan {selectedUser} tanesi seçildi",
            uncheck: "Tüm işaretleri kaldır",
            checkAll: "Tümünü işaretle",
            matchedUsers: "{chechkedCount} adet kullanıcı eşleşti",
            more: "Daha fazla",
            exportUsers: "Seçilen kullanıcıları dışa aktar",
            exportAllUsers: "Tüm kullanıcıları dışa aktar",
            addSegment: "Segment Ekle",
            deletedCheckedUser: "Seçilen kullanıcıları sil",
            deleteAllUser: "Tüm kullanıcıları sil",
            matchedFilter: "Tüm filtreleri eşleştir",
            visitor: "Ziyatretçisi",
            deleteUser: "Kullanıcıyı sil",
            userData: "Kullanıcı bilgileri",
            lastSession: "Kullanıcı Haraketleri",
            notUserData: "Kullanıcı haraketleri bulunamadı",
            segments: "Segmentler",
            tags: "Etiketler",
            addTag: "Etiket ekle",
            userChats: "Kullanıcı Konuşmaları",
            userMails: "Kullanıcı Mailleri",
            seeAll: "Hepsini gör",
            confirm: "Onayla",
            manageSegments: "Segment yönetimi",
            search: "Ara",
            manageTags: "Tag yönetimi",
            allAttributes: "Tüm özellikleri gör",
            noData: "Veri yok",
            noEmail: "Mail yok",
            noIpAddress: "IP adresi bulunamadı.",
            noWpNumber: "Numara bulunamadı.",
            filterName: "Filtre ismi...",
            matchedContacts: "{chechkedCount} adet bağlantı eşleşti",
        },
        chatbotv2: {
            selectedStory: "{count} Senaryo Seçildi",
            B2Cargo_Actions: "B2Cargo Aksiyonları",
            Holiday_Plus_Actions: "Holiday+ Aksiyonları",
            Instagram_Actions: "Instagram Aksiyonları",
            HOLIDAY_PLUS_GET_ROOMS: "ODALARI LISTELE",
            HOLIDAY_PLUS_GET_HOTELS: "OTELLERI LISTELE",
            B2CARGO_LOGIN_USER: "Kullanıcı Girişi",
            B2CARGO_PRODUCT_STATUS: "Ürün Durumu",
            didntSuppression: "Herhangi bir kısıtlama yapmadınız.",
            suppressionRemoved: "Kısıtlama Kaldırıldı",
            suppressionAdded: "Kısıtlama Eklendi",
            whatsappIntegrationTitle: "Whatsapp V1 ve Whatsapp V2 Entegrasyonu",
            whatsappApiIntegrationTitle: "Whatsapp Business API Entegrasyonu",
            ReadyTemplateBadge: "Hazır Şablon",
            readyTemplates: "Hazır Şablonlar",
            regex: "Regex",
            regexDescription: "Regex ile herşeyi yakala",
            chatbotLogo: "Chatbot Resmi",
            chatbotName: "ChatBot Adı",
            ChatbotScenarioList: "Chatbot Senaryo Listesi",
            Scenario: "Senaryolar",
            allSecnario: "Tüm Chatbot Senaryoları",
            filters: {
                equal: "eşittir",
                not_equal: "eşit değildir",
                contain: "içerir",
                not_contain: "içermez",
                starts_with: "ile başlar",
                ends_with: "ile biter",
                empty: "boş ise",
                non_empty: "boş değil ise",
                longer_than: "daha uzunsa",
                shorter_than: "daha kısaysa",
                less_than: "küçükse",
                less_or_equal: "küçük veya eşit ise",
                greater_than: "büyükse",
                greater_or_equal: "büyük veya eşit ise",
            },
            planRequired: "{integratable} Plan Gerekmektedir.",
            noDefaultStoryTitle: "Varsayılan Hikaye",
            noDefaultStory: "Varsayılan hikayeniz bulunmamaktadır.\n Bu hikayeyi varsayılan yapmak ister misiniz?",
            noMessage: "Mesaj Yok",

            loading: "Yükleniyor",
            loadMore: "Daha fazla",
            hostname: "Host adı",
            allTemplates: "Tüm Şablonlar",
            allAITemplates: "Tüm Yapay Zeka Şablonları",
            templatesFromTheIndustry: "Sektörden Şablonlar",
            basicTemplate: "Temel Şablon",
            proTemplate: "Gelişmiş Şablon",
            goToStory: "hikayeye git",
            noResultFound: "Hiç bir sonuç bulunamadı",
            checkYourFilterCombination: "Filtre kombinasyonunu kontrol et",
            clearYourSearch: "aramayı temizle",
            andTryAgain: "ve yeniden dene",
            withBot: "& Bot",
            userWithBot: "Kullanıcı & Bot",
            chatDetail: "Sohbet Detayları",
            allUserDetail: "Tüm kullanıcı detaylarını görün",
            sessionData: "Oturum verileri",
            supsisChatWidget: "Supsis Sohbet Aracı",
            integratedWith: "Şunlarla entegredir : ",
            integration: "Entegrasyon",
            Users: "Kullanıcılar",
            user_id: "Kullanıcı ID",
            botStory: "Bot hikayesi",
            categories: "Kategoriler",
            worksWith: "İle çalışır",
            importBot: "Botu kullan",
            keyFeatures: "Ana Özellikler",
            importing: "ekleniyor",
            comingSoon: "Yakında Hizmetinizde",
            pickStory: "Hikaye seçin",
            conversationId: "Konuşma ID",
            integrateStoryWithSupsisWidget: "Supsis Widget'ını Chatbot Story ile Entegre Edin",
            integrateStoryWithWhatsapp: "Whatsapp'ı Chatbot Story ile Entegre Edin",
            integrateStoryWithInstagram: "Instagram'ı Chatbot Story ile Entegre Edin",
            selectIntegratingStory: "Entegre edilecek hikayeyi seçin",
            install: "Yükle",
            attr: {
                weekday: "Haftanın Günü",
                channelId: "Kanal",
                email: "E-posta",
                phone: "Telefon",
                language: "Dil",
                timezone: "Saat Dilimi",
                gender: "Cinsiyet",
                country: "Ülke",
                referrer: "Referrer",
                url: "Ziyaret Adresi",
                ip: "IP",
                last_seen: "Son Görülme",
                name: "İsim",
                user_id: "Kullanıcı numarası",
                department: "Departman",
                message: "Mesaj",
                akinon_brand: "Marka",
                akinon_order_id: "Sipariş Numarası",
                akinon_product_id: "Ürün Numarası",
                akinon_user_id: "Kullanıcı ID'si",
                akinon_user_name: "Kullanıcı Adı",
                akinon_user_email: "Kullanıcı E-Postası",
                akinon_invoice_url: "Fatura URL",
                akinon_order_status: "Sipariş Durumu",
                akinon_order_price: "Sipariş Fiyatı",
                akinon_shipper_name: "Kargo Firması Adı",
                akinon_product_size: "Ürün Bedeni",
                akinon_sku: "SKU",
                akinon_product_url: "Ürün URL",
                akinon_product_title: "Ürün Başlığı",
                akinon_product_image: "Ürün Resmi",
                akinon_product_stock: "Ürün Stoğu",
                akinon_order_date: "Sipariş Tarihi",
                akinon_track_number: "Kargo Takip Numarası",
                akinon_track_url: "Kargo Takip URL",
                akinon_latitude: "Enlem (Konum)",
                akinon_longitude: "Boylam (Konum)",

                ideasoft_user_id: "Üye Id",
                ideasoft_invoice_url: "Fatura Linki",
                ideasoft_order_id: "Sipariş Numarası",
                ideasoft_order_status: "Sipariş Durumu",
                ideasoft_order_price: "Sipariş Tutarı",
                ideasoft_shipper_name: "Kargo Firması",
                ideasoft_product_size: "Ürün Bedeni",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Ürün Linki",
                ideasoft_product_title: "Ürün Başlığı",
                ideasoft_product_image: "Ürün Resmi",
                ideasoft_product_stock: "Ürün Stok",
                ideasoft_order_date: "Sipariş Tarihi",
                ideasoft_track_number: "Kargo Takip Numarası",
                ideasoft_track_url: "Kargo Takip URL",

                offline_mode: "Çevrimdışı Mod",
                available_agents: "Uygun Temsilciler",
                platform: "Platform",
                probel_sube_kodu: "Şube Kodu",
                probel_brans_adi: "Branş Adı",
                probel_brans_kodu: "Branş Kodu",
                probel_doktor_adi: "Doktor Adı",
                probel_doktor_kodu: "Doktor Kodu",
                probel_poliklinik_adi: "Poliklinik Adı",
                probel_poliklinik_kodu: "Poliklinik Kodu",
                probel_randevu_tarihi: "Randevu Tarihi",
                probel_date: "Randevu Tarihi",
                probel_randevu_saati: "Randevu Saati",
                probel_randevu_id: "Randevu ID",
                probel_hasta_token: "Hasta Token",
                probel_kimlik_tipi: "Kimlik Tipi",
                probel_kimlik_no: "Kimlik No",
                probel_hasta_adi: "Hasta Adı",
                probel_hasta_soyadi: "Hasta Soyadı",
                probel_hasta_cinsiyet: "Cinsiyet",
                probel_hasta_dogum_tarihi: "Doğum Tarihi",
                probel_hasta_telefon: "Telefon",
                hour: "Saat",
                segments: "Segments",
                ticket: "Etiket",
                tags: "Etiket",
                metaReferrals: "Meta Referrals",
                idleUserTime: "Kullanıcı Son Aksiyon (Saniye)",
                ai_class_result: "YZ Sınıf Sonuç",
                meta_comment_id: "Meta Yorum ID",
                meta_comment: "Meta Yorum",
                meta_post_id: "Meta Post ID",
                b2cargo_companyCode: "Firma Kodu",
                b2cargo_takipNo: "Ürün Takip No",
                b2cargo_takipseri: "Ürün Takip Seri",
                b2cargo_evrakdurum: "Ürün Durumu",
                b2cargo_teslimtar: "Teslim Tarihi",
                b2cargo_gonderen: "Gönderen Firma",
                b2cargo_aliciAdi: "Alıcı Firma",
                b2cargo_cikisIl: "Çıkış İl",
                b2cargo_varisIl: "Varış İl",
                b2cargo_teslim: "Teslim Durumu",
                b2cargo_urun: "Ürün Tipi",
                b2cargo_atfTarih: "ATF Tarih",
                b2cargo_palet: "Palet",
                b2cargo_koli: "Koli",
                b2cargo_kg: "Ürün Ağırlığı",
                b2cargo_desi: "Ürün Boyutu",
                b2cargo_zimmetno: "Zimmet No",
                b2cargo_varissube: "Varış Şube",
                holiday_plus_room_id: "Oda ID",
                holiday_plus_room_title: "Oda Adı",
                holiday_plus_room_description: "Oda Açıklaması",
                holiday_plus_room_size: "Oda Boyutu",
                holiday_plus_room_price: "Oda Fiyatı",
                holiday_plus_room_price_offer: "Oda İndirimi",
                holiday_plus_room_discount_price: "Oda İndirimli Fiyatı",
                holiday_plus_selected_hotel_id: "Seçilen Otel ID",
                b2cargo_atfDurum: "ATF Durum",
            },
            storyList: "Hikaye Listesi",
            douYouWannaDeleteItem: "Bu öğeyi silmek istiyor musunuz?",
            douYouWannaDeleteWithChildren: "Bu öğeyi alt öğeleriyle birlikte silmek istiyor musunuz?",
            stories: "Hikayeler",
            templates: "Şablonlar",
            aitemplates: "Yapay Zeka Şablonlar",
            integrations: "Entegrasyonlar",
            all: "Tümü",
            installed: "Yüklenmiş Olanlar",
            installationOK: "Yüklü",
            uninstall: "Kaldır",
            remainingMessageDesc: "Kalan ücretsiz mesaj : ",
            openAISiteRoutingDescStart: "Bir Apikey almak için",
            openAISiteRoutingDescEnd: " bağlantısına tıklayabilirsiniz.",
            integrationOK: "Entegre edildi",
            chatWidget: "Supsis Sohbet Balonu",
            artificialIntelligence: "Yapay Zeka",
            integratePlatform: "Chatbot {integretable} ile entegre edilebilir.",
            integrateOpenAIWithChatbot: "Chat GPT-4o'ü Chatbot ile Entegre Edin",
            integrateChatBotWithChatGPT3: "ChatBot'un Chat GPT-4o ile Entegrasyonu",
            integrateStoryWithTelegram: "Telegram Chatbot ile Entegrasyonu",
            webhooks: "Web Kancaları",
            archive: "Arşiv",
            reports: "Raporlar",
            uncheckAll: "Tümünü bırak",
            userSegments: "Kullanıcı Bölümleri",
            plans: "Planlar",
            chatBotPlans: "Chat Bot Planlar",
            addSegment: "Bölüm Ekle",
            addToSegment: "Bölüme Ekle",
            removeFromSegment: "Bölümden Çıkar",
            plansVTippyContent:
                "Bu paket için ücretlendirme her ay başı yapılacaktır, iptal etmek istediğiniz süreçte kullanımınız ay başına kadar ücretlendirilecektir ve paketiniz bitecektir.<br><br>Paket değişiklikleri ertesi gün faturaya yansımaktadır. <br><br>Paket fiyatı KDV harici fiyatıdır.",
            segmentName: "Bölüm Adı",
            sameSegment: "Aynı isimde bir segment mevcut",
            usersInSegment: "Bölümdeki Kullanıcılar",
            noUsersAdded: "Kullanıcı eklenmedi",
            updateSegment: "Bölümü Güncelle",
            newSegment: "Yeni Bölüm",
            selectAll: "Tümünü seç",
            queriesSelected: "sorguları seçildi",
            noBlocksFound: "Blok bulunamadı!",
            userQuery: "Kullanıcı Sorgusu",
            date: "Tarih",
            unmatched: "Eşleşmeyen",
            goToChat: "Sohbete Git",
            selectStory: "Hikaye Seç",
            selectBlock: "Blok Seç",
            training: "Bot Eğitimi",
            trainingAlert:
                "Bot eğitimi sayfasında yaptığınız değişikliklerin uygulanması için değişiklik yaptığınız senaryonun yeni versiyonunu yayınlamanız gerekmektedir.",
            unmatchedPhrases: "Eşleşmeyen İfadeler",
            ignored: "Önemsiz",
            story: "Hikaye",
            timePeriod: "Zaman Dilimi",
            wholeTimeSpan: "Tüm zamanlar",
            selectAStory: "Bir hikaye seçin",
            searchUserQuery: "Kullanıcı sorgusu ara",
            time: {
                today: "Bugün",
                yesterday: "Dün",
                last7: "Son 7 Gün",
                last30: "Son 30 Gün",
                "this-month": "Bu Ay",
                "last-month": "Geçen Ay",
                "last-3-month": "Son 3 Ay",
                "this-year": "Bu Yıl",
                "last-year": "Geçen Yıl",
                custom: "Farklı Bir Tarih Seç",
            },
            emailProvider: "E-mail sağlayıcı",
            triggerFromAnywhere: "Her yerden tetiklenebilir",
            editWebhook: "Webhook düzenle",
            newWebhook: "Yeni Webhook",
            webhookTitle: "Webhook Başlığı",
            webhookUrl: "Webhook URL'si",
            webhookToken: "WebHook Token",
            webhookUsername: "WebHook Kullanıcı adı",
            webhookPassword: "WebHook Parolası",
            allIntegrations: "Tüm Entegrasyonlar",
            integrateYourCBwithChatWidget: "Chatbotu Chat Widget ile entegre edin.",
            integrateYourCBwithChatGpt3: "Chatbot, GPT-4o ile entegre edilebilir. GPT-4o api key gerekli.",
            integrateYourCBwithWebHook: "ChatBot ve web hizmetleriniz arasında sohbet bilgilerini kolaylıkla iletin.",
            integrateYourCBwithIntegratable: "ChatBot ve {integratable} arasında sohbet bilgilerini kolaylıkla iletin.",
            addWebhook: "Webhook Ekle",
            editBlock: "Düzenle",
            moveBlock: "Taşı",
            copyBlock: "Kopyala",
            chatbot: "Chatbot",
            addFilter: "Filtre Ekle",
            addFilterGroup: "Filtre Grubu Ekle",
            in: "içinde",
            and: "ve",
            or: "veya",
            allStories: "Tüm Hikayeler",
            addBot: "Bot Oluştur",
            testBot: "Botu Test Et",
            publish: "Yayınla",
            editName: "Adı Düzenle",
            search: "Hikayenizde arayın…",
            typeMoreThan3Char: "En az 3 karakter girin ",
            expand: "Genişlet",
            expandAll: "Tümünü Genişlet",
            noMatchingItem: "Eşleşen öğe yok",
            hint: "İpucu",
            select: "Seç",
            navigate: "Gezin",
            dismiss: "Vazgeç",
            choseAttribute: "Filtre türünü seçin",
            selectReply: "Yanıt türünü seçin",
            preview: "Önizleme",
            draft: "Taslak",
            lastUpdate: "Son Güncelleme",
            published: "Yayınlandı",
            newStory: "Yeni Hikaye",
            updateStory: "Hikayeyi Güncelle",
            storyDescription: "Hikaye Açıklaması",
            storyTitle: "Hikaye Başlığı",
            deleteSingleBlock: "Tek Bloğu Sil",
            deleteWithChildren: "İç Dallanmalarla Birlikte Sil",
            startTestFromHere: "Testi Buradan Başlat",
            copyBlockId: "Blok ID'sini Kopyala",
            gotoLiveLink: "Buradan Canlı Link Oluştur",
            copyBlockIdSuccessfull: "Blok ID'sini Kopyalandı",

            collapse: "Daralt",
            collapseAll: "Tümünü Daralt",
            snDelay: "{delay} sn gecikme",
            blockUpdated: "Blok Güncellendi",
            addPayload: "Cevap Ekle",
            previewModeCaution:
                "Şuanda hikayenizin versiyonlarından birinin önizlemesini yapıyorsunuz. Önizleme modunda değişiklikleri kaydedemezsiniz!",
            enterText: "Buraya yazın...",
            trackpad: "Trackpad",
            navigation: "Navigasyon",
            navigationDesc:
                "Lütfen navigasyon modunuzu seçin. İzleme dörtgeni veya fare seçeneklerinden dilediğinizi seçebilirsiniz..",
            botSetting: "Bot Ayarı",
            botSettingDesc:
                "Lütfen güven seviyesini belirleyin. Bu, kullanıcı girişleriyle ilgili chatbot yorumlarının doğruluğunu tanımlayan 0 ile 100 arasında bir yüzdedir. ",
            languageSettingsDesc: "Lütfen Bot'un yanıt verdiği dilin tercih ettiğiniz dil olduğundan emin olun.",
            mouse: "Mouse",
            Interactions: "Etkileşimler",
            Actions: "Aksiyonlar",
            Supsis_Actions: "Supsis Aksiyonları",
            Shopify_Actions: "Shopify Aksiyonları",
            Akinon_Actions: "Akinon Aksiyonları",
            IdeaSoft_Actions: "Ideasoft Aksiyonları",
            START_POINT: "BAŞLANGIÇ NOKTASI",
            AI_ASSISTANT: "YAPAY ZEKA ASISTAN",
            BOT_RESPONSE: "BOT'UN YANITI",
            AI_BOT_RESPONSE: "YZ YANIT (GPT-4o)",
            AI_CLASSIFICATION: "YZ SINIFLANDIR",
            Templates: "Şablon Bloklar",
            AI_MENU_FLOW: "Hazır Menü Flow",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "VARSAYILAN AKSİ DURUM",
            DEFAULT_TIMEOUT: "VARSAYILAN Zaman Aşımı",
            AI_FUNCTIONS: "YZ FONKSIYON",
            FILTER: "FİLTRE",
            addNewFilter: "Yeni filtre ekle",
            FLOW: "AKIŞ",
            ATTACHMENT_INPUT: "DOSYA GİRİŞİ",
            USER_INPUT: "KULLANICI GİRİŞİ",
            GO_TO_STEP: "ADIM'A GİT",
            WEBHOOK: "WEB HOOK",
            SET_ATTRIBUTE: "ÖZELLİK AYARLA",
            QUESTION: "SORU",
            CLOSE_CHAT: "SOHBETİ KAPAT",
            CREATE_TICKET: "TICKET OLUŞTUR",
            TRANSFER_CHAT: "SOHBETİ AKTAR",
            TRANSFER_TO_CHATBOT: "CHATBOTA YÖNLENDİR",
            TAG_CHAT: "ETIKET EKLE",
            REMOVE_TAG: "ETIKET SIL",
            SET_DEPARTMENT: "DEPARTMANA AYARLA",
            SEND_TRANSCRIPT: "TRANSKRİPT GÖNDER",
            SEND_SMS: "SMS GONDER",
            SEND_MAIL: "MAIL GONDER",
            CREATE_EVENT: "ETKİNLİK OLUŞTUR",
            CREATE_RESERVATION: "REZERVASYON OLUŞTUR",
            RESERVATION_OPEN_URL: "Rezervasyon Ekranı Görüntüle",
            RESERVATION_SELECT_DAY: "Rezervasyon günü seç",
            RESERVATION_EVENT_LIST: "Müşteri Rezervasyon Listesi",
            RESERVATION_SELECT_TIME: "Rezervasyon saati seç",
            CREATE_TASK: "GÖREV OLUŞTUR",
            SHOPIFY_SHOW_PRODUCTS: "SHOPIFY ÜRÜNLERİ GÖSTER",
            SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY ÜRÜN VARLIĞI",
            SHOPIFY_ORDER_STATUS: "MAĞAZA SİPARİŞ DURUMU",

            AKINON_SHOW_PRODUCTS: "AKINON ÜRÜN GÖSTER",
            AKINON_FIND_PRODUCT: "AKINON ÜRÜN BUL",
            AKINON_ORDER_STATUS: "AKINON SİPARİŞ DURUMU",
            AKINON_SELECT_ORDER: "AKINON SİPARİŞ SEÇ",
            AKINON_SELECT_SIZE: "AKINON BEDEN SEÇ",
            AKINON_FIND_NEAREST_STOCK: "MAĞAZA STOK GÖSTER",
            AKINON_FIND_NEAREST_STORES: "YAKIN MAĞAZALARI GÖSTER",
            AKINON_SHOW_DISCOUNT_CODES: "İNDİRİM KODU GÖSTER",

            IDEASOFT_SELECT_ORDER: "SİPARİŞ SEÇ",
            IDEASOFT_ORDER_STATUS: "SİPARİŞ DURUMU ÇEK",
            IDEASOFT_GET_MEMBER_INFO: "ÜYE DETAY GETİR",

            followingAttributesFilled: "Aşağıdaki niteliklerler dolu olarak gelecektir.",
            GET_LOCATION: "KONUM AL",
            FALLBACK: "AKSİ DURUM",
            TIMEOUT: "ZAMAN AŞIMI",
            SUCCESS: "BAŞARILI",
            FAILURE: "BAŞARISIZ",

            Probel_Actions: "Probel Aksiyonları",
            PROBEL_SELECT_BRANCH: "Branş Seç",
            PROBEL_SELECT_CLINIC: "Poliklinik Seç",
            PROBEL_SELECT_DAY: "Randevu Günü Seç",
            PROBEL_SELECT_HOUR: "Randevu Saati Seç",
            PROBEL_MAKE_APPOINTMENT: "Randevu Oluştur",
            PROBEL_CANCEL_APPOINTMENT: "Randevu İptal",
            PROBEL_GET_PATIENT_TOKEN: "Hasta Token Al",
            PROBEL_FILL_INFO: "MERNIS Bilgi Getir",
            PROBEL_SELECT_APPOINTMENT: "Randevu Seç",
            SUPPRESSION_ADD: "Kullanıcı Engelle",
            SUPPRESSION_REMOVE: "Kullanıcı Engel Kaldır",
            SEND_WP_BUSINESS_MESSAGE: "WHATSAPP MESAJ GÖNDER",
            INSTAGRAM_COMMENT_REPLY: "Yorumu Yanıtla",
            INSTAGRAM_COMMENT_DELETE: "Yorumu Sil",
            INSTAGRAM_COMMENT_SHOW: "Yorumu Göster",
            INSTAGRAM_COMMENT_HIDE: "Yorumu Gizle",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "Yoruma DM Yanıt",
            message: "Mesaj",
            condition: "Şart",
            score: "Skor",
            equal: "eşit",
            not_equal: "eşit değil",
            contain: "içerir",
            not_contain: "içermez",
            starts_with: "ile başlar",
            ends_with: "ile biter",
            empty: "boş",
            longer_than: "daha uzun",
            shorter_than: "daha kısa",
            less_than: "daha az",
            less_than_equal: "küçük eşittir",
            greater_than: "büyüktür",
            greater_than_equal: "büyük eşittir",
            value: "Değer",
            failures: "Başarısız",
            email: "E-posta",
            name: "İsim",
            username: "Kullanıcı adı",
            source: "Kaynak",
            language: "Dil",
            timezone: "Saat Dilimi",
            region: "Bölge",
            country: "Ülke",
            referrer: "Yönlendiren",
            url: "URL",
            ip: "IP",
            city: "Şehir",
            lastSeen: "Son Görülen",
            userId: "Kullanıcı ID",
            selectStep: "Adım'ı Seçin",
            keywords: "Anahtar Kelime",

            userSays: "Kullanıcının Söyledikleri",
            addKeyword: "Anahtar Kelime Ekle",
            addUserMessage: "Kullanıcı Mesajı Ekle",
            set: "Özellik",
            to: "ile",
            gender: "Cinsiyet",

            go_to_failure: "Başarısız Yanıt adımına git",
            go_to_success: "Başarılı Yanıt adımına git",
            untilFilled: "sürekli",
            time1: "Bir kere",
            time2: "2 kere",
            time3: "3 kere",
            time4: "4 kere",
            time5: "5 kere",
            any: "Herhangi birşey",
            anytext: "Herhangi bir yazı (harfler veya boşluklar)",
            anytextDescription: "Boş olmayan harfler ve boşluklarla eşleşir",
            alphanumeric: "Harfler Ve Sayılar",
            integer: "Tam Sayı",
            no: "Hayır",
            number: "Sayı",
            phone: "Telefon",
            yes: "Evet",
            yesNo: "Evet - Hayır",
            anyDescription: "Boş olmayan herhangi bir şeyle eşleşir.",
            alphanumericDescription: "Hem harflerle hem de sayılarla eşleşir.",
            integerDescription: "Herhangi bir tamsayı ile eşleşir.",
            noDescription: "Hayır ile eş anlamlı sözcüklerle eşleşir.",
            numberDescription: "Sıralı temel sayıylarla eşleşir.",
            phoneDescription: "Telefon numarasıyla eşleşir.",
            yesDescription: "Evet kelimesinin eş anlamlılarıyla eşleşir.",
            yesNoDescription: "Evet ve hayır kelimelerinin eşanlamlılarıyla eşleşir.",
            emailDescription: "E-postayla eşleşir.",
            urlDescription: "URL ile eşleşir.",
            temperature: "Sıcaklık",
            askWhenInvalid: "geçersiz olursa sor",
            applyFilter: "Filtre Ekle",
            notificationMessageStartSuccess: "Blok ",
            notificationMessageEndSuccess: " Eklendi",
            notificationMessageStartError: "Bir hata oluştu, blok ",
            notificationMessageEndError: " eklenemedi",
            blockChangedWannaUpdate: "Güncellemeyi Kaydetmek İstiyormusunuz ?",
            TEXT: "Yazı",
            IMAGE: "Resim",
            GALLERY: "Galeri",
            BUTTON: "Buton",
            RANDOM_TEXT: "Rastgele Yazı",
            QUICK_REPLY: "Hızlı Cevap",
            FILE: "Dosya",
            responses: "Tepkiler",
            flow: "Akış",
            active: "Aktif",
            passive: "Pasif",

            chooseAttributeType: "Özellik Türünü Seçin",
            imageAttachment: "Resim Ekleme",
            audioAttachment: "Ses Ekleme",
            videoAttachment: "Video Ekleme",
            documentAttachment: "Belge Ekleme",
            anyAttachment: "Herhangi bir Ek",
            typeAttributeValue: "Özellik Değerini Gir",
            typeSearchValue: "Arama Değeri yazın",
            male: "Erkek",
            addAttribute: "Özellik Ekle",
            addAttributeDescription:
                "Özniteliğin adı yalnızca A-Z harfleri, 0-9 sayıları, tire veya alt çizgi olan alfasayısal karakterler içerebilir.",
            USER_DATA: "Kullanıcı Bilgisi",
            CUSTOM_ATTRIBUTES: "ÖZEL ÖZNİTELİKLER",
            enterBotResponseHere: "Buraya Bot'un soracağı soruyu yazın...",

            addCard: "Kart Ekle",
            addButton: "Buton Ekle",
            typeCardTitle: "Kart Başlığı",
            typeCardDescription: "Kart Açıklaması",
            dragAndDropBrowse: "Resim Yükle",
            dragAndDropBrowseFile: "Upload File",
            button: "Buton",
            enterYourMessage: "Mesajınızı Girin",
            imageView: "Resim görünümü",
            imageUploading: "Resim Yükleniyor...",
            fileUploading: "File Uploading...",
            clickToChooseNewImage: "Yeni Resim Seçmek İçin Tıklayın",
            clickToChooseNewFile: "Click To Choose New File",
            removeTheExistingOne: "Mevcut Olanı Kaldır",
            validateResponseWithEntity: "Yanıtı Doğrula",
            actionOnFailureInput: "Hatalı Yazım Durumunda Ne Yapılsın?",
            askNextQuestion: "Bir sonraki soruyu sor",
            goToSuccessBlock: "Başarılı Bloğuna Git",
            goToFailureBlock: "Başarısız Bloğuna Git",
            saveResposeToAttribute: "Yanıtı Kaydet",
            selectReplyType: "Yanıt Türü'nü seçin",
            questionVariants: "Soru Çeşitleri",
            systemEntities: "Tanımlı Doğrulama İfadeleri",
            delay: "Gecikme",
            retrySectionTextPart: " sor.",
            retrySectionText: "Kulanıcının yanıtı geçersiz ise ",
            addNextQuestion: "Sonraki Soruyu Ekle",
            typeBlockTitle: "Blok başlığı",
            versionHistory: "Sürüm Geçmişi",
            restore: "Güncelle",
            versionName: "Versiyon Adı",
            restoreModalText:
                "Bu eylem, seçilen sürümü geri yükleyecektir. Bu sürümü geri yüklemek istediğinizden emin misiniz?",
            restoreVersion: "Versiyon Güncelle",
            newVersion: "Yeni Versiyon",
            synonymMustBeUnique: "Aynı Eşanlamlı Kelimeleden Birden Fazla Olamaz ",
            save: "Kaydet",
            entries: "Girdiler",
            youHaveNoEntries: "Girdi Bulunamadı",
            inputsCantBeEmpty: "Alanlar Boş Bırakılamaz",
            entryNamesMustBeUnique: "Anahtar Kelime Aynı Olamaz!",
            entityNameCantBeEmpty: "Varlık Adı Boş Bırakılamaz",
            entityNameMustBeUnique: "Varlık Adı Aynı Olamaz",
            synonyms: "Eş Anlamlılar",
            title: "Anahtar Kelime",
            entryName: "Girdi Adı",
            entities: "Varlıklar",
            entityhasbeenUpdatedSuccessfully: "Varlık Başarıyla Kaydedildi",
            emptyError: "Gerekli Alanlar Boş Bırakılamaz",

            allChats: "Tüm Sohbetler",
            paidChats: "Ücretli Sohbetler",
            busiestPeriod: "En Yoğun Dönem",
            ratingDistribution: "Puanlama Dağılımı",
            allMessages: "Tüm mesajlar",
            avarageMessages: "Ortalama Mesajlar",
            popularity: "Popülerlik",
            allUsers: "Tüm kullanıcılar",
            interactionName: "Etkileşim Adı",
            numberOfMessage: "Mesaj Sayısı",
            ofAllUsersMessage: "% Tüm Kullanıcıların Mesajı",

            totalData: "Toplam Veri",
            avgData: "Ortalama Veri",
            exportToCsv: "Csv'ye Aktar",
            exportToExcel: "Excel'e Aktar",
            inMaintenance: "Yapım Aşamasında",
            ADD_TO_SEGMENT: "Bölüme Ekle",
            REMOVE_FROM_SEGMENT: "Bölümden Çıkar",
            users: "Kullanıcılar",
            webhookName: "Webhook Adı",
            webHookUrl: "Webhook url",
            webHookToken: "Webhook Token",
            delete: "Sil",
            basicAuth: "Basic Auth",
            requiredFieldsCannotBeLeftBlank: "Zorunlu Alanlar Boş Bırakılamaz ",

            yourVerificationToken: "Token",
            yourWebHookName: "Webhook Adınız",
            yourWebHookUrl: "Webhook URL'niz",
            enterKey: "Key",
            password: "Şifre",
            headerValue: "Value",
            saveSuccessfully: "İşleminiz Başarıyla Kaydedildi.",
            urlTypeError: "Lütfen Alanı Doğru Şekilde Doldurunuz (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "OpenAI Chat GPT-4o İçin Api Anahtarı Gerekli.",
                apiKeyDesc:
                    "Chatbot + Chat GPT-4o entegrasyonu için Api Key gereklidir. Lütfen api anahtarınızı alın veya deneme için aşağıdaki api anahtarını kullanın. Deneme amaçlı sadece 20 mesaj kullanabilirsiniz.",
                getApiKey: "Bir Open AI Api Anahtarını Alın",
                typeApiKey: "Api anahtarını yazın",
                ownApiKey: "OpenAI Api Anahtarına Sahip Olun",
                trialApiKey: "Deneme Api Anahtarı (20 Mesaj Olarak Sınırlıdır)",
                useOurTrial: "Ücretsiz Deneme Sürümümüzü Kullanın",
                twentyMessages: "20 Mesajı ücretsiz olarak kullanıp deneyebilirsiniz.",
                enableChatGpt3: "Chat GPT-4o Aktifleştirin",
            },
        },
        coupon: {
            code: "Kod",
            discount: "İndirim",
            endDate: "Bitiş Tarihi",
            name: "İsim",
            email: "E-posta",
            phone: "Telefon",
            add: "Kupon Ekle",
            coupons: "Kuponlar",
            couponDeleted: "Kupon Silindi",
            limit: "Limit",
            visitorBan: "Visitör engellenmiştir.",
            visitorUnBlock: "Engeli Kaldırılmıştır.",
        },
        instagramTitle: "Instagram Özelliklerini etkinleştirmek için aşağıdaki butona tıklayın.",
        instegramFunctionActive: "Instagram Özelliğini Etkinleştir",
        ChatBOT: "Chat Bot",
        WhatsappContacts: "Whatsapp Kişileri",
        InstagramContacts: "Instagram Kişileri",
        MessengerContacts: "Messenger Kişileri",
        volumeUp: "Sesi Aç",
        minimize: "Küçült",
        maximize: "Büyüt",
        auditLogs: {
            auditLogsTitle: "Denetim Logları",
            auditLogsSub:
                "Denetim günlükleri, son 30 gün içinde şirketinizde gerçekleşen olayları takip etmenizi sağlar.",
        },
        task: {
            workflow: "İş Akışı",
            workflowDetail: "İş Akışı Detay",
            workflowPerm: "İş Akışı Yetkileri",
            perm: "Yetkiler",
            detail: "Detaylar",
            userPerm: "Kullanıcı Yetkileri:",
            deleteCard: "Kart Silme",
            createCard: "Kart Oluşturma",
            editCard: "Kart Düzenleme",
            dragCard: "Kart Taşıma",
            allWorkflow: "Tüm İş Akışları",
            createworkflow: "İş Akışı Oluştur",
            deleteWorkflow: "Bu İş Akışını Silmek İstediğinize Emin Misiniz?",
            permEditTask: "Bu Taskı Düzenleme Yetkiniz Yok",
            permEditTaskDes: "Düzenleme Yetkisi İçin Yöneticinizle İletişime Geçiniz.",
            createTaskError: "Görev Oluşturma Yetkiniz Yok",
            createTaskErrorDesc: "Görev Oluşturma Yetkisi İçin Yöneticinizle İletişime Geçiniz",
            moveTaskError: "Görev Durumu Değiştirme Yetkiniz Yok",
            moveTaskErrorDesc: "Görev Durumu Değiştirme Yetkisi İçin Yöneticiniz ile İletişime Geçiniz",
            deleteTaskError: "Görev Silme Yetkiniz Yok",
            deleteTaskErrorDesc: "Görev Silme Yetkisi İçin yöneticinizle İletişime Geçiniz",
            permissionError: "Görev Oluşturma Yetkiniz Yok",
            permissionErrorDesc: "Görev Oluşturma Yetkisi İçin Yöneticinizle İletişime Geçiniz",
            whatsappContactProfileTitle: "{name} / {number} Profili",
            createTaskVisitor: "Görev Oluştur (Ziyaretçi)",
            editWorkflow: "Workflow'u Düzenle",
            visitor: "Ziyaretçi Profili",
            createTaskMessage: "Görev Oluştur (Mesaj)",
            createStage: "Aşama Oluştur",
            stagesAndStatuses: "Aşamalar ve Durumlar",
            workflowCreateDesc: "Workflow Açıklaması",
            subTasks: "Alt Görevler",
            followers: "Takipçiler",
            collaborators: "Üzerinde çalışanlar",
            addRelations: "İlişki ekle",
            relations: "İlişkili",
            main: "Ana Sekme",
            name: "Adı",
            completedOfCheck: "{total} görevden {completed} tamamlandı",
            workflowUpdateMs: "Workflow Başarıyla Güncellendi",
            taskUpdateMs: "Görev Başarıyla Güncellendi",
            workflowCreatedMs: "Workflow Başarıyla Oluşturuldu",
            workflowCreateError: "Workflow Oluşturulamadı",
            taskCreatedMs: "Görev Başarıyla Oluşturuldu",
            settingsDesc4:
                "Bu şekilde, her bir görevinizi detaylı bir şekilde izleyebilir, ekip üyelerine görev atamaları yapabilir ve genel olarak iş süreçlerinizi daha etkili bir şekilde yönetebilirsiniz. Supsis görev modülü, iş yönetimi ve takım koordinasyonu konusunda size kapsamlı bir çözüm sunar.",
            settingsDesc3:
                "Ayrıca, Supsis görev modülü, özelleştirilebilir bir iş akışıyla kendi çalışma düzeninizi oluşturmanıza olanak tanır. Otomatizasyonlarla görevleri daha etkili bir şekilde yönetebilir ve ekip içindeki işbirliğini artırabilirsiniz.",
            settingsDesc2:
                "Supsis görev modülü, hiçbir görevin gözden kaçmasına izin vermez. Görevleri herhangi bir parametreye göre filtreleyebilir, her iş akışı aşamasının iş yükünü takip edebilir ve takviminizi düzenleyebilirsiniz, böylece zamanlamalarınıza uyum sağlayabilirsiniz.",
            settingsDesc1:
                "Görevler modülü, işbirliği içindeki çalışmaları düzenlemenize, görevleri devretmenize ve takımınızın ilerlemesini izlemenize olanak tanır. İhtiyaçlarınıza göre görevlerinizi herhangi bir görünümü seçerek düzenleyebilir ve otomasyonlarla kendi özel iş akışınızı oluşturabilirsiniz.",
            taskModuleSettingsTitle: "Görev Modülü Ayarları",
            high: "Yüksek",
            medium: "Orta",
            low: "Düşük",
            priority: "Öncelik",
            addExistsSubtask: "Varolan Alt Görevi Ekle",
            addSubtask: "Alt Görev Ekle",
            add: "Ekle",
            newCheckList: "Yeni Checklist",
            subtaskTitle: "Alt Görev Başlığı",
            view: "Görüntüle",
            attachFiles: "Dosya ekle",
            createTaskDesc: "Görev açıklaması",
            title: "Başlık",
            createWorkflow: "Workflow Oluştur",
            editTask: "Görevi Düzenle",
            createTask: "Görev Oluştur",
            deleteColumnCont: "Bu kolonu silmek istediğinizden emin misiniz ?",
            changeStage: "Durum Değiştir",
            assignees: "Atananlar",
            owner: "Sahip",
            stage: "Durum",
            writeSomething: "Bir şey yazın",
            selectAssginee: "Atanacak Kişi",
            assignee: "Atanan",
            enterNewTaskDesc: "Yeni Görev Açıklaması",
            enterNewTaskTitle: "Yeni Görev Başlığı",
            task: "Görev",
            deleteTaskCont: "Bu görevleri silmek istediğinizden emin misiniz ?",
            deleteWorkFlowCont: "Bu Workflow'u silmek istediğinizden emin misiniz?",
            completed: "Tamamlandı",
            todo: "Yapılacak",
            kanbanBoard: "Kanban Panosu",
            listView: "Liste Görünümü",
        },
        permissionErrors: {
            userCreate: "Kullanıcı Eklemek için yetkiniz yok. Yöneticinizle görüşün",
            userRead: "Kullanıcıları Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            userUpdate: "Kullanıcıları Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            userDelete: "Kullanıcıları Silmek için yetkiniz yok. Yöneticinizle görüşün",
            visitorBlock: "Ziyaretçileri Engellemek için yetkiniz yok. Yöneticinizle görüşün",
            visitorUnblock: "Ziyaretçileri Engelini Açmak için yetkiniz yok. Yöneticinizle görüşün",
            visitorDetailRead: "Ziyaretçi Detayı Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            visitorListRead: "Ziyaretçi Listesini Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            visitorDelete: "Ziyaretçi Silmek için yetkiniz yok. Yöneticinizle görüşün",
            visitorExcel: "Excel Çıktısı Almak için yetkiniz yok. Yöneticinizle görüşün",
            visitorUpdate: "Ziyaretçi Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            bannedVisitorRead: "Yasaklı Ziyaretçi Listesini Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            bannedWordCreate: "Yasaklı Kelime Eklemek için yetkiniz yok. Yöneticinizle görüşün",
            bannedWordRead: "Yasaklı Kelimeleri Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            bannedWordDelete: "Yasaklı Kelimele Silmek için yetkiniz yok. Yöneticinizle görüşün",
            chatRead: "Konuşmaları Görmek için yetkiniz yok. Yöneticinizle görüşün",
            chatUpdate: "Konuşmaları Düzenlemek için yetkiniz yok. Yöneticinizle görüşün",
            archiveRead: "Arşivi Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            roleCreate: "Rol Eklemek için yetkiniz yok. Yöneticinizle görüşün",
            roleRead: "Rolleri Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            roleUpdate: "Rolleri Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            roleDelete: "Rol Silmek için yetkiniz yok. Yöneticinizle görüşün",
            departmentCreate: "Departman Eklemek için yetkiniz yok. Yöneticinizle görüşün",
            departmentRead: "Departmanları Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            departmentUpdate: "Departman Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            departmentDelete: "Departman Silmek için yetkiniz yok. Yöneticinizle görüşün",
            preparedContentCreate: "Hazır İçerik Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            preparedContentRead: "Hazır İçerik Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            preparedContentUpdate: "Hazır İçerik Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            preparedContentDelete: "Hazır İçerik Silmek için yetkiniz yok. Yöneticinizle görüşün",
            welcomeCreate: "Karşılama Mesajı Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            welcomeRead: "Karşılama Mesajlarını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            welcomeUpdate: "Karşılama Mesajı Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            welcomeDelete: "Karşılama Mesajı Silmek için yetkiniz yok. Yöneticinizle görüşün",
            settingCreate: "Ayar Eklemek için yetkiniz yok. Yöneticinizle görüşün",
            settingRead: "Ayarları Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            settingUpdate: "Ayarları Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            settingDelete: "Ayar Silmek için yetkiniz yok. Yöneticinizle görüşün",
            reportCreate: "Rapor Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            reportRead: "Raporları Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            reportUpdate: "Raporları Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            reportDelete: "Rapor Silmek için yetkiniz yok. Yöneticinizle görüşün",
            offlineSupportRequestCreate: "Ticket Oluşturmak için yetkiniz yok. Yöneticinizle görüşün ",
            offlineSupportRequestRead: "Ticketleri Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            offlineSupportRequestUpdate: "Ticketlere Cevap Vermek için yetkiniz yok. Yöneticinizle görüşün",
            offlineSupportRequestDelete: "Ticketleri Silmek için yetkiniz yok. Yöneticinizle görüşün",
            catalogCreate: "Katalog Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            catalogRead: "Katalogu Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            catalogUpdate: "Katalog Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            catalogDelete: "Katalog Silmek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotStoryCreate: "Chatbot Hikayesi Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            chatbotStoryRead: "Chatbot Hikayelerini Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotStoryUpdate: "Chatbot Hikayelerini Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotStoryDelete: "Chatbot Hikayelerini Silmek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotTemplateRead: "Chatbot Şablonlarını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotTemplateAiRead: "Yapay Zeka Chatbot Şablonlarını Görmek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotIntegrationsRead: "Chatbot Entegrasyonlarını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotArchiveRead: "Chatbot Arşivi Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotEntitiesRead: "Chatbot Varlıklarını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotEntitiesCreate: "Chatbot Varlığı Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            chatbotEntitiesUpdate: "Chatbot Varlıklarını Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotEntitiesDelete: "Chatbot Varlıkları Silmek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotReportRead: "Chatbot Raporlarını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotTrainRead: "Chatbot Eğitimini Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotSegmentCreate: "Chatbot Kullanıcı Bölümü Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            chatbotSegmentRead: "Chatbot Kullanıcı Bölümlerini Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotSegmentUpdate: "Chatbot Kullanıcı Bölümlerini Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            chatbotSegmentDelete: "Chatbot Kullanıcı Bölümlerini Silmek için yetkiniz yok. Yöneticinizle görüşün",
            integrationsRead: "Entegrasyonlar Sayfasını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            whatsappIntegrationRead:
                "Whatsapp Entegrasyon Sayfasını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            instagramIntegrationRead:
                "Instagram Entegrasyon Sayfasını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            telegramIntegrationRead:
                "Telegram Entegrasyon Sayfasını Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            integrationCreate: "Entegrasyon Etkinleştirmek için yetkiniz yok. Yöneticinizle görüşün",
            triggerCreate: "Tetikleyici Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            triggerRead: "Tetikleyicileri Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            triggerUpdate: "Tetikleyicileri Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            triggerDelete: "Tetikleyici Silmek için yetkiniz yok. Yöneticinizle görüşün",
            billingRead: "Faturaları Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            taskCreate: "Görev Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            taskRead: "Görevleri Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            taskUpdate: "Görevleri Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            taskDelete: "Görev Silmek için yetkiniz yok. Yöneticinizle görüşün",
            calendarCreate: "Takvim/Rezervasyon Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            calendarRead: "Takvim/Rezervasyon Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            calendarUpdate: "Takvim/Rezervasyon Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            calendarDelete: "Takvim/Rezervasyon Silmek için yetkiniz yok. Yöneticinizle görüşün",
            mailCreate: "Mail Oluşturmak için yetkiniz yok. Yöneticinizle görüşün",
            mailRead: "Mailleri Görüntülemek için yetkiniz yok. Yöneticinizle görüşün",
            mailUpdate: "Mailleri Güncellemek için yetkiniz yok. Yöneticinizle görüşün",
            mailDelete: "Mail Silmek için yetkiniz yok. Yöneticinizle görüşün",
        },
        message: {
            noConversationDesc: "Burada aktif sohbetleri ve size atanmış sohbetleri görebilirsiniz.",
            forMe: "Bana Özel",
            unAssigned: "Atanmamış",
            agentDetails: "Temsilci Detayları",
            contactProperties: "Kullanıcı Değerleri",
            goToProfile: "Profile Git",
            addNote: "Not Ekle",
            noPreferredAgent: "Henüz Tercih Edilen Bir Temsilci Yok",
            toPrefer: "Tercih Et",
            inChat: "Sohbette",
            watching: "İzliyor",
            chatsTitle: "Sohbetler",
            dealyTimeMaxValueError: "Gecikme süresi en fazla 15 olabilir",
            dealyTimeTypeError: "Gecikme süresi sayı olmalı",
            passedTimeHm: "{hour} Saat {min} Dakika",
            passedTimeMs: "{min} Dakika {sec} saniye",
            passedTimeSc: "{Sec} Saniye",
            translateMessage: "Mesajınız yapay zeka tarafından çevrilmiştir.",
            toneChanged: "Mesaj tonu {tone} olarak değiştirildi",
            aiResponseAdded: "Yapay Zeka Yanıtı Mesaja Eklendi",
            messageLonger: "Mesaj Daha Uzun Hale Getirildi",
            grammarFixed: "Yazım Düzeltildi",
            aiTranslate: "Çeviri",
            other: "Diğer",
            yourLanguage: "Sizin diliniz",
            myLanguage: "Benim dilim",
            forwardToChatbot: "Chatbota İlet",
            friendly: "Dostça",
            confident: "Kararlı",
            straightForward: "Basit",
            casual: "Gündelik",
            professional: "Profesyonel",
            longSentence: "Uzun Cümle",
            changeTone: "Tonu Değiştir",
            fixGrammar: "Yazım Düzelt",
            aiResponse: "Yapay Zeka Yanıtı",
            templateButtonNote:
                "Kişiyi yasaklamak için, büyük veya küçük harf fark etmeksizin yasaklama düğmesinde aşağıdaki metinleri kullanmaya dikkat edin. ",
            templateButtonTags: "#Mesaj Gönderme# | #Abonelikten Çıkar# | #Yasakla# | #Engelle#",
            dashboard: "Kontrol Paneli",
            adminReports: "Admin Raporları",
            calendarModule: "Takvim Modülü",
            taskModule: "Görev Yönetim Modülü",
            maxUrlButtonMessage: "En fazla 2 adet url buton ekleyebilirsiniz.",
            noPreferredDepartment: "Tercih Edilen Departman Yok",
            searchForDepartment: "Departman Ara",
            departmentAssignedToTheVisitor: "Ziyaretçiye atamak istediğiniz departmanı seçin.",
            assignPreferredDepartment: "Tercih Edilen Departmana Ata",
            smsChannel: "Sms Kanalı: ",
            whatsappv2Channel: "Whatsapp V2 Kanalı: ",
            whatsappv1Channel: "Whatsapp V1 Kanalı: ",
            wBChannel: "Whatsapp Business Kanalı: ",
            messengerChannel: "Messenger Kanalı: ",
            instagramChannel: "İnstagram Kanalı: ",
            allPlatforms: "Tüm Platformlar",
            cbStartMessageDesc:
                "Kullanıcının girdiği ilk mesaj, chatbot tarafından otomatik olarak işlenerek ilgili adrese yönlendirilsin.",
            cbStartMessage: "Chatbot Başlangıç Mesajı",
            messengerUserProfile: "Messenger Kişi Profili",
            instagramUserProfile: "Instagram Kişi Profili",
            noEventFound: "Etkinlik Bulunamadı",
            visitorMails: "Ziyaretçi E-postaları",
            visitorActions: "Ziyaretçi Hareketleri",
            notVerified: "Doğrulanmadı",
            visitorEvents: "Etkinlikler",
            assignedTasks: "Atanan Görevler",
            mails: "Mailler",
            prefferedAgents: "Tercih Edilen Temsilciler",
            createEvent: "Etkinlik Oluştur",
            blockManagement: "Engelleme Yönetimi",
            deleteUser: "Kullanıcıyı Sil",
            blocked: "Engellendi",
            profiles: "Profiller",
            similiarProfiles: "Benzer Profiller Bulundu",
            ReplyAsAPm: "Özel Mesaj Olarak Yanıtla ve Kapat",
            replyAsAComment: "Yorum Olarak Yanıtla ve Kapat",
            messengerAddDesc: "Aşağıdaki Bağlan düğmesine tıklayın ve Facebook hesabınıza giriş yapın.",
            instaAddPrivacyCheckDesc: "{Privacy} ve {Terms and Conditions} Okudum Ve Kabul Ediyorum.",
            instaAddDesc5: "Aşağıdaki Bağlan düğmesine tıklayın ve Facebook hesabınıza giriş yapın.",
            instaAddDesc4: "Facebook Geliştirici olarak kaydolun",
            instaAddDesc3: "<b>'Mesajlara erişime izin ver'</b> anahtarının açık olduğundan emin olun",
            instaAddDesc2: "Instagram profesyonel hesabınızın Facebook sayfanıza bağlı olduğundan emin olun",
            instaAddDesc1: "Instagram hesabınızın bir Instagram profesyonel (Business) hesabı olduğundan emin olun.",
            selectedDepartment: "Seçilen Departman",
            departmentForwardEnable: "Departman Yönlendirme Kuralı Etkin",
            departmentForwardRule: "Departman Yönlendirme Kuralı",
            departmentForwardDesc: "Kanala gelen sohbetlerin hangi departmana yönlendirileceğini seçin.",
            channelName: "Kanal Adı",
            forwardToLiveAgents: "👉 Canlı Temsilcilere Yönlendir",
            manageIgChannel: "Instagram Kanalınızı Yönetin",
            igDetail: "Instagram Detay",
            manageVisibilityDesc: "Bu kanalı kimlerin görebileceğini yönet",
            selectAnIgAccount: "Bağlamak istediğin Instagram hesabını seç.",
            connectToInsta: "Instagram'a Bağlan",
            connectToMetaLeads: "Meta Leads Hesabına Bağlan",
            deleteInstaChannelInfo: "Instagram kanalını silmek istediğinizden emin misiniz?",
            instagramChannels: "Instagram Kanalları",
            checkboxWarning: "Bu alanın seçilmesi zorunludur",
            onlyChatbot: "Sadece Chatbot",
            onlyAgents: "Sadece Temsilciler",
            sendingAllow: "Gönderim",
            receiving: "Alım",
            platform: "Platform",
            banModalTitle: "Ziyaretçi Yasaklama Ekranı",
            selectDepartmentDesc: "Görünürlüğü değiştirmek istediğiniz departmanları seçin",
            selectAgentDesc: "Görünürlüğü değiştirmek istediğiniz temsilcileri seçin",
            selectDepartment: "Departman Seç",
            selectAgent: "Temsilci Seç",
            visibleDepartments: "Gören Departmanlar",
            visibleAgents: "Gören Temsilciler",
            visibilityInfoCont: "Tüm temsilciler ve departmanlar bu kanalı görebilir",
            editDepartmentVisibility: "Departman Görünürlüğünü düzenle",
            editAgentVisibility: "Temsilci Görünürlüğünü düzenle",
            typeSTToSearch: "Kullanıcı aramak için birşeyler yazınız",
            exportToCSV: "CSV'ye Aktar",
            clear: "Temizle",
            usedSessionCount: "Kullanılan Oturum Sayısı",
            maxSessionCount: "Maksimum Oturum Sayısı",
            leftSessionCount: "Kalan Oturum Sayısı",
            planManagement: "Plan Yönetimi",
            teamChat: "Takım Konuşması",
            templateNameIsNotValid: "Şablon Adı Geçerli Değil",
            relatedAdvertisement: "İlgili Reklam",
            whatsappNumber: "Whatsapp Numarası",
            createTask: "Görev Oluştur",
            integrationsWhatsappV1:
                "Supsis ve WhatsApp arasında sorunsuz bir iletişim kurmak için WhatsApp Planı gerekmektedir.",
            integrationsWhatsappV2: "Supsis ve WhatsApp arasında sohbet bilgilerini kolayca iletebilirsiniz.",
            integrationsWhatsappBusiness:
                "Sohbet bilgilerini hızlı ve pratik bir şekilde Supsis ve WhatsApp arasında iletebilirsiniz.",
            selectDays: "Gün Seçin",
            addTime: "Saat Ekle",
            instagramContactList: "Instagram Kişi Listesi",
            archiveAllRated: "Herhangi bir puanlama yapılan tüm konuşmaları getir.",
            allChannels: "Tüm kanallar",
            comment: "Yorum",
            news: "Yenilikler",
            conversation: "Takım konuşması",
            speechTermination: "Konuşmayı sonlandır",
            noSystemMessage: "Henüz Sistemde Mesaj Yok !",
            supsisCustomerService: "Supsis'in sunduğu müşteri hizmetleri,",
            supsisClickExperience: "deneyimini tıklayarak deneyebilirsiniz.",
            customerPage: "Müşteri Sayfasına Git",
            buttonTitle: "Buton Başlığı",
            buttonType: "Buton Tipi",
            buttonSendMessage: "Mesaj gönder",
            buttonGoToBlock: "Bloğa git",
            buttonOpenUrl: "Aç URL",
            buttonPhoneCall: "Telefon görüşmesi",
            buttonOpenMoment: "Açık Anı",
            buttonCloseChat: "Sohbeti Kapat",
            buttonTransferChat: "Sohbeti Aktar",
            buttonCreateTicket: "Bilet Oluştur",
            you: "Sen",
            and: "ve",
            deleteVisitor: "Kullanıcıyı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
            deleteThread: "Tüm mailleri silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
            deleteMail: "Maili silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
            dndBlocked: "Dosya gönderim ayarları kapalı.",
            tokenCopied: "Erişim token'ı kopyalandı.",
            apiIntegration: "Geliştirici",
            generateToken: "Token Üret",
            copyToken: "Token Kopyala",
            labels: "Etiketler",
            noData: "İçerik Yok",
            color: "Renk",
            titleColor: "Başlık Rengi",
            secondTitleColor: "İkinci Başlık Rengi",
            tag_name_indicator: "Etiket Adı",
            sendMessage: "Mesaj Gönder",
            removeFromG: "Gruptan Çıkar",
            delChannel: "Bu kanalı silmek istediğinizden emin misiniz?",
            new_name: "Yeni İsim",
            set_group_info: "Grup bilgilerini düzenle",
            shortcut_desc_num: "Numeric rakamlarla aktif konuşmalar arası geçiş yapma",
            copilot_desc_num: "Chat Ekranında Copilot u açmayı sağlar",
            typing_w_chat: "yazıyor...",
            edit_group_info: "Grup Bilgilerini Düzenle",
            notif_sound: "Bildirimlerin Sesini Aç",
            notif_mute: "Bildirimleri Sessize Al",
            leave: "Ayrıl",
            group: "Grup",
            updateTag: "Etiket Güncelle",
            os_browser: "İşletim Sistemi ve Tarayıcı",
            ordered_desc: "Sohbetleri sırayla temsilcilere atar.",
            random_desc: "Sohbetleri temsilcilere rastgele atar.",
            Rrobin_desc: "Temsilcilere sohbetleri round robin tarzında atar. (En az meşgul olan temsilciler öncelikli)",
            RrobinRev_desc:
                "Temsilcilere sohbetleri round robin tarzında atar. (En fazla meşgul olan temsilciler öncelikli)",
            algo_desc: "Otomatik sohbet atama için algoritmayı seçin",
            algorithm: "Algoritma",
            addTag: "Etiket Ekle",
            tags: "Etiketler",
            searchRepresentative: "Temsilci Arayın.",
            preferredRepresentative: "Temsilciler",
            voting: "Oylanıyor",
            chatWidget: "Supsis Sohbet Balonu",
            webhooks: "Web Kancaları",
            selectHooks: "Seçenekeler",
            planRequired: "{integratable} Plan Gerekmektedir.",
            allIntegrations: "Tüm Entegrasyonlar",
            disableAgentSystemMessages: "Temsilci sistem mesajlarını gizle",
            disableAgentSystemMessagesDesc: "Temsilci Sistem Mesajlarını Gizle.",
            disableAutoTranslate: "Otomatik Tercüme",
            disableAutoTranslateDesc:
                "Farklı dillerden gelen mesajları otomatik olarak çevirir. Böylece müşterilerinizle daha kolay iletişim kurabilirsiniz.",
            shouldAddMethod:
                "Ödeme Metodu & Fatura Adresi alanını doldurmalısınız!\nHesabınızdan para cekilmeyecektir.\n" +
                "Ay sonunda kullanım tutarınıza göre fatura oluşacaktır",
            approveSelection: "Seçiminizi Onaylayın",
            trialDaysEndSelectPlan: "Plan Seçinimini Onaylayın",
            trialDaysEndSelectPlanDesc: "Deneme sürümünüz bitmiştir. Aşağıdan plan seçerek onaylamanız gerekmektedir.",
            infinitePlay: "Sürekli çal",
            hideBubbleOnMobile: "Mobilde gizle",
            deleteSystemLanguage: "Sistemden {code} dilini siler",
            assignedChat: "Atanan Chat",
            check: "Onay kutusu",
            systemStatus: "Sistem Durumu",
            chatAssignedToUser: "Yeni chat atandı",
            inactiveThresholdTime: "Pasif Chat Süresi (dakika)",
            tippyInactiveThresholdTime:
                "Konuşmada verilen süre içinde herhangi bir mesaj gönderilmediğinde konuşma pasif olarak kabul edilir.Değeri (dakika) olarak giriniz. En az 1dk En çok 120dk olmalıdır.",
            inactiveTerminateTime: "Pasif Chat Kapatma Süresi (dakika)",
            tippyInactiveTerminateTime:
                "Konuşma pasif olduktan verilen süre  sonra kapatılacaktır. Değeri (dakika) olarak giriniz. En az 0 en çok 120dk olmalıdır.",
            removePendingMessage: "Mesaj gönderimi iptal et",
            disconnected: "Bağlı Değil",
            visitorWriteEmptyChatTippy: "Müşteri, konuşamaya temsilci bağlanmadan önce yazabilir.",
            visitorWriteEmptyChat: "Müşteri, temsilci bağlanmadan yazabilir.",
            visitorConnectionEventSystemMessageEnabled:
                "Ziyaretçinin bağlantı durumu sistem mesajlarını etkinleştirir.",
            visitorConnectionEventSystemMessageEnabledTippy:
                "Ziyaretci ayrıldı ve ziyaretci geri geldi sistem mesajlarını gösterir.",
            openBubble: "Konuşma Balonu Aç",
            showHeaderImage: "Şirket Logosu ve İsim Göster",
            changeLogo: "Logoyu Değiştir",
            changePhoto: "Resmi Değiştir",
            addPhoto: "Resim ekle",
            seePhoto: "Resmi Gör",
            deletePhoto: "Resmi Sil",
            askQuestion: "Soru sor",
            locationPermsNeeded: "Bu özelliği kullanabilmeniz için konum izinleri gerekli",
            useMyLocation: "Konumumu kullan",
            acceptingChat: "Chat alımı açık",
            notAcceptingChat: "Chat alımı kapalı",
            websiteChatWidgetIntegration: "Website Chat Balonu Entegrasyonu",
            loggedOut: "Çevrimdışı",
            listStatuses: "Durumlar",
            hideInactiveAgents: "Pasif Temsilcileri Gizle",
            hideMinorValues: "Küçük Değerleri Gizle",
            agentActivities: "Temsilci Aktivitileri",
            newHASHContent: "#Etiket Ekle",
            hash: "Etiket",
            languageRemovalQuestion: "Sistemden {code} dilini silmek üzeresiniz!",
            blockBy: "Temsilci",
            hashText: "Etiket",
            exampleHash: "siparis-takip",
            cardInfos: "Kart Bilgileri",
            saveSystemCardInfo: "Kartınız sistemimize kaydedilip ödenecek tarih geldiğinde otomatik ödenir.",
            cardNumber: "Kart Numarası",
            cardType: "Kredi Kartı Türü",
            skt: "SKT",
            cvv: "CVV",
            saveCard: "Kartı Kaydet",
            cardNameSurname: "Kart Sahibinin Adı Soyadı",
            confidentialityAgreementCheck: "Gizlilik Sözleşmesini Kabul Ediyorum",
            confidentialityAgreement: "Gizlilik Sözleşmesi",
            notValidHash: "Boşluk karakteri içermemelidir",
            videoCallEnabledDesc: "Görüntülü arama özelliğini etkinleştirmek için aktif edin",
            videoCallEnabled: "Görüntülü Arama Özelliği",
            audioCallDesc: "Sesli arama özelliğini etkinleştirmek için aktif edin",
            audioCallEnabled: "Sesli Arama Özelliği",
            assignPreferredAgent: "Tercih Edilen Temsilciyi Ata",
            representativeAssignedToTheVisitor: "Ziyaretçiye atamak istediğiniz tercih edilen temsilciyi seçin.",
            agentFileSendEnabledDesc: "Temsilcilerin dosya gönderme özelliğini etkinleştirir",
            agentFileSendEnabled: "Temsilciler Dosya Gönderebilir",
            visitorFileSendEnabledDesc: "Ziyaretciler dosya gönderme özelliğini açıp kapatmanıza izin verir",
            visitorFileSendEnabled: "Ziyaretciler Dosya Gönderebilir",
            visitorAutoLogin: "Ziyaretçi Otomatik Giriş",
            visitorAutoLoginDesc: "Ziyaretçi balonu tıklar tıklamaz konuşma başlar",
            agentVoiceRecordEnabledDesc: "Temsilcilerin ses kaydetme özelliğini etkinleştirir",
            agentVoiceRecordEnabled: "Temsilciler Ses Kaydedebilir",
            visitorVoiceRecordEnabledDesc: "Ziyaretcilerin ses kaydetme özelliğini etkinleştirir",
            visitorVoiceRecordEnabled: "Ziyaretciler Ses Kaydedebilir",
            startVideoCall: "Görüntülü Görüşme",
            startAudioCall: "Sesli Görüşme",
            visitorGDPRDeleteEnabledDesc: "Ziyaretciler tüm bilgilerini silme özelliğini açıp kapatmanıza izin verir",
            visitorGDPRDeleteEnabled: "Ziyaretciler tüm bilgilerini silebilir",
            visitorLocationEnabled: "Ziyaretciler konum paylaşabilir",
            visitorLocationEnabledDesc: "Ziyaretçilerin konum paylaşımını açmasına veya kapatmasına izin verir",
            customerLocationEnabled: "Temsilciler konum paylaşabilir",
            customerAutoMergeEnabled: "Aynı kişileri otomatik birleştirir",
            customerAutoMergeEnabledDesc:
                "Bu özellik, otomatik birleştirme işlemini gerçekleştirerek aynı kişilere ait verileri etkili bir şekilde bir araya getirir. Bu sayede benzer profillere sahip kullanıcılar, veri setlerinde daha tutarlı ve düzenli bir şekilde temsil edilir.",
            chatAiCopilot: "Chat AI Copilot",
            chatAiCopilotDesc: "Chat AI Copilot Kullanarak Müşterilerinizin Sorularını Otomatik Olarak Cevaplayın",
            customerLocationEnabledDesc: "Temsilcilerin konum paylaşımını açmasına veya kapatmasına izin verir",
            triggerAlreadyExists: "Bu koşula ait bir tetikleyici zaten var.",
            ticketStatusForm: "Ticket Durum Formu",
            statusFormTitle: "Ticket Durum Başlığı",
            allStatus: "Tüm Durumlar",
            triggers: "Tetikleyiciler",
            trigger: "Tetikleyici",
            noTrigger: "Henüz Tetikleyici Eklemediniz",
            triggerSkipLoginForm: "Giriş Formu",
            triggerSkipLoginFormTrue: "Giriş Formunu Göster",
            triggerSkipLoginFormFalse: "Giriş Formunu Atla Mesajı Başlat",
            noContent: "içerik yok",
            toCreate: " Oluşturmak için",
            clickTheButton: "butonuna tıklayın",
            triggerContent:
                " Açılan pencerede görülmesini istediğiniz açıklamayı yazın. Yalnızca bir dilde yazmanız yeterlidir diğer dillere çeviri otomatik olarak yapılmaktadır.",
            triggerDrag: "Sürükleyerek veya çubuğa tıklayarak mesaj süresini ayarlayabilirsiniz.",
            triggerNewCondition: "Butonu ile yeni bir koşul ekleyebilirsiniz.",
            triggerNoConditionDescription1:
                "Seçenekler arasından istediğiniz koşulları oluşturabilirsiniz. Herhangi bir tetikleyici için hiçbir koşul oluşturmamanız halinde ilk sıradaki tetikleyici aktif olur.",
            triggerNoConditionDescription2:
                "Yine ziyaretçi sayfasında aynı koşullara sahip tetikleyicilerden yalnızca bir tanesi aktif olarak gözükür.",
            triggerShowAndHide: "Tetikleyicilerin göstermek istediğinizde gösterebilir veya gizleyebilirsiniz.",
            countryLanguage: "Ülke/Dil",
            addTrigger: "Tetikleyici Ekle",
            yesPlease: "Evet, lütfen!",
            noThanks: "Hayır, teşekkürler.",
            firstAnswer: "Soru Diyaloğu Olumlu Yanıt",
            secondAnswer: "Soru Diyaloğu Olumsuz Yanıt",
            noTitle: "Başlık Yok",
            sumChat_MediaFile: "Medya ve Belgeler",
            importantWarning: "ÖNEMLİ UYARI",
            images: "Resimler",
            URLS: "Linkler",
            files: "Dosyalar",
            warning: "UYARI!",
            noCondition: "Şart Yok! Artı ikonuna tıklayarak Şart ekleyebilirsiniz.",
            showTriggers: "Tetikleyicileri Göstermek için Tıklayın",
            showThisTrigger: "Bu Tetikleyiciyi Göstermek için Tıklayın",
            hideTriggers: "Tetikleyicileri Gizlemek için Tıklayın",
            hideThisTrigger: "Bu Tetikleyiciyi Gizlemek için Tıklayın",
            updateTrigger: "Tetikleyiciyi Güncelle",
            conditions: "Koşullar",

            messageDurationPerRow: "Her Bir Satır İçin Mesaj Süresi",
            dayTime: "Saat",
            weekDay: "Haftanın günü",
            spendTimePage: "Sayfada Geçirilen Zaman",
            spendTimeSite: "Sitede Geçirilen Zaman",
            pageUrl: "URL",
            pageTitle: "Sayfa Başlığı",
            equal: "Eşit",
            not_equal: "Eşit Değil",
            less_than: "Küçüktür",
            greater_than: "Büyüktür",
            less_than_or_equal: "Küçüktür veya Eşittir",
            greater_than_or_equal: "Büyüktür veya Eşittir",
            visitorName: "Ziyaretçi Adı",
            seconds10: "10 saniye",
            seconds30: "30 saniye",
            minute1: "1 dakika",
            minutes5: "5 dakika",
            minutes10: "10 dakika",
            minutes30: "30 dakika",
            hour1: "1 saat",
            hours2: "2 saat",
            hours4: "4 saat",
            hours8: "8 saat",
            hours12: "12 saat",
            hours24: "24 saat",
            maxCondition: "Maksimum Durum",
            doYouWishToDeleteTrigger: "Tetikleyiciyi Silmek İstiyor musunuz",
            contains: "İçerir",
            not_contains: "İçermez",
            chatLanguage: "Konuşma Dili",
            translating: "Çevriliyor",
            liveSupportStartingWait: "Canlı Destek Başlatılıyor , Lütfen Bekleyiniz",
            noConnection: "Bağlantı Yok!",
            buyWhatsapp: "WhatsApp satın alın",
            integrations: "Entegrasyonlar",
            refundInvoiceSure: "Faturayı iade etmek istediğinize emin misiniz?",
            invoiceMarkedAsPaidSuccess: "Fatura ödendi olarak işaretlenmiştir.",
            invoiceMarkedAsPaidError: "Hata , Fatura ödendi olarak işaretlenemedi.",
            deleteConfirm: "Bu {object} gerçekten silmek istiyor musunuz?",
            markPaidConfirm: "Bu faturayı ödendi olarak işaretlemek istediğine emin misin?",
            startChatDesc: "Konuşma Başlat",
            addLink: "Bağlantı",
            selectStep: "Bir adım seçiniz:",
            addGOTO: "Git",
            sendFastLink: "Şifresiz Giriş Linki Gönder",
            or: "Veya",
            allTags: "Tüm Etiketler",
            showDetail: "Detay Göster",
            hideDetail: "Detay Gizle",
            weLlSendPhone: "Telefonunuza Gönderelim",
            weLlSendEmail: "E-Posta Gönderelim",
            linkSentToPhone: "Link sms olarak gönderildi",
            offerlinkSendToPhone: "SMS ile size uygulamamızın indirme linkini gönderelim.",
            offerlinkSendToMail: "Mail ile size uygulamamızın indirme linkini gönderelim.",
            theEmail: "Kayıtlı E-postam",
            differentEmail: "Farklı E-posta",
            linkSentToMailBox: "Link mail adresinize gönderildi",
            errorOccurred: "Hata oluştu !",
            clickStoreIcon: "Telefonunuza uygun olan icona tıklayarak mobil uygulamaya ulaşabilirsiniz",
            meetWithSupsis: "SUPSIS mobil uygulamamız ile tanışmak ister misiniz?",
            downloadMobileApps: "Mobil Uygulamayı İndirin",
            getApps: "Uygulamaları Edinin",
            info: "Bilgi",
            conversationHistory: "Konuşma Geçmişi",
            events: "Takvim Etkinlikleri",
            reservations: "Rezervasyonlar",
            planInfoHeader: "Plan Bilgisi",
            planInformation:
                "Planınız {selectedPlan} Plan ({detailMaxAgentCount} Temsilci) ({freeAgent} Ücretsiz Temsilci)",
            creditAvailable: "Planınızda mevcut olan Temsilci krediniz: ",
            upDownGradePlan: "Planınızı yükseltmek/düşürmek istiyorsanız, lütfen",
            click: "Tıklayın",
            all: "Hepsi",
            allDepartments: "Tüm Departmanlar",
            preferredLanguage: "Tercih Edilen Dil",
            kmkAutoDepartmentBind: "KMK Otomatik Departmant Bulma",
            kmkAutoDepartmentBindDesc: "KMK Müşteri sayfalarında otomatik mağaza adını bulur ve login formuna set eder",
            visitorEmailUpdated: "Ziyaretci eposta adresi güncellendi",
            visitorEmailIsNotValid: "Girdiniz eposta adresi doğru değil",
            visitorNameUpdated: "Ziyaretci adı güncellendi",
            clickToEdit: "Düzenlemek için tıklayın",
            addEmail: "+ Email Adresi Ekle",
            addFullname: "+ Ad Ekle",
            partner: "Ref?",
            isIntegrated: "Entegrasyon?",
            agentCount: "Temsilci Sayısı",
            autoStartChat: "Otomatik Chat Başlangıcı",
            bubbleColor: "Chat Balonu Rengi",
            openFolder: "Aç",
            preDefined: "Temalar",
            customIcon: "Bilgisayarınızdan Yükleyin",
            theme: "Tema",
            themeSettings: "Tema Ayarları",
            chatThemeSettings: "Chat Tema Ayarları",
            bubbleSettings: "Chat Balonu Ayarları",
            inputHeightOfBubble: "Balon Boyutu",
            inputPixelsOfChatBubble: "Chat Balonu'nun Kenarlara Olan Uzaklıklığını Düzenlemek İçin Tıklayın",
            modalTitleIsMarginAsPixelInfo: "Chat Balonu'nun Kenarlara Olan Uzaklıklığı : ",
            inputPxOfXaxis: "Yatay Konum",
            inputPxOfYaxis: "Dikey Konum",
            inputPxOfMobileXaxis: "(Mobil) Yatay Konum",
            inputPxOfMobileYaxis: "(Mobil) Dikey Konum",
            animations: "Animasyonlar",
            preferredAnimation: "Tercih Edilen Animasyon",
            selectAnAnimation: "Bir Animasyon Seçin",
            inputOfBubbleMessage: "Genis Chat Balonlarına İçerik Ekle.\n{contentOfChatBubble}",
            showChatBubbleOnlyLoggedUserToolTip:
                "Sohbet Balonunu Oturum Açma Durumuna Bağlı Olarak Gizleme Ayarıdır.Kapalı olması durumunda tüm ziyaretçilere gösterilir.",
            showChatBubbleOnlyLoggedUser: "Balonu Yalnızca Oturum Açmış Kullanıcıya Göster. (ideasoft)",
            helloDoUNeedHelp: "Merhaba, yardımcı olabilirim!",
            bubbleIcon: "Chat Balonu Resmi",
            overrideMargins: "Kenar Boşluklarını Özelleştir",
            autoHideBubble: "Chat Balonunu Gizle",
            vtippyAutoHideBubble: "Temsilciler çevrimdışıyken chat balonunu gizler",
            hideBubble: "Chat Balonunu Devredışı Bırak",
            vtippyHideBubble: "Chat balonunu devredışı bırakır, göstermez.",
            overrideMobileMargin: "Mobil Versiyon Boşlukları Özelleştir",
            vtippyMobileMargin: "Mobil versiyon için chat balonu kenar boşluklarını özelleştir",
            vtippyHideBubbleOnMobile: "Chat Balonu mobile kullanan ziyaretçilerde gizlenir.",
            isFabsActive: "Açılır Menüleri Göster",
            bubbleOpenableMenu: "Chat Balonu Açılır Menü",
            vtippyIsFabsActive: "Açılır Menüleri Gösterme / Gizleme Ayarıdır",
            vtippyIsFabsAsIcon: "Açılır menünde ikonların görünüp görünmeyeceğinin ayarıdır.",
            vtippyTranslateButton: "Seçili Olan Dili Diğer Dillere Çevirir.",
            vtippyTranslateClearButton: "Diğer dillerdeki içerikleri temizler.",

            vtippySelectnotification: "Bildirim sesi seçebilirsiniz.",
            vtippyVoiceLevel: "Ses seviyesini ayarlayabilirsiniz.",
            vtippyStartVoice: "Dinle",
            vtippyInfiniteNotification:
                "Yeni gelen Chatler panel de aktif değilseniz çalmaya devam eder. Tıklayarak aktif-pasif düzenleyebilirsiniz.",

            vtippyNewVisitorNotification: "Web sitenize gelen ziyaretçiler için sesli bildirim ayarları.",
            vtippyNewChatNotification: "Sisteme gelen her yeni chat için sesli bildirim ayarları.",
            vtippyNewConversationNotification: "Size atanan her yeni chat için sesli bildirim ayarları.",
            vtippyNewMessageNotification: "Size atanmış chatlerden gelen mesaj bildirim ayarları.",
            vtippyPrivateMessageNotification: "Takım konuşmasından gelen mesajlar için sesli bildirim ayarları.",

            isFabsAsIcon: "Menü İkonlarını Göster.",
            setMarginAsPixel: "Piksel olarak ayarla",
            returnDefaultMargins: "Varsayılan Kenar Boşluğu Ayarları",
            closePreviewColors: "Ön İzlemeyi Kapat",
            previewColors: "Ön İzlemeyi Aç",
            videoCalls: "Görüntülü Görüşmeler",
            filterLost: "Kaçan Konuşmalar",
            vtipyCustomLogin:
                "Ziyaretçileriniz sisteme bağlanırken giriş formunda istenecek bilgileri buradan özelleştirebilirsiniz.",
            vtipyLoginlessChat:
                "Ziyaretçileriniz sisteme bağlanırken giriş formu gösterilmez. Temsilciler ziyaretçilerin kişisel bilgilerini isteyerek kullanılır",
            loginlessChat: "Ziyaretçi Giriş Formu",
            imageUrl: "Resim",
            replied: "Yanıtlandı",
            solved: "Çözüldü",
            openImage: "Resmi Aç",
            writeFeedback: "Supsis ile  ilgili geri bildirimini buraya yazabilirsin.",
            feedbackFailed: "Geri bildirim gönderimi sırasında hata oluştu.",
            feedbackSuccessful: "Geri bildirim gönderimi başarılı.",
            sendFeedback: "Geribildirim Gönder",
            errorReport: "SUPSIS ile ilgili yaşadığınız sorunlar hakkında bize geri bildirimde bulunabilirsiniz.",
            sendErrorFeedBack: "Yaşadığınız sorunla ilgili bize geri bildirimde bulunun.",
            successImgUpload: "Resminiz başarıyla yüklendi",
            successImgDelete: "Resim başarıyla silindi.",
            errorImgUpload: "Resminiz yüklenirken bir hata meydana geldi",
            errorImgDelete: "Resim silinirken bir hata meydana geldi",
            chatBotEndStatics: "Chatbot Konusma Sonuçlandırma Oranı",
            videoCallDist: "Video Görüşme Dağılımı",
            deleteSite: '" {siteName} " Sitesi Silinsin mi ?',
            deleteThisSite: "Bu siteyi sil",
            departmentInfo: "Departman Bilgisi",
            infoAboutDepartment: "Departman hakkında kısa bilgi",
            deleteDepartmentQuestion: "Bu departmanı gerçekten silmek istiyor musunuz?",
            departmentDeleted: "Departman silindi",
            departmentTitle: "Departman Başlığı",
            updateDepartmentForm: "Departman Güncelleme Formu",
            updateCompleted: "Güncelleme Tamamlandı",
            CatalogUpdatedSuccessfully: "Güncelleme Başarıyla Tamamlandı",
            integrateSupsiswithIntegratable: "Supsis ve {integratable} arasında sohbet bilgilerini kolaylıkla iletin.",
            installationOK: "Yüklü",
            newDepartmentForm: "Yeni Departman Kayıt Formu",
            newDepartment: "Yeni Departman",
            departmentSaved: "Departman Kaydedildi",
            sameDepartment: "Aynı isimde bir departman mevcut!",
            sameValue: "Aynı isimde bir değer mevcut!",
            sameTag: "Aynı isimde bir etiket mevcut!",
            departments: "Departmanlar",
            department: "Departman",
            announcements: "Duyurular",
            announcement: "Duyuru",
            newAnnouncement: "Yeni Duyuru",
            announcementInfo: "Duyuru Bilgisi",
            infoAboutAnnouncement: "Duyuru hakkında kısa bilgi",
            deleteAnnouncementQuestion: "Bu duyuruyu gerçekten silmek istiyor musunuz?",
            announcementDeleted: "Duyuru silindi",
            announcementTitle: "Duyuru Başlığı",
            updateAnnouncementForm: "Duyuru Güncelleme Formu",
            newAnnouncementForm: "Yeni Duyuru Kayıt Formu",
            announcementSaved: "Duyuru kaydedildi.",
            chatTimingSettings: "Chat Süre Ayarları",
            assetOversize: "Göndermek istediğiniz dosyanın boyutu 10mb'den büyük olmamalıdır.",
            assetOversizeMB: `Göndermek istediğiniz dosyanın boyutu {mb} mb'den büyük olmamalıdır.`,
            assetOversizeWithExt: "Dosya boyutu 10mb'tan küçük ve png,jpg formatında olmalıdır.",
            messageDeleted: "Bu mesaj silindi",
            filterVideoCall: "Görüntülü Görüşmeleri Gösterir",
            filterLostChat: "Kayıp Sohbetleri Filtreler",
            filterClosedByAgent: "Temsilci Tarafından Kapatılan Sohbetleri Filtreler",
            notificationText: "Supsis bildirimlerinin doğru şekilde çalışması için ",
            notificationTitle: "Bildirimler Kapalı",
            deniedText:
                "Bildirimleriniz kapalıdır, Müşterilerinizi kaçırmamanız için bildirimlerinizi açmanız gerekmektedir.",
            deniedTitle: "Bildirimlerinizi Açmak İçin Tıklayınız !",
            deniedHeader: "Müşterilerinizi kaçırmamak için bildirimlerinizi açmanız gerekmektedir!",
            showNotificationGuide: "Detaylar için tıklayın",
            howToEnableNotification: "Bildirimleri Nasıl Etkinleştirebilirim",
            notificationOK: "Tamam",
            notificationUnderstood: "Anladım",
            notificationCancel: "İptal",
            howToEnableNotificationInstruction1: "Tarayıcının adres çubuğundaki kilit ikonuna tıklayınız",
            howToEnableNotificationInstruction2: "İzinler kısmında 'Bildirimler' pasif gözüküyorsa aktifleştirin",
            howToEnableNotificationInstruction3:
                'İzinler kısmında "Bildirimler" gözükmüyorsa "Site Ayarlarına" tıklayınız',
            howToEnableNotificationInstruction4:
                'Site ayarları sayfasından "İzinler" bölümden "Bildirimler" iznini açınız',
            checkPaymentMethod: "Lütfen ödeme yönteminizi kontrol edin",
            pushNotificationEnabled: "Harika, Bildirim gönderimi etkin.",
            pushNotificationDenied: "Bildirim izinlerini reddettiniz",
            suspendedMessage: "Hesabınız askıya alındı",
            suspendedDescription: "Hesabınız ödenmemiş faturalarınız yüzünden askıya alındı.",
            enableNotification: "Bildirimlerinizi açınız.",
            languageSettings: "Konuşma Dili",
            problemsSound:
                'Eğer bildirimler ile ilgili sorun yaşıyorsanız, tarayıcınızın adres çubuğundan (Resimde Gösterilen) kilit iconuna tıklayıp "Site Ayarları" alanından tıklayarak, açılan  bölümden "Ses" izin ver olarak değiştirebilirsiniz.',
            betweenRepresentative: "Bir temsilci yeni mesajı.",
            desktopNotifications: "Bildirimler",
            notificationDisable: "Temsilci ayarlarından masaüstü bildirimlerini kapatabilirsiniz.",
            notificationEnabled: "Supsis bildirimleri aktif.",
            newMessageAlert: "Yeni bir mesajınız var.",
            newConversationAlert: "Yeni bir konuşmanız var.",
            chatBot: "ChatBot",
            ticketResponse: "Representative Response:",
            archived: "Arşivle",
            chatbotChatCount: "CHATBOT",
            closeChat: "Mesajlaşmayı Bitir",
            ticket: "Ticket",
            formStep: "Form Adımı",
            menuStep: "Menü Adımı",
            contentStep: "İçerik Adımı",
            menuTitle: "Menü Başlığı",
            messageContent: "Mesaj İçeriği",
            goToLive: "Temsilciye Aktar",
            prevStep: "Önceki Adıma Dön",
            button: "Buton",
            addImage: "Görüntü",
            addText: "Metin",
            stepTitle: "Adım Başlığı",
            addTicket: "Ticket",
            formDescription: "Soru",
            addInput: "Soru",
            addRandomText: "Rastgele Metin",
            changeTitle: "Başlığı Değiştir",
            changeVisitorTitle: "Visitor Başlığını Değiştir",
            catalog: "Katalog Başlığı",
            openTheCatalog: "Kataloğu Aç",
            catalogNotOpen:
                "Katalog özelliği devre dışı. Müşterilerinize önceden hazırlanmış içeriklerle destek sağlamak için katalok özelliğini açabilirsiniz.",
            showCatalogCategories: "Katalog menünüsün chat balonunda gözükme durumunu değiştir.",
            showChatBot: "ChatBot menünüsün chat balonunda gözükme durumunu değiştir.",
            openCatalog: "Katalog",
            unreadMessages: "Okunmamış Mesajlar",
            personalFirstMsg: "Temsilci İlk Cevaplama Süresi Ortalaması(sn)",
            personalRating: "Personel Puan Ort.",
            soundSettings: "Bildirim Ayarları",
            newPrivateMessage: "Özel Mesaj",
            addNewGroup: "Yeni Grup Oluştur",
            teamChatTeam: "Takım Mesajları",
            teamChatDm: "Dm Mesajları",
            teamChatDepartment: "Departman Mesajları",
            teamChatGroup: "Grup Mesajları",
            newMessage: "Yeni Mesaj",
            newConversation: "Yeni Chat",
            newVisitor: "Yeni Ziyaretçi",
            chatPosition: "Chat Konumu",
            bottomLeftCorner: "Sol alt köşe",
            leftDocked: "sola Yerleştir",
            bottomRightCorner: "Sağ alt köşe",
            rightDocked: "sağa Yerleştir",
            chatPositionSelect: "Konum Seçiniz",
            bottomLeft: "Sol Alt",
            left: "Sola yaslı",
            bottomRight: "Sağ Alt",
            right: "Sağa yaslı",
            mailorname: "E-Posta ya da İsim",
            breaksByTime: "Zamana göre mola sayıları",
            clPlaceholder: "Müşteri formunda gözükücek isim",
            fieldName: "Anahtar İsim",
            value: "Değer",
            addSetting: "Yeni Bir Ayar Ekle",
            globalSettings: "Genel Ayarlar",
            target: "Yük testi adresi",
            duration: "Yük testi süresi(sn)",
            arrivalCount: "Bot Sayısı(adet)",
            bootMaxLife: "Bir botun ayakta kalma süresi(sn)",
            startLoadTest: "Yük Testini Başlat",
            noClusterInstanceFound: "Sunucu bulunamadı",
            stopLoadTest: "Yük Testini Bitir",
            integrationDesc: "Aşağıdaki  tek satırlık kodu sitenize  eklemeniz yeterlidir.",
            integrationDemoCode: "Örnek entegrasyon demo kodu",
            integrationWindow: "Siteme Nasıl Entegre Yaparım ?",
            notIntegrated: "Entegrasyon",
            help: "Yardım",
            notIntegratedDesc:
                "Chat sistemini sitenize eklemediğinizi farkettik. Sitenize entegre edip ilk görüşmeyi başlattığınızda entegrasyonu tamamlamış olacaksınız. ENTEGRASYON KODU için tıklayınız",
            backToLogin: "Tekrar Giriş Yap",
            passwordlessLoginUnsuccessful:
                "Giriş başarısız.Giriş linkinin süresi dolmuş veya daha önce kullanılmış olabilir.",
            passwordlessLogin: "Şifresiz Giriş",
            loginWithEmail: "Eposta ile Giriş Yap",
            loginWithPassword: "Şifre ile Giriş Yap",
            enteringPasswordless: "Şifresiz Giriş Yapılıyor...",
            toMainPath: "Anasayfaya yönlendir",
            userRoleChanged: "Kullanıcı izinleriniz değişti. Devam etmek için ana sayfaya yönlendirileceksiniz.",
            passwordChangeSuccess: "Şifre Değiştirme İşleminiz Başarılı...",
            feedback: "Geri bildirim",
            showFeedbackHistory: "Geri bildirim gönderilmiş mesajları göster.",
            newSelfServiceSite: "Yeni Self Servis Site",
            subdomain: "Alt alan adı",
            rootUserEmail: "Kullanıcı Eposta",
            rootUserName: "Adınız",
            newVersion: "Yeni Sürüm Mevcut",
            closeLiveSupport: "Canlı Desteği Kapat",
            newVersionShort: "Yeni Sürüm",
            bannedWordRestrict: "Yasaklı Kelime Engelleme",
            ticketShow: "Müşterilerin Ticket Oluşturmasına izin ver",
            ticketShowDesc: "Chat Menüsünden Ticket Oluşturma Seçeneğini aktif et",

            autoLoadIframe: "Canlı Trafik",
            autoLoadIframeDesc: "Iframe otomatik yükler ve tüm ziyaretci trafiği alır",
            bannedWordRestrictDesc:
                "Yasaklı Kelime Engelleme açık olduğunda temsilciler sisteme tanımlanana yasaklı kelimeleri ziyaretcilere yazması engellenir",
            agentDown: "Temsilci Düştü",
            delayChat: "Geciken Konuşma",
            tableSettingTippy: "Tabloda görünecek bilgileri burdan değiştirebilirsiniz.",
            tableSettings: "Tablo Ayarları",
            tableSettingsInfo:
                "Tabloda görünecek bilgileri burdan değiştirebilirsiniz. En fazla 7 tane sütun seçebilirsiniz",
            privateParametry: "Özelliştirilmiş Kullanıcı Parametreleri",
            systemOperetor: "Sistem Bilgileri",
            cityAndDistrict: "Şehir/İlçe",
            general: "Genel",
            availability: "Temsilci Çalışma Saatleri",
            home: "Anasayfa",
            successful: "Başarılı",
            forgetPasswordSent: "Parola sıfırlama maili gönderildi, e-mailinizi kontrol ediniz.",
            saturday: "Cumartesi",
            friday: "Cuma",
            thursday: "Perşembe",
            wednesday: "Çarşamba",
            tuesday: "Salı",
            monday: "Pazartesi",
            sunday: "Pazar",
            download: "Dosyayı İndir",
            calendarPassedTimeHour: "{hour} saat {name}",
            calendarPassedTime: "{hour} saat {min} dk {name}",
            calendarPassedTimeMinSec: "{min} dk {sec} sn {name}",
            calendarPassedTimeMin: "{value} dk {name}",
            calendarPassedTimeSec: "{hour} saat {min} dk {sec} sn {name}",
            workScheduleOneDay: "{name} Adlı Kullanıcının {sDate} Günü çalışma Takvimi",
            workSchedule: "{name} Adlı kullanıcın {sDate} - {eDate} Arası Çalışma Takvimi",
            calendar: "Takvim",
            noRating: "Hiç Puanlama Yapılmamış",
            rateDist: "Puan Dağılımı",
            distConversation: "Temsilcilerin Konuşma Dağılımı",
            distributionConversa: "Puanlama Dağılımı",
            distChatbotAgent: "İletişim Kanalları",
            distAgent: "Chatbot & Agent",
            distFugitive: "Kaçan Konuşma & Karşılanan Konuşma",
            distLive: "Canlı Sohbet",
            distChatbot: "Chatbot",
            distComplex: "Chatbot + Canlı Sohbet",
            distHandled: "Karşılanan Konuşma",
            distMissed: "Kaçan Konuşma",
            distWeb: "Web Site",
            distWhatsapp: "Whatsapp",
            distTelegram: "Telegram",
            distInstagram: "Instagram",
            totalWhatsappChatCount: "Whatsapp Chat Sayısı",
            statsByTime: "Zamana Göre Konuşma Sayıları",
            selectRep: "Bir temsilci seçin",
            allRepresentatives: "Bütün Temsilciler",
            avgRating: "Puan Dağılım ({point}) ({count} değerlendirme)",
            avgFirstMessageTime: "Ortalama ilk müdehale süresi ",
            totalBreakTime: "Sistem Mola Süresi",
            totalBreakNum: "Mola Sayısı",
            averageConTime: "Ortalama Konuşma Süresi",
            multiWpReportTitle: " Whatsapp Konuşma Sayısı",
            multiWpReport: " Whatsapp Chat Dağılımı",
            multiWpReportExplanation: " Whatsapp Kanallarınızın Chat Miktarını Görebilirsiniz.",
            longestConTime: "En uzun Konuşma Süresi",
            shortestConTime: "En Kısa Konuşma Süresi",
            refresh: "Yenile",
            waitingReply: "Cevap Bekleyenler",
            organizationName: "Organizasyon Adı",
            companySlogan: "Şirket Sloganı",
            messageSentErr: "Mesaj gönderilemedi, tekrar deneyiniz.",
            messageSent: "Mesaj gönderildi.",
            openPrivateChat: "Temsilciler arası konuşmayı aç",
            escKey: "Aktif konuşmayı gizle",
            archiveChatKey: "Arşiv Sayfası alttaki sohbete inmeyi sağlar.",
            chatCopilot: "Chat CoPilot özelliğini açar",
            privateChat: "Temsilciler Arası Konuşma Paneli",
            multiModeAlertDesc:
                'SUPSIS başka bir pencerede açık. SUPSIS\'ı bu pencerede kullanmak için "Burada Kullan"a tıklayın.',
            useHereText: "Burada Kullan",
            brandVisibility: "SUPSIS marka etiketi chat balonunda gözükür",
            focusInput: " İmleci aktif olan konuşmanın yazma alanına odaklar",
            send: "Gönder",
            notYet: "Henüz değil",
            sending: "Gönderiliyor",
            onlyRepresentative: "Mesajınız sadece temsilciler tarafından görülecektir.",
            yourMessage: "Mesajınız",
            liveFabListDescription: "Canlı Destek",
            messengerIntegrationDesc:
                " Facebook sayfası üzerinden müşterilerinizle sohbet edin , chatbot ile otomatik mesajlar gönderin.",
            checkDepartmentToAgent: "Çevrimiçi temsilcinin kontrol edileceği departman",
            ifAllOfflineStory: "Çevrimiçi temsilci yoksa yönlendirmek için hikaye",
            AssignMessagesToAgents: "Tüm mesajları Temsilcilere Yönlendir",
            firstChatbotAndAssign: "Önce Chatbot Cevap Verir ve Sonra Temsilciye Yönlendirir",
            hybridAssign:
                "Sistem, çevrimiçi bir temsilci olup olmadığını görmek için departmanı kontrol eder ve çevrimiçi bir temsilci yoksa, bunu chatbot'a atar.",
            ticketFabListDescription: "Ticket",
            whatsappFabListDescription: "Whatsapp",
            phoneFabListDescription: "Telefon",
            emailFabListDescription: "E-posta",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Twitter",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "YouTube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "Bu alana {channelLink} kanalınızın linkini koyabilirsiniz.",
            typeYourAccountLink: "Bu alana {accountLink} hesabınızın linkini koyabilirsiniz.",
            typeYourMessage: "Mesajınızı buraya yazın",
            typeYourMessageMail:
                "Bu alana girilen mesaj Müşteri tarafından yukarıdaki mail adresine ilk mesaj olarak gönderilecektir.",
            typeYourMessageDesc:
                "Bu alana girilen mesaj, Müşteri tarafından yukarıdaki telefon numarasına ilk mesaj olarak gönderilecektir.",
            sendNumber: "Mesajın gönderileceği telefon numarası: {path}",
            callNumber: "Müşterinizin arayacağı telefon numarası: {phoneNumber}",
            numberIsNotCorrect: "Eksik numara girildi !!",
            emailIsNotCorrect: "E-posta Hatalı !",
            selectFab: "Bir Fab Seçin",
            notValid: "Sadece harf girebilirsiniz.(Tek karakter). e,d,f,z,a,x,c,v,w,t,n harfleri geçersizdir",
            forMacUsers: " Mac kullanıcıları Control(⌃) tuşunu kullanabilir",
            basePriceValue: "Taban Fiyat",
            basePriceDiscount: "İndirim",
            basePriceCurrency: "Para Birimi",
            customerDBEnabled: "Veritabanı Seçimi: Müşterinin Kendi Veritabanı Sunucusu Kullan",
            customerDBDisabled: "Veritabanı Seçimi: Supsis Veritabanı Sucunusu Kullan",
            mongoConnectionString: "Mongo Bağlantısı",
            whatsappBasePriceValue: "Whatsapp Taban Fiyatı",
            whatsappPlusBasePriceValue: "Whatsapp Plus Taban Fiyatı",
            instagramBasePriceValue: "Instagram Taban Fiyatı",
            instagramPlusBasePriceValue: "Instagram Plus Taban Fiyatı",
            clientAddress: "İstemci Adresi",
            customerClientAddress: "Müşteri İstemci Adresi",
            apiAddress: "Api Adresi",
            socketAddress: "Soket Adresi",
            backendAddress: "BackEnd Adresi",
            panelLogoUrl: "Panel Logo Adresi",
            panelCustomCssUrl: "Özel Panel Css Adresi",
            customerLogoUrl: "Müşteri Logo Adresi",
            customerCssUrl: "Müşteri css Adresi",
            siteAlias: "Site Adı",
            language: "Dil",
            features: "Özellikler",
            interactionPopularity: "Etkileşimlerin popülerliği",
            interactionCount: "Etkileşim Sayısı",
            uniqueUserCount: "Benzersiz Kullanıcı Sayısı",
            allUserPercentage: "(%) Tüm Kullanıcıların Yüzdesi",
            represantativeSettings: "Temsilci Ayarları",
            documentTitle: "Supsis Doküman Formu",
            supsisDocument: "Supsis Döküman",
            ApiDoc: "Api Dönümanı",
            chatBalloonTehemeSettings: "Sohbet Balonu ve Tema Ayarları",
            customLoginFormSettingsTitle: "Ziyaretçi Giriş Formunu Özelleştir",
            addNewField: "Yeni Alan Ekle",
            editField: "Alanı Düzenle",
            typeHere: "Buraya yaz",
            pco: "PÇO",
            perPage: "/sayfa",
            perPageInFilter: "Adet",
            noUserInfoFound: "Kullanıcı Bilgisi Bulunamadı",
            startFilter: "Aramaya başla",
            CHAT: "Sohbet",
            showMyChats: "Bana Atananları Göster",
            showOnlineAgents: "Sadece Çevrimiçi Olanları Göster",
            showWaitingChats: "Temsilci Bekleyenleri Göster",
            addNewStatus: "Durum Ekle",
            newTitleContent: "Başlık Ekle",
            roleName: "Rol Adı",
            error: "Hata",
            contentType: "İçerik Tipi",
            contentTitle: "İçerik Başlığı",
            newSiteForm: "Yeni Site Kayıt Formu",
            updateSiteForm: "Site Güncelleme Formu",
            newBannedWordForm: "Yeni Yasaklı Kelime Kayıt Formu",
            updateBannedWordForm: "Yasaklı Kelime Güncelleme Formu",
            newWelcomeMessageForm: "Yeni Karşılama Mesajı Kayıt Formu",
            updateWelcomeMessageForm: "Sistem Mesajı Güncelleme Formu",
            newDefaultContentForm: "Yeni Hazır İçerik Kayıt Formu",
            updateDefaultContentForm: "Hazır İçerik Güncelleme Formu",
            newSubjectForm: "Yeni Konu Kayıt Formu",
            updateSubjectForm: "Konu Güncelleme Formu",
            showIntro: "Tanıtımı Göster",
            showChatColorMeaning: "Sohbet Renkleri",
            options: "Seçenekler",
            resetPassword: "Şifreyi yenile",
            audioLevel: "Sesli uyarı ses seviyesi",
            privateChatNotificationSound: "Bildirim sesi",
            continue: "Devam et",
            newRoleForm: "Yeni Rol Kayıt Formu",
            updateRoleForm: "Rol Güncelleme Formu",
            newUserForm: "Yeni Kullanıcı Kayıt Formu",
            updateUserForm: "Kullanıcı Güncelle Formu",
            changeOSRForm: "Çevrimdışı Mesaj Değiştir",
            tooltipOSRForm: "Çevrimdışı mesajı değiştireblirsiniz.",
            newOSRForm: "Çevrimdışı Destek Formu",
            newOSRMessages: "Çevrimdışı Mesaj Ekle",
            newOsrMessageTitle: "Çevrim Dışı Mesaj Başlığı",
            updateOSRForm: "Çevrimdışı Güncelleme Formu",
            osrTitle: "Başlık",
            osrTitleDescription: "Çevrimdışı destek formu başlığı ekleyebilirsiniz",
            osrContent: "İçerik",
            osrContentDescription: "Çevrimdışı destek formu içeriği ekleyebilirsiniz",
            hello: "merhaba dünya",
            date: "Tarih",
            startDate: "Başlangıç Tarihi",
            finish: "Bitiş",
            start: "Başlangıç",
            search: "Ara",
            endDate: "Bitiş Tarihi",
            representative: "Temsilciler",
            representative_: "Temsilci",
            star: "Yıldız",
            filter: "FİLTRELE",
            reset: "SIFIRLA",
            dailyChatList: "Günlük Konuşma Listesi",
            dailyChatDuration: "Günlük Konuşma Süreleri",
            chatDuration: "Konuşma Süresi",
            dailyChatGraph: "Günlük Konuşma Grafiği",
            ok: "Tamam",
            cancel: "Vazgeç",
            chatCount: "Chat Sayısı",
            shortest: "En Kısa",
            longest: "En Uzun",
            average: "Ortalama",
            count: "Adet",
            averagePoint: "Ortalama Puan",
            pointDist: "Puan Dağılımı",
            point: "Puan",
            filters: "Filtreler",
            totalCustomer: "Toplam Müşteri",
            avResponseTime: "Ort. İlk Müdahale Zamanı",
            breakDuration: "Mola Süresi",
            breakCount: "Mola Adeti",
            active: "Aktif",
            passive: "Pasif",
            userForm: "Kullanıcı Formu",
            startChat: "Chat Başlat",
            sender: "Gönderen",
            profile: "Profil",
            name: "Ad",
            number: "Numara",
            username: "Kullanıcı Adı",
            updateUserName: "Kullanıcı Adı Güncelle",
            email: "E-Posta",
            password: "Şifre",
            oldPassword: "Eski Şifre",
            newPassword: "Yeni Şifre",
            passwordAtLeast: "Şifre (en az {num} karakter)",
            passwordRepeat: "Şifre Tekrar",
            changePassword: "Şifre Değiştir",
            status: "Durum",
            enableState: "Aktif?",
            douYouWishToDeleteUser: "Bu kullanıcıyı gerçekten silmek istiyor musunuz?",
            douYouWishToDeleteAnnouncement: "Bu duyuruyu gerçekten silmek istiyor musunuz?",
            userDeleted: "Kullanıcı silindi",
            userSaved: "Kullanıcı kaydedildi.",
            oldPasswordError: "Eski şifre hatalı, lütfen kontrol edin.",
            chooseAnOption: "Lütfen tercih ettiğiniz bildirim sesini seçin.",
            userVolumeUpdated: "Ses ayarı güncellendi.",
            save: "Kaydet",
            update: "Güncelle",
            addNewMenu: "Yeni Menü Ekle",
            addNewContent: "Yeni İçerik Ekle",
            pleaseTitleEnter: "Lütfen başlık girin",
            like: "Beğenilme",
            disLike: "Beğenilmeme",
            users: "Kullanıcılar",
            visitor: "Ziyaretçiler",
            allContacts: "Tüm Bağlantılar",
            allUsers: "Tüm Temsilciler",
            allSites: "Tüm Siteler",
            newUser: "Yeni Kullanıcı",
            noNewUser: "Henüz bir kullanıcı yok.",
            noNewAdminUser: "Henüz bir admin kullanıcı yok.",
            noNewAnnouncement: "Henüz bir duyuru yok.",
            noRoleFound: "Henüz bir rol yok.",
            noBannedWordFound: "Henüz yasaklı kelime yok.",
            noWelcomeMessageFound: "Henüz sistem mesajı yok.",
            noSubjectFound: "Henüz konu yok.",
            noVisitorFound: "Ziyaretci bulunamadı.",
            noContactFound: "Rehber bulunamadı.",
            sendResponse: "Cevap Yaz",
            delete: "Sil",
            duplicate: "Kopyala",
            makeDefault: "Varsayılan Yap",
            checkMore: "Daha Fazlası",
            useReadyTemplates: "Hazır Şablonlar Kullanın",
            useAITemplates: "Hazır Yapay Zeka Şablonları Kullanın",
            noRePresentativeFound: "Temsilci bulunamadı.",
            noLiveSupportFound: "Henüz canlı destek kaydı yok.",
            noLiveSupportFoundWithDepartment: " Departmanına Ait Chat Kaydı Yoktur",
            noBannedVisitorFound: "Henüz bir yasaklı ziyaretçi yok.",
            removeBanDescription: "Yasağı kaldır",
            editThisItem: "Bu kaydı güncelle",
            removeThisItem: "Bu kaydı sil",
            role: "Rol",
            newRolePlaceHolder: "Yeni rol eklemek için tıklayınız...",
            autoChatAssignLimit: "Otomatik Konuşma Atama Limiti",
            chatAssignInfo: "-1 = Sistem varsayılanı, 0 = Hiç atama yapılmaz, >0 = Verilen değer kadar atama yapılır.",
            relatedDepartments: "İlgili Departmanlar",
            subjectInfo: "Konu seçilmemesi halinde tüm konulara izin verilecektir..",
            archive: "Arşiv",
            offlineSupportRequests: "Çevrimdışı Destek",
            offlineModeMessage: "Çevrimdışı Mesaj",
            offlineMode: "Çevrimdışı Mod",
            first: "İlk",
            last: "Son",
            query: "Aramaya Başla",
            clean: "Temizle",
            loading: "Yükleniyor",
            loadMore: "Daha fazla yükle",
            noMessage: "Hiç mesaj yok...",
            selectChat: "Konuşma Seçiniz",
            noMessageInChat: "Bu konuşmada herhangi bir mesaj bulunamadı",
            noMediaToShow: "Gösterilecek Medya Yok",
            userInfo: "Kullanıcı Bilgileri",
            firstSeen: "İlk Görülme",
            userProfile: "Profil",
            addCalendarEvent: "Etkinlik +",
            chatId: "Konuşma ID",
            visitorId: "Ziyaretçi ID",
            visitingPage: "Ziyaret Edilen Sayfa",
            osAndBrowser: "İşletim Sistemi & Tarayıcı",
            customerClientVersion: "Müşteri Versiyonu",
            visitorFeedback: "Müşteri Geri Bildirimi",
            notes: "Notlar",
            nameSurname: "Adı Soyad",
            chats: "Konuşmalar",
            bannedVisitors: "Yasaklı Ziyaretçiler",
            country: "Ülke",
            city: "Şehir",
            cityDistrict: "İl İlçe",
            browser: "Tarayıcı",
            os: "İşletim Sistemi",
            ipAddress: "IP Adresi",
            connectionDate: "Bağlantı Zamanı",
            transaction: "İşlem",
            banRemoved: "Engelleme kaldırıldı.",
            bannedWords: "Yasaklı Kelimeler",
            newBannedWord: "Yeni Yasaklı Kelime",
            noBannedWord: "Henüz bir engelli kelime yok.",
            bannedWordForm: "Yasaklı Kelime Formu",
            word: "Kelime",
            bannedWordAndWordGroup: "Yasaklı kelime / kelime grubu",
            doYouWishToDeleteBannedWord: "Bu yasaklı kelimeyi gerçekten silmek istiyor musunuz?",
            doYouWishToOfflineSupportRequest: "Bu mesajı silmek istiyor musunuz?",
            bannedWordSaved: "Yasaklı kelime kaydedildi",
            deletedSuccessfully: "Başarıyla silindi",
            deleteErrorMsg: "Silme işlemi gerçekletirilemedi, tekrar deneyiniz",
            socketError: "Sockete Bağlantı sorunu. Lütfen sayfayı yenileyip tekrar deneyiniz",
            socketConnecting: "Sunucu ile bağlantı kuruluyor",
            offlineModeDescription: "Sistem kapalı, müşteriler canlı desteğe erişemeyecek.",
            offlineModeSettingsDescription: "Ayarlar menüsünde 'Çevrimdışı Mod' özelliğini kontrol edin.",
            offlineModeUser: "Sistemde en az bir online temsilci olması gerekir.",
            adminCannotConnectSocket: "Adminler sokete bağlanamaz.",
            liveSupport: "Canlı Destek",
            siteVisitors: "Site Ziyaretçileri",
            visitors: "Ziyaretçiler",
            mail: "Mailler",
            thoseConnectedToLiveSupport: "Canlı Desteğe Bağlananlar",
            visitorHistory: "Ziyaretçi Geçmişi",
            visitorHistoryDescription: "Ziyaretçi sohbet geçmişini görüntüleyebilir ve indirebilirsiniz.",
            privateMessage: "Özel Mesaj",
            addRepresentative: "Temsilci Ekle",
            forwardRepresentative: "Temsilciye Yönlendir",
            keyboardShortcuts: "Klavye Kısayolları",
            chatColorMeanings: "Konuşma Renk Anlamları",
            connLostCheckInternet: "Bağlantınız koptu. Lütfen internet bağlantınızın olduğundan emin olunuz.",
            wishToEndThisChat: "Bu görüşmeyi sonlandırmak istiyor musunuz?",
            defaultContents: "Şablonlar",
            contents: "İçerikler",
            newDefaultContent: "Yeni Hazır İçerik",
            newCTRLContent: "CTRL İçeriği Ekle",
            newALTContent: "ALT İçeriği Ekle",
            newTABContent: "TAB İçeriği Ekle",
            title: "Başlık",
            shortcutChar: "Kısayol Karakteri",
            pickOne: "Birini seçin",
            writeSomething: "Bir karakter yazın (a-z|0-9)",
            letterSequence: "Harf Serisi",
            exampleText: "Örnek: fut -> futbol",
            anyChar: "Herhangi bir karakter",
            shorcutKey: "Kısayol tuşu",
            content: "İçerik",
            shortcutName: "Kısayol Adı",
            type: "Tip",
            shortcut: "Kısayol",
            deleteContentQuestion: "Bu Hazır İçeriği gerçekten silmek istiyor musunuz?",
            defaultContentDeleted: "Hazır İçerik silindi.",
            defaultContentSaved: "Hazır İçerik kaydedildi.",
            defaultContentForm: "Hazır İçerik Formu",
            titleContentForm: "Hazır İçerik Başlığı",
            contentMoved: "İçerik taşındı.",
            cannotMoveFullParent: "Bu elemanı taşıyamazsınız",
            yourEmail: "E-Posta Adresiniz",
            yourName: "Adınız ve Soyadınız",
            lostPassword: "Şifremi Unuttum",
            login: "Giriş",
            forgotPassword: "Parolamı Unuttum",
            multipleSession: "Başka bir yerde oturum açtınız.",
            notAuthorizedToDisplayPage: "Bu sayfayı görüntülemek için izniniz bulunmuyor!",
            permissions: "İzinler",
            newPermission: "Yeni İzin",
            permissionForm: "İzin Formu",
            displayTitle: "Görüntüleme başlığı",
            key: "Anahtar",
            keyToUseInSystem: "Sistemde kullanılacak anahtar değer",
            deletePermissionQuestion: "Bu izni gerçekten silmek istiyor musunuz?",
            permissionDeleted: "İzin silindi.",
            permissionSaved: "İzin kaydedildi.",
            newRole: "Yeni Rol",
            selectARole: "Bir Rol Seç",
            yes: "Evet",
            no: "Hayır",
            fullAuth: "Tam Yetki",
            roleDeleted: "Rol silindi.",
            sameRole: "Aynı isimde bir rol mevcut",
            roleSaved: "Rol kaydedildi.",
            roleForm: "Rol Formu",
            roles: "Roller",
            settings: "Ayarlar",
            selectTopic: "Departman Seçimi",
            autoCallTransfer: "Otomatik Görüşme Aktarımı",
            customerTyping: "Kullanıcı Yazıyor",
            typing: "Yazıyor",
            agentTyping: "Temsilci  Yazıyor",
            disconnectTime: "Konuşmayı Sonlandırma Süresi (sn)",
            tippyDissconnectTime: "Hareketsiz durumdaki konuşmayı kaç saniye sonra kapatılacağını ayarlar",
            queueNumberVisibleFeature: "Ziyaretciye Sırada Bekleyen Kişi Sayısını Göster",
            privateChatEnabled: "Temsilciler Arası Sohbeti Göster",
            delayedTalkTime: "Gecikme Süresi(sn)",
            employeeAverageChatCount: "Personel chat oranı için ortalama konuşma sayısı",
            customerDownTimeWhenRepExit: "Temsilci çıkış yaptığında müşteri boşa düşme süresi(sn.)",
            autoAssignLimit: "Otomatik Atama Limiti",
            wasted: "Boşa Düşme Süresi (sn)",
            settingsSaved: "Ayarlar kaydedildi.",
            settingsCannotSaved: "Ayarlar Kaydedilemedi",
            noAuthorization: "Yetkiniz Yok!",
            warningBadInput: "0 ile 70 arasında bir sayı girmeniz önerilir.",
            warningBadInputMarginY: "Dikey Kenar Boşluğu Girişi Hakkında Uyarı ⚠️",
            warningBadInputMarginX: "Yatay Kenar Boşluğu Girişi Hakkında Uyarı ⚠️",
            warningBadInputBubbleSize: "Balon Boyutu Girişi Hakkında Uyarı ⚠️",
            settingFormWrong: "Girdiğiniz veriler hatalıdır, kontrol edip tekrar deneyiniz",
            delayTime: "Gecikme Zamanı (sn.)",
            sites: "Siteler",
            newSite: "Yeni Site",
            noSiteYet: "Henüz bir site yok.",
            siteAddress: "Site Adresi",
            turnBack: "Geri Dön",
            customerRepLimit: "Müşeri Temsilcisi Limiti",
            siteSaved: "Site kaydedildi.",
            siteSaveError: "Site oluştururken hata oluştu.",
            subjects: "Konular",
            newSubject: "Yeni Konu",
            noSubject: "Henüz bir konu yok.",
            subject: "Konu",
            subjectTitle: "Konu Başlığı",
            description: "Açıklama",
            infoAboutSubject: "Konu hakkında kısa bilgi",
            deleteSubjectQuestion: "Bu konuyu gerçekten silmek istiyor musunuz?",
            subjectDeleted: "Konu silindi",
            subjectSaved: "Konu kaydedildi.",
            osrFromMessageSaved: "Çevrimdışı mesaj kaydedildi.",
            welcomeMessages: "Sistem Mesajları",
            newWelcomeMessages: "Yeni Karşılama Mesajı",
            noWelcomeMessage: "Henüz bir sistem mesajı yok.",
            welcomeMessageContent: "Sistem mesaj içeriği",
            makeChoice: "Bir seçim yapın...",
            welcomeMessage: "Karşılama Mesajı",
            repLoggedIn: "Temsilci oturum açtı",
            loginMessage: "Oturum kapatma mesajı",
            message: "Mesaj",
            messageTitle: "Başlık",
            deleteWelcomeMessageQuestion: "Bu sistem mesajını gerçekten silmek istiyor musunuz?",
            welcomeMessageDeleted: "Sistem mesajı silindi",
            welcomeMessageSaved: "Sistem mesajı kaydedildi.",
            welcomeMessageForm: "Sistem Mesajı Formu",
            noRep: "Henüz bir temsilci yok.",
            addChat: "Görüşmeye Ekle",
            forwardChat: "Görüşmeyi Yönlendir",
            ago: "önce",
            repName: "Temsilci Adı",
            lastOnline: "Son Bağlantı/Online zamanı",
            lastStatusChange: "Son Durum Değişikliği",
            activeChat: "Aktif konuşma",
            userMaxCapacity: "Max Chat Kapasitesi",
            noActiveChat: "Aktif konuşma yok.",
            watch: "İZLE",
            join: "KATIL",
            open: "KONUŞMAYI AÇ",
            directMessage: "ÖZEL MESAJ",
            block: "ENGELLE",
            transactions: "İşlemler",
            informations: "Bilgiler",
            visitStart: "Ziyaret Başlangıcı",
            fullName: "Adı Soyadı",
            waitChatTime: "Bekleme Süresi/Chat Süresi",
            blockUserConfirm: "Bu kişiyi gerçekten engellemek istiyor musunuz?",
            messaging: "Mesajlaşma",
            hideChat: "Konuşmayı Gizle",
            block_: "Engelle",
            privateMessage_: "Gizli Mesaj",
            assignRep: "Temsilci Ata",
            joinChat: "Konuşmaya Katıl",
            forwardRep: "Yönlendir",
            leaveChat: "Görüşmeden Ayrıl",
            endChat: "Görüşmeyi Sonlandır",
            translatedTextDescription: "Amazon  bu mesajın {from} -> {to} çevirisini yapmıştır.",
            autoTranslate: "Otomatik Tercüme",
            translateThisMessage: "Bu mesajı çevir",
            autoTranslateDetectedDesc:
                "Ziyaretçi {visitorLanguage} dilinde konuşuyor. Otomatik Tercümeyi Etkinleştirmek İçin Buraya Tıklayın",
            on: "Açık",
            off: "Kapalı",
            copy: "Kopyala",
            prevChats: "Önceki Konuşmalar",
            noShortCut: "Kısayol yok",
            leaveChartConfirm: "Konuşmadan ayrılmak istediğinize emin misiniz?",
            endChatConfirm: "Bu görüşmeyi sonlandırmak istiyor musunuz?",
            chatBar: "Konuşma Gösterge Paneli",
            endConversation: "Görüşmeyi Sonlandır",
            onlyOneRep: "Bu konuşmadaki tek temsilci sizsiniz!",
            chatList: "Konuşma Listesi",
            unreadTitle: "Okunmamış",
            visitorLeftTitle: "Ziyaretci Çıkış",
            activeChatTitle: "Aktif Konuşma",
            autoAssignedTitle: "Otomatik Atanmış",
            watchModeTitle: "İzleme Modu",
            lostChat: "Temsilci Bağlantısı Kopmuş",
            repLostConn: "Temsilci konuşmadan koptu ise konuşma arkaplanı pembe olur.",
            chatWidthDelay: "Gecikmeye Düşen Chat",
            repChatWidthDelay:
                "Sistemde aktif temsilci olmadığında veya yoğunluktan dolayı ziyaretçi alınmadığında konuşma arka planı yeşil rengi olur. ",
            unreadMsg: "Okunmamış Mesaj Varsa  arkaplan açık mavi olur.",
            visitorLeftChat: "Ziyaretçi konuşmadan ayrıldı ise arkaplan koyu gri olur.",
            activeChatMsg: "Konuşma aktif ise arkaplan yeşil olur",
            autoAssignMsg: "Otomatik atama ile atandı ve konuşmaya daha bakılmadı ise arkaplan hardal olur",
            watchModeMsg: "İzleme modunda açıldı ise arkaplan kırmızı olur",
            online: "Çevrimiçi",
            beRightBack: "Hemen Dönecek",
            away: "Hemen Dönecek",
            busy: "Meşgul",
            offline: "Çevrimdışı",
            logout: "Çıkış Yap",
            forWindows: "Windows İçin",
            forMac: "Mac İçin",
            nextChatFromActive: "Aktif konuşmadan bir sonraki konuşmaya geç",
            previousChatFromActive: "Aktif konuşmadan bir önceki konuşmaya geç",
            hideActiveChat: "Aktif konuşmayı gizle",
            closeActiveChat: "Aktif konuşmayı bitir",
            firsthiddenChat: "En çok beklemiş müşterinin konuşmasına bağlan",
            firstChatWaiting: "Cevap bekleyen konuşmaya geçiş yap",
            previousOpenedChat: "Sıra farketmeksizin, bir önce açılan konuşmaya geçiş yap",
            hashHintMessage: "ile hashtag kısayollarını hızlıca girebilirsiniz",
            pmHintMessage: "İle Gizli mesaj Gönderebilirsiniz (Örnek pm: selam)",
            vtippyTicketNotification: "Size gelen her yeni ticket için bildirim ayarları",
            newTicketSound: "Yeni Ticket",
            vtippyDepartmentNotification: "Departman konuşmasından gelen mesajlar için bildirim ayarları ",
            vtippyGroupNotification: "Oluşturulan gruplardan gelen mesajlar için bildirim ayarları ",
            vtippyAnnouncemenNotification: "Yeni gelen duyurular için bildirim ayarları",
            billingAddress: "Fatura Adresi",
            addNewAddress: "Yeni Adres Ekle",
            adressTitle: "Adres Başlığı",
            address: "Adres",
            languageSelection: "Dil Seçimi",
            shortcutHintMessage: "Kısayol mesajları ile daha hızlı mesajlar iletebileceğinizi biliyormusunuz. ",
            switchBetweenConversations: "kısayolları ile chatler arası hızlıca geçiş yapabileceğini biliyor musun?",
            atNameHintMessage: "ile ziyaretçinin adını hızlıca yazabileceğini biliyor musun?",
            dndHintMessage: "Sürükle bırak ile dosya upload edebilirsiniz.",
            pasteFile: "ile dosya gönderebilirsiniz.",
            atEmailHintMessage: "ile ziyaretçinin E-postasını hızlıca yazabileceğini biliyor musun?",
            pastePlainText: "Kopyalaadığınız ifadeyi stilsiz düz metin olarak yapıştırır.",
            pressAndTalk: "Basarak konuşmanı yazıya dökebilirsin",
            historyDetails: "Geçmiş Detayları",
            chat: "Konuşma",
            chatNotFound: "Konuşma Bulunamadı.",
            dataNotFound: "Data bulunamadı",
            visitorInfo: "Ziyaretçi Bilgileri",
            timeSpent: "Geçen Süre",
            noActiveVisitors: "Aktif ziyaretçi yok",
            select: "Açılır Menü",
            fullname: "Tam Ad",
            text: "Metin",
            numeric: "Sayısal",
            phone: "Telefon",
            optionsPlaceholder: "Seçenek değeri",
            selectField: "Açılır Menü eklemek istiyorsanız tıklayın",
            fullnameField: "Tam Ad alanı eklemek istiyorsanız tıklayın.",
            textField: "Metin alanı eklemek istiyorsanız tıklayın.",
            labelField: "Açıklama alanı eklemek istiyorsanız tıklayın.",
            numericField: "Sayısal alanı eklemek istiyorsanız tıklayın.",
            phoneField: "Telefon alanı eklemek istiyorsanız tıklayın.",
            departmentField: "Bölüm eklemek istiyorsanız tıklayın",
            emailField: "Email alanı eklemek istiyorsanız tıklayın.",
            visible: "Görünür",
            required: "Zorunluluk",
            label: "Açıklama",
            totalConnected: "Konuşma Sayısı",
            missedChat: "Kaçan Konuşma Sayısı",
            workTime: "Mesai Süresi",
            closedChatCount: "Kapatılan Konuşmalar",
            activeConvo: "Aktif konuşulan",
            notAnswered: "Henüz cevap verilmemiş",
            delayedConvo: "Gecikmiş Konuşmalar",
            leavingRep: "Ayrılan temsilci",
            staffRate: "Personel Çalışma Oranı",
            customLoginAlert: "Formunuzda  en az 1 adet görünür alan olmak zorundadır.",
            atLeastOneLanguage: "En az bir dil açıklaması olmak zorundadır.",
            requiredField: "Bu alan zorunludur.",
            notRequiredField: "Bu alan zorunlu değildir.",
            visibleField: "Bu alan formda gözükür.",
            notVisibleField: "Bu alan formda gözükmez.",
            connectServer: "Sunucuya bağlısınız",
            disconnectServer: "Sunucu ile bağlantınız kesildi",
            liveChatOff: "Canlı Destek Kapalı",
            visitorScreen: "Ziyaretçi Ekranı",
            viewOnTheSite: "Sayfada Görüntüle",
            viewOnTheSiteTippy: "Yaptığınız Değişikliklerin Nasıl Durduğunu Görmek İçin Tıklayın.",
            showHint: "İpucu Göster",
            dontShowHint: "İpucu Gösterme",
            liveChatOn: "Canlı Destek Açık",
            nightModeOff: "Gece Modu Kapalı",
            nightModeOn: "Gece Modu Açık",
            edit: "Düzenle",
            deleteField: "Sil",
            arrow_upward: "Yukarı Taşı",
            arrow_downward: "Aşağı Taşı",
            doubleClickEdit: "Düzenlemek için iki kere tıklayın veya düzenle butonuna basın.",
            newCatalogCategory: "Yeni Katalog Kategorisi",
            childCreate: "Alt içerik oluşturmak için tıklayın",
            updateCatalogCategoryFrom: "Katalog Kategori Güncelle Formu",
            newCatalogCategoryFrom: "Yeni Katalog Kategori Formu",
            catalogMenu: "Menü",
            catalogContent: "İçerik",
            catalogCategoryName: "Katalog kategori adı",
            newCatalogContentFrom: "Yeni Katalog İçerik Formu",
            catalogContentName: "Katalog içerik adı",
            catalogCategorySaved: "Katalog katagorisi kaydedildi",
            catalogCategoryDeleted: "Katalog kategorisi silindi.",
            catalogCategoryRate: "İçerik Puanı",
            catalogContentFeature: "Katalog Özelliği",
            vtipyAudioLevel: "Bildirim seslerini kısmanız veya açmanız için kullanılır.",
            vtipyOrganizationName: "Organizasyon adını değiştirip güncelleyebilirsiniz.",
            vtipyBrandVisibility: "Supsis etiketinin, chat balonunda gösterip gösterilmeyeği ayarıdır.",
            vtipyBrandVisibilityForced: "Yalnızca ProPlan kullanıcıları değiştirebilir!!",
            vtipyClientDefault: "Temsilci sayfası dilini buradan değiştirebilirsiniz.",
            vtipyCustomerClientDefault: "Müşteri(Chat) sayfasının dilini buradan değiştirebilirsiniz.",
            vtipyVisitorPreferredLang: "Müşteri(Chat) sayfasında konuşma dilini seçebilir.",
            vtipyCustomerClientLanguageDetect: "Müşteri(Chat) sayfasının dilini otomatik olarak algılıyabilirsiniz.",
            vtipySelectTopic:
                "Müşterilerin seçtiği konulara göre departmanlara(konulara) yönlendirmek zorunlu hali gelir.",
            vtipyAutoCallTransfer: "Müsait olan temsilcilere, bekleyen görüşmeleri otomatik atar.",
            vtipyCustomerTyping: "Müşterinin chat ekranında yazdıklarını, temsilci chat ekranında görmenizi sağlar.",
            vtipyAgentTyping: "Temsilcinin yazma durumunu müşteri baloncuğunda gösterir.",
            vtipyQueueNumberVisibleFeature:
                "Temsilcilerin yoğun oldukları zamanda, bağlanmak isteyen müşterilere kaçıncı sırada olduklarını gösterir.",
            vtipyPrivateChatEnabled: "Temsilciler arası konuşma panelini gösterir.",
            vtipyDelayedTalkTime:
                'Bu süre zarfında konuşmaya hiçbir temsilci bağlanmadığında "Geciken Konuşma" olarak etiketlenir.',
            vtipyOfflineMode: "Sistemi çevrim dışı moda almanızı sağlar.",
            vtipyAutoAssignLimit: "Temsilciye otomatik kaç tane müşteri(chat) atama yapılacağını belirler.",
            vtipyCustomerDownTimeWhenRepExit: "Temsilci çıkış yaptığında müşteri boşa düşme süresi(sn.)",
            tippyDisconnectTime: "Müşteri bağlantısı koptuktan sonra chatin kapanma süresi (sn).",
            changeSettings: "Global Ayarı Değiştirin",
            totalBg: "TOPLAM SOHBETLER",
            activeBg: "SANA ATANMIŞ",
            watchBg: "İZLEME",
            waitingBg: "KUYRUKTAKİLER",
            lateBg: "ÇOK BEKLEYENLER",
            freeBg: "BOŞTA OLANLAR",
            maxCapacityBg: "MAKS KAPASITE",
            addNewSettings: "Yeni Bir Global Ayar Ekleyin",
            darkMode: "Gece Modu",
            clientDefault: "Panel varsayılan dil",
            customerClientDefault: "Müşteri kısmı varsayılan dil",
            customerClientLanguageDetect: "Müşteri kısmı dili otomatik algıla",
            visitorPreferredLang: "Müşteri konuşma dilini seçsin",
            preferredThemeColor: "Konuşma Ekranı Tema Tercihi",
            detail: "İncele",
            langSetting: "Dil Ayarı",
            supportUs: "Bize Ulaşın (Canlı Destek)",
            changeLang: "Dil Değiştir",
            fontSizeSetting: "Ekran Büyütme Ayarı",
            changeLangDesc: "Uygulama dilini {code} olarak ayarlar.",
            trLang: "Türkçe",
            enLang: "İngilizce",
            fieldRequired: "{field} alanı gereklidir.",
            selectALanguage: "Bir Dil Seçiniz",
            selectATheme: "Bir Tema Seçiniz",
            responseForm: "Cevap Formu",
            clientRequestInfo: "Müşteri Talep Bilgisi",
            createdDate: "Oluşturma Tarihi",
            descMessage: "Mesaj",
            new: "Yeni",
            lastLoginPlatform: "Platform",
            requiredFieldField: "Bu alan zorunludur",
            catalogCategoryMenu: "Katalog Kategori menüsü ekle",
            catalogCategoryLeaf: "Katalog kategorisi alt menüsü ekle",
            selectAllPermission: "Tümünü Seç",
            catalogCategories: "Katalog",
            copiedClipboard: "Panoya kopyalandı",
            organizationLogo: "Şirket Logosu",
            changePlan: "Plan Değiştir",
            close: "Kapat",
            vtipyUploadLogo:
                "Şirket logonuzu bu alandan yükleyerek müşteri maillerinde ve müşteri sayfasında kendi logonuzu kullanabilirsiniz.",
            tagName: "Etiket Adı",
            tagDescription: "Etiket Açıklaması",
            tagColor: "Etiket Rengi",
            userInformations: "Kullanıcı Bilgileri",
            incomingChat: "Gelen Chat",
            support: "Destek",
            team: "Takım",
            groups: "Gruplar",
            newConversationStarted: "Yeni görüşme başladı",
            allHistoryLoaded: "Tüm geçmiş yüklendi",
            chatCreator: "Sohbet Oluşturan",
            enterGroupTitle: "Grup başlığı girin",
            requiredTitle: "Başlık alanı boş geçilemez",
            requiredChannel: "Kanal adı boş geçilemez",
            next: "Sonraki",
            add: "Ekle",
            selectPeople: "Kişileri seçin",
            textLimitAlertMessage:
                "WhatsApp'ta karakter sınırlaması 19 karakterdir ve bu sınırdan sonrası görüntülenmez. Ancak web üzerinde, 19 karakter sınırını aşan metinler bir alt satıra otomatik olarak geçirilir ve görüntülenir.",
        },
        telegram: {
            typeInTelegramToken: "Telegram Token'i Girin",
            token: "Token",
            telegram: "Telegram",
            telegramTokenTitle: "Telegram Supsis Entegrasyonu",
            telegramAlertForm: "Telegram bot token adresinden alabilirsiniz",
            telegramAlertTitle: "Jetonu gerçekten silmek istiyor musunuz?",
            telegramAlertText: "Belirteç kalıcı olarak kaybolacak!",
        },
        wp: {
            whatsapp: "Whatsapp",
            chatStartingWait: "Konuşma başlatılıyor , Lütfen Bekleyiniz",
            chatStarted: "Konuşma başlatıldı",
            chatNotStarted: "Konuşma başlatılamadı",
            contactSelected: "kişi seçildi",
            startChatWithAnyNo: "Herhangi Bir Numara ile Sohbete Başlayın",
            toLittleChar: "Eksik rakam girildi !",
            typeInANumberDesc: "Sohbet başlatmak için numarayı yazın",
            wpPlusAndLicenceRequired: "Whatsapp Plus Planı ve Lisansı Gereklidir.",
            wpPlusAndLicenceRequiredDesc:
                "Rehberinizde kayıtlı olmayan numaralara sohbet başlatabilmeniz için whatsapp planınızı yükseltmeli ve bir lisans almalısınız.",
            agreement: "Sözleşme",
            purchase: "Satın Alma",
            activating: "Whatsapp Hizmeti Etkinleştirme",
            authenticating: "QR Kodu Doğrulama",
            ready: "Tamamla",
            activationTitle: "Supsis Üzerinde Whatsapp Entegrasyonu Etkinleştirme:",
            wpIntegrationInstruction1: "Whatsapp'ı Telefonunuzda Açın",
            wpIntegrationInstruction2: "Menü'yü yada Ayarlar'ı seçin ve Bağlı Cihazlar'a tıklayın. ",
            wpIntegrationInstruction3: "Kodu taramak için telefonunuzu bu ekrana doğrultun",
            qrGeneratingWait: "QR Kodu Oluşturuluyor lütfen bekleyin...",
            pleaseContinueToWaitUntilCompleted:
                "QR Kodu doğrulandıktan sonra otomatik olarak tamamlandı alanına geçecektir. Lütfen bekleyiniz...",
            authenticatingWait: "Oturum açılıyor, lütfen bekleyin...",

            enableFeature: "Whatsapp Özelliğini Etkinleştir",
            unsubscribeWpInetgration: "Whatsapp Entegrasyonu aboneliğini sonlandır",
            unsubscribeIGIntegration: "Instagram Entegrasyonu aboneliğini sonlandır",
            wpBack: "Geri",
            terminatelWpInetgration:
                "Abonelikten çık butonuna tıkladığınızda whatsapp entegrasyonunuz sonlandırılacaktır.",
            cancelWpInetgration: "Whatsapp entegrasyonunu iptal etmek istiyor musunuz?",
            terminatelIGIntegration:
                "Abonelikten çık butonuna tıkladığınızda instagram entegrasyonunuz sonlandırılacaktır.",
            cancelIGIntgeration: "Instagram entegrasyonunu iptal etmek istiyor musunuz?",
            startChatWp: "Sohbet Başlat",
            readAndAgree: "Okudu onaylıyorum",
            subscribe: "Abone Ol",
            subscribed: "Abone olundu",
            toEnableWpDescription: "Whatsapp Özelliklerini etkinleştirmek için aşağıdaki butona tıklayın.",
            waitForWpActivationDescription:
                "Whatsapp hesap hizmetiniz aktif hale geliyor. Lütfen bekleyin. Yaklaşık 30 saniye sürer.",
            greatWpActivatedDescription: "Whatsapp hesap hizmetiniz etkinleştirildi.",
            unsubscribe: "Abonelikten Çık",
            planDetails: "Özellikler",
            sendReceiveMessage: "Mesaj Gönderme & Alma ",
            sendReceiveImage: "Resim Gönderme & Alma ",
            sendReceiveAudio: "Ses Kaydı Gönderme & Alma ",
            sendReceiveGif: "GIF Gönderme & Alma",
            startChat: "Supsis'te Chat Başlatma",
            supsisFunctionality: "Kullanışlı Supsis Sohbet Özelliği",
            onePhoneMultiAgent: "Tek Telefon ile Birden Fazla Temsilci",
            basicIntegration: "Uğraştırmayan Basit Entegrasyon",
            purchaseHeader: "Supsis-Whatsapp Entegrasyonu Satın Alma",
            wpServices: "Whatsapp Hizmeti",
            wpServicesIntegrationCompleted: "Whatsapp entegrasyonunuz tamamlandı. Artık kullanabilirsiniz.",
            purchasePaymentDescription:
                "Whatsapp Özelliği aydan aya faturalandırılır. Aboneliği kabul ettikten sonra whatsapp hizmetiniz aktif hale gelecektir.",
            wpIntegrationFeatures: "Whatsapp Entegrasyonu Özellikler",
            saveChanges: "Değişiklikleri Kaydet",
            contactList: "Kişi Listesi",
            broadcast: {
                broadcast: "Toplu Mesaj",
                detail: "Detay",
                customer: "Müşteri",
                phoneNumbers: "İrtibat Numaraları",
                showMore: "Daha Fazla Göster",
                showLess: "Daha Az Göster",
                groupName: "Grup İsmi",
                messages: "Mesajlar",
                status: "Durum",
                usageCost: "Kullanım Maliyeti",
                sendingTime: "Gönderme Zamanı",
                progress: "İlerleme",
                groupDetail: "Grup Detayı",
                messagesPerContact: "Kişi Başına Mesaj Sayısı",
                successRatio: "Başarı Oranı",
                message: "Mesaj",
            },
            messages: "Mesajlar",
            broadcastRequests: "Toplu Mesaj İstekleri",
            customerGroups: "Müşteri Grupları",
            messageTemplates: "Mesaj Şablonları",
            plans: "Planlar",
            wpIntegrationRequired: "Whatsapp Entegrasyonu Gerekli",
            wpRequiredIntegrationDescription:
                "Üzgünüz, ziyaret ettiğiniz sayfa whatsapp'ınızı entegre ettiğinizde aktif hale gelecektir.",
            integrateWp: "Hadi, Whatsapp'ı Entegre Edin",
            active: "Aktif",
            archived: "Arşivlenmiş",
            createBroadcastMessage: "Toplu Mesaj Oluştur",
            title: "Başlık",
            description: "Açıklama",
            createdAt: "Oluşturma Tarihi",
            numbers: "Numaralar",
            actions: "Hareketler",
            action: "Aksiyon",
            createCustomerGroup: "Özel bir müşteri grubu oluşturun",
            search: "Arama",
            name: "İSİM",
            contacts: "Kişiler",
            noContactFound: "Kişi Bulunamadı",
            broadcastTitle: "Toplu mesajınıza bir başlık yazın.",
            recipients: "Alıcılar",
            selectRecipients: "Alıcıları Seçin",
            writeYourMessage: "Mesajınızı yazın.",
            schedule: "Planla",
            scheduleNowOrLater: "Şimdi veya daha sonra planlayın.",
            summary: "Özet",
            cancel: "İptal",
            send: "Gönder",
            sending: "Gönderiliyor",
            deleteCustomerGroup: "Bu müşteri grubunu silmek istediğinizden emin misiniz? {name}",
            customerGroupDeleting: "Müşteri grubu siliniyor ...",
            customerGroupDeletingSuccess: "Müşteri grubu başarıyla silindi",
            customerGroupDeletingError: "Müşteri grubu silinirken hata oluştu",
            wpPlusRequired: "Whatsapp Plus Planı Gerekli.",
            broadcastMessageArchived: "Toplu mesaj grubu arşivlendi",
            broadcastMessageNotArchived: "Toplu mesaj grubu arşivlenmedi",
            groupNameSearch: "Müşteri Grubu Adını Yazın",
            groupNameDesc: "Müşteri grubu adı müşteri gruplarınızı tanımlayın",
            save: "Kaydet",
            number: "NUMARA",
            addColumn: "Sütun Ekle",
            addColumnDesc: "Tabloya bir sütun ekleyin",
            addNewContact: "Yeni Kişi Ekle",
            addNewContactDesc: "Tabloya kişi ekleme",
            importFile: "Dosyadan İçe Aktar",
            importFileDesc: "Kişileri excel veya csv dosyasından içe aktarın",
            contactAdded: "Kişi eklendi",
            updateCustomerGroup: "Müşteri grubu güncelleniyor...",
            updateCustomerGroupSuccess: "Müşteri grubu başarıyla güncellendi",
            sendBroadcastMessage: "Toplu Mesaj Gönder",
            columnName: "Sütun Adı",
            columnType: "Sütun Tipi",
            defaultValue: "Varsayılan Değer",
            setDefaultValue: "Varsayılan değeri mevcut kişilere ayarla",
            age: "Yaş",
            location: "Konum",
            gender: "Cinsiyet",
            selectContactFile: "Kişilerin Olduğu Dosyayı Seçin",
            selectContactCsvOrExcel: "Bir CSV veya EXCEL dosyası seçin.",
            importConfiguration: "Dosyanızı içe Aktarın",
            customizeFile: "Eklediğiniz kişiler dosyasını düzenleyin.",
            sendMessageTo: "Mesajı kime göndermek istiyorsunuz?",
            allContact: "Tüm Kişiler",
            messageTypes: "Mesaj Tipleri",
            whenSendMessage: "Mesajı ne zaman göndermek istiyorsunuz?",
            instantlyRightNow: "Hemen Şimdi",
            completed: "Tamamlandı",
            scheduleFuture: "Gelecekteki bir tarih için zamanlama",
            messageDesc: "Mesajınız anında tüm alıcılara gönderilecektir",
            messageSendAt: "Mesajınız adresindeki tüm alıcılara şu tarihte iletilecektir: ",
            estimatedPrice: "Tahmini Fiyat",
            estimatedTime: "Tahmini Süre",
            now: "Şimdi",
            tenMinute: "10 Dakika",
            cancelled: "İptal Edildi",
            failed: "Başarısız",
            running: "Devam Ediyor",
            queued: "Sıraya Alındı",
            scheduled: "Planlanmış",
            noNumberAdded: "Numara Eklenmedi",
            csvOrExcelFile: "CSV veya Excel Dosyası",
            broadcastMessagesToContactFile: "Kişi Listesine Toplu Mesaj Gönderme",
            broadcastMessageTemplates: "Toplu Mesaj Şablonları",
            messageFlow: "Mesaj Akışı",
            textMessageSupport: "Kısa Mesaj Desteği",
            imageMessageSupport: "Resimli Mesaj Desteği",
            spamPreventions: "Spam Mesaj Önleme",
            includesAllBasicPlans: "Whatsapp Paketindeki Tüm Özellikleri İçerir",
            chatbotIntegration: "Chatbot Entegrasyonu",
            messageToNewNumbers: "Yeni Numaralara Mesaj Gönderme",
            broadcastMessageToEveryone: "Herkese Toplu Mesaj Gönderme",
            personalizedBroadcastMessage: "Kişiselleştirilebilir Toplu Mesajlar",
            customerGroupSegmentation: "Müşteri Grubu Segmentasyonu",
            scheduleBroadcastMessage: "Toplu Mesaj Planlama",
            locationMessageSupport: "Konum Mesajı Desteği",
            advancedSpamPreventions: "Gelişmiş Spam Mesaj Önleme",
            whatsappPlans: "Whatsapp Planları",
            selectBestPlan: "Sana uygun planı seç",
            comingSoon: "Çok Yakında...",
            selectFile: "Bir dosya seçin",
            created: "Oluşturuldu",
            message: "Mesaj",
        },
        ig: {
            instagram: "Instagram",
        },
        ticket: {
            ticketTagFilter: "Ticket Konusu Filtre Etiketi",
            ticketEmails: "Yönlendirelecek E-Posta Listesi",
            save: "Kaydet",
            delete: "Sil",
            transactions: "İşlemler",
            noEmailTicketNotifications: "Ticket Eposta  Yönlendirme Kaydı Bulunamadı",
            emailIsNotValid: "Eposta Adresi Geçersiz",
            emailNotificationDeleted: "Ticket Yönlendirme Kaydı Silindi",
            emailNotificationDeleteError: "Ticket Yönlendirme Kaydı Silinemedi!!",
            tagFilterRequired:
                "Ticket Konusu Filtre Etiketi Gereklidir. Tüm ticket'lar için * (wildcard) etiketini kullanabilirsiniz!",
            emailsRequired: "Ticket Yönlendirmesi için en az 1 Eposta adresi girilmelidir",
            emailNotificationCreated: "Ticket Yönlendirme Kaydı Oluşturuldu",
            emailNotificationCreateError: "Ticket Yönlendirme Kaydı Oluşturulamadı!!",
            ticketForwarding: "Ticket Eposta Yönlendirme",
            ticketTagFilterDesc:
                "Ticket filtrelemek için chatbot tasarımda kullandığınız ticket konularını kullanır. Farklı bir etiket yazıp enter'a basıp ekleyebilirsinz. '*' etiketi seçerseniz tüm ticketları seçer",
            ticketEmailsDesc:
                "Ticket'ların yönlendireleceği eposta listesi. Sistemdeki temsilcilerin adresleri seçerek ekleyebilirsiniz. Sistem dışı  eposta/lar da ekleyebilirsiniz.",
            ticketList: "Ticket Yönlendirme Kuralları",
            ticketTagFilterPlaceHolder: "Ticket filtresi, hepsi için * seçiniz",
            ticketEmailsPlaceHolder: "Yönlendirme eposta listesi",
        },
        theme: {
            headerColor1: "Başlık (Sol)",
            headerColor1A: "Başlık Kısmı Renk/Saydamlık",
            headerColor2: "Başlık (Sağ)",
            headerColor2A: "Başlık Kısmı 2. Renk/Saydamlık",
            backgroundColor: "Arkaplan (Sol)",
            backgroundColorA: "Arkaplan 1. Renk/Saydamlık",
            backgroundColor2: "Arkaplan (Sağ)",
            backgroundColor2A: "Arkaplan 2. Renk/Saydamlık ",
            opacity: "Saydamlık",
            textColor: "Genel Metin Rengi",
            errorTheme: "Hata Rengi",
            bubbleBackground: "Temsilci balon rengi",
            bubbleVisitorBackground: "Müşteri balon rengi",
            bubbleBackgroundA: "Temsilci balon saydamlığı",
            bubbleVisitorBackgroundA: "Müşteri balon saydamlığı",
            bubbleText: "Temsilci konuşma rengi",
            bubbleVisitorText: "Müşteri konuşma rengi",
            textFormColor: "Form rengi",
            selectCustom: "Özel Tema Seç",
            font: "Font",
            headerColorSecond: "Başlık Üst Rengi",
            headerColorFirst: "Başlık Alt Rengi",
            backgroundColorFirst: "Arkaplan Üst Rengi",
            formColor: "Form Yazı Rengi",
            buttonColor: "Buton Rengi",
            backgroundColorSecond: "Arkaplan Alt Rengi",
            chatBotButtonText: "Chatbot Yazı Rengi",
            chatBotButtonColor: "Chatbot Buton Rengi",
        },
        billing: {
            paymentStatus: "Ödeme Durumu",
            amount: "Tutar",
            invoiceID: "Fatura ID",
            expected: "Bekleniyor..",
            currentAmount: "Mevcut Tutar",
            monthlyEstimatedAmount: "Ay Sonu Tahmini Tutar",
            creationDate: "Kesim Tarihi",
            invoiceStatus: "Fatura Durumu",
            invoicePeriod: "Fatura Dönemi",
            newPaymentMethod: "Yeni Ödeme Yöntemi",
            channelCount: "Kanal Sayısı",
            remainingTime: "Kalan Süre",
            chatbotLimit: "Chatbot Limiti",
            free: "Ücretsiz",
            maxChatbotSession: "Maksimum Chatbot Sayısı",
            buyIt: "Satın al",
            renewalDate: "Yenilenme Tarihi",
            monthly: "Aylık",
            yearly: "Yıllık",
            packagePeriod: "Paket Dönemi",
            packageType: "Paket Türü",
            packageManagement: "Paket Yönetimi",
            invoiceManagement: "Fatura Yönetimi",
            futureInvoice: "Gelecek Fatura",
            pastInvoices: "Geçmiş Faturalar",
            creditCard: "Kredi kartı",
            invoice: "Fatura",
            mustBeUpgradePlanForChatBot: "Chatbot özelliğini aktif edebilmeniz için Pro Plan'a geçmelisiniz!",
            incorrect: "Hatalı",
            cardInfo: "Kart Bilgisi",
            billingDetails: "Fatura Detayları",
            firstPreferredCard: "Birincil Kart Olarak Ayarla",
            primary: "Birincil",
            addCardIyzico:
                "Kayıtlı bir kartınız bulunmamaktadır. Aylık kullanım ücretlerinizi ödeyebilmeniz için kart eklemeniz gerekmektedir.Ödeme sistemi iyzico tarafından sağlanmaktadır.",
            billingPlanSettings: "Fatura & Ödeme Yöntemi",
            paymentMethod: "Ödeme Yöntemi",
            billingDate: "Fatura Tarihi",
            isPaid: "Ödeme Durumu",
            paid: "Ödendi",
            unPaid: "Ödenmedi",
            billingHistory: "Fatura Geçmişi",
            markPaid: "Ödendi Olarak İşaretle",
            paymentDate: "Ödeme Tarihi",
            pay: "Faturayı Öde",
            newInvoice: "Fatura Oluştur",
            updateBilling: "Fatura Adresini Değiştir",
            updateCard: "Kredi Kartını Değiştir",
            paymentBilling: "Ödeme Metodu & Fatura Adresi",
            price: "Fatura Tutarı",
            billingAddress: "Açık Adres",
            billingCity: "Şehir",
            billingCountry: "Ülke",
            contactName: "Faturalandırma Kişi Adı",
            expireMonth: "Son Kullanma T. Ay",
            expireYear: "Son Kullanma T. Yıl",
            cardNumber: "Kart Numarası",
            cardHolderName: "Kart Üzerindeki Ad Soyad",
            cardAlias: "Kart takma isim",
            identityNumber: "Kimlik/Vergi  Numarası",
            name: "Ad",
            surname: "Soyad",
            email: "Eposta",
            addCard: "Kart Ekle",
            update: "Güncelle",
            cancel: "Vazgeç",
            save: "Kaydet",
            saving: "Kaydediliyor",
            noInvoiceFound: "Fatura kaydı bulunamadı",
            year: "Yıl",
            updating: "Güncelleniyor",
            newInvoiceForm: "Yeni Fatura Oluşturma Formu",
            error: "Hata",
            transactions: "İşlemler",
            paymentMethodAdded: "Ödeme yöntemi başarıyla eklendi",
            paymentMethodAddError: "Ödeme yöntemi eklenemedi, Hata oluştu",
            creditCardChanged: "Kredi kartınız değiştirildi",
            errorOccurred: "Bir hata oluştu, tekrar deneyin.",
            billingDetailUpdated: "Fatura bilgileriniz güncellendi",
            invoiceCreated: "Fatura kaydı başarıyla oluşturuldu",
            paymentSuccess: "Faturanız başarıyla ödendi, teşekkür ederiz",
            paymentFail: "Faturanız ödenirken  hata oluştu daha sonra tekrar deneyiniz.",
            startWith: "{binNumber} ile başlayan {cardFamily} kart",
            billingAddressChanged: "Fatura Adresi bilgileri güncellendi ",
            hidePlan: "Planı Gizle",
            informationShopping:
                "Ödeme bilgileriniz, fatura bilgileriniz, kredi kartı bilgileriniz Shopify tarafından kontrol edilmektedir.",
            trialTimeInformation:
                "Deneme Sürümü bitmesine {dayCount} gün kaldı. Bu süre bitimine kadar ödeme yöntemi girmemeniz durumunda sistem tarafından otomatik olarak FREE Plan'a geçilir.",
            trialTimeInformationShort: "Son {dayCount} Gün",
            currentPlanLabel: "Mevcut Plan: {planName} Plan ({agentCount} Temsilci)",
            changeCancelPlan: "Planı Değiştir/İptal et",
            oneAgent: "Temsilci",
            agent: "Temsilci",
            yourCurrentPlan: "Mevcut Plan",
            month: "Ay",
            billedMonthToMonth: "(Aylık Faturalandırma)",
            selectAgentCount: "Temsilci Sayısı Seçin",
            selectFreePlan: "Free Plan Seçin",
            planDetails: "Plan Detayları",
            multiAgent: "(Çok Temsilci)",
            selectProPlan: "Pro Plan Seçin",
            foreverFree: "Süresiz Free",
            websiteIntegration: "Web Sitesi Entegrasyonu",
            websiteIntegrationUnlimited: "Web Sitesi Entegrasyonu",
            ChatBotUnlimited: "ChatBot",
            videoCallUnlimited: "Görüntülü Arama",
            multiAgentUpTo: "Çok Temsilcili ({agentCount} Temsilciye Kadar)",
            audioCallUnlimited: "Sesli Arama",
            screenSharingUnlimited: "Ekran Paylaşımı",
            fileTransferUnlimited: "Dosya Paylaşımı",
            autoChatAssignerUnlimited: "Otomatik Sohbet Ataması",
            multiLanguageTranslationUnlimited: "Otomatik Dil Çeviricisi",
            detailedReporting: "Raporlama",
            days30TrialsAvailable: "30-Günlük Ücretsiz Deneme",
            limitedArchiveLookupLastMo: "Sınırlı Arşiv Araması (Son {monthCount}-ay)",
            fullCustomizationUnlimited: "Özelleştirme",
            planUpdated: "Planınız başarıyla güncellendi.",
            planUpdating: "Planınız güncelleniyor...",
            planUpdatingDescription: "Güncelleme süresince lütfen bekleyin!",
            done: "Tamamlandı",
            freePlanUpdated: "Planınız Free Plan olarak güncellendi. (Maksimum Temsilci Sayısı: 1)",
            proPlanUpdated: "Planınız Pro Plan olarak güncellendi. (Maksimum Temsilci Sayısı: {proPlanUpdated}) ",
            canNotDwnGrade:
                "Planınız PRO {agentCountFirst} Temsilci sayısından {valNewPlnToUppr} {agentCountSecond} sayısına  düşürülemez!. Temsilci kredileriniz kullanımda. ",
            deleteWarning: " {valDif} Temsilci silmeniz gerekmektedir.",
            warnMessage: "Seçilen plan, mevcut plandan farklı olmalıdır",
            add: "Ekle",
            cancelYourPlan: "Planını İptal Et",
            upgradeYourPlan: "Planını Yükselt",
            downgradeYourPlan: "Planını Düşür",
            agree: "KABUL ET",
            disagree: "VAZGEÇ",

            invoices: "Faturalar",
            priceIntervals: "Tutar Aralığı",
            selectSiteAlias: "Site Adı Girin veya Seçin",
            selectPriceInterval: "Tutar Aralığı Girin veya Seçin",
            isRefunded: "Geri Ödeme Yapıldı mı?",
            invoiceId: "Fatura No",
            siteId: "Site No",
            createdDate: "Olurşturulma Tarihi",
            failCount: "Başarısız Çekim Denemesi Adeti",
            failDate: "Yapılmayan Ödemenin tarihi",
            Dashboard: "Gösterge Paneli",
            Agents: "Temsilciler",
            Integration: "Entegrasyon",
            Settings: "Ayarlar",
            Contacts: "Kişiler",
            Domain: "Domain",
            lastActivity: "Son Aktivite",
            basePrice: "Taban Fiyat",
            packagePrice: "Paket Fiyatı",
            whatsappPrice: "Whatsapp Fiyatı",
            realtimeVisitorCount: "Anlık Ziyaretçi",
            suspend: "Askıya Al",
            partner: "Partner",
            plan: "Plan",
            trialDay: "Deneme Günü",
            mobile: "Mobil",
            webSite: "Web Sitesi",
            websiteOrigins: "Web Sitesi Kaynağı",
            ownerName: "Sahibinin Adı",
            ownerEmailAddress: "Sahibinin Email'i",
            discount: "İndirim",
            daysLeft: "Kalan Gün",
            newTrialPopUp: "Yeni Deneme Süresi Kaç Gün Olsun",
            newWpPricePopUp: "Yeni Whatsapp Ücreti Ne Kadar Olsun ?",
            newIGPricePopUp: "Yeni Instagram Ücreti Ne Kadar Olsun ?",
            newBasePricePopUp: "Yeni Supsis Taban Fiyatı Ne Kadar Olsun ?",
            siteInfoUpdated: "Site Bilgisi Güncellendi",
            siteInfoNotUpdated: "Site Bilgisi Güncellenmedi",
            siteInfoNotUpdatedErr: "Hata Oluştu! Site Bilgisi Güncellenmedi.",
        },
        tour: {
            representativeTab: "Temsilci Tablosu",
            stats: "İSTATİSTİK PANELİ",
            chats: "CHAT PANELİ",
            settings: "AYARLAR",
            status: "DURUM",
            prevStep: "Önceki Adım",
            nextStep: "Sonraki Adım",
            finish: "Bitir",
            skip: "Atla",
            skip2: "Sistemi biliyorum bir daha gösterme",
            startTour: "Tura Başla",
            firstTimeIntro:
                "Sisteme ilk defa girdiğini keşfettim izin verirsen ufak bir tanıtıcı tur başlatmak istiyorum",
            hi: "Merhaba",
            welcomeTo: "Supsis Canlı Destek'e Hoşgeldin",
            statsPanel: "Sistemle anlık olarak bekleyen, toplam, aktif chat sayılarını gösteren durum çubuğudur.",
            sidebarMenu: "Menü",
            sidebarMenuContent: "Sayfalar arası geçişleri buradan yapabilirsiniz.",
            representativePrivateMessage: "Temsilciler Arası Konuşma Paneli",
            representativePrivateMessageContent: "Temsilciler arası özel konuşmaları buradan görebilirsiniz.",
            helpMenu: "Yardım Menüsü",
            helpMenuContent: "Sistem hakkında yardım bilgilerine buradan ulaşabilirsiniz.",
            settingsMenu: "Ayarlar Menüsü",
            settingsMenuContent: "Dil, gece modu ve ekran büyütme adımlarını buradan yapabilirsiniz.",
            startChat: "Sohbeti Başlat",
            profileMenu: "Profil Menüsü",
            profileMenuContent: "Müsaitlik durumunuzu değiştireblir ve temsilci ayarlarınızı buradan yapabilirsiniz.",
            visitorsTab: "Ziyaretçiler",
            visitorsTabContent: "Ziyaretçileri buradan görebilirsiniz.",
            visitorTabHistory: "Ziyaretçi Geçmişi",
            visitorTabHistoryContent: "Ziyaretçi geçmişini buradan görebilirsiniz.",
            representativ_eTab: "Temsilciler",
            representativeTabContent: "Temsilcileri buradan görebilirsiniz.",
            liveSupport: "Canlı Destek",
            liveSupportContent: "Canlı Destek alan müşteri sayısını buradan görebilirsiniz. ",
            siteVisitors: "Site Ziyaretçileri",
            siteVisitorsContent: "Site ziyaretçi sayısını buradan görebilirsiniz. ",
            tableSettings: "Tablo Ayarları",
            tableSettingsContent: "Tabloda kolon gösterme veya gizlemeyi buradan yapabilirsiniz.",
            watchModeButton: "İzleyici Butonu",
            watchModeContent: "İzleyici mode olarak buradan katılabilirsiniz ve sadece yazılanları görüntülersiniz.",
            popoverInfo: "Ziyaretçi Detay",
            popoverInfoContent: "Ziyaretçi hakkında  bilgi verir.",
            popoverButton: "Gelişmiş Konuşma Ayarları",
            popoverButtonContent:
                "Konuşmayı açar, temsilciye direk mesaj atabilir veya ziyaretçiyi engelleyebilirsiniz.",
            openChat: "Konuşma Katıl Butonu",
            openChatContent: "Konuşmayı buradan açabilirsiniz",
            pagination: "Sayfalama Menüsü.",
            paginationContent: "Sayfa sayısını buradan arttırabilirsiniz.",

            chatwindow: {
                chatWindowSettingsButtons: "KONUŞMA PENCERESİ AYARLAR BUTONU",
                chatWindowActionButtons: "KONUŞMA PENCERESİ GENEL İŞLEM BUTTONLARI",
                chatPanelActions: "KONUŞMA PANELİ İŞLEMLERİ",
                otherPanels: "DİĞER PANELLER",
                settingsButton: "Konuşma engelleme, yönlendirme, gizli mesaj atma ve temsilci atama yapabilirsiniz.",
                chatColorButton: "Konuşma balonlarındaki hangi renk ne anlama geldiğini buradan öğrenebilirsiniz",
                keyboardShortcutButton:
                    "Yazışma esnasında kolaylık sağlayan fonksiyonların veya diğer kullandığın özelliklerin kısayollarını buradan bulabilirsin",
                hideButton: "Açık konuşmayı aşağıya indirir arka planda açık kalmaya devam eder",
                closeButton: "Açık konuşması sonlandırır ve konuşmadan çıkarsınız",
                ellipsisButton:
                    "Daha fazla işlemler burada yer almaktadır. Özel mesaj gönderme , ziyaratci banlama , temsilci atama gibi işlemler buradan yapılır",
                userInfoWidget: "Ziyaretçi hakkında detaylı bilgiler burada yer alacaktır",
                preparedContentWidget:
                    "Burada hazır içerik şablonları bulunmaktadır. İster tıklayarak ister kısayolunu konuşma ekranında yazı yazma alanında kısayol serisi tuşlayarak hazır içerikleri hızlıca ekleyebilirsin",
                chatHistoryWidget:
                    "Bu ziyaretcinin geçmiş konuşmaları varsa burada listelenecektir. Eski konuşma detaylarını buradan inceleyebilirsin",
                chatBarButton:
                    "Aktif konuşmayı buradan engelleyebilir, temsilciye gizli mesaj atabilir ve görüşmeden ayrılabilirsiniz.",
            },
        },
        adminUser: {
            newAdminUserForm: "Yeni Admin Kullanıcısı Kayıt Formu",
            updateAdminUserForm: "Admin Kullanıcısı Güncelleme Formu",
            adminUsers: "Admin Kullanıcılar",
            newAdminUser: "Yeni Admin Kullanıcı",
            noAdminUser: "Henüz bir admin kullanıcı yok.",
            adminUserName: "Admin Kullanıcı Adı",
        },
        report: {
            hourly: "(Saatlik)",
            hourlyAverage: "Saatlik Ortalama",
            hourlyMax: "Saatlik Maksimum",
            hourlyMin: "Saatlik Minimum",
            dailyAverage: "Günlük Ortalama",
            dailyMax: "Günlük Maksimum",
            dalyMin: "Günlük Minimum",
            totalAmount: "Toplam Miktar",
            averageAmount: "Ortalama Miktar",
            minAmount: "Minimum Miktar",
            maxAmount: "Maksimum Miktar",
            siteCount: "Site Sayısı",
            agentCount: "Temsilci Sayısı",
            channelsTimeSeries: "Kanallar Grafiği",
            channelPies: "Kanallar Pasta Grafiği",
            pieView: "Pasta Grafiği",
            topVisitorCountry: "En Çok Ziyaretçinin Geldiği Ülke",
            websiteTrafficByCountry: "Ülkeye Göre Website Trafiği",
            visitorCount: "Ziyaretçi Sayısı",
            websiteVisitorTraffic: "Website Ziyaretçi Trafiği",
            websiteTraffic: "Website Trafiği",
            author: "Yazan",
            topWorstComments: "En Kötü Yorumlar",
            topBestComments: "En İyi Yorumlar",
            topBestWorstComments: "En İyi/Kötü Yorumlar",
            topComments: "Yorum Analizi",
            noComment: "Henüz Yorum Yapılmadı",
            minWaitingTime: "Minimum Bekleme Süresi",
            maxWaitingTime: "Maksimum Bekleme Süresi",
            averageWaitTime: "Ortalama Bekleme Süresi",
            waitTime: "Bekleme Süresi (Saniye)",
            agentWaitDurationTitle: "Temsilci Bekleme Süresi Grafiği",
            incomingMessage: "Gelen Mesaj(lar)",
            outgoingMessage: "Giden Mesaj(lar)",
            totalSpent: "Toplam Harcama",
            avgSpent: "Ortalama Harcama",
            totalPayment: "Toplam Yükleme",
            walletStatus: "Cüzdan Durumu",
            walletBalanceStatus: "Cüzdan Bakiyesi Durumu",
            messageTraffic: "Mesaj Trafiği",
            breakCount: "Mola Sayısı",
            agentBreakTime: "Temsilcilerin Mola Sayıları ☕",
            agentStatusHour: "Temsilci Durumu (Saat)",
            agentWorkTimeCalendar: "Temsilci Çalışma Süresi Takvimi",
            agentActivity: "Temsilci Aktivitesi",
            noEnoughtData: "Yeterli Veri Yok",
            averageFirstResponse: "Ortalama İlk Cevap Süresi",
            slowestResponser: "En Yavaş Cevap Veren",
            fastestResponder: "En Hızlı Cevap Veren",
            firstAnswerTimeSec: "İlk Mesaj Süresi (Saniye Olarak)",
            firstAnswerByAgent: "Temsilcilerin İlk Mesaj Süresi",
            averageSolutionTime: "Ortalama Çözüm Süresi",
            slowestSolver: "En Yavaş Çözen",
            fastestSolver: "En Hızlı Çözen",
            averageChat: "Ortalama Chat",
            leastChatReceiver: "En Az Chat Alan",
            mostChatRecipients: "En Çok Chat Alan",
            averageTicket: "Ortalama Ticket",
            leastTicketReceiver: "En Az Ticket Alan",
            mostTicketRecipients: "En Çok Ticket Alan",
            resolveTime: "Çözüm Süresi (dk)",
            resolveTimeByUser: "Kullanıcıya Göre Chat Çözüm Süresi (Dakika olarak)",
            chatResolveTimeByAgent: "Temsilcilere Göre Sohbet Çözüm Süresi",
            chatDistByHandDesc: "Temsilci, chatbot ve hibrit tarafından kaç sohbet gerçekleştirildi?",
            chatDistByHandleType: "Yanıtlayana Göre Chat Dağılımı",
            chatCountsByHandleType: "Yanıtlayana Göre Chat Sayıları",
            missed: "Kaçırıldı",
            answered: "Yanıtlandı",
            chatDistByAnsDesc: "Kaç sohbet yanıtlandı ya da kaçırıldı?",
            chatCountsByAns: "Yanıta Göre Chat Sayıları",
            chatCountByPlatform: "Platforma Göre Chat Sayıları",
            chatDistByPDesc: "Hangi platforma kaç chat geldi?",
            chatDistByPlatform: "Platforma Göre Chat Dağılımı",
            ticketCountByUser: "Temsilcilere Göre Ticket Sayıları",
            ticketCountByStatus: "Yanıtlama Durmuna Göre Chat Sayıları",
            user: "Temsilci",
            saveAsImage: "Görsel olarak indir",
            fullScreen: "Tam ekran",
            download: "İndir",
            tableView: "Tablo Görünümü",
            chartView: "Grafik Görünümü",
            chatDistByUsers: "Temsilcilere Göre Chat Dağılımı",
            chatCountsByUsers: "Temsilcilere Göre Chat Sayıları",
            minDuration: "Minimum Süre",
            maxDuration: "Maksimum Süre",
            totalDurationByAgent: "Temsilci Toplam Oturum Süresi",
            averageDurationByAgent: "Temsilci Ortalama Oturum Süresi",
            totalDurationByCB: "Chatbot Toplam Oturum Süresi",
            averageDurationByCB: "Chatbot Ortalama Oturum Süresi",
            viewUnitAs: "Birim",
            hybrid: "Hibrit",
            handledBy: "Tarafından:",
            sessionDurationOverall: "Genel Oturum Süresi",
            allChannels: "Tüm Kanallar",
            sessionsDurationOverall: "Oturum Süreleri Genel",
            sessionsOverall: "Oturumlar Genel",
            eventCount: "Etkinlik Sayısı",
            calendarEvents: "Takvim Etkinlikleri",
            reservationEvents: "Rezervasyon Etkinlikleri",
            incomingMails: "Gelen Mailler",
            incomingMailCount: "Gelen Mail Sayısı",
            reservation: "Rezervasyon",
            event: "Etkinlik",
            reservationEventCount: "Rezervasyon Etkinlik Sayısı",
            channelBreakdown: "Kanal Dağılımı",
            websiteAnalysis: "Website Analizi",
            customerSatisfaction: "Müşteri Memnuniyeti",
            teamBreakAnalysis: "Takım Çalışma/Mola Analizi",
            dailyAgentActivity: "Günlük Temsilci Aktiviteleri",
            agentPerformance: "Temsilci Performansı",
            chatDistributions: "Chat Dağılımı",
            users: "Kullanıcı",
            segmentTimeseries: "Segment Grafiği",
            segmentsOverall: "Genel Segmentler",
            unmatchRatio: "Eşleşmeme Oranı",
            totalMatchCount: "Toplam Eşleşme Sayısı",
            totalUnmatchCount: "Toplam Eşleşmeme Sayısı",
            matchRatio: "Eşleşme Oranı",
            matched: "Eşleşen",
            trainingOverall: "Genel Eğitim",
            trainingStatusTimeseries: "Eğitim Durumu Zaman Grafiği",
            duration: "Süre",
            totalSessionDuration: "Toplam Oturum Süresi",
            averageSessionDuration: "Ortalama Oturum Süresi",
            second: "Saniye",
            minute: "Dakika",
            hour: "Saat",
            aggregateAs: "Şu şekilde hesapla",
            chatbotSessionDurationOverall: "Genel ChatBot Oturum Süresi",
            ratingTimeSeries: "Oylama Grafiği",
            chatCountTimeseries: "Sohbet Sayısı Zaman Grafiği",
            notRated: "Puanlanmamış",
            totalRatingCount: "Toplam Değerlendirme Sayısı",
            averageRating: "Ortalama Değerlendirme",
            weightedAverageRating: "Ağırlıklı Ortalama Değerlendirme",
            rate: "Puanlama",
            ratingOverall: "Müşteri Değerlendirmeleri",
            session: "Oturum",
            total: "Toplam",
            average: "Ortalama",
            max: "En Fazla",
            min: "En Az",
            sessionCount: "Oturum Sayısı",
            uniqueUsers: "Benzersiz Kullanıcılar",
            viewAs: "Şu şekilde görüntüle: ",
            overall: "Genel",
            detailReport: "Detaylı Rapor",
            dailyReports: "Günlük Raporlar",
            pointBasedReports: "Puan Bazlı Raporlar",
            personDateBasedPointReport: "Kişi ve Gün Bazlı Puan Raporu",
            personDateBasedReport: "Kişi ve Gün Bazlı Rapor",
            personBasedReport: "Kişi Bazlı Raporlar",
            personAndDateBasedGraph: "Kişi ve Gün Bazlı grafiği",
            noReport: "Rapor Yok",
            reports: "Raporlar",
            totalBar: "Toplam",
            ticketCount: "Ticket Sayısı",
        },
        announcements: {
            menu: "Duyurular",
            newAnnouncementForm: "Yeni Duyuru Kayıt Formu",
            updateAnnouncementForm: "Duyuru Güncelleme Formu",
        },
        stats: {
            total: "Sistemdeki aktif konuşmaların sayısıdır.",
            active: "Size ait olan aktif konuşmaların sayısıdır.",
            waiting: "Temsilci atanmayı bekleyen yeni aktif konuşma sayısıdır.",
            late: "Belli bir süre geçmiş  ve temsilci atanmayı bekleyen yeni konuşmaların sayısıdır.",
            free: "Temsilcisi çıkış yaptıktan sonra yeni temsilci atamayı bekleyen konuşmaların sayısıdır.",
            pco: "[Personel Çalışma Oranı] : Sistemdeki çevrimiçi temsilcilerin toplam alabildiği konuşma sayısının doluluk oranınıdır. ",
            maxCapacity: "Sistemin bekletmeden temsilci atayabileceği maksimum chat sayısıdır",
            chatbot: `Chatbot'un aktif konuşma sayısı`,
        },
        time: {
            lastYear: "Son Yıl",
            thisYear: "Bu Yıl",
            last3Months: "Son 3 ay",
            last7: "Son 7 Gün",
            today: "Bugün",
            yesterday: "Dün",
            lastWeek: "Geçen Hafta",
            currentWeek: "Bu Hafta",
            currentMonth: "Bu Ay",
            lastMonth: "Geçen Ay",
            last30Day: "Son 30 gün",
            allTime: "Tüm Zamanlar",
            custom: "Farklı Bir Zaman",
        },
        fastWizard: {
            generalColors: "Genel Renkler",
            tellUsMore: "Deneyiminizi kişiselleştirebilmemiz için bize daha fazla bilgi verin",
            moreInfo: "Genel Ayarlar",
            display: "Tema Ayarları",
            availability: "Temsilci Çalışma Saatleri",
            preview: "Ön İzleme",
            installCode: "Kurulum",
            previous: "Önceki Adım",
            setupSupsisLiveChat: "SUPSIS LIVE Hızlı Kurulum",
            continue: "Sıradaki Adım",
            completeInitialize: "Hızlı Kurulumu Tamamla",
            completedMessage: "SUPSIS Live Hızlı Kurulumu Başarıyla Gerçekleştirildi.",

            websiteIntegration: "Supsis Live entegrasyonu için web sitenizin adresi",

            customizeLiveChat: "Canlı Sohbetinizi Özelleştirin",
            createBrandedExperience: "Ziyaretçileriniz için markalı bir sohbet deneyimi oluşturun.",
            chatColor: "Chat Rengi",
            chooseChatColor: "Bir Renk Seçin.",
            chatBubble: "Chat Balonu",
            selectBubble: "Bir Chat Balonu Seçin",
            chatBubbleColor: "Chat Balonu Rengi",
            selectChatBubbleColor: "Chat Balonu Rengini Seçin",
            customSelection: "Özel Seçim:",

            onlineSupportVisitorTime: "Ziyaretçilerinize hangi zaman aralıklarında hizmet sağlarsınız ?",
            channelAvailability: "Çevrimci Zamanlama",
            availability724: "7/24 Sürekli Hizmet",
            basedOnTeam: "Temsilci Çalışma Saatleri Dahilinde",
            basedOnTeamExplanation:
                "En az 1 temsilci çevrimçi olduğunda sohbet çevrimiçi görünür. Çevrimiçi temsilci yoksa offline olarak görünür",
            customHours: "Özel Çalışma Saatleri",
            customHoursExplanation: "Kendi Çalışma Saatlerinizi Belirleyin",
            customHoursTimezone: "Bölgesel Zaman Dilimi:",
            customHoursFrom: "Başlangıç:",
            customHoursTo: "Bitiş:",
            customHoursAddHours: "+Saat Ekle",

            previewDesktop: "Masaüstü",
            previewIpad: "Tablet",

            installationAndInstructions: "Kurulum & Talimatlar",
            installationTrackingCode: "Takip numarasını web sitenize yükleyin",
            installationTrackingCodePlease:
                "Lütfen kodu, SUPSIS Canlı sohbeti etkinleştirmek istediğiniz herhangi bir sayfada {bodyTag} etiketinin bitiminden hemen önce aşağıdaki talimatlara uygun olarak yapıştırın.",
            installationInstructionsJavascript:
                " Yukarıda verilen entegrasyon kodunu {bodyTag} etiketi içerisinde kapanıştan hemen öncesine yapıştırın.",
            installationInstructionsShopify1: "1. Shopify panelinize giriş yapın",
            installationInstructionsCopy: "Kopyala",
            installationInstructionsCoppyMessage: "Entegrasyon komutları panoya kopyalandı",
            installationInstructionsShopify2:
                "2. Online Store > Themes > Actions 'a gidin,altındaki açılır menüden  Current Theme > Edit code >theme.liquid 'e ilerleyin",
            installationInstructionsShopify3:
                "3.Yukarıda verilen entegrasyon kodunu, theme.liquid scriptinin sonundaki {bodyTag} etiketinin hemen önüne yerleştirin.",
            installationInstructionsIdeaSoft1: "1. Bayi panelinize giriş yapınız.",
            installationInstructionsIdeaSoft2: "2. Ayarlar -> SEO -> Arama Motoru Servisleri adımını takip ediniz.",
            installationInstructionsIdeaSoft3:
                '3. Takip Kodu  kısmından "Meta Tag ile Site Doğrulama"  seçeneğini seçiniz.',
            installationInstructionsIdeaSoft4:
                "4. Açılan kutuya yukarıdaki entegrasyon kodunu kopyalayıp yapıştırın ve kaydediniz.",
            installationInstructionsIdeaSoft5:
                '5. Ayarlar -> Optimizasyonlar -> "Ön Belleği Temizle" butonuna basınız. Entegrasyon tamamlanmıştır.',
            installationInstructionsWordPress1: "1. WordPress yönetici panelinize giriş yapın",
            installationInstructionsWordPress2: "2. Görünüm > Tema Düzenleyici'ye gidin",
            installationInstructionsWordPress3:
                "3. (en sağda) Tema Dosyaları altında, Tema Altbilgisini (footer.php)'yi bulun ve seçin",
            installationInstructionsWordPress4:
                "4.Yukarıdaki entegrasyon kodunu alttaki {bodyTag} etiketinin önüne yapıştırın.",
            installationInstructionsWordPress5: "5. Değişiklikleri kaydetmek için Dosyayı Güncelle'yi tıklayın",
            installationInstructionsOpenCart1: "1. Opencart admin panelinize giriş yapın",
            installationInstructionsOpenCart2: "2. Tasarım > Tema Düzenleyici'ye gidin",
            installationInstructionsOpenCart3:
                "3. 'common' klasörünü seçin ve içerisindeki 'header.twig' dosyasını açın.",
            installationInstructionsOpenCart4:
                "4.Yukarıdaki entegrasyon kodunu, alttaki {headTag} etiketinin önüne yapıştırın.",
            installationInstructionsOpenCart5: "5. Kaydet butonuna tıklayın",
            installationInstructionsTicimax1: "1. Ticimax yönetim panelinize giriş yapın",
            installationInstructionsTicimax2: "2. Tasarım > Tasarım ayarları > Header Footer Tasarımını açın",
            installationInstructionsTicimax3: "3. Logo tasarımı kısmında 'Kaynak'butonunu tıklayın.",
            installationInstructionsTicimax4: "4. HTML kodunun altına yukarıdaki entegrasyon kodunu yapıştırın.",
            installationInstructionsEticaretteyim1: "1. Eticaretteyim yönetim panelinize giriş yapın",
            installationInstructionsEticaretteyim2:
                "2. Eklentiler > HTML Oluştur > Kısmından SUPSIS Adını Verip  Kodu Kopyalamanız Yeterlidir.",
            installationInstructions: "Talimatlar",
            installationVerify: "Web Sitenizin Supsis Kurulumunu Doğrulayın",
            installationVerifyChecking: "Kontrol Ediliyor",
            installationVerifyCheck: "Kontrol Et",
            installationVerifyCheckingStatus: "{website} sitesinin SUPSIS entegrasyon durumu kontrol ediliyor",
            installationCheckingStatusMessageYes: "SUPSIS LIVE {website} sitesine entegre olmuştur.",
            installationCheckingStatusMessageNo: `SUPSIS şu anda {website} sitesine entegre değil.\n Entegrasyon işleminizi şimdi ya da daha sonra tamamlayabilirsiniz.`,

            vtippyPreferredLanguage: "Tercih Edilen Dil ",
        },
        packages: {
            mostPopular: "EN ÇOK TERCİH EDİLEN",
            currency: "₺",
            activePlan: "AKTİF PLAN",
        },
        totalCost: {
            title: "SUPSİS MALİYETİ",
            monthlyPayments: "Aylık Ödemeler",
            currency: "₺",
            currencyMonthly: "₺ / Aylık",
            oneTimePayments: "Tek Seferlik Ödemeler",
            oneTimeDiscount: "Yıllık Paket İndirimi",
            currencyYearly: "₺ / Yıllık",
            totalOneTimeCost: "Toplam İlk Seferde ödenecek Tutar",
            totalTax: "Vergi ( %18 )",
            referenceCode: "Referans Kodunuz var mı?",
            referencePlaceholder: "Lütfen Kodu Giriniz",
            codeButton: "Uygula",
            monthlyCost: "Hesabınızdan Aylık Çekilecek Tutar?",
            oneTimeFullCost: "Tek Seferlik Herşey Dahil Tutar?",
            payment: "Ödemeyi Yap",
        },
        akinon: {
            typeOrSelectSKU: "SKU yazın veya seçin",
            akinonUserId: "Akinon Kullanıcı Id",
            userEmail: "Kullanıcı Email",
            userEmailDesc: "Kullanıcı e-postasını yazın veya seçin...",
            send: "Gönder",
            selectCity: "İlçe Seçin",
            city: "İlçe",
            selectState: "İlinizi Seçin",
            state: "İl",
            useMap: "Haritayı Kullan",
            chooseAddress: "Adres Seç",
            selectCountry: "Ülke Seç",
            country: "Ülke",
            productIdDesc: "Ürün yazın veya seçin...",
            productId: "Ürün Id'si",
            userIdDesc: "Akinon kullanıcı id'si yazın...",
            productSKU: "Ürün SKU'su",
            latitudeDesc: "Hedef konum enlemini yazın veya seçin...",
            longitudeDesc: "Hedef konumun boylamını yazın veya seçin...",
            orderNumber: "Sipariş numaranız",
            orderDesc: "Sipariş numarasını yazın...",
            longitude: "Boylam",
            latitude: "Enlem",
        },
        probel: {
            branchCode: "Branş Kodu",
            branchCodeDesc: "Branş kodunu yazın veya seçin...",
            hospitalBranchCode: "Şube Kodu",
            hospitalBranchCodeDesc: "Şube kodunu yazın veya seçin...",
            clinicCode: "Poliklinik Kodu",
            clinicCodeDesc: "Poliklinik kodunu yazın veya seçin...",
            date: "Randevu Tarihi",
            dateDesc: "Randevu tarihini girin veya seçin...",
            patientToken: "Hasta Token",
            patientTokenDesc: "Hasta tokenini yazın veya seçin...",
            appointmentId: "Randevu Id",
            appointmentIdDesc: "Randevu id'sini yazın veya seçin...",
            identityType: "Kimlik Türü",
            identityNumber: "Kimlik Numarası",
            name: "Hasta Adı",
            surname: "Hasta Soyadı",
            gender: "Hasta Cinsiyet",
            birthDay: "Hasta Doğum Tarihi",
            phoneNumber: "Hasta Telefon Numarası",
            identityTypeDesc: "Kimlik türünü yazın veya seçin...",
            identityNumberDesc: "Kimlik numarasını yazın veya seçin...",
            nameDesc: "Hasta adını yazın veya seçin...",
            surnameDesc: "Hasta soyadını yazın veya seçin...",
            genderDesc: "Hasta cinsiyetini yazın veya seçin...",
            birthDayDesc: "Hasta doğum tarihini yazın veya seçin...",
            phoneNumberDesc: "Hasta telefon numarasını yazın veya seçin...",
        },
        headBar: {
            email: "E-mail",
            phone: "Telefon",
            name: "Ad",
            date: "Tarih",
            subject: "Konu",
            situation: "Durum",
            representative: "Temsilci",
            transactions: "İşlemler",
        },
        login: {
            loginTitle1: "SUPSIS'e",
            loginTitle2: "Hoşgeldiniz",
            email: "Email Adresiniz",
            emailPlaceholder: "Lütfen e-posta adresinizi giriniz.",
            emailError: "Lütfen Geçerli E-posta Giriniz",
            password: "Şifreniz",
            passwordLogin: "Şifresiz Giriş",
            passwordAndLogin: "Şifre ile Giriş Yap",
            passwordNew: "Şifremi Yenile",
            loginAnd: "Veya",
            passwordPlaceholder: "Lütfen şifrenizi giriniz.",
            loginMemory: "Bu cihazı hatırla",
            passwordForget: "Şifremi unutum",
            passwordNewAgain: "Yeni Şifre",
            passwordNewAgainTwo: "Yeni Şifre Tekrarı",
            passwordNewAgainPlaceholder: "Lütfen yeni şifrenizi giriniz.",
            passwordNewAgainPlaceholderTwo: "Lütfen yeni şifre tekrarınızı giriniz.",
            login: "Giriş Yap",
            loginFooter: "Veya, E-Posta ile Giriş Yap",
            emailLogin: "E-Posta ile Giriş yap",
        },
        settings: {
            auditlogs: "Denetim Logları",
            myaccount: "Hesabım",
            notifications: "Bildirimler",
            company: "Şirket",
            features: "Özellikler",
            general: "Genel",
            chat: "Sohbet",
            timings: "Süre Ayarları",
            language: "Dil",
            wallet: "Cüzdan",
            "bubble-settings": "Sohbet Balonu Ayarları",
            "bubble-actions": "Sohbet Balonu Özellikleri",
            "theme-settings": "Sohbet Teması Ayarları",
            visitorLoginForm: "Ziyaretçi Giriş Formu",
            visitorAttribute: "Ziyaretçi Profil Bilgileri",
            timing_settings: "Süre Ayarları",
            auto_assign: "Otomatik Chat Atama",
            availability: "Temsilci Çalışma Saatleri",
            "website-integration": "Web Sitesi Entegrasyonu",
            General: "Genel",
            Chat: "Sohbet",
            Timings: "Süre Ayarları",
            Integration: "Entegrasyon",
            developer: "Geliştirici",
            ıntegration: "Entegrasyon",
            visitorNew: "Yeni Ziyaretçi Tasarıma Geçiş",
            companySubtitles: "Şirketinizin genel bilgilerini yönetin.",
            featuresSubtitles: "Supsis'in akıllı özelliklerini yönetin.",
            languageSubtitles: "Şirketinizin tercih ettiği dili yönetin.",
            bubbleSettings: "Sohbet Balonu Ayarları",
            bubbleSettingsSubtitles: "Sohbet balonu ayarlarınızı yönetin.",
            bubbleActionsSubtitles:
                "Sohbet balonu özelliklerinizi genişletin. Firmanıza ait whatsapp ,mail ,telefon bilgilerini ziyaretçilerinizle paylaşabilirsiniz.",
            chatThemeSettingsSubtitles: "Sohbet teması ayarlarınızı yönetin.",
            visitorLoginFormSubtitles: "Ziyaretçi giriş formu ayarlarınızı yönetin.",
            chatTimingSettingsSubtitles: "Chat Süre Ayarları - Konuşma Süresi Kontrolleri ve Seçenekleri.",
            webSiteIntegrationSubtitles: "Web sitenize sohbet balonu ekleyin.",
            apiAccessTitle: "API Erişimi",
            apiAccessSubtitles: "Token kodunuza burdan ulaşabilirsiniz.",
            youTubeActionForm: "Youtube Kanalınızı Ekleyin",
            linkedinActionForm: "Linkedin Hesabınızı Ekleyin",
            telegramActionForm: "Telegram Hesabını Ekleyin",
            facebookActionForm: "Facebook Sayfanızı Ekleyin",
            tiwitterActionForm: "Twitter Sayfanızı Ekleyin",
            instagramActionForm: "Instagram Sayfanızı Ekleyin",
            liveSupportDescription: "Müşterilerinizle canlı bir sohbet açın",
            ticketDescription: "Müşterilerinizle canlı bir sohbet açın",
            whatsappDescription: "Müşterileriniz WhatsApp ile size ulaşsın",
            phoneDescription: "Müşterileriniz telefon ile size ulaşsın",
            emailDescription: "Müşterileriniz e-posta ile size ulaşsın",
            facebookDescription: "Müşterileriniz Facebook ile size ulaşsın",
            twitterDescription: "Müşterileriniz Twitter ile size ulaşsın",
            instagramDescription: "Müşterileriniz Instagram ile size ulaşsın",
            youtubeDescription: "Müşterileriniz Youtube ile size ulaşsın",
            linkedinDescription: "Müşterileriniz Linkedin ile size Ulaşsın",
            telegramDescription: "Müşterileriniz Telegram ile size Ulaşsın",
            whatsappModalTitle: "Whatsapp İşlem Formu",
            whatsappModalDescription: "Whatsapp hesabınızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            phoneModalTitle: "Telefon İşlem Formu",
            phoneModalDescription: "Telefon numaranızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            emailModalTitle: "E-Posta İşlem Formu",
            emailModalDescription: "E-posta hesabınızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            facebookModalTitle: "Facebook İşlem Formu",
            facebookModalDescription: "Facebook hesabınızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            twitterModalTitle: "Twitter İşlem Formu",
            twitterModalDescription: "Twitter hesabınızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            instagramModalTitle: "Instagram İşlem Formu",
            instagramModalDescription: "Instagram hesabınızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            youtubeModalTitle: "Youtube İşlem Formu",
            youtubeModalDescription: "Youtube hesabınızı bağlamak için lütfen aşağıdaki formu doldurunuz.",
            linkedinModalTitle: "LinkeIn İşlem Formu",
            linkedinModalDescription: "LinkedIn hesabını bağlama için lütfen aşşağıdaki formu doldurunuz",
            telegramModalTitle: "Telegram İşlem Formu",
            telegramModalDescription:
                "Telegram Hesabınızı bağlama için aşağıdaki forma Telegram profil linkini yazınız",
            instagramAlertTitle: "Instagram Entegrasyonu Gerekli",
            instagramAlertDesc:
                "Üzgünüz, ziyaret ettiğiniz sayfa, Instagram'ınızı entegre ettiğinizde etkinleştirilecektir.",
            instagramActivateText: "Haydi, Instagram'ı Entegre Et",
            remove: "Kaldır",
            edit: "Düzenle",
            connected: "Bağlı",
            add: "Ekle",
            themeDescription: "Sohbet Tema  Ayarları.",
            fontDescription: "Sohbet Yazı Tipi Ayarları.",
            emailTitle: "E-Posta Adresinizi Giriniz",
            emailMessage: "E-posta İlk Gönderim Mesajı",
            isFabsAsIcon: "Menü İkon Yazılarını Göster.",
            chatBubbleTextSetting: "Chat Balonu Yazı Ayarı",
            textOnChatBubble: "Chat Balonu üzerinde gözükecek metin ayarlarını yapabilirsiniz.",
            textToAppearOnChatBubble: "Chat Balonu üzerinde Gözükecek Metin",
            newVisitorProfileInformation: "Yeni Ziyaretçi Profil Bilgisi",
            newVisitorProfileInformationDescription: "Ziyaretçi profil bilgisine yeni değer ekler",
            create: "Oluştur",
            newAdd: "Yeni Ekle",
            toInform: "Bilgilendirme",
            toInformDescription: "Bu sayfada eklediğiniz değerleri ziyaretci giriş formu ile eşleştirebilirsiniz.",
            showVisitor: "Ziyaretçiyi Göster",
            label: "Etiket",
            text: "Yazı",
            email: "E-posta",
            phone: "Telefon",
            number: "Sayı",
            url: "URL",
            date: "Zaman",
            dropdown: "Seçilebilir",
            languageTimeZone: "Dil & Bölge",
            timeZoneTitle: "Bölge & Saat Dilimi",
            timeZoneDescription: "Bölge ve saat dilimi ayarları",
        },
        userInfoWidget: {
            userInformation: "Kullanıcı Bilgileri",
            fullName: "Adı Soyadı",
            newValue: "Yeni Değer",
            newProfileInfo: "Yeni Profil Bilgisi",
            affiliatedRepresentatives: "Temsilciler",
            preferredAgents: "Tercih Edilen Temsilciler",
            labels: "Etiketler",
            agentNotes: "Temsilci Notları",
            newNote: "Yeni Not",
            note: "Not",
            available: "adet not mevcut.",
            systemInformation: "Sistem Bilgileri",
            speechID: "Konuşma Kimliği",
            customerVersion: "Müşteri Version",
            IPAddress: "IP Adresi",
            pageVisited: "Ziyaret Edilen Sayfa",
            systemAndBrowser: "İşletim Sistemi & Tarayıcı",
            countryAndLanguage: "Ülke & Dil",
            clickToEdit: "Düzenlemek Yazının içine tıklayın",
            adsYouAreInterestedIn: "İlgilendiği Reklamlar",
            detail: "Detay",
            adsTitle: "Başlık",
            adUrl: "Reklam Url",
            sourceID: "Kaynak ID",
            resourceType: "Kaynak Türü",
            adsBody: "İçerik",
            adsCreateDate: "Oluşturma Tarihi",
            adsUpdateDate: "Güncellenme Tarihi",
        },
        newWizartV2: {
            generalSettings: "Genel Ayarlar",
            themeSettings: "Tema Ayarları",
            representativeWorkingHours: "Temsilci Çalışma Saatleri",
            preview: "Önizleme",
            setup: "Kurulum",
            formStepTitle: "Deneyiminizi kişiselleştirebilmemiz için bize daha fazla bilgi verin",
            supsisEntergation: "Supsis'i Hangi Websitenizde kullanacaksınız? :",
            goToNextStep: "Bir Sonraki Adıma Geç",
            readytemplate: "Hazır Renk Şablonu Kullan",
            customSettings: "Özel Ayarlar",
            customerMessageView: "Müşteri mesaj Görünümü",
            backcgroundColor: "Arka Plan Rengi",
            textColor: "Yazı Rengi",
            agentMessageView: "Temsilci Mesaj Görünümü",
            workingHours: "Ziyaretçilerine hangi zaman aralıklarında hizmet sağlarsınız?",
            continuousService: "Sürekli Hizmet",
            continuousServiceDescription: "Chat balonu her zaman aktif olur. Siz sistemde olmasanız bile.",
            vote: "Seçimini Yap",
            representativeWorking: "Temsilci Çalışma Saatleri Dahilinde",
            representativeWorkingDescription:
                "En az 1 temsilci çevrimçi olduğunda sohbet çevrimiçi görünür. Çevrimiçi temsilci yoksa offline olarak görünür.",
            computer: "Bilgisayar",
            tablet: "Tablet",
            uploadTrackingCodeToYourWebsite: "Entegrasyon Kodunu Web Sitenize Yükleyin",
            password: "Set New Password",
        },
        whatsappChannel: {
            whatsappTitleV1: "Whatsapp V1 Kanalları (QR)",
            whatsappTitleV2: "Whatsapp V2 Kanalları (QR)",
            channelName: "Kanal",
            phoneNummer: "Telefon Numarası",
            forwardToChatbot: "Chatbot'a ilet",
            forwardingChatbotOrLiveAgent: "Yönlendirme (Chatbot veya Live Agent)",
            addChannel: "Kanal Ekle",
            newWhatsappChannel: "Yeni Whatsapp Kanalı",
            newWhatsappChannelDescription: "QR Kodunu tarayarak yeni bir whatsapp kanalı oluşturun",
            editWhatsappChannel: "Whatsapp Kanalını Düzenleyin",
            editWhatsappChannelDescription: "Whatsapp kanalını düzenleme",
            whatsappChannel: "Whatsapp Kanalı",
            deleteWhatsappChannelDescription: "Bu kanalı silmek istediğinizden emin misiniz?",
            whatsappIntegration: "Whatsapp Entegrasyonu",
            deleteChannel: "Kanalı Sil",
            restartChannel: "Kanalı Yeniden Başlat",
            wantRestartChannel: "Kanalı yeniden başlatmak istiyor musun?",
            deleteSMSChannelDescription: "SMS kanalını silmek istediğinizden emin misiniz?",
            smsChannel: "SMS Kanalı",
            maxChannelCount: "Birden Fazla SMS Kanalı Oluşturamazsınız !",
            smsModalText:
                "Modern iletişim çözümleriyle entegre olmamız, size kolay ve etkili bir şekilde SMS gönderme imkanı sunuyor. İletişimde sınırları kaldırın, müşterilerinizle doğrudan bağlantı kurun!",
            smsModalBtn: "Sms Kanalı Açmak İçin Tıklayınız...",
            postaCellDetail: "PostaCell Kanal Detayı",
        },
        noPermission: "Bu işlemi gerçekleştirmek için yetkiniz yok. Yöneticinizle görüşün.",
        mail_integration_detail: {
            title: "Mail Detay",
            integration: "Entegrasyon",
            sender: "Sender Mail",
            signature: "İmza",
            inbox: "Inbox",
            medias: "Medya",
            visibility: "Görünürlük",
            settings_group: "Ayarlar",
            contacts: "Kişiler",
        },
        whatsapp_business_api: {
            title: "Whatsapp Business API Kanalları",
            integration: "Entegrasyon",
            detail: "Detay",
            visibility: "Görünürlük",
            templates: "Tüm Şablon Mesajlar",
            settings_group: "Ayar",
            template_message_group: "Şablon Mesajları",
            new_template: "Yeni Şablon Oluştur",
            broadcast_group: "Toplu Mesaj",
            broadcast_requests: "Toplu Mesaj Gönderimleri",
            customer_groups: "Müşteri Grupları",
            chat_initiator_template: "Chat Başlatma Şablonu",
            daily_usages: "Günlük Kullanımlar",
            reports: "Raporlar",
            contacts: "Kişiler",
            numbers: "Numaralar",
            all_contacts: "Tüm Kişiler",
            businessChannelDetail: "Whatsapp Business Kanal Detayı",
            wallet: "Cüzdan",
            postacellMessage: "SMS Gönder",
            postacellAllMessage: "Toplu SMS Gönder",
            message_group: "Mesaj",
            createNewTemplate: "Yeni şablon mesaj oluştur",
            templateName: "Şablon adı",
            templateNameDesc: "Mesaj şablonunuza bir isim verin.",
            templateInfo: "Şablon Bilgileri",
            viewTemplates: "Şablonları gör",
            templateNameRules: "Şablon adı sadece küçük harf, sayı ve alt çizgi içerebilir.",
            category: "Kategori",
            categoryDesc: "Ne tür bir şablon oluşturmak istediğinizi seçin",
            categoryUtility: "Yardımcı",
            categoryUtilityDesc:
                "Hesap güncellemeleri, sipariş güncellemeleri, uyarılar ve daha fazlası gibi yardımcı bilgiler gönderin.",
            categoryMarketing: "Pazarlama",
            categoryMarketingDesc:
                "Farkındalığı ve etkileşimi artırmak için promosyon teklifleri, ürün teklifleri ve daha fazlasını gönderin.",
            categoryAuth: "Doğrulama",
            categoryAuthDesc: "Müşterilerinizin hesaplarına erişmesi için kodlar gönderin.",
            optional: "Tercihen",
            languageDesc: "Şablon mesajınızın hangi dilde gönderileceğini seçin",
            header: "Başlık",
            headerRules: "Mesajınıza 60 karakterlik bir başlık ekleyin. Başlıkta yalnızca bir değişken desteklenir.",
            headerOptionMedia: "Medya",
            headerOptionText: "Metin",
            none: "Hiçbiri",
            headerType: "Başlık tipi",
            headerText: "Başlık metni",
            body: "Gövde",
            bodyRules: "Mesajnınız için seçtiğiniz dilde bir metin girin",
            addVariable: "Değişken ekle",
            variables: "Değişkenler",
            variable: "Değişken",
            defaultVariableName: "Varsayılan Değişken Adı",
            defaultVariableToolTip:
                "Değişkeniniz şablonda bu isimle gözükür.<br> Ayrıca aksi durumlarda mesajınızda varsayılan olarak bu değer gönderilir.",
            selectATemplate: "Mesaj Şablonunuzu Seçin",
            variableSettings: "Değişken ayarları",
            example: "Örnek",
            footer: "alt bilgi",
            footerDesc: "Mesajınıza 60 karakterlik bir altbilgi ekleyin. Altbilgide değişkenler desteklenmez.",
            buttons: "Butonlar",
            buttonType: "Buton tipi",
            buttonTypeReply: "Cevapla",
            submit: "Kaydet",
            submitting: "Kaydediliyor",
            addButton: "Buton Ekle",
            rejectWhatsapp: "Whatsapp tarafından reddedildi.",
            approvedWhatsapp: "Whatsapp tarafından kabul edildi.",
            pendingWhatsapp: "Onay Bekliyor",
        },
        multi_whatsapp_api: {
            integration: "Entegrasyon",
            detail: "Detay",
            visibility: "Görünürlük",
            templates: "Tüm Şablon Mesajlar",
            settings_group: "Ayar",
            template_message_group: "Şablon Mesajları",
            new_template: "Yeni Şablon Oluştur",
            broadcast_group: "Toplu Mesaj",
            broadcast_requests: "Toplu Mesaj Gönderimleri",
            customer_groups: "Müşteri Grupları",
            chat_initiator_template: "Chat Başlatma Şablonu",
            contacts: "Kişiler",
            numbers: "Numaralar",
            all_contacts: "Tüm Kişiler",
        },
    },
    en: {
        chatWindow: {
            thereIsNoChatContent: "No chat content available.",
            thereIsNoChatContentDsc: "You can view the chat content and send messages here.",
            interactions: "Interactions:",
            departments: "Departments",
            channels: "Channels",
            date: "Date",
            lastChatStatus: "Last Chat Status",
            all: "All",
            queued: "Queued",
            open: "Open",
            closed: "Closed",
            private: "Private",
            chatbot: "Chatbot",
            lostMissed: "Lost / Missed",
            interaction: "Interaction",
            myActiveInbox: "My Active Inbox",
            activeQueueInbox: "Active + Queue Inbox",
            chatbotActiveInbox: "Chatbot Active Inbox",
            myDepartmentsActiveInbox: "My Departments Active Inbox",
            notInteractedYesterday: "No interactions yesterday",
            queueInbox: "Queue Inbox",
            whatsappActiveInbox: "WhatsApp Active Inbox",
            socialMediaActiveInbox: "Social Media Active Inbox",
            missedThisMonth: "Missed Chats This Month",
            chooseAFileOrDragItHere: "Choose a file or drag it here!",
            watching: "Watching",
            selectFilter: "Select Filter",
            clearAll: "Clear All",
            me: "Me",
            today: "Today",
            yesterday: "Yesterday",
            thisWeek: "This Week",
            lastWeek: "Last Week",
            last7Days: "Last 7 Days",
            last30Days: "Last 30 Days",
            thisMonth: "This Month",
            lastMonth: "Last Month",
            last24h: "Last 24 Hours",
            custom: "Custom",
            startMessage: "Start Message",
            goToAgentReport: "Go to Agent Report",
            agentDetail: "Agent Detail",
            agentList: "Agent List",
            selectedFilter: "Selected Filter",
            groupBy: "Group",
            none: "No Group",
            agent: "Agent",
            department: "Department",
            sortBy: "Sort",
            lastPostAbove: "Last Post Above",
            newChatsAbove: "New Chats Above",
            oldChatsAbove: "Old Chats Above",
            live: "Live",
            systemStatus: "System Status",
            refresh: "Refresh",
            close: "Close",
            totalCustomers: "Total Customers",
            totalAnswered: "Total Answered",
            waitingAnswer: "Waiting Answer",
            totalAgentInChat: "Total Agent In Chat",
            onlineAgentCount: "Online Agent Count",
            totalCustomer: "Total Customer",
            answered: "Answered",
            unanswered: "Unanswered",
            noContactWasFoundMatchingTheCurrentFilters: "No contact was found matching the current filters.",
            you: "You",
            others: "Others",
            queue: "Queue",
            chatbotContact: "Chatbot",
            closedContact: "Closed",
            myInteractions: "Benim Etkileşimlerim",
            special: "Özel",
            allInteractions: "Tüm kişiler",
            waiting: "Wating",
            departmentToWhichItIsAffiliated: "Department to which it is affiliated",
        },
        automation: {
            blocks: {
                START_POINT: "START POINT",
                AI_ASSISTANT: "AI ASSISTANT",
                BOT_RESPONSE: "BOT RESPONSE",
                AI_BOT_RESPONSE: "AI RESPONSE (GPT-4o)",
                AI_CLASSIFICATION: "AI CLASSIFICATION",
                AI_MENU_FLOW: "AI MENU",
                OTP_WHATSAPP_FLOW: "OTP Whatsapp",
                OTP_SMS_FLOW: "OTP SMS",
                OTP_MAIL_FLOW: "OTP MAIL",
                AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
                PLATFORM_FLOW: "PLATFORM",
                DEFAULT_FALLBACK: "DEFAULT FALLBACK",
                DEFAULT_TIMEOUT: "DEFAULT TIMEOUT",
                AI_FUNCTIONS: "AI FUNCTIONS",
                FILTER: "FILTER",
                FLOW: "FLOW",
                ATTACHMENT_INPUT: "ATTACHMENT INPUT",
                USER_INPUT: "USER INPUT",
                GO_TO_STEP: "GO TO STEP",
                WEBHOOK: "WEBHOOK",
                SET_ATTRIBUTE: "SET ATTRIBUTE",
                QUESTION: "QUESTION",
                CLOSE_CHAT: "CLOSE CHAT",
                CREATE_TICKET: "CREATE TICKET",
                TRANSFER_CHAT: "TRANSFER CHAT",
                TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
                TAG_CHAT: "ADD TAG",
                REMOVE_TAG: "REMOVE TAG",
                SET_DEPARTMENT: "SET DEPARTMENT",
                SEND_TRANSCRIPT: "SEND TRANSCRIPT",
                SEND_SMS: "SEND SMS",
                SEND_MAIL: "SMS MAIL",
                CREATE_EVENT: "CREATE EVENT",
                CREATE_RESERVATION: "CREATE RESERVATION",
                RESERVATION_OPEN_URL: "Reservation Open Url",
                RESERVATION_SELECT_DAY: "Select reservation day",
                RESERVATION_EVENT_LIST: "Reservation list visitor",
                RESERVATION_SELECT_TIME: "Select reservation time",
                CREATE_TASK: "CREATE TASK",
                SHOPIFY_SHOW_PRODUCTS: "SHOPIFY SHOW PRODUCTS",
                SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY PRODUCT AVAILABILITY",
                SHOPIFY_ORDER_STATUS: "SHOPIFY ORDER STATUS",
                AKINON_SHOW_PRODUCTS: "AKINON SHOW PRODUCTS",
                AKINON_FIND_PRODUCT: "AKINON FIND PRODUCT",
                AKINON_ORDER_STATUS: "AKINON ORDER STATUS",
                AKINON_SELECT_ORDER: "AKINON SELECT ORDER",
                AKINON_SELECT_SIZE: "AKINON SELECT SIZE",
                AKINON_FIND_NEAREST_STOCK: "SHOW STORE STOCK",
                AKINON_FIND_NEAREST_STORES: "SHOW NEAREST STORES",
                AKINON_SHOW_DISCOUNT_CODES: "SHOW DISCOUNT CODES",
                SUPPRESSION_ADD: "BLOCK CONTACT",
                SUPPRESSION_REMOVE: "UNBLOCK CONTACT",
                IDEASOFT_SELECT_ORDER: "SELECT ORDER",
                IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
                IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",
                SEND_WP_BUSINESS_MESSAGE: "SEND WHATSAPP MESSAGE",
                INSTAGRAM_COMMENT_REPLY: "REPLY COMMENT",
                INSTAGRAM_COMMENT_DELETE: "DELETE COMMENT",
                INSTAGRAM_COMMENT_SHOW: "SHOW COMMENT",
                INSTAGRAM_COMMENT_HIDE: "HIDE COMMENT",
                INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "REPLY AS PRIVATE",
                LOOP: "Loop",
                LOOP_NEXT: "Loop Next Item",
                LOOP_BREAK: "Break Loop",
                LOOP_CONTINUE: "Continue Next Loop",
                LOOP_FINISH: "Finish Loop",
                SLEEP: "Sleep",
                NOOP: "Noop",
                CATCH_WEBHOOK: "Catch Webhook",
                TERMINATE_AUTOMATION: "Terminate Automation",
                CREATE_CONTACT: "Create Contact",
                UPDATE_CONTACT: "Update Contact",
                FIND_CONTACTS: "Find Contacts",
                FIND_CONTACT: "Find Contact",
                FIND_CHATS: "Find Chats",
                FIND_CHAT: "Find Chat",
                WAIT_FOR: "Wait For",
                STRING_FORMAT: "Format String",
                NUMBER_FORMAT: "Format Number",
                DATE_FORMAT: "Format Date",
                RECORDS_FROM_CSV: "Records From CSV",
                MESSAGE_RECEIVED: "Message Received",
            },
        },
        plans: {
            manageWithChatbot: "Manage with Chatbot",
            manageInbox: "Manage Inbox",
            commentManagement: "Manage Comments",
            privateReplyMessage: "Private Reply Comments",
            mentionTicket: "Convert Mentions to Tickets",
            week: "Week",
            readyContents: "Ready Contents",
            webhookIntegration: "Webhook Integration",
            businessChannel: "WhatsApp Business Channel",
            confirmationFeature: "Confirmation Feature",
            specialReporting: "Special Reporting",
            aiAssistant: "AI Assistant",
            flexibleBilling: "Flexible Billing",
            automaticReservation: "Automatic Reservation",
            taskManagement: "Task Management",
            calendarIntegration: "Calendar Integration",
            activeChatbot: "Active Chatbot",
            smsIntegration: "SMS Integration",
            mailIntegration: "Mail Integration",
            startChatWithVisitor: "Start Chat With Visitor",
            whatsappManaging: "Whatsapp Management",
            automaticChatbotButton: "Automatic Button/Chatbot",
            personalizedBroadcasts: "Personalized Broadcasts",
            chatWithNonContacts: "Chat With Non-Contacts",
            broadcastMessaging: "Broadcast Messaging",
            perBroadcast: "Per Broadcast",
            extraPricePerMessage: "Extra Price Per Message",
            smartTrigger: "Smart Trigger",
            telegramIntegration: "Telegram Integration",
            instagramIntegration: "Instagram Integration",
            ticketFeature: "Ticket Feature",
            storage: "Storage",
            onePanelManagement: "One Panel Management",
            isolatedDatabaseConnection: "Isolated Database Connection",
            removeLogo: "Remove Supsis Logo",
            chatBaloonCustomization: "Chat Balloon Customization",
            chatAndNotifications: "Chat and Notifications",
            unlimited: "Unlimited",
            specialCustomerSupport: "Special Customer Support",
            softwareSupport: "Software Support",
            standardSupport: "Standard Support",
            teamChatIntegration: "Team Chat Integration",
            fileAndVoiceShare: "File and Voice Share",
            instantVisitor: "Instant Visitor Tracking",
            detailedReporting: "Detailed Reporting",
            normalreporting: "Normal Reporting",
            noExtraCosts: "No Extra Costs",
            accessibleToAllAgents: "Accessible to All Agents",
            dataSecurity: "Data Security",
            autoTranslate: "Auto Translate",
            chatbotVersionHistory: "Chatbot Version History",
            chatbotStory: "Chatbot Story",
            freeAgent: "Free Agent",
            stableAgentCount: "Stable Agent Count",
            stableChannelCount: "Stable Channel Count",
            chipPlans: "Affordable Plans",
            generalPlan: "General Plan",
            specialPlan: "Special Plan",
            currentPlan: "Current Plan",
            selected: "Selected",
            popular: "Popular",
            trialPkg: "Trial Package",
            support: "24/7 Support",
            flexiblePricing: "Flexible Pricing",
            rightToCancel: "Right to Cancel Anytime",
            unlimitedCBScenario: "Unlimited Chatbot Scenarios",
            freeFirstScenario: "Free First Scenario",
            unlimitedLearn: "Unlimited Chatbot Training",
            allPlatformIntegration: "Integration with All Platforms",
            detailedReports: "Detailed Reports",
            aiSupport: "AI Support",
            creativeAI: "Fast and Realistic AI Chat Assistant",
            unlimitedSession: "Unlimited Sessions Simultaneously",
            assistantFromWebsite: "Creating Assistant from Website",
            assistantFromDoc: "Creating Chatbot from Document",
            mobileApp: "Mobile App",
        },

        messenger: {
            channel: "Messenger Channel",
            manageChannel: "Manage Channel",
            channelDetail: "Channel Detail",
            integrationTitle: "Messenger Integration",
            deleteDesc: "Are you sure you want to delete the Messenger channel?",
            channels: "Messenger Channels",
            connectMessenger: "Connect to Messenger",
            detail: "Detail",
            visibility: "Visibility",
            settings_group: "Settings",
            commentsettings: "Comment Management",
            commentSettingsTitle: "Messenger Comment Management",
            commentSettingsDesc: "Manage your Messenger comments",
        },
        instagram: {
            channel: "Instagram Channel",
            detail: "Detail",
            visibility: "Visibility",
            settings_group: "Settings",
            commentsettings: "Comment Management",
            commentSettingsTitle: "Instagram Comment Management",
            commentSettingsDesc: "Manage your Instagram comments",
            commentSettingsTicket: "Ensures that incoming comments are recorded in the system as tickets.",
            commentSettingsChatbot: "Select which chatbot scenario incoming comments should be directed to.",
            leads: "Leads",
            forms: "Forms",
        },
        calendar: {
            setting: "Settings",
            delete: "Delete",
            cancel: "Cancel",
            save: "Save",
            close: "Close",
            deleteRepeatEvent: "Delete Repeating Event",
            thisEvent: "This Event",
            thisAndOtherEvent: "This and Following Events",
            allEvent: "All Events",
            ok: "OK",
            googleCalendarLink: "Add to Google Calendar",
            yahooCalendarLink: "Add to Yahoo Calendar",
            subject: "Subject",
            visitor: "Visitor",
            allDay: "All Day",
            title: "Title",
            deleteEvent: "Delete Event",
            deleteEvents: "Delete Events",
            deleteEventsSure: "Are you sure you want to delete events associated with this calendar?",
            deleteEventConfirm: "Are you sure you want to delete this event?",
            notEmptyTitle: "Title cannot be empty!",
            tasks: "Tasks",
            googleConnect: "Connect Google Integration",
            googleDisconnect: "Disconnect Google Integration",
            sure: "Are you sure?",
            disconnectGoogleSure: "Are you sure you want to remove the Google connection?",
            yes: "Yes",
            no: "No",
            customRepeat: "Custom Repeat",
            recurrenceFrequency: "Repeat Frequency:",
            repeatDays: "Repeat on these days:",
            never: "Never",
            thisDate: "On This Date:",
            recurrenceCount: "Recurrence Count:",
            end: "End",
            event: "Event",
            calendars: "Calendars",
            newCalendar: "Create New Calendar",
            changeColor: "Change Color",
            addCalendar: "Add Calendar",
            nameCalendar: "Calendar Name",
            description: "Description",
            change: "Change",
            deleteCalendar: "Delete Calendar",
            deleteCalendarSure: "Are you sure you want to delete the calendar?",
            notEmptyCalendarName: "Calendar name cannot be empty",
            myEvents: "My Events",
            everyoneEvents: "All Events",
            haveEvent: " 's events",
            goCalendar: " Go to Calendar",
            goReservation: " Create Reservation",
            agents: " Agents",
            today: "Today",
            month: "Month",
            week: "Week",
            day: "Day",
            list: "List",
        },
        ticimax: {
            segment: "Segment",
            settings_group: "Settings",
            waitDayFromLastSend: "Wait Day Count from Last Sent Message Per Member",
            automationRuleName: "Automation Rule Name",
            time: "Time",
            year: "Year",
            month: "Month",
            dayOfMonth: "Day of Month",
            day: "Day",
            bySecond: "By Second",
            byMinute: "By Minute",
            byHour: "By Hour",
            byWeekNo: "By Week No",
            byYearDay: "By Year Day",
            byMonthDay: "By Month Day",
            byMonth: "By Month",
            december: "December",
            november: "November",
            october: "October",
            september: "September",
            august: "August",
            july: "July",
            june: "June",
            may: "May",
            april: "April",
            march: "March",
            february: "February",
            january: "January",
            byWeekDay: "By WeekDay",
            interval: "Interval",
            seconds: "Seconds",
            minutes: "Minutes",
            hourly: "Hourly",
            daily: "Daily",
            weekly: "Weekly",
            monthly: "Monthly",
            yearly: "Yearly",
            frequency: "Frequency",
            attributes: {
                vip: "VIP",
                segment: "Segment",
                province: "Province",
                country: "Country",
                phone: "Phone",
                email: "Email",
                fullname: "Full Name",
                couponPercent: "Coupon %",
                lastOrderDate: "Last Order",
                firstOrderDate: "First Order",
                county: "County",
                lastSource: "Last Source",
                firstSource: "First Source",
                lastPaymentType: "Last Payment Method",
                firstPaymentType: "First Payment Method",
                maxOrderAmount: "Maximum Order Amount",
                minOrderAmount: "Minimum Order Amount",
                totalOrderAmount: "Total Order Amount",
                totalOrderCount: "Total Order Count",
                usedCouponAmount: "Coupon Amount",
                usedCouponCount: "Coupon Count",
                tookDayFromLastOrder: "Days Since Last Order",
                isCouponUser: "Is Coupon User",
            },
            createAutomation: "Create Automation",
            previous: "Previous",
            createAutomationDesc: "Create and manage your message automations",
            newTicimaxChannel: "New Ticimax Channel",
            connextToTicimaxXml: "Connect to Ticimax XML Service",
            connectTicimax: "Connect to Ticimax",
            examplePreview: "Example Preview",
            completeAutomationRule: "Complete Automation Rule",
            configureMessage: "Configure Message",
            automationTimer: "Automation Timer",
            findTargetMembers: "Find Target Members",
            createAutomationRule: "Create Automation Rule",
            action: "Action",
            status: "Status",
            triggeredUserCount: "Triggered User Count",
            nextScheduled: "Next Scheduled",
            timerRule: "Timer Rule",
            automationRules: "Automation Rules",
            apply: "Apply",
            searchAMember: "Search a Member",
            segmentedMembersDesc: "List and automate your segmented members",
            manageVisibilityDesc: "Manage who can see the channel",
            xmlOrderListURL: "XML Order List URL",
            manageIntegrationDesc: "Manage your Ticimax integration",
            detail: "Detail",
            ticimaxChannelsTitle: "Ticimax Channels",
            ticimaxDetail: "Ticimax Detail",
            settingsGroup: "Settings",
            visibility: "Visibility",
            members: "Members",
            automation: "Automation",
            integrationChannel: "Integration Channel",
            channelUpdated: "Channel updated successfully",
            channelUpdateFailed: "Failed to update channel",
        },
        notification: {
            mobileApp: "Mobile App",
            webPanel: "Web Panel",
            notifications: "Notifications",
            whatsappActions: "Whatsapp Actions",
            chatbotActions: "Chatbot Actions",
            companyActions: "Company Actions",
            crmActions: "SUPSIS CRM ACTIONS",
            basicActions: "Basic Actions",
            notificationSettingsDesc:
                "Choose which notifications you want to receive and where you want to receive them.",
            noNotificationDesc2:
                "Here you will see all notifications related to the jobs, candidates, and talent pools you are following. You can customize notifications by adjusting settings.",
            noNotificationTitle2: "No notifications yet.",
            noNotificationTitle1: "No notifications. Enjoy the silence.",
            adjustSettings: "Adjust settings",
            showAll: "Show all",
            showOnlyUnread: "Show only unread",
            mailWasSent: "Email was sent.",
            mailAdressRemoved: "Email address removed.",
            chatbotPublished: "Version <b>{version}</b> of the chatbot was published by <b>{user}</b>.",
            chatbotDeleted: "<b>{chatbot}</b> chatbot was deleted by <b>{user}</b>.",
            settingsUpdatedWoDetail: "Settings were updated by <b>{user}</b>.",
            noActivityDesc: "There is currently no activity in the system. A few events need to occur",
            noActivityTitle: "No activity yet",
            actionType: "Action Type",
            dateBetween: "Date Between",
            selectActor: "Select User",
            activities: "Activities",
            chatbotCreated: "Chatbot named <b>{chatbot}</b> was created by <b>{user}</b>.",
            taskStageChanged:
                "The stage of task <b>{task}</b> was changed from <b>{oldStage}</b> to <b>{newStage}</b> by <b>{user}</b>.",
            taskCreated: "<b>{task}</b> task was created by <b>{user}</b>.",
            contactPropRemoved: "<b>{prop}</b> visitor property was removed by <b>{user}</b>.",
            contactPropAdded: "<b>{prop}</b> visitor property was added by <b>{user}</b>.",
            userRemoved: "<b>{oldUser}</b> user was removed by <b>{user}</b>.",
            loginFormUpdated: "Visitor login form was updated by <b>{user}</b>.",
            loginFormDeactivated: "User login form was deactivated by <b>{user}</b>.",
            loginFormActivated: "User login form was activated by <b>{user}</b>.",
            invoiceRefunded: "Refund process was made by <b>{user}</b>.",
            paymentMethodAdded: "A new payment method was added by <b>{user}</b>.",
            invoicePaymentFailed: "Invoice payment was not accepted by <b>{user}</b>.",
            invoicePaymentReceived: "Invoice payment received by <b>{user}</b>.",
            planStarted: "<b>{user}</b> User started the subscription for <b>{title}</b> (<b>{altTitle}</b>).",
            planStartedAgent:
                "<b>{user}</b> User started the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{details} Representative</b>).",
            planStartedChatbot:
                "<b>{user}</b> User started the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Session</b>).",
            planStartedWhatsapp:
                "<b>{user}</b> User started the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Whatsapp Channels</b>).",
            planStartedWhatsappApi:
                "<b>{user}</b> User started the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Whatsapp Business Channels</b>).",
            PlanCanceled: "<b>{user}</b> User canceled the subscription for <b>{title}</b> (<b>{altTitle}</b>).",
            planCanceledAgent:
                "<b>{user}</b> User canceled the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{details} Representative</b>).",
            planCanceledChatbot:
                "<b>{user}</b> User canceled the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Session</b>).",
            planCanceledWhatsapp:
                "<b>{user}</b> User canceled the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Whatsapp Channels</b>).",
            planCanceledWhatsappApi:
                "<b>{user}</b> User canceled the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Whatsapp Business Channels</b>).",
            invoiceCreated: "Invoice was created by <b>{user}</b>.",
            billingAddressUpdated: "Address information was updated by <b>{user}</b>.",
            taskWorkflowDeleted: "Workflow <b>{workflow}</b> was deleted by <b>{user}</b>.",
            whatsappBroadcastFailed: "Sending of broadcast message titled <b>{title}</b> failed.",
            whatsappBroadcastCancelled: "Sending of broadcast message titled <b>{title}</b> has been cancelled.",
            whatsappBroadcastCompleted:
                "A broadcast message titled <b>{title}</b> has been successfully sent to <b>{numbers}</b> recipients.",
            whatsappBroadcastCreated:
                "A broadcast message titled <b>{title}</b> has been sent to <b>{numbers}</b> recipients by <b>{user}</b>.",
            ticketAssigned: "A ticket has been assigned to <b>{user2}</b> by <b>{user1}</b>.",
            userLoggedIn: "<b>{user}</b> logged into SUPSIS.",
            chatJoined: "<b>{agent}</b> joined the chat with <b>{visitor}</b>.",
            chatForwarded: "Chat with <b>{visitor}</b> was forwarded to <b>{agent}</b> by <b>{user}</b>.",
            chatAssigned: "Chat with <b>{visitor}</b> was assigned to <b>{agent}</b> by the system.",
            customerGroupUpdated: "The group named <b>{group}</b> was updated by <b>{user}</b>.",
            customerGroupRemoved: "The group named <b>{group}</b> was removed by <b>{user}</b>.",
            customerGroupAdded: "The group named <b>{group}</b> was created by <b>{user}</b>.",
            contentRemoved: "Ready content <b>{content}</b> was removed by <b>{user}</b>.",
            contentAdded: "Ready content <b>{content}</b> was added by <b>{user}</b>.",
            channelVisibilityChanged:
                "Visibility of integration channel <b>{channel}</b> was changed by <b>{user}</b>.",
            taskDeleted: "<b>{task}</b> task was deleted by <b>{user}</b>.",
            userRemovedToDepartment:
                "<b>{user2}</b> user removed from <b>{department}</b> department by <b>{user1}</b>.",
            userAddedToDepartment: "<b>{user2}</b> user added to <b>{department}</b> department by <b>{user1}</b>.",
            mailAddressAdded: "<b>{email}</b> email address added by <b>{user}</b>",
            settingUpdate: "Updated by <b>{user}</b>:",
            taskWFlowCreated: "<b>{Wflow}</b> task workflow created by <b>{user}</b>.",
            bannedWordRemoved: "<b>{bWord}</b> banned word removed by <b>{user}</b>.",
            bannedWordCreated: "<b>{bWord}</b> banned word created by <b>{user}</b>.",
            welcomeMessageRemoved: "<b>{welcome}</b> welcome message removed by <b>{user}</b>.",
            welcomeMessageAdded: "<b>{welcome}</b> welcome message created by <b>{user}</b>.",
            tagRemoved: "<b>{tag}</b> tag removed by <b>{user}</b>.",
            tagAdded: "<b>{tag}</b> tag added by <b>{user}</b>.",
            roleRemoved: "<b>{role}</b> role removed by <b>{user}</b>.",
            roleAdded: "<b>{role}</b> role added by <b>{user}</b>.",
            departmentRemoved: "<b>{department}</b> department removed by <b>{user}</b>.",
            departmentAdded: "<b>{department}</b> department added by <b>{user}</b>.",
            triggerUpdated: "A trigger updated by <b>{user}</b>.",
            triggerRemoved: "A trigger removed by <b>{user}</b>.",
            triggerAdded: "A new trigger created by <b>{user}</b>.",
            webhookRemoved: "The webhook belonging to <b>{user1}</b> was removed by <b>{user2}</b>",
            webhookAdded: "<b>{user1}</b> added the webhook, which was added by <b>{user2}</b>",
            chatClosed: "Chat with <b>{visitor}</b> was ended by <b>{agent}</b>.",
            chatOpenedByAgent: "<b>{agent}</b> initiated a <b>{platform}</b> chat with <b>{visitor}</b>.",
            chatOpenedByVisitor: "A <b>{platform}</b> chat was initiated by <b>{visitor}</b>.",
            channelRemoved: "<b>{channel}</b> channel was removed by <b>{agent}</b>.",
            userAdded: "<b>{agent}</b> created a representative named <b>{newAgent}</b>.",
            visitorUnblocked: "<b>{visitor}</b> visitor unblocked by <b>{agent}</b> user.",
            visitorBlocked: "Visitor <b>{visitor}</b> blocked by <b>{agent}</b>.",
            userStatusChanged: "User <b>{name}</b> changed status from <b>{oldStatus}</b> to <b>{newStatus}</b>.",
            channelCreated: "<b>{channel}</b> channel created by <b>{name}</b>.",
            reservationCreatedPlan:
                "<b>{name}</b> User scheduled the appointment named <b>{title}</b> for <b>{date}</b>.",
            reservationUpdatedPlan: "<b>{name}</b> User updated the appointment named <b>{title}</b>.",
            reservationDeletedPlan: "<b>{name}</b> User deleted the appointment named <b>{title}</b>.",
            reservationCreated: "<b>{name}</b> User and <b>{visitor}</b> Visitor with reservation date <b>{date}</b>.",
            reservationDeleted:
                "Appointment scheduled between <b>{name}</b> User and <b>{visitor}</b> Visitor on <b>{date}</b> has been canceled.",
            chatAssignedMe: "When a chat is assigned to me",
            ticketAssignedMe: "When a ticket is assigned to me",
            taskAssignedMe: "When a task is assigned to me",
            myChatClosed: "When chat that I own is closed",
            tagActionsToVisitor: "Tags added or removed from a contact",
            ticketCreated:
                "Ticket is created by visitor or chatbot. Also, when a send offline message is sent from the chat widget",
            notesActions: "A note was added or removed from a customer.",
            visitorProfileUpdated: "Visitor profile updated",
            chatStartedByAnyPlatform: "Chat is started on any platform by contact or agent",
            userActions: "User is created, updated or deleted",
            departmentActions: "Department is created, updated or deleted",
            settingsActions: "Settings are created, updated or deleted",
            integrationsActions: "Integration channel is created, updated or deleted",
            loginFormActions: "Login form is updated or activated or deactivated",
            bannedWordActions: "Banned word is created, updated or deleted",
            emailActions: "Email account is created or deleted",
            preparedContentActions: "Prepared content is created or deleted",
            roleActions: "Role is created, updated or deleted",
            tagActions: "Tag is created, updated or deleted",
            welcomeMessageActions: "Welcome message is created, updated or deleted",
            webhookActions: "Webhook is created, updated or deleted",
            billingEvents: "Billing Events",
            taskWorkflowCrud: "Task workflow is created, updated or deleted",
            taskCrud: "Task is created, updated or deleted",
            systemStatus: "System online or offline status changes",
            chatbotStoryCrud: "Chatbot story is created, updated or deleted",
            chatbotForwardAgent: "Chatbot forwards a chat to agent",
            userSegmentCrud: "User segment is created, updated or deleted",
            chatbotCreditLow: "When chatbot credit is low",
            wpCreditLow: "When Whatsapp credit is low",
            wpCustomerGroupCrud: "When Whatsapp customer group is created, updated or deleted",
            wpBroadcastMessageStatus: "When Whatsapp broadcast message is sent, completed or cancelled",
            wpTemplateMesssageCrud: "When Whatsapp template message is created, updated or deleted",
            reservationMessageCrud: "Reservation Created, Updated, Canceled",
        },
        search: {
            prefix: {
                jump: "Jump",
                new: "New",
                visitor: "Visitor",
                dm: "DM",
            },
            calendar: "Calendar",
            soundSettings: "Sound Notifications",
            allNotifications: "All Notifications",
            allActivities: "All Activities",
            workFlow: "Work Flow",
            editTask: "Edit Task",
            tasks: "Tasks",
            todo: "To-Do",
            tapTo: "Press ⇥ for '{prefix}' operations",
            newUsers: "New ⇥ Users",
            newTags: "New ⇥ Tags",
            newRole: "New ⇥ Role",
            newTrigger: "New ⇥ Triggers",
            newDepartment: "New ⇥ Department",
            newTicket: "New ⇥ Ticket",
            jumpSettings: "Jump ⇥ Settings",
            jumpIntegrations: "Jump ⇥ Integrations",
            jumpTeam: "Jump ⇥ Team",
            jumpUsers: "Jump ⇥ Users",
            jumpReport: "Jump ⇥ Report",
            timingSettings: "Timing Settings",
            exampleVisitorMail: "visitor@mail.com",
            languageAndRegion: "Language and Region",
            theme: "Theme",
            appearance: "Appearance",
            color: "Color - Colour",
            background: "Background",
            smart: "Smart",
            teamChat: "Team Chat",
            chatbot: "ChatBot",
            chatbotTraining: "Chatbot Training",
            chatbotUserSegments: "Chatbot User Segments",
            chatbotIntegration: "Chatbot Integrations",
            chatbotEntities: "Chatbot Entities",
            chatbotIntegrationWebHook: "Chatbot Integrations Webhook",
            chatbotArchive: "Chatbot Archive",
            chatbotTemplatesAI: "Chatbot Templates AI",
            chatbotTemplates: "Chatbot Templates",
            chatbotReportsOverall: "Chatbot Reports Overall",
            chatbotReportsAllChats: "Chatbot Reports All Chats",
            chatbotReportsRatingDistribution: "Chatbot Reports Rating Distribution",
            chatbotReportsPaidChats: "Chatbot Reports Paid Chats",
            chatbotReportsBusiestPeriod: "Chatbot Reports Busiest Period",
            chatbotTemplatesAllMessages: "Chatbot Templates All Messages",
            chatbotTemplatesAvarage: "Chatbot Templates Avarage",
            chatbotTemplatesPopularity: "Chatbot Templates Popularity",
            chatbotTemplatesAllUser: "Chatbot Templates All User",

            ticket: "Ticket",
            archives: "Archives",
            tags: "Tags",
            offlineSupportRequests: "Offline Support Requests",
            roles: "Roles",
            users: "Users",
            subjects: "Subjects",
            contents: "Contents",
            welcomeMessages: "Welcome Messages",
            catalog: "Catalog",
            bannedWords: "Banned Words",
            bannedVisitors: "Banned Visitors",
            application: "Application",
            mails: "Mails",
            visitors: "Visitors",
            integrationsWebhook: "Integrations Webhook",
            billing: "Billing",
            reportNew: "Report New",
            integrations: "Integrations",
            chatbotStory: "Chatbot Story",
            searchPlaceHolder: "Search, Jump to or Add...",
            searchAreaTitle: "Search in Supsis",
            searchAreaDesc1: "Search for anything. Just say",
            searchAreaDesc2: "or",
            searchAreaDesc3: "or search anything",
            navigateBtn: "Navigate",
            selectBtn: "Select",
            cancelBtn: "Cancel",
            integration: {
                wpBusinessAPI: "Integrations - Whatsapp Business API Channels",
                wpV1: "Integrations - Multi Whatsapp Channels",
                instagram: "Integrations - Instagram",
                instagramContactList: "Integrations - Instagram Contact List",
                mail: "Integrations - Mail",
                whatsapp: "Integrations - Whatsapp",
                whatsappContactList: "Integrations - Whatsapp Contact List",
                wpBCRequests: "Integrations - Whatsapp Broadcast Requests",
                wpBCCustomerGroups: "Integrations - Whatsapp Broadcast Customer Groups",
                wpBCTemplates: "Integrations - Whatsapp Broadcast Message Templates",
                chatbot: "Integrations - ChatBot",
            },
            settings: {
                settings: "Settings",
                features: "Settings - Features",
                languageAndRegion: "Settings - Language and Region",
                bubbleSettings: "Settings - Bubble Settings",
                bubbleActions: "Settings - Bubble Actions",
                themeSettings: "Settings - Theme Settings",
                visitorLoginForm: "Settings - Visitor Login Form",
                visitorAttribute: "Settings - Visitor Attributes",
                autoAssign: "Settings - Auto Assign",
                chatTimingSettings: "Settings - Chat Timing Settings",
                availability: "Settings - Availability",
                websiteIntegration: "Settings - Website Integration",
                developer: "Settings - Developer",
            },
        },
        mail: {
            deleteMailDesc: "This action cannot be undone.",
            deleteMailTitle: "Are you sure you want to delete this email address?",
            gmailForwardMail: "Gmail Mail Forwarding",
            senderMailAddressDesc: "Please Enter Sender Mail Address",
            verified: "Verified",
            notForwarded: "Not Forwarded",
            notVerified: "Not Verified",
            default: "Default",
            isVerified: "Verified",
            forwarding: "Forwarding",
            mailAdress: "Mail Address",
            addSenderAddress: "Add Sender Address",
            outlookForward: "Microsoft (Outlook/Exchange) Forward",
            gmailForward: "Google (Gmail) Forward",
            senderMail: "Sender Mail",
            mailDetail: "Mail Detail",
            mailNotFound: "Mail not found",
            mailSelecting: "Selecting Mail",
            newMail: "New Email",
            myMails: "My Emails",
            inbox: "Inbox",
            sent: "Sent",
            departmentMails: "Department Emails",
            newTemplate: "New Template",
            unread: "Unread",
            unreply: "Unanswered",
            reply: "Reply",
            attachments: "Mail Attachments",
            To: "To",
            From: "From",
            FromName: "From Name",
            placeHolders: "Placeholders",
            attacheFiles: "Attach Files",
            replyAll: "Reply All",
            forward: "Forward",
            deleteThread: "Delete Thread",
            markAsRead: "Mark as Read",
            markAsAllRead: "Mark All as Read",
            emailEditor: "Email Editor",
            integrateYourMail: "Integrate Your Email",
            connect: "Connect",
            departmentMail: "Department Email",
            createMailAddress: "Create Email Address",
            createNewMail: "Create New Email",
        },
        visitor: {
            mail: "Mail",
            visitorDetail: "Visitor Details",
            selectedUser: "{selectedUser} out of {totalUsers} users selected",
            uncheck: "Uncheck All",
            checkAll: "Check All",
            matchedUsers: "{checkedCount} users matched",
            more: "More",
            exportUsers: "Export Selected Users",
            exportAllUsers: "Export All Users",
            addSegment: "Add Segment",
            deleteCheckedUser: "Delete Selected Users",
            deleteAllUser: "Delete All Users",
            matchedFilter: "Match All Filters",
            visitor: "Visitor",
            deleteUser: "Delete User",
            userData: "User Data",
            lastSession: "Last Session",
            notUserData: "No user data found",
            segments: "Segments",
            tags: "Tags",
            addTag: "Add Tag",
            userChats: "User Chats",
            seeAll: "See All",
            confirm: "Confirm",
            manageSegments: "Manage Segments",
            search: "Search",
            manageTags: "Manage Tags",
            allAttributes: "View All Attributes",
            noData: "No data",
            noEmail: "No email",
            noIpAddress: "IP address not found.",
            noWpNumber: "Number not found.",
            filterName: "filter name..",
            matchedContacts: "{chechkedCount} contacts matched",
        },
        chatbotv2: {
            selectedStory: "{count} story selected",
            B2Cargo_Actions: "B2Cargo Actions",
            Holiday_Plus_Actions: "Holiday+ Actions",
            Instagram_Actions: "Instagram Actions",
            b2cargo_login_user: "Login User",
            b2cargo_product_status: "Product Status",
            HOLIDAY_PLUS_GET_ROOMS: "LIST ROOMS",
            HOLIDAY_PLUS_GET_HOTELS: "LIST HOTELS",
            suppressionRemoved: "Suppression Removed",
            suppressionAdded: "Suppression Added",
            didntSuppression: "You didn't make any suppression.",
            whatsappIntegrationTitle: "Whatsapp V1 and Whatsapp V2 Integration",
            whatsappApiIntegrationTitle: "Whatsapp Business API Integration",
            ReadyTemplateBadge: "Ready Template",
            readyTemplates: "Ready Templates",
            regex: "Regex",
            regexDescription: "Regex ile herşeyi yakala",
            chatbotLogo: "Chatbot Logo",
            chatbotName: "ChatBot Name",
            allSecnario: "Chatbot Scenario List",
            ChatbotScenarioList: "Chatbot Scenario List",
            Scenario: "Scenario",
            filters: {
                equal: "is equal to",
                not_equal: "isn't equal",
                contain: "contain",
                not_contain: "not contain",
                starts_with: "starts with",
                ends_with: "ends with",
                empty: "is empty",
                non_empty: "non empty",
                longer_than: "longer than",
                shorter_than: "shorter than",
                less_than: "less than",
                less_or_equal: "less or equal",
                greater_than: "greater than",
                greater_or_equal: "greater or equal",
            },
            planRequired: "{integratable} Plan Required",
            noDefaultStoryTitle: "Default Story",
            noDefaultStory: "There is no default story.\n Would you like to make default this story?",
            noMessage: "No Message",
            loading: "Loading",
            loadMore: "Load More",
            hostname: "Host name",
            goToStory: "go to story",
            noResultFound: "No results found",
            checkYourFilterCombination: "Check your filter combination",
            clearYourSearch: "clear your search",
            andTryAgain: "and try again",
            allTemplates: "All Templates",
            allAITemplates: "All AI Templates",
            templatesFromTheIndustry: "Templates from the Industry",
            basicTemplate: "Basic Template",
            proTemplate: "Advanced Template",
            withBot: "& Bot",
            userWithBot: "User & Bot",
            chatDetail: "Chat details",
            allUserDetail: "See all user details",
            sessionData: "Session data",
            supsisChatWidget: "Supsis Chat Widget",
            integratedWith: "Integrated with :   ",
            botStory: "Bot story",
            integration: "Integration",
            Users: "Users",
            user_id: "User ID",
            categories: "Categories",
            worksWith: "Works with",
            importBot: "Import bot",
            keyFeatures: "Key features",
            importing: "importing",
            comingSoon: "Coming Soon",
            pickStory: "Pick a story",
            conversationId: "Conversation ID",
            integrateStoryWithSupsisWidget: "Integrate Supsis Widget With Chatbot Story",
            integrateStoryWithWhatsapp: "Integrate Whatsapp With Chatbot Story",
            integrateStoryWithInstagram: "Integrate Instagram with Chatbot Story",
            selectIntegratingStory: "Select the story that will be integrated",
            install: "Install",
            attr: {
                weekday: "Weekday",
                channelId: "Channel",
                email: "E-mail",
                phone: "Phone",
                language: "Language",
                timezone: "Timezone",
                gender: "Gender",
                country: "Country",
                referrer: "Referrer",
                department: "Department",
                url: "URL",
                ip: "IP",
                last_seen: "Last Seen",
                name: "Name",
                user_id: "User ID",
                message: "Message",
                akinon_brand: "Brand",
                akinon_order_id: "Order Id",
                akinon_product_id: "Product Id",
                akinon_user_id: "User Id",
                akinon_user_name: "User Name",
                akinon_user_email: "User Email",
                akinon_invoice_url: "Invoice Url",
                akinon_order_status: "Order Status",
                akinon_order_price: "Order Price",
                akinon_shipper_name: "Shipper Name",
                akinon_product_size: "Product Size",
                akinon_sku: "Sku",
                akinon_product_url: "Product Url",
                akinon_product_title: "Product Title",
                akinon_product_image: "Product Image",
                akinon_product_stock: "Product Stock",
                akinon_order_date: "Order Date",
                akinon_track_number: "Track Number",
                akinon_track_url: "Track Url",
                akinon_latitude: "Latitude",
                akinon_longitude: "Longitude",

                ideasoft_user_id: "Member Id",
                ideasoft_invoice_url: "Invoice Url",
                ideasoft_order_id: "Order ID",
                ideasoft_order_status: "Order Status",
                ideasoft_order_price: "Order Price",
                ideasoft_shipper_name: "Shipper Name",
                ideasoft_product_size: "Product Size",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Product Url",
                ideasoft_product_title: "Product Title",
                ideasoft_product_image: "Product Image",
                ideasoft_product_stock: "Product Stock",
                ideasoft_order_date: "Order Date",
                ideasoft_track_number: "Track Number",
                ideasoft_track_url: "Track Url",

                offline_mode: "Offline Mode",
                available_agents: "Available Agents",
                platform: "Platform",
                hour: "Hour",
                segments: "Segments",
                tags: "Tags",
                ticket: "Ticket",
                metaReferrals: "Meta Referrals",
                idleUserTime: "User Last Action (Second)",
                ai_class_result: "YZ Sınıf Sonuç",
                meta_comment_id: "Meta Comment ID",
                meta_comment: "Meta Comment",
                meta_post_id: "Meta Post ID",
                b2cargo_companyCode: "Company Code",
                b2cargo_takipNo: "Tracking Number",
                b2cargo_takipseri: "Tracking Serial",
                b2cargo_evrakdurum: "Order Status",
                b2cargo_teslimtar: "Delivery Date",
                b2cargo_gonderen: "Sender Name",
                b2cargo_aliciAdi: "Receiver Name",
                b2cargo_cikisIl: "Province of Departure",
                b2cargo_varisIl: "Province of Arrival",
                b2cargo_teslim: "Product Status",
                b2cargo_urun: "Product Type",
                b2cargo_atfTarih: "Product ATF Date",
                b2cargo_palet: "Product Palette",
                b2cargo_koli: "Product Parcel",
                b2cargo_kg: "Product WEIGHT",
                b2cargo_desi: "Product DESI",
                b2cargo_zimmetno: "Debit No",
                b2cargo_varissube: "Arrival Branch",
                b2cargo_atfDurum: "ATF State",
                holiday_plus_room_id: "Room ID",
                holiday_plus_room_title: "Room Title",
                holiday_plus_room_description: "Room Description",
                holiday_plus_room_size: "Room Size",
                holiday_plus_room_price: "Room Price",
                holiday_plus_room_price_offer: "Room Price Offer",
                holiday_plus_room_discount_price: "Room Discount Price",
                holiday_plus_selected_hotel_id: "Selected Hotel ID",
            },
            storyList: "Story List",
            douYouWannaDeleteItem: "Do you want to delete this item?",
            douYouWannaDeleteWithChildren: "Do you want to delete this item with its children?",
            stories: "Stories",
            templates: "Templates",
            aitemplates: "AI Templates",
            integrations: "Integrations",
            all: "All",
            installed: "Installed",
            installationOK: "Installed",
            uninstall: "Uninstall",
            remainingMessageDesc: "Remaining free messages : ",
            openAISiteRoutingDescStart: "You can click the link ",
            openAISiteRoutingDescEnd: "to get an api key.",
            integrationOK: "Integrated",
            chatWidget: "Supsis Chat Widget",
            artificialIntelligence: "Artificial Intelligence",
            integratePlatform: "Chatbot can be integrated with {integretable}.",
            integrateOpenAIWithChatbot: "Integrate Chat GPT-4o With Chatbot",
            integrateChatBotWithChatGPT3: "Integration of ChatBot With Chat GPT-4o",
            integrateStoryWithTelegram: "Integrate Story With Telegram",
            webhooks: "Webhooks",
            archive: "Archive",
            reports: "Reports",
            uncheckAll: "Uncheck all",
            userSegments: "User Segments",
            addSegment: "Add Segment",
            addToSegment: "Add To Segment",
            removeFromSegment: "Remove From Segment",
            plansVTippyContent:
                "Billing for this package will be done at the beginning of each month, and in case you wish to cancel, your usage will be charged until the beginning of the month and your package will expire.<br><br>The package price is exclusive of VAT.<br><br>Package changes are reflected in the invoice the next day.",
            segmentName: "Segment Name",
            sameSegment: "There is a segment with the same name!",
            usersInSegment: "Users In Segment",
            noUsersAdded: "No users added",
            updateSegment: "Update Segment",
            newSegment: "New Segment",
            selectAll: "Select all",
            queriesSelected: "queries selected",
            noBlocksFound: "No blocks found!",
            userQuery: "User Query",
            date: "Date",
            unmatched: "Unmatched",
            goToChat: "Go to Chat",
            selectStory: "Select Story",
            selectBlock: "Select Block",
            training: "Training",
            trainingAlert:
                "To implement the changes you made on the bot training page, you need to publish the new version of the scenario you modified",
            unmatchedPhrases: "Unmatched Phrases",
            ignored: "Ignored",
            story: "Story",
            timePeriod: "Time Period",
            wholeTimeSpan: "Whole time span",
            selectAStory: "Select a story",
            searchUserQuery: "Search user query",
            time: {
                today: "Today",
                yesterday: "Yesterday",
                last7: "Last 7 Days",
                last30: "Last 30 Days",
                "this-month": "This Month",
                "last-month": "Last Month",
                "last-3-month": "Last 3 Month",
                "this-year": "This Year",
                "last-year": "Last Year",
                custom: "Choose a Different Date",
            },
            emailProvider: "Email provider",
            triggerFromAnywhere: "Trigger from anywhere",
            allIntegrations: "All Integrations",
            integrateYourCBwithChatWidget: "Integrate your chatbot with Chat Widget.",
            integrateYourCBwithChatGpt3: "Chatbot can be integrated with GPT-4o. GPT-4o api key required.",
            integrateYourCBwithWebHook: "Pass chat information between ChatBot and your web services with ease.",
            integrateYourCBwithIntegratable: "Pass chat information between ChatBot and {integratable} with ease.",
            addWebhook: "Add Webhook",
            editWebhook: "Edit Webhook",
            newWebhook: "New Webhook",
            webhookTitle: "Webhook Title",
            webhookUrl: "Webhook Url",
            webhookToken: "Webhook Token",
            webhookUsername: "Webhook Username",
            webhookPassword: "Webhook Password",
            editBlock: "Edit",
            moveBlock: "Move",
            copyBlock: "Copy",
            addFilter: "Add Filter",
            addFilterGroup: "Add Filter Group",
            in: "in",
            and: "and",
            or: "or",
            chatbot: "Chatbot",
            allStories: "All Stories",
            addBot: "Create Bot",
            testBot: "Test Your Bot",
            publish: "Publish",
            editName: "Edit Name",
            search: "Search in your story…",
            typeMoreThan3Char: "Type in at least 3 character",
            expand: "Expand",
            expandAll: "Expand All",
            noMatchingItem: "No matching item",
            hint: "Hint",
            select: "Select",
            navigate: "Navigate",
            dismiss: "Dismiss",
            choseAttribute: "Chose Attribute",
            selectReply: "Select Reply",
            preview: "Preview",
            draft: "Draft",
            lastUpdate: "Last Update",
            published: "Published",
            newStory: "New Story",
            updateStory: "Update Story",
            storyDescription: "Story Description",
            storyTitle: "Story Title",
            deleteSingleBlock: "Delete Single Block",
            deleteWithChildren: "Delete With Children",
            startTestFromHere: "Start Test From Here",
            copyBlockId: "Copy Block Id",
            gotoLiveLink: "Go to Live Link",
            copyBlockIdSuccessfull: "Block Id copied to clipboard",
            collapse: "Collapse",
            collapseAll: "Collapse All",
            snDelay: "{delay} sec delay",
            blockUpdated: "Block Updated",
            addPayload: "Add Payload",
            previewModeCaution:
                "You're now previewing one of your story's versions. You can't save changes in the preview mode!",
            enterText: "Enter text...",
            trackpad: "Trackpad",
            navigation: "Navigation",
            navigationDesc: "Please choose your navigation mode.It is up to you if it will be trackpad or mouse.",
            botSetting: "Bot Setting",
            botSettingDesc:
                "Please set confidence level. This is a percentage between 0 and 100. The level defines correctness of chatbot interprets which are related to user inputs.",
            languageSettingsDesc: "Please make sure that Bot's language which it responses is your preferred language.",
            mouse: "Mouse",
            Interactions: "Interactions",
            Actions: "Actions",
            Supsis_Actions: "Supsis Actions",
            Shopify_Actions: "Shopify Actions",
            Akinon_Actions: "Akinon Actions",
            IdeaSoft_Actions: "Ideasoft Actions",
            START_POINT: "START POINT",
            AI_ASSISTANT: "AI ASSISTANT",
            BOT_RESPONSE: "BOT RESPONSE",
            AI_BOT_RESPONSE: "AI RESPONSE (GPT-4o)",
            AI_CLASSIFICATION: "AI CLASSIFICATION",
            Templates: "Template Blocks",
            AI_MENU_FLOW: "AI MENU",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "DEFAULT FALLBACK",
            DEFAULT_TIMEOUT: "DEFAULT TIMEOUT",
            AI_FUNCTIONS: "AI FUNCTIONS",
            FILTER: "FILTER",
            addNewFilter: "Add new filter",
            FLOW: "FLOW",
            ATTACHMENT_INPUT: "ATTACHMENT INPUT",
            USER_INPUT: "USER INPUT",
            GO_TO_STEP: "GO TO STEP",
            WEBHOOK: "WEBHOOK",
            SET_ATTRIBUTE: "SET ATTRIBUTE",
            QUESTION: "QUESTION",
            CLOSE_CHAT: "CLOSE CHAT",
            CREATE_TICKET: "CREATE TICKET",
            TRANSFER_CHAT: "TRANSFER CHAT",
            TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
            TAG_CHAT: "ADD TAG",
            REMOVE_TAG: "REMOVE TAG",
            SET_DEPARTMENT: "SET DEPARTMENT",
            SEND_TRANSCRIPT: "SEND TRANSCRIPT",
            SEND_SMS: "SEND SMS",
            SEND_MAIL: "SMS MAIL",
            CREATE_EVENT: "CREATE EVENT",
            CREATE_RESERVATION: "CREATE RESERVATION",
            RESERVATION_OPEN_URL: "Reservation Open Url",
            RESERVATION_SELECT_DAY: "Select reservation day",
            RESERVATION_EVENT_LIST: "Reservation list visitor",
            RESERVATION_SELECT_TIME: "Select reservation time",
            CREATE_TASK: "CREATE TASK",
            SHOPIFY_SHOW_PRODUCTS: "SHOPIFY SHOW PRODUCTS",
            SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY PRODUCT AVAILABILITY",
            SHOPIFY_ORDER_STATUS: "SHOPIFY ORDER STATUS",
            AKINON_SHOW_PRODUCTS: "AKINON SHOW PRODUCTS",
            AKINON_FIND_PRODUCT: "AKINON FIND PRODUCT",
            AKINON_ORDER_STATUS: "AKINON ORDER STATUS",
            AKINON_SELECT_ORDER: "AKINON SELECT ORDER",
            AKINON_SELECT_SIZE: "AKINON SELECT SIZE",
            AKINON_FIND_NEAREST_STOCK: "SHOW STORE STOCK",
            AKINON_FIND_NEAREST_STORES: "SHOW NEAREST STORES",
            AKINON_SHOW_DISCOUNT_CODES: "SHOW DISCOUNT CODES",
            SUPPRESSION_ADD: "BLOCK CONTACT",
            SUPPRESSION_REMOVE: "UNBLOCK CONTACT",
            IDEASOFT_SELECT_ORDER: "SELECT ORDER",
            IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
            IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",
            SEND_WP_BUSINESS_MESSAGE: "SEND WHATSAPP MESSAGE",
            INSTAGRAM_COMMENT_REPLY: "REPLY COMMENT",
            INSTAGRAM_COMMENT_DELETE: "DELETE COMMENT",
            INSTAGRAM_COMMENT_SHOW: "SHOW COMMENT",
            INSTAGRAM_COMMENT_HIDE: "HIDE COMMENT",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "REPLY AS PRIVATE",
            followingAttributesFilled: "The following attributes will come filled.",
            GET_LOCATION: "GET LOCATION",
            FALLBACK: "FALLBACK",
            TIMEOUT: "TIMEOUT",
            SUCCESS: "SUCCESS",
            FAILURE: "FAILURE",
            message: "Message",
            condition: "Condition",
            score: "Score",
            equal: "Equal",
            not_equal: "isn't equal",
            contain: "Contain",
            not_contain: "Not contain",
            starts_with: "starts with",
            ends_with: "ends with",
            empty: "empty",
            longer_than: "longer than",
            shorter_than: "shorter than",
            less_than: "less than",
            less_than_equal: "less than equal",
            greater_than: "greater than",
            greater_than_equal: "greater than equal",
            value: "Value",
            failures: "Failures",
            email: "Email",
            name: "Name",
            username: "Username",
            source: "Source",
            language: "Language",
            timezone: "TimeZone",
            region: "Region",
            country: "Country",
            referrer: "Referrer",
            url: "Url",
            ip: "Ip",
            city: "City",
            lastSeen: "Last seen",
            userId: "User ID",
            selectStep: "Select Step",
            keywords: "Keywords",
            userSays: "User Says",
            addKeyword: "Add Keyword",
            addUserMessage: "Add User Message",
            set: "Set",
            to: "To",
            gender: "Gender",
            go_to_failure: "Go to failure",
            go_to_success: "Go to success",
            untilFilled: "Until Filled",
            time1: "Once",
            time2: "2 times",
            time3: "3 times",
            time4: "4 times",
            time5: "5 times",
            any: "Any",
            anytext: "Any Text",
            anytextDescription: "Matches only words + spaces",
            alphanumeric: "Alphanumeric",
            integer: "Integer",
            no: "No",
            number: "Number",
            phone: "Phone",
            yes: "Yes",
            yesNo: "Yes - No",
            anyDescription: "Matches anything that is non-empty.",
            alphanumericDescription: "Matches both letters and numerals",
            integerDescription: "Matches an integer number",
            noDescription: "Matches no synonyms",
            numberDescription: "Matches ordinal and cardinal number",
            phoneDescription: "Matches phone number",
            yesDescription: "Matches yes synonyms",
            yesNoDescription: "Matches yes and no synonyms",
            emailDescription: "Matches e-mail",
            urlDescription: "Matches URL",
            temperature: "Temperature",
            askWhenInvalid: "Ask When Invalid",
            applyFilter: "Apply Filter",
            RANDOM_TEXT: "Random Text",
            QUICK_REPLY: "Quick Reply",
            FILE: "File",
            notificationMessageStartSuccess: "The block ",
            notificationMessageEndSuccess: " has been added",
            notificationMessageStartError: "An error occurred, the block ",
            notificationMessageEndError: " has not been added",
            blockChangedWannaUpdate: "Wanna update changed",
            responses: "Responses",
            TEXT: "Text",
            IMAGE: "Image",
            GALLERY: "Gallery",
            BUTTON: "Button",
            flow: "Flow",
            active: "Active",
            passive: "Passive",
            chooseAttributeType: "Choose Attribute Type",
            imageAttachment: "Image Attachment",
            audioAttachment: "Audio Attachment",
            videoAttachment: "Video Attachment",
            documentAttachment: "Document Attachment",
            anyAttachment: "Any Attachment",
            typeAttributeValue: "Type Attribute Value",
            typeSearchValue: "Type Search Value",
            addAttribute: "Add Attribute",
            addAttributeDescription:
                "The attribute’s name can only contain alphanumeric characters which are letters A-Z, numbers 0-9, dash or underscore.",
            male: "Male",
            USER_DATA: "User Data",
            CUSTOM_ATTRIBUTES: "CUSTOM ATTRIBUTES",
            enterBotResponseHere: "Enter Bot Response Here...",

            addCard: "Add Card",
            addButton: "Add Button",
            typeCardTitle: "Type Card Title",
            typeCardDescription: "Type Card Description",
            dragAndDropBrowse: "Drag And Drop Browse",
            dragAndDropBrowseFile: "Upload File",
            button: "Button",
            enterYourMessage: "Enter Your Message",
            imageView: "Image View",
            imageUploading: "Image Uploading",
            fileUploading: "File Uploading...",
            clickToChooseNewImage: "Click To Choose New Image",
            clickToChooseNewFile: "Click To Choose New File",
            removeTheExistingOne: "Remove The Existing One",

            validateResponseWithEntity: "Validate Response With Entity",
            actionOnFailureInput: "Action On Failure Input",
            askNextQuestion: "Ask the next question",
            goToSuccessBlock: "Go To Success Block",
            goToFailureBlock: "Go To Failure Block",
            saveResposeToAttribute: "Save Respose To Attribute",
            selectReplyType: "Select Reply Type",
            questionVariants: "Question Variants",
            systemEntities: "System Entities",
            delay: "delay",
            retrySectionTextPart: "Ask ",
            retrySectionText: " , if user's response is invalid",
            addNextQuestion: "Add Next Question",
            typeBlockTitle: "Type block title",
            versionHistory: "Version History",
            restore: "Restore",
            versionName: "Version Name",
            restoreModalText:
                "This action will restore the selected version. Are you sure you want to restore this version?",
            restoreVersion: "Restore Version",
            newVersion: "New Version",
            synonymMustBeUnique: "Synonym Must Be Unique",
            save: "Save",
            entries: "Entries",
            youHaveNoEntries: "You Have No Entries",
            inputsCantBeEmpty: "Inputs Can't Be Empty",
            entryNamesMustBeUnique: "Entry Names Must Be Unique",

            entityNameMustBeUnique: "Entity Name Must Be Unique",
            synonyms: "Synonyms",
            entities: "Entities",
            title: "Title",
            entryName: "Entry Name",

            entityhasbeenUpdatedSuccessfully: "Entity Has Been Updated Successfully",
            emptyError: "Entries Can't Be Empty",
            entityNameCantBeEmpty: "Entity Can't Be Empty",

            allChats: "All Chats",
            paidChats: "Paid Chats",
            busiestPeriod: "Busiest Period",
            ratingDistribution: "Rating Distribution",
            allMessages: "All Messages",
            avarageMessages: "Avarage Messages",
            popularity: "Popularity",
            allUsers: "All Users",
            interactionName: "Interaction Name",
            numberOfMessage: "Number Of Message",
            ofAllUsersMessage: "% Of All Users Message",
            totalData: "Total Data",
            avgData: "Avg Data",
            exportToCsv: "Export To CSV",
            exportToExcel: "Export To Excel",
            inMaintenance: "In Maintenance",
            ADD_TO_SEGMENT: "Add to Segment",
            REMOVE_FROM_SEGMENT: "Remove from segment",
            users: "Users",
            webhookName: "Webhook Name",
            webHookUrl: "Webhook url",
            webHookToken: "Webhook token",
            delete: "Delete",
            basicAuth: "Basic Auth",
            requiredFieldsCannotBeLeftBlank: "Required Fields Cannot Be Empty",
            headerValue: "Value",
            yourVerificationToken: "Token",
            yourWebHookName: "Your Webhook Name",
            yourWebHookUrl: "Your Webhook Url",
            enterKey: "Enter Key",
            password: "Password",
            saveSuccessfully: "Your transaction has been successfully saved",
            urlTypeError: "Please Fill In The Field Correctly (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "OpenAI Chat GPT-4 Api Key Required.",
                apiKeyDesc:
                    "Chatbot + Chat GPT-4 integration requires Api Key. Please get your api-key or use the api key below for trial. You can use only 20 message for trial.",
                getApiKey: "Get Open AI Api Key",
                typeApiKey: "Type in Api key",
                ownApiKey: "Own OpenAI Api Key",
                trialApiKey: "Trial Api Key (Restricted as 20 Message)",
                useOurTrial: "Use Our Free Trial",
                twentyMessages: "You can try by using 20 Messages as free.",
                enableChatGpt3: "Enable Chat GPT-4",
            },
        },
        coupon: {
            code: "Code",
            discount: "Discount",
            endDate: "End Date",
            name: "Name",
            email: "Email",
            phone: "Phone",
            add: "Add Coupon",
            coupons: "Coupons",
            couponDeleted: "Coupon Deleted",
            limit: "Limit",
            visitorBan: "Visitor has been blocked.",
            visitorUnBlock: "Block has been removed.",
        },
        instagramTitle: "Click the button below to enable Instagram Features.",
        instegramFunctionActive: "Enable Instagram Feature",
        ChatBOT: "Chat Bot",
        WhatsappContacts: "Whatsapp Contacts",
        InstagramContacts: "Instagram Contacts",
        MessengerContacts: "Messenger Contacts",
        volumeUp: "Volume Up",
        minimize: "Minimize",
        maximize: "Maximize",
        auditLogs: {
            auditLogsTitle: "Audit Logs",
            auditLogsSub:
                "Audit logs allow you to track events that have occurred in your company over the last 30 days.",
        },
        task: {
            workflow: "Workflow",
            workflowDetail: "Workflow Detail",
            workflowPerm: "Workflow Permissions",
            perm: "Permissions",
            detail: "Details",
            userPerm: "User Permissions",
            deleteCard: "Delete Card",
            createCard: "Create Card",
            editCard: "Edit Card",
            dragCard: "Drag Card",
            allWorkflow: "All Workflows",
            createworkflow: "Create Workflow",
            deleteWorkflow: "Are You Sure You Want to Delete This Workflow?",
            permEditTask: "You Do Not Have Permission to Edit This Task",
            permEditTaskDes: "Contact Your Administrator for Editing Permissions.",
            createTaskError: "You Do Not Have Permission to Create Tasks",
            createTaskErrorDesc: "Contact Your Administrator for Task Creation Permissions.",
            moveTaskError: "You Do Not Have Permission to Change Task Status",
            moveTaskErrorDesc: "Contact Your Administrator for Task Status Change Permissions.",
            deleteTaskError: "You Do Not Have Permission to Delete Tasks",
            deleteTaskErrorDesc: "Contact Your Administrator for Task Deletion Permissions",
            permissionError: "You do not have permission to create tasks",
            permissionErrorDesc: "Please contact your administrator for task creation permissions",
            whatsappContactProfileTitle: "{name} / {number} Profile",
            createTaskVisitor: "Create Task (Visitor)",
            editWorkflow: "Edit Workflow",
            visitor: "Visitor Profile",
            createTaskMessage: "Create Task (Message)",
            createStage: "Create Stage",
            stagesAndStatuses: "Stages and Statuses",
            workflowCreateDesc: "Workflow Description",
            subTasks: "Subtasks",
            followers: "Followers",
            collaborators: "Collaborators",
            addRelations: "Add Relations",
            relations: "Relations",
            main: "Main",
            name: "Name",
            completedOfCheck: "{completed} of {total} tasks completed",
            workflowUpdateMs: "Workflow Successfully Updated",
            taskUpdateMs: "Task Successfully Updated",
            workflowCreatedMs: "Workflow Successfully Created",
            workflowCreateError: "Workflow Could Not Be Created",
            taskCreatedMs: "Task Successfully Created",
            settingsDesc3:
                "Additionally, the Supsis task module allows you to create your own workflow with customizable automation, enabling you to manage tasks more effectively and enhance collaboration within the team.",
            settingsDesc4:
                "This way, you can track each of your tasks in detail, assign tasks to team members, and overall manage your business processes more efficiently. The Supsis task module provides you with a comprehensive solution for task management and team coordination.",
            settingsDesc2:
                "The Supsis task module leaves no task overlooked. You can filter tasks based on any parameter, track workloads for each workflow stage, and organize your calendar to align with your schedules.",
            settingsDesc1:
                "The Tasks module allows you to organize collaborative work, delegate tasks, and track your team's progress. You can customize your tasks according to your needs by selecting any view and create your own custom workflows with automations.",
            taskModuleSettingsTitle: "Task Module Settings",
            high: "High",
            medium: "Medium",
            low: "Low",
            priority: "Priority",
            addExistsSubtask: "Add Existing Subtask",
            addSubtask: "Add Subtask",
            add: "Add",
            newCheckList: "New Checklist",
            subtaskTitle: "Subtask Title",
            view: "View",
            attachFiles: "Attach Files",
            createTaskDesc: "Task Description",
            title: "Title",
            createWorkflow: "Create Workflow",
            editTask: "Edit Task",
            createTask: "Create Task",
            deleteColumnCont: "Are you sure you want to delete this column?",
            changeStage: "Change Stage",
            assignees: "Assignees",
            owner: "Owner",
            stage: "Stage",
            writeSomething: "Write something",
            selectAssginee: "Select Assignee",
            assignee: "Assignee",
            enterNewTaskDesc: "Enter New Task Description",
            enterNewTaskTitle: "Enter New Task Title",
            task: "Tasks",
            deleteTaskCont: "Are you sure you want to delete these tasks?",
            deleteWorkFlowCont: "Are you sure you want to delete this Workflow?",
            completed: "Completed",
            todo: "ToDo",
            kanbanBoard: "Kanban Board",
            listView: "List View",
        },
        permissionErrors: {
            userCreate: "You do not have permission to add users. Please consult your administrator.",
            userRead: "You do not have permission to view users. Please consult your administrator.",
            userUpdate: "You do not have permission to update users. Please consult your administrator.",
            userDelete: "You do not have permission to delete users. Please consult your administrator.",
            visitorBlock: "You do not have permission to block visitors. Please consult your administrator.",
            visitorUnblock: "You do not have permission to unblock visitors. Please consult your administrator.",
            visitorDetailRead: "You do not have permission to view visitor details. Please consult your administrator.",
            visitorListRead: "You do not have permission to view visitor lists. Please consult your administrator.",
            visitorDelete: "You do not have permission to delete visitors. Please consult your administrator.",
            visitorExcel: "You do not have permission to get Excel output. Please consult your administrator.",
            visitorUpdate: "You do not have permission to update visitors. Please consult your administrator.",
            bannedVisitorRead:
                "You do not have permission to view banned visitors list. Please consult your administrator.",
            bannedWordCreate: "You do not have permission to add banned words. Please consult your administrator.",
            bannedWordRead: "You do not have permission to view banned words. Please consult your administrator.",
            bannedWordDelete: "You do not have permission to delete banned words. Please consult your administrator.",
            chatRead: "You do not have permission to view chats. Please consult your administrator.",
            chatUpdate: "You do not have permission to edit chats. Please consult your administrator.",
            archiveRead: "You do not have permission to view archives. Please consult your administrator.",
            roleCreate: "You do not have permission to add roles. Please consult your administrator.",
            roleRead: "You do not have permission to view roles. Please consult your administrator.",
            roleUpdate: "You do not have permission to update roles. Please consult your administrator.",
            roleDelete: "You do not have permission to delete roles. Please consult your administrator.",
            departmentCreate: "You do not have permission to add departments. Please consult your administrator.",
            departmentRead: "You do not have permission to view departments. Please consult your administrator.",
            departmentUpdate: "You do not have permission to update departments. Please consult your administrator.",
            departmentDelete: "You do not have permission to delete departments. Please consult your administrator.",
            preparedContentCreate:
                "You do not have permission to create prepared content. Please consult your administrator.",
            preparedContentRead:
                "You do not have permission to view prepared content. Please consult your administrator.",
            preparedContentUpdate:
                "You do not have permission to update prepared content. Please consult your administrator.",
            preparedContentDelete:
                "You do not have permission to delete prepared content. Please consult your administrator.",
            welcomeCreate: "You do not have permission to create welcome messages. Please consult your administrator.",
            welcomeRead: "You do not have permission to view welcome messages. Please consult your administrator.",
            welcomeUpdate: "You do not have permission to update welcome messages. Please consult your administrator.",
            welcomeDelete: "You do not have permission to delete welcome messages. Please consult your administrator.",
            settingCreate: "You don't have permission to create settings. Please consult with your administrator.",
            settingRead: "You don't have permission to view settings. Please consult with your administrator.",
            settingUpdate: "You don't have permission to update settings. Please consult with your administrator.",
            settingDelete: "You don't have permission to delete settings. Please consult with your administrator.",
            reportCreate: "You don't have permission to create reports. Please consult with your administrator.",
            reportRead: "You don't have permission to view reports. Please consult with your administrator.",
            reportUpdate: "You don't have permission to update reports. Please consult with your administrator.",
            reportDelete: "You don't have permission to delete reports. Please consult with your administrator.",
            offlineSupportRequestCreate:
                "You don't have permission to create offline support requests. Please consult with your administrator.",
            offlineSupportRequestRead:
                "You don't have permission to view offline support requests. Please consult with your administrator.",
            offlineSupportRequestUpdate:
                "You don't have permission to respond to offline support requests. Please consult with your administrator.",
            offlineSupportRequestDelete:
                "You don't have permission to delete offline support requests. Please consult with your administrator.",
            catalogCreate: "You don't have permission to create catalogs. Please consult with your administrator.",
            catalogRead: "You don't have permission to view catalogs. Please consult with your administrator.",
            catalogUpdate: "You don't have permission to update catalogs. Please consult with your administrator.",
            catalogDelete: "You don't have permission to delete catalogs. Please consult with your administrator.",
            chatbotStoryCreate:
                "You don't have permission to create chatbot stories. Please consult with your administrator.",
            chatbotStoryRead:
                "You don't have permission to view chatbot stories. Please consult with your administrator.",
            chatbotStoryUpdate:
                "You don't have permission to update chatbot stories. Please consult with your administrator.",
            chatbotStoryDelete:
                "You don't have permission to delete chatbot stories. Please consult with your administrator.",
            chatbotTemplateRead:
                "You don't have permission to view chatbot templates. Please consult with your administrator.",
            chatbotTemplateAiRead:
                "You don't have permission to view AI chatbot templates. Please consult with your administrator.",
            chatbotIntegrationsRead:
                "You don't have permission to view chatbot integrations. Please consult with your administrator.",
            chatbotArchiveRead:
                "You don't have permission to view chatbot archives. Please consult with your administrator.",
            chatbotEntitiesRead:
                "You don't have permission to view chatbot entities. Please consult with your administrator.",
            chatbotEntitiesCreate:
                "You don't have permission to create chatbot entities. Please consult with your administrator.",
            chatbotEntitiesUpdate:
                "You don't have permission to update chatbot entities. Please consult with your administrator.",
            chatbotEntitiesDelete:
                "You don't have permission to delete chatbot entities. Please consult with your administrator.",
            chatbotReportRead: "You do not have permission to view Chatbot Reports. Please contact your administrator.",
            chatbotTrainRead: "You do not have permission to view Chatbot Training. Please contact your administrator.",
            chatbotSegmentCreate:
                "You do not have permission to create Chatbot User Segments. Please contact your administrator.",
            chatbotSegmentRead:
                "You do not have permission to view Chatbot User Segments. Please contact your administrator.",
            chatbotSegmentUpdate:
                "You do not have permission to update Chatbot User Segments. Please contact your administrator.",
            chatbotSegmentDelete:
                "You do not have permission to delete Chatbot User Segments. Please contact your administrator.",
            integrationsRead:
                "You do not have permission to view Integrations Page. Please contact your administrator.",
            whatsappIntegrationRead:
                "You do not have permission to view Whatsapp Integration Page. Please contact your administrator.",
            instagramIntegrationRead:
                "You do not have permission to view Instagram Integration Page. Please contact your administrator.",
            telegramIntegrationRead:
                "You do not have permission to view Telegram Integration Page. Please contact your administrator.",
            integrationCreate: "You do not have permission to enable Integrations. Please contact your administrator.",
            triggerCreate: "You do not have permission to create Triggers. Please contact your administrator.",
            triggerRead: "You do not have permission to view Triggers. Please contact your administrator.",
            triggerUpdate: "You do not have permission to update Triggers. Please contact your administrator.",
            triggerDelete: "You do not have permission to delete Triggers. Please contact your administrator.",
            billingRead: "You don't have permission to view the bills. Please contact your administrator.",
            taskCreate: "You don't have permission to create tasks. Please contact your administrator.",
            taskRead: "You don't have permission to view tasks. Please contact your administrator.",
            taskUpdate: "You don't have permission to update tasks. Please contact your administrator.",
            taskDelete: "You don't have permission to delete tasks. Please contact your administrator.",
            calendarCreate:
                "You don't have permission to create calendar/reservation. Please contact your administrator.",
            calendarRead: "You don't have permission to view calendar/reservation. Please contact your administrator.",
            calendarUpdate:
                "You don't have permission to update calendar/reservation. Please contact your administrator.",
            calendarDelete:
                "You don't have permission to delete calendar/reservation. Please contact your administrator.",
            mailCreate: "You don't have permission to create mails. Please contact your administrator.",
            mailRead: "You don't have permission to view mails. Please contact your administrator.",
            mailUpdate: "You don't have permission to update mails. Please contact your administrator.",
            mailDelete: "You don't have permission to delete mails. Please contact your administrator.",
        },
        message: {
            noConversationDesc: "Here you can see active chats and chats assigned to you.",
            forMe: "For Me",
            unAssigned: "Unassigned",
            agentDetails: "Agent Details",
            contactProperties: "Contact Properties",
            goToProfile: "Go to Profile",
            addNote: "Add Note",
            noPreferredAgent: "No Preferred Agent Yet",
            toPrefer: "Prefer",
            inChat: "In Chat",
            watching: "Watching",
            chatsTitle: "Chats",
            dealyTimeMaxValueError: "Delay time can be a maximum of 15",
            dealyTimeTypeError: "Delay Time Value Must Be a Number",
            passedTimeHm: "{hour} Hours {min} Minutes",
            passedTimeMs: "{min} Minutes {sec} seconds",
            passedTimeSc: "{sec} Seconds",
            translateMessage: "Your message has been translated by artificial intelligence.",
            toneChanged: "Message tone changed to {tone}",
            aiResponseAdded: "AI Response Added to Message",
            messageLonger: "Message Made Longer",
            grammarFixed: "Grammar Fixed",
            aiTranslate: "Translation",
            other: "Other",
            yourLanguage: "Your language",
            myLanguage: "My language",
            forwardToChatbot: "Forward to Chatbot",
            friendly: "Friendly",
            confident: "Confident",
            straightForward: "Straightforward",
            casual: "Casual",
            professional: "Professional",
            longSentence: "Long Sentence",
            changeTone: "Change Tone",
            fixGrammar: "Fix Grammar",
            aiResponse: "AI Response",
            templateButtonNote:
                "To ban contact, be careful to use the following texts on the ban button. Regardless of uppercase or lowercase letters",
            templateButtonTags: "#Send Message# | #Unsubscribe# | #Ban# | #Block#",
            dashboard: "Dashboard",
            adminReports: "Admin Reports",
            calendarModule: "Calendar Module",
            taskModule: "Task Management Module",
            maxUrlButtonMessage: "You can add a maximum of 2 URL buttons.",
            noPreferredDepartment: "No Preferred Department",
            searchForDepartment: "Search for Department",
            departmentAssignedToTheVisitor: "Select the department you want to assign to the visitor.",
            assignPreferredDepartment: "Assign Preferred Department",
            smsChannel: "SMS Channel: ",
            whatsappv2Channel: "Whatsapp V2 Channel: ",
            whatsappv1Channel: "Whatsapp V1 Channel: ",
            wBChannel: "Whatsapp Business Channel: ",
            messengerChannel: "Messenger Channel: ",
            instagramChannel: "Instagram Channel: ",
            allPlatforms: "All Platforms",
            cbStartMessage: "Chatbot Start Message",
            cbStartMessageDesc:
                "The first message entered by the user is automatically processed by the chatbot and directed to the relevant address.",
            messengerUserProfile: "Messenger User Profile",
            instagramUserProfile: "Instagram User Profile",
            noEventFound: "No Event Found",
            visitorMails: "Visitor Mails",
            visitorActions: "Visitor Actions",
            notVerified: "Not Verified",
            visitorEvents: "Visitor Events",
            assignedTasks: "Assigned Tasks",
            mails: "Mails",
            prefferedAgents: "Preferred Agents",
            createEvent: "Create Event",
            blockManagement: "Block Management",
            deleteUser: "Delete User",
            blocked: "Blocked",
            profiles: "Profiles",
            similiarProfiles: "Similar Profiles Found",
            ReplyAsAPm: "Reply as Private and Close",
            replyAsAComment: "Reply Comment and Close",
            messengerAddDesc: "Click on the Connect button below & login to your Facebook account.",
            instaAddPrivacyCheckDesc: "I read and agree to {Privacy} and {Terms and Conditions}",
            instaAddDesc5: "Click on the Connect button below & login to your Facebook account.",
            instaAddDesc4: "Register as a Facebook Developer",
            instaAddDesc3: "Ensure that the <b>'Allow access to messages'</b> toggle is switched on",
            instaAddDesc2: "Ensure that your Instagram professional account is connected to your Facebook page",
            instaAddDesc1: "Ensure that your Instagram account is an Instagram professional (Business) account.",
            selectedDepartment: "Selected Department",
            departmentForwardEnable: "Department Forwarding Rule Enabled",
            departmentForwardRule: "Department Forwarding Rule",
            departmentForwardDesc: "Choose which department the chats coming to the channel will be directed to.",
            channelName: "Channel Name",
            forwardToLiveAgents: " 👉 Forward to Live Agents",
            manageIgChannel: "Manage Your Instagram Channel",
            igDetail: "Instagram Detail",
            manageVisibilityDesc: "Manage who can see this channel visibility",
            selectAnIgAccount: "Select an Instagram Account to connect to Supsis",
            connectToInsta: "Connect to Instagram",
            connectToMetaLeads: "Connect to Meta Leads",
            deleteInstaChannelInfo: "Are you sure you want to delete the Instagram channel?",
            instagramChannels: "Instagram Channels",
            suspendedDescription: "Your account has been suspended due to unpaid invoices",
            onlyChatbot: "Only Chatbot",
            onlyAgents: "Only Agents",
            checkboxWarning: "This field is required to be checked",
            sendingAllow: "Sending",
            receiving: "Receiving",
            platform: "Platform",
            banModalTitle: "Visitor Ban Modal",
            selectDepartmentDesc: "Select the departments you want to change the visibility of",
            selectAgentDesc: "Select the agents you want to change the visibility of",
            selectDepartment: "Select Department",
            selectAgent: "Select Agent",
            visibleDepartments: "Visible Departments",
            visibleAgents: "Visible Agents",
            visibilityInfoCont: "All agents and departments can see this channel",
            editDepartmentVisibility: "Edit Department Visibility",
            editAgentVisibility: "Edit Agent Visibility",
            typeSTToSearch: "Type something to search for users",
            exportToCSV: "Export to CSV",
            clear: "Clear",
            usedSessionCount: "Used Session Count",
            maxSessionCount: "Maximum Session Count",
            leftSessionCount: "Remaining Session Count",
            planManagement: "Plan Management",
            teamChat: "Team Chat",
            templateNameIsNotValid: "Template Name Is Not Valid",
            relatedAdvertisement: "Related Advertisement",
            whatsappNumber: "Whatsapp number",
            createTask: "Create Task",
            integrationsWhatsappV1:
                "A WhatsApp Plan is required for seamless communication between Supsis and WhatsApp.",
            integrationsWhatsappV2: "You can easily share chat information between Supsis and WhatsApp.",
            integrationsWhatsappBusiness:
                "You can quickly and conveniently transmit chat information between Supsis and WhatsApp.",
            selectDays: "Select Days",
            addTime: "Add Time",
            instagramContactList: "Instagram Contact List",
            archiveAllRated: "Retrieve all conversations with any ratings.",
            allChannels: "All channels",
            comment: "Comment",
            news: "What's New",
            conversation: "Team Chat",
            speechTermination: "End Conversation",
            noSystemMessage: "There are no messages in the system yet!",
            supsisCustomerService: "Customer services provided by Supsis,",
            supsisClickExperience: "You can try the experience by clicking.",
            customerPage: "Go to Customer Page",
            buttonTitle: "Button title",
            buttonType: "Button type",
            buttonSendMessage: "Send Message",
            buttonGoToBlock: "Go to block",
            buttonOpenUrl: "Open URL",
            buttonPhoneCall: "Phone Call",
            buttonOpenMoment: "Open Moment",
            buttonCloseChat: "Close Chat",
            buttonTransferChat: "Transfer Chat",
            buttonCreateTicket: "Create Ticket",
            deleteVisitor: "Are you sure you want to delete user? This operation cannot be undone.",
            deleteThread: "Are you sure you want to delete all mails? This operation cannot be undone.",
            deleteMail: "Are you sure you want to delete mail? This operation cannot be undone.",
            userProfile: "Profile",
            addCalendarEvent: "Event +",
            you: "You",
            apiIntegration: "Developer",
            generateToken: "Generate Token",
            copyToken: "Copy Token",
            dndBlocked: "File sending settings turned off.",
            labels: "Labels",
            noData: "No Data",
            color: "Color",
            titleColor: "Title Color",
            secondTitleColor: "Second Title Color",
            tag_name_indicator: "Tag Name",
            sendMessage: "Send Message",
            removeFromG: "Remove from the group",
            delChannel: "Are you sure you want to delete this channel?",
            new_name: "New Name",
            set_group_info: "Edit group information",
            shortcut_desc_num: "Switch between active conversations with numeric digits",
            copilot_desc_num: "Allows you to open Copilot on the Chat Screen",
            typing_w_chat: "typing...",
            edit_group_info: "Edit Group Information",
            notif_sound: "Turn on Notification Sounds",
            notif_mute: "Mute Notifications",
            leave: "Leave",
            group: "Group",
            updateTag: "Update Tag",
            ordered_desc: "Assigns chats to representatives in order.",
            random_desc: "Assigns chats to representatives randomly.",
            Rrobin_desc:
                "Assigns chats to representatives in a round-robin fashion. (Prioritizes least busy representatives)",
            RrobinRev_desc:
                "Assigns chats to representatives in a reverse round-robin fashion. (Prioritizes most busy representatives)",
            algo_desc: "Select the algorithm for automatic chat assignment",
            algorithm: "Algorithm",
            os_browser: "Operating System and Browser",
            addTag: "Add Tag",
            tags: "Tags",
            searchRepresentative: "Search Representative",
            preferredRepresentative: "Representatives",
            voting: "Voting",
            chatWidget: "Supsis Chat Widget",
            webhooks: "Webhooks",
            selectHooks: "Select Web Hooks",
            planRequired: "{integratable} Plan Required",
            allIntegrations: "All Integrations",
            disableAgentSystemMessages: "Hide agent system messages",
            disableAgentSystemMessagesDesc: "Hide Agent System Messages.",
            disableAutoTranslate: "Auto Translate",
            disableAutoTranslateDesc:
                "It automatically translates messages from different languages. So you can communicate with your customers more easily.",
            shouldAddMethod:
                "You must fill in the Payment Method and Billing Address field!\n No money will be withdrawn from your account.\n" +
                "At the end of the month, an invoice will be created according to your usage amount.",
            approveSelection: "Approve Selection",

            trialDaysEndSelectPlan: "Confirm Plan Selection",
            trialDaysEndSelectPlanDesc: "Your trial version is over. You need to confirm by selecting the plan below.",
            infoAboutAnnouncement: "Brief information about the announcement",
            announcement: "Announcement",
            newAnnouncementForm: "New Announcement Form",
            newAnnouncement: "New Announcement",
            announcements: "Announcements",
            languageSelection: "Language Selection",
            announcementTitle: "Announcement Title",
            infinitePlay: "Play continuously",
            newTicketSound: "New Ticket",
            vtippyDepartmentNotification: "Notification settings for messages from department conversation",
            vtippyGroupNotification: "Notification settings for messages from created groups",
            vtippyAnnouncemenNotification: "Notification settings for new announcements",
            hideBubbleOnMobile: "Hide on mobile",
            cardInfos: "Card Infos",
            vtippyHideBubbleOnMobile: "Chat Bubble is hidden from mobile users.",
            deleteSystemLanguage: "Delete {code} language from the system",
            assignedChat: "Assigned Chat",
            CHAT: "Chat",
            check: "Check Box",
            systemStatus: "System Status",
            chatAssignedToUser: "New chat assigned",
            inactiveThresholdTime: "Inactive Chat Time (minute)",
            tippyInactiveThresholdTime:
                "If no message is sent within the given time, the conversation is considered inactive. Enter the value (minutes). Must be range in 1min - 120min.",
            inactiveTerminateTime: "Inactive Chat Terminate Duration (minute)",
            tippyInactiveTerminateTime:
                "Inactive chat  will be terminated if it does not switch to active mode within a certain time. Enter the value (minutes). Must be range in 1min - 120min.",
            removePendingMessage: "Cancel message sending",
            disconnected: "Disconnected",
            visitorWriteEmptyChatTippy: "Customer can write to conversation before agent connects.",
            visitorWriteEmptyChat: "Client can write without agent connected.",
            visitorConnectionEventSystemMessageEnabled: "Visitor connection status system messages enable",
            visitorConnectionEventSystemMessageEnabledTippy: "Visitor left and Visitor comeback system messages enable",
            openBubble: "Open Bubble",
            showHeaderImage: "Show Company Logo and Name",
            askQuestion: "Ask a question",
            locationPermsNeeded: "Location permissions are needed to use this feature",
            useMyLocation: "Use my location",
            acceptingChat: "Accepting chats",
            notAcceptingChat: "Not Accepting chats",
            blockBy: "Banned By",
            languageRemovalQuestion: "You are about to delete {code} language from the system!",
            loggedOut: "Logged out",
            vtippyNewVisitorNotification: "Audible notification for every new visitor to your website",

            vtippySelectnotification: "You can choose notification sound.",
            vtippyVoiceLevel: "you can adjust the volume",
            vtippyStartVoice: "Listen",
            vtippyInfiniteNotification:
                "If you are not active in the new Chats panel, it will continue to play. You can edit active-passive by clicking.",

            vtippyTranslateButton: "Translates the selected language to other languages",
            vtippyTranslateClearButton: "Cleans content in other languages.",
            vtippyTicketNotification: "Notification settings for every new ticket you receive",

            vtippyNewChatNotification:
                "You can select sound notification for new conversations coming to the system and adjust the volume.",
            vtippyNewConversationNotification:
                "You can choose sound notification and adjust volume for when new incoming conversations are assigned to you.",
            vtippyNewMessageNotification:
                "You can select notifications for incoming messages to your conversations and adjust the volume.",
            vtippyPrivateMessageNotification:
                "You can select a notification for the incoming message to the team talk.",
            hideInactiveAgents: "Hide Inactive Agents",
            hideMinorValues: "Hide Minor Values",
            hashHintMessage: "You can quickly enter hashtag shortcuts with #hash",
            pmHintMessage: "Did you know that you can send a keyword private message?. eg pm: Hi",
            billingAddress: "Billing Address",
            addNewAddress: "Add New Address",
            adressTitle: "Address Title",
            address: "Address",
            shortcutHintMessage: "Did you know that you can send messages faster with shortcut messages?",
            switchBetweenConversations:
                "Did you know that you can quickly switch between conversations with abc shortcuts?",
            atNameHintMessage: "Did you know you can quickly enter the visitor name with @name?",
            dndHintMessage: "You can upload files with drag and drop.",
            pasteFile: "you can send files.",
            atEmailHintMessage: "Did you know you can quickly enter the visitor mail with @mail?",
            pastePlainText: "Paste from clipboard as plain text",
            pressAndTalk: "Press and talk",
            agentActivities: "Agent Activities",
            listStatuses: "Statuses",
            newHASHContent: "#Add Hash",
            hash: "Hash Tag",
            hashText: "Hash Text",
            exampleHash: "order-tracking",
            notValidHash: "Must not contain spaces.",
            websiteChatWidgetIntegration: "Website Chat Widget Integration",
            videoCallEnabledDesc: "Activate to enable the video call feature.",
            videoCallEnabled: "Video Call Feature",
            audioCallDesc: "Activate to enable voice search feature.",
            audioCallEnabled: "Voice Search Feature",
            assignPreferredAgent: "Assign Preferred Agent",
            representativeAssignedToTheVisitor: "Select the preferred agent you want to assign to the visitor.",
            agentFileSendEnabledDesc: "Enables the ability to send files to delegates",
            agentFileSendEnabled: "Representatives Can Submit Files",
            visitorFileSendEnabledDesc: "Allows you to turn the visitors file sending feature on or off",
            visitorFileSendEnabled: "Visitors Can Submit Files",
            visitorAutoLogin: "Visitor Auto Login",
            visitorAutoLoginDesc: "Auto start conversation when visitor click on chat bubble",
            agentVoiceRecordEnabledDesc: "Enables agents to record audio",
            agentVoiceRecordEnabled: "Agents Can Record Audio",
            visitorVoiceRecordEnabledDesc: "Enables visitors to record audio",
            visitorVoiceRecordEnabled: "Visitors Can Record Audio",
            startVideoCall: "Video call",
            startAudioCall: "Voice Call",
            visitorGDPRDeleteEnabledDesc: "Allows you to toggle the ability to delete all visitors information",
            visitorGDPRDeleteEnabled: "Visitors can delete all their information",
            visitorLocationEnabled: "Visitors can share location",
            visitorLocationEnabledDesc: "Allows visitors to turn location sharing on or off",
            customerLocationEnabled: "Representatives can share location",
            customerAutoMergeEnabled: "Automatically merges the same individuals",
            customerAutoMergeEnabledDesc:
                "This feature performs automatic merging to effectively bring together data related to the same individuals. This ensures that users with similar profiles are represented more consistently and orderly in data sets.",
            chatAiCopilot: "Chat AI Copilot",
            chatAiCopilotDesc: "Automatically Respond to Your Customers' Questions Using Chat AI Copilot",
            customerLocationEnabledDesc: "Allows representatives to turn location sharing on or off",
            triggerAlreadyExists: "Trigger already exists",
            ticketStatusForm: "Ticket Status Form",
            statusFormTitle: "Ticket Status Title",
            allStatus: "All Statuses",
            triggers: "Triggers",
            trigger: "Trigger",
            noTrigger: "You Haven't Added Any Triggers Yet",
            triggerSkipLoginForm: "Login Form",
            triggerSkipLoginFormTrue: "Show Login Form",
            triggerSkipLoginFormFalse: "Skip Login Form and Go Directly to the Message",
            noContent: "no content",
            toCreate: "To create",
            clickTheButton: "click the button",
            triggerContent:
                "Type the description you want to appear in the modal that opens. You only need to write in one language and the translation into other languages is done automatically.",
            triggerDrag: "You can adjust the message duration by dragging or clicking the bar.",
            triggerNewCondition: "You can add a new condition with the button.",
            triggerNoConditionDescription1:
                "You can create the conditions you want from the options. If you do not create any conditions for any trigger, the first trigger will be active.",
            triggerNoConditionDescription2:
                "Only one of the triggers with the same conditions appears on the Visitor page.",
            triggerShowAndHide: "You can show or hide triggers whenever you want.",
            countryLanguage: "Country/Language",
            addTrigger: "Add Trigger",
            yesPlease: "Yes, please!",
            noThanks: "No, thanks.",
            firstAnswer: "Question Dialogue Confirm Answer",
            secondAnswer: "Question Dialogue Dismiss Answer",
            noTitle: "No Tittle",
            sumChat_MediaFile: "Media and Documents",
            importantWarning: "IMPORTANT WARNING!",
            images: "Images",
            URLS: "Links",
            files: "Files",
            noCondition: "No Condition! You can add Conditions by clicking the plus icon.",
            showTriggers: "Click to Show Triggers",
            showThisTrigger: "Click to Show This Trigger",
            hideTriggers: "Click to Hide Triggers",
            hideThisTrigger: "Click to Hide This Trigger",
            updateTrigger: "Update Trigger",
            conditions: "Conditions",
            messageDurationPerRow: "Message Duration Per Row",
            updateCompleted: "Update Completed",
            CatalogUpdatedSuccessfully: "Catalog Updated Successfully",
            integrateSupsiswithIntegratable: "Pass chat information between Supsis and {integratable} with ease.",
            installationOK: "Installed",
            dayTime: "Hour",
            weekDay: "Day of Week",
            spendTimePage: "Spent Time on Page",
            spendTimeSite: "Spent Time on Site",
            pageUrl: "Page URL",
            pageTitle: "Page Title",
            equal: "Equal",
            not_equal: "Not Equal",
            less_than: "Less Than",
            greater_than: "Greater Than",
            less_than_or_equal: "Less Than or Equal",
            greater_than_or_equal: "Greater Than or Equal",
            visitorName: "Visitor Name",
            seconds10: "10 seconds",
            seconds30: "30 seconds",
            minute1: "1 minute",
            minutes5: "5 minutes",
            minutes10: "10 minutes",
            minutes30: "30 minutes",
            hour1: "1 hour",
            hours2: "2 hours",
            hours4: "4 hours",
            hours8: "8 hours",
            hours12: "12 hours",
            hours24: "24 hours",
            maxCondition: "Max Condition",
            doYouWishToDeleteTrigger: "Do You Wish To Delete Trigger",
            contains: "Contains",
            not_contains: "Does Not Contain",
            chatLanguage: "Chat Language",
            translating: "Translating",
            buyWhatsapp: "Purchase WhatsApp integration",
            liveSupportStartingWait: "Starting Live Support, Please Wait",
            noConnection: "No Connection!",
            integrations: "Integrations",
            refundInvoiceSure: "Are you sure you want to return the invoice?",
            invoiceMarkedAsPaidSuccess: "Invoice has marked as paid successfully",
            invoiceMarkedAsPaidError: "Error, Invoice has not marked paid",
            deleteConfirm: "Do you want to delete this {object}?",
            markPaidConfirm: "Are you sure mark as paid this invoice?",
            addLink: "Link",
            startChatDesc: "Start Conversation",
            selectStep: "Select a step:",
            addGOTO: "Go to",
            sendFastLink: "Send Fast Link",
            or: "Or",
            allTags: "All Tags",
            showDetail: "Show Detail",
            hideDetail: "Hide Detail",
            weLlSendPhone: "We'll Send to Your Phone",
            weLlSendEmail: "We'll Send to Your e-Mail",
            linkSentToPhone: "Link sent as sms",
            offerlinkSendToPhone: "We will send you the download link of our application via SMS.",
            offerlinkSendToMail: "We will send you the download link of our application via e-mail.",
            theEmail: "My Registered Email",
            differentEmail: "Another Different Email",
            linkSentToMailBox: "Link was sent to your mail adress",
            errorOccurred: "Error occured !",
            clickStoreIcon: "You can access the mobile application by clicking the icon suitable for your phone.",
            meetWithSupsis: "Would you like to meet our SUPSIS mobile application?",
            downloadMobileApps: "Download Mobile App",
            getApps: "Get Apps",
            info: "Information",
            conversationHistory: "Conversation History",
            events: "Calendar Events",
            reservations: "Reservations",
            planInfoHeader: "Plan Information",
            planInformation: "Your plan is {selectedPlan} ({detailMaxAgentCount} Agent) ({freeAgent} Free Agent)",
            creditAvailable: "Your Agent credit available in your plan: ",
            upDownGradePlan: "If you want to upgrade/downgrade your plan, please",
            click: "Click",
            autoStartChat: "Automatic Chat Start",
            bubbleColor: "Chat Bubble Color",
            openFolder: "Open Folder",
            preDefined: "Themes",
            customIcon: "Install from your computer",
            theme: "Theme",
            themeSettings: "Theme Settings",
            chatThemeSettings: "Chat Theme Settings",
            bubbleSettings: "Chat Bubble Settings",
            inputHeightOfBubble: "Bubble Size",
            inputPixelsOfChatBubble: "Click to Edit Distances of Chat Bubble to Edges",
            modalTitleIsMarginAsPixelInfo: "Distances of Chat Bubble to Edges : ",
            inputPxOfXaxis: "Horizontal Position",
            inputPxOfYaxis: "Vertical Position",
            inputPxOfMobileXaxis: "(Mobil) Horizontal Position",
            inputPxOfMobileYaxis: "(Mobil) Vertical Position",
            animations: "Animations",
            preferredAnimation: "Preferred Animation",
            selectAnAnimation: "Select an Animation",
            inputOfBubbleMessage: "Add content to large chat bubbles.\n{contentOfChatBubble}",
            showChatBubbleOnlyLoggedUserToolTip:
                "It is the Setting to Hide the Chat Bubble Based on Login Status.Showed to all visitors in case Off.",
            showChatBubbleOnlyLoggedUser: "Show Bubble to Only Logged in User. (ideasoft)",
            helloDoUNeedHelp: "Hi, Do you need help?",
            bubbleIcon: "Chat Bubble Image",
            overrideMargins: "Customize Margins",
            autoHideBubble: "Hide Chat Bubble",
            vtippyAutoHideBubble: "Hides chat bubble when agents are offline",
            hideBubble: "Disable Chat Bubble",
            vtippyHideBubble: "Disables the chat bubble.",
            overrideMobileMargin: "Customize Margins for Mobile",
            vtippyMobileMargin: "Customize Margins for Mobile",
            isFabsActive: "Show Floating Action Button",
            bubbleOpenableMenu: "Chat Bubble Dropdown",
            vtippyIsFabsActive: "Setting of Show / Hide Floating Action Button",
            vtippyIsFabsAsIcon: "It is the setting of whether the icons will appear in the drop-down menu.",
            isFabsAsIcon: "Show Menu Icons.",
            setMarginAsPixel: "Set as pixel",
            returnDefaultMargins: "Default Margin Settings",
            deleteSite: 'Do you want to Delete the site " {siteName} " ?',
            deleteThisSite: "Delete the site",
            assetOversizeWithExt: "File size must be less than 10mb and in png,jpg format.",
            closeChat: "End Messaging",
            ticket: "Ticket",
            formStep: "Form Step",
            menuStep: "Menu Step",
            contentStep: "Content Step",
            menuTitle: "Menu Title",
            messageContent: "Message Content",
            goToLive: "Transfer to Representative",
            prevStep: "Return to Previous Step",
            button: "Button",
            addImage: "Image",
            addText: "Text",
            stepTitle: "Step Title",
            addTicket: "Ticket",
            formDescription: "Question",
            addInput: "Question",
            addRandomText: "Random Text",
            calendarPassedTimeMinSec: "{min} minute {sec} second {name}",
            calendarPassedTimeSec: "{hour} hour {min} minute {sec} second {name}",
            updateUserName: "Update Username",
            forgotPassword: "Forgot Password",
            osrFromMessageSaved: "Offline message saved.",
            requiredField: "This field is required.",
            nightModeOn: "Night Mode On",
            catalogMenu: "Menu",
            catalogContent: "Content",
            all: "All",
            allDepartments: "All Departments",
            preferredLanguage: "Preferred Language",
            kmkAutoDepartmentBind: "KMK Auto Deparment Find",
            kmkAutoDepartmentBindDesc: "Search Seller on KMK Customer Sites and set to login page as a department",
            visitorEmailUpdated: "Visitor email  updated",
            visitorEmailIsNotValid: "Visitor email is not valid",
            visitorNameUpdated: "Visitor name updated",
            clickToEdit: "Click to edit",
            addEmail: "+ Add Email",
            addFullname: "+ Add Fullname",
            partner: "Ref?",
            isIntegrated: "Integration?",
            agentCount: "Agent Count",
            closePreviewColors: "Close Theme Preview",
            previewColors: "Open Theme Preview",
            videoCalls: "Video Calls",
            filterLost: "Lost Chats",
            vtipyCustomLogin:
                "You can customize the information that will be requested in the login form when your visitors connect to the system.",
            vtipyLoginlessChat: "Visitor login form will be hidden. Visitor can connect to chat directly. ",
            loginlessChat: "Visitor Login Form",
            imageUrl: "Image Url",
            replied: "Replied",
            solved: "Solved",
            openImage: "Open Image",
            writeFeedback: "You can write your feedback about Supsis here.",
            feedbackFailed: "An error occurred while sending feedback.",
            feedbackSuccessful: "Feedback submission successful.",
            sendFeedback: "Send Feedback",
            errorReport: "You can give us feedback about the problems you have about the SUPSIS.",
            sendErrorFeedBack: "Give us feedback on the issue you are experiencing.",
            successImgUpload: "Your image has been uploaded successfully.",
            successImgDelete: "Image successfully deleted.",
            errorImgUpload: "An error occurred while uploading your image.",
            errorImgDelete: "An error occurred while deleting the image",
            chatBotEndStatics: "Chatbot Conversation Success Rate",
            videoCallDist: "Video Call Distribution",
            departmentInfo: "Department Info",
            infoAboutDepartment: "Give brief information about the department",
            deleteDepartmentQuestion: "Do you really want to delete this department?",
            departmentDeleted: "Department Deleted",
            departmentTitle: "Department Title",
            updateDepartmentForm: "Department Update Form",
            newDepartmentForm: "New Department Form",
            department: "Department",
            newDepartment: "New Department",
            departmentSaved: "Department Saved",
            sameDepartment: "There is a department with the same name",
            sameValue: "There is a value with the same name!",
            sameRole: "There is a role with the same name!",
            sameTag: "There is a tag with this name!",
            departments: "Departments",
            chatTimingSettings: "Chat Timing Settings",
            assetOversize: "The size of the file you want to send should not exceed 2mb.",
            assetOversizeMB: "The size of the file you want to send should not exceed {mb}MB.",
            messageDeleted: "This message is deleted",
            filterLostChat: "Filter Lost Chats",
            filterClosedByAgent: "Filter Closed By Agent",
            filterVideoCall: "Video Call Filter",
            notificationText: "Supsis need permission to ",
            notificationTitle: "Notifications Off",
            deniedText:
                "Your notifications are closed, you need to turn on your notifications so that you do not miss your customers.",
            deniedTitle: "Click to Open Your Notifications!",
            deniedHeader: "In order not to miss your customers, you need to turn on your notifications!",
            showNotificationGuide: "Click for details",
            howToEnableNotification: "How Can I Enable Notifications",
            notificationOK: "Ok",
            notificationUnderstood: "Understood!",
            notificationCancel: "Cancel",
            howToEnableNotificationInstruction1: "Click on the lock icon in the address bar of the browser",
            howToEnableNotificationInstruction2: "If 'Notifications' is disabled in the Permissions section, enable it",
            howToEnableNotificationInstruction3:
                'If "Notifications" does not appear in the Permissions section, click on "Site Settings"',
            howToEnableNotificationInstruction4:
                'Turn on the "Notifications" permission from the "Permissions" section of the site settings page',
            checkPaymentMethod: "Please check your payment method",
            pushNotificationEnabled: "Great, Push notification enabled",
            pushNotificationDenied: "You have denied the notification permission",
            suspendedMessage: "Your account has been suspended",
            enableNotification: "Enable Desktop Notifications.",
            languageSettings: "Selected Language",
            problemsSound:
                "If you have problems with notifications,You can click lock image from your browser search box (Shown in Picture) click 'Site Settings' and change 'Sound ' to Allow",
            betweenRepresentative: "There is a new message from a Representative",
            desktopNotifications: "Desktop Notifications",
            notificationEnabled: "Supsis desktop notifications is enabled.",
            newMessageAlert: "You have a new message.",
            notificationDisable: "You can disable notification from Representative settings",
            newConversationAlert: "You have a new visitor.",
            chatBot: "ChatBot",
            ticketResponse: "Temsilcinin Yanıtı:",
            archived: "archive",
            chatbotChatCount: "CHATBOT",
            changeTitle: "Change Title",
            changeVisitorTitle: "Change Visitor Title",
            catalog: "Catalog Title",
            openTheCatalog: "Open Catalog",
            catalogNotOpen:
                "The catalog feature is disabled. You can turn on the catalog feature to support your customers with pre-prepared content.",
            showCatalogCategories: "Set whether catalog menu will show up on Chat bubble",
            showChatBot: "Set whether ChatBot will show up on Chat bubble",
            openCatalog: "Catalog Visibility",
            unreadMessages: "Unread Messages",
            personalFirstMsg: "Agent First Response Time Average (sec)",
            personalRating: "Staff Score Avg",
            soundSettings: "Notification Settings",
            newPrivateMessage: "Private Message",
            addNewGroup: "Create A New Group",
            teamChatTeam: "Team Messages",
            teamChatDm: "Dm Messages",
            teamChatDepartment: "Department Messages",
            teamChatGroup: "Group Messages",
            newMessage: "New Message",
            newConversation: "New Chat",
            newVisitor: "New Visitor",
            chatPosition: "Chat Position",
            bottomLeftCorner: "Bottom Left Corner",
            leftDocked: "Left Docked",
            bottomRightCorner: "Bottom Right Corner",
            rightDocked: "Right Docked",
            chatPositionSelect: "Choose Position",
            bottomLeft: "Bottom Left",
            left: "Left",
            cardNumber: "Card Number",
            cardType: "Card Type",
            skt: "ED",
            cvv: "CVV",
            saveCard: "Save Card",
            cardNameSurname: "Card Holder's Name and Surname",
            confidentialityAgreementCheck: "I Accept the Confidentiality Agreement",
            confidentialityAgreement: "Confidentiality Agreement",
            bottomRight: "Bottom Right",
            right: "Right",
            mailorname: "E-Mail or Name",
            fieldName: "Key Name",
            value: "Value",
            addSetting: "Add a Settings",
            globalSettings: "Global Settings",
            breaksByTime: "Break count by time",
            clPlaceholder: "Name that will appear on the customer form",
            target: "Load Test Address",
            duration: "Load Test Duration(sec)",
            arrivalCount: "Chat Count",
            bootMaxLife: "Chat Max Life Time(sec)",
            startLoadTest: "Start Load Test",
            noClusterInstanceFound: "There is no server",
            stopLoadTest: "Stop Load Test",
            integrationDesc: "Just add the one-line code below to your site.",
            integrationDemoCode: "Simple integration demo code",
            integrationWindow: "How Do I Integrate To My Site ?",
            notIntegrated: "Integration",
            help: "Help",
            notIntegratedDesc:
                "We noticed that you did not add the chat system to your site. When you integrate it into your site and start the first chat, you will complete the integration. Click for INTEGRATION SCRIPT",
            backToLogin: "Go Back To Login Screen",
            passwordlessLoginUnsuccessful: "Login is not successful.Url could be expired or used before",
            passwordlessLogin: "Login Without Password",
            loginWithEmail: "Login With Email",
            loginWithPassword: "Login With Password",
            enteringPasswordless: "Login Without Password...",
            toMainPath: "Redirect to Main Page",
            userRoleChanged: "Your permissions changed. You will be redirected to main page.",
            passwordChangeSuccess: "Your Password Changed Successfully  ",
            feedback: "Show Feedback",
            showFeedbackHistory: "Show messages that have been sent feedback",
            newSelfServiceSite: "New Self Service Site",
            subdomain: "Subdomain",
            rootUserEmail: "Email",
            rootUserName: "Name",
            newVersion: "New Version Available",
            closeLiveSupport: "Close Live Support",
            newVersionShort: "New Version",
            bannedWordRestrict: "Banned Word Blocking",
            ticketShow: "Allow Customers to Create Tickets",
            ticketShowDesc: "Enable the Ticket Creation Option in the Chat Menu",
            autoLoadIframe: "Live Traffic",
            autoLoadIframeDesc: "Auto Load Iframe , Pass All Visitor Traffic",
            bannedWordRestrictDesc:
                "When the Forbidden Word Blocking is turned on, representatives are prevented from typing the prohibited words defined in the system to the visitors.",
            agentDown: "Agent Down",
            delayChat: "Delayed Chat",
            tableSettingTippy: "You can change the information that will appear in the table.",
            tableSettings: "Table Settings",
            tableSettingsInfo:
                "You can change the information that will appear in the table. You can select 7 column at most",
            privateParametry: "Customized User Parameters",
            systemOperetor: "System Information",
            cityAndDistrict: "City/District",
            general: "General",
            availability: "Availability",
            home: "Home",
            successful: "Succesfull",
            forgetPasswordSent: "Reset password link email was sent , check your inbox",
            saturday: "Saturday",
            friday: "Friday",
            thursday: "Thursday",
            wednesday: "Wednesday",
            tuesday: "Tuesday",
            monday: "Monday",
            sunday: "Sunday",
            download: "Download File",
            calendarPassedTimeHour: "{name} for {hour} hour",
            calendarPassedTime: "{name} for {hour} hour {min} min",
            calendarPassedTimeMin: "{name} for {value} min",
            workScheduleOneDay: "{name}'s working schedule on {sDate}",
            workSchedule: "{name}'s working schedule between {sDate} - {eDate}",
            calendar: "Calendar",
            noRating: "There is no Rating to Show",
            rateDist: "Distribution of  Rates",
            distConversation: "Speech distribution by representatives",
            distributionConversa: "Scoring Distribution",
            distChatbotAgent: "Communication channels",
            distAgent: "Chatbot & Agent",
            distFugitive: "Missed Speech & Received Speech",
            distLive: "Live chat",
            distChatbot: "Chatbot",
            distComplex: "Chatbot + Live chat",
            distHandled: "Answered Chat",
            distMissed: "missed Chat",
            distWeb: "WebSite",
            distWhatsapp: "Whatsapp",
            distTelegram: "Telegram",
            distInstagram: "Instagram",
            totalWhatsappChatCount: "Whatsapp Chat Count",
            statsByTime: "Number of Chat by Time",
            selectRep: "Select a representative",
            allRepresentatives: "All Representatives",
            avgRating: "Rating Score({point}) ({count} Rating) ",
            avgFirstMessageTime: "Average Response Time",
            totalBreakTime: "System Break Time",
            totalBreakNum: "Break Count",
            averageConTime: "Average Conversation Time",
            multiWpReportTitle: "Number of Multiple WhatsApp Conversations",
            multiWpReport: "Multiple Whatsapp Chat Distribution",
            multiWpReportExplanation: "You Can See the Chat Amount of Your  Whatsapp Channels.",
            longestConTime: "Longest Conversation Time",
            shortestConTime: "Shortest Conversation Time",
            refresh: "Refresh",
            waitingReply: "Pending Messages",
            organizationName: "Organization Name",
            companySlogan: "Company Slogan",
            messageSentErr: "Message not send, Try again.",
            messageSent: "Message Sent.",
            openPrivateChat: "Open Representative Chat",
            escKey: "Hides active conversation",
            archiveChatKey: "Allows you to join the chat at the bottom of the Archive Page.",
            chatCopilot: "Turns on Chat CoPilot",
            privateChat: "Inter-Agents Conversation Panel",
            multiModeAlertDesc: 'SUPSIS is open in another window. Click "Use Here" to use SUPSIS in this window.',
            useHereText: "Use Here",
            brandVisibility: "SUPSIS brand label show up on chat bubble",
            focusInput: "Focus cursor active chat's input field ",
            send: "Send",
            notYet: "Not yet",
            sending: "Sending",
            onlyRepresentative: "Your message can seen only by representatives",
            yourMessage: "Your message",
            liveFabListDescription: "Live Support",
            messengerIntegrationDesc:
                "Chat with your customers via Facebook page, send automated messages with chatbot.",
            checkDepartmentToAgent: "Department where the online representative will be checked",
            ifAllOfflineStory: "Story to redirect if there is no online representative.",
            AssignMessagesToAgents: "Handle chats via live agents",
            firstChatbotAndAssign: "Handle chats via chatbots",
            hybridAssign:
                "If exists any live agent than on selected department  then handle  with live agents otherwise handle with chatbot.",
            ticketFabListDescription: "Ticket",
            whatsappFabListDescription: "Whatsapp",
            phoneFabListDescription: "Phone",
            emailFabListDescription: "E-mail",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Twitter",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "YouTube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "Type your {channelLink} channel link in this field.",
            typeYourAccountLink: "Type your {accountLink} account link in this field.",
            typeYourMessage: "Type your message here",
            typeYourMessageMail:
                "The message entered in this field will be sent by the Customer to the above mail address as the first message.",
            typeYourMessageDesc:
                "The message entered in this field will be sent by the Customer to the above phone number as the first message.",
            sendNumber: "Telephone number to send the message to: {path}",
            callNumber: "Phone number for your customer to call: {phoneNumber}",
            numberIsNotCorrect: "Missing number entered!!",
            emailIsNotCorrect: "E-mail Is Not Correct !",
            selectFab: "Select a Fab",
            notValid: "You can only enter letters. (Single character).e,d,f,z,a,x,c,v,w,t,n letters are invalid",
            forMacUsers: " Mac users can use  Control(⌃) shortcut",
            basePriceValue: "Base Price",
            basePriceDiscount: "Discount",
            basePriceCurrency: "Currency",
            customerDBEnabled: "Database Selection: Use Customer Database Server",
            customerDBDisabled: "Database Selection:  Use Supsis Database Server",
            mongoConnectionString: "Mongo Connection",
            whatsappBasePriceValue: "Whatsapp Base Price",
            whatsappPlusBasePriceValue: "Whatsapp Plus Base Price",
            instagramBasePriceValue: "Instagram Base Price",
            instagramPlusBasePriceValue: "Instagram Plus Base Price",
            clientAddress: "Client Address",
            customerClientAddress: "Customer Client Address",
            apiAddress: "Api Address",
            socketAddress: "Socket Address",
            backendAddress: "backend Address",
            panelLogoUrl: "Panel Logo Url",
            panelCustomCssUrl: "Panel Custom Css Url",
            customerLogoUrl: "Customer Logo Url",
            customerCssUrl: "Customer Css Url",
            siteAlias: "Site Alias",
            language: "Language",
            features: "Features",
            interactionPopularity: "Popularity of interactions",
            interactionCount: "Number of Interaction",
            uniqueUserCount: "Number of Unique User",
            allUserPercentage: "(%) Percent of All User",
            represantativeSettings: "Represantative Settings",
            documentTitle: "Supsis Document Form",
            supsisDocument: "Supsis Document",
            ApiDoc: "API Documentation",
            chatBalloonTehemeSettings: "Chat Balloon & Theme Settings",
            customLoginFormSettingsTitle: "Customize Visitor Login Form",
            addNewField: "Add New Field",
            editField: "Edit Field",
            typeHere: "Type the content here!",
            pco: "Cap. Uti. Rate",
            perPage: "/page",
            perPageInFilter: "Piece",
            noUserInfoFound: "No User Information Found",
            startFilter: "Start filter",
            showMyChats: "Show My Chats",
            showOnlineAgents: "Show Only Online Agents",
            showWaitingChats: "Show Waiting Chats",
            addNewStatus: "Add Status",
            newTitleContent: "New Title",
            newCTRLContent: "New CTRL Content",
            newALTContent: "New ALT Content",
            newTABContent: "New TAB Content",
            roleName: "Role Name",
            error: "Error",
            contentTitle: "Content Title",
            contentType: "Content Type",
            cannotMoveFullParent: "Cannot move this item",
            newSiteForm: "New Site Register Form",
            updateSiteForm: "Site Update Form",
            newBannedWordForm: "New Banned Word Register Form",
            updateBannedWordForm: "Banned Word Update Form",
            newWelcomeMessageForm: "New Welcome Message Register Form",
            updateWelcomeMessageForm: "System Message Update Form",
            newDefaultContentForm: "New Default Content Register Form",
            updateDefaultContentForm: "Default Content Update Form",
            newSubjectForm: "New Subject Register Form",
            updateSubjectForm: "Subject Update Form",
            showChatColorMeaning: "Chat Colors",
            showIntro: "Show Intro",
            options: "Options",
            resetPassword: "Reset Password",
            audioLevel: "Volume of audio alert",
            privateChatNotificationSound: "Notification sound",
            continue: "Continue",
            newRoleForm: "New Role Register Form",
            updateRoleForm: "Role Update Form",
            newRolePlaceHolder: "Click to new role",
            newUserForm: "New User Register Form",
            updateUserForm: "User Update Form",
            changeOSRForm: "Offline Change Message",
            tooltipOSRForm: "You can change the offline message.",
            newOSRForm: "Offline Support Form",
            newOSRMessages: "Add Offline Message",
            updateOSRForm: "Offline Update Form",
            osrTitle: "Title",
            osrTitleDescription: "You can add offline support form title",
            osrContent: "Content",
            osrContentDescription: "You can add offline support form content",
            hello: "Hello",
            cantProceedPayment: "Cause of we couldn't proceed payment",
            and: "and",
            suspendedPlan: " features are suspended",
            payNow: "PAY NOW",
            KeepUsingFeatures: "For Keep Using Your Features",
            date: "Date",
            startDate: "Start Date",
            finish: "Finish",
            start: "Start",
            search: "Search",
            endDate: "End Date",
            representative: "Representatives",
            representative_: "Representative",
            star: "Star",
            filter: "FILTER",
            reset: "RESET",
            dailyChatList: "Daily Chat List",
            dailyChatDuration: "Daily Chat Duration",
            chatDuration: "Chat Duration",
            dailyChatGraph: "daily Chat Graph",
            ok: "OK",
            cancel: "Cancel",
            chatCount: "Chat Count",
            shortest: "Shortest",
            longest: "Longest",
            average: "Average",
            count: "Count",
            averagePoint: "Average Point",
            pointDist: "Point Distribution",
            point: "Point",
            filters: "Filters",
            totalCustomer: "Total Customer",
            avResponseTime: "Average Reponse Time",
            breakDuration: "Break Duration",
            breakCount: "Break Count",
            lastLoginPlatform: "Platform",
            active: "Active",
            passive: "Passive",
            userForm: "User Form",
            sender: "Sender",
            profile: "Profile",
            name: "Name",
            number: "Number",
            username: "User name",
            email: "Email",
            password: "Password",
            oldPassword: "Old Password",
            newPassword: "New Password",
            passwordAtLeast: "Password (at least {num} character)",
            passwordRepeat: "Repeat Password",
            changePassword: "Change Password",
            status: "Status",
            enableState: "Active?",
            douYouWishToDeleteUser: "Dou you wish to delete this user?",
            userDeleted: "User Deleted",
            userSaved: "User saved.",
            oldPasswordError: "The old password is incorrect, please check.",
            chooseAnOption: "Please select a notification sound.",
            userVolumeUpdated: "Volume settings updated.",
            save: "Save",
            update: "Update",
            addNewMenu: "Add New Menu",
            addNewContent: "Add New Content",
            pleaseTitleEnter: "Please title enter",
            like: "Like",
            disLike: "Dislike",
            users: "Users",
            visitor: "Visitors",
            allContacts: "All Contacts",
            allUsers: "All Representatives",
            allSites: "All Domains",
            newUser: "New User",
            noNewUser: "There is no user yet.",
            noNewAdminUser: "There is no admin user yet.",
            noRoleFound: "There is no role yet.",
            noBannedWordFound: "There is no banned word yet.",
            noWelcomeMessageFound: "There is no system message yet.",
            noSubjectFound: "There is no subject yet.",
            noVisitorFound: "There is no visitor.",
            noContactFound: "There is no contact.",
            sendResponse: "Write a Response",
            delete: "Delete",
            noLiveSupportFound: "There is no visitor connect to live support",
            noLiveSupportFoundWithDepartment: "There is no speech belonging to the department",
            duplicate: "Duplicate",
            makeDefault: "Make Default",
            checkMore: "Check More",
            useReadyTemplates: "Use Ready Templates",
            useAITemplates: "Use GPT-4 AI Ready Templates",
            noRePresentativeFound: "There is no representative",
            noBannedVisitorFound: "There is no banned visitor yet.",
            removeBanDescription: "Remove ban",
            editThisItem: "Update this item",
            removeThisItem: "Remove this item",
            role: "Role",
            autoChatAssignLimit: "Auto Chat Assign Limit",
            chatAssignInfo: "-1 = System Default, 0 = No Assign, >0 = Assign as given value.",
            relatedDepartments: "Related Departments",
            subjectInfo: "If there is no selected subject, all subjects are allowed.",
            archive: "Archive",
            offlineSupportRequests: "Offline Supports",
            first: "First",
            last: "Last",
            query: "Start Searching",
            clean: "Clean",
            loading: "Loading",
            loadMore: "Load More",
            noMessage: "Is not any message",
            selectChat: "Pick a Chat",
            noMessageInChat: "There is no message in this chat",
            noMediaToShow: "No Media to Show",
            userInfo: "User Info",
            firstSeen: "First Seen",
            chatId: "Chat ID",
            visitorId: "Visitor ID",
            visitingPage: "Visiting Page",
            osAndBrowser: "Operating System & Browser",
            customerClientVersion: "Customer Client Version",
            visitorFeedback: "Visitor Feedback",
            notes: "Notes",
            nameSurname: "Name & Surname",
            chats: "Chats",
            bannedVisitors: "Banned Visitors",
            country: "Country",
            city: "City",
            cityDistrict: "City District",
            browser: "Browser",
            os: "Operating System",
            ipAddress: "IP Address",
            connectionDate: "Connection Date",
            transaction: "Transaction",
            banRemoved: "Ban Removed.",
            bannedWords: "Banned Words",
            newBannedWord: "New Banned Word",
            noBannedWord: "No banned word yet.",
            bannedWordForm: "Banned Work Form",
            word: "Word",
            bannedWordAndWordGroup: "Banned word / work group",
            doYouWishToDeleteBannedWord: "Dou you really wish to delete this banned word?",
            doYouWishToOfflineSupportRequest: "Dou you really wish to delete this message?",
            bannedWordSaved: "Banned word saved",
            deletedSuccessfully: "Deleted Successfully",
            deleteErrorMsg: "Error: It's not deleted, try again",
            socketError: "Socket connection error. Please refresh page and try again.",
            socketConnecting: "Connecting to server",
            offlineModeDescription: "System down, customers will not be able to access live support.",
            offlineModeSettingsDescription: "Check the Offline Mode feature in the settings menu.",
            offlineModeUser: "There must be at least one online representative in the system.",
            offlineModeMessage: "Offline Message",
            offlineMode: "Offline Mode",
            adminCannotConnectSocket: "Admin cannot connect to socket.",
            liveSupport: "Live Support",
            siteVisitors: "Site Visitors",
            visitors: "Visitors",
            mail: "Mails",
            thoseConnectedToLiveSupport: "Those who connected to live support",
            visitorHistory: "Visitor History",
            visitorHistoryDescription: "You can view and download visitor chat history.",
            privateMessage: "Private Message",
            addRepresentative: "Add Representative",
            forwardRepresentative: "Forward Representative",
            keyboardShortcuts: "Keyboard Shortcuts",
            chatColorMeanings: "Chat color meanings",
            connLostCheckInternet: "Connection lost, please check your internet connection.",
            wishToEndThisChat: "Dou you wish to end this chat?",
            defaultContents: "Templates",
            contents: "Contents",
            newDefaultContent: "New Default Content",
            title: "Title",
            shortcutChar: "Shortcut Character",
            pickOne: "Pick one",
            writeSomething: "Write a character (a-z|0-9)",
            letterSequence: "Letter Sequence",
            exampleText: "Example: soc -> soccer",
            anyChar: "Any character",
            shorcutKey: "Shortcut Key",
            content: "Content",
            shortcutName: "Shortcut Name",
            type: "Type",
            shortcut: "Shortcut",
            defaultContentForm: "Default Content Form",
            deleteContentQuestion: "Do you really wish delete this Default Content?",
            defaultContentDeleted: "Default Content deleted",
            defaultContentSaved: "Default Content saved.",
            contentMoved: "Content Moved.",
            yourEmail: "Email Address",
            yourName: "Your Name and Surname",
            login: "Login",
            lostPassword: "Forgot Password",
            multipleSession: "You are signed in elsewhere.",
            notAuthorizedToDisplayPage: "You are not authorized to see this page!",
            permissions: "Permissions",
            newPermission: "New Permission",
            permissionForm: "Permission Form",
            displayTitle: "Display Title",
            key: "Key",
            keyToUseInSystem: "Key value to use in the system",
            deletePermissionQuestion: "Do you really wish to delete this permission?",
            permissionDeleted: "Permission deleted.",
            permissionSaved: "Permission Saved.",
            newRole: "New Role",
            selectARole: "Select a Role",
            yes: "Yes",
            no: "No",
            fullAuth: "Full Authorization",
            roleDeleted: "Role deleted.",
            roleSaved: "Role saved.",
            roleForm: "Role Form",
            roles: "Roles",
            settings: "Settings",
            selectTopic: "Select Department",
            autoCallTransfer: "Auto Call Transfer",
            customerTyping: "Customer typing",
            typing: "Typing",
            agentTyping: "Representative typing",
            disconnectTime: "Max Reconnection Time (sec)",
            tippyDissconnectTime: "When a chat inactive after how many seconds conversation will end.",
            queueNumberVisibleFeature: "Show Queue Number to Visitor",
            privateChatEnabled: "Show The Chat Between Representatives",
            delayedTalkTime: "Delay Time (sec)",
            employeeAverageChatCount: "Average chat number for employee chat rate",
            customerDownTimeWhenRepExit: "Customer downtime when representative leaves (sn.)",
            autoAssignLimit: "Auto Assign Limit",
            wasted: "Conversation Lost Time (sec)",
            settingFormWrong: "Form data is wrong, try again after check it",
            settingsSaved: "Settings saved.",
            settingsCannotSaved: "Settings Cannot Be Saved",
            noAuthorization: "No Authorization",
            warningBadInput: "It is recommended to enter a number between 0 and 70.",
            warning: "WARNING!",
            warningBadInputMarginY: "Warning About Vertical Margin Input ⚠️",
            warningBadInputMarginX: "Warning About Horizontal Margin Input ⚠️",
            warningBadInputBubbleSize: "Warning About Chat Bubble Input ⚠️",
            delayTime: "Delay Time (sec)",
            sites: "Sites",
            newSite: "New Site",
            noSiteYet: "There is no site yet.",
            siteAddress: "Site Address",
            turnBack: "Return Back",
            customerRepLimit: "Customer Representative Limit",
            siteSaved: "Site saved.",
            siteSaveError: "An error occured during creating site",
            subjects: "Subjects",
            newSubject: "New Subject",
            noSubject: "No subject yet.",
            subject: "Subject",
            subjectTitle: "Subject Title",
            description: "Description",
            infoAboutSubject: "Information about subject",
            deleteSubjectQuestion: "Do you really wish to delete this subject?",
            subjectDeleted: "Subject deleted.",
            subjectSaved: "Subject saved.",
            welcomeMessages: "System Messages",
            newWelcomeMessages: "New Welcome Message",
            noWelcomeMessage: "No System Message.",
            welcomeMessageContent: "System message content",
            makeChoice: "Make a choice...",
            welcomeMessage: "Welcome Message",
            repLoggedIn: "Representative logged in",
            loginMessage: "Log in message",
            message: "Message",
            deleteWelcomeMessageQuestion: "Do you really wish to delete this system message?",
            welcomeMessageDeleted: "System message deleted",
            welcomeMessageSaved: "System message saved.",
            welcomeMessageForm: "System Message Form",
            noRep: "There is no representative yet.",
            addChat: "Add Chat",
            forwardChat: "Forward Chat",
            ago: "ago",
            repName: "Representative Name",
            lastOnline: "Last Connection/Online time",
            lastStatusChange: "Last Status Change",
            activeChat: "Active Chat",
            userMaxCapacity: "Max Chat Capacity",
            noActiveChat: "No active chat",
            watch: "WATCH",
            join: "JOIN",
            open: "OPEN CONVERSATION",
            directMessage: "PRIVATE MESSAGE",
            block: "BLOCK",
            transactions: "Transactions",
            informations: "Informations",
            visitStart: "Visit Start",
            fullName: "Fullname",
            waitChatTime: "Waiting/Chatting Time",
            blockUserConfirm: "Do you want to block this user?",
            messaging: "Messaging",
            hideChat: "Hide Chat",
            block_: "Block",
            privateMessage_: "Private Message",
            assignRep: "Assign Representative",
            joinChat: "Join Chat",
            forwardRep: "Forward",
            leaveChat: "Leave Chat",
            endChat: "End Chat",
            translatedTextDescription: "Amazon translated this message {from} -> {to}.",
            autoTranslate: "Auto Translate",
            translateThisMessage: "Translate this message",
            autoTranslateDetectedDesc:
                "Visitor language is {visitorLanguage}. Click Here to Activate Automatic Translation",
            on: "on",
            off: "off",
            copy: "Copy",
            prevChats: "Previous Chats",
            noShortCut: "No shortcut",
            leaveChartConfirm: "Dou you really wish to leave the chat?",
            endChatConfirm: "Dou you wish to end the chat?",
            endConversation: "End Conversation",
            onlyOneRep: "You are the only representative in this conversation!",
            chatList: "Chat List",
            chatBar: "Chat Bar",
            unreadTitle: "Unread",
            visitorLeftTitle: "Visitor Left",
            activeChatTitle: "Active Chat",
            autoAssignedTitle: "Auto Assigned Chat",
            watchModeTitle: "Watch Mode",
            lostChat: "Representative Connection Lost",
            chatWidthDelay: "Chat with Delay",
            repChatWidthDelay:
                "When there is no active representative in the system or all of our representatives full due to high traffic, chat background will be green  ",
            repLostConn: "If customer representative has lost connection, chat background will be pink.",
            unreadMsg: "If there are unread messages, the background will be light blue.",
            visitorLeftChat: "If the visitor left the conversation, the background becomes dark gray.",
            activeChatMsg: "Background is green if chat is active",
            autoAssignMsg:
                "The background becomes mustard if assigned by automatic assignment and the conversation is not looked further",
            watchModeMsg: "If turned on in playback mode, the background becomes red",
            online: "Online",
            beRightBack: "Away",
            away: "Away",
            busy: "Busy",
            offline: "Offline",
            logout: "Log out",
            forWindows: "For Windows",
            forMac: "For Mac",
            nextChatFromActive: "Switch from active to next conversation",
            previousChatFromActive: "Switch from active to previous",
            hideActiveChat: "Hide active conversation",
            closeActiveChat: "Close active conversation",
            firsthiddenChat: "Join most waited customer's chat",
            firstChatWaiting: "Switch to waiting conversation",
            previousOpenedChat: "Regardless of the order, skip to the previously opened conversation",
            historyDetails: "History Details",
            chat: "Chat",
            chatNotFound: "Chat Not Found.",
            dataNotFound: "No Data Found.",
            visitorInfo: "Visitor Info",
            timeSpent: "TimeSpent",
            noActiveVisitors: "No active visitors",
            totalConnected: "Conversation Count",
            missedChat: "Missed Chat Count",
            workTime: "Work Time",
            closedChatCount: "Closed Chat",
            activeConvo: "Active conversation",
            notAnswered: "Not yet answered",
            delayedConvo: "Delayed",
            leavingRep: "Leaving representative",
            staffRate: "Staff Working Rate",
            select: "Dropdown Menu",
            fullname: "Full Name",
            text: "Text",
            numeric: "Number",
            phone: "Phone",
            optionsPlaceholder: "Option value",
            selectField: "Click if you want to add a dropdown menu",
            fullnameField: "Click if you want to add a full name field.",
            textField: "Click if you want to add a text field.",
            labelField: "Click if you want to add a description field.",
            numericField: "Click if you want to add a numeric field.",
            phoneField: "Click if you want to add a phone field.",
            departmentField: "Click if you want to add a department field.",
            emailField: "Click if you want to add a email field.",
            visible: "Visible",
            required: "Required",
            label: "Comment",
            customLoginAlert: "Your Login Form must contain least one  visible field.",
            atLeastOneLanguage: "You must feel at least one language",
            requiredFieldField: "This field is required",
            notRequiredField: "This field is not required",
            visibleField: "This field is visible",
            notVisibleField: "This field does not appear in the form.",
            connectServer: "You are connected to the server",
            disconnectServer: "You are not connected to the server",
            liveChatOff: "Live chat is off",
            visitorScreen: "Visitor Screen",
            viewOnTheSite: "View On The Page",
            viewOnTheSiteTippy: "Click Here To See How Your Changes Hold Up.",
            showHint: "Show Hint",
            dontShowHint: "Don't Show Hint",
            liveChatOn: "Live chat is on",
            nightModeOff: "Night mode off",
            doubleClickEdit: "Double click or press the edit button to edit.",
            edit: "Edit",
            deleteField: "Delete",
            arrow_upward: "Arrow Upward",
            arrow_downward: "Arrow Downward",
            newCatalogCategory: "New Catalog Category",
            childCreate: "Double click to create a new child",
            updateCatalogCategoryFrom: "Update Catalog Category Form",
            newCatalogCategoryFrom: "New Catalog Category Form",
            catalogCategoryMenu: "Add catalog category menu",
            catalogCategoryLeaf: "Add catalog category submenu",
            catalogCategoryName: "Catalog category name",
            newCatalogContentFrom: "New Catalog Content Form",
            catalogContentName: "Catalog content name",
            catalogCategorySaved: "Catalog category saved",
            catalogCategoryDeleted: "Catalog category deleted",
            catalogCategoryRate: "Content Rate",
            catalogContentFeature: "Catalog Content feature",
            vtipyAudioLevel: "Used to mute or unmute notification sounds.",
            vtipyOrganizationName: "You can change the organization name and update it.",
            vtipyBrandVisibility: "Supsis is the setting whether the tag can be displayed in the chat bubble.",
            vtipyBrandVisibilityForced: "Only ProPlan users can change!!",
            vtipyClientDefault: "You can change the agent page language here.",
            vtipyCustomerClientDefault: "You can change the language of the customer (Chat) page here.",
            vtipyVisitorPreferredLang: "The customer can select the spoken language on the (Chat) page.",
            vtipyCustomerClientLanguageDetect: "You can change the language of the customer (Chat) page here.",
            vtipySelectTopic: "Automatic assignments to existing representatives in the selected department occur.",
            vtipyAutoCallTransfer: "Automatically assigns waiting calls to available agents.",
            vtipyCustomerTyping:
                "It allows you to see what the customer wrote on the chat screen on the representative chat screen.",
            vtipyAgentTyping: "It give information when representative typing to customer in chat buble",
            vtipyQueueNumberVisibleFeature:
                "When representatives are busy, it shows customers who want to connect, in what order they are.",
            vtipyPrivateChatEnabled: "Shows the inter-agent conversation panel.",
            vtipyDelayedTalkTime:
                'If no delegates are connected to the conversation during this time, it will be labeled \\ "Delayed Chat \\',
            vtipyOfflineMode: "Allows you to put the system in offline mode.",
            vtipyAutoAssignLimit:
                "It determines how many customers (chat) will be assigned to the representative automatically.",
            vtipyCustomerDownTimeWhenRepExit: "Customer idle time when the representative exits (sec.)",
            tippyDisconnectTime: "The chat close time after disconnect the customer (sec).",
            changeSettings: "Change Global Settings",
            totalBg: "TOTAL CHATS",
            activeBg: "YOUR CHATS",
            watchBg: "WATCH",
            waitingBg: "QUEUE CHATS",
            lateBg: "MOST WAITING CHATS",
            freeBg: "FREE",
            maxCapacityBg: "MAX CAPACITY",
            addNewSettings: "Add a New Global Settings",
            darkMode: "Dark Mode",

            clientDefault: "Panel default language",
            customerClientDefault: "Customer client default language",
            customerClientLanguageDetect: "Customer Client Language Auto Detect",
            visitorPreferredLang: "Let the customer choose the spoken language",
            preferredThemeColor: "Preferred Theme Color For Client Chat Screen",
            detail: "Detail",
            supportUs: "Contact Us (Live Support)",
            langSetting: "Language Setting",
            changeLang: "Change Language",
            fontSizeSetting: "Screen Zoom Setting",
            changeLangDesc: "Changes application language to {code}",
            trLang: "Turkish",
            enLang: "English",
            fieldRequired: "{field} field is required",
            selectALanguage: "Select a Language",
            selectATheme: "Select a Theme",
            responseForm: "Response Form",
            clientRequestInfo: "Client Request Info",
            createdDate: "Created Date",
            descMessage: "Messages",
            new: "New",
            selectAllPermission: "Select All",
            catalogCategories: "Catalog",
            copiedClipboard: "Copied to clipboard",
            changeLogo: "Change Logo",
            changePhoto: "Change the Photo",
            addPhoto: "Add a Photo",
            seePhoto: "See The Photo",
            deletePhoto: "Delete the Photo",
            organizationLogo: "Organization Logo",
            changePlan: "Change Plan",
            close: "Close",
            vtipyUploadLogo:
                "By uploading your company logo from this area, you can use your own logo in customer emails and customer pages.",
            tagName: "Tag Name",
            tagDescription: "Label Description",
            tagColor: "Label Color",
            userInformations: "User Informations",
            incomingChat: "Incoming Chat",
            support: "Support",
            team: "Team",
            groups: "Groups",
            newConversationStarted: "New converstaion started",
            allHistoryLoaded: "All history loaded",
            chatCreator: "Chat Creator",
            enterGroupTitle: "Enter group title",
            requiredTitle: "Title cannot be empty",
            requiredChannel: "Channel name cannot be empty",
            next: "Next",
            selectPeople: "Select people",
            textLimitAlertMessage:
                "The character limit in WhatsApp is 19 characters and beyond this limit it will not be displayed. However, on the web, texts exceeding the 19-character limit are automatically moved to the next line and displayed.",
        },
        telegram: {
            typeInTelegramToken: "Type In Telegram Token",
            token: "Token",
            telegram: "Telegram",
            telegramTokenTitle: "Telegram Supsis Integration",
            telegramAlertForm: "You can get telegram bot token from",
            telegramAlertTitle: "Do you really want to delete the token?",
            telegramAlertText: "The token will be lost permanently!",
        },
        wp: {
            chatStarted: "Chat Started",
            chatNotStarted: "Chat Not Started",
            contactSelected: "contact selected",
            startChatWithAnyNo: "Start Chat with Any Number",
            toLittleChar: "Missing number !",
            typeInANumberDesc: "Type in number to starting chat with:",
            wpPlusAndLicenceRequired: "Whatsapp Plus Plan and Licence Required.",
            wpPlusAndLicenceRequiredDesc:
                "Before you can start chats with numbers that are not registered in your contacts, you must upgrade your whatsapp plan and get a license..",
            chatStartingWait: "Conversation starting, Please wait",
            whatsapp: "Whatsapp",
            agreement: "Agreement",
            purchase: "Purchase",
            activating: "Whatsapp Service Activation",
            authenticating: "QR Code Authentication",
            ready: "Ready",
            enableFeature: "Enable Whatsapp Feature",
            readAndAgree: "I have read and agree",
            subscribe: "Subscribe",
            subscribed: "Subscribed",
            toEnableWpDescription: "To enable Whatsapp Features , click on the button below.",
            waitForWpActivationDescription:
                "Your whatsapp account service is activating. Please wait for a while. It takes about 10-30seconds.",
            greatWpActivatedDescription: "Great, Your whatsapp account service is activated!",
            unsubscribe: "Unsubscribe",
            planDetails: "Features",
            sendReceiveMessage: "Send & Receive Text Messages",
            sendReceiveImage: "Send & Receive Image Files",
            sendReceiveAudio: "Send & Receive Audio Files",
            sendReceiveGif: "Send & Receive GIF Files",
            startChat: "Start Chat on Supsis",
            supsisFunctionality: "Useful Supsis Chat Functionality",
            onePhoneMultiAgent: "One Phone and Multiple Agents",
            basicIntegration: "Basic Integration and Zero Configuration",
            activationTitle: "To activate whatsapp integration on supsis:",
            wpIntegrationInstruction1: "Open WhatsApp on your phone",
            wpIntegrationInstruction2: "Tap Menu or Setting. Click Linked Devices",
            wpIntegrationInstruction3: "Point your phone to this screen to capture the code",
            qrGeneratingWait: "QR Code Generating please wait...",
            pleaseContinueToWaitUntilCompleted:
                "After the QR Code is verified, it will automatically switch to the completed field. Please wait...",
            authenticatingWait: "Authenticating, please wait...",
            unsubscribeWpInetgration: "Unsubscribe Whatsapp Integration",
            unsubscribeIGIntegration: "Unsubscribe Instagram Integration",
            wpBack: "Back",
            terminatelWpInetgration: "When clicked the 'Unsubscribe' button, your whatsapp integration will terminate",
            cancelWpInetgration: "Do you want to cancel whatsapp integration?",
            terminatelIGIntegration: "When clicked the 'Unsubscribe' button, your instagram integration will terminate",
            cancelIGIntegration: "Do you want to cancel instagram integration?",
            startChatWp: "Start Chat",
            purchaseHeader: "Supsis-Whatsapp Integration Purchase",
            wpServices: "Whatsapp Service",
            wpServicesIntegrationCompleted: "Your whatsapp integration is completed. You can now use the service.",
            purchasePaymentDescription:
                "Whatsapp Feature billed month-to-month. Your whatsapp service will be activated after you accept subscription.",
            wpIntegrationFeatures: "Whatsapp Integration Features",
            saveChanges: "Save Changes",
            contactList: "Contact List",
            broadcast: {
                broadcast: "Broadcast",
                detail: "Broadcast Detail",
                customer: "Customer",
                phoneNumbers: "Contact Numbers",
                showMore: "Show More",
                groupName: "Group Name",
                messages: "Messages",
                status: "Status",
                usageCost: "Usage Cost",
                sendingTime: "Sending Time",
                progress: "Progress",
                groupDetail: "Group Detail",
                messagesPerContact: "Messages Per Contact",
                successRatio: "Success Ratio",
            },
            messages: "Messages",
            broadcastRequests: "Broadcast Requests",
            customerGroups: "Customer Groups",
            messageTemplates: "Message Templates",
            plans: "Plans",
            wpIntegrationRequired: "Whatsapp Integration Required",
            wpRequiredIntegrationDescription:
                "Sorry, the page you visited will be activated when integrate your whatsapp.",
            integrateWp: "Let's go, Integrate Whatsapp",
            active: "Active",
            archived: "Archived",
            createBroadcastMessage: "Create Broadcast Message",
            title: "Title",
            description: "Description",
            createdAt: "Created At",
            numbers: "Numbers",
            actions: "Actions",
            action: "Action",
            createCustomerGroup: "Create a custom customer group",
            search: "Search",
            name: "NAME",
            contacts: "Contacts",
            noContactFound: "No Contact Found",
            broadcastTitle: "Give a title your broadcast.",
            recipients: "Recipients",
            selectRecipients: "Select Recipients",
            writeYourMessage: "Write your message.",
            schedule: "Schedule",
            scheduleNowOrLater: "Schedule now or later",
            summary: "Summary",
            cancel: "Cancel",
            send: "Send",
            sending: "Sending",
            deleteCustomerGroup: "Are you sure delete this customer group? {name}",
            customerGroupDeleting: "Customer group deleting ...",
            customerGroupDeletingSuccess: "Customer group deleted successfully",
            customerGroupDeletingError: "Error while deleting customer group",
            wpPlusRequired: "Whatsapp Plus Plan Required.",
            broadcastMessageArchived: "Broadcast Message as archived",
            broadcastMessageNotArchived: "Broadcast Message is not archived",
            groupNameSearch: "Type Customer Group Name",
            groupNameDesc: "Customer group name identify your customer groups",
            save: "Save",
            number: "NUMBER",
            addColumn: "Add Column",
            addColumnDesc: "Add a column to table",
            addNewContact: "Add New Contact",
            addNewContactDesc: "Add a contact to table",
            importFile: "Import From File",
            importFileDesc: "Import contacts from excel or csv file",
            contactAdded: "Contact added",
            updateCustomerGroup: "Updating customer group...",
            updateCustomerGroupSuccess: "Customer group updated successfully",
            sendBroadcastMessage: "Send Broadcast Message",
            columnName: "Column Name",
            columnType: "Column Type",
            defaultValue: "Default Value",
            setDefaultValue: "Set the default value to exists  contacts",
            age: "Age",
            location: "Location",
            gender: "Gender",
            selectContactFile: "Select Contact File",
            selectContactCsvOrExcel: "Select a CSV or EXCEL file.",
            importConfiguration: "Import Configuration",
            customizeFile: "Customize your import configuration.",
            sendMessageTo: "Who do you want to send the message to?",
            allContact: "All Contact",
            messageTypes: "Message Types",
            whenSendMessage: "When do you want to send the message to?",
            instantlyRightNow: "Instantly Right Now",
            completed: "Completed",
            scheduleFuture: "Schedule for a future date",
            messageDesc: "Your message will be sent instantly to all the recipients",
            messageSendAt: "Your message will be sent to all the recipients at",
            estimatedPrice: "Estimated Price",
            estimatedTime: "Estimated Time",
            now: "Now",
            tenMinute: "10 Minute",
            cancelled: "Cancelled",
            failed: "Failed",
            running: "Running",
            queued: "Queued",
            scheduled: "Scheduled",
            noNumberAdded: "No Numbers Added",
            csvOrExcelFile: "CSV or Excel File",
            broadcastMessagesToContactFile: "Broadcast Messages to Contact List",
            broadcastMessageTemplates: "Broadcast Message Templates",
            messageFlow: "Message Flow",
            textMessageSupport: "Text Message Support",
            imageMessageSupport: "Image Message Support",
            spamPreventions: "Spam Preventions",
            includesAllBasicPlans: "Includes all in Basic Plan",
            chatbotIntegration: "Chatbot Integration",
            messageToNewNumbers: "Message to New Numbers",
            broadcastMessageToEveryone: "Broadcast Messages to Everyone",
            personalizedBroadcastMessage: "Personalized Broadcast Messages",
            customerGroupSegmentation: "Customer Group Segmentation",
            scheduleBroadcastMessage: "Schedule Broadcast Message",
            locationMessageSupport: "Location Message Support",
            advancedSpamPreventions: "Advanced Spam Preventions",
            whatsappPlans: "Whatsapp Plans",
            selectBestPlan: "Choose the plan that suits you",
            comingSoon: "Coming Soon...",
            selectFile: "Select a file",
            created: "Created",
            message: "Message",
        },
        ig: {
            instagram: "Instagram",
        },
        ticket: {
            ticketTagFilter: "Ticket Filter Tag",
            ticketEmails: "Ticket Forwarding Email List",
            save: "Save",
            delete: "Delete",
            transactions: "Options",
            noEmailTicketNotifications: "There is no data",
            emailIsNotValid: "Email is not valid",
            emailNotificationDeleted: "Item deleted successfully",
            emailNotificationDeleteError: "An error occurred",
            tagFilterRequired: "Ticket Filter Tag Required, Use *(wildcard) tag for all tickets",
            emailsRequired: "Forwarding Emails must not be null",
            emailNotificationCreated: "Ticket Forwading Rule Created",
            emailNotificationCreateError: "An error occurred",
            ticketForwarding: "Ticket Email Forwarding",
            ticketTagFilterDesc:
                "It uses the ticket topics you used in the chatbot design to filter the tickets. You can write a different tag and press enter to add it. If you select the '*' tag it will select all tickets",
            ticketEmailsDesc:
                "Email list to which tickets will be forwarded. You can add the addresses of the representatives in the system by selecting them. You can also add non-system email/s.",
            ticketList: "Ticket Forwarding Rules",
            ticketTagFilterPlaceHolder: "Ticket filter, select '*' for all",
            ticketEmailsPlaceHolder: "Forwarding email list",
        },
        theme: {
            opacity: "Opacity",
            headerColor1: "Hader Section Color 1",
            headerColor1A: "Hader Section Opacity 1",
            headerColor2: "Header Section Color 2",
            headerColor2A: "Header Section Opacity 2",
            backgroundColor: "Background Color 1",
            backgroundColorA: "Background Opacity 1",
            backgroundColor2: "Background Color 2",
            backgroundColor2A: "Background Opacity 2",
            textColor: "Text Color",
            errorTheme: "Error Color",
            bubbleBackground: "Representative bubble color",
            bubbleVisitorBackground: "Customer bubble color",
            bubbleBackgroundA: "Representative bubble opacity",
            bubbleVisitorBackgroundA: "Customer bubble opacity",
            bubbleText: "Representative text color",
            bubbleVisitorText: "Customer text color",
            textFormColor: "Form color",
            selectCustom: "Select Custom Theme",
            headerColorSecond: "Header Top Color",
            headerColorFirst: "Title Bottom Color",
            backgroundColorFirst: "Background Top Color",
            formColor: "Form Text Color",
            buttonColor: "Button Color",
            backgroundColorSecond: "Background Bottom Color",
            chatBotButtonText: "Chatbot Font Color",
            chatBotButtonColor: "Chatbot Button Color",
        },
        billing: {
            paymentStatus: "Payment Status",
            amount: "Amount",
            invoiceID: "Invoice ID",
            expected: "Expected..",
            currentAmount: "Current Amount",
            monthlyEstimatedAmount: "Monthly Estimated Amount",
            creationDate: "Creation Date",
            invoiceStatus: "Invoice Status",
            invoicePeriod: "Invoice Period",
            newPaymentMethod: "New Payment Method",
            channelCount: "Channel Count",
            remainingTime: "Remaining Time",
            chatbotLimit: "Chatbot Limit",
            free: "Free",
            maxChatbotSession: "Maximum Chatbot Sessions",
            buyIt: "Buy It",
            renewalDate: "Renewal Date",
            monthly: "Monthly",
            yearly: "Yearly",
            packagePeriod: "Package Period",
            packageType: "Package Type",
            packageManagement: "Package Management",
            invoiceManagement: "Invoice Management",
            futureInvoice: "Future Invoice",
            pastInvoices: "Past Invoices",
            creditCard: "Credit card",
            invoice: "Invoice",
            mustBeUpgradePlanForChatBot: "To activate the ChatBot feature, you must switch to the Pro Plan!",
            incorrect: "Incorrect",
            cardInfo: "Card Info",
            billingDetails: "Billing Details",
            firstPreferredCard: "Set as Primary Card",
            primary: "Primary",
            addCardIyzico:
                "You do not have a registered card. In order to pay your monthly usage fees, you need to add a card. The payment system is provided by iyzico.",
            billingPlanSettings: "Billing & Invoice",
            startWith: "{cardFamily} card starts with {binNumber}",
            paymentMethod: "Payment Method",
            billingDate: "Billing Date",
            isPaid: "Is Paid?",
            paid: "Paid",
            unPaid: "Unpaid",
            billingHistory: "Invoice History",
            markPaid: "Mark as Paid",
            paymentDate: "Payment Date",
            pay: "Pay",
            newInvoice: "Create Invoice",
            updateBilling: "Update Billing Detail",
            updateCard: "Change Credit Card",
            paymentBilling: "Payment Method & Billing Details",
            price: "Price",
            billingAddress: "Billing Address",
            billingCity: "City",
            billingCountry: "Country",
            contactName: "Billing Contact Name",
            expireMonth: "Expire Month",
            expireYear: "Expire Year",
            cardNumber: "Card Number",
            cardHolderName: "Card Holder Name",
            cardAlias: "Card Alias",
            identityNumber: "Identity Number",
            name: "Name",
            surname: "Surname",
            email: "Email",
            addCard: "Add Card",
            update: "Update",
            cancel: "Cancel",
            save: "Save",
            saving: "Saving",
            noInvoiceFound: "There is no invoice",
            year: "Year",
            updating: "Updating...",
            newInvoiceForm: "New Invoice Create Form",
            error: "Error",
            transactions: "Options",
            paymentMethodAdded: "Payment method has successfully added",
            paymentMethodAddError: "Payment method has not added, An error occurred",
            creditCardChanged: "Credit card has successfully changed ",
            errorOccurred: "An error occurred , try again",
            billingDetailUpdated: "Billing detail has successfully updated",
            invoiceCreated: "Invoice has successfully created",
            paymentSuccess: "Payment successfully , thank you",
            paymentFail: "Payment fail, try again",
            billingAddressChanged: "Billing address has successfully changed ",
            hidePlan: "Hide Plan",
            informationShopping:
                "Your payment information, billing information, credit card information are controlled by Shopify.",
            trialTimeInformation:
                "Trial ends {dayCount} days after. If you do not enter a payment method until the expiry of this period, you will be automatically switched to the FREE PLAN by the system.",
            trialTimeInformationShort: "Trial: Last {dayCount} Day",
            currentPlanLabel: "Current Plan: {planName} ({agentCount} Agent)",
            changeCancelPlan: "Change/Cancel Plan",
            oneAgent: "Agent",
            agent: "Agent",
            yourCurrentPlan: "Current Plan",
            month: "Month",
            billedMonthToMonth: "(billed month-to-month)",
            selectAgentCount: "Select Agent Count",
            selectFreePlan: "Select Free Plan",
            planDetails: "Plan Details",
            multiAgent: "(Multi Agent)",
            selectProPlan: "Select Pro Plan",
            foreverFree: "Forever Free",
            websiteIntegration: "Website Integration",
            websiteIntegrationUnlimited: "Website Integration",
            ChatBotUnlimited: "ChatBot",
            videoCallUnlimited: "Video Call",
            multiAgentUpTo: "Multi Agent (up to {agentCount} Agent)",
            audioCallUnlimited: "Audio Call",
            screenSharingUnlimited: "Screen Sharing",
            fileTransferUnlimited: "File Transfer",
            autoChatAssignerUnlimited: "Auto Chat Assigner",
            multiLanguageTranslationUnlimited: "Auto Translate",
            detailedReporting: "Reporting",
            days30TrialsAvailable: "30-days trials available",
            limitedArchiveLookupLastMo: "Limited Archive Lookup (Last {monthCount}-mo)",
            fullCustomizationUnlimited: "Customization",
            planUpdated: "Great, your plan is updated.",
            planUpdating: "Your Plan is Updating...",
            planUpdatingDescription: "Please wait during your plan updating",
            done: "Done",
            freePlanUpdated: "Your plan updated as a Free Plan. (Max Agent Credit: 1)",
            proPlanUpdated: "Your plan updated as a PRO Plan. (Max Agent Credit: {agentCount})",
            canNotDwnGrade:
                "Cannot downgrade your plan from PRO {agentCountFirst} Agent(s) to {valNewPlnToUppr} {agentCountSecond}. Your agent credits in use.  ",
            deleteWarning: "You must delete or disable {valDif} Agent(s)",
            warnMessage: "Selected plan must be different than current plan",
            add: "Add",
            cancelYourPlan: "Cancel Your Plan",
            upgradeYourPlan: "Upgrade Your Plan",
            downgradeYourPlan: "Downgrade Your Plan",
            agree: "AGREE",
            disagree: "DISAGREE",
            invoices: "Invoices",
            priceIntervals: "Price Interval",
            selectSiteAlias: "Select or Enter Site Name",
            selectPriceInterval: "Select or Enter Price Interval",
            isRefunded: "Is Refunded?",
            invoiceId: "Invoice No",
            siteId: "Site No",
            createdDate: "Created Date",
            failCount: "Number of Failed Payment Fetch Attempts",
            failDate: "Failed Payment Date",
            Dashboard: "Dashboard",
            Agents: "Agents",
            Integration: "Integration",
            Settings: "Settings",
            Contacts: "Contacts",
            Domain: "Domain",
            lastActivity: "Last Activity",
            basePrice: "Base Price",
            packagePrice: "Package Price",
            whatsappPrice: "Whatsapp Price",
            realtimeVisitorCount: "Real Time Visitor",
            suspend: "Suspend",
            partner: "Partner",
            plan: "Plan",
            trialDay: "Trial Days",
            mobile: "Mobile",
            webSite: "Web Site",
            websiteOrigins: "Web Site Origin",
            ownerName: "Owner Name",
            ownerEmailAddress: "Owner Email",
            discount: "Discount",
            daysLeft: "Days Left",
            newTrialPopUp: "How Many Days Should the New Trial Period Be?",
            newWpPricePopUp: "How Much Is The New Whatsapp Fee?",
            newIGPricePopUp: "How Much Is The New Instagram Fee?",
            newBasePricePopUp: "How Much Is The New Base Price?",
            siteInfoUpdated: "Site Information Updated",
            siteInfoNotUpdated: "Site Information Not Updated",
            siteInfoNotUpdatedErr: "Error Occured! Site Information Not Updated.",
        },
        tour: {
            closeChat: "Close Chat",
            ticket: "Ticket",
            formStep: "Form Step",
            menuStep: "Menu Step",
            contentStep: "Content Step",
            menuTitle: "Menu Title",
            messageContent: "Message Content",
            goToLive: "Connect Representative",
            stats: "STATISTICS PANEL",
            settings: "SETTINGS",
            status: "STATUS",
            prevStep: "Previous Step",
            nextStep: "Next Step",
            finish: "Finish",
            skip: "Skip",
            skip2: "Skip, I know system",
            startTour: "Start Tour",
            firstTimeIntro:
                "You are entering the system for the first time, I want to introduce the application if you allow",
            hi: "Hi",
            welcomeTo: "Welcome to Supsis Live Support",
            statsPanel:
                "It is the status bar showing the total and active chat numbers that are waiting instantly with the system..",
            sidebarMenu: "MENU",
            sidebarMenuContent: "You can switch between pages here.",
            representativePrivateMessage: "INTER-REPRESENTATIVE CONVERSATION PANEL",
            representativePrivateMessageContent: "You can see private conversations between agents here.",
            helpMenu: "HELP MENU",
            helpMenuContent: "You can find help information about the system here..",
            settingsMenu: "SETTINGS MENU",
            settingsMenuContent: "You can do the language, night mode and screen magnification steps here..",
            startChat: "Start Chat",
            profileMenu: "PROFILE MENU",
            profileMenuContent: "You can change your availability and set your agent settings here..",
            visitorsTab: "Visitors",
            visitorsTabContent: "You can see visitors here.",
            visitorTabHistory: "Visitor History",
            visitorTabHistoryContent: "You can see the visitor history here.",
            representativeTab: "Representatives",
            representativeTabContent: "You can see the representatives here.",
            liveSupport: "Live support",
            liveSupportContent: "You can see the number of customers receiving Live Support here..",
            siteVisitors: "Site Visitors",
            siteVisitorsContent: "You can see the number of site visitors here.",
            tableSettings: "Table Settings",
            tableSettingsContent: "You can show or hide columns in the table here.",
            watchModeButton: "Viewer Button",
            watchModeContent: "You can join here as a viewer mode and you can only view what is posted.",
            popoverInfo: "Visitor Details",
            popoverInfoContent: "It gives information about the visitor.",
            popoverButton: "Advanced Chat Settings",
            popoverButtonContent:
                "You can open the conversation, send a message directly to the representative or block the visitor.",
            openChat: "Join Conversation Button",
            openChatContent: "You can open the conversation here",
            pagination: "Paging Menu.",
            paginationContent: "You can increase the number of pages here.",
            changeLang: "Can change system language",
            changeTheme: "Can switch dark and light theme",
            changeStatus: "Can change your availability status",
            logout: "Can logout system from here",
            chatwindow: {
                chatWindowActionButtons: "CHAT WINDOW ACTION BUTTONS",
                chatPanelActions: "CHAT PANEL ACTIONS",
                otherPanels: "OTHER PANELS",
                chatColorButton: "Show meaning of chat bar colors",
                keyboardShortcutButton: "Show keybpard shortcuts functions",
                hideButton: "Minimize current chat without exit",
                closeButton: "Force close and exit from current chat",
                ellipsisButton:
                    "More actions of chat. Minimize,close, Ban Visitor , Send Private Message , Assign Representative",
                userInfoWidget: "Show detail of owner visitor of current chat user",
                preparedContentWidget:
                    "Prepared Message Templates Widget, can select fastly insert a message template to current chat ",
                chatHistoryWidget: "If there are  some chat history of current visitor , can view them",
                chatWindowSettingsButtons: "TALK WINDOW SETTINGS BUTTON",
                settingsButton: "You can block conversation, forward, confidential message and assign delegates.",
                chatBarButton:
                    "Here you can block active conversation, send a private message to the agent and leave the conversation..",
            },
        },
        adminUser: {
            newAdminUserForm: "New Admin User Register Form",
            updateAdminUserForm: "Admin User Update Form",
            adminUsers: "Admin Users",
            newAdminUser: "New Admin User",
            noAdminUser: "No Admin Users Yet",
            adminUserName: "Admin User Name",
        },
        report: {
            hourly: "(Hourly)",
            hourlyAverage: "Hourly Average",
            hourlyMax: "Hourly Maximum",
            hourlyMin: "Hourly Minimum",
            totalAmount: "Total Amount",
            averageAmount: "Average Amount",
            minAmount: "Minimum Amount",
            maxAmount: "Maximum Amount",
            siteCount: "site Count",
            agentCount: "Agent Count",
            channelsTimeSeries: "Channels Time Series",
            channelPies: "Channel Pies",
            pieView: "Pie Chart",
            topVisitorCountry: "Top Visitor Country",
            websiteTrafficByCountry: "Website Traffic by Country",
            visitorCount: "Visitor Count",
            websiteVisitorTraffic: "Website Visitor Traffic",
            websiteTraffic: "Website Traffic",
            author: "Author",
            topWorstComments: "Top Worst Comments",
            topBestComments: "Top Best Comments",
            topComments: "Top Comments",
            noComment: "No Comments Yet",
            minWaitingTime: "Minimum Waiting Time",
            maxWaitingTime: "Maximum Waiting Time",
            averageWaitTime: "Average Waiting Time",
            waitTime: "Bekleme Süresi (Saniye)",
            agentWaitDurationTitle: "Agent Wait Duration TimeSeries",
            incomingMessage: "Incoming Message(s)",
            outgoingMessage: "Outgoing Message(s)",
            totalSpent: "Total Spent",
            avgSpent: "Average Spent",
            totalPayment: "Total Payment",
            walletStatus: "Wallet Status",
            walletBalanceStatus: "Wallet Balance Status",
            messageTraffic: "Message Traffic",
            breakCount: "Break Count",
            agentBreakTime: "Agent's Break Counts ☕",
            agentWorkTimeCalendar: "Agent Work Time Calendar",
            agentStatusHour: "Agent's Statusses (In Hour Unit)",
            agentActivity: "Agent Activity",
            noEnoughtData: "Not Enough Data",
            averageFirstResponse: "Average First Response Time",
            slowestResponser: "Slowest Responder",
            fastestResponder: "Fastest Responder",
            firstAnswerTimeSec: "First Message Time (in Seconds)",
            firstAnswerByAgent: "First Message Time by Agent",
            averageSolutionTime: "Average Solution Time",
            slowestSolver: "Slowest Solver",
            fastestSolver: "Fastest Solver",
            averageChat: "Average Chat",
            leastChatReceiver: "Least Chat Receiver",
            mostChatRecipients: "Most Chat Recipients",
            averageTicket: "Average Ticket",
            leastTicketReceiver: "Least Ticket Least",
            mostTicketRecipients: "Most Ticket Recipients",
            resolveTime: "Resolution Time (min)",
            resolveTimeByUser: "Chat Resolution Time by User (in minutes)",
            chatResolveTimeByAgent: "Chat Resolution Time by Agents",
            chatDistByHandleType: "Chat Distribution by Handler",
            chatDistByHandDesc: "How many chats were handled by agents, chatbots, and hybrid?",
            chatCountsByHandleType: "Chat Counts by Handle Type",
            missed: "Missed",
            answered: "Answered",
            chatDistByAnsDesc: "How many chats were answered or missed?",
            chatCountsByAns: "Chat Counts by Answer",
            chatCountByPlatform: "Chat Counts by Platform",
            chatDistByPDesc: "How many chats came to which platform?",
            chatDistByPlatform: "Chat Distribution by Platform",
            ticketCountByUser: "Ticket Counts by Agents",
            ticketCountByStatus: "Ticket Counts by Response Status",
            user: "User",
            saveAsImage: "Save as Image",
            fullScreen: "Full Screen",
            download: "Download",
            tableView: "Table View",
            chartView: "Chart View",
            chatDistByUsers: "Chat Distribution by Agents",
            chatCountsByUsers: "Chat Counts by Agents",
            minDuration: "Minimum Duration",
            maxDuration: "Maximum Duration",
            totalDurationByAgent: "Total Session Duration by Agent",
            averageDurationByAgent: "Average Session Duration by Agent",
            totalDurationByCB: "Total Session Duration by Chatbot",
            averageDurationByCB: "Average Session Duration by Chatbot",
            viewUnitAs: "View Unit As",
            hybrid: "Hybrid",
            handledBy: "Handled By",
            sessionDurationOverall: "Overall Session Duration",
            allChannels: "All Channels",
            sessionsDurationOverall: "Overall Session Durations",
            sessionsOverall: "Overall Sessions",
            calendarEvents: "Calendar Events",
            reservationEvents: "Reservation Events",
            incomingMails: "Incoming Mails",
            incomingMailCount: "Incoming Mail Count",
            reservation: "Reservation",
            event: "Event",
            reservationEventCount: "Reservation Event Count",
            eventCount: "Event Counts",
            channelBreakdown: "Channel Breakdown",
            websiteAnalysis: "Website Analysis",
            customerSatisfaction: "Customer Satisfaction",
            teamBreakAnalysis: "Team Work / Break Analysis",
            dailyAgentActivity: "Daily Agent Activity",
            agentPerformance: "Agent Performance",
            chatDistributions: "Chat Distributions",
            users: "Users",
            segmentTimeseries: "Segment Time Series",
            segmentsOverall: "Segments Overall",
            unmatchRatio: "Unmatch Ratio",
            totalMatchCount: "Total Match Count",
            totalUnmatchCount: "Total Unmatch Count",
            matchRatio: "Match Ratio",
            matched: "Matched",
            trainingOverall: "Training Overall",
            trainingStatusTimeseries: "Training Status Time Series",
            duration: "Duration",
            totalSessionDuration: "Total Session Duration",
            averageSessionDuration: "Average Session Duration",
            second: "Second",
            minute: "Minute",
            hour: "Hour",
            aggregateAs: "Aggregate as",
            chatbotSessionDurationOverall: " Overall Chatbot Session Duration",
            ratingTimeSeries: "Rating Time Series",
            chatCountTimeseries: "Chat Count Time Series",
            notRated: "Not Rated",
            totalRatingCount: "Total Rating Count",
            averageRating: "Average Rating",
            weightedAverageRating: "Weighted Average Rating",
            rate: "Rateing",
            ratingOverall: "Customer Ratings Overall",
            session: "Session",
            total: "Total",
            average: "Average",
            max: "Maximum",
            min: "Minimum",
            sessionCount: "Session Count",
            uniqueUsers: "Unique Users",
            viewAs: "View as:",
            overall: "Overall",
            detailReport: "Detailed Report",
            dailyReports: "Daily Reports",
            pointBasedReports: "Point Based Reports",
            personDateBasedPointReport: "Person and Date Based Point Report",
            personDateBasedReport: "Person and Date Based Report",
            personBasedReport: "Person Based Reports",
            personAndDateBasedGraph: "Person and Date Based Graph",
            noReport: "No Report",
            reports: "Reports",
            totalBar: "Total",
            ticketCount: "Ticket Count",
        },
        stats: {
            total: "Number of  all  open chats",
            active: "Number of   assigned active chats to you",
            waiting: "Number of visitors waiting for a representative to enter",
            late: "Number of visitors waiting more than a certain period",
            free: "Number of free visitors waiting for the new representative to enter",
            pco: "[Capacity Utilization Rate] Rate of work load of active representative chat capacity",
            maxCapacity: "Maximum number of chat that the system can assign representatives without waiting",
            chatbot: `Number of active chat with chatbot`,
        },
        time: {
            lastYear: "Last Year",
            thisYear: "This Year",
            last3Months: "Last 3 Months",
            last7: "Last 7 Days",
            today: "Today",
            yesterday: "Yesterday",
            lastWeek: "Last Week",
            currentWeek: "This Week",
            currentMonth: "This Month",
            lastMonth: "Last Month",
            last30Day: "Last 30-day",
            allTime: "All Times",
            custom: "Custom Date",
        },
        fastWizard: {
            generalColors: "General Colors",
            tellUsMore: "Tell us more , so we can personalize your experience",
            moreInfo: "More Info",
            display: "Display",
            availability: "Availability",
            preview: "Preview",
            installCode: "Install Code",
            previous: "Previous",
            setupSupsisLiveChat: "Setup SUPSIS LIVE Chat ",
            continue: "Next Step",
            completeInitialize: "Complete Setup",
            completedMessage: "SUPSIS Live Chat Setup Successfully  Completed.",

            websiteIntegration: "Your website address to integrate supsis live chat",

            customizeLiveChat: "Customize Your Live Chat",
            createBrandedExperience: "Create a branded chat experience for your visitors.",
            chatColor: "Chat Color",
            chooseChatColor: "Choose an accent color.",
            chatBubble: "Chat Bubble",
            selectBubble: "Select a chat bubble",
            chatBubbleColor: "Chat Bubble Color",
            selectChatBubbleColor: "Select a chat bubble color",
            customSelection: "Custom Selection:",

            chatAvailability: "Chat Availability",
            onlineSupportVisitorTime: "When are you online to support your visitors?",
            channelAvailability: "Channel Availability",
            availability724: "Chat is available 7/24",
            basedOnTeam: "Based on Team Member Status",
            basedOnTeamExplanation: "Chat will appear online when at least 1 member is set to available",
            customHours: "Custom Business Hours",
            customHoursExplanation: "Configure your business hours",
            customHoursTimezone: "Timezone:",
            customHoursFrom: "From:",
            customHoursTo: "To:",
            customHoursAddHours: "+Add Hours",

            previewDesktop: "Desktop",
            previewIpad: "Ipad",

            installationAndInstructions: "Installation & Instructions",
            installationTrackingCode: "Install the tracking code on your website",

            installationTrackingCodePlease:
                "Please paste the code in accordance with the instructions below, just before the end of the {bodyTag} tag on any page where you want to enable SUPSIS Live chat.",
            installationInstructionsJavascript:
                " Paste the integration code given above in the {bodyTag} tag just before the closing.",
            installationInstructionsCopy: "Copy",
            installationInstructionsCoppyMessage: "Integration script copied to clipboard",
            installationInstructionsShopify1: "1. Login to your Shopify panel",
            installationInstructionsShopify2:
                "2. Go to Online Store > Themes > Actions drop-down menu under Current Theme > Edit code > theme.liquid",
            installationInstructionsShopify3:
                "3. Place paste the integration code given above just before the  {bodyTag}  tag at the end of the theme.liquid script.",
            installationInstructionsIdeaSoft1: "1. Login to your dealer panel.",
            installationInstructionsIdeaSoft2: "2. Go to Settings -> SEO -> Search Engine Services.",
            installationInstructionsIdeaSoft3:
                '3. Select "Site Verification with Meta Tag" from the Tracking Code section.',
            installationInstructionsIdeaSoft4:
                "4. Copy and paste the integration code above into the opened box and save.",
            installationInstructionsIdeaSoft5:
                '5. Inside Settings -> Optimizations click to "Clear Cache" button. Thus integration is completed.',
            installationInstructionsWordPress1: "1. Login to your WordPress admin panel",
            installationInstructionsWordPress2: "2. Go to Appearance > Theme Editor",
            installationInstructionsWordPress3:
                "3. Under Theme Files (far right), find the Theme Footer (footer.php) and select it",
            installationInstructionsWordPress4:
                "4.Paste the integration code above before the {bodyTag} tag at the bottom.",
            installationInstructionsWordPress5: "5. Click Update File to save changes",
            installationInstructionsOpenCart1: "1. Login to your Opencart admin panel",
            installationInstructionsOpenCart2: "2. Go to Design > Theme Editor",
            installationInstructionsOpenCart3: "3. Select 'common' folder and open 'header.twig' file.",
            installationInstructionsOpenCart4:
                "4.Paste the integration code above before the {headTag} tag at the bottom.",
            installationInstructionsOpenCart5: "5. Click save button.",
            installationInstructionsTicimax1: "1. Login to your Ticimax administration panel",
            installationInstructionsTicimax2: "2. Open Design > Design > Header Footer Design settings",
            installationInstructionsTicimax3: "3. Click the 'Source' button in the logo design section.",
            installationInstructionsTicimax4: "4. Paste the integration code above below the HTML code.",
            installationInstructionsEticaretteyim1: "1. Login to your Eticaretteyim administration panel",
            installationInstructionsEticaretteyim2:
                "2. Just Name SUPSIS from Plugins > Generate HTML > and Copy the Code.",
            installationInstructions: "Instructions",
            installationVerify: "Verify Your Website Installation of Supsis",
            installationVerifyChecking: "Checking",
            installationVerifyCheck: "Check",
            installationVerifyCheckingStatus: "Checking SUPSIS integration status on {website}",
            installationCheckingStatusMessageYes: "Great, SUPSIS is integrated to {website} website !!",
            installationCheckingStatusMessageNo:
                "SUPSIS is not currently integrated with {website} website. You can complete your integration process now or later.",

            vtippyPreferredLanguage: "Preferred Language",
        },
        akinon: {
            typeOrSelectSKU: "Type or select SKU",
            akinonUserId: "Akinon User Id",
            userEmail: "User Email",
            userEmailDesc: "Type or select user email...",
            send: "Send",
            selectCity: "Select City",
            city: "City",
            selectState: "Select State",
            state: "State",
            useMap: "Use Map",
            chooseAddress: "Choose Address",
            selectCountry: "Select Country",
            country: "Country",
            productIdDesc: "Type or select product...",
            productId: "Product Id",
            userIdDesc: "Type Akinon user id...",
            productSKU: "Product SKU",
            latitudeDesc: "Type or select target location latitude...",
            longitudeDesc: "Type or select target location longitude...",
            orderNumber: "Your order number",
            orderDesc: "Type order number...",
            longitude: "Longitude",
            latitude: "Latitude",
        },
        headBar: {
            Email: "E-mail",
            phone: "Phone",
            name: "Name",
            date: "Date",
            subject: "Subject",
            situation: "Situation",
            representative: "Representative",
            transactions: "Transactions",
        },
        login: {
            loginTitle1: "Welcome to",
            loginTitle2: "SUPSIS",
            email: "Your email adress",
            emailPlaceholder: "Please enter your e-mail address.",
            emailError: "Please Enter Valid Email",
            password: "Your password",
            passwordLogin: "Password Free Login",
            passwordAndLogin: "Login with Password",
            passwordNew: "Reset My Password",
            loginAnd: "Or",
            passwordPlaceholder: "Please enter your password.",
            loginMemory: "Remember this device",
            passwordForget: "I forgot my password",
            passwordNewAgain: "New Password",
            passwordNewAgainTwo: "New Password Repeat",
            passwordNewAgainPlaceholder: "Please enter your new password.",
            passwordNewAgainPlaceholderTwo: "Please re-enter your new password.",
            login: "Login",
            loginFooter: "Or, Sign In With Email",
            emailLogin: "Sign in with Email",
        },
        settings: {
            auditlogs: "Audit Logs",
            myaccount: "My Account",
            notifications: "Notifications",
            company: "Company",
            features: "Features",
            general: "General",
            chat: "Chat",
            timings: "Timings",
            wallet: "Wallet",
            language: "Language",
            "bubble-settings": "Bubble Settings",
            "bubble-actions": "Bubble Actions",
            "theme-settings": "Theme Settings",
            visitorLoginForm: "Visitor Login Form",
            visitorAttribute: "Visitor Profile Information",
            timing_settings: "Chat Timing Settings",
            auto_assign: "Auto Chat Assign",
            availability: "Availability",
            "website-integration": "Website Integration",
            General: "General",
            Chat: "Chat",
            Timings: "Timings",
            Integration: "Integration",
            developer: "Developer",
            visitorNew: "Visitor Transition to New Design",
            companySubtitles: "Manage your company information.",
            featuresSubtitles: "Manage the smart features of Supsis.",
            languageSubtitles: "Manage your language settings.",
            bubbleSettings: "Bubble Settings",
            bubbleSettingsSubtitles: "Manage your bubble settings.",
            bubbleActionsSubtitles: "Manage your bubble actions.",
            chatThemeSettingsSubtitles: "Manage your chat theme settings.",
            visitorLoginFormSubtitles: "Manage your visitor login form settings.",
            chatTimingSettingsSubtitles: "Manage your chat timing settings.",
            webSiteIntegrationSubtitles: "Manage your website integration settings.",
            apiAccessTitle: "API Access",
            apiAccessSubtitles: "Manage your API access settings.",
            youTubeActionForm: "Add Your Youtube Channel",
            linkedinActionForm: "Add Your Linkedin Account",
            telegramActionForm: "Add Telegram Account",
            facebookActionForm: "Add Your Facebook Page",
            tiwitterActionForm: "Add Your Twitter Page",
            instagramActionForm: "Add Your Instagram Page",
            liveSupportDescription: "Open a live chat with your customers",
            ticketDescription: "Create a ticket for your customers",
            whatsappDescription: "Let your customers reach you via Whatsapp",
            phoneDescription: "Let your customers reach you via phone",
            emailDescription: "Let your customers reach you via email",
            facebookDescription: "Let your customers reach you via Facebook",
            twitterDescription: "Let your customers reach you via Twitter",
            instagramDescription: "Let your customers reach you via Instagram",
            youtubeDescription: "Let your customers reach you via Youtube",
            linkedinDescription: "Let your customers reach you with LinkedIn",
            telegramDescription: "Let your customers reach size with Telegram",
            whatsappModalTitle: "Whatsapp Transaction Form",
            whatsappModalDescription: "Please fill out the form below to connect your Whatsapp account.",
            phoneModalTitle: "Phone Transaction Form",
            phoneModalDescription: "Please fill out the form below to connect your phone account.",
            emailModalTitle: "E-mail Transaction Form",
            emailModalDescription: "Please fill out the form below to connect your e-mail account.",
            facebookModalTitle: "Facebook Transaction Form",
            facebookModalDescription: "Please fill out the form below to connect your Facebook account.",
            twitterModalTitle: "Twitter Transaction Form",
            twitterModalDescription: "Please fill out the form below to connect your Twitter account.",
            instagramModalTitle: "Instagram Transaction Form",
            instagramModalDescription: "Please fill out the form below to connect your Instagram account.",
            youtubeModalTitle: "Youtube Transaction Form",
            youtubeModalDescription: "Please fill out the form below to connect your Youtube account.",
            linkedinModalTitle: "LinkeIn Transaction Form",
            linkedinModalDescription: "Please fill out the form below to link your LinkedIn account.",
            telegramModalTitle: "Telegram Transaction Form",
            telegramModalDescription:
                "Enter your Telegram profile link in the form below to link your Telegram Account",
            instagramAlertTitle: "Instagram Integration Required",
            instagramAlertDesc: "Sorry, the page you visited will be activated when you integrate your Instagram.",
            instagramActivateText: "Let's go, Integrate Instagram",
            remove: "Remove",
            edit: "Edit",
            connected: "Connected",
            add: "Add",
            themeDescription: "Manage your theme settings.",
            fontDescription: "Manage your font settings.",
            isFabsAsIcon: "Show Menu Icon Texts.",
            chatBubbleTextSetting: "Chat Bubble Text Setting",
            textOnChatBubble: "You can adjust the text settings that will appear on the Chat Bubble.",
            textToAppearOnChatBubble: "Text to Appear on Chat Bubble",
            newVisitorProfileInformation: "New Visitor Profile Information",
            newVisitorProfileInformationDescription: "Adds new value to visitor profile information",
            create: "Create",
            newAdd: "Add New",
            toInform: "To inform",
            toInformDescription: "You can match the values you add on this page with the visitor login form.",
            showVisitor: "Show Visitor",
            label: "Label",
            text: "Text",
            email: "Mail",
            phone: "Phone",
            number: "Number",
            url: "URL",
            date: "Date",
            dropdown: "Dropdown",
            languageTimeZone: "Language and Region",
            timeZoneTitle: "Region & Time Zone",
            timeZoneDescription: "Region and time zone settings",
        },
        userInfoWidget: {
            userInformation: "User information",
            fullName: "Name and surname",
            newValue: "New Value",
            newProfileInfo: "New Profile Info",
            affiliatedRepresentatives: "Representatives",
            preferredAgents: "Preferred Agent(s)",
            labels: "Labels",
            agentNotes: "Agent Notes",
            newNote: "New Note",
            note: "Note",
            available: "There are notes available.",
            systemInformation: "System Information",
            speechID: "Speech ID",
            customerVersion: "Customer Version",
            IPAddress: "IP Address",
            pageVisited: "Page Visited",
            systemAndBrowser: "Operating System & Browser",
            countryAndLanguage: "Country and language",
            clickToEdit: "Edit Click inside the post",
            adsYouAreInterestedIn: "Ads You Are Interested In",
            detail: "Detail",
            adsTitle: "Title",
            adUrl: "Ad URL",
            sourceID: "Source ID",
            resourceType: "Resource Type",
            adsBody: "Content",
            adsCreateDate: "Creation Date",
            adsUpdateDate: "Update Date",
        },
        newWizartV2: {
            generalSettings: "General Settings",
            themeSettings: "Theme Settings",
            representativeWorkingHours: "Representative Working Hours",
            preview: "Preview",
            setup: "Setup",
            formStepTitle: "Give us more information so we can personalize your experience",
            supsisEntergation: "Where will you use Supsis on your website?:",
            goToNextStep: "Take Next Step",
            readytemplate: "Use Ready Color Template",
            customSettings: "Custom Settings",
            customerMessageView: "Customer message View",
            backcgroundColor: "Background Color",
            textColor: "Font Color",
            agentMessageView: "Agent Message View",
            workingHours: "What time intervals do you provide services to your visitors?",
            continuousService: "Continuous Service",
            continuousServiceDescription: "The chat bubble is always active. Even if you are not in the system.",
            vote: "Make your choice",
            representativeWorking: "Representative Working Hours",
            representativeWorkingDescription:
                "The chat appears online when at least 1 agent is online. If there is no online representative, it will appear as offline.",
            computer: "Computer",
            tablet: "Tablet",
            uploadTrackingCodeToYourWebsite: "Upload Tracking Code to Your Website",
            password: "Установить новый пароль",
        },
        whatsappChannel: {
            whatsappTitleV1: "Whatsapp V1 Channels (QR)",
            whatsappTitleV2: "Whatsapp V2 Channels (QR)",
            channelName: "Channel",
            phoneNumber: "Phone Number",
            forwardToChatbot: "Forward to Chatbot",
            forwardingChatbotOrLiveAgent: "Forwarding (Chatbot or Live Agent)",
            addChannel: "Add Channel",
            newWhatsappChannel: "New WhatsApp Channel",
            newWhatsappChannelDescription: "Create a new WhatsApp channel by scanning the QR code",
            editWhatsappChannel: "Edit WhatsApp Channel",
            editWhatsappChannelDescription: "Edit WhatsApp channel",
            whatsappChannel: "WhatsApp Channel",
            deleteWhatsappChannelDescription: "Are you sure you want to delete this channel?",
            whatsappIntegration: "WhatsApp Integration",
            deleteChannel: "Delete Channel",
            restartChannel: "Restart Channel",
            wantRestartChannel: "Do you want to restart the channel?",
            deleteSMSChannelDescription: "Are you sure you want to delete the SMS channel?",
            smsChannel: "SMS Channel",
            maxChannelCount: "You Cannot Create More than One SMS Channel!",
            smsModalText:
                "Our integration with modern communication solutions gives you the opportunity to send SMS easily and effectively. Remove boundaries in communication, connect directly with your customers!",
            smsModalBtn: "Click to Open SMS Channel...",
            postaCellDetail: "PostaCell Channel Detail",
        },
        noPermission: "You do not have permission to perform this operation. Please contact your manager.",
        mail_integration_detail: {
            title: "Mail Detail",
            integration: "Integration",
            sender: "Sender Mail",
            signature: "Signature",
            inbox: "Inbox",
            medias: "Media",
            visibility: "Visibility",
            settings_group: "Settings",
            contacts: "Contacts",
        },
        whatsapp_business_api: {
            title: "Whatsapp Business API Channels",
            integration: "Integration",
            detail: "Detail",
            visibility: "Visibility",
            templates: "All Template Messages",
            settings_group: "Setting",
            template_message_group: "Template Messages",
            chat_initiator_template: "Chat Initiator Template",
            contacts: "Contacts",
            numbers: "Numbers",
            all_contacts: "All Contacts",
            new_template: "Create new Template",
            broadcast_group: "Broadcast",
            broadcast_requests: "Broadcast Requests",
            customer_groups: "Customer Groups",
            businessChannelDetail: "Whatsapp Business Channel Detail",
            wallet: "Wallet",
            postacellMessage: "Send SMS",
            postacellAllMessage: "Send Bulk SMS",
            message_group: "Message",
            createNewTemplate: "Create a new template message",
            templateName: "Template name",
            templateNameDesc: "Give a name to your message template.",
            viewTemplates: "View templates",
            templateNameRules: "Template name can only include lowercase letters, numbers, and underscores.",
            category: "Category",
            categoryDesc: "Select what type of template you want to create",
            categoryUtility: "Utility",
            categoryUtilityDesc: "Send utility information such as account updates, order updates, alerts, and more.",
            categoryMarketing: "Marketing",
            categoryMarketingDesc:
                "Send promotional offers, product offers, and more to increase awareness and engagement.",
            categoryAuth: "Authentication",
            categoryAuthDesc: "Send codes for your customers to access their accounts.",
            optional: "Optional",
            languageDesc: "Select the language in which your template message will be sent",
            header: "Header",
            headerRules: "Add a 60-character header to your message. Only one variable is supported in the header.",
            headerOptionMedia: "Media",
            headerOptionText: "Text",
            none: "None",
            headerType: "Header Type",
            headerText: "Header Text",
            body: "Body",
            bodyRules: "Enter text in the language you selected for your message",
            addVariable: "Add Variable",
            variables: "Variables",
            variable: "Variable",
            defaultVariableName: "Default Variable Name",
            defaultVariableToolTip:
                "Your variable appears in the template with this name. <br><br> Additionally, this value is sent as the default in case of other situations.",
            selectATemplate: "Select a Message Template",
            variableSettings: "Variable settings",
            example: "Example",
            footer: "Footer",
            footerDesc: "Add a 60-character footer to your message. Variables are not supported in the footer.",
            buttons: "Buttons",
            buttonType: "Button Type",
            buttonTypeReply: "Reply",
            submit: "Save",
            submitting: "Submitting",
            addButton: "Add Button",
            rejectWhatsapp: "Rejected by Whatsapp.",
            approvedWhatsapp: "Approved by Whatsapp.",
            pendingWhatsapp: "Pending Approval",
        },
    },
    ru: {
        chatWindow: {
            thereIsNoChatContent: "Нет содержимого чата.",
            thereIsNoChatContentDsc: "Здесь вы можете просматривать содержимое чата и отправлять сообщения.",
            interactions: "Взаимодействия:",
            departments: "Отделы",
            channels: "Каналы",
            date: "Дата",
            lastChatStatus: "Последний статус чата",
            all: "Все",
            queued: "В очереди",
            open: "Открыто",
            closed: "Закрыто",
            private: "Частное",
            chatbot: "Чат-бот",
            lostMissed: "Потерянные / Пропущенные",
            interaction: "Взаимодействие",
            myActiveInbox: "Мой активный почтовый ящик",
            activeQueueInbox: "Активный + Очередь почтовый ящик",
            chatbotActiveInbox: "Активный почтовый ящик чат-бота",
            myDepartmentsActiveInbox: "Активный почтовый ящик моих отделов",
            notInteractedYesterday: "Вчера не было взаимодействий",
            queueInbox: "Очередь почтового ящика",
            whatsappActiveInbox: "Активный почтовый ящик WhatsApp",
            socialMediaActiveInbox: "Активный почтовый ящик соцсетей",
            missedThisMonth: "Пропущенные чаты в этом месяце",
            chooseAFileOrDragItHere: "Выберите файл или перетащите его сюда!",
            watching: "Наблюдаю",
            selectFilter: "Выбрать фильтр",
            clearAll: "Очистить все",
            me: "Я",
            today: "Сегодня",
            yesterday: "Вчера",
            thisWeek: "Эта неделя",
            lastWeek: "Прошлая неделя",
            last7Days: "Последние 7 дней",
            last30Days: "Последние 30 дней",
            thisMonth: "Этот месяц",
            lastMonth: "Прошлый месяц",
            last24h: "Последние 24 часа",
            custom: "Настроить",
            startMessage: "Начать сообщение",
            goToAgentReport: "Перейти к отчету агента",
            agentDetail: "Детали агента",
            agentList: "Список агентов",
            selectedFilter: "Выбранный фильтр",
            groupBy: "Группировать",
            none: "Нет группы",
            agent: "Представитель",
            department: "Отдел",
            sortBy: "Сортировать",
            lastPostAbove: "Последнее сообщение сверху",
            newChatsAbove: "Новые чаты сверху",
            oldChatsAbove: "Старые чаты сверху",
            live: "Жить",
            systemStatus: "Состояние системы",
            refresh: "Обновить",
            close: "Закрыть",
            totalCustomers: "Общее количество клиентов",
            totalAnswered: "Всего отвечено",
            waitingAnswer: "Ожидание ответа",
            totalAgentInChat: "Всего агентов в чате",
            onlineAgentCount: "Количество онлайн агентов",
            totalCustomer: "Всего клиентов",
            answered: "Отвечено",
            unanswered: "Без ответа",
            noContactWasFoundMatchingTheCurrentFilters: "Не найдено контактов, соответствующих текущим фильтрам.",
            you: "Ты",
            others: "Другие",
            queue: "Очередь",
            chatbotContact: "Чатбот",
            closedContact: "Закрыто",
            myInteractions: "Мои взаимодействия",
            special: "Особенный",
            allInteractions: "Все контакты",
            waiting: "Ожидающие",
            departmentToWhichItIsAffiliated: "Отдел, к которому он относится",
        },
        plans: {
            manageWithChatbot: "Manage with Chatbot",
            manageInbox: "Manage Inbox",
            commentManagement: "Manage Comments",
            privateReplyMessage: "Private Reply Comments",
            mentionTicket: "Convert Mentions to Tickets",
            week: "Неделя",
            readyContents: "Готовое содержимое",
            webhookIntegration: "Интеграция вебхуков",
            businessChannel: "Канал бизнеса WhatsApp",
            confirmationFeature: "Функция подтверждения",
            specialReporting: "Специальная отчетность",
            aiAssistant: "ИИ помощник",
            flexibleBilling: "Гибкая биллинг",
            automaticReservation: "Автоматическое бронирование",
            taskManagement: "Управление задачами",
            calendarIntegration: "Интеграция календаря",
            activeChatbot: "Активный чатбот",
            smsIntegration: "Интеграция SMS",
            mailIntegration: "Интеграция почты",
            startChatWithVisitor: "Начать чат с посетителем",
            whatsappManaging: "Управление Whatsapp",
            automaticChatbotButton: "Автоматическая кнопка/чат-бот",
            personalizedBroadcasts: "Персонализированные рассылки",
            chatWithNonContacts: "Чат с неконтактными лицами",
            broadcastMessaging: "Рассылка сообщений",
            perBroadcast: "За трансляцию",
            extraPricePerMessage: "Дополнительная плата за сообщение",
            smartTrigger: "Умный триггер",
            telegramIntegration: "Интеграция с Telegram",
            instagramIntegration: "Интеграция с Instagram",
            ticketFeature: "Функция билетов",
            storage: "Хранение",
            onePanelManagement: "Управление в одной панели",
            isolatedDatabaseConnection: "Изолированное подключение к базе данных",
            removeLogo: "Удалить логотип Supsis",
            chatBaloonCustomization: "Настройка пузырьков чата",
            chatAndNotifications: "Чат и уведомления",
            unlimited: "Неограниченный",
            specialCustomerSupport: "Специальная клиентская поддержка",
            softwareSupport: "Поддержка программного обеспечения",
            standardSupport: "Стандартная поддержка",
            teamChatIntegration: "Интеграция чата команды",
            fileAndVoiceShare: "Обмен файлами и голосом",
            instantVisitor: "Мгновенное отслеживание посетителей",
            detailedReporting: "Подробная отчетность",
            normalreporting: "Обычная отчетность",
            noExtraCosts: "Без дополнительных расходов",
            accessibleToAllAgents: "Доступно для всех агентов",
            dataSecurity: "Безопасность данных",
            autoTranslate: "Автоматический перевод",
            chatbotVersionHistory: "История версий чатбота",
            chatbotStory: "История чатбота",
            freeAgent: "Бесплатный агент",
            stableAgentCount: "Количество стабильных агентов",
            stableChannelCount: "Stable Channel Count",
            chipPlans: "Доступные планы",
            generalPlan: "Общий план",
            specialPlan: "Специальный план",
            currentPlan: "Текущий план",
            selected: "Выбрано",
            popular: "Популярный",
            trialPkg: "Пробный пакет",
            support: "Поддержка 24/7",
            flexiblePricing: "Гибкая ценовая политика",
            rightToCancel: "Право отмены в любое время",
            unlimitedCBScenario: "Неограниченные сценарии чатбота",
            freeFirstScenario: "Бесплатный первый сценарий",
            unlimitedLearn: "Неограниченное обучение чатбота",
            allPlatformIntegration: "Интеграция со всеми платформами",
            detailedReports: "Подробные отчеты",
            aiSupport: "Поддержка искусственного интеллекта",
            creativeAI: "Быстрый и реалистичный чат-ассистент на основе ИИ",
            unlimitedSession: "Неограниченные сеансы одновременно",
            assistantFromWebsite: "Создание помощника с веб-сайта",
            assistantFromDoc: "Создание чат-бота из документа",
            mobileApp: "Мобильное приложение",
        },
        messenger: {
            channel: "Канал Messenger",
            manageChannel: "Управление каналом",
            channelDetail: "Детали канала",
            integrationTitle: "Интеграция Messenger",
            deleteDesc: "Вы уверены, что хотите удалить канал Messenger?",
            channels: "Каналы Messenger",
            connectMessenger: "Подключиться к Messenger",
            detail: "деталь",
            visibility: "видимость",
            settings_group: "Настройки",
            commentsettings: "Управление комментариями",
            commentSettingsTitle: "Управление комментариями в мессенджере",
            commentSettingsDesc: "Управляйте своими комментариями в Messenger",
        },
        instagram: {
            channel: "Канал Instagram",
            detail: "деталь",
            visibility: "видимость",
            settings_group: "Настройки",
            commentsettings: "Управление комментариями",
            commentSettingsTitle: "Управление комментариями в Instagram",
            commentSettingsDesc: "Управляйте своими комментариями в Instagram",
            commentSettingsTicket: "Обеспечивает сохранение входящих комментариев в системе как заявок.",
            commentSettingsChatbot: "Выберите, к какому сценарию чат-бота следует направить входящие комментарии.",
            leads: "Leads",
            forms: "Forms",
        },
        calendar: {
            setting: "Настройки",
            delete: "Удалить",
            cancel: "Отмена",
            save: "Сохранить",
            close: "Закрыть",
            deleteRepeatEvent: "Удалить повторяющееся событие",
            thisEvent: "Это событие",
            thisAndOtherEvent: "Это и следующие события",
            allEvent: "Все события",
            ok: "ОК",
            googleCalendarLink: "Добавить в Google Календарь",
            yahooCalendarLink: "Добавить в Yahoo Календарь",
            subject: "Тема",
            visitor: "Посетитель",
            allDay: "Весь день",
            title: "Название",
            deleteEvent: "Удалить событие",
            deleteEvents: "Удалить события",
            deleteEventsSure: "Вы уверены, что хотите удалить события из этого календаря?",
            deleteEventConfirm: "Вы уверены, что хотите удалить это событие?",
            notEmptyTitle: "Название не может быть пустым!",
            tasks: "Задачи",
            googleConnect: "Интеграция с Google",
            googleDisconnect: "Отключить интеграцию с Google",
            sure: "Вы уверены?",
            disconnectGoogleSure: "Вы уверены, что хотите отключить Google?",
            yes: "Да",
            no: "Нет",
            customRepeat: "Настроить повторение",
            recurrenceFrequency: "Частота повторения",
            repeatDays: "Повторять по дням",
            never: "Никогда",
            thisDate: "В эту дату",
            recurrenceCount: "Количество повторений",
            end: "Конец",
            event: "Событие",
            calendars: "Календари",
            newCalendar: "Создать новый календарь",
            changeColor: "Изменить цвет",
            addCalendar: "Добавить календарь",
            nameCalendar: "Название календаря",
            description: "Описание",
            change: "Изменить",
            deleteCalendar: "Удалить календарь",
            deleteCalendarSure: "Вы уверены, что хотите удалить этот календарь?",
            notEmptyCalendarName: "Название календаря не может быть пустым",
            myEvents: "Мои события",
            everyoneEvents: "Все события",
            haveEvent: "события у представителя",
            goCalendar: "Перейти в календарь",
            goReservation: "Создать бронирование",
            agents: "Представители",
            today: "Сегодня",
            month: "Месяц",
            week: "Неделя",
            day: "День",
            list: "Список",
        },
        ticimax: {
            segment: "Сегмент",
            settings_group: "Настройки",
            waitDayFromLastSend: "Количество дней ожидания с момента последнего отправленного сообщения",
            automationRuleName: "Название правила автоматизации",
            time: "Время",
            year: "Год",
            month: "Месяц",
            dayOfMonth: "День месяца",
            day: "День",
            bySecond: "По секунде",
            byMinute: "По минуте",
            byHour: "По часу",
            byWeekNo: "По номеру недели",
            byYearDay: "По номеру дня в году",
            byMonthDay: "По номеру дня в месяце",
            byMonth: "По месяцу",
            december: "Декабрь",
            november: "Ноябрь",
            october: "Октябрь",
            september: "Сентябрь",
            august: "Август",
            july: "Июль",
            june: "Июнь",
            may: "Май",
            april: "Апрель",
            march: "Март",
            february: "Февраль",
            january: "Январь",
            byWeekDay: "По дню недели",
            interval: "Интервал",
            seconds: "Секунды",
            minutes: "Минуты",
            hourly: "По часам",
            daily: "По дням",
            weekly: "По неделям",
            monthly: "По месяцам",
            yearly: "По годам",
            frequency: "Частота",
            attributes: {
                vip: "VIP",
                segment: "Сегмент",
                province: "Провинция",
                country: "Страна",
                phone: "Телефон",
                email: "Эл. почта",
                fullname: "Полное имя",
                couponPercent: "% купона",
                lastOrderDate: "Последний заказ",
                firstOrderDate: "Первый заказ",
                county: "Каунти",
                lastSource: "Последний источник",
                firstSource: "Первый источник",
                lastPaymentType: "Последний способ оплаты",
                firstPaymentType: "Первый способ оплаты",
                maxOrderAmount: "Максимальная сумма заказа",
                minOrderAmount: "Минимальная сумма заказа",
                totalOrderAmount: "Общая сумма заказов",
                totalOrderCount: "Общее количество заказов",
                usedCouponAmount: "Сумма использованного купона",
                usedCouponCount: "Количество использованных купонов",
                tookDayFromLastOrder: "Дни с момента последнего заказа",
                isCouponUser: "Пользователь купона",
            },
            createAutomation: "Создать автоматизацию",
            previous: "Предыдущий",
            createAutomationDesc: "Создайте и управляйте автоматизацией сообщений",
            newTicimaxChannel: "Новый канал Ticimax",
            connextToTicimaxXml: "Подключиться к службе Ticimax XML",
            connectTicimax: "Подключиться к Ticimax",
            examplePreview: "Примерный просмотр",
            completeAutomationRule: "Завершите правило автоматизации",
            configureMessage: "Настройка сообщения",
            automationTimer: "Таймер автоматизации",
            findTargetMembers: "Найти целевых участников",
            createAutomationRule: "Создать правило автоматизации",
            action: "Действие",
            status: "Статус",
            triggeredUserCount: "Количество пользователей, сработавших",
            nextScheduled: "Следующее запланированное",
            timerRule: "Правило таймера",
            automationRules: "Правила автоматизации",
            apply: "Применить",
            searchAMember: "Поиск участника",
            segmentedMembersDesc: "Перечислите и автоматизируйте сегментированных участников",
            manageVisibilityDesc: "Управляйте видимостью канала",
            xmlOrderListURL: "URL списка заказов XML",
            manageIntegrationDesc: "Управляйте вашей интеграцией Ticimax",
            detail: "Подробности",
            ticimaxChannelsTitle: "Каналы Ticimax",
            ticimaxDetail: "Детали Ticimax",
            settingsGroup: "Настройки",
            visibility: "Видимость",
            members: "Участники",
            automation: "Автоматизация",
            integrationChannel: "Интеграционный канал",
            channelUpdated: "Канал успешно обновлен",
            channelUpdateFailed: "Ошибка обновления канала",
        },
        notification: {
            mobileApp: "Мобильное приложение",
            webPanel: "Веб-панель",
            notifications: "Уведомления",
            whatsappActions: "Действия WhatsApp",
            chatbotActions: "Действия чатбота",
            companyActions: "Действия компании",
            crmActions: "Действия SUPSIS CRM",
            basicActions: "Основные действия",
            notificationSettingsDesc: "Выберите, какие уведомления вы хотите получать и где.",
            noNotificationDesc2:
                "Здесь вы увидите все уведомления, связанные с вакансиями, кандидатами и пулами талантов, которые вы отслеживаете. Вы можете настроить уведомления, изменив настройки.",
            noNotificationTitle2: "Пока нет уведомлений.",
            noNotificationTitle1: "Уведомлений нет. Наслаждайтесь тишиной.",
            adjustSettings: "Настроить параметры",
            showAll: "Показать все",
            showOnlyUnread: "Показать только непрочитанные",
            mailWasSent: "Письмо было отправлено.",
            mailAdressRemoved: "Email адрес был удален.",
            chatbotPublished: "Версия <b>{version}</b> чат-бота была опубликована пользователем <b>{user}</b>.",
            chatbotDeleted: "Чат-бот <b>{chatbot}</b> был удален пользователем <b>{user}</b>.",
            settingsUpdatedWoDetail: "Настройки были обновлены пользователем <b>{user}</b>.",
            noActivityDesc: "В настоящее время в системе нет активности. Несколько событий должны произойти",
            noActivityTitle: "Пока нет действий",
            actionType: "Тип действия",
            dateBetween: "Даты между",
            selectActor: "Выберите пользователя",
            activities: "Мероприятия",
            chatbotCreated: "Чат-бот с именем <b>{chatbot}</b> был создан пользователем <b>{user}</b>.",
            taskStageChanged:
                "Стадия задачи <b>{task}</b> была изменена с <b>{oldStage}</b> на <b>{newStage}</b> пользователем <b>{user}</b>.",
            taskCreated: "Задача <b>{task}</b> была создана пользователем <b>{user}</b>.",
            contactPropRemoved: "Свойство посетителя <b>{prop}</b> было удалено пользователем <b>{user}</b>.",
            contactPropAdded: "Свойство посетителя <b>{prop}</b> было добавлено пользователем <b>{user}</b>.",
            userRemoved: "Пользователь <b>{oldUser}</b> был удален пользователем <b>{user}</b>.",
            loginFormUpdated: "Форма входа посетителя была обновлена <b>{user}</b>.",
            loginFormDeactivated: "Форма входа пользователя была отключена <b>{user}</b>.",
            loginFormActivated: "Форма входа пользователя была активирована <b>{user}</b>.",
            invoiceRefunded: "Процесс возврата был осуществлен <b>{user}</b>.",
            paymentMethodAdded: "Новый способ оплаты был добавлен пользователем <b>{user}</b>.",
            invoicePaymentFailed: "Оплата счета не была принята пользователем <b>{user}</b>.",
            invoicePaymentReceived: "Оплата счета была принята пользователем <b>{user}</b>.",
            planStarted: "<b>{user}</b> Пользователь начал подписку <b>{title}</b> <b>({altTitle})</b>.",
            PlanCanceled: "<b>{user}</b> Пользователь отменил подписку <b>{title}</b> <b>({altTitle})</b>.",
            invoiceCreated: "Счет был создан пользователем <b>{user}</b>.",
            billingAddressUpdated: "Информация об адресе была обновлена пользователем <b>{user}</b>.",
            taskWorkflowDeleted: "Рабочий процесс <b>{workflow}</b> был удален пользователем <b>{user}</b>.",
            whatsappBroadcastFailed: "Отправка широковещательного сообщения с заголовком <b>{title}</b> не удалась.",
            whatsappBroadcastCancelled:
                "Отправка широковещательного сообщения с заголовком <b>{title}</b> была отменена.",
            whatsappBroadcastCompleted:
                "Широковещательное сообщение с заголовком <b>{title}</b> успешно отправлено <b>{numbers}</b> получателям.",
            whatsappBroadcastCreated:
                "Широковещательное сообщение с заголовком <b>{title}</b> было отправлено <b>{user}</b> <b>{numbers}</b> получателям.",
            ticketAssigned: "<b>{user1}</b> пользователям <b>{user2}</b> назначен билет.",
            userLoggedIn: "<b>{user}</b> вошел в систему SUPSIS.",
            chatJoined: "<b>{agent}</b>, <b>{visitor}</b> с чатом.",
            chatForwarded: "Чат с <b>{visitor}</b> был перенаправлен на <b>{agent}</b> от <b>{user}</b>.",
            chatAssigned: "Чат с <b>{visitor}</b> был назначен <b>{agent}</b> системой.",
            customerGroupUpdated: "Группа <b>{group}</b> была обновлена <b>{user}</b>.",
            customerGroupRemoved: "Группа <b>{group}</b> была удалена <b>{user}</b>.",
            customerGroupAdded: "Группа <b>{group}</b> была создана <b>{user}</b>.",
            contentRemoved: "Готовое содержимое <b>{content}</b> было удалено <b>{user}</b>.",
            contentAdded: "Готовое содержимое <b>{content}</b> было добавлено <b>{user}</b>.",
            channelVisibilityChanged:
                "Видимость интеграционного канала <b>{channel}</b> была изменена пользователем <b>{user}</b>.",
            taskDeleted: "Задача <b>{task}</b> была удалена пользователем <b>{user}</b>.",
            userRemovedToDepartment:
                "Пользователь <b>{user2}</b> удален из отдела <b>{department}</b> пользователем <b>{user1}</b>.",
            userAddedToDepartment:
                "Пользователь <b>{user2}</b> добавлен в отдел <b>{department}</b> пользователем <b>{user1}</b>.",
            mailAddressAdded: "<b>{email}</b> адрес электронной почты добавлен <b>{user}</b>",
            settingUpdate: "Обновлено <b>{user}</b>:",
            taskWFlowCreated: "Рабочий процесс <b>{Wflow}</b> создан пользователем <b>{user}</b>.",
            bannedWordRemoved: "Запрещенное слово <b>{bWord}</b> удалено пользователем <b>{user}</b>.",
            bannedWordCreated: "Запрещенное слово <b>{bWord}</b> создано пользователем <b>{user}</b>.",
            welcomeMessageRemoved: "Приветственное сообщение <b>{welcome}</b> удалено пользователем <b>{user}</b>.",
            welcomeMessageAdded: "Приветственное сообщение <b>{welcome}</b> создано <b>{user}</b>.",
            tagRemoved: "Тег <b>{tag}</b> удален <b>{user}</b>.",
            tagAdded: "Тег <b>{tag}</b> добавлен <b>{user}</b>.",
            roleRemoved: "Роль <b>{role}</b> удалена <b>{user}</b>.",
            roleAdded: "Роль <b>{role}</b> добавлена <b>{user}</b>.",
            departmentRemoved: "Отдел <b>{department}</b> удален <b>{user}</b>.",
            departmentAdded: "Отдел <b>{department}</b> добавлен <b>{user}</b>.",
            triggerUpdated: "Триггер обновлен <b>{user}</b>.",
            triggerRemoved: "Триггер удален <b>{user}</b>.",
            triggerAdded: "Новый триггер создан <b>{user}</b>.",
            webhookRemoved: "Webhook <b>{user1}</b>, удаленный <b>{user2}</b>",
            webhookAdded: "Webhook добавлен <b>{user1}</b>, добавлен <b>{user2}</b>.",
            chatOpenedByAgent: "<b>{agent}</b> начал чат <b>{platform}</b> с <b>{visitor}</b>.",
            chatOpenedByVisitor: "Чат <b>{platform}</b> был начат <b>{visitor}</b>.",
            channelRemoved: "Канал <b>{channel}</b> был удален <b>{agent}</b>.",
            userAdded: "<b>{agent}</b> создал представителя по имени <b>{newAgent}</b>.",
            visitorUnblocked: "Посетитель <b>{visitor}</b> разблокирован пользователем <b>{agent}</b>.",
            visitorBlocked: "Посетитель <b>{visitor}</b> заблокирован <b>{agent}</b>.",
            userStatusChanged: "Пользователь <b>{name}</b> изменил статус с <b>{oldStatus}</b> на <b>{newStatus}</b>.",
            channelCreated: "Канал <b>{channel}</b> создан пользователем <b>{name}</b>.",
            reservationCreatedPlan:
                "<b>{name}</b> пользователь запланировал встречу под названием <b>{title}</b> на <b>{date}</b>.",
            reservationUpdatedPlan: "<b>{name}</b> пользователь обновил встречу под названием <b>{title}</b>.",
            reservationDeletedPlan: "<b>{name}</b> пользователь удалил встречу под названием <b>{title}</b>.",
            reservationCreated:
                "Бронь создана для пользователя <b>{name}</b> и посетителя <b>{visitor}</b> на <b>{date}</b>.",
            reservationDeleted:
                "Запланированная встреча между пользователем <b>{name}</b> и посетителем <b>{visitor}</b> на <b>{date}</b> отменена.",
            chatAssignedMe: "Когда чат назначен мне",
            ticketAssignedMe: "Когда мне назначен билет",
            taskAssignedMe: "Когда мне назначается задача",
            myChatClosed: "Когда закрывается чат, который я владею",
            tagActionsToVisitor: "Теги добавлены или удалены у контакта",
            ticketCreated:
                "Билет создан посетителем или чат-ботом. Также, когда отправлено автономное сообщение из виджета чата",
            notesActions: "Заметка была добавлена или удалена у клиента.",
            visitorProfileUpdated: "Профиль посетителя обновлен",
            chatStartedByAnyPlatform: "Чат запущен на любой платформе контактом или агентом",
            userActions: "Пользователь создан, обновлен или удален",
            departmentActions: "Отдел создан, обновлен или удален",
            settingsActions: "Настройки созданы, обновлены или удалены",
            integrationsActions: "Канал интеграции создан, обновлен или удален",
            loginFormActions: "Форма входа обновлена, активирована или деактивирована",
            bannedWordActions: "Запрещенное слово создано, обновлено или удалено",
            emailActions: "Учетная запись электронной почты создана или удалена",
            preparedContentActions: "Подготовленный контент создан или удален",
            roleActions: "Роль создана, обновлена или удалена",
            tagActions: "Метка создана, обновлена или удалена",
            welcomeMessageActions: "Приветственное сообщение создано, обновлено или удалено",
            webhookActions: "Webhook создан, обновлен или удален",
            billingEvents: "События биллинга",
            taskWorkflowCrud: "Рабочий процесс задачи создан, обновлен или удален",
            taskCrud: "Задача создана, обновлена или удалена",
            systemStatus: "Изменения статуса системы онлайн или офлайн",
            chatbotStoryCrud: "История чатбота создана, обновлена или удалена",
            chatbotForwardAgent: "Чатбот перенаправляет чат агенту",
            userSegmentCrud: "Сегмент пользователя создан, обновлен или удален",
            chatbotCreditLow: "Когда кредит чатбота низок",
            wpCreditLow: "Когда кредит Whatsapp низкий",
            wpCustomerGroupCrud: "Когда создается, обновляется или удаляется группа клиентов WhatsApp",
            wpBroadcastMessageStatus:
                "Когда отправляется, завершается или отменяется широковещательное сообщение WhatsApp",
            wpTemplateMesssageCrud: "Когда создается, обновляется или удаляется шаблонное сообщение WhatsApp",
            reservationMessageCrud: "Резервирование создано, обновлено, отменено",
        },
        mail: {
            deleteMailDesc: "Это действие нельзя отменить.",
            deleteMailTitle: "Вы уверены, что хотите удалить этот адрес электронной почты?",
            gmailForwardMail: "Пересылка почты Gmail",
            senderMailAddressDesc: "Пожалуйста, введите адрес электронной почты отправителя",
            verified: "Подтверждено",
            notForwarded: "Не переадресовано",
            notVerified: "Не подтверждено",
            default: "По умолчанию",
            isVerified: "Проверенный",
            forwarding: "Переадресация",
            mailAdress: "Адрес электронной почты",
            addSenderAddress: "Добавить адрес отправителя",
            outlookForward: "Microsoft (Outlook/Exchange) Переадресация",
            gmailForward: "Google (Gmail) Переадресация",
            senderMail: "Адрес отправителя",
            mailDetail: "Детали письма",
            mailNotFound: "Почта не найдена",
            mailSelecting: "Выбор почты",
            newMail: "Новое письмо",
            myMails: "Мои письма",
            inbox: "Входящие",
            sent: "Отправленные",
            departmentMails: "Электронные письма отдела",
            newTemplate: "Новый шаблон",
            unread: "Непрочитанный",
            unreply: "Unanswered",
            reply: "Ответить",
            attachments: "Вложения в письме",
            To: "Кому",
            From: "От кого",
            placeHolders: "Заменители",
            attacheFiles: "Прикрепить файлы",
            replyAll: "Ответить всем",
            forward: "Переслать",
            deleteThread: "Удалить беседу",
            markAsRead: "Отметить как прочитанное",
            markAsAllRead: "Пометить все как прочитанные",
            emailEditor: "Редактор электронной почты",
            integrateYourMail: "Интегрируйте свою почту",
            connect: "Подключить",
            departmentMail: "Почта отдела",
            createMailAddress: "Создать почтовый адрес",
            createNewMail: "Создать новое письмо",
        },
        visitor: {
            mail: "Почта",
            visitorDetail: "Детали посетителя",
            selectedUser: "Выбрано {selectedUser} из {totalUsers} пользователей",
            uncheck: "Снять все отметки",
            checkAll: "Отметить все",
            matchedUsers: "Совпадение с {checkedCount} пользователями",
            more: "Больше",
            exportUsers: "Экспортировать выбранных пользователей",
            exportAllUsers: "Экспортировать всех пользователей",
            addSegment: "Добавить сегмент",
            deleteCheckedUser: "Удалить выбранных пользователей",
            deleteAllUser: "Удалить всех пользователей",
            matchedFilter: "Совпадение всех фильтров",
            visitor: "Посетитель",
            deleteUser: "Удалить пользователя",
            userData: "Данные пользователя",
            lastSession: "Последняя сессия",
            notUserData: "Данные пользователя не найдены",
            segments: "Сегменты",
            tags: "Теги",
            addTag: "Добавить тег",
            userChats: "Чаты с пользователем",
            seeAll: "Показать все",
            confirm: "Подтвердить",
            manageSegments: "Управление сегментами",
            search: "Поиск",
            manageTags: "Управление тегами",
            allAttributes: "Показать все атрибуты",
            noData: "Нет данных",
            noEmail: "Нет электронной почты",
            noIpAddress: "IP адрес не найден.",
            noWpNumber: "Номер не найден.",
            filterName: "имя фильтра..",
            matchedContacts: "{chechkedCount} контакты совпадают",
        },
        chatbotv2: {
            selectedStory: "{count} сценарий выбран",
            Instagram_Actions: "Instagram Actions",
            suppressionRemoved: "Ограничение удалено",
            suppressionAdded: "Ограничение добавлено",
            didntSuppression: "Вы не сделали никаких ограничений.",
            whatsappIntegrationTitle: "WhatsApp V1 и WhatsApp V2 Интеграция",
            whatsappApiIntegrationTitle: "Интеграция WhatsApp Business API",
            ReadyTemplateBadge: "Готовый шаблон",
            readyTemplates: "Готовые шаблоны",
            regex: "Regex",
            regexDescription: "Regex ile herşeyi yakala",
            chatbotLogo: "Логотип чатбота",
            chatbotName: "Имя чатбота",
            allSecnario: "Список сценариев чат-бота",
            ChatbotScenarioList: "Список сценариев чат-бота",
            Scenario: "Сценарий",
            filters: {
                equal: "равно",
                not_equal: "не равно",
                contain: "содержать",
                not_contain: "не содержать",
                starts_with: "начинается с",
                ends_with: "начинается с",
                empty: "пустой",
                non_empty: "не пустой",
                longer_than: "длиннее чем",
                shorter_than: "короче чем",
                less_than: "меньше, чем",
                less_or_equal: "меньше или равно",
                greater_than: "лучше чем",
                greater_or_equal: "больше или равно",
            },
            planRequired: "{integratable} Требуется план",
            noDefaultStoryTitle: "История по умолчанию",
            noDefaultStory: "Нет истории по умолчанию.\nХотите сделать эту историю по умолчанию?",
            noMessage: "Нет сообщений",
            loading: "Загрузка",
            loadMore: "Загрузи больше",
            hostname: "имя хоста",
            goToStory: "перейти к истории",
            noResultFound: "результатов не найдено",
            checkYourFilterCombination: "Проверьте комбинацию фильтров",
            clearYourSearch: "очистите свой поиск",
            andTryAgain: "и попробуй еще раз",
            withBot: "& бот",
            userWithBot: "Пользователь & бот",
            chatDetail: "Детали чата",
            allUserDetail: "Посмотреть все данные о пользователе",
            sessionData: "Данные сеанса",
            supsisChatWidget: "Виджет Supsis Chat",
            integratedWith: "Интегрировано с : ",
            botStory: "История бота",
            integration: "Интеграции",
            Users: "пользователи",
            user_id: "ID пользователя",
            allTemplates: "Все шаблоны",
            allAITemplates: "Все шаблоны ИИ",
            templatesFromTheIndustry: "Шаблоны из отрасли",
            basicTemplate: "Базовый шаблон",
            proTemplate: "Расширенный шаблон",
            categories: "Категории",
            worksWith: "Работает с",
            importBot: "Импорт бота",
            keyFeatures: "Ключевая особенность",
            importing: "импорт",
            comingSoon: "Вскоре",
            cardInfos: "информация о карте",
            pickStory: "Выбери историю",
            conversationId: "Идентификатор беседы",
            integrateStoryWithSupsisWidget: "Интегрируйте виджет Supsis с историей чат-бота",
            integrateStoryWithWhatsapp: "Интегрируйте WhatsApp с историей чат-бота",
            integrateStoryWithInstagram: "Интегрируйте Instagram с историей чат-бота",
            selectIntegratingStory: "Выберите историю, которая будет интегрирована",
            install: "Установить",
            attr: {
                weekday: "Weekday",
                channelId: "Channel",
                email: "Эл. адрес",
                phone: "Phone",
                language: "Язык",
                timezone: "Часовой пояс",
                gender: "Пол",
                country: "Страна",
                department: "Отдел",
                referrer: "Реферер",
                url: "URL-адрес",
                ip: "IP",
                last_seen: "Last Видимый",
                name: "Имя",
                user_id: "ID пользователя",
                message: "Message",
                akinon_brand: "Бренд",
                akinon_order_id: "Номер заказа",
                akinon_product_id: "Код товара",
                akinon_user_id: "ID пользователя",
                akinon_user_name: "Имя пользователя",
                akinon_user_email: "Электронная почта пользователя",
                akinon_invoice_url: "URL счета",
                akinon_order_status: "Статус заказа",
                akinon_order_price: "Стоимость заказа",
                akinon_shipper_name: "Имя грузоотправителя",
                akinon_product_size: "Размер товара",
                akinon_sku: "Артикул",
                akinon_product_url: "URL продукта",
                akinon_product_title: "Название продукта",
                akinon_product_image: "Изображение продукта",
                akinon_product_stock: "Товарный запас",
                akinon_order_date: "Дата заказа",
                akinon_track_number: "Номер дорожки",
                akinon_track_url: "URL отслеживания",
                akinon_latitude: "Широта",
                akinon_longitude: "Долгота",
                idleUserTime: "User Last Action (Second)",
                ai_class_result: "AI Class Result",
                meta_comment_id: "Meta Comment ID",
                meta_comment: "Meta Comment",
                meta_post_id: "Meta Post ID",
                ideasoft_user_id: "Member Id",
                ideasoft_invoice_url: "Invoice Url",
                ideasoft_order_id: "Sipariş Numarası",
                ideasoft_order_status: "Order Status",
                ideasoft_order_price: "Order Price",
                ideasoft_shipper_name: "Shipper Name",
                ideasoft_product_size: "Product Size",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Product Url",
                ideasoft_product_title: "Product Title",
                ideasoft_product_image: "Product Image",
                ideasoft_product_stock: "Product Stock",
                ideasoft_order_date: "Order Date",
                ideasoft_track_number: "Track Number",
                ideasoft_track_url: "Track Url",

                offline_mode: "Автономный режим",
                available_agents: "Доступные представитель",
                platform: "Платформа",
                hour: "Час",
                segments: "Segments",
                tags: "Теги",
                ticket: "билет",
                metaReferrals: "Мета-рефералы",
            },
            storyList: "Список историй",
            douYouWannaDeleteItem: "Вы хотите удалить этот элемент?",
            douYouWannaDeleteWithChildren: "Вы хотите удалить этот элемент вместе с его дочерними элементами?",
            stories: "Рассказы",
            templates: "Шаблоны",
            aitemplates: "Шаблоны ИИ",
            integrations: "Интеграции",
            all: "Все",
            installed: "Установлены",
            installationOK: "установлены",
            uninstall: "Удалить",
            remainingMessageDesc: "Осталось бесплатных сообщений : ",
            openAISiteRoutingDescStart: "Вы можете щелкнуть ссылку ",
            openAISiteRoutingDescEnd: " чтобы получить ключ API.",
            integrationOK: "Интегрированный",
            chatWidget: "Supsis Виджет чата",
            artificialIntelligence: "Искусственный интеллект",
            integratePlatform: "Чат-бот может быть интегрирован с {integretable}.",
            integrateOpenAIWithChatbot: "Интеграция чата GPT-4 с чат-ботом",
            integrateChatBotWithChatGPT3: "Интеграция ChatBot с Chat GPT-4",
            integrateStoryWithTelegram: "История интеграции с Telegram",
            webhooks: "вебхуки",
            archive: "Архив",
            reports: "Отчеты",
            uncheckAll: "Снять все",
            userSegments: "Сегменты пользователей",
            addSegment: "Добавить сегмент",
            addToSegment: "Add To Segment",
            removeFromSegment: "Remove From Segment",
            plansVTippyContent:
                "Оплата за этот пакет будет производиться в начале каждого месяца, и в случае отмены ваше использование будет оплачено до начала месяца, и ваш пакет истечет.<br><br>Цена пакета не включает НДС.<br><br>Изменения в пакете отражаются в счете на следующий день.",
            segmentName: "Название сегмента",
            sameSegment: "Существует сегмент с таким же названием!",
            usersInSegment: "Пользователы в сегменте",
            noUsersAdded: "Пользователи не добавлены",
            updateSegment: "Обновить сегмент",
            newSegment: "Новый сегмент",
            selectAll: "Выбрать все",
            queriesSelected: "выбранные запросы",
            noBlocksFound: "Блоки не найдены!",
            userQuery: "Пользовательский запрос",
            date: "Свидание",
            unmatched: "Бесподобный",
            goToChat: "Перейти в чат",
            selectStory: "Выберите историю",
            selectBlock: "Выберите блок",
            training: "Подготовка",
            trainingAlert:
                "Для внедрения изменений, которые вы внесли на странице обучения бота, вам необходимо опубликовать новую версию сценария, который вы изменили",
            unmatchedPhrases: "Непревзойденные фразы",
            ignored: "Игнорируется",
            story: "История",
            timePeriod: "Временной период",
            wholeTimeSpan: "Весь промежуток времени",
            selectAStory: "Выберите историю",
            searchUserQuery: "Поисковый запрос пользователя",
            time: {
                today: "Сегодня",
                yesterday: "Вчерашний день",
                last7: "Последние 7 дней",
                last30: "Последние 30 дней",
                "this-month": "Этот месяц",
                "last-month": "Прошлый месяц",
                "last-3-month": "Последние 3 месяца",
                "this-year": "В этом году",
                "last-year": "Прошедший год",
                custom: "Выберите другую дату",
            },
            emailProvider: "Провайдер электронной почты",
            triggerFromAnywhere: "Запуск из любого места",
            editBlock: "Редактировать",
            moveBlock: "Шаг",
            copyBlock: "Копировать",
            chatbot: "чат-бот",
            addFilter: "Добавить фильтр",
            addFilterGroup: "Добавить группу фильтров",
            in: "в",
            and: "а также",
            or: "вейя",
            allStories: "Все истории",
            addBot: "Добавить бота",
            testBot: "Протестируйте бота",
            publish: "Публиковать",
            editName: "Редактировать название",
            search: "Найдите в своей истории…",
            typeMoreThan3Char: "Введите не менее 3 символов",
            expand: "Расширять",
            expandAll: "Расширять все",
            noMatchingItem: "Нет подходящего товара",
            hint: "Намекать",
            select: "Выбрать",
            navigate: "Навигация",
            dismiss: "Увольнять",
            choseAttribute: "Выберите тип атрибута",
            selectReply: "Выберите тип ответа",
            preview: "Предварительный просмотр",
            draft: "Черновик",
            lastUpdate: "Последнее обновление",
            published: "Опубликовано",
            newStory: "Новая история",
            updateStory: "Обновить историю",
            storyDescription: "Описание истории",
            storyTitle: "Название рассказа",
            deleteSingleBlock: "Удалить отдельный блок",
            deleteWithChildren: "Удалить с детьми",
            startTestFromHere: "Start Test From Here",
            copyBlockId: "Copy Block Id",
            gotoLiveLink: "Go to Live Link",
            copyBlockIdSuccessfull: "Block Id copied to clipboard",
            collapse: "Свернуть",
            collapseAll: "Свернуть все",
            snDelay: "{delay} сек задержка",
            blockUpdated: "Блок обновлен",
            addPayload: "Добавить полезную нагрузку",
            previewModeCaution:
                "Сейчас вы просматриваете одну из версий вашей истории. Вы не можете сохранить изменения в режиме предварительного просмотра!",
            enterText: "Введите текст...",
            trackpad: "Трекпад",
            navigation: "Навигация",
            navigationDesc: "Пожалуйста, выберите режим навигации. Вам решать, будет ли это трекпад или мышь.",
            botSetting: "Настройка бота",
            botSettingDesc:
                "Пожалуйста, определите уровень доверия. Это процент от 0 до 100. Уровень определяет правильность интерпретаций чат-ботов, связанных с вводом данных пользователем.",
            languageSettingsDesc:
                "Пожалуйста, убедитесь, что язык бота, на который он отвечает, является вашим предпочтительным языком.",
            mouse: "мышь",
            Interactions: "Взаимодействия",
            Actions: "Действия",
            Supsis_Actions: "Supsis Действия",
            Shopify_Actions: "Shopify Действия",
            Akinon_Actions: "Akinon Действия",
            IdeaSoft_Actions: "Ideasoft Actions",
            START_POINT: "ТОЧКА ОТСЧЕТА",
            AI_ASSISTANT: "AI ASSISTANT",
            BOT_RESPONSE: "ОТВЕТ БОТА",
            AI_BOT_RESPONSE: "AI RESPONSE (GPT-4o)",
            AI_CLASSIFICATION: "AI CLASSIFICATION",
            Templates: "Template Blocks",
            AI_MENU_FLOW: "AI MENU",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "ВОЗВРАТ ПО УМОЛЧАНИЮ",
            FILTER: "ФИЛЬТР",
            addNewFilter: "Добавить новый фильтр",
            FLOW: "ПОТОК",
            ATTACHMENT_INPUT: "ПРИЛОЖЕНИЕ ВВОД",
            USER_INPUT: "ВВОД ПОЛЬЗОВАТЕЛЯ",
            GO_TO_STEP: "ПЕРЕЙТИ К ШАГУ",
            WEBHOOK: "ВЕБХУК",
            SET_ATTRIBUTE: "УСТАНОВИТЬ АТРИБУТ",
            QUESTION: "ВОПРОС",
            CLOSE_CHAT: "ЗАКРЫТЬ ЧАТ",
            CREATE_TICKET: "СОЗДАТЬ ЗАЯВКУ",
            TRANSFER_CHAT: "ТРАНСФЕРНЫЙ ЧАТ",
            TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
            TAG_CHAT: "ADD TAG",
            REMOVE_TAG: "REMOVE TAG",
            SET_DEPARTMENT: "УСТАНОВИТЬ ОТДЕЛ",
            SEND_TRANSCRIPT: "ОТПРАВИТЬ ЗАПИСЬ",
            SEND_SMS: "SEND SMS",
            SEND_MAIL: "SMS MAIL",
            CREATE_EVENT: "CREATE EVENT",
            CREATE_RESERVATION: "CREATE RESERVATION",
            RESERVATION_OPEN_URL: "Reservation Open Url",
            RESERVATION_SELECT_DAY: "Select reservation day",
            RESERVATION_EVENT_LIST: "Reservation list visitor",
            RESERVATION_SELECT_TIME: "Select reservation time",
            CREATE_TASK: "CREATE TASK",
            SHOPIFY_SHOW_PRODUCTS: "ПОКУПАТЬ ПОКАЗАТЬ ПРОДУКЦИЮ",
            SHOPIFY_PRODUCT_AVAILABILITY: "ПОКУПАЙТЕ НАЛИЧИЕ ПРОДУКТА",
            SHOPIFY_ORDER_STATUS: "ПОКУПАТЬ СТАТУС ЗАКАЗА",
            AKINON_SHOW_PRODUCTS: "АКИНОН ПОКАЗАТЬ ПРОДУКТЫ",
            AKINON_FIND_PRODUCT: "AKINON FIND PRODUCT",
            AKINON_ORDER_STATUS: "АКИНОН СТАТУС ЗАКАЗА",
            AKINON_SELECT_ORDER: "AKINON SELECT ORDER",
            AKINON_SELECT_SIZE: "AKINON SELECT SIZE",
            AKINON_FIND_NEAREST_STOCK: "SHOW STORE STOCK",
            AKINON_FIND_NEAREST_STORES: "SHOW NEAREST STORES",
            AKINON_SHOW_DISCOUNT_CODES: "SHOW DISCOUNT CODES",

            IDEASOFT_SELECT_ORDER: "SELECT ORDER",
            IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
            IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",
            INSTAGRAM_COMMENT_REPLY: "ОТВЕТИТЬ НА КОММЕНТАРИЙ",
            INSTAGRAM_COMMENT_DELETE: "УДАЛИТЬ КОММЕНТАРИЙ",
            INSTAGRAM_COMMENT_SHOW: "ПОКАЗАТЬ КОММЕНТАРИЙ",
            INSTAGRAM_COMMENT_HIDE: "СКРЫТЬ КОММЕНТАРИЙ",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "ОТВЕТИТЬ В ЛИЧНЫХ СООБЩЕНИЯХ",
            followingAttributesFilled: "Будут заполнены следующие атрибуты.",
            GET_LOCATION: "GET LOCATION",
            FALLBACK: "ОТСТУПАТЬ",
            SUCCESS: "УСПЕХ",
            FAILURE: "ОТКАЗ",

            message: "сообщение",
            condition: "условие",
            score: "счет",
            equal: "равный",
            not_equal: "не равный",
            contain: "содержать",
            not_contain: "не содержать",
            starts_with: "начинается с",
            ends_with: "заканчивается",
            empty: "пустой",
            longer_than: "длиннее чем",
            shorter_than: "короче чем",
            less_than: "меньше, чем",
            less_than_equal: "меньше, чем равно",
            greater_than: "лучше чем",
            greater_than_equal: "больше, чем равно",
            value: "ценность",
            failures: "неудачи",
            email: "Эл. адрес",
            name: "имя",
            username: "имя пользователя",
            source: "источник",
            language: "язык",
            timezone: "часовой пояс",
            region: "область, край",
            country: "страна",
            referrer: "реферер",
            url: "URL",
            ip: "IP",
            city: "город",
            lastSeen: "последний раз видели",
            userId: "ID пользователя",
            selectStep: "выберите шаг",
            keywords: "ключевые слова",
            userSays: "пользователи говорят",
            addKeyword: "Добавить слово",
            addUserMessage: "аддусермессаже",
            set: "установлен",
            to: "к",
            gender: "Пол",

            go_to_failure: "Идти к провалу",
            go_to_success: "Идти к успеху",
            untilFilled: "До заполнения",
            time1: "однажды",
            time2: "время 2",
            time3: "время 3",
            time4: "время 4",
            time5: "время 5",
            any: "Любые",
            anytext: "Any Text",
            anytextDescription: "Matches only words + spaces",
            alphanumeric: "буквенно-цифровой",
            integer: "Целое число",
            no: "Нет",
            number: "Число",
            phone: "Телефон",
            yes: "Да",
            yesNo: "Да нет",
            anyDescription: "Соответствует всему, что не пусто.",
            alphanumericDescription: "Соответствует буквам и цифрам.",
            integerDescription: "Соответствует целому числу.",
            noDescription: "Нет синонимов.",
            numberDescription: "Соответствует порядковому и количественному числительному.",
            phoneDescription: "Соответствует номеру телефона.",
            yesDescription: "Соответствует да синонимам.",
            yesNoDescription: "Соответствует синонимам 'да' и 'нет'.",
            emailDescription: "Соответствует электронной почте.",
            urlDescription: "Соответствует URL.",
            temperature: "Температура",
            askWhenInvalid: "спросить, когда недействительно",

            applyFilter: "Применение фильтра",
            RANDOM_TEXT: "Случайный текст",
            QUICK_REPLY: "Быстрый ответ",
            FILE: "File",
            notificationMessageStartSuccess: "Блокировать ",
            notificationMessageEndSuccess: " Добавлен",
            notificationMessageStartError: "Произошла ошибка, заблокируйте ",
            notificationMessageEndError: " не удалось добавить",
            blockChangedWannaUpdate: "Я хочу изменить обновление",
            responses: "Ответы",
            TEXT: "текст",
            IMAGE: "Изображение",
            GALLERY: "Галерея",
            BUTTON: "Кнопка",
            flow: "Поток",
            active: "активный",
            passive: "пассивный",

            chooseAttributeType: "Выберите тип функции",
            imageAttachment: "Вложение изображения",
            audioAttachment: "Аудио вложение",
            videoAttachment: "Видео вложение",
            documentAttachment: "Приложение к документу",
            anyAttachment: "Любое вложение",
            typeAttributeValue: "Тип Атрибут Значение",
            typeSearchValue: "Введите значение поиска",
            male: "мужчина",
            addAttribute: "Добавить атрибут",
            addAttributeDescription:
                "Имя атрибута может содержать только буквенно-цифровые символы, такие как буквы A-Z, цифры 0-9, тире или подчеркивание.",
            USER_DATA: "информация о пользователе",
            CUSTOM_ATTRIBUTES: "ПОЛЬЗОВАТЕЛЬСКИЕ АТРИБУТЫ",
            enterBotResponseHere: "Введите ответ бота здесь...",

            addCard: "Добавить карту",
            addButton: "Добавить кнопку",
            typeCardTitle: "Заголовок типа этажа",
            typeCardDescription: "Тип карты Содержание",
            dragAndDropBrowse: "Загрузить изображение",
            dragAndDropBrowseFile: "Upload File",
            button: "Кнопка",
            enterYourMessage: "Введите сообщение",
            imageView: "Просмотр изображения",
            imageUploading: "Загрузка изображения...",
            fileUploading: "File uploading...",
            clickToChooseNewImage: "Нажмите, чтобы выбрать новое изображение",
            clickToChooseNewFile: "Click To Choose New File",
            removeTheExistingOne: "Удалить существующий",

            validateResponseWithEntity: "Подтвердить ответ",
            actionOnFailureInput: "Действия при неудачном входе в систему",
            askNextQuestion: "Задайте следующий вопрос",
            goToSuccessBlock: "Перейти в свой блог успеха",
            goToFailureBlock: "Перейти к неудавшемуся блоку",
            saveResposeToAttribute: "Сохранить ответ",
            selectReplyType: "Выберите тип ответа",
            questionVariants: "Типы вопросов",
            systemEntities: "система Сущности",
            delay: "задерживать",
            retrySectionTextPart: "Спросите ",
            retrySectionText: " , не является ли ответ пользователя недействительным",
            addNextQuestion: "добавить следующий вопрос",
            typeBlockTitle: "введите заголовок блока",
            versionHistory: "история версий",
            restore: "история",
            versionName: "Название версии",
            restoreModalText:
                "Это действие восстановит выбранную версию. Вы уверены, что хотите восстановить эту версию?",
            restoreVersion: "Восстановить версию",
            newVersion: "Новая версия",
            synonymMustBeUnique: "Синоним должен быть уникальным",
            save: "Сохранять",
            entries: "Записи",
            youHaveNoEntries: "У вас нет записей",
            inputsCantBeEmpty: "Входы не могут быть пустыми",
            entryNamesMustBeUnique: "Имена записей должны быть уникальными",
            entityNameCantBeEmpty: "Сущность не может быть пустой",
            entityNameMustBeUnique: "Имя объекта должно быть уникальным",
            synonyms: "синонимы",
            entities: "Сущности",
            title: "заглавие",
            entryName: "имя_записи",
            entityhasbeenUpdatedSuccessfully: "Сущность успешно обновлена",

            allChats: "все чаты",
            paidChats: "платные чаты",
            busiestPeriod: "Самый загруженный период",
            ratingDistribution: "Распределение рейтинга",
            allMessages: "Все сообщения",
            avarageMessages: "Среднее количество сообщений",
            popularity: "популярность",
            allUsers: "Все пользователи",
            interactionName: "Название взаимодействия",
            numberOfMessage: "Номер сообщения",
            ofAllUsersMessage: "% всех сообщений пользователей",

            totalData: "Всего данных",
            avgData: "Средние данные",
            exportToCsv: "Экспорт в CSV",
            expoorToExcel: "Экспорт в Excel",
            inMaintenance: "в обслуживании",
            ADD_TO_SEGMENT: "добавить в сегмент",
            REMOVE_FROM_SEGMENT: "удалить из сегмента",
            users: "пользователи",
            webhookName: "Имя вебхука",
            webHookUrl: "URL вебхука",
            webHookToken: "Token",
            delete: "Удалить",
            basicAuth: "Basic Auth",
            requiredFieldsCannotBeLeftBlank: "Обязательные поля нельзя оставлять пустыми",
            yourVerificationToken: "Token",
            yourWebHookName: "Ваше имя вебхука",
            yourWebHookUrl: "URL вашего вебхука",
            enterKey: "Key",
            password: "Пароль",
            headerValue: "Value",
            saveSuccessfully: "ваша транзакция успешно сохранена",
            urlTypeError: "Пожалуйста, заполните поле правильно (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "Требуется ключ OpenAI Chat GPT-4 API.",
                apiKeyDesc:
                    "Для интеграции Chatbot + Chat GPT-4 требуется ключ Api. Пожалуйста, получите ключ API или используйте приведенный ниже ключ API для пробной версии. Вы можете использовать только 20 сообщений для пробной версии.",
                getApiKey: "Получить ключ Openai API",
                typeApiKey: "Введите ключ API",
                ownApiKey: "Собственный ключ API OpenAI",
                trialApiKey: "Пробный ключ API (ограничено 20 сообщениями)",
                useOurTrial: "Воспользуйтесь нашей бесплатной пробной версией",
                twentyMessages: "Вы можете попробовать, используя 20 сообщений бесплатно.",
                enableChatGpt3: "Включить чат GPT-4",
            },
        },
        coupon: {
            code: "Код",
            discount: "Скидка",
            endDate: "Дата окончания",
            name: "Имя",
            email: "Электронное письмо",
            phone: "Телефон",
            add: "Добавить купон",
            coupons: "купоны",
            couponDeleted: "Купон удален",
            limit: "Ограничение",
            visitorBan: "Посетитель заблокирован.",
            visitorUnBlock: "Блокировка снята.",
        },
        instagramTitle: "Нажмите кнопку ниже, чтобы включить функции Instagram..",
        instegramFunctionActive: "Включить функцию Instagram",
        ChatBOT: "Чат-бот",
        WhatsappContacts: "WhatsApp Контакты",
        InstagramContacts: "Instagram Контакты",
        MessengerContacts: "Messenger Contacts",
        editWebhook: "Изменить вебхук",
        newWebhook: "Новый вебхук",
        webhookTitle: "Название вебхука",
        webhookUrl: "URL-адрес веб-перехватчика",
        webhookToken: "Токен вебхука",
        webhookUsername: "Имя пользователя вебхука",
        webhookPassword: "Пароль вебхука",
        allIntegrations: "Все интеграции",
        integrateYourCBwithChatWidget: "Интегрируйте своего чат-бота с виджетом чата.",
        integrateYourCBwithChatGpt3: "Чат-бот можно интегрировать с GPT-4. Требуется ключ API GPT-4.",
        integrateYourCBwithWebHook: "С легкостью передавайте информацию чата между ChatBot и вашими веб-службами.",
        integrateYourCBwithIntegratable: "С легкостью передавайте информацию чата между ChatBot и {integratable}.",
        addWebhook: "Добавить вебхук",
        volumeUp: "Увеличить громкость",
        minimize: "Свести к минимуму",
        maximize: "Максимизировать",
        auditLogs: {
            auditLogsTitle: "Журнал аудита",
            auditLogsSub:
                "Журналы аудита позволяют отслеживать события, произошедшие в вашей компании за последние 30 дней.",
        },
        task: {
            workflow: "Рабочий процесс",
            workflowDetail: "Детали рабочего процесса",
            workflowPerm: "Разрешения рабочего процесса",
            perm: "Разрешения",
            detail: "Детали",
            userPerm: "Пользовательские разрешения",
            deleteCard: "Удалить карточку",
            createCard: "Создать карточку",
            editCard: "Редактировать карточку",
            dragCard: "Перетащить карточку",
            allWorkflow: "Все рабочие процессы",
            createworkflow: "Создать рабочий процесс",
            deleteWorkflow: "Вы уверены, что хотите удалить этот рабочий процесс?",
            permEditTask: "У вас нет разрешения на редактирование этой задачи",
            permEditTaskDes: "Обратитесь к администратору для получения разрешений на редактирование.",
            createTaskError: "У вас нет разрешения на создание задач",
            createTaskErrorDesc: "Обратитесь к администратору для получения разрешений на создание задач.",
            moveTaskError: "У вас нет разрешения на изменение статуса задачи",
            moveTaskErrorDesc: "Обратитесь к администратору для получения разрешений на изменение статуса задачи.",
            deleteTaskError: "У вас нет разрешения на удаление задач",
            deleteTaskErrorDesc: "Обратитесь к администратору для получения разрешений на удаление задач.",
            permissionError: "У вас нет прав на создание задач",
            permissionErrorDesc:
                "Пожалуйста, свяжитесь с вашим администратором для получения разрешения на создание задач",
            whatsappContactProfileTitle: "Профиль {name} / {number}",
            createTaskVisitor: "Создать задачу (посетитель)",
            editWorkflow: "Редактировать рабочий процесс",
            visitor: "Профиль посетителя",
            createTaskMessage: "Создать задачу (Сообщение)",
            createStage: "Создать этап",
            stagesAndStatuses: "Этапы и статусы",
            workflowCreateDesc: "Описание рабочего процесса",
            subTasks: "Подзадачи",
            followers: "Подписчики",
            collaborators: "Совместные работники",
            addRelations: "Добавить отношения",
            relations: "отношения",
            main: "Главная вкладка",
            name: "имя",
            completedOfCheck: "{completed} из {total} задач выполнено",
            workflowUpdateMs: "Workflow Successfully Updated",
            taskUpdateMs: "Task Successfully Updated",
            workflowCreatedMs: "Workflow Successfully Created",
            workflowCreateError: "Не удалось создать рабочий процесс",
            taskCreatedMs: "Task Successfully Created",
            settingsDesc3:
                "Кроме того, модуль задач Supsis позволяет создавать собственный рабочий процесс с настраиваемой автоматизацией, что позволяет управлять задачами более эффективно и улучшать сотрудничество в команде.",
            settingsDesc4:
                "Таким образом, вы можете подробно отслеживать каждую из ваших задач, назначать задачи членам команды и общим образом управлять вашими бизнес-процессами более эффективно. Модуль задач Supsis предоставляет вам комплексное решение для управления задачами и координации команды.",
            settingsDesc2:
                "The Supsis task module leaves no task overlooked. You can filter tasks based on any parameter, track workloads for each workflow stage, and organize your calendar to align with your schedules.",
            settingsDesc1:
                "Модуль задач позволяет организовывать совместную работу, делегировать задачи и отслеживать прогресс вашей команды. Вы можете настроить ваши задачи в соответствии с вашими потребностями, выбрав любое представление, и создать собственные рабочие процессы с помощью автоматизации.",
            taskModuleSettingsTitle: "Настройки модуля задачи",
            high: "Высокий",
            medium: "Средний",
            low: "Низкий",
            priority: "Приоритет",
            addExistsSubtask: "Добавить существующую подзадачу",
            addSubtask: "Добавить подзадачу",
            add: "Добавить",
            newCheckList: "Новый список дел",
            subtaskTitle: "Заголовок подзадачи",
            view: "Посмотреть",
            attachFiles: "Прикрепить файлы",
            createTaskDesc: "Описание задачи",
            title: "заглавие",
            createWorkflow: "Создать рабочий процесс",
            editTask: "Редактировать задачу",
            createTask: "Создать задачу",
            deleteColumnCont: "Вы уверены, что хотите удалить этот столбец?",
            changeStage: "Изменить стадию",
            assignees: "Назначенные лица",
            owner: "Владелец",
            stage: "Стадия",
            writeSomething: "Напишите что-нибудь",
            selectAssginee: "Select Assignee",
            assignee: "Assignee",
            enterNewTaskDesc: "Enter New Task Description",
            enterNewTaskTitle: "Enter New Task Title",
            task: "Задача",
            deleteTaskCont: "Вы уверены, что хотите удалить эти задачи?",
            deleteWorkFlowCont: "Вы уверены, что хотите удалить этот рабочий процесс?",
            completed: "Завершено",
            todo: "Дела",
            kanbanBoard: "Доска Канбан",
            listView: "Список",
        },
        permissionErrors: {
            userCreate:
                "У вас нет разрешения на добавление пользователей. Пожалуйста, проконсультируйтесь с администратором.",
            userRead:
                "У вас нет разрешения на просмотр пользователей. Пожалуйста, проконсультируйтесь с администратором.",
            userUpdate:
                "У вас нет разрешения на обновление пользователей. Пожалуйста, проконсультируйтесь с администратором.",
            userDelete:
                "У вас нет разрешения на удаление пользователей. Пожалуйста, проконсультируйтесь с администратором.",
            visitorBlock:
                "У вас нет разрешения на блокировку посетителей. Пожалуйста, проконсультируйтесь с администратором.",
            visitorUnblock:
                "У вас нет разрешения на разблокировку посетителей. Пожалуйста, проконсультируйтесь с администратором.",
            visitorDetailRead:
                "У вас нет разрешения на просмотр сведений о посетителях. Пожалуйста, проконсультируйтесь с администратором.",
            visitorListRead:
                "У вас нет разрешения на просмотр списка посетителей. Пожалуйста, проконсультируйтесь с администратором.",
            visitorDelete:
                "У вас нет разрешения на удаление посетителей. Пожалуйста, проконсультируйтесь с администратором.",
            visitorExcel:
                "У вас нет разрешения на получение Excel-вывода. Пожалуйста, проконсультируйтесь с администратором.",
            visitorUpdate:
                "У вас нет разрешения на обновление посетителей. Пожалуйста, проконсультируйтесь с администратором.",
            bannedVisitorRead:
                "У вас нет разрешения на просмотр списка заблокированных посетителей. Пожалуйста, проконсультируйтесь с администратором.",
            bannedWordCreate:
                "У вас нет разрешения на добавление запрещенных слов. Пожалуйста, проконсультируйтесь с администратором.",
            bannedWordRead:
                "У вас нет разрешения на просмотр запрещенных слов. Пожалуйста, проконсультируйтесь с администратором.",
            bannedWordDelete:
                "У вас нет разрешения на удаление запрещенных слов. Пожалуйста, проконсультируйтесь с администратором.",
            chatRead: "У вас нет разрешения на просмотр чатов. Пожалуйста, проконсультируйтесь с администратором.",
            chatUpdate: "У вас нет разрешения на редактирование чатов. Пожалуйста, обратитесь к вашему администратору.",
            archiveRead: "У вас нет разрешения на просмотр архивов. Пожалуйста, обратитесь к вашему администратору.",
            roleCreate: "У вас нет разрешения на добавление ролей. Пожалуйста, обратитесь к вашему администратору.",
            roleRead: "У вас нет разрешения на просмотр ролей. Пожалуйста, обратитесь к вашему администратору.",
            roleUpdate: "У вас нет разрешения на обновление ролей. Пожалуйста, обратитесь к вашему администратору.",
            roleDelete: "У вас нет разрешения на удаление ролей. Пожалуйста, обратитесь к вашему администратору.",
            departmentCreate:
                "У вас нет разрешения на добавление отделов. Пожалуйста, обратитесь к вашему администратору.",
            departmentRead: "У вас нет разрешения на просмотр отделов. Пожалуйста, обратитесь к вашему администратору.",
            departmentUpdate:
                "У вас нет разрешения на обновление отделов. Пожалуйста, обратитесь к вашему администратору.",
            departmentDelete:
                "У вас нет разрешения на удаление отделов. Пожалуйста, обратитесь к вашему администратору.",
            preparedContentCreate:
                "У вас нет разрешения на создание готового контента. Пожалуйста, обратитесь к вашему администратору.",
            preparedContentRead:
                "У вас нет разрешения на просмотр готового контента. Пожалуйста, обратитесь к вашему администратору.",
            preparedContentUpdate:
                "У вас нет разрешения на обновление готового контента. Пожалуйста, обратитесь к вашему администратору.",
            preparedContentDelete:
                "У вас нет разрешения на удаление готового контента. Пожалуйста, обратитесь к вашему администратору.",
            welcomeCreate:
                "У вас нет разрешения на создание приветственных сообщений. Пожалуйста, обратитесь к вашему администратору.",
            welcomeRead:
                "У вас нет разрешения на просмотр приветственных сообщений. Пожалуйста, обратитесь к вашему администратору.",
            welcomeUpdate:
                "У вас нет разрешения на обновление приветственных сообщений. Пожалуйста, обратитесь к вашему администратору.",
            welcomeDelete:
                "У вас нет разрешения на удаление приветственных сообщений. Пожалуйста, обратитесь к вашему администратору.",
            settingCreate: "У вас нет разрешения на создание настроек. Пожалуйста, обратитесь к администратору.",
            settingRead: "У вас нет разрешения на просмотр настроек. Пожалуйста, обратитесь к администратору.",
            settingUpdate: "У вас нет разрешения на обновление настроек. Пожалуйста, обратитесь к администратору.",
            settingDelete: "У вас нет разрешения на удаление настроек. Пожалуйста, обратитесь к администратору.",
            reportCreate: "У вас нет разрешения на создание отчетов. Пожалуйста, обратитесь к администратору.",
            reportRead: "У вас нет разрешения на просмотр отчетов. Пожалуйста, обратитесь к администратору.",
            reportUpdate: "У вас нет разрешения на обновление отчетов. Пожалуйста, обратитесь к администратору.",
            reportDelete: "У вас нет разрешения на удаление отчетов. Пожалуйста, обратитесь к администратору.",
            offlineSupportRequestCreate:
                "У вас нет разрешения на создание запросов в офлайн-поддержку. Пожалуйста, обратитесь к администратору.",
            offlineSupportRequestRead:
                "У вас нет разрешения на просмотр запросов в офлайн-поддержку. Пожалуйста, обратитесь к администратору.",
            offlineSupportRequestUpdate:
                "У вас нет разрешения на ответ на запросы в офлайн-поддержку. Пожалуйста, обратитесь к администратору.",
            offlineSupportRequestDelete:
                "У вас нет разрешения на удаление запросов в офлайн-поддержку. Пожалуйста, обратитесь к администратору.",
            catalogCreate: "У вас нет разрешения на создание каталогов. Пожалуйста, обратитесь к администратору.",
            catalogRead: "У вас нет разрешения на просмотр каталогов. Пожалуйста, обратитесь к администратору.",
            catalogUpdate: "У вас нет разрешения на обновление каталогов. Пожалуйста, обратитесь к администратору.",
            catalogDelete: "У вас нет разрешения на удаление каталогов. Пожалуйста, обратитесь к администратору.",
            chatbotStoryCreate:
                "У вас нет разрешения на создание историй чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotStoryRead:
                "У вас нет разрешения на просмотр историй чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotStoryUpdate:
                "У вас нет разрешения на обновление историй чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotStoryDelete:
                "У вас нет разрешения на удаление историй чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotTemplateRead:
                "У вас нет разрешения на просмотр шаблонов чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotTemplateAiRead:
                "У вас нет разрешения на просмотр шаблонов искусственного интеллекта чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotIntegrationsRead:
                "У вас нет разрешения на просмотр интеграций чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotArchiveRead:
                "У вас нет разрешения на просмотр архивов чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotEntitiesRead:
                "У вас нет разрешения на просмотр сущностей чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotEntitiesCreate:
                "У вас нет разрешения на создание сущностей чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotEntitiesUpdate:
                "У вас нет разрешения на обновление сущностей чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotEntitiesDelete:
                "У вас нет разрешения на удаление сущностей чат-ботов. Пожалуйста, обратитесь к администратору.",
            chatbotReportRead: "У вас нет прав на просмотр отчетов чатбота. Пожалуйста, обратитесь к администратору.",
            chatbotTrainRead: "У вас нет прав на просмотр обучения чатбота. Пожалуйста, обратитесь к администратору.",
            chatbotSegmentCreate:
                "У вас нет прав на создание сегментов пользователей чатбота. Пожалуйста, обратитесь к администратору.",
            chatbotSegmentRead:
                "У вас нет прав на просмотр сегментов пользователей чатбота. Пожалуйста, обратитесь к администратору.",
            chatbotSegmentUpdate:
                "У вас нет прав на обновление сегментов пользователей чатбота. Пожалуйста, обратитесь к администратору.",
            chatbotSegmentDelete:
                "У вас нет прав на удаление сегментов пользователей чатбота. Пожалуйста, обратитесь к администратору.",
            integrationsRead:
                "У вас нет прав на просмотр страницы интеграций. Пожалуйста, обратитесь к администратору.",
            whatsappIntegrationRead:
                "У вас нет прав на просмотр страницы интеграции WhatsApp. Пожалуйста, обратитесь к администратору.",
            instagramIntegrationRead:
                "У вас нет прав на просмотр страницы интеграции Instagram. Пожалуйста, обратитесь к администратору.",
            telegramIntegrationRead:
                "У вас нет прав на просмотр страницы интеграции Telegram. Пожалуйста, обратитесь к администратору.",
            integrationCreate: "У вас нет прав на активацию интеграций. Пожалуйста, обратитесь к администратору.",
            triggerCreate: "У вас нет прав на создание триггеров. Пожалуйста, обратитесь к администратору.",
            triggerRead: "У вас нет прав на просмотр триггеров. Пожалуйста, обратитесь к администратору.",
            triggerUpdate: "У вас нет прав на обновление триггеров. Пожалуйста, обратитесь к администратору.",
            triggerDelete: "У вас нет прав на удаление триггеров. Пожалуйста, обратитесь к администратору.",
            billingRead: "У вас нет разрешения на просмотр счетов. Пожалуйста, свяжитесь с вашим администратором.",
            taskCreate: "У вас нет разрешения на создание задач. Пожалуйста, свяжитесь с вашим администратором.",
            taskRead: "У вас нет разрешения на просмотр задач. Пожалуйста, свяжитесь с вашим администратором.",
            taskUpdate: "У вас нет разрешения на обновление задач. Пожалуйста, свяжитесь с вашим администратором.",
            taskDelete: "У вас нет разрешения на удаление задач. Пожалуйста, свяжитесь с вашим администратором.",
            calendarCreate:
                "У вас нет разрешения на создание календаря/бронирования. Пожалуйста, свяжитесь с вашим администратором.",
            calendarRead:
                "У вас нет разрешения на просмотр календаря/бронирования. Пожалуйста, свяжитесь с вашим администратором.",
            calendarUpdate:
                "У вас нет разрешения на обновление календаря/бронирования. Пожалуйста, свяжитесь с вашим администратором.",
            calendarDelete:
                "У вас нет разрешения на удаление календаря/бронирования. Пожалуйста, свяжитесь с вашим администратором.",
            mailCreate: "У вас нет разрешения на создание писем. Пожалуйста, свяжитесь с вашим администратором.",
            mailRead: "У вас нет разрешения на просмотр писем. Пожалуйста, свяжитесь с вашим администратором.",
            mailUpdate: "У вас нет разрешения на обновление писем. Пожалуйста, свяжитесь с вашим администратором.",
            mailDelete: "У вас нет разрешения на удаление писем. Пожалуйста, свяжитесь с вашим администратором.",
        },
        message: {
            noConversationDesc: "Здесь вы можете увидеть активные чаты и чаты, назначенные вам.",
            forMe: "Для меня",
            unAssigned: "Не назначено",
            agentDetails: "Детали агента",
            contactProperties: "Контактные данные",
            goToProfile: "Перейти к профилю",
            addNote: "Добавить заметку",
            noPreferredAgent: "Пока нет предпочтительного агента",
            toPrefer: "Предпочитать",
            inChat: "В чате",
            watching: "Смотрит",
            chatsTitle: "Чаты",
            dealyTimeMaxValueError: "Время задержки может быть максимум 15",
            dealyTimeTypeError: "Значение времени задержки должно быть числом",
            passedTimeHm: "{hour} Часов {min} Минут",
            passedTimeMs: "{min} Минут {sec} секунд",
            passedTimeSc: "{sec} секунд",
            translateMessage: "Ваше сообщение было переведено искусственным интеллектом.",
            toneChanged: "Тон сообщения изменен на {tone}",
            aiResponseAdded: "Ответ ИИ добавлен в сообщение",
            messageLonger: "Сообщение сделано длиннее",
            grammarFixed: "Грамматика исправлена",
            aiTranslate: "Перевод",
            other: "Другое",
            yourLanguage: "Ваш язык",
            myLanguage: "Мой язык",
            forwardToChatbot: "Переслать Чатботу",
            friendly: "Дружелюбный",
            confident: "Уверенный",
            straightForward: "Прямолинейный",
            casual: "Повседневный",
            professional: "Профессиональный",
            longSentence: "Длинное Предложение",
            changeTone: "Изменить Тон",
            fixGrammar: "Исправить Грамматику",
            aiResponse: "Ответ ИИ",
            templateButtonNote:
                "Для запрета контакта используйте следующие тексты на кнопке запрета. Независимо от заглавных или строчных букв",
            templateButtonTags: "#Отправить сообщение# | #Отписаться# | #Запретить# | #Заблокировать#",
            dashboard: "Панель инструментов",
            calendarModule: "Модуль календаря",
            taskModule: "Модуль управления задачами",
            maxUrlButtonMessage: "You can add a maximum of 2 URL buttons.",
            searchForDepartment: "Поиск по отделу",
            assignPreferredDepartment: "Назначить предпочтительный отдел",
            smsChannel: "Канал SMS: ",
            whatsappv2Channel: "Канал Whatsapp V2: ",
            whatsappv1Channel: "Канал Whatsapp V1: ",
            wBChannel: "Канал Whatsapp Business: ",
            messengerChannel: "Канал Messenger: ",
            instagramChannel: "Канал Instagram: ",
            allPlatforms: "Все платформы",
            cbStartMessage: "Сообщение запуска чатбота",
            cbStartMessageDesc:
                "Первое сообщение, введенное пользователем, автоматически обрабатывается чатботом и направляется на соответствующий адрес.",
            messengerUserProfile: "Профиль пользователя Messenger",
            instagramUserProfile: "Профиль пользователя Instagram",
            noEventFound: "Событие не найдено",
            visitorMails: "Почта посетителя",
            visitorActions: "Действия посетителя",
            notVerified: "Не верифицировано",
            visitorEvents: "События посетителей",
            assignedTasks: "Назначенные задачи",
            mails: "Почта",
            prefferedAgents: "Предпочитаемые агенты",
            createEvent: "Создать событие",
            blockManagement: "Управление блокировкой",
            deleteUser: "Удалить пользователя",
            blocked: "Заблокированный",
            profiles: "Профили",
            similiarProfiles: "Найдены похожие профили",
            ReplyAsAPm: "Ответить как личное сообщение и закрыть",
            replyAsAComment: "Ответить как комментарий и закрыть",
            messengerAddDesc: "Нажмите на кнопку Подключить ниже и войдите в свою учетную запись Facebook.",
            instaAddPrivacyCheckDesc: "Я прочитал и согласен с {Privacy} и {Terms and Conditions}",
            instaAddDesc5: "Нажмите на кнопку Подключить ниже и войдите в свою учетную запись Facebook.",
            instaAddDesc4: "Зарегистрируйтесь в качестве разработчика Facebook",
            instaAddDesc3: "Убедитесь, что переключатель <b>'Разрешить доступ к сообщениям'</b> включен",
            instaAddDesc2: "Убедитесь, что ваш профессиональный аккаунт Instagram подключен к вашей странице Facebook",
            instaAddDesc1: "Убедитесь, что ваш аккаунт Instagram является профессиональным (бизнес) аккаунтом.",
            selectedDepartment: "Выбранный отдел",
            departmentForwardEnable: "Включено правило переадресации отдела",
            departmentForwardRule: "Правило переадресации отдела",
            departmentForwardDesc: "Выберите, в какой департамент будут направляться входящие чаты в канал.",
            channelName: "Название канала",
            forwardToLiveAgents: "👉 Переадресовать живым агентам",
            manageIgChannel: "Управление вашим Instagram каналом",
            igDetail: "Детали Instagram",
            manageVisibilityDesc: "Управление тем, кто может видеть этот канал",
            selectAnIgAccount: "Выберите аккаунт Instagram",
            connectToInsta: "Подключиться к Instagram",
            connectToMetaLeads: "Connect to Meta Leads",
            deleteInstaChannelInfo: "Вы уверены, что хотите удалить канал Instagram?",
            instagramChannels: "Каналы Instagram",
            suspendedDescription: "Ваш аккаунт заблокирован из-за неоплаченных счетов",
            onlyChatbot: "Только чатбот",
            onlyAgents: "Только агенты",
            checkboxWarning: "Это поле должно быть обязательно отмечено",
            sendingAllow: "Отправка",
            receiving: "Получение",
            platform: "Платформа",
            banModalTitle: "Модальное окно запрета посетителя",
            selectDepartmentDesc: "Выберите отделы, для которых вы хотите изменить видимость",
            selectAgentDesc: "Выберите агентов, для которых вы хотите изменить видимость",
            selectDepartment: "Выберите отдел",
            selectAgent: "Выберите агента",
            visibleDepartments: "Видимые отделы",
            visibleAgents: "Видимые агенты",
            visibilityInfoCont: "Все агенты и отделы могут видеть этот канал",
            editDepartmentVisibility: "Изменить видимость отдела",
            editAgentVisibility: "Изменить видимость агента",
            typeSTToSearch: "Введите что-нибудь для поиска пользователей",
            exportToCSV: "Экспорт в CSV",
            clear: "Очистить",
            usedSessionCount: "Количество использованных сеансов",
            maxSessionCount: "Максимальное количество сеансов",
            leftSessionCount: "Оставшееся количество сеансов",
            planManagement: "Управление планом",
            teamChat: "Чат команды",
            templateNameIsNotValid: "Имя шаблона недействительно",
            relatedAdvertisement: "связанная реклама",
            whatsappNumber: "Номер WhatsApp",
            integrationsWhatsappV1:
                "Для беспроблемного взаимодействия между Supsis и WhatsApp требуется план WhatsApp.",
            integrationsWhatsappV2: "Вы можете легко передавать информацию о чате между Supsis и WhatsApp.",
            integrationsWhatsappBusiness:
                "Вы можете быстро и удобно передавать информацию о чате между Supsis и WhatsApp.",
            selectDays: "Выберите дни",
            addTime: "Выберите время",
            instagramContactList: "Список контактов Instagram",
            archiveAllRated: "Получить все разговоры с любыми оценками.",
            allChannels: "все каналы",
            comment: "комментарий",
            news: "что нового",
            conversation: "командный разговор",
            speechTermination: "закончить разговор",
            noSystemMessage: "Сообщений в системе пока нет!",
            supsisCustomerService: "Услуги для клиентов, предоставляемые Supsis,",
            supsisClickExperience: "Вы можете попробовать опыт, нажав.",
            customerPage: "Перейти на страницу клиента",
            buttonTitle: "Название кнопки",
            buttonType: "Тип кнопки",
            buttonSendMessage: "Отправить сообщение",
            buttonGoToBlock: "перейти в блог",
            buttonOpenUrl: "Открыть URL",
            buttonPhoneCall: "Телефонный звонок",
            buttonOpenMoment: "Открытый момент",
            buttonCloseChat: "Закрыть чат",
            buttonTransferChat: "Трансферный чат",
            buttonCreateTicket: "Создать тикет",
            deleteVisitor: "Вы уверены, что хотите удалить пользователя? Это действие не может быть отменено.",
            userProfile: "Профиль",
            addCalendarEvent: "Добавить +",
            apiIntegration: "разработчик",
            generateToken: "Создать токен",
            copyToken: "Копирование токена",
            dndBlocked: "Настройки отправки файлов отключены.",
            labels: "Этикетки",
            noData: "Нет данных",
            color: "Цвет",
            titleColor: "Цвет заголовка",
            secondTitleColor: "Цвет второго заголовка",
            tag_name_indicator: "Название этикетки",
            sendMessage: "Отправить сообщение",
            removeFromG: "Удалить из группы",
            delChannel: "Вы уверены, что хотите удалить этот канал?",
            new_name: "Новое имя",
            set_group_info: "Редактировать информацию о группе",
            shortcut_desc_num: "Переключение между активными разговорами с использованием цифровых цифр",
            copilot_desc_num: "Позволяет открыть Copilot на экране чата.",
            typing_w_chat: "пишет...",
            edit_group_info: "Редактировать информацию о группе",
            notif_sound: "Включить звук уведомлений",
            notif_mute: "Отключить уведомления",
            leave: "Уйти",
            group: "Группа",
            updateTag: "Обновить метку",
            ordered_desc: "Распределяет чаты сотрудникам по порядку.",
            random_desc: "Распределяет чаты сотрудникам случайным образом.",
            Rrobin_desc: "Распределяет чаты сотрудникам круговым методом. (Приоритет у наименее занятых сотрудников)",
            RrobinRev_desc:
                "Распределяет чаты сотрудникам круговым методом в обратном порядке. (Приоритет у наиболее занятых сотрудников)",
            algo_desc: "Выберите алгоритм для автоматического распределения чатов",
            algorithm: "Алгоритм",
            os_browser: "Операционная система и браузер",
            addTag: "Добавить тег",
            tags: "Теги",
            searchRepresentative: "Поиск представителя",
            preferredRepresentative: "Представители",
            voting: "Голосование",
            CHAT: "Чат",
            chatWidget: "Supsis Виджет чата",
            webhooks: "вебхуки",
            selectHooks: "Выберите веб-хуки",
            planRequired: "{integratable} Требуется план",
            allIntegrations: "Все интеграции",
            disableAgentSystemMessages: "Скрыть системные сообщения агента",
            disableAgentSystemMessagesDesc: "Скрыть системные сообщения агента.",
            disableAutoTranslate: "Auto Translate",
            disableAutoTranslateDesc:
                "It automatically translates messages from different languages. So you can communicate with your customers more easily.",
            shouldAddMethod:
                "Вы должны заполнить поля «Способ оплаты» и «Платежный адрес»! \nДеньги не будут сняты с вашего счета.\n" +
                "В конце месяца будет выставлен счет в соответствии с суммой использования.",
            approveSelection: "Утвердить выбор",
            trialDaysEndSelectPlan: "Подтвердить выбор плана",
            trialDaysEndSelectPlanDesc:
                "Ваша пробная версия закончилась. Вам необходимо подтвердить, выбрав план ниже.",
            infoAboutAnnouncement: "Краткая информация об объявлении",
            announcement: "Объявление",
            languageSelection: "Выбор языка",
            newAnnouncementForm: "Новая форма объявления",
            newAnnouncement: "Новое объявление",
            announcements: "Объявления",
            infinitePlay: "Играть непрерывно",
            vtippyHideBubbleOnMobile: "Чат Bubble скрыт от мобильных пользователей.",
            hideBubbleOnMobile: "Скрыть на мобильном",
            deleteSystemLanguage: "Удалить язык {code} из системы",
            assignedChat: "Assigned Chat",
            check: "Check box",
            newTicketSound: "Новый билет",
            vtippyDepartmentNotification: "Настройки уведомлений для сообщений из департаментского разговора",
            vtippyGroupNotification: "Настройки уведомлений для сообщений из созданных групп",
            vtippyAnnouncemenNotification: "Настройки уведомлений для новых объявлений",
            warning: "Предупреждение",
            billingAddress: "Адрес для выставления счета",
            addNewAddress: "Добавить новый адрес",
            adressTitle: "адрес Название",
            address: "адрес",
            systemStatus: "Статус системы",
            chatAssignedToUser: "New chat assigned",
            inactiveThresholdTime: "Inactive Chat Time (minute)",
            tippyInactiveThresholdTime:
                "If no message is sent within the given time, the conversation is considered inactive. Enter the value (minutes). Must be range in 1min - 120min.",
            inactiveTerminateTime: "Inactive Chat Terminate Duration (minute)",
            tippyInactiveTerminateTime:
                "Inactive chat  will be terminated if it does not switch to active mode within a certain time. Enter the value (minutes). Must be range in 1min - 120min.",
            removePendingMessage: "Cancel message sending",
            disconnected: "Отключено",
            visitorWriteEmptyChatTippy: "Клиент может писать в беседу до подключения агента.",
            visitorWriteEmptyChat: "Клиент может писать без подключения агента.",
            visitorConnectionEventSystemMessageEnabled: "Visitor connection status system messages enable",
            visitorConnectionEventSystemMessageEnabledTippy: "Visitor left and Visitor comeback system messages enable",
            openBubble: "Открыть пузырь",
            showHeaderImage: "Показать изображение заголовка",
            askQuestion: "Задайте вопрос",
            locationPermsNeeded: "Необходимые разрешения на местоположение",
            useMyLocation: "Использовать мою локацию ",
            acceptingChat: "Прием чатов",
            notAcceptingChat: "Не принимает чаты",
            loggedOut: "Вышли из",
            websiteChatWidgetIntegration: "страница Реализация",
            hideInactiveAgents: "Скрыть неактивных агентов",
            hideMinorValues: "Hide Minor Values",
            agentActivities: "Деятельность агента",
            listStatuses: "Статусы",
            newHASHContent: "#Добавить метку",
            changeLogo: "Изменить логотип",
            changePhoto: "Изменить фотографию",
            addPhoto: "Добавить фотографию",
            seePhoto: "См. фото",
            deletePhoto: "Удалить фотографию",
            languageRemovalQuestion: "Вы собираетесь удалить язык {code} из системы!",
            hash: "Хэштег",
            hashText: "Хэш-текст",
            updateCompleted: "обновление завершено",
            CatalogUpdatedSuccessfully: "Каталог успешно обновлен",
            integrateSupsiswithIntegratable: "С легкостью передавайте информацию чата между Supsis и {integratable}.",
            installationOK: "установлены",
            exampleHash: "отслеживание заказа",
            notValidHash: "Не должно содержать пробелов.",
            videoCallEnabledDesc: "Активируйте, чтобы включить функцию видеозвонка.",
            videoCallEnabled: "Функция видеозвонка",
            audioCallDesc: "Активируйте, чтобы включить функцию голосового поиска.",
            audioCallEnabled: "Функция голосового поиска",
            assignPreferredAgent: "Назначить предпочтительного агента",
            representativeAssignedToTheVisitor:
                "Выберите предпочитаемого агента, которого хотите назначить посетителю.",
            agentFileSendEnabledDesc: "Позволяет отправлять файлы делегатам",
            agentFileSendEnabled: "Представители могут отправлять файлы",
            visitorFileSendEnabledDesc: "Позволяет включать и выключать функцию отправки файлов посетителям.",
            visitorFileSendEnabled: "Посетители могут отправлять файлы",
            visitorAutoLogin: "Автоматический вход посетителя",
            visitorAutoLoginDesc: "Автоматический запуск разговора, когда посетитель нажимает на всплывающее окно чата",
            agentVoiceRecordEnabledDesc: "Позволяет агентам записывать звук",
            agentVoiceRecordEnabled: "Агенты могут записывать аудио",
            visitorVoiceRecordEnabledDesc: "Позволяет посетителям записывать аудио",
            visitorVoiceRecordEnabled: "Посетители могут записывать аудио",
            startVideoCall: "Видеозвонок",
            startAudioCall: "Голосовой звонок",
            visitorGDPRDeleteEnabledDesc:
                "Позволяет включить/выключить возможность удаления всей информации о посетителях.",
            visitorGDPRDeleteEnabled: "Посетители могут удалить всю свою информацию",
            visitorLocationEnabled: "Посетители могут делиться местоположением",
            visitorLocationEnabledDesc:
                "Позволяет посетителям включать или выключать совместное использование местоположения",
            customerLocationEnabled: "Пользователи могут делиться местоположением",
            customerAutoMergeEnabled: "Автоматически объединяет одних и тех же людей",
            customerAutoMergeEnabledDesc:
                "Эта функция выполняет автоматическое объединение, эффективно собирая данные, относящиеся к одним и тем же людям. Это обеспечивает более последовательное и упорядоченное представление пользователей с похожими профилями в наборах данных.",
            chatAiCopilot: "Чат ИИ Копилот",
            chatAiCopilotDesc: "Автоматически отвечайте на вопросы ваших клиентов, используя Чат ИИ Копилот",
            customerLocationEnabledDesc:
                "Позволяет пользователям включать или выключать совместное использование местоположения",
            triggerAlreadyExists: "Триггер уже существует.",
            ticketStatusForm: "Форма статуса билета",
            statusFormTitle: "Название статуса заявки",
            allStatus: "Все статусы",
            triggers: "Триггеры",
            trigger: "Курок",
            noTrigger: "Вы еще не добавили ни одного триггера",
            triggerSkipLoginForm: "Форма входа",
            triggerSkipLoginFormTrue: "Показать форму входа",
            triggerSkipLoginFormFalse: "Пропустить форму входа и перейти к сообщению",
            noContent: "нет содержания",
            toCreate: "Создать",
            clickTheButton: "нажмите кнопку",
            noLiveSupportFoundWithDepartment: "Нет речи, принадлежащей отделу",
            triggerContent:
                "Введите описание, которое вы хотите отобразить в открывшемся модальном окне. Вам нужно только писать на одном языке, а перевод на другие языки выполняется автоматически.",
            triggerDrag: "Вы можете настроить продолжительность сообщения, перетащив или щелкнув полосу.",
            triggerNewCondition: "Вы можете добавить новое условие с помощью кнопки.",
            triggerNoConditionDescription1:
                "Вы можете создать нужные условия из опций. Если вы не создадите никаких условий ни для одного триггера, активным будет первый триггер.",
            triggerNoConditionDescription2:
                "На странице посетителя отображается только один из триггеров с одинаковыми условиями.",
            triggerShowAndHide: "Вы можете показать или скрыть триггеры, когда захотите.",
            countryLanguage: "Страна/Язык",
            addTrigger: "Добавить триггер",
            saveSystemCardInfo:
                "Ваша карта будет сохранена в нашей системе и оплачена автоматически, когда наступит срок оплаты.",
            cardNumber: "Номер карты",
            cardType: "Тип карты",
            skt: "сг",
            cvv: "CVV",
            saveCard: "Сохранить карту",
            cardNameSurname: "Имя и фамилия держателя карты",
            confidentialityAgreementCheck: "Я принимаю соглашение о конфиденциальности",
            confidentialityAgreement: "соглашение о конфиденциальности",
            yesPlease: "Да, пожалуйста!",
            noThanks: "Спасибо, не надо.",
            firstAnswer: "Вопрос Диалог Подтвердить Ответ",
            secondAnswer: "Вопрос Диалог Отклонить Ответ",
            noTitle: "Без названия",
            sumChat_MediaFile: "Медиа и документы",
            importantWarning: "ВАЖНОЕ ПРЕДУПРЕЖДЕНИЕ!",
            images: "Изображения",
            URLS: "Ссылки",
            files: "Файлы",
            noCondition: "Нет условий! Вы можете добавить Условия, щелкнув значок плюса.",
            showTriggers: "Нажмите, чтобы показать триггеры",
            showThisTrigger: "Нажмите, чтобы показать этот триггер",
            hideTriggers: "Нажмите, чтобы скрыть триггеры",
            hideThisTrigger: "Нажмите, чтобы скрыть этот триггер",
            updateTrigger: "Триггер обновления",
            conditions: "Условия",
            messageDurationPerRow: "Длительность сообщения в строке",
            vtippyTicketNotification: "Настройки уведомлений для каждого нового билета, который вы получаете",

            dayTime: "Час",
            weekDay: "День недели",
            spendTimePage: "Время, проведенное на странице",
            spendTimeSite: "Проведенное время на сайте",
            pageUrl: "URL-адрес страницы",
            pageTitle: "Заголовок страницы",
            vtippyNewVisitorNotification: "Звуковое оповещение о каждом новом посетителе вашего сайта",
            vtippyTranslateButton: "Переводит выбранный язык на другие языки",
            vtippyTranslateClearButton: "Очищает контент на других языках.",

            vtippySelectnotification: "Вы можете выбрать звук уведомления.",
            vtippyVoiceLevel: "вы можете регулировать громкость",
            vtippyStartVoice: "Слушать",
            vtippyInfiniteNotification:
                "Если вы не активны на новой панели чатов, она продолжит играть. Вы можете редактировать актив-пассив, нажав.",

            vtippyNewChatNotification:
                "Вы можете выбрать звуковое оповещение о новых разговорах, поступающих в систему, и отрегулировать громкость.",
            vtippyNewConversationNotification:
                "Вы можете выбрать звуковое уведомление и отрегулировать громкость, когда новые входящие разговоры назначаются вам.",
            vtippyNewMessageNotification:
                "Вы можете выбрать уведомления о входящих сообщениях в свои разговоры и настроить громкость.",
            vtippyPrivateMessageNotification:
                "Вы можете выбрать уведомление о входящем сообщении в командный разговор.",
            equal: "Равный",
            not_equal: "Не равный",
            less_than: "Меньше, чем",
            greater_than: "Лучше чем",
            less_than_or_equal: "Меньше или равно",
            greater_than_or_equal: "Больше или равно",
            visitorName: "Имя посетителя",
            seconds10: "10 секунд",
            seconds30: "30 секунд",
            minute1: "1 минута",
            minutes5: "5 минут",
            minutes10: "10 минут",
            minutes30: "30 минут",
            hour1: "1 час",
            hours2: "два часа",
            hours4: "4 часа",
            hours8: "8 часов",
            hours12: "12 часов",
            hours24: "24 часа",
            maxCondition: "Максимальное состояние",
            doYouWishToDeleteTrigger: "Вы хотите удалить триггер",
            contains: "Содержит",
            not_contains: "Не содержит",
            chatLanguage: "Язык чата",
            translating: "Идет перевод",
            buyWhatsapp: "Приобрести интеграцию с WhatsApp",
            liveSupportStartingWait: "Запуск поддержки в режиме реального времени, пожалуйста, подождите",
            noConnection: "Нет соединения!",
            integrations: "Интеграции",
            refundInvoiceSure: "Вы уверены, что хотите вернуть счет?",
            invoiceMarkedAsPaidSuccess: "Счет отмечен как успешно оплаченный",
            invoiceMarkedAsPaidError: "Ошибка, счет не помечен как оплаченный",
            deleteConfirm: "Вы хотите удалить этот {object}?",
            markPaidConfirm: "Вы уверены, что пометите этот счет как оплаченный?",
            startChatDesc: "Начать разговор",
            addLink: "Ссылка на сайт",
            selectStep: "Выберите шаг:",
            addGOTO: "Перейти к",
            sendFastLink: "Отправить Fast Link",
            or: "или",
            allTags: "Все теги",
            showDetail: "Показать детали",
            hideDetail: "Скрыть детали",
            weLlSendPhone: "Мы отправим на ваш телефон",
            weLlSendEmail: "Мы отправим на Ваш e-mail",
            linkSentToPhone: "Ссылка отправлена в смс",
            offerlinkSendToPhone: "Мы вышлем вам ссылку для скачивания нашего приложения в SMS.",
            offerlinkSendToMail: "Мы вышлем вам ссылку для скачивания нашего приложения в Почта.",
            theEmail: "Моя зарегистрированная электронная почта",
            differentEmail: "Другое электронное письмо",
            linkSentToMailBox: "Ссылка отправлена на ваш почтовый адрес",
            errorOccurred: "Произошла ошибка !",
            clickStoreIcon:
                "Вы можете получить доступ к мобильному приложению, нажав на значок, подходящий для вашего телефона.",
            meetWithSupsis: "Хотите познакомиться с нашим мобильным приложением SUPSIS?",
            downloadMobileApps: "Скачать мобильное приложение",
            getApps: "Получить приложения",
            info: "Информация",
            conversationHistory: "История разговоров",
            planInfoHeader: "Информация о плане",
            planInformation:
                "Ваш тарифный {selectedPlan} план ({detailMaxAgentCount} агент) ({freeAgent} свободный агент)",
            creditAvailable: "Ваш агентский кредит доступен в вашем плане: ",
            upDownGradePlan: "Если вы хотите повысить / понизить свой тарифный план, пожалуйста",
            click: "Нажмите",
            autoStartChat: "Автоматический запуск чата",
            bubbleColor: "Цвет пузыря чата",
            openFolder: "Открыть папку",
            preDefined: "Темы",
            customIcon: "Установить со своего компьютера",
            theme: "Тема",
            themeSettings: "Настройки темы",
            chatThemeSettings: "Настройки темы чата",
            bubbleSettings: "Настройки пузыря чата",
            inputHeightOfBubble: "Размер пузыря",
            inputPixelsOfChatBubble: "Нажмите, чтобы изменить расстояние от пузыря чата до краев",
            modalTitleIsMarginAsPixelInfo: "Расстояния от чат-пузыря до краев : ",
            inputPxOfXaxis: "Горизонтальное положение",
            inputPxOfYaxis: "Вертикальное положение",
            inputPxOfMobileXaxis: "(Mobil) Horizontal Position",
            inputPxOfMobileYaxis: "(Mobil) Vertical Position",
            animations: "Анимации",
            preferredAnimation: "Предпочтительная анимация",
            selectAnAnimation: "Выберите анимацию",
            inputOfBubbleMessage: "Добавляйте контент в большие пузыри чата.\n{contentOfChatBubble}",
            showChatBubbleOnlyLoggedUserToolTip:
                "Это настройка для скрытия всплывающей подсказки чата в зависимости от статуса входа в систему.Показывается всем посетителям в случае Off.",
            showChatBubbleOnlyLoggedUser:
                "Показывать всплывающую подсказку только авторизованному пользователю. (ideasoft)",
            helloDoUNeedHelp: "Привет, тебе нужна помощь?",
            bubbleIcon: "Изображение пузыря чата",
            overrideMargins: "Настроить поля",
            autoHideBubble: "Скрыть пузырь чата",
            vtippyAutoHideBubble: "Скрывает всплывающее окно чата, когда агенты не в сети",
            hideBubble: "Отключить чат-пузырь",
            vtippyHideBubble: "Отключает пузырь чата.",
            overrideMobileMargin: "Customize Margins for Mobile",
            vtippyMobileMargin: "Customize Margins for Mobile",
            isFabsActive: "Показать плавающую кнопку действия",
            bubbleOpenableMenu: "Выпадающее меню чата",
            vtippyIsFabsActive: "Настройка отображения/скрытия плавающей кнопки действия",
            vtippyIsFabsAsIcon: "Это настройка того, будут ли значки отображаться в раскрывающемся меню.",
            isFabsAsIcon: "Показать значки меню.",
            setMarginAsPixel: "Установить как пиксель",
            returnDefaultMargins: "Настройки поля по умолчанию",
            deleteSite: 'Вы хотите удалить сайт " {siteName} " ?',
            deleteThisSite: "Удалить сайт",
            assetOversizeWithExt: "Размер файла должен быть менее 10 МБ и в формате png, jpg.",
            all: "Все",
            allDepartments: "Все отделы",
            preferredLanguage: "предпочтительный язык",
            kmkAutoDepartmentBind: "KMK Поиск автоотдела",
            kmkAutoDepartmentBindDesc:
                "Найдите продавца на сайтах клиентов KMK и настройте страницу входа в качестве отдела",
            chatBot: "Чат-бот",
            ticketResponse: "Представительский ответ:",
            archived: "Архив",
            chatbotChatCount: "ЧАТБОТ",
            visitorEmailUpdated: "Электронная почта посетителя обновлена",
            visitorEmailIsNotValid: "Электронная почта посетителя недействительна",
            visitorNameUpdated: "Имя посетителя обновлено",
            clickToEdit: "Нажмите, чтобы изменить",
            addEmail: "+ Добавить электронную почту",
            addFullname: "+ Add Fullname",
            partner: "Ref?",
            isIntegrated: "Интеграция?",
            agentCount: "Количество агентов",
            closePreviewColors: "Закрыть предварительный просмотр темы",
            previewColors: "Открыть предварительный просмотр темы",
            videoCalls: "Видеозвонки",
            filterLost: "Потерянные чаты",
            vtipyCustomLogin:
                "Вы можете настроить информацию, которая будет запрашиваться в форме входа, когда ваши посетители подключаются к системе.",
            vtipyLoginlessChat: "Форма входа посетителя будет скрыта. Посетитель может подключиться к чату напрямую.",
            loginlessChat: "Форма входа посетителя видна",
            imageUrl: "URL изображения",
            replied: "Ответил",
            solved: "Решено",
            openImage: "Открыть изображение",
            writeFeedback: "Вы можете написать свой отзыв о SUPSIS здесь.",
            feedbackFailed: "Ошибка при отправке отзыва.",
            feedbackSuccessful: "Отзыв отправлен.",
            sendFeedback: "Отправить отзыв",
            errorReport: "Вы можете сообщить нам о своих проблемах с SUPSIS.",
            sendErrorFeedBack: "Поделитесь с нами своим мнением о проблеме, с которой вы столкнулись.",
            successImgUpload: "Ваше изображение было успешно загружено.",
            successImgDelete: "Изображение успешно удалено.",
            errorImgUpload: "Произошла ошибка при загрузке вашего изображения.",
            errorImgDelete: "При удалении изображения произошла ошибка",
            chatBotEndStatics: "Коэффициент успешности разговора с чат-ботом",
            videoCallDist: "Распределение видеозвонков",
            departmentInfo: "Информация об отделе",
            infoAboutDepartment: "Дайте краткую информацию об отделении",
            deleteDepartmentQuestion: "Вы действительно хотите удалить этот отдел?",
            departmentDeleted: "Отдел удален",
            departmentTitle: "Название отдела",
            updateDepartmentForm: "Форма обновления отдела",
            newDepartmentForm: "Форма нового отдела",
            department: "отделение",
            newDepartment: "Новый отдел",
            departmentSaved: "Отдел сохранен",
            sameDepartment: "Существует отдел с таким же названием",
            sameValue: "Существует значение с таким же именем!",
            sameTag: "Существует тег с таким именем!",
            departments: "Отделы",
            chatTimingSettings: "Настройки времени чата",
            assetOversize: "Размер отправляемого файла не должен превышать 2 МБ.",
            assetOversizeMB: "Размер файла, который вы хотите отправить, не должен превышать {mb}МБ.",
            messageDeleted: "Это сообщение удалено",
            filterVideoCall: "Фильтр видеозвонков",
            filterLostChat: "Фильтры Потерянные чаты",
            filterClosedByAgent: "Фильтр закрыт агентом",
            notificationText: " Супсису нужно разрешение на",
            notificationTitle: "Уведомления отключены",
            deniedText:
                "Ваши уведомления закрыты, вам нужно включить свои уведомления, чтобы не пропустить своих клиентов.",
            deniedTitle: "Нажмите, чтобы открыть свои уведомления!",
            deniedHeader: "Чтобы не упустить своих клиентов, вам необходимо включить свои уведомления!",
            showNotificationGuide: "Нажми для деталей",
            howToEnableNotification: "Как я могу включить уведомления",
            notificationOK: "Ok",
            notificationUnderstood: "Понял!",
            notificationCancel: "Отмена",
            howToEnableNotificationInstruction1: "Нажмите на значок замка в адресной строке браузера",
            howToEnableNotificationInstruction2: "Если «Уведомления» отключены в разделе «Разрешения», включите их.",
            howToEnableNotificationInstruction3:
                "Если «Уведомления» не отображаются в разделе «Разрешения», нажмите «Настройки сайта».",
            howToEnableNotificationInstruction4:
                "Включите разрешение «Уведомления» в разделе «Разрешения» на странице настроек сайта.",
            checkPaymentMethod: "Пожалуйста, проверьте способ оплаты",
            pushNotificationEnabled: "Отлично, Push-уведомление включено",
            pushNotificationDenied: "Вы отказали в разрешении на уведомление",
            suspendedMessage: "Ваша учетная запись была приостановлена",
            enableNotification: "Включите уведомления на рабочем столе.",
            languageSettings: "выбранный язык",
            problemsSound:
                "Если у вас возникли проблемы с уведомлениями, вы можете щелкнуть изображение блокировки в окне поиска браузера (показано на рисунке), щелкнуть «Настройки сайта» и изменить «Звук» на «Разрешить».",
            betweenRepresentative: "Есть новое сообщение от представителя",
            desktopNotifications: "Уведомления на рабочем столе",
            notificationEnabled: "Уведомления на рабочем столе SUPSIS включены.",
            newMessageAlert: "У вас есть новое сообщение.",
            notificationDisable: "Вы можете отключить уведомление в настройках представителя",
            newConversationAlert: "У вас новый посетитель.",
            autoLoadIframe: "Живой трафик",
            autoLoadIframeDesc: "Автоматически загружать iframe, пропускать весь трафик посетителей",
            enableState: "Активный?",
            requiredFieldField: "Это поле обязательно к заполнению",
            catalogCategoryMenu: "Добавить меню категории каталога",
            catalogCategoryLeaf: "Добавить подменю категории каталога",
            closeChat: "Завершить обмен сообщениями",
            ticket: "Билет",
            formStep: "Шаг формы",
            menuStep: "Шаг меню",
            contentStep: "Шаг содержания",
            menuTitle: "Заголовок меню",
            messageContent: "Содержание сообщения",
            goToLive: "Передача представителю",
            prevStep: "Вернуться к предыдущему шагу",
            button: "Кнопка",
            addImage: "Изображение",
            addText: "Текст",
            stepTitle: "Название шага",
            addTicket: "Проездной билет",
            formDescription: "Вопрос",
            addInput: "Вопрос",
            addRandomText: "Случайный текст",
            changeTitle: "Изменить заголовок",
            changeVisitorTitle: "Изменить заголовок посетителя",
            catalog: "Название каталога",
            openTheCatalog: "Открытый каталог",
            catalogNotOpen:
                "Функция каталога отключена. Вы можете включить функцию каталога, чтобы поддерживать своих клиентов заранее подготовленным контентом. ",
            showCatalogCategories: "Измените способ отображения меню каталога в пузыре чата. ",
            showChatBot: "Измените статус меню чат-бота, чтобы он отображался в пузыре чата.",
            openCatalog: " Каталог ",
            unreadMessages: " Непрочитанные сообщения ",
            personalFirstMsg: "Среднее время первого ответа агента (сек)",
            personalRating: " Средний балл персонала",
            soundSettings: " Настройки звука ",
            newPrivateMessage: " Личное сообщение ",
            addNewGroup: "Создать новую группу",
            newMessage: " Новое сообщение ",
            newConversation: "новый чат ",
            newVisitor: " Новый посетитель ",
            chatPosition: " Расположение чата ",
            bottomLeftCorner: "нижний левый угол",
            leftDocked: "оставил в пристыкованном виде",
            bottomRightCorner: "нижний правый угол",
            rightDocked: "справа закреплено",
            chatPositionSelect: " Выберите место ",
            teamChatGroup: "Групповые сообщения",
            teamChatDepartment: "Сообщения отдела",
            teamChatTeam: "Сообщения команды",
            teamChatDm: "Личные сообщения",
            bottomLeft: " Внизу слева ",
            left: "Слева",
            bottomRight: "Внизу справа ",
            right: "Справа",
            mailorname: " Электронная почта или имя ",
            breaksByTime: " Количество перерывов по времени ",
            clPlaceholder: " Имя, которое будет отображаться в форме клиента ",
            fieldName: " Имя ключа ",
            value: "Значение",
            addSetting: " Добавить новую настройку ",
            globalSettings: "Общие настройки",
            target: " Адрес нагрузочного теста ",
            duration: " Время нагрузочного теста(сек)",
            arrivalCount: " Количество ботов(шт)",
            bootMaxLife: "Время жизни бота(сек)",
            startLoadTest: " Начать нагрузочный тест ",
            noClusterInstanceFound: "Сервер не найден",
            stopLoadTest: " Завершить нагрузочный тест ",
            integrationDesc: "Просто добавьте на свой сайт приведенный ниже однострочный код.",
            integrationDemoCode: " Пример демо кода интеграции ",
            integrationWindow: " Как мне интегрировать мой сайт?",
            notIntegrated: "интеграции",
            help: " Помощь",
            notIntegratedDesc:
                " Мы поняли, что вы не добавляли чат на свой сайт. Когда вы интегрируете его на свой сайт и начнете первый разговор, вы завершите интеграцию. Нажмите, чтобы увидеть СЦЕНАРИЙ ИНТЕГРАЦИИ ",
            backToLogin: " Войдите снова",
            passwordlessLoginUnsuccessful:
                " Ошибка входа. Возможно, срок действия ссылки для входа истек или она использовалась ранее.",
            passwordlessLogin: " Вход без пароля ",
            loginWithEmail: "Войти по электронной почте",
            loginWithPassword: "Войти с паролем",
            enteringPasswordless: " Войти без пароля ...",
            toMainPath: " Перенаправить на домашнюю страницу ",
            userRoleChanged: " Ваши права доступа изменились. Вы попадете на главную страницу, чтобы продолжить.",
            passwordChangeSuccess: " Ваш пароль успешно изменен ...",
            feedback: " Обратная связь ",
            showFeedbackHistory: " Показать сообщения, на которые были отправлены отзывы.",
            newSelfServiceSite: " Новый сайт самообслуживания ",
            subdomain: "Субдоменное имя",
            rootUserEmail: "Электронная почта пользователя",
            rootUserName: "Ваше имя",
            newVersion: "Доступна новая версия",
            closeLiveSupport: "Закрыть онлайн-поддержку",
            newVersionShort: "новая версия",
            bannedWordRestrict: " Блокировка запрещенных слов ",
            ticketShow: "Разрешить клиентам создавать заявки",
            ticketShowDesc: "Включить опцию создания заявок в меню чата",
            bannedWordRestrictDesc:
                " Когда включена блокировка запрещенных слов, представителям запрещается вводить посетителям запрещенные слова, определенные в системе. ",
            agentDown: " Представитель отлючился",
            delayChat: " Отложенный чат ",
            tableSettingTippy: "Здесь вы можете изменить информацию, которая будет отображаться в таблице.",
            tableSettings: " Настройки таблицы",
            tableSettingsInfo:
                " Здесь вы можете изменить информацию, которая будет отображаться в таблице. Вы можете выбрать до 7 столбцов ",
            privateParametry: "Индивидуальные параметры пользователя",
            systemOperetor: "Системная информация",
            cityAndDistrict: " Город / Район ",
            general: " Общий ",
            availability: "Доступность",
            home: "Главная",
            successful: " Успешно ",
            forgetPasswordSent: " Письмо для сброса пароля отправлено, проверьте свою электронную почту.",
            saturday: " Суббота ",
            friday: " Пятница ",
            thursday: " Четверг ",
            wednesday: "Среда ",
            tuesday: " Вторник ",
            monday: " Понедельник ",
            sunday: " Воскресенье ",
            download: " Скачать",
            calendarPassedTimeHour: "{час} время {имя}",
            calendarPassedTime: "{час} время {мин} мин {имя}",
            calendarPassedTimeMinSec: "{мин}час{сек}сек{имя}",
            calendarPassedTimeMin: "{значение} мин {имя}",
            calendarPassedTimeSec: "{час} часы {мин} мин {сек} сек {имя}",
            workScheduleOneDay: "График работы на {sDate} день пользователя по имени {name} ",
            workSchedule: "График работы с {sDate} - {eDate} от {name} ",
            calendar: "Календарь",
            noRating: " Нет подсчета оценок ",
            rateDist: " Диаграмма распределения оценок ",
            distConversation: "Распределение выступлений по представителям",
            distributionConversa: "Распределение очков",
            distChatbotAgent: "Каналы связи",
            distAgent: "Чат-бот и агент",
            distFugitive: "Пропущенная речь и полученная речь",
            distLive: "Живой чат",
            distChatbot: "Чат-бот",
            distComplex: "Чат-бот + Живой чат",
            distHandled: "ответил в чате",
            distMissed: "речь без ответа",
            distWeb: "Веб-сайт",
            distWhatsapp: "Whatsapp",
            distTelegram: "Телеграмма",
            distInstagram: "Инстаграм",
            totalWhatsappChatCount: "чатов в Whatsapp",
            statsByTime: " Количество диалогов по времени",
            selectRep: " Выберите представителя ",
            allRepresentatives: "Все представители",
            avgRating: " Распределение оценок ({оценка}) ({count} оценка)",
            avgFirstMessageTime: " Среднее время первого ответа ",
            totalBreakTime: "Время перерыва системы",
            totalBreakNum: "Количество перерывов",
            averageConTime: "Среднее время разговора",
            multiWpReportTitle: "Количество разговоров в WhatsApp",
            multiWpReport: "Количество нескольких чатов WhatsApp",
            multiWpReportExplanation: "Вы можете увидеть количество чатов на ваших нескольких каналах WhatsApp.",
            longestConTime: " Самое долгое время разговора",
            shortestConTime: " Наименьшее время разговора",
            refresh: "Обновить",
            waitingReply: "В ожидании ответа",
            organizationName: " Название организации",
            companySlogan: "Полное название организации",
            messageSentErr: "Сообщение не может быть отправлено, попробуйте еще раз.",
            messageSent: " Сообщение отправлено.",
            openPrivateChat: "Открыть межпользовательский диалог ",
            escKey: " Скрыть активный диалог ",
            archiveChatKey: "Позволяет присоединиться к чату в нижней части страницы архива.",
            chatCopilot: "Включает Chat CoPilot",
            privateChat: " Межпредставительская дискуссионная панель ",
            multiModeAlertDesc:
                " SUPSIS открыт в другом окне. Нажмите «Использовать здесь», чтобы использовать SUPSIS в этом окне. ",
            useHereText: " Используйте здесь",
            brandVisibility: "Тег бренда SUPSIS появляется в иконке чата",
            focusInput: " Наведите курсор на область письма активного диалога",
            send: "Отправить",
            notYet: "Еще нет",
            sending: "Отправка",
            onlyRepresentative: "Ваше сообщение увидят только агенты.",
            yourMessage: "Ваше сообщение",
            liveFabListDescription: "Живая поддержка",
            messengerIntegrationDesc:
                "Общайтесь со своими клиентами через страницу Facebook, отправляйте автоматические сообщения с помощью чат-бота.",
            checkDepartmentToAgent: "Проверить отдел на наличие онлайн-агента",
            ifAllOfflineStory: "Сюжет для направления, если все в оффлайне",
            AssignMessagesToAgents: "Назначить все сообщения агентам",
            firstChatbotAndAssign: "Сначала чатбот отвечает, а затем назначает агенту",
            hybridAssign:
                "Система проверяет отдел, чтобы увидеть, есть ли онлайн-агент, и если онлайн-агента нет, она назначает его чатботу.",
            ticketFabListDescription: "Проездной билет",
            whatsappFabListDescription: "WhatsApp",
            phoneFabListDescription: "Телефон",
            emailFabListDescription: "Эл. адрес",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Twitter",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "YouTube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "Введите в это поле ссылку на свой канал {channelLink}.",
            typeYourAccountLink: "Введите в это поле ссылку на свой аккаунт в {accountLink}.",
            typeYourMessage: "Пишите ваше сообщение здесь",
            typeYourMessageMail:
                "Сообщение, введенное в это поле, будет отправлено Клиентом на указанный выше почтовый адрес в качестве первого сообщения.",
            typeYourMessageDesc:
                "Сообщение, введенное в это поле, будет отправлено Клиентом на указанный выше номер телефона в качестве первого сообщения.",
            sendNumber: "Номер телефона для отправки сообщения: {path}",
            callNumber: "Номер телефона, по которому должен звонить ваш клиент: {phoneNumber}",
            numberIsNotCorrect: "Введен пропущенный номер!!",
            emailIsNotCorrect: "Электронная почта неверна!",
            selectFab: "Выберите Фаб",
            notValid:
                "Вы можете вводить только буквы (один символ). Буквы e, d, f, z, a, x, c, v, w, t, n недействительны ",
            forMacUsers: " Пользователи Mac могут использовать клавишу Control (⌃) ",
            basePriceValue: "Базисная цена",
            basePriceDiscount: "Скидка",
            basePriceCurrency: "Валюта",
            customerDBEnabled: " Выбор базы данных: используйте собственный сервер базы данных клиента",
            customerDBDisabled: " Выбор базы данных: используйте базу данных Supsis сервер ",
            mongoConnectionString: " Подключение Мongo ",
            whatsappBasePriceValue: "Базовая цена WhatsApp",
            whatsappPlusBasePriceValue: "Базовая цена WhatsApp Plus",
            instagramBasePriceValue: "Instagram Base Price",
            instagramPlusBasePriceValue: "Instagram  Plus Base Price",
            clientAddress: " Адрес клиента",
            customerClientAddress: "Клиентский адрес посетителя ",
            apiAddress: " Адрес API",
            socketAddress: "Soket адрес ",
            backendAddress: "BackEnd Адрес",
            panelLogoUrl: " Адрес логотипа панели",
            panelCustomCssUrl: " Адрес пользовательской панели Css ",
            customerLogoUrl: " Адрес логотипа клиента ",
            customerCssUrl: " Адрес CSS клиента ",
            siteAlias: " Название сайта",
            language: "Язык",
            features: "Функции",
            interactionPopularity: "Популярность взаимодействий",
            interactionCount: "Количество взаимодействий",
            uniqueUserCount: "Количество уникальных пользователей",
            allUserPercentage: "(%) Процент всех пользователей",
            represantativeSettings: "Настройки представителя",
            documentTitle: "Форма вспомогательного документа",
            supsisDocument: "Дополнительный документ",
            ApiDoc: "Документация по API",
            chatBalloonTehemeSettings: "Настройки иконки чата и темы",
            customLoginFormSettingsTitle: "Специальная форма входа",
            addNewField: "Добавить новый вопрос",
            editField: " Редактировать вопрос",
            typeHere: " Введите здесь",
            pco: "СРП",
            perPage: "/страница",
            perPageInFilter: "Кусок",
            noUserInfoFound: "Информация о пользователе не найдена",
            startFilter: "Начать поиск",
            showMyChats: " Показать мои чаты",
            showOnlineAgents: " Показать только онлайн",
            showWaitingChats: " Показать ожидающих представителя",
            addNewStatus: "добавить статус",
            newTitleContent: " Добавить заголовок ",
            roleName: "Название должности",
            error: " Ошибка ",
            contentType: " Тип содержимого",
            contentTitle: " Заголовок содержимого ",
            newSiteForm: " Форма регистрации нового сайта ",
            updateSiteForm: " Форма обновления сайта",
            newBannedWordForm: " Новая форма регистрации запрещенных слов",
            updateBannedWordForm: "Форма обновления запрещенного слова",
            newWelcomeMessageForm: "Новая регистрационная форма приветственного сообщения",
            updateWelcomeMessageForm: "Форма обновления системных сообщений",
            newDefaultContentForm: "Новая форма регистрации содержимого по умолчанию",
            updateDefaultContentForm: "Форма обновления контента по умолчанию",
            newSubjectForm: " Форма регистрации новой темы ",
            updateSubjectForm: " Форма обновления темы ",
            showIntro: " Показать презентацию ",
            showChatColorMeaning: " Цвета чата ",
            options: " Опции ",
            resetPassword: " Сброс пароля ",
            audioLevel: " Громкость звукового предупреждения ",
            privateChatNotificationSound: " Звук уведомления",
            continue: " Продолжить",
            newRoleForm: " Форма регистрации новой должности",
            updateRoleForm: " Форма обновления должности ",
            newUserForm: " Форма регистрации нового пользователя",
            updateUserForm: " Обновить форму пользователя ",
            changeOSRForm: " Изменить офлайн-сообщение ",
            tooltipOSRForm: " Вы можете изменить офлайн-сообщение.",
            newOSRForm: " Форма офлайн-поддержки ",
            newOSRMessages: " Добавить автономное сообщение ",
            updateOSRForm: " Форма офлайн-обновления",
            osrTitle: " Заголовок ",
            osrTitleDescription: " Вы можете добавить заголовок в форму офлайн- поддержки ",
            osrContent: " Содержание",
            osrContentDescription: " Вы можете добавить содержание в форму офлайн-поддержки ",
            hello: "Привет",
            cantProceedPayment: "Потому что нам не заплатили",
            and: "а также",
            suspendedPlan: " ваш план был приостановлен",
            payNow: "ЗАПЛАТИТЬ СЕЙЧАС!",
            KeepUsingFeatures: "Продолжайте использовать функции",
            date: " История ",
            startDate: " Дата начала ",
            finish: "Закончить",
            start: "Начать",
            search: " Поиск",
            endDate: " Дата окончания",
            representative: " Представители",
            representative_: " Представитель",
            star: "Оценка",
            filter: "Фильтр",
            reset: "Сброс настроек",
            dailyChatList: " Список ежедневных диалогов",
            dailyChatDuration: " Ежедневное время диалогов",
            chatDuration: " Время диалогов",
            dailyChatGraph: " Таблица ежедневных диалогов",
            ok: "Ок",
            cancel: "Отмена",
            chatCount: "Количество диалогов",
            shortest: " Самый быстрый",
            longest: "Самый долгий",
            average: " В среднем",
            count: "Количество",
            averagePoint: "Средняя оценка",
            pointDist: "Распределение оценок",
            point: "Оценка",
            filters: " Фильтры",
            totalCustomer: " Всего клиентов",
            avResponseTime: "Среднее время первого ответа",
            breakDuration: " Перерыв",
            breakCount: " Количество перерывов ",
            lastLoginPlatform: "Platform",
            active: "Активный",
            passive: "Пассивный",
            userForm: " Форма пользователя ",
            sender: "отправитель",
            profile: "Профиль",
            name: "Имя",
            number: "Число",
            username: "Имя пользователя",
            updateUserName: "Обновить имя пользователя",
            email: "Эл. адрес",
            password: "Пароль",
            oldPassword: "Старый пароль",
            newPassword: "Новый пароль",
            passwordAtLeast: "Пароль (не менее {num} символов)",
            passwordRepeat: " Пароль снова ",
            changePassword: " Изменить пароль ",
            status: "Статус",
            douYouWishToDeleteUser: " Вы действительно хотите удалить этого пользователя?",
            userDeleted: " Пользователь удален ",
            userSaved: " Пользователь зарегистрирован.",
            oldPasswordError: " Старый пароль неверен.",
            chooseAnOption: "Пожалуйста, выберите звук уведомления.",
            userVolumeUpdated: " Настройки звука обновлены.",
            save: "Сохранить",
            update: "Обновить",
            addNewMenu: " Добавить новое меню ",
            addNewContent: " Добавить новый контент ",
            pleaseTitleEnter: "Пожалуйста, введите заголовок",
            like: "Рейтинг",
            disLike: "Не нравится ",
            users: "Представители",
            visitor: "Посетители",
            allContacts: "Все контакты",
            allUsers: "Все представители",
            allSites: " Все сайты ",
            newUser: "Новый представитель",
            noNewUser: " Представителя пока нет.",
            noNewAdminUser: " Еще нет представителя с правами администратора.",
            noRoleFound: "Должности ещё нет.",
            noBannedWordFound: " Запрещенных слов пока нет.",
            noWelcomeMessageFound: "Системного сообщения пока нет.",
            noSubjectFound: " Пока нет тем.",
            noVisitorFound: " Посетителей не найдено.",
            noContactFound: "Нет контакта",
            sendResponse: " Напишите ответ.",
            delete: " Удалить",
            duplicate: "Дублировать",
            makeDefault: "Использовать по умолчанию",
            checkMore: "Проверить больше",
            useReadyTemplates: "Используйте готовые шаблоны",
            noRePresentativeFound: " Представитель не найден.",
            noLiveSupportFound: " Пока нет записи о живой поддержке.",
            noBannedVisitorFound: "Забаненных посетителей пока нет.",
            removeBanDescription: " Снять запрет ",
            editThisItem: " Обновить эту запись",
            removeThisItem: " Удалить эту запись ",
            role: "Должность",
            newRolePlaceHolder: " Щелкните, чтобы добавить новую должность...",
            autoChatAssignLimit: " Предел автоматического присвоения речи ",
            chatAssignInfo:
                "-1 = Системное значение по умолчанию, 0 = Нет назначения,> 0 = Назначить столько, сколько заданное значение.",
            relatedDepartments: "Связанные отделы",
            subjectInfo: " Если тема не выбрана, будут разрешены все темы..",
            archive: "Архив",
            offlineSupportRequests: " Офлайн-поддержка ",
            offlineModeMessage: " Автономное сообщение ",
            offlineMode: " Автономный режим ",
            first: " Первый ",
            last: "Последний",
            query: " Начать поиск ",
            clean: "Очистить",
            loading: " Загрузка ",
            loadMore: " Загрузи больше",
            noMessage: " Нет сообщений...",
            selectChat: " Выбрать чат",
            noMessageInChat: " В этом чате сообщений не найдено ",
            noMediaToShow: "Нет средств массовой информации для показа",
            firstSeen: "Впервые увидено",
            userInfo: " Информация о пользователе ",
            chatId: " ID чата",
            visitorId: "ID посетителя",
            visitingPage: " Посещение страницы",
            osAndBrowser: " Операционная система и браузер ",
            customerClientVersion: " Клиентская версия",
            visitorFeedback: " Обратная связь с клиентами ",
            notes: "Заметки",
            nameSurname: " Имя Фамилия ",
            chats: "Чаты",
            bannedVisitors: " Запрещенные посетители ",
            country: " Страна ",
            city: " Город ",
            cityDistrict: " Район ",
            browser: "Браузер",
            os: " Операционные системы ",
            ipAddress: "IP Адрес",
            connectionDate: " Время подключения ",
            transaction: " обработка ",
            banRemoved: " Блокировка снята.",
            bannedWords: " Запрещенные слова ",
            newBannedWord: " Новое запрещённое слово ",
            noBannedWord: "Нет запрещённых слов.",
            bannedWordForm: " Запрещенная форма слова ",
            word: " Слово",
            bannedWordAndWordGroup: " Запрещенное слово / фраза ",
            doYouWishToDeleteBannedWord: " Вы действительно хотите удалить это запрещенное слово?",
            doYouWishToOfflineSupportRequest: " Вы хотите удалить это сообщение?",
            bannedWordSaved: " Запрещенное слово было записано ",
            deletedSuccessfully: " Успешно удалено ",
            deleteErrorMsg: " Не удалось удалить, попробуйте еще раз. ",
            socketError: " Sockete Проблема с подключением. Обновите страницу и попробуйте еще раз. ",
            socketConnecting: " Связь с сервером ",
            offlineModeDescription:
                " Система не работает, клиенты не смогут получить доступ к поддержке в реальном времени.",
            offlineModeSettingsDescription: " Проверьте функцию 'Автономный режим' в меню настроек..",
            offlineModeUser: " В системе должен быть хотя бы один онлайн-представитель.",
            adminCannotConnectSocket: "Администраторы не могут подключиться к soket.",
            liveSupport: " Живая поддержка ",
            siteVisitors: " Посетители сайта ",
            visitors: " Посетители ",
            thoseConnectedToLiveSupport: " Подключено к Live Support ",
            visitorHistory: " История посетителей ",
            visitorHistoryDescription: "Вы можете просматривать и загружать историю чатов посетителей.",
            privateMessage: " Личное сообщение ",
            addRepresentative: " Добавить представителя ",
            forwardRepresentative: " Обратитесь к представителю ",
            keyboardShortcuts: " Горячие клавиши ",
            chatColorMeanings: "Значение цвета чата",
            connLostCheckInternet: " Ваше соединение потеряно. Убедитесь, что у вас есть подключение к Интернету.",
            wishToEndThisChat: " Вы хотите закончить этот разговор?",
            defaultContents: "Контент по умолчанию",
            contents: "Содержание",
            newDefaultContent: "Новый контент по умолчанию",
            newCTRLContent: "CTRL Добавить содержание ",
            newALTContent: "ALT Добавить содержание ",
            newTABContent: "TAB Добавить содержание ",
            title: " Заголовок ",
            shortcutChar: " Ярлык",
            pickOne: " Выберите один ",
            writeSomething: " Введите символ (a-z | 0-9)",
            letterSequence: "Последовательность букв",
            exampleText: " Пример: фут - > футбол ",
            anyChar: "anyChar",
            shorcutKey: " Быстрая клавиша ",
            content: " Содержание ",
            shortcutName: " Название ярлыка ",
            type: "тип",
            shortcut: "Ярлык",
            deleteContentQuestion: "Вы действительно хотите удалить это содержимое по умолчанию?",
            defaultContentDeleted: "Контент по умолчанию удален",
            defaultContentSaved: "Контент по умолчанию сохранен.",
            defaultContentForm: "Форма содержимого по умолчанию",
            contentMoved: " Системное сообщение перемещено.",
            cannotMoveFullParent: "Вы не можете переместить этот элемент",
            yourEmail: " Адрес электронной почты ",
            yourName: "Ваше имя и фамилия",
            lostPassword: " я забыл мой пароль ",
            login: "Авторизоваться",
            forgotPassword: "Забыл мой пароль",
            multipleSession: "Вы вошли в систему где-то еще.",
            notAuthorizedToDisplayPage: " У вас нет разрешения на просмотр этой страницы!",
            permissions: "Разрешения",
            newPermission: " Новое Разрешение ",
            permissionForm: "Форма разрешения",
            displayTitle: " Отображать заголовок ",
            key: "ключ",
            keyToUseInSystem: "Sistemde kullanılacak anahtar değer",
            deletePermissionQuestion: " Вы действительно хотите удалить это разрешение?",
            permissionDeleted: " Разрешение удалено.",
            permissionSaved: "İzin kaydedildi.",
            newRole: "Новая должность",
            selectARole: " Выберите должность ",
            yes: "Да",
            no: "Нет",
            fullAuth: " Полные полномочия ",
            roleDeleted: " Должность удалена.",
            sameRole: "Существует роль с таким же именем.",
            roleSaved: " Должность сохранена.",
            roleForm: " Должностная форма ",
            roles: "Должности",
            settings: " Настройки ",
            selectTopic: " Выбор темы ",
            autoCallTransfer: " Автоматический перевод вызова ",
            customerTyping: " Типы пользователей ",
            typing: "печатание",
            agentTyping: " Представитель пишет ",
            disconnectTime: "Конец разговора (сек)",
            tippyDissconnectTime:
                " Устанавливает количество секунд, по истечении которых стационарный разговор будет отключен. ",
            queueNumberVisibleFeature: " Показать количество посетителей в очереди ",
            privateChatEnabled: " Показать чат между представителями ",
            delayedTalkTime: " Время задержки (сек)",
            employeeAverageChatCount: " Среднее количество разговоров в чате персонала ",
            customerDownTimeWhenRepExit: " Время ожидания клиента при выходе представителя (сек.)",
            autoAssignLimit: "Предел автоматического назначения",
            wasted: "потрачено (сек)",
            settingsSaved: " Настройки сохранены.",
            settingsCannotSaved: "Настройки не могут быть сохранены",
            noAuthorization: "нет авторизации",
            warningBadInput: "Рекомендуется вводить число от 0 до 70.",
            warningBadInputMarginY: "Предупреждение о вводе вертикального поля ⚠️",
            warningBadInputMarginX: "Предупреждение о вводе горизонтального поля ⚠️",
            warningBadInputBubbleSize: "Предупреждение о вводе всплывающих окон чата ⚠️",
            settingFormWrong: " Введенные вами данные неверны, проверьте и попробуйте еще раз.",
            delayTime: " Время задержки (сек.)",
            sites: " Сайты ",
            newSite: " Новый сайт ",
            noSiteYet: " Сайта пока нет.",
            siteAddress: " Адрес сайта ",
            turnBack: "Вернуться Назад",
            customerRepLimit: "Лимит представителя клиента",
            siteSaved: " Сайт зарегистрирован.",
            siteSaveError: " Произошла ошибка при создании сайта.",
            subjects: " Темы ",
            newSubject: " Новая тема ",
            noSubject: " Темы пока нет.",
            subject: " Тема ",
            subjectTitle: " Заголовок темы ",
            description: " Описание ",
            infoAboutSubject: " Краткая информация по теме ",
            deleteSubjectQuestion: " Вы действительно хотите удалить эту тему?",
            subjectDeleted: " Тема удалена ",
            subjectSaved: " Тема сохранена.",
            osrFromMessageSaved: " Автономное сообщение записано.",
            welcomeMessages: "Системные сообщения",
            newWelcomeMessages: "Новое приветственное сообщение",
            noWelcomeMessage: "Нет системного сообщения.",
            welcomeMessageContent: "Содержание системного сообщения",
            makeChoice: " Сделайте выбор...",
            welcomeMessage: "Приветственное сообщение",
            repLoggedIn: " Представитель вошел в систему ",
            loginMessage: " Сообщение о выходе ",
            message: " Сообщение ",
            deleteWelcomeMessageQuestion: "Вы действительно хотите удалить это системное сообщение?",
            welcomeMessageDeleted: "Системное сообщение удалено",
            welcomeMessageSaved: "Системное сообщение сохранено.",
            welcomeMessageForm: "Форма системного сообщения ",
            noRep: " Пока нет представителя.",
            addChat: " Добавить в разговор ",
            forwardChat: "переадресовать чат кому-нибудь",
            ago: "тому назад",
            repName: " Имя представителя ",
            lastOnline: " Последнее подключение / время в сети ",
            lastStatusChange: " Последнее изменение статуса ",
            activeChat: " Активная беседа ",
            userMaxCapacity: " Максимальная емкость чата ",
            noActiveChat: " Нет активного разговора.",
            watch: " СМОТРЕТЬ ",
            join: " ПРИСОЕДИНИТЬСЯ ",
            open: " ОТКРЫТО ДЛЯ ДИАЛОГА ",
            directMessage: " ЛИЧНОЕ СООБЩЕНИЕ ",
            block: " ЗАБЛОКИРОВАТЬ ",
            transactions: " Операции ",
            informations: " Информация ",
            visitStart: " Начало визита ",
            fullName: " Имя и фамилия ",
            waitChatTime: " Время ожидания / время разговора ",
            blockUserConfirm: " Вы действительно хотите заблокировать этого пользователя ?",
            messaging: " Обмен сообщениями ",
            hideChat: " Скрыть диалог",
            block_: " Заблокировать ",
            privateMessage_: " Секретное сообщение ",
            assignRep: " Назначить представителя ",
            joinChat: "Присоединиться к чату",
            forwardRep: " Перенаправить ",
            leaveChat: "Выйти из разговора",
            endChat: " Завершить разговор ",
            translatedTextDescription: "Амазонка перевел это сообщение {from} -> {to}.",
            autoTranslate: "Автоматический перевод",
            translateThisMessage: "Перевести это сообщение",
            autoTranslateDetectedDesc:
                "Язык посетителя: {visitorLanguage}. Нажмите здесь, чтобы активировать автоматический перевод",
            on: "вкл",
            off: "выкл",
            copy: " Копировать ",
            prevChats: " Предыдущие диалоги ",
            noShortCut: " Нет ярлыка ",
            leaveChartConfirm: " Вы уверены, что хотите выйти из разговора?",
            endChatConfirm: " Вы хотите закончить этот разговор?",
            chatBar: " Панель разговора ",
            endConversation: " Завершить разговор ",
            onlyOneRep: " Вы единственный представитель в этом разговоре!",
            chatList: " Список диалогов",
            unreadTitle: " Непрочитанные",
            visitorLeftTitle: " Выход посетителя ",
            activeChatTitle: " Активный диалог",
            autoAssignedTitle: " Назначено автоматически ",
            watchModeTitle: " Режим просмотра",
            lostChat: " Соединение представителя прервано ",
            repLostConn: " Фон диалога становится розовым, если представитель отключен от диалога.",
            chatWidthDelay: "Отложенный чат",
            repChatWidthDelay:
                " Когда в системе нет активного представителя или когда нет посетителей из-за плотности, фон речи становится зеленым. ",
            unreadMsg: " Если есть непрочитанное сообщение, фон будет голубым.",
            visitorLeftChat: " Если посетитель покидает беседу, фон становится темно-серым..",
            activeChatMsg: " Если разговор активен, фон будет зеленым ",
            autoAssignMsg:
                " Если назначено автоматическим назначением и разговор еще не просматривался, фон будет горчичным",
            watchModeMsg: " Фон становится красным, когда чат открыт в режиме просмотра ",
            online: " В сети ",
            beRightBack: "Скоро вернусь",
            away: " Скоро вернусь",
            busy: " Занят",
            offline: " Не в сети ",
            logout: " Выйти",
            forWindows: " Для Windows ",
            forMac: "Для Mac",
            nextChatFromActive: " Переключиться с активного разговора на следующий разговор ",
            previousChatFromActive: " Перейти от активного разговора к предыдущему разговору ",
            hideActiveChat: " Скрыть активную беседу ",
            closeActiveChat: " Остановить активный разговор ",
            firsthiddenChat: " Подключиться к чату самого ожидающего клиента ",
            firstChatWaiting: " Переключиться на ожидающий разговор ",
            previousOpenedChat: " Перейти к первому открытому разговору вне зависимости от порядка ",
            historyDetails: " Подробности истории",
            chat: "Чат",
            chatNotFound: "Речь не найдена.",
            dataNotFound: "Данные не найдены.",
            visitorInfo: " Информация для посетителей ",
            timeSpent: "Время вышло",
            noActiveVisitors: " Нет активных посетителей ",
            select: " Всплывающее меню ",
            fullname: " ФИО",
            text: " Текст ",
            numeric: "Числовой",
            phone: " Телефон",
            optionsPlaceholder: "Значение параметра",
            selectField: " Щелкните, если хотите добавить раскрывающееся меню ",
            fullnameField: "Нажмите, если хотите добавить поле Полное имя.",
            textField: " Щелкните, если хотите добавить текстовое поле.",
            labelField: "Щелкните, если хотите добавить поле описания.",
            numericField: " Щелкните, если хотите добавить числовое поле.",
            phoneField: " Нажмите, если хотите добавить поле телефона.",
            departmentField: "Щелкните, если вы хотите добавить поле отдела.",
            emailField: " Нажмите, если хотите добавить домен электронной почты.",
            visible: " Видимый ",
            required: " Обязательство ",
            label: "Описание",
            totalConnected: "Количество диалогов",
            missedChat: " Количество пропущенных диалогов",
            workTime: " Рабочее время ",
            closedChatCount: " Закрытые диалоги",
            activeConvo: "Активные диалоги",
            notAnswered: "Ещё не ответили",
            delayedConvo: " Отложенные диалоги",
            leavingRep: " Выделенный представитель",
            staffRate: " Уровень занятости сотрудников ",
            customLoginAlert: "Ваша форма входа должна содержать хотя бы одно поле.",
            atLeastOneLanguage: " Должно быть хотя бы одно языковое описание.",
            requiredField: " Это поле обязательно к заполнению.",
            notRequiredField: " Это поле не обязательно.",
            visibleField: "Это поле видно.",
            notVisibleField: "Это поле не отображается.",
            connectServer: " Вы подключены к серверу ",
            disconnectServer: " Ваше соединение с сервером было потеряно ",
            liveChatOff: " Живая поддержка отключена ",
            visitorScreen: " Отображение посетителей ",
            viewOnTheSite: "Посмотреть на странице",
            viewOnTheSiteTippy: "Click Here To See How Your Changes Hold Up.",
            showHint: " Показать подсказку ",
            dontShowHint: " Показать подсказку",
            liveChatOn: " Онлайн-поддержка открыта ",
            nightModeOff: " Ночной режим выключен ",
            nightModeOn: " Ночной режим включен ",
            edit: " Редактировать ",
            deleteField: " Удалить ",
            arrow_upward: " Переместить вверх ",
            arrow_downward: " Переместить вниз ",
            doubleClickEdit: " Дважды щелкните или нажмите «Редактировать», чтобы отредактировать.",
            newCatalogCategory: "Новая категория каталога",
            childCreate: " Нажмите, чтобы создать дополнительный контент ",
            updateCatalogCategoryFrom: "Форма обновления категории каталога",
            newCatalogCategoryFrom: "Форма новой категории каталога",
            catalogMenu: " Меню ",
            catalogContent: " Содержание ",
            catalogCategoryName: " Название категории каталога ",
            newCatalogContentFrom: "Форма содержания нового каталога",
            catalogContentName: " Название содержимого каталога ",
            catalogCategorySaved: " Категория каталога сохранена ",
            catalogCategoryDeleted: " Категория каталога удалена.",
            catalogCategoryRate: " Оценка содержания ",
            catalogContentFeature: "Каталог Особенности",
            vtipyAudioLevel: " Используется для отключения или включения звуков уведомлений.",
            vtipyOrganizationName: " Вы можете изменить название организации и обновить его.",
            vtipyBrandVisibility: " Supsis - это настройка отображения тега в пузыре чата.",
            vtipyBrandVisibilityForced: "Только пользователи ProPlan могут изменять!!",
            vtipyClientDefault: " Здесь вы можете изменить язык страницы представителя.",
            vtipyCustomerClientDefault: " Здесь вы можете изменить язык страницы клиента (чата).",
            vtipyVisitorPreferredLang: "Клиент может выбрать разговорный язык на странице (Чат).",
            vtipyCustomerClientLanguageDetect: " Вы можете автоматически определять язык страницы клиента (чат).",
            vtipySelectTopic: "Происходят автоматические назначения существующим представителям в выбранном отделе.",
            vtipyAutoCallTransfer: " Автоматически назначает ожидающие вызовы доступным операторам.",
            vtipyCustomerTyping: " Позволяет вам видеть, что написал клиент на экране чата на экране чата агента.",
            vtipyAgentTyping: " Показывает статус записи представителя в пузыре клиента.",
            vtipyQueueNumberVisibleFeature:
                " Когда представители заняты, это показывает клиентам, которые хотят подключиться, в каком порядке они находятся.",
            vtipyPrivateChatEnabled: " Показывает панель разговора между агентами.",
            vtipyDelayedTalkTime: ' Ярлык "Отложенная речь ", если в это время к разговору не подключены агенты.',
            vtipyOfflineMode: " Позволяет перевести систему в автономный режим.",
            vtipyAutoAssignLimit: " Определяет, сколько клиентов (чатов) будет автоматически назначено представителю..",
            vtipyCustomerDownTimeWhenRepExit: " Время ожидания клиента (сек.)",
            tippyDisconnectTime: " Время закрытия чата после отключения клиента (сек.).",
            changeSettings: " Изменить глобальную настройку ",
            totalBg: "ВСЕГО ЧАТОВ",
            activeBg: "АКТИВНЫЕ ЧАТЫ",
            watchBg: "ОТСЛЕЖИВАНИЕ",
            waitingBg: "ОЖИДАЮЩИЕ РАЗГОВОРЫ",
            lateBg: " проходящие чаты",
            freeBg: "праздный",
            maxCapacityBg: "МАКС МОЩНОСТЬ",
            addNewSettings: " Добавить новую глобальную настройку",
            darkMode: "Ночной режим",
            clientDefault: "Язык панели по умолчанию",
            customerClientDefault: "Язык по умолчанию для клиентской части",
            customerClientLanguageDetect: "Автоматическое определение языка клиентской части",
            visitorPreferredLang: "Позвольте клиенту выбрать разговорный язык",
            preferredThemeColor: " Настройка темы разговорного экрана ",
            detail: "Рассмотрение",
            supportUs: "Свяжитесь с нами (Живая поддержка)",
            langSetting: "Настройка языка",
            changeLang: "изменение языка",
            fontSizeSetting: "Настройка увеличения экрана",
            changeLangDesc: "Устанавливает язык приложения на {code}.",
            trLang: "Турецкий",
            enLang: "Английский",
            fieldRequired: "{field} Поле, обязательное для заполнения.",
            selectALanguage: "Выберите язык",
            selectATheme: "Выберите тему",
            responseForm: "Форма ответа",
            clientRequestInfo: "Информация о запросе клиента ",
            createdDate: "Дата создания",
            descMessage: "Сообщение",
            new: "Новое",
            selectAllPermission: "Выбрать все",
            catalogCategories: "Каталог",
            copiedClipboard: "Скопировано в буфер обмена",
            organizationLogo: "Логотип организации",
            changePlan: "Изменить план",
            close: "Закрывать",
            vtipyUploadLogo:
                "Загрузив логотип своей компании из этой области, вы можете использовать свой собственный логотип в электронных письмах клиентов и на страницах клиентов.",
            tagName: "Название тэга",
            tagDescription: "Метка Описание",
            tagColor: "Цвет этикетки",
            userInformations: "информация о пользователе",
            incomingChat: "Входящий чат",
            support: "Поддерживать",
            team: "Набор",
            groups: "Группы",
            newConversationStarted: "Новый разговор начался",
            allHistoryLoaded: "Вся история загружена",
            chatCreator: "Создатель чата",
            enterGroupTitle: "Введите название группы",
            requiredTitle: "Нельзя оставлять поле заголовка пустым",
            requiredChannel: "Имя канала не может быть пустым",
            next: "Подтверждать",
            selectPeople: "Выберите людей",
            textLimitAlertMessage:
                "Ограничение на количество символов в WhatsApp составляет 19 символов, за пределами этого ограничения оно отображаться не будет. Однако в Интернете тексты, длина которых превышает лимит в 19 символов, автоматически перемещаются на следующую строку и отображаются.",
        },
        telegram: {
            typeInTelegramToken: "Введите токен Telegram",
            token: "Token",
            telegram: "Telegram",
            telegramTokenTitle: "Интеграция с Telegram",
            telegramAlertForm: "Вы можете получить токен бота Telegram от",
            telegramAlertTitle: "Вы действительно хотите удалить токен?",
            telegramAlertText: "Токен исчезнет навсегда!",
        },
        wp: {
            whatsapp: "Whatsapp",
            chatStarted: "Чат начался",
            chatNotStarted: "Чат не запущен",
            contactSelected: "контакт выбран",
            startChatWithAnyNo: "Начать чат с любым номером",
            toLittleChar: "Отсутствует номер !",
            typeInANumberDesc: "Введите номер, чтобы начать чат с:",
            wpPlusAndLicenceRequired: "Требуется план Whatsapp Plus и лицензия.",
            wpPlusAndLicenceRequiredDesc:
                "Прежде чем вы сможете начать чаты с номерами, которые не зарегистрированы в ваших контактах, вы должны обновить свой план WhatsApp и получить лицензию.",
            chatStartingWait: "Разговор начинается, пожалуйста, подождите",
            agreement: "Соглашение",
            purchase: "Покупка",
            activating: "Активация сервиса WhatsApp",
            authenticating: "Аутентификация по QR-коду",
            ready: "Готовый",
            activationTitle: "Чтобы активировать интеграцию с WhatsApp на Supsis:",
            wpIntegrationInstruction1: "Откройте WhatsApp на своём телефоне",
            wpIntegrationInstruction2: "Нажмите «Меню» или «Настройки». Щелкните Связанные устройства.",
            wpIntegrationInstruction3: "Наведите свой телефон на этот экран, чтобы считать код",
            qrGeneratingWait: "Генерируется QR-код, пожалуйста, подождите...",
            pleaseContinueToWaitUntilCompleted:
                "После проверки QR-кода он автоматически переключится на заполненное поле. Пожалуйста подождите...",
            authenticatingWait: "Аутентификация, пожалуйста, подождите...",
            enableFeature: "Включить функцию WhatsApp",
            readAndAgree: "Я подтверждаю прочитал",
            subscribe: "Подписаться",
            subscribed: "Подписан",
            toEnableWpDescription: "Чтобы включить функции WhatsApp, нажмите кнопку ниже.",
            waitForWpActivationDescription:
                "Служба вашей учетной записи WhatsApp активируется. Пожалуйста, подожди минутку. Это занимает около 10-30 секунд.",
            greatWpActivatedDescription: "Отлично, услуга «Ваша учетная запись WhatsApp» активирована!",
            unsubscribe: "Отписаться",
            planDetails: "Детали интеграции",
            sendReceiveMessage: "Отправка и получение текстовых сообщений",
            sendReceiveImage: "Отправка и получение файлов изображений",
            sendReceiveAudio: "Отправка и получение аудиофайлов",
            sendReceiveGif: "Отправка и получение файлов GIF",
            startChat: "Начать чат на Supsis",
            supsisFunctionality: "Полезный функционал Supsis Chat",
            onePhoneMultiAgent: "Один телефон и несколько агентов",
            basicIntegration: "Базовая интеграция и нулевая конфигурация",
            unsubscribeWpInetgration: "Отписаться от WhatsApp",
            unsubscribeIGIntegration: "Unsubscribe Instagram Integration",
            wpBack: "назад",
            terminatelWpInetgration: "При нажатии кнопки «Отписаться» ваша интеграция с WhatsApp прекратится.",
            cancelWpInetgration: "Вы хотите отменить интеграцию WhatsApp?",
            terminatelIGIntegration: "When clicked the 'Unsubscribe' button, your instagram integration will terminate",
            cancelIGIntegration: "Do you want to cancel instagram integration?",
            startChatWp: "Начать Чат",
            purchaseHeader: "Покупка интеграции Supsis-Whatsapp",
            wpServices: "Служба WhatsApp",
            wpServicesIntegrationCompleted:
                "Ваша интеграция WhatsApp завершена. Теперь вы можете пользоваться сервисом.",
            purchasePaymentDescription:
                "Функция WhatsApp оплачивается ежемесячно. Ваша служба WhatsApp будет активирована после того, как вы примете подписку.",
            wpIntegrationFeatures: "Возможности интеграции WhatsApp",
            saveChanges: "Сохранить изменения",
            contactList: "Список контактов",
            broadcast: {
                broadcast: "Транслировать",
                detail: "Деталь",
                customer: "Покупатель",
                phoneNumbers: "Контактные телефоны",
                showMore: "Показать больше",
                showLess: "Показывай меньше",
                groupName: "Название группы",
                messages: "Сообщения",
                status: "Статус",
                usageCost: "Стоимость использования",
                sendingTime: "Время отправки",
                progress: "Прогресс",
                groupDetail: "Подробная информация о группе",
                messagesPerContact: "Сообщений на контакт",
                successRatio: "Коэффициент успеха",
            },
            messages: "Сообщения",
            broadcastRequests: "Запросы трансляции",
            customerGroups: "Группы клиентов",
            messageTemplates: "Шаблоны сообщений",
            plans: "Планы",
            wpIntegrationRequired: "Требуется интеграция с WhatsApp",
            wpRequiredIntegrationDescription:
                "Извините, страница, которую вы посетили, будет активирована при интеграции вашего WhatsApp.",
            integrateWp: "Поехали, интегрируем WhatsApp",
            active: "Активный",
            archived: "В архиве",
            createBroadcastMessage: "Создать широковещательное сообщение",
            title: "Заголовок",
            description: "Описание",
            createdAt: "Создано на",
            numbers: "Числа",
            actions: "Действия",
            action: "Действие",
            createCustomerGroup: "Создайте пользовательскую группу клиентов",
            search: "Поиск",
            name: "ИМЯ",
            contacts: "Контакты",
            noContactFound: "Контакт не найден",
            broadcastTitle: "Дайте название вашей трансляции.",
            recipients: "Получатели",
            selectRecipients: "Выберите получателей",
            writeYourMessage: "Напишите свое сообщение.",
            schedule: "Расписание",
            scheduleNowOrLater: "Запланируйте сейчас или позже",
            summary: "Резюме",
            cancel: "Отмена",
            send: "Отправлять",
            sending: "Отправка",
            deleteCustomerGroup: "Вы уверены, что хотите удалить эту группу клиентов? {name}",
            customerGroupDeleting: "Удаление группы клиентов ...",
            customerGroupDeletingSuccess: "Группа клиентов успешно удалена",
            customerGroupDeletingError: "Ошибка при удалении группы клиентов",
            wpPlusRequired: "Требуется план Whatsapp Plus.",
            broadcastMessageArchived: "Широковещательное сообщение как заархивированное",
            broadcastMessageNotArchived: "Широковещательное сообщение не архивируется",
            groupNameSearch: "Введите имя группы клиентов",
            groupNameDesc: "Название группы клиентов идентифицирует ваши группы клиентов",
            save: "Сохранять",
            number: "КОЛИЧЕСТВО",
            addColumn: "Добавить столбец",
            addColumnDesc: "Добавить столбец в таблицу",
            addNewContact: "Добавить новый контакт",
            addNewContactDesc: "Добавить контакт в таблицу",
            importFile: "Импорт из файла",
            importFileDesc: "Импорт контактов из файла excel или csv",
            contactAdded: "Контакт добавлен",
            updateCustomerGroup: "Обновление группы клиентов...",
            updateCustomerGroupSuccess: "Группа клиентов успешно обновлена",
            sendBroadcastMessage: "Отправить широковещательное сообщение",
            columnName: "Имя столбца",
            columnType: "Тип столбца",
            defaultValue: "Значение по умолчанию",
            setDefaultValue: "Установите значение по умолчанию для существующих контактов",
            age: "Возраст",
            location: "Расположение",
            gender: "Пол",
            selectContactFile: "Выберите контактный файл",
            selectContactCsvOrExcel: "Выберите файл CSV или EXCEL.",
            importConfiguration: "Импорт конфигурации",
            customizeFile: "Настройте конфигурацию импорта.",
            sendMessageTo: "Кому вы хотите отправить сообщение?",
            allContact: "Все контакты",
            messageTypes: "Типы сообщений",
            whenSendMessage: "Когда вы хотите отправить сообщение?",
            instantlyRightNow: "Мгновенно прямо сейчас",
            completed: "Завершенный",
            scheduleFuture: "Расписание на будущую дату",
            messageDesc: "Ваше сообщение будет отправлено мгновенно всем получателям",
            messageSendAt: "Ваше сообщение будет отправлено всем получателям на",
            estimatedPrice: "Ориентировочная цена",
            estimatedTime: "Расчетное время",
            now: "в настоящее время",
            tenMinute: "10 минут",
            cancelled: "Отменено",
            failed: "Не удалось",
            running: "Бег",
            queued: "В очереди",
            scheduled: "Запланированное",
            noNumberAdded: "Номера не добавлены",
            csvOrExcelFile: "CSV или файл Excel",
            broadcastMessagesToContactFile: "Рассылка сообщений в список контактов",
            broadcastMessageTemplates: "Шаблоны широковещательных сообщений",
            messageFlow: "Поток сообщений",
            textMessageSupport: "Поддержка текстовых сообщений",
            imageMessageSupport: "Поддержка графических сообщений",
            spamPreventions: "Защита от спама",
            includesAllBasicPlans: "Включает все в базовом плане",
            chatbotIntegration: "Интеграция с чат-ботом",
            messageToNewNumbers: "Сообщение на новые номера",
            broadcastMessageToEveryone: "Рассылка сообщений всем",
            personalizedBroadcastMessage: "Персонализированные широковещательные сообщения",
            customerGroupSegmentation: "Сегментация групп клиентов",
            scheduleBroadcastMessage: "Запланировать широковещательное сообщение",
            locationMessageSupport: "Поддержка сообщений о местоположении",
            advancedSpamPreventions: "Усовершенствованная защита от спама",
            whatsappPlans: "WhatsApp планы",
            selectBestPlan: "Выберите план, который вам подходит",
            comingSoon: "Вскоре...",
            selectFile: "Выберите файл",
            created: "Созданный",
            message: "Сообщение",
        },
        ig: {
            instagram: "Instagram",
        },
        ticket: {
            ticketTagFilter: "Тег фильтра билетов",
            ticketEmails: "Список рассылки для пересылки билетов",
            save: "Сохранить",
            delete: "Удалить",
            transactions: "Параметры",
            noEmailTicketNotifications: "Нет данных",
            emailIsNotValid: "Email не является допустимым",
            emailNotificationDeleted: "Товар удален успешно",
            emailNotificationDeleteError: "Произошла ошибка",
            tagFilterRequired: "Требуется тег фильтра заявки, используйте тег * (подстановочный знак) для всех заявок",
            emailsRequired: "Пересылка писем не должна быть нулевой",
            emailNotificationCreated: "Создано правило пересылки билетов",
            emailNotificationCreateError: "Произошла ошибка",
            ticketForwarding: "Пересылка билетов по электронной почте",
            ticketTagFilterDesc:
                "Он использует темы тикетов, которые вы использовали в дизайне чат-бота, для фильтрации тикетов. Вы можете написать другой тег и нажать Enter, чтобы добавить его. Если вы выберете тег '*', он выберет все билеты",
            ticketEmailsDesc:
                "Список адресов электронной почты, на которые будут отправлены билеты. Вы можете добавить адреса представителей в систему, выбрав их. Вы также можете добавить несистемные адреса электронной почты.",
            ticketList: "Правила пересылки билетов",
            ticketTagFilterPlaceHolder: "Фильтр билетов, выберите '*' для всех",
            ticketEmailsPlaceHolder: "Список рассылки для пересылки",
        },
        theme: {
            opacity: "Непрозрачность",
            headerColor1: "Секция Хадера, цвет 1",
            headerColor1A: "Непрозрачность раздела Хадера 1",
            headerColor2: "Цвет раздела заголовка 2",
            headerColor2A: "Непрозрачность раздела заголовка 2",
            backgroundColor: "Цвет фона 1",
            backgroundColorA: "Прозрачность фона 1",
            backgroundColor2: "Цвет фона 2",
            backgroundColor2A: "Прозрачность фона 2",
            textColor: "Цвет текста",
            errorTheme: "Цвет ошибки",
            selectCustom: "Выберите настраиваемую тему",
            bubbleBackground: "Репрезентативный цвет пузыря",
            bubbleVisitorBackground: "Цвет кружка клиента",
            bubbleBackgroundA: "Репрезентативная непрозрачность пузырька",
            bubbleVisitorBackgroundA: "Непрозрачность пузырька клиента",
            bubbleText: "Репрезентативный цвет текста",
            bubbleVisitorText: "Цвет текста клиента",
            textFormColor: "Цвет формы",
            headerColorSecond: "Цвет верхней части заголовка",
            headerColorFirst: "Нижний цвет заголовка",
            backgroundColorFirst: "Фон Верхний цвет",
            formColor: "Цвет текста формы",
            buttonColor: "Цвет кнопки",
            backgroundColorSecond: "Цвет фона снизу",
            chatBotButtonText: "Цвет шрифта чат-бота",
            chatBotButtonColor: "Цвет кнопки чат-бота",
        },
        billing: {
            paymentStatus: "Статус оплаты",
            amount: "Сумма",
            invoiceID: "Идентификатор счета",
            expected: "Ожидается..",
            currentAmount: "Текущая сумма",
            monthlyEstimatedAmount: "Ежемесячная примерная сумма",
            creationDate: "Дата создания",
            invoiceStatus: "Статус счета",
            invoicePeriod: "Период выставления счета",
            newPaymentMethod: "Новый способ оплаты",
            channelCount: "Количество каналов",
            remainingTime: "Оставшееся время",
            chatbotLimit: "Лимит чатбота",
            free: "Бесплатно",
            maxChatbotSession: "Максимальное количество сеансов чатбота",
            buyIt: "Купить",
            renewalDate: "Дата обновления",
            monthly: "Ежемесячно",
            yearly: "Ежегодно",
            packagePeriod: "Период пакета",
            packageType: "Тип пакета",
            packageManagement: "Управление пакетами",
            invoiceManagement: "Управление счетами",
            futureInvoice: "Будущий счет",
            pastInvoices: "Прошлые счета",
            creditCard: "Кредитная карта",
            invoice: "Инвойс",
            mustBeUpgradePlanForChatBot: "Чтобы активировать функцию ChatBot, вы должны перейти на тариф Pro!",
            incorrect: "Неправильно",
            cardInfo: "Информация о карте",
            billingDetails: "Платежные реквизиты",
            firstPreferredCard: "Сделать основной картой",
            primary: "Начальный",
            addCardIyzico:
                "У вас нет зарегистрированной карты. Чтобы оплачивать ежемесячную плату за использование, вам необходимо добавить карту. Платежная система предоставляется iyzico.",
            billingPlanSettings: "Биллинг и счет-фактура",
            startWith: "Карточка {cardFamily} начинается с {binNumber}",
            paymentMethod: "Способ оплаты",
            billingDate: "Дата оплаты",
            isPaid: "Платеж получен?",
            paid: "Оплаченный",
            unPaid: "Неоплачиваемый",
            billingHistory: "История счетов",
            markPaid: "Отметить как оплаченное",
            paymentDate: "Дата платежа",
            pay: "Платить",
            newInvoice: "Создать счет-фактуру",
            updateBilling: "Обновить платежную информацию",
            updateCard: "Сменить кредитную карту",
            paymentBilling: "Метод Paymnet и платежные реквизиты",
            price: "Цена",
            billingAddress: "Платежный адрес",
            billingCity: "Город",
            billingCountry: "Страна",
            contactName: "Имя контактного лица по счетам",
            expireMonth: "Срок действия месяца",
            expireYear: "Год истечения",
            cardNumber: "Номер карты",
            cardHolderName: "Имя владельца карты",
            cardAlias: "Псевдоним карты",
            identityNumber: "Идентификационный номер",
            name: "Имя",
            surname: "Фамилия",
            email: "Эл. адрес",
            addCard: "Добавить карту",
            update: "Обновлять",
            cancel: "Отмена",
            save: "Сохранить",
            saving: "Экономия",
            noInvoiceFound: "Нет счета",
            year: "Год",
            updating: "Обновление...",
            newInvoiceForm: "Форма создания нового счета",
            error: "Ошибка",
            transactions: "Параметры",
            paymentMethodAdded: "Способ оплаты успешно добавлен",
            paymentMethodAddError: "Способ оплаты не добавлен, произошла ошибка",
            creditCardChanged: "Кредитная карта успешно изменена",
            errorOccurred: "Произошла ошибка, попробуйте еще раз",
            billingDetailUpdated: "Платежная информация успешно обновлена",
            invoiceCreated: "Счет-фактура успешно создана",
            paymentSuccess: "Оплата прошла успешно, спасибо",
            paymentFail: "Платеж не прошел, попробуйте еще раз",
            billingAddressChanged: "Платежный адрес успешно изменен",
            hidePlan: "Скрыть план",
            informationShopping:
                "Ваша платежная информация, платежная информация, информация о кредитной карте контролируются Shopify.",
            trialTimeInformation:
                "Пробная версия заканчивается через {dayCount} дней после. Если вы не укажете способ оплаты до истечения этого периода, система автоматически переключит вас на БЕСПЛАТНЫЙ ПЛАН.",
            trialTimeInformationShort: "Последний {dayCount} День",
            currentPlanLabel: "Текущий план: {planName} ({agentCount} Агент )",
            changeCancelPlan: "Изменить / отменить тарифный план",
            oneAgent: "Агент",
            agent: "Агент",
            yourCurrentPlan: "Текущий план",
            month: "Месяц",
            billedMonthToMonth: "(выставляется счет от месяца к месяцу)",
            selectAgentCount: "Выберите количество агентов",
            selectFreePlan: "Выберите бесплатный план",
            planDetails: "Детали плана",
            multiAgent: "(Мультиагент)",
            selectProPlan: "Выберите план Pro",
            foreverFree: "Вечно свободный",
            websiteIntegration: "интеграция с сайтом",
            websiteIntegrationUnlimited: "интеграция с сайтом (неограниченный)",
            ChatBotUnlimited: "ChatBot (неограниченный)",
            videoCallUnlimited: " видеозвонок (неограниченный)",
            multiAgentUpTo: "Мультиагент (до {agentCount} агентов)",
            audioCallUnlimited: "Аудиовызов (неограниченный)",
            screenSharingUnlimited: "Совместное использование экрана(неограниченный)",
            fileTransferUnlimited: "Передача файлов (неограниченный)",
            autoChatAssignerUnlimited: "Автоматическое назначение чата (неограниченный)",
            multiLanguageTranslationUnlimited: "Многоязычный перевод (неограниченный)",
            detailedReporting: "Подробная отчетность",
            days30TrialsAvailable: "Доступны 30-дневные пробные версии",
            fullCustomizationUnlimited: "Полная настройка (неограниченный)",
            limitedArchiveLookupLastMo: "Ограниченный архив Поиск (Последний {monthCount}-мес)",
            planUpdated: "Отлично, ваш план обновлен.",
            planUpdating: "Ваш план обновляется...",
            planUpdatingDescription: "Подождите, пока ваш план обновится",
            done: "Выполнено",
            freePlanUpdated: "Ваш план обновлен как бесплатный (1 Агент)",
            proPlanUpdated: "Ваш план обновлен как план PRO {agentCount} Агент ",
            canNotDwnGrade:
                "Невозможно понизить ваш тарифный план с PRO {agentCountFirst} Агент до {valNewPlnToUppr} {agentCountSecond}.  ",
            deleteWarning: "Вы должны удалить или отключить {valDif} Агент.",
            warnMessage: "Выбранный план должен отличаться от текущего.",
            add: "Добавлять",
            cancelYourPlan: "Отменить тарифный план",
            upgradeYourPlan: "Обновите свой план",
            downgradeYourPlan: "Понизьте свой план",
            agree: "ДАТЬ СОГЛАСИЕ",
            disagree: "Не согласен",
            invoices: "Счета",
            priceIntervals: "Ценовой интервал",
            selectSiteAlias: "Выберите или введите название сайта",
            selectPriceInterval: "Выберите или введите ценовой интервал",
            isRefunded: "Возврат сделан?",
            invoiceId: "Счет №",
            siteId: "Сайт №",
            createdDate: "Дата создания",
            failCount: "Количество неудачных попыток получения платежа",
            failDate: "Неудачная дата платежа",
            Dashboard: "Панель приборов",
            Agents: "Агенты",
            Integration: "Интеграция",
            Settings: "Настройки",
            Contacts: "Контакты",
            Domain: "Домен",
            lastActivity: "Последняя активность",
            basePrice: "Базисная цена",
            packagePrice: "Базисная цена",
            whatsappPrice: "WhatsApp Цена",
            realtimeVisitorCount: "Посетитель в реƒжиме реального времени",
            suspend: "Приостановить",
            partner: "Партнер",
            plan: "Строить планы",
            trialDay: "Пробные дни",
            mobile: "Мобильный",
            webSite: "Веб-сайт",
            websiteOrigins: "Происхождение веб-сайта",
            ownerName: "Имя владельца",
            ownerEmailAddress: "Электронная почта владельца",
            discount: "Скидка",
            daysLeft: "Осталось дней",
            newTrialPopUp: "Сколько дней должен длиться новый пробный период?",
            newWpPricePopUp: "Сколько стоит новый тариф WhatsApp?",
            newIGPricePopUp: "Сколько стоит новый тариф Instagram?",
            newBasePricePopUp: "Сколько стоит новая базовая цена?",
            siteInfoUpdated: "Информация о сайте обновлена",
            siteInfoNotUpdated: "Информация о сайте не обновлена",
            siteInfoNotUpdatedErr: "Произошла ошибка! Информация о сайте не обновлена.",
        },
        tour: {
            stats: " ПАНЕЛЬ СТАТИСТИКИ ",
            chats: " ЧАТ ПАНЕЛЬ ",
            settings: " НАСТРОЙКИ ",
            status: " СТАТУС ",
            prevStep: " Предыдущий шаг ",
            nextStep: " Следующий шаг ",
            finish: " Закончи это ",
            skip: " Прыжок ",
            skip2: " Я знаю систему, больше не показываю",
            startTour: "Начать тур",
            firstTimeIntro:
                " Я обнаружил, что вы впервые вошли в систему, если вы позволите, я хочу начать небольшой вводный тур. ",
            hi: " Привет ",
            welcomeTo: " Добро пожаловать в службу поддержки Supsis Live ",
            statsPanel:
                " Это строка состояния, показывающая общее количество активных номеров чата, которые мгновенно ожидают вместе с системой.",
            sidebarMenu: " Меню ",
            sidebarMenuContent: " Здесь вы можете переключаться между страницами.",
            representativePrivateMessage: "Межпредставительская дискуссионная панель",
            representativePrivateMessageContent: " Здесь вы можете увидеть личные разговоры между агентами.",
            helpMenu: "Меню помощи",
            helpMenuContent: " Здесь вы можете найти справочную информацию о системе.",
            settingsMenu: " Меню настроек ",
            settingsMenuContent: " Здесь вы можете выбрать язык, ночной режим и увеличение экрана.",
            startChat: "Начать Чат",
            profileMenu: " Меню профиля ",
            profileMenuContent: " Здесь вы можете изменить доступность и настроить параметры делегата.",
            visitorsTab: " Посетители ",
            visitorsTabContent: " Вы можете увидеть посетителей здесь. ",
            visitorTabHistory: " История посетителей ",
            visitorTabHistoryContent: " Вы можете увидеть историю посетителей здесь.",
            representativeTab: " Представители ",
            representativeTabContent: " Вы можете увидеть представителей здесь.",
            liveSupport: " Живая поддержка ",
            liveSupportContent:
                " Здесь вы можете увидеть количество клиентов, получающих поддержку в реальном времени.",
            siteVisitors: "Посетители сайта",
            siteVisitorsContent: " Здесь вы можете увидеть количество посетителей сайта.",
            tableSettings: " Настройки стола ",
            tableSettingsContent: "Отсюда вы можете показать или скрыть столбцы в таблице.",
            watchModeButton: "Кнопка просмотра",
            watchModeContent:
                " Вы можете присоединиться сюда в режиме просмотра, и вы можете просматривать только то, что было опубликовано.",
            popoverInfo: " Подробная информация о посетителе ",
            popoverInfoContent: " Дает информацию о посетителе.",
            popoverButton: " Расширенные настройки речи ",
            popoverButtonContent:
                " Вы можете открыть беседу, отправить сообщение напрямую представителю или заблокировать посетителя.",
            openChat: " Кнопка: Присоединиться к разговору",
            openChatContent: " Вы можете начать разговор здесь ",
            pagination: " Меню подкачки.",
            paginationContent: " Здесь вы можете увеличить количество страниц.",
            chatwindow: {
                chatWindowSettingsButtons: " КНОПКА НАСТРОЕК ОКНА РАЗГОВОРА ",
                chatWindowActionButtons: " ОКНО РЕЧИ КНОПКИ ОБЩИХ ОПЕРАЦИЙ ",
                chatPanelActions: " РАБОТА С РЕЧНОЙ ПАНЕЛЬЮ ",
                otherPanels: "ДРУГИЕ ПАНЕЛИ",
                settingsButton:
                    "Вы можете заблокировать речь, пересылку, конфиденциальное сообщение и назначить делегатов.",
                chatColorButton: " Вы можете узнать, что означает цвет в речевых пузырях, здесь.",
                keyboardShortcutButton:
                    " Здесь вы можете найти ярлыки для функций, которые упрощают ведение переписки или других функций, которые вы используете. ",
                hideButton: "Откладывает открытое выступление и остается открытым на заднем плане",
                closeButton: " Вы заканчиваете откровенный разговор и уходите из разговора ",
                ellipsisButton:
                    " Сюда включены другие транзакции. Здесь выполняются такие операции, как отправка личных сообщений, запрет посетителей, назначение представителей. ",
                userInfoWidget: " Подробная информация о посетителе будет доступна здесь. ",
                preparedContentWidget:
                    "Есть готовые шаблоны контента. Вы можете быстро добавить готовый контент, щелкнув ярлык или набрав серию ярлыков в области письма на экране речи.",
                chatHistoryWidget:
                    " Если у этого посетителя есть прошлые разговоры, они будут перечислены здесь. Вы можете просмотреть старые детали речи здесь ",
                chatBarButton:
                    " Здесь вы можете заблокировать активный разговор, отправить личное сообщение агенту и выйти из разговора.",
            },
        },
        adminUser: {
            newAdminUserForm: " Форма регистрации нового администратора ",
            updateAdminUserForm: " Форма обновления пользователя-администратора ",
            adminUsers: " Пользователи с правами администратора ",
            newAdminUser: " Новый пользователь-администратор ",
            noAdminUser: " Еще нет пользователя с правами администратора.",
            adminUserName: " Имя пользователя администратора ",
        },
        report: {
            hourly: "(Часовой)",
            hourlyAverage: "Средний за час",
            hourlyMax: "Максимум за час",
            hourlyMin: "Минимум за час",
            totalAmount: "Общая сумма",
            averageAmount: "Средняя сумма",
            minAmount: "Минимальная сумма",
            maxAmount: "Максимальная сумма",
            siteCount: "site Count",
            agentCount: "Agent Count",
            channelsTimeSeries: "Временной ряд каналов",
            channelPies: "Пироги каналов",
            pieView: "Круговая диаграмма",
            topVisitorCountry: "Страна с наибольшим количеством посетителей",
            websiteTrafficByCountry: "Трафик веб-сайта по странам",
            visitorCount: "Количество посетителей",
            websiteVisitorTraffic: "Трафик посетителей на сайте",
            websiteTraffic: "Трафик сайта",
            author: "Автор",
            topWorstComments: "Худшие комментарии",
            topBestComments: "Лучшие комментарии",
            topComments: "Лучшие комментарии",
            noComment: "Комментариев пока нет",
            minWaitingTime: "Минимальное время ожидания",
            maxWaitingTime: "Максимальное время ожидания",
            averageWaitTime: "Среднее время ожидания",
            waitTime: "Время ожидания (секунды)",
            agentWaitDurationTitle: "График времени ожидания агента",
            incomingMessage: "Входящее сообщение(я)",
            outgoingMessage: "Исходящее сообщение(я)",
            totalSpent: "Общие расходы",
            avgSpent: "Средние расходы",
            totalPayment: "Общая оплата",
            walletStatus: "Состояние кошелька",
            walletBalanceStatus: "Состояние баланса кошелька",
            messageTraffic: "Сообщения",
            breakCount: "Количество перерывов",
            agentBreakTime: "Количество перерывов агентов ☕",
            agentStatusHour: "Часовой статус агента",
            agentWorkTimeCalendar: "Календарь рабочего времени агента",
            agentActivity: "Активность агента",
            noEnoughtData: "Достаточно данных нет",
            averageFirstResponse: "Среднее время первого ответа",
            slowestResponser: "Самый медленный отвечающий",
            fastestResponder: "Самый быстрый отвечающий",
            firstAnswerTimeSec: "Время первого сообщения (в секундах)",
            firstAnswerByAgent: "Время первого сообщения от агента",
            averageSolutionTime: "Среднее время решения",
            slowestSolver: "Самый медленный решатель",
            fastestSolver: "Самый быстрый решатель",
            averageChat: "Средний чат",
            leastChatReceiver: "Наименее активный получатель чата",
            mostChatRecipients: "Наибольший количество получателей чата",
            averageTicket: "Average Ticket",
            leastTicketReceiver: "Least Ticket Least",
            mostTicketRecipients: "Most Ticket Recipients",
            resolveTime: "Время разрешения (мин)",
            resolveTimeByUser: "Время разрешения чата пользователем (в минутах)",
            chatResolveTimeByAgent: "Время разрешения чата агентами",
            chatDistByHandleType: "Распределение чатов по обработчику",
            chatDistByHandDesc: "Сколько чатов обработали агенты, чатботы и гибриды?",
            chatCountsByHandleType: "Число чатов по типу обработки",
            missed: "Пропущено",
            answered: "Отвечено",
            chatDistByAnsDesc: "Сколько чатов было ответов или пропущено?",
            chatCountsByAns: "Количество чатов по ответу",
            chatCountByPlatform: "Количество чатов по платформе",
            chatDistByPDesc: "Сколько чатов поступило на какую платформу?",
            chatDistByPlatform: "Распределение чатов по платформе",
            ticketCountByUser: "Ticket Counts by Agents",
            ticketCountByStatus: "Ticket Counts by Response Status",
            user: "Пользователь",
            saveAsImage: "Сохранить как изображение",
            fullScreen: "Полноэкранный режим",
            download: "Скачать",
            tableView: "Вид таблицы",
            chartView: "Вид диаграммы",
            chatDistByUsers: "Распределение чатов по пользователям",
            chatCountsByUsers: "Количество чатов по пользователям",
            minDuration: "Минимальная продолжительность",
            maxDuration: "Максимальная продолжительность",
            totalDurationByAgent: "Общая продолжительность сеанса по агенту",
            averageDurationByAgent: "Средняя продолжительность сеанса по агенту",
            totalDurationByCB: "Общая продолжительность сеанса по чатботу",
            averageDurationByCB: "Средняя продолжительность сеанса по чатботу",
            viewUnitAs: "Просмотреть единицу как",
            hybrid: "Гибридный",
            handledBy: "Обработано",
            sessionDurationOverall: "Общая продолжительность сессии",
            allChannels: "Все каналы",
            sessionsDurationOverall: "Общая длительность сессий",
            sessionsOverall: "Общее количество сессий",
            calendarEvents: "Календарные события",
            reservationEvents: "События бронирования",
            incomingMails: "Входящие письма",
            incomingMailCount: "Количество входящих писем",
            reservation: "Бронирование",
            event: "Событие",
            reservationEventCount: "Количество событий бронирования",
            eventCount: "Event Counts",
            channelBreakdown: "Разбивка каналов",
            websiteAnalysis: "Анализ веб-сайта",
            customerSatisfaction: "Удовлетворенность клиентов",
            teamBreakAnalysis: "Анализ работы команды/перерыва",
            dailyAgentActivity: "Ежедневная активность агента",
            agentPerformance: "Производительность агента",
            chatDistributions: "Распределение чатов",
            users: "Пользователи",
            segmentTimeseries: "График сегмента",
            segmentsOverall: "Общие сегменты",
            unmatchRatio: "Коэффициент несовпадения",
            totalMatchCount: "Общее количество совпадений",
            totalUnmatchCount: "Общее количество несовпадений",
            matchRatio: "Коэффициент совпадения",
            matched: "Совпадает",
            trainingOverall: "Общая тренировка",
            trainingStatusTimeseries: "График статуса обучения",
            duration: "Продолжительность",
            totalSessionDuration: "Общая продолжительность сессии",
            averageSessionDuration: "Средняя продолжительность сессии",
            second: "секунда",
            minute: "минута",
            hour: "час",
            aggregateAs: "Агрегировать как",
            chatbotSessionDurationOverall: "Общая продолжительность сессии чатбота",
            ratingTimeSeries: "График оценок",
            chatCountTimeseries: "Временной ряд количества чатов",
            notRated: "Не оценено",
            totalRatingCount: "Общее количество оценок",
            averageRating: "Средний рейтинг",
            weightedAverageRating: "Взвешенный средний рейтинг",
            rate: "Оценить",
            ratingOverall: "Customer Ratings Overall",
            session: "Сеанс",
            total: "Всего",
            average: "Среднее",
            max: "Максимум",
            min: "Минимум",
            sessionCount: "Количество сеансов",
            uniqueUsers: "Уникальные пользователи",
            viewAs: "Просмотреть как:",
            overall: "Общий",
            detailReport: " Детальный отчет ",
            dailyReports: " Ежедневный отчет ",
            pointBasedReports: " Отчеты на основе оценок ",
            personDateBasedPointReport: " Отчет об оценке по количеству людей и дней ",
            personDateBasedReport: " Персональный и дневной отчет ",
            personBasedReport: " Персональные отчеты ",
            personAndDateBasedGraph: " График  людей и дней ",
            noReport: " Нет отчета ",
            reports: " Отчеты ",
            totalBar: " Общее ",
            ticketCount: "Ticket Count",
        },
        stats: {
            total: " Количество активных разговоров в системе.",
            active: " Количество принадлежащих вам активных разговоров.",
            waiting: " Количество новых активных разговоров, ожидающих делегирования.",
            late: " Количество новых разговоров, прошедших определенный период времени и ожидающих делегирования.",
            free: " Количество разговоров, ожидающих назначения нового представителя после выхода представителя из системы..",
            pco: "[Personel Çalışma Oranı] : Это коэффициент занятости от общего количества звонков, которые могут получить онлайн-представители в системе. ",
            maxCapacity:
                " Это максимальное количество чатов, которое система может назначить представителям без ожидания. ",
            chatbot: ` Количество активных разговоров чат-бота `,
        },
        time: {
            lastYear: "Прошлый год",
            thisYear: "Этот год",
            last3Months: "Последние 3 месяца",
            last7: "Последние 7 дней",
            today: " Сегодня ",
            yesterday: "Вчера",
            lastWeek: " Прошлая неделя ",
            currentWeek: " Эта неделя ",
            currentMonth: " Этот месяц ",
            lastMonth: " Прошлый месяц ",
            last30Day: " Последние 30 дней ",
            allTime: " Все время ",
            custom: " Другое время ",
        },
        fastWizard: {
            generalColors: "Общие цвета",
            tellUsMore: "Расскажите нам больше, чтобы мы могли персонализировать ваш опыт",
            moreInfo: "Больше информации",
            display: "Отображать",
            availability: "Доступность",
            preview: "Предварительный просмотр",
            installCode: "Установить код",
            previous: "Предыдущий",
            setupSupsisLiveChat: "Настроить чат SUPSIS LIVE",
            continue: "Следующий шаг",
            completeInitialize: "Завершить инициализацию",
            completedMessage: "Настройка чата SUPSIS LIVE успешно завершена.",

            websiteIntegration: "Адрес вашего веб-сайта для интеграции онлайн-чата supsis",

            customizeLiveChat: "Настройте свой онлайн-чат",
            createBrandedExperience: "Создайте фирменный чат для ваших посетителей.",
            chatColor: "Цвет чата",
            chatBubble: "Пузырь чата",
            selectBubble: "Выберите всплывающее окно чата",
            chatBubbleColor: "Цвет пузыря чата",
            selectChatBubbleColor: "Выберите цвет пузыря чата",
            customSelection: "Пользовательский выбор:",

            chatAvailability: "Доступность чата",
            onlineSupportVisitorTime: "Когда вы в сети, чтобы поддержать посетителей?",
            channelAvailability: "Доступность канала",
            availability724: "Чат доступен 7/24",
            basedOnTeam: "На основе статуса члена команды",
            basedOnTeamExplanation: "Чат появится в сети, если хотя бы 1 участник станет доступным.",
            customHours: "Индивидуальные часы работы",
            customHoursExplanation: "Настройте свое рабочее время",
            customHoursTimezone: "Часовой пояс:",
            customHoursFrom: "Из:",
            customHoursTo: "К:",
            customHoursAddHours: "+Добавить часы",

            previewDesktop: "Рабочий стол",
            previewIpad: "IPad",

            installationAndInstructions: "Инструкция & установке",
            installationTrackingCode: "Установите код отслеживания на свой сайт",
            installationTrackingCodePlease:
                "Вставьте код в соответствии с приведенными ниже инструкциями непосредственно перед концом тега {bodyTag} на любую страницу, на которой вы хотите включить чат SUPSIS Live.",
            installationInstructionsJavascript:
                " Вставьте приведенный выше код интеграции в тег {bodyTag} непосредственно перед закрывающим",
            installationInstructionsShopify1: "1. Войдите в свою панель Shopify",
            installationInstructionsCopy: "Копировать",
            installationInstructionsCoppyMessage: "Скрипт интеграции скопирован в буфер обмена",
            installationInstructionsShopify2:
                "2. Перейдите в Интернет-магазин> Темы> раскрывающееся меню Действия в разделе Текущая тема> Изменить код> тема.жидкость.",
            installationInstructionsShopify3:
                "3. Вставьте приведенный выше код интеграции непосредственно перед тегом {bodyTag} в конце скрипта theme.liquid.",
            installationInstructionsIdeaSoft1: "1. Войдите в свою дилерскую панель.",
            installationInstructionsIdeaSoft2: "2. Зайдите в Настройки -> SEO -> Службы поисковых систем.",
            installationInstructionsIdeaSoft3:
                "3. Выберите «Проверка сайта с помощью метатега» в разделе «Код отслеживания».",
            installationInstructionsIdeaSoft4:
                "4. Скопируйте и вставьте приведенный выше код интеграции в открывшееся поле и сохраните.",
            installationInstructionsIdeaSoft5:
                "5. Внутри настроек -> Оптимизация нажмите кнопку «Очистить кеш». На этом интеграция завершена.",
            installationInstructionsWordPress1: "1. Войдите в свою админ панель WordPress.",
            installationInstructionsWordPress2: "2. Перейдите в Внешний вид> Редактор тем.",
            installationInstructionsWordPress3:
                "3. В разделе «Файлы темы» (крайний справа) найдите нижний колонтитул темы (footer.php) и выберите его.",
            installationInstructionsWordPress4:
                "4. Вставьте приведенный выше код интеграции перед тегом {bodyTag} внизу.",
            installationInstructionsWordPress5: "5. Нажмите «Обновить файл», чтобы сохранить изменения.",
            installationInstructionsOpenCart1: "1. Войдите в свою админ панель Opencart.",
            installationInstructionsOpenCart2: "2. Перейдите в Внешний Дизайн > Редактор тем.",
            installationInstructionsOpenCart3: "3. Выберите «общую» папку и откройте файл 'header.twig'.",
            installationInstructionsOpenCart4:
                "4. Вставьте приведенный выше код интеграции перед тегом {headTag} внизу.",
            installationInstructionsOpenCart5: "5. Нажмите кнопку сохранения.",
            installationInstructionsTicimax1: "1. Войдите в свою административную панель Ticimax.",
            installationInstructionsTicimax2:
                "2. Откройте «Дизайн» > «Настройки дизайна» > «Дизайн нижнего колонтитула верхнего колонтитула».",
            installationInstructionsTicimax3: "3. Нажмите кнопку «Источник» в разделе дизайна логотипа.",
            installationInstructionsTicimax4: "4. Вставьте код интеграции выше под HTML-кодом.",
            installationInstructionsEticaretteyim1: "1. Войдите в панель администрирования вашего интернет-магазина",
            installationInstructionsEticaretteyim2:
                "2. Просто назовите SUPSIS из «Плагины»> «Создать HTML»> и скопируйте код.",
            installationInstructions: "инструкции",
            installationVerify: "Убедитесь, что на вашем сайте установлен SUPSIS",
            installationVerifyChecking: "Проверка",
            installationVerifyCheck: "Проверять",
            installationVerifyCheckingStatus: "Проверка статуса интеграции SUPSIS на {website} сайт",
            installationCheckingStatusMessageYes: "Отлично, SUPSIS интегрирован в {website} сайт !!",
            installationCheckingStatusMessageNo:
                "SUPSIS в настоящее время не интегрирован с веб-сайтом {website}. Вы можете завершить процесс интеграции сейчас или позже.",

            vtippyPreferredLanguage: "предпочтительный язык",
        },
        akinon: {
            typeOrSelectSKU: "Введите или выберите артикул",
            akinonUserId: "Идентификатор пользователя Акинон",
            userEmail: "Электронная почта пользователя",
            userEmailDesc: "Введите или выберите адрес электронной почты пользователя...",
            send: "Отправлять",
            selectCity: "Выберите город",
            city: "Город",
            selectState: "Выберите штат",
            state: "Состояние",
            useMap: "Использовать карту",
            chooseAddress: "Выберите адрес",
            selectCountry: "Выберите страну",
            country: "Страна",
            productIdDesc: "Введите или выберите продукт...",
            productId: "Код товара",
            userIdDesc: "Введите идентификатор пользователя Akinon...",
            productSKU: "Артикул продукта",
            latitudeDesc: "Введите или выберите широту целевого местоположения...",
            longitudeDesc: "Введите или выберите долготу целевого местоположения...",
            orderNumber: "Ваш номер заказа",
            orderDesc: "Введите номер заказа...",
            longitude: "Долгота",
            latitude: "Широта",
        },
        headBar: {
            email: "Электронная почта",
            phone: "телефон",
            name: "Имя",
            date: "История",
            subject: "Предмет",
            situation: "Ситуация",
            representative: "Представитель",
            transactions: "Транзакции",
        },
        login: {
            loginTitle1: "Добро пожаловать в",
            loginTitle2: "SUPSIS",
            email: "Ваш адрес электронной почты",
            emailPlaceholder: "Пожалуйста, введите Ваш адрес электронной почты.",
            emailError: "Пожалуйста, введите действительный адрес электронной почты",
            password: "Ваш пароль",
            passwordLogin: "Пароль Бесплатный вход",
            passwordAndLogin: "Войти с паролем",
            passwordNew: "Сбросить пароль",
            loginAnd: "Или",
            passwordPlaceholder: "Пожалуйста введите ваш пароль.",
            loginMemory: "Запомнить это устройство",
            passwordForget: "Я забыл свой пароль",
            passwordNewAgain: "Новый пароль",
            passwordNewAgainTwo: "Повторить новый пароль",
            passwordNewAgainPlaceholder: "Пожалуйста, введите новый пароль.",
            passwordNewAgainPlaceholderTwo: "Пожалуйста, введите новый пароль еще раз.",
            login: "Авторизоваться",
            loginFooter: "Или войдите с электронной почтой",
            emailLogin: "Войти с помощью электронной почты",
        },
        settings: {
            auditlogs: "Audit Logs",
            myaccount: "My Account",
            notifications: "Notifications",
            company: "Компания",
            features: "Особенности",
            general: "Общий",
            chat: "Чат",
            wallet: "кошелек",
            timings: "Время",
            language: "Язык",
            "bubble-settings": "Настройки пузыря",
            "bubble-actions": "Действия пузыря",
            "theme-settings": "Настройки темы чата",
            visitorLoginForm: "Форма входа посетителя",
            visitorAttribute: "Информация о профиле посетителя",
            timing_settings: "Настройки времени чата",
            auto_assign: "Auto Chat Assign",
            availability: "Доступность",
            "website-integration": "Интеграция веб-сайта",
            General: "Общий",
            Chat: "Чат",
            Timings: "Время",
            Integration: "Интеграция",
            developer: "Разработчик",
            visitorNew: "Новый посетитель",
            companySubtitles: "Управляйте настройками компании.",
            featuresSubtitles: "Управляйте функциями.",
            languageSubtitles: "Управляйте языковыми настройками.",
            bubbleSettings: "Настройки пузыря",
            bubbleSettingsSubtitles: "Управляйте настройками пузыря.",
            bubbleActionsSubtitles: "Управляйте действиями пузыря.",
            chatThemeSettingsSubtitles: "Управляйте настройками темы чата.",
            visitorLoginFormSubtitles: "Управляйте настройками формы входа посетителя.",
            chatTimingSettingsSubtitles: "Управляйте настройками времени чата.",
            webSiteIntegrationSubtitles: "Управляйте настройками интеграции веб-сайта.",
            apiAccessTitle: "Доступ к API",
            apiAccessSubtitles: "Управляйте доступом к API.",
            youTubeActionForm: "Добавьте свой канал YouTube",
            linkedinActionForm: "Добавьте свою учетную запись Linkedin",
            telegramActionForm: "Добавить учетную запись Telegram",
            facebookActionForm: "Добавьте свою страницу Facebook",
            tiwitterActionForm: "Добавьте свою страницу Twitter",
            instagramActionForm: "Добавьте свою страницу Instagram",
            liveSupportDescription: "Поддержка в реальном времени",
            ticketDescription: "Откройте чат с вашими клиентами",
            whatsappDescription: "Ваши клиенты могут связаться с вами через WhatsApp",
            phoneDescription: "Ваши клиенты могут связаться с вами по телефону",
            emailDescription: "Ваши клиенты могут связаться с вами по электронной почте",
            facebookDescription: "Ваши клиенты могут связаться с вами через Facebook",
            twitterDescription: "Ваши клиенты могут связаться с вами через Twitter",
            instagramDescription: "Ваши клиенты могут связаться с вами через Instagram",
            youtubeDescription: "Ваши клиенты могут связаться с вами через YouTube",
            linkedinDescription: "Позвольте вашим клиентам связаться с вами с помощью LinkedIn",
            telegramDescription: "Позвольте вашим клиентам достичь большего с помощью Telegram",
            whatsappModalTitle: "Форма обработки WhatsApp",
            whatsappModalDescription: "Чтобы подключить свой номер WhatsApp, заполните форму ниже.",
            phoneModalTitle: "Форма обработки телефона",
            phoneModalDescription: "Чтобы подключить свой номер телефона, заполните форму ниже.",
            emailModalTitle: "Форма обработки электронной почты",
            emailModalDescription: "Чтобы подключить свой адрес электронной почты, заполните форму ниже.",
            facebookModalTitle: "Форма обработки Facebook",
            facebookModalDescription: "Чтобы подключить свою страницу Facebook, заполните форму ниже.",
            twitterModalTitle: "Форма обработки Twitter",
            twitterModalDescription: "Чтобы подключить свою страницу Twitter, заполните форму ниже.",
            instagramModalTitle: "Форма обработки Instagram",
            instagramModalDescription: "Чтобы подключить свою страницу Instagram, заполните форму ниже.",
            youtubeModalTitle: "Форма обработки YouTube",
            youtubeModalDescription: "Чтобы подключить свой канал YouTube, заполните форму ниже.",
            linkedinModalTitle: "Форма транзакции LinkeIn",
            linkedinModalDescription: "Пожалуйста, заполните форму ниже, чтобы связать свою учетную запись LinkedIn.",
            telegramModalTitle: "Форма транзакции Telegram",
            telegramModalDescription:
                "Введите ссылку на свой профиль Telegram в форму ниже, чтобы связать свою учетную запись Telegram.",

            instagramAlertTitle: "Требуется интеграция с Instagram",
            instagramAlertDesc:
                "Извините, посещенная вами страница будет активирована при интеграции с вашим Instagram.",
            instagramActivateText: "Поехали, интегрируем Instagram",
            remove: "Удалить",
            edit: "Редактировать",
            connected: "Подключенный",
            add: "Добавить",
            themeDescription: "Выберите тему чата.",
            fontDescription: "Выберите шрифт чата.",
            isFabsAsIcon: "Показать тексты значков меню.",
            chatBubbleTextSetting: "Настройка текста чата",
            textOnChatBubble: "Вы можете настроить параметры текста, которые будут отображаться в пузыре чата.",
            textToAppearOnChatBubble: "Текст, который будет отображаться в пузыре чата",
            newVisitorProfileInformation: "Информация о профиле нового посетителя",
            newVisitorProfileInformationDescription: "Добавляет новую ценность информации профиля посетителя",
            create: "Создавать",
            newAdd: "Добавить новое",
            toInform: "Довести до сведения",
            toInformDescription:
                "Вы можете сопоставить значения, которые вы добавляете на этой странице, с формой входа посетителя.",
            showVisitor: "Показать посетителя",
            label: "Билет",
            text: "ПисьмоПисьмо",
            email: "почта",
            phone: "телефон",
            number: "Число",
            url: "URL",
            date: "Время",
            dropdown: "выбираемый",
            languageTimeZone: "Язык и регион",
            timeZoneTitle: "Регион и часовой пояс",
            timeZoneDescription: "Настройки региона и часового пояса",
        },
        userInfoWidget: {
            userInformation: "Информация о пользователе",
            fullName: "Имя и фамилия",
            newValue: "Новое значение",
            newProfileInfo: "Информация о новом профиле",
            affiliatedRepresentatives: "Представители",
            preferredAgents: "Предпочтительный агент(ы)",
            labels: "этикетки",
            agentNotes: "Примечания агента",
            newNote: "Новая заметка",
            note: "заметка",
            available: "Имеются заметки.",
            systemInformation: "Системная информация",
            speechID: "Идентификатор речи",
            customerVersion: "Версия клиента",
            IPAddress: "Айпи адрес",
            pageVisited: "Посещенная страница",
            systemAndBrowser: "Операционная система и браузер",
            countryAndLanguage: "Страна и язык",
            clickToEdit: "Изменить Нажмите внутри поста",
            adsYouAreInterestedIn: "Рекламы, которые вас интересуют",
            detail: "Деталь",
            adsTitle: "Заголовок",
            adUrl: "URL рекламы",
            sourceID: "Идентификатор источника",
            resourceType: "Тип ресурса",
            adsBody: "Содержание",
            adsCreateDate: "Дата создания",
            adsUpdateDate: "Дата обновления",
        },
        newWizartV2: {
            generalSettings: "общие настройки",
            themeSettings: "Настройки темы",
            representativeWorkingHours: "График работы представителя",
            preview: "предварительный просмотр",
            setup: "Настраивать",
            formStepTitle: "Дайте нам больше информации, чтобы мы могли персонализировать ваш опыт",
            supsisEntergation: "На каком вашем веб-сайте вы будете использовать Supsis?:",
            goToNextStep: "Сделайте следующий шаг",
            readytemplate: "Сделайте следующий шаг",
            customSettings: "Özel Ayarlar",
            customerMessageView: "Сообщение клиента Посмотреть",
            backcgroundColor: "Фоновый цвет",
            textColor: "Цвет шрифта",
            agentMessageView: "Представление сообщений агента",
            workingHours: "В какие промежутки времени вы обслуживаете своих посетителей?",
            continuousService: "Непрерывное обслуживание",
            continuousServiceDescription: "Пузырь чата всегда активен. Даже если вы не в системе.",
            vote: "Сделай свой выбор",
            representativeWorking: "График работы представителя",
            representativeWorkingDescription:
                "Чат появляется в сети, когда хотя бы 1 агент находится в сети. Если онлайн-представителя нет, он будет отображаться как офлайн.",
            computer: "Компьютер",
            tablet: "планшет",
            uploadTrackingCodeToYourWebsite: "Загрузите код отслеживания на свой веб-сайт",
            password: "Установить новый пароль",
        },
        whatsappChannel: {
            whatsappTitleV1: "Каналы Whatsapp V1 (QR)",
            whatsappTitleV2: "Каналы Whatsapp V2 (QR)",
            channelName: "Имя канала",
            phoneNumber: "Номер телефона",
            forwardToChatbot: "Переслать боту",
            forwardingChatbotOrLiveAgent: "Пересылка (бот или живой агент)",
            addChannel: "Добавить канал",
            newWhatsappChannel: "Новый канал WhatsApp",
            newWhatsappChannelDescription: "Создайте новый канал WhatsApp, отсканировав QR-код",
            editWhatsappChannel: "Редактировать канал WhatsApp",
            editWhatsappChannelDescription: "Редактирование канала WhatsApp",
            whatsappChannel: "Канал WhatsApp",
            deleteWhatsappChannelDescription: "Вы уверены, что хотите удалить этот канал?",
            whatsappIntegration: "Интеграция WhatsApp",
            deleteChannel: "Удалить канал",
            restartChannel: "Перезапустить канал",
            wantRestartChannel: "Хотите перезапустить канал?",
            deleteSMSChannelDescription: "Вы уверены, что хотите удалить канал SMS?",
            smsChannel: "СМС-канал",
            maxChannelCount: "Вы не можете создать более одного SMS-канала!",
            smsModalText:
                "Наша интеграция с современными коммуникационными решениями дает вам возможность легко и эффективно отправлять SMS. Устраните границы в общении, общайтесь напрямую со своими клиентами!",
            smsModalBtn: "Нажмите, чтобы открыть канал SMS...",
            postaCellDetail: "Подробности о канале PostaCell",
        },
        noPermission: "У вас нет разрешения на выполнение этой операции.",
        mail_integration_detail: {
            title: "Детали почты",
            integration: "Интеграция",
            sender: "Отправитель",
            signature: "Подпись",
            inbox: "Входящие",
            medias: "Медиа",
            visibility: "Видимость",
            settings_group: "Настройки",
            contacts: "Контакты",
        },
        whatsapp_business_api: {
            title: "Каналы Whatsapp Business API",
            integration: "Интеграция",
            detail: "Детали",
            visibility: "Видимость",
            templates: "Все шаблоны сообщений",
            settings_group: "Настройки",
            template_message_group: "Шаблоны сообщений",
            chat_initiator_template: "Шаблон инициирования чата",
            contacts: "Контакты",
            numbers: "Числа",
            all_contacts: "Все контакты",
            new_template: "Создать новый шаблон",
            broadcast_group: "Рассылка",
            broadcast_requests: "Запросы на рассылку",
            customer_groups: "Группы клиентов",
            businessChannelDetail: "Детали канала Whatsapp Business",
            wallet: "Wallet",
            postacellMessage: "Отправить SMS",
            postacellAllMessage: "Отправить массовое SMS",
            message_group: "Сообщение",
            createNewTemplate: "Создать новый шаблон сообщения",
            templateName: "Имя шаблона",
            templateNameDesc: "Дайте имя вашему шаблону сообщения.",
            viewTemplates: "Просмотреть шаблоны",
            templateNameRules: "Имя шаблона может включать только строчные буквы, цифры и подчеркивания.",
            category: "Категория",
            categoryDesc: "Выберите, какой тип шаблона вы хотите создать",
            categoryUtility: "Утилита",
            categoryUtilityDesc:
                "Отправляйте информацию об утилите, такую как обновления аккаунта, обновления заказа, оповещения и многое другое.",
            categoryMarketing: "Маркетинг",
            categoryMarketingDesc:
                "Отправляйте рекламные предложения, предложения по продукции и многое другое для увеличения осведомленности и вовлеченности.",
            categoryAuth: "Аутентификация",
            categoryAuthDesc: "Отправляйте коды для того, чтобы ваши клиенты могли получить доступ к своим аккаунтам.",
            optional: "По желанию",
            languageDesc: "Выберите язык, на котором будет отправлен ваш шаблонный текст",
            header: "Заголовок",
            headerRules:
                "Добавьте заголовок к вашему сообщению длиной 60 символов. В заголовке поддерживается только одна переменная.",
            headerOptionMedia: "Медиа",
            headerOptionText: "Текст",
            none: "Нет",
            headerType: "Тип заголовка",
            headerText: "Текст заголовка",
            body: "Тело",
            bodyRules: "Введите текст на выбранном вами языке для вашего сообщения",
            addVariable: "Добавить переменную",
            variables: "Переменные",
            variable: "Переменная",
            defaultVariableName: "Имя переменной по умолчанию",
            defaultVariableToolTip:
                "Ваша переменная появляется в шаблоне под этим именем. <br><br> Кроме того, это значение отправляется по умолчанию в случае других ситуаций.",
            selectATemplate: "Выберите шаблон сообщения",
            variableSettings: "Настройки переменных",
            example: "Пример",
            footer: "Нижний колонтитул",
            footerDesc:
                "Добавьте к вашему сообщению нижний колонтитул длиной 60 символов. В подвале не поддерживаются переменные.",
            buttons: "Кнопки",
            buttonType: "Тип кнопки",
            buttonTypeReply: "Ответить",
            submit: "Сохранить",
            submitting: "Подача заявки",
            addButton: "Добавить кнопку",
            rejectWhatsapp: "Отклонено WhatsApp.",
            approvedWhatsapp: "Одобрено WhatsApp.",
            pendingWhatsapp: "В ожидании одобрения",
        },
    },
    de: {
        chatWindow: {
            thereIsNoChatContent: "Kein Chat-Inhalt verfügbar.",
            thereIsNoChatContentDsc: "Hier können Sie den Chat-Inhalt anzeigen und Nachrichten senden.",
            interactions: "Interaktionen:",
            departments: "Abteilungen",
            channels: "Kanäle",
            date: "Datum",
            lastChatStatus: "Letzter Chat-Status",
            all: "Alle",
            queued: "Warteschlange",
            open: "Offen",
            closed: "Geschlossen",
            private: "Privat",
            chatbot: "Chatbot",
            lostMissed: "Verloren / Verpasst",
            interaction: "Interaktion",
            myActiveInbox: "Mein aktiver Posteingang",
            activeQueueInbox: "Aktiv + Warteschlange Posteingang",
            chatbotActiveInbox: "Chatbot aktiver Posteingang",
            myDepartmentsActiveInbox: "Aktiver Posteingang meiner Abteilungen",
            notInteractedYesterday: "Gestern keine Interaktionen",
            queueInbox: "Warteschlange Posteingang",
            whatsappActiveInbox: "WhatsApp aktiver Posteingang",
            socialMediaActiveInbox: "Social Media aktiver Posteingang",
            missedThisMonth: "Diesen Monat verpasste Chats",
            chooseAFileOrDragItHere: "Wählen Sie eine Datei oder ziehen Sie sie hierher!",
            watching: "Beobachten",
            selectFilter: "Filter auswählen",
            clearAll: "Alles löschen",
            me: "Ich",
            today: "Heute",
            yesterday: "Gestern",
            thisWeek: "Diese Woche",
            lastWeek: "Letzte Woche",
            last7Days: "Letzte 7 Tage",
            last30Days: "Letzte 30 Tage",
            thisMonth: "Diesen Monat",
            lastMonth: "Letzten Monat",
            last24h: "Letzte 24 Stunden",
            custom: "Benutzerdefiniert",
            startMessage: "Nachricht starten",
            goToAgentReport: "Zum Agentenbericht gehen",
            agentDetail: "Agenten-Detail",
            agentList: "Agentenliste",
            selectedFilter: "Ausgewählter Filter",
            groupBy: "Gruppieren",
            none: "Keine Gruppe",
            agent: "Vertreter",
            department: "Abteilung",
            sortBy: "Sortieren",
            lastPostAbove: "Letzter Beitrag oben",
            newChatsAbove: "Neue Chats oben",
            oldChatsAbove: "Alte Chats oben",
            live: "Live",
            systemStatus: "Systemstatus",
            refresh: "Aktualisieren",
            close: "Schließen",
            totalCustomers: "Gesamtkunden",
            totalAnswered: "Insgesamt beantwortet",
            waitingAnswer: "Wartet auf Antwort",
            totalAgentInChat: "Gesamtzahl der Agenten im Chat",
            onlineAgentCount: "Anzahl der Online-Agenten",
            totalCustomer: "Gesamtkunde",
            answered: "Beantwortet",
            unanswered: "Unbeantwortet",
            noContactWasFoundMatchingTheCurrentFilters:
                "Es wurde kein Kontakt gefunden, der den aktuellen Filtern entspricht.",
            you: "Du",
            others: "Andere",
            queue: "Warteschlange",
            chatbotContact: "Chatbot",
            closedContact: "Geschlossen",
            myInteractions: "Meine Interaktionen",
            special: "Spezial",
            allInteractions: "Alle Kontakte",
            waiting: "Ausstehend",
            departmentToWhichItIsAffiliated: "Abteilung, der es zugeordnet ist",
        },
        plans: {
            manageWithChatbot: "Manage with Chatbot",
            manageInbox: "Manage Inbox",
            commentManagement: "Manage Comments",
            privateReplyMessage: "Private Reply Comments",
            mentionTicket: "Convert Mentions to Tickets",
            week: "Woche",
            readyContents: "Fertige Inhalte",
            webhookIntegration: "Webhook-Integration",
            businessChannel: "WhatsApp Business Kanal",
            confirmationFeature: "Bestätigungsfunktion",
            specialReporting: "Spezielle Berichterstattung",
            aiAssistant: "KI-Assistent",
            flexibleBilling: "Flexible Abrechnung",
            automaticReservation: "Automatische Reservierung",
            taskManagement: "Aufgabenverwaltung",
            calendarIntegration: "Kalenderintegration",
            activeChatbot: "Aktiver Chatbot",
            smsIntegration: "SMS-Integration",
            mailIntegration: "E-Mail-Integration",
            startChatWithVisitor: "Chat mit Besucher starten",
            whatsappManaging: "Whatsapp-Verwaltung",
            automaticChatbotButton: "Automatischer Button/Chatbot",
            personalizedBroadcasts: "Personalisierte Rundsendungen",
            chatWithNonContacts: "Chat mit Nicht-Kontakten",
            broadcastMessaging: "Broadcast-Nachrichten",
            perBroadcast: "Pro Sendung",
            extraPricePerMessage: "Zusätzlicher Preis pro Nachricht",
            smartTrigger: "Intelligenter Auslöser",
            telegramIntegration: "Telegram Integration",
            instagramIntegration: "Instagram Integration",
            ticketFeature: "Ticket-Funktion",
            storage: "Speicher",
            onePanelManagement: "Einzelne Panelverwaltung",
            isolatedDatabaseConnection: "Isolierte Datenbankverbindung",
            removeLogo: "Supis-Logo entfernen",
            chatBaloonCustomization: "Chat-Ballon-Anpassung",
            chatAndNotifications: "Chat und Benachrichtigungen",
            unlimited: "Unbegrenzt",
            specialCustomerSupport: "Spezieller Kundensupport",
            softwareSupport: "Software-Support",
            standardSupport: "Standard-Support",
            teamChatIntegration: "Team-Chat-Integration",
            fileAndVoiceShare: "Datei- und Sprachfreigabe",
            instantVisitor: "Instant-Besuchertracking",
            detailedReporting: "Detaillierte Berichterstattung",
            normalreporting: "Normale Berichterstattung",
            noExtraCosts: "Keine zusätzlichen Kosten",
            accessibleToAllAgents: "Zugänglich für alle Agenten",
            dataSecurity: "Datensicherheit",
            autoTranslate: "Automatische Übersetzung",
            chatbotVersionHistory: "Chatbot-Versionenverlauf",
            chatbotStory: "Chatbot-Geschichte",
            freeAgent: "Kostenloser Agent",
            stableAgentCount: "Stabile Agentenanzahl",
            stableChannelCount: "Stable Channel Count",
            chipPlans: "Günstige Pläne",
            generalPlan: "Allgemeiner Plan",
            specialPlan: "Spezieller Plan",
            currentPlan: "Aktueller Plan",
            selected: "Ausgewählt",
            popular: "Beliebt",
            trialPkg: "Testpaket",
            support: "24/7 Support",
            flexiblePricing: "Flexible Preisgestaltung",
            rightToCancel: "Recht auf jederzeitige Kündigung",
            unlimitedCBScenario: "Unbegrenzte Chatbot-Szenarien",
            freeFirstScenario: "Kostenloses erstes Szenario",
            unlimitedLearn: "Unbegrenztes Chatbot-Training",
            allPlatformIntegration: "Integration mit allen Plattformen",
            detailedReports: "Detaillierte Berichte",
            aiSupport: "KI-Unterstützung",
            creativeAI: "Schneller und realistischer KI-Chat-Assistent",
            unlimitedSession: "Unbegrenzte Sitzungen gleichzeitig",
            assistantFromWebsite: "Erstellen eines Assistenten von der Website",
            assistantFromDoc: "Erstellen eines Chatbots aus dem Dokument",
            mobileApp: "Mobile App",
        },
        messenger: {
            channel: "Messenger-Kanal",
            manageChannel: "Kanal verwalten",
            channelDetail: "Kanaldetail",
            integrationTitle: "Messenger Integration",
            deleteDesc: "Möchten Sie den Messenger-Kanal wirklich löschen?",
            channels: "Messenger-Kanäle",
            connectMessenger: "Mit Messenger verbinden",
            detail: "Detail",
            visibility: "Sichtbarkeit",
            settings_group: "Einstellungen",
            commentsettings: "Kommentarverwaltung",
            commentSettingsTitle: "Messenger-Kommentarverwaltung",
            commentSettingsDesc: "Verwalten Sie Ihre Messenger-Kommentare",
        },
        instagram: {
            channel: "Instagram-Kanal",
            detail: "Detail",
            visibility: "Sichtbarkeit",
            settings_group: "Einstellungen",
            commentsettings: "Kommentarverwaltung",
            commentSettingsTitle: "Instagram-Kommentarverwaltung",
            commentSettingsDesc: "Verwalten Sie Ihre Instagram-Kommentare",
            commentSettingsTicket: "Stellt sicher, dass eingehende Kommentare im System als Tickets erfasst werden.",
            commentSettingsChatbot:
                "Wählen Sie, zu welchem Chatbot-Szenario eingehende Kommentare weitergeleitet werden sollen.",
            leads: "Leads",
            forms: "Forms",
        },
        calendar: {
            setting: "Einstellungen",
            delete: "Löschen",
            cancel: "Abbrechen",
            save: "Speichern",
            close: "Schließen",
            deleteRepeatEvent: "Wiederholendes Ereignis löschen",
            thisEvent: "Dieses Ereignis",
            thisAndOtherEvent: "Dieses und folgende Ereignisse",
            allEvent: "Alle Ereignisse",
            ok: "OK",
            googleCalendarLink: "Zum Google Kalender hinzufügen",
            yahooCalendarLink: "Zum Yahoo Kalender hinzufügen",
            subject: "Betreff",
            visitor: "Besucher",
            allDay: "Ganztägig",
            title: "Titel",
            deleteEvent: "Ereignis löschen",
            deleteEvents: "Ereignisse löschen",
            deleteEventsSure: "Sind Sie sicher, dass Sie die Ereignisse in diesem Kalender löschen möchten?",
            deleteEventConfirm: "Sind Sie sicher, dass Sie dieses Ereignis löschen möchten?",
            notEmptyTitle: "Der Titel darf nicht leer sein!",
            tasks: "Aufgaben",
            googleConnect: "Google-Integration",
            googleDisconnect: "Google-Integration trennen",
            sure: "Sind Sie sicher?",
            disconnectGoogleSure: "Sind Sie sicher, dass Sie die Google-Verbindung trennen möchten?",
            yes: "Ja",
            no: "Nein",
            customRepeat: "Benutzerdefinierte Wiederholung",
            recurrenceFrequency: "Wiederholungsfrequenz",
            repeatDays: "An diesen Tagen wiederholen:",
            never: "Niemals",
            thisDate: "An diesem Datum:",
            recurrenceCount: "Anzahl der Wiederholungen:",
            end: "Ende",
            event: "Ereignis",
            calendars: "Kalender",
            newCalendar: "Neuen Kalender erstellen",
            changeColor: "Farbe ändern",
            addCalendar: "Kalender hinzufügen",
            nameCalendar: "Kalendername",
            description: "Beschreibung",
            change: "Ändern",
            deleteCalendar: "Kalender löschen",
            deleteCalendarSure: "Sind Sie sicher, dass Sie diesen Kalender löschen möchten?",
            notEmptyCalendarName: "Der Kalendername darf nicht leer sein",
            myEvents: "Meine Ereignisse",
            everyoneEvents: "Alle Ereignisse",
            haveEvent: "Ereignisse des Vertreters",
            goCalendar: "Zum Kalender gehen",
            goReservation: "Reservierung erstellen",
            agents: "Vertreter",
            today: "Heute",
            month: "Monat",
            week: "Woche",
            day: "Tag",
            list: "Liste",
        },
        ticimax: {
            segment: "Segment",
            settings_group: "Einstellungen",
            waitDayFromLastSend: "Wartezeit in Tagen seit der letzten gesendeten Nachricht",
            automationRuleName: "Name der Automatisierungsregel",
            time: "Zeit",
            year: "Jahr",
            month: "Monat",
            dayOfMonth: "Tag des Monats",
            day: "Tag",
            bySecond: "Pro Sekunde",
            byMinute: "Pro Minute",
            byHour: "Pro Stunde",
            byWeekNo: "Nach Wochennummer",
            byYearDay: "Nach Tag im Jahr",
            byMonthDay: "Nach Tag im Monat",
            byMonth: "Nach Monat",
            december: "Dezember",
            november: "November",
            october: "Oktober",
            september: "September",
            august: "August",
            july: "Juli",
            june: "Juni",
            may: "Mai",
            april: "April",
            march: "März",
            february: "Februar",
            january: "Januar",
            byWeekDay: "Nach Wochentag",
            interval: "Intervall",
            seconds: "Sekunden",
            minutes: "Minuten",
            hourly: "Stündlich",
            daily: "Täglich",
            weekly: "Wöchentlich",
            monthly: "Monatlich",
            yearly: "Jährlich",
            frequency: "Frequenz",
            attributes: {
                vip: "VIP",
                segment: "Segment",
                province: "Provinz",
                country: "Land",
                phone: "Telefon",
                email: "E-Mail",
                fullname: "Vollständiger Name",
                couponPercent: "% Rabatt",
                lastOrderDate: "Letzte Bestellung",
                firstOrderDate: "Erste Bestellung",
                county: "Landkreis",
                lastSource: "Letzte Quelle",
                firstSource: "Erste Quelle",
                lastPaymentType: "Letzte Zahlungsmethode",
                firstPaymentType: "Erste Zahlungsmethode",
                maxOrderAmount: "Maximaler Bestellbetrag",
                minOrderAmount: "Minimaler Bestellbetrag",
                totalOrderAmount: "Gesamtbestellmenge",
                totalOrderCount: "Gesamtanzahl der Bestellungen",
                usedCouponAmount: "Verwendeter Gutscheinbetrag",
                usedCouponCount: "Anzahl der verwendeten Gutscheine",
                tookDayFromLastOrder: "Tage seit der letzten Bestellung",
                isCouponUser: "Ist Gutscheinbenutzer",
            },
            createAutomation: "Automatisierung erstellen",
            previous: "Zurück",
            createAutomationDesc: "Erstellen und verwalten Sie die Automatisierung von Nachrichten",
            newTicimaxChannel: "Neuer Ticimax-Kanal",
            connextToTicimaxXml: "Mit Ticimax XML-Dienst verbinden",
            connectTicimax: "Mit Ticimax verbinden",
            examplePreview: "Beispielvorschau",
            completeAutomationRule: "Automatisierungsregel abschließen",
            configureMessage: "Nachricht konfigurieren",
            automationTimer: "Automatisierungs-Timer",
            findTargetMembers: "Zielmitglieder finden",
            createAutomationRule: "Automatisierungsregel erstellen",
            action: "Aktion",
            status: "Status",
            triggeredUserCount: "Ausgelöste Benutzeranzahl",
            nextScheduled: "Nächste geplante",
            timerRule: "Timer-Regel",
            automationRules: "Automatisierungsregeln",
            apply: "Anwenden",
            searchAMember: "Mitglied suchen",
            segmentedMembersDesc: "Listen und automatisieren Sie segmentierte Mitglieder",
            manageVisibilityDesc: "Verwalten Sie die Sichtbarkeit des Kanals",
            xmlOrderListURL: "URL der XML-Bestellliste",
            manageIntegrationDesc: "Verwalten Sie Ihre Ticimax-Integration",
            detail: "Detail",
            ticimaxChannelsTitle: "Ticimax-Kanäle",
            ticimaxDetail: "Ticimax-Detail",
            settingsGroup: "Einstellungen",
            visibility: "Sichtbarkeit",
            members: "Mitglieder",
            automation: "Automatisierung",
            integrationChannel: "Integrationskanal",
            channelUpdated: "Kanal erfolgreich aktualisiert",
            channelUpdateFailed: "Aktualisierung des Kanals fehlgeschlagen",
        },
        notification: {
            mobileApp: "Mobile App",
            webPanel: "Web-Panel",
            notifications: "Benachrichtigungen",
            whatsappActions: "Whatsapp-Aktionen",
            chatbotActions: "Chatbot-Aktionen",
            companyActions: "Unternehmensaktionen",
            crmActions: "SUPSIS CRM-AKTIONEN",
            basicActions: "Grundlegende Aktionen",
            notificationSettingsDesc:
                "Wählen Sie aus, welche Benachrichtigungen Sie erhalten möchten und wo Sie sie erhalten möchten.",
            noNotificationDesc2:
                "Hier sehen Sie alle Benachrichtigungen zu den Stellenangeboten, Bewerbern und Talentpools, die Sie verfolgen. Sie können Benachrichtigungen anpassen, indem Sie die Einstellungen anpassen.",
            noNotificationTitle2: "Noch keine Benachrichtigungen.",
            noNotificationTitle1: "Keine Benachrichtigungen. Genießen Sie die Stille.",
            adjustSettings: "Einstellungen anpassen",
            showAll: "Alle anzeigen",
            showOnlyUnread: "Nur Ungelesene anzeigen",
            mailWasSent: "E-Mail wurde gesendet.",
            mailAdressRemoved: "E-Mail-Adresse entfernt.",
            chatbotPublished: "Version <b>{version}</b> des Chatbots wurde von <b>{user}</b> veröffentlicht.",
            chatbotDeleted: "Der Chatbot <b>{chatbot}</b> wurde von <b>{user}</b> gelöscht.",
            settingsUpdatedWoDetail: "Die Einstellungen wurden von <b>{user}</b> aktualisiert.",
            noActivityDesc: "Derzeit gibt es keine Aktivität im System. Ein paar Ereignisse müssen eintreten",
            noActivityTitle: "Bisher keine Aktivität",
            actionType: "Aktionsart",
            dateBetween: "Datum zwischen",
            selectActor: "Benutzer auswählen",
            activities: "Aktivitäten",
            chatbotCreated: "Der Chatbot mit dem Namen <b>{chatbot}</b> wurde von <b>{user}</b> erstellt.",
            taskStageChanged:
                "Die Stufe der Aufgabe <b>{task}</b> wurde von <b>{user}</b> von <b>{oldStage}</b> auf <b>{newStage}</b> geändert.",
            taskCreated: "Die Aufgabe <b>{task}</b> wurde von <b>{user}</b> erstellt.",
            contactPropRemoved: "Das Besucherattribut <b>{prop}</b> wurde von <b>{user}</b> entfernt.",
            contactPropAdded: "Das Besucherattribut <b>{prop}</b> wurde von <b>{user}</b> hinzugefügt.",
            userRemoved: "<b>{oldUser}</b> Benutzer wurde von <b>{user}</b> entfernt.",
            loginFormUpdated: "Das Anmeldeformular für Besucher wurde von <b>{user}</b> aktualisiert.",
            loginFormDeactivated: "Le formulaire de connexion de l'utilisateur a été désactivé par <b>{user}</b>.",
            loginFormActivated: "Das Benutzeranmeldeformular wurde von <b>{user}</b> aktiviert.",
            invoiceRefunded: "Die Rückerstattung wurde von <b>{user}</b> vorgenommen.",
            paymentMethodAdded: "Eine neue Zahlungsmethode wurde von <b>{user}</b> hinzugefügt.",
            invoicePaymentFailed: "Die Rechnungszahlung wurde von <b>{user}</b> nicht akzeptiert.",
            invoicePaymentReceived: "Die Rechnungszahlung wurde von <b>{user}</b> akzeptiert.",
            planStarted: "<b>{user}</b> Пользователь начал подписку на <b>{title}</b> (<b>{altTitle}</b>).",
            planStartedAgent:
                "<b>{user}</b> Пользователь начал подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{details} Представитель</b>).",
            planStartedChatbot:
                "<b>{user}</b> Пользователь начал подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Сессия</b>).",
            planStartedWhatsapp:
                "<b>{user}</b> Пользователь начал подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Whatsapp Каналы</b>).",
            planStartedWhatsappApi:
                "<b>{user}</b> Пользователь начал подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Whatsapp Бизнес Каналы</b>).",
            PlanCanceled: "<b>{user}</b> Пользователь отменил подписку на <b>{title}</b> (<b>{altTitle}</b>).",
            planCanceledAgent:
                "<b>{user}</b> Пользователь отменил подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{details} Представитель</b>).",
            planCanceledChatbot:
                "<b>{user}</b> Пользователь отменил подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Сессия</b>).",
            planCanceledWhatsapp:
                "<b>{user}</b> Пользователь отменил подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Whatsapp Каналы</b>).",
            planCanceledWhatsappApi:
                "<b>{user}</b> Пользователь отменил подписку на <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Whatsapp Бизнес Каналы</b>).",
            invoiceCreated: "Rechnung wurde von <b>{user}</b> erstellt.",
            billingAddressUpdated: "Adressinformationen wurden von <b>{user}</b> aktualisiert.",
            taskWorkflowDeleted: "Workflow <b>{workflow}</b> wurde von <b>{user}</b> gelöscht.",
            whatsappBroadcastFailed: "Der Versand der Rundnachricht mit dem Titel <b>{title}</b> ist fehlgeschlagen.",
            whatsappBroadcastCancelled: "Der Versand der Rundnachricht mit dem Titel <b>{title}</b> wurde abgebrochen.",
            whatsappBroadcastCompleted:
                "Eine Rundnachricht mit dem Titel <b>{title}</b> wurde erfolgreich an <b>{numbers}</b> Empfänger gesendet.",
            whatsappBroadcastCreated:
                "Eine Rundnachricht mit dem Titel <b>{title}</b> wurde an <b>{numbers}</b> Empfänger von <b>{user}</b> gesendet.",
            ticketAssigned: "Ein Ticket wurde <b>{user1}</b> an <b>{user2}</b> zugewiesen.",
            userLoggedIn: "<b>{user}</b> hat sich bei SUPSIS angemeldet.",
            chatJoined: "<b>{agent}</b> ist dem Chat mit <b>{visitor}</b> beigetreten.",
            chatForwarded: "Der Chat mit <b>{visitor}</b> wurde von <b>{user}</b> an <b>{agent}</b> weitergeleitet.",
            chatAssigned: "Der Chat mit <b>{visitor}</b> wurde von dem System <b>{agent}</b> zugewiesen.",
            customerGroupUpdated: "Gruppe <b>{group}</b> wurde von <b>{user}</b> aktualisiert.",
            customerGroupRemoved: "Gruppe <b>{group}</b> wurde von <b>{user}</b> entfernt.",
            customerGroupAdded: "Gruppe <b>{group}</b> wurde von <b>{user}</b> erstellt.",
            contentRemoved: "Fertiger Inhalt <b>{content}</b> wurde von <b>{user}</b> entfernt.",
            contentAdded: "Fertiger Inhalt <b>{content}</b> wurde von <b>{user}</b> hinzugefügt.",
            channelVisibilityChanged:
                "Die Sichtbarkeit des Integrationskanals <b>{channel}</b> wurde von <b>{user}</b> geändert.",
            taskDeleted: "Die Aufgabe <b>{task}</b> wurde von <b>{user}</b> gelöscht.",
            userRemovedToDepartment:
                "<b>{user2}</b> Benutzer wurde von <b>{user1}</b> aus der <b>{department}</b> Abteilung entfernt.",
            userAddedToDepartment:
                "<b>{user2}</b> Benutzer wurde von <b>{user1}</b> zur <b>{department}</b> Abteilung hinzugefügt.",
            mailAddressAdded: "<b>{email}</b> E-Mail-Adresse hinzugefügt von <b>{user}</b>",
            settingUpdate: "Aktualisiert von <b>{user}</b>:",
            taskWFlowCreated: "<b>{Wflow}</b> Aufgabenworkflow erstellt von <b>{user}</b>.",
            bannedWordRemoved: "<b>{bWord}</b> verbotenes Wort wurde von <b>{user}</b> entfernt.",
            bannedWordCreated: "<b>{bWord}</b> verbotenes Wort wurde von <b>{user}</b> erstellt.",
            welcomeMessageRemoved: "<b>{welcome}</b> Willkommensnachricht wurde von <b>{user}</b> entfernt.",
            welcomeMessageAdded: "<b>{welcome}</b> Willkommensnachricht erstellt von <b>{user}</b>.",
            tagRemoved: "Tag <b>{tag}</b> entfernt von <b>{user}</b>.",
            tagAdded: "Tag <b>{tag}</b> hinzugefügt von <b>{user}</b>.",
            roleRemoved: "Rolle <b>{role}</b> entfernt von <b>{user}</b>.",
            roleAdded: "Rolle <b>{role}</b> hinzugefügt von <b>{user}</b>.",
            departmentRemoved: "Abteilung <b>{department}</b> entfernt von <b>{user}</b>.",
            departmentAdded: "Abteilung <b>{department}</b> hinzugefügt von <b>{user}</b>.",
            triggerUpdated: "Ein Trigger aktualisiert von <b>{user}</b>.",
            triggerRemoved: "Ein Trigger entfernt von <b>{user}</b>.",
            triggerAdded: "Ein neuer Trigger erstellt von <b>{user}</b>.",
            webhookRemoved: "Webhook von <b>{user1}</b>, entfernt von <b>{user2}</b>",
            webhookAdded: "Webhook hinzugefügt von <b>{user1}</b>, hinzugefügt von <b>{user2}</b>.",
            chatClosed: "Der Chat mit <b>{visitor}</b> wurde von <b>{agent}</b> beendet.",
            chatOpenedByAgent: "<b>{agent}</b> hat einen <b>{platform}</b>-Chat mit <b>{visitor}</b> gestartet.",
            chatOpenedByVisitor: "Ein <b>{platform}</b>-Chat wurde von <b>{visitor}</b> gestartet.",
            channelRemoved: "<b>{channel}</b>-Kanal wurde von <b>{agent}</b> entfernt.",
            userAdded: "<b>{agent}</b> hat einen Vertreter namens <b>{newAgent}</b> erstellt.",
            visitorUnblocked: "Besucher <b>{visitor}</b> wurde von Benutzer <b>{agent}</b> entsperrt.",
            visitorBlocked: "Besucher <b>{visitor}</b> wurde von <b>{agent}</b> blockiert.",
            userStatusChanged:
                "Benutzer <b>{name}</b> hat den Status von <b>{oldStatus}</b> auf <b>{newStatus}</b> geändert.",
            channelCreated: "Kanal <b>{channel}</b> wurde von <b>{name}</b> erstellt.",
            reservationCreatedPlan:
                "<b>{name}</b> Benutzer hat den Termin mit dem Namen <b>{title}</b> für den <b>{date}</b> geplant.",
            reservationUpdatedPlan: "<b>{name}</b> Benutzer hat den Termin mit dem Namen <b>{title}</b> aktualisiert.",
            reservationDeletedPlan: "<b>{name}</b> Benutzer hat den Termin mit dem Namen <b>{title}</b> gelöscht.",
            reservationCreated:
                "Eine Reservierung wurde für Benutzer <b>{name}</b> und Besucher <b>{visitor}</b> am <b>{date}</b> erstellt.",
            reservationDeleted:
                "Der Termin zwischen Benutzer <b>{name}</b> und Besucher <b>{visitor}</b> am <b>{date}</b> wurde storniert.",
            chatAssignedMe: "Wenn ein Chat mir zugewiesen wird",
            ticketAssignedMe: "Wenn mir ein Ticket zugewiesen wird",
            taskAssignedMe: "Wenn mir eine Aufgabe zugewiesen wird",
            myChatClosed: "Wenn der Chat, den ich besitze, geschlossen wird",
            tagActionsToVisitor: "Tags wurden einem Kontakt hinzugefügt oder entfernt",
            ticketCreated:
                "Ticket wurde vom Besucher oder Chatbot erstellt. Auch, wenn eine Offline-Nachricht vom Chat-Widget gesendet wird",
            notesActions: "Eine Notiz wurde einem Kunden hinzugefügt oder entfernt.",
            visitorProfileUpdated: "Besucherprofil aktualisiert",
            chatStartedByAnyPlatform: "Chat wird auf jeder Plattform von Kontakt oder Agent gestartet",
            userActions: "Benutzer wird erstellt, aktualisiert oder gelöscht",
            departmentActions: "Abteilung wird erstellt, aktualisiert oder gelöscht",
            settingsActions: "Einstellungen werden erstellt, aktualisiert oder gelöscht",
            integrationsActions: "Integrationskanal wird erstellt, aktualisiert oder gelöscht",
            loginFormActions: "Anmeldeformular wird aktualisiert, aktiviert oder deaktiviert",
            bannedWordActions: "Verbotenes Wort wird erstellt, aktualisiert oder gelöscht",
            emailActions: "E-Mail-Konto wird erstellt oder gelöscht",
            preparedContentActions: "Vorbereiteter Inhalt wird erstellt oder gelöscht",
            roleActions: "Rolle wird erstellt, aktualisiert oder gelöscht",
            tagActions: "Tag wird erstellt, aktualisiert oder gelöscht",
            welcomeMessageActions: "Willkommensnachricht wird erstellt, aktualisiert oder gelöscht",
            webhookActions: "Webhook wird erstellt, aktualisiert oder gelöscht",
            billingEvents: "Abrechnungsereignisse",
            taskWorkflowCrud: "Aufgabenworkflow wird erstellt, aktualisiert oder gelöscht",
            taskCrud: "Aufgabe wird erstellt, aktualisiert oder gelöscht",
            systemStatus: "Systemstatusänderungen online oder offline",
            chatbotStoryCrud: "Chatbot-Geschichte wird erstellt, aktualisiert oder gelöscht",
            chatbotForwardAgent: "Chatbot leitet einen Chat an einen Agenten weiter",
            userSegmentCrud: "Benutzersegment wird erstellt, aktualisiert oder gelöscht",
            chatbotCreditLow: "Wenn das Guthaben des Chatbots niedrig ist",
            wpCreditLow: "Wenn das Whatsapp-Guthaben niedrig ist",
            wpCustomerGroupCrud: "Wenn eine Whatsapp-Kundengruppe erstellt, aktualisiert oder gelöscht wird",
            wpBroadcastMessageStatus:
                "Wenn eine Whatsapp-Rundsendungsnachricht gesendet, abgeschlossen oder abgebrochen wird",
            wpTemplateMesssageCrud: "Wenn eine Whatsapp-Template-Nachricht erstellt, aktualisiert oder gelöscht wird",
            reservationMessageCrud: "Reservierung erstellt, aktualisiert, storniert",
        },
        mail: {
            deleteMailDesc: "Dieser Vorgang kann nicht rückgängig gemacht werden.",
            deleteMailTitle: "Möchten Sie diese E-Mail-Adresse wirklich löschen?",
            gmailForwardMail: "Gmail E-Mail-Weiterleitung",
            senderMailAddressDesc: "Bitte geben Sie die E-Mail-Adresse des Absenders ein",
            verified: "Verifiziert",
            notForwarded: "Nicht weitergeleitet",
            notVerified: "Nicht verifiziert",
            default: "Standard",
            isVerified: "Verifiziert",
            forwarding: "Weiterleitung",
            mailAdress: "E-Mail-Adresse",
            addSenderAddress: "Absenderadresse hinzufügen",
            outlookForward: "Microsoft (Outlook/Exchange) Weiterleitung",
            gmailForward: "Google (Gmail) Weiterleitung",
            senderMail: "Absendermail",
            mailDetail: "E-Mail-Detail",
            mailNotFound: "E-Mail nicht gefunden",
            mailSelecting: "E-Mail-Auswahl",
            newMail: "Neue E-Mail",
            myMails: "Meine E-Mails",
            inbox: "Posteingang",
            sent: "Gesendet",
            departmentMails: "Abteilungsemails",
            newTemplate: "Neue Vorlage",
            unread: "Ungelesen",
            unreply: "Unanswered",
            reply: "Antworten",
            attachments: "E-Mail-Anhänge",
            To: "An",
            From: "Von",
            placeHolders: "Platzhalter",
            attacheFiles: "Dateien anhängen",
            replyAll: "Allen antworten",
            forward: "Weiterleiten",
            deleteThread: "Thread löschen",
            markAsRead: "Als gelesen markieren",
            markAsAllRead: "Alle als gelesen markieren",
            emailEditor: "E-Mail-Editor",
            integrateYourMail: "Integrieren Sie Ihre E-Mail",
            connect: "Verbinden",
            departmentMail: "Abteilungs-E-Mail",
            createMailAddress: "E-Mail-Adresse erstellen",
            createNewMail: "Neue E-Mail erstellen",
        },
        visitor: {
            mail: "Mail",
            visitorDetail: "Besucherdetails",
            selectedUser: "{selectedUser} von {totalUsers} Benutzern ausgewählt",
            uncheck: "Alle abwählen",
            checkAll: "Alle auswählen",
            matchedUsers: "{checkedCount} Benutzer übereinstimmend",
            more: "Mehr",
            exportUsers: "Ausgewählte Benutzer exportieren",
            exportAllUsers: "Alle Benutzer exportieren",
            addSegment: "Segment hinzufügen",
            deleteCheckedUser: "Ausgewählte Benutzer löschen",
            deleteAllUser: "Alle Benutzer löschen",
            matchedFilter: "Alle Filter übereinstimmend",
            visitor: "Besucher",
            deleteUser: "Benutzer löschen",
            userData: "Benutzerdaten",
            lastSession: "Letzte Sitzung",
            notUserData: "Keine Benutzerdaten gefunden",
            segments: "Segmenten",
            tags: "Tags",
            addTag: "Tag hinzufügen",
            userChats: "Benutzer-Chats",
            seeAll: "Alle anzeigen",
            confirm: "Bestätigen",
            manageSegments: "Segment verwalten",
            search: "Suchen",
            manageTags: "Tags verwalten",
            allAttributes: "Alle Attribute anzeigen",
            noData: "Keine Daten",
            noEmail: "Keine E-Mail",
            noIpAddress: "IP-Adresse nicht gefunden.",
            noWpNumber: "Nummer nicht gefunden.",
            filterName: "Filtername..",
            matchedContacts: "{chechkedCount} Kontakte abgeglichen",
        },
        chatbotv2: {
            selectedStory: "{count} Geschichte ausgewählt",
            Instagram_Actions: "Instagram Actions",
            suppressionRemoved: "Unterdrückung entfernt",
            suppressionAdded: "Unterdrückung hinzugefügt",
            didntSuppression: "Sie haben keine Unterdrückung vorgenommen.",
            whatsappIntegrationTitle: "WhatsApp V1 und WhatsApp V2 Integration",
            whatsappApiIntegrationTitle: "WhatsApp Business API Integration",
            ReadyTemplateBadge: "Fertige Vorlage",
            readyTemplates: "Fertige Vorlagen",
            regex: "Regex",
            regexDescription: "Regex ile herşeyi yakala",
            chatbotLogo: "ChatBot-Logo",
            chatbotName: "ChatBot-Name",
            allSecnario: "Liste der Chatbot-Szenarien",
            ChatbotScenarioList: "Liste der Chatbot-Szenarien",
            Scenario: "Szenario",
            filters: {
                equal: "gleich",
                not_equal: "nicht gleich",
                contain: "enthält",
                not_contain: "beteiligt",
                starts_with: "Beginnt mit",
                ends_with: "endet mit",
                empty: "Wenn es leer ist",
                non_empty: "Wenn nicht leer",
                longer_than: "Wenn länger",
                shorter_than: "Wenn kürzer",
                less_than: "Wenn klein",
                less_or_equal: "Wenn klein oder gleich",
                greater_than: "Wenn groß",
                greater_or_equal: "Wenn groß oder gleich",
            },
            planRequired: "{integratable} Plan ist erforderlich.",
            noDefaultStoryTitle: "Standardgeschichte",
            noDefaultStory: "Sie haben nicht die Standardgeschichte.",
            noMessage: "Keine Nachricht",
            loading: "Wird geladen",
            loadMore: "Mehr",
            hostname: "Hostname",
            allTemplates: "Alle Vorlagen",
            allAITemplates: "Alle KI-Vorlagen",
            templatesFromTheIndustry: "Vorlagen aus der Industrie",
            basicTemplate: "Grundlegende Vorlage",
            proTemplate: "Erweiterte Vorlage",
            goToStory: "in die Geschichte gehen",
            noResultFound: "Es wurden keine Ergebnisse gefunden",
            checkYourFilterCombination: "Überprüfen Sie die Filterkombination",
            clearYourSearch: "Reinigen Sie die Suche",
            andTryAgain: "und versuche es erneut",
            withBot: "& Stiefel",
            userWithBot: "Benutzer & Bot",
            chatDetail: "Chat -Details",
            allUserDetail: "Siehe alle Benutzerdetails",
            sessionData: "Sitzungsdaten",
            supsisChatWidget: "SUPSIS -Chat -Tool",
            integratedWith: "Integriert in Folgendes:",
            integration: "Integration",
            Users: "Benutzer",
            user_id: "Benutzer-ID",
            botStory: "Bootsgeschichte",
            categories: "Kategorien",
            worksWith: "Arbeitet mit",
            importBot: "Verwenden Sie Bot",
            keyFeatures: "HAUPTEIGENSCHAFTEN",
            importing: "hinzugefügt",
            comingSoon: "Bald zu Ihrem Service",
            pickStory: "Wählen Sie Geschichte",
            conversationId: "Sprachausweise",
            integrateStoryWithSupsisWidget: "Integrieren Sie das Supisis -Widget in die Chatbot -Geschichte",
            integrateStoryWithWhatsapp: "Integrieren Sie WhatsApp in Chatbot Story",
            integrateStoryWithInstagram: "Integrieren Sie Instagram in die Chatbot -Geschichte",
            selectIntegratingStory: "Wählen Sie die integrierte Geschichte aus",
            install: "Belastung",
            attr: {
                weekday: "Weekday",
                channelId: "Channel",
                email: "Email",
                phone: "Phone",
                language: "Sprache",
                timezone: "Zeitzone",
                gender: "Geschlecht",
                country: "Land",
                referrer: "Referenz",
                url: "Adresse besuchen",
                ip: "SEIL",
                last_seen: "Zuletzt gesehen",
                name: "Name",
                user_id: "Benutzernummer",
                department: "Abteilung",
                message: "Nachricht",
                akinon_brand: "Marke",
                akinon_order_id: "Bestellnummer",
                akinon_product_id: "Produktnummer",
                akinon_user_id: "Benutzer-ID",
                akinon_user_name: "Nutzername",
                akinon_user_email: "Benutzer Email",
                akinon_invoice_url: "Rechnungs -URL",
                akinon_order_status: "Bestellstatus",
                akinon_order_price: "Bestellpreis",
                akinon_shipper_name: "Cargo Firmenname",
                akinon_product_size: "Produktkörper",
                akinon_sku: "Skue",
                akinon_product_url: "Produkt -URL",
                akinon_product_title: "Produktüberschrift",
                akinon_product_image: "Produktbild",
                akinon_product_stock: "Produktbestand",
                akinon_order_date: "Auftragsdatum",
                akinon_track_number: "Versandnummer",
                akinon_track_url: "Frachtverfolgungs -URL",
                akinon_latitude: "Breitengrad (Ort)",
                akinon_longitude: "Länge (Ort)",

                ideasoft_user_id: "Member Id",
                ideasoft_invoice_url: "Invoice Url",
                ideasoft_order_id: "Sipariş Numarası",
                ideasoft_order_status: "Order Status",
                ideasoft_order_price: "Order Price",
                ideasoft_shipper_name: "Shipper Name",
                ideasoft_product_size: "Product Size",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Product Url",
                ideasoft_product_title: "Product Title",
                ideasoft_product_image: "Product Image",
                ideasoft_product_stock: "Product Stock",
                ideasoft_order_date: "Order Date",
                ideasoft_track_number: "Track Number",
                ideasoft_track_url: "Track Url",
                idleUserTime: "User Last Action (Second)",
                ai_class_result: "AI Class Result",
                meta_comment_id: "Meta Comment ID",
                meta_comment: "Meta Comment",
                meta_post_id: "Meta Post ID",
                offline_mode: "Offline-Modus",
                available_agents: "Geeignete Vertreter",
                platform: "Plattform",
                probel_sube_kodu: "Branchencode",
                probel_brans_adi: "Zweigname",
                probel_brans_kodu: "Branchencode",
                probel_doktor_adi: "Arztname",
                probel_doktor_kodu: "Doktorcode",
                probel_poliklinik_adi: "Polyklinischer Name",
                probel_poliklinik_kodu: "Polyclinic Code",
                probel_randevu_tarihi: "Termin",
                probel_date: "Termin",
                probel_randevu_saati: "Termin",
                probel_randevu_id: "Termin -ID",
                probel_hasta_token: "Patient Token",
                probel_kimlik_tipi: "Identitätstyp",
                probel_kimlik_no: "Identifikationsnummer",
                probel_hasta_adi: "Patientenname",
                probel_hasta_soyadi: "Nachname des Patienten",
                probel_hasta_cinsiyet: "Geschlecht",
                probel_hasta_dogum_tarihi: "Geburtsdatum",
                probel_hasta_telefon: "Telefon",
                hour: "Stunde",
                segments: "Segments",
                tags: "Tags",
                ticket: "Fahrkarte",
                metaReferrals: "Meta-Verweise",
            },
            storyList: "Story List",
            douYouWannaDeleteItem: "Möchten Sie diesen Artikel löschen?",
            douYouWannaDeleteWithChildren: "Möchten Sie dieses Element mit den Sub -Elementen löschen?",
            stories: "Geschichten",
            templates: "Vorlagen",
            aitemplates: "KI-Vorlagen",
            integrations: "Integrationen",
            all: "Alle",
            installed: "Hochgeladen",
            installationOK: "Geladen",
            uninstall: "Aufzug",
            remainingMessageDesc: "Verbleibende kostenlose Nachricht:",
            openAISiteRoutingDescStart: "Einen Apikey bekommen",
            openAISiteRoutingDescEnd: "Sie können auf den Link klicken.",
            integrationOK: "Integriert",
            chatWidget: "SUPSIS -Chat -Ballon",
            artificialIntelligence: "Künstliche Intelligenz",
            integratePlatform: "Chatbot kann in {integretable} integriert werden.",
            integrateOpenAIWithChatbot: "Integrieren Sie Chat GPT-4 in Chatbot",
            integrateChatBotWithChatGPT3: "Integration von Chatbot mit CHAT GPT-4",
            integrateStoryWithTelegram: "Integration mit Telegramm -Chatbot",
            webhooks: "Webhaken",
            archive: "Archiv",
            reports: "Berichte",
            uncheckAll: "Lassen Sie alle",
            userSegments: "Benutzerabschnitte",
            addSegment: "Abschnitt hinzufügen",
            addToSegment: "Zum Abschnitt hinzufügen",
            removeFromSegment: "Aus der Abteilung weglassen",
            plansVTippyContent:
                "Die Abrechnung für dieses Paket erfolgt zu Beginn jeden Monats, und falls Sie kündigen möchten, wird Ihr Verbrauch bis zum Monatsbeginn berechnet und Ihr Paket läuft ab.<br><br>Der Paketpreis ist exklusive Mehrwertsteuer.<br><br>Paketänderungen werden am nächsten Tag auf der Rechnung ausgewiesen.",
            segmentName: "Abteilungsname",
            sameSegment: "Es gibt einen Segment mit demselben Namen!",
            usersInSegment: "Benutzer im Abschnitt",
            noUsersAdded: "Benutzer nicht hinzugefügt",
            updateSegment: "Aktualisieren Sie den Abschnitt Aktualisieren",
            newSegment: "Neues Kapitel",
            selectAll: "Wählen Sie Alle",
            queriesSelected: "Fragen ausgewählt",
            noBlocksFound: "Der Block wurde nicht gefunden!",
            userQuery: "Benutzerabfrage",
            date: "Geschichte",
            unmatched: "Unverkennbar",
            goToChat: "Geh zum Chat",
            selectStory: "Wählen Sie Geschichte",
            selectBlock: "Wählen Sie Block",
            training: "Bot -Training",
            trainingAlert:
                "Um die Änderungen, die Sie auf der Bot-Trainingsseite vorgenommen haben, umzusetzen, müssen Sie die neue Version des von Ihnen modifizierten Szenarios veröffentlichen.",
            unmatchedPhrases: "Nicht zusammenfassende Ausdrücke",
            ignored: "Unbedeutend",
            story: "Geschichte",
            timePeriod: "Zeitraum",
            wholeTimeSpan: "Jederzeit",
            selectAStory: "Wählen Sie eine Geschichte",
            searchUserQuery: "Suchen Sie die Benutzerabfrage",
            time: {
                today: "Heute",
                yesterday: "Gestern",
                last7: "Letzten 7 Tage",
                last30: "Letzte 30 Tage",
                "this-month": "Diesen Monat",
                "last-month": "Im vergangenen Monat",
                "last-3-month": "Letzte 3 Monate",
                "this-year": "Dieses Jahr",
                "last-year": "Letztes Jahr",
                custom: "Wählen Sie ein anderes Datum",
            },
            emailProvider: "E-Mail-Anbieter",
            triggerFromAnywhere: "Kann von überall aus ausgelöst werden",
            editWebhook: "Webhook bearbeiten",
            newWebhook: "Neues Webhook",
            webhookTitle: "Webhook -Titel",
            webhookUrl: "Webhook URL",
            webhookToken: "Webhook Token",
            webhookUsername: "Webhook Benutzername",
            webhookPassword: "Webhook Passwort",
            allIntegrations: "Alle Integrationen",
            integrateYourCBwithChatWidget: "Integriert in Chatbothe Chat -Widget.",
            integrateYourCBwithChatGpt3:
                "Chatbot kann in GPT-4 integriert werden. GPT-4-API-Schlüssel ist erforderlich.",
            integrateYourCBwithWebHook:
                "Leiten Sie die Chat -Informationen zwischen Chatbot und Webdiensten einfach weiter.",
            integrateYourCBwithIntegratable:
                "Leicht die Chat -Informationen zwischen Chatbot und {integratable} einfach weiter weiter weiter weiterzuleiten.",
            addWebhook: "Fügen Sie Webhook hinzu",
            editBlock: "Bearbeiten",
            moveBlock: "Umzug",
            copyBlock: "Kopieren",
            chatbot: "Chatbot",
            addFilter: "Filter hinzufügen",
            addFilterGroup: "Filtergruppe hinzufügen",
            in: "innen",
            and: "Und",
            or: "oder",
            allStories: "Alle Geschichten",
            addBot: "Erstellen Sie einen Bot",
            testBot: "Testen Sie den Bot",
            publish: "Veröffentlichen",
            editName: "Namen bearbeiten",
            search: "Rufen Sie in Ihrer Geschichte an ...",
            typeMoreThan3Char: "Geben Sie mindestens 3 Zeichen ein",
            expand: "Erweiterung",
            expandAll: "Alle erweitern",
            noMatchingItem: "Kein passender Artikel",
            hint: "Hinweis",
            select: "Wählen",
            navigate: "Reisen",
            dismiss: "aufgeben",
            choseAttribute: "Wählen Sie den Filtertyp",
            selectReply: "Wählen Sie den Antworttyp",
            preview: "Vorschau",
            draft: "Entwurf",
            lastUpdate: "Letztes Update",
            published: "Es wurde veröffentlicht",
            newStory: "Neue Geschichte",
            updateStory: "Aktualisieren Sie die Geschichte",
            storyDescription: "Geschichte Beschreibung",
            storyTitle: "Geschichtenentitel",
            deleteSingleBlock: "Einen Block löschen",
            deleteWithChildren: "Mit inneren Zweigen löschen",
            startTestFromHere: "Starten Sie den Test hier",
            copyBlockId: "Block -ID kopieren",
            gotoLiveLink: "Erstellen Sie einen Live -Link von hier aus",
            copyBlockIdSuccessfull: "Copped Block ID",
            collapse: "Verengung",
            collapseAll: "Beschränken Sie alle",
            snDelay: "{delay} Sn Delay",
            blockUpdated: "Block aktualisiert",
            addPayload: "Antwort hinzufügen",
            previewModeCaution:
                "Sie sehen sich momentan eine der Versionen Ihrer Geschichte vor. Sie können Änderungen im Vorschaudermodus nicht aufzeichnen!",
            enterText: "Hier schreiben ...",
            trackpad: "Trackpad",
            navigation: "Navigation",
            navigationDesc:
                "Bitte wählen Sie Ihren Navigationsmodus. Sie können wählen, ob Sie Rechteck- oder Mausoptionen ansehen können.",
            botSetting: "Starteinstellung",
            botSettingDesc:
                "Bitte bestimmen Sie das Vertrauensniveau. Dies ist ein Prozentsatz von 0 bis 100 und definiert die Genauigkeit von Chatbot -Kommentaren zu Benutzereingaben.",
            languageSettingsDesc:
                "Bitte stellen Sie sicher, dass die Sprache, auf die Sie antworten, die Sprache ist, die Sie bevorzugen.",
            mouse: "Maus",
            Interactions: "Interaktionen",
            Actions: "Aktionen",
            Supsis_Actions: "SUPSiS -Aktionen",
            Shopify_Actions: "Shopify -Aktionen",
            Akinon_Actions: "Akinon -Aktionen",
            IdeaSoft_Actions: "Ideasoft Actions",
            START_POINT: "STARTPUNKT",
            AI_ASSISTANT: "AI ASSISTANT",
            BOT_RESPONSE: "Bots Antwort",
            AI_BOT_RESPONSE: "Künstliche Intelligenz Antwort (GPT-4o)",
            AI_CLASSIFICATION: "AI CLASSIFICATION",
            Templates: "Template Blocks",
            AI_MENU_FLOW: "AI MENU",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "Standardend ansonsten",
            FILTER: "FILTER",
            addNewFilter: "Neuen Filter hinzufügen",
            FLOW: "FLUSS",
            ATTACHMENT_INPUT: "Dateieinführung",
            USER_INPUT: "BENUTZER-ANMELDUNG",
            GO_TO_STEP: "Gehen Sie zu Schritt",
            WEBHOOK: "Webhaken",
            SET_ATTRIBUTE: "Feature festlegen",
            QUESTION: "FRAGE",
            CLOSE_CHAT: "Schließen Sie Chat",
            CREATE_TICKET: "Erstellen Sie ein Ticket",
            TRANSFER_CHAT: "Chat übertragen",
            TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
            TAG_CHAT: "ADD TAG",
            REMOVE_TAG: "REMOVE TAG",
            SET_DEPARTMENT: "Auf die Abteilung einstellen",
            SEND_TRANSCRIPT: "Transkript senden",
            SEND_SMS: "SEND SMS", //todo translate
            SEND_MAIL: "SMS MAIL", //todo translate
            CREATE_EVENT: "CREATE EVENT", //todo translate
            CREATE_RESERVATION: "CREATE RESERVATION",
            RESERVATION_OPEN_URL: "Reservation Open Url",
            RESERVATION_SELECT_DAY: "Select reservation day",
            RESERVATION_EVENT_LIST: "Reservation list visitor",
            RESERVATION_SELECT_TIME: "Select reservation time",
            CREATE_TASK: "CREATE TASK",
            SHOPIFY_SHOW_PRODUCTS: "Shopıfy Show -Produkte",
            SHOPIFY_PRODUCT_AVAILABILITY: "Shopify -Immobilie",
            SHOPIFY_ORDER_STATUS: "Bestellstatus speichern",
            AKINON_SHOW_PRODUCTS: "Das Akinon -Produkt zeigen",
            AKINON_FIND_PRODUCT: "Finden Sie das Akinon -Produkt",
            AKINON_ORDER_STATUS: "Akinon -Bestellstatus",
            AKINON_SELECT_ORDER: "Akınon wählt Reihenfolge aus",
            AKINON_SELECT_SIZE: "Akınon wählen Sie Größe",
            AKINON_FIND_NEAREST_STOCK: "SHOP STORE Aktie",
            AKINON_FIND_NEAREST_STORES: "Zeigen Sie in engen Geschäfte",
            AKINON_SHOW_DISCOUNT_CODES: "Rabattcode anzeigen",

            IDEASOFT_SELECT_ORDER: "SELECT ORDER",
            IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
            IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",
            INSTAGRAM_COMMENT_REPLY: "KOMMENTAR BEANTWORTEN",
            INSTAGRAM_COMMENT_DELETE: "KOMMENTAR LÖSCHEN",
            INSTAGRAM_COMMENT_SHOW: "KOMMENTAR ANZEIGEN",
            INSTAGRAM_COMMENT_HIDE: "KOMMENTAR VERBERGEN",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "ALS PRIVAT ANTWORTEN",
            followingAttributesFilled: "Die folgenden Qualifikationen werden voll sein.",
            GET_LOCATION: "Standort nehmen",
            FALLBACK: "Ansonsten",
            SUCCESS: "ERFOLGREICH",
            FAILURE: "ERFOLGLOS",
            Probel_Actions: "Probelaktionen",
            PROBEL_SELECT_BRANCH: "Wählen Sie Branch",
            PROBEL_SELECT_CLINIC: "Wählen Sie Polyclinic",
            PROBEL_SELECT_DAY: "Wählen Sie einen Termin am Tag",
            PROBEL_SELECT_HOUR: "Wählen Sie eine Terminzeit",
            PROBEL_MAKE_APPOINTMENT: "Einen Termin erstellen",
            PROBEL_CANCEL_APPOINTMENT: "Termin stornieren",
            PROBEL_GET_PATIENT_TOKEN: "Patient zum Token",
            PROBEL_FILL_INFO: "MERNIS Fill Info",
            PROBEL_SELECT_APPOINTMENT: "Wählen Sie einen Termin",
            message: "Nachricht",
            condition: "Zustand",
            score: "Punktzahl",
            equal: "gleich",
            not_equal: "nicht gleich",
            contain: "enthält",
            not_contain: "beteiligt",
            starts_with: "Beginnt mit",
            ends_with: "endet mit",
            empty: "leer",
            longer_than: "Größer",
            shorter_than: "kürzer",
            less_than: "weniger",
            less_than_equal: "Klein gleich",
            greater_than: "ist toll",
            greater_than_equal: "Großartig gleich",
            value: "Wert",
            failures: "Erfolglos",
            email: "Email",
            name: "Name",
            username: "Nutzername",
            source: "Quelle",
            language: "Sprache",
            timezone: "Zeitzone",
            region: "Bereich",
            country: "Land",
            referrer: "Orientierung",
            url: "URL",
            ip: "SEIL",
            city: "Stadt",
            lastSeen: "Zuletzt gesehen",
            userId: "Benutzer-ID",
            selectStep: "Wählen Sie Schritt",
            keywords: "Stichwort",
            userSays: "Was der Benutzer sagt",
            addKeyword: "Keyword hinzufügen",
            addUserMessage: "Benutzerpost hinzufügen",
            set: "Besonderheit",
            to: "mit",
            gender: "Geschlecht",
            go_to_failure: "Gehen Sie zum erfolglosen Antwortschritt",
            go_to_success: "Gehen Sie zum erfolgreichen Antwortschritt",
            untilFilled: "ständig",
            time1: "Einmal",
            time2: "2 mal",
            time3: "dreimal",
            time4: "4 Mal",
            time5: "5 mal",
            any: "Irgendetwas",
            anytext: "Any Text",
            anytextDescription: "Matches only words + spaces",
            alphanumeric: "Buchstaben und Zahlen",
            integer: "Ganze Zahl",
            no: "NEIN",
            number: "Nummer",
            phone: "Telefon",
            yes: "Ja",
            yesNo: "ja Nein",
            anyDescription: "Übereinstimmung mit allem, was nicht leer ist.",
            alphanumericDescription: "Es entspricht sowohl Buchstaben als auch Zahlen.",
            integerDescription: "Passen Sie eine ganze ganze Zahl überein.",
            noDescription: "Es entspricht nicht mit Synonymwörtern.",
            numberDescription: "Es stimmt mit sequentiellen Grundlagen überein.",
            phoneDescription: "Passen Sie die Telefonnummer an.",
            yesDescription: "Ja, es passt zu den Synonymen des Wortes.",
            yesNoDescription: "Ja und nein, dass keine Wörter mit den Synonymen der Wörter übereinstimmen.",
            emailDescription: "Passen Sie es mit E-Mail an.",
            urlDescription: "Match URL.",
            temperature: "Hitze",
            askWhenInvalid: "Fragen Sie, ob es ungültig ist",
            applyFilter: "Filter hinzufügen",
            notificationMessageStartSuccess: "Block",
            notificationMessageEndSuccess: "Hinzugefügt",
            notificationMessageStartError: "Es ist ein Fehler aufgetreten, Block",
            notificationMessageEndError: "konnte nicht hinzugefügt werden",
            blockChangedWannaUpdate: "Möchten Sie das Update speichern?",
            TEXT: "Schreiben",
            IMAGE: "Bild",
            GALLERY: "Galerie",
            BUTTON: "Taste",
            RANDOM_TEXT: "Willkürlich",
            QUICK_REPLY: "Schnelle Antwort",
            FILE: "Datei",
            responses: "Reaktionen",
            flow: "Fluss",
            active: "Aktiv",
            passive: "Passiv",
            chooseAttributeType: "Wählen Sie den Funktionstyp",
            imageAttachment: "Bild hinzuzufügen",
            audioAttachment: "Klang",
            videoAttachment: "Video hinzufügen",
            documentAttachment: "Hinzufügen von Dokument",
            anyAttachment: "Irgendwelche zusätzlichen",
            typeAttributeValue: "Geben Sie den Funktionswert ein",
            typeSearchValue: "Schreiben Sie den Suchwert",
            male: "Männlich",
            addAttribute: "Feature hinzufügen",
            addAttributeDescription:
                "Der Name des Attributs kann nur A-Z-Buchstaben, 0-9 Zahlen und Alphaysalzeichen mit Reifen oder unterer Linie enthalten.",
            USER_DATA: "Nutzerinformation",
            CUSTOM_ATTRIBUTES: "Besondere Attribute",
            enterBotResponseHere: "Schreiben Sie die Frage, die Bot hier stellen wird ...",
            addCard: "Karte hinzufügen",
            addButton: "Taste hinzufügen",
            typeCardTitle: "Kartenkopf",
            typeCardDescription: "Kartenabrechnung",
            dragAndDropBrowse: "Laden Sie ein Bild hoch",
            dragAndDropBrowseFile: "Datei hochladen",
            button: "Taste",
            enterYourMessage: "Gib deine Nachricht ein",
            imageView: "Bildansicht",
            imageUploading: "Das Bild lädt ...",
            fileUploading: "Datei hochladen ...",
            clickToChooseNewImage: "Klicken Sie hier, um ein neues Bild auszuwählen",
            clickToChooseNewFile: "Klicken Sie hier, um eine neue Datei auszuwählen",
            removeTheExistingOne: "Entfernen Sie, was verfügbar ist",
            validateResponseWithEntity: "Überprüfen Sie die Antwort",
            actionOnFailureInput: "Was sollte bei falscher Rechtschreibung getan werden?",
            askNextQuestion: "Die nächste Frage stellen",
            goToSuccessBlock: "Gehen Sie zum erfolgreichen Blog",
            goToFailureBlock: "Gehen Sie zum erfolglosen Block",
            saveResposeToAttribute: "Notieren Sie die Antwort",
            selectReplyType: "Wählen Sie den Antworttyp aus",
            questionVariants: "Arten von Fragen",
            systemEntities: "Definierte Verifizierungsausdrücke",
            delay: "Verzögerung",
            retrySectionTextPart: "Herr.",
            retrySectionText: "Wenn die Antwort des Benutzers ungültig ist",
            addNextQuestion: "Fügen Sie die nächste Frage hinzu",
            typeBlockTitle: "Blockkopf",
            versionHistory: "Versionsgeschichte",
            restore: "Aktualisieren",
            versionName: "Versionsname",
            restoreModalText:
                "Diese Aktion stellt die ausgewählte Version wieder her. Sind Sie sicher, dass Sie diese Version wiederherstellen möchten?",
            restoreVersion: "Update-Version",
            newVersion: "Neue Version",
            synonymMustBeUnique: "Es gibt nicht mehr als ein Wort mit demselben Synonym",
            save: "Speichern",
            entries: "Eingänge",
            youHaveNoEntries: "Eingabe nicht gefunden",
            inputsCantBeEmpty: "Die Felder können nicht leer gelassen werden",
            entryNamesMustBeUnique: "Das Schlüsselwort kann nicht das gleiche sein!",
            entityNameCantBeEmpty: "Der Name des Vermögenswerts kann nicht leer gelassen werden",
            entityNameMustBeUnique: "Der Name des Vermögenswerts kann nicht der gleiche sein",
            synonyms: "Synonyme",
            title: "Stichwort",
            entryName: "Name eingeben",
            entities: "Vermögenswerte",
            entityhasbeenUpdatedSuccessfully: "Erfolgreich aufgenommen werden",
            emptyError: "Die erforderlichen Bereiche können nicht leer bleiben",
            allChats: "Alle Gespräche",
            paidChats: "Bezahlte Chats",
            busiestPeriod: "Die intensivste Zeit",
            ratingDistribution: "Bewertungsverteilung",
            allMessages: "Alle Artikel",
            avarageMessages: "Durchschnittliche Nachrichten",
            popularity: "Popularität",
            allUsers: "Alle Nutzer",
            interactionName: "Interaktionsname",
            numberOfMessage: "Anzahl der Nachrichten",
            ofAllUsersMessage: "% Alle Benutzernachrichten",
            totalData: "Gesamtdaten",
            avgData: "Durchschnittliche Daten",
            exportToCsv: "Übertragung zu CSV",
            exportToExcel: "Übertragung zu Excel",
            inMaintenance: "Im Bau",
            ADD_TO_SEGMENT: "Zum Abschnitt hinzufügen",
            REMOVE_FROM_SEGMENT: "Aus der Abteilung weglassen",
            users: "Benutzer",
            webhookName: "Webhook Name",
            webHookUrl: "Webhook URL",
            webHookToken: "Webhook Token",
            delete: "Löschen",
            basicAuth: "Basic auth",
            requiredFieldsCannotBeLeftBlank: "Obligatorische Bereiche können nicht leer bleiben",
            yourVerificationToken: "Zeichen",
            yourWebHookName: "Ihr Webhook -Name",
            yourWebHookUrl: "Ihre Webhook -URL",
            enterKey: "Taste",
            password: "Passwort",
            headerValue: "Wert",
            saveSuccessfully: "Ihre Transaktion wurde erfolgreich aufgezeichnet.",
            urlTypeError: "Bitte füllen Sie das Feld korrekt aus (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "API-Schalter für OpenAI-Chat GPT-4 erforderlich.",
                apiKeyDesc:
                    "API-Schlüssel ist für Chatbot + Chat GPT-4-Integration erforderlich. Bitte entfernen Sie Ihren API -Switch oder verwenden Sie den folgenden API -Switch für die Testversion. Sie können nur 20 Nachrichten für Testzwecke verwenden.",
                getApiKey: "Holen Sie sich einen offenen API -Switch",
                typeApiKey: "Schreiben Sie den API -Schlüssel",
                ownApiKey: "Openai API -Schlüssel haben",
                trialApiKey: "Test -API -Schlüssel (begrenzt als 20 Nachrichten)",
                useOurTrial: "Verwenden Sie unsere kostenlose Testversion",
                twentyMessages: "Sie können 20 Nachrichten kostenlos verwenden.",
                enableChatGpt3: "Aktivieren Sie Chat GPT-4",
            },
        },
        coupon: {
            code: "Code",
            discount: "Rabatt",
            endDate: "Endtermin",
            name: "Name",
            email: "Email",
            phone: "Telefon",
            add: "Gutschein hinzufügen",
            coupons: "Gutscheine",
            couponDeleted: "Gutschein gelöscht",
            limit: "Grenze",
            visitorBan: "Besucher wurde gesperrt.",
            visitorUnBlock: "Sperrung aufgehoben.",
        },
        instagramTitle: "Klicken Sie auf die Schaltfläche unten, um die Instagram-Funktionen zu aktivieren.",
        instegramFunctionActive: "Aktivieren Sie die Instagram Funktion",
        ChatBOT: "Chat-Bot",
        WhatsappContacts: "WhatsApp Kontakte",
        InstagramContacts: "Instagram Kontakte",
        MessengerContacts: "Messenger Contacts",
        volumeUp: "Lautstärke",
        minimize: "Schrumpfen",
        maximize: "Erweiterung",
        auditLogs: {
            auditLogsTitle: "Audit-Logs",
            auditLogsSub:
                "Audit-Logs ermöglichen es Ihnen, Ereignisse zu verfolgen, die in Ihrem Unternehmen in den letzten 30 Tagen stattgefunden haben.",
        },
        task: {
            workflow: "Arbeitsablauf",
            workflowDetail: "Arbeitsablauf Details",
            workflowPerm: "Arbeitsablauf Berechtigungen",
            perm: "Berechtigungen",
            detail: "Details",
            userPerm: "Benutzerberechtigungen",
            deleteCard: "Karte löschen",
            createCard: "Karte erstellen",
            editCard: "Karte bearbeiten",
            dragCard: "Karte verschieben",
            allWorkflow: "Alle Arbeitsabläufe",
            createworkflow: "Arbeitsablauf erstellen",
            deleteWorkflow: "Sind Sie sicher, dass Sie diesen Arbeitsablauf löschen möchten?",
            permEditTask: "Sie haben keine Berechtigung, diese Aufgabe zu bearbeiten",
            permEditTaskDes: "Wenden Sie sich an Ihren Administrator, um Bearbeitungsberechtigungen zu erhalten.",
            createTaskError: "Sie haben keine Berechtigung, Aufgaben zu erstellen",
            createTaskErrorDesc:
                "Wenden Sie sich an Ihren Administrator, um Berechtigungen zum Erstellen von Aufgaben zu erhalten.",
            moveTaskError: "Sie haben keine Berechtigung, den Aufgabenstatus zu ändern",
            moveTaskErrorDesc:
                "Wenden Sie sich an Ihren Administrator, um Berechtigungen zur Änderung des Aufgabenstatus zu erhalten.",
            deleteTaskError: "Sie haben keine Berechtigung, Aufgaben zu löschen",
            deleteTaskErrorDesc:
                "Wenden Sie sich an Ihren Administrator, um Berechtigungen zum Löschen von Aufgaben zu erhalten.",
            permissionError: "Sie haben keine Berechtigung, Aufgaben zu erstellen",
            permissionErrorDesc:
                "Bitte wenden Sie sich an Ihren Administrator, um Berechtigungen zur Aufgabenerstellung zu erhalten",
            whatsappContactProfileTitle: "{name} / {number} Profil",
            createTaskVisitor: "Aufgabe erstellen (Besucher)",
            editWorkflow: "Workflow bearbeiten",
            visitor: "Besucherprofil",
            createTaskMessage: "Aufgabe erstellen (Nachricht)",
            createStage: "Stufe erstellen",
            stagesAndStatuses: "Phasen und Status",
            workflowCreateDesc: "Workflow-Beschreibung",
            subTasks: "Teilaufgaben",
            followers: "Anhänger",
            collaborators: "Mitarbeiter",
            addRelations: "Beziehungen hinzufügen",
            relations: "Beziehungen",
            main: "Haupt",
            name: "Name",
            completedOfCheck: "{completed} von {total} Aufgaben abgeschlossen",
            workflowUpdateMs: "Workflow erfolgreich aktualisiert",
            taskUpdateMs: "Aufgabe erfolgreich aktualisiert",
            workflowCreatedMs: "Workflow erfolgreich erstellt",
            workflowCreateError: "Der Workflow konnte nicht erstellt werden",
            taskCreatedMs: "Aufgabe erfolgreich erstellt",
            settingsDesc3:
                "Darüber hinaus ermöglicht Ihnen das Supsis-Aufgabenmodul, Ihren eigenen Workflow mit anpassbarer Automatisierung zu erstellen, sodass Sie Aufgaben effektiver verwalten und die Zusammenarbeit im Team verbessern können.",
            settingsDesc4:
                "Auf diese Weise können Sie jede Ihrer Aufgaben im Detail verfolgen, Aufgaben an Teammitglieder zuweisen und insgesamt Ihre Geschäftsprozesse effizienter verwalten. Das Supsis-Aufgabenmodul bietet Ihnen eine umfassende Lösung für die Aufgabenverwaltung und Teamkoordination.",
            settingsDesc2:
                "Das Supsis-Aufgabenmodul lässt keine Aufgabe unbeachtet. Sie können Aufgaben basierend auf jedem Parameter filtern, Arbeitslasten für jeden Workflow-Schritt verfolgen und Ihren Kalender organisieren, um sich an Ihre Zeitpläne anzupassen.",
            settingsDesc1:
                "Das Aufgabenmodul ermöglicht es Ihnen, die Zusammenarbeit zu organisieren, Aufgaben zu delegieren und den Fortschritt Ihres Teams zu verfolgen. Sie können Ihre Aufgaben nach Bedarf anpassen, indem Sie eine beliebige Ansicht auswählen und Ihre eigenen benutzerdefinierten Workflows mit Automatisierungen erstellen.",
            taskModuleSettingsTitle: "Aufgabenmodul-Einstellungen",
            high: "Hoch",
            medium: "Mittel",
            low: "Niedrig",
            priority: "Priorität",
            addExistsSubtask: "Vorhandene Teilaufgabe hinzufügen",
            addSubtask: "Teilaufgabe hinzufügen",
            add: "Hinzufügen",
            newCheckList: "Neue Checkliste",
            subtaskTitle: "Teilaufgabentitel",
            view: "Anzeigen",
            attachFiles: "Dateien anhängen",
            createTaskDesc: "Aufgabenbeschreibung",
            title: "Titel",
            createWorkflow: "Workflow erstellen",
            editTask: "Aufgabe bearbeiten",
            createTask: "Aufgabe erstellen",
            deleteColumnCont: "Sind Sie sicher, dass Sie diese Spalte löschen möchten?",
            changeStage: "Status ändern",
            assignees: "Beauftragte",
            owner: "Besitzer",
            stage: "Status",
            writeSomething: "Schreiben Sie etwas",
            selectAssginee: "Zuweisung auswählen",
            assignee: "Beauftragter",
            enterNewTaskDesc: "Neue Aufgabenbeschreibung eingeben",
            enterNewTaskTitle: "Neuen Aufgabentitel eingeben",
            task: "Aufgabe",
            deleteTaskCont: "Möchten Sie diese Aufgaben wirklich löschen?",
            deleteWorkFlowCont: "Sind Sie sicher, dass Sie diesen Workflow löschen möchten?",
            completed: "Abgeschlossen",
            todo: "Zu erledigen",
            kanbanBoard: "Kanban-Board",
            listView: "Listenansicht",
        },
        permissionErrors: {
            userCreate:
                "Sie haben keine Berechtigung, Benutzer hinzuzufügen. Bitte konsultieren Sie Ihren Administrator.",
            userRead: "Sie haben keine Berechtigung, Benutzer anzuzeigen. Bitte konsultieren Sie Ihren Administrator.",
            userUpdate:
                "Sie haben keine Berechtigung, Benutzer zu aktualisieren. Bitte konsultieren Sie Ihren Administrator.",
            userDelete:
                "Sie haben keine Berechtigung, Benutzer zu löschen. Bitte konsultieren Sie Ihren Administrator.",
            visitorBlock:
                "Sie haben keine Berechtigung, Besucher zu blockieren. Bitte konsultieren Sie Ihren Administrator.",
            visitorUnblock:
                "Sie haben keine Berechtigung, Besucher zu entsperren. Bitte konsultieren Sie Ihren Administrator.",
            visitorDetailRead:
                "Sie haben keine Berechtigung, Besucherdetails anzuzeigen. Bitte konsultieren Sie Ihren Administrator.",
            visitorListRead:
                "Sie haben keine Berechtigung, die Besucherliste anzuzeigen. Bitte konsultieren Sie Ihren Administrator.",
            visitorDelete:
                "Sie haben keine Berechtigung, Besucher zu löschen. Bitte konsultieren Sie Ihren Administrator.",
            visitorExcel:
                "Sie haben keine Berechtigung, Excel-Ausgabe zu erhalten. Bitte konsultieren Sie Ihren Administrator.",
            visitorUpdate:
                "Sie haben keine Berechtigung, Besucher zu aktualisieren. Bitte konsultieren Sie Ihren Administrator.",
            bannedVisitorRead:
                "Sie haben keine Berechtigung, die Liste der gesperrten Besucher anzuzeigen. Bitte konsultieren Sie Ihren Administrator.",
            bannedWordCreate:
                "Sie haben keine Berechtigung, gesperrte Wörter hinzuzufügen. Bitte konsultieren Sie Ihren Administrator.",
            bannedWordRead:
                "Sie haben keine Berechtigung, gesperrte Wörter anzuzeigen. Bitte konsultieren Sie Ihren Administrator.",
            bannedWordDelete:
                "Sie haben keine Berechtigung, gesperrte Wörter zu löschen. Bitte konsultieren Sie Ihren Administrator.",
            chatRead: "Sie haben keine Berechtigung, Chats anzuzeigen. Bitte konsultieren Sie Ihren Administrator.",
            chatUpdate:
                "Sie haben keine Berechtigung, Chats zu bearbeiten. Bitte wenden Sie sich an Ihren Administrator.",
            archiveRead:
                "Sie haben keine Berechtigung, Archive anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            roleCreate:
                "Sie haben keine Berechtigung, Rollen hinzuzufügen. Bitte wenden Sie sich an Ihren Administrator.",
            roleRead: "Sie haben keine Berechtigung, Rollen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            roleUpdate:
                "Sie haben keine Berechtigung, Rollen zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            roleDelete:
                "Sie haben keine Berechtigung, Rollen zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            departmentCreate:
                "Sie haben keine Berechtigung, Abteilungen hinzuzufügen. Bitte wenden Sie sich an Ihren Administrator.",
            departmentRead:
                "Sie haben keine Berechtigung, Abteilungen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            departmentUpdate:
                "Sie haben keine Berechtigung, Abteilungen zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            departmentDelete:
                "Sie haben keine Berechtigung, Abteilungen zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            preparedContentCreate:
                "Sie haben keine Berechtigung, vorbereiteten Inhalt zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            preparedContentRead:
                "Sie haben keine Berechtigung, vorbereiteten Inhalt anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            preparedContentUpdate:
                "Sie haben keine Berechtigung, vorbereiteten Inhalt zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            preparedContentDelete:
                "Sie haben keine Berechtigung, vorbereiteten Inhalt zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            welcomeCreate:
                "Sie haben keine Berechtigung, Begrüßungsnachrichten zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            welcomeRead:
                "Sie haben keine Berechtigung, Begrüßungsnachrichten anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            welcomeUpdate:
                "Sie haben keine Berechtigung, Begrüßungsnachrichten zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            welcomeDelete:
                "Sie haben keine Berechtigung, Begrüßungsnachrichten zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            settingCreate:
                "Sie haben keine Berechtigung, Einstellungen zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            settingRead:
                "Sie haben keine Berechtigung, Einstellungen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            settingUpdate:
                "Sie haben keine Berechtigung, Einstellungen zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            settingDelete:
                "Sie haben keine Berechtigung, Einstellungen zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            reportCreate:
                "Sie haben keine Berechtigung, Berichte zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            reportRead:
                "Sie haben keine Berechtigung, Berichte anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            reportUpdate:
                "Sie haben keine Berechtigung, Berichte zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            reportDelete:
                "Sie haben keine Berechtigung, Berichte zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            offlineSupportRequestCreate:
                "Sie haben keine Berechtigung, Offline-Supportanfragen zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            offlineSupportRequestRead:
                "Sie haben keine Berechtigung, Offline-Supportanfragen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            offlineSupportRequestUpdate:
                "Sie haben keine Berechtigung, auf Offline-Supportanfragen zu antworten. Bitte wenden Sie sich an Ihren Administrator.",
            offlineSupportRequestDelete:
                "Sie haben keine Berechtigung, Offline-Supportanfragen zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            catalogCreate:
                "Sie haben keine Berechtigung, Kataloge zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            catalogRead:
                "Sie haben keine Berechtigung, Kataloge anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            catalogUpdate:
                "Sie haben keine Berechtigung, Kataloge zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            catalogDelete:
                "Sie haben keine Berechtigung, Kataloge zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotStoryCreate:
                "Sie haben keine Berechtigung, Chatbot-Geschichten zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotStoryRead:
                "Sie haben keine Berechtigung, Chatbot-Geschichten anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotStoryUpdate:
                "Sie haben keine Berechtigung, Chatbot-Geschichten zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotStoryDelete:
                "Sie haben keine Berechtigung, Chatbot-Geschichten zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotTemplateRead:
                "Sie haben keine Berechtigung, Chatbot-Vorlagen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotTemplateAiRead:
                "Sie haben keine Berechtigung, KI-Chatbot-Vorlagen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotIntegrationsRead:
                "Sie haben keine Berechtigung, Chatbot-Integrationen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotArchiveRead:
                "Sie haben keine Berechtigung, Chatbot-Archive anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotEntitiesRead:
                "Sie haben keine Berechtigung, Chatbot-Entitäten anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotEntitiesCreate:
                "Sie haben keine Berechtigung, Chatbot-Entitäten zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotEntitiesUpdate:
                "Sie haben keine Berechtigung, Chatbot-Entitäten zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotEntitiesDelete:
                "Sie haben keine Berechtigung, Chatbot-Entitäten zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotReportRead:
                "Sie haben keine Berechtigung, Chatbot-Berichte anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotTrainRead:
                "Sie haben keine Berechtigung, das Training des Chatbots anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotSegmentCreate:
                "Sie haben keine Berechtigung, Chatbot-Benutzersegmente zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotSegmentRead:
                "Sie haben keine Berechtigung, Chatbot-Benutzersegmente anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotSegmentUpdate:
                "Sie haben keine Berechtigung, Chatbot-Benutzersegmente zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotSegmentDelete:
                "Sie haben keine Berechtigung, Chatbot-Benutzersegmente zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            integrationsRead:
                "Sie haben keine Berechtigung, die Integrationsseite anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            whatsappIntegrationRead:
                "Sie haben keine Berechtigung, die WhatsApp-Integrationsseite anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            instagramIntegrationRead:
                "Sie haben keine Berechtigung, die Instagram-Integrationsseite anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            telegramIntegrationRead:
                "Sie haben keine Berechtigung, die Telegramm-Integrationsseite anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            integrationCreate:
                "Sie haben keine Berechtigung, Integrationen zu aktivieren. Bitte wenden Sie sich an Ihren Administrator.",
            triggerCreate:
                "Sie haben keine Berechtigung, Trigger zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            triggerRead:
                "Sie haben keine Berechtigung, Trigger anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            triggerUpdate:
                "Sie haben keine Berechtigung, Trigger zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            triggerDelete:
                "Sie haben keine Berechtigung, Trigger zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            billingRead:
                "Sie haben keine Berechtigung, die Rechnungen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            taskCreate:
                "Sie haben keine Berechtigung, Aufgaben zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            taskRead:
                "Sie haben keine Berechtigung, Aufgaben anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            taskUpdate:
                "Sie haben keine Berechtigung, Aufgaben zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            taskDelete:
                "Sie haben keine Berechtigung, Aufgaben zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            calendarCreate:
                "Sie haben keine Berechtigung, Kalender/Reservierungen zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            calendarRead:
                "Sie haben keine Berechtigung, den Kalender/die Reservierungen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            calendarUpdate:
                "Sie haben keine Berechtigung, den Kalender/die Reservierungen zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            calendarDelete:
                "Sie haben keine Berechtigung, den Kalender/die Reservierungen zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            mailCreate:
                "Sie haben keine Berechtigung, E-Mails zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            mailRead: "Sie haben keine Berechtigung, E-Mails anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            mailUpdate:
                "Sie haben keine Berechtigung, E-Mails zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            mailDelete:
                "Sie haben keine Berechtigung, E-Mails zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
        },
        message: {
            noConversationDesc: "Hier können Sie aktive Chats und Ihnen zugewiesene Chats sehen.",
            forMe: "Für mich",
            unAssigned: "Nicht zugewiesen",
            agentDetails: "Agentendetails",
            contactProperties: "Kontaktinformationen",
            goToProfile: "Zum Profil gehen",
            addNote: "Notiz hinzufügen",
            noPreferredAgent: "Noch kein bevorzugter Agent",
            toPrefer: "Bevorzugen",
            inChat: "Im Chat",
            watching: "Schaut zu",
            chatsTitle: "Chats",
            dealyTimeMaxValueError: "Die Verzögerungszeit kann maximal 15 betragen",
            dealyTimeTypeError: "Verzögerungszeitwert muss eine Zahl sein",
            passedTimeHm: "{hour} Stunden {min} Minuten",
            passedTimeMs: "{min} Minuten {sec} Sekunden",
            passedTimeSc: "{sec} Sekunden",
            translateMessage: "Ihre Nachricht wurde durch künstliche Intelligenz übersetzt.",
            toneChanged: "Nachrichtenton auf {tone} geändert",
            aiResponseAdded: "KI-Antwort zur Nachricht hinzugefügt",
            messageLonger: "Nachricht verlängert",
            grammarFixed: "Grammatik korrigiert",
            aiTranslate: "Übersetzung",
            other: "Andere",
            yourLanguage: "Ihre Sprache",
            myLanguage: "Meine Sprache",
            forwardToChatbot: "An Chatbot Weiterleiten",
            friendly: "Freundlich",
            confident: "Selbstbewusst",
            straightForward: "Geradlinig",
            casual: "Lässig",
            professional: "Professionell",
            longSentence: "Langer Satz",
            changeTone: "Ton Ändern",
            fixGrammar: "Grammatik Korrigieren",
            aiResponse: "KI-Antwort",
            templateButtonNote:
                "Um den Kontakt zu sperren, verwenden Sie bitte die folgenden Texte auf der Sperrtaste. Unabhängig von Groß- oder Kleinbuchstaben",
            templateButtonTags: "#Nachricht senden# | #Abbestellen# | #Sperren# | #Blockieren# ",
            dashboard: "Dashboard",
            adminReports: "Admin Reports",
            calendarModule: "Kalendermodul",
            taskModule: "Aufgabenverwaltungsmodul",
            maxUrlButtonMessage: "You can add a maximum of 2 URL buttons.",
            noPreferredDepartment: "Keine bevorzugte Abteilung vorhanden",
            searchForDepartment: "Nach Abteilung suchen",
            departmentAssignedToTheVisitor: "Wählen Sie die Abteilung aus, die Sie dem Besucher zuweisen möchten.",
            assignPreferredDepartment: "Bevorzugte Abteilung zuweisen",
            smsChannel: "SMS-Kanal: ",
            whatsappv2Channel: "Whatsapp V2-Kanal: ",
            whatsappv1Channel: "Whatsapp V1-Kanal: ",
            wBChannel: "Whatsapp Business-Kanal: ",
            messengerChannel: "Messenger-Kanal: ",
            instagramChannel: "Instagram-Kanal: ",
            allPlatforms: "Alle Plattformen",
            cbStartMessage: "Chatbot-Startnachricht",
            cbStartMessageDesc:
                "Die erste vom Benutzer eingegebene Nachricht wird automatisch vom Chatbot verarbeitet und an die entsprechende Adresse weitergeleitet.",
            messengerUserProfile: "Messenger Benutzerprofil",
            instagramUserProfile: "Instagram Benutzerprofil",
            noEventFound: "Kein Ereignis gefunden",
            visitorMails: "Besucher-E-Mails",
            visitorActions: "Besucheraktionen",
            notVerified: "Nicht überprüft",
            visitorEvents: "Besucherereignisse",
            assignedTasks: "Zugewiesene Aufgaben",
            mails: "Mails",
            prefferedAgents: "Bevorzugte Agenten",
            createEvent: "Ereignis erstellen",
            blockManagement: "Blockmanagement",
            deleteUser: "Benutzer löschen",
            blocked: "Blockiert",
            profiles: "Profile",
            similiarProfiles: "Ähnliche Profile gefunden",
            ReplyAsAPm: "Als Privatnachricht antworten und schließen",
            replyAsAComment: "Als Kommentar antworten und schließen",
            messengerAddDesc:
                "Klicken Sie unten auf die Schaltfläche Verbinden und melden Sie sich bei Ihrem Facebook-Konto an.",
            instaAddPrivacyCheckDesc: "Ich habe die {Privacy} und {Terms and Conditions} gelesen und stimme ihnen zu",
            instaAddDesc5:
                "Klicken Sie unten auf die Schaltfläche Verbinden und melden Sie sich bei Ihrem Facebook-Konto an.",
            instaAddDesc4: "Registrieren Sie sich als Facebook-Entwickler",
            instaAddDesc3:
                "Stellen Sie sicher, dass der <b>'Zugriff auf Nachrichten erlauben'</b>-Schalter aktiviert ist",
            instaAddDesc2: "Stellen Sie sicher, dass Ihr Instagram-Profikonto mit Ihrer Facebook-Seite verbunden ist",
            instaAddDesc1:
                "Stellen Sie sicher, dass Ihr Instagram-Konto ein professionelles Instagram-Konto (Geschäftskonto) ist.",
            selectedDepartment: "Ausgewählte Abteilung",
            departmentForwardEnable: "Abteilungsweiterleitung aktiviert",
            departmentForwardRule: "Abteilungsweiterleitungsregel",
            departmentForwardDesc:
                "Wählen Sie aus, an welche Abteilung eingehende Chats im Kanal weitergeleitet werden sollen.",
            channelName: "Kanalname",
            forwardToLiveAgents: "👉 An Live-Agenten weiterleiten",
            manageIgChannel: "Verwalten Sie Ihren Instagram-Kanal",
            igDetail: "Instagram-Detail",
            manageVisibilityDesc: "Verwalten, wer diesen Kanal sehen kann",
            selectAnIgAccount: "Wählen Sie ein Instagram-Konto aus",
            connectToInsta: "Mit Instagram verbinden",
            connectToMetaLeads: "Connect to Meta Leads",
            deleteInstaChannelInfo: "Möchten Sie den Instagram-Kanal wirklich löschen?",
            instagramChannels: "Instagram-Kanäle",
            suspendedDescription: "Ihr Konto wurde aufgrund unbezahlter Rechnungen gesperrt",
            onlyChatbot: "Nur Chatbot",
            onlyAgents: "Nur Agenten",
            checkboxWarning: "Dieses Feld muss angekreuzt werden",
            sendingAllow: "Senden",
            receiving: "Empfang",
            platform: "Plattform",
            banModalTitle: "Besucher-Sperrbildschirm",
            selectDepartmentDesc: "Wählen Sie die Abteilungen aus, für die Sie die Sichtbarkeit ändern möchten",
            selectAgentDesc: "Wählen Sie die Agenten aus, für die Sie die Sichtbarkeit ändern möchten",
            selectDepartment: "Abteilung auswählen",
            selectAgent: "Agent auswählen",
            visibleDepartments: "Sichtbare Abteilungen",
            visibleAgents: "Sichtbare Agenten",
            visibilityInfoCont: "Alle Agenten und Abteilungen können diesen Kanal sehen",
            editDepartmentVisibility: "Abteilungssichtbarkeit bearbeiten",
            editAgentVisibility: "Agentensichtbarkeit bearbeiten",
            typeSTToSearch: "Geben Sie etwas ein, um nach Benutzern zu suchen",
            exportToCSV: "Als CSV exportieren",
            clear: "Löschen",
            usedSessionCount: "Verwendete Sitzungsanzahl",
            maxSessionCount: "Maximale Sitzungsanzahl",
            leftSessionCount: "Verbleibende Sitzungsanzahl",
            planManagement: "Planverwaltung",
            teamChat: "Team-Chat",
            templateNameIsNotValid: "Vorlagenname ist ungültig",
            relatedAdvertisement: "Entsprechende Werbung",
            whatsappNumber: "WhatsApp-Nummer",
            integrationsWhatsappV1:
                "Für reibungslose Kommunikation zwischen Supsis und WhatsApp ist ein WhatsApp-Plan erforderlich.",
            integrationsWhatsappV2: "Sie können Chat-Informationen leicht zwischen Supsis und WhatsApp übertragen.",
            integrationsWhatsappBusiness:
                "Sie können Chat-Informationen schnell und bequem zwischen Supsis und WhatsApp übermitteln.",
            selectDays: "Tage auswählen",
            addTime: "Zeit hinzufügen",
            instagramContactList: "Instagram Kontaktliste",
            archiveAllRated: "Alle Konversationen mit Bewertungen abrufen.",
            allChannels: "alle Kanäle",
            comment: "Kommentar",
            news: "Was gibt es Neues?",
            conversation: "Teamgespräch",
            speechTermination: "Gespräch beenden",
            noSystemMessage: "Es sind noch keine Nachrichten im System!",
            supsisCustomerService: "Kundenservice von Supsis,",
            supsisClickExperience: "Sie können das Erlebnis ausprobieren, indem Sie darauf klicken.",
            customerPage: "Gehen Sie zur Kundenseite",
            buttonTitle: "Schaltflächentitel",
            buttonType: "Schaltflächentyp",
            buttonSendMessage: "Nachricht senden",
            buttonGoToBlock: "gehe zum Blog",
            buttonOpenUrl: "Öffne URL",
            buttonPhoneCall: "Anruf",
            buttonOpenMoment: "Offener Augenblick",
            buttonCloseChat: "Chat schließen",
            buttonTransferChat: "Chat übertragen",
            buttonCreateTicket: "Ticket erstellen",
            deleteVisitor:
                "Möchten Sie den Benutzer wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
            userProfile: "Profil",
            addCalendarEvent: "Veranstaltung +",
            you: "Du",
            and: "und",
            dndBlocked: "Dateisendeneinstellungen sind geschlossen.",
            tokenCopied: "Der Zugang wurde an Token kopiert.",
            apiIntegration: "Entwickler",
            generateToken: "Produktion von Token",
            copyToken: "Token -Kopie",
            labels: "Etiketten",
            noData: "Kein Inhalt",
            color: "Farbe",
            titleColor: "Titelfarbe",
            secondTitleColor: "Farbe des zweiten Titels",
            tag_name_indicator: "Verlinke den Namen",
            sendMessage: "Nachricht senden",
            removeFromG: "Aus der Gruppe entfernen",
            delChannel: "Möchten Sie diesen Kanal wirklich löschen?",
            new_name: "Neuer Name",
            set_group_info: "Gruppeninformationen bearbeiten",
            shortcut_desc_num: "Wechseln Sie zwischen aktiven Gesprächen mit numerischen Ziffern",
            copilot_desc_num: "Ermöglicht Ihnen, Copilot auf dem Chat-Bildschirm zu öffnen",
            typing_w_chat: "schreibt...",
            edit_group_info: "Gruppeninformationen bearbeiten",
            notif_sound: "Benachrichtigungstöne aktivieren",
            notif_mute: "Benachrichtigungen stummschalten",
            leave: "Verlassen",
            group: "Gruppe",
            updateTag: "Tag aktualisieren",
            ordered_desc: "Weist Chats in der Reihenfolge den Mitarbeitern zu.",
            random_desc: "Weist Chats zufällig den Mitarbeitern zu.",
            Rrobin_desc:
                "Weist Chats den Mitarbeitern im Round-Robin-Verfahren zu. (Bevorzugt die am wenigsten beschäftigten Mitarbeiter)",
            RrobinRev_desc:
                "Weist Chats den Mitarbeitern im umgekehrten Round-Robin-Verfahren zu. (Bevorzugt die am meisten beschäftigten Mitarbeiter)",
            algo_desc: "Wählen Sie den Algorithmus für die automatische Chat-Zuweisung aus",
            algorithm: "Algorithmus",
            os_browser: "Betriebssystem und Browser",
            CHAT: "Plaudern",
            addTag: "Etikett hinzufügen",
            tags: "Etiketten",
            searchRepresentative: "Vertreter suchen",
            preferredRepresentative: "Vertreter",
            voting: "Abstimmung",
            chatWidget: "SUPSIS -Chat -Ballon",
            webhooks: "Webhaken",
            selectHooks: "Wählen Sie Webhaken",
            planRequired: "{integratable} Plan ist erforderlich.",
            allIntegrations: "Alle Integrationen",
            disableAgentSystemMessages: "Repräsentative Systemnachrichten verbergen",
            disableAgentSystemMessagesDesc: "Agentensystemnachrichten ausblenden.",
            disableAutoTranslate: "Auto Translate",
            disableAutoTranslateDesc:
                "It automatically translates messages from different languages. So you can communicate with your customers more easily.",
            shouldAddMethod: "Sie müssen das Feld Zahlungsmethode und Rechnungsadresse ausfüllen!",
            approveSelection: "Bestätigen Sie Ihre Wahl",
            trialDaysEndSelectPlan: "Bestätigen Sie die Planauswahl",
            trialDaysEndSelectPlanDesc:
                "Ihre Testversion ist vorbei. Sie müssen bestätigen, indem Sie den folgenden Plan auswählen.",
            infinitePlay: "Spielen Sie die ganze Zeit",
            hideBubbleOnMobile: "Verstecken Sie sich auf dem Handy",
            deleteSystemLanguage: "{code} Aus dem System löscht die Sprache",
            assignedChat: "Zugewiesener Chat",
            check: "Bestätigungsbox",
            systemStatus: "Systemstatus",
            chatAssignedToUser: "Neues Chat wurde ernannt",
            inactiveThresholdTime: "Passive Chat -Zeit (Minuten)",
            tippyInactiveThresholdTime:
                "Wenn innerhalb der in der Rede angegebenen Zeit keine Nachricht gesendet wird, wird die Rede als passiv angesehen. Geben Sie den Wert ein (Minuten). Mindestens 1 Minuten sollten höchstens 120 Minuten betragen.",
            inactiveTerminateTime: "Passive Chat Schließzeit (Minuten)",
            tippyInactiveTerminateTime:
                "Das Gespräch wird nach der angegebenen Zeit geschlossen. Geben Sie den Wert ein (Minuten). Es sollte mindestens 0 in den meisten 120 Minuten sein.",
            removePendingMessage: "Stornierung",
            disconnected: "Nicht verbunden",
            visitorWriteEmptyChatTippy: "Der Kunde kann schreiben, bevor der Vertreter mit dem Sprechen verbunden ist.",
            visitorWriteEmptyChat: "Der Kunde kann schreiben, ohne den Vertreter zu verbinden.",
            visitorConnectionEventSystemMessageEnabled:
                "Der Verbindungsstatus des Besuchers aktiviert Systemmeldungen.",
            visitorConnectionEventSystemMessageEnabledTippy:
                "Der Besucher links und der Besucher kam zurück und zeigte die Systemmeldungen.",
            openBubble: "Sprechen Ballloom offen",
            showHeaderImage: "Kopfbild anzeigen",
            changeLogo: "Ändern Sie das Logo",
            changePhoto: "Foto ändern",
            addPhoto: "Ein Foto hinzufügen",
            seePhoto: "Siehe das Foto",
            deletePhoto: "Das Foto löschen",
            askQuestion: "Frage stellen",
            locationPermsNeeded: "Die Standortgenehmigung für die Verwendung dieser Funktion erforderlich",
            useMyLocation: "Verwenden Sie meinen Standort",
            acceptingChat: "Der Chat -Kauf ist geöffnet",
            notAcceptingChat: "Chat -Einnahme geschlossen",
            websiteChatWidgetIntegration: "Website -Chat -Ballonintegration",
            loggedOut: "Offline",
            listStatuses: "Situationen",
            hideInactiveAgents: "Passive Vertreter verbergen",
            hideMinorValues: "Kleine Werte verbergen",
            agentActivities: "Repräsentative Aktivitäten",
            newHASHContent: "#Thete hinzufügen",
            hash: "Fahrkarte",
            languageRemovalQuestion: "Sie sind kurz davor, die {code} Sprache aus dem System zu löschen!",
            blockBy: "Vertreter",
            hashText: "Fahrkarte",
            exampleHash: "Bestellentakip",
            notValidHash: "Sollte keinen Lückencharakter enthalten",
            videoCallEnabledDesc: "Aktivieren Sie, um die Video -Suchfunktion zu aktivieren",
            videoCallEnabled: "Video -Suchfunktion",
            audioCallDesc: "Aktivieren Sie, um die Sprachsuchfunktion zu aktivieren",
            audioCallEnabled: "Sprachsuchfunktion",
            assignPreferredAgent: "Bevorzugter Vertreter",
            representativeAssignedToTheVisitor:
                "Wählen Sie den bevorzugten Agenten aus, den Sie dem Besucher zuweisen möchten.",
            agentFileSendEnabledDesc: "Aktiviert die Dateiversenden der Vertreterfunktionen",
            agentFileSendEnabled: "Vertreter können Dateien senden",
            visitorFileSendEnabledDesc:
                "Mit den Besuchern können Sie die Funktion zum Senden von Dateien öffnen und ausschalten",
            visitorFileSendEnabled: "Besucher können Dateien senden",
            visitorAutoLogin: "Besucher automatisch Anmeldung",
            visitorAutoLoginDesc: "Besucherballonklicks klicken, sobald Sie auf die Konversation klicken",
            agentVoiceRecordEnabledDesc: "Ermöglicht die Soundaufzeichnungsfunktion der Vertreter",
            agentVoiceRecordEnabled: "Vertreter können Ton aufnehmen",
            visitorVoiceRecordEnabledDesc: "Ermöglicht die Soundaufzeichnungsfunktion der Besucher",
            visitorVoiceRecordEnabled: "Besucher können Sound aufnehmen",
            startVideoCall: "Videoanruf",
            startAudioCall: "Gesangsanruf",
            visitorGDPRDeleteEnabledDesc: "Mit den Besuchern können Sie alle Informationen öffnen und ausschalten",
            visitorGDPRDeleteEnabled: "Besucher können alle Informationen löschen",
            visitorLocationEnabled: "Besucher können den Standort teilen",
            visitorLocationEnabledDesc:
                "Ermöglicht den Besuchern, die Freigabe der Standort zu öffnen oder zu schließen",
            customerLocationEnabled: "Vertreter können den Standort teilen",
            customerAutoMergeEnabled: "Verschmilzt automatisch die gleichen Personen",
            customerAutoMergeEnabledDesc:
                "Diese Funktion führt eine automatische Zusammenführung durch, um Daten effektiv von denselben Personen zu sammeln. Dadurch werden Benutzer mit ähnlichen Profilen in Datenbeständen konsistenter und geordneter repräsentiert.",
            chatAiCopilot: "Chat KI Copilot",
            chatAiCopilotDesc: "Beantworten Sie automatisch die Fragen Ihrer Kunden mit dem Chat KI Copilot",
            customerLocationEnabledDesc: "Ermöglicht den Vertretern, die Standortfreigabe zu öffnen oder zu schließen",
            triggerAlreadyExists: "Es gibt bereits einen Auslöser für diesen Zustand.",
            ticketStatusForm: "Ticketstatusformular",
            statusFormTitle: "Ticketstatentitel",
            allStatus: "Alle Situationen",
            triggers: "Löst aus",
            trigger: "Abzug",
            noTrigger: "Sie haben noch keinen Auslöser hinzugefügt",
            triggerSkipLoginForm: "Anmeldeformular",
            triggerSkipLoginFormTrue: "Anmeldeformular anzeigen",
            triggerSkipLoginFormFalse: "Anmeldeformular überspringen und direkt zur Nachricht wechseln",
            noContent: "Kein Inhalt",
            toCreate: "Erschaffen",
            clickTheButton: "Drück den Knopf",
            triggerContent:
                "Schreiben Sie die Beschreibung, die Sie im Fenster sehen möchten, das sich öffnet. Schreiben Sie einfach in einer Sprache aus, um automatisch in andere Sprachen zu übersetzen.",
            triggerDrag: "Sie können die Nachrichtenzeit durch Ziehen oder Klicken auf die Leiste festlegen.",
            triggerNewCondition: "Sie können einen neuen Zustand mit Taste hinzufügen.",
            triggerNoConditionDescription1:
                "Sie können die gewünschten Bedingungen aus den Optionen erstellen. Wenn Sie keine Bedingungen für einen Auslöser erstellen, ist der Abzug in erster Linie aktiv.",
            triggerNoConditionDescription2:
                "Auf der Besucherseite ist nur einer der Auslöser mit den gleichen Bedingungen aktiv sichtbar.",
            triggerShowAndHide: "Sie können die Trigger zeigen oder verbergen, wenn Sie zeigen möchten.",
            countryLanguage: "Land/Sprache",
            addTrigger: "Trigger hinzufügen",
            yesPlease: "Ja bitte!",
            noThanks: "Nein danke.",
            firstAnswer: "Frage Dialog positive Antwort",
            secondAnswer: "Frage Dialog negative Antwort",
            noTitle: "Kein Titel",
            sumChat_MediaFile: "Medien und Dokumente",
            importantWarning: "WICHTIGE WARNUNG!",
            images: "Bilder",
            URLS: "Links",
            files: "Dateien",
            warning: "WARNUNG!",
            noCondition: "Nicht nötig! Sie können einen Zustand hinzufügen, indem Sie auf das Plus -Symbol klicken.",
            showTriggers: "Klicken Sie hier, um die Trigger anzuzeigen",
            showThisTrigger: "Klicken Sie hier, um diesen Auslöser anzuzeigen",
            hideTriggers: "Klicken Sie hier, um die Trigger auszublenden",
            hideThisTrigger: "Klicken Sie hier, um diesen Auslöser auszublenden",
            updateTrigger: "Aktualisieren Sie den Auslöser",
            conditions: "Bedingungen",
            messageDurationPerRow: "Nachrichtenzeit für jede Zeile",
            dayTime: "Stunde",
            weekDay: "Wochentag",
            spendTimePage: "Zeit auf der Seite verbracht",
            spendTimeSite: "Zeit auf der Website verbracht",
            pageUrl: "URL",
            pageTitle: "Seitentitel",
            equal: "Gleich",
            not_equal: "Nicht gleich",
            less_than: "Klein",
            greater_than: "Ist toll",
            less_than_or_equal: "Ist klein oder gleich",
            greater_than_or_equal: "Ist groß oder gleich",
            visitorName: "Besuchername",
            seconds10: "10 Sekunden",
            seconds30: "30 Sekunden",
            minute1: "1 Minute",
            minutes5: "5 Minuten",
            minutes10: "10 Minuten",
            minutes30: "30 Minuten",
            hour1: "1 Stunde",
            hours2: "2 Stunden",
            hours4: "4 Stunden",
            hours8: "8 Stunden",
            hours12: "12 Stunden",
            hours24: "24 Stunden",
            maxCondition: "Maximale Situation",
            doYouWishToDeleteTrigger: "Möchten Sie den Abzug löschen?",
            contains: "Enthält",
            not_contains: "Beteiligt",
            chatLanguage: "Sprechsprache",
            translating: "Übersetzung",
            liveSupportStartingWait: "Live -Unterstützung wird begonnen, bitte warten Sie",
            noConnection: "Keine Verbindung!",
            buyWhatsapp: "Kaufen Sie WhatsApp",
            integrations: "Integrationen",
            refundInvoiceSure: "Sind Sie sicher, dass Sie die Rechnung zurückgeben möchten?",
            invoiceMarkedAsPaidSuccess: "Die Rechnung wurde als bezahlt gekennzeichnet.",
            invoiceMarkedAsPaidError: "Der Fehler konnte nicht gekennzeichnet werden, da die Rechnung bezahlt wurde.",
            deleteConfirm: "Möchten Sie dieses {Objekt} wirklich löschen?",
            markPaidConfirm: "Sind Sie sicher, dass Sie diese Rechnung als bezahlt markieren möchten?",
            startChatDesc: "Sprache starten",
            addLink: "Verbindung",
            selectStep: "Wählen Sie einen Schritt aus:",
            addGOTO: "Gehen",
            sendFastLink: "Senden Sie den Anmeldelink ohne Passwort",
            or: "Oder",
            allTags: "Alle Tags",
            showDetail: "Detail anzeigen",
            hideDetail: "Detail ausblenden",
            weLlSendPhone: "Senden wir es an Ihr Telefon",
            weLlSendEmail: "Senden wir eine E-Mail",
            linkSentToPhone: "Der Link wurde als SMS gesendet",
            offerlinkSendToPhone: "Senden wir den Download -Link unserer Bewerbung mit SMS an Sie.",
            offerlinkSendToMail: "Senden wir den Download -Link unserer Bewerbung per Post an Sie.",
            theEmail: "Registrierte Email",
            differentEmail: "Andere E-Mails",
            linkSentToMailBox: "Link an Ihre Mail -Adresse gesendet",
            errorOccurred: "Ein Fehler ist aufgetreten !",
            clickStoreIcon:
                "Sie können die mobile Anwendung erreichen, indem Sie auf das Symbol klicken, das zu Ihrem Telefon passt",
            meetWithSupsis: "Möchten Sie unsere mobile SUPSIS -Anwendung treffen?",
            downloadMobileApps: "Laden Sie die mobile Anwendung herunter",
            getApps: "Bewerbungen erhalten",
            info: "Information",
            conversationHistory: "Sprachgeschichte",
            planInfoHeader: "Informationen planen",
            planInformation:
                "Ihr Plan {selectedPlan} Plan ({detailMaxagentCount} Repräsentant) ({freeAgent} Free Agent)",
            creditAvailable: "Ihr repräsentatives Darlehen in Ihrem Plan:",
            upDownGradePlan: "Wenn Sie Ihren Plan erhöhen/reduzieren möchten, bitte",
            click: "KLICKEN",
            all: "Alle",
            allDepartments: "Alle Abteilungen",
            preferredLanguage: "Bevorzugte Sprache",
            kmkAutoDepartmentBind: "KMK Automatische Abteilungsfindung",
            kmkAutoDepartmentBindDesc:
                "KMK findet den automatischen Speichernamen auf Kundenseiten und setzt ihn auf das Anmeldformular",
            visitorEmailUpdated: "Besucher -E -Mail -Adresse aktualisiert",
            visitorEmailIsNotValid: "Sie haben die E -Mail -Adresse eingegeben, ist nicht korrekt",
            visitorNameUpdated: "Name des Besuchers aktualisiert",
            clickToEdit: "Zum Bearbeiten anklicken",
            addEmail: "+ Fügen Sie die E -Mail -Adresse hinzu",
            addFullname: "+ Name hinzufügen",
            partner: "Ref?",
            isIntegrated: "Integration?",
            agentCount: "Anzahl der Vertreter",
            autoStartChat: "Automatischer Chat -Start",
            bubbleColor: "Chat -Ballonfarbe",
            openFolder: "Hungrig",
            preDefined: "Themen",
            customIcon: "Installieren Sie es von Ihrem Computer aus",
            theme: "Thema",
            themeSettings: "Themen Einstellungen",
            chatThemeSettings: "Chat Designeinstellungen",
            bubbleSettings: "Chat -Balloneinstellungen",
            inputHeightOfBubble: "Ballongröße",
            inputPixelsOfChatBubble:
                "Klicken Sie hier, um die Entfernung des Chat -Ballons an den Rändern zu regulieren",
            modalTitleIsMarginAsPixelInfo: "Die Entfernung des Chat -Ballons zu den Rändern:",
            inputPxOfXaxis: "Horizontale Lage",
            inputPxOfYaxis: "Vertikale Lage",
            inputPxOfMobileXaxis: "(Mobiler) horizontaler Standort",
            inputPxOfMobileYaxis: "(Mobiler) vertikaler Standort",
            animations: "Animationen",
            preferredAnimation: "Bevorzugte Animation",
            selectAnAnimation: "Wählen Sie eine Animation",
            inputOfBubbleMessage: "Fügen Sie Inhalte zu riesigen Chat-Blasen hinzu.\n{contentOfChatBubble} ",
            showChatBubbleOnlyLoggedUserToolTip:
                "Der Chat -Ballon ist die Versteck, abhängig vom Anmeldung der Protokollierung.",
            showChatBubbleOnlyLoggedUser: "Zeigen Sie den Ballon nur dem Benutzer, der sich angemeldet hat. (Ideenoft)",
            helloDoUNeedHelp: "Hallo, ich kann helfen!",
            bubbleIcon: "Chat -Ballonbild",
            overrideMargins: "Passen Sie die Kantenlücken an",
            autoHideBubble: "Verstecke deinen Chat -Ballon",
            vtippyAutoHideBubble: "Vertreter verstecken den Chat -Ballon, während sie online sind",
            hideBubble: "Отключить чат-пузырь",
            vtippyHideBubble: "Отключает пузырь чата.",
            overrideMobileMargin: "Passen Sie Mobile -Versionslücken an",
            vtippyMobileMargin: "Passen Sie den Chat -Ballon -Edge -Rand für mobile Version an",
            vtippyHideBubbleOnMobile: "Der Chat -Ballon ist in Besuchern mit Mobilgeräten versteckt.",
            isFabsActive: "Offene Menüs zeigen",
            bubbleOpenableMenu: "Der Chat -Ballon öffnet das Menü",
            vtippyIsFabsActive: "Es ist die Einstellung von Öffnungsmenüs / Verstecktätigkeiten",
            vtippyIsFabsAsIcon: "Es ist die Einstellung, ob die Symbole in den Pop -UP -Männern erscheinen.",
            vtippyTranslateButton: "Umwandle die ausgewählte Sprache in andere Sprachen.",
            vtippyTranslateClearButton: "Reinigt die Inhalte in anderen Sprachen.",
            vtippySelectnotification: "Sie können Benachrichtigungsklang auswählen.",
            vtippyVoiceLevel: "Sie können die Audioebene festlegen.",
            vtippyStartVoice: "Hören",
            vtippyInfiniteNotification:
                "Die neu angekommenen Chats werden weiter spielen, wenn Sie im Panel nicht aktiv sind. Sie können Active-Passive bearbeiten, indem Sie klicken.",
            vtippyNewVisitorNotification: "Sprachbenachrichtigungseinstellungen für Besucher Ihrer Website.",
            vtippyNewChatNotification:
                "Sprachbenachrichtigungseinstellungen für jeden neuen Chat, der zum System kommt.",
            vtippyNewConversationNotification:
                "Sprachbenachrichtigungseinstellungen für jeden neuen Chat, der Ihnen zugewiesen ist.",
            vtippyNewMessageNotification: "Nachrichtenbenachrichtigungseinstellungen aus den Ihnen zugewiesenen Chats.",
            vtippyPrivateMessageNotification: "Sprachbenachrichtigungseinstellungen für Nachrichten aus der Teamrede.",
            isFabsAsIcon: "Menüsymbole anzeigen.",
            setMarginAsPixel: "Pixel einstellen",
            returnDefaultMargins: "Standardkante Gap -Einstellungen",
            closePreviewColors: "Schließen Sie die Vorschau",
            previewColors: "Öffnen Sie die Vorschau",
            videoCalls: "Videointerviews",
            filterLost: "Entkommene Gespräche",
            vtipyCustomLogin:
                "Wenn Sie Ihre Besucher mit dem System anschließen, können Sie die Informationen hier im Eingabeformular anpassen.",
            vtipyLoginlessChat:
                "Das Anmeldeformular wird nicht angezeigt, wenn Sie Ihre Besucher mit dem System verbinden. Vertreter werden verwendet, indem sie nach den persönlichen Informationen der Besucher fragen.",
            loginlessChat: "Besucheranmeldeformular",
            imageUrl: "Bild",
            replied: "ANTWORTETE",
            solved: "Gelöst",
            openImage: "Hungrig",
            writeFeedback: "Hier können Sie Ihr Feedback zu Supsis schreiben.",
            feedbackFailed: "Während des Feedback -Senders gab es einen Fehler.",
            feedbackSuccessful: "Das Feedback -Senden ist erfolgreich.",
            sendFeedback: "Feedback abschicken",
            errorReport: "Sie können uns Feedback zu den Problemen geben, die Sie mit SUPSıs haben.",
            sendErrorFeedBack: "Geben Sie uns Feedback zu Ihrem Problem.",
            successImgUpload: "Ihr Bild ist erfolgreich Wolle",
            successImgDelete: "Bild wurde erfolgreich gelöscht.",
            errorImgUpload: "Beim Hochladen Ihres Bildes trat ein Fehler auf",
            errorImgDelete: "Beim Löschen des Bildes ist ein Fehler aufgetreten",
            chatBotEndStatics: "Chatbot Sprachabschlussrate",
            videoCallDist: "Videointerviewverteilung",
            deleteSite: "{sitename} kann gelöscht werden?",
            deleteThisSite: "Löschen Sie diese Seite",
            departmentInfo: "Abteilungsinformationen",
            infoAboutDepartment: "Kurze Informationen über die Abteilung",
            deleteDepartmentQuestion: "Möchten Sie diese Abteilung wirklich löschen?",
            departmentDeleted: "Die Abteilung wurde gelöscht",
            departmentTitle: "Abteilungstitel",
            updateDepartmentForm: "Abteilungs -Update -Formular",
            updateCompleted: "Update abgeschlossen",
            CatalogUpdatedSuccessfully: "Erfolgreich aktualisiert",
            integrateSupsiswithIntegratable: "Leicht die Chat Informationen zwischen SUPSIS und {integratable} leiten.",
            installationOK: "Geladen",
            newDepartmentForm: "Neue Abteilungsregistrierungsformular",
            newDepartment: "Neue Abteilung",
            departmentSaved: "Abteilung gespeichert",
            sameDepartment: "Es gibt eine Abteilung mit demselben Namen",
            sameValue: "Es gibt einen Wert mit demselben Namen!",
            sameTag: "Es gibt ein Tag mit diesem Namen!",
            departments: "Abteilungen",
            department: "Abteilung",
            announcements: "Ankündigungen",
            announcement: "Bekanntmachung",
            newAnnouncement: "Neue Ankündigung",
            announcementInfo: "Ankündigungsinformationen",
            infoAboutAnnouncement: "Kurze Informationen über die Ankündigung",
            deleteAnnouncementQuestion: "Möchten Sie diese Ankündigung wirklich löschen?",
            announcementDeleted: "Die Ankündigung wurde gelöscht",
            announcementTitle: "Ankündigungstitel",
            updateAnnouncementForm: "Ankündigungs -Update -Formular",
            newAnnouncementForm: "Neues Ankündigungsformular",
            announcementSaved: "Ankündigung aufgezeichnet.",
            chatTimingSettings: "Chat -Zeiteinstellungen",
            assetOversize: "Die Größe der Datei, die Sie senden möchten, sollte nicht größer als 10 MB sein.",
            assetOversizeMB: "Die Größe der Datei, die Sie senden möchten, sollte {mb} MB nicht überschreiten.",
            assetOversizeWithExt: "Die Dateigröße sollte kleiner als 10 MB und PNG, JPG -Format sein.",
            messageDeleted: "Diese Nachricht wurde gelöscht",
            filterVideoCall: "Zeigt Videogespräche",
            filterLostChat: "Lost Chats Filter",
            filterClosedByAgent: "Filter von repräsentativen Filtern geschlossen",
            notificationText: "Damit SUPSIS -Benachrichtigungen korrekt arbeiten können",
            notificationTitle: "Benachrichtigungen aus",
            deniedText:
                "Ihre Benachrichtigungen sind geschlossen, Sie müssen Ihre Benachrichtigungen öffnen, um Ihre Kunden nicht zu verpassen.",
            deniedTitle: "Klicken Sie hier, um Ihre Benachrichtigungen zu öffnen!",
            deniedHeader: "Um Ihre Kunden nicht zu verpassen, müssen Sie Ihre Benachrichtigungen aktivieren!",
            showNotificationGuide: "Für Einzelheiten anklicken",
            howToEnableNotification: "Wie kann ich Benachrichtigungen aktivieren?",
            notificationOK: "OK",
            notificationUnderstood: "Verstanden!",
            notificationCancel: "Stornieren",
            howToEnableNotificationInstruction1:
                "Klicken Sie in der Adressleiste des Browsers auf das Symbol für Sperre",
            howToEnableNotificationInstruction2:
                'Aktivieren Sie, wenn "Benachrichtigungen" im Abschnitt Genehmigungen passiv zu sein scheinen',
            howToEnableNotificationInstruction3:
                'Wenn "Benachrichtigungen" im Abschnitt Genehmigungen nicht angezeigt werden, klicken Sie auf "Site -Einstellungen".',
            howToEnableNotificationInstruction4:
                'Öffnen Sie die Berechtigung "Benachrichtigungen" aus dem Abschnitt "Genehmigungen" auf der Seite "Site -Einstellungen',
            checkPaymentMethod: "Bitte überprüfen Sie Ihre Zahlungsmethode",
            pushNotificationEnabled: "Großartige Benachrichtigungssendung ist aktiv.",
            pushNotificationDenied: "Sie haben die Benachrichtigungsgenehmigungen abgelehnt",
            suspendedMessage: "Ihr Konto wurde gesperrt",
            enableNotification: "Öffnen Sie Ihre Benachrichtigungen.",
            languageSettings: "Sprechsprache",
            problemsSound:
                'Wenn Sie Probleme mit den Benachrichtigungen haben, klicken Sie auf das Sperrsymbol der Adressleiste Ihres Browsers (im Bild angezeigt) und klicken Sie auf das Feld "Site -Einstellungen" und ändern Sie die "Audio" aus dem geöffneten Abschnitt.',
            betweenRepresentative: "Die neue Nachricht eines Vertreters.",
            desktopNotifications: "Benachrichtigungen",
            notificationDisable:
                "Sie können die Desktop -Benachrichtigungen aus den repräsentativen Einstellungen schließen.",
            notificationEnabled: "SUPSIS -Benachrichtigungen sind aktiv.",
            newMessageAlert: "Du hast eine neue Nachricht.",
            newConversationAlert: "Sie haben ein neues Gespräch.",
            chatBot: "Chatbot",
            ticketResponse: "Repressive Antwort:",
            archived: "Mit Archiven",
            chatbotChatCount: "Chatbot",
            closeChat: "Beende die Nachrichten",
            ticket: "Tick",
            formStep: "Formschritt",
            menuStep: "Menüschritt",
            contentStep: "Inhaltsschritt",
            menuTitle: "Menükopf",
            messageContent: "Nachrichteninhalt",
            goToLive: "Übertragung zum Vertreter",
            prevStep: "Kehren Sie zu meinem vorherigen Schritt zurück",
            button: "Taste",
            addImage: "Bild",
            addText: "Text",
            stepTitle: "Schritt Titel",
            addTicket: "Tick",
            formDescription: "Frage",
            addInput: "Frage",
            addRandomText: "Zufälliger Text",
            changeTitle: "Ändern Sie den Titel",
            changeVisitorTitle: "Besuchertitel ändern",
            catalog: "Katalogentitel",
            openTheCatalog: "Öffnen Sie den Katalog",
            catalogNotOpen:
                "Die Katalogfunktion ist deaktiviert. Sie können die Catalok -Funktion öffnen, um Ihren Kunden vorbereitete Inhalte zu unterstützen.",
            showCatalogCategories: "Ändern Sie den Status des Erscheinens im Chat -Ballon des Katalogmenüs.",
            showChatBot: "Ändern Sie den Zustand des Erscheinens im Chat -Ballon des Chatbot -Menüs.",
            openCatalog: "Katalog",
            unreadMessages: "Ungelesene Beiträge",
            personalFirstMsg: "Repräsentant erster Reaktionszeitdurchschnitt (SN)",
            personalRating: "Personal Score ORT.",
            soundSettings: "Benachrichtigungseinstellungen",
            newPrivateMessage: "Private Nachricht",
            addNewGroup: "Eine neue Gruppe erstellen",
            newMessage: "Neue Nachricht",
            newConversation: "Neuer Chat",
            newVisitor: "Neuer Besucher",
            chatPosition: "Chat -Standort",
            bottomLeftCorner: "untere linke Ecke",
            leftDocked: "links angedockt",
            bottomRightCorner: "untere rechte Ecke",
            rightDocked: "rechts angedockt",
            chatPositionSelect: "Ort auswählen",
            teamChatGroup: "Gruppennachrichten",
            teamChatDepartment: "Nachrichten der Abteilung",
            teamChatTeam: "Team-Nachrichten",
            teamChatDm: "DM Nachrichten",
            bottomLeft: "Unten links",
            left: "Linkshändig",
            bottomRight: "Rechts unten",
            right: "Rechts -old",
            mailorname: "E-Mail oder Name",
            breaksByTime: "Schimmelpilzzahlen",
            clPlaceholder: "Der Name erscheint in Kundenform",
            fieldName: "Schlüsselname",
            value: "Wert",
            addSetting: "Fügen Sie eine neue Einstellung hinzu",
            globalSettings: "Allgemeine Einstellungen",
            target: "Lastprüfung",
            duration: "Lasttestzeit (SN)",
            arrivalCount: "Anzahl der Bots (Stück)",
            bootMaxLife: "Standzeit eines Bots (SN)",
            startLoadTest: "Starten Sie den Lasttest",
            noClusterInstanceFound: "Der Server nicht gefunden",
            stopLoadTest: "Beenden Sie den Lasttest",
            integrationDesc: "Fügen Sie einfach den folgenden Codes für einen Zeilen hinzu.",
            integrationDemoCode: "Beispielintegration Demo Code",
            integrationWindow: "Wie integriere ich meine Website?",
            notIntegrated: "Integration",
            help: "Hilfe",
            notIntegratedDesc:
                "Wir haben festgestellt, dass Sie das Chat -System nicht zu Ihrer Website hinzugefügt haben. Wenn Sie sich in Ihre Website integrieren und das erste Interview starten, haben Sie die Integration abgeschlossen. Klicken Sie auf den Integrationscode",
            backToLogin: "Nochmal anmelden",
            passwordlessLoginUnsuccessful: "Eintrag fehlgeschlagen.",
            passwordlessLogin: "Eindringung des Eintritts",
            loginWithEmail: "Melden Sie sich mit E -Mail an",
            loginWithPassword: "Melden Sie sich mit Passwort an",
            enteringPasswordless: "Der Eintrag erfolgt ohne Passwort ...",
            toMainPath: "Richtung zur Homepage",
            userRoleChanged:
                "Ihr Benutzergenehmigungen haben sich geändert. Sie werden auf die Hauptseite verwiesen, um fortzufahren.",
            passwordChangeSuccess: "Ihr Kennwortänderungsprozess ist erfolgreich ...",
            feedback: "Rückmeldung",
            showFeedbackHistory: "Feedback Senden Nachrichten anzeigen.",
            newSelfServiceSite: "Neue Self -Service -Site",
            subdomain: "Sub -Domain -Name",
            rootUserEmail: "Benutzer Email",
            rootUserName: "Ihren Namen",
            newVersion: "Neue Version verfügbar",
            closeLiveSupport: "Schließende Live -Unterstützung",
            newVersionShort: "Neue Version",
            bannedWordRestrict: "Verbotenes Wort Blockieren",
            ticketShow: "Erlauben Sie Kunden, Tickets zu erstellen",
            ticketShowDesc: "Aktivieren Sie die Option zur Ticketerstellung im Chat-Menü",
            autoLoadIframe: "Live -Verkehr",
            autoLoadIframeDesc: "Iframe lädt automatisch den gesamten Besucherverkehr",
            bannedWordRestrictDesc:
                "Wenn das verbotene Wortblockieren geöffnet ist, wird der Vertreter daran gehindert, den Besuchern verbotene Wörter zu schreiben.",
            agentDown: "Vertreter fiel",
            delayChat: "Verzögerte Konversation",
            tableSettingTippy: "Sie können die Informationen in der Tabelle von hier aus ändern.",
            tableSettings: "Tisch Einstellungen",
            tableSettingsInfo:
                "Sie können die Informationen in der Tabelle von hier aus ändern. Sie können bis zu 7 Spalten auswählen",
            privateParametry: "Benutzerdefinierte Benutzerparameter",
            systemOperetor: "System Information",
            cityAndDistrict: "Stadtteil",
            general: "Allgemein",
            availability: "Repräsentative Arbeitszeit",
            home: "Startseite",
            successful: "Erfolgreich",
            forgetPasswordSent: "Das Passwort Reset Mail wurde gesendet. Überprüfen Sie Ihre E-Mail.",
            saturday: "Samstag",
            friday: "Freitag",
            thursday: "Donnerstag",
            wednesday: "Mittwoch",
            tuesday: "Dienstag",
            monday: "Montag",
            sunday: "Sonntag",
            download: "Laden Sie die Datei herunter",
            calendarPassedTimeHour: "{hour} clock {name}",
            calendarPassedTime: "{hour} clock {min} min {name}",
            calendarPassedTimeMinSec: "{min} min {sec} sec {name}",
            calendarPassedTimeMin: "{value} dk {name}",
            calendarPassedTimeSec: "{hour} clock {min} min {sec} sn {name}",
            workScheduleOneDay: "{name} 'S {sDate} Day Work Calender",
            workSchedule: "{name} namens {sdate} - {edate}",
            calendar: "Kalender",
            noRating: "Es wurde keine Wertung erzielt",
            rateDist: "Bewertungsverteilung",
            distConversation: "Redeverteilung durch Vertreter",
            distributionConversa: "Punkteverteilung",
            distChatbotAgent: "Kommunikationskanäle",
            distAgent: "Chatbot & Agent",
            distFugitive: "Verpasste Rede und empfangene Rede",
            distLive: "Live-Chat",
            distChatbot: "Chatbot",
            distComplex: "Chatbot & Live-Chat",
            distHandled: "Chat beantwortet",
            distMissed: "unbeantworteter Chat",
            distWeb: "Webseite",
            distWhatsapp: "Whatsapp",
            distTelegram: "Telegram",
            distInstagram: "Instagram",
            totalWhatsappChatCount: "WhatsApp -Anzahl der Chats",
            statsByTime: "Anzahl der spricht rechtzeitig",
            selectRep: "Wählen Sie einen Vertreter",
            allRepresentatives: "Alle Vertreter",
            avgRating: "Punktverteilung ({punkt}) ({count} Evaluation)",
            avgFirstMessageTime: "Die durchschnittliche erste Zeit",
            totalBreakTime: "System Break -Zeit",
            totalBreakNum: "Anzahl der Molain",
            averageConTime: "Durchschnittliche Sprachzeit",
            multiWpReportTitle: "Mehrere WhatsApp-Konversationsnummern",
            multiWpReport: "Anzahl mehrerer WhatsApp-Chats",
            multiWpReportExplanation: "Sie können die Chat-Anzahl Ihrer Multi-WhatsApp-Kanäle sehen.",
            longestConTime: "Längste Gesprächszeit",
            shortestConTime: "Kürzeste Sprachzeit",
            refresh: "Aktualisierung",
            waitingReply: "Auf eine Antwort warten",
            organizationName: "Organisationsname",
            companySlogan: "Langer Name der Organisation",
            messageSentErr: "Keine Nachricht konnte nicht gesendet werden, versuchen Sie es erneut.",
            messageSent: "Die Nachricht wurde gesendet.",
            openPrivateChat: "Öffnen Sie das Gespräch zwischen Vertretern",
            escKey: "Aktive Konversation verbergen",
            archiveChatKey: "Ermöglicht es Ihnen, am Chat unten auf der Archivseite teilzunehmen.",
            chatCopilot: "Aktiviert Chat CoPilot",
            privateChat: "Konversationspanel zwischen Vertretern",
            multiModeAlertDesc:
                'SUPSIS ist in einem anderen Fenster geöffnet. Klicken Sie in diesem Fenster auf "Verwenden Sie hier", um SUPSIS zu verwenden.',
            useHereText: "Verwenden Sie es hier",
            brandVisibility: "SUPSIS -Brand -Label erscheint im Chat -Ballon",
            focusInput: "Konzentrieren Sie sich auf das Schreibfeld der Active Rede von Cursor",
            send: "Schicken",
            notYet: "Noch nicht",
            sending: "Gesendet",
            onlyRepresentative: "Ihre Nachricht wird nur von Vertretern gesehen.",
            yourMessage: "Ihre Nachricht",
            liveFabListDescription: "Live Support",
            messengerIntegrationDesc:
                "Chatten Sie mit Ihren Kunden über die Facebook-Seite, senden Sie automatisierte Nachrichten mit Chatbot.",
            checkDepartmentToAgent: "Abteilung auf Online-Agenten überprüfen",
            ifAllOfflineStory: "Story zur Weiterleitung, wenn alle offline sind",
            AssignMessagesToAgents: "Alle Nachrichten den Agenten zuweisen",
            firstChatbotAndAssign: "Zuerst antwortet der Chatbot und weist dann einem Agenten zu",
            hybridAssign:
                "Das System überprüft die Abteilung, um zu sehen, ob ein Online-Agent vorhanden ist, und weist es bei fehlendem Online-Agenten dem Chatbot zu.",
            ticketFabListDescription: "Tick",
            whatsappFabListDescription: "WhatsApp",
            phoneFabListDescription: "Telefon",
            emailFabListDescription: "Email",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Twitter",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "Youtube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "Sie können den Link Ihres {channelLink} -Kanals auf diesem Feld einsetzen.",
            typeYourAccountLink: "Sie können den Link Ihres {accountLink} -Konto in diesem Feld einfügen.",
            typeYourMessage: "Schreibe deine Nachricht hier",
            typeYourMessageMail:
                "Die in diesem Feld eingegebene Nachricht wird als erste Nachricht an die oben genannte E -Mail -Adresse gesendet.",
            typeYourMessageDesc:
                "Die in diesem Feld eingegebene Nachricht wird vom Kunden als erste Nachricht an die oben genannte Telefonnummer gesendet.",
            sendNumber: "Telefonnummer zum Senden der Nachricht: {path}",
            callNumber: "Telefonnummer zu Ihrem Kundenanruf: {phoneNumber}",
            numberIsNotCorrect: "Die fehlende Nummer wurde eingegeben !!",
            emailIsNotCorrect: "E-Mail ist falsch!",
            selectFab: "Wählen Sie eine Fabrik",
            notValid:
                "Sie können nur den Brief (ein Zeichen) eingeben. E, d, f, z, a, x, c, v, w, t, n Buchstaben sind ungültig",
            forMacUsers: "Mac -Benutzer können den Schlüsselsteuerschlüssel verwenden",
            basePriceValue: "Minimaler Preis",
            basePriceDiscount: "Rabatt",
            basePriceCurrency: "Währung",
            customerDBEnabled: "Datenbankauswahl: Verwenden Sie den eigenen Datenbankserver des Kunden",
            customerDBDisabled: "Datenbankauswahl: Verwenden Sie die SUPSIS -Datenbank Sucunus",
            mongoConnectionString: "Mongo -Verbindung",
            whatsappBasePriceValue: "WhatsApp -Grundpreis",
            whatsappPlusBasePriceValue: "WhatsApp plus Grundpreis",
            instagramBasePriceValue: "Instagram -Grundpreis",
            instagramPlusBasePriceValue: "Instagram plus Grundpreis",
            clientAddress: "Kundenadresse",
            customerClientAddress: "Kundenkundenadresse",
            apiAddress: "API -Adresse",
            socketAddress: "Sockeladresse",
            backendAddress: "Backend -Adresse",
            panelLogoUrl: "Panel -Logo -Adresse",
            panelCustomCssUrl: "Spezialpanel CSS -Adresse",
            customerLogoUrl: "Kundenlogo -Adresse",
            customerCssUrl: "Kunden -CSS -Adresse",
            siteAlias: "Standortname",
            language: "Sprache",
            features: "Merkmale",
            interactionPopularity: "Popularität von Interaktionen",
            interactionCount: "Anzahl der Interaktionen",
            uniqueUserCount: "Anzahl der eindeutigen Benutzer",
            allUserPercentage: "(%) Prozent aller Benutzer",
            represantativeSettings: "Repräsentative Einstellungen",
            documentTitle: "Verdächtigungsformular",
            supsisDocument: "Verdachtsdokument",
            ApiDoc: "API-Dokumentation",
            chatBalloonTehemeSettings: "Chat -Ballon- und Themeneinstellungen",
            customLoginFormSettingsTitle: "Passen Sie das Besucheranmeldeformular an",
            addNewField: "Neues Feld hinzufügen",
            editField: "Bearbeitungsfeld",
            typeHere: "Geben Sie hier ein",
            pco: "PCO",
            perPage: "/Buchseite",
            perPageInFilter: "Stück",
            noUserInfoFound: "Keine Benutzerinformationen gefunden",
            startFilter: "Fang an zu suchen",
            showMyChats: "Zeigen Sie mir die zugewiesenen",
            showOnlineAgents: "Nur online zeigen",
            showWaitingChats: "Repräsentative zeigen diejenigen, die erwarten",
            addNewStatus: "Status hinzufügen",
            newTitleContent: "Titel hinzufügen",
            roleName: "Rollenname",
            error: "Fehler",
            contentType: "Inhaltstyp",
            contentTitle: "Inhaltstitel",
            newSiteForm: "Neues Standortregistrierungsformular",
            updateSiteForm: "Site -Update -Formular",
            newBannedWordForm: "Neues Registrierungsformular für verbotenes Wort",
            updateBannedWordForm: "Formular für verbotenes Wort Update",
            newWelcomeMessageForm: "Neues Begrüßungsmeldungsformular",
            updateWelcomeMessageForm: "Formular zur Systemmeldung Aktualisierung",
            newDefaultContentForm: "Neues Bereitschafts -Inhaltsregistrierungsformular",
            updateDefaultContentForm: "Formular für das Ready Content -Update",
            newSubjectForm: "Neues Fachregistrierungsformular",
            updateSubjectForm: "Formular des Betreff -Update",
            showIntro: "Einführung zeigen",
            showChatColorMeaning: "Chatfarben",
            options: "Optionen",
            resetPassword: "Aktualisieren Sie das Passwort",
            audioLevel: "Sprachwarnschall Level",
            privateChatNotificationSound: "Benachrichtigungston",
            continue: "Weitermachen",
            newRoleForm: "Neues Rollenregistrierungsformular",
            updateRoleForm: "Rollen -Update -Formular",
            newUserForm: "Neues Benutzerregistrierungsformular",
            updateUserForm: "Benutzer aktualisieren",
            changeOSRForm: "Ändern Sie die Offline -Nachricht",
            tooltipOSRForm: "Sie können die Offline -Nachricht ändern.",
            newOSRForm: "Offline -Support -Formular",
            newOSRMessages: "Fügen Sie Offline -Post hinzu",
            newOsrMessageTitle: "Offline -Nachrichtentitel",
            updateOSRForm: "Offline -Update -Formular",
            osrTitle: "Titel",
            osrTitleDescription: "Sie können den Titel des Offline -Support -Formulars hinzufügen",
            osrContent: "Inhalt",
            osrContentDescription: "Sie können nicht -Online -Support -Formularinhalte hinzufügen",
            hello: "Hallo Welt",
            date: "Geschichte",
            startDate: "Anfangsdatum",
            finish: "Beenden",
            start: "Anfang",
            search: "Suchen",
            endDate: "Endtermin",
            representative: "Vertreter",
            representative_: "Vertreter",
            star: "Stern",
            filter: "Filter",
            reset: "ZURÜCKSETZEN",
            dailyChatList: "Tägliche Sprachliste",
            dailyChatDuration: "Tägliche Sprachzeit",
            chatDuration: "Sprachzeit",
            dailyChatGraph: "Tägliche Gesprächsgrafik",
            ok: "OK",
            cancel: "aufgeben",
            chatCount: "Anzahl der Reden",
            shortest: "Kürzeste",
            longest: "Die längste",
            average: "Durchschnitt",
            count: "Stück",
            averagePoint: "Durchschnittliche Punktzahl",
            pointDist: "Bewertungsverteilung",
            point: "Punkt",
            filters: "Filter",
            totalCustomer: "Totaler Kunde",
            avResponseTime: "Abdeckung. Die erste Interventionszeit",
            breakDuration: "Pause",
            breakCount: "Bruch",
            active: "Aktiv",
            passive: "Passiv",
            userForm: "Benutzerform",
            startChat: "Chat beginnen",
            sender: "Absender",
            profile: "Profil",
            name: "Name",
            number: "Nummer",
            username: "Nutzername",
            updateUserName: "Benutzername aktualisieren",
            email: "Email",
            password: "Passwort",
            oldPassword: "Altes Passwort",
            newPassword: "Neues Kennwort",
            passwordAtLeast: "Passwort (mindestens {num} Zeichen)",
            passwordRepeat: "Passwort erneut",
            changePassword: "Kennwort ändern",
            status: "Situation",
            enableState: "Aktiv?",
            douYouWishToDeleteUser: "Möchten Sie diesen Benutzer wirklich löschen?",
            douYouWishToDeleteAnnouncement: "Möchten Sie diese Ankündigung wirklich löschen?",
            userDeleted: "Benutzer gelöscht",
            userSaved: "Benutzer gespeichert.",
            oldPasswordError: "Das alte Passwort ist falsch. Bitte überprüfen Sie.",
            chooseAnOption: "Bitte wählen Sie Ihren bevorzugten Benachrichtigungs -Sound aus.",
            userVolumeUpdated: "Die Schallanpassung wurde aktualisiert.",
            save: "Speichern",
            update: "Aktualisieren",
            addNewMenu: "Neues Menü hinzufügen",
            addNewContent: "Neue Inhalte hinzufügen",
            pleaseTitleEnter: "Bitte geben Sie den Titel ein",
            like: "Anerkennung",
            disLike: "Ungnade",
            users: "Benutzer",
            visitor: "Besucher",
            allContacts: "Alle Links",
            allUsers: "Alle Vertreter",
            allSites: "Alle Standorte",
            newUser: "Neuer Benutzer",
            noNewUser: "Es gibt noch keinen Benutzer.",
            noNewAdminUser: "Es gibt noch keinen Administratorbenutzer.",
            noNewAnnouncement: "Es gibt noch keine Ankündigung.",
            noRoleFound: "Es gibt noch keine Rolle.",
            noBannedWordFound: "Es gibt noch kein Verbot.",
            noWelcomeMessageFound: "Noch keine Systemnachricht.",
            noSubjectFound: "Es gibt noch kein Thema.",
            noVisitorFound: "Der Besucher wurde nicht gefunden.",
            noContactFound: "Der Leitfaden wurde nicht gefunden.",
            sendResponse: "Antwort schreiben",
            delete: "Löschen",
            duplicate: "Kopieren",
            makeDefault: "Machen Sie den Standard",
            checkMore: "Mehr",
            useReadyTemplates: "Verwenden Sie Bereitschaftsvorlagen",
            noRePresentativeFound: "Der Vertreter wurde nicht gefunden.",
            noLiveSupportFound: "Es gibt noch keine Live -Support -Aufzeichnungen.",
            noLiveSupportFoundWithDepartment: "Es gibt keine Chat -Aufzeichnung der Abteilung",
            noBannedVisitorFound: "Es gibt noch keine verbotenen Besucher.",
            removeBanDescription: "Das Verbot entfernen",
            editThisItem: "Aktualisieren Sie diesen Datensatz",
            removeThisItem: "Löschen Sie diesen Datensatz",
            role: "Rolle",
            newRolePlaceHolder: "Klicken Sie hier, um eine neue Rolle hinzuzufügen ...",
            autoChatAssignLimit: "Automatische Sprachzuweisungsgrenze",
            chatAssignInfo:
                "-1 = Systemannahme, 0 = kein Termin erfolgt,> 0 = Zuweisung ist bis zum angegebenen Wert bestanden.",
            relatedDepartments: "Die zuständigen Abteilungen",
            subjectInfo: "Alle Probleme sind zulässig, wenn das Thema nicht ausgewählt ist.",
            archive: "Archiv",
            offlineSupportRequests: "Offline -Unterstützung",
            offlineModeMessage: "Offline -Nachricht",
            offlineMode: "Offline-Modus",
            first: "Erste",
            last: "Ende",
            query: "Fang an zu suchen",
            clean: "Sauber",
            loading: "Wird geladen",
            loadMore: "Lade mehr hoch",
            noMessage: "Es gibt keine Nachricht ...",
            selectChat: "Wählen Sie Sprache",
            noMessageInChat: "In dieser Rede wurde keine Nachricht gefunden",
            noMediaToShow: "Keine Medien zu zeigen",
            firstSeen: "Zum ersten Mal gesehen",
            userInfo: "Nutzerinformation",
            chatId: "Sprachausweise",
            visitorId: "Besucher-ID",
            visitingPage: "Besuchte Seite",
            osAndBrowser: "Betriebssystem und Browser",
            customerClientVersion: "Kundenversion",
            visitorFeedback: "Kundenbewertung",
            notes: "Notizen",
            nameSurname: "Vorname Familienname",
            chats: "Reden",
            bannedVisitors: "Verbotte Besucher",
            country: "Land",
            city: "Stadt",
            cityDistrict: "Provinzbezirk",
            browser: "Scanner",
            os: "Betriebssystem",
            ipAddress: "IP Adresse",
            connectionDate: "Verbindungszeit",
            transaction: "Verfahren",
            banRemoved: "Die Blockierung wurde entfernt.",
            bannedWords: "Verbotene Worte",
            newBannedWord: "Neues verbotenes Wort",
            noBannedWord: "Es gibt noch kein Wort mit Behinderungen.",
            bannedWordForm: "Verbotene Wortform",
            word: "Wort",
            bannedWordAndWordGroup: "Verbotte Wort / Wortgruppe",
            doYouWishToDeleteBannedWord: "Möchten Sie dieses verbotene Wort wirklich löschen?",
            doYouWishToOfflineSupportRequest: "Möchten Sie diese Nachricht löschen?",
            bannedWordSaved: "Verbotenes Wort aufgezeichnet",
            deletedSuccessfully: "Erfolgt gelöscht",
            deleteErrorMsg: "Das Löschen des Prozesses konnte nicht realisiert werden, versuchen Sie es erneut",
            socketError: "Sochete Connection Problem. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut",
            socketConnecting: "Die Verbindung wird mit dem Server hergestellt",
            offlineModeDescription: "Das System ist geschlossen, Kunden können nicht auf Live -Support zugreifen.",
            offlineModeSettingsDescription: 'Überprüfen Sie im Menü Einstellungen die Funktion "Offline -Modus".',
            offlineModeUser: "Das System muss mindestens ein Online -Vertreter sein.",
            adminCannotConnectSocket: "Administratoren können nicht mit der Steckdose verbunden werden.",
            liveSupport: "Live Support",
            siteVisitors: "Site -Besucher",
            visitors: "Besucher",
            thoseConnectedToLiveSupport: "Diejenigen, die mit Live -Unterstützung verbunden sind",
            visitorHistory: "Besuchergeschichte",
            visitorHistoryDescription: "Sie können den Besucher-Chat-Verlauf anzeigen und herunterladen.",
            privateMessage: "Private Nachricht",
            addRepresentative: "Vertreter hinzufügen",
            forwardRepresentative: "Anweisung zum Vertreter",
            keyboardShortcuts: "Tastatürkürzel",
            chatColorMeanings: "Sprachfarbe Bedeutungen",
            connLostCheckInternet:
                "Ihre Verbindung ist gebrochen. Bitte stellen Sie sicher, dass Sie eine Internetverbindung haben.",
            wishToEndThisChat: "Möchten Sie dieses Treffen beenden?",
            defaultContents: "Bereites Inhalt",
            contents: "Inhalt",
            newDefaultContent: "Neue Bereitschaftsinhalte",
            newCTRLContent: "Fügen Sie Strg -Inhalt hinzu",
            newALTContent: "Fügen Sie den Sub -Conontent hinzu",
            newTABContent: "Registerkarte Inhalt hinzufügen",
            title: "Titel",
            shortcutChar: "Verknüpfungscharakter",
            pickOne: "Wähle eins",
            writeSomething: "Schreiben Sie einen Charakter (a-z | 0-9)",
            letterSequence: "Briefreihe",
            exampleText: "Beispiel: fut -> Fußball",
            anyChar: "Jeder Charakter",
            shorcutKey: "Tastenkürzel",
            content: "Inhalt",
            shortcutName: "Verknüpfungsname",
            type: "Medizin",
            shortcut: "Abkürzung",
            deleteContentQuestion: "Möchten Sie diesen in den Bereit sich hergestellten Inhalt wirklich löschen?",
            defaultContentDeleted: "Bereites Inhalt wurde gelöscht.",
            defaultContentSaved: "Ready -hergestellte Inhalte aufgezeichnet.",
            defaultContentForm: "Bereitete Inhaltsform",
            titleContentForm: "Title in Content",
            contentMoved: "Der Inhalt wurde verschoben.",
            cannotMoveFullParent: "Sie können dieses Element nicht tragen",
            yourEmail: "E-Mail-Addresse",
            yourName: "Ihr Name und Nachname",
            lostPassword: "Ich habe mein Passwort vergessen",
            login: "Eingang",
            forgotPassword: "Ich habe mein Passwort vergessen",
            multipleSession: "Sie haben sich irgendwo anders angemeldet.",
            notAuthorizedToDisplayPage: "Sie haben keine Erlaubnis, diese Seite anzuzeigen!",
            permissions: "Genehmigung",
            newPermission: "Neuer Urlaub",
            permissionForm: "Erlaubnis von",
            displayTitle: "Bildgebungstitel",
            key: "Taste",
            keyToUseInSystem: "Der Schlüsselwert, der im System verwendet werden soll",
            deletePermissionQuestion: "Möchten Sie diese Erlaubnis wirklich löschen?",
            permissionDeleted: "Die Erlaubnis wurde gelöscht.",
            permissionSaved: "Erlaubnis wurde aufgezeichnet.",
            newRole: "Neue Rolle",
            selectARole: "Wählen Sie eine Rolle",
            yes: "Ja",
            no: "NEIN",
            fullAuth: "Volle Autorität",
            roleDeleted: "Die Rolle wurde gelöscht.",
            roleSaved: "Die Rolle wurde aufgezeichnet.",
            roleForm: "Rollenform",
            roles: "Rollen",
            settings: "Einstellungen",
            selectTopic: "Abteilungsauswahl",
            autoCallTransfer: "Automatische Interviewübertragung",
            customerTyping: "Benutzer schreiben",
            typing: "Er schreibt",
            agentTyping: "Vertreter schreibt",
            disconnectTime: "Kündigungszeit (SN)",
            tippyDissconnectTime:
                "Passt das Gespräch in der immer noch Situation nach wie vielen Sekunden an, die geschlossen werden wird",
            queueNumberVisibleFeature: "Zeigen Sie die Anzahl der Personen, die im Einklang mit dem Besucher warten",
            privateChatEnabled: "Chat zwischen Vertretern zeigen",
            delayedTalkTime: "Verzögerungszeit (SN)",
            employeeAverageChatCount: "Durchschnittliche Anzahl von Reden für das Personal -Chat -Verhältnis",
            customerDownTimeWhenRepExit: "Als der Vertreter ausgeht, verschwendete der Kunde Zeit (Mr.)",
            autoAssignLimit: "Automatische Zuordnungsgrenze",
            wasted: "V Verschwendung Zeit (SN)",
            settingsSaved: "Einstellungen aufgezeichnet.",
            settingsCannotSaved: "Einstellungen können nicht gespeichert werden",
            noAuthorization: "Keine Berechtigung",
            warningBadInput: "Es wird empfohlen, eine Zahl zwischen 0 und 70 einzugeben.",
            warningBadInputMarginY: "Warnung vor dem Auftritt der vertikalen Seitenhauptstadt ⚠️",
            warningBadInputMarginX: "Warnung vor dem Eingang des horizonalen Kapitals ⚠️",
            warningBadInputBubbleSize: "Warnung vor Ballongrößeneintrag ⚠️",
            settingFormWrong: "Die Daten, die Sie eingeben, sind falsch, überprüfen und versuchen Sie es erneut",
            delayTime: "Zeitverzögerungszeit (Mr.)",
            sites: "Standorte",
            newSite: "Neue Seite",
            noSiteYet: "Es gibt noch keine Website.",
            siteAddress: "Website-Adresse",
            turnBack: "Zurückdrehen",
            customerRepLimit: "Kundenvertreterlimit",
            siteSaved: "Die Seite wurde gerettet.",
            siteSaveError: "Es gab einen Fehler beim Erstellen einer Website.",
            subjects: "Themen",
            newSubject: "Neues Thema",
            noSubject: "Es gibt noch kein Thema.",
            subject: "Thema",
            subjectTitle: "Thementitel",
            description: "Erläuterung",
            infoAboutSubject: "Kurze Informationen zum Thema",
            deleteSubjectQuestion: "Möchten Sie dieses Thema wirklich löschen?",
            subjectDeleted: "Das Thema wurde gelöscht",
            subjectSaved: "Das Thema wurde gerettet.",
            osrFromMessageSaved: "Offline -Nachricht aufgezeichnet.",
            welcomeMessages: "Systemmeldungen",
            newWelcomeMessages: "Neue Begrüßungsnachricht",
            noWelcomeMessage: "Noch keine Systemnachricht.",
            welcomeMessageContent: "Systemnachrichteninhalt",
            makeChoice: "Entscheide dich ...",
            welcomeMessage: "Willkommensnachricht",
            repLoggedIn: "Vertreter unterzeichnet",
            loginMessage: "Signiernachricht",
            message: "Nachricht",
            deleteWelcomeMessageQuestion: "Möchten Sie diese Systemnachricht wirklich löschen?",
            welcomeMessageDeleted: "Systemnachricht gelöscht",
            welcomeMessageSaved: "Die Systemmeldung wurde aufgezeichnet.",
            welcomeMessageForm: "Systemnachrichtenformular",
            noRep: "Es gibt noch keinen Vertreter.",
            addChat: "Fügen Sie das Interview hinzu",
            forwardChat: "Leiten Sie das Interview",
            ago: "Vor",
            repName: "Repräsentativer Name",
            lastOnline: "Letzte Verbindung/Online -Zeit",
            lastStatusChange: "Letzte Falländerung",
            activeChat: "Aktive Rede",
            userMaxCapacity: "Max Chat -Kapazität",
            noActiveChat: "Keine aktive Rede.",
            watch: "BETRACHTEN",
            join: "VERBINDEN",
            open: "Öffne das Gespräch",
            directMessage: "PRIVATE NACHRICHT",
            block: "BLOCK",
            transactions: "Transaktionen",
            informations: "Informationen",
            visitStart: "Beginn des Besuchs",
            fullName: "Name und Nachname",
            waitChatTime: "Wartezeit/Chatzeit",
            blockUserConfirm: "Möchten Sie diese Person wirklich verhindern?",
            messaging: "Nachrichten",
            hideChat: "Verstecke das Gespräch",
            block_: "Block",
            privateMessage_: "Geheime Botschaft",
            assignRep: "Repräsentant ATA",
            joinChat: "Einbeziehung im Gespräch",
            forwardRep: "Orientierungshilfe",
            leaveChat: "Verlassen Sie das Interview",
            endChat: "Beenden Sie das Treffen",
            translatedTextDescription: "Amazon hat diese Nachricht {from} -> {to} übersetzt.",
            autoTranslate: "Automatische Übersetzung",
            translateThisMessage: "Drehen Sie diese Nachricht",
            autoTranslateDetectedDesc:
                "Besucher sprechen in {visitorLanguage}. Klicken Sie hier, um die automatische Übersetzung zu aktivieren",
            on: "Offen",
            off: "Geschlossen",
            copy: "Kopieren",
            prevChats: "Vorherige Reden",
            noShortCut: "Keine Verknüpfung",
            leaveChartConfirm: "Bist du sicher, dass du gehen willst, ohne zu reden?",
            endChatConfirm: "Möchten Sie dieses Treffen beenden?",
            chatBar: "Sprachanzeige",
            endConversation: "Beenden Sie das Treffen",
            onlyOneRep: "Sie sind der einzige Vertreter in diesem Gespräch!",
            chatList: "Sprachliste",
            unreadTitle: "Ungelesen",
            visitorLeftTitle: "Besucherausgabe",
            activeChatTitle: "Aktive Rede",
            autoAssignedTitle: "Automatisch zugewiesen",
            watchModeTitle: "Überwachungsmodus",
            lostChat: "Repräsentative Verbindung gebrochen",
            repLostConn: "Wenn der Vertreter aus der Rede ausbrach, wird das Gespräch rosa.",
            chatWidthDelay: "Verzögerung des Chats",
            repChatWidthDelay:
                "Wenn es keinen aktiven Vertreter im System gibt oder dass Besucher aufgrund der Dichte nicht genommen werden, ist der Hintergrund grün.",
            unreadMsg: "Wenn es eine ungelesene Nachricht gibt, wird der Hintergrund hellblau.",
            visitorLeftChat: "Wenn der Besucher die Rede verließ, wird der Hintergrund dunkelgrau.",
            activeChatMsg: "Wenn die Rede aktiv ist, wird der Hintergrund grün",
            autoAssignMsg:
                "Wenn er mit automatischer Aufgabe ernannt wurde und das Gespräch nicht betrachtet wurde, wird der Hintergrund Senf",
            watchModeMsg: "Wenn im Überwachungsmodus geöffnet wird, wird der Hintergrund rot",
            online: "Online",
            beRightBack: "Ich komme gleich wieder",
            away: "Ich komme gleich wieder",
            busy: "Beschäftigt",
            offline: "Offline",
            logout: "Ausloggen",
            forWindows: "Für Windows",
            forMac: "Für Mac",
            nextChatFromActive: "Gehen Sie zum nächsten Gespräch ohne aktive Gespräch",
            previousChatFromActive: "Übergeben Sie das vorherige Gespräch ohne aktive Rede",
            hideActiveChat: "Aktive Konversation verbergen",
            closeActiveChat: "Beenden Sie aktive Gespräche",
            firsthiddenChat: "Stellen Sie eine Verbindung zur Rede des am meisten gewarteten Kunden her",
            firstChatWaiting: "Wechseln Sie zur Sprache, die auf eine Antwort wartet",
            previousOpenedChat: "Wechseln Sie zu dem Gespräch, das zuvor geöffnet wurde",
            hashHintMessage: "Sie können schnell die Hashtag -Verknüpfungen eingeben",
            pmHintMessage: "Sie können eine geheime Nachricht mit (Beispiel PM: HI) senden",
            vtippyTicketNotification: "Benachrichtigungseinstellungen für jedes neue Ticket, das zu Ihnen kommt",
            newTicketSound: "Neues Ticket",
            vtippyDepartmentNotification:
                "Benachrichtigungseinstellungen für Nachrichten aus der Abteilungskonversation",
            vtippyGroupNotification: "Benachrichtigungseinstellungen für Nachrichten aus erstellten Gruppen",
            vtippyAnnouncemenNotification: "Benachrichtigungseinstellungen für neue Ankündigungen",
            languageSelection: "Sprachauswahl",
            shortcutHintMessage: "Sie wissen, dass Sie schnellere Nachrichten mit Abkürzungsnachrichten senden können.",
            switchBetweenConversations:
                "Wissen Sie, dass Sie schnell zwischen Verknüpfungen und Chats umschalten können?",
            atNameHintMessage: "Wissen Sie, dass Sie den Namen des Besuchers schnell schreiben können?",
            dndHintMessage: "Sie können die Datei mit Drag & Drop hochladen.",
            pasteFile: "Sie können Dateien mit senden.",
            atEmailHintMessage: "Wissen Sie, dass der Besucher die E-Mail schnell schreiben kann?",
            pastePlainText: "Es klebt den Ausdruck, den Sie als direkter Text ohne Stil kopieren.",
            pressAndTalk: "Press and talk",
            historyDetails: "Vergangene Details",
            chat: "Rede",
            chatNotFound: "Keine Sprache gefunden.",
            dataNotFound: "Daten nicht gefunden.",
            visitorInfo: "Besucherinformationen",
            timeSpent: "Die Zeit",
            noActiveVisitors: "Keine aktiven Besucher",
            select: "Öffnen Sie das Menü",
            fullname: "Vollständiger Name",
            text: "Text",
            numeric: "Digital",
            phone: "Telefon",
            optionsPlaceholder: "Optionswert",
            selectField: "Klicken Sie auf, wenn Sie ein Pop -up -Menü hinzufügen möchten",
            fullnameField: "Klicken Sie, wenn Sie einen vollständigen Namensraum hinzufügen möchten.",
            textField: "Klicken Sie, wenn Sie ein Textfeld hinzufügen möchten.",
            labelField: "Wenn Sie das Feld Beschreibung hinzufügen möchten, klicken Sie auf.",
            numericField: "Wenn Sie einen numerischen Bereich hinzufügen möchten, klicken Sie auf.",
            phoneField: "Klicken Sie, wenn Sie ein Telefonfeld hinzufügen möchten.",
            departmentField: "Klicken Sie auf, wenn Sie einen Abschnitt hinzufügen möchten",
            emailField: "Wenn Sie den E -Mail -Bereich hinzufügen möchten, klicken Sie auf.",
            visible: "Sichtbar",
            required: "Schwierigkeit",
            label: "Erläuterung",
            totalConnected: "Anzahl der Reden",
            missedChat: "Anzahl der Reden entkommen",
            workTime: "Arbeitszeit",
            closedChatCount: "Geschlossene Gespräche",
            activeConvo: "Aktiv gesprochen",
            notAnswered: "Noch nicht beantwortet",
            delayedConvo: "Verzögerte Gespräche",
            leavingRep: "Abfahrtsvertreter",
            staffRate: "Personal Arbeitsrate",
            customLoginAlert: "Es muss mindestens 1 sichtbarer Bereich in Ihrer Form sein.",
            atLeastOneLanguage: "Muss mindestens eine Sprache der Sprache sein.",
            requiredField: "Dieser Bereich ist obligatorisch.",
            notRequiredField: "Dieser Bereich ist nicht obligatorisch.",
            visibleField: "Dieses Feld erscheint in der Form.",
            notVisibleField: "Dieses Feld erscheint nicht in der Form.",
            connectServer: "Sie sind mit dem Server verbunden",
            disconnectServer: "Ihre Verbindung mit dem Server wurde abgeschnitten",
            liveChatOff: "Live -Unterstützung aus",
            visitorScreen: "Besucherbildschirm",
            viewOnTheSite: "Ansicht auf der Seite",
            viewOnTheSiteTippy: "Klicken Sie hier, um zu sehen, wie Ihre Änderungen stoppen.",
            showHint: "Tipp zeigen",
            dontShowHint: "Tipp zeigt",
            liveChatOn: "Live -Unterstützung ist offen",
            nightModeOff: "Nachtmodus aus",
            nightModeOn: "Der Nachtmodus ist offen",
            edit: "Bearbeiten",
            deleteField: "Löschen",
            arrow_upward: "Stromaufwärts",
            arrow_downward: "Stromabwärts",
            doubleClickEdit: "Klicken Sie zweimal, um die Schaltfläche Bearbeiten zu bearbeiten oder zu drücken.",
            newCatalogCategory: "Neue Katalogkategorie",
            childCreate: "Klicken Sie hier, um Sub -Incontent zu erstellen",
            updateCatalogCategoryFrom: "Katalogkategorie -Aktualisierungsformular",
            newCatalogCategoryFrom: "Neue Formular der Katalogkatalog",
            catalogMenu: "Speisekarte",
            catalogContent: "Inhalt",
            catalogCategoryName: "Katalogkategorie Name",
            newCatalogContentFrom: "Neues Kataloginhaltsformular",
            catalogContentName: "Kataloginhaltsname",
            catalogCategorySaved: "Katalogkategorie aufgezeichnet",
            catalogCategoryDeleted: "Die Katalogkategorie wurde gelöscht.",
            catalogCategoryRate: "Content Score",
            catalogContentFeature: "Katalogfunktion",
            vtipyAudioLevel: "Es wird verwendet, um Benachrichtigungsgeräusche zu schneiden oder zu öffnen.",
            vtipyOrganizationName: "Sie können den Organisationsnamen ändern und aktualisieren.",
            vtipyBrandVisibility: "Das SUPSIS -Tag ist die Einstellung, ob es im Chat -Ballon angezeigt wird.",
            vtipyBrandVisibilityForced: "Nur Proplan kann Benutzer ändern !!",
            vtipyClientDefault: "Sie können die repräsentative Seitensprache hier ändern.",
            vtipyCustomerClientDefault: "Hier können Sie die Sprache der Kundenseite (CHAT) ändern.",
            vtipyVisitorPreferredLang: "Sie können die Sprachsprache auf der Seite Kunden (CHAT) auswählen.",
            vtipyCustomerClientLanguageDetect:
                "Sie können automatisch die Sprache der Seite der Kunden (CHAT) erkennen.",
            vtipySelectTopic:
                "Nach den von den Kunden ausgewählten Themen müssen die Abteilungen (Fächer) geleitet werden.",
            vtipyAutoCallTransfer: "Es weist die Warteverträge automatisch den verfügbaren Vertretern zu.",
            vtipyCustomerTyping: "Sie können den Kunden auf dem Chat -Bildschirm auf dem Chat -Bildschirm sehen.",
            vtipyAgentTyping: "Der Vertreter zeigt den Schreibstatus beim Kundenballon.",
            vtipyQueueNumberVisibleFeature:
                "Es zeigt, was für Kunden, die sich verbinden möchten, wenn Vertreter intensiv sind.",
            vtipyPrivateChatEnabled: "Zeigt das Sprachgremium zwischen Vertretern.",
            vtipyDelayedTalkTime:
                'Während dieser Zeit ist kein Vertreter mit dem Sprechen als "verzögerte Rede" verbunden.',
            vtipyOfflineMode: "Mit dem System können Sie offline -Mode kaufen.",
            vtipyAutoAssignLimit: "Es bestimmt, wie viele Kundenterminer an den Vertreter vereinbart werden.",
            vtipyCustomerDownTimeWhenRepExit: "Als der Vertreter ausgeht, verschwendete der Kunde Zeit (Mr.)",
            tippyDisconnectTime: "Nachdem die Kundenverbindung unterbrochen wurde, ist die Schließzeit (SN).",
            changeSettings: "Ändern Sie die globale Einstellung",
            totalBg: "Gesamtzahl der Chats",
            activeBg: "Aktive Chats",
            watchBg: "Verfolgung",
            waitingBg: "Ausstehende Chats",
            lateBg: "vorbeiziehende Gespräche",
            freeBg: "Leerlauf",
            maxCapacityBg: "Max",
            addNewSettings: "Fügen Sie eine neue globale Einstellung hinzu",
            darkMode: "NACHT-MODUS",
            clientDefault: "Panel Standardsprache",
            customerClientDefault: "Kundenteil ist die Standardsprache",
            customerClientLanguageDetect: "Kundenteil der Sprache erkennt automatisch",
            visitorPreferredLang: "Kunde Wählen Sie die Sprachsprache",
            preferredThemeColor: "Sprachbildschirm -Themenpräferenz",
            detail: "Prüfen",
            langSetting: "Die Spracheinstellung",
            supportUs: "Kontaktieren Sie uns (Live -Unterstützung)",
            changeLang: "Sprache ändern",
            fontSizeSetting: "Einstellung der Bildschirmvergrößerung",
            changeLangDesc: "Legt die Anwendungssprache auf {code} fest.",
            trLang: "Türkisch",
            enLang: "Englisch",
            fieldRequired: "{field} Feld ist erforderlich.",
            selectALanguage: "Wählen Sie eine Sprache",
            selectATheme: "Wähle ein Thema",
            responseForm: "Antwortformular",
            clientRequestInfo: "Kundenbedarfsinformationen",
            createdDate: "Erstellungsdatum",
            descMessage: "Nachricht",
            new: "Neu",
            lastLoginPlatform: "Plattform",
            requiredFieldField: "Dieser Bereich ist obligatorisch",
            catalogCategoryMenu: "Fügen Sie das Katalogkategoriemenü hinzu",
            catalogCategoryLeaf: "Katalogkategorie Sub -Menu",
            selectAllPermission: "Wählen Sie Alle",
            catalogCategories: "Katalog",
            copiedClipboard: "In die Tafel kopiert",
            organizationLogo: "Firmenlogo",
            changePlan: "Plan ändern",
            close: "Schließen",
            vtipyUploadLogo:
                "Sie können Ihr eigenes Logo auf Customer Mails und Kundenseite verwenden, indem Sie Ihr Firmenlogo aus diesem Bereich installieren.",
            tagName: "Verlinke den Namen",
            tagDescription: "Etikettenbeschreibung",
            tagColor: "Etikettenfarbe",
            userInformations: "Nutzerinformation",
            incomingChat: "Eingehender Chat",
            support: "Unterstützung",
            team: "Satz",

            groups: "Gruppen",
            newConversationStarted: "Neues Gespräch begonnen",
            allHistoryLoaded: "Der gesamte Verlauf wurde hochgeladen",
            chatCreator: "Chat-Ersteller",
            enterGroupTitle: "Geben Sie den Gruppentitel ein",
            requiredTitle: "Sie können das Titelfeld nicht leer lassen",
            requiredChannel: "Der Kanalname darf nicht leer sein",
            next: "Bestätigen",
            selectPeople: "Wählen Sie Personen aus",
            textLimitAlertMessage:
                "Die Zeichenbeschränkung in WhatsApp beträgt 19 Zeichen und darüber hinaus wird es nicht angezeigt. Im Web werden jedoch Texte, die die 19-Zeichen-Grenze überschreiten, automatisch in die nächste Zeile verschoben und angezeigt.",
        },
        shouldAddMethod:
            "Sie müssen das Feld Zahlungsmethode & Rechnungsadresse ausfüllen!\nEs wird kein Geld von Ihrem Konto abgebucht..\n" +
            "Am Ende des Monats wird eine Rechnung entsprechend Ihrer Nutzungsmenge erstellt.",
        telegram: {
            typeInTelegramToken: "Geben Sie Telegram Token ein",
            token: "Zeichen",
            telegramTokenTitle: "Telegram Supsis Integration",
            telegramAlertForm: "Sie können Telegram Bot Token von erhalten",
            telegramAlertTitle: "Möchten Sie das Token wirklich löschen?",
            telegramAlertText: "Der Token geht dauerhaft verloren!",
        },
        wp: {
            whatsapp: "WhatsApp",
            chatStartingWait: "Die Rede beginnt, bitte warten",
            chatStarted: "Die Sprache begann",
            chatNotStarted: "Sprache konnte nicht gestartet werden",
            contactSelected: "Die Person wurde ausgewählt",
            startChatWithAnyNo: "Chatten Sie mit einer beliebigen Zahl",
            toLittleChar: "Die fehlende Nummer wurde eingegeben!",
            typeInANumberDesc: "Schreiben Sie die Nummer, um einen Chat zu starten",
            wpPlusAndLicenceRequired: "WhatsApp Plus -Plan und Lizenz sind erforderlich.",
            wpPlusAndLicenceRequiredDesc:
                "Sie sollten Ihren WhatsApp -Plan erhöhen und eine Lizenz erhalten, damit Sie mit dem Chatten nach Nummern beginnen können, die nicht in Ihrem Leitfaden registriert sind.",
            agreement: "Vereinbarung",
            purchase: "Besorgen",
            activating: "WhatsApp -Dienst aktiviert",
            authenticating: "QR -Codeüberprüfung",
            ready: "Vollständig",
            activationTitle: "Aktivieren Sie die WhatsApp -Integration auf SUPSIS:",
            wpIntegrationInstruction1: "Öffnen Sie WhatsApp auf Ihrem Telefon",
            wpIntegrationInstruction2: "Wählen Sie Menü oder Einstellungen und klicken Sie auf Geräte.",
            wpIntegrationInstruction3: "Führen Sie Ihr Telefon auf diesem Bildschirm aus, um den Code zu scannen",
            qrGeneratingWait: "Der QR -Code wird erstellt, bitte warten ...",
            pleaseContinueToWaitUntilCompleted:
                "Nachdem der QR -Code überprüft wurde, wechselt er automatisch in den ausgefüllten Bereich. Warten Sie mal...",
            authenticatingWait: "Es loggt sich an, bitte warte ...",
            enableFeature: "Aktivieren Sie die WhatsApp -Funktion",
            unsubscribeWpInetgration: "WhatsApp -Integration beendet sein Abonnement",
            unsubscribeIGIntegration: "Beendigung von Instagram -Integration -Abonnements",
            wpBack: "Zurück",
            terminatelWpInetgration:
                "Wenn Sie auf die Abonnementschaltfläche klicken, wird Ihre WhatsApp -Integration beendet.",
            cancelWpInetgration: "Möchten Sie WhatsApp -Integration stornieren?",
            terminatelIGIntegration:
                "Wenn Sie auf die Abonnementschaltfläche klicken, wird Ihre Instagram -Integration beendet.",
            cancelIGIntgeration: "Möchten Sie die Instagram -Integration stornieren?",
            startChatWp: "Chat beginnen",
            readAndAgree: "Ich habe es gelesen, ich stimmte zu",
            subscribe: "Abonnieren",
            subscribed: "Gezeichnet",
            toEnableWpDescription: "Klicken Sie auf die Schaltfläche unten, um WhatsApp -Funktionen zu aktivieren.",
            waitForWpActivationDescription:
                "Der WhatsApp -Account -Service wird aktiv. Warten Sie mal. Es dauert ungefähr 30 Sekunden.",
            greatWpActivatedDescription: "WhatsApp -Kontodienst wurde aktiviert.",
            unsubscribe: "Aus dem Abonnement herauskommen",
            planDetails: "Merkmale",
            sendReceiveMessage: "Senden von Nachrichten und Empfangen",
            sendReceiveImage: "Bilder senden und empfangen",
            sendReceiveAudio: "Senden von Audioaufzeichnungen und Empfangen",
            sendReceiveGif: "GIF -Senden & Empfangen",
            startChat: "Chat beginnend in SUPSIS",
            supsisFunctionality: "Nützliche SUPSIS -Chat -Funktion",
            onePhoneMultiAgent: "Mehr als ein Vertreter mit einem einzelnen Telefon",
            basicIntegration: "Einfache Integration",
            purchaseHeader: "SUPSiS-WhatsApp-Integration Einkauf",
            wpServices: "WhatsApp -Service",
            wpServicesIntegrationCompleted: "WhatsApp -Integration ist abgeschlossen. Sie können es jetzt verwenden.",
            purchasePaymentDescription:
                "WhatsApp -Feature ist von Monat zu Monat in Rechnung gestellt. Nach der Annahme des Abonnements wird Ihr WhatsApp -Dienst aktiviert.",
            wpIntegrationFeatures: "WhatsApp -Integrationsfunktionen",
            saveChanges: "Änderungen speichern",
            contactList: "Personliste",
            broadcast: {
                broadcast: "Kollektive Nachricht",
                detail: "Detail",
                customer: "Kunde",
                phoneNumbers: "Kontaktnummern",
                showMore: "Zeig mehr",
                showLess: "Zeige weniger",
                groupName: "Gruppenname",
                messages: "Mitteilungen",
                status: "Situation",
                usageCost: "Nutzungskosten",
                sendingTime: "Zeit zu senden",
                progress: "Fortschritt",
                groupDetail: "Gruppendetail",
                messagesPerContact: "Anzahl der Nachrichten pro Kopf",
                successRatio: "Erfolgsrate",
                message: "Nachricht",
            },
            messages: "Mitteilungen",
            broadcastRequests: "Kollektive Nachrichtenanfragen",
            customerGroups: "Kundengruppen",
            messageTemplates: "Nachrichtenvorlagen",
            plans: "Pläne",
            wpIntegrationRequired: "WhatsApp -Integration erforderlich",
            wpRequiredIntegrationDescription:
                "Entschuldigung, die Seite, die Sie besuchen, wird aktiviert, wenn Sie Ihre WhatsApp integrieren.",
            integrateWp: "Komm schon, integrieren Sie WhatsApp",
            active: "Aktiv",
            archived: "Archiviert",
            createBroadcastMessage: "Erstellen Sie eine kollektive Nachricht",
            title: "Titel",
            description: "Erläuterung",
            createdAt: "Erstellungsdatum",
            numbers: "Zahlen",
            actions: "Bewegungen",
            action: "Aktion",
            createCustomerGroup: "Erstellen Sie eine spezielle Kundengruppe",
            search: "Forderung",
            name: "NAME",
            contacts: "Personen",
            noContactFound: "Die Person nicht gefunden",
            broadcastTitle: "Schreiben Sie einen Titel in Ihre kollektive Nachricht.",
            recipients: "Käufer",
            selectRecipients: "Wählen Sie Käufer",
            writeYourMessage: "Schreibe deine Nachricht.",
            schedule: "Mit Plan",
            scheduleNowOrLater: "Planen Sie jetzt oder später.",
            summary: "Zusammenfassung",
            cancel: "Stornieren",
            send: "Schicken",
            sending: "Gesendet",
            deleteCustomerGroup: "Sind Sie sicher, dass Sie diese Kundengruppe löschen möchten? {Name}",
            customerGroupDeleting: "Die Kundengruppe wird gelöscht ...",
            customerGroupDeletingSuccess: "Kundengruppe erfolgreich gelöscht",
            customerGroupDeletingError: "Die Kundengruppe ist beim Löschen aufgetreten",
            wpPlusRequired: "WhatsApp Plus -Plan ist erforderlich.",
            broadcastMessageArchived: "Archivarchive",
            broadcastMessageNotArchived: "Die Bulk Message Group wurde nicht archiviert",
            groupNameSearch: "Schreiben Sie den Kundengruppennamen",
            groupNameDesc: "Kundengruppenname Definieren Sie Ihre Kundengruppen",
            save: "Speichern",
            number: "NUMMER",
            addColumn: "Spalte hinzufügen",
            addColumnDesc: "Fügen Sie der Tabelle eine Spalte hinzu",
            addNewContact: "Neue Person hinzufügen",
            addNewContactDesc: "Person zur Tabelle hinzufügen",
            importFile: "Aus der Datei einführen",
            importFileDesc: "Befragte Personen aus der Excel- oder CSV -Datei",
            contactAdded: "Person hinzugefügt",
            updateCustomerGroup: "Die Kundengruppe wird aktualisiert ...",
            updateCustomerGroupSuccess: "Die Kundengruppe hat erfolgreich aktualisiert",
            sendBroadcastMessage: "Senden Sie eine kollektive Nachricht",
            columnName: "Spaltenname",
            columnType: "Spalte",
            defaultValue: "Standardwert",
            setDefaultValue: "Setzen Sie den Standardwert auf vorhandene Personen",
            age: "Alter",
            location: "Standort",
            gender: "Geschlecht",
            selectContactFile: "Wählen Sie die Datei mit Personen aus",
            selectContactCsvOrExcel: "Wählen Sie eine CSV- oder Excel -Datei aus.",
            importConfiguration: "Verbessern Sie Ihre Datei",
            customizeFile: "Bearbeiten Sie die Personen, die Sie hinzufügen.",
            sendMessageTo: "Wen möchten Sie die Nachricht senden?",
            allContact: "Alle Leute",
            messageTypes: "Nachrichtentypen",
            whenSendMessage: "Wann möchten Sie die Nachricht senden?",
            instantlyRightNow: "Im Augenblick",
            completed: "Vollendet",
            scheduleFuture: "Timing für ein zukünftiges Datum",
            messageDesc: "Ihre Nachricht wird sofort an alle Käufer gesendet",
            messageSendAt: "Es wird an alle Käufer unter Ihrer Nachrichtenadresse weitergeleitet:",
            estimatedPrice: "Schätzpreis",
            estimatedTime: "Geschätzte Zeit",
            now: "Jetzt",
            tenMinute: "10 Minuten",
            cancelled: "Es wird abgesagt",
            failed: "Erfolglos",
            running: "Geht weiter",
            queued: "Aufgereiht",
            scheduled: "Geplant",
            noNumberAdded: "Nummer nicht hinzugefügt",
            csvOrExcelFile: "CSV- oder Excel -Datei",
            broadcastMessagesToContactFile: "Senden von kollektiven Nachrichten an die Personliste",
            broadcastMessageTemplates: "Kollektive Nachrichtenvorlagen",
            messageFlow: "Nachrichtenfluss",
            textMessageSupport: "SMS -Unterstützung",
            imageMessageSupport: "Unterstützung bei Bildnachrichten",
            spamPreventions: "Spam -Nachrichtenprävention",
            includesAllBasicPlans: "Enthält alle Funktionen im WhatsApp -Paket",
            chatbotIntegration: "Chatbot -Integration",
            messageToNewNumbers: "Senden von Nachrichten an neue Zahlen",
            broadcastMessageToEveryone: "Senden einer kollektiven Nachricht an alle",
            personalizedBroadcastMessage: "Persönliche Massennachrichten",
            customerGroupSegmentation: "Kundengruppensegmentierung",
            scheduleBroadcastMessage: "Bulk -Nachrichtenplanung",
            locationMessageSupport: "Standortmeldungsunterstützung",
            advancedSpamPreventions: "Erweiterte Spam -Nachrichtenprävention",
            whatsappPlans: "WhatsApp -Pläne",
            selectBestPlan: "Wählen Sie den entsprechenden Plan für Sie",
            comingSoon: "Sehr bald...",
            selectFile: "Wähle eine Datei",
            created: "Erstellt",
            message: "Nachricht",
        },
        ig: {
            instagram: "Instagram",
        },
        ticket: {
            ticketTagFilter: "Ticketfilter -Tag",
            ticketEmails: "E-Mail-Liste zu direkter",
            save: "Speichern",
            delete: "Löschen",
            transactions: "Transaktionen",
            noEmailTicketNotifications: "TES Ticket Eposta Verwandte Registrierung COYPENTIENT",
            emailIsNotValid: "Die e-mail Adresse ist ungültig",
            emailNotificationDeleted: "Ticket -Routing -Datensatz gelöscht",
            emailNotificationDeleteError: "Ticket -Routing -Datensatz konnte nicht gelöscht werden !!",
            tagFilterRequired:
                "Ticket -Betrefffilter -Tag ist erforderlich. Sie können das * (Wildcard) -Tag für alle Tickets verwenden!",
            emailsRequired: "Mindestens 1 E -Mail -Adresse sollte für die Ticketausrichtung eingegeben werden",
            emailNotificationCreated: "Ticket -Routing -Datensatz erstellt",
            emailNotificationCreateError: "Ticket -Routing -Datensatz konnte nicht erstellt werden !!",
            ticketForwarding: "Ticket -E -Mail -Anleitung",
            ticketTagFilterDesc:
                "Um ein Ticket zu filtern, verwendet der Chatbot die Tickets, die Sie im Design verwenden. Sie können ein anderes Etikett schreiben und die Eingabetaste drücken und hinzufügen. Wenn Sie das Tag '*' auswählen, wählen Sie alle Tickets aus",
            ticketEmailsDesc:
                "Die E -Mail -Liste wird durch Tickets gerichtet. Sie können die Adressen der Vertreter im System hinzufügen, indem Sie die Adressen auswählen. Sie können auch nicht -System -E -Mail/s hinzufügen.",
            ticketList: "Ticket -Routing -Regeln",
            ticketTagFilterPlaceHolder: "Ticketfilter, für alle * auswählen *",
            ticketEmailsPlaceHolder: "Routing -E -Mail -Liste",
        },
        theme: {
            headerColor1: "Titel (links)",
            headerColor1A: "Titelteilfarbe/Transparenz",
            headerColor2: "Titel (rechts)",
            headerColor2A: "Titelteil 2. Farbe/Transparenz",
            backgroundColor: "Hintergrund (links)",
            backgroundColorA: "Hintergrund 1. Farbe/Transparenz",
            backgroundColor2: "Hintergrund (rechts)",
            backgroundColor2A: "Hintergrund 2. Farbe/Transparenz",
            opacity: "Transparenz",
            textColor: "Allgemeine Textfarbe",
            errorTheme: "Fehlerfarbe",
            bubbleBackground: "Repräsentative Ballonfarbe",
            bubbleVisitorBackground: "Kundenballonfarbe",
            bubbleBackgroundA: "Repräsentative Ballontransparenz",
            bubbleVisitorBackgroundA: "Kundenballontransparenz",
            bubbleText: "Repräsentative Sprachfarbe",
            bubbleVisitorText: "Kundensprachfarbe",
            textFormColor: "Farbe bilden",
            selectCustom: "Wählen Sie ein besonderes Thema",
            headerColorSecond: "Kopffarbe oben",
            headerColorFirst: "Farbe des Titelbodens",
            backgroundColorFirst: "Hintergrundfarbe oben",
            formColor: "Formulartextfarbe",
            buttonColor: "Knopffarbe",
            backgroundColorSecond: "Hintergrundfarbe unten",
            chatBotButtonText: "Chatbot-Schriftfarbe",
            chatBotButtonColor: "Farbe der Chatbot-Schaltfläche",
        },
        billing: {
            paymentStatus: "Zahlungsstatus",
            amount: "Betrag",
            invoiceID: "Rechnungs-ID",
            expected: "Erwartet..",
            currentAmount: "Aktueller Betrag",
            monthlyEstimatedAmount: "Monatlicher geschätzter Betrag",
            creationDate: "Erstellungsdatum",
            invoiceStatus: "Rechnungsstatus",
            invoicePeriod: "Rechnungszeitraum",
            newPaymentMethod: "Neue Zahlungsmethode",
            channelCount: "Kanalanzahl",
            remainingTime: "Verbleibende Zeit",
            chatbotLimit: "Chatbot-Limit",
            free: "Kostenlos",
            maxChatbotSession: "Maximale Chatbot-Sitzungen",
            buyIt: "Kaufen",
            renewalDate: "Verlängerungsdatum",
            monthly: "Monatlich",
            yearly: "Jährlich",
            packagePeriod: "Paketperiode",
            packageType: "Pakettyp",
            packageManagement: "Paketverwaltung",
            invoiceManagement: "Rechnungsmanagement",
            futureInvoice: "Zukünftige Rechnung",
            pastInvoices: "Vergangene Rechnungen",
            creditCard: "Kreditkarte",
            invoice: "Rechnung",
            mustBeUpgradePlanForChatBot: "Sie müssen zum Pro -Plan wechseln, um die Chatbot -Funktion zu aktivieren!",
            cardInfo: "Karteninformationen",
            billingDetails: "Rechnungs-Details",
            addCardIyzico:
                "Sie haben keine registrierte Karte. Sie müssen Karten hinzufügen, um Ihre monatlichen Gebührengebühren zu bezahlen.",
            billingPlanSettings: "Rechnungsmethode und Zahlungsmethode",
            paymentMethod: "Bezahlverfahren",
            billingDate: "Rechnungsdatum",
            isPaid: "Wird es bezahlt?",
            paid: "Bezahlt",
            markPaid: "Als bezahlt festgelegt",
            paymentDate: "Zahlungsdatum",
            pay: "Die Rechnung bezahlen",
            newInvoice: "Rechnung erstellen",
            updateBilling: "Ändern Sie Ihre Rechnungsadresse",
            updateCard: "Ändern Sie Ihre Kreditkarte",
            paymentBilling: "Zahlungsmethode und Rechnungsadresse",
            price: "Rechnungsbetrag",
            billingAddress: "Offene Adresse",
            billingCity: "Stadt",
            billingCountry: "Land",
            contactName: "Rechnungsname",
            expireMonth: "Ende verwenden Sie T. Ay",
            expireYear: "Ablauf T. Jahr",
            cardNumber: "Kartennummer",
            cardHolderName: "Nennen Sie den Nachnamen auf der Karte",
            cardAlias: "Kartenstopfenname",
            identityNumber: "ID/Steuernummer",
            name: "Name",
            surname: "Nachname",
            email: "Email",
            addCard: "Karte hinzufügen",
            update: "Aktualisieren",
            cancel: "aufgeben",
            save: "Speichern",
            saving: "Gerettet",
            noInvoiceFound: "Rechnungsaufzeichnung nicht gefunden",
            year: "Jahr",
            updating: "Aktualisierung",
            newInvoiceForm: "Neue Rechnung erstellen Form",
            error: "Fehler",
            transactions: "Transaktionen",
            paymentMethodAdded: "Zahlungsmethode erfolgreich hinzugefügt",
            paymentMethodAddError: "Die Zahlungsmethode konnte nicht hinzugefügt werden, ein Fehler trat auf",
            creditCardChanged: "Ihre Kreditkarte wurde geändert",
            errorOccurred: "Es gab einen Fehler, versuchen Sie es erneut.",
            billingDetailUpdated: "Ihre Rechnungsinformationen wurden aktualisiert",
            invoiceCreated: "Rechnungsregistrierungserfolg erstellt",
            paymentSuccess: "Ihre Rechnung wurde erfolgreich bezahlt, danke",
            paymentFail: "Wenn Ihre Rechnung bezahlt wird, trat der Fehler auf und versuchen Sie es erneut.",
            startWith: "{cardFamily} Karte beginnend mit {binNumber}",
            billingAddressChanged: "Rechnungsinformationen aktualisiert",
            hidePlan: "Den Plan verstecken",
            informationShopping:
                "Ihre Zahlungsinformationen, Rechnungsinformationen und Kreditkarteninformationen werden von Shopify überprüft.",
            trialTimeInformation:
                "{dayCount} hat die Testversion verlassen. Wenn Sie die Zahlungsmethode erst Ende dieses Zeitpunkts eingeben, wechselt das System automatisch zum freien Plan.",
            trialTimeInformationShort: "Last {dayCount} Tag",
            currentPlanLabel: "Aktueller Plan: {planName} Plan ({agentCount} Repräsentant)",
            changeCancelPlan: "Den Plan ändern/stornieren",
            oneAgent: "Vertreter",
            agent: "Vertreter",
            yourCurrentPlan: "Bestehender Plan",
            month: "Mond",
            billedMonthToMonth: "(Monatliche Abrechnung)",
            selectAgentCount: "Wählen Sie die Anzahl der Vertreter aus",
            selectFreePlan: "Wählen Sie kostenlosen Plan",
            planDetails: "Planen Sie Details",
            multiAgent: "(Sehr repräsentativ)",
            selectProPlan: "Wählen Sie den Pro -Plan",
            foreverFree: "Unbestimmt frei",
            websiteIntegration: "Website -Integration",
            websiteIntegrationUnlimited: "Website -Integration",
            ChatBotUnlimited: "Chatbot",
            videoCallUnlimited: "Videosuche",
            multiAgentUpTo: "Mehrere Vertreter ({agentCount} zu Repräsentant)",
            audioCallUnlimited: "Sprachanruf",
            screenSharingUnlimited: "Bildschirm teilen",
            fileTransferUnlimited: "Datenaustausch",
            autoChatAssignerUnlimited: "Automatische Chatzuweisung",
            multiLanguageTranslationUnlimited: "Automatischer Sprachwandler",
            detailedReporting: "Berichterstattung",
            days30TrialsAvailable: "30-tägige kostenlose Testversion",
            limitedArchiveLookupLastMo: "Limited Archivsuche (letztes {monatCount} -ay)",
            fullCustomizationUnlimited: "Anpassen",
            planUpdated: "Ihr Plan wurde erfolgreich aktualisiert.",
            planUpdating: "Ihr Plan aktualisiert ...",
            planUpdatingDescription: "Bitte warten Sie während des Update!",
            done: "Vollendet",
            freePlanUpdated: "Ihr Plan wurde als kostenloser Plan aktualisiert. (Maximale Anzahl von Vertretern: 1)",
            proPlanUpdated:
                "Ihr Plan wurde als Pro -Plan aktualisiert. (Maximale Anzahl von Vertretern: {proPlanUpdated})",
            canNotDwnGrade:
                "Ihr Plan kann nicht von PRO {agentCountFirst} Agents auf {valNewPlnToUppr} {agentCountSecond} heruntergestuft werden!. Ihre Agenten-Credits werden verwendet.",
            deleteWarning: "{valdif} Sie müssen den Vertreter löschen.",
            warnMessage: "Der ausgewählte Plan sollte sich vom aktuellen Plan unterscheiden",
            add: "Hinzufügen",
            cancelYourPlan: "Stornieren Sie Ihren Plan",
            upgradeYourPlan: "Aktualisieren Sie Ihren Plan",
            downgradeYourPlan: "Reduzieren Sie Ihren Plan",
            agree: "GIB ES ZU",
            disagree: "AUFGEBEN",
            invoices: "Rechnungen",
            priceIntervals: "Betragsbereich",
            selectSiteAlias: "Geben Sie den Site -Namen ein oder wählen Sie",
            selectPriceInterval: "Geben Sie den Betragbereich ein oder wählen Sie den Betragsbereich aus",
            isRefunded: "Wurde erstattet?",
            invoiceId: "Rechnungsnummer",
            siteId: "Standort Nr",
            createdDate: "Das Datum des Seins",
            failCount: "Fehlgeschlagener Schießversuch",
            failDate: "Zahlungsdatum, der nicht erfolgt ist",
            Dashboard: "Armaturenbrett",
            Agents: "Vertreter",
            Integration: "Integration",
            Settings: "Einstellungen",
            Contacts: "Links",
            Domain: "Domain",
            lastActivity: "Letzte Aktivität",
            basePrice: "Minimaler Preis",
            packagePrice: "Paketpreis",
            whatsappPrice: "WhatsApp -Preis",
            realtimeVisitorCount: "Sofortiger Besucher",
            suspend: "Verdächtig",
            partner: "Partner",
            plan: "Planen",
            trialDay: "Probetag",
            mobile: "Handy, Mobiltelefon",
            webSite: "Webseite",
            websiteOrigins: "Website -Quelle",
            ownerName: "Der Name des Besitzers",
            ownerEmailAddress: "Die E -Mail des Besitzers",
            discount: "Rabatt",
            daysLeft: "Der verbleibende Tag",
            newTrialPopUp: "Wie viele Tage wird die neue Testzeit sein",
            newWpPricePopUp: "Wie viel kostet die neue WhatsApp -Gebühr?",
            newIGPricePopUp: "Wie viel kostet die neue Instagram -Gebühr?",
            newBasePricePopUp: "Wie viel kostet der neue SUPSIS -Grundpreis?",
            siteInfoUpdated: "Standortinformationen aktualisiert",
            siteInfoNotUpdated: "Standortinformationen nicht aktualisiert",
            siteInfoNotUpdatedErr: "Ein Fehler ist aufgetreten! Site -Informationen wurden nicht aktualisiert.",
        },
        tour: {
            representativeTab: "Vertreter",
            stats: "Statistisches Panel",
            chats: "Chat -Panel",
            settings: "EINSTELLUNGEN",
            status: "SITUATION",
            prevStep: "Vorheriger Schritt",
            nextStep: "Nächster Schritt",
            finish: "Beende es",
            skip: "Springen",
            skip2: "Ich kenne das System, zeige nicht wieder",
            startTour: "Beginnen Sie die Tour",
            firstTimeIntro: "Ich entdeckte, dass es zum ersten Mal in das System eingegeben wurde.",
            hi: "Hallo",
            welcomeTo: "Willkommen bei Supsis Live Support",
            statsPanel:
                "Es ist die Statusleiste, die die gesamten aktiven Chat -Nummern zeigt, die sofort mit dem System warten.",
            sidebarMenu: "Speisekarte",
            sidebarMenuContent: "Hier können Sie Übergänge zwischen den Seiten durchführen.",
            representativePrivateMessage: "Konversationspanel zwischen Vertretern",
            representativePrivateMessageContent: "Hier sehen Sie spezielle Gespräche zwischen Vertretern.",
            helpMenu: "Hilfsmenü",
            helpMenuContent: "Hier finden Sie die Hilfeinformationen zum System.",
            settingsMenu: "Einstellungsmenü",
            settingsMenuContent:
                "Sie können die Schritte für Sprache, Nachtmodus und Bildschirmvergrößerung hier ausführen.",
            startChat: "Chat beginnen",
            profileMenu: "Profilmenü",
            profileMenuContent:
                "Sie können Ihren verfügbaren Status ändern und Ihre repräsentativen Einstellungen hier vornehmen.",
            visitorsTab: "Besucher",
            visitorsTabContent: "Hier können Sie Besucher sehen.",
            visitorTabHistory: "Besuchergeschichte",
            visitorTabHistoryContent: "Sie können die Besuchergeschichte hier sehen.",
            representativ_eTab: "Vertreter",
            representativeTabContent: "Sie können die Vertreter hier sehen.",
            liveSupport: "Live Support",
            liveSupportContent: "Sie können die Anzahl der Kunden sehen, die hier Live -Support erhalten.",
            siteVisitors: "Site -Besucher",
            siteVisitorsContent: "Sie können die Anzahl der Besucher hier sehen.",
            tableSettings: "Tisch Einstellungen",
            tableSettingsContent: "In der Tabelle können Sie hier eine Spalte anzeigen oder ausblenden.",
            watchModeButton: "Publikumsknopf",
            watchModeContent: "Sie können dem Publikum als Modus beitreten und zeigen nur, was geschrieben ist.",
            popoverInfo: "Besucherdetail",
            popoverInfoContent: "Gibt Informationen über den Besucher.",
            popoverButton: "Erweiterte Spracheinstellungen",
            popoverButtonContent:
                "Sie können ein Gespräch öffnen, eine direkte Nachricht an den Vertreter senden oder den Besucher blockieren.",
            openChat: "Sprachschaltfläche anschließen",
            openChatContent: "Sie können das Gespräch hier öffnen",
            pagination: "Paging -Menü.",
            paginationContent: "Sie können die Anzahl der Seiten hier erhöhen.",
            chatwindow: {
                chatWindowSettingsButtons: "Sprachfenstereinstellungen Schaltfläche",
                chatWindowActionButtons: "Sprachfenster allgemeiner Prozessschaltfläche",
                chatPanelActions: "Sprachpanel Verfahren",
                otherPanels: "Andere Panels",
                settingsButton: "Sie können Sprachblockierung, Anleitung, geheime Nachrichten und Vertretern zuweisen.",
                chatColorButton: "Sie können lernen, welche Farbe im Gespräch Ballons hier bedeutet",
                keyboardShortcutButton:
                    "Sie finden die Abkürzungen von Funktionen, die während der Korrespondenz oder anderer Funktionen, die Sie hier verwenden, Komfort bieten.",
                hideButton: "Es reduziert das offene Gespräch darunter weiterhin offen im Hintergrund",
                closeButton: "Beendet die offene Rede und geht ohne das Gespräch",
                ellipsisButton:
                    "Hier finden Sie weitere Vorgänge. Operationen wie das Senden von privaten Nachrichten, das Ziyaratci -Verbot, die repräsentative Ernennung finden Sie hier.",
                userInfoWidget: "Detaillierte Informationen zum Besucher werden hier enthalten sein",
                preparedContentWidget:
                    "Hier gibt es bereit -hergestellte Inhaltsvorlagen. Sie können schnell referenzierte Inhalte hinzufügen, indem Sie im Feld Schreibfeld auf die Verknüpfung klicken, indem Sie auf den Sprachbildschirm klicken.",
                chatHistoryWidget:
                    "Dies wird hier aufgeführt, wenn der Besucher frühere Gespräche führt. Sie können die alten Sprachdetails hier untersuchen",
                chatBarButton:
                    "Sie können hier aktive Gespräche verhindern, eine geheime Nachricht an den Vertreter senden und das Interview verlassen.",
            },
        },
        adminUser: {
            newAdminUserForm: "Neues Administratorregistrierungsformular",
            updateAdminUserForm: "Administrator -Benutzer -Aktualisierungsformular",
            adminUsers: "Administrator Benutzer",
            newAdminUser: "Neuer Administrator Benutzer",
            noAdminUser: "Es gibt noch keinen Administratorbenutzer.",
            adminUserName: "Administratorbenutzername",
        },
        report: {
            hourly: "(Stündlich)",
            hourlyAverage: "Stündlicher Durchschnitt",
            hourlyMax: "Stündliches Maximum",
            hourlyMin: "Stündliches Minimum",
            totalAmount: "Gesamtbetrag",
            averageAmount: "Durchschnittsbetrag",
            minAmount: "Mindestbetrag",
            maxAmount: "Höchstbetrag",
            siteCount: "site Count",
            agentCount: "Agent Count",
            channelsTimeSeries: "Kanäle Zeitreihen",
            channelPies: "Kanal-Torten",
            pieView: "Kreisdiagramm",
            topVisitorCountry: "Top-Besucherland",
            websiteTrafficByCountry: "Website-Traffic nach Ländern",
            visitorCount: "Besucheranzahl",
            websiteVisitorTraffic: "Website-Besuchertraffic",
            websiteTraffic: "Website-Traffic",
            author: "Autor",
            topWorstComments: "Top Schlechteste Kommentare",
            topBestComments: "Top Beste Kommentare",
            topComments: "Top-Kommentare",
            noComment: "Noch keine Kommentare",
            minWaitingTime: "Minimale Wartezeit",
            maxWaitingTime: "Maximale Wartezeit",
            averageWaitTime: "Durchschnittliche Wartezeit",
            waitTime: "Wartezeit (Sekunden)",
            agentWaitDurationTitle: "Wartezeitdiagramm des Agents",
            incomingMessage: "Eingehende Nachricht(en)",
            outgoingMessage: "Ausgehende Nachricht(en)",
            totalSpent: "Gesamtausgaben",
            avgSpent: "Durchschnittsausgaben",
            totalPayment: "Gesamtzahlung",
            walletStatus: "Wallet-Status",
            walletBalanceStatus: "Wallet-Saldo-Status",
            messageTraffic: "Nachrichtenverkehr",
            breakCount: "Pausenanzahl",
            agentBreakTime: "Anzahl der Pausen der Agenten ☕",
            agentStatusHour: "Agentenstatus Stunde",
            agentWorkTimeCalendar: "Kalender für die Arbeitszeit des Agenten",
            agentActivity: "Aktivität des Agenten",
            noEnoughtData: "Nicht genug Daten",
            averageFirstResponse: "Durchschnittliche Erstantwortzeit",
            slowestResponser: "Langsamster Responder",
            fastestResponder: "Schnellster Responder",
            firstAnswerTimeSec: "Erstnachrichtenzeit (in Sekunden)",
            firstAnswerByAgent: "Erstnachrichtenzeit durch Agent",
            averageSolutionTime: "Durchschnittliche Lösungszeit",
            slowestSolver: "Langsamster Löser",
            fastestSolver: "Schnellster Löser",
            averageChat: "Durchschnittlicher Chat",
            leastChatReceiver: "Am wenigsten aktiver Chat-Empfänger",
            mostChatRecipients: "Meiste Chat-Empfänger",
            averageTicket: "Average Ticket",
            leastTicketReceiver: "Least Ticket Least",
            mostTicketRecipients: "Most Ticket Recipients",
            resolveTime: "Auflösungszeit (Min)",
            resolveTimeByUser: "Chat-Auflösungszeit nach Benutzer (in Minuten)",
            chatResolveTimeByAgent: "Chat-Auflösungszeit nach Agenten",
            chatDistByHandleType: "Chat-Verteilung nach Handler",
            chatDistByHandDesc: "Wie viele Chats wurden von Agenten, Chatbots und Hybrid bearbeitet?",
            chatCountsByHandleType: "Chatanzahl nach Bearbeitungstyp",
            missed: "Verpasst",
            answered: "Beantwortet",
            chatDistByAnsDesc: "Wie viele Chats wurden beantwortet oder verpasst?",
            chatCountsByAns: "Chatanzahl nach Antwort",
            chatCountByPlatform: "Chatanzahl nach Plattform",
            chatDistByPDesc: "Wie viele Chats kamen auf welche Plattform?",
            chatDistByPlatform: "Chat-Verteilung nach Plattform",
            ticketCountByUser: "Ticket Counts by Agents",
            ticketCountByStatus: "Ticket Counts by Response Status",
            user: "Benutzer",
            saveAsImage: "Als Bild speichern",
            fullScreen: "Vollbild",
            download: "Herunterladen",
            tableView: "Tabellenansicht",
            chartView: "Diagrammansicht",
            chatDistByUsers: "Chat-Verteilung nach Benutzern",
            chatCountsByUsers: "Chatanzahl nach Benutzern",
            minDuration: "Mindestdauer",
            maxDuration: "Maximaldauer",
            totalDurationByAgent: "Gesamtdauer der Sitzung nach Agent",
            averageDurationByAgent: "Durchschnittliche Dauer der Sitzung nach Agent",
            totalDurationByCB: "Gesamtdauer der Sitzung nach Chatbot",
            averageDurationByCB: "Durchschnittliche Dauer der Sitzung nach Chatbot",
            viewUnitAs: "Einheit anzeigen als",
            hybrid: "Hybrid",
            handledBy: "Bearbeitet von",
            sessionDurationOverall: "Gesamte Sitzungsdauer",
            allChannels: "Alle Kanäle",
            sessionsDurationOverall: "Gesamtdauer der Sitzungen",
            sessionsOverall: "Gesamtsitzungen",
            calendarEvents: "Kalenderereignisse",
            reservationEvents: "Reservierungsereignisse",
            incomingMails: "Eingehende E-Mails",
            incomingMailCount: "Anzahl eingehender E-Mails",
            reservation: "Reservierung",
            event: "Veranstaltung",
            reservationEventCount: "Anzahl der Reservierungsereignisse",
            channelBreakdown: "Kanalübersicht",
            websiteAnalysis: "Website-Analyse",
            customerSatisfaction: "Kundenzufriedenheit",
            teamBreakAnalysis: "Team-Break-Analyse",
            dailyAgentActivity: "Tägliche Agentenaktivität",
            agentPerformance: "Agentenleistung",
            chatDistributions: "Chat-Verteilung",
            users: "Benutzer",
            segmentTimeseries: "Segment-Zeitreihe",
            segmentsOverall: "Gesamtsegmente",
            unmatchRatio: "Nichtübereinstimmungsverhältnis",
            totalMatchCount: "Gesamtanzahl der Übereinstimmungen",
            totalUnmatchCount: "Gesamtanzahl der Nichtübereinstimmungen",
            matchRatio: "Übereinstimmungsverhältnis",
            matched: "Übereinstimmend",
            trainingOverall: "Gesamtschulung",
            trainingStatusTimeseries: "Schulungsstatus-Zeitreihe",
            duration: "Dauer",
            totalSessionDuration: "Gesamtdauer der Sitzung",
            averageSessionDuration: "Durchschnittliche Sitzungsdauer",
            second: "Sekunde",
            minute: "Minute",
            hour: "Stunde",
            aggregateAs: "Aggregieren als",
            chatbotSessionDurationOverall: "Gesamtdauer der Chatbot-Sitzung",
            ratingTimeSeries: "Bewertungszeitreihe",
            chatCountTimeseries: "Chat-Zählzeitreihe",
            notRated: "Nicht bewertet",
            totalRatingCount: "Gesamtanzahl der Bewertungen",
            averageRating: "Durchschnittliche Bewertung",
            weightedAverageRating: "Gewichteter Durchschnitt der Bewertung",
            rate: "Bewerten",
            ratingOverall: "Customer Ratings Overall",
            session: "Sitzung",
            total: "Gesamt",
            average: "Durchschnitt",
            max: "Maximal",
            min: "Minimal",
            sessionCount: "Sitzungszähler",
            uniqueUsers: "Eindeutige Benutzer",
            viewAs: "Anzeigen als:",
            overall: "Insgesamt",
            detailReport: "Ausführlicher Bericht",
            dailyReports: "Tagesberichte",
            pointBasedReports: "Punktbasierte Berichte",
            personDateBasedPointReport: "Person und täglicher Punktbericht",
            personDateBasedReport: "Person und Tagesbericht",
            personBasedReport: "Personenbasierte Berichte",
            personAndDateBasedGraph: "Person und tägliche Grafik",
            noReport: "Kein Bericht",
            reports: "Berichte",
            totalBar: "Gesamt",
            ticketCount: "Ticket Count",
        },
        announcements: {
            menu: "Ankündigungen",
            newAnnouncementForm: "Neues Ankündigungsformular",
            updateAnnouncementForm: "Ankündigungs -Update -Formular",
        },
        stats: {
            total: "Die Anzahl der aktiven Gespräche im System.",
            active: "Es ist die Anzahl der aktiven Gespräche, die Ihnen gehören.",
            waiting: "Der Vertreter ist die Anzahl der neuen aktiven Reden, die darauf warten, ernannt zu werden.",
            late: "Es ist die Anzahl der neuen Reden, die für einen bestimmten Zeitraum verabschiedet wurden und darauf warten, zum Vertreter ernannt zu werden.",
            free: "Der Vertreter ist die Anzahl der Reden, die darauf warten, nach der Veröffentlichung einen neuen Vertreter zu ernennen.",
            pco: "[Personal Arbeitsverhältnis]: Dies ist die Belegungsrate der Anzahl der Reden, in denen die Online -Vertreter im System erhalten können.",
            maxCapacity:
                "Ist die maximale Anzahl von Chats, die das System einen Vertreter ernennen kann, ohne zu warten",
            chatbot: "Chatbots aktive Reden Nummer",
        },
        time: {
            lastYear: "Letztes Jahr",
            thisYear: "Dieses Jahr",
            last3Months: "Letzte 3 Monate",
            last7: "Letzte 7 Tage",
            today: "Heute",
            yesterday: "Gestern",
            lastWeek: "Letzte Woche",
            currentWeek: "Diese Woche",
            currentMonth: "Diesen Monat",
            lastMonth: "Im vergangenen Monat",
            last30Day: "Letzte 30 Tage",
            allTime: "Jederzeit",
            custom: "Eine andere Zeit",
        },
        fastWizard: {
            generalColors: "Allgemeine Farben",
            tellUsMore: "Geben Sie uns mehr Informationen, damit wir Ihre Erfahrungen personalisieren können",
            moreInfo: "Allgemeine Einstellungen",
            display: "Themen Einstellungen",
            availability: "Repräsentative Arbeitszeit",
            preview: "Vorschau",
            installCode: "Aufstellen",
            previous: "Vorheriger Schritt",
            setupSupsisLiveChat: "SUPSIS Live Fast Setting",
            continue: "Nächster Schritt",
            completeInitialize: "Führen Sie die schnelle Installation ab",
            completedMessage: "Supsis Live Quick Installation wurde erfolgreich durchgeführt.",
            websiteIntegration: "Adresse Ihrer Website für die Live -Integration von Supsis",
            customizeLiveChat: "Passen Sie Ihren Live -Chat an",
            createBrandedExperience: "Erstellen Sie ein Marken -Chat -Erlebnis für Ihre Besucher.",
            chatColor: "Chatfarbe",
            chooseChatColor: "Wähle eine Farbe.",
            chatBubble: "Chat -Ballon",
            selectBubble: "Wählen Sie einen Chat -Ballon",
            chatBubbleColor: "Chat -Ballonfarbe",
            selectChatBubbleColor: "Wählen Sie die Chat -Ballonfarbe",
            customSelection: "Besondere Wahl:",
            onlineSupportVisitorTime: "In welchen Zeitintervallen bieten Sie Ihren Besuchern an?",
            channelAvailability: "Zykluszeitpunkt",
            availability724: "7/24 kontinuierlicher Service",
            basedOnTeam: "Vertreter innerhalb der Arbeitszeiten",
            basedOnTeamExplanation:
                "Wenn es mindestens 1 Vertreter online gibt, erscheint der Chat online. Wenn es keinen Online -Vertreter gibt, erscheint es als offline",
            customHours: "Besondere Arbeitszeiten",
            customHoursExplanation: "Bestimmen Sie Ihre eigenen Arbeitszeiten",
            customHoursTimezone: "Regionale Zeitzone:",
            customHoursFrom: "Anfang:",
            customHoursTo: "Beenden:",
            customHoursAddHours: "+Uhr hinzufügen",
            previewDesktop: "Desktop",
            previewIpad: "Tablette",
            installationAndInstructions: "Installationsanleitung",
            installationTrackingCode: "Laden Sie die Tracking -Nummer auf Ihre Website hoch",
            installationTrackingCodePlease:
                "Bitte fügen Sie den Code gemäß den folgenden Anweisungen kurz vor dem Ende des {bodyTag} -Tags auf einer beliebigen Seite ein, die SUPSıs Live -Chat aktivieren möchten.",
            installationInstructionsJavascript:
                "Fügen Sie den oben genannten Integrationscode kurz vor dem Schließen im {bodyTag} -Label ein.",
            installationInstructionsShopify1: "1. Melden Sie sich bei Ihrem Shopify -Panel an",
            installationInstructionsCopy: "Kopieren",
            installationInstructionsCoppyMessage: "Integrationsbefehle an die Karte kopiert",
            installationInstructionsShopify2:
                "2. Gehen Sie zum Online -Shop> Themen> Aktionen im POP -UP -Menü unter dem aktuellen Thema> Code bearbeiten> thema.liquid",
            installationInstructionsShopify3:
                "3. Platzieren Sie den Integrationscode vor dem {bodyTag} -Label am Ende von Theme.liquid Skript.",
            installationInstructionsIdeaSoft1: "1. Melden Sie sich bei Ihrem Händlerpanel an.",
            installationInstructionsIdeaSoft2:
                "2. Einstellungen -> SEO -> Befolgen Sie den Schritt der Suchmaschinendienste.",
            installationInstructionsIdeaSoft3:
                "3. Platzieren Sie den oben angegebenen Integrationscode direkt vor dem {bodyTag} Tag am Ende des theme.liquid-Skripts.",
            installationInstructionsIdeaSoft4:
                "4. Kopieren Sie den oben genannten Integrationscode in das geöffnete Feld.",
            installationInstructionsIdeaSoft5:
                '5. Einstellungen -> Optimierungen -> Drücken Sie die Taste "Davtur". Die Integration wurde abgeschlossen.',
            installationInstructionsWordPress1: "1. Melden Sie sich in Ihrem WordPress Admin -Bereich an",
            installationInstructionsWordPress2: "2. anzeigen> gehen zum Thema redaktionell",
            installationInstructionsWordPress3:
                "3. Suchen und wählen Sie den Footprint (footer.php) unter den Themendateien (rechts) (rechts).",
            installationInstructionsWordPress4:
                "4. Fügen Sie den obigen Integrationscode vor dem {bodyTag} -Tag unten ein.",
            installationInstructionsWordPress5:
                "5. Aktualisieren Sie die Datei, um Änderungen zu speichern. Klicken Sie auf",
            installationInstructionsOpenCart1: "1. Melden Sie sich in Ihrem OpenCart -Administratorfeld an",
            installationInstructionsOpenCart2: "2. Design> Gehen Sie zu Tema Editorial",
            installationInstructionsOpenCart3:
                '3. Wählen Sie den Ordner "Common" aus und öffnen Sie die Datei "Header.twig" darin.',
            installationInstructionsOpenCart4:
                "4. Fügen Sie den obigen Integrationscode vor dem {headtag} -Tag unten ein.",
            installationInstructionsOpenCart5: "5. Klicken Sie auf die Schaltfläche Speichern",
            installationInstructionsTicimax1: "1. Melden Sie sich in Ihrem Ticimax -Management -Panel an",
            installationInstructionsTicimax2: "2. Design> Konstruktionseinstellungen> Headerfußzeile Design Open",
            installationInstructionsTicimax3: "3. Klicken Sie im Abschnitt Logo -Design auf 'Source'Buton.",
            installationInstructionsTicimax4: "4. Fügen Sie den obigen Integrationscode unter den HTML -Code ein.",
            installationInstructionsEticaretteyim1: "1. Melden Sie sich bei Ihrem E-Commerce-Administrationsbereich an",
            installationInstructionsEticaretteyim2:
                "2. Benennen Sie einfach SUPSIS aus Plugins > HTML generieren > und kopieren Sie den Code.",
            installationInstructions: "Anweisungen",
            installationVerify: "Überprüfen Sie die SUPSIS -Installation Ihrer Website",
            installationVerifyChecking: "Kontrolliert",
            installationVerifyCheck: "prüfen Sie",
            installationVerifyCheckingStatus: "Der SUPSIS -Integrationsstatus von {website} prüft",
            installationCheckingStatusMessageYes: "SUPSıs Live wurde in {website} integriert.",
            installationCheckingStatusMessageNo:
                "SUPSIS ist derzeit nicht mit der Website {website} integriert. Sie können Ihren Integrationsprozess jetzt oder später abschließen.",
            vtippyPreferredLanguage: "Bevorzugte Sprache",
        },
        akinon: {
            typeOrSelectSKU: "Schreiben oder wählen Sie SKU",
            akinonUserId: "Akinon User ID",
            userEmail: "Benutzer Email",
            userEmailDesc: "Schreiben oder wählen Sie die Benutzer -E -Mail ...",
            send: "Schicken",
            selectCity: "Wählen Sie den Distrikt",
            city: "Bezirk",
            selectState: "Wählen Sie Ihre Provinz",
            state: "Provinz",
            useMap: "Verwenden Sie die Karte",
            chooseAddress: "Adresse auswählen",
            selectCountry: "Land auswählen",
            country: "Land",
            productIdDesc: "Schreiben oder wählen Sie das Produkt ...",
            productId: "Produkt ID",
            userIdDesc: "Schreiben Sie die Akinon -Benutzer -ID ...",
            productSKU: "Produkt SKU",
            latitudeDesc: "Schreiben oder wählen Sie den Zielort der Zielort ...",
            longitudeDesc: "Schreiben oder wählen Sie die Länge der Zielposition ...",
            orderNumber: "Ihre Auftragsnummer",
            orderDesc: "Schreiben Sie die Bestellnummer ...",
            longitude: "Längengrad",
            latitude: "Breite",
        },
        probel: {
            branchCode: "Branchencode",
            branchCodeDesc: "Schreiben oder wählen Sie den Zweig -Code ...",
            hospitalBranchCode: "Branchencode",
            hospitalBranchCodeDesc: "Schreiben oder wählen Sie den Zweig -Code ...",
            clinicCode: "Polyclinic Code",
            clinicCodeDesc: "Schreiben oder wählen Sie den Polyclinic Code ...",
            date: "Termin",
            dateDesc: "Geben Sie das Datum des Termins ein oder wählen Sie ...",
            patientToken: "Patient Token",
            patientTokenDesc: "Schreiben oder wählen Sie das Patient -Token ...",
            appointmentId: "Termin -ID",
            appointmentIdDesc: "Schreiben oder wählen Sie die Termin -ID ...",
            identityType: "Identitätstyp",
            identityNumber: "Identifikationsnummer",
            name: "Patientenname",
            surname: "Nachname des Patienten",
            gender: "Kranker Sex",
            birthDay: "Patientendatum der Geburtsdatum",
            phoneNumber: "Patientennummer",
            identityTypeDesc: "Schreiben oder wählen Sie die Art der Identität ...",
            identityNumberDesc: "Schreiben oder wählen Sie die ID -Nummer ...",
            nameDesc: "Schreiben oder wählen Sie den Patientennamen ...",
            surnameDesc: "Schreiben oder wählen Sie den Nachnamen des Patienten ...",
            genderDesc: "Schreiben oder wählen Sie Patientensex ...",
            birthDayDesc: "Schreiben oder wählen Sie das Geburtsdatum ...",
            phoneNumberDesc: "Geben Sie die Patientennummer ein oder wählen Sie die Patientennummer ...",
        },
        headBar: {
            email: "Email",
            phone: "Telefon",
            name: "Name",
            date: "Geschichte",
            subject: "Thema",
            situation: "Situation",
            representative: "Vertreter",
            transactions: "Transaktionen",
        },
        login: {
            loginTitle1: "Willkommen bei",
            loginTitle2: "SUPSIS",
            email: "Deine E-Mail Adresse",
            emailPlaceholder: "Geben Sie bitte Ihre Email-Adresse ein.",
            emailError: "Bitte eine gültige E-Mail-Adresse eintragen",
            password: "Ihr Passwort",
            passwordLogin: "Passwortfreies Login",
            passwordAndLogin: "Login mit Passwort",
            passwordNew: "Setze mein Passwort zurück",
            loginAnd: "Oder",
            passwordPlaceholder: "Bitte geben Sie Ihr Passwort ein.",
            loginMemory: "erinnern Sie sich an dieses Gerät",
            passwordForget: "Ich habe mein Passwort vergessen",
            passwordNewAgain: "Neues Kennwort",
            passwordNewAgainTwo: "Neues Passwort wiederholen",
            passwordNewAgainPlaceholder: "Bitte geben Sie Ihr neues Passwort ein.",
            passwordNewAgainPlaceholderTwo: "Bitte geben Sie Ihr neues Passwort erneut ein.",
            login: "Anmeldung",
            loginFooter: "Oder melden Sie sich mit E-Mail an",
            emailLogin: "Melden Sie sich mit E-Mail an",
        },
        settings: {
            auditlogs: "Audit Logs",
            myaccount: "My Account",
            notifications: "Notifications",
            company: "Firma",
            features: "Eigenschaften",
            general: "Allgemeines",
            chat: "Plaudern",
            wallet: "Brieftasche",
            timings: "Zeitmessung",
            language: "Sprache",
            "bubble-settings": "Blaseneinstellungen",
            "bubble-actions": "Blasenaktionen",
            "theme-settings": "Thema Einstellungen",
            visitorLoginForm: "Besucher Login Formular",
            visitorAttribute: "Informationen zum Besucherprofil",
            timing_settings: "Chat Timing Einstellungen",
            auto_assign: "Auto Chat Assign",
            availability: "Verfügbarkeit",
            "website-integration": "Website Integration",
            General: "Allgemeines",
            Chat: "Plaudern",
            Timings: "Zeitmessung",
            Integration: "Integration",
            developer: "Entwickler",
            visitorNew: "Neuer Besucher",
            companySubtitles: "Verwalten Sie Ihre Unternehmensinformationen.",
            featuresSubtitles: "Verwalten Sie Ihre Funktionen.",
            languageSubtitles: "Verwalten Sie Ihre Spracheinstellungen.",
            bubbleSettings: "Blaseneinstellungen",
            bubbleSettingsSubtitles: "Verwalten Sie Ihre Blaseneinstellungen.",
            bubbleActionsSubtitles: "Verwalten Sie Ihre Blasenaktionen.",
            chatThemeSettingsSubtitles: "Verwalten Sie Ihre Chat -Thema -Einstellungen.",
            visitorLoginFormSubtitles: "Verwalten Sie Ihre Besucher -Login -Formular -Einstellungen.",
            chatTimingSettingsSubtitles: "Verwalten Sie Ihre Chat -Timing -Einstellungen.",
            webSiteIntegrationSubtitles: "Verwalten Sie Ihre Website -Integration.",
            apiAccessTitle: "API Zugriff",
            apiAccessSubtitles: "Verwalten Sie Ihre API -Zugriff.",
            youTubeActionForm: "Fügen Sie Ihren YouTube -Kanal hinzu",
            linkedinActionForm: "Fügen Sie Ihr LinkedIn-Konto hinzu",
            telegramActionForm: "Telegram-Konto hinzufügen",
            facebookActionForm: "Fügen Sie Ihre Facebook -Seite hinzu",
            tiwitterActionForm: "Fügen Sie Ihren Twitter -Kanal hinzu",
            instagramActionForm: "Fügen Sie Ihren Instagram -Kanal hinzu",
            liveSupportDescription: "Aktivieren Sie den Live -Support -Modus, um Ihre Besucher zu unterstützen.",
            ticketDescription: "Aktivieren Sie den Ticket -Modus, um Ihre Besucher zu unterstützen.",
            whatsappDescription: "Aktivieren Sie den Whatsapp -Modus, um Ihre Besucher zu unterstützen.",
            phoneDescription: "Aktivieren Sie den Telefon -Modus, um Ihre Besucher zu unterstützen.",
            emailDescription: "Aktivieren Sie den E-Mail -Modus, um Ihre Besucher zu unterstützen.",
            facebookDescription: "Aktivieren Sie den Facebook -Modus, um Ihre Besucher zu unterstützen.",
            twitterDescription: "Aktivieren Sie den Twitter -Modus, um Ihre Besucher zu unterstützen.",
            instagramDescription: "Aktivieren Sie den Instagram -Modus, um Ihre Besucher zu unterstützen.",
            youtubeDescription: "Aktivieren Sie den Youtube -Modus, um Ihre Besucher zu unterstützen.",
            linkedinDescription: "Ermöglichen Sie Ihren Kunden, Sie mit LinkedIn zu erreichen",
            telegramDescription: "Lassen Sie Ihre Kunden mit Telegram an Größe gewinnen",
            whatsappModalTitle: "WhatsApp-Transaktionsformular",
            whatsappModalDescription: "Bitte füllen Sie das Formular unten aus, um Ihr WhatsApp-Konto zu verbinden.",
            phoneModalTitle: "Telefontransaktionsformular",
            phoneModalDescription: "Bitte füllen Sie das Formular unten aus, um Ihr Telefonkonto zu verbinden.",
            emailModalTitle: "E-Mail Transaktionsformular",
            emailModalDescription: "Bitte füllen Sie das Formular unten aus, um Ihr E-Mail-Konto zu verbinden.",
            facebookModalTitle: "Facebook Transaktionsformular",
            facebookModalDescription: "Bitte füllen Sie das Formular unten aus, um Ihr Facebook-Konto zu verbinden.",
            twitterModalTitle: "Twitter-Transaktionsformular",
            twitterModalDescription:
                "Bitte füllen Sie das untenstehende Formular aus, um Ihr Twitter-Konto zu verbinden.",
            instagramModalTitle: "Instagram-Transaktionsformular",
            instagramModalDescription: "Bitte füllen Sie das Formular unten aus, um Ihr Instagram-Konto zu verbinden.",
            youtubeModalTitle: "Youtube Transaktionsformular",
            youtubeModalDescription: "Bitte füllen Sie das Formular unten aus, um Ihr Youtube-Konto zu verbinden.",
            linkedinModalTitle: "LinkeIn-Transaktionsformular",
            linkedinModalDescription:
                "Bitte füllen Sie das untenstehende Formular aus, um Ihr LinkedIn-Konto zu verknüpfen.",
            telegramModalTitle: "Telegram-Transaktionsformular",
            telegramModalDescription:
                "Geben Sie Ihren Telegram-Profillink in das untenstehende Formular ein, um Ihr Telegram-Konto zu verknüpfen",
            instagramAlertTitle: "Instagram-Integration erforderlich",
            instagramAlertDesc:
                "Entschuldigung, die von Ihnen besuchte Seite wird aktiviert, wenn Sie Ihr Instagram integrieren.",
            instagramActivateText: "Los geht's, integriere Instagram",
            remove: "Entfernen",
            edit: "Bearbeiten",
            connected: "Verbunden",
            add: "Hinzufügen",
            themeDescription: "Wählen Sie ein Thema für Ihren Chat aus.",
            fontDescription: "Wählen Sie eine Schriftart für Ihren Chat aus.",
            isFabsAsIcon: "Menüsymboltexte anzeigen.",
            chatBubbleTextSetting: "Chat-Blasentext-Einstellung",
            textOnChatBubble: "Sie können die Texteinstellungen anpassen, die in der Chat-Blase angezeigt werden.",
            textToAppearOnChatBubble: "Text, der in der Chat-Blase angezeigt wird",
            newVisitorProfileInformation: "Neue Besucherprofilinformationen",
            newVisitorProfileInformationDescription: "Fügt den Besucherprofilinformationen einen neuen Wert hinzu",
            create: "Erstellen",
            newAdd: "Neue hinzufügen",
            toInform: "Informieren",
            toInformDescription:
                "Sie können die Werte, die Sie auf dieser Seite hinzufügen, mit dem Besucher-Anmeldeformular abgleichen.",
            showVisitor: "Besucher anzeigen",
            label: "Fahrkarte",
            text: "Schreiben",
            email: "Email",
            phone: "Telefon",
            number: "Nummer",
            url: "URL",
            date: "Zeit",
            dropdown: "wählbar",
            languageTimeZone: "Sprache und Region",
            timeZoneTitle: "Region und Zeitzone",
            timeZoneDescription: "Regions- und Zeitzoneneinstellungen",
        },
        userInfoWidget: {
            userInformation: "Nutzerinformation",
            fullName: "Name und Nachname",
            newValue: "Neuer Wert",
            newProfileInfo: "Neue Profilinformationen",
            affiliatedRepresentatives: "Vertreter",
            preferredAgents: "Bevorzugter Agent",
            labels: "Etiketten",
            agentNotes: "Agentennotizen",
            newNote: "Neue Notiz",
            note: "Notiz",
            available: "Es sind Notizen vorhanden.",
            systemInformation: "System Information",
            speechID: "Sprach-ID",
            customerVersion: "Kundenversion",
            IPAddress: "IP Adresse",
            pageVisited: "Seite besucht",
            systemAndBrowser: "Betriebssystem und Browser",
            countryAndLanguage: "Land und Sprache",
            clickToEdit: "Bearbeiten Klicken Sie in den Beitrag",
            adsYouAreInterestedIn: "Anzeigen, an denen Sie interessiert sind",
            detail: "Detail",
            adsTitle: "Titel",
            adUrl: "Anzeigen-URL",
            sourceID: "Quell-ID",
            resourceType: "Ressourcentyp",
            adsBody: "Inhalt",
            adsCreateDate: "Erstellungsdatum",
            adsUpdateDate: "Aktualisierungsdatum",
        },
        newWizartV2: {
            generalSettings: "Allgemeine Einstellungen",
            themeSettings: "Themen Einstellungen",
            representativeWorkingHours: "Repräsentative Arbeitszeiten",
            preview: "Repräsentative Arbeitszeiten",
            setup: "Aufstellen",
            formStepTitle: "Geben Sie uns weitere Informationen, damit wir Ihr Erlebnis individuell gestalten können",
            supsisEntergation: "Wo werden Sie Supsis auf Ihrer Website verwenden?:",
            goToNextStep: "Machen Sie den nächsten Schritt",
            readytemplate: "Verwenden Sie eine fertige Farbvorlage",
            customSettings: "Benutzerdefinierte Einstellungen",
            customerMessageView: "Kundennachrichtenansicht",
            backcgroundColor: "Hintergrundfarbe",
            textColor: "Schriftfarbe",
            agentMessageView: "Agentennachrichtenansicht",
            workingHours: "In welchen Zeitabständen bieten Sie Ihren Besuchern Dienstleistungen an?",
            continuousService: "Kontinuierlicher Service",
            continuousServiceDescription: "Die Chat-Blase ist immer aktiv. Auch wenn Sie nicht im System sind.",
            vote: "Treffen Sie Ihre Wahl",
            representativeWorking: "Repräsentative Arbeitszeiten",
            representativeWorkingDescription:
                "Der Chat erscheint online, wenn mindestens 1 Agent online ist. Wenn kein Online-Vertreter vorhanden ist, wird er als offline angezeigt.",
            computer: "Computer",
            tablet: "Tablette",
            uploadTrackingCodeToYourWebsite: "Laden Sie den Tracking-Code auf Ihre Website hoch",
            password: "Neues Passwort festlegen",
        },
        whatsappChannel: {
            whatsappTitleV1: "Whatsapp V1 Kanäle (QR)",
            whatsappTitleV2: "Whatsapp V2 Kanäle (QR)",
            channelName: "Channel",
            phoneNumber: "Telefonnummer",
            forwardToChatbot: "An Chatbot weiterleiten",
            forwardingChatbotOrLiveAgent: "Weiterleitung (Chatbot oder Live-Agent)",
            addChannel: "Kanal hinzufügen",
            newWhatsappChannel: "Neuer WhatsApp-Kanal",
            newWhatsappChannelDescription: "Erstellen Sie einen neuen WhatsApp-Kanal, indem Sie den QR-Code scannen",
            editWhatsappChannel: "WhatsApp-Kanal bearbeiten",
            editWhatsappChannelDescription: "WhatsApp-Kanal bearbeiten",
            whatsappChannel: "WhatsApp-Kanal",
            deleteWhatsappChannelDescription: "Sind Sie sicher, dass Sie diesen Kanal löschen möchten?",
            whatsappIntegration: "WhatsApp-Integration",
            deleteChannel: "Kanal löschen",
            restartChannel: "Kanal neu starten",
            wantRestartChannel: "Möchten Sie den Kanal neu starten?",
            deleteSMSChannelDescription: "Sind Sie sicher, dass Sie den SMS-Kanal löschen möchten?",
            smsChannel: "SMS-Kanal",
            maxChannelCount: "Sie können nicht mehr als einen SMS-Kanal erstellen!",
            smsModalText:
                "Unsere Integration mit modernen Kommunikationslösungen bietet Ihnen die Möglichkeit, SMS einfach und effektiv zu versenden. Beseitigen Sie Grenzen in der Kommunikation, treten Sie direkt mit Ihren Kunden in Kontakt!",
            smsModalBtn: "Klicken Sie hier, um den SMS-Kanal zu öffnen...",
            postaCellDetail: "PostaCell-Kanaldetails",
        },
        noPermission: "Sie haben keine Berechtigung, diese Aktion auszuführen.",
        mail_integration_detail: {
            title: "E-Mail-Detail",
            integration: "Integration",
            sender: "Absender-E-Mail",
            signature: "Unterschrift",
            inbox: "Posteingang",
            medias: "Medien",
            visibility: "Sichtbarkeit",
            settings_group: "Einstellungen",
            contacts: "Kontakte",
        },
        whatsapp_business_api: {
            title: "Whatsapp Business API Kanäle",
            integration: "Integration",
            detail: "Detail",
            visibility: "Sichtbarkeit",
            templates: "Alle Vorlagen-Nachrichten",
            settings_group: "Einstellung",
            template_message_group: "Vorlagen-Nachrichten",
            chat_initiator_template: "Chat-Initiierungsvorlage",
            contacts: "Kontakte",
            numbers: "Zahlen",
            all_contacts: "Alle Kontakte",
            new_template: "Neue Vorlage erstellen",
            broadcast_group: "Rundsendung",
            broadcast_requests: "Rundsende-Anfragen",
            customer_groups: "Kundengruppen",
            businessChannelDetail: "Whatsapp Business Kanaldetails",
            wallet: "Wallet",
            postacellMessage: "SMS senden",
            postacellAllMessage: "Massen-SMS senden",
            message_group: "Nachricht",
            createNewTemplate: "Neue Vorlagennachricht erstellen",
            templateName: "Vorlagenname",
            templateNameDesc: "Geben Sie Ihrem Nachrichtenvorlagen einen Namen.",
            viewTemplates: "Vorlagen anzeigen",
            templateNameRules: "Der Vorlagenname darf nur Kleinbuchstaben, Zahlen und Unterstriche enthalten.",
            category: "Kategorie",
            categoryDesc: "Wählen Sie aus, welche Art von Vorlage Sie erstellen möchten",
            categoryUtility: "Dienstprogramm",
            categoryUtilityDesc:
                "Senden Sie nützliche Informationen wie Kontoupdates, Bestellupdates, Warnungen und mehr.",
            categoryMarketing: "Marketing",
            categoryMarketingDesc:
                "Senden Sie Werbeangebote, Produktangebote und mehr, um die Aufmerksamkeit und Interaktion zu erhöhen.",
            categoryAuth: "Authentifizierung",
            categoryAuthDesc: "Senden Sie Codes, damit Ihre Kunden auf ihre Konten zugreifen können.",
            optional: "Optional",
            languageDesc: "Wählen Sie die Sprache aus, in der Ihre Vorlagennachricht gesendet wird",
            header: "Header",
            headerRules:
                "Fügen Sie Ihrer Nachricht einen 60 Zeichen langen Header hinzu. Im Header wird nur eine Variable unterstützt.",
            headerOptionMedia: "Medien",
            headerOptionText: "Text",
            none: "Keiner",
            headerType: "Headertyp",
            headerText: "Headertext",
            body: "Körper",
            bodyRules: "Geben Sie den Text in der von Ihnen für Ihre Nachricht ausgewählten Sprache ein",
            addVariable: "Variable hinzufügen",
            variables: "Variablen",
            variable: "Variable",
            defaultVariableName: "Standardvariablenname",
            defaultVariableToolTip:
                "Ihre Variable erscheint im Template mit diesem Namen. <br><br> Darüber hinaus wird dieser Wert als Standardwert gesendet, falls andere Situationen auftreten.",
            selectATemplate: "Wählen Sie eine Nachrichtenvorlage",
            variableSettings: "Variablen-Einstellungen",
            example: "Beispiel",
            footer: "Fußzeile",
            footerDesc:
                "Fügen Sie Ihrer Nachricht eine Fußzeile mit 60 Zeichen hinzu. Variablen werden in der Fußzeile nicht unterstützt.",
            buttons: "Schaltflächen",
            buttonType: "Schaltflächentyp",
            buttonTypeReply: "Antworten",
            submit: "Speichern",
            submitting: "Wird übermittelt",
            addButton: "Schaltfläche hinzufügen",
            rejectWhatsapp: "Von Whatsapp abgelehnt.",
            approvedWhatsapp: "Von Whatsapp genehmigt.",
            pendingWhatsapp: "Ausstehende Genehmigung",
        },
    },
    fr: {
        chatWindow: {
            thereIsNoChatContent: "Aucun contenu de chat disponible.",
            thereIsNoChatContentDsc: "Vous pouvez voir le contenu du chat et envoyer des messages ici.",
            interactions: "Interactions :",
            departments: "Départements",
            channels: "Canaux",
            date: "Date",
            lastChatStatus: "Dernier statut du chat",
            all: "Tous",
            queued: "En attente",
            open: "Ouvert",
            closed: "Fermé",
            private: "Privé",
            chatbot: "Chatbot",
            lostMissed: "Perdu / Manqué",
            interaction: "Interaction",
            myActiveInbox: "Ma boîte de réception active",
            activeQueueInbox: "Boîte de réception active + file d'attente",
            chatbotActiveInbox: "Boîte de réception active du chatbot",
            myDepartmentsActiveInbox: "Boîte de réception active de mes départements",
            notInteractedYesterday: "Aucune interaction hier",
            queueInbox: "File d'attente de la boîte de réception",
            whatsappActiveInbox: "Boîte de réception active WhatsApp",
            socialMediaActiveInbox: "Boîte de réception active des réseaux sociaux",
            missedThisMonth: "Chats manqués ce mois-ci",
            chooseAFileOrDragItHere: "Choisissez un fichier ou faites-le glisser ici!",
            watching: "En train de regarder",
            selectFilter: "Sélectionner un filtre",
            clearAll: "Tout effacer",
            me: "Moi",
            today: "Aujourd'hui",
            yesterday: "Hier",
            thisWeek: "Cette semaine",
            lastWeek: "La semaine dernière",
            last7Days: "Les 7 derniers jours",
            last30Days: "Les 30 derniers jours",
            thisMonth: "Ce mois-ci",
            lastMonth: "Le mois dernier",
            last24h: "Les dernières 24 heures",
            custom: "Personnalisé",
            startMessage: "Démarrer le message",
            goToAgentReport: "Aller au rapport d'agent",
            agentDetail: "Détail de l'agent",
            agentList: "Liste des agents",
            selectedFilter: "Filtre sélectionné",
            groupBy: "Grouper",
            none: "Pas de groupe",
            agent: "Représentant",
            department: "Département",
            sortBy: "Trier",
            lastPostAbove: "Dernier message en haut",
            newChatsAbove: "Nouveaux chats en haut",
            oldChatsAbove: "Anciens chats en haut",
            live: "En direct",
            systemStatus: "État du système",
            refresh: "Rafraîchir",
            close: "Fermer",
            totalCustomers: "Nombre total de clients",
            totalAnswered: "Total répondu",
            waitingAnswer: "En attente de réponse",
            totalAgentInChat: "Nombre total d'agents en chat",
            onlineAgentCount: "Nombre d'agents en ligne",
            totalCustomer: "Client total",
            answered: "Répondu",
            unanswered: "Non répondu",
            noContactWasFoundMatchingTheCurrentFilters: "Aucun contact ne correspond aux filtres actuels.",
            you: "Vous",
            others: "Autres",
            queue: "File d'attente",
            chatbotContact: "Chatbot",
            closedContact: "Fermé",
            myInteractions: "Mes Interactions",
            special: "Spécial",
            allInteractions: "Tous les contacts",
            waiting: "En attente",
            departmentToWhichItIsAffiliated: "Département auquel il est affilié",
        },
        plans: {
            manageWithChatbot: "Manage with Chatbot",
            manageInbox: "Manage Inbox",
            commentManagement: "Manage Comments",
            privateReplyMessage: "Private Reply Comments",
            mentionTicket: "Convert Mentions to Tickets",
            week: "Semaine",
            readyContents: "Contenus prêts",
            webhookIntegration: "Intégration de webhook",
            businessChannel: "Canal professionnel WhatsApp",
            confirmationFeature: "Fonction de confirmation",
            specialReporting: "Reporting spécial",
            aiAssistant: "Assistant IA",
            flexibleBilling: "Facturation flexible",
            automaticReservation: "Réservation automatique",
            taskManagement: "Gestion des tâches",
            calendarIntegration: "Intégration du calendrier",
            activeChatbot: "Chatbot actif",
            smsIntegration: "Intégration SMS",
            mailIntegration: "Intégration e-mail",
            startChatWithVisitor: "Commencer le chat avec le visiteur",
            whatsappManaging: "Gestion de Whatsapp",
            automaticChatbotButton: "Bouton/Chatbot automatique",
            personalizedBroadcasts: "Diffusions personnalisées",
            chatWithNonContacts: "Chat avec les non contacts",
            broadcastMessaging: "Messagerie de diffusion",
            perBroadcast: "Par diffusion",
            extraPricePerMessage: "Prix supplémentaire par message",
            smartTrigger: "Déclencheur intelligent",
            telegramIntegration: "Intégration de Telegram",
            instagramIntegration: "Intégration d'Instagram",
            ticketFeature: "Fonction de ticket",
            storage: "Stockage",
            onePanelManagement: "Gestion à partir d'un seul panneau",
            isolatedDatabaseConnection: "Connexion de base de données isolée",
            removeLogo: "Supsis Logo Supprimer",
            chatBaloonCustomization: "Personnalisation du ballon de discussion",
            chatAndNotifications: "Chat et Notifications",
            unlimited: "Illimité",
            specialCustomerSupport: "Support client spécial",
            softwareSupport: "Support logiciel",
            standardSupport: "Support standard",
            teamChatIntegration: "Intégration de chat d'équipe",
            fileAndVoiceShare: "Partage de fichiers et de voix",
            instantVisitor: "Suivi instantané des visiteurs",
            detailedReporting: "Rapport détaillé",
            normalreporting: "Reporting normal",
            noExtraCosts: "Pas de frais supplémentaires",
            accessibleToAllAgents: "Accessible à tous les agents",
            dataSecurity: "Sécurité des données",
            autoTranslate: "Traduction automatique",
            chatbotVersionHistory: "Historique des versions du chatbot",
            chatbotStory: "Histoire du chatbot",
            freeAgent: "Agent gratuit",
            stableAgentCount: "Nombre d'agents stables",
            stableChannelCount: "Stable Channel Count",
            chipPlans: "Plans abordables",
            generalPlan: "Plan général",
            specialPlan: "Plan spécial",
            currentPlan: "Plan actuel",
            selected: "Sélectionné",
            popular: "Populaire",
            trialPkg: "Forfait d'essai",
            support: "Support 24/7",
            flexiblePricing: "Tarification flexible",
            rightToCancel: "Droit d'annulation à tout moment",
            unlimitedCBScenario: "Scénarios de chatbot illimités",
            freeFirstScenario: "Premier scénario gratuit",
            unlimitedLearn: "Formation illimitée au chatbot",
            allPlatformIntegration: "Intégration avec toutes les plateformes",
            detailedReports: "Rapports détaillés",
            aiSupport: "Support IA",
            creativeAI: "Assistant de chat IA rapide et réaliste",
            unlimitedSession: "Sessions illimitées simultanément",
            assistantFromWebsite: "Créer un assistant à partir du site Web",
            assistantFromDoc: "Créer un chatbot à partir du document",
            mobileApp: "Application mobile",
        },
        messenger: {
            channel: "Canal Messenger",
            manageChannel: "Gérer le canal",
            channelDetail: "Détail du canal",
            integrationTitle: "Intégration Messenger",
            deleteDesc: "Êtes-vous sûr de vouloir supprimer le canal Messenger?",
            channels: "Canaux Messenger",
            connectMessenger: "Se connecter à Messenger",
            detail: "détail",
            visibility: "Visibilité",
            settings_group: "Paramètres",
            commentsettings: "Gestion des commentaires",
            commentSettingsTitle: "Gestión de comentarios de Messenger",
            commentSettingsDesc: "Gérer vos commentaires Messenger",
        },
        instagram: {
            channel: "Chaîne Instagram",
            detail: "détail",
            visibility: "Visibilité",
            settings_group: "Paramètres",
            commentsettings: "Gestion des commentaires",
            commentSettingsTitle: "Gestion des commentaires Instagram",
            commentSettingsDesc: "Gérez vos commentaires Instagram",
            commentSettingsTicket:
                "Assure que les commentaires entrants sont enregistrés dans le système sous forme de tickets.",
            commentSettingsChatbot:
                "Sélectionnez à quel scénario de chatbot les commentaires entrants doivent être dirigés.",
            leads: "Leads",
            forms: "Forms",
        },
        calendar: {
            setting: "Paramètres",
            delete: "Supprimer",
            cancel: "Annuler",
            save: "Enregistrer",
            close: "Fermer",
            deleteRepeatEvent: "Supprimer l'événement récurrent",
            thisEvent: "Cet événement",
            thisAndOtherEvent: "Cet événement et les suivants",
            allEvent: "Tous les événements",
            ok: "OK",
            googleCalendarLink: "Ajouter au Google Agenda",
            yahooCalendarLink: "Ajouter au Yahoo Agenda",
            subject: "Sujet",
            visitor: "Visiteur",
            allDay: "Toute la journée",
            title: "Titre",
            deleteEvent: "Supprimer l'événement",
            deleteEvents: "Supprimer les événements",
            deleteEventsSure: "Êtes-vous sûr de vouloir supprimer les événements de ce calendrier?",
            deleteEventConfirm: "Êtes-vous sûr de vouloir supprimer cet événement?",
            notEmptyTitle: "Le titre ne peut pas être vide!",
            tasks: "Tâches",
            googleConnect: "Intégration Google",
            googleDisconnect: "Désactiver l'intégration Google",
            sure: "Êtes-vous sûr?",
            disconnectGoogleSure: "Êtes-vous sûr de vouloir désactiver la connexion Google?",
            yes: "Oui",
            no: "Non",
            customRepeat: "Répétition personnalisée",
            recurrenceFrequency: "Fréquence de répétition",
            repeatDays: "Répéter les jours suivants:",
            never: "Jamais",
            thisDate: "À cette date:",
            recurrenceCount: "Nombre de répétitions:",
            end: "Fin",
            event: "Événement",
            calendars: "Calendriers",
            newCalendar: "Créer un nouveau calendrier",
            changeColor: "Changer de couleur",
            addCalendar: "Ajouter un calendrier",
            nameCalendar: "Nom du calendrier",
            description: "Description",
            change: "Modifier",
            deleteCalendar: "Supprimer le calendrier",
            deleteCalendarSure: "Êtes-vous sûr de vouloir supprimer ce calendrier?",
            notEmptyCalendarName: "Le nom du calendrier ne peut pas être vide",
            myEvents: "Mes événements",
            everyoneEvents: "Tous les événements",
            haveEvent: "événements de l'agent",
            goCalendar: "Aller au calendrier",
            goReservation: "Créer une réservation",
            agents: "Agents",
            today: "Aujourd'hui",
            month: "Mois",
            week: "Semaine",
            day: "Jour",
            list: "Liste",
        },
        ticimax: {
            segment: "Segment",
            settings_group: "Groupe de paramètres",
            waitDayFromLastSend: "Jour d'attente depuis le dernier message envoyé",
            automationRuleName: "Nom de la règle d'automatisation",
            time: "Temps",
            year: "An",
            month: "Mois",
            dayOfMonth: "Jour du mois",
            day: "Jour",
            bySecond: "Par seconde",
            byMinute: "Par minute",
            byHour: "Par heure",
            byWeekNo: "Par numéro de semaine",
            byYearDay: "Par jour de l'année",
            byMonthDay: "Par jour du mois",
            byMonth: "Par mois",
            december: "Décembre",
            november: "Novembre",
            october: "Octobre",
            september: "Septembre",
            august: "Août",
            july: "Juillet",
            june: "Juin",
            may: "Mai",
            april: "Avril",
            march: "Mars",
            february: "Février",
            january: "Janvier",
            byWeekDay: "Par jour de semaine",
            interval: "Intervalle",
            seconds: "Secondes",
            minutes: "Minutes",
            hourly: "Toutes les heures",
            daily: "Quotidiennement",
            weekly: "Hebdomadaire",
            monthly: "Mensuel",
            yearly: "Annuel",
            frequency: "Fréquence",
            attributes: {
                vip: "VIP",
                segment: "Segment",
                province: "Province",
                country: "Pays",
                phone: "Téléphone",
                email: "E-mail",
                fullname: "Nom complet",
                couponPercent: "% de réduction",
                lastOrderDate: "Dernière commande",
                firstOrderDate: "Première commande",
                county: "Comté",
                lastSource: "Dernière source",
                firstSource: "Première source",
                lastPaymentType: "Dernier mode de paiement",
                firstPaymentType: "Premier mode de paiement",
                maxOrderAmount: "Montant maximal de la commande",
                minOrderAmount: "Montant minimal de la commande",
                totalOrderAmount: "Montant total de la commande",
                totalOrderCount: "Nombre total de commandes",
                usedCouponAmount: "Montant du coupon utilisé",
                usedCouponCount: "Nombre de coupons utilisés",
                tookDayFromLastOrder: "Jours depuis la dernière commande",
                isCouponUser: "Est utilisateur de coupon",
            },
            createAutomation: "Créer une automatisation",
            previous: "Précédent",
            createAutomationDesc: "Créez et gérez l'automatisation des messages",
            newTicimaxChannel: "Nouvelle chaîne Ticimax",
            connextToTicimaxXml: "Se connecter au service XML Ticimax",
            connectTicimax: "Se connecter à Ticimax",
            examplePreview: "Aperçu de l'exemple",
            completeAutomationRule: "Règle d'automatisation complète",
            configureMessage: "Configurer le message",
            automationTimer: "Minuterie d'automatisation",
            findTargetMembers: "Trouver les membres cibles",
            createAutomationRule: "Créer une règle d'automatisation",
            action: "Action",
            status: "Statut",
            triggeredUserCount: "Nombre d'utilisateurs déclenchés",
            nextScheduled: "Prochain prévu",
            timerRule: "Règle de minuterie",
            automationRules: "Règles d'automatisation",
            apply: "Appliquer",
            searchAMember: "Rechercher un membre",
            segmentedMembersDesc: "Énumérez et automatisez les membres segmentés",
            manageVisibilityDesc: "Gérer la visibilité du canal",
            xmlOrderListURL: "URL de la liste de commandes XML",
            manageIntegrationDesc: "Gérez votre intégration Ticimax",
            detail: "Détail",
            ticimaxChannelsTitle: "Canaux Ticimax",
            ticimaxDetail: "Détail Ticimax",
            settingsGroup: "Paramètres",
            visibility: "Visibilité",
            members: "Membres",
            automation: "Automatisation",
            integrationChannel: "Canal d'intégration",
            channelUpdated: "Chaîne mise à jour avec succès",
            channelUpdateFailed: "Échec de la mise à jour du canal",
        },
        notification: {
            mobileApp: "Application mobile",
            webPanel: "Panneau Web",
            notifications: "Notifications",
            whatsappActions: "Actions Whatsapp",
            chatbotActions: "Actions du chatbot",
            companyActions: "Actions de l'entreprise",
            crmActions: "ACTIONS CRM SUPSIS",
            basicActions: "Actions de base",
            notificationSettingsDesc:
                "Choisissez les notifications que vous souhaitez recevoir et où vous souhaitez les recevoir.",
            noNotificationDesc2:
                "Ici, vous verrez toutes les notifications liées aux offres d'emploi, aux candidats et aux pools de talents que vous suivez. Vous pouvez personnaliser les notifications en ajustant les paramètres.",
            noNotificationTitle2: "Pas encore de notifications.",
            noNotificationTitle1: "Pas de notifications. Profitez du silence.",
            adjustSettings: "Ajuster les paramètres",
            showAll: "Afficher tout",
            showOnlyUnread: "Afficher uniquement les non lus",
            mailWasSent: "Le courriel a été envoyé.",
            mailAdressRemoved: "Adresse e-mail supprimée.",
            chatbotPublished: "La version <b>{version}</b> du chatbot a été publiée par <b>{user}</b>.",
            chatbotDeleted: "Le chatbot <b>{chatbot}</b> a été supprimé par <b>{user}</b>.",
            settingsUpdatedWoDetail: "Les paramètres ont été mis à jour par <b>{user}</b>.",
            noActivityDesc:
                "Il n'y a actuellement aucune activité dans le système. Quelques événements doivent se produire",
            noActivityTitle: "Pas encore d'activité",
            actionType: "Type d'action",
            dateBetween: "Dates entre",
            selectActor: "Sélectionner un utilisateur",
            activities: "Activités",
            chatbotCreated: "Le chatbot nommé <b>{chatbot}</b> a été créé par <b>{user}</b>.",
            taskStageChanged:
                "L'étape de la tâche <b>{task}</b> a été changée de <b>{oldStage}</b> à <b>{newStage}</b> par <b>{user}</b>.",
            taskCreated: "La tâche <b>{task}</b> a été créée par <b>{user}</b>.",
            contactPropRemoved: "La propriété du visiteur <b>{prop}</b> a été supprimée par <b>{user}</b>.",
            contactPropAdded: "La propriété du visiteur <b>{prop}</b> a été ajoutée par <b>{user}</b>.",
            userRemoved: "L'utilisateur <b>{oldUser}</b> a été supprimé par <b>{user}</b>.",
            loginFormUpdated: "Le formulaire de connexion visiteur a été mis à jour par <b>{user}</b>.",
            loginFormDeactivated: "El formulario de inicio de sesión del usuario fue desactivado por <b>{user}</b>.",
            loginFormActivated: "Le formulaire de connexion de l'utilisateur a été activé par <b>{user}</b>.",
            invoiceRefunded: "Le processus de remboursement a été effectué par <b>{user}</b>.",
            paymentMethodAdded: "Une nouvelle méthode de paiement a été ajoutée par <b>{user}</b>.",
            invoicePaymentFailed: "Le paiement de la facture n'a pas été accepté par <b>{user}</b>.",
            invoicePaymentReceived: "Le paiement de la facture a été accepté par <b>{user}</b>.",
            planStarted: "<b>{user}</b> L'utilisateur a démarré l'abonnement pour <b>{title}</b> (<b>{altTitle}</b>).",
            planStartedAgent:
                "<b>{user}</b> L'utilisateur a démarré l'abonnement pour <b>{title}</b> <b>{altTitle}</b> (<b>{details} Représentant</b>).",
            planStartedChatbot:
                "<b>{user}</b> L'utilisateur a démarré l'abonnement pour <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Session</b>).",
            planStartedWhatsapp:
                "<b>{user}</b> L'utilisateur a démarré l'abonnement pour <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Canaux Whatsapp</b>).",
            planStartedWhatsappApi:
                "<b>{user}</b> L'utilisateur a démarré l'abonnement pour <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Canaux Professionnels Whatsapp</b>).",
            PlanCanceled: "<b>{user}</b> L'utilisateur a annulé l'abonnement pour <b>{title}</b> (<b>{altTitle}</b>).",
            planCanceledAgent:
                "<b>{user}</b> L'utilisateur a annulé l'abonnement pour <b>{title}</b> <b>{altTitle}</b> (<b>{details} Représentant</b>).",
            planCanceledChatbot:
                "<b>{user}</b> L'utilisateur a annulé l'abonnement pour <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Session</b>).",
            planCanceledWhatsapp:
                "<b>{user}</b> L'utilisateur a annulé l'abonnement pour <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Canaux Whatsapp</b>).",
            planCanceledWhatsappApi:
                "<b>{user}</b> L'utilisateur a annulé l'abonnement pour <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Canaux Professionnels Whatsapp</b>).",
            invoiceCreated: "La facture a été créée par <b>{user}</b>.",
            billingAddressUpdated: "Les informations de l'adresse ont été mises à jour par <b>{user}</b>.",
            taskWorkflowDeleted: "Le flux de travail <b>{workflow}</b> a été supprimé par <b>{user}</b>.",
            whatsappBroadcastFailed: "L'envoi du message de diffusion intitulé <b>{title}</b> a échoué.",
            whatsappBroadcastCancelled: "L'envoi du message de diffusion intitulé <b>{title}</b> a été annulé.",
            whatsappBroadcastCompleted:
                "Un message de diffusion intitulé <b>{title}</b> a été envoyé avec succès à <b>{numbers}</b> destinataires.",
            whatsappBroadcastCreated:
                "Un message de diffusion intitulé <b>{title}</b> a été envoyé à <b>{numbers}</b> destinataires par <b>{user}</b>.",
            ticketAssigned: "Un ticket a été attribué à <b>{user2}</b> par <b>{user1}</b>.",
            userLoggedIn: "<b>{user}</b> s'est connecté à SUPSIS.",
            chatJoined: "<b>{agent}</b> a rejoint le chat avec <b>{visitor}</b>.",
            chatForwarded: "Le chat avec <b>{visitor}</b> a été transmis à <b>{agent}</b> par <b>{user}</b>.",
            chatAssigned: "Le chat avec <b>{visitor}</b> a été attribué à <b>{agent}</b> par le système.",
            customerGroupUpdated: "Le groupe <b>{group}</b> a été mis à jour par <b>{user}</b>.",
            customerGroupRemoved: "Le groupe <b>{group}</b> a été supprimé par <b>{user}</b>.",
            customerGroupAdded: "Le groupe <b>{group}</b> a été créé par <b>{user}</b>.",
            contentRemoved: "Le contenu prêt <b>{content}</b> a été supprimé par <b>{user}</b>.",
            contentAdded: "Le contenu prêt <b>{content}</b> a été ajouté par <b>{user}</b>.",
            channelVisibilityChanged:
                "La visibilité du canal d'intégration <b>{channel}</b> a été modifiée par <b>{user}</b>.",
            taskDeleted: "La tâche <b>{task}</b> a été supprimée par <b>{user}</b>.",
            userRemovedToDepartment:
                "L'utilisateur <b>{user2}</b> a été supprimé du département <b>{department}</b> par <b>{user1}</b>.",
            userAddedToDepartment:
                "L'utilisateur <b>{user2}</b> a été ajouté au département <b>{department}</b> par <b>{user1}</b>.",
            mailAddressAdded: "Adresse e-mail <b>{email}</b> ajoutée par <b>{user}</b>",
            settingUpdate: "Mis à jour par <b>{user}</b> :",
            taskWFlowCreated: "Flux de travail des tâches <b>{Wflow}</b> créé par <b>{user}</b>.",
            bannedWordRemoved: "Le mot interdit <b>{bWord}</b> a été supprimé par <b>{user}</b>.",
            bannedWordCreated: "Le mot interdit <b>{bWord}</b> a été créé par <b>{user}</b>.",
            welcomeMessageRemoved: "Le message de bienvenue <b>{welcome}</b> a été supprimé par <b>{user}</b>.",
            welcomeMessageAdded: "Message de bienvenue <b>{welcome}</b> créé par <b>{user}</b>.",
            tagRemoved: "Tag <b>{tag}</b> supprimé par <b>{user}</b>.",
            tagAdded: "Tag <b>{tag}</b> ajouté par <b>{user}</b>.",
            roleRemoved: "Rôle <b>{role}</b> supprimé par <b>{user}</b>.",
            roleAdded: "Rôle <b>{role}</b> ajouté par <b>{user}</b>.",
            departmentRemoved: "Département <b>{department}</b> supprimé par <b>{user}</b>.",
            departmentAdded: "Département <b>{department}</b> ajouté par <b>{user}</b>.",
            triggerUpdated: "Un déclencheur mis à jour par <b>{user}</b>.",
            triggerRemoved: "Un déclencheur supprimé par <b>{user}</b>.",
            triggerAdded: "Un nouveau déclencheur créé par <b>{user}</b>.",
            webhookRemoved: "Webhook de <b>{user1}</b>, supprimé par <b>{user2}</b>",
            webhookAdded: "Webhook ajouté par <b>{user1}</b>, ajouté par <b>{user2}</b>.",
            chatClosed: "Le chat avec <b>{visitor}</b> a été terminé par <b>{agent}</b>.",
            chatOpenedByAgent: "<b>{agent}</b> a lancé un chat <b>{platform}</b> avec <b>{visitor}</b>.",
            chatOpenedByVisitor: "Un chat <b>{platform}</b> a été lancé par <b>{visitor}</b>.",
            channelRemoved: "Le canal <b>{channel}</b> a été supprimé par <b>{agent}</b>.",
            userAdded: "<b>{agent}</b> a créé un représentant nommé <b>{newAgent}</b>.",
            visitorUnblocked: "Le visiteur <b>{visitor}</b> a été débloqué par l'utilisateur <b>{agent}</b>.",
            visitorBlocked: "Le visiteur <b>{visitor}</b> a été bloqué par <b>{agent}</b>.",
            userStatusChanged:
                "L'utilisateur <b>{name}</b> a changé de statut de <b>{oldStatus}</b> à <b>{newStatus}</b>.",
            channelCreated: "Le canal <b>{channel}</b> a été créé par <b>{name}</b>.",
            reservationCreatedPlan:
                "<b>{name}</b> utilisateur a planifié le rendez-vous nommé <b>{title}</b> pour le <b>{date}</b>.",
            reservationUpdatedPlan: "<b>{name}</b> utilisateur a mis à jour le rendez-vous nommé <b>{title}</b>.",
            reservationDeletedPlan: "<b>{name}</b> usuario ha eliminado la cita llamada <b>{title}</b>.",
            reservationCreated:
                "Une réservation a été créée pour l'utilisateur <b>{name}</b> et le visiteur <b>{visitor}</b> le <b>{date}</b>.",
            reservationDeleted:
                "Le rendez-vous entre l'utilisateur <b>{name}</b> et le visiteur <b>{visitor}</b> le <b>{date}</b> a été annulé.",
            chatAssignedMe: "Quand un chat m'est assigné",
            ticketAssignedMe: "Quand un ticket m'est assigné",
            taskAssignedMe: "Quand une tâche m'est assignée",
            myChatClosed: "Quand le chat que je possède est fermé",
            tagActionsToVisitor: "Tags ajoutés ou supprimés d'un contact",
            ticketCreated:
                "Le ticket est créé par le visiteur ou le chatbot. De plus, lorsqu'un message hors ligne est envoyé depuis le widget de chat",
            notesActions: "Une note a été ajoutée ou supprimée d'un client.",
            visitorProfileUpdated: "Profil du visiteur mis à jour",
            chatStartedByAnyPlatform: "Le chat est lancé sur n'importe quelle plateforme par un contact ou un agent",
            userActions: "L'utilisateur est créé, mis à jour ou supprimé",
            departmentActions: "Le département est créé, mis à jour ou supprimé",
            settingsActions: "Les paramètres sont créés, mis à jour ou supprimés",
            integrationsActions: "Le canal d'intégration est créé, mis à jour ou supprimé",
            loginFormActions: "Le formulaire de connexion est mis à jour, activé ou désactivé",
            bannedWordActions: "Le mot interdit est créé, mis à jour ou supprimé",
            emailActions: "Le compte e-mail est créé ou supprimé",
            preparedContentActions: "Le contenu préparé est créé ou supprimé",
            roleActions: "Le rôle est créé, mis à jour ou supprimé",
            tagActions: "Le tag est créé, mis à jour ou supprimé",
            welcomeMessageActions: "Le message de bienvenue est créé, mis à jour ou supprimé",
            webhookActions: "Le webhook est créé, mis à jour ou supprimé",
            billingEvents: "Événements de facturation",
            taskWorkflowCrud: "Le flux de travail des tâches est créé, mis à jour ou supprimé",
            taskCrud: "Tâche est créée, mise à jour ou supprimée",
            systemStatus: "Changements de statut en ligne ou hors ligne du système",
            chatbotStoryCrud: "L'histoire du chatbot est créée, mise à jour ou supprimée",
            chatbotForwardAgent: "Le chatbot transfère un chat à un agent",
            userSegmentCrud: "Le segment utilisateur est créé, mis à jour ou supprimé",
            chatbotCreditLow: "Lorsque le crédit du chatbot est faible",
            wpCreditLow: "Lorsque le crédit Whatsapp est faible",
            wpCustomerGroupCrud: "Lorsque le groupe de clients Whatsapp est créé, mis à jour ou supprimé",
            wpBroadcastMessageStatus: "Lorsque le message de diffusion Whatsapp est envoyé, terminé ou annulé",
            wpTemplateMesssageCrud: "Lorsque le message de modèle Whatsapp est créé, mis à jour ou supprimé",
            reservationMessageCrud: "Réservation créée, mise à jour, annulée",
        },
        mail: {
            deleteMailDesc: "Cette action ne peut pas être annulée.",
            deleteMailTitle: "Êtes-vous sûr de vouloir supprimer cette adresse e-mail?",
            gmailForwardMail: "Transfert de messagerie Gmail",
            senderMailAddressDesc: "Veuillez entrer l'adresse e-mail de l'expéditeur",
            verified: "Vérifié",
            notForwarded: "Non transféré",
            notVerified: "Non vérifié",
            default: "Par défaut",
            isVerified: "Vérifié",
            forwarding: "Transfert",
            mailAdress: "Adresse e-mail",
            addSenderAddress: "Ajouter une adresse d'expéditeur",
            outlookForward: "Transfert Microsoft (Outlook/Exchange)",
            gmailForward: "Transfert Google (Gmail)",
            senderMail: "Mail de l'expéditeur",
            mailDetail: "Détail du mail",
            mailNotFound: "Mail non trouvé",
            mailSelecting: "Sélection de mail",
            newMail: "Nouveau courrier électronique",
            myMails: "Mes courriels",
            inbox: "Boîte de réception",
            sent: "Envoyé",
            departmentMails: "Emails du département",
            newTemplate: "Nouveau modèle",
            unread: "Non lu",
            unreply: "Unanswered",
            reply: "Répondre",
            attachments: "Pièces jointes du courrier",
            To: "À",
            From: "De",
            placeHolders: "Espacements réservés",
            attacheFiles: "Joindre des fichiers",
            replyAll: "Répondre à tous",
            forward: "Transférer",
            deleteThread: "Supprimer la conversation",
            markAsRead: "Marquer comme lu",
            markAsAllRead: "Tout marquer comme lu",
            emailEditor: "Éditeur de courrier électronique",
            integrateYourMail: "Intégrez votre e-mail",
            connect: "Connecter",
            departmentMail: "Courrier électronique du département",
            createMailAddress: "Créer une adresse e-mail",
            createNewMail: "Créer un nouvel e-mail",
        },
        visitor: {
            mail: "Mail",
            visitorDetail: "Détails du visiteur",
            selectedUser: "{selectedUser} parmi {totalUsers} utilisateurs sélectionnés",
            uncheck: "Décocher tout",
            checkAll: "Tout cocher",
            matchedUsers: "{checkedCount} utilisateurs correspondants",
            more: "Plus",
            exportUsers: "Exporter les utilisateurs sélectionnés",
            exportAllUsers: "Exporter tous les utilisateurs",
            addSegment: "Ajouter un segment",
            deleteCheckedUser: "Supprimer les utilisateurs sélectionnés",
            deleteAllUser: "Supprimer tous les utilisateurs",
            matchedFilter: "Correspondance de tous les filtres",
            visitor: "Visiteur",
            deleteUser: "Supprimer l'utilisateur",
            userData: "Données utilisateur",
            lastSession: "Dernière session",
            notUserData: "Aucune donnée utilisateur trouvée",
            segments: "Segments",
            tags: "Tags",
            addTag: "Ajouter un tag",
            userChats: "Chats utilisateur",
            seeAll: "Voir tout",
            confirm: "Confirmer",
            manageSegments: "Gérer les segments",
            search: "Recherche",
            manageTags: "Gérer les tags",
            allAttributes: "Voir toutes les attributs",
            noData: "Pas de données",
            noEmail: "Pas d'e-mail",
            noIpAddress: "Adresse IP non trouvée.",
            noWpNumber: "Numéro non trouvé.",
            filterName: "nom du filtre..",
            matchedContacts: "{chechkedCount} contacts appariés",
        },
        chatbotv2: {
            selectedStory: "{count} scénario sélectionné",
            Instagram_Actions: "Instagram Actions",
            suppressionRemoved: "Suppression supprimée",
            suppressionAdded: "Suppression ajoutée",
            didntSuppression: "Vous n'avez effectué aucune suppression.",
            whatsappIntegrationTitle: "Intégration WhatsApp V1 et WhatsApp V2",
            whatsappApiIntegrationTitle: "Intégration de l'API WhatsApp Business",
            ReadyTemplateBadge: "Modèle prêt",
            readyTemplates: "Modèles prêts",
            regex: "Regex",
            regexDescription: "Regex ile herşeyi yakala",
            chatbotLogo: "Logo du ChatBot",
            chatbotName: "Nom du ChatBot",
            allSecnario: "Liste des scénarios de chatbot",
            ChatbotScenarioList: "Liste des scénarios de chatbot",
            Scenario: "Scénario",
            filters: {
                equal: "est égal à",
                not_equal: "n'est pas égal",
                contain: "contenir",
                not_contain: "contient pas de",
                starts_with: "commence avec",
                ends_with: "se termine par",
                empty: "est vide",
                non_empty: "non vide",
                longer_than: "plus long que",
                shorter_than: "plus court que",
                less_than: "moins que",
                less_or_equal: "moins ou égal",
                greater_than: "plus grand que",
                greater_or_equal: "plus grand ou égal",
            },
            planRequired: "{integratable} plan requis",
            noDefaultStoryTitle: "Histoire par défaut",
            noDefaultStory:
                "Mot interdit détecté, veuillez corriger le message et envoyer \n Voulez-vous faire de cette histoire la valeur par défaut ?",
            noMessage: "Pas de message",
            loading: "Chargement",
            loadMore: "Charger plus",
            hostname: "Nom d'hôte",
            goToStory: "aller à l'histoire",
            noResultFound: "Aucun résultat trouvé",
            checkYourFilterCombination: "Vérifiez votre combinaison de filtre",
            clearYourSearch: "Effacer votre recherche",
            andTryAgain: "et essayez à nouveau",
            allTemplates: "Tous les modèles",
            allAITemplates: "Tous les modèles d'IA",
            templatesFromTheIndustry: "Modèles de l'industrie",
            basicTemplate: "Modèle de base",
            proTemplate: "Modèle avancé",
            withBot: "& Bot",
            userWithBot: "Utilisateur et bot",
            chatDetail: "Détails du chat",
            allUserDetail: "Voir tous les détails de l'utilisateur",
            sessionData: "Données de session",
            supsisChatWidget: "Widget de chat en soupise",
            integratedWith: "Intégré avec :",
            botStory: "Histoire de bot",
            integration: "L'intégration",
            Users: "utilisateurs/utilisatrices",
            user_id: "ID de l'utilisateur",
            categories: "Catégories",
            worksWith: "Marche avec",
            importBot: "Importer un bot",
            keyFeatures: "Principales caractéristiques",
            importing: "importation",
            comingSoon: "À venir",
            pickStory: "Choisir une histoire",
            conversationId: "ID de conversation",
            integrateStoryWithSupsisWidget: "Intégrer le widget de Supsis avec Chatbot Story",
            integrateStoryWithWhatsapp: "Intégrer WhatsApp à Chatbot Story",
            integrateStoryWithInstagram: "Intégrer Instagram avec Chatbot Story",
            selectIntegratingStory: "Sélectionnez l'histoire qui sera intégrée",
            install: "Installer",
            attr: {
                weekday: "Weekday",
                channelId: "Channel",
                email: "E-mail",
                phone: "Téléphone",
                language: "Langue",
                timezone: "Fuseau horaire",
                gender: "Genre",
                country: "Pays",
                referrer: "Référent",
                department: "Département",
                url: "URL",
                ip: "IP",
                last_seen: "Dernier vu",
                name: "Nom",
                user_id: "ID de l'utilisateur",
                message: "Message",
                akinon_brand: "Marque",
                akinon_order_id: "Numéro de commande",
                akinon_product_id: "ID de produit",
                akinon_user_id: "ID de l'utilisateur",
                akinon_user_name: "Nom d'utilisateur",
                akinon_user_email: "E-mail utilisateur",
                akinon_invoice_url: "URL de facture",
                akinon_order_status: "Statut de la commande",
                akinon_order_price: "Prix ​​de commande",
                akinon_shipper_name: "Nom de l'expéditeur",
                akinon_product_size: "Taille du produit",
                akinon_sku: "Sku",
                akinon_product_url: "URL du produit",
                akinon_product_title: "Titre du produit",
                akinon_product_image: "Image du produit",
                akinon_product_stock: "Stock de produits",
                akinon_order_date: "Date de commande",
                akinon_track_number: "Numéro de piste",
                akinon_track_url: "URL de piste",
                akinon_latitude: "Latitude",
                akinon_longitude: "Longitude",
                idleUserTime: "User Last Action (Second)",
                ai_class_result: "AI Class Result",
                meta_comment_id: "Meta Comment ID",
                meta_comment: "Meta Comment",
                meta_post_id: "Meta Post ID",
                ideasoft_user_id: "Member Id",
                ideasoft_invoice_url: "Invoice Url",
                ideasoft_order_id: "Sipariş Numarası",
                ideasoft_order_status: "Order Status",
                ideasoft_order_price: "Order Price",
                ideasoft_shipper_name: "Shipper Name",
                ideasoft_product_size: "Product Size",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Product Url",
                ideasoft_product_title: "Product Title",
                ideasoft_product_image: "Product Image",
                ideasoft_product_stock: "Product Stock",
                ideasoft_order_date: "Order Date",
                ideasoft_track_number: "Track Number",
                ideasoft_track_url: "Track Url",

                offline_mode: "Mode hors-ligne",
                available_agents: "Agents disponibles",
                platform: "Plateforme",
                hour: "Heure",
                segments: "Segments",
                tags: "Étiquettes",
                ticket: "Billet",
                metaReferrals: "Méta-références",
            },
            storyList: "Liste d'histoires",
            douYouWannaDeleteItem: "Voulez-vous supprimer cet élément?",
            douYouWannaDeleteWithChildren: "Voulez-vous supprimer cet article avec ses enfants?",
            stories: "Histoires",
            templates: "Modèles",
            aitemplates: "Modèles d'IA",
            integrations: "Intégrations",
            all: "Tous",
            installed: "installée",
            installationOK: "installée",
            uninstall: "Désinstaller",
            remainingMessageDesc: "Messages gratuits restants:",
            openAISiteRoutingDescStart: "Vous pouvez cliquer sur le lien",
            openAISiteRoutingDescEnd: "Pour obtenir une clé API.",
            integrationOK: "Intégré",
            chatWidget: "Widget de chat en soupise",
            artificialIntelligence: "Intelligence artificielle",
            integratePlatform: "Chatbot peut être intégré à {integretable}.",
            integrateOpenAIWithChatbot: "Intégrer le chat gpt-4 avec chatbot",
            integrateChatBotWithChatGPT3: "Intégration de chatbot avec le chat gpt-4",
            integrateStoryWithTelegram: "Intégrer l'histoire avec le télégramme",
            webhooks: "Webhooks",
            archive: "Archive",
            reports: "Rapports",
            uncheckAll: "Décocher tout",
            userSegments: "Segments d'utilisateurs",
            addSegment: "Ajouter un segment",
            addToSegment: "Ajouter au segment",
            removeFromSegment: "Supprimer du segment",
            plansVTippyContent:
                "La facturation de ce forfait sera effectuée au début de chaque mois, et en cas d'annulation, votre utilisation sera facturée jusqu'au début du mois et votre forfait expirera.<br><br>Le prix du forfait est hors TVA.<br><br>Les changements de forfait sont reflétés dans la facture le lendemain.",
            segmentName: "Nom du segment",
            sameSegment: "Il y a un segment avec le même nom!",
            usersInSegment: "Utilisateurs du segment",
            noUsersAdded: "Aucun utilisateur ajouté",
            updateSegment: "Segment de mise à jour",
            newSegment: "Nouveau segment",
            selectAll: "Tout sélectionner",
            queriesSelected: "requêtes sélectionnées",
            noBlocksFound: "Pas de blocs trouvés!",
            userQuery: "Requête utilisateur",
            date: "Date",
            unmatched: "Incomparable",
            goToChat: "Aller discuter",
            selectStory: "Sélectionner une histoire",
            selectBlock: "Sélectionner le bloc",
            training: "Entraînement",
            trainingAlert:
                "Pour mettre en œuvre les modifications que vous avez apportées à la page de formation du bot, vous devez publier la nouvelle version du scénario que vous avez modifié.",
            unmatchedPhrases: "Phrases inégalées",
            ignored: "Ignoré",
            story: "Histoire",
            timePeriod: "Période de temps",
            wholeTimeSpan: "Laps de temps entier",
            selectAStory: "Sélectionnez une histoire",
            searchUserQuery: "Recherchez la requête utilisateur",
            time: {
                today: "Aujourd'hui",
                yesterday: "Hier",
                last7: "Les 7 derniers jours",
                last30: "Les 30 derniers jours",
                "this-month": "Ce mois-ci",
                "last-month": "Le mois dernier",
                "last-3-month": "3 mois dernier",
                "this-year": "Cette année",
                "last-year": "L'année dernière",
                custom: "Choisissez une autre date",
            },
            emailProvider: "Fournisseur de messagerie électronique",
            triggerFromAnywhere: "Déclencher de n'importe où",
            allIntegrations: "Toutes les intégrations",
            integrateYourCBwithChatWidget: "Intégrez votre chatbot avec le widget de chat.",
            integrateYourCBwithChatGpt3: "Chatbot peut être intégré à GPT-4. Clé API GPT-4 requis.",
            integrateYourCBwithWebHook:
                "Passez facilement les informations de chat entre le chatbot et vos services Web.",
            integrateYourCBwithIntegratable:
                "Passez facilement les informations de chat entre chatbot et {integratable}.",
            addWebhook: "Ajouter WebHook",
            editWebhook: "Modifier webhook",
            newWebhook: "Nouveau webhook",
            webhookTitle: "Titre de webhook",
            webhookUrl: "URL de webhook",
            webhookToken: "Webhook token",
            webhookUsername: "Nom d'utilisateur webhook",
            webhookPassword: "Mot de passe webhook",
            editBlock: "Modifier",
            moveBlock: "Déplacer",
            copyBlock: "Copie",
            addFilter: "Ajouter le filtre",
            addFilterGroup: "Ajouter un groupe de filtre",
            in: "dans",
            and: "et",
            or: "ou",
            chatbot: "Chatbot",
            allStories: "Toutes les histoires",
            addBot: "Créer un bot",
            testBot: "Testez votre bot",
            publish: "Publier",
            editName: "Modifier le nom",
            search: "Recherche dans votre histoire…",
            typeMoreThan3Char: "Tapez au moins 3 caractères",
            expand: "Développer",
            expandAll: "Développer tout",
            noMatchingItem: "Aucun article correspondant",
            hint: "Indice",
            select: "Sélectionner",
            navigate: "Naviguer",
            dismiss: "Rejeter",
            choseAttribute: "Attribut choisi",
            selectReply: "Sélectionnez Répondre",
            preview: "Aperçu",
            draft: "Brouillon",
            lastUpdate: "Dernière mise à jour",
            published: "Publié",
            newStory: "Nouvelle histoire",
            updateStory: "Mettre à jour l'histoire",
            storyDescription: "Description de l'histoire",
            storyTitle: "Titre de l'histoire",
            deleteSingleBlock: "Supprimer un seul bloc",
            deleteWithChildren: "Supprimer avec les enfants",
            startTestFromHere: "Commencez le test à partir d'ici",
            copyBlockId: "Copier l'ID de blocage",
            gotoLiveLink: "Aller au lien en direct",
            copyBlockIdSuccessfull: "ID de bloc copié dans le presse-papiers",
            collapse: "Effondrement",
            collapseAll: "S'effondrer tout",
            snDelay: "{delay} SEC Delay",
            blockUpdated: "Bloc mis à jour",
            addPayload: "Ajouter la charge utile",
            previewModeCaution:
                "Vous apercevez maintenant l'une des versions de votre histoire. Vous ne pouvez pas enregistrer des modifications en mode d'aperçu!",
            enterText: "Entrez du texte...",
            trackpad: "Trackpad",
            navigation: "La navigation",
            navigationDesc:
                "Veuillez choisir votre mode de navigation. C'est à vous de décider s'il sera trackpad ou souris.",
            botSetting: "Réglage de bot",
            botSettingDesc:
                "Veuillez définir le niveau de confiance. Il s'agit d'un pourcentage entre 0 et 100. Le niveau définit l'exactitude des interprètes de chatbot qui sont liés aux entrées utilisateur.",
            languageSettingsDesc: "Veuillez vous assurer que la langue de bot qui répond est votre langue préférée.",
            mouse: "Souris",
            Interactions: "Interactions",
            Actions: "Actions",
            Supsis_Actions: "Actions du Supsis",
            Shopify_Actions: "Actions shopify",
            Akinon_Actions: "Actions à Akinon",
            IdeaSoft_Actions: "Ideasoft Actions",
            START_POINT: "POINT DE DÉPART",
            AI_ASSISTANT: "AI ASSISTANT",
            BOT_RESPONSE: "Réponse du bot",
            AI_BOT_RESPONSE: "Réponse AI (GPT-4o)",
            AI_CLASSIFICATION: "AI CLASSIFICATION",
            Templates: "Template Blocks",
            AI_MENU_FLOW: "AI MENU",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "Se repliez par défaut",
            FILTER: "FILTRE",
            addNewFilter: "Ajouter un nouveau filtre",
            FLOW: "COULER",
            ATTACHMENT_INPUT: "Entrée de fixation",
            USER_INPUT: "Entrée utilisateur",
            GO_TO_STEP: "Aller au pas",
            WEBHOOK: "Webhook",
            SET_ATTRIBUTE: "Set Attribut",
            QUESTION: "QUESTION",
            CLOSE_CHAT: "Chatte",
            CREATE_TICKET: "Créer un billet",
            TRANSFER_CHAT: "Chat transféré",
            TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
            TAG_CHAT: "ADD TAG",
            REMOVE_TAG: "REMOVE TAG",
            SET_DEPARTMENT: "Département",
            SEND_TRANSCRIPT: "Envoyer une transcription",
            SEND_SMS: "SEND SMS", //todo translate
            SEND_MAIL: "SMS MAIL", //todo translate
            CREATE_EVENT: "CREATE EVENT", //todo translate
            CREATE_RESERVATION: "CREATE RESERVATION",
            RESERVATION_OPEN_URL: "Reservation Open Url",
            RESERVATION_SELECT_DAY: "Select reservation day",
            RESERVATION_SELECT_TIME: "Select reservation time",
            RESERVATION_EVENT_LIST: "Reservation list visitor",
            CREATE_TASK: "CREATE TASK",
            SHOPIFY_SHOW_PRODUCTS: "Produits Shopify Show",
            SHOPIFY_PRODUCT_AVAILABILITY: "Shopify Disponibilité du produit",
            SHOPIFY_ORDER_STATUS: "Statut de commande Shopify",
            AKINON_SHOW_PRODUCTS: "Produits Akinon Show",
            AKINON_FIND_PRODUCT: "Akinon trouve le produit",
            AKINON_ORDER_STATUS: "Statut d'ordre d'Akinon",
            AKINON_SELECT_ORDER: "Ordre de sélection à Akinon",
            AKINON_SELECT_SIZE: "Taille de sélection d'Akinon",
            AKINON_FIND_NEAREST_STOCK: "Afficher le magasin",
            AKINON_FIND_NEAREST_STORES: "Montrer les magasins les plus proches",
            AKINON_SHOW_DISCOUNT_CODES: "Afficher les codes de réduction",

            IDEASOFT_SELECT_ORDER: "SELECT ORDER",
            IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
            IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",
            INSTAGRAM_COMMENT_REPLY: "RÉPONDRE AU COMMENTAIRE",
            INSTAGRAM_COMMENT_DELETE: "SUPPRIMER LE COMMENTAIRE",
            INSTAGRAM_COMMENT_SHOW: "AFFICHER LE COMMENTAIRE",
            INSTAGRAM_COMMENT_HIDE: "MASQUER LE COMMENTAIRE",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "RÉPONDRE EN PRIVÉ",
            followingAttributesFilled: "Les attributs suivants seront remplis.",
            GET_LOCATION: "Obtenir l'emplacement",
            FALLBACK: "SE RETIRER",
            SUCCESS: "SUCCÈS",
            FAILURE: "ÉCHEC",
            message: "Message",
            condition: "Condition",
            score: "Score",
            equal: "Égal",
            not_equal: "n'est pas égal",
            contain: "Contenir",
            not_contain: "Contient pas de",
            starts_with: "commence avec",
            ends_with: "se termine par",
            empty: "vide",
            longer_than: "plus long que",
            shorter_than: "plus court que",
            less_than: "moins que",
            less_than_equal: "moins d'égal",
            greater_than: "plus grand que",
            greater_than_equal: "plus que l'égal",
            value: "Valeur",
            failures: "Les échecs",
            email: "E-mail",
            name: "Nom",
            username: "Nom d'utilisateur",
            source: "Source",
            language: "Langue",
            timezone: "Fuseau horaire",
            region: "Région",
            country: "Pays",
            referrer: "Référent",
            url: "URL",
            ip: "IP",
            city: "Ville",
            lastSeen: "Dernier vu",
            userId: "ID de l'utilisateur",
            selectStep: "Sélectionner l'étape",
            keywords: "Mots clés",
            userSays: "L'utilisateur dit",
            addKeyword: "Ajouter un mot-clé",
            addUserMessage: "Ajouter un message utilisateur",
            set: "Ensemble",
            to: "Pour",
            gender: "Genre",
            go_to_failure: "Aller à l'échec",
            go_to_success: "Aller au succès",
            untilFilled: "Jusqu'à rempli",
            time1: "Une fois",
            time2: "2 fois",
            time3: "3 fois",
            time4: "4 fois",
            time5: "5 fois",
            any: "N'importe quel",
            anytext: "Any Text",
            anytextDescription: "Matches only words + spaces",
            alphanumeric: "Alphanumérique",
            integer: "Entier",
            no: "Non",
            number: "Nombre",
            phone: "Téléphone",
            yes: "Oui",
            yesNo: "Oui Non",
            anyDescription: "Correspond à tout ce qui n'est pas vide.",
            alphanumericDescription: "Correspond aux lettres et aux chiffres",
            integerDescription: "Correspond à un numéro entier",
            noDescription: "Correspond à aucun synonyme",
            numberDescription: "Correspond au numéro ordinal et cardinal",
            phoneDescription: "Correspond au numéro de téléphone",
            yesDescription: "Correspond aux synonymes oui",
            yesNoDescription: "Correspond aux synonymes oui et non",
            emailDescription: "Correspond à l'e-mail",
            urlDescription: "Correspond à l'URL",
            temperature: "Température",
            askWhenInvalid: "Demandez quand invalide",
            applyFilter: "Appliquer le filtre",
            RANDOM_TEXT: "Texte aléatoire",
            QUICK_REPLY: "Réponse rapide",
            FILE: "Déposer",
            notificationMessageStartSuccess: "Le bloc",
            notificationMessageEndSuccess: "a été ajouté",
            notificationMessageStartError: "Une erreur s'est produite, le bloc",
            notificationMessageEndError: "n'a pas été ajouté",
            blockChangedWannaUpdate: "Je veux que la mise à jour changée",
            responses: "Réponses",
            TEXT: "Texte",
            IMAGE: "Image",
            GALLERY: "Galerie",
            BUTTON: "Bouton",
            flow: "Couler",
            active: "Actif",
            passive: "Passif",
            chooseAttributeType: "Choisissez le type d'attribut",
            imageAttachment: "Pièce jointe",
            audioAttachment: "Pièce jointe audio",
            videoAttachment: "Pièce jointe vidéo",
            documentAttachment: "Pièce jointe",
            anyAttachment: "Tout attachement",
            typeAttributeValue: "Tapez la valeur d'attribut",
            typeSearchValue: "Tapez la valeur de recherche",
            addAttribute: "Ajouter un attribut",
            addAttributeDescription:
                "Le nom de l'attribut ne peut contenir que des caractères alphanumériques qui sont des lettres A-Z, des numéros 0-9, du tiret ou du soulignement.",
            male: "Homme",
            USER_DATA: "Données d'utilisateur",
            CUSTOM_ATTRIBUTES: "Attributs personnalisés",
            enterBotResponseHere: "Entrez la réponse du bot ici ...",
            addCard: "Ajouter une carte",
            addButton: "Ajouter le bouton",
            typeCardTitle: "Titre de la carte de type",
            typeCardDescription: "Description de la carte de type",
            dragAndDropBrowse: "Faire glisser et dépasser",
            dragAndDropBrowseFile: "Téléverser un fichier",
            button: "Bouton",
            enterYourMessage: "Entrez votre message",
            imageView: "Vue d'image",
            imageUploading: "Téléchargement d'images",
            fileUploading: "Téléchargement de fichiers ...",
            clickToChooseNewImage: "Cliquez pour choisir une nouvelle image",
            clickToChooseNewFile: "Cliquez pour choisir un nouveau fichier",
            removeTheExistingOne: "Supprimer celui existant",
            validateResponseWithEntity: "Valider la réponse avec l'entité",
            actionOnFailureInput: "Action sur l'entrée de défaillance",
            askNextQuestion: "Posez la question suivante",
            goToSuccessBlock: "Aller au bloc de réussite",
            goToFailureBlock: "Aller au bloc d'échec",
            saveResposeToAttribute: "Enregistrer le dépendance à l'attribut",
            selectReplyType: "Sélectionnez le type de réponse",
            questionVariants: "Variants de questions",
            systemEntities: "Entités système",
            delay: "retard",
            retrySectionTextPart: "Demander",
            retrySectionText: ", si la réponse de l'utilisateur n'est pas valide",
            addNextQuestion: "Ajouter la question suivante",
            typeBlockTitle: "Type Titre du bloc",
            versionHistory: "Historique des versions",
            restore: "Restaurer",
            versionName: "Nom de version",
            restoreModalText:
                "Cette action restaurera la version sélectionnée. Êtes-vous sûr de vouloir restaurer cette version?",
            restoreVersion: "Restaurer la version",
            newVersion: "Nouvelle version",
            synonymMustBeUnique: "Le synonyme doit être unique",
            save: "Sauvegarder",
            entries: "Entrées",
            youHaveNoEntries: "Vous n'avez pas d'entrées",
            inputsCantBeEmpty: "Les entrées ne peuvent pas être vides",
            entryNamesMustBeUnique: "Les noms d'entrée doivent être uniques",
            entityNameMustBeUnique: "Le nom de l'entité doit être unique",
            synonyms: "Synonymes",
            entities: "Entités",
            title: "Titre",
            entryName: "Nom d'entrée",
            entityhasbeenUpdatedSuccessfully: "L'entité a été mise à jour avec succès",
            emptyError: "Les entrées ne peuvent pas être vides",
            entityNameCantBeEmpty: "L'entité ne peut pas être vide",
            allChats: "Tous les chats",
            paidChats: "Chats payants",
            busiestPeriod: "Période la plus fréquentée",
            ratingDistribution: "Répartition des notes",
            allMessages: "Tous les messages",
            avarageMessages: "Messages avarage",
            popularity: "Popularité",
            allUsers: "Tous les utilisateurs",
            interactionName: "Nom d'interaction",
            numberOfMessage: "Nombre de messages",
            ofAllUsersMessage: "% De tous les utilisateurs messages",
            totalData: "Total des données",
            avgData: "Données AVG",
            exportToCsv: "Exporter vers CSV",
            exportToExcel: "Exporter vers Excel",
            inMaintenance: "En maintenance",
            ADD_TO_SEGMENT: "Ajouter au segment",
            REMOVE_FROM_SEGMENT: "Supprimer du segment",
            users: "Utilisateurs",
            webhookName: "Nom de webhook",
            webHookUrl: "URL de webhook",
            webHookToken: "Webhook token",
            delete: "Supprimer",
            basicAuth: "Auth de base",
            requiredFieldsCannotBeLeftBlank: "Les champs requis ne peuvent pas être laissés vides",
            headerValue: "Valeur",
            yourVerificationToken: "Jeton",
            yourWebHookName: "Votre nom Webhook",
            yourWebHookUrl: "Votre URL de webhook",
            enterKey: "La touche Entrée",
            password: "Mot de passe",
            saveSuccessfully: "Votre transaction a été enregistrée avec succès",
            urlTypeError: "Veuillez remplir correctement le champ (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "Clé API GPT-4 OpenAI GPT-4 requis.",
                apiKeyDesc:
                    "CHATBOT + CHAT L'intégration GPT-4 nécessite une clé API. Veuillez obtenir votre touche API ou utiliser la clé API ci-dessous pour l'essai. Vous ne pouvez utiliser que 20 messages pour l'essai.",
                getApiKey: "Ouvrir la touche API AI ouverte",
                typeApiKey: "Tapez la clé de l'API",
                ownApiKey: "Propre clé API Openai",
                trialApiKey: "Clé de l'API d'essai (restreint comme un message 20)",
                useOurTrial: "Utilisez notre essai gratuit",
                twentyMessages: "Vous pouvez essayer en utilisant 20 messages comme gratuit.",
                enableChatGpt3: "Activer le chat gpt-4",
            },
        },
        "Would you like to make default this story?": "#VALUE!",
        coupon: {
            code: "Code",
            discount: "Rabais",
            endDate: "Date de fin",
            name: "Nom",
            email: "E-mail",
            phone: "Téléphone",
            add: "Ajouter le coupon",
            coupons: "Coupons",
            couponDeleted: "Coupon supprimé",
            limit: "Limite",
            visitorBan: "Visiteur a été bloqué.",
            visitorUnBlock: "Le blocage a été levé.",
        },
        instagramTitle: "Cliquez sur le bouton ci-dessous pour activer les fonctionnalités Instagram.",
        instegramFunctionActive: "Activer la fonctionnalité Instagram",
        ChatBOT: "Chatbot",
        WhatsappContacts: "Contacts WhatsApp",
        InstagramContacts: "Contacts Instagram",
        MessengerContacts: "Messenger Contacts",
        volumeUp: "Monter le son",
        minimize: "Minimiser",
        maximize: "Maximiser",
        auditLogs: {
            auditLogsTitle: "Journaux d'audit",
            auditLogsSub:
                "Les journaux d'audit vous permettent de suivre les événements survenus dans votre entreprise au cours des 30 derniers jours.",
        },
        task: {
            workflow: "Flux de travail",
            workflowDetail: "Détails du flux de travail",
            workflowPerm: "Permissions du flux de travail",
            perm: "Permissions",
            detail: "Détails",
            userPerm: "Permissions utilisateur",
            deleteCard: "Supprimer la carte",
            createCard: "Créer une carte",
            editCard: "Modifier la carte",
            dragCard: "Déplacer la carte",
            allWorkflow: "Tous les flux de travail",
            createworkflow: "Créer un flux de travail",
            deleteWorkflow: "Êtes-vous sûr de vouloir supprimer ce flux de travail ?",
            permEditTask: "Vous n'avez pas la permission de modifier cette tâche",
            permEditTaskDes: "Contactez votre administrateur pour obtenir les permissions de modification.",
            createTaskError: "Vous n'avez pas la permission de créer des tâches",
            createTaskErrorDesc: "Contactez votre administrateur pour obtenir les permissions de création de tâches.",
            moveTaskError: "Vous n'avez pas la permission de changer le statut de la tâche",
            moveTaskErrorDesc:
                "Contactez votre administrateur pour obtenir les permissions de changement de statut de tâche.",
            deleteTaskError: "Vous n'avez pas la permission de supprimer des tâches",
            deleteTaskErrorDesc:
                "Contactez votre administrateur pour obtenir les permissions de suppression de tâches.",
            permissionError: "Vous n'avez pas l'autorisation de créer des tâches",
            permissionErrorDesc:
                "Veuillez contacter votre administrateur pour obtenir les autorisations de création de tâches",
            whatsappContactProfileTitle: "Profil de {name} / {number}",
            createTaskVisitor: "Créer une tâche (visiteur)",
            editWorkflow: "Modifier le flux de travail",
            visitor: "Profil du visiteur",
            createTaskMessage: "Créer une tâche (Message)",
            createStage: "Créer une étape",
            stagesAndStatuses: "Étapes et statuts",
            workflowCreateDesc: "Description du flux de travail",
            subTasks: "Sous-tâches",
            followers: "Suiveurs",
            collaborators: "Collaborateurs",
            addRelations: "Ajouter des relations",
            relations: "Relations",
            main: "Principal",
            name: "Nom",
            completedOfCheck: "{completed} sur {total} tâches terminées",
            workflowUpdateMs: "Workflow mis à jour avec succès",
            taskUpdateMs: "Tâche mise à jour avec succès",
            workflowCreatedMs: "Workflow créé avec succès",
            workflowCreateError: "Le flux de travail n'a pas pu être créé",
            taskCreatedMs: "Tâche créée avec succès",
            settingsDesc3:
                "De plus, le module de tâches Supsis vous permet de créer votre propre flux de travail avec une automatisation personnalisable, vous permettant de gérer les tâches de manière plus efficace et d'améliorer la collaboration au sein de l'équipe.",
            settingsDesc4:
                "De cette manière, vous pouvez suivre chacune de vos tâches en détail, attribuer des tâches aux membres de l'équipe et gérer globalement vos processus métier de manière plus efficace. Le module de tâches Supsis vous fournit une solution complète pour la gestion des tâches et la coordination d'équipe.",
            settingsDesc2:
                "Le module de tâches Supsis ne laisse aucune tâche passée inaperçue. Vous pouvez filtrer les tâches en fonction de n'importe quel paramètre, suivre les charges de travail pour chaque étape du flux de travail et organiser votre calendrier pour vous aligner sur vos horaires.",
            settingsDesc1:
                "Le module Tâches vous permet d'organiser le travail collaboratif, de déléguer des tâches et de suivre la progression de votre équipe. Vous pouvez personnaliser vos tâches selon vos besoins en sélectionnant n'importe quelle vue et créer vos propres flux de travail personnalisés avec des automatisations.",
            taskModuleSettingsTitle: "Paramètres du module de tâches",
            high: "Élevée",
            medium: "Moyenne",
            low: "Faible",
            priority: "Priorité",
            addExistsSubtask: "Ajouter une sous-tâche existante",
            addSubtask: "Ajouter une sous-tâche",
            add: "Ajouter",
            newCheckList: "Nouvelle liste de contrôle",
            subtaskTitle: "Titre de la sous-tâche",
            view: "Vue",
            attachFiles: "Joindre des fichiers",
            createTaskDesc: "Description de la tâche",
            title: "Titre",
            createWorkflow: "Créer un flux de travail",
            editTask: "Modifier la tâche",
            createTask: "Créer une tâche",
            deleteColumnCont: "Êtes-vous sûr de vouloir supprimer cette colonne?",
            changeStage: "Changer d'étape",
            assignees: "Assignés",
            owner: "Propriétaire",
            stage: "Étape",
            writeSomething: "Écrivez quelque chose",
            selectAssginee: "Sélectionner le destinataire",
            assignee: "Bénéficiaire",
            enterNewTaskDesc: "Entrez la description de la nouvelle tâche",
            enterNewTaskTitle: "Entrez le titre de la nouvelle tâche",
            task: "Tâche",
            deleteTaskCont: "Êtes-vous sûr de vouloir supprimer ces tâches?",
            deleteWorkFlowCont: "Êtes-vous sûr de vouloir supprimer ce workflow ?",
            completed: "Terminé",
            todo: "À faire",
            kanbanBoard: "Tableau Kanban",
            listView: "Vue Liste",
        },
        permissionErrors: {
            userCreate:
                "Vous n'avez pas la permission d'ajouter des utilisateurs. Veuillez consulter votre administrateur.",
            userRead:
                "Vous n'avez pas la permission de voir les utilisateurs. Veuillez consulter votre administrateur.",
            userUpdate:
                "Vous n'avez pas la permission de mettre à jour les utilisateurs. Veuillez consulter votre administrateur.",
            userDelete:
                "Vous n'avez pas la permission de supprimer les utilisateurs. Veuillez consulter votre administrateur.",
            visitorBlock:
                "Vous n'avez pas la permission de bloquer les visiteurs. Veuillez consulter votre administrateur.",
            visitorUnblock:
                "Vous n'avez pas la permission de débloquer les visiteurs. Veuillez consulter votre administrateur.",
            visitorDetailRead:
                "Vous n'avez pas la permission de voir les détails des visiteurs. Veuillez consulter votre administrateur.",
            visitorListRead:
                "Vous n'avez pas la permission de voir la liste des visiteurs. Veuillez consulter votre administrateur.",
            visitorDelete:
                "Vous n'avez pas la permission de supprimer les visiteurs. Veuillez consulter votre administrateur.",
            visitorExcel:
                "Vous n'avez pas la permission d'obtenir une sortie Excel. Veuillez consulter votre administrateur.",
            visitorUpdate:
                "Vous n'avez pas la permission de mettre à jour les visiteurs. Veuillez consulter votre administrateur.",
            bannedVisitorRead:
                "Vous n'avez pas la permission de voir la liste des visiteurs interdits. Veuillez consulter votre administrateur.",
            bannedWordCreate:
                "Vous n'avez pas la permission d'ajouter des mots interdits. Veuillez consulter votre administrateur.",
            bannedWordRead:
                "Vous n'avez pas la permission de voir les mots interdits. Veuillez consulter votre administrateur.",
            bannedWordDelete:
                "Vous n'avez pas la permission de supprimer les mots interdits. Veuillez consulter votre administrateur.",
            chatRead: "Vous n'avez pas la permission de voir les chats. Veuillez consulter votre administrateur.",
            chatUpdate:
                "Vous n'avez pas la permission de modifier les discussions. Veuillez consulter votre administrateur.",
            archiveRead:
                "Vous n'avez pas la permission de consulter les archives. Veuillez consulter votre administrateur.",
            roleCreate: "Vous n'avez pas la permission d'ajouter des rôles. Veuillez consulter votre administrateur.",
            roleRead: "Vous n'avez pas la permission de consulter les rôles. Veuillez consulter votre administrateur.",
            roleUpdate:
                "Vous n'avez pas la permission de mettre à jour les rôles. Veuillez consulter votre administrateur.",
            roleDelete:
                "Vous n'avez pas la permission de supprimer les rôles. Veuillez consulter votre administrateur.",
            departmentCreate:
                "Vous n'avez pas la permission d'ajouter des départements. Veuillez consulter votre administrateur.",
            departmentRead:
                "Vous n'avez pas la permission de consulter les départements. Veuillez consulter votre administrateur.",
            departmentUpdate:
                "Vous n'avez pas la permission de mettre à jour les départements. Veuillez consulter votre administrateur.",
            departmentDelete:
                "Vous n'avez pas la permission de supprimer les départements. Veuillez consulter votre administrateur.",
            preparedContentCreate:
                "Vous n'avez pas la permission de créer du contenu préparé. Veuillez consulter votre administrateur.",
            preparedContentRead:
                "Vous n'avez pas la permission de consulter le contenu préparé. Veuillez consulter votre administrateur.",
            preparedContentUpdate:
                "Vous n'avez pas la permission de mettre à jour le contenu préparé. Veuillez consulter votre administrateur.",
            preparedContentDelete:
                "Vous n'avez pas la permission de supprimer le contenu préparé. Veuillez consulter votre administrateur.",
            welcomeCreate:
                "Vous n'avez pas la permission de créer des messages de bienvenue. Veuillez consulter votre administrateur.",
            welcomeRead:
                "Vous n'avez pas la permission de consulter les messages de bienvenue. Veuillez consulter votre administrateur.",
            welcomeUpdate:
                "Vous n'avez pas la permission de mettre à jour les messages de bienvenue. Veuillez consulter votre administrateur.",
            welcomeDelete:
                "Vous n'avez pas la permission de supprimer les messages de bienvenue. Veuillez consulter votre administrateur.",
            settingCreate:
                "Vous n'avez pas l'autorisation de créer des paramètres. Veuillez consulter votre administrateur.",
            settingRead:
                "Vous n'avez pas l'autorisation de consulter les paramètres. Veuillez consulter votre administrateur.",
            settingUpdate:
                "Vous n'avez pas l'autorisation de mettre à jour les paramètres. Veuillez consulter votre administrateur.",
            settingDelete:
                "Vous n'avez pas l'autorisation de supprimer les paramètres. Veuillez consulter votre administrateur.",
            reportCreate:
                "Vous n'avez pas l'autorisation de créer des rapports. Veuillez consulter votre administrateur.",
            reportRead:
                "Vous n'avez pas l'autorisation de consulter les rapports. Veuillez consulter votre administrateur.",
            reportUpdate:
                "Vous n'avez pas l'autorisation de mettre à jour les rapports. Veuillez consulter votre administrateur.",
            reportDelete:
                "Vous n'avez pas l'autorisation de supprimer les rapports. Veuillez consulter votre administrateur.",
            offlineSupportRequestCreate:
                "Vous n'avez pas l'autorisation de créer des demandes de support hors ligne. Veuillez consulter votre administrateur.",
            offlineSupportRequestRead:
                "Vous n'avez pas l'autorisation de consulter les demandes de support hors ligne. Veuillez consulter votre administrateur.",
            offlineSupportRequestUpdate:
                "Vous n'avez pas l'autorisation de répondre aux demandes de support hors ligne. Veuillez consulter votre administrateur.",
            offlineSupportRequestDelete:
                "Vous n'avez pas l'autorisation de supprimer les demandes de support hors ligne. Veuillez consulter votre administrateur.",
            catalogCreate:
                "Vous n'avez pas l'autorisation de créer des catalogues. Veuillez consulter votre administrateur.",
            catalogRead:
                "Vous n'avez pas l'autorisation de consulter les catalogues. Veuillez consulter votre administrateur.",
            catalogUpdate:
                "Vous n'avez pas l'autorisation de mettre à jour les catalogues. Veuillez consulter votre administrateur.",
            catalogDelete:
                "Vous n'avez pas l'autorisation de supprimer les catalogues. Veuillez consulter votre administrateur.",
            chatbotStoryCreate:
                "Vous n'avez pas l'autorisation de créer des histoires de chatbot. Veuillez consulter votre administrateur.",
            chatbotStoryRead:
                "Vous n'avez pas l'autorisation de consulter les histoires de chatbot. Veuillez consulter votre administrateur.",
            chatbotStoryUpdate:
                "Vous n'avez pas l'autorisation de mettre à jour les histoires de chatbot. Veuillez consulter votre administrateur.",
            chatbotStoryDelete:
                "Vous n'avez pas l'autorisation de supprimer les histoires de chatbot. Veuillez consulter votre administrateur.",
            chatbotTemplateRead:
                "Vous n'avez pas l'autorisation de consulter les modèles de chatbot. Veuillez consulter votre administrateur.",
            chatbotTemplateAiRead:
                "Vous n'avez pas l'autorisation de consulter les modèles de chatbot IA. Veuillez consulter votre administrateur.",
            chatbotIntegrationsRead:
                "Vous n'avez pas l'autorisation de consulter les intégrations de chatbot. Veuillez consulter votre administrateur.",
            chatbotArchiveRead:
                "Vous n'avez pas l'autorisation de consulter les archives de chatbot. Veuillez consulter votre administrateur.",
            chatbotEntitiesRead:
                "Vous n'avez pas l'autorisation de consulter les entités de chatbot. Veuillez consulter votre administrateur.",
            chatbotEntitiesCreate:
                "Vous n'avez pas l'autorisation de créer des entités de chatbot. Veuillez consulter votre administrateur.",
            chatbotEntitiesUpdate:
                "Vous n'avez pas l'autorisation de mettre à jour les entités de chatbot. Veuillez consulter votre administrateur.",
            chatbotEntitiesDelete:
                "Vous n'avez pas l'autorisation de supprimer les entités de chatbot. Veuillez consulter votre administrateur.",
            chatbotReportRead:
                "Vous n'avez pas la permission de consulter les rapports du chatbot. Veuillez contacter votre administrateur.",
            chatbotTrainRead:
                "Vous n'avez pas la permission de consulter la formation du chatbot. Veuillez contacter votre administrateur.",
            chatbotSegmentCreate:
                "Vous n'avez pas la permission de créer des segments d'utilisateurs du chatbot. Veuillez contacter votre administrateur.",
            chatbotSegmentRead:
                "Vous n'avez pas la permission de consulter les segments d'utilisateurs du chatbot. Veuillez contacter votre administrateur.",
            chatbotSegmentUpdate:
                "Vous n'avez pas la permission de mettre à jour les segments d'utilisateurs du chatbot. Veuillez contacter votre administrateur.",
            chatbotSegmentDelete:
                "Vous n'avez pas la permission de supprimer les segments d'utilisateurs du chatbot. Veuillez contacter votre administrateur.",
            integrationsRead:
                "Vous n'avez pas la permission de consulter la page des intégrations. Veuillez contacter votre administrateur.",
            whatsappIntegrationRead:
                "Vous n'avez pas la permission de consulter la page d'intégration WhatsApp. Veuillez contacter votre administrateur.",
            instagramIntegrationRead:
                "Vous n'avez pas la permission de consulter la page d'intégration Instagram. Veuillez contacter votre administrateur.",
            telegramIntegrationRead:
                "Vous n'avez pas la permission de consulter la page d'intégration Telegram. Veuillez contacter votre administrateur.",
            integrationCreate:
                "Vous n'avez pas la permission d'activer les intégrations. Veuillez contacter votre administrateur.",
            triggerCreate:
                "Vous n'avez pas la permission de créer des déclencheurs. Veuillez contacter votre administrateur.",
            triggerRead:
                "Vous n'avez pas la permission de consulter les déclencheurs. Veuillez contacter votre administrateur.",
            triggerUpdate:
                "Vous n'avez pas la permission de mettre à jour les déclencheurs. Veuillez contacter votre administrateur.",
            triggerDelete:
                "Vous n'avez pas la permission de supprimer les déclencheurs. Veuillez contacter votre administrateur.",
            billingRead:
                "Vous n'avez pas l'autorisation de consulter les factures. Veuillez contacter votre administrateur.",
            taskCreate: "Vous n'avez pas l'autorisation de créer des tâches. Veuillez contacter votre administrateur.",
            taskRead:
                "Vous n'avez pas l'autorisation de consulter les tâches. Veuillez contacter votre administrateur.",
            taskUpdate:
                "Vous n'avez pas l'autorisation de mettre à jour les tâches. Veuillez contacter votre administrateur.",
            taskDelete:
                "Vous n'avez pas l'autorisation de supprimer les tâches. Veuillez contacter votre administrateur.",
            calendarCreate:
                "Vous n'avez pas l'autorisation de créer un calendrier/une réservation. Veuillez contacter votre administrateur.",
            calendarRead:
                "Vous n'avez pas l'autorisation de consulter un calendrier/une réservation. Veuillez contacter votre administrateur.",
            calendarUpdate:
                "Vous n'avez pas l'autorisation de mettre à jour un calendrier/une réservation. Veuillez contacter votre administrateur.",
            calendarDelete:
                "Vous n'avez pas l'autorisation de supprimer un calendrier/une réservation. Veuillez contacter votre administrateur.",
            mailCreate: "Vous n'avez pas l'autorisation de créer des e-mails. Veuillez contacter votre administrateur.",
            mailRead:
                "Vous n'avez pas l'autorisation de consulter des e-mails. Veuillez contacter votre administrateur.",
            mailUpdate:
                "Vous n'avez pas l'autorisation de mettre à jour des e-mails. Veuillez contacter votre administrateur.",
            mailDelete:
                "Vous n'avez pas l'autorisation de supprimer des e-mails. Veuillez contacter votre administrateur.",
        },
        message: {
            noConversationDesc: "Ici, vous pouvez voir les chats actifs et les chats qui vous sont attribués.",
            forMe: "Pour moi",
            unAssigned: "Non attribué",
            agentDetails: "Détails de l'agent",
            contactProperties: "Propriétés de contact",
            goToProfile: "Aller au profil",
            addNote: "Ajouter une note",
            noPreferredAgent: "Pas encore d'agent préféré",
            toPrefer: "Préférer",
            inChat: "Dans la discussion",
            watching: "Regarde",
            chatsTitle: "Discussions",
            dealyTimeMaxValueError: "Le temps de retard peut être de 15 au maximum",
            dealyTimeTypeError: "La valeur du temps de retard doit être un nombre",
            passedTimeHm: "{hour} Heures {min} Minutes",
            passedTimeMs: "{min} Minutes {sec} secondes",
            passedTimeSc: "{sec} Secondes",
            translateMessage: "Votre message a été traduit par l'intelligence artificielle.",
            toneChanged: "Le ton du message a été changé en {tone}",
            aiResponseAdded: "Réponse de l'IA ajoutée au message",
            messageLonger: "Message rendu plus long",
            grammarFixed: "Grammaire corrigée",
            aiTranslate: "Traduction",
            other: "Autre",
            yourLanguage: "Votre langue",
            myLanguage: "Ma langue",
            forwardToChatbot: "Transférer au Chatbot",
            friendly: "Amical",
            confident: "Confiant",
            straightForward: "Direct",
            casual: "Décontracté",
            professional: "Professionnel",
            longSentence: "Longue Phrase",
            changeTone: "Changer de Ton",
            fixGrammar: "Corriger la Grammaire",
            aiResponse: "Réponse de l'IA",
            templateButtonNote:
                "Pour interdire le contact, utilisez les textes suivants sur le bouton de bannissement. Indépendamment des lettres majuscules ou minuscules",
            templateButtonTags: "#Envoyer un message# | #Se désabonner# | #Bannir# | #Bloquer#",
            dashboard: "Tableau de bord",
            calendarModule: "Module de calendrier",
            taskModule: "Module de gestion des tâches",
            maxUrlButtonMessage: "You can add a maximum of 2 URL buttons.",
            noPreferredDepartment: "Aucun département préféré",
            searchForDepartment: "Rechercher un département",
            departmentAssignedToTheVisitor: "Sélectionnez le département que vous souhaitez attribuer au visiteur.",
            assignPreferredDepartment: "Attribuer un département préféré",
            smsChannel: "Canal SMS: ",
            whatsappv2Channel: "Canal Whatsapp V2: ",
            whatsappv1Channel: "Canal Whatsapp V1: ",
            wBChannel: "Canal Whatsapp Business: ",
            messengerChannel: "Canal Messenger: ",
            instagramChannel: "Canal Instagram: ",
            allPlatforms: "Toutes les plateformes",
            cbStartMessage: "Message de démarrage du chatbot",
            cbStartMessageDesc:
                "Le premier message saisi par l'utilisateur est automatiquement traité par le chatbot et dirigé vers l'adresse correspondante.",
            messengerUserProfile: "Profil utilisateur Messenger",
            instagramUserProfile: "Profil utilisateur Instagram",
            noEventFound: "Aucun événement trouvé",
            visitorMails: "Mails des visiteurs",
            visitorActions: "Actions des visiteurs",
            notVerified: "Non vérifié",
            visitorEvents: "Événements des visiteurs",
            assignedTasks: "Tâches assignées",
            mails: "Courriels",
            prefferedAgents: "Agents préférés",
            createEvent: "Créer un événement",
            blockManagement: "Gestion des blocs",
            deleteUser: "Supprimer l'utilisateur",
            blocked: "Bloqué",
            profiles: "Profils",
            similiarProfiles: "Profils similaires trouvés",
            ReplyAsAPm: "Répondre en tant que message privé et fermer",
            replyAsAComment: "Répondre en tant que commentaire et fermer",
            messengerAddDesc:
                "Cliquez sur le bouton Se connecter ci-dessous et connectez-vous à votre compte Facebook.",
            instaAddPrivacyCheckDesc: "J'ai lu et j'accepte la {Privacy} et les {Terms and Conditions}",
            instaAddDesc5: "Cliquez sur le bouton Se connecter ci-dessous et connectez-vous à votre compte Facebook.",
            instaAddDesc4: "Inscrivez-vous en tant que développeur Facebook",
            instaAddDesc3: "Assurez-vous que le commutateur <b>'Autoriser l'accès aux messages'</b> est activé",
            instaAddDesc2: "Assurez-vous que votre compte professionnel Instagram est connecté à votre page Facebook",
            instaAddDesc1:
                "Assurez-vous que votre compte Instagram est un compte Instagram professionnel (compte professionnel).",
            selectedDepartment: "Département sélectionné",
            departmentForwardEnable: "Règle de transfert de département activée",
            departmentForwardRule: "Règle de transfert de département",
            departmentForwardDesc:
                "Sélectionnez vers quel département les chats entrants seront redirigés dans le canal.",
            channelName: "Nom de la chaîne",
            forwardToLiveAgents: "👉 Transférer aux agents en direct",
            manageIgChannel: "Gérez votre chaîne Instagram",
            igDetail: "Détail Instagram",
            manageVisibilityDesc: "Gérer qui peut voir ce canal",
            selectAnIgAccount: "Sélectionnez un compte Instagram",
            connectToInsta: "Se connecter à Instagram",
            connectToMetaLeads: "Connect to Meta Leads",
            deleteInstaChannelInfo: "Êtes-vous sûr de vouloir supprimer le canal Instagram?",
            instagramChannels: "Chaînes Instagram",
            suspendedDescription: "Votre compte a été suspendu en raison de factures impayées",
            onlyChatbot: "Uniquement le chatbot",
            onlyAgents: "Uniquement les agents",
            checkboxWarning: "Ce champ doit être obligatoirement coché",
            sendingAllow: "Envoi",
            receiving: "Réception",
            platform: "Plateforme",
            banModalTitle: "Fenêtre modale d'interdiction de visiteur",
            selectDepartmentDesc: "Sélectionnez les départements dont vous souhaitez modifier la visibilité",
            selectAgentDesc: "Sélectionnez les agents dont vous souhaitez modifier la visibilité",
            selectDepartment: "Sélectionner le département",
            selectAgent: "Sélectionner l'agent",
            visibleDepartments: "Départements visibles",
            visibleAgents: "Agents visibles",
            visibilityInfoCont: "Tous les agents et départements peuvent voir ce canal",
            editDepartmentVisibility: "Modifier la visibilité du département",
            editAgentVisibility: "Modifier la visibilité de l'agent",
            typeSTToSearch: "Tapez quelque chose pour rechercher des utilisateurs",
            exportToCSV: "Exporter vers CSV",
            clear: "Effacer",
            usedSessionCount: "Nombre de sessions utilisées",
            maxSessionCount: "Nombre maximum de sessions",
            leftSessionCount: "Nombre de sessions restantes",
            planManagement: "Gestion des plans",
            teamChat: "Chat d'équipe",
            templateNameIsNotValid: "Le nom du modèle n'est pas valide",
            relatedAdvertisement: "Publicité connexe",
            whatsappNumber: "Numéro WhatsApp",
            integrationsWhatsappV1:
                "Un plan WhatsApp est nécessaire pour une communication sans problème entre Supsis et WhatsApp.",
            integrationsWhatsappV2:
                "Vous pouvez facilement partager des informations de chat entre Supsis et WhatsApp.",
            integrationsWhatsappBusiness:
                "Vous pouvez transmettre rapidement et facilement des informations de chat entre Supsis et WhatsApp.",
            selectDays: "Sélectionner les jours",
            addTime: "Ajouter du temps",
            instagramContactList: "Liste de contacts Instagram",
            archiveAllRated: "Récupérer toutes les conversations avec des évaluations.",
            allChannels: "toutes les chaînes",
            comment: "commentaire",
            news: "Quoi de neuf ?",
            conversation: "conversation d'équipe",
            speechTermination: "mettre fin à la conversation",
            noSystemMessage: "Il n'y a pas encore de messages dans le système!",
            supsisCustomerService: "Services à la clientèle fournis par Supsis,",
            supsisClickExperience: "Vous pouvez tenter l'expérience en cliquant.",
            customerPage: "Aller à la page client",
            buttonTitle: "Titre du bouton",
            buttonType: "Type de bouton",
            buttonSendMessage: "envoyer le message",
            buttonGoToBlock: "aller sur le blog",
            buttonOpenUrl: "Ouvrir le lien",
            buttonPhoneCall: "Appel téléphonique",
            buttonOpenMoment: "Moment ouvert",
            buttonCloseChat: "Fermer la discussion",
            buttonTransferChat: "Transférer la conversation",
            buttonCreateTicket: "Créer un billet",
            deleteVisitor: "Voulez-vous vraiment supprimer l'utilisateur ? Cette action ne peut pas être annulée.",
            userProfile: "Profil",
            addCalendarEvent: "Événement +",
            you: "Toi",
            and: "et",
            apiIntegration: "Développeur",
            generateToken: "Générer le jeton",
            copyToken: "Copier le jeton",
            dndBlocked: "Fichier d'envoi des paramètres désactivés.",
            labels: "Étiquettes",
            noData: "Pas de données",
            color: "Couleur",
            titleColor: "Couleur du titre",
            secondTitleColor: "Couleur du deuxième titre",
            tag_name_indicator: "Nom de l'étiquette",
            sendMessage: "Envoyer message",
            removeFromG: "Retirer du groupe",
            delChannel: "Êtes-vous sûr de vouloir supprimer ce canal ?",
            new_name: "Nouveau nom",
            set_group_info: "Éditer les informations de groupe",
            shortcut_desc_num: "Passez d'une conversation active à l'autre avec des chiffres numériques",
            copilot_desc_num: "Vous permet d'ouvrir Copilot sur l'écran de discussion",
            typing_w_chat: "il écrit...",
            edit_group_info: "Modifier les informations du groupe",
            notif_sound: "Activer les sons de notification",
            notif_mute: "Mettre les notifications en mode silencieux",
            leave: "Quitter",
            group: "Groupe",
            updateTag: "Mettre à jour l'étiquette",
            ordered_desc: "Attribue les chats aux représentants dans l'ordre.",
            random_desc: "Attribue les chats aux représentants de manière aléatoire.",
            Rrobin_desc:
                "Attribue les chats aux représentants de manière circulaire. (Priorité aux représentants moins occupés)",
            RrobinRev_desc:
                "Attribue les chats aux représentants de manière circulaire inversée. (Priorité aux représentants les plus occupés)",
            algo_desc: "Sélectionnez l'algorithme pour l'attribution automatique des chats",
            algorithm: "Algorithme",
            os_browser: "Système d'exploitation et navigateur",
            CHAT: "Discuter",
            addTag: "Ajouter une étiquette",
            tags: "Mots clés",
            searchRepresentative: "Rechercher un représentant",
            preferredRepresentative: "Représentants",
            voting: "Vote",
            chatWidget: "Widget de chat en soupise",
            webhooks: "Webhooks",
            selectHooks: "Sélectionnez des crochets Web",
            planRequired: "{intégraable} plan requis",
            allIntegrations: "Toutes les intégrations",
            disableAgentSystemMessages: "Masquer les messages du système d'agent",
            disableAgentSystemMessagesDesc: "Masquer les messages du système de l'agent.",
            disableAutoTranslate: "Auto Translate",
            disableAutoTranslateDesc:
                "It automatically translates messages from different languages. So you can communicate with your customers more easily.",
            shouldAddMethod:
                "Vous devez remplir le champ Mode de paiement et adresse de facturation !\n Aucun argent ne sera retiré de votre compte. \n" +
                "À la fin du mois, une facture sera créée en fonction de votre consommation.",
            approveSelection: "Approuver la sélection",
            trialDaysEndSelectPlan: "Confirmer la sélection du plan",
            trialDaysEndSelectPlanDesc:
                "Votre version d'essai est terminée. Vous devez confirmer en sélectionnant le plan ci-dessous.",
            infoAboutAnnouncement: "Brèves informations sur l'annonce",
            announcement: "Annonce",
            newAnnouncementForm: "Nouveau formulaire d'annonce",
            newAnnouncement: "Nouvelle annonce",
            announcements: "Annonces",
            newTicketSound: "Nouveau billet",
            vtippyDepartmentNotification:
                "Paramètres de notification pour les messages de la conversation du département",
            vtippyGroupNotification: "Paramètres de notification pour les messages des groupes créés",
            vtippyTicketNotification: "Paramètres de notification pour chaque nouveau ticket que vous recevez",
            vtippyAnnouncemenNotification: "Paramètres de notification pour les nouvelles annonces",
            languageSelection: "Sélection de la langue",
            announcementTitle: "Titre d'annonce",
            infinitePlay: "Jouer en continu",
            hideBubbleOnMobile: "Cacher sur mobile",
            vtippyHideBubbleOnMobile: "Chat Bubble est caché aux utilisateurs mobiles.",
            deleteSystemLanguage: "Supprimer la langue {code} du système",
            assignedChat: "Chat assigné",
            check: "Cocher",
            systemStatus: "État du système",
            chatAssignedToUser: "Nouveau chat attribué",
            inactiveThresholdTime: "Temps de chat inactif (minute)",
            tippyInactiveThresholdTime:
                "Si aucun message n'est envoyé dans le délai donné, la conversation est considérée comme inactive. Entrez la valeur (minutes). Doit être de plage en 1 min - 120 minutes.",
            inactiveTerminateTime: "Durée du chat inactif (minute)",
            tippyInactiveTerminateTime:
                "Le chat inactif sera terminé s'il ne passe pas en mode actif dans un certain temps. Entrez la valeur (minutes). Doit être de plage en 1 min - 120 minutes.",
            removePendingMessage: "Annuler l'envoi du message",
            disconnected: "Débranché",
            visitorWriteEmptyChatTippy: "Le client peut écrire dans la conversation avant que l'agent ne se connecte.",
            visitorWriteEmptyChat: "Le client peut écrire sans l'agent connecté.",
            visitorConnectionEventSystemMessageEnabled:
                "Les messages du système d'état de connexion du visiteur activent",
            visitorConnectionEventSystemMessageEnabledTippy:
                "Les messages du système de retour du visiteur et du visiteur permettent",
            openBubble: "Bulle ouverte",
            showHeaderImage: "Afficher l'image d'en-tête",
            askQuestion: "poser une question",
            locationPermsNeeded:
                "Des autorisations de localisation sont nécessaires pour utiliser cette fonctionnalité",
            useMyLocation: "Utilise ma location",
            acceptingChat: "Accepter les chats",
            notAcceptingChat: "Ne pas accepter les chats",
            blockBy: "Interdit par",
            languageRemovalQuestion: "Vous êtes sur le point de supprimer la langue {code} du système!",
            loggedOut: "Déconnecté",
            vtippyNewVisitorNotification: "Notification audible pour chaque nouveau visiteur sur votre site Web",
            vtippySelectnotification: "Vous pouvez choisir le son de notification.",
            vtippyVoiceLevel: "vous pouvez ajuster le volume",
            vtippyStartVoice: "Écouter",
            vtippyInfiniteNotification:
                "Si vous n'êtes pas actif dans le nouveau panneau Chats, il continuera de jouer. Vous pouvez modifier actif-passif en cliquant.",
            vtippyTranslateButton: "Traduit la langue sélectionnée vers d'autres langues",
            vtippyTranslateClearButton: "Nettoie le contenu dans d'autres langues.",
            vtippyNewChatNotification:
                "Vous pouvez sélectionner une notification sonore pour les nouvelles conversations à venir dans le système et ajuster le volume.",
            vtippyNewConversationNotification:
                "Vous pouvez choisir une notification sonore et ajuster le volume lorsque de nouvelles conversations entrantes vous sont attribuées.",
            vtippyNewMessageNotification:
                "Vous pouvez sélectionner des notifications pour les messages entrants à vos conversations et ajuster le volume.",
            vtippyPrivateMessageNotification:
                "Vous pouvez sélectionner une notification pour le message entrant à l'équipe.",
            hideInactiveAgents: "Masquer les agents inactifs",
            hideMinorValues: "Masquer les valeurs mineures",
            hashHintMessage: "Vous pouvez rapidement entrer des raccourcis hashtag avec #hash",
            pmHintMessage: "Saviez-vous que vous pouvez envoyer un message clé privé ?. par exemple PM: salut",
            shortcutHintMessage:
                "Saviez-vous que vous pouvez envoyer des messages plus rapidement avec des messages de raccourci?",
            switchBetweenConversations:
                "Saviez-vous que vous pouvez rapidement basculer entre les conversations avec les raccourcis ABC?",
            atNameHintMessage: "Saviez-vous que vous pouvez rapidement saisir le nom du visiteur avec @name?",
            dndHintMessage: "Vous pouvez télécharger des fichiers avec glisser-déposer.",
            pasteFile: "vous pouvez envoyer des fichiers.",
            atEmailHintMessage: "Saviez-vous que vous pouvez rapidement saisir le courrier des visiteurs avec @mail?",
            pastePlainText: "Coller du presse-papiers comme texte brut",
            pressAndTalk: "Press and talk",
            agentActivities: "Activités d'agent",
            listStatuses: "Statuts",
            newHASHContent: "#Add Hash",
            hash: "Hashtag",
            hashText: "Texte de hachage",
            exampleHash: "suivi de commande",
            notValidHash: "Ne doit pas contenir d'espaces.",
            websiteChatWidgetIntegration: "Intégration du widget de chat de site Web",
            videoCallEnabledDesc: "Activez pour activer la fonction d'appel vidéo.",
            videoCallEnabled: "Fonction d'appel vidéo",
            audioCallDesc: "Activez pour activer la fonction de recherche vocale.",
            audioCallEnabled: "Fonctionnalité de recherche vocale",
            assignPreferredAgent: "Agent préféré",
            representativeAssignedToTheVisitor:
                "Sélectionnez l'agent préféré que vous souhaitez attribuer au visiteur.",
            agentFileSendEnabledDesc: "Permet la possibilité d'envoyer des fichiers aux délégués",
            agentFileSendEnabled: "Les représentants peuvent soumettre des fichiers",
            visitorFileSendEnabledDesc:
                "Vous permet de tourner la fonction d'envoi de fichiers visiteurs activé ou désactivé",
            visitorFileSendEnabled: "Les visiteurs peuvent soumettre des fichiers",
            visitorAutoLogin: "Connexion automatique des visiteurs",
            visitorAutoLoginDesc: "Conversation de démarrage automatique lorsque le visiteur clique sur Bubble de chat",
            agentVoiceRecordEnabledDesc: "Permet aux agents d'enregistrer l'audio",
            agentVoiceRecordEnabled: "Les agents peuvent enregistrer l'audio",
            visitorVoiceRecordEnabledDesc: "Permet aux visiteurs d'enregistrer l'audio",
            visitorVoiceRecordEnabled: "Les visiteurs peuvent enregistrer l'audio",
            startVideoCall: "Appel vidéo",
            startAudioCall: "Appel vocal",
            visitorGDPRDeleteEnabledDesc:
                "Vous permet de basculer la possibilité de supprimer toutes les informations des visiteurs",
            visitorGDPRDeleteEnabled: "Les visiteurs peuvent supprimer toutes leurs informations",
            visitorLocationEnabled: "Les visiteurs peuvent partager l'emplacement",
            visitorLocationEnabledDesc: "Permet aux visiteurs de tourner ou désactiver le partage de l'emplacement",
            customerLocationEnabled: "Les représentants peuvent partager l'emplacement",
            customerAutoMergeEnabled: "Fusionne automatiquement les mêmes personnes",
            customerAutoMergeEnabledDesc:
                "Cette fonctionnalité effectue une fusion automatique pour regrouper de manière efficace les données liées aux mêmes personnes. Cela garantit une représentation plus cohérente et ordonnée des utilisateurs ayant des profils similaires dans les ensembles de données.",
            chatAiCopilot: "Copilote de discussion IA",
            chatAiCopilotDesc:
                "Répondez automatiquement aux questions de vos clients en utilisant le Copilote de discussion IA",
            customerLocationEnabledDesc:
                "Permet aux représentants de tourner ou désactiver le partage de l'emplacement",
            triggerAlreadyExists: "Le déclencheur existe déjà",
            ticketStatusForm: "Formulaire de statut de ticket",
            statusFormTitle: "Titre de l'état du billet",
            allStatus: "Tous les statuts",
            triggers: "Déclencheurs",
            trigger: "Déclencher",
            noTrigger: "Vous n'avez pas encore ajouté de déclencheurs",
            triggerSkipLoginForm: "Formulaire de connexion",
            triggerSkipLoginFormTrue: "Afficher le formulaire de connexion",
            triggerSkipLoginFormFalse: "Passer le formulaire de connexion et aller directement au message",
            noContent: "Pas de contenu",
            toCreate: "Créer",
            clickTheButton: "cliquez sur le bouton",
            triggerContent:
                "Tapez la description que vous souhaitez apparaître dans le modal qui s'ouvre. Il vous suffit d'écrire dans une seule langue et la traduction dans d'autres langues est effectuée automatiquement.",
            triggerDrag: "Vous pouvez ajuster la durée du message en faisant glisser ou en cliquant sur la barre.",
            triggerNewCondition: "Vous pouvez ajouter une nouvelle condition avec le bouton.",
            triggerNoConditionDescription1:
                "Vous pouvez créer les conditions que vous souhaitez à partir des options. Si vous ne créez aucune condition pour un déclencheur, le premier déclencheur sera actif.",
            triggerNoConditionDescription2:
                "Un seul des déclencheurs avec les mêmes conditions apparaît sur la page des visiteurs.",
            triggerShowAndHide: "Vous pouvez afficher ou masquer des déclencheurs quand vous le souhaitez.",
            countryLanguage: "Pays/Langue",
            addTrigger: "Ajouter la déclencheur",
            yesPlease: "Oui s'il te plaît!",
            noThanks: "Non merci.",
            firstAnswer: "Question Dialogue Confirmer Réponse",
            secondAnswer: "Question Dialogue Rejet Réponse",
            noTitle: "Pas de title",
            sumChat_MediaFile: "Médias et documents",
            importantWarning: "AVERTISSEMENT IMPORTANT!",
            images: "Images",
            URLS: "Liens",
            files: "Dossiers",
            noCondition: "Aucune condition! Vous pouvez ajouter des conditions en cliquant sur l'icône Plus.",
            showTriggers: "Cliquez pour afficher les déclencheurs",
            showThisTrigger: "Cliquez pour afficher ce déclencheur",
            hideTriggers: "Cliquez pour masquer les déclencheurs",
            hideThisTrigger: "Cliquez pour masquer ce déclencheur",
            updateTrigger: "Mettre à jour le déclencheur",
            conditions: "Conditions",
            messageDurationPerRow: "Durée du message par ligne",
            updateCompleted: "Mise à jour terminée",
            CatalogUpdatedSuccessfully: "Catalogue mis à jour avec succès",
            integrateSupsiswithIntegratable:
                "Passez facilement les informations de chat entre le Supsis et {integratable}.",
            installationOK: "installée",
            dayTime: "Heure",
            weekDay: "Jour de la semaine",
            spendTimePage: "Passé du temps sur la page",
            spendTimeSite: "Passé du temps sur place",
            pageUrl: "L'URL de la page",
            pageTitle: "Titre de la page",
            equal: "Égal",
            not_equal: "Inégal",
            less_than: "Moins que",
            greater_than: "Plus grand que",
            less_than_or_equal: "Moins ou égal",
            greater_than_or_equal: "Meilleur que ou égal",
            visitorName: "Nom du visiteur",
            seconds10: "10 secondes",
            seconds30: "30 secondes",
            minute1: "1 minute",
            minutes5: "5 minutes",
            minutes10: "10 minutes",
            minutes30: "30 minutes",
            hour1: "1 heure",
            hours2: "2 heures",
            hours4: "4 heures",
            hours8: "8 heures",
            hours12: "12 heures",
            hours24: "24 heures",
            maxCondition: "Condition maximale",
            doYouWishToDeleteTrigger: "Souhaitez-vous supprimer le déclencheur",
            contains: "Contient",
            not_contains: "Ne contient pas",
            chatLanguage: "Langue de chat",
            translating: "Traduction en cours",
            buyWhatsapp: "Acheter l'intégration WhatsApp",
            liveSupportStartingWait: "Commencer le soutien en direct, veuillez patienter",
            noConnection: "Pas de connection!",
            integrations: "Intégrations",
            refundInvoiceSure: "Êtes-vous sûr de vouloir retourner la facture?",
            invoiceMarkedAsPaidSuccess: "La facture a marqué comme payé avec succès",
            invoiceMarkedAsPaidError: "Erreur, la facture n'a pas marqué",
            deleteConfirm: "Voulez-vous supprimer ce {object}?",
            markPaidConfirm: "Êtes-vous sûr de Mark comme payé cette facture?",
            addLink: "Lien",
            startChatDesc: "Commencer la conversation",
            selectStep: "Sélectionnez une étape:",
            addGOTO: "Aller à",
            sendFastLink: "Envoyer un lien rapide",
            or: "Ou",
            allTags: "Toutes les balises",
            showDetail: "Montrer les détails",
            hideDetail: "Masquer les détails",
            weLlSendPhone: "Nous enverrons à votre téléphone",
            weLlSendEmail: "Nous enverrons à votre e-mail",
            linkSentToPhone: "Lien envoyé comme SMS",
            offerlinkSendToPhone: "Nous vous enverrons le lien de téléchargement de notre application via SMS.",
            offerlinkSendToMail: "Nous vous enverrons le lien de téléchargement de notre application par e-mail.",
            theEmail: "Mon e-mail enregistré",
            differentEmail: "Un autre e-mail différent",
            linkSentToMailBox: "Le lien a été envoyé à votre adresse de courrier",
            errorOccurred: "Erreur est survenue !",
            clickStoreIcon:
                "Vous pouvez accéder à l'application mobile en cliquant sur l'icône adaptée à votre téléphone.",
            meetWithSupsis: "Souhaitez-vous rencontrer notre application mobile en Supsis?",
            downloadMobileApps: "Télécharger l'application mobile",
            getApps: "Obtenir des applications",
            info: "Information",
            conversationHistory: "Historique des conversations",
            planInfoHeader: "Planifier des informations",
            planInformation: "Votre plan est {selectedPlan} ({detailMaxAgentCount} Agent) ({freeAgent} agent libre)",
            creditAvailable: "Votre crédit d'agent disponible dans votre plan:",
            upDownGradePlan: "Si vous souhaitez mettre à niveau / rétrograder votre plan, veuillez",
            click: "Cliquez sur",
            autoStartChat: "Démarrage du chat automatique",
            bubbleColor: "Couleur de bulle de chat",
            openFolder: "Dossier ouvert",
            preDefined: "Thèmes",
            customIcon: "Installer à partir de votre ordinateur",
            theme: "Thème",
            themeSettings: "Réglage des thèmes",
            chatThemeSettings: "Paramètres du thème de discussion",
            bubbleSettings: "Paramètres de bulle de chat",
            inputHeightOfBubble: "Taille de bulle",
            inputPixelsOfChatBubble: "Cliquez pour modifier les distances de la bulle de chat sur les bords",
            modalTitleIsMarginAsPixelInfo: "Distances de la bulle de chat sur les bords:",
            inputPxOfXaxis: "Position horizontale",
            inputPxOfYaxis: "Position verticale",
            inputPxOfMobileXaxis: "(Mobil) position horizontale",
            inputPxOfMobileYaxis: "(Mobil) position verticale",
            animations: "Animations",
            preferredAnimation: "Animation préférée",
            selectAnAnimation: "Sélectionnez une animation",
            inputOfBubbleMessage: "Ajoutez du contenu à d'énormes bulles de discussion. \n {contentOfChatBubble}",
            showChatBubbleOnlyLoggedUserToolTip:
                "Il s'agit du paramètre pour masquer la bulle de chat en fonction de l'état de connexion.",
            showChatBubbleOnlyLoggedUser: "Afficher la bulle pour uniquement connectée à l'utilisateur. (Ideasoft)",
            helloDoUNeedHelp: "Salut, avez-vous besoin d'aide?",
            bubbleIcon: "Image de bulle de chat",
            overrideMargins: "Personnaliser les marges",
            autoHideBubble: "Hide Chat Bubble",
            vtippyAutoHideBubble: "Cache la bulle de chat lorsque les agents sont hors ligne",
            hideBubble: "Chat-Blase deaktivieren",
            vtippyHideBubble: "Deaktiviert die Chat-Blase.",
            overrideMobileMargin: "Personnaliser les marges pour mobile",
            vtippyMobileMargin: "Personnaliser les marges pour mobile",
            isFabsActive: "Afficher le bouton d'action flottante",
            bubbleOpenableMenu: "Dropdown de Chat Bubble",
            vtippyIsFabsActive: "Réglage du bouton Afficher / masquer l'action flottante",
            vtippyIsFabsAsIcon:
                "C'est le réglage de la question de savoir si les icônes apparaîtront dans le menu déroulant.",
            isFabsAsIcon: "Afficher les icônes de menu.",
            setMarginAsPixel: "Définir en pixel",
            returnDefaultMargins: "Paramètres de marge par défaut",
            deleteSite: 'Voulez-vous supprimer le site "{siteName}"?',
            deleteThisSite: "Supprimer le site",
            assetOversizeWithExt: "La taille du fichier doit être inférieure à 10 Mo et en PNG, format JPG.",
            closeChat: "Messagerie finale",
            ticket: "Billet",
            formStep: "Étape de forme",
            menuStep: "Étape du menu",
            contentStep: "Étape de contenu",
            menuTitle: "Titre de menu",
            messageContent: "Contenu du message",
            goToLive: "Transfert vers le représentant",
            prevStep: "Revenir à l'étape précédente",
            button: "Bouton",
            addImage: "Image",
            addText: "Texte",
            stepTitle: "Titre de pas",
            addTicket: "Billet",
            formDescription: "Question",
            addInput: "Question",
            addRandomText: "Texte aléatoire",
            calendarPassedTimeMinSec: "{min} minute {sec} seconde {nom}",
            calendarPassedTimeSec: "{hour} heure {min} minute {sec} seconde {name}",
            updateUserName: "Mettre à jour le nom d'utilisateur",
            forgotPassword: "Mot de passe oublié",
            osrFromMessageSaved: "Message hors ligne enregistré.",
            requiredField: "Ce champ est obligatoire.",
            nightModeOn: "Mode nocturne sur",
            catalogMenu: "Menu",
            catalogContent: "Contenu",
            all: "Tous",
            allDepartments: "Tous les départements",
            preferredLanguage: "langue préférée",
            kmkAutoDepartmentBind: "KMK Auto Depariment Find",
            kmkAutoDepartmentBindDesc:
                "Rechercher le vendeur sur les sites des clients KMK et réglé sur la page de connexion en tant que département",
            visitorEmailUpdated: "Courriel du visiteur mis à jour",
            visitorEmailIsNotValid: "Le courrier électronique des visiteurs n'est pas valide",
            visitorNameUpdated: "Nom du visiteur mis à jour",
            clickToEdit: "Cliquez pour modifier",
            addEmail: "+ Ajouter un e-mail",
            addFullname: "+ Ajouter FullName",
            partner: "Ref?",
            isIntegrated: "L'intégration?",
            agentCount: "Compte d'agent",
            closePreviewColors: "Fermer un aperçu du thème",
            previewColors: "Aperçu du thème ouvert",
            videoCalls: "Appels vidéo",
            filterLost: "Chats perdus",
            vtipyCustomLogin:
                "Vous pouvez personnaliser les informations qui seront demandées dans le formulaire de connexion lorsque vos visiteurs se connectent au système.",
            vtipyLoginlessChat:
                "Le formulaire de connexion des visiteurs sera caché. Le visiteur peut se connecter directement à discuter.",
            loginlessChat: "Formulaire de connexion",
            imageUrl: "URL de l'image",
            replied: "Répondu",
            solved: "Résolu",
            openImage: "Image ouverte",
            writeFeedback: "Vous pouvez rédiger vos commentaires sur le Supsis ici.",
            feedbackFailed: "Une erreur s'est produite lors de l'envoi de commentaires.",
            feedbackSuccessful: "Soumission de rétroaction réussie.",
            sendFeedback: "Envoyer des commentaires",
            errorReport: "Vous pouvez nous donner des commentaires sur les problèmes que vous avez sur le Supsis.",
            sendErrorFeedBack: "Donnez-nous des commentaires sur le problème que vous rencontrez.",
            successImgUpload: "Votre image a été téléchargée avec succès.",
            successImgDelete: "L'image a été supprimée avec succès.",
            errorImgUpload: "Une erreur s'est produite lors du téléchargement de votre image.",
            errorImgDelete: "Une erreur s'est produite lors de la suppression de l'image",
            chatBotEndStatics: "Taux de réussite de la conversation du chatbot",
            videoCallDist: "Distribution des appels vidéo",
            departmentInfo: "Informations sur le département",
            infoAboutDepartment: "Donnez de brèves informations sur le département",
            deleteDepartmentQuestion: "Voulez-vous vraiment supprimer ce département?",
            departmentDeleted: "Département supprimé",
            departmentTitle: "Titre du département",
            updateDepartmentForm: "Formulaire de mise à jour du département",
            newDepartmentForm: "Nouveau formulaire de département",
            department: "Département",
            newDepartment: "Nouveau département",
            departmentSaved: "Département sauvé",
            sameDepartment: "Il y a un département avec le même nom",
            sameValue: "Il y a une valeur avec le même nom!",
            sameTag: "Il y a une balise avec ce nom!",
            departments: "Départements",
            chatTimingSettings: "Paramètres de synchronisation de chat",
            assetOversize: "La taille du fichier que vous souhaitez envoyer ne doit pas dépasser 2 Mo.",
            assetOversizeMB: "La taille du fichier que vous souhaitez envoyer ne doit pas dépasser {mb} Mo.",
            messageDeleted: "Ce message est supprimé",
            filterLostChat: "Filtrer les chats perdus",
            filterClosedByAgent: "Filtre fermé par agent",
            filterVideoCall: "Filtre d'appel vidéo",
            notificationText: "Le soupsis a besoin de l'autorisation de",
            notificationTitle: "Notifications désactivées",
            deniedText:
                "Vos notifications sont fermées, vous devez activer vos notifications afin de ne pas manquer vos clients.",
            deniedTitle: "Cliquez pour ouvrir vos notifications!",
            deniedHeader: "Pour ne pas manquer vos clients, vous devez activer vos notifications !",
            showNotificationGuide: "Cliquer pour les détails",
            howToEnableNotification: "Comment puis-je activer les notifications",
            notificationOK: "D'accord",
            notificationUnderstood: "Compris!",
            notificationCancel: "Annuler",
            howToEnableNotificationInstruction1:
                "Cliquez sur l'icône de verrouillage dans la barre d'adresse du navigateur",
            howToEnableNotificationInstruction2:
                "Si les «notifications» sont désactivées dans la section des autorisations, activez-la",
            howToEnableNotificationInstruction3:
                'Si "Notifications" n\'apparaît pas dans la section des autorisations, cliquez sur "Paramètres du site',
            howToEnableNotificationInstruction4:
                'Activez l\'autorisation "Notifications" de la section "Autorisations" de la page Paramètres du site',
            checkPaymentMethod: "Veuillez vérifier votre mode de paiement",
            pushNotificationEnabled: "Super, notification push activée",
            pushNotificationDenied: "Vous avez nié l'autorisation de notification",
            suspendedMessage: "votre compte a été suspendu",
            enableNotification: "Activer les notifications de bureau.",
            languageSettings: "Langue sélectionnée",
            problemsSound:
                "Si vous avez des problèmes avec les notifications, vous pouvez cliquer sur l'image de verrouillage de verrouiller dans votre zone de recherche de navigateur (affiché sur l'image), cliquez sur «Paramètres du site» et modifier le «son» pour autoriser",
            betweenRepresentative: "Il y a un nouveau message d'un représentant",
            desktopNotifications: "Notifications de bureau",
            notificationEnabled: "Les notifications de bureau de Supsis sont activées.",
            newMessageAlert: "Vous avez un nouveau message.",
            notificationDisable: "Vous pouvez désactiver la notification à partir de paramètres représentatifs",
            newConversationAlert: "Vous avez un nouveau visiteur.",
            chatBot: "Chatbot",
            ticketResponse: "Temsilcinin Yanıtı:",
            archived: "archive",
            chatbotChatCount: "Chatbot",
            changeTitle: "Titre de changement",
            changeVisitorTitle: "Cambiar título de visitante",
            catalog: "Titre de catalogue",
            openTheCatalog: "Catalogue ouvert",
            catalogNotOpen:
                "La fonction de catalogue est désactivée. Vous pouvez activer la fonction de catalogue pour prendre en charge vos clients avec du contenu préparé.",
            showCatalogCategories: "Définissez si le menu du catalogue apparaîtra sur la bulle de chat",
            showChatBot: "Définissez si le chatbot apparaîtra sur la bulle de chat",
            openCatalog: "Visibilité du catalogue",
            unreadMessages: "Messages non lus",
            personalFirstMsg: "Moyenne de temps de réponse de l'agent (SEC)",
            personalRating: "Score du personnel AVG",
            soundSettings: "Paramètres de notification",
            newPrivateMessage: "Message privé",
            addNewGroup: "Créer un nouveau groupe",
            newMessage: "Nouveau message",
            newConversation: "Nouveau chat",
            newVisitor: "Nouveau visiteur",
            chatPosition: "Position de chat",
            bottomLeftCorner: "Coin inférieur gauche",
            leftDocked: "gauche Amarré",
            bottomRightCorner: "Coin inférieur droit",
            rightDocked: "à droiteAmarré",
            chatPositionSelect: "Choisir la position",
            teamChatGroup: "Messages de groupe",
            teamChatDepartment: "Messages de département",
            teamChatTeam: "Messages d'équipe",
            teamChatDm: "Messages privés",
            bottomLeft: "En bas à gauche",
            left: "Gauche",
            bottomRight: "En bas à droite",
            right: "Droite",
            mailorname: "E-mail ou nom",
            fieldName: "Nom de clé",
            value: "Valeur",
            addSetting: "Ajouter un paramètres",
            globalSettings: "Paramètres globaux",
            breaksByTime: "Couler de rupture par le temps",
            clPlaceholder: "Nom qui apparaîtra sur le formulaire client",
            target: "Adresse de test de chargement",
            duration: "Durée du test de chargement (SEC)",
            arrivalCount: "Nombre de discussions",
            bootMaxLife: "Chat Max Life Time (SEC)",
            startLoadTest: "Démarrer le test de chargement",
            noClusterInstanceFound: "Il n'y a pas de serveur",
            stopLoadTest: "Test de chargement d'arrêt",
            integrationDesc: "Ajoutez simplement le code en ligne ci-dessous à votre site.",
            integrationDemoCode: "Code de démonstration d'intégration simple",
            integrationWindow: "Comment puis-je m'intégrer à mon site?",
            notIntegrated: "L'intégration",
            help: "Aider",
            notIntegratedDesc:
                "Nous avons remarqué que vous n'aviez pas ajouté le système de chat à votre site. Lorsque vous l'intégrez dans votre site et commencez le premier chat, vous terminerez l'intégration. Cliquez pour le script d'intégration",
            backToLogin: "Revenir à l'écran de connexion",
            passwordlessLoginUnsuccessful: "La connexion n'est pas réussie.Url pourrait être expiré ou utilisé avant",
            passwordlessLogin: "Connexion sans mot de passe",
            loginWithEmail: "Connectez-vous avec e-mail",
            loginWithPassword: "Connectez-vous avec le mot de passe",
            enteringPasswordless: "Connexion sans mot de passe ...",
            toMainPath: "Rediriger vers la page principale",
            userRoleChanged: "Vos autorisations ont changé. Vous serez redirigé vers la page principale.",
            passwordChangeSuccess: "Votre mot de passe a changé avec succès",
            feedback: "Montrer des commentaires",
            showFeedbackHistory: "Afficher les messages qui ont été envoyés des commentaires",
            newSelfServiceSite: "Nouveau site de libre service",
            subdomain: "Sous-domaine",
            rootUserEmail: "E-mail",
            rootUserName: "Nom",
            newVersion: "Nouvelle version disponible",
            closeLiveSupport: "Fermer le soutien en direct",
            newVersionShort: "Nouvelle version",
            bannedWordRestrict: "Blocking des mots interdits",
            ticketShow: "Autoriser les clients à créer des tickets",
            ticketShowDesc: "Activer l'option de création de ticket dans le menu de discussion",
            autoLoadIframe: "Circulation en direct",
            autoLoadIframeDesc: "Iframe de chargement automatique, transmettez tout le trafic des visiteurs",
            bannedWordRestrictDesc:
                "Lorsque le blocage des mots interdits est activé, les représentants sont empêchés de taper les mots interdits définis dans le système aux visiteurs.",
            agentDown: "Agent",
            delayChat: "Chat retardé",
            tableSettingTippy: "Vous pouvez modifier les informations qui apparaîtront dans le tableau.",
            tableSettings: "Paramètres de la table",
            tableSettingsInfo:
                "Vous pouvez modifier les informations qui apparaîtront dans le tableau. Vous pouvez sélectionner 7 colonnes au plus",
            privateParametry: "Paramètres utilisateur personnalisés",
            systemOperetor: "Informations système",
            cityAndDistrict: "District de la ville",
            general: "Général",
            availability: "Disponibilité",
            home: "Maison",
            successful: "Réussite",
            forgetPasswordSent:
                "Réinitialiser le lien de mot de passe e-mail a été envoyé, cochez votre boîte de réception",
            saturday: "Samedi",
            friday: "Vendredi",
            thursday: "Jeudi",
            wednesday: "Mercredi",
            tuesday: "Mardi",
            monday: "Lundi",
            sunday: "Dimanche",
            download: "Télécharger un fichier",
            calendarPassedTimeHour: "{hour} pendant {name} heure",
            calendarPassedTime: "{name} pour {hour} heure {min} min",
            calendarPassedTimeMin: "{name} pour {value} min",
            workScheduleOneDay: "Horaire de travail de {name} sur {sDate}",
            workSchedule: "{name} est le calendrier de travail entre {sDate} - {eDate}",
            calendar: "Calendrier",
            noRating: "Il n'y a pas de note à montrer",
            rateDist: "Distribution des taux",
            distConversation: "Distribution des discours par les représentants",
            distributionConversa: "Répartition des scores",
            distChatbotAgent: "Canaux de communication",
            distAgent: "Chatbot & Agent",
            distFugitive: "Discours manqué et discours reçu",
            distLive: "Chat en direct",
            distChatbot: "Chatbot",
            distComplex: "Chatbot & Chat en direct",
            distHandled: "Chat répondu",
            distMissed: "chat sans réponse",
            distWeb: "Site Internet",
            distWhatsapp: "Whatsapp",
            distTelegram: "Telegram",
            distInstagram: "Instagram",
            totalWhatsappChatCount: "Nombre de chat WhatsApp",
            statsByTime: "Nombre de discussions par temps",
            selectRep: "Sélectionnez un représentant",
            allRepresentatives: "Tous les représentants",
            avgRating: "Score de notation ({point}) ({count} note)",
            avgFirstMessageTime: "Temps de réponse moyen",
            totalBreakTime: "Temps de pause du système",
            totalBreakNum: "Dénombrement",
            averageConTime: "Temps de conversation moyen",
            multiWpReportTitle: "Nombre de conversations multi-Whatsapp",
            multiWpReport: "Nombre de discussions WhatsApp multiples",
            multiWpReportExplanation: "Vous pouvez voir le montant des discussions de vos chaînes  Whatsapp.",
            longestConTime: "Temps de conversation le plus long",
            shortestConTime: "Temps de conversation le plus court",
            refresh: "Rafraîchir",
            waitingReply: "Messages en attente",
            organizationName: "nom de l'organisation",
            companySlogan: "Nom long de l'organisation",
            messageSentErr: "Message non envoyez, réessayez.",
            messageSent: "Message envoyé.",
            openPrivateChat: "Chat représentatif ouvert",
            escKey: "Cache une conversation active",
            archiveChatKey: "Vous permet de rejoindre le chat en bas de la page d'archivage.",
            chatCopilot: "Active Chat CoPilot",
            privateChat: "Panneau de conversation inter-agents",
            multiModeAlertDesc:
                'Le Supsis est ouvert dans une autre fenêtre. Cliquez sur "Utiliser ici" pour utiliser le Supsis dans cette fenêtre.',
            useHereText: "Utiliser ici",
            brandVisibility: "La marque de marque de Supsis apparaît sur la bulle de chat",
            focusInput: "Focus Cursor Active Chat Cntary Field",
            send: "Envoyer",
            notYet: "Pas encore",
            sending: "Envoi en cours",
            onlyRepresentative: "Votre message ne peut voir que par des représentants",
            yourMessage: "Votre message",
            liveFabListDescription: "Support en direct",
            messengerIntegrationDesc:
                "Discutez avec vos clients via la page Facebook, envoyez des messages automatisés avec le chatbot.",
            checkDepartmentToAgent: "Vérifier le département pour l'agent en ligne",
            ifAllOfflineStory: "Histoire à diriger si tous hors ligne",
            AssignMessagesToAgents: "Attribuer tous les messages aux agents",
            firstChatbotAndAssign: "D'abord, le Chatbot répond, puis il est assigné à un agent",
            hybridAssign:
                "Le système vérifie le département pour voir s'il y a un agent en ligne, et s'il n'y a pas d'agent en ligne, il l'assigne au chatbot.",
            ticketFabListDescription: "Billet",
            whatsappFabListDescription: "Whatsapp",
            phoneFabListDescription: "Téléphone",
            emailFabListDescription: "E-mail",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Twitter",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "Youtube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "Tapez votre lien de canal {channelLink} dans ce champ.",
            typeYourAccountLink: "Tapez votre lien de compte {accountLink} dans ce champ.",
            typeYourMessage: "tapez votre message ici",
            typeYourMessageMail:
                "Le message entré dans ce champ sera envoyé par le client à l'adresse courante ci-dessus comme premier message.",
            typeYourMessageDesc:
                "Le message entré dans ce champ sera envoyé par le client au numéro de téléphone ci-dessus comme premier message.",
            sendNumber: "Numéro de téléphone pour envoyer le message à: {path}",
            callNumber: "Numéro de téléphone que votre client peut appeler: {phoneNumber}",
            numberIsNotCorrect: "Numéro manquant entré !!",
            emailIsNotCorrect: "Le courriel n'est pas correct!",
            selectFab: "Sélectionnez un fabuleux",
            notValid:
                "Vous ne pouvez entrer que des lettres. (Caractère unique) .e, d, f, z, a, x, c, v, w, t, n les lettres ne sont pas valides",
            forMacUsers: "Les utilisateurs de Mac peuvent utiliser le raccourci de contrôle (⌃)",
            basePriceValue: "Prix ​​de base",
            basePriceDiscount: "Rabais",
            basePriceCurrency: "Monnaie",
            customerDBEnabled: "Sélection de la base de données: utilisez le serveur de base de données client",
            customerDBDisabled: "Sélection de la base de données: Utilisez le serveur de base de données Supsis",
            mongoConnectionString: "Connexion Mongo",
            whatsappBasePriceValue: "Prix ​​de base WhatsApp",
            whatsappPlusBasePriceValue: "Prix ​​de base WhatsApp Plus",
            instagramBasePriceValue: "Prix ​​de base Instagram",
            instagramPlusBasePriceValue: "Instagram plus prix de base",
            clientAddress: "Adresse du client",
            customerClientAddress: "Adresse client client",
            apiAddress: "Adresse API",
            socketAddress: "Adresse à la douille",
            backendAddress: "adresse backend",
            panelLogoUrl: "URL du logo du panneau",
            panelCustomCssUrl: "URL CSS personnalisée du panneau personnalisé",
            customerLogoUrl: "URL du logo client",
            customerCssUrl: "URL du client CSS",
            siteAlias: "Alias ​​du site",
            language: "Langue",
            features: "Caractéristiques",
            interactionPopularity: "Popularité des interactions",
            interactionCount: "Nombre d'interactions",
            uniqueUserCount: "Nombre d'utilisateurs uniques",
            allUserPercentage: "(%) Pourcentage de tous les utilisateurs",
            represantativeSettings: "Paramètres représentatifs",
            documentTitle: "Formulaire de document Supsis",
            supsisDocument: "Document Supsis",
            ApiDoc: "Documentation de l'API",
            chatBalloonTehemeSettings: "Ballon de chat et paramètres de thème",
            customLoginFormSettingsTitle: "Personnaliser le formulaire de connexion des visiteurs",
            addNewField: "Ajouter un nouveau champ",
            editField: "Champ de modification",
            typeHere: "Tapez le contenu ici!",
            pco: "Cur",
            perPage: "/page",
            perPageInFilter: "Morceau",
            noUserInfoFound: "Aucune information sur l'utilisateur n'a été trouvée",
            startFilter: "Démarrer le filtre",
            showMyChats: "Montrez mes chats",
            showOnlineAgents: "Afficher uniquement les agents en ligne",
            showWaitingChats: "Afficher les chats d'attente",
            addNewStatus: "ajouter un statut",
            newTitleContent: "Nouveau titre",
            newCTRLContent: "Nouveau contenu CTRL",
            newALTContent: "Nouveau contenu alt",
            newTABContent: "Nouveau contenu d'onglet",
            roleName: "Nom de rôle",
            error: "Erreur",
            contentTitle: "Titre de contenu",
            contentType: "Type de contenu",
            cannotMoveFullParent: "Impossible de déplacer cet élément",
            newSiteForm: "Nouveau formulaire de registre de site",
            updateSiteForm: "Formulaire de mise à jour du site",
            newBannedWordForm: "Nouveau formulaire de registre de mots interdits",
            updateBannedWordForm: "Formulaire de mise à jour des mots interdits",
            newWelcomeMessageForm: "Nouveau formulaire de registre de messages de bienvenue",
            updateWelcomeMessageForm: "Formulaire de mise à jour du message système",
            newDefaultContentForm: "Nouveau formulaire de registre de contenu par défaut",
            updateDefaultContentForm: "Formulaire de mise à jour de contenu par défaut",
            newSubjectForm: "Nouveau formulaire de registre des sujets",
            updateSubjectForm: "Formulaire de mise à jour du sujet",
            showChatColorMeaning: "Couleurs de chat",
            showIntro: "Montrer l'intro",
            options: "Options",
            resetPassword: "réinitialiser le mot de passe",
            audioLevel: "Volume d'alerte audio",
            privateChatNotificationSound: "Son de notification",
            continue: "Continuer",
            newRoleForm: "Nouveau formulaire de registre des rôles",
            updateRoleForm: "Formulaire de mise à jour des rôles",
            newRolePlaceHolder: "Cliquez sur un nouveau rôle",
            newUserForm: "Nouveau formulaire de registre d'utilisateurs",
            updateUserForm: "Formulaire de mise à jour de l'utilisateur",
            changeOSRForm: "Message de changement hors ligne",
            tooltipOSRForm: "Vous pouvez modifier le message hors ligne.",
            newOSRForm: "Formulaire de support hors ligne",
            newOSRMessages: "Ajouter un message hors ligne",
            updateOSRForm: "Formulaire de mise à jour hors ligne",
            osrTitle: "Titre",
            osrTitleDescription: "Vous pouvez ajouter le titre de formulaire de support hors ligne",
            osrContent: "Contenu",
            osrContentDescription: "Vous pouvez ajouter du contenu de formulaire de support hors ligne",
            hello: "Bonjour le monde",
            date: "Date",
            startDate: "Date de début",
            finish: "Finir",
            start: "Commencer",
            search: "Recherche",
            endDate: "Date de fin",
            representative: "Représentants",
            representative_: "Représentant",
            star: "Étoile",
            filter: "FILTRE",
            reset: "RÉINITIALISER",
            dailyChatList: "Liste de discussion quotidienne",
            dailyChatDuration: "Durée quotidienne du chat",
            chatDuration: "Durée du chat",
            dailyChatGraph: "graphique de chat quotidien",
            ok: "D'ACCORD",
            cancel: "Annuler",
            chatCount: "Nombre de discussions",
            shortest: "Le plus court",
            longest: "Le plus long",
            average: "Moyenne",
            count: "Compter",
            averagePoint: "Point moyen",
            pointDist: "Répartition des points",
            point: "Indiquer",
            filters: "Filtres",
            totalCustomer: "Client total",
            avResponseTime: "Temps de réponse moyen",
            breakDuration: "Durée de rupture",
            breakCount: "Dénombrement",
            lastLoginPlatform: "Plateforme",
            active: "Actif",
            passive: "Passif",
            userForm: "Formulaire utilisateur",
            sender: "Expéditeur",
            profile: "Profil",
            name: "Nom",
            number: "Nombre",
            username: "Nom d'utilisateur",
            email: "E-mail",
            password: "Mot de passe",
            oldPassword: "ancien mot de passe",
            newPassword: "nouveau mot de passe",
            passwordAtLeast: "Mot de passe (au moins {num} caractères)",
            passwordRepeat: "Répéter le mot de passe",
            changePassword: "Changer le mot de passe",
            status: "Statut",
            enableState: "Actif?",
            douYouWishToDeleteUser: "DOU Vous souhaitez supprimer cet utilisateur?",
            userDeleted: "Supprimé par l'utilisateur",
            userSaved: "Utilisateur enregistré.",
            oldPasswordError: "L'ancien mot de passe est incorrect, veuillez vérifier.",
            chooseAnOption: "Veuillez sélectionner un son de notification.",
            userVolumeUpdated: "Paramètres de volume mis à jour.",
            save: "Sauvegarder",
            update: "Mise à jour",
            addNewMenu: "Ajouter un nouveau menu",
            addNewContent: "Ajouter un nouveau contenu",
            pleaseTitleEnter: "S'il vous plaît titre entrez",
            like: "Comme",
            disLike: "Ne pas aimer",
            users: "Utilisateurs",
            visitor: "Visiteurs",
            allContacts: "Tous les contacts",
            allUsers: "Tous les représentants",
            allSites: "Tous les domaines",
            newUser: "Nouvel utilisateur",
            noNewUser: "Il n'y a pas encore d'utilisateur.",
            noNewAdminUser: "Il n'y a pas encore d'utilisateur administrateur.",
            noRoleFound: "Il n'y a pas encore de rôle.",
            noBannedWordFound: "Il n'y a pas encore de mot interdit.",
            noWelcomeMessageFound: "Il n'y a pas encore de message système.",
            noSubjectFound: "Il n'y a pas encore de sujet.",
            noVisitorFound: "Il n'y a pas de visiteur.",
            noContactFound: "Il n'y a pas de contact.",
            sendResponse: "Écrire une réponse",
            delete: "Supprimer",
            noLiveSupportFound: "Il n'y a pas de visiteur connecté au support en direct",
            noLiveSupportFoundWithDepartment: "Il n'y a pas de discours appartenant au département",
            duplicate: "Dupliquer",
            makeDefault: "Faire défaut",
            checkMore: "Vérifiez plus",
            useReadyTemplates: "Utilisez des modèles prêts",
            noRePresentativeFound: "Il n'y a pas de représentant",
            noBannedVisitorFound: "Il n'y a pas encore de visiteur interdit.",
            removeBanDescription: "Supprimer l'interdiction",
            editThisItem: "Mettre à jour cet article",
            removeThisItem: "enlever cet article",
            role: "Rôle",
            autoChatAssignLimit: "Limite d'attribution de chat automatique",
            chatAssignInfo: "-1 = par défaut du système, 0 = pas d'attribution,> 0 = Assignez la valeur donnée.",
            relatedDepartments: "Départements connexes",
            subjectInfo: "S'il n'y a pas de sujet sélectionné, tous les sujets sont autorisés.",
            archive: "Archive",
            offlineSupportRequests: "Supports hors ligne",
            first: "D'abord",
            last: "Dernier",
            query: "Commencez à rechercher",
            clean: "Faire le ménage",
            loading: "Chargement",
            loadMore: "Charger plus",
            noMessage: "N'est aucun message",
            selectChat: "Choisir une conversation",
            noMessageInChat: "Il n'y a pas de message dans ce chat",
            noMediaToShow: "Pas de médias à montrer",
            firstSeen: "Première apparition",
            userInfo: "informations utilisateur",
            chatId: "Identifiant de chat",
            visitorId: "ID du visiteur",
            visitingPage: "Page de visite",
            osAndBrowser: "Système d'exploitation et navigateur",
            customerClientVersion: "Version client client",
            visitorFeedback: "Rétroaction des visiteurs",
            notes: "Notes",
            nameSurname: "Prénom / nom de famille",
            chats: "Chats",
            bannedVisitors: "Visiteurs interdits",
            country: "Pays",
            city: "Ville",
            cityDistrict: "District de la ville",
            browser: "Navigateur",
            os: "Système opérateur",
            ipAddress: "Adresse IP",
            connectionDate: "Date de connexion",
            transaction: "Transaction",
            banRemoved: "Interdiction supprimée.",
            bannedWords: "Mots interdits",
            newBannedWord: "Nouveau mot interdit",
            noBannedWord: "Pas encore de mot interdit.",
            bannedWordForm: "Formulaire de travail interdit",
            word: "Mot",
            bannedWordAndWordGroup: "Groupe de mots / travail interdits",
            doYouWishToDeleteBannedWord: "Dou Vous souhaitez vraiment supprimer ce mot interdit?",
            doYouWishToOfflineSupportRequest: "DOU, vous souhaitez vraiment supprimer ce message?",
            bannedWordSaved: "Mot interdit enregistré",
            deletedSuccessfully: "Supprimé avec succès",
            deleteErrorMsg: "Erreur: ce n'est pas supprimé, réessayez",
            socketError: "Erreur de connexion à socket. Veuillez actualiser la page et réessayer.",
            socketConnecting: "Connexion au serveur",
            offlineModeDescription: "Système Down, les clients ne pourront pas accéder à l'assistance en direct.",
            offlineModeSettingsDescription: "Vérifiez la fonction de mode hors ligne dans le menu Paramètres.",
            offlineModeUser: "Il doit y avoir au moins un représentant en ligne dans le système.",
            offlineModeMessage: "Message hors ligne",
            offlineMode: "Mode hors-ligne",
            adminCannotConnectSocket: "L'administrateur ne peut pas se connecter à la prise.",
            liveSupport: "Support en direct",
            siteVisitors: "Visiteurs du site",
            visitors: "Visiteurs",
            thoseConnectedToLiveSupport: "Ceux qui se sont connectés au soutien en direct",
            visitorHistory: "Histoire des visiteurs",
            visitorHistoryDescription:
                "Vous pouvez afficher et télécharger l'historique des discussions des visiteurs.",
            privateMessage: "Message privé",
            addRepresentative: "Ajouter un représentant",
            forwardRepresentative: "Représentant à terme",
            keyboardShortcuts: "Raccourcis clavier",
            chatColorMeanings: "Significations de couleur de chat",
            connLostCheckInternet: "Connexion perdue, veuillez vérifier votre connexion Internet.",
            wishToEndThisChat: "Dou Vous souhaitez terminer ce chat?",
            defaultContents: "Contenu par défaut",
            contents: "Contenu",
            newDefaultContent: "Nouveau contenu par défaut",
            title: "Titre",
            shortcutChar: "Caractère de raccourci",
            pickOne: "En choisir un",
            writeSomething: "Écrivez un personnage (A-Z | 0-9)",
            letterSequence: "Séquence de lettres",
            exampleText: "Exemple: SOC -> Soccer",
            anyChar: "N'importe quel caractère",
            shorcutKey: "Touche de raccourci",
            content: "Contenu",
            shortcutName: "Nom de raccourci",
            type: "Taper",
            shortcut: "Raccourci",
            defaultContentForm: "Formulaire de contenu par défaut",
            deleteContentQuestion: "Souhaitez-vous vraiment supprimer ce contenu par défaut?",
            defaultContentDeleted: "Contenu par défaut supprimé",
            defaultContentSaved: "Contenu par défaut enregistré.",
            contentMoved: "Le contenu déplacé.",
            yourEmail: "Adresse e-mail",
            yourName: "Votre nom et prénom",
            login: "Connexion",
            lostPassword: "Mot de passe oublié",
            multipleSession: "Vous êtes signé ailleurs.",
            notAuthorizedToDisplayPage: "Vous n'êtes pas autorisé à voir cette page!",
            permissions: "Autorisation",
            newPermission: "Nouvelle autorisation",
            permissionForm: "Formulaire d'autorisation",
            displayTitle: "Titre d'affichage",
            key: "Clé",
            keyToUseInSystem: "Valeur clé à utiliser dans le système",
            deletePermissionQuestion: "Souhaitez-vous vraiment supprimer cette autorisation?",
            permissionDeleted: "Autorisation supprimée.",
            permissionSaved: "Autorisation enregistrée.",
            newRole: "Nouveau rôle",
            selectARole: "Sélectionnez un rôle",
            yes: "Oui",
            no: "Non",
            fullAuth: "Autorisation complète",
            roleDeleted: "Rôle supprimé.",
            roleSaved: "Rôle sauvé.",
            roleForm: "Formulaire de rôle",
            roles: "Les rôles",
            settings: "Paramètres",
            selectTopic: "Département de sélection",
            autoCallTransfer: "Transfert d'appel automatique",
            customerTyping: "Typage client",
            typing: "Dactylographie",
            agentTyping: "Typage représentatif",
            disconnectTime: "Temps de reconnexion maximum (SEC)",
            tippyDissconnectTime: "Lorsqu'un chat inactif après le nombre de secondes de la conversation se terminera.",
            queueNumberVisibleFeature: "Afficher le numéro d'attente au visiteur",
            privateChatEnabled: "Montrez le chat entre les représentants",
            delayedTalkTime: "Temps de retard (SEC)",
            employeeAverageChatCount: "Numéro de chat moyen pour le taux de chat des employés",
            customerDownTimeWhenRepExit: "Temps d'arrêt du client lorsque le représentant part (Sn.)",
            autoAssignLimit: "Limite d'attribution automatique",
            wasted: "Conversation Lost Time (SEC)",
            settingFormWrong: "Les données du formulaire sont erronées, réessayez après la vérification",
            settingsSaved: "Paramètres sauvegardés.",
            settingsCannotSaved: "Les paramètres ne peuvent pas être enregistrés",
            noAuthorization: "Pas d'autorisation",
            warningBadInput: "Il est recommandé d'entrer un nombre entre 0 et 70.",
            warning: "AVERTISSEMENT!",
            warningBadInputMarginY: "AVERTISSEMENT DES ENTRÉE DE LA MARGIE VERTIQUE ⚠️",
            warningBadInputMarginX: "AVERTISSEMENT de l'entrée de la marge horizontale ⚠️",
            warningBadInputBubbleSize: "AVERTISSEMENT D'ENTRÉE DE BUBLE DE CHAT ⚠️",
            delayTime: "Temps de retard (SEC)",
            sites: "Des sites",
            newSite: "Nouveau site",
            noSiteYet: "Il n'y a pas encore de site.",
            siteAddress: "Adresse du site",
            turnBack: "Retourner",
            customerRepLimit: "Limite de représentant client",
            siteSaved: "Site enregistré.",
            siteSaveError: "Une erreur s'est produite lors de la création du site",
            subjects: "Sujets",
            newSubject: "Nouveau sujet",
            noSubject: "Aucun sujet encore.",
            subject: "Sujet",
            subjectTitle: "Titre du sujet",
            description: "Description",
            infoAboutSubject: "Informations sur le sujet",
            deleteSubjectQuestion: "Souhaitez-vous vraiment supprimer ce sujet?",
            subjectDeleted: "Sujet supprimé.",
            subjectSaved: "Sujet sauvé.",
            welcomeMessages: "Messages système",
            newWelcomeMessages: "Nouveau message de bienvenue",
            noWelcomeMessage: "Pas de message système.",
            welcomeMessageContent: "Contenu du message système",
            makeChoice: "Fais un choix...",
            welcomeMessage: "Message de bienvenue",
            repLoggedIn: "Représentant connecté",
            loginMessage: "Se connecter",
            message: "Message",
            deleteWelcomeMessageQuestion: "Souhaitez-vous vraiment supprimer ce message système?",
            welcomeMessageDeleted: "Message système supprimé",
            welcomeMessageSaved: "Message système enregistré.",
            welcomeMessageForm: "Formulaire de message système",
            noRep: "Il n'y a pas encore de représentant.",
            addChat: "Ajouter le chat",
            forwardChat: "Chat avant",
            ago: "il y a",
            repName: "Nom représentatif",
            lastOnline: "Dernière connexion / heure en ligne",
            lastStatusChange: "Dernier changement de statut",
            activeChat: "Chat actif",
            userMaxCapacity: "Capacité de chat maximale",
            noActiveChat: "Pas de chat actif",
            watch: "MONTRE",
            join: "REJOINDRE",
            open: "Conversation ouverte",
            directMessage: "MESSAGE PRIVÉ",
            block: "BLOC",
            transactions: "Transactions",
            informations: "Informations",
            visitStart: "Visiter Start",
            fullName: "Nom et prénom",
            waitChatTime: "Temps d'attente / chat",
            blockUserConfirm: "Voulez-vous bloquer cet utilisateur?",
            messaging: "Messagerie",
            hideChat: "Cacher le chat",
            block_: "Bloc",
            privateMessage_: "Message privé",
            assignRep: "Affecter un représentant",
            joinChat: "Rejoindre le chat",
            forwardRep: "Avant",
            leaveChat: "Laisser la discussion",
            endChat: "Chat fin",
            translatedTextDescription: "Amazon a traduit ce message {from} -> {to}.",
            autoTranslate: "Traduire automatiquement",
            translateThisMessage: "Traduire ce message",
            autoTranslateDetectedDesc:
                "La langue des visiteurs est {visitorLanguage}. Cliquez ici pour activer la traduction automatique",
            on: "sur",
            off: "désactivé",
            copy: "Copie",
            prevChats: "Chats précédents",
            noShortCut: "Pas de raccourci",
            leaveChartConfirm: "Dou, vous souhaitez vraiment quitter le chat?",
            endChatConfirm: "Dou Vous souhaitez terminer le chat?",
            endConversation: "Conversation de fin",
            onlyOneRep: "Vous êtes le seul représentant de cette conversation!",
            chatList: "Liste de discussion",
            chatBar: "Barre de discussion",
            unreadTitle: "Non lu",
            visitorLeftTitle: "Visiteur à gauche",
            activeChatTitle: "Chat actif",
            autoAssignedTitle: "Chat attribué automatiquement",
            watchModeTitle: "Mode de surveillance",
            lostChat: "Connexion représentative perdue",
            chatWidthDelay: "Discuter avec retard",
            repChatWidthDelay:
                "Lorsqu'il n'y a pas de représentant actif dans le système ou tous nos représentants en raison du trafic élevé, les antécédents de chat seront verts",
            repLostConn: "Si le représentant du client a perdu la connexion, le fond de chat sera rose.",
            unreadMsg: "S'il y a des messages non lus, l'arrière-plan sera bleu clair.",
            visitorLeftChat: "Si le visiteur a quitté la conversation, le fond devient gris foncé.",
            activeChatMsg: "Le fond est vert si le chat est actif",
            autoAssignMsg:
                "L'arrière-plan devient de la moutarde s'il est attribué par affectation automatique et la conversation n'est pas examinée plus loin",
            watchModeMsg: "S'il est allumé en mode de lecture, l'arrière-plan devient rouge",
            online: "En ligne",
            beRightBack: "Loin",
            away: "Loin",
            busy: "Occupé",
            offline: "Hors ligne",
            logout: "Se déconnecter",
            forWindows: "Pour les fenêtres",
            forMac: "Pour Mac",
            nextChatFromActive: "Passer de la conversation active à la prochaine conversation",
            previousChatFromActive: "Passer de l'actif à la précédente",
            hideActiveChat: "Cacher une conversation active",
            closeActiveChat: "Fermer une conversation active",
            firsthiddenChat: "Rejoignez la plupart du chat des clients attendu",
            firstChatWaiting: "Passer à la conversation en attente",
            previousOpenedChat: "Quelle que soit l'ordre, passez à la conversation précédemment ouverte",
            historyDetails: "Détails de l'histoire",
            chat: "Discuter",
            chatNotFound: "Aucun discours trouvé.",
            dataNotFound: "Données introuvables.",
            visitorInfo: "Informations sur les visiteurs",
            timeSpent: "Temps passé",
            noActiveVisitors: "Pas de visiteurs actifs",
            totalConnected: "Nombre de conversations",
            missedChat: "Compte de chat manqué",
            workTime: "Temps de travail",
            closedChatCount: "Chat fermé",
            activeConvo: "Conversation active",
            notAnswered: "Pas encore répondu",
            delayedConvo: "Retardé",
            leavingRep: "Quitter le représentant",
            staffRate: "Taux de travail du personnel",
            select: "Menu déroulant",
            fullname: "Nom et prénom",
            text: "Texte",
            numeric: "Nombre",
            phone: "Téléphone",
            optionsPlaceholder: "Valeur d'option",
            selectField: "Cliquez si vous souhaitez ajouter un menu déroulant",
            fullnameField: "Cliquez si vous souhaitez ajouter un champ de nom complet.",
            textField: "Cliquez si vous souhaitez ajouter un champ de texte.",
            labelField: "Cliquez si vous souhaitez ajouter un champ de description.",
            numericField: "Cliquez si vous souhaitez ajouter un champ numérique.",
            phoneField: "Cliquez si vous souhaitez ajouter un champ téléphonique.",
            departmentField: "Cliquez si vous souhaitez ajouter un champ de département.",
            emailField: "Cliquez si vous souhaitez ajouter un champ de messagerie.",
            visible: "Visible",
            required: "Requis",
            label: "Commentaire",
            customLoginAlert: "Votre formulaire de connexion doit contenir le moins d'un champ visible.",
            atLeastOneLanguage: "Vous devez ressentir au moins une langue",
            requiredFieldField: "Ce champ est obligatoire",
            notRequiredField: "Ce champ n'est pas requis",
            visibleField: "Ce champ est visible",
            notVisibleField: "Ce champ n'apparaît pas sous la forme.",
            connectServer: "Vous êtes connecté au serveur",
            disconnectServer: "Vous n'êtes pas connecté au serveur",
            liveChatOff: "Le chat en direct est désactivé",
            visitorScreen: "Écran de visiteur",
            viewOnTheSite: "Afficher sur la page",
            viewOnTheSiteTippy: "Cliquez ici pour voir comment vos modifications restent.",
            showHint: "Dévoiler un indice",
            dontShowHint: "Ne montrez pas indice",
            liveChatOn: "Le chat en direct est sur",
            nightModeOff: "Mode nocturne éteint",
            doubleClickEdit: "Double-cliquez ou appuyez sur le bouton Modifier pour modifier.",
            edit: "Modifier",
            deleteField: "Supprimer",
            arrow_upward: "Flèche vers le haut",
            arrow_downward: "Flèche vers le bas",
            newCatalogCategory: "Nouvelle catégorie de catalogue",
            childCreate: "Double-cliquez pour créer un nouvel enfant",
            updateCatalogCategoryFrom: "Mettre à jour le formulaire de catégorie de catalogue",
            newCatalogCategoryFrom: "Nouveau formulaire de catégorie de catalogue",
            catalogCategoryMenu: "Ajouter le menu de catégorie de catalogue",
            catalogCategoryLeaf: "Ajouter un sous-menu de catégorie de catalogue",
            catalogCategoryName: "Nom de la catégorie de catalogue",
            newCatalogContentFrom: "Nouveau formulaire de contenu de catalogue",
            catalogContentName: "Nom du contenu du catalogue",
            catalogCategorySaved: "Catégorie de catalogue enregistré",
            catalogCategoryDeleted: "Catégorie de catalogue supprimé",
            catalogCategoryRate: "Taux de contenu",
            catalogContentFeature: "Fonction de contenu de catalogue",
            vtipyAudioLevel: "Utilisé pour les sons de notification muets ou réactiles.",
            vtipyOrganizationName: "Vous pouvez modifier le nom de l'organisation et le mettre à jour.",
            vtipyBrandVisibility: "Le Supsis est le paramètre si la balise peut être affichée dans la bulle de chat.",
            vtipyBrandVisibilityForced: "Seuls les utilisateurs de Proplan peuvent changer !!",
            vtipyClientDefault: "Vous pouvez modifier la langue de la page de l'agent ici.",
            vtipyCustomerClientDefault: "Vous pouvez modifier ici la langue de la page Client (CHAT).",
            vtipyVisitorPreferredLang: "Le client peut sélectionner la langue parlée sur la page (CHAT).",
            vtipyCustomerClientLanguageDetect: "Vous pouvez modifier ici la langue de la page Client (CHAT).",
            vtipySelectTopic:
                "Des affectations automatiques aux représentants existants du département sélectionné se produisent.",
            vtipyAutoCallTransfer: "Attribue automatiquement les appels en attente aux agents disponibles.",
            vtipyCustomerTyping:
                "Il vous permet de voir ce que le client a écrit sur l'écran de chat sur l'écran de chat représentatif.",
            vtipyAgentTyping:
                "Il donne des informations lorsque vous êtes représentatif tapant au client dans le chat buble",
            vtipyQueueNumberVisibleFeature:
                "Lorsque les représentants sont occupés, cela montre aux clients qui souhaitent se connecter, dans quel ordre ils sont.",
            vtipyPrivateChatEnabled: "Montre le panneau de conversation inter-agent.",
            vtipyDelayedTalkTime:
                "Si aucun délégué n'est connecté à la conversation pendant cette période, il sera étiqueté \\ \"Chat retardé \\",
            vtipyOfflineMode: "Vous permet de mettre le système en mode hors ligne.",
            vtipyAutoAssignLimit:
                "Il détermine le nombre de clients (CHAT) sera affecté automatiquement au représentant.",
            vtipyCustomerDownTimeWhenRepExit: "Temps de ralenti du client lorsque le représentant sort (Sec.)",
            tippyDisconnectTime: "Le temps de fermeture du chat après avoir déconnecté le client (SEC).",
            changeSettings: "Modifier les paramètres globaux",
            totalBg: "discussions totales",
            activeBg: "discussions actives",
            watchBg: "MONTRE",
            waitingBg: "Discussions En Attente",
            lateBg: "Conversations Passagères",
            freeBg: "GRATUIT",
            maxCapacityBg: "CAPACITÉ MAXIMALE",
            addNewSettings: "Ajouter un nouveau paramètre global",
            darkMode: "Mode sombre",
            clientDefault: "Langue par défaut du panneau",
            customerClientDefault: "Client la langue par défaut du client",
            customerClientLanguageDetect: "Détection automatique de la langue du client client",
            visitorPreferredLang: "Laissez le client choisir la langue parlée",
            preferredThemeColor: "Couleur du thème préféré pour l'écran de chat client",
            detail: "Détail",
            supportUs: "Contactez-nous (support en direct)",
            langSetting: "Paramètres de langue",
            changeLang: "Changer de langue",
            fontSizeSetting: "Paramètre de zoom d'écran",
            changeLangDesc: "Modifie le langage de l'application en {code}",
            trLang: "turc",
            enLang: "Anglais",
            fieldRequired: "{field} champ est requis",
            selectALanguage: "Sélectionnez une langue",
            selectATheme: "Sélectionnez un thème",
            responseForm: "Formulaire de réponse",
            clientRequestInfo: "Informations sur la demande du client",
            createdDate: "Date de création",
            descMessage: "messages",
            new: "Nouveau",
            selectAllPermission: "Tout sélectionner",
            catalogCategories: "Catalogue",
            copiedClipboard: "Copié dans le presse-papier",
            changeLogo: "Changer le logo",
            changePhoto: "Changer de photo",
            addPhoto: "Ajouter une photo",
            seePhoto: "Voir la photo",
            deletePhoto: "Supprimer la photo",
            organizationLogo: "Logo de l'organisation",
            changePlan: "Plan de changement",
            close: "Fermer",
            vtipyUploadLogo:
                "En téléchargeant le logo de votre entreprise de ce domaine, vous pouvez utiliser votre propre logo dans les e-mails clients et les pages clients.",
            tagName: "Nom de la balise",
            tagDescription: "Libellé Description",
            tagColor: "Couleur de l'étiquette",
            userInformations: "informations de l'utilisateur",
            incomingChat: "Chat entrant",
            support: "Soutien",
            team: "Ensemble",
            groups: "Groupes",
            newConversationStarted: "Une nouvelle conversation a commencé",
            allHistoryLoaded: "Tout l'historique téléchargé",
            chatCreator: "Créateur de chat",
            enterGroupTitle: "Entrez le titre du groupe",
            requiredTitle: "Vous ne pouvez pas laisser le champ de titre vide",
            requiredChannel: "Le nom du canal ne peut pas être vide",
            next: "Confirmer",
            selectPeople: "Sélectionnez les personnes",
            textLimitAlertMessage:
                "La limite de caractères dans WhatsApp est de 19 caractères et au-delà de cette limite, il ne sera pas affiché. Or, sur le web, les textes dépassant la limite de 19 caractères sont automatiquement déplacés vers la ligne suivante et affichés.",
        },
        "No money will be withdrawn from your account": {
            "": "#VALUE!",
        },
        "At the end of the month, an invoice will be created according to your usage amount": {
            "": "#VALUE!",
        },
        "{contentOfChatBubble}": "#VALUE!",
        telegram: {
            typeInTelegramToken: "Tapez en jeton de télégramme",
            token: "Jeton",
            telegramTokenTitle: "Intégration de Telegram Supsis",
            telegramAlertForm: "Vous pouvez obtenir le jeton de bot Telegram à partir de",
            telegramAlertTitle: "Voulez-vous vraiment supprimer le jeton?",
            telegramAlertText: "Le jeton sera définitivement perdu!",
        },
        wp: {
            chatStarted: "Le chat a commencé",
            chatNotStarted: "Le chat n'est pas commencé",
            contactSelected: "Contact sélectionné",
            startChatWithAnyNo: "Commencez à discuter avec n'importe quel numéro",
            toLittleChar: "Numéro manquant !",
            typeInANumberDesc: "Tapez le nombre pour commencer à discuter avec:",
            wpPlusAndLicenceRequired: "Plan WhatsApp Plus et licence requise.",
            wpPlusAndLicenceRequiredDesc:
                "Avant de pouvoir commencer des chats avec des numéros qui ne sont pas enregistrés dans vos contacts, vous devez mettre à niveau votre plan WhatsApp et obtenir une licence.",
            chatStartingWait: "Conversation commençant, veuillez attendre",
            whatsapp: "Whatsapp",
            agreement: "Accord",
            purchase: "Achat",
            activating: "Activation du service WhatsApp",
            authenticating: "Authentification du code QR",
            ready: "Prêt",
            enableFeature: "Activer la fonction WhatsApp",
            readAndAgree: "J'ai lu et accepté",
            subscribe: "S'abonner",
            subscribed: "Souscrit",
            toEnableWpDescription: "Pour activer les fonctionnalités WhatsApp, cliquez sur le bouton ci-dessous.",
            waitForWpActivationDescription:
                "Votre service de compte WhatsApp s'active. S'il te plaît attend un moment. Il faut environ 10 à 30 secondes.",
            greatWpActivatedDescription: "Super, votre service de compte WhatsApp est activé!",
            unsubscribe: "Se désabonner",
            planDetails: "Caractéristiques",
            sendReceiveMessage: "Envoyer et recevoir des SMS",
            sendReceiveImage: "Envoyer et recevoir des fichiers d'image",
            sendReceiveAudio: "Envoyer et recevoir des fichiers audio",
            sendReceiveGif: "Envoyer et recevoir des fichiers GIF",
            startChat: "Commencez à discuter sur le Supsis",
            supsisFunctionality: "Fonctionnalité de chat en supsis utile",
            onePhoneMultiAgent: "Un téléphone et plusieurs agents",
            basicIntegration: "Intégration de base et configuration zéro",
            activationTitle: "Pour activer l'intégration WhatsApp sur le Supsis:",
            wpIntegrationInstruction1: "Ouvrez WhatsApp sur votre téléphone",
            wpIntegrationInstruction2: "Appuyez sur le menu ou paramètres. Cliquez sur les appareils liés",
            wpIntegrationInstruction3: "Pointez votre téléphone vers cet écran pour capturer le code",
            qrGeneratingWait: "Code QR Génération Veuillez vous attendre ...",
            pleaseContinueToWaitUntilCompleted:
                "Une fois le code QR vérifié, il passera automatiquement au champ terminé. S'il vous plaît, attendez...",
            authenticatingWait: "Authentification, veuillez attendre ...",
            unsubscribeWpInetgration: "Intégration de WhatsApp de désabonnement",
            unsubscribeIGIntegration: "Intégration Instagram de désabonnement",
            wpBack: "Dos",
            terminatelWpInetgration:
                "Lorsque vous cliquez sur le bouton «désinscrire», votre intégration WhatsApp se terminera",
            cancelWpInetgration: "Voulez-vous annuler l'intégration WhatsApp?",
            terminatelIGIntegration:
                "Lorsque vous cliquez sur le bouton «désinscrire», votre intégration Instagram se terminera",
            cancelIGIntegration: "Voulez-vous annuler l'intégration Instagram?",
            startChatWp: "Démarrer la discussion",
            purchaseHeader: "Achat d'intégration Supsis-WhatsApp",
            wpServices: "Service WhatsApp",
            wpServicesIntegrationCompleted:
                "Votre intégration WhatsApp est terminée. Vous pouvez maintenant utiliser le service.",
            purchasePaymentDescription:
                "Fonction de WhatsApp facturée de mois en mois. Votre service WhatsApp sera activé après avoir accepté l'abonnement.",
            wpIntegrationFeatures: "Fonctionnalités d'intégration WhatsApp",
            saveChanges: "Sauvegarder les modifications",
            contactList: "Liste de contacts",
            broadcast: {
                broadcast: "Diffuser",
                detail: "Détail de diffusion",
                customer: "Client",
                phoneNumbers: "Numéro de contact",
                showMore: "Montre plus",
                groupName: "Nom de groupe",
                messages: "messages",
                status: "Statut",
                usageCost: "Coût d'utilisation",
                sendingTime: "Temps d'envoi",
                progress: "Progrès",
                groupDetail: "Détails du groupe",
                messagesPerContact: "Messages par contact",
                successRatio: "Ratio de réussite",
            },
            messages: "messages",
            broadcastRequests: "Demandes de diffusion",
            customerGroups: "Groupes de clients",
            messageTemplates: "Modèles de messages",
            plans: "Des plans",
            wpIntegrationRequired: "L'intégration WhatsApp requise",
            wpRequiredIntegrationDescription:
                "Désolé, la page que vous avez visité sera activée lors de l'intégration de votre WhatsApp.",
            integrateWp: "Allons-y, intégrons WhatsApp",
            active: "Actif",
            archived: "Archivé",
            createBroadcastMessage: "Créer un message de diffusion",
            title: "Titre",
            description: "Description",
            createdAt: "Créé à",
            numbers: "Nombres",
            actions: "Actions",
            action: "Action",
            createCustomerGroup: "Créer un groupe de clients personnalisé",
            search: "Recherche",
            name: "NOM",
            contacts: "Contacts",
            noContactFound: "Aucun contact trouvé",
            broadcastTitle: "Donnez un titre à votre diffusion.",
            recipients: "Destinataire",
            selectRecipients: "Sélectionner les destinataires",
            writeYourMessage: "Écrivez votre message.",
            schedule: "Calendrier",
            scheduleNowOrLater: "Horaire maintenant ou plus tard",
            summary: "Résumé",
            cancel: "Annuler",
            send: "Envoyer",
            sending: "Envoi en cours",
            deleteCustomerGroup: "Êtes-vous sûr de supprimer ce groupe de clients? {name}",
            customerGroupDeleting: "Suppression du groupe de clients ...",
            customerGroupDeletingSuccess: "Groupe de clients supprimé avec succès",
            customerGroupDeletingError: "Erreur lors de la suppression du groupe de clients",
            wpPlusRequired: "Plan WhatsApp plus requis.",
            broadcastMessageArchived: "Message de diffusion comme archivé",
            broadcastMessageNotArchived: "Le message de diffusion n'est pas archivé",
            groupNameSearch: "Tapez le nom du groupe de clients",
            groupNameDesc: "Nom du groupe de clients Identifiez vos groupes de clients",
            save: "Sauvegarder",
            number: "NOMBRE",
            addColumn: "Ajouter la colonne",
            addColumnDesc: "Ajouter une colonne à la table",
            addNewContact: "Ajouter un nouveau contact",
            addNewContactDesc: "Ajouter un contact à la table",
            importFile: "Importer depuis le fichier",
            importFileDesc: "Importer des contacts à partir du fichier Excel ou CSV",
            contactAdded: "Contact ajouté",
            updateCustomerGroup: "Mise à jour du groupe de clients ...",
            updateCustomerGroupSuccess: "Groupe de clients mis à jour avec succès",
            sendBroadcastMessage: "Envoyer un message de diffusion",
            columnName: "Nom de colonne",
            columnType: "Type de colonne",
            defaultValue: "Valeur par défaut",
            setDefaultValue: "Définissez la valeur par défaut sur les contacts",
            age: "Âge",
            location: "Emplacement",
            gender: "Genre",
            selectContactFile: "Sélectionnez le fichier de contact",
            selectContactCsvOrExcel: "Sélectionnez un fichier CSV ou Excel.",
            importConfiguration: "Configuration d'importation",
            customizeFile: "Personnalisez votre configuration d'importation.",
            sendMessageTo: "À qui voulez-vous envoyer le message?",
            allContact: "Tous les contacts",
            messageTypes: "Types de messages",
            whenSendMessage: "Quand voulez-vous envoyer le message?",
            instantlyRightNow: "Instantanément maintenant",
            completed: "Complété",
            scheduleFuture: "Planification pour une date future",
            messageDesc: "Votre message sera envoyé instantanément à tous les destinataires",
            messageSendAt: "Votre message sera envoyé à tous les destinataires à",
            estimatedPrice: "Prix ​​estimé",
            estimatedTime: "Temps estimé",
            now: "Maintenant",
            tenMinute: "10 minutes",
            cancelled: "Annulé",
            failed: "Échoué",
            running: "En cours",
            queued: "En queue",
            scheduled: "Programmé",
            noNumberAdded: "Aucun chiffre ajouté",
            csvOrExcelFile: "Fichier CSV ou Excel",
            broadcastMessagesToContactFile: "Diffuser les messages à la liste des contacts",
            broadcastMessageTemplates: "Modèles de messagerie",
            messageFlow: "Flux de messages",
            textMessageSupport: "Prise en charge du SMS",
            imageMessageSupport: "Prise en charge du message d'image",
            spamPreventions: "Prévention de spam",
            includesAllBasicPlans: "Comprend tout le plan de base",
            chatbotIntegration: "Intégration de chatbot",
            messageToNewNumbers: "Message à de nouveaux nombres",
            broadcastMessageToEveryone: "Diffuser des messages à tout le monde",
            personalizedBroadcastMessage: "Messages de diffusion personnalisés",
            customerGroupSegmentation: "Segmentation du groupe de clients",
            scheduleBroadcastMessage: "Planifier le message de diffusion",
            locationMessageSupport: "Prise en charge du message de localisation",
            advancedSpamPreventions: "Préventions de spam avancées",
            whatsappPlans: "Plans WhatsApp",
            selectBestPlan: "Choisissez le plan qui vous convient",
            comingSoon: "À venir...",
            selectFile: "Sélectionner un fichier",
            created: "Créé",
            message: "Message",
        },
        ig: {
            instagram: "Instagram",
        },
        ticket: {
            ticketTagFilter: "Étiquette de filtre de billets",
            ticketEmails: "Liste des e-mails de transfert de billets",
            save: "Sauvegarder",
            delete: "Supprimer",
            transactions: "Options",
            noEmailTicketNotifications: "Il n'y a pas de données",
            emailIsNotValid: "L'email n'est pas valide",
            emailNotificationDeleted: "Article supprimé avec succès",
            emailNotificationDeleteError: "Une erreur s'est produite",
            tagFilterRequired: "Tag de filtre de billets requis, utilisez * (wildcard) Tag pour tous les billets",
            emailsRequired: "Le transfert des e-mails ne doit pas être nul",
            emailNotificationCreated: "Règle de forwading de billets créé",
            emailNotificationCreateError: "Une erreur s'est produite",
            ticketForwarding: "Transfert d'e-mail de billet",
            ticketTagFilterDesc:
                "Il utilise les sujets de billets que vous avez utilisés dans la conception du chatbot pour filtrer les billets. Vous pouvez écrire une balise différente et appuyer sur Entrée pour l'ajouter. Si vous sélectionnez la balise '*', il sélectionnera tous les billets",
            ticketEmailsDesc:
                "Liste de messagerie vers laquelle les billets seront transmis. Vous pouvez ajouter les adresses des représentants du système en les sélectionnant. Vous pouvez également ajouter des e-mails sans système.",
            ticketList: "Règles de transfert de billets",
            ticketTagFilterPlaceHolder: "Filtre de billets, sélectionnez '*' pour tous",
            ticketEmailsPlaceHolder: "Transfert de la liste des e-mails",
        },
        theme: {
            opacity: "Opacité",
            headerColor1: "Couleur de section hader 1",
            headerColor1A: "Hader Section Opacité 1",
            headerColor2: "Couleur de section d'en-tête 2",
            headerColor2A: "Section d'en-tête Opacité 2",
            backgroundColor: "Couleur d'arrière-plan 1",
            backgroundColorA: "Opacité d'arrière-plan 1",
            backgroundColor2: "Couleur d'arrière-plan 2",
            backgroundColor2A: "Opacité arrière 2",
            textColor: "Couleur de texte",
            errorTheme: "Couleur d'erreur",
            bubbleBackground: "Couleur bulle représentative",
            bubbleVisitorBackground: "Couleur de bulle du client",
            bubbleBackgroundA: "Opacité de bulle représentative",
            bubbleVisitorBackgroundA: "Opacité de bulle du client",
            bubbleText: "Couleur de texte représentatif",
            bubbleVisitorText: "Couleur du texte du client",
            textFormColor: "Forme de couleur",
            selectCustom: "Sélectionnez le thème personnalisé",
            headerColorSecond: "Couleur du haut de l'en-tête",
            headerColorFirst: "Couleur du bas du titre",
            backgroundColorFirst: "Couleur de fond supérieure",
            formColor: "Couleur du texte du formulaire",
            buttonColor: "Couleur du bouton",
            backgroundColorSecond: "Couleur de fond de fond",
            chatBotButtonText: "Couleur du bouton du chatbot",
            chatBotButtonColor: "Couleur du bouton du chatbot",
        },
        billing: {
            paymentStatus: "Statut de paiement",
            amount: "Montant",
            invoiceID: "ID de facture",
            expected: "Attendu...",
            currentAmount: "Montant actuel",
            monthlyEstimatedAmount: "Montant estimé mensuel",
            creationDate: "Date de création",
            invoiceStatus: "État de la facture",
            invoicePeriod: "Période de facturation",
            newPaymentMethod: "Nouvelle méthode de paiement",
            channelCount: "Nombre de canaux",
            remainingTime: "Temps restant",
            chatbotLimit: "Limite de chatbot",
            free: "Gratuit",
            maxChatbotSession: "Sessions maximum de chatbot",
            buyIt: "Acheter",
            renewalDate: "Date de renouvellement",
            monthly: "Mensuel",
            yearly: "Annuel",
            packagePeriod: "Période du package",
            packageType: "Type de package",
            packageManagement: "Gestion des packages",
            invoiceManagement: "Gestion des factures",
            futureInvoice: "Facture future",
            pastInvoices: "Factures passées",
            creditCard: "Carte de crédit",
            invoice: "Facture",
            mustBeUpgradePlanForChatBot: "Pour activer la fonction de chatbot, vous devez passer au plan Pro!",
            cardInfo: "Informations sur la carte",
            billingDetails: "Détails de la facturation",
            addCardIyzico:
                "Vous n'avez pas de carte enregistrée. Afin de payer vos frais d'utilisation mensuels, vous devez ajouter une carte. Le système de paiement est fourni par Iyzico.",
            billingPlanSettings: "Facture",
            startWith: "{cardFamily} La carte commence par {binNumber}",
            paymentMethod: "Mode de paiement",
            billingDate: "Date de facturation",
            isPaid: "Est payé?",
            paid: "Payé",
            markPaid: "Marquez comme payé",
            paymentDate: "Date de paiement",
            pay: "Payer",
            newInvoice: "Créer une facture",
            updateBilling: "Mettre à jour les détails de facturation",
            updateCard: "Changer la carte de crédit",
            paymentBilling: "Méthode de paiement et détails de facturation",
            price: "Prix",
            billingAddress: "adresse de facturation",
            billingCity: "Ville",
            billingCountry: "Pays",
            contactName: "Nom de contact de facturation",
            expireMonth: "Expirer le mois",
            expireYear: "Expirer l'année",
            cardNumber: "Numéro de carte",
            cardHolderName: "Nom du titulaire",
            cardAlias: "Alias ​​de la carte",
            identityNumber: "Numéro d'identité",
            name: "Nom",
            surname: "Nom de famille",
            email: "E-mail",
            addCard: "Ajouter une carte",
            update: "Mise à jour",
            cancel: "Annuler",
            save: "Sauvegarder",
            saving: "Économie",
            noInvoiceFound: "Il n'y a pas de facture",
            year: "Année",
            updating: "Mise à jour ...",
            newInvoiceForm: "Nouvelle facture Créer une forme",
            error: "Erreur",
            transactions: "Options",
            paymentMethodAdded: "Le mode de paiement a ajouté avec succès",
            paymentMethodAddError: "Le mode de paiement n'a pas ajouté, une erreur s'est produite",
            creditCardChanged: "La carte de crédit a changé avec succès",
            errorOccurred: "Une erreur s'est produite, réessayez",
            billingDetailUpdated: "Les détails de facturation ont réussi à mettre à jour",
            invoiceCreated: "La facture a créé avec succès",
            paymentSuccess: "Paiement avec succès, merci",
            paymentFail: "Paiement échoué, réessayez",
            billingAddressChanged: "L'adresse de facturation a changé avec succès",
            hidePlan: "Plan de cachette",
            informationShopping:
                "Vos informations de paiement, les informations de facturation, les informations sur la carte de crédit sont contrôlées par Shopify.",
            trialTimeInformation:
                "Le procès se termine {dayCount} jours après. Si vous n'entrez pas de mode de paiement avant l'expiration de cette période, vous serez automatiquement passé au plan libre par le système.",
            trialTimeInformationShort: "Essai: dernier {dayCount} jour",
            currentPlanLabel: "Plan actuel: {planName} ({agentCount} Agent)",
            changeCancelPlan: "Plan de modification / annulation",
            oneAgent: "Agent",
            agent: "Agent",
            yourCurrentPlan: "Plan actuel",
            month: "Mois",
            billedMonthToMonth: "(facturé de mois en mois)",
            selectAgentCount: "Sélectionner le nombre d'agents",
            selectFreePlan: "Sélectionnez le plan gratuit",
            planDetails: "Détails du plan",
            multiAgent: "(Multi agent)",
            selectProPlan: "Sélectionner le plan Pro",
            foreverFree: "Libre pour toujours",
            websiteIntegration: "Intégration du site Web",
            websiteIntegrationUnlimited: "Intégration du site Web",
            ChatBotUnlimited: "Chatbot",
            videoCallUnlimited: "Appel vidéo",
            multiAgentUpTo: "Multi agent (jusqu'à {agentCount} Agent)",
            audioCallUnlimited: "Appel audio",
            screenSharingUnlimited: "Partage d'écran",
            fileTransferUnlimited: "Transfert de fichier",
            autoChatAssignerUnlimited: "Assistant de chat automatique",
            multiLanguageTranslationUnlimited: "Traduire automatiquement",
            detailedReporting: "Déclaration",
            days30TrialsAvailable: "Essais de 30 jours disponibles",
            limitedArchiveLookupLastMo: "Lookup d'archives limité (dernier {monthCount}-mo)",
            fullCustomizationUnlimited: "Personnalisation",
            planUpdated: "Super, votre plan est mis à jour.",
            planUpdating: "Votre plan est de mise à jour ...",
            planUpdatingDescription: "Veuillez patienter pendant la mise à jour de votre plan",
            done: "Fait",
            freePlanUpdated: "Votre plan est mis à jour en tant que plan gratuit. (MAX Agent Credit: 1)",
            proPlanUpdated:
                "Votre plan est mis à jour en tant que plan professionnel. (MAX Agent Credit: {proPlanUpdated})",
            canNotDwnGrade:
                "Impossible de rétrograder votre plan de Pro {agentCountFirst} Agent (s) vers {valNewPlnToUppr} {agentCountSecond}. Votre agent crédits utilisés.",
            deleteWarning: "Vous devez supprimer ou désactiver {valDif} agent (s)",
            warnMessage: "Le plan sélectionné doit être différent du plan actuel",
            add: "Ajouter",
            cancelYourPlan: "Annuler votre plan",
            upgradeYourPlan: "Améliorez votre plan",
            downgradeYourPlan: "Rétrograder votre plan",
            agree: "ACCEPTER",
            disagree: "ÊTRE EN DÉSACCORD",
            invoices: "Facture",
            priceIntervals: "Intervalle de prix",
            selectSiteAlias: "Sélectionnez ou entrez le nom du site",
            selectPriceInterval: "Sélectionnez ou entrez l'intervalle de prix",
            isRefunded: "Est remboursé?",
            invoiceId: "Facture non",
            siteId: "Site no",
            createdDate: "Date de création",
            failCount: "Nombre de tentatives de récupération de paiement échouées",
            failDate: "Date de paiement échoué",
            Dashboard: "Tableau de bord",
            Agents: "Agents",
            Integration: "L'intégration",
            Settings: "Paramètres",
            Contacts: "Contacts",
            Domain: "Domaine",
            lastActivity: "Dernière Activité",
            basePrice: "Prix ​​de base",
            packagePrice: "Prix ​​du coffret",
            whatsappPrice: "Prix ​​WhatsApp",
            realtimeVisitorCount: "Visiteur en temps réel",
            suspend: "Suspendre",
            partner: "Partenaire",
            plan: "Plan",
            trialDay: "Jours d'essai",
            mobile: "Mobile",
            webSite: "Site Internet",
            websiteOrigins: "Origine du site Web",
            ownerName: "Le nom du propriétaire",
            ownerEmailAddress: "Courriel du propriétaire",
            discount: "Rabais",
            daysLeft: "Jours restants",
            newTrialPopUp: "Combien de jours la nouvelle période d'essai devrait-elle être?",
            newWpPricePopUp: "Combien coûtent les nouveaux frais WhatsApp?",
            newIGPricePopUp: "Combien coûtent les nouvelles frais Instagram?",
            newBasePricePopUp: "Combien coûte le nouveau prix de base?",
            siteInfoUpdated: "Informations sur le site Mises à jour",
            siteInfoNotUpdated: "Informations sur le site non mises à jour",
            siteInfoNotUpdatedErr: "Erreur est survenue! Informations sur le site non mises à jour.",
        },
        tour: {
            closeChat: "Chatte",
            ticket: "Billet",
            formStep: "Étape de forme",
            menuStep: "Étape du menu",
            contentStep: "Étape de contenu",
            menuTitle: "Titre de menu",
            messageContent: "Contenu du message",
            goToLive: "Représentant Connect",
            stats: "Groupe de statistiques",
            settings: "PARAMÈTRES",
            status: "STATUT",
            prevStep: "Étape précédente",
            nextStep: "L'étape suivante",
            finish: "Finir",
            skip: "Sauter",
            skip2: "Sauter, je sais que le système",
            startTour: "Tour initial",
            firstTimeIntro:
                "Vous entrez dans le système pour la première fois, je souhaite présenter l'application si vous autorisez",
            hi: "Salut",
            welcomeTo: "Bienvenue au soutien en direct du Supsis",
            statsPanel:
                "Il s'agit de la barre d'état indiquant les numéros de chat totaux et actifs qui attendent instantanément avec le système.",
            sidebarMenu: "MENU",
            sidebarMenuContent: "Vous pouvez basculer entre les pages ici.",
            representativePrivateMessage: "Panneau de conversation inter-représentatif",
            representativePrivateMessageContent: "Vous pouvez voir des conversations privées entre les agents ici.",
            helpMenu: "Menu d'aide",
            helpMenuContent: "Vous pouvez trouver des informations d'aide sur le système ici.",
            settingsMenu: "Menu des paramètres",
            settingsMenuContent:
                "Vous pouvez faire ici la langue, le mode nocturne et les étapes d'agrandissement d'écran.",
            startChat: "Démarrer la discussion",
            profileMenu: "Menu de profil",
            profileMenuContent:
                "Vous pouvez modifier votre disponibilité et définir les paramètres de votre agent ici.",
            visitorsTab: "Visiteurs",
            visitorsTabContent: "Vous pouvez voir les visiteurs ici.",
            visitorTabHistory: "Histoire des visiteurs",
            visitorTabHistoryContent: "Vous pouvez voir l'histoire des visiteurs ici.",
            representativeTab: "Représentants",
            representativeTabContent: "Vous pouvez voir les représentants ici.",
            liveSupport: "Support en direct",
            liveSupportContent: "Vous pouvez voir le nombre de clients recevoir un support en direct ici.",
            siteVisitors: "Visiteurs du site",
            siteVisitorsContent: "Vous pouvez voir le nombre de visiteurs du site ici.",
            tableSettings: "Paramètres de la table",
            tableSettingsContent: "Vous pouvez afficher ou masquer des colonnes dans le tableau ici.",
            watchModeButton: "Bouton de la visionneuse",
            watchModeContent: "Vous pouvez vous joindre ici en mode Viewer et vous ne pouvez voir ce qui est publié.",
            popoverInfo: "Détails du visiteur",
            popoverInfoContent: "Il donne des informations sur le visiteur.",
            popoverButton: "Paramètres de chat avancés",
            popoverButtonContent:
                "Vous pouvez ouvrir la conversation, envoyer un message directement au représentant ou bloquer le visiteur.",
            openChat: "Rejoignez le bouton de conversation",
            openChatContent: "Vous pouvez ouvrir la conversation ici",
            pagination: "Menu de pagination.",
            paginationContent: "Vous pouvez augmenter le nombre de pages ici.",
            changeLang: "Peut changer la langue du système",
            changeTheme: "Peut changer le thème sombre et clair",
            changeStatus: "Peut modifier votre statut de disponibilité",
            logout: "Peut déconnecter le système d'ici",
            chatwindow: {
                chatWindowActionButtons: "Boutons d'action de fenêtre de chat",
                chatPanelActions: "Actions du panneau de chat",
                otherPanels: "Autres panneaux",
                chatColorButton: "Montrez un sens des couleurs de barre de chat",
                keyboardShortcutButton: "Afficher les fonctions de raccourcis KeyBpard",
                hideButton: "Minimiser le chat actuel sans sortir",
                closeButton: "Forcer la fermeture et sortir du chat actuel",
                ellipsisButton:
                    "Plus d'actions de chat. Minimiser, fermer, interdire le visiteur, envoyer un message privé, affecter un représentant",
                userInfoWidget: "Afficher le détail du visiteur du propriétaire de l'utilisateur actuel du chat",
                preparedContentWidget:
                    "Widget de modèles de messages préparés, peut sélectionner rapidement un modèle de message sur le chat actuel",
                chatHistoryWidget: "S'il y a des antécédents de chat du visiteur actuel, peut les voir",
                chatWindowSettingsButtons: "Bouton Paramètres de la fenêtre de parler",
                settingsButton:
                    "Vous pouvez bloquer la conversation, transmettre, un message confidentiel et attribuer des délégués.",
                chatBarButton:
                    "Ici, vous pouvez bloquer la conversation active, envoyer un message privé à l'agent et laisser la conversation.",
            },
        },
        adminUser: {
            newAdminUserForm: "Nouveau formulaire de registre d'utilisateurs d'administration",
            updateAdminUserForm: "Formulaire de mise à jour de l'utilisateur de l'administrateur",
            adminUsers: "Utilisateurs administratifs",
            newAdminUser: "Nouvel utilisateur administrateur",
            noAdminUser: "Aucun utilisateur d'administration encore",
            adminUserName: "Nom d'utilisateur admin",
        },
        report: {
            hourly: "(Horaire)",
            hourlyAverage: "Moyenne horaire",
            hourlyMax: "Maximum horaire",
            hourlyMin: "Minimum horaire",
            totalAmount: "Montant total",
            averageAmount: "Montant moyen",
            minAmount: "Montant minimum",
            maxAmount: "Montant maximum",
            siteCount: "site Count",
            agentCount: "Agent Count",
            channelsTimeSeries: "Séries chronologiques des canaux",
            channelPies: "Tartes de canal",
            pieView: "Diagramme circulaire",
            topVisitorCountry: "Pays le plus visité",
            websiteTrafficByCountry: "Trafic du site web par pays",
            visitorCount: "Nombre de visiteurs",
            websiteVisitorTraffic: "Trafic des visiteurs du site web",
            websiteTraffic: "Trafic du site web",
            author: "Auteur",
            topWorstComments: "Pires commentaires",
            topBestComments: "Meilleurs commentaires",
            topComments: "Meilleurs commentaires",
            noComment: "Pas encore de commentaires",
            minWaitingTime: "Temps d'attente minimum",
            maxWaitingTime: "Temps d'attente maximum",
            averageWaitTime: "Temps d'attente moyen",
            waitTime: "Temps d'attente (secondes)",
            agentWaitDurationTitle: "Graphique de la durée d'attente de l'agent",
            incomingMessage: "Message(s) entrant(s)",
            outgoingMessage: "Message(s) sortant(s)",
            totalSpent: "Dépense totale",
            avgSpent: "Dépense moyenne",
            totalPayment: "Paiement total",
            walletStatus: "Statut du portefeuille",
            walletBalanceStatus: "Statut du solde du portefeuille",
            messageTraffic: "Trafic de messages",
            breakCount: "Nombre de pauses",
            agentBreakTime: "Nombre de pauses des agents ☕",
            agentStatusHour: "Heure de statut de l'agent",
            agentWorkTimeCalendar: "Calendrier du temps de travail de l'agent",
            agentActivity: "Activité de l'agent",
            noEnoughtData: "Pas assez de données",
            averageFirstResponse: "Temps moyen de première réponse",
            slowestResponser: "Le plus lent à répondre",
            fastestResponder: "Le plus rapide à répondre",
            firstAnswerTimeSec: "Temps de la première réponse (en secondes)",
            firstAnswerByAgent: "Temps de la première réponse par l'agent",
            averageSolutionTime: "Temps de résolution moyen",
            slowestSolver: "Résolveur le plus lent",
            fastestSolver: "Résolveur le plus rapide",
            averageChat: "Chat moyen",
            leastChatReceiver: "Récepteur de chat le moins actif",
            mostChatRecipients: "Le plus grand nombre de destinataires de chat",
            averageTicket: "Average Ticket",
            leastTicketReceiver: "Least Ticket Least",
            mostTicketRecipients: "Most Ticket Recipients",
            resolveTime: "Temps de résolution (min)",
            resolveTimeByUser: "Temps de résolution du chat par l'utilisateur (en minutes)",
            chatResolveTimeByAgent: "Temps de résolution du chat par les agents",
            chatDistByHandleType: "Répartition des chats par gestionnaire",
            chatDistByHandDesc: "Combien de chats ont été gérés par des agents, des chatbots et des hybrides?",
            chatCountsByHandleType: "Nombre de chats par type de traitement",
            missed: "Manqué",
            answered: "Répondu",
            chatDistByAnsDesc: "Combien de discussions ont été répondues ou manquées?",
            chatCountsByAns: "Nombre de discussions par réponse",
            chatCountByPlatform: "Nombre de discussions par plateforme",
            chatDistByPDesc: "Combien de discussions sont venues sur quelle plateforme ?",
            chatDistByPlatform: "Distribution des discussions par plateforme",
            ticketCountByUser: "Ticket Counts by Agents",
            ticketCountByStatus: "Ticket Counts by Response Status",
            user: "Utilisateur",
            saveAsImage: "Enregistrer en tant qu'image",
            fullScreen: "Plein écran",
            download: "Télécharger",
            tableView: "Vue tableau",
            chartView: "Vue graphique",
            chatDistByUsers: "Répartition des discussions par utilisateurs",
            chatCountsByUsers: "Nombre de discussions par utilisateurs",
            minDuration: "Durée minimale",
            maxDuration: "Durée maximale",
            totalDurationByAgent: "Durée totale de la session par agent",
            averageDurationByAgent: "Durée moyenne de la session par agent",
            totalDurationByCB: "Durée totale de la session par chatbot",
            averageDurationByCB: "Durée moyenne de la session par chatbot",
            viewUnitAs: "Afficher l'unité comme",
            hybrid: "Hybride",
            handledBy: "Traité par",
            sessionDurationOverall: "Durée totale de la session",
            allChannels: "Tous les canaux",
            sessionsDurationOverall: "Durée totale des sessions",
            sessionsOverall: "Sessions globales",
            calendarEvents: "Événements de calendrier",
            reservationEvents: "Événements de réservation",
            incomingMails: "Mails entrants",
            incomingMailCount: "Nombre de mails entrants",
            reservation: "Réservation",
            event: "Événement",
            reservationEventCount: "Nombre d'événements de réservation",
            channelBreakdown: "Répartition des canaux",
            websiteAnalysis: "Analyse du site Web",
            customerSatisfaction: "Satisfaction client",
            teamBreakAnalysis: "Analyse des pauses d'équipe",
            dailyAgentActivity: "Activité quotidienne de l'agent",
            agentPerformance: "Performance de l'agent",
            chatDistributions: "Répartition des chats",
            users: "Utilisateurs",
            segmentTimeseries: "Série temporelle du segment",
            segmentsOverall: "Segments Globaux",
            unmatchRatio: "Taux de non-correspondance",
            totalMatchCount: "Nombre total de correspondances",
            totalUnmatchCount: "Nombre total de non-correspondances",
            matchRatio: "Taux de correspondance",
            matched: "Correspondant",
            trainingOverall: "Formation globale",
            trainingStatusTimeseries: "Série temporelle de l'état de formation",
            duration: "Durée",
            totalSessionDuration: "Durée totale de la session",
            averageSessionDuration: "Durée moyenne de la session",
            second: "seconde",
            minute: "minute",
            hour: "heure",
            aggregateAs: "Agréger comme",
            chatbotSessionDurationOverall: "Durée totale de la session du chatbot",
            ratingTimeSeries: "Série temporelle des évaluations",
            chatCountTimeseries: "Série temporelle du nombre de chats",
            notRated: "Non évalué",
            totalRatingCount: "Nombre total d'évaluations",
            averageRating: "Évaluation moyenne",
            weightedAverageRating: "Évaluation moyenne pondérée",
            rate: "Évaluer",
            ratingOverall: "Customer Ratings Overall",
            session: "Session",
            total: "Total",
            average: "Moyenne",
            max: "Maximum",
            min: "Minimum",
            sessionCount: "Nombre de sessions",
            uniqueUsers: "Utilisateurs Uniques",
            viewAs: "Afficher en tant que:",
            overall: "Global",
            detailReport: "Rapport détaillé",
            dailyReports: "Rapports quotidiens",
            pointBasedReports: "Rapports de points",
            personDateBasedPointReport: "Rapport de points de la personne et de la date",
            personDateBasedReport: "Rapport de personne et de date",
            personBasedReport: "Rapports basés sur la personne",
            personAndDateBasedGraph: "Graphique de personne et de date",
            noReport: "Aucun rapport",
            reports: "Rapports",
            totalBar: "Total",
            ticketCount: "Ticket Count",
        },
        stats: {
            total: "Nombre de tous les chats ouverts",
            active: "Nombre de chats actifs attribués à vous",
            waiting: "Nombre de visiteurs attendant qu'un représentant entre",
            late: "Nombre de visiteurs attendant plus d'une certaine période",
            free: "Nombre de visiteurs gratuits en attendant que le nouveau représentant entre",
            pco: "[Taux d'utilisation de la capacité] Taux de travail Charge de capacité de chat représentative active",
            maxCapacity: "Nombre maximum de chat que le système peut attribuer des représentants sans attendre",
            chatbot: "Nombre de discussions actives avec chatbot",
        },
        time: {
            lastYear: "L'Année Dernière",
            thisYear: "Cette Année",
            last3Months: "3 Derniers Mois",
            last7: "7 Derniers Jours",
            today: "Aujourd'hui",
            yesterday: "Hier",
            lastWeek: "La semaine dernière",
            currentWeek: "Cette semaine",
            currentMonth: "Ce mois-ci",
            lastMonth: "Le mois dernier",
            last30Day: "30 derniers jours",
            allTime: "Chaque fois",
            custom: "Date de personnalité",
        },
        fastWizard: {
            generalColors: "Couleurs générales",
            tellUsMore: "Dites-nous plus, afin que nous puissions personnaliser votre expérience",
            moreInfo: "Plus d'informations",
            display: "Afficher",
            availability: "Disponibilité",
            preview: "Aperçu",
            installCode: "Installer le code",
            previous: "Précédent",
            setupSupsisLiveChat: "Configurer le chat en direct du Supsis",
            continue: "L'étape suivante",
            completeInitialize: "Configuration complète",
            completedMessage: "La configuration de chat en direct en direct a terminé avec succès.",
            websiteIntegration: "L'adresse de votre site Web pour intégrer le chat en direct Supsis",
            customizeLiveChat: "Personnalisez votre chat en direct",
            createBrandedExperience: "Créez une expérience de chat de marque pour vos visiteurs.",
            chatColor: "Couleur de chat",
            chooseChatColor: "Choisissez une couleur d'accent.",
            chatBubble: "Bulle de chat",
            selectBubble: "Sélectionnez une bulle de chat",
            chatBubbleColor: "Couleur de bulle de chat",
            selectChatBubbleColor: "Sélectionnez une couleur de bulle de chat",
            customSelection: "Sélection personnalisée:",
            chatAvailability: "Disponibilité du chat",
            onlineSupportVisitorTime: "Quand êtes-vous en ligne pour soutenir vos visiteurs?",
            channelAvailability: "Disponibilité du canal",
            availability724: "Le chat est disponible 7/24",
            basedOnTeam: "Basé sur le statut des membres de l'équipe",
            basedOnTeamExplanation: "Le chat apparaîtra en ligne quand au moins 1 membre est réglé sur",
            customHours: "Heures d'ouverture personnalisées",
            customHoursExplanation: "Configurez vos heures d'ouverture",
            customHoursTimezone: "Fuseau horaire:",
            customHoursFrom: "Depuis:",
            customHoursTo: "Pour:",
            customHoursAddHours: "+ Ajouter des heures",
            previewDesktop: "Bureau",
            previewIpad: "IPad",
            installationAndInstructions: "Instructions d'installation",
            installationTrackingCode: "Installez le code de suivi sur votre site Web",
            installationTrackingCodePlease:
                "Veuillez coller le code conformément aux instructions ci-dessous, juste avant la fin de la balise {bodyTag} sur n'importe quelle page où vous souhaitez activer le chat en direct du Supsis.",
            installationInstructionsJavascript:
                "Collez le code d'intégration indiqué ci-dessus dans la balise {bodyTag} juste avant la fermeture.",
            installationInstructionsCopy: "Copie",
            installationInstructionsCoppyMessage: "Script d'intégration copié dans le presse-papiers",
            installationInstructionsShopify1: "1. Connectez-vous à votre panneau Shopify",
            installationInstructionsShopify2:
                "2. Accédez à la boutique en ligne> Thèmes> Menu déroulant Actions sous le thème actuel> Modifier le code> thème.liquid",
            installationInstructionsShopify3:
                "3. Placez Coller le code d'intégration indiqué ci-dessus juste avant la balise {bodyTag} à la fin du thème.liquid Script.",
            installationInstructionsIdeaSoft1: "1. Connectez-vous à votre panneau de concessionnaire.",
            installationInstructionsIdeaSoft2: "2. Accédez aux paramètres -> SEO -> Services de moteur de recherche.",
            installationInstructionsIdeaSoft3:
                '3. Sélectionnez "Vérification du site avec Meta Tag" dans la section Code de suivi.',
            installationInstructionsIdeaSoft4:
                "4. Copiez et collez le code d'intégration ci-dessus dans la case ouverte et enregistrez.",
            installationInstructionsIdeaSoft5:
                "5. Paramètres à l'intérieur -> Optimisations Cliquez sur le bouton \"effacer le cache\". Ainsi, l'intégration est terminée.",
            installationInstructionsWordPress1: "1. Connectez-vous à votre panneau d'administration WordPress",
            installationInstructionsWordPress2: "2. Allez à l'apparence> Éditeur de thème",
            installationInstructionsWordPress3:
                "3. Sous les fichiers de thème (à l'extrême droite), trouvez le pied de page du thème (pied.php) et sélectionnez-le",
            installationInstructionsWordPress4:
                "4.Paste le code d'intégration ci-dessus avant la balise {bodyTag} en bas.",
            installationInstructionsWordPress5:
                "5. Cliquez sur Mettre à jour le fichier pour enregistrer les modifications",
            installationInstructionsOpenCart1: "1. Connectez-vous à votre panneau d'administration OpenCart",
            installationInstructionsOpenCart2: "2. Allez dans Conception> Éditeur de thème",
            installationInstructionsOpenCart3:
                "3. Sélectionnez le dossier «commun» et ouvrez le fichier en-tête.twig ».",
            installationInstructionsOpenCart4:
                "4.Paste le code d'intégration ci-dessus avant la balise {headTag} en bas.",
            installationInstructionsOpenCart5: "5. Cliquez sur le bouton Enregistrer.",
            installationInstructionsTicimax1: "1. Connectez-vous à votre panneau d'administration TICIMAX",
            installationInstructionsTicimax2:
                "2. Open Design> Design> Paramètres de conception de pied de page d'en-tête",
            installationInstructionsTicimax3:
                "3. Cliquez sur le bouton «Source» dans la section de conception du logo.",
            installationInstructionsTicimax4: "4. Collez le code d'intégration ci-dessous sous le code HTML.",
            installationInstructionsEticaretteyim1:
                "1. Connectez-vous à votre panneau d'administration de commerce électronique",
            installationInstructionsEticaretteyim2:
                "2. Nommez simplement SUPSIS à partir de Plugins> Générer HTML> et copiez le code.",
            installationInstructions: "Instructions",
            installationVerify: "Vérifiez l'installation de votre site Web de Supsis",
            installationVerifyChecking: "Vérification",
            installationVerifyCheck: "Vérifier",
            installationVerifyCheckingStatus: "Vérification de l'état d'intégration du Supsis sur {website}",
            installationCheckingStatusMessageYes: "Super, le Supsis est intégré au site Web {website} !!",
            installationCheckingStatusMessageNo:
                "SUPSIS n'est actuellement pas intégré au site {website}. Vous pouvez terminer votre processus d'intégration maintenant ou plus tard.",
            vtippyPreferredLanguage: "langue préférée",
        },
        akinon: {
            typeOrSelectSKU: "Tapez ou sélectionnez SKU",
            akinonUserId: "ID utilisateur d'Akinon",
            userEmail: "E-mail utilisateur",
            userEmailDesc: "Tapez ou sélectionnez un e-mail utilisateur ...",
            send: "Envoyer",
            selectCity: "Sélectionnez une ville",
            city: "Ville",
            selectState: "Sélectionnez l'état",
            state: "État",
            useMap: "Utiliser la carte",
            chooseAddress: "Choisir l'adresse",
            selectCountry: "Choisissez le pays",
            country: "Pays",
            productIdDesc: "Tapez ou sélectionnez Produit ...",
            productId: "ID de produit",
            userIdDesc: "Tapez l'ID utilisateur Akinon ...",
            productSKU: "SKU de produit",
            latitudeDesc: "Tapez ou sélectionnez la latitude de l'emplacement cible ...",
            longitudeDesc: "Tapez ou sélectionnez Longitude de l'emplacement cible ...",
            orderNumber: "Votre numéro de commande",
            orderDesc: "Tapez le numéro de commande ...",
            longitude: "Longitude",
            latitude: "Latitude",
        },
        headBar: {
            email: "E-mail",
            phone: "Téléphone",
            name: "Nom",
            date: "Histoire",
            subject: "Sujet",
            situation: "Situation",
            representative: "Représentant",
            transactions: "Transactions",
        },
        login: {
            loginTitle1: "Bienvenue à",
            loginTitle2: "SUPSIS",
            email: "Votre adresse email",
            emailPlaceholder: "Veuillez saisir votre adresse e-mail.",
            emailError: "Veuillez saisir une adresse e-mail valide",
            password: "Votre mot de passe",
            passwordLogin: "Connexion sans mot de passe",
            passwordAndLogin: "Connexion avec mot de passe",
            passwordNew: "Réinitialiser mon mot de passe",
            loginAnd: "Ou",
            passwordPlaceholder: "S'il vous plait entrez votre mot de passe.",
            loginMemory: "Rappelez-vous cet appareil",
            passwordForget: "j'ai oublié mon mot de passe",
            passwordNewAgain: "Nouveau mot de passe",
            passwordNewAgainTwo: "Répétition du nouveau mot de passe",
            passwordNewAgainPlaceholder: "Veuillez entrer votre nouveau mot de passe.",
            passwordNewAgainPlaceholderTwo: "Veuillez ressaisir votre nouveau mot de passe.",
            login: "Connexion",
            loginFooter: "Ou connectez-vous avec un e-mail",
            emailLogin: "Connectez-vous avec un e-mail",
        },
        settings: {
            auditlogs: "Audit Logs",
            myaccount: "My Account",
            notifications: "Notifications",
            company: "Entreprise",
            features: "Caractéristiques",
            general: "Général",
            chat: "Bavarder",
            timings: "Timing",
            wallet: "porte-monnaie",
            language: "Langue",
            "bubble-settings": "Paramètres de la bulle",
            "bubble-actions": "Actions de la bulle",
            "theme-settings": "Paramètres de thème",
            visitorLoginForm: "Formulaire de connexion des visiteurs",
            visitorAttribute: "Informations sur le profil du visiteur",
            timing_settings: "Paramètres de synchronisation",
            auto_assign: "Auto Chat Assign",
            availability: "Disponibilité",
            "website-integration": "Intégration de site Web",
            General: "Général",
            Chat: "Bavarder",
            Timings: "Timing",
            Integration: "Intégration",
            developer: "Développeur",
            visitorNew: "Nouveau visiteur",
            companySubtitles: "Gérer les paramètres de votre entreprise.",
            featuresSubtitles: "Gérer les fonctionnalités de votre entreprise.",
            languageSubtitles: "Gérer les paramètres de langue de votre entreprise.",
            bubbleSettings: "Paramètres de la bulle",
            bubbleSettingsSubtitles: "Gérer les paramètres de la bulle de votre entreprise.",
            bubbleActionsSubtitles: "Gérer les actions de la bulle de votre entreprise.",
            chatThemeSettingsSubtitles: "Gérer les paramètres de thème de chat de votre entreprise.",
            visitorLoginFormSubtitles:
                "Gérer les paramètres de formulaire de connexion des visiteurs de votre entreprise.",
            chatTimingSettingsSubtitles: "Gérer les paramètres de synchronisation de chat de votre entreprise.",
            webSiteIntegrationSubtitles: "Gérer les paramètres d'intégration de site Web de votre entreprise.",
            apiAccessTitle: "Accès API",
            apiAccessSubtitles: "Gérer les paramètres d'accès API de votre entreprise.",
            youTubeActionForm: "Ajoutez votre chaîne YouTube",
            linkedinActionForm: "Ajouter votre compte Linkedin",
            telegramActionForm: "Ajouter un compte Telegram",
            facebookActionForm: "Ajoutez votre page Facebook",
            tiwitterActionForm: "Ajoutez votre page Twitter",
            instagramActionForm: "Ajoutez votre page Instagram",
            liveSupportDescription: "Ouvrez un chat en direct avec vos clients",
            ticketDescription: "Gérez les demandes de vos clients",
            whatsappDescription: "Laissez vos clients vous contacter via Whatsapp",
            phoneDescription: "Laissez vos clients vous contacter par téléphone",
            emailDescription: "Laissez vos clients vous contacter par e-mail",
            facebookDescription: "Laissez vos clients vous contacter via Facebook",
            twitterDescription: "Laissez vos clients vous contacter via Twitter",
            instagramDescription: "Laissez vos clients vous contacter via Instagram",
            youtubeDescription: "Laissez vos clients vous contacter via Youtube",
            linkedinDescription: "Laissez vos clients vous joindre avec LinkedIn",
            telegramDescription: "Laissez vos clients atteindre la taille avec Telegram",
            whatsappModalTitle: "Formulaire de traitement Whatsapp",
            whatsappModalDescription: "Veuillez remplir le formulaire ci-dessous pour lier votre compte Whatsapp.",
            phoneModalTitle: "Formulaire de traitement téléphonique",
            phoneModalDescription: "Veuillez remplir le formulaire ci-dessous pour lier votre compte téléphonique.",
            emailModalTitle: "Formulaire de traitement des e-mails",
            emailModalDescription: "Veuillez remplir le formulaire ci-dessous pour lier votre compte e-mail.",
            facebookModalTitle: "Formulaire de traitement Facebook",
            facebookModalDescription: "Veuillez remplir le formulaire ci-dessous pour lier votre compte Facebook.",
            twitterModalTitle: "Formulaire de traitement Twitter",
            twitterModalDescription: "Veuillez remplir le formulaire ci-dessous pour lier votre compte Twitter.",
            instagramModalTitle: "Formulaire de traitement Instagram",
            instagramModalDescription: "Veuillez remplir le formulaire ci-dessous pour lier votre compte Instagram.",
            youtubeModalTitle: "Formulaire de traitement Youtube",
            youtubeModalDescription: "Veuillez remplir le formulaire ci-dessous pour lier votre compte Youtube.",
            linkedinModalTitle: "Formulaire de transaction LinkeIn",
            linkedinModalDescription: "Veuillez remplir le formulaire ci-dessous pour lier votre compte LinkedIn.",
            telegramModalTitle: "Formulaire de transaction par télégramme",
            telegramModalDescription:
                "Entrez votre lien de profil Telegram dans le formulaire ci-dessous pour lier votre compte Telegram",
            instagramAlertTitle: "Intégration Instagram requise",
            instagramAlertDesc:
                "Désolé, la page que vous avez visitée sera activée lorsque vous intégrerez votre Instagram.",
            instagramActivateText: "Allons-y, intégrons Instagram",
            remove: "Retirer",
            edit: "Éditer",
            connected: "Connecté",
            add: "Ajouter",
            themeDescription: "Choisissez le thème de votre entreprise.",
            fontDescription: "Choisissez la police de votre entreprise.",
            isFabsAsIcon: "Afficher les textes des icônes de menu.",
            chatBubbleTextSetting: "Réglage du texte de la bulle de chat",
            textOnChatBubble:
                "Vous pouvez ajuster les paramètres de texte qui apparaîtront sur la bulle de discussion.",
            textToAppearOnChatBubble: "Texte à apparaître sur la bulle de chat",
            newVisitorProfileInformation: "Nouvelles informations de profil de visiteur",
            newVisitorProfileInformationDescription: "Nouvelles informations de profil de visiteur",
            create: "Créer",
            newAdd: "Ajouter nouveau",
            toInform: "Informer",
            toInformDescription:
                "Vous pouvez faire correspondre les valeurs que vous ajoutez sur cette page avec le formulaire de connexion des visiteurs.",
            showVisitor: "Afficher le visiteur",
            label: "Billet",
            text: "En écrivant",
            email: "E-mail",
            phone: "Téléphone",
            number: "Nombre",
            url: "URL",
            date: "Temps",
            dropdown: "sélectionnable",
            languageTimeZone: "Langue et région",
            timeZoneTitle: "Région et fuseau horaire",
            timeZoneDescription: "Paramètres de région et de fuseau horaire",
        },
        userInfoWidget: {
            userInformation: "Informations de l'utilisateur",
            fullName: "Nom et surnom",
            newValue: "Nouvelle valeur",
            newProfileInfo: "Nouvelles informations de profil",
            affiliatedRepresentatives: "Représentants",
            preferredAgents: "Agent(s) préféré(s)",
            labels: "Étiquettes",
            agentNotes: "Remarques sur les agents",
            newNote: "Nouvelle note",
            note: "Note",
            available: "Des notes sont disponibles.",
            systemInformation: "Informations système",
            speechID: "ID de la parole",
            customerVersion: "Version client",
            IPAddress: "Adresse IP",
            pageVisited: "Page visitée",
            systemAndBrowser: "Système d'exploitation et navigateur",
            countryAndLanguage: "Pays et langue",
            clickToEdit: "Modifier Cliquez à l'intérieur du message",
            adsYouAreInterestedIn: "Publicités qui vous intéressent",
            detail: "Détail",
            adsTitle: "Titre",
            adUrl: "URL de l'annonce",
            sourceID: "Identifiant de la source",
            resourceType: "Type de ressource",
            adsBody: "Contenu",
            adsCreateDate: "Date de création",
            adsUpdateDate: "Date de mise à jour",
        },
        newWizartV2: {
            generalSettings: "réglages généraux",
            themeSettings: "réglages généraux",
            representativeWorkingHours: "Heures de travail représentatives",
            preview: "Aperçu",
            setup: "Installation",
            formStepTitle: "Donnez-nous plus d'informations afin que nous puissions personnaliser votre expérience",
            supsisEntergation: "Où utiliserez-vous Supsis sur votre site web ? :",
            goToNextStep: "Passez à l'étape suivante",
            readytemplate: "Utiliser le modèle de couleur prêt",
            customSettings: "Paramètres personnalisés",
            customerMessageView: "Message client Voir",
            backcgroundColor: "Couleur de l'arrière plan",
            textColor: "Couleur de la police",
            agentMessageView: "Affichage des messages de l'agent",
            workingHours: "À quels intervalles de temps fournissez-vous des services à vos visiteurs?",
            continuousService: "Service continu",
            continuousServiceDescription:
                "La bulle de discussion est toujours active. Même si vous n'êtes pas dans le système.",
            vote: "Fais ton choix",
            representativeWorking: "Heures de travail représentatives",
            representativeWorkingDescription:
                "Le chat apparaît en ligne lorsqu'au moins 1 agent est en ligne. S'il n'y a pas de représentant en ligne, il apparaîtra hors ligne.",
            computer: "Ordinateur",
            tablet: "Tablette",
            uploadTrackingCodeToYourWebsite: "Télécharger le code de suivi sur votre site Web",
            password: "Definir un nouveau mot de passe",
        },
        whatsappChannel: {
            whatsappTitleV1: "Canaux Whatsapp V1 (QR)",
            whatsappTitleV2: "Canaux Whatsapp V2 (QR)",
            channelName: "Nom du Canal",
            phoneNumber: "Numéro de Téléphone",
            forwardToChatbot: "Transférer au Chatbot",
            forwardingChatbotOrLiveAgent: "Transfert (Chatbot ou Agent en Direct)",
            addChannel: "Ajouter un Canal",
            newWhatsappChannel: "Nouveau Canal WhatsApp",
            newWhatsappChannelDescription: "Créez un nouveau canal WhatsApp en scannant le code QR",
            editWhatsappChannel: "Modifier le Canal WhatsApp",
            editWhatsappChannelDescription: "Modifier le canal WhatsApp",
            whatsappChannel: "Canal WhatsApp",
            deleteWhatsappChannelDescription: "Êtes-vous sûr de vouloir supprimer ce canal ?",
            whatsappIntegration: "Intégration WhatsApp",
            deleteChannel: "Supprimer le Canal",
            restartChannel: "Redémarrer le Canal",
            wantRestartChannel: "Voulez-vous redémarrer le canal ?",
            deleteSMSChannelDescription: "Êtes-vous sûr de vouloir supprimer le canal SMS ?",
            smsChannel: "Canal SMS",
            maxChannelCount: "Vous ne pouvez pas créer plus d’un canal SMS !",
            smsModalText:
                "Notre intégration avec des solutions de communication modernes vous donne la possibilité d'envoyer des SMS facilement et efficacement. Supprimez les frontières de la communication, connectez-vous directement avec vos clients !",
            smsModalBtn: "Cliquez pour ouvrir le canal SMS...",
            postaCellDetail: "Détails du canal PostaCell",
        },
        noPermission: "Vous n'avez pas la permission d'effectuer cette opération.",
        mail_integration_detail: {
            title: "Détail du courrier",
            integration: "Intégration",
            sender: "Expéditeur",
            signature: "Signature",
            inbox: "Boîte de réception",
            medias: "Médias",
            visibility: "Visibilité",
            settings_group: "Paramètres",
            contacts: "Contacts",
        },
        whatsapp_business_api: {
            title: "Canaux Whatsapp Business API",
            integration: "Intégration",
            detail: "Détail",
            visibility: "Visibilité",
            templates: "Tous les modèles de messages",
            settings_group: "Paramètres",
            template_message_group: "Messages modèles",
            chat_initiator_template: "Modèle d'initiation de chat",
            contacts: "Contacts",
            numbers: "Numbers",
            all_contacts: "Tous les contacts",
            new_template: "Créer un nouveau modèle",
            broadcast_group: "Diffusion",
            broadcast_requests: "Demandes de diffusion",
            customer_groups: "Groupes de clients",
            businessChannelDetail: "Détails du canal Whatsapp Business",
            wallet: "Wallet",
            postacellMessagepostacellMessage: "Envoyer un SMS",
            postacellAllMessage: "Envoyer des SMS en masse",
            message_group: "Message",
            createNewTemplate: "Créer un nouveau message modèle",
            templateName: "Nom du modèle",
            templateNameDesc: "Donnez un nom à votre modèle de message.",
            viewTemplates: "Voir les modèles",
            templateNameRules:
                "Le nom du modèle ne peut inclure que des lettres minuscules, des chiffres et des traits de soulignement.",
            category: "Catégorie",
            categoryDesc: "Sélectionnez le type de modèle que vous souhaitez créer",
            categoryUtility: "Utilitaire",
            categoryUtilityDesc:
                "Envoyez des informations utilitaires telles que les mises à jour de compte, les mises à jour de commande, les alertes, et plus encore.",
            categoryMarketing: "Marketing",
            categoryMarketingDesc:
                "Envoyez des offres promotionnelles, des offres de produits et plus encore pour augmenter la notoriété et l'engagement.",
            categoryAuth: "Authentification",
            categoryAuthDesc: "Envoyez des codes pour que vos clients puissent accéder à leurs comptes.",
            optional: "Optionnel",
            languageDesc: "Sélectionnez la langue dans laquelle votre message modèle sera envoyé",
            header: "En-tête",
            headerRules:
                "Ajoutez un en-tête de 60 caractères à votre message. Seule une variable est prise en charge dans l'en-tête.",
            headerOptionMedia: "Média",
            headerOptionText: "Texte",
            none: "Aucun",
            headerType: "Type d'en-tête",
            headerText: "Texte de l'en-tête",
            body: "Corps",
            bodyRules: "Saisissez le texte dans la langue que vous avez choisie pour votre message",
            addVariable: "Ajouter une variable",
            variables: "Variables",
            variable: "Variable",
            defaultVariableName: "Nom de variable par défaut",
            defaultVariableToolTip:
                "Votre variable apparaît dans le modèle avec ce nom. <br><br> De plus, cette valeur est envoyée par défaut en cas d'autres situations.",
            selectATemplate: "Sélectionnez un modèle de message",
            variableSettings: "Paramètres de variable",
            example: "Exemple",
            footer: "Pied de page",
            footerDesc:
                "Ajoutez un pied de page de 60 caractères à votre message. Les variables ne sont pas prises en charge dans le pied de page.",
            buttons: "Boutons",
            buttonType: "Type de bouton",
            buttonTypeReply: "Répondre",
            submit: "Enregistrer",
            submitting: "Soumission en cours",
            addButton: "Ajouter un bouton",
            rejectWhatsapp: "Rejeté par Whatsapp.",
            approvedWhatsapp: "Approuvé par Whatsapp.",
            pendingWhatsapp: "En attente d'approbation",
        },
    },
    es: {
        chatWindow: {
            thereIsNoChatContent: "No hay contenido de chat disponible.",
            thereIsNoChatContentDsc: "Aquí puedes ver el contenido del chat y enviar mensajes.",
            interactions: "Interacciones:",
            departments: "Departamentos",
            channels: "Canales",
            date: "Fecha",
            lastChatStatus: "Último estado del chat",
            all: "Todos",
            queued: "En cola",
            open: "Abierto",
            closed: "Cerrado",
            private: "Privado",
            chatbot: "Chatbot",
            lostMissed: "Perdido / No atendido",
            interaction: "Interacción",
            myActiveInbox: "Mi bandeja de entrada activa",
            activeQueueInbox: "Bandeja de entrada activa + en cola",
            chatbotActiveInbox: "Bandeja de entrada activa del chatbot",
            myDepartmentsActiveInbox: "Bandeja de entrada activa de mis departamentos",
            notInteractedYesterday: "No hubo interacciones ayer",
            queueInbox: "Bandeja de entrada en cola",
            whatsappActiveInbox: "Bandeja de entrada activa de WhatsApp",
            socialMediaActiveInbox: "Bandeja de entrada activa de redes sociales",
            missedThisMonth: "Chats perdidos este mes",
            chooseAFileOrDragItHere: "¡Elige un archivo o arrástralo aquí!",
            watching: "Observando",
            selectFilter: "Seleccionar filtro",
            clearAll: "Limpiar todo",
            me: "Yo",
            today: "Hoy",
            yesterday: "Ayer",
            thisWeek: "Esta semana",
            lastWeek: "La semana pasada",
            last7Days: "Últimos 7 días",
            last30Days: "Últimos 30 días",
            thisMonth: "Este mes",
            lastMonth: "El mes pasado",
            last24h: "Últimas 24 horas",
            custom: "Personalizado",
            startMessage: "Iniciar mensaje",
            goToAgentReport: "Ir al informe del agente",
            agentDetail: "Detalle del agente",
            agentList: "Lista de agentes",
            selectedFilter: "Filtro seleccionado",
            groupBy: "Agrupar",
            none: "Sin grupo",
            agent: "Representante",
            department: "Departamento",
            sortBy: "Ordenar",
            lastPostAbove: "Última publicación arriba",
            newChatsAbove: "Nuevos chats arriba",
            oldChatsAbove: "Chats antiguos arriba",
            live: "Vivir",
            systemStatus: "Estado del sistema",
            refresh: "Actualizar",
            close: "Cerrar",
            totalCustomers: "Total de clientes",
            totalAnswered: "Total respondido",
            waitingAnswer: "Esperando respuesta",
            totalAgentInChat: "Total de agentes en el chat",
            onlineAgentCount: "Cantidad de agentes en línea",
            totalCustomer: "Cliente total",
            answered: "Respondido",
            unanswered: "Sin respuesta",
            noContactWasFoundMatchingTheCurrentFilters:
                "No se encontró ningún contacto que coincida con los filtros actuales.",
            you: "Tú",
            others: "Otros",
            queue: "Cola",
            chatbotContact: "Chatbot",
            closedContact: "Cerrado",
            myInteractions: "Mis Interacciones",
            special: "Especial",
            allInteractions: "Todos los contactos",
            waiting: "Pendiente",
            departmentToWhichItIsAffiliated: "Departamento al que está adscrito",
        },
        plans: {
            manageWithChatbot: "Manage with Chatbot",
            manageInbox: "Manage Inbox",
            commentManagement: "Manage Comments",
            privateReplyMessage: "Private Reply Comments",
            mentionTicket: "Convert Mentions to Tickets",
            week: "Semana",
            readyContents: "Contenidos listos",
            webhookIntegration: "Integración de Webhook",
            businessChannel: "Canal de negocios de WhatsApp",
            confirmationFeature: "Función de confirmación",
            specialReporting: "Informes especiales",
            aiAssistant: "Asistente de IA",
            flexibleBilling: "Facturación flexible",
            automaticReservation: "Reserva automática",
            taskManagement: "Gestión de tareas",
            calendarIntegration: "Integración de calendario",
            activeChatbot: "Chatbot activo",
            smsIntegration: "Integración de SMS",
            mailIntegration: "Integración de correo",
            startChatWithVisitor: "Iniciar chat con visitante",
            whatsappManaging: "Gestión de Whatsapp",
            automaticChatbotButton: "Botón/Chatbot automático",
            personalizedBroadcasts: "Transmisiones personalizadas",
            chatWithNonContacts: "Chat con no contactos",
            broadcastMessaging: "Mensajería de difusión",
            perBroadcast: "Por difusión",
            extraPricePerMessage: "Precio extra por mensaje",
            smartTrigger: "Disparador inteligente",
            telegramIntegration: "Integración de Telegram",
            instagramIntegration: "Integración de Instagram",
            ticketFeature: "Función de ticket",
            storage: "Almacenamiento",
            onePanelManagement: "Gestión de un solo panel",
            isolatedDatabaseConnection: "Conexión de base de datos aislada",
            removeLogo: "Eliminar logotipo de Supsis",
            chatBaloonCustomization: "Personalización del globo de chat",
            chatAndNotifications: "Chat y Notificaciones",
            unlimited: "Ilimitado",
            specialCustomerSupport: "Soporte especial al cliente",
            softwareSupport: "Soporte de software",
            standardSupport: "Soporte estándar",
            teamChatIntegration: "Integración de chat de equipo",
            fileAndVoiceShare: "Compartir archivos y voz",
            instantVisitor: "Seguimiento instantáneo de visitantes",
            detailedReporting: "Informes detallados",
            normalreporting: "Informes normales",
            noExtraCosts: "Sin costos adicionales",
            accessibleToAllAgents: "Accesible para todos los agentes",
            dataSecurity: "Seguridad de datos",
            autoTranslate: "Traducción automática",
            chatbotVersionHistory: "Historial de versiones del chatbot",
            chatbotStory: "Historia del chatbot",
            freeAgent: "Agente gratuito",
            stableAgentCount: "Número de agentes estables",
            stableChannelCount: "Stable Channel Count",
            chipPlans: "Planes asequibles",
            generalPlan: "Plan general",
            specialPlan: "Plan especial",
            currentPlan: "Plan actual",
            selected: "Seleccionado",
            popular: "Popular",
            trialPkg: "Paquete de prueba",
            support: "Soporte 24/7",
            flexiblePricing: "Precios flexibles",
            rightToCancel: "Derecho de cancelación en cualquier momento",
            unlimitedCBScenario: "Escenarios de chatbot ilimitados",
            freeFirstScenario: "Primer escenario gratuito",
            unlimitedLearn: "Formación ilimitada en chatbots",
            allPlatformIntegration: "Integración con todas las plataformas",
            detailedReports: "Informes detallados",
            aiSupport: "Soporte de IA",
            creativeAI: "Asistente de chat IA rápido y realista",
            unlimitedSession: "Sesiones ilimitadas simultáneamente",
            assistantFromWebsite: "Creación de asistente desde el sitio web",
            assistantFromDoc: "Creación de chatbot desde el documento",
            mobileApp: "Aplicación móvil",
        },
        messenger: {
            channel: "Canal de Messenger",
            manageChannel: "Gestionar canal",
            channelDetail: "Detalle del canal",
            integrationTitle: "Integración de Messenger",
            deleteDesc: "¿Estás seguro de que deseas eliminar el canal de Messenger?",
            channels: "Canales de Messenger",
            connectMessenger: "Conectar a Messenger",
            detail: "detalle",
            visibility: "Visibilidad",
            settings_group: "Configuración",
            commentsettings: "Gestión de comentarios",
            commentSettingsTitle: "Configuración de comentarios de Messenger",
            commentSettingsDesc: "Gestiona tus comentarios de Messenger",
        },
        instagram: {
            channel: "Canal de Instagram",
            detail: "detalle",
            visibility: "Visibilidad",
            settings_group: "Configuración",
            commentsettings: "Gestión de comentarios",
            commentSettingsTitle: "Gestión de comentarios de Instagram",
            commentSettingsDesc: "Administra tus comentarios de Instagram",
            commentSettingsTicket: "Asegura que los comentarios entrantes se registren en el sistema como tickets.",
            commentSettingsChatbot: "Seleccione a qué escenario de chatbot deben dirigirse los comentarios entrantes.",
            leads: "Leads",
            forms: "Forms",
        },
        calendar: {
            setting: "Configuraciones",
            delete: "Eliminar",
            cancel: "Cancelar",
            save: "Guardar",
            close: "Cerrar",
            deleteRepeatEvent: "Eliminar evento recurrente",
            thisEvent: "Este evento",
            thisAndOtherEvent: "Este y otros eventos",
            allEvent: "Todos los eventos",
            ok: "OK",
            googleCalendarLink: "Agregar a Google Calendar",
            yahooCalendarLink: "Agregar a Yahoo Calendar",
            subject: "Asunto",
            visitor: "Visitante",
            allDay: "Todo el día",
            title: "Título",
            deleteEvent: "Eliminar evento",
            deleteEvents: "Eliminar eventos",
            deleteEventsSure: "¿Está seguro de que desea eliminar los eventos de este calendario?",
            deleteEventConfirm: "¿Está seguro de que desea eliminar este evento?",
            notEmptyTitle: "¡El título no puede estar vacío!",
            tasks: "Tareas",
            googleConnect: "Integración con Google",
            googleDisconnect: "Desconectar integración con Google",
            sure: "¿Está seguro?",
            disconnectGoogleSure: "¿Está seguro de que desea desconectar Google?",
            yes: "Sí",
            no: "No",
            customRepeat: "Repetición personalizada",
            recurrenceFrequency: "Frecuencia de repetición",
            repeatDays: "Repetir en los días:",
            never: "Nunca",
            thisDate: "En esta fecha:",
            recurrenceCount: "Número de repeticiones:",
            end: "Fin",
            event: "Evento",
            calendars: "Calendarios",
            newCalendar: "Crear nuevo calendario",
            changeColor: "Cambiar color",
            addCalendar: "Agregar calendario",
            nameCalendar: "Nombre del calendario",
            description: "Descripción",
            change: "Cambiar",
            deleteCalendar: "Eliminar calendario",
            deleteCalendarSure: "¿Está seguro de que desea eliminar este calendario?",
            notEmptyCalendarName: "El nombre del calendario no puede estar vacío",
            myEvents: "Mis eventos",
            everyoneEvents: "Todos los eventos",
            haveEvent: "eventos del agente",
            goCalendar: "Ir al calendario",
            goReservation: "Crear una reserva",
            agents: "Agentes",
            today: "Hoy",
            month: "Mes",
            week: "Semana",
            day: "Día",
            list: "Lista",
        },
        ticimax: {
            segment: "Segmento",
            settings_group: "Grupo de configuración",
            waitDayFromLastSend: "Día de espera desde el último mensaje enviado",
            automationRuleName: "Nombre de la regla de automatización",
            time: "Hora",
            year: "Año",
            month: "Mes",
            dayOfMonth: "Día del mes",
            day: "Día",
            bySecond: "Por segundo",
            byMinute: "Por minuto",
            byHour: "Por hora",
            byWeekNo: "Por número de semana",
            byYearDay: "Por día del año",
            byMonthDay: "Por día del mes",
            byMonth: "Por mes",
            december: "Diciembre",
            november: "Noviembre",
            october: "Octubre",
            september: "Septiembre",
            august: "Agosto",
            july: "Julio",
            june: "Junio",
            may: "Mayo",
            april: "Abril",
            march: "Marzo",
            february: "Febrero",
            january: "Enero",
            byWeekDay: "Por día de la semana",
            interval: "Intervalo",
            seconds: "Segundos",
            minutes: "Minutos",
            hourly: "Cada hora",
            daily: "Diario",
            weekly: "Semanal",
            monthly: "Mensual",
            yearly: "Anual",
            frequency: "Frecuencia",
            attributes: {
                vip: "VIP",
                segment: "Segmento",
                province: "Provincia",
                country: "País",
                phone: "Teléfono",
                email: "Correo electrónico",
                fullname: "Nombre completo",
                couponPercent: "% de cupón",
                lastOrderDate: "Último pedido",
                firstOrderDate: "Primer pedido",
                county: "Condado",
                lastSource: "Última fuente",
                firstSource: "Primera fuente",
                lastPaymentType: "Último método de pago",
                firstPaymentType: "Primer método de pago",
                maxOrderAmount: "Importe máximo del pedido",
                minOrderAmount: "Importe mínimo del pedido",
                totalOrderAmount: "Importe total del pedido",
                totalOrderCount: "Número total de pedidos",
                usedCouponAmount: "Importe del cupón utilizado",
                usedCouponCount: "Número de cupones utilizados",
                tookDayFromLastOrder: "Días desde el último pedido",
                isCouponUser: "¿Es usuario de cupón?",
            },
            createAutomation: "Crear automatización",
            previous: "Anterior",
            createAutomationDesc: "Crea y gestiona la automatización de mensajes",
            newTicimaxChannel: "Nuevo canal de Ticimax",
            connextToTicimaxXml: "Conectar al servicio XML de Ticimax",
            connectTicimax: "Conectar con Ticimax",
            examplePreview: "Vista previa del ejemplo",
            completeAutomationRule: "Regla de automatización completa",
            configureMessage: "Configurar mensaje",
            automationTimer: "Temporizador de automatización",
            findTargetMembers: "Encontrar miembros objetivos",
            createAutomationRule: "Crear regla de automatización",
            action: "Acción",
            status: "Estado",
            triggeredUserCount: "Número de usuarios activados",
            nextScheduled: "Próxima programada",
            timerRule: "Regla de temporizador",
            automationRules: "Reglas de automatización",
            apply: "Aplicar",
            searchAMember: "Buscar un miembro",
            segmentedMembersDesc: "Enumere y automatice los miembros segmentados",
            manageVisibilityDesc: "Administrar la visibilidad del canal",
            xmlOrderListURL: "URL de la lista de pedidos XML",
            manageIntegrationDesc: "Administrar su integración de Ticimax",
            detail: "Detalle",
            ticimaxChannelsTitle: "Canales de Ticimax",
            ticimaxDetail: "Detalle de Ticimax",
            settingsGroup: "Ajustes",
            visibility: "Visibilidad",
            members: "Miembros",
            automation: "Automatización",
            integrationChannel: "Canal de integración",
            channelUpdated: "Canal actualizado correctamente",
            channelUpdateFailed: "Error al actualizar el canal",
        },
        notification: {
            mobileApp: "Aplicación móvil",
            webPanel: "Panel web",
            notifications: "Notificaciones",
            whatsappActions: "Acciones de Whatsapp",
            chatbotActions: "Acciones del chatbot",
            companyActions: "Acciones de la empresa",
            crmActions: "ACCIONES CRM DE SUPSIS",
            basicActions: "Acciones básicas",
            notificationSettingsDesc: "Elija qué notificaciones desea recibir y dónde desea recibirlas.",
            noNotificationDesc2:
                "Aquí verás todas las notificaciones relacionadas con los trabajos, candidatos y piscinas de talento que estás siguiendo. Puedes personalizar las notificaciones ajustando la configuración.",
            noNotificationTitle2: "Aún no hay notificaciones.",
            noNotificationTitle1: "Sin notificaciones. Disfruta del silencio.",
            adjustSettings: "Ajustar configuración",
            showAll: "Mostrar todo",
            showOnlyUnread: "Mostrar solo no leídos",
            mailWasSent: "El correo electrónico fue enviado.",
            mailAdressRemoved: "Dirección de correo electrónico eliminada.",
            chatbotPublished: "La versión <b>{version}</b> del chatbot fue publicada por <b>{user}</b>.",
            chatbotDeleted: "El chatbot <b>{chatbot}</b> fue eliminado por <b>{user}</b>.",
            settingsUpdatedWoDetail: "La configuración fue actualizada por <b>{user}</b>.",
            noActivityDesc: "Actualmente no hay actividad en el sistema. Deben ocurrir algunos eventos",
            noActivityTitle: "Todavía no hay actividad",
            actionType: "Tipo de acción",
            dateBetween: "Fecha entre",
            selectActor: "Seleccionar usuario",
            activities: "Actividades",
            chatbotCreated: "El chatbot llamado <b>{chatbot}</b> fue creado por <b>{user}</b>.",
            taskStageChanged:
                "La etapa de la tarea <b>{task}</b> se cambió de <b>{oldStage}</b> a <b>{newStage}</b> por <b>{user}</b>.",
            taskCreated: "La tarea <b>{task}</b> fue creada por <b>{user}</b>.",
            contactPropRemoved: "La propiedad del visitante <b>{prop}</b> fue eliminada por <b>{user}</b>.",
            contactPropAdded: "La propiedad del visitante <b>{prop}</b> fue agregada por <b>{user}</b>.",
            userRemoved: "El usuario <b>{oldUser}</b> fue eliminado por <b>{user}</b>.",
            loginFormUpdated: "El formulario de inicio de sesión del visitante fue actualizado por <b>{user}</b>.",
            loginFormDeactivated: "El formulario de inicio de sesión del usuario fue desactivado por <b>{user}</b>.",
            loginFormActivated: "El formulario de inicio de sesión del usuario fue activado por <b>{user}</b>.",
            invoiceRefunded: "El proceso de reembolso fue realizado por <b>{user}</b>.",
            paymentMethodAdded: "Se agregó un nuevo método de pago por <b>{user}</b>.",
            invoicePaymentFailed: "El pago de la factura no fue aceptado por <b>{user}</b>.",
            invoicePaymentReceived: "El pago de la factura fue aceptado por <b>{user}</b>.",
            planStarted: "<b>{user}</b> El usuario inició la suscripción para <b>{title}</b> (<b>{altTitle}</b>).",
            planStartedAgent:
                "<b>{user}</b> El usuario inició la suscripción para <b>{title}</b> <b>{altTitle}</b> (<b>{details} Representante</b>).",
            planStartedChatbot:
                "<b>{user}</b> El usuario inició la suscripción para <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Sesión</b>).",
            planStartedWhatsapp:
                "<b>{user}</b> El usuario inició la suscripción para <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Canales de Whatsapp</b>).",
            planStartedWhatsappApi:
                "<b>{user}</b> El usuario inició la suscripción para <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Canales de Negocios de Whatsapp</b>).",
            PlanCanceled: "<b>{user}</b> El usuario canceló la suscripción para <b>{title}</b> (<b>{altTitle}</b>).",
            planCanceledAgent:
                "<b>{user}</b> El usuario canceló la suscripción para <b>{title}</b> <b>{altTitle}</b> (<b>{details} Representante</b>).",
            planCanceledChatbot:
                "<b>{user}</b> El usuario canceló la suscripción para <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Sesión</b>).",
            planCanceledWhatsapp:
                "<b>{user}</b> El usuario canceló la suscripción para <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Canales de Whatsapp</b>).",
            planCanceledWhatsappApi:
                "<b>{user}</b> El usuario canceló la suscripción para <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Canales de Negocios de Whatsapp</b>).",
            invoiceCreated: "La factura fue creada por <b>{user}</b>.",
            billingAddressUpdated: "La información de la dirección fue actualizada por <b>{user}</b>.",
            taskWorkflowDeleted: "El flujo de trabajo <b>{workflow}</b> fue eliminado por <b>{user}</b>.",
            whatsappBroadcastFailed: "Fallo en el envío del mensaje de difusión titulado <b>{title}</b>.",
            whatsappBroadcastCancelled: "Se ha cancelado el envío del mensaje de difusión titulado <b>{title}</b>.",
            whatsappBroadcastCompleted:
                "Se ha enviado con éxito un mensaje de difusión titulado <b>{title}</b> a <b>{numbers}</b> destinatarios.",
            whatsappBroadcastCreated:
                "Se ha enviado un mensaje de difusión titulado <b>{title}</b> a <b>{numbers}</b> destinatarios por <b>{user}</b>.",
            ticketAssigned: "Se ha asignado un ticket a <b>{user2}</b> por <b>{user1}</b>.",
            userLoggedIn: "<b>{user}</b> se ha conectado a SUPSIS.",
            chatJoined: "<b>{agent}</b> se unió al chat con <b>{visitor}</b>.",
            chatForwarded: "El chat con <b>{visitor}</b> fue enviado a <b>{agent}</b> por <b>{user}</b>.",
            chatAssigned: "El chat con <b>{visitor}</b> fue asignado a <b>{agent}</b> por el sistema.",
            customerGroupUpdated: "El grupo <b>{group}</b> fue actualizado por <b>{user}</b>.",
            customerGroupRemoved: "El grupo <b>{group}</b> fue eliminado por <b>{user}</b>.",
            customerGroupAdded: "El grupo <b>{group}</b> fue creado por <b>{user}</b>.",
            contentRemoved: "El contenido listo <b>{content}</b> fue eliminado por <b>{user}</b>.",
            contentAdded: "El contenido listo <b>{content}</b> fue agregado por <b>{user}</b>.",
            channelVisibilityChanged:
                "La visibilidad del canal de integración <b>{channel}</b> fue cambiada por <b>{user}</b>.",
            taskDeleted: "La tarea <b>{task}</b> fue eliminada por <b>{user}</b>.",
            userRemovedToDepartment:
                "El usuario <b>{user2}</b> fue eliminado del departamento <b>{department}</b> por <b>{user1}</b>.",
            userAddedToDepartment:
                "El usuario <b>{user2}</b> fue añadido al departamento <b>{department}</b> por <b>{user1}</b>.",
            mailAddressAdded: "Dirección de correo electrónico <b>{email}</b> agregada por <b>{user}</b>",
            settingUpdate: "Actualizado por <b>{user}</b>:",
            taskWFlowCreated: "Flujo de trabajo de tareas <b>{Wflow}</b> creado por <b>{user}</b>.",
            bannedWordRemoved: "La palabra prohibida <b>{bWord}</b> fue eliminada por <b>{user}</b>.",
            bannedWordCreated: "La palabra prohibida <b>{bWord}</b> fue creada por <b>{user}</b>.",
            welcomeMessageRemoved: "El mensaje de bienvenida <b>{welcome}</b> fue eliminado por <b>{user}</b>.",
            welcomeMessageAdded: "Mensaje de bienvenida <b>{welcome}</b> creado por <b>{user}</b>.",
            tagRemoved: "Etiqueta <b>{tag}</b> eliminada por <b>{user}</b>.",
            tagAdded: "Etiqueta <b>{tag}</b> agregada por <b>{user}</b>.",
            roleRemoved: "Rol <b>{role}</b> eliminado por <b>{user}</b>.",
            roleAdded: "Rol <b>{role}</b> agregado por <b>{user}</b>.",
            departmentRemoved: "Departamento <b>{department}</b> eliminado por <b>{user}</b>.",
            departmentAdded: "Departamento <b>{department}</b> agregado por <b>{user}</b>.",
            triggerUpdated: "Un desencadenador actualizado por <b>{user}</b>.",
            triggerRemoved: "Un desencadenador eliminado por <b>{user}</b>.",
            triggerAdded: "Un nuevo desencadenador creado por <b>{user}</b>.",
            webhookRemoved: "Webhook de <b>{user1}</b> eliminado por <b>{user2}</b>",
            webhookAdded: "Webhook agregado por <b>{user1}</b>, agregado por <b>{user2}</b>.",
            chatClosed: "El chat con <b>{visitor}</b> fue finalizado por <b>{agent}</b>.",
            chatOpenedByAgent: "<b>{agent}</b> inició un chat <b>{platform}</b> con <b>{visitor}</b>.",
            chatOpenedByVisitor: "Se inició un chat <b>{platform}</b> por <b>{visitor}</b>.",
            channelRemoved: "El canal <b>{channel}</b> fue eliminado por <b>{agent}</b>.",
            userAdded: "<b>{agent}</b> creó un representante llamado <b>{newAgent}</b>.",
            visitorUnblocked: "El visitante <b>{visitor}</b> desbloqueado por el usuario <b>{agent}</b>.",
            visitorBlocked: "El visitante <b>{visitor}</b> bloqueado por <b>{agent}</b>.",
            userStatusChanged: "El usuario <b>{name}</b> cambió el estado de <b>{oldStatus}</b> a <b>{newStatus}</b>.",
            channelCreated: "El canal <b>{channel}</b> fue creado por <b>{name}</b>.",
            reservationCreatedPlan:
                "<b>{name}</b> usuario programó la cita llamada <b>{title}</b> para el <b>{date}</b>.",
            reservationUpdatedPlan: "<b>{name}</b> usuario ha actualizado la cita llamada <b>{title}</b>.",
            reservationDeletedPlan: "<b>{name}</b> Benutzer hat den Termin mit dem Namen <b>{title}</b> gelöscht.",
            reservationCreated:
                "Se ha creado una reserva para el usuario <b>{name}</b> y el visitante <b>{visitor}</b> en la fecha <b>{date}</b>.",
            reservationDeleted:
                "La cita programada entre el usuario <b>{name}</b> y el visitante <b>{visitor}</b> en la fecha <b>{date}</b> ha sido cancelada.",
            chatAssignedMe: "Cuando se me asigna un chat",
            ticketAssignedMe: "Cuando se me asigna un ticket",
            taskAssignedMe: "Cuando se me asigna una tarea",
            myChatClosed: "Cuando se cierra el chat que poseo",
            tagActionsToVisitor: "Etiquetas agregadas o eliminadas de un contacto",
            ticketCreated:
                "El ticket es creado por el visitante o el chatbot. Además, cuando se envía un mensaje fuera de línea desde el widget de chat",
            notesActions: "Se agregó o eliminó una nota de un cliente.",
            visitorProfileUpdated: "Perfil de visitante actualizado",
            chatStartedByAnyPlatform: "El chat se inicia en cualquier plataforma por contacto o agente",
            userActions: "Usuario creado, actualizado o eliminado",
            departmentActions: "Departamento creado, actualizado o eliminado",
            settingsActions: "Configuraciones creadas, actualizadas o eliminadas",
            integrationsActions: "Canal de integración creado, actualizado o eliminado",
            loginFormActions: "El formulario de inicio de sesión se actualiza, activa o desactiva",
            bannedWordActions: "Palabra prohibida creada, actualizada o eliminada",
            emailActions: "La cuenta de correo electrónico se crea o elimina",
            preparedContentActions: "Contenido preparado creado o eliminado",
            roleActions: "Rol creado, actualizado o eliminado",
            tagActions: "Etiqueta creada, actualizada o eliminada",
            welcomeMessageActions: "Mensaje de bienvenida creado, actualizado o eliminado",
            webhookActions: "Webhook creado, actualizado o eliminado",
            billingEvents: "Eventos de facturación",
            taskWorkflowCrud: "El flujo de trabajo de la tarea se crea, actualiza o elimina",
            taskCrud: "La tarea se crea, actualiza o elimina",
            systemStatus: "Cambios de estado en línea u fuera de línea del sistema",
            chatbotStoryCrud: "La historia del chatbot se crea, actualiza o elimina",
            chatbotForwardAgent: "El chatbot reenvía un chat a un agente",
            userSegmentCrud: "El segmento de usuario se crea, actualiza o elimina",
            chatbotCreditLow: "Cuando el crédito del chatbot es bajo",
            wpCreditLow: "Cuando el crédito de Whatsapp es bajo",
            wpCustomerGroupCrud: "Cuando se crea, actualiza o elimina un grupo de clientes de Whatsapp",
            wpBroadcastMessageStatus: "Cuando se envía, completa o cancela un mensaje de difusión de Whatsapp",
            wpTemplateMesssageCrud: "Cuando se crea, actualiza o elimina un mensaje de plantilla de Whatsapp",
            reservationMessageCrud: "Reserva creada, actualizada, cancelada",
        },
        mail: {
            deleteMailDesc: "Esta acción no se puede deshacer.",
            deleteMailTitle: "¿Estás seguro de que quieres eliminar esta dirección de correo electrónico?",
            gmailForwardMail: "Reenvío de correo electrónico de Gmail",
            senderMailAddressDesc: "Por favor, ingrese la dirección de correo electrónico del remitente",
            verified: "Verificado",
            notForwarded: "No reenviado",
            notVerified: "No verificado",
            default: "Predeterminado",
            isVerified: "Verificado",
            forwarding: "Reenvío",
            mailAdress: "Dirección de correo electrónico",
            addSenderAddress: "Agregar dirección del remitente",
            outlookForward: "Reenvío de Microsoft (Outlook/Exchange)",
            gmailForward: "Reenvío de Google (Gmail)",
            senderMail: "Correo del remitente",
            mailDetail: "Detalle del correo",
            mailNotFound: "Correo no encontrado",
            mailSelecting: "Seleccionando correo",
            newMail: "Nuevo correo electrónico",
            myMails: "Mis correos electrónicos",
            inbox: "Bandeja de entrada",
            sent: "Enviado",
            departmentMails: "Correos electrónicos del departamento",
            newTemplate: "Nuevo plantilla",
            unread: "No leído",
            unreply: "Unanswered",
            reply: "Responder",
            attachments: "Adjuntos del correo",
            To: "Para",
            From: "De",
            placeHolders: "Marcadores de posición",
            attacheFiles: "Adjuntar archivos",
            replyAll: "Responder a todos",
            forward: "Reenviar",
            deleteThread: "Eliminar hilo",
            markAsRead: "Marquer comme lu",
            markAsAllRead: "Marcar todo como leído",
            emailEditor: "Editor de correo electrónico",
            integrateYourMail: "Integra tu correo electrónico",
            connect: "Conectar",
            departmentMail: "Correo electrónico del departamento",
            createMailAddress: "Crear dirección de correo electrónico",
            createNewMail: "Crear nuevo correo electrónico",
        },
        visitor: {
            mail: "Correo",
            visitorDetail: "Detalles del visitante",
            selectedUser: "{selectedUser} de {totalUsers} usuarios seleccionados",
            uncheck: "Desmarcar todo",
            checkAll: "Marcar todo",
            matchedUsers: "{checkedCount} usuarios coincidentes",
            more: "Más",
            exportUsers: "Exportar usuarios seleccionados",
            exportAllUsers: "Exportar todos los usuarios",
            addSegment: "Agregar segmento",
            deleteCheckedUser: "Eliminar usuarios seleccionados",
            deleteAllUser: "Eliminar todos los usuarios",
            matchedFilter: "Coincidir con todos los filtros",
            visitor: "Visitante",
            deleteUser: "Eliminar usuario",
            userData: "Datos de usuario",
            lastSession: "Última sesión",
            notUserData: "No se encontraron datos de usuario",
            segments: "Segmentos",
            tags: "Etiquetas",
            addTag: "Agregar etiqueta",
            userChats: "Chats de usuario",
            seeAll: "Ver todos",
            confirm: "Confirmar",
            manageSegments: "Administrar segmentos",
            search: "Buscar",
            manageTags: "Administrar etiquetas",
            allAttributes: "Ver todos los atributos",
            noData: "Sin datos",
            noEmail: "Sin correo electrónico",
            noIpAddress: "Dirección IP no encontrada.",
            noWpNumber: "Número no encontrado.",
            filterName: "nombre del filtro..",
            matchedContacts: "{chechkedCount} contactos coincidentes",
        },
        chatbotv2: {
            selectedStory: "{count} historia seleccionada",
            Instagram_Actions: "Instagram Actions",
            suppressionRemoved: "Supresión eliminada",
            suppressionAdded: "Supresión agregada",
            didntSuppression: "No hiciste ninguna supresión.",
            whatsappIntegrationTitle: "Integración de WhatsApp V1 y WhatsApp V2",
            whatsappApiIntegrationTitle: "Integración de la API de WhatsApp Business",
            ReadyTemplateBadge: "Plantilla lista",
            readyTemplates: "Plantillas listas",
            regex: "Regex",
            regexDescription: "Regex ile herşeyi yakala",
            chatbotLogo: "Logo del ChatBot",
            chatbotName: "Nombre del ChatBot",
            allSecnario: "Lista de escenarios de chatbot",
            ChatbotScenarioList: "Lista de escenarios de chatbot",
            Scenario: "Escenarios",
            filters: {
                equal: "es igual a",
                not_equal: "no es igual",
                contain: "contener",
                not_contain: "no contiene",
                starts_with: "comienza con",
                ends_with: "termina con",
                empty: "esta vacio",
                non_empty: "no vacío",
                longer_than: "mas largo que",
                shorter_than: "más corto que",
                less_than: "menos que",
                less_or_equal: "Menos o igual",
                greater_than: "mas grande que",
                greater_or_equal: "mayor o igual",
            },
            planRequired: "{integratable} Plan requerido",
            noDefaultStoryTitle: "Historia predeterminada",
            noDefaultStory: "No hay una historia predeterminada.",
            noMessage: "Sin mensaje",
            loading: "Cargando",
            loadMore: "Carga más",
            hostname: "Nombre de host",
            goToStory: "ir a la historia",
            noResultFound: "No se han encontrado resultados",
            checkYourFilterCombination: "Revise su combinación de filtro",
            clearYourSearch: "borra tu búsqueda",
            andTryAgain: "e intenta de nuevo",
            allTemplates: "Todas las plantillas",
            allAITemplates: "Todas las plantillas de IA",
            templatesFromTheIndustry: "Plantillas de la industria",
            basicTemplate: "Plantilla básica",
            proTemplate: "Plantilla avanzada",
            withBot: "& Bot",
            userWithBot: "Usuario y bot",
            chatDetail: "Detalles del chat",
            allUserDetail: "Ver todos los detalles del usuario",
            sessionData: "Datos de sesión",
            supsisChatWidget: "Widget de chat de supsis",
            integratedWith: "Integrado con :",
            botStory: "Bot Story",
            integration: "Integración",
            Users: "Usuarios",
            user_id: "ID de usuario",
            categories: "Categorías",
            worksWith: "Funciona con",
            importBot: "Bot",
            keyFeatures: "Características clave",
            importing: "importador",
            comingSoon: "Muy pronto",
            pickStory: "Elige una historia",
            conversationId: "ID de conversación",
            integrateStoryWithSupsisWidget: "Integre el widget de supsis con la historia de chatbot",
            integrateStoryWithWhatsapp: "Integre WhatsApp con Chatbot Story",
            integrateStoryWithInstagram: "Integrar Instagram con Chatbot Story",
            selectIntegratingStory: "Seleccione la historia que se integrará",
            install: "Instalar",
            attr: {
                weekday: "Weekday",
                channelId: "Channel",
                email: "Correo electrónico",
                phone: "Teléfono",
                language: "Idioma",
                timezone: "Zona horaria",
                gender: "Género",
                country: "País",
                referrer: "Referente",
                department: "Departamento",
                url: "Url",
                ip: "Ip",
                last_seen: "Ultima vez visto",
                name: "Nombre",
                user_id: "ID de usuario",
                message: "Mensaje",
                akinon_brand: "Marca",
                akinon_order_id: "Solicitar ID",
                akinon_product_id: "ID del Producto",
                akinon_user_id: "ID de usuario",
                akinon_user_name: "Nombre de usuario",
                akinon_user_email: "Correo electrónico de usuario",
                akinon_invoice_url: "URL de factura",
                akinon_order_status: "Estado de pedido",
                akinon_order_price: "Precio del pedido",
                akinon_shipper_name: "Nombre del remitente",
                akinon_product_size: "Tamaño del producto",
                akinon_sku: "Sku",
                akinon_product_url: "URL del producto",
                akinon_product_title: "Titulo del producto",
                akinon_product_image: "Imagen del producto",
                akinon_product_stock: "Stock de productos",
                akinon_order_date: "Fecha de orden",
                akinon_track_number: "Número de pista",
                akinon_track_url: "URL de seguimiento",
                akinon_latitude: "Latitud",
                akinon_longitude: "Longitud",
                idleUserTime: "User Last Action (Second)",
                ai_class_result: "AI Class Result",
                meta_comment_id: "Meta Comment ID",
                meta_comment: "Meta Comment",
                meta_post_id: "Meta Post ID",
                ideasoft_user_id: "Member Id",
                ideasoft_invoice_url: "Invoice Url",
                ideasoft_order_id: "Sipariş Numarası",
                ideasoft_order_status: "Order Status",
                ideasoft_order_price: "Order Price",
                ideasoft_shipper_name: "Shipper Name",
                ideasoft_product_size: "Product Size",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Product Url",
                ideasoft_product_title: "Product Title",
                ideasoft_product_image: "Product Image",
                ideasoft_product_stock: "Product Stock",
                ideasoft_order_date: "Order Date",
                ideasoft_track_number: "Track Number",
                ideasoft_track_url: "Track Url",

                offline_mode: "Modo offline",
                available_agents: "Agentes disponibles",
                platform: "Plataforma",
                hour: "Hora",
                segments: "Segments",
                tags: "Etiquetas",
                ticket: "boleto",
                metaReferrals: "Metareferencias",
            },
            storyList: "Lista de historias",
            douYouWannaDeleteItem: "¿Quieres eliminar este artículo?",
            douYouWannaDeleteWithChildren: "¿Quieres eliminar este artículo con sus hijos?",
            stories: "Cuentos",
            templates: "Plantillas",
            aitemplates: "Plantillas de IA",
            integrations: "Integraciones",
            all: "Todo",
            installed: "Instalado",
            installationOK: "Instalado",
            uninstall: "Desinstalar",
            remainingMessageDesc: "Mensajes gratuitos restantes:",
            openAISiteRoutingDescStart: "Puede hacer clic en el enlace",
            openAISiteRoutingDescEnd: "Para obtener una clave API.",
            integrationOK: "Integrado",
            chatWidget: "Widget de chat de supsis",
            artificialIntelligence: "Inteligencia artificial",
            integratePlatform: "ChatBot se puede integrar con {integretable}.",
            integrateOpenAIWithChatbot: "Integre el chat gpt-4 con chatbot",
            integrateChatBotWithChatGPT3: "Integración de chatbot con chat gpt-4",
            integrateStoryWithTelegram: "Integre la historia con telegrama",
            webhooks: "Webhooks",
            archive: "Archivo",
            reports: "Informes",
            uncheckAll: "Desmarcar todo",
            userSegments: "Segmentos de usuario",
            addSegment: "Agregar segmento",
            addToSegment: "Agregar al segmento",
            removeFromSegment: "Eliminar del segmento",
            plansVTippyContent:
                "La facturación de este paquete se realizará al principio de cada mes y, en caso de que desee cancelar, se le cobrará su uso hasta el principio del mes y su paquete expirará.<br><br>El precio del paquete no incluye el IVA.<br><br>Los cambios en el paquete se reflejan en la factura al día siguiente.",
            segmentName: "Nombre de segmento",
            sameSegment: "¡Hay un segmento con el mismo nombre!",
            usersInSegment: "Usuarios en segmento",
            noUsersAdded: "No hay usuarios agregados",
            updateSegment: "Segmento de actualización",
            newSegment: "Nuevo segmento",
            selectAll: "Seleccionar todo",
            queriesSelected: "Consultas seleccionadas",
            noBlocksFound: "¡No se encontraron bloques!",
            userQuery: "Consulta de usuario",
            date: "Fecha",
            unmatched: "Sin par",
            goToChat: "Ir a chatear",
            selectStory: "Seleccionar historia",
            selectBlock: "Bloque de selección",
            training: "Capacitación",
            trainingAlert:
                "ra implementar los cambios que realizaste en la página de entrenamiento del bot, debes publicar la nueva versión del escenario que modificaste.",
            unmatchedPhrases: "Frases inigualables",
            ignored: "Ignorado",
            story: "Historia",
            timePeriod: "Periodo de tiempo",
            wholeTimeSpan: "Tramo de tiempo completo",
            selectAStory: "Seleccione una historia",
            searchUserQuery: "Buscar consulta de usuario",
            time: {
                today: "Hoy",
                yesterday: "Ayer",
                last7: "Los últimos 7 días",
                last30: "Últimos 30 días",
                "this-month": "Este mes",
                "last-month": "El mes pasado",
                "last-3-month": "Últimos 3 meses",
                "this-year": "Este año",
                "last-year": "El año pasado",
                custom: "Elija una fecha diferente",
            },
            emailProvider: "Proveedor de correo electrónico",
            triggerFromAnywhere: "Disparar desde cualquier lugar",
            allIntegrations: "Todas las integraciones",
            integrateYourCBwithChatWidget: "Integre su chatbot con el widget de chat.",
            integrateYourCBwithChatGpt3: "ChatBot se puede integrar con GPT-4. Se requiere la tecla API GPT-4.",
            integrateYourCBwithWebHook: "Pase la información de chat entre chatbot y sus servicios web con facilidad.",
            integrateYourCBwithIntegratable:
                "Pase la información de chat entre chatbot y {integratable} con facilidad.",
            addWebhook: "Agregar webhook",
            editWebhook: "Editar webhook",
            newWebhook: "Nuevo webhook",
            webhookTitle: "Título de webhook",
            webhookUrl: "URL de webhook",
            webhookToken: "Token webhook",
            webhookUsername: "Nombre de usuario de webhook",
            webhookPassword: "Contraseña de webhook",
            editBlock: "Editar",
            moveBlock: "Mover",
            copyBlock: "Copiar",
            addFilter: "Añadir filtro",
            addFilterGroup: "Agregar grupo de filtro",
            in: "en",
            and: "y",
            or: "o",
            chatbot: "Chatbot",
            allStories: "Todas las historias",
            addBot: "Crear bot",
            testBot: "Pon a prueba tu bot",
            publish: "Publicar",
            editName: "Editar nombre",
            search: "Busque en su historia ...",
            typeMoreThan3Char: "Escriba al menos 3 caracteres",
            expand: "Expandir",
            expandAll: "Expandir todo",
            noMatchingItem: "Sin elemento coincidente",
            hint: "Pista",
            select: "Seleccionar",
            navigate: "Navegar",
            dismiss: "Despedir",
            choseAttribute: "Elegir el atributo",
            selectReply: "Seleccionar respuesta",
            preview: "Avance",
            draft: "Borrador",
            lastUpdate: "Última actualización",
            published: "Publicado",
            newStory: "Nueva historia",
            updateStory: "Actualizar historia",
            storyDescription: "Descripción de la historia",
            storyTitle: "Título de historia",
            deleteSingleBlock: "Eliminar un solo bloque",
            deleteWithChildren: "Eliminar con los niños",
            startTestFromHere: "Comience la prueba desde aquí",
            copyBlockId: "Copiar ID de bloque",
            gotoLiveLink: "Ir a Live Link",
            copyBlockIdSuccessfull: "ID de bloque copiado en el portapapeles",
            collapse: "Colapsar",
            collapseAll: "Desplegar todo",
            snDelay: "{delay} retraso de sec",
            blockUpdated: "Bloque actualizado",
            addPayload: "Agregar carga útil",
            previewModeCaution:
                "Ahora estás previamente en una de las versiones de tu historia. ¡No puede guardar cambios en el modo de vista previa!",
            enterText: "Ingrese texto...",
            trackpad: "Pañuelo",
            navigation: "Navegación",
            navigationDesc: "Elija su modo de navegación. Depende de usted si será Trackpad o mouse.",
            botSetting: "Configuración de bot",
            botSettingDesc:
                "Establezca el nivel de confianza. Este es un porcentaje entre 0 y 100. El nivel define la corrección de ChatBot Interprets que están relacionados con las entradas del usuario.",
            languageSettingsDesc: "Asegúrese de que el lenguaje de Bot que responda es su lenguaje preferido.",
            mouse: "Ratón",
            Interactions: "Interacciones",
            Actions: "Comportamiento",
            Supsis_Actions: "Acciones de supsis",
            Shopify_Actions: "Acciones de Shopify",
            Akinon_Actions: "Acciones de Akinon",
            IdeaSoft_Actions: "Ideasoft Actions",
            START_POINT: "PUNTO DE PARTIDA",
            AI_ASSISTANT: "AI ASSISTANT",
            BOT_RESPONSE: "Respuesta de bots",
            AI_BOT_RESPONSE: "Respuesta de IA (GPT-4o)",
            AI_CLASSIFICATION: "AI CLASSIFICATION",
            Templates: "Template Blocks",
            AI_MENU_FLOW: "AI MENU",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "Fallback de forma predeterminada",
            FILTER: "FILTRAR",
            addNewFilter: "Agregar nuevo filtro",
            FLOW: "FLUIR",
            ATTACHMENT_INPUT: "Entrada adjunta",
            USER_INPUT: "ENTRADA DEL USUARIO",
            GO_TO_STEP: "Ir a un paso",
            WEBHOOK: "Webhook",
            SET_ATTRIBUTE: "Establecer atributo",
            QUESTION: "PREGUNTA",
            CLOSE_CHAT: "Chat cerrado",
            CREATE_TICKET: "CREATE TICKET",
            TRANSFER_CHAT: "Chat de transferencia",
            TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
            TAG_CHAT: "ADD TAG",
            REMOVE_TAG: "REMOVE TAG",
            SET_DEPARTMENT: "Departamento establecido",
            SEND_TRANSCRIPT: "Enviar transcripción",
            SEND_SMS: "SEND SMS", //todo translate
            SEND_MAIL: "SMS MAIL", //todo translate
            CREATE_EVENT: "CREATE EVENT", //todo translate
            CREATE_RESERVATION: "CREATE RESERVATION",
            RESERVATION_OPEN_URL: "Reservation Open Url",
            RESERVATION_SELECT_DAY: "Select reservation day",
            RESERVATION_SELECT_TIME: "Select reservation time",
            RESERVATION_EVENT_LIST: "Reservation list visitor",
            CREATE_TASK: "CREATE TASK",
            SHOPIFY_SHOW_PRODUCTS: "Shopify Show Products",
            SHOPIFY_PRODUCT_AVAILABILITY: "Disponibilidad del producto Shopify",
            SHOPIFY_ORDER_STATUS: "Estado del pedido de Shopify",
            AKINON_SHOW_PRODUCTS: "Productos de Akinon Show",
            AKINON_FIND_PRODUCT: "Akinon encontrar producto",
            AKINON_ORDER_STATUS: "Estado de orden de Akinon",
            AKINON_SELECT_ORDER: "Orden de selección de Akinon",
            AKINON_SELECT_SIZE: "Tamaño de selección de Akinon",
            AKINON_FIND_NEAREST_STOCK: "Stock de la tienda de exhibición",
            AKINON_FIND_NEAREST_STORES: "Mostrar tiendas más cercanas",
            AKINON_SHOW_DISCOUNT_CODES: "Mostrar códigos de descuento",

            IDEASOFT_SELECT_ORDER: "SELECT ORDER",
            IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
            IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",
            INSTAGRAM_COMMENT_REPLY: "RESPONDER AL COMENTARIO",
            INSTAGRAM_COMMENT_DELETE: "ELIMINAR COMENTARIO",
            INSTAGRAM_COMMENT_SHOW: "MOSTRAR COMENTARIO",
            INSTAGRAM_COMMENT_HIDE: "OCULTAR COMENTARIO",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "RESPONDER EN PRIVADO",
            followingAttributesFilled: "Se llenarán los siguientes atributos.",
            GET_LOCATION: "Obtener ubicación",
            FALLBACK: "RETROCEDER",
            SUCCESS: "ÉXITO",
            FAILURE: "FALLA",
            message: "Mensaje",
            condition: "Condición",
            score: "Puntaje",
            equal: "Igual",
            not_equal: "no es igual",
            contain: "Contener",
            not_contain: "No contiene",
            starts_with: "comienza con",
            ends_with: "termina con",
            empty: "vacío",
            longer_than: "mas largo que",
            shorter_than: "más corto que",
            less_than: "menos que",
            less_than_equal: "Menos que igual",
            greater_than: "mas grande que",
            greater_than_equal: "mayor que igual",
            value: "Valor",
            failures: "Fallas",
            email: "Correo electrónico",
            name: "Nombre",
            username: "Nombre de usuario",
            source: "Fuente",
            language: "Idioma",
            timezone: "Zona horaria",
            region: "Región",
            country: "País",
            referrer: "Referente",
            url: "Url",
            ip: "Ip",
            city: "Ciudad",
            lastSeen: "Ultima vez visto",
            userId: "ID de usuario",
            selectStep: "Seleccionar paso",
            keywords: "Palabras clave",
            userSays: "El usuario dice",
            addKeyword: "Agregar palabra clave",
            addUserMessage: "Agregar mensaje de usuario",
            set: "Colocar",
            to: "A",
            gender: "Género",
            go_to_failure: "Ir al fracaso",
            go_to_success: "Ir al éxito",
            untilFilled: "Hasta llenarlo",
            time1: "Una vez",
            time2: "2 veces",
            time3: "3 veces",
            time4: "4 veces",
            time5: "5 veces",
            any: "Cualquier",
            anytext: "Any Text",
            anytextDescription: "Matches only words + spaces",
            alphanumeric: "Alfanumérico",
            integer: "Entero",
            no: "No",
            number: "Número",
            phone: "Teléfono",
            yes: "Sí",
            yesNo: "Sí No",
            anyDescription: "Coincide con cualquier cosa que no sea vacía.",
            alphanumericDescription: "Coincide con letras y números",
            integerDescription: "Coincide con un número entero",
            noDescription: "Coincide sin sinónimos",
            numberDescription: "Coincide con el número ordinal y cardinal",
            phoneDescription: "Coincide con el número de teléfono",
            yesDescription: "Coincide con sí sinónimos",
            yesNoDescription: "Coincide con los sinónimos de sí y no",
            emailDescription: "Correo electrónico de coincidencias",
            urlDescription: "Mataña URL",
            temperature: "Temperatura",
            askWhenInvalid: "Pregunte cuando sea inválido",
            applyFilter: "Aplicar filtro",
            RANDOM_TEXT: "Texto aleatorio",
            QUICK_REPLY: "Respuesta rápida",
            FILE: "Archivo",
            notificationMessageStartSuccess: "El bloque",
            notificationMessageEndSuccess: "ha sido añadido",
            notificationMessageStartError: "Se produjo un error, el bloque",
            notificationMessageEndError: "no ha sido agregado",
            blockChangedWannaUpdate: "Quiero actualizar cambiado",
            responses: "Respuestas",
            TEXT: "Texto",
            IMAGE: "Imagen",
            GALLERY: "Galería",
            BUTTON: "Botón",
            flow: "Fluir",
            active: "Activo",
            passive: "Pasivo",
            chooseAttributeType: "Elija el tipo de atributo",
            imageAttachment: "Adjunto de imagen",
            audioAttachment: "Accesorio de audio",
            videoAttachment: "Accesorio de video",
            documentAttachment: "Adjunto de documentos",
            anyAttachment: "Cualquier apego",
            typeAttributeValue: "Tipo de valor de atributo",
            typeSearchValue: "Tipo de valor de búsqueda",
            addAttribute: "Agregar atributo",
            addAttributeDescription:
                "El nombre del atributo solo puede contener caracteres alfanuméricos que son letras A-Z, números 0-9, tablero o bajo.",
            male: "Masculino",
            USER_DATA: "Datos del usuario",
            CUSTOM_ATTRIBUTES: "Atributos personalizados",
            enterBotResponseHere: "Ingrese la respuesta de bot aquí ...",
            addCard: "Agregar tarjeta",
            addButton: "Botón Agregar",
            typeCardTitle: "Título de la tarjeta de tipo",
            typeCardDescription: "Tipo de descripción de la tarjeta",
            dragAndDropBrowse: "Arrastrar y soltar navegar",
            dragAndDropBrowseFile: "Subir archivo",
            button: "Botón",
            enterYourMessage: "Ingrese su mensaje",
            imageView: "Vista de imagen",
            imageUploading: "Carga de imágenes",
            fileUploading: "Carga de archivos ...",
            clickToChooseNewImage: "Haga clic para elegir una nueva imagen",
            clickToChooseNewFile: "Haga clic para elegir un archivo nuevo",
            removeTheExistingOne: "Eliminar el existente",
            validateResponseWithEntity: "Validar la respuesta con la entidad",
            actionOnFailureInput: "Acción sobre la entrada de falla",
            askNextQuestion: "Haga la siguiente pregunta",
            goToSuccessBlock: "Ir al bloque de éxito",
            goToFailureBlock: "Ir al bloque de falla",
            saveResposeToAttribute: "Guardar respuestas para atribuir",
            selectReplyType: "Seleccione Tipo de respuesta",
            questionVariants: "Variantes de preguntas",
            systemEntities: "Entidades del sistema",
            delay: "demora",
            retrySectionTextPart: "Preguntar",
            retrySectionText: ", si la respuesta del usuario no es válida",
            addNextQuestion: "Agregue la siguiente pregunta",
            typeBlockTitle: "Título del bloque de tipo",
            versionHistory: "Historial de versiones",
            restore: "Restaurar",
            versionName: "Nombre de la versión",
            restoreModalText:
                "Esta acción restaurará la versión seleccionada. ¿Estás seguro de que quieres restaurar esta versión?",
            restoreVersion: "Versión de restauración",
            newVersion: "Nueva versión",
            synonymMustBeUnique: "El sinónimo debe ser único",
            save: "Ahorrar",
            entries: "Entradas",
            youHaveNoEntries: "No tienes entradas",
            inputsCantBeEmpty: "Las entradas no pueden estar vacías",
            entryNamesMustBeUnique: "Los nombres de entrada deben ser únicos",
            entityNameMustBeUnique: "El nombre de la entidad debe ser único",
            synonyms: "Sinónimos",
            entities: "Entidades",
            title: "Título",
            entryName: "Nombre de entrada",
            entityhasbeenUpdatedSuccessfully: "La entidad se ha actualizado con éxito",
            emptyError: "Las entradas no pueden estar vacías",
            entityNameCantBeEmpty: "La entidad no puede estar vacía",
            allChats: "Todos los chats",
            paidChats: "Chats pagados",
            busiestPeriod: "Período más ocupado",
            ratingDistribution: "Distribución de calificaciones",
            allMessages: "Todos los mensajes",
            avarageMessages: "Mensajes de avaraje",
            popularity: "Popularidad",
            allUsers: "Todos los usuarios",
            interactionName: "Nombre de interacción",
            numberOfMessage: "Número de mensaje",
            ofAllUsersMessage: "% De todos los usuarios Mensaje",
            totalData: "Total de datos",
            avgData: "Datos de AVG",
            exportToCsv: "Exportar a CSV",
            exportToExcel: "Exportar a Excel",
            inMaintenance: "En mantenimiento",
            ADD_TO_SEGMENT: "Agregar al segmento",
            REMOVE_FROM_SEGMENT: "Eliminar del segmento",
            users: "Usuarios",
            webhookName: "Nombre de webhook",
            webHookUrl: "URL de webhook",
            webHookToken: "Token webhook",
            delete: "Borrar",
            basicAuth: "Autenticación básica",
            requiredFieldsCannotBeLeftBlank: "Los campos requeridos no se pueden dejar en blanco",
            headerValue: "Valor",
            yourVerificationToken: "Simbólico",
            yourWebHookName: "Tu nombre de webhook",
            yourWebHookUrl: "Tu URL webhook",
            enterKey: "Introducir clave",
            password: "Contraseña",
            saveSuccessfully: "Su transacción ha sido guardada con éxito",
            urlTypeError: "Complete el campo correctamente (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "OpenAI CHAT GPT-4 API Clave requerida.",
                apiKeyDesc:
                    "ChatBot + Chat GPT-4 La integración requiere la tecla API. Obtenga su API-Key o use la tecla API a continuación para probar. Puede usar solo 20 mensajes para la prueba.",
                getApiKey: "Poner la llave API de AI",
                typeApiKey: "Escriba la tecla API",
                ownApiKey: "PROPIA CLAVE DE API OPERAI",
                trialApiKey: "Clave de API de prueba (restringido como 20 mensaje)",
                useOurTrial: "Use nuestra prueba gratuita",
                twentyMessages: "Puede probar usando 20 mensajes como gratis.",
                enableChatGpt3: "Habilitar chat gpt-4",
            },
        },
        "Would you like to make default this story?": "#VALUE!",
        coupon: {
            code: "Código",
            discount: "Descuento",
            endDate: "Fecha final",
            name: "Nombre",
            email: "Correo electrónico",
            phone: "Teléfono",
            add: "Agregar cupón",
            coupons: "Cupones",
            couponDeleted: "Cupón eliminado",
            limit: "Límite",
            visitorBan: "El visitante ha sido bloqueado.",
            visitorUnBlock: "El bloqueo ha sido eliminado.",
        },
        instagramTitle: "Haga clic en el botón a continuación para habilitar las funciones de Instagram.",
        instegramFunctionActive: "Función de Instagram habilitadar",
        ChatBOT: "robot de chat",
        WhatsappContacts: "Contactos Whatsapp",
        InstagramContacts: "Contactos Instagram",
        MessengerContacts: "Messenger Contacts",
        volumeUp: "Sube el volumen",
        minimize: "Minimizar",
        maximize: "Maximizar",
        auditLogs: {
            auditLogsTitle: "Registros de auditoría",
            auditLogsSub:
                "Los registros de auditoría le permiten realizar un seguimiento de los eventos ocurridos en su empresa en los últimos 30 días.",
        },
        task: {
            workflow: "Flujo de trabajo",
            workflowDetail: "Detalles del flujo de trabajo",
            workflowPerm: "Permisos del flujo de trabajo",
            perm: "Permisos",
            detail: "Detalles",
            userPerm: "Permisos de usuario",
            deleteCard: "Eliminar tarjeta",
            createCard: "Crear tarjeta",
            editCard: "Editar tarjeta",
            dragCard: "Mover tarjeta",
            allWorkflow: "Todos los flujos de trabajo",
            createworkflow: "Crear flujo de trabajo",
            deleteWorkflow: "¿Estás seguro de que quieres eliminar este flujo de trabajo?",
            permEditTask: "No tienes permiso para editar esta tarea",
            permEditTaskDes: "Contacta a tu administrador para obtener permisos de edición.",
            createTaskError: "No tienes permiso para crear tareas",
            createTaskErrorDesc: "Contacta a tu administrador para obtener permisos para crear tareas.",
            moveTaskError: "No tienes permiso para cambiar el estado de la tarea",
            moveTaskErrorDesc: "Contacta a tu administrador para obtener permisos para cambiar el estado de la tarea.",
            deleteTaskError: "No tienes permiso para eliminar tareas",
            deleteTaskErrorDesc: "Contacta a tu administrador para obtener permisos para eliminar tareas.",
            permissionError: "No tienes permiso para crear tareas",
            permissionErrorDesc: "Por favor, contacta a tu administrador para obtener permisos de creación de tareas",
            whatsappContactProfileTitle: "Perfil de {name} / {number}",
            createTaskVisitor: "Crear tarea (visitante)",
            editWorkflow: "Editar flujo de trabajo",
            visitor: "Perfil del visitante",
            createTaskMessage: "Crear tarea (Mensaje)",
            createStage: "Crear etapa",
            stagesAndStatuses: "Etapas y estados",
            workflowCreateDesc: "Descripción del flujo de trabajo",
            subTasks: "Subtareas",
            followers: "Seguidores",
            collaborators: "Colaboradores",
            addRelations: "Agregar relaciones",
            relations: "Relaciones",
            main: "Principal",
            name: "Nombre",
            completedOfCheck: "{completed} de {total} tareas completadas",
            workflowUpdateMs: "Flujo de trabajo actualizado correctamente",
            taskUpdateMs: "Tarea actualizada correctamente",
            workflowCreatedMs: "Flujo de trabajo creado correctamente",
            workflowCreateError: "No se pudo crear el flujo de trabajo",
            taskCreatedMs: "Tarea creada correctamente",
            settingsDesc3:
                "Además, el módulo de tareas de Supsis le permite crear su propio flujo de trabajo con automatización personalizable, lo que le permite gestionar las tareas de manera más efectiva y mejorar la colaboración dentro del equipo.",
            settingsDesc4:
                "De esta manera, puede realizar un seguimiento detallado de cada una de sus tareas, asignar tareas a los miembros del equipo y en general administrar sus procesos comerciales de manera más eficiente. El módulo de tareas de Supsis le proporciona una solución integral para la gestión de tareas y la coordinación de equipos.",
            settingsDesc2:
                "El módulo de tareas de Supsis no deja ninguna tarea sin supervisión. Puede filtrar tareas según cualquier parámetro, hacer un seguimiento de las cargas de trabajo para cada etapa del flujo de trabajo y organizar su calendario para que se ajuste a sus horarios.",
            settingsDesc1:
                "El módulo de tareas le permite organizar el trabajo colaborativo, delegar tareas y hacer un seguimiento del progreso de su equipo. Puede personalizar sus tareas según sus necesidades seleccionando cualquier vista y crear sus propios flujos de trabajo personalizados con automatizaciones.",
            taskModuleSettingsTitle: "Configuración del módulo de tareas",
            high: "Alto",
            medium: "Medio",
            low: "Bajo",
            priority: "Prioridad",
            addExistsSubtask: "Agregar sub tarea existente",
            addSubtask: "Agregar sub tarea",
            add: "Agregar",
            newCheckList: "Nueva lista de verificación",
            subtaskTitle: "Título de la subtarea",
            view: "Ver",
            attachFiles: "Adjuntar archivos",
            createTaskDesc: "Descripción de la tarea",
            title: "Título",
            createWorkflow: "Crear flujo de trabajo",
            editTask: "Editar tarea",
            createTask: "Crear tarea",
            deleteColumnCont: "¿Estás seguro de que quieres eliminar esta columna?",
            changeStage: "Cambiar Etapa",
            assignees: "Asignados",
            owner: "Propietario",
            stage: "Etapa",
            writeSomething: "Escribe algo",
            selectAssginee: "Seleccionar destinatario",
            assignee: "Asignado",
            enterNewTaskDesc: "Ingrese la descripción de la nueva tarea",
            enterNewTaskTitle: "Ingrese el título de la nueva tarea",
            task: "Tarea",
            deleteTaskCont: "¿Estás seguro de que deseas eliminar estas tareas?",
            deleteWorkFlowCont: "¿Está seguro de que desea eliminar este flujo de trabajo?",
            completed: "Completado",
            todo: "Por hacer",
            kanbanBoard: "Tablero Kanban",
            listView: "Vista de Lista",
        },
        permissionErrors: {
            userCreate: "No tiene permiso para agregar usuarios. Por favor, consulte a su administrador.",
            userRead: "No tiene permiso para ver usuarios. Por favor, consulte a su administrador.",
            userUpdate: "No tiene permiso para actualizar usuarios. Por favor, consulte a su administrador.",
            userDelete: "No tiene permiso para eliminar usuarios. Por favor, consulte a su administrador.",
            visitorBlock: "No tiene permiso para bloquear visitantes. Por favor, consulte a su administrador.",
            visitorUnblock: "No tiene permiso para desbloquear visitantes. Por favor, consulte a su administrador.",
            visitorDetailRead:
                "No tiene permiso para ver detalles de visitantes. Por favor, consulte a su administrador.",
            visitorListRead:
                "No tiene permiso para ver la lista de visitantes. Por favor, consulte a su administrador.",
            visitorDelete: "No tiene permiso para eliminar visitantes. Por favor, consulte a su administrador.",
            visitorExcel: "No tiene permiso para obtener la salida de Excel. Por favor, consulte a su administrador.",
            visitorUpdate: "No tiene permiso para actualizar visitantes. Por favor, consulte a su administrador.",
            bannedVisitorRead:
                "No tiene permiso para ver la lista de visitantes bloqueados. Por favor, consulte a su administrador.",
            bannedWordCreate:
                "No tiene permiso para agregar palabras prohibidas. Por favor, consulte a su administrador.",
            bannedWordRead: "No tiene permiso para ver palabras prohibidas. Por favor, consulte a su administrador.",
            bannedWordDelete:
                "No tiene permiso para eliminar palabras prohibidas. Por favor, consulte a su administrador.",
            chatRead: "No tiene permiso para ver chats. Por favor, consulte a su administrador.",
            chatUpdate: "No tienes permiso para editar chats. Consulta con tu administrador.",
            archiveRead: "No tienes permiso para ver archivos. Consulta con tu administrador.",
            roleCreate: "No tienes permiso para agregar roles. Consulta con tu administrador.",
            roleRead: "No tienes permiso para ver roles. Consulta con tu administrador.",
            roleUpdate: "No tienes permiso para actualizar roles. Consulta con tu administrador.",
            roleDelete: "No tienes permiso para eliminar roles. Consulta con tu administrador.",
            departmentCreate: "No tienes permiso para agregar departamentos. Consulta con tu administrador.",
            departmentRead: "No tienes permiso para ver departamentos. Consulta con tu administrador.",
            departmentUpdate: "No tienes permiso para actualizar departamentos. Consulta con tu administrador.",
            departmentDelete: "No tienes permiso para eliminar departamentos. Consulta con tu administrador.",
            preparedContentCreate: "No tienes permiso para crear contenido preparado. Consulta con tu administrador.",
            preparedContentRead: "No tienes permiso para ver contenido preparado. Consulta con tu administrador.",
            preparedContentUpdate:
                "No tienes permiso para actualizar contenido preparado. Consulta con tu administrador.",
            preparedContentDelete:
                "No tienes permiso para eliminar contenido preparado. Consulta con tu administrador.",
            welcomeCreate: "No tienes permiso para crear mensajes de bienvenida. Consulta con tu administrador.",
            welcomeRead: "No tienes permiso para ver mensajes de bienvenida. Consulta con tu administrador.",
            welcomeUpdate: "No tienes permiso para actualizar mensajes de bienvenida. Consulta con tu administrador.",
            welcomeDelete: "No tienes permiso para eliminar mensajes de bienvenida. Consulta con tu administrador.",
            settingCreate: "No tiene permiso para crear ajustes. Por favor, consulte con su administrador.",
            settingRead: "No tiene permiso para ver ajustes. Por favor, consulte con su administrador.",
            settingUpdate: "No tiene permiso para actualizar ajustes. Por favor, consulte con su administrador.",
            settingDelete: "No tiene permiso para eliminar ajustes. Por favor, consulte con su administrador.",
            reportCreate: "No tiene permiso para crear informes. Por favor, consulte con su administrador.",
            reportRead: "No tiene permiso para ver informes. Por favor, consulte con su administrador.",
            reportUpdate: "No tiene permiso para actualizar informes. Por favor, consulte con su administrador.",
            reportDelete: "No tiene permiso para eliminar informes. Por favor, consulte con su administrador.",
            offlineSupportRequestCreate:
                "No tiene permiso para crear solicitudes de soporte sin conexión. Por favor, consulte con su administrador.",
            offlineSupportRequestRead:
                "No tiene permiso para ver solicitudes de soporte sin conexión. Por favor, consulte con su administrador.",
            offlineSupportRequestUpdate:
                "No tiene permiso para responder a solicitudes de soporte sin conexión. Por favor, consulte con su administrador.",
            offlineSupportRequestDelete:
                "No tiene permiso para eliminar solicitudes de soporte sin conexión. Por favor, consulte con su administrador.",
            catalogCreate: "No tiene permiso para crear catálogos. Por favor, consulte con su administrador.",
            catalogRead: "No tiene permiso para ver catálogos. Por favor, consulte con su administrador.",
            catalogUpdate: "No tiene permiso para actualizar catálogos. Por favor, consulte con su administrador.",
            catalogDelete: "No tiene permiso para eliminar catálogos. Por favor, consulte con su administrador.",
            chatbotStoryCreate:
                "No tiene permiso para crear historias de chatbot. Por favor, consulte con su administrador.",
            chatbotStoryRead:
                "No tiene permiso para ver historias de chatbot. Por favor, consulte con su administrador.",
            chatbotStoryUpdate:
                "No tiene permiso para actualizar historias de chatbot. Por favor, consulte con su administrador.",
            chatbotStoryDelete:
                "No tiene permiso para eliminar historias de chatbot. Por favor, consulte con su administrador.",
            chatbotTemplateRead:
                "No tiene permiso para ver plantillas de chatbot. Por favor, consulte con su administrador.",
            chatbotTemplateAiRead:
                "No tiene permiso para ver plantillas de chatbot de IA. Por favor, consulte con su administrador.",
            chatbotIntegrationsRead:
                "No tiene permiso para ver integraciones de chatbot. Por favor, consulte con su administrador.",
            chatbotArchiveRead:
                "No tiene permiso para ver archivos de chatbot. Por favor, consulte con su administrador.",
            chatbotEntitiesRead:
                "No tiene permiso para ver entidades de chatbot. Por favor, consulte con su administrador.",
            chatbotEntitiesCreate:
                "No tiene permiso para crear entidades de chatbot. Por favor, consulte con su administrador.",
            chatbotEntitiesUpdate:
                "No tiene permiso para actualizar entidades de chatbot. Por favor, consulte con su administrador.",
            chatbotEntitiesDelete:
                "No tiene permiso para eliminar entidades de chatbot. Por favor, consulte con su administrador.",
            chatbotReportRead:
                "No tienes permiso para ver los informes del chatbot. Por favor, contacta a tu administrador.",
            chatbotTrainRead:
                "No tienes permiso para ver el entrenamiento del chatbot. Por favor, contacta a tu administrador.",
            chatbotSegmentCreate:
                "No tienes permiso para crear segmentos de usuarios del chatbot. Por favor, contacta a tu administrador.",
            chatbotSegmentRead:
                "No tienes permiso para ver los segmentos de usuarios del chatbot. Por favor, contacta a tu administrador.",
            chatbotSegmentUpdate:
                "No tienes permiso para actualizar los segmentos de usuarios del chatbot. Por favor, contacta a tu administrador.",
            chatbotSegmentDelete:
                "No tienes permiso para eliminar los segmentos de usuarios del chatbot. Por favor, contacta a tu administrador.",
            integrationsRead:
                "No tienes permiso para ver la página de integraciones. Por favor, contacta a tu administrador.",
            whatsappIntegrationRead:
                "No tienes permiso para ver la página de integración de WhatsApp. Por favor, contacta a tu administrador.",
            instagramIntegrationRead:
                "No tienes permiso para ver la página de integración de Instagram. Por favor, contacta a tu administrador.",
            telegramIntegrationRead:
                "No tienes permiso para ver la página de integración de Telegram. Por favor, contacta a tu administrador.",
            integrationCreate: "No tienes permiso para activar integraciones. Por favor, contacta a tu administrador.",
            triggerCreate: "No tienes permiso para crear desencadenadores. Por favor, contacta a tu administrador.",
            triggerRead: "No tienes permiso para ver los desencadenadores. Por favor, contacta a tu administrador.",
            triggerUpdate:
                "No tienes permiso para actualizar los desencadenadores. Por favor, contacta a tu administrador.",
            triggerDelete:
                "No tienes permiso para eliminar los desencadenadores. Por favor, contacta a tu administrador.",
            billingRead: "No tienes permiso para ver las facturas. Por favor, contacta a tu administrador.",
            taskCreate: "No tienes permiso para crear tareas. Por favor, contacta a tu administrador.",
            taskRead: "No tienes permiso para ver tareas. Por favor, contacta a tu administrador.",
            taskUpdate: "No tienes permiso para actualizar tareas. Por favor, contacta a tu administrador.",
            taskDelete: "No tienes permiso para eliminar tareas. Por favor, contacta a tu administrador.",
            calendarCreate:
                "No tienes permiso para crear calendarios/reservas. Por favor, contacta a tu administrador.",
            calendarRead: "No tienes permiso para ver calendarios/reservas. Por favor, contacta a tu administrador.",
            calendarUpdate:
                "No tienes permiso para actualizar calendarios/reservas. Por favor, contacta a tu administrador.",
            calendarDelete:
                "No tienes permiso para eliminar calendarios/reservas. Por favor, contacta a tu administrador.",
            mailCreate: "No tienes permiso para crear correos electrónicos. Por favor, contacta a tu administrador.",
            mailRead: "No tienes permiso para ver correos electrónicos. Por favor, contacta a tu administrador.",
            mailUpdate:
                "No tienes permiso para actualizar correos electrónicos. Por favor, contacta a tu administrador.",
            mailDelete: "No tienes permiso para eliminar correos electrónicos. Por favor, contacta a tu administrador.",
        },
        message: {
            noConversationDesc: "Aquí puedes ver los chats activos y los chats asignados a ti.",
            forMe: "Para mí",
            unAssigned: "No asignado",
            agentDetails: "Detalles del agente",
            contactProperties: "Propiedades de contacto",
            goToProfile: "Ir al perfil",
            addNote: "Agregar nota",
            noPreferredAgent: "Aún no hay agente preferido",
            toPrefer: "Preferir",
            inChat: "En el chat",
            watching: "Viendo",
            chatsTitle: "Chats",
            dealyTimeMaxValueError: "El tiempo de retraso puede ser de un máximo de 15",
            dealyTimeTypeError: "El valor del tiempo de retraso debe ser un número",
            passedTimeHm: "{hour} Horas {min} Minutos",
            passedTimeMs: "{min} Minutos {sec} segundos",
            passedTimeSc: "{sec} Segundos",
            translateMessage: "Tu mensaje ha sido traducido por inteligencia artificial.",
            toneChanged: "El tono del mensaje cambió a {tone}",
            aiResponseAdded: "Respuesta de IA añadida al mensaje",
            messageLonger: "Mensaje hecho más largo",
            grammarFixed: "Gramática corregida",
            aiTranslate: "Traducción",
            other: "Otro",
            yourLanguage: "Tu idioma",
            myLanguage: "Mi idioma",
            forwardToChatbot: "Reenviar al Chatbot",
            friendly: "Amistoso",
            confident: "Confiado",
            straightForward: "Directo",
            casual: "Casual",
            professional: "Profesional",
            longSentence: "Frase Larga",
            changeTone: "Cambiar Tono",
            fixGrammar: "Corregir Gramática",
            aiResponse: "Respuesta de IA",
            templateButtonNote:
                "Para prohibir el contacto, tenga cuidado de usar los siguientes textos en el botón de prohibición. Independientemente de las letras mayúsculas o minúsculas",
            templateButtonTags: "#Enviar mensaje# | #Darse de baja# | #Prohibir# | #Bloquear#",
            dashboard: "Tablero de control",
            calendarModule: "Módulo de calendario",
            taskModule: "Módulo de gestión de tareas",
            maxUrlButtonMessage: "You can add a maximum of 2 URL buttons.",
            noPreferredDepartment: "No hay departamento preferido",
            searchForDepartment: "Buscar departamento",
            departmentAssignedToTheVisitor: "Seleccione el departamento que desea asignar al visitante.",
            assignPreferredDepartment: "Asignar departamento preferido",
            smsChannel: "Canal SMS: ",
            whatsappv2Channel: "Canal Whatsapp V2: ",
            whatsappv1Channel: "Canal Whatsapp V1: ",
            wBChannel: "Canal Whatsapp Business: ",
            messengerChannel: "Canal Messenger: ",
            instagramChannel: "Canal Instagram: ",
            allPlatforms: "Todas las plataformas",
            cbStartMessage: "Mensaje de inicio del chatbot",
            cbStartMessageDesc:
                "El primer mensaje ingresado por el usuario es procesado automáticamente por el chatbot y dirigido a la dirección relevante.",
            messengerUserProfile: "Perfil de usuario de Messenger",
            instagramUserProfile: "Perfil de usuario de Instagram",
            noEventFound: "No se encontraron eventos",
            visitorMails: "Correos de visitantes",
            visitorActions: "Acciones de visitantes",
            notVerified: "No verificado",
            visitorEvents: "Eventos de visitantes",
            assignedTasks: "Tareas asignadas",
            mails: "Correos",
            prefferedAgents: "Agentes preferidos",
            createEvent: "Crear evento",
            blockManagement: "Gestión de bloqueo",
            deleteUser: "Eliminar usuario",
            blocked: "Bloqueado",
            profiles: "Perfiles",
            similiarProfiles: "Perfiles similares encontrados",
            ReplyAsAPm: "Responder como mensaje privado y cerrar",
            replyAsAComment: "Responder como comentario y cerrar",
            messengerAddDesc: "Haz clic en el botón Conectar a continuación e inicia sesión en tu cuenta de Facebook.",
            instaAddPrivacyCheckDesc: "He leído y acepto la {Privacy} y las {Terms and Conditions}",
            instaAddDesc5: "Haz clic en el botón Conectar a continuación e inicia sesión en tu cuenta de Facebook.",
            instaAddDesc4: "Regístrese como desarrollador de Facebook",
            instaAddDesc3: "Asegúrese de que el interruptor <b>'Permitir acceso a los mensajes'</b> esté activado",
            instaAddDesc2: "Asegúrese de que su cuenta profesional de Instagram esté conectada a su página de Facebook",
            instaAddDesc1:
                "Asegúrese de que su cuenta de Instagram sea una cuenta profesional de Instagram (cuenta comercial).",
            selectedDepartment: "Departamento seleccionado",
            departmentForwardEnable: "Regla de reenvío de departamento habilitada",
            departmentForwardRule: "Regla de reenvío de departamento",
            departmentForwardDesc: "Seleccione a qué departamento se redirigirán los chats entrantes en el canal.",
            channelName: "Nombre del canal",
            forwardToLiveAgents: "👉 Reenviar a agentes en vivo",
            manageIgChannel: "Administra tu canal de Instagram",
            igDetail: "Detalle de Instagram",
            manageVisibilityDesc: "Administrar quién puede ver este canal",
            selectAnIgAccount: "Seleccione una cuenta de Instagram",
            connectToInsta: "Conectar a Instagram",
            connectToMetaLeads: "Connect to Meta Leads",
            deleteInstaChannelInfo: "¿Estás seguro de que quieres eliminar el canal de Instagram?",
            instagramChannels: "Canales de Instagram",
            suspendedDescription: "Su cuenta ha sido suspendida debido a facturas impagas.",
            onlyChatbot: "Solo chatbot",
            onlyAgents: "Solo agentes",
            checkboxWarning: "Este campo debe estar marcado obligatoriamente",
            sendingAllow: "Envío",
            receiving: "Recepción",
            platform: "Plataforma",
            banModalTitle: "Modal de prohibición de visitantes",
            selectDepartmentDesc: "Seleccione los departamentos cuya visibilidad desea cambiar",
            selectAgentDesc: "Seleccione los agentes cuya visibilidad desea cambiar",
            selectDepartment: "Seleccionar departamento",
            selectAgent: "Seleccionar agente",
            visibleDepartments: "Departamentos visibles",
            visibleAgents: "Agentes visibles",
            visibilityInfoCont: "Todos los agentes y departamentos pueden ver este canal",
            editDepartmentVisibility: "Editar visibilidad del departamento",
            editAgentVisibility: "Editar visibilidad del agente",
            typeSTToSearch: "Escriba algo para buscar usuarios",
            exportToCSV: "Exportar a CSV",
            clear: "Limpiar",
            usedSessionCount: "Cantidad de sesiones utilizadas",
            maxSessionCount: "Cantidad máxima de sesiones",
            leftSessionCount: "Cantidad de sesiones restantes",
            planManagement: "Gestión de planes",
            teamChat: "Chat de equipo",
            templateNameIsNotValid: "El nombre de la plantilla no es válido",
            relatedAdvertisement: "Anuncio relacionado",
            whatsappNumber: "número de whatsapp",
            integrationsWhatsappV1:
                "Se requiere un plan de WhatsApp para una comunicación sin problemas entre Supsis y WhatsApp.",
            integrationsWhatsappV2: "Puedes compartir fácilmente información de chat entre Supsis y WhatsApp.",
            integrationsWhatsappBusiness:
                "Puedes transmitir información de chat de manera rápida y conveniente entre Supsis y WhatsApp.",
            selectDays: "Seleccionar días",
            addTime: "Agregar tiempo",
            instagramContactList: "Lista de contactos de Instagram",
            archiveAllRated: "Recuperar todas las conversaciones con cualquier calificación.",
            allChannels: "Todos los canales",
            comment: "comentario",
            news: "Novedades",
            conversation: "charla en equipo",
            speechTermination: "finalizar conversación",
            noSystemMessage: "Aún no hay mensajes en el sistema!",
            supsisCustomerService: "Atención al cliente proporcionada por Supsis,",
            supsisClickExperience: "puedes probar la experiencia haciendo click.",
            customerPage: "puedes probar la experiencia haciendo click",
            buttonTitle: "Título del botón",
            buttonType: "Tipo de botón",
            buttonSendMessage: "enviar mensaje",
            buttonGoToBlock: "ir al blog",
            buttonOpenUrl: "Abrir URL",
            buttonPhoneCall: "llamada telefonica",
            buttonOpenMoment: "Momento abierto",
            buttonCloseChat: "Cerrar charla",
            buttonTransferChat: "Transferir chat",
            buttonCreateTicket: "Crear Ticket",
            deleteVisitor: "¿Está seguro de que desea eliminar el usuario? Esta acción no se puede deshacer.",
            userProfile: "Perfil",
            addCalendarEvent: "Evento +",
            you: "Tú",
            and: "y",
            apiIntegration: "Desarrollador",
            generateToken: "Generar Token",
            copyToken: "Copiar Token",
            dndBlocked: "Configuración de envío de archivo apagado.",
            labels: "Etiquetas",
            noData: "Sin datos",
            CHAT: "Charlar",
            color: "Color",
            titleColor: "Color del título",
            secondTitleColor: "Color del segundo título",
            tag_name_indicator: "Nombre de etiqueta",
            sendMessage: "Enviar mensaje",
            removeFromG: "Sacar del grupo",
            delChannel: "¿Estás seguro de que deseas eliminar este canal?",
            new_name: "Nuevo nombre",
            set_group_info: "Editar información del grupo",
            shortcut_desc_num: "Cambie entre conversaciones activas con dígitos numéricos",
            copilot_desc_num: "Le permite abrir Copilot en la pantalla de chat.",
            typing_w_chat: "er schreibt...",
            edit_group_info: "Editar la información del grupo",
            notif_sound: "Activar los sonidos de notificación",
            notif_mute: "Silenciar notificaciones",
            leave: "Salir",
            group: "Grupo",
            updateTag: "Actualizar etiqueta",
            ordered_desc: "Asigna chats a los representantes en orden.",
            random_desc: "Asigna chats a los representantes al azar.",
            Rrobin_desc:
                "Asigna chats a los representantes de manera circular. (Prioriza a los representantes menos ocupados)",
            RrobinRev_desc:
                "Asigna chats a los representantes de manera circular inversa. (Prioriza a los representantes más ocupados)",
            algo_desc: "Seleccione el algoritmo para la asignación automática de chats",
            algorithm: "Algoritmo",
            os_browser: "Sistema operativo y navegador",
            addTag: "Añadir etiqueta",
            tags: "Etiquetas",
            searchRepresentative: "Buscar representante",
            preferredRepresentative: "Representantes",
            voting: "Votación",
            chatWidget: "Widget de chat de supsis",
            webhooks: "Webhooks",
            selectHooks: "Seleccionar ganchos web",
            planRequired: "{integratable} Plan requerido",
            allIntegrations: "Todas las integraciones",
            disableAgentSystemMessages: "Ocultar mensajes del sistema de agente",
            disableAgentSystemMessagesDesc: "Ocultar mensajes del sistema del agente.",
            disableAutoTranslate: "Auto Translate",
            disableAutoTranslateDesc:
                "It automatically translates messages from different languages. So you can communicate with your customers more easily.",
            shouldAddMethod: "¡Debe completar el método de pago y el campo de la dirección de facturación!",
            approveSelection: "Aprobar la selección",
            trialDaysEndSelectPlan: "Confirmar la selección del plan",
            trialDaysEndSelectPlanDesc:
                "Tu versión de prueba ha terminado. Debe confirmar seleccionando el plan a continuación.",
            infoAboutAnnouncement: "Breve información sobre el anuncio",
            announcement: "Anuncio",
            newAnnouncementForm: "Nuevo formulario de anuncio",
            newAnnouncement: "Nuevo anuncio",
            announcements: "Anuncios",
            newTicketSound: "Nuevo boleto",
            vtippyDepartmentNotification:
                "Configuración de notificaciones para mensajes de la conversación del departamento",
            vtippyGroupNotification: "Configuración de notificaciones para mensajes de grupos creados",
            vtippyTicketNotification: "Configuración de notificaciones para cada nuevo ticket que reciba",
            vtippyAnnouncemenNotification: "Configuración de notificaciones para los nuevos anuncios",
            languageSelection: "Selección de idioma",
            announcementTitle: "Título de anuncio",
            infinitePlay: "Jugar continuamente",
            hideBubbleOnMobile: "Esconderse en el móvil",
            vtippyHideBubbleOnMobile: "La burbuja de chat está oculta de los usuarios móviles.",
            deleteSystemLanguage: "Eliminar {code} lenguaje del sistema",
            assignedChat: "Chat asignado",
            check: "Casilla de verificación",
            systemStatus: "Estado del sistema",
            chatAssignedToUser: "Nuevo chat asignado",
            inactiveThresholdTime: "Tiempo de chat inactivo (minuto)",
            tippyInactiveThresholdTime:
                "Si no se envía ningún mensaje dentro del tiempo dado, la conversación se considera inactiva. Ingrese el valor (actas). Debe ser un rango en 1min - 120 minutos.",
            inactiveTerminateTime: "El chat inactivo termina la duración (minuto)",
            tippyInactiveTerminateTime:
                "El chat inactivo se terminará si no cambia al modo activo dentro de un tiempo determinado. Ingrese el valor (actas). Debe ser un rango en 1min - 120 minutos.",
            removePendingMessage: "Cancelar envío de mensajes",
            disconnected: "Desconectado",
            visitorWriteEmptyChatTippy: "El cliente puede escribir en conversación antes de que el agente se conecta.",
            visitorWriteEmptyChat: "El cliente puede escribir sin el agente conectado.",
            visitorConnectionEventSystemMessageEnabled:
                "Mensajes del sistema de estado de conexión del visitante Habilitar mensajes",
            visitorConnectionEventSystemMessageEnabledTippy:
                "Visitante a la izquierda y mensajes del sistema de regreso de visitantes Habilitar los mensajes",
            openBubble: "Burbuja",
            showHeaderImage: "Mostrar imagen de encabezado",
            askQuestion: "Hacer una pregunta",
            locationPermsNeeded: "Se necesitan permisos de ubicación para usar esta función",
            useMyLocation: "Usa mi ubicación",
            acceptingChat: "Aceptar chats",
            notAcceptingChat: "No aceptar chats",
            blockBy: "Prohibido por",
            languageRemovalQuestion: "¡Estás a punto de eliminar el lenguaje {code} del sistema!",
            loggedOut: "Desconectado",
            vtippyNewVisitorNotification: "Notificación audible para cada nuevo visitante en su sitio web",
            vtippySelectnotification: "Puede elegir el sonido de notificación.",
            vtippyVoiceLevel: "puedes ajustar el volumen",
            vtippyStartVoice: "Escuchar",
            vtippyInfiniteNotification:
                "Si no está activo en el nuevo panel de chats, continuará jugando. Puede editar Active-Passive haciendo clic.",
            vtippyTranslateButton: "Traduce el idioma seleccionado a otros idiomas",
            vtippyTranslateClearButton: "Limpia el contenido en otros idiomas.",
            vtippyNewChatNotification:
                "Puede seleccionar notificación de sonido para nuevas conversaciones que lleguen al sistema y ajustar el volumen.",
            vtippyNewConversationNotification:
                "Puede elegir una notificación de sonido y ajustar el volumen para cuando se le asignen nuevas conversaciones entrantes.",
            vtippyNewMessageNotification:
                "Puede seleccionar notificaciones para mensajes entrantes en sus conversaciones y ajustar el volumen.",
            vtippyPrivateMessageNotification:
                "Puede seleccionar una notificación para el mensaje entrante para la charla del equipo.",
            hideInactiveAgents: "Ocultar agentes inactivos",
            hideMinorValues: "Ocultar valores menores",
            hashHintMessage: "Puede ingresar rápidamente atajos de hashtag con #hash",
            pmHintMessage: "¿Sabía que puede enviar un mensaje privado de palabra clave? por ejemplo, PM: Hola",
            shortcutHintMessage: "¿Sabía que puede enviar mensajes más rápido con mensajes de acceso directo?",
            switchBetweenConversations: "¿Sabía que puede cambiar rápidamente entre conversaciones con atajos de ABC?",
            atNameHintMessage: "¿Sabía que puede ingresar rápidamente el nombre del visitante con @name?",
            dndHintMessage: "Puede cargar archivos con arrastrar y soltar.",
            pasteFile: "Puede enviar archivos.",
            atEmailHintMessage: "¿Sabía que puede ingresar rápidamente el correo visitante con @mail?",
            pastePlainText: "Pegar del portapapeles como texto sin formato",
            pressAndTalk: "Press and talk",
            agentActivities: "Actividades de agente",
            listStatuses: "Estado",
            newHASHContent: "#Add hash",
            hash: "Hashtag",
            hashText: "Texto hash",
            exampleHash: "rastreo de orden",
            notValidHash: "No debe contener espacios.",
            websiteChatWidgetIntegration: "Integración de widgets de chat del sitio web",
            videoCallEnabledDesc: "Active para habilitar la función de videollamada.",
            videoCallEnabled: "Función de videollamada",
            audioCallDesc: "Active para habilitar la función de búsqueda de voz.",
            audioCallEnabled: "Función de búsqueda de voz",
            assignPreferredAgent: "Asignar agente preferido",
            representativeAssignedToTheVisitor: "Seleccione el agente preferido que desea asignar al visitante.",
            agentFileSendEnabledDesc: "Habilita la capacidad de enviar archivos a los delegados",
            agentFileSendEnabled: "Los representantes pueden enviar archivos",
            visitorFileSendEnabledDesc: "Le permite activar o desactivar la función de envío del archivo de visitantes",
            visitorFileSendEnabled: "Los visitantes pueden enviar archivos",
            visitorAutoLogin: "Inicio de sesión automático de visitantes",
            visitorAutoLoginDesc:
                "Inicie automáticamente la conversación Cuando el visitante haga clic en la burbuja de chat",
            agentVoiceRecordEnabledDesc: "Permite a los agentes grabar audio",
            agentVoiceRecordEnabled: "Los agentes pueden grabar audio",
            visitorVoiceRecordEnabledDesc: "Permite a los visitantes grabar audio",
            visitorVoiceRecordEnabled: "Los visitantes pueden grabar audio",
            startVideoCall: "Videollamada",
            startAudioCall: "Llamada de voz",
            visitorGDPRDeleteEnabledDesc:
                "Le permite alternar la capacidad de eliminar la información de todos los visitantes",
            visitorGDPRDeleteEnabled: "Los visitantes pueden eliminar toda su información",
            visitorLocationEnabled: "Los visitantes pueden compartir la ubicación",
            visitorLocationEnabledDesc: "Permite a los visitantes activar o desactivar la ubicación",
            customerLocationEnabled: "Los representantes pueden compartir la ubicación",
            customerAutoMergeEnabled: "Fusiona automáticamente a las mismas personas",
            customerAutoMergeEnabledDesc:
                "Esta función realiza una fusión automática para reunir de manera efectiva los datos relacionados con las mismas personas. Esto garantiza que los usuarios con perfiles similares estén representados de manera más consistente y ordenada en los conjuntos de datos.",
            chatAiCopilot: "Copiloto de Chat IA",
            chatAiCopilotDesc:
                "Responde automáticamente a las preguntas de tus clientes utilizando el Copiloto de Chat IA",
            customerLocationEnabledDesc: "Permite a los representantes activar o desactivar la ubicación",
            triggerAlreadyExists: "El desencadenante ya existe",
            ticketStatusForm: "Formulario de estado del boleto",
            statusFormTitle: "Título del estado del boleto",
            allStatus: "Todos los estados",
            triggers: "Desencadenantes",
            trigger: "Desencadenar",
            noTrigger: "Todavía no has agregado ningún desencadenante",
            triggerSkipLoginForm: "Formulario de inicio de sesión",
            triggerSkipLoginFormTrue: "Mostrar formulario de inicio de sesión",
            triggerSkipLoginFormFalse: "Saltar formulario de inicio de sesión e ir directamente al mensaje",
            noContent: "sin contenido",
            toCreate: "Crear",
            clickTheButton: "clic en el botón",
            triggerContent:
                "Escriba la descripción que desea aparecer en el modal que se abre. Solo necesita escribir en un idioma y la traducción a otros idiomas se realiza automáticamente.",
            triggerDrag: "Puede ajustar la duración del mensaje arrastrando o haciendo clic en la barra.",
            triggerNewCondition: "Puede agregar una nueva condición con el botón.",
            triggerNoConditionDescription1:
                "Puede crear las condiciones que desea de las opciones. Si no crea ninguna condición para ningún disparador, el primer desencadenante estará activo.",
            triggerNoConditionDescription2:
                "Solo uno de los desencadenantes con las mismas condiciones aparece en la página del visitante.",
            triggerShowAndHide: "Puede mostrar u ocultar disparadores cuando lo desee.",
            countryLanguage: "País/idioma",
            addTrigger: "Agregar disparador",
            yesPlease: "¡Sí, por favor!",
            noThanks: "No, gracias.",
            firstAnswer: "Diálogo de preguntas Confirmar respuesta",
            secondAnswer: "PREGUNTA diálogo descartar respuesta",
            noTitle: "Sin titaje",
            sumChat_MediaFile: "Medios y documentos",
            importantWarning: "¡ADVERTENCIA IMPORTANTE!",
            images: "Imágenes",
            URLS: "Enlaces",
            files: "Ficheros",
            noCondition: "¡Sin condicion! Puede agregar condiciones haciendo clic en el icono más.",
            showTriggers: "Haga clic para mostrar disparadores",
            showThisTrigger: "Haga clic para mostrar este disparador",
            hideTriggers: "Haga clic para ocultar disparadores",
            hideThisTrigger: "Haga clic para ocultar este disparador",
            updateTrigger: "Actualizar disparador",
            conditions: "Condiciones",
            messageDurationPerRow: "Duración del mensaje por fila",
            updateCompleted: "Actualización completada",
            CatalogUpdatedSuccessfully: "Catálogo actualizado con éxito",
            integrateSupsiswithIntegratable: "Pase la información de chat entre supsis y {integratable} con facilidad.",
            installationOK: "Instalado",
            dayTime: "Hora",
            weekDay: "Día de la semana",
            spendTimePage: "Pasé tiempo en la página",
            spendTimeSite: "Pasé tiempo en el sitio",
            pageUrl: "URL de la página",
            pageTitle: "Título de la página",
            equal: "Igual",
            not_equal: "No es igual",
            less_than: "Menos que",
            greater_than: "Mas grande que",
            less_than_or_equal: "Menor o igual",
            greater_than_or_equal: "Mayor que o igual",
            visitorName: "Nombre del visitante",
            seconds10: "10 segundos",
            seconds30: "30 segundos",
            minute1: "1 minuto",
            minutes5: "5 minutos",
            minutes10: "10 minutos",
            minutes30: "30 minutos",
            hour1: "1 hora",
            hours2: "2 horas",
            hours4: "4 horas",
            hours8: "8 horas",
            hours12: "12 horas",
            hours24: "24 horas",
            maxCondition: "Condición máxima",
            doYouWishToDeleteTrigger: "¿Desea eliminar el gatillo?",
            contains: "Contiene",
            not_contains: "No contiene",
            chatLanguage: "Lenguaje de chat",
            translating: "Traductorio",
            buyWhatsapp: "Comprar integración de WhatsApp",
            liveSupportStartingWait: "Comenzando el soporte en vivo, espere",
            noConnection: "¡Sin conexión!",
            integrations: "Integraciones",
            refundInvoiceSure: "¿Estás seguro de que quieres devolver la factura?",
            invoiceMarkedAsPaidSuccess: "La factura ha marcada como pagada con éxito",
            invoiceMarkedAsPaidError: "Error, la factura no ha marcado el pago",
            deleteConfirm: "¿Quieres eliminar este {object}?",
            markPaidConfirm: "¿Estás seguro de Mark como pagó esta factura?",
            addLink: "Enlace",
            startChatDesc: "Iniciar conversación",
            selectStep: "Seleccione un paso:",
            addGOTO: "Ir a",
            sendFastLink: "Enviar enlace rápido",
            or: "O",
            allTags: "Todas las etiquetas",
            showDetail: "Mostrar detalle",
            hideDetail: "Ocultar detalle",
            weLlSendPhone: "Enviaremos a tu teléfono",
            weLlSendEmail: "Enviaremos a su correo electrónico",
            linkSentToPhone: "Enlace enviado como SMS",
            offerlinkSendToPhone: "Le enviaremos el enlace de descarga de nuestra aplicación a través de SMS.",
            offerlinkSendToMail: "Le enviaremos el enlace de descarga de nuestra aplicación por correo electrónico.",
            theEmail: "Mi correo electrónico registrado",
            differentEmail: "Otro correo electrónico diferente",
            linkSentToMailBox: "El enlace se envió a su dirección de correo",
            errorOccurred: "Ocurrió un error !",
            clickStoreIcon: "Puede acceder a la aplicación móvil haciendo clic en el icono adecuado para su teléfono.",
            meetWithSupsis: "¿Le gustaría cumplir con nuestra aplicación móvil de supsis?",
            downloadMobileApps: "Descargar la aplicación móvil",
            getApps: "Obtener aplicaciones",
            info: "Información",
            conversationHistory: "Historial de conversación",
            planInfoHeader: "Información sobre la información",
            planInformation: "Su plan es {selectedPlan} ({detailMaxAgentCount} agente) ({freeAgent} )",
            creditAvailable: "Su crédito de agente disponible en su plan:",
            upDownGradePlan: "Si desea actualizar/degradar su plan, por favor",
            click: "Hacer clic",
            autoStartChat: "Inicio de chat automático",
            bubbleColor: "Color de burbujas de chat",
            openFolder: "Carpeta abierta",
            preDefined: "Temas",
            customIcon: "Instalar desde su computadora",
            theme: "Tema",
            themeSettings: "Ajustes de tema",
            chatThemeSettings: "Edición de tema de chat",
            bubbleSettings: "Configuración de burbujas de chat",
            inputHeightOfBubble: "Tamaño de burbuja",
            inputPixelsOfChatBubble: "Haga clic para editar distancias de burbuja de chat a los bordes",
            modalTitleIsMarginAsPixelInfo: "Distancias de burbuja de chat a los bordes:",
            inputPxOfXaxis: "Posicion horizontal",
            inputPxOfYaxis: "Posición vertical",
            inputPxOfMobileXaxis: "(Mobil) posición horizontal",
            inputPxOfMobileYaxis: "(Mobil) posición vertical",
            animations: "Animaciones",
            preferredAnimation: "Animación preferida",
            selectAnAnimation: "Seleccione una animación",
            inputOfBubbleMessage: "Agregue contenido a enormes burbujas de chat.\n{contentOfChatBubble}",
            showChatBubbleOnlyLoggedUserToolTip:
                "Es la configuración para ocultar la burbuja de chat en función del estado de inicio de sesión. Muestado a todos los visitantes en caso de que se desactiven.",
            showChatBubbleOnlyLoggedUser: "Mostrar burbuja solo para iniciar sesión en el usuario. (Ideasoft)",
            helloDoUNeedHelp: "Hola, ¿necesitas ayuda?",
            bubbleIcon: "Imagen de burbujas de chat",
            overrideMargins: "Personalizar márgenes",
            autoHideBubble: "Ocultar burbuja de chat",
            vtippyAutoHideBubble: "Oculta la burbuja de chat cuando los agentes están fuera de línea",
            hideBubble: "Desactivar burbuja de chat",
            vtippyHideBubble: "Desactiva la burbuja de chat.",
            overrideMobileMargin: "Personalizar márgenes para dispositivos móviles",
            vtippyMobileMargin: "Personalizar márgenes para dispositivos móviles",
            isFabsActive: "Mostrar botón de acción flotante",
            bubbleOpenableMenu: "Desendo de chat de burbujas",
            vtippyIsFabsActive: "Configuración del botón Show / Ocult Floating Action",
            vtippyIsFabsAsIcon: "Es la configuración de si los iconos aparecerán en el menú desplegable.",
            isFabsAsIcon: "Mostrar íconos de menú.",
            setMarginAsPixel: "Establecido como píxel",
            returnDefaultMargins: "Configuración de margen predeterminada",
            deleteSite: '¿Quieres eliminar el sitio "{siteName}"?',
            deleteThisSite: "Eliminar el sitio",
            assetOversizeWithExt: "El tamaño del archivo debe ser inferior a 10 MB y en formato PNG, JPG.",
            closeChat: "Mensajes finales",
            ticket: "Boleto",
            formStep: "Paso de formulario",
            menuStep: "Paso de menú",
            contentStep: "Paso de contenido",
            menuTitle: "Título de menú",
            messageContent: "Contenido del mensaje",
            goToLive: "Transferir a representante",
            prevStep: "Volver al paso anterior",
            button: "Botón",
            addImage: "Imagen",
            addText: "Texto",
            stepTitle: "Título de paso",
            addTicket: "Boleto",
            formDescription: "Pregunta",
            addInput: "Pregunta",
            addRandomText: "Texto aleatorio",
            calendarPassedTimeMinSec: "{min} minuto {sec} segundo {nombre}",
            calendarPassedTimeSec: "{hora} hora {min} minuto {sec} segundo {nombre}",
            updateUserName: "Actualizar el nombre de usuario",
            forgotPassword: "Has olvidado tu contraseña",
            osrFromMessageSaved: "Mensaje fuera de línea guardado.",
            requiredField: "Este campo es obligatorio.",
            nightModeOn: "Modo nocturno en",
            catalogMenu: "Menú",
            catalogContent: "Contenido",
            all: "Todo",
            allDepartments: "Todos los departamentos",
            preferredLanguage: "Idioma preferido",
            kmkAutoDepartmentBind: "KMK Auto DeParment Find",
            kmkAutoDepartmentBindDesc:
                "Búsqueda del vendedor en los sitios de clientes de KMK y se establece en la página de inicio de sesión como departamento",
            visitorEmailUpdated: "Correo electrónico del visitante actualizado",
            visitorEmailIsNotValid: "El correo electrónico del visitante no es válido",
            visitorNameUpdated: "Nombre del visitante actualizado",
            clickToEdit: "Haz click para editar",
            addEmail: "+ Agregar correo electrónico",
            addFullname: "+ Agregar Name Full",
            partner: "¿Árbitro?",
            isIntegrated: "¿Integración?",
            agentCount: "Conteo de agentes",
            closePreviewColors: "Vista previa del tema cercano",
            previewColors: "Vista previa del tema abierto",
            videoCalls: "Videollamadas",
            filterLost: "Chats perdidos",
            vtipyCustomLogin:
                "Puede personalizar la información que se solicitará en el formulario de inicio de sesión cuando sus visitantes se conecten al sistema.",
            vtipyLoginlessChat:
                "El formulario de inicio de sesión del visitante estará oculto. El visitante puede conectarse para chatear directamente.",
            loginlessChat: "Formulario de inicio de sesión del visitante",
            imageUrl: "URL de la imagen",
            replied: "Respondió",
            solved: "Resuelto",
            openImage: "Abrir imagen",
            writeFeedback: "Puede escribir sus comentarios sobre la supsis aquí.",
            feedbackFailed: "Se produjo un error al enviar comentarios.",
            feedbackSuccessful: "Presentación de comentarios exitoso.",
            sendFeedback: "Enviar comentarios",
            errorReport: "Puede darnos comentarios sobre los problemas que tiene sobre la supsis.",
            sendErrorFeedBack: "Danos comentarios sobre el problema que está experimentando.",
            successImgUpload: "Su imagen ha sido cargada con éxito.",
            successImgDelete: "La imagen se ha eliminado correctamente.",
            errorImgUpload: "Se produjo un error al cargar su imagen.",
            errorImgDelete: "Se ha producido un error al borrar la imagen",
            chatBotEndStatics: "Tasa de éxito de conversación de chatbot",
            videoCallDist: "Distribución de videollamadas",
            departmentInfo: "Información del departamento",
            infoAboutDepartment: "Dar información breve sobre el departamento",
            deleteDepartmentQuestion: "¿Realmente quieres eliminar este departamento?",
            departmentDeleted: "Departamento eliminado",
            departmentTitle: "Título de departamento",
            updateDepartmentForm: "Formulario de actualización del departamento",
            newDepartmentForm: "Nuevo formulario de departamento",
            department: "Departamento",
            newDepartment: "Nuevo departamento",
            departmentSaved: "Departamento guardado",
            sameDepartment: "Hay un departamento con el mismo nombre",
            sameValue: "¡Hay un valor con el mismo nombre!",
            sameTag: "¡Hay una etiqueta con este nombre!",
            departments: "Departamentos",
            chatTimingSettings: "Configuración de tiempo de chat",
            assetOversize: "El tamaño del archivo que desea enviar no debe exceder 2 MB.",
            assetOversizeMB: "El tamaño del archivo que desea enviar no debe superar los {mb} MB.",
            messageDeleted: "Este mensaje se elimina",
            filterLostChat: "Filtro de chats perdidos",
            filterClosedByAgent: "Filtro cerrado por agente",
            filterVideoCall: "Filtro de videollamadas",
            notificationText: "La supsis necesita permiso para",
            notificationTitle: "Notificaciones desactivadas",
            deniedText:
                "Sus notificaciones están cerradas, debe activar sus notificaciones para que no se pierda a sus clientes.",
            deniedTitle: "Haz clic para abrir tus notificaciones!",
            deniedHeader: "Para no perderte a tus clientes, debes activar tus notificaciones!",
            showNotificationGuide: "Haga clic para obtener más detalles",
            howToEnableNotification: "¿Cómo puedo habilitar las notificaciones?",
            notificationOK: "De acuerdo",
            notificationUnderstood: "¡Entendido!",
            notificationCancel: "Cancelar",
            howToEnableNotificationInstruction1:
                "Haga clic en el icono de bloqueo en la barra de direcciones del navegador",
            howToEnableNotificationInstruction2:
                "Si las 'notificaciones' se deshabilitan en la sección de permisos, habilitarlo",
            howToEnableNotificationInstruction3:
                'Si no aparecen "notificaciones" en la sección de permisos, haga clic en "Configuración del sitio',
            howToEnableNotificationInstruction4:
                'Encienda el permiso de "notificaciones" de la sección "Permisos" de la página de configuración del sitio',
            checkPaymentMethod: "Verifique su método de pago",
            pushNotificationEnabled: "Gran notificación de push habilitada",
            pushNotificationDenied: "Has negado el permiso de notificación",
            suspendedMessage: "Tu cuenta ha sido suspendida",
            enableNotification: "Habilitar notificaciones de escritorio.",
            languageSettings: "Idioma seleccionado",
            problemsSound:
                "Si tiene problemas con las notificaciones, puede hacer clic en Bloquear la imagen del cuadro de búsqueda de su navegador (que se muestra en la imagen) Haga clic en 'Configuración del sitio' y cambie 'Sound' para permitir",
            betweenRepresentative: "Hay un nuevo mensaje de un representante",
            desktopNotifications: "Notificaciones de escritorio",
            notificationEnabled: "Las notificaciones de escritorio de supsis están habilitadas.",
            newMessageAlert: "Tienes un nuevo mensaje.",
            notificationDisable: "Puede deshabilitar la notificación de la configuración representativa",
            newConversationAlert: "Tienes un nuevo visitante.",
            chatBot: "Chatbot",
            ticketResponse: "Temsilcinin yanıtı:",
            archived: "archivo",
            chatbotChatCount: "Chatbot",
            changeTitle: "Cambiar título",
            changeVisitorTitle: "Cambiar título de visitante",
            catalog: "Título de catálogo",
            openTheCatalog: "Catálogo abierto",
            catalogNotOpen:
                "La función de catálogo está deshabilitada. Puede activar la función de catálogo para admitir a sus clientes con contenido prepreparado.",
            showCatalogCategories: "Establezca si el menú de catálogo aparecerá en la burbuja de chat",
            showChatBot: "Establezca si chatbot aparecerá en la burbuja de chat",
            openCatalog: "Visibilidad del catálogo",
            unreadMessages: "Mensajes no leídos",
            personalFirstMsg: "Promedio del tiempo de respuesta del agente (Sec)",
            personalRating: "Puntaje del personal AVG",
            soundSettings: "Configuración de las notificaciones",
            newPrivateMessage: "Mensaje privado",
            addNewGroup: "Crear un nuevo grupo",
            newMessage: "Nuevo mensaje",
            newConversation: "Nueva conversación",
            newVisitor: "Nuevo visitante",
            chatPosition: "Posición de chat",
            bottomLeftCorner: "esquina inferior izquierda",
            leftDocked: "izquierda Atracado",
            bottomRightCorner: "esquina inferior derecha",
            rightDocked: "derecho acoplado",
            chatPositionSelect: "Elija la posición",
            teamChatGroup: "Mensajes de grupo",
            teamChatDepartment: "Mensajes del departamento",
            teamChatTeam: "Mensajes de equipo",
            teamChatDm: "Mensajes DM",
            bottomLeft: "Abajo a la izquierda",
            left: "Izquierda",
            bottomRight: "Abajo a la derecha",
            right: "Bien",
            mailorname: "Correo electrónico o nombre",
            fieldName: "Nombre clave",
            value: "Valor",
            addSetting: "Agregar una configuración",
            globalSettings: "Ajustes globales",
            breaksByTime: "Romper el recuento de tiempo",
            clPlaceholder: "Nombre que aparecerá en el formulario del cliente",
            target: "Dirección de prueba de carga",
            duration: "Duración de la prueba de carga (Sec)",
            arrivalCount: "Recuento de chat",
            bootMaxLife: "Chat Max Life Time (Sec)",
            startLoadTest: "Prueba de carga de inicio",
            noClusterInstanceFound: "No hay servidor",
            stopLoadTest: "Prueba de carga de parada",
            integrationDesc: "Simplemente agregue el código de una línea a continuación a su sitio.",
            integrationDemoCode: "Código de demostración de integración simple",
            integrationWindow: "¿Cómo me integro en mi sitio?",
            notIntegrated: "Integración",
            help: "Ayuda",
            notIntegratedDesc:
                "Notamos que no agregó el sistema de chat a su sitio. Cuando lo integre en su sitio y comience el primer chat, completará la integración. Haga clic en el script de integración",
            backToLogin: "Vuelve a la pantalla de inicio de sesión",
            passwordlessLoginUnsuccessful: "El inicio de sesión no es exitoso. URL podría expirarse o usarse antes",
            passwordlessLogin: "Iniciar sesión sin contraseña",
            loginWithEmail: "Iniciar sesión con el correo electrónico",
            loginWithPassword: "Iniciar sesión con contraseña",
            enteringPasswordless: "Iniciar sesión sin contraseña ...",
            toMainPath: "Redirigir a la página principal",
            userRoleChanged: "Sus permisos cambiaron. Serás redirigido a la página principal.",
            passwordChangeSuccess: "Su contraseña cambió con éxito",
            feedback: "Mostrar comentarios",
            showFeedbackHistory: "Mostrar mensajes que se han enviado comentarios",
            newSelfServiceSite: "Nuevo sitio de autoservicio",
            subdomain: "Subdominio",
            rootUserEmail: "Correo electrónico",
            rootUserName: "Nombre",
            newVersion: "Nueva versión disponible",
            closeLiveSupport: "Cerrar apoyo en vivo",
            newVersionShort: "Nueva versión",
            bannedWordRestrict: "Bloqueo de palabras prohibidas",
            ticketShow: "Permitir a los clientes crear tickets",
            ticketShowDesc: "Activar la opción de creación de tickets en el menú de chat",
            autoLoadIframe: "Tráfico vivo",
            autoLoadIframeDesc: "Carga automática para iframe, pase todo el tráfico de visitantes",
            bannedWordRestrictDesc:
                "Cuando se enciende el bloqueo de palabras prohibido, se impide que los representantes escriban las palabras prohibidas definidas en el sistema a los visitantes.",
            agentDown: "Agente",
            delayChat: "Chat retrasado",
            tableSettingTippy: "Puede cambiar la información que aparecerá en la tabla.",
            tableSettings: "Configuración de tabla",
            tableSettingsInfo:
                "Puede cambiar la información que aparecerá en la tabla. Puede seleccionar 7 columna como máximo",
            privateParametry: "Parámetros de usuario personalizados",
            systemOperetor: "Información del sistema",
            cityAndDistrict: "Distrito de la ciudad",
            general: "General",
            availability: "Disponibilidad",
            home: "Hogar",
            successful: "Exitoso",
            forgetPasswordSent:
                "Se envió el correo electrónico del enlace de contraseña de restablecimiento, consulte su bandeja de entrada",
            saturday: "Sábado",
            friday: "Viernes",
            thursday: "Jueves",
            wednesday: "Miércoles",
            tuesday: "Martes",
            monday: "Lunes",
            sunday: "Domingo",
            download: "Descargar archivo",
            calendarPassedTimeHour: "{name} por {hour} hora",
            calendarPassedTime: "{name} para {hour} hora {min} min",
            calendarPassedTimeMin: "{name} para {sec} min",
            workScheduleOneDay: "{name} El horario de trabajo en {value}",
            workSchedule: "{name} El horario de trabajo entre {sDate} - {eDate}",
            calendar: "Calendario",
            noRating: "No hay calificación para mostrar",
            rateDist: "Distribución de tarifas",
            distConversation: "Distribución de discursos por representantes",
            distributionConversa: "Distribución de puntuación",
            distChatbotAgent: "Canales de comunicación",
            distAgent: "Chatbot & Agente",
            distFugitive: "Discurso perdido y discurso recibido",
            distLive: "Chat en vivo",
            distChatbot: "Chatbot",
            distComplex: "Chatbot & Chat en vivo",
            distHandled: "chat respondido",
            distMissed: "sin respuesta",
            distWeb: "Sitio web",
            distWhatsapp: "Whatsapp",
            distTelegram: "Telegram",
            distInstagram: "Instagram",
            totalWhatsappChatCount: "Recuento de chat de whatsapp",
            statsByTime: "Número de chat por tiempo",
            selectRep: "Seleccione un representante",
            allRepresentatives: "Todos los representantes",
            avgRating: "Puntuación de calificación ({point}) ({count} Calificación)",
            avgFirstMessageTime: "Tiempo promedio de respuesta",
            totalBreakTime: "Tiempo de descanso del sistema",
            totalBreakNum: "Recuento de descanso",
            averageConTime: "Tiempo de conversación promedio",
            multiWpReportTitle: "Número de conversación múltiple de Whatsapp",
            multiWpReport: "Número de múltiples chats de WhatsApp",
            multiWpReportExplanation: "Puede ver la cantidad de chat de sus múltiples canales de Whatsapp.",
            longestConTime: "El tiempo de conversación más largo",
            shortestConTime: "El tiempo de conversación más corto",
            refresh: "Actualizar",
            waitingReply: "Mensajes pendientes",
            organizationName: "Nombre de la Organización",
            companySlogan: "Nombre largo de la organización",
            messageSentErr: "Mensaje no enviar, inténtelo de nuevo.",
            messageSent: "Mensaje enviado.",
            openPrivateChat: "Chat representativo abierto",
            escKey: "Esconde una conversación activa",
            archiveChatKey: "Le permite unirse al chat en la parte inferior de la página de archivo.",
            chatCopilot: "Activa Chat CoPilot",
            privateChat: "Panel de conversación entre agentes",
            multiModeAlertDesc:
                'La supsis está abierta en otra ventana. Haga clic en "Use aquí" para usar supsis en esta ventana.',
            useHereText: "Usar aquí",
            brandVisibility: "La etiqueta de la marca de supsis aparece en la burbuja de chat",
            focusInput: "Focus cursor Cursor Active Chat Campo de entrada del chat",
            send: "Enviar",
            notYet: "Aún no",
            sending: "Enviando",
            onlyRepresentative: "Su mensaje solo puede ver por representantes",
            yourMessage: "Tu mensaje",
            liveFabListDescription: "Soporte vital",
            messengerIntegrationDesc:
                "Chatea con tus clientes a través de la página de Facebook, envía mensajes automáticos con el chatbot.",
            checkDepartmentToAgent: "Verificar el departamento para el agente en línea",
            ifAllOfflineStory: "Historia para dirigir si todos están fuera de línea",
            AssignMessagesToAgents: "Asignar Todos los Mensajes a los Agentes",
            firstChatbotAndAssign: "Primero responde el Chatbot y luego se asigna a un agente",
            hybridAssign:
                "El sistema verifica el departamento para ver si hay un agente en línea, y si no hay un agente en línea, lo asigna al chatbot.",
            ticketFabListDescription: "Boleto",
            whatsappFabListDescription: "Whatsapp",
            phoneFabListDescription: "Teléfono",
            emailFabListDescription: "Correo electrónico",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Gorjeo",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "YouTube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "Escriba su enlace de canal {channelLink} en este campo.",
            typeYourAccountLink: "Escriba su enlace de cuenta {accountLink} en este campo.",
            typeYourMessage: "Escribe tu mensaje aquí",
            typeYourMessageMail:
                "El Cliente enviará el mensaje ingresado en este campo a la dirección de correo anterior como el primer mensaje.",
            typeYourMessageDesc:
                "El Cliente enviará el mensaje ingresado en este campo al número de teléfono anterior como el primer mensaje.",
            sendNumber: "Número de teléfono para enviar el mensaje a: {path}",
            callNumber: "Número de teléfono para que su cliente llame: {phoneNumber}",
            numberIsNotCorrect: "Número faltante ingresado !!",
            emailIsNotCorrect: "¡El correo electrónico no es correcto!",
            selectFab: "Seleccione un fabuloso",
            notValid:
                "Solo puedes ingresar letras. (Carácter único) .e, d, f, z, a, x, c, v, w, t, n letras no son válidas",
            forMacUsers: "Los usuarios de Mac pueden usar el atajo de control (⌃)",
            basePriceValue: "Precio base",
            basePriceDiscount: "Descuento",
            basePriceCurrency: "Divisa",
            customerDBEnabled: "Selección de la base de datos: use el servidor de bases de datos de clientes",
            customerDBDisabled: "Selección de la base de datos: use el servidor de base de datos Supsis",
            mongoConnectionString: "Conexión Mongo",
            whatsappBasePriceValue: "Precio base de whatsapp",
            whatsappPlusBasePriceValue: "Whatsapp más precio base",
            instagramBasePriceValue: "Precio base de Instagram",
            instagramPlusBasePriceValue: "Instagram más precio base",
            clientAddress: "Dirección del cliente",
            customerClientAddress: "Dirección de cliente",
            apiAddress: "Dirección API",
            socketAddress: "Dirección de enchufe",
            backendAddress: "dirección de fondo",
            panelLogoUrl: "URL del logotipo del panel",
            panelCustomCssUrl: "URL CSS personalizada de panel",
            customerLogoUrl: "URL del logotipo de los clientes",
            customerCssUrl: "URL CSS del cliente",
            siteAlias: "Alias ​​de sitio",
            language: "Idioma",
            features: "Características",
            interactionPopularity: "Popularidad de las interacciones",
            interactionCount: "Número de interacción",
            uniqueUserCount: "Número de usuario único",
            allUserPercentage: "(%) Porcentaje de todos los usuarios",
            represantativeSettings: "Configuración representativa",
            documentTitle: "Formulario Documento Supuesto",
            supsisDocument: "Documento Supuesto",
            ApiDoc: "Documentación de la API",
            chatBalloonTehemeSettings: "Configuración de globo de chat y temas",
            customLoginFormSettingsTitle: "Personalizar el formulario de inicio de sesión del visitante",
            addNewField: "Agregar nuevo campo",
            editField: "Campo de edición",
            typeHere: "¡Escriba el contenido aquí!",
            pco: "CANALLA",
            perPage: "/página",
            perPageInFilter: "Pedazo",
            noUserInfoFound: "No se ha encontrado información del usuario",
            startFilter: "Filtro de inicio",
            showMyChats: "Muestra mis chats",
            showOnlineAgents: "Mostrar solo agentes en línea",
            showWaitingChats: "Mostrar chats de espera",
            addNewStatus: "Agregar estado",
            newTitleContent: "Nuevo título",
            newCTRLContent: "Nuevo contenido CTRL",
            newALTContent: "Nuevo contenido ALT",
            newTABContent: "Nuevo contenido de pestaña",
            roleName: "Nombre de rol",
            error: "Error",
            contentTitle: "Título de contenido",
            contentType: "Tipo de contenido",
            cannotMoveFullParent: "No puedo mover este elemento",
            newSiteForm: "Nuevo formulario de registro del sitio",
            updateSiteForm: "Formulario de actualización del sitio",
            newBannedWordForm: "Nuevo formulario de registro de palabras prohibido",
            updateBannedWordForm: "Formulario de actualización de palabras prohibidas",
            newWelcomeMessageForm: "Nuevo formulario de registro de mensajes de bienvenida",
            updateWelcomeMessageForm: "Formulario de actualización del mensaje del sistema",
            newDefaultContentForm: "Nuevo formulario de registro de contenido predeterminado",
            updateDefaultContentForm: "Formulario de actualización de contenido predeterminado",
            newSubjectForm: "Nuevo formulario de registro de asignaturas",
            updateSubjectForm: "Formulario de actualización de la asignatura",
            showChatColorMeaning: "Colores de chat",
            showIntro: "Introducción",
            options: "Opción",
            resetPassword: "Restablecer la contraseña",
            audioLevel: "Volumen de alerta de audio",
            privateChatNotificationSound: "Sonido de notificación",
            continue: "Continuar",
            newRoleForm: "Nuevo formulario de registro de roles",
            updateRoleForm: "Formulario de actualización de roles",
            newRolePlaceHolder: "Haga clic en el nuevo rol",
            newUserForm: "Nuevo formulario de registro de usuario",
            updateUserForm: "Formulario de actualización del usuario",
            changeOSRForm: "Mensaje de cambio fuera de línea",
            tooltipOSRForm: "Puede cambiar el mensaje fuera de línea.",
            newOSRForm: "Formulario de soporte fuera de línea",
            newOSRMessages: "Agregar mensaje fuera de línea",
            updateOSRForm: "Formulario de actualización fuera de línea",
            osrTitle: "Título",
            osrTitleDescription: "Puede agregar Título del formulario de soporte fuera de línea",
            osrContent: "Contenido",
            osrContentDescription: "Puede agregar contenido de formulario de soporte fuera de línea",
            hello: "Hola Mundo",
            date: "Fecha",
            startDate: "Fecha de inicio",
            finish: "Finalizar",
            start: "Comenzar",
            search: "Buscar",
            endDate: "Fecha final",
            representative: "Representantes",
            representative_: "Representante",
            star: "Estrella",
            filter: "FILTRAR",
            reset: "REINICIAR",
            dailyChatList: "Lista de chat diaria",
            dailyChatDuration: "Duración diaria de chat",
            chatDuration: "Duración del chat",
            dailyChatGraph: "Gráfico de chat diario",
            ok: "DE ACUERDO",
            cancel: "Cancelar",
            chatCount: "Recuento de chat",
            shortest: "El mejor",
            longest: "El más largo",
            average: "Promedio",
            count: "Contar",
            averagePoint: "Punto promedio",
            pointDist: "Distribución de puntos",
            point: "Punto",
            filters: "Filtros",
            totalCustomer: "Cliente total",
            avResponseTime: "Tiempo de respuesta promedio",
            breakDuration: "Ruptura de la duración",
            breakCount: "Recuento de descanso",
            lastLoginPlatform: "Plataforma",
            active: "Activo",
            passive: "Pasivo",
            userForm: "Formulario de usuario",
            sender: "Remitente",
            profile: "Perfil",
            name: "Nombre",
            number: "Número",
            username: "Nombre de usuario",
            email: "Correo electrónico",
            password: "Contraseña",
            oldPassword: "Contraseña anterior",
            newPassword: "Nueva contraseña",
            passwordAtLeast: "Contraseña (al menos {num} carácter)",
            passwordRepeat: "Repita la contraseña",
            changePassword: "Cambiar la contraseña",
            status: "Estado",
            enableState: "¿Activo?",
            douYouWishToDeleteUser: "Dou, ¿desea eliminar a este usuario?",
            userDeleted: "Usuario eliminado",
            userSaved: "Guardado del usuario.",
            oldPasswordError: "La contraseña anterior es incorrecta, verifique.",
            chooseAnOption: "Seleccione un sonido de notificación.",
            userVolumeUpdated: "Configuración de volumen actualizada.",
            save: "Ahorrar",
            update: "Actualizar",
            addNewMenu: "Agregar nuevo menú",
            addNewContent: "Agregar contenido nuevo",
            pleaseTitleEnter: "Por favor titular ingresar",
            like: "Como",
            disLike: "Disgusto",
            users: "Usuarios",
            visitor: "Visitantes",
            allContacts: "Todos los contactos",
            allUsers: "Todos los representantes",
            allSites: "Todos los dominios",
            newUser: "Nuevo Usuario",
            noNewUser: "Todavía no hay usuario.",
            noNewAdminUser: "Todavía no hay usuario administrativo.",
            noRoleFound: "Todavía no hay ningún papel.",
            noBannedWordFound: "Todavía no hay una palabra prohibida.",
            noWelcomeMessageFound: "Todavía no hay mensaje del sistema.",
            noSubjectFound: "Todavía no hay tema.",
            noVisitorFound: "No hay visitante.",
            noContactFound: "No hay contacto.",
            sendResponse: "Escribe una respuesta",
            delete: "Borrar",
            noLiveSupportFound: "No hay visitante conectar al soporte en vivo",
            noLiveSupportFoundWithDepartment: "No hay discurso que pertenezca al departamento",
            duplicate: "Duplicar",
            makeDefault: "Hacer por defecto",
            checkMore: "Verifique más",
            useReadyTemplates: "Usar plantillas listas",
            noRePresentativeFound: "No hay representante",
            noBannedVisitorFound: "Todavía no hay un visitante prohibido.",
            removeBanDescription: "Eliminar la prohibición",
            editThisItem: "Actualizar este elemento",
            removeThisItem: "Eliminar este elemento",
            role: "Role",
            autoChatAssignLimit: "Límite de asignación de chat automático",
            chatAssignInfo: "-1 = predeterminado del sistema, 0 = no asignar,> 0 = asignar como valor dado.",
            relatedDepartments: "Departamentos relacionados",
            subjectInfo: "Si no hay sujeto seleccionado, todos los sujetos están permitidos.",
            archive: "Archivo",
            offlineSupportRequests: "Soportes fuera de línea",
            first: "Primero",
            last: "Último",
            query: "Empezar a buscar",
            clean: "Limpio",
            loading: "Cargando",
            loadMore: "Carga más",
            noMessage: "No es ningún mensaje",
            selectChat: "Elige una charla",
            noMessageInChat: "No hay ningún mensaje en este chat",
            noMediaToShow: "No Media to show",
            firstSeen: "Primera vez visto",
            userInfo: "Información de usuario",
            chatId: "ID de chat",
            visitorId: "ID de visitante",
            visitingPage: "Página de visita",
            osAndBrowser: "Sistema operativo y navegador",
            customerClientVersion: "Versión del cliente del cliente",
            visitorFeedback: "Comentarios de los visitantes",
            notes: "Notas",
            nameSurname: "Nombre Apellido",
            chats: "Chatas",
            bannedVisitors: "Visitantes prohibidos",
            country: "País",
            city: "Ciudad",
            cityDistrict: "Distrito de la ciudad",
            browser: "Navegador",
            os: "Sistema operativo",
            ipAddress: "Dirección IP",
            connectionDate: "Fecha de conexión",
            transaction: "Transacción",
            banRemoved: "Prohibición eliminada.",
            bannedWords: "Palabras prohibidas",
            newBannedWord: "Nueva palabra prohibida",
            noBannedWord: "No hay una palabra prohibida todavía.",
            bannedWordForm: "Formulario de trabajo prohibido",
            word: "Palabra",
            bannedWordAndWordGroup: "Palabra / grupo de trabajo prohibido",
            doYouWishToDeleteBannedWord: "Dou, ¿realmente desea eliminar esta palabra prohibida?",
            doYouWishToOfflineSupportRequest: "Dou, ¿realmente desea eliminar este mensaje?",
            bannedWordSaved: "Palabra prohibida guardada",
            deletedSuccessfully: "Borrado exitosamente",
            deleteErrorMsg: "Error: no se elimina, intente de nuevo",
            socketError: "Error de conexión de socket. Actualice la página y vuelva a intentarlo.",
            socketConnecting: "Conectando al servidor",
            offlineModeDescription: "Sistema Down, los clientes no podrán acceder al soporte en vivo.",
            offlineModeSettingsDescription: "Verifique la función del modo fuera de línea en el menú Configuración.",
            offlineModeUser: "Debe haber al menos un representante en línea en el sistema.",
            offlineModeMessage: "Mensaje fuera de línea",
            offlineMode: "Modo offline",
            adminCannotConnectSocket: "El administrador no puede conectarse a Socket.",
            liveSupport: "Soporte vital",
            siteVisitors: "Visitantes del sitio",
            visitors: "Visitantes",
            thoseConnectedToLiveSupport: "Los que se conectaron con el soporte en vivo",
            visitorHistory: "Historial de visitantes",
            visitorHistoryDescription: "Puede ver y descargar el historial de chat de los visitantes.",
            privateMessage: "Mensaje privado",
            addRepresentative: "Agregar representante",
            forwardRepresentative: "Representante delantero",
            keyboardShortcuts: "Atajos de teclado",
            chatColorMeanings: "Significados de color del chat",
            connLostCheckInternet: "Conexión perdida, consulte su conexión a Internet.",
            wishToEndThisChat: "Dou, ¿desea terminar este chat?",
            defaultContents: "Contenido predeterminado",
            contents: "Contenido",
            newDefaultContent: "Nuevo contenido predeterminado",
            title: "Título",
            shortcutChar: "Personaje de atajo",
            pickOne: "Elegir uno",
            writeSomething: "Escribe un personaje (A-Z | 0-9)",
            letterSequence: "Secuencia de letras",
            exampleText: "Ejemplo: SOC -> Fútbol",
            anyChar: "Cualquier personaje",
            shorcutKey: "Tecla de acceso directo",
            content: "Contenido",
            shortcutName: "Nombre de atajo",
            type: "Tipo",
            shortcut: "Atajo",
            defaultContentForm: "Formulario de contenido predeterminado",
            deleteContentQuestion: "¿Realmente deseas eliminar este contenido predeterminado?",
            defaultContentDeleted: "Contenido predeterminado eliminado",
            defaultContentSaved: "Contenido predeterminado guardado.",
            contentMoved: "Contenido movido.",
            yourEmail: "Dirección de correo electrónico",
            yourName: "Su nombre y apellido",
            login: "Acceso",
            lostPassword: "Has olvidado tu contraseña",
            multipleSession: "Estás firmado en otro lugar.",
            notAuthorizedToDisplayPage: "¡No estás autorizado a ver esta página!",
            permissions: "Permisos",
            newPermission: "Nuevo permiso",
            permissionForm: "Formulario de permiso",
            displayTitle: "Título de exhibición",
            key: "Llave",
            keyToUseInSystem: "Valor clave para usar en el sistema",
            deletePermissionQuestion: "¿Realmente desea eliminar este permiso?",
            permissionDeleted: "Permiso eliminado.",
            permissionSaved: "Permiso guardado.",
            newRole: "Nuevo rol",
            selectARole: "Seleccione un rol",
            yes: "Sí",
            no: "No",
            fullAuth: "Autorización completa",
            roleDeleted: "Rol eliminado.",
            roleSaved: "Rol guardado.",
            roleForm: "Forma de rol",
            roles: "Roles",
            settings: "Ajustes",
            selectTopic: "Departamento seleccionado",
            autoCallTransfer: "Transferencia de llamadas automáticas",
            customerTyping: "Typing de clientes",
            typing: "Mecanografía",
            agentTyping: "Tipificación representativa",
            disconnectTime: "Tiempo de reconexión máxima (Sec)",
            tippyDissconnectTime: "Cuando un chat inactivo después de cuántos segundos terminará la conversación.",
            queueNumberVisibleFeature: "Mostrar número de cola al visitante",
            privateChatEnabled: "Mostrar el chat entre representantes",
            delayedTalkTime: "Tiempo de retraso (Sec)",
            employeeAverageChatCount: "Número de chat promedio para la tasa de chat de los empleados",
            customerDownTimeWhenRepExit: "Tiempo de inactividad del cliente cuando el representante se va (sn.)",
            autoAssignLimit: "Límite de asignación automática",
            wasted: "Conversación Tiempo perdido (Sec)",
            settingFormWrong: "Los datos del formulario son incorrectos, intente nuevamente después de verificarlo",
            settingsSaved: "Ajustes guardados.",
            settingsCannotSaved: "No se pueden guardar los ajustes",
            noAuthorization: "No autorización",
            warningBadInput: "Se recomienda ingresar un número entre 0 y 70.",
            warning: "¡ADVERTENCIA!",
            warningBadInputMarginY: "Advertencia sobre entrada del margen vertical ⚠️",
            warningBadInputMarginX: "Advertencia sobre entrada del margen horizontal ⚠️",
            warningBadInputBubbleSize: "Advertencia sobre la entrada de burbujas de chat ⚠️",
            delayTime: "Tiempo de retraso (Sec)",
            sites: "Sitios",
            newSite: "Nuevo sitio",
            noSiteYet: "Todavía no hay sitio.",
            siteAddress: "Dirección del sitio",
            turnBack: "Devolver",
            customerRepLimit: "Límite de representante del cliente",
            siteSaved: "Sitio guardado.",
            siteSaveError: "Se produjo un error durante la creación del sitio",
            subjects: "Asignaturas",
            newSubject: "Nuevo sujeto",
            noSubject: "No hay sujeto todavía.",
            subject: "Sujeto",
            subjectTitle: "Título del tema",
            description: "Descripción",
            infoAboutSubject: "Información sobre sujeto",
            deleteSubjectQuestion: "¿Realmente deseas eliminar este tema?",
            subjectDeleted: "Sujeto eliminado.",
            subjectSaved: "Sujeto guardado.",
            welcomeMessages: "Mensajes del sistema",
            newWelcomeMessages: "Nuevo mensaje de bienvenida",
            noWelcomeMessage: "Sin mensaje del sistema.",
            welcomeMessageContent: "Contenido de mensaje del sistema",
            makeChoice: "Tomar una decisión...",
            welcomeMessage: "Mensaje de bienvenida",
            repLoggedIn: "Representante iniciado sesión",
            loginMessage: "Mensaje de inicio de sesión",
            message: "Mensaje",
            deleteWelcomeMessageQuestion: "¿Realmente desea eliminar este mensaje del sistema?",
            welcomeMessageDeleted: "Mensaje del sistema eliminado",
            welcomeMessageSaved: "Mensaje del sistema guardado.",
            welcomeMessageForm: "Formulario de mensaje del sistema",
            noRep: "Todavía no hay representante.",
            addChat: "Agregar chat",
            forwardChat: "Chat avanzado",
            ago: "atrás",
            repName: "nombre representativo",
            lastOnline: "Última conexión/hora en línea",
            lastStatusChange: "Último cambio de estado",
            activeChat: "Chat activo",
            userMaxCapacity: "Capacidad de chat máxima",
            noActiveChat: "Sin chat activo",
            watch: "MIRAR",
            join: "UNIRSE",
            open: "Conversación abierta",
            directMessage: "MENSAJE PRIVADO",
            block: "BLOQUEAR",
            transactions: "Actas",
            informations: "Información",
            visitStart: "Inicio de visita",
            fullName: "Nombre completo",
            waitChatTime: "Tiempo de espera/chat",
            blockUserConfirm: "¿Quieres bloquear a este usuario?",
            messaging: "Mensajería",
            hideChat: "Esconder chat",
            block_: "Bloquear",
            privateMessage_: "Mensaje privado",
            assignRep: "Asignar representante",
            joinChat: "Únete al chat",
            forwardRep: "Adelante",
            leaveChat: "Deja el chat",
            endChat: "Chat finalizado",
            translatedTextDescription: "Amazon tradujo este mensaje {from} -> {to}.",
            autoTranslate: "Traducir automático",
            translateThisMessage: "Traducir este mensaje",
            autoTranslateDetectedDesc:
                "El lenguaje de visitantes es {visitorLanguage}. Haga clic aquí para activar la traducción automática",
            on: "en",
            off: "apagado",
            copy: "Copiar",
            prevChats: "Chats anteriores",
            noShortCut: "Sin atajo",
            leaveChartConfirm: "Dou, ¿realmente deseas salir del chat?",
            endChatConfirm: "Dou, ¿desea terminar el chat?",
            endConversation: "Finalizar la conversación",
            onlyOneRep: "¡Eres el único representante en esta conversación!",
            chatList: "Lista de chat",
            chatBar: "Barra de chat",
            unreadTitle: "No leído",
            visitorLeftTitle: "Visitante se fue",
            activeChatTitle: "Chat activo",
            autoAssignedTitle: "Chat asignado automáticamente",
            watchModeTitle: "Modo de reloj",
            lostChat: "Conexión representativa perdida",
            chatWidthDelay: "Charlar con demora",
            repChatWidthDelay:
                "Cuando no hay representante activo en el sistema o en todos nuestros representantes llenos debido al alto tráfico, los antecedentes de chat serán verdes",
            repLostConn:
                "Si el representante del cliente ha perdido la conexión, los antecedentes de chat serán rosados.",
            unreadMsg: "Si hay mensajes no leídos, el fondo será azul claro.",
            visitorLeftChat: "Si el visitante dejó la conversación, el fondo se vuelve gris oscuro.",
            activeChatMsg: "El fondo es verde si el chat está activo",
            autoAssignMsg:
                "El fondo se vuelve mostaza si se asigna la asignación automática y la conversación no se ve más allá",
            watchModeMsg: "Si se enciende en modo de reproducción, el fondo se vuelve rojo",
            online: "En línea",
            beRightBack: "Lejos",
            away: "Lejos",
            busy: "Ocupado",
            offline: "Desconectado",
            logout: "Cerrar sesión",
            forWindows: "Para ventanas",
            forMac: "Para Mac",
            nextChatFromActive: "Cambiar de activo a la siguiente conversación",
            previousChatFromActive: "Cambiar de activo a anterior",
            hideActiveChat: "Ocultar conversación activa",
            closeActiveChat: "Cerrar conversación activa",
            firsthiddenChat: "Únete al chat de cliente más esperado",
            firstChatWaiting: "Cambiar a la conversación de espera",
            previousOpenedChat: "Independientemente del pedido, salte a la conversación previamente abierta",
            historyDetails: "Detalles del historial",
            chat: "Charlar",
            chatNotFound: "No se encontró ningún discurso.",
            dataNotFound: "Datos no encontrados.",
            visitorInfo: "Información del visitante",
            timeSpent: "Tiempo usado",
            noActiveVisitors: "No hay visitantes activos",
            totalConnected: "Conteo de conversación",
            missedChat: "Recuento de chat perdido",
            workTime: "Tiempo de trabajo",
            closedChatCount: "Chat cerrado",
            activeConvo: "Conversación activa",
            notAnswered: "Todavía no respondió",
            delayedConvo: "Demorado",
            leavingRep: "Dejando representante",
            staffRate: "Tasa de trabajo del personal",
            select: "Menú desplegable",
            fullname: "Nombre completo",
            text: "Texto",
            numeric: "Número",
            phone: "Teléfono",
            optionsPlaceholder: "Valor de la opción",
            selectField: "Haga clic si desea agregar un menú desplegable",
            fullnameField: "Haga clic si desea agregar un campo de nombre completo.",
            textField: "Haga clic si desea agregar un campo de texto.",
            labelField: "Haga clic si desea agregar un campo de descripción.",
            numericField: "Haga clic si desea agregar un campo numérico.",
            phoneField: "Haga clic si desea agregar un campo de teléfono.",
            departmentField: "Haga clic si desea agregar un campo de departamento.",
            emailField: "Haga clic si desea agregar un campo de correo electrónico.",
            visible: "Visible",
            required: "Requerido",
            label: "Comentario",
            customLoginAlert: "Su formulario de inicio de sesión debe contener al menos un campo visible.",
            atLeastOneLanguage: "Debes sentir al menos un idioma",
            requiredFieldField: "Este campo es obligatorio",
            notRequiredField: "Este campo no es requerido",
            visibleField: "Este campo es visible",
            notVisibleField: "Este campo no aparece en el formulario.",
            connectServer: "Estás conectado al servidor",
            disconnectServer: "No está conectado al servidor",
            liveChatOff: "El chat en vivo está apagado",
            visitorScreen: "Pantalla de visitante",
            viewOnTheSite: "Ver en la página",
            viewOnTheSiteTippy: "Haga clic aquí para ver cómo se mantienen sus cambios.",
            showHint: "Mostrar pista",
            dontShowHint: "No muestres pistas",
            liveChatOn: "El chat en vivo está encendido",
            nightModeOff: "Modo nocturno apagado",
            doubleClickEdit: "Haga doble clic o presione el botón Editar para editar.",
            edit: "Editar",
            deleteField: "Borrar",
            arrow_upward: "Flecha hacia arriba",
            arrow_downward: "Flecha hacia abajo",
            newCatalogCategory: "Nueva categoría de catálogo",
            childCreate: "Haga doble clic para crear un nuevo niño",
            updateCatalogCategoryFrom: "Formulario de categoría de catálogo de actualización",
            newCatalogCategoryFrom: "Nuevo formulario de categoría de catálogo",
            catalogCategoryMenu: "Agregar menú Catálogo de categoría",
            catalogCategoryLeaf: "Agregar submenú de categoría de catálogo",
            catalogCategoryName: "Nombre de categoría de catálogo",
            newCatalogContentFrom: "Nuevo formulario de contenido de catálogo",
            catalogContentName: "Nombre del contenido del catálogo",
            catalogCategorySaved: "Categoría de catálogo guardada",
            catalogCategoryDeleted: "Categoría de catálogo eliminada",
            catalogCategoryRate: "Tasa de contenido",
            catalogContentFeature: "Función de contenido de catálogo",
            vtipyAudioLevel: "Se usa para silenciar o inmutarse sonidos de notificación.",
            vtipyOrganizationName: "Puede cambiar el nombre de la organización y actualizarlo.",
            vtipyBrandVisibility:
                "La supsis es la configuración de si la etiqueta se puede mostrar en la burbuja de chat.",
            vtipyBrandVisibilityForced: "¡Solo los usuarios de Proplan pueden cambiar!",
            vtipyClientDefault: "Puede cambiar el idioma de la página del agente aquí.",
            vtipyCustomerClientDefault: "Puede cambiar el idioma de la página del cliente (chat) aquí.",
            vtipyVisitorPreferredLang: "El cliente puede seleccionar el idioma hablado en la página (CHAT).",
            vtipyCustomerClientLanguageDetect: "Puede cambiar el idioma de la página del cliente (chat) aquí.",
            vtipySelectTopic:
                "Se producen tareas automáticas a representantes existentes en el departamento seleccionado.",
            vtipyAutoCallTransfer: "Asigna automáticamente las llamadas de espera a los agentes disponibles.",
            vtipyCustomerTyping:
                "Le permite ver lo que el cliente escribió en la pantalla de chat en la pantalla de chat representativa.",
            vtipyAgentTyping: "Da información cuando el representante escribe al cliente en el chat Buble",
            vtipyQueueNumberVisibleFeature:
                "Cuando los representantes están ocupados, muestra a los clientes que desean conectarse, en qué orden son.",
            vtipyPrivateChatEnabled: "Muestra el panel de conversación entre agentes.",
            vtipyDelayedTalkTime:
                'Si no se conectan los delegados a la conversación durante este tiempo, se etiquetará \\ "Chat retrasado \\',
            vtipyOfflineMode: "Le permite poner el sistema en modo fuera de línea.",
            vtipyAutoAssignLimit: "Determina cuántos clientes (CHAT) se asignarán al representante automáticamente.",
            vtipyCustomerDownTimeWhenRepExit: "Tiempo de inactividad del cliente cuando el representante sale (Sec.)",
            tippyDisconnectTime: "El chat se interviene después de desconectar al cliente (SEC).",
            changeSettings: "Cambiar la configuración global",
            totalBg: "Chats Totales",
            activeBg: "Chats Activos",
            watchBg: "MIRAR",
            waitingBg: "Chats Pendientes",
            lateBg: "conversaciones pasajeras",
            freeBg: "GRATIS",
            maxCapacityBg: "MÁXIMA CAPACIDAD",
            addNewSettings: "Agregar una nueva configuración global",
            darkMode: "Modo oscuro",
            clientDefault: "Lenguaje predeterminado del panel",
            customerClientDefault: "Cliente Idioma predeterminado del cliente",
            customerClientLanguageDetect: "Language del cliente Detección automática",
            visitorPreferredLang: "Deje que el cliente elija el idioma hablado",
            preferredThemeColor: "Color del tema preferido para la pantalla de chat del cliente",
            detail: "Detalle",
            supportUs: "Contáctenos (soporte en vivo)",
            langSetting: "Configuración de idioma",
            changeLang: "Cambiar idioma",
            fontSizeSetting: "Configuración de zoom de pantalla",
            changeLangDesc: "Cambia el lenguaje de aplicación a {code}",
            trLang: "turco",
            enLang: "Inglés",
            fieldRequired: "{field} se requiere campo",
            selectALanguage: "Selecciona un idioma",
            selectATheme: "Selecciona un tema",
            responseForm: "Formulario de respuesta",
            clientRequestInfo: "Información de solicitud de cliente",
            createdDate: "Fecha de creación",
            descMessage: "Mensajes",
            new: "Nuevo",
            selectAllPermission: "Seleccionar todo",
            catalogCategories: "Catalogar",
            copiedClipboard: "Copiado al portapapeles",
            changeLogo: "Cambiar logotipo",
            changePhoto: "Cambiar foto",
            addPhoto: "Añadir una foto",
            seePhoto: "Ver la foto",
            deletePhoto: "Borrar la foto",
            organizationLogo: "Logotipo de la organización",
            changePlan: "Cambio de plan",
            close: "Cerca",
            vtipyUploadLogo:
                "Al cargar el logotipo de su empresa desde esta área, puede usar su propio logotipo en correos electrónicos de clientes y páginas de clientes.",
            tagName: "Nombre de etiqueta",
            tagDescription: "Etiqueta Descripción",
            tagColor: "Color de la etiqueta",
            userInformations: "informacion del usuario",
            incomingChat: "Chat entrante",
            support: "Apoyo",
            team: "Colocar",
            groups: "Grupos",
            newConversationStarted: "Nueva conversación iniciada",
            allHistoryLoaded: "Todo el historial subido",
            chatCreator: "Creador de chat",
            enterGroupTitle: "Ingrese el título del grupo",
            requiredTitle: "No puede dejar el campo de título en blanco",
            requiredChannel: "El nombre del canal no puede estar vacío",
            next: "Confirmar",
            selectPeople: "Seleccionar personas",
            textLimitAlertMessage:
                "El límite de caracteres en WhatsApp es de 19 caracteres y más allá de este límite no se mostrará. Sin embargo, en la web, los textos que superan el límite de 19 caracteres se mueven automáticamente a la siguiente línea y se muestran.",
        },
        "No money will be withdrawn from your account": {
            "": "#VALUE!",
        },
        "At the end of the month, an invoice will be created according to your usage amount": {
            "": "#VALUE!",
        },
        "{contentOfChatBubble}": "#VALUE!",
        telegram: {
            typeInTelegramToken: "Escriba la token de telegrama",
            token: "Simbólico",
            telegramTokenTitle: "Telegram Susis Integración",
            telegramAlertForm: "Puede obtener el token de bot de Telegram de",
            telegramAlertTitle: "Realmente desea eliminar el token?",
            telegramAlertText: "El token desaparecerá permanentemente!",
        },
        wp: {
            chatStarted: "El chat comenzó",
            chatNotStarted: "El chat no empezado",
            contactSelected: "Contacto seleccionado",
            startChatWithAnyNo: "Empiece a chatear con cualquier número",
            toLittleChar: "Numero faltante !",
            typeInANumberDesc: "Escriba el número para comenzar el chat con:",
            wpPlusAndLicenceRequired: "Se requieren plan y licencia de WhatsApp Plus.",
            wpPlusAndLicenceRequiredDesc:
                "Antes de que pueda comenzar los chats con números que no están registrados en sus contactos, debe actualizar su plan de WhatsApp y obtener una licencia.",
            chatStartingWait: "Conversación comenzando, por favor espera",
            whatsapp: "Whatsapp",
            agreement: "Acuerdo",
            purchase: "Compra",
            activating: "Activación del servicio de whatsapp",
            authenticating: "Autenticación del código QR",
            ready: "Listo",
            enableFeature: "Habilitar la función WhatsApp",
            readAndAgree: "He leído y estoy de acuerdo",
            subscribe: "Suscribir",
            subscribed: "Suscrito",
            toEnableWpDescription: "Para habilitar las funciones de WhatsApp, haga clic en el botón de abajo.",
            waitForWpActivationDescription:
                "Su servicio de cuenta de WhatsApp se está activando. Por favor espera un momento. Se necesitan alrededor de 10-30 segundos.",
            greatWpActivatedDescription: "¡Genial, su servicio de cuenta de WhatsApp está activado!",
            unsubscribe: "Cancelar la suscripción",
            planDetails: "Características",
            sendReceiveMessage: "Enviar y recibir mensajes de texto",
            sendReceiveImage: "Enviar y recibir archivos de imagen",
            sendReceiveAudio: "Enviar y recibir archivos de audio",
            sendReceiveGif: "Enviar y recibir archivos GIF",
            startChat: "Empiece a chatear en supsis",
            supsisFunctionality: "Funcionalidad de chat de supsis útil",
            onePhoneMultiAgent: "Un teléfono y múltiples agentes",
            basicIntegration: "Integración básica y configuración cero",
            activationTitle: "Para activar la integración de WhatsApp en supsis:",
            wpIntegrationInstruction1: "Abra WhatsApp en su teléfono",
            wpIntegrationInstruction2: "Toque el menú o la configuración. Haga clic en dispositivos vinculados",
            wpIntegrationInstruction3: "Apunte su teléfono a esta pantalla para capturar el código",
            qrGeneratingWait: "Generación del código QR Por favor espere ...",
            pleaseContinueToWaitUntilCompleted:
                "Después de verificar el código QR, cambiará automáticamente al campo completado. Espere por favor...",
            authenticatingWait: "Autenticando, por favor espera ...",
            unsubscribeWpInetgration: "Cancelar la suscripción de la integración de whatsapp",
            unsubscribeIGIntegration: "Cancelar la suscripción de la integración de Instagram",
            wpBack: "Atrás",
            terminatelWpInetgration:
                "Cuando se hace clic en el botón 'cancelar suscripción', su integración de WhatsApp terminará",
            cancelWpInetgration: "¿Quieres cancelar la integración de WhatsApp?",
            terminatelIGIntegration:
                "Cuando se hace clic en el botón 'cancelar suscripción', su integración de Instagram terminará",
            cancelIGIntegration: "¿Quieres cancelar la integración de Instagram?",
            startChatWp: "Comenzar chat",
            purchaseHeader: "Compra de integración de supsis-whatsapp",
            wpServices: "Servicio de whatsapp",
            wpServicesIntegrationCompleted: "Su integración de WhatsApp está completa. Ahora puede usar el servicio.",
            purchasePaymentDescription:
                "Característica de WhatsApp facturada mes a mes. Su servicio de WhatsApp se activará después de aceptar la suscripción.",
            wpIntegrationFeatures: "Características de integración de WhatsApp",
            saveChanges: "Guardar cambios",
            contactList: "Lista de contactos",
            broadcast: {
                broadcast: "Transmisión",
                detail: "Detalle de transmisión",
                customer: "Cliente",
                phoneNumbers: "Números de contacto",
                showMore: "Mostrar más",
                groupName: "Nombre del grupo",
                messages: "Mensajes",
                status: "Estado",
                usageCost: "Costo de uso",
                sendingTime: "Envío de tiempo",
                progress: "Progreso",
                groupDetail: "Detalle grupal",
                messagesPerContact: "Mensajes por contacto",
                successRatio: "Relación de éxito",
            },
            messages: "Mensajes",
            broadcastRequests: "Solicitudes de transmisión",
            customerGroups: "Grupos de clientes",
            messageTemplates: "Plantillas de mensajes",
            plans: "Planes",
            wpIntegrationRequired: "Se requiere integración de WhatsApp",
            wpRequiredIntegrationDescription: "Lo siento, la página que visitó se activará cuando integre su WhatsApp.",
            integrateWp: "Vamos, integrar whatsapp",
            active: "Activo",
            archived: "Archivado",
            createBroadcastMessage: "Crear mensaje de transmisión",
            title: "Título",
            description: "Descripción",
            createdAt: "Creado en",
            numbers: "Números",
            actions: "Comportamiento",
            action: "Acción",
            createCustomerGroup: "Crear un grupo de clientes personalizado",
            search: "Buscar",
            name: "NOMBRE",
            contacts: "Contactos",
            noContactFound: "No se encontró contacto",
            broadcastTitle: "Dale un título a tu transmisión.",
            recipients: "Receptores",
            selectRecipients: "Seleccionar destinatarios",
            writeYourMessage: "Escribe tu mensaje.",
            schedule: "Cronograma",
            scheduleNowOrLater: "Programe ahora o más tarde",
            summary: "Resumen",
            cancel: "Cancelar",
            send: "Enviar",
            sending: "Enviando",
            deleteCustomerGroup: "¿Estás seguro de eliminar este grupo de clientes? {nombre}",
            customerGroupDeleting: "Grupo de clientes Eliminando ...",
            customerGroupDeletingSuccess: "Grupo de clientes eliminado con éxito",
            customerGroupDeletingError: "Error al eliminar el grupo de clientes",
            wpPlusRequired: "Se requiere plan de WhatsApp Plus.",
            broadcastMessageArchived: "Mensaje de transmisión como archivado",
            broadcastMessageNotArchived: "El mensaje de transmisión no está archivado",
            groupNameSearch: "Escriba el nombre del grupo de clientes",
            groupNameDesc: "Nombre del grupo de clientes Identifique sus grupos de clientes",
            save: "Ahorrar",
            number: "NÚMERO",
            addColumn: "Añadir columna",
            addColumnDesc: "Agregue una columna a la tabla",
            addNewContact: "Añadir nuevo contacto",
            addNewContactDesc: "Agregue un contacto a la mesa",
            importFile: "Importar desde el archivo",
            importFileDesc: "Importar contactos desde el archivo Excel o CSV",
            contactAdded: "Contacto agregado",
            updateCustomerGroup: "Actualización del grupo de clientes ...",
            updateCustomerGroupSuccess: "Grupo de clientes actualizado con éxito",
            sendBroadcastMessage: "Enviar mensaje de transmisión",
            columnName: "Nombre de columna",
            columnType: "Tipo de columna",
            defaultValue: "Valor por defecto",
            setDefaultValue: "Establezca el valor predeterminado en los contactos existe",
            age: "Edad",
            location: "Ubicación",
            gender: "Género",
            selectContactFile: "Seleccione el archivo de contacto",
            selectContactCsvOrExcel: "Seleccione un archivo CSV o Excel.",
            importConfiguration: "Configuración de importación",
            customizeFile: "Personalice su configuración de importación.",
            sendMessageTo: "¿A quién quieres enviar el mensaje?",
            allContact: "Todo contacto",
            messageTypes: "Tipos de mensajes",
            whenSendMessage: "¿Cuándo quieres enviar el mensaje?",
            instantlyRightNow: "Al instante ahora mismo",
            completed: "Terminado",
            scheduleFuture: "Programe para una fecha futura",
            messageDesc: "Su mensaje se enviará instantáneamente a todos los destinatarios.",
            messageSendAt: "Su mensaje se enviará a todos los destinatarios en",
            estimatedPrice: "Precio estimado",
            estimatedTime: "Hora prevista",
            now: "Ahora",
            tenMinute: "10 minutos",
            cancelled: "Cancelado",
            failed: "Fallido",
            running: "Correr",
            queued: "Puesto en cola",
            scheduled: "Programado",
            noNumberAdded: "No hay números agregados",
            csvOrExcelFile: "Archivo CSV o Excel",
            broadcastMessagesToContactFile: "Mensajes de transmisión a la lista de contactos",
            broadcastMessageTemplates: "Plantillas de mensajes de transmisión",
            messageFlow: "Flujo de mensajes",
            textMessageSupport: "Soporte de mensajes de texto",
            imageMessageSupport: "Soporte de mensaje de imagen",
            spamPreventions: "Preventivos de spam",
            includesAllBasicPlans: "Incluye todo en el plan básico",
            chatbotIntegration: "Integración de chatbot",
            messageToNewNumbers: "Mensaje a nuevos números",
            broadcastMessageToEveryone: "Transmitir mensajes a todos",
            personalizedBroadcastMessage: "Mensajes de transmisión personalizados",
            customerGroupSegmentation: "Segmentación del grupo de clientes",
            scheduleBroadcastMessage: "Programe un mensaje de transmisión",
            locationMessageSupport: "Soporte de mensaje de ubicación",
            advancedSpamPreventions: "Preventiones de spam avanzadas",
            whatsappPlans: "Planes de whatsapp",
            selectBestPlan: "Elija el plan que le convenga",
            comingSoon: "Muy pronto...",
            selectFile: "Seleccione un archivo",
            created: "Creado",
            message: "Mensaje",
        },
        ig: {
            instagram: "Instagram",
        },
        ticket: {
            ticketTagFilter: "Etiqueta de filtro de boleto",
            ticketEmails: "Lista de correo electrónico de reenvío de boletos",
            save: "Ahorrar",
            delete: "Borrar",
            transactions: "Opción",
            noEmailTicketNotifications: "No hay datos",
            emailIsNotValid: "El correo no es válido",
            emailNotificationDeleted: "Artículo eliminado con éxito",
            emailNotificationDeleteError: "Ocurrió un error",
            tagFilterRequired: "Etiqueta de filtro de ticket requerida, use *(comodín) etiqueta para todos los boletos",
            emailsRequired: "Reenviar correos electrónicos no debe ser nulo",
            emailNotificationCreated: "Regla de bosque de boletos creados",
            emailNotificationCreateError: "Ocurrió un error",
            ticketForwarding: "Reenvío de correo electrónico de boleto",
            ticketTagFilterDesc:
                "Utiliza los temas de boletos que usó en el diseño de chatbot para filtrar los boletos. Puede escribir una etiqueta diferente y presionar Entrar para agregarla. Si selecciona la etiqueta '*', seleccionará todos los boletos",
            ticketEmailsDesc:
                "Lista de correo electrónico a la que se reenviarán los boletos. Puede agregar las direcciones de los representantes en el sistema seleccionándolos. También puede agregar correos electrónicos sin sistema.",
            ticketList: "Reglas de reenvío de boletos",
            ticketTagFilterPlaceHolder: "Filtro de boletos, seleccione '*' para todos",
            ticketEmailsPlaceHolder: "Reenvío de la lista de correo electrónico",
        },
        theme: {
            opacity: "Opacidad",
            headerColor1: "Color de la sección Hader 1",
            headerColor1A: "Opacidad de la sección Hader 1",
            headerColor2: "Color de la sección del encabezado 2",
            headerColor2A: "Opacidad de la sección del encabezado 2",
            backgroundColor: "Color de fondo 1",
            backgroundColorA: "Opacidad de fondo 1",
            backgroundColor2: "Color de fondo 2",
            backgroundColor2A: "Opacidad de fondo 2",
            textColor: "Color de texto",
            errorTheme: "Color de error",
            bubbleBackground: "Color de burbujas representativo",
            bubbleVisitorBackground: "Color de burbujas de clientes",
            bubbleBackgroundA: "Opacidad de burbuja representativa",
            bubbleVisitorBackgroundA: "Opacidad de la burbuja del cliente",
            bubbleText: "Color de texto representativo",
            bubbleVisitorText: "Color de texto del cliente",
            textFormColor: "Color de forma",
            selectCustom: "Seleccionar tema personalizado",
            headerColorSecond: "Color superior del encabezado",
            headerColorFirst: "Color inferior del título",
            backgroundColorFirst: "Color superior de fondo",
            formColor: "Color del texto del formulario",
            buttonColor: "Color del boton",
            backgroundColorSecond: "Color inferior de fondo",
            chatBotButtonText: "Color de fuente del chatbot",
            chatBotButtonColor: "Color del botón del chatbot",
        },
        billing: {
            paymentStatus: "Estado del pago",
            amount: "Cantidad",
            invoiceID: "ID de la factura",
            expected: "Esperado...",
            currentAmount: "Monto actual",
            monthlyEstimatedAmount: "Monto estimado mensual",
            creationDate: "Fecha de creación",
            invoiceStatus: "Estado de la factura",
            invoicePeriod: "Periodo de facturación",
            newPaymentMethod: "Nuevo método de pago",
            channelCount: "Cantidad de canales",
            remainingTime: "Tiempo restante",
            chatbotLimit: "Límite de chatbot",
            free: "Gratis",
            maxChatbotSession: "Máximo de Sesiones de Chatbot",
            buyIt: "Comprar",
            renewalDate: "Fecha de renovación",
            monthly: "Mensual",
            yearly: "Anual",
            packagePeriod: "Período del paquete",
            packageType: "Tipo de paquete",
            packageManagement: "Gestión de paquetes",
            invoiceManagement: "Gestión de facturas",
            futureInvoice: "Factura futura",
            pastInvoices: "Facturas pasadas",
            creditCard: "Tarjeta de crédito",
            invoice: "Factura",
            mustBeUpgradePlanForChatBot: "Para activar la función de chatbot, ¡debe cambiar al plan profesional!",
            cardInfo: "Información de la tarjeta",
            billingDetails: "Detalles de facturación",
            addCardIyzico:
                "No tienes una tarjeta registrada. Para pagar sus tarifas de uso mensuales, debe agregar una tarjeta. El sistema de pago es proporcionado por Iyzico.",
            billingPlanSettings: "Factura",
            startWith: "La tarjeta {CardFamily} comienza con {binnumber}",
            paymentMethod: "Método de pago",
            billingDate: "Fecha de facturación",
            isPaid: "¿Está pagado?",
            paid: "Pagado",
            markPaid: "Mark como pagado",
            paymentDate: "Fecha de pago",
            pay: "Pagar",
            newInvoice: "Crear factura",
            updateBilling: "Detalles de facturación de actualización",
            updateCard: "Cambiar tarjeta de crédito",
            paymentBilling: "Método de pago y detalles de facturación",
            price: "Precio",
            billingAddress: "Dirección de Envio",
            billingCity: "Ciudad",
            billingCountry: "País",
            contactName: "Nombre de contacto de facturación",
            expireMonth: "Mes expirar",
            expireYear: "Expirar año",
            cardNumber: "Número de tarjeta",
            cardHolderName: "Nombre del titular de la tarjeta",
            cardAlias: "Alias ​​de tarjeta",
            identityNumber: "Número de identidad",
            name: "Nombre",
            surname: "Apellido",
            email: "Correo electrónico",
            addCard: "Agregar tarjeta",
            update: "Actualizar",
            cancel: "Cancelar",
            save: "Ahorrar",
            saving: "Ahorro",
            noInvoiceFound: "No hay factura",
            year: "Año",
            updating: "Actualización ...",
            newInvoiceForm: "Nuevo formulario de creación de factura",
            error: "Error",
            transactions: "Opción",
            paymentMethodAdded: "El método de pago ha agregado con éxito",
            paymentMethodAddError: "El método de pago no ha agregado, se produjo un error",
            creditCardChanged: "La tarjeta de crédito ha cambiado con éxito",
            errorOccurred: "Se produjo un error, intente nuevamente",
            billingDetailUpdated: "Los detalles de facturación se han actualizado con éxito",
            invoiceCreated: "La factura ha creado con éxito",
            paymentSuccess: "Pago con éxito, gracias",
            paymentFail: "Fallidad de pago, intente nuevamente",
            billingAddressChanged: "La dirección de facturación ha cambiado con éxito",
            hidePlan: "Ocultar",
            informationShopping:
                "Shopify controla su información de pago, información de facturación, información de la tarjeta de crédito.",
            trialTimeInformation:
                "La prueba termina {DayCount} días después. Si no ingresa un método de pago hasta el vencimiento de este período, el sistema cambiará automáticamente al plan gratuito.",
            trialTimeInformationShort: "Prueba: último día {DayCount}",
            currentPlanLabel: "Plan actual: {PlanName} ({AgentCount} agente)",
            changeCancelPlan: "Plan de cambio/cancelación",
            oneAgent: "Agente",
            agent: "Agente",
            yourCurrentPlan: "Plan actual",
            month: "Mes",
            billedMonthToMonth: "(facturado mes a mes)",
            selectAgentCount: "Seleccionar recuento de agentes",
            selectFreePlan: "Seleccione un plan gratis",
            planDetails: "Detalles del plan",
            multiAgent: "(Agente múltiple)",
            selectProPlan: "Seleccionar plan profesional",
            foreverFree: "Siempre libre",
            websiteIntegration: "Integración del sitio web",
            websiteIntegrationUnlimited: "Integración del sitio web",
            ChatBotUnlimited: "Chatbot",
            videoCallUnlimited: "Videollamada",
            multiAgentUpTo: "Agente multi (hasta {agentCount} agente)",
            audioCallUnlimited: "Llamado de audio",
            screenSharingUnlimited: "Compartir pantalla",
            fileTransferUnlimited: "Transferencia de archivos",
            autoChatAssignerUnlimited: "Asignador de chat automático",
            multiLanguageTranslationUnlimited: "Traducir automático",
            detailedReporting: "Informes",
            days30TrialsAvailable: "Pruebas de 30 días disponibles",
            limitedArchiveLookupLastMo: "Búsqueda de archivo limitado (último {monthCount} -mo)",
            fullCustomizationUnlimited: "Personalización",
            planUpdated: "Genial, su plan se actualiza.",
            planUpdating: "Tu plan está actualizando ...",
            planUpdatingDescription: "Espere durante la actualización de su plan",
            done: "Hecho",
            freePlanUpdated: "Su plan se actualizó como un plan gratuito. (Crédito del agente máximo: 1)",
            proPlanUpdated: "Su plan actualizado como un plan profesional. (Crédito del agente máximo: {agenteCount})",
            canNotDwnGrade:
                "No se puede degradar su plan de Pro {agentCountFirst} agente (s) a {valNewPlnToUppr} {agentCountSecond}. Su agente acredita en uso.",
            deleteWarning: "Debe eliminar o deshabilitar {valDif} agente (s)",
            warnMessage: "El plan seleccionado debe ser diferente al plan actual",
            add: "Agregar",
            cancelYourPlan: "Cancele su plan",
            upgradeYourPlan: "Actualiza tu plan",
            downgradeYourPlan: "Degradar su plan",
            agree: "ACEPTAR",
            disagree: "DISCREPAR",
            invoices: "Facturas",
            priceIntervals: "Intervalo de precio",
            selectSiteAlias: "Seleccione o ingrese el nombre del sitio",
            selectPriceInterval: "Seleccione o ingrese el intervalo de precio",
            isRefunded: "¿Se reembolsa?",
            invoiceId: "Factura no",
            siteId: "Sitio no",
            createdDate: "Fecha de creación",
            failCount: "Número de intentos de búsqueda de pago fallidos",
            failDate: "Fecha de pago fallida",
            Dashboard: "Panel",
            Agents: "Agentes",
            Integration: "Integración",
            Settings: "Ajustes",
            Contacts: "Contactos",
            Domain: "Dominio",
            lastActivity: "Última actividad",
            basePrice: "Precio base",
            packagePrice: "Precio del paquete",
            whatsappPrice: "Precio de whatsapp",
            realtimeVisitorCount: "Visitante en tiempo real",
            suspend: "Suspender",
            partner: "Pareja",
            plan: "Plan",
            trialDay: "Días de prueba",
            mobile: "Móvil",
            webSite: "Sitio web",
            websiteOrigins: "Origen del sitio web",
            ownerName: "Nombre del dueño",
            ownerEmailAddress: "Correo electrónico del propietario",
            discount: "Descuento",
            daysLeft: "Días restantes",
            newTrialPopUp: "¿Cuántos días debería ser el nuevo período de prueba?",
            newWpPricePopUp: "¿Cuánto cuesta la nueva tarifa de WhatsApp?",
            newIGPricePopUp: "¿Cuánto cuesta la nueva tarifa de Instagram?",
            newBasePricePopUp: "¿Cuánto cuesta el nuevo precio base?",
            siteInfoUpdated: "Información del sitio actualizada",
            siteInfoNotUpdated: "Información del sitio no actualizada",
            siteInfoNotUpdatedErr: "¡Ocurrió un error! Información del sitio no actualizada.",
        },
        tour: {
            closeChat: "Chat cerrado",
            ticket: "Boleto",
            formStep: "Paso de formulario",
            menuStep: "Paso de menú",
            contentStep: "Paso de contenido",
            menuTitle: "Título de menú",
            messageContent: "Contenido del mensaje",
            goToLive: "Conectar representante",
            stats: "Panel de estadísticas",
            settings: "AJUSTES",
            status: "ESTADO",
            prevStep: "Paso anterior",
            nextStep: "Próximo paso",
            finish: "Finalizar",
            skip: "Saltar",
            skip2: "Omitir, conozco el sistema",
            startTour: "Empezar recorrido",
            firstTimeIntro: "Está ingresando al sistema por primera vez, quiero presentar la aplicación si lo permite",
            hi: "Hola",
            welcomeTo: "Bienvenido al soporte en vivo de Supsis",
            statsPanel:
                "Es la barra de estado que muestra los números de chat totales y activos que esperan instantáneamente con el sistema.",
            sidebarMenu: "MENÚ",
            sidebarMenuContent: "Puede cambiar entre páginas aquí.",
            representativePrivateMessage: "Panel de conversación entre representantes",
            representativePrivateMessageContent: "Puede ver conversaciones privadas entre agentes aquí.",
            helpMenu: "MENÚ DE AYUDA",
            helpMenuContent: "Puede encontrar información de ayuda sobre el sistema aquí.",
            settingsMenu: "Menú Configuración",
            settingsMenuContent: "Puede hacer el idioma, el modo nocturno y los pasos de aumento de pantalla aquí.",
            startChat: "Comenzar chat",
            profileMenu: "Menú de perfil",
            profileMenuContent: "Puede cambiar su disponibilidad y establecer la configuración de su agente aquí.",
            visitorsTab: "Visitantes",
            visitorsTabContent: "Puedes ver visitantes aquí.",
            visitorTabHistory: "Historial de visitantes",
            visitorTabHistoryContent: "Puedes ver el historial de visitantes aquí.",
            representativeTab: "Representantes",
            representativeTabContent: "Puedes ver a los representantes aquí.",
            liveSupport: "Soporte vital",
            liveSupportContent: "Puede ver el número de clientes que reciben soporte en vivo aquí.",
            siteVisitors: "Visitantes del sitio",
            siteVisitorsContent: "Puede ver el número de visitantes del sitio aquí.",
            tableSettings: "Configuración de tabla",
            tableSettingsContent: "Puede mostrar u ocultar columnas en la tabla aquí.",
            watchModeButton: "Botón Visador",
            watchModeContent: "Puede unirse aquí como modo de visor y solo puede ver lo que se publica.",
            popoverInfo: "Detalles del visitante",
            popoverInfoContent: "Proporciona información sobre el visitante.",
            popoverButton: "Configuración de chat avanzada",
            popoverButtonContent:
                "Puede abrir la conversación, enviar un mensaje directamente al representante o bloquear el visitante.",
            openChat: "Unir el botón de conversación",
            openChatContent: "Puedes abrir la conversación aquí",
            pagination: "Menú de paginación.",
            paginationContent: "Puede aumentar el número de páginas aquí.",
            changeLang: "Puede cambiar el lenguaje del sistema",
            changeTheme: "Puede cambiar el tema oscuro y ligero",
            changeStatus: "Puede cambiar su estado de disponibilidad",
            logout: "¿Puede el sistema de inicio de sesión desde aquí?",
            chatwindow: {
                chatWindowActionButtons: "Botones de acción de la ventana de chat",
                chatPanelActions: "Acciones del panel de chat",
                otherPanels: "Otros paneles",
                chatColorButton: "Mostrar el significado de los colores del bar de chat",
                keyboardShortcutButton: "Mostrar funciones de accesos directos de Keybpard",
                hideButton: "Minimizar el chat actual sin salir",
                closeButton: "Fuerza cerrar y salir del chat actual",
                ellipsisButton:
                    "Más acciones de chat. Minimizar, cerrar, prohibir el visitante, enviar mensajes privados, asignar representante",
                userInfoWidget: "Mostrar detalle del visitante del propietario del usuario de chat actual",
                preparedContentWidget:
                    "Widget de plantillas de mensajes preparados, puede seleccionar insertar rápidamente una plantilla de mensaje en el chat actual",
                chatHistoryWidget: "Si hay algún historial de chat del visitante actual, puede verlos",
                chatWindowSettingsButtons: "Botón de configuración de la ventana de conversación",
                settingsButton: "Puede bloquear la conversación, avanzar, mensaje confidencial y asignar delegados.",
                chatBarButton:
                    "Aquí puede bloquear la conversación activa, enviar un mensaje privado al agente y dejar la conversación.",
            },
        },
        adminUser: {
            newAdminUserForm: "Nuevo formulario de registro de usuario de administrador",
            updateAdminUserForm: "Formulario de actualización del usuario de administrador",
            adminUsers: "Usuarios administrativos",
            newAdminUser: "Nuevo usuario administrativo",
            noAdminUser: "Todavía no hay usuarios administrativos",
            adminUserName: "Nombre de usuario administrativo",
        },
        report: {
            hourly: "(Por hora)",
            hourlyAverage: "Promedio por hora",
            hourlyMax: "Máximo por hora",
            hourlyMin: "Mínimo por hora",
            totalAmount: "Monto Total",
            averageAmount: "Monto Promedio",
            minAmount: "Monto Mínimo",
            maxAmount: "Monto Máximo",
            siteCount: "site Count",
            agentCount: "Agent Count",
            channelsTimeSeries: "Series temporales de canales",
            channelPies: "Tartas de canal",
            pieView: "Gráfico circular",
            topVisitorCountry: "País con más visitantes",
            websiteTrafficByCountry: "Tráfico del sitio web por país",
            visitorCount: "Número de visitantes",
            websiteVisitorTraffic: "Tráfico de visitantes del sitio web",
            websiteTraffic: "Tráfico del sitio web",
            author: "Autor",
            topWorstComments: "Peores comentarios",
            topBestComments: "Mejores comentarios",
            topComments: "Comentarios principales",
            noComment: "Aún no hay comentarios",
            minWaitingTime: "Tiempo de espera mínimo",
            maxWaitingTime: "Tiempo de espera máximo",
            averageWaitTime: "Tiempo de espera promedio",
            waitTime: "Tiempo de espera (segundos)",
            agentWaitDurationTitle: "Gráfico de duración de espera del agente",
            incomingMessage: "Mensaje(s) entrante(s)",
            outgoingMessage: "Mensaje(s) saliente(s)",
            totalSpent: "Gasto total",
            avgSpent: "Gasto promedio",
            totalPayment: "Pago total",
            walletStatus: "Estado del monedero",
            walletBalanceStatus: "Estado del saldo del monedero",
            messageTraffic: "Tráfico de mensajes",
            breakCount: "Recuento de descansos",
            agentBreakTime: "Recuentos de descanso del agente ☕",
            agentStatusHour: "Hora del estado del agente",
            agentWorkTimeCalendar: "Calendario de tiempo de trabajo del agente",
            agentActivity: "Actividad del agente",
            noEnoughtData: "Datos insuficientes",
            averageFirstResponse: "Tiempo promedio de primera respuesta",
            slowestResponser: "Más lento en responder",
            fastestResponder: "Más rápido en responder",
            firstAnswerTimeSec: "Tiempo del primer mensaje (en segundos)",
            firstAnswerByAgent: "Tiempo del primer mensaje por el agente",
            averageSolutionTime: "Tiempo promedio de solución",
            slowestSolver: "Resolutor más lento",
            fastestSolver: "Resolutor más rápido",
            averageChat: "Chat promedio",
            leastChatReceiver: "Receptor de chat menos activo",
            mostChatRecipients: "La mayoría de los destinatarios de chat",
            averageTicket: "Average Ticket",
            leastTicketReceiver: "Least Ticket Least",
            mostTicketRecipients: "Most Ticket Recipients",
            resolveTime: "Tiempo de resolución (min)",
            resolveTimeByUser: "Tiempo de resolución de chat por usuario (en minutos)",
            chatResolveTimeByAgent: "Tiempo de resolución de chat por agentes",
            chatDistByHandleType: "Distribución de chats por manejador",
            chatDistByHandDesc: "¿Cuántos chats fueron manejados por agentes, chatbots y híbridos?",
            chatCountsByHandleType: "Cantidad de chats por tipo de manejo",
            missed: "Perdido",
            answered: "Respondido",
            chatDistByAnsDesc: "¿Cuántos chats fueron respondidos o perdidos?",
            chatCountsByAns: "Recuento de chats por respuesta",
            chatCountByPlatform: "Recuento de chats por plataforma",
            chatDistByPDesc: "¿Cuántos chats llegaron a cada plataforma?",
            chatDistByPlatform: "Distribución de chats por plataforma",
            ticketCountByUser: "Ticket Counts by Agents",
            ticketCountByStatus: "Ticket Counts by Response Status",
            user: "Usuario",
            saveAsImage: "Guardar como imagen",
            fullScreen: "Pantalla completa",
            download: "Descargar",
            tableView: "Vista de tabla",
            chartView: "Vista de gráfico",
            chatDistByUsers: "Distribución de chats por usuarios",
            chatCountsByUsers: "Recuento de chats por usuarios",
            minDuration: "Duración mínima",
            maxDuration: "Duración máxima",
            totalDurationByAgent: "Duración total de la sesión por agente",
            averageDurationByAgent: "Duración promedio de la sesión por agente",
            totalDurationByCB: "Duración total de la sesión por chatbot",
            averageDurationByCB: "Duración promedio de la sesión por chatbot",
            viewUnitAs: "Ver unidad como",
            hybrid: "Híbrido",
            handledBy: "Manejado por",
            sessionDurationOverall: "Duración total de la sesión",
            allChannels: "Todos los Canales",
            sessionsDurationOverall: "Duración total de las sesiones",
            sessionsOverall: "Sesiones totales",
            calendarEvents: "Eventos de calendario",
            reservationEvents: "Eventos de reserva",
            incomingMails: "Correos entrantes",
            incomingMailCount: "Conteo de correos entrantes",
            reservation: "Reserva",
            event: "Evento",
            reservationEventCount: "Conteo de eventos de reserva",
            channelBreakdown: "Desglose de canales",
            websiteAnalysis: "Análisis del sitio web",
            customerSatisfaction: "Satisfacción del cliente",
            teamBreakAnalysis: "Análisis de pausas del equipo",
            dailyAgentActivity: "Actividad diaria del agente",
            agentPerformance: "Rendimiento del agente",
            chatDistributions: "Distribución de chats",
            users: "Usuarios",
            segmentTimeseries: "Serie temporal del segmento",
            segmentsOverall: "Segmentos en General",
            unmatchRatio: "Proporción de no coincidencia",
            totalMatchCount: "Número total de coincidencias",
            totalUnmatchCount: "Número total de no coincidencias",
            matchRatio: "Proporción de coincidencia",
            matched: "Coincidente",
            trainingOverall: "Entrenamiento General",
            trainingStatusTimeseries: "Serie temporal del estado de entrenamiento",
            duration: "Duración",
            totalSessionDuration: "Duración total de la sesión",
            averageSessionDuration: "Duración promedio de la sesión",
            second: "segundo",
            minute: "minuto",
            hour: "hora",
            aggregateAs: "Agregar como",
            chatbotSessionDurationOverall: "Duración total de la sesión del chatbot",
            ratingTimeSeries: "Serie temporal de calificaciones",
            chatCountTimeseries: "Serie temporal del número de chats",
            notRated: "No calificado",
            totalRatingCount: "Cantidad total de calificaciones",
            averageRating: "Calificación promedio",
            weightedAverageRating: "Calificación promedio ponderada",
            rate: "Calificar",
            ratingOverall: "Customer Ratings Overall",
            session: "Sesión",
            total: "Total",
            average: "Promedio",
            max: "Máximo",
            min: "Mínimo",
            sessionCount: "Conteo de sesiones",
            uniqueUsers: "Usuarios Únicos",
            viewAs: "Ver como:",
            overall: "En General",
            detailReport: "Reporte detallado",
            dailyReports: "Reportes diarios",
            pointBasedReports: "Informes basados ​​en puntos",
            personDateBasedPointReport: "Informe de punto basado en la persona y la fecha",
            personDateBasedReport: "Informe basado en la persona y la fecha",
            personBasedReport: "Informes basados ​​en la persona",
            personAndDateBasedGraph: "Gráfico basado en la persona y la fecha",
            noReport: "Sin informe",
            reports: "Informes",
            totalBar: "Total",
            ticketCount: "Ticket Count",
        },
        stats: {
            total: "Número de todos los chats abiertos",
            active: "Número de chats activos asignados para usted",
            waiting: "Número de visitantes que esperan que ingrese un representante",
            late: "Número de visitantes que esperan más de un cierto período",
            free: "Número de visitantes gratuitos que esperan que el nuevo representante ingrese",
            pco: "[Tasa de utilización de capacidad] Tasa de trabajo Carga de capacidad de chat representativa activa",
            maxCapacity: "Número máximo de chat que el sistema puede asignar representantes sin esperar",
            chatbot: "Número de chat activo con chatbot",
        },
        time: {
            lastYear: "El Año Pasado",
            thisYear: "Este Año",
            last3Months: "Últimos 3 Meses",
            last7: "Últimos 7 Días",
            today: "Hoy",
            yesterday: "Ayer",
            lastWeek: "La semana pasada",
            currentWeek: "Esta semana",
            currentMonth: "Este mes",
            lastMonth: "El mes pasado",
            last30Day: "Últimos 30 días",
            allTime: "Todo el tiempo",
            custom: "Fecha personalizada",
        },
        fastWizard: {
            generalColors: "Colores generales",
            tellUsMore: "Cuéntanos más, para que podamos personalizar tu experiencia",
            moreInfo: "Más información",
            display: "Mostrar",
            availability: "Disponibilidad",
            preview: "Avance",
            installCode: "Código de instalación",
            previous: "Anterior",
            setupSupsisLiveChat: "Configurar chat en vivo de supsis",
            continue: "Próximo paso",
            completeInitialize: "Configuración completa",
            completedMessage: "Configuración de chat en vivo de Supsis completada con éxito.",
            websiteIntegration: "La dirección de su sitio web para integrar el chat en vivo de supsis",
            customizeLiveChat: "Personaliza tu chat en vivo",
            createBrandedExperience: "Cree una experiencia de chat de marca para sus visitantes.",
            chatColor: "Color de chat",
            chooseChatColor: "Elija un color de acento.",
            chatBubble: "Burbuja de chat",
            selectBubble: "Seleccione una burbuja de chat",
            chatBubbleColor: "Color de burbujas de chat",
            selectChatBubbleColor: "Seleccione un color de burbuja de chat",
            customSelection: "La selección personalizada:",
            chatAvailability: "Disponibilidad de chat",
            onlineSupportVisitorTime: "¿Cuándo está en línea para apoyar a sus visitantes?",
            channelAvailability: "Disponibilidad de canales",
            availability724: "El chat está disponible 7/24",
            basedOnTeam: "Basado en el estado del miembro del equipo",
            basedOnTeamExplanation: "El chat aparecerá en línea cuando al menos 1 miembro esté disponible en",
            customHours: "Horario comercial personalizado",
            customHoursExplanation: "Configure su horario hábil",
            customHoursTimezone: "Zona horaria:",
            customHoursFrom: "De:",
            customHoursTo: "A:",
            customHoursAddHours: "+Agregar horas",
            previewDesktop: "Escritorio",
            previewIpad: "Ipad",
            installationAndInstructions: "Instrucciones de instalación",
            installationTrackingCode: "Instale el código de seguimiento en su sitio web",
            installationTrackingCodePlease:
                "Pegue el código de acuerdo con las instrucciones a continuación, justo antes del final de la etiqueta {bodyTag} en cualquier página donde desee habilitar el chat en vivo de Supsis.",
            installationInstructionsJavascript:
                "Pegue el código de integración dado anteriormente en la etiqueta {bodyTag} justo antes del cierre.",
            installationInstructionsCopy: "Copiar",
            installationInstructionsCoppyMessage: "Script de integración copiado en portapapeles",
            installationInstructionsShopify1: "1. Inicie sesión en su panel de Shopify",
            installationInstructionsShopify2:
                "2. Vaya a la tienda en línea> Temas> Menú desplegable Acciones en el tema actual> Editar código> teme.liquid",
            installationInstructionsShopify3:
                "3. Coloque Peque el código de integración dado anteriormente justo antes de la etiqueta {bodyTag} al final del script teme.liquid.",
            installationInstructionsIdeaSoft1: "1. Inicie sesión en el panel de su distribuidor.",
            installationInstructionsIdeaSoft2: "2. Vaya a Configuración -> SEO -> Servicios de motor de búsqueda.",
            installationInstructionsIdeaSoft3:
                '3. Seleccione "Verificación del sitio con metaetiqueta" de la sección Código de seguimiento.',
            installationInstructionsIdeaSoft4:
                "4. Copie y pegue el código de integración anterior en el cuadro abierto y guarde.",
            installationInstructionsIdeaSoft5:
                '5. Configuración interna -> Optimizaciones Haga clic en el botón "Borrar caché". Así se completa la integración.',
            installationInstructionsWordPress1: "1. Inicie sesión en su panel de administración de WordPress",
            installationInstructionsWordPress2: "2. Vaya a la aparición> Editor de temas",
            installationInstructionsWordPress3:
                "3. En archivos de temas (extrema derecha), busque el pie de página del tema (footer.php) y seleccione",
            installationInstructionsWordPress4:
                "4. Paste el código de integración anterior antes de la etiqueta {bodyTag} en la parte inferior.",
            installationInstructionsWordPress5: "5. Haga clic en Actualizar el archivo para guardar cambios",
            installationInstructionsOpenCart1: "1. Inicie sesión en su panel de administración de OpenCart",
            installationInstructionsOpenCart2: "2. Ir al diseño> Editor de temas",
            installationInstructionsOpenCart3: "3. Seleccione la carpeta 'común' y abra 'Header.twig' archivo.",
            installationInstructionsOpenCart4:
                "4. Paste el código de integración anterior antes de la etiqueta {headTag} en la parte inferior.",
            installationInstructionsOpenCart5: "5. Haga clic en el botón Guardar.",
            installationInstructionsTicimax1: "1. Inicie sesión en su panel de administración de Ticimax",
            installationInstructionsTicimax2:
                "2. Abierto de diseño> Diseño> Configuración de diseño de pie de página de encabezado",
            installationInstructionsTicimax3: "3. Haga clic en el botón 'Fuente' en la sección de diseño del logotipo.",
            installationInstructionsTicimax4: "4. Pegue el código de integración arriba debajo del código HTML.",
            installationInstructionsEticaretteyim1: "1. Accede al panel de administración de tu ecommerce",
            installationInstructionsEticaretteyim2:
                "2. Simplemente nombre SUPSIS desde Complementos> Generar HTML> y copie el código.",
            installationInstructions: "Instrucciones",
            installationVerify: "Verifique la instalación de su sitio web de supsis",
            installationVerifyChecking: "Comprobación",
            installationVerifyCheck: "Controlar",
            installationVerifyCheckingStatus: "Verificación del estado de integración de supsis en {website}",
            installationCheckingStatusMessageYes: "¡Genial, el supsis está integrado en el sitio web {website}!",
            installationCheckingStatusMessageNo:
                "SUPSIS no está actualmente integrado con el sitio web {website}. Puede completar su proceso de integración ahora o más tarde.",
            vtippyPreferredLanguage: "Idioma preferido",
        },
        akinon: {
            typeOrSelectSKU: "Escriba o seleccione SKU",
            akinonUserId: "ID de usuario de Akinon",
            userEmail: "Correo electrónico de usuario",
            userEmailDesc: "Escriba o seleccione el correo electrónico del usuario ...",
            send: "Enviar",
            selectCity: "Ciudad selecta",
            city: "Ciudad",
            selectState: "Seleccione estado",
            state: "Estado",
            useMap: "Usar mapa",
            chooseAddress: "Elegir dirección",
            selectCountry: "Seleccionar país",
            country: "País",
            productIdDesc: "Escriba o seleccione producto ...",
            productId: "ID del Producto",
            userIdDesc: "Escriba la identificación de usuario de Akinon ...",
            productSKU: "Sku de productos",
            latitudeDesc: "Escriba o seleccione Latitud de ubicación objetivo ...",
            longitudeDesc: "Escriba o seleccione la longitud de ubicación de destino ...",
            orderNumber: "Su número de orden",
            orderDesc: "Escriba el número de pedido ...",
            longitude: "Longitud",
            latitude: "Latitud",
        },
        headBar: {
            email: "Correo electrónico",
            phone: "Teléfono",
            name: "Nombre",
            date: "Historia",
            subject: "Sujeto",
            situation: "Situación",
            representative: "Representante",
            transactions: "Actas",
        },
        login: {
            loginTitle1: "Bienvenido a",
            loginTitle2: "SUPSIS",
            email: "Tu dirección de correo electrónico",
            emailPlaceholder: "Por favor, introduzca su dirección de correo electrónico.",
            emailError: "Por favor introduzca un correo electrónico válido",
            password: "Tu contraseña",
            passwordLogin: "Iniciar sesión sin contraseña",
            passwordAndLogin: "Iniciar sesión con contraseña",
            passwordNew: "Restablecer mi contraseña",
            loginAnd: "O",
            passwordPlaceholder: "Por favor, introduzca su contraseña.",
            loginMemory: "Recuerde este dispositivo",
            passwordForget: "Olvidé mi contraseña",
            passwordNewAgain: "Nueva contraseña",
            passwordNewAgainTwo: "Repetir nueva contraseña",
            passwordNewAgainPlaceholder: "Por favor ingrese su nueva contraseña.",
            passwordNewAgainPlaceholderTwo: "Vuelva a introducir su nueva contraseña.",
            login: "Acceso",
            loginFooter: "O inicie sesión con correo electrónico",
            emailLogin: "Iniciar sesión con correo electrónico",
        },
        settings: {
            auditlogs: "Audit Logs",
            myaccount: "My Account",
            notifications: "Notifications",
            company: "Empresa",
            features: "Caracteristicas",
            general: "General",
            chat: "Charla",
            timings: "Horarios",
            wallet: "cartera",
            language: "Idioma",
            "bubble-settings": "Configuración de la burbuja",
            "bubble-actions": "Acciones de burbujas",
            "theme-settings": "Configuración del tema",
            visitorLoginForm: "Formulario de inicio de sesión de visitantes",
            visitorAttribute: "Información del perfil del visitante",
            timing_settings: "Configuración de tiempo",
            auto_assign: "Auto Chat Assign",
            availability: "Disponibilidad",
            "website-integration": "Integración del sitio web",
            General: "General",
            Chat: "Charla",
            Timings: "Horarios",
            Integration: "Integración",
            developer: "Desarrollador",
            visitorNew: "Visitante nuevo",
            companySubtitles: "Gestionar la información de su empresa.",
            featuresSubtitles: "Gestionar las características de su empresa.",
            languageSubtitles: "Gestionar el idioma de su empresa.",
            bubbleSettings: "Configuración de la burbuja",
            bubbleSettingsSubtitles: "Gestionar la configuración de la burbuja de su empresa.",
            bubbleActionsSubtitles: "Gestionar las acciones de la burbuja de su empresa.",
            chatThemeSettingsSubtitles: "Gestionar la configuración del tema de chat de su empresa.",
            visitorLoginFormSubtitles:
                "Gestionar la configuración del formulario de inicio de sesión de visitantes de su empresa.",
            chatTimingSettingsSubtitles: "Gestionar la configuración de tiempo de chat de su empresa.",
            webSiteIntegrationSubtitles: "Gestionar la integración de su sitio web de empresa.",
            apiAccessTitle: "Acceso API",
            apiAccessSubtitles: "Gestionar el acceso a la API de su empresa.",
            youTubeActionForm: "Agregue su canal de YouTube",
            linkedinActionForm: "Agrega tu cuenta de LinkedIn",
            telegramActionForm: "Agregar cuenta de Telegram",
            facebookActionForm: "Agregue su página de Facebook",
            tiwitterActionForm: "Agregue su página de Twitter",
            instagramActionForm: "Agregue su página de Instagram",
            liveSupportDescription: "Müşterilerinizle canlı bir sohbet açın",
            ticketDescription: "Crea un ticket de soporte con tus clientes",
            whatsappDescription: "Deje que sus clientes se comuniquen con usted a través de Whatsapp",
            phoneDescription: "Deje que sus clientes se comuniquen con usted por teléfono",
            emailDescription: "Deje que sus clientes se comuniquen con usted por correo electrónico",
            facebookDescription: "Deje que sus clientes se comuniquen con usted a través de Facebook",
            twitterDescription: "Deje que sus clientes se comuniquen con usted a través de Twitter",
            instagramDescription: "Deje que sus clientes se comuniquen con usted a través de Instagram",
            youtubeDescription: "Deje que sus clientes se comuniquen con usted a través de Youtube",
            linkedinDescription: "Deja que tus clientes te contacten con LinkedIn",
            telegramDescription: "Deje que sus clientes alcancen el tamaño con Telegram",
            whatsappModalTitle: "Formulario de acción de Whatsapp",
            whatsappModalDescription: "Para agregar su cuenta de Whatsapp, complete el siguiente formulario.",
            phoneModalTitle: "Formulario de acción telefónica",
            phoneModalDescription: "Para agregar su cuenta telefónica, complete el siguiente formulario.",
            emailModalTitle: "Formulario de acción de correo electrónico",
            emailModalDescription: "Para agregar su cuenta de correo electrónico, complete el siguiente formulario.",
            facebookModalTitle: "Formulario de acción de Facebook",
            facebookModalDescription: "Para agregar su cuenta de Facebook, complete el siguiente formulario.",
            twitterModalTitle: "Formulario de acción de Twitter",
            twitterModalDescription: "Para agregar su cuenta de Twitter, complete el siguiente formulario.",
            instagramModalTitle: "Formulario de acción de Instagram",
            instagramModalDescription: "Para agregar su cuenta de Instagram, complete el siguiente formulario.",
            youtubeModalTitle: "Formulario de acción de Youtube",
            youtubeModalDescription: "Para agregar su cuenta de Youtube, complete el siguiente formulario.",
            linkedinModalTitle: "Formulario de transacción de LinkeIn",
            linkedinModalDescription: "Complete el siguiente formulario para vincular su cuenta de LinkedIn.",
            telegramModalTitle: "Formulario de transacción de Telegram",
            telegramModalDescription:
                "Ingrese el enlace de su perfil de Telegram en el siguiente formulario para vincular su cuenta de Telegram",
            instagramAlertTitle: "Se requiere integración de Instagram",
            instagramAlertDesc: "Lo siento, la página que visitaste se activará cuando integres tu Instagram.",
            instagramActivateText: "Vamos, integra Instagram",
            remove: "Eliminar",
            edit: "Editar",
            connected: "Conectado",
            add: "Añadir",
            themeDescription: "Gestionar la configuración del tema de chat de su empresa.",
            fontDescription: "Gestionar la configuración de fuente de chat de su empresa.",
            isFabsAsIcon: "Mostrar textos de iconos de menú.",
            chatBubbleTextSetting: "Configuración de texto de burbujas de chat",
            textOnChatBubble: "Puede ajustar la configuración de texto que aparecerá en la burbuja de chat.",
            textToAppearOnChatBubble: "Texto para aparecer en la burbuja de chat",
            newVisitorProfileInformation: "Información del perfil del nuevo visitante",
            newVisitorProfileInformationDescription: "Agregar nuevo valor a la información del perfil del visitante",
            create: "Crear",
            newAdd: "Agregar nuevo",
            toInform: "Para informar",
            toInformDescription:
                "Puede hacer coincidir los valores que agrega en esta página con el formulario de inicio de sesión del visitante.",
            showVisitor: "Mostrar visitante",
            label: "Boleto",
            text: "Escribiendo",
            email: "Correo electrónico",
            phone: "Teléfono",
            number: "Número",
            url: "URL",
            date: "Tiempo",
            dropdown: "seleccionable",
            languageTimeZone: "Langue et région",
            timeZoneTitle: "Région et fuseau horaire",
            timeZoneDescription: "Paramètres de région et de fuseau horaire",
        },
        userInfoWidget: {
            userInformation: "Informacion del usuario",
            fullName: "Nombre y apellido",
            newValue: "Nuevo valor",
            newProfileInfo: "Nueva información de perfil",
            affiliatedRepresentatives: "Representantes",
            preferredAgents: "Agente (s) Preferido (s)",
            labels: "Etiquetas",
            agentNotes: "Notas del agente",
            newNote: "Nueva nota",
            note: "Nota",
            available: "Hay notas disponibles.",
            systemInformation: "Información del sistema",
            speechID: "identificación de voz",
            customerVersion: "Versión del cliente",
            IPAddress: "Dirección IP",
            pageVisited: "Página visitada",
            systemAndBrowser: "Sistema operativo y navegador",
            countryAndLanguage: "País e idioma",
            clickToEdit: "Editar Haga clic dentro de la publicación",
            adsYouAreInterestedIn: "Anuncios en los que estás interesado/a",
            detail: "Detalle",
            adsTitle: "Título",
            adUrl: "URL del anuncio",
            sourceID: "ID de origen",
            resourceType: "Tipo de recurso",
            adsBody: "Contenido",
            adsCreateDate: "Fecha de creación",
            adsUpdateDate: "Fecha de actualización",
        },
        newWizartV2: {
            generalSettings: "Configuración general",
            themeSettings: "Ajustes de tema",
            representativeWorkingHours: "Horas de trabajo representativas",
            preview: "avance",
            setup: "Configuración",
            formStepTitle: "Danos más información para que podamos personalizar tu experiencia.",
            supsisEntergation: "¿Dónde usará Supsis en su sitio web?:",
            goToNextStep: "Dar el siguiente paso",
            readytemplate: "Usar plantilla de color listo",
            customSettings: "Ajustes personalizados",
            customerMessageView: "Mensaje del cliente Ver",
            backcgroundColor: "Color de fondo",
            textColor: "Color de fuente",
            agentMessageView: "Vista de mensajes del agente",
            workingHours: "¿En qué intervalos de tiempo proporciona servicios a sus visitantes?",
            continuousService: "Servicio Continuo",
            continuousServiceDescription: "La burbuja de chat siempre está activa. Incluso si no estás en el sistema.",
            vote: "Haz tu elección",
            representativeWorking: "Horas de trabajo representativas",
            representativeWorkingDescription:
                "El chat aparece en línea cuando al menos 1 agente está en línea. Si no hay un representante en línea, aparecerá como fuera de línea.",
            computer: "Computadora",
            tablet: "Tablet",
            uploadTrackingCodeToYourWebsite: "Cargue el código de seguimiento en su sitio web",
            password: "Establecer nueva contraseña",
        },
        whatsappChannel: {
            whatsappTitleV1: "Canales de Whatsapp V1 (QR)",
            whatsappTitleV2: "Canales de Whatsapp V2 (QR)",
            channelName: "Nombre del Canal",
            phoneNumber: "Número de Teléfono",
            forwardToChatbot: "Reenviar al Chatbot",
            forwardingChatbotOrLiveAgent: "Reenvío (Chatbot o Agente en Vivo)",
            addChannel: "Agregar Canal",
            newWhatsappChannel: "Nuevo Canal de WhatsApp",
            newWhatsappChannelDescription: "Cree un nuevo canal de WhatsApp escaneando el código QR",
            editWhatsappChannel: "Editar Canal de WhatsApp",
            editWhatsappChannelDescription: "Editar canal de WhatsApp",
            whatsappChannel: "Canal de WhatsApp",
            deleteWhatsappChannelDescription: "¿Estás seguro de que deseas eliminar este canal?",
            whatsappIntegration: "Integración de WhatsApp",
            deleteChannel: "Eliminar Canal",
            restartChannel: "Reiniciar Canal",
            wantRestartChannel: "¿Quieres reiniciar el canal?",
            deleteSMSChannelDescription: "Estás seguro de que quieres eliminar el canal de SMS?",
            smsChannel: "canal SMS",
            maxChannelCount: "No puedes crear más de un canal de SMS!",
            smsModalText:
                "Nuestra integración con soluciones de comunicación modernas le brinda la oportunidad de enviar SMS de manera fácil y efectiva. ¡Elimine los límites en la comunicación, conéctese directamente con sus clientes!",
            smsModalBtn: "Haga clic para abrir el canal SMS...",
            postaCellDetail: "Detalle del canal PostaCell",
        },
        noPermission: "No tienes permiso para realizar esta operación.",
        mail_integration_detail: {
            title: "Detalle del correo",
            integration: "Integración",
            sender: "Correo del remitente",
            signature: "Firma",
            inbox: "Bandeja de entrada",
            medias: "Medios",
            visibility: "Visibilidad",
            settings_group: "Configuración",
            contacts: "Contactos",
        },
        whatsapp_business_api: {
            title: "Canales de Whatsapp Business API",
            integration: "Integración",
            detail: "Detalle",
            visibility: "Visibilidad",
            templates: "Todos los Mensajes de Plantilla",
            settings_group: "Configuración",
            template_message_group: "Mensajes de Plantilla",
            chat_initiator_template: "Plantilla de iniciación de chat",
            contacts: "Contactos",
            numbers: "Números",
            all_contacts: "Todos los contactos",
            new_template: "Crear nueva Plantilla",
            broadcast_group: "Difusión",
            broadcast_requests: "Solicitudes de Difusión",
            customer_groups: "Grupos de Clientes",
            businessChannelDetail: "Detalles del canal de Whatsapp Business",
            wallet: "Wallet",
            postacellMessage: "Enviar SMS",
            postacellAllMessage: "Enviar SMS Masivo",
            message_group: "Mensaje",
            createNewTemplate: "Crear nuevo mensaje de plantilla",
            templateName: "Nombre de la plantilla",
            templateNameDesc: "Dale un nombre a tu plantilla de mensaje.",
            viewTemplates: "Ver plantillas",
            templateNameRules:
                "El nombre de la plantilla solo puede incluir letras minúsculas, números y guiones bajos.",
            category: "Categoría",
            categoryDesc: "Seleccione qué tipo de plantilla desea crear",
            categoryUtility: "Utilidad",
            categoryUtilityDesc:
                "Envíe información de utilidad como actualizaciones de cuenta, actualizaciones de pedidos, alertas y más.",
            categoryMarketing: "Marketing",
            categoryMarketingDesc:
                "Envíe ofertas promocionales, ofertas de productos y más para aumentar la conciencia y participación.",
            categoryAuth: "Autenticación",
            categoryAuthDesc: "Envíe códigos para que sus clientes puedan acceder a sus cuentas.",
            optional: "Opcional",
            languageDesc: "Seleccione el idioma en el que se enviará su mensaje de plantilla",
            header: "Encabezado",
            headerRules:
                "Agregue un encabezado de 60 caracteres a su mensaje. Solo se admite una variable en el encabezado.",
            headerOptionMedia: "Medios",
            headerOptionText: "Texto",
            none: "Ninguno",
            headerType: "Tipo de encabezado",
            headerText: "Texto del encabezado",
            body: "Cuerpo",
            bodyRules: "Ingrese texto en el idioma que seleccionó para su mensaje",
            addVariable: "Agregar variable",
            variables: "Variables",
            variable: "Variable",
            defaultVariableName: "Nombre de variable predeterminado",
            defaultVariableToolTip:
                "Su variable aparece en la plantilla con este nombre. <br><br> Además, este valor se envía por defecto en caso de otras situaciones.",
            selectATemplate: "Seleccione una plantilla de mensaje",
            variableSettings: "Configuración de variable",
            example: "Ejemplo",
            footer: "Pie de página",
            footerDesc:
                "Agrega un pie de página de 60 caracteres a tu mensaje. Las variables no son compatibles en el pie de página.",
            buttons: "Botones",
            buttonType: "Tipo de botón",
            buttonTypeReply: "Responder",
            submit: "Guardar",
            submitting: "Enviando",
            addButton: "Agregar botón",
            rejectWhatsapp: "Rechazado por Whatsapp.",
            approvedWhatsapp: "Aprobado por Whatsapp.",
            pendingWhatsapp: "Pendiente de aprobación",
        },
    },
    ar: {
        chatWindow: {
            thereIsNoChatContent: "لا يوجد محتوى للدردشة.",
            thereIsNoChatContentDsc: "يمكنك عرض محتوى الدردشة وإرسال الرسائل هنا.",
            interactions: "التفاعلات:",
            departments: "الأقسام",
            channels: "القنوات",
            date: "التاريخ",
            lastChatStatus: "آخر حالة للدردشة",
            all: "الكل",
            queued: "في الانتظار",
            open: "مفتوح",
            closed: "مغلق",
            private: "خاص",
            chatbot: "روبوت الدردشة",
            lostMissed: "مفقود / غير مستجاب",
            interaction: "التفاعل",
            myActiveInbox: "بريدي الوارد النشط",
            activeQueueInbox: "البريد الوارد النشط + الانتظار",
            chatbotActiveInbox: "البريد الوارد النشط لروبوت الدردشة",
            myDepartmentsActiveInbox: "البريد الوارد النشط لأقسامى",
            notInteractedYesterday: "لا تفاعلات بالأمس",
            queueInbox: "البريد الوارد في الانتظار",
            whatsappActiveInbox: "البريد الوارد النشط لـ WhatsApp",
            socialMediaActiveInbox: "البريد الوارد النشط لوسائل التواصل الاجتماعي",
            missedThisMonth: "الدردشات الفائتة هذا الشهر",
            chooseAFileOrDragItHere: "اختر ملفًا أو اسحبه هنا!",
            watching: "مشاهدة",
            selectFilter: "اختر مرشحًا",
            clearAll: "مسح الكل",
            me: "أنا",
            today: "اليوم",
            yesterday: "أمس",
            thisWeek: "هذا الأسبوع",
            lastWeek: "الأسبوع الماضي",
            last7Days: "آخر 7 أيام",
            last30Days: "آخر 30 يومًا",
            thisMonth: "هذا الشهر",
            lastMonth: "الشهر الماضي",
            last24h: "آخر 24 ساعة",
            custom: "مخصص",
            startMessage: "بدء الرسالة",
            goToAgentReport: "اذهب إلى تقرير الوكيل",
            agentDetail: "تفاصيل الوكيل",
            agentList: "قائمة الوكلاء",
            selectedFilter: "عامل التصفية المحدد",
            groupBy: "تجميع",
            none: "لا توجد مجموعة",
            agent: "ممثل",
            department: "قسم",
            sortBy: "ترتيب",
            lastPostAbove: "آخر منشور في الأعلى",
            newChatsAbove: "الدردشات الجديدة في الأعلى",
            oldChatsAbove: "الدردشات القديمة في الأعلى",
            live: "يعيش",
            systemStatus: "حالة النظام",
            refresh: "تحديث",
            close: "إغلاق",
            totalCustomers: "إجمالي العملاء",
            totalAnswered: "إجمالي الردود",
            waitingAnswer: "بانتظار الرد",
            totalAgentInChat: "إجمالي الوكلاء في الدردشة",
            onlineAgentCount: "عدد الوكلاء المتصلين",
            totalCustomer: "إجمالي العميل",
            answered: "تم الرد",
            unanswered: "لم يتم الرد",
            noContactWasFoundMatchingTheCurrentFilters: "لم يتم العثور على أي جهة اتصال مطابقة للمرشحات الحالية.",
            you: "أنت",
            others: "الآخرون",
            queue: "قائمة الانتظار",
            chatbotContact: "شات بوت",
            closedContact: "مغلق",
            myInteractions: "تفاعلاتي",
            special: "خاص",
            allInteractions: "جميع جهات الاتصال",
            waiting: "قيد الانتظار",
            departmentToWhichItIsAffiliated: "القسم التابع له",
        },
        plans: {
            manageWithChatbot: "Manage with Chatbot",
            manageInbox: "Manage Inbox",
            commentManagement: "Manage Comments",
            privateReplyMessage: "Private Reply Comments",
            mentionTicket: "Convert Mentions to Tickets",
            week: "أسبوع",
            readyContents: "المحتويات الجاهزة",
            webhookIntegration: "تكامل ويب هوك",
            businessChannel: "قناة واتساب للأعمال",
            confirmationFeature: "ميزة التأكيد",
            specialReporting: "تقارير خاصة",
            aiAssistant: "مساعد الذكاء الاصطناعي",
            flexibleBilling: "الفوترة المرنة",
            automaticReservation: "الحجز التلقائي",
            taskManagement: "إدارة المهام",
            calendarIntegration: "تكامل التقويم",
            activeChatbot: "الشات بوت النشط",
            smsIntegration: "تكامل الرسائل القصيرة",
            mailIntegration: "تكامل البريد",
            startChatWithVisitor: "بدء محادثة مع الزائر",
            whatsappManaging: "إدارة الواتساب",
            automaticChatbotButton: "زر / روبوت دردشة تلقائي",
            personalizedBroadcasts: "البث المخصص",
            chatWithNonContacts: "الدردشة مع غير المتصلين",
            broadcastMessaging: "الرسائل الجماعية",
            perBroadcast: "لكل بث",
            extraPricePerMessage: "سعر إضافي لكل رسالة",
            smartTrigger: "زنة ذكية",
            telegramIntegration: "تكامل تلغرام",
            instagramIntegration: "تكامل إنستجرام",
            ticketFeature: "ميزة التذاكر",
            storage: "تخزين",
            onePanelManagement: "إدارة لوحة واحدة",
            isolatedDatabaseConnection: "اتصال قاعدة بيانات معزول",
            removeLogo: "إزالة شعار Supsis",
            chatBaloonCustomization: "تخصيص بالون الدردشة",
            chatAndNotifications: "الدردشة والإشعارات",
            unlimited: "غير محدود",
            specialCustomerSupport: "دعم العملاء الخاص",
            softwareSupport: "دعم البرمجيات",
            standardSupport: "الدعم القياسي",
            teamChatIntegration: "تكامل دردشة الفريق",
            fileAndVoiceShare: "مشاركة الملفات والصوت",
            instantVisitor: "تتبع الزائر الفوري",
            detailedReporting: "تقارير مفصلة",
            normalreporting: "تقارير عادية",
            noExtraCosts: "لا تكاليف إضافية",
            accessibleToAllAgents: "يمكن الوصول إليها من قبل جميع الوكلاء",
            dataSecurity: "أمان البيانات",
            autoTranslate: "الترجمة التلقائية",
            chatbotVersionHistory: "سجل إصدارات الدردشة الآلية",
            chatbotStory: "قصة الدردشة الآلية",
            freeAgent: "العميل المجاني",
            stableAgentCount: "عدد الوكلاء الثابتة",
            stableChannelCount: "Stable Channel Count",
            chipPlans: "خطط بأسعار معقولة",
            generalPlan: "خطة عامة",
            specialPlan: "خطة خاصة",
            currentPlan: "الخطة الحالية",
            selected: "مختار",
            popular: "شائع",
            trialPkg: "حزمة تجريبية",
            support: "الدعم على مدار الساعة",
            flexiblePricing: "تسعير مرن",
            rightToCancel: "الحق في الإلغاء في أي وقت",
            unlimitedCBScenario: "سيناريوهات الدردشة غير المحدودة",
            freeFirstScenario: "السيناريو الأول مجانًا",
            unlimitedLearn: "تدريب الدردشة غير المحدود",
            allPlatformIntegration: "التكامل مع جميع البنيات التحتية",
            detailedReports: "تقارير مفصلة",
            aiSupport: "دعم الذكاء الصناعي",
            creativeAI: "مساعد دردشة ذكاء اصطناعي سريع وواقعي",
            unlimitedSession: "جلسات غير محدودة في نفس الوقت",
            assistantFromWebsite: "إنشاء مساعد من الموقع الإلكتروني",
            assistantFromDoc: "إنشاء Chatbot من المستند",
            mobileApp: "تطبيق الجوال",
        },
        messenger: {
            channel: "قناة المسنجر",
            manageChannel: "إدارة القناة",
            channelDetail: "تفاصيل القناة",
            integrationTitle: "تكامل Messenger",
            deleteDesc: "هل أنت متأكد أنك تريد حذف قناة Messenger؟",
            channels: "قنوات المراسل",
            connectMessenger: "الاتصال بالمراسل",
            detail: "تفصيل",
            visibility: "رؤية",
            settings_group: "الإعدادات",
            commentsettings: "إدارة التعليقات",
            commentSettingsTitle: "إدارة تعليقات الماسنجر",
            commentSettingsDesc: "إدارة تعليقاتك على Messenger",
        },
        instagram: {
            channel: "قناة إنستجرام",
            detail: "تفصيل",
            visibility: "رؤية",
            settings_group: "الإعدادات",
            commentsettings: "إدارة التعليقات",
            commentSettingsTitle: "إدارة التعليقات على إنستغرام",
            commentSettingsDesc: "إدارة تعليقاتك على إنستغرام",
            commentSettingsTicket: "يضمن تسجيل التعليقات الواردة في النظام كتذاكر.",
            commentSettingsChatbot: "حدد سيناريو شات بوت الذي يجب توجيه التعليقات الواردة إليه.",
            leads: "Leads",
            forms: "Forms",
        },
        calendar: {
            setting: "الإعدادات",
            delete: "حذف",
            cancel: "إلغاء",
            save: "حفظ",
            close: "إغلاق",
            deleteRepeatEvent: "حذف الحدث المتكرر",
            thisEvent: "هذا الحدث",
            thisAndOtherEvent: "هذا الحدث والأحداث التالية",
            allEvent: "جميع الأحداث",
            ok: "موافق",
            googleCalendarLink: "إضافة إلى تقويم Google",
            yahooCalendarLink: "إضافة إلى تقويم Yahoo",
            subject: "الموضوع",
            visitor: "الزائر",
            allDay: "طوال اليوم",
            title: "العنوان",
            deleteEvent: "حذف الحدث",
            deleteEvents: "حذف الأحداث",
            deleteEventsSure: "هل أنت متأكد من أنك تريد حذف الأحداث من هذا التقويم؟",
            deleteEventConfirm: "هل أنت متأكد من أنك تريد حذف هذا الحدث؟",
            notEmptyTitle: "لا يمكن ترك العنوان فارغًا!",
            tasks: "المهام",
            googleConnect: "دمج Google",
            googleDisconnect: "إلغاء دمج Google",
            sure: "هل أنت متأكد؟",
            disconnectGoogleSure: "هل أنت متأكد من أنك تريد إلغاء دمج Google؟",
            yes: "نعم",
            no: "لا",
            customRepeat: "تكرار مخصص",
            recurrenceFrequency: "تكرار الحدوث",
            repeatDays: "تكرار في الأيام:",
            never: "أبدًا",
            thisDate: "في هذا التاريخ:",
            recurrenceCount: "عدد مرات التكرار:",
            end: "النهاية",
            event: "الحدث",
            calendars: "التقاويم",
            newCalendar: "إنشاء تقويم جديد",
            changeColor: "تغيير اللون",
            addCalendar: "إضافة تقويم",
            nameCalendar: "اسم التقويم",
            description: "الوصف",
            change: "تغيير",
            deleteCalendar: "حذف التقويم",
            deleteCalendarSure: "هل أنت متأكد من أنك تريد حذف هذا التقويم؟",
            notEmptyCalendarName: "لا يمكن أن يكون اسم التقويم فارغًا",
            myEvents: "أحداثي",
            everyoneEvents: "جميع الأحداث",
            haveEvent: "أحداث الوكيل",
            goCalendar: "اذهب إلى التقويم",
            goReservation: "إنشاء حجز",
            agents: "الوكلاء",
            today: "اليوم",
            month: "شهر",
            week: "أسبوع",
            day: "يوم",
            list: "قائمة",
        },
        ticimax: {
            segment: "قطاع",
            settings_group: "مجموعة الإعدادات",
            waitDayFromLastSend: "يوم الانتظار منذ آخر رسالة تم إرسالها",
            automationRuleName: "اسم قاعدة الأتمتة",
            time: "زمن",
            year: "سنة",
            month: "شهر",
            dayOfMonth: "يوم الشهر",
            day: "يوم",
            bySecond: "لكل ثانية",
            byMinute: "لكل دقيقة",
            byHour: "لكل ساعة",
            byWeekNo: "لكل رقم أسبوع",
            byYearDay: "لكل يوم في السنة",
            byMonthDay: "لكل يوم في الشهر",
            byMonth: "لكل شهر",
            december: "ديسمبر",
            november: "نوفمبر",
            october: "أكتوبر",
            september: "سبتمبر",
            august: "أغسطس",
            july: "يوليو",
            june: "يونيو",
            may: "مايو",
            april: "أبريل",
            march: "مارس",
            february: "فبراير",
            january: "يناير",
            byWeekDay: "لكل يوم في الأسبوع",
            interval: "فاصل زمني",
            seconds: "ثواني",
            minutes: "دقائق",
            hourly: "كل ساعة",
            daily: "يوميًا",
            weekly: "أسبوعيًا",
            monthly: "شهريًا",
            yearly: "سنويًا",
            frequency: "تكرار",
            attributes: {
                vip: "VIP",
                segment: "قطاع",
                province: "مقاطعة",
                country: "بلد",
                phone: "هاتف",
                email: "البريد الإلكتروني",
                fullname: "الاسم الكامل",
                couponPercent: "% من القسيمة",
                lastOrderDate: "آخر طلب",
                firstOrderDate: "أول طلب",
                county: "مقاطعة",
                lastSource: "آخر مصدر",
                firstSource: "أول مصدر",
                lastPaymentType: "آخر طريقة دفع",
                firstPaymentType: "أول طريقة دفع",
                maxOrderAmount: "الحد الأقصى لمبلغ الطلب",
                minOrderAmount: "الحد الأدنى لمبلغ الطلب",
                totalOrderAmount: "إجمالي مبلغ الطلب",
                totalOrderCount: "إجمالي عدد الطلبات",
                usedCouponAmount: "مبلغ القسيمة المستخدمة",
                usedCouponCount: "عدد القسائم المستخدمة",
                tookDayFromLastOrder: "أيام منذ آخر طلب",
                isCouponUser: "هل هو مستخدم قسيمة؟",
            },
            createAutomation: "إنشاء التلقائي",
            previous: "سابق",
            createAutomationDesc: "إنشاء وإدارة الأتمتة الرسائل",
            newTicimaxChannel: "قناة Ticimax الجديدة",
            connextToTicimaxXml: "الاتصال بخدمة XML Ticimax",
            connectTicimax: "الاتصال بـ Ticimax",
            examplePreview: "معاينة المثال",
            completeAutomationRule: "قاعدة الأتمتة الكاملة",
            configureMessage: "تكوين الرسالة",
            automationTimer: "المؤقت الآلي",
            findTargetMembers: "العثور على الأعضاء المستهدفين",
            createAutomationRule: "إنشاء قاعدة الأتمتة",
            action: "عمل",
            status: "الحالة",
            triggeredUserCount: "عدد المستخدمين المفعلين",
            nextScheduled: "المقررة التالية",
            timerRule: "قاعدة المؤقت",
            automationRules: "قواعد الأتمتة",
            apply: "تطبيق",
            searchAMember: "البحث عن عضو",
            segmentedMembersDesc: "قائمة وأتمتة الأعضاء المجزأين",
            manageVisibilityDesc: "إدارة رؤية القناة",
            xmlOrderListURL: "عنوان URL لقائمة الطلبات XML",
            manageIntegrationDesc: "إدارة تكامل Ticimax الخاص بك",
            detail: "التفاصيل",
            ticimaxChannelsTitle: "قنوات Ticimax",
            ticimaxDetail: "تفاصيل Ticimax",
            settingsGroup: "الإعدادات",
            visibility: "الرؤية",
            members: "الأعضاء",
            automation: "الأتمتة",
            integrationChannel: "قناة التكامل",
            channelUpdated: "تم تحديث القناة بنجاح",
            channelUpdateFailed: "فشل تحديث القناة",
        },
        notification: {
            mobileApp: "التطبيق المحمول",
            webPanel: "لوحة الويب",
            notifications: "الإشعارات",
            whatsappActions: "إجراءات الواتساب",
            chatbotActions: "إجراءات الدردشة الآلية",
            companyActions: "إجراءات الشركة",
            crmActions: "إجراءات CRM SUPSIS",
            basicActions: "الإجراءات الأساسية",
            notificationSettingsDesc: "اختر الإشعارات التي تريد تلقيها وأين تريد تلقيها.",
            noNotificationDesc2:
                "هنا سترى جميع الإشعارات المتعلقة بالوظائف والمرشحين وحمامات المواهب التي تتابعها. يمكنك تخصيص الإشعارات عن طريق ضبط الإعدادات.",
            noNotificationTitle2: "لا يوجد إشعارات بعد.",
            noNotificationTitle1: "لا توجد إشعارات. استمتع بالسكون.",
            adjustSettings: "ضبط الإعدادات",
            showAll: "إظهار الكل",
            showOnlyUnread: "عرض فقط غير المقروءة",
            mailWasSent: "تم إرسال البريد الإلكتروني.",
            mailAdressRemoved: "تمت إزالة عنوان البريد الإلكتروني.",
            chatbotPublished: "تم نشر الإصدار <b>{version}</b> من الدردشة الآلية بواسطة <b>{user}</b>.",
            chatbotDeleted: "تم حذف الدردشة الآلية <b>{chatbot}</b> بواسطة <b>{user}</b>.",
            settingsUpdatedWoDetail: "تم تحديث الإعدادات بواسطة <b>{user}</b>.",
            noActivityDesc: "لا توجد حاليًا أي أنشطة في النظام. يجب أن تحدث بعض الأحداث",
            noActivityTitle: "لا يوجد نشاط بعد",
            actionType: "نوع الحركة",
            dateBetween: "تاريخ بين",
            selectActor: "اختر المستخدم",
            activities: "أنشطة",
            chatbotCreated: "تم إنشاء الدردشة الآلية ذات الاسم <b>{chatbot}</b> بواسطة <b>{user}</b>.",
            taskStageChanged:
                "تم تغيير مرحلة المهمة <b>{task}</b> من <b>{oldStage}</b> إلى <b>{newStage}</b> بواسطة <b>{user}</b>.",
            taskCreated: "تم إنشاء المهمة <b>{task}</b> بواسطة <b>{user}</b>.",
            contactPropRemoved: "تمت إزالة خاصية الزائر <b>{prop}</b> بواسطة <b>{user}</b>.",
            contactPropAdded: "تمت إضافة خاصية الزائر <b>{prop}</b> بواسطة <b>{user}</b>.",
            userRemoved: "تمت إزالة المستخدم <b>{oldUser}</b> بواسطة <b>{user}</b>.",
            loginFormUpdated: "تم تحديث نموذج تسجيل الدخول للزائر بواسطة <b>{user}</b>.",
            loginFormDeactivated: "تم تعطيل نموذج تسجيل الدخول بواسطة <b>{user}</b>.",
            loginFormActivated: "تم تنشيط نموذج تسجيل الدخول بواسطة <b>{user}</b>.",
            invoiceRefunded: "تمت عملية الاسترداد بواسطة <b>{user}</b>.",
            paymentMethodAdded: "تمت إضافة طريقة دفع جديدة بواسطة <b>{user}</b>.",
            invoicePaymentFailed: "لم يتم قبول دفع الفاتورة من قبل <b>{user}</b>.",
            invoicePaymentReceived: "تم قبول دفع الفاتورة بواسطة <b>{user}</b>.",
            planStarted: "<b>{user}</b> بدأ المستخدم الاشتراك في <b>{title}</b> (<b>{altTitle}</b>).",
            planStartedAgent:
                "<b>{user}</b> بدأ المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{details} مندوب</b>).",
            planStartedChatbot:
                "<b>{user}</b> بدأ المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} جلسة</b>).",
            planStartedWhatsapp:
                "<b>{user}</b> بدأ المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} قنوات واتساب</b>).",
            planStartedWhatsappApi:
                "<b>{user}</b> بدأ المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} قنوات واتساب للأعمال</b>).",
            PlanCanceled: "<b>{user}</b> ألغى المستخدم الاشتراك في <b>{title}</b> (<b>{altTitle}</b>).",
            planCanceledAgent:
                "<b>{user}</b> ألغى المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{details} مندوب</b>).",
            planCanceledChatbot:
                "<b>{user}</b> ألغى المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} جلسة</b>).",
            planCanceledWhatsapp:
                "<b>{user}</b> ألغى المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} قنوات واتساب</b>).",
            planCanceledWhatsappApi:
                "<b>{user}</b> ألغى المستخدم الاشتراك في <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} قنوات واتساب للأعمال</b>).",
            invoiceCreated: "تم إنشاء الفاتورة بواسطة <b>{user}</b>.",
            billingAddressUpdated: "تم تحديث معلومات العنوان بواسطة <b>{user}</b>.",
            taskWorkflowDeleted: "تم حذف سير العمل <b>{workflow}</b> بواسطة <b>{user}</b>.",
            whatsappBroadcastFailed: "فشل إرسال رسالة البث ذات العنوان <b>{title}</b>.",
            whatsappBroadcastCancelled: "تم إلغاء إرسال رسالة البث ذات العنوان <b>{title}</b>.",
            whatsappBroadcastCompleted: "تم إرسال رسالة بث بعنوان <b>{title}</b> بنجاح إلى <b>{numbers}</b> مستلمين.",
            whatsappBroadcastCreated:
                "تم إرسال رسالة بث بعنوان <b>{title}</b> إلى <b>{numbers}</b> مستلمين بواسطة <b>{user}</b>.",
            ticketAssigned: "تم تعيين تذكرة لـ <b>{user2}</b> بواسطة <b>{user1}</b>.",
            userLoggedIn: "قام <b>{user}</b> بتسجيل الدخول إلى SUPSIS.",
            chatJoined: "انضم <b>{agent}</b> إلى المحادثة مع <b>{visitor}</b>.",
            chatForwarded: "تم تحويل المحادثة مع <b>{visitor}</b> إلى <b>{agent}</b> بواسطة <b>{user}</b>.",
            chatAssigned: "تم تعيين الدردشة مع <b>{visitor}</b> إلى <b>{agent}</b> من قبل النظام.",
            customerGroupUpdated: "تم تحديث المجموعة <b>{group}</b> بواسطة <b>{user}</b>.",
            customerGroupRemoved: "تمت إزالة المجموعة <b>{group}</b> بواسطة <b>{user}</b>.",
            customerGroupAdded: "تم إنشاء المجموعة <b>{group}</b> بواسطة <b>{user}</b>.",
            contentRemoved: "تمت إزالة المحتوى الجاهز <b>{content}</b> بواسطة <b>{user}</b>.",
            contentAdded: "تمت إضافة المحتوى الجاهز <b>{content}</b> بواسطة <b>{user}</b>.",
            channelVisibilityChanged: "تم تغيير رؤية قناة التكامل <b>{channel}</b> بواسطة <b>{user}</b>.",
            taskDeleted: "تم حذف المهمة <b>{task}</b> بواسطة <b>{user}</b>.",
            userRemovedToDepartment:
                "تمت إزالة المستخدم <b>{user2}</b> من قسم <b>{department}</b> بواسطة <b>{user1}</b>.",
            userAddedToDepartment:
                "تمت إضافة المستخدم <b>{user2}</b> إلى قسم <b>{department}</b> بواسطة <b>{user1}</b>.",
            mailAddressAdded: "تمت إضافة عنوان البريد الإلكتروني <b>{email}</b> بواسطة <b>{user}</b>",
            settingUpdate: "تم التحديث بواسطة <b>{user}</b>:",
            taskWFlowCreated: "تم إنشاء تدفق العمل للمهام <b>{Wflow}</b> بواسطة <b>{user}</b>.",
            bannedWordRemoved: "تمت إزالة الكلمة المحظورة <b>{bWord}</b> بواسطة <b>{user}</b>.",
            bannedWordCreated: "تم إنشاء الكلمة المحظورة <b>{bWord}</b> بواسطة <b>{user}</b>.",
            welcomeMessageRemoved: "تمت إزالة رسالة الترحيب <b>{welcome}</b> بواسطة <b>{user}</b>.",
            welcomeMessageAdded: "تم إنشاء رسالة ترحيب <b>{welcome}</b> بواسطة <b>{user}</b>.",
            tagRemoved: "تمت إزالة العلامة <b>{tag}</b> بواسطة <b>{user}</b>.",
            tagAdded: "تمت إضافة العلامة <b>{tag}</b> بواسطة <b>{user}</b>.",
            roleRemoved: "تمت إزالة الدور <b>{role}</b> بواسطة <b>{user}</b>.",
            roleAdded: "تمت إضافة الدور <b>{role}</b> بواسطة <b>{user}</b>.",
            departmentRemoved: "تمت إزالة القسم <b>{department}</b> بواسطة <b>{user}</b>.",
            departmentAdded: "تمت إضافة القسم <b>{department}</b> بواسطة <b>{user}</b>.",
            triggerUpdated: "تم تحديث المشغل بواسطة <b>{user}</b>.",
            triggerRemoved: "تمت إزالة المشغل بواسطة <b>{user}</b>.",
            triggerAdded: "تم إنشاء مشغل جديد بواسطة <b>{user}</b>.",
            webhookRemoved: "تمت إزالة webhook <b>{user1}</b> بواسطة <b>{user2}</b>",
            webhookAdded: "تمت إضافة Webhook بواسطة <b>{user1}</b>, تمت إضافتها بواسطة <b>{user2}</b>.",
            chatClosed: "تم إنهاء المحادثة مع <b>{visitor}</b> بواسطة <b>{agent}</b>.",
            chatOpenedByAgent: "<b>{agent}</b> بدأ دردشة <b>{platform}</b> مع <b>{visitor}</b>.",
            chatOpenedByVisitor: "دردشة <b>{platform}</b> تم بدءها بواسطة <b>{visitor}</b>.",
            channelRemoved: "تمت إزالة القناة <b>{channel}</b> بواسطة <b>{agent}</b>.",
            userAdded: "<b>{agent}</b> أنشأ ممثلاً يدعى <b>{newAgent}</b>.",
            visitorUnblocked: "الزائر <b>{visitor}</b> تم إلغاء حظره بواسطة المستخدم <b>{agent}</b>.",
            visitorBlocked: "تم حظر الزائر <b>{visitor}</b> بواسطة <b>{agent}</b>.",
            userStatusChanged: "قام المستخدم <b>{name}</b> بتغيير الحالة من <b>{oldStatus}</b> إلى <b>{newStatus}</b>.",
            channelCreated: "تم إنشاء القناة <b>{channel}</b> بواسطة <b>{name}</b>.",
            reservationCreatedPlan: "قام <b>{name}</b> بجدولة الموعد بعنوان <b>{title}</b> لتاريخ <b>{date}</b>.",
            reservationUpdatedPlan: "قام <b>{name}</b> بتحديث الموعد بعنوان <b>{title}</b>.",
            reservationDeletedPlan: "قام <b>{name}</b> بحذف الموعد بعنوان <b>{title}</b>.",
            reservationCreated: "تم إنشاء حجز للمستخدم <b>{name}</b> والزائر <b>{visitor}</b> في تاريخ <b>{date}</b>.",
            reservationDeleted:
                "تم إلغاء الموعد المقرر بين المستخدم <b>{name}</b> والزائر <b>{visitor}</b> في تاريخ <b>{date}</b>.",
            chatAssignedMe: "عندما يتم تعيين محادثة لي",
            ticketAssignedMe: "عندما يتم تعيين تذكرة لي",
            taskAssignedMe: "عندما يتم تعيين مهمة لي",
            myChatClosed: "عند إغلاق الدردشة التي أمتلكها",
            tagActionsToVisitor: "تمت إضافة أو إزالة الوسوم من جهة اتصال",
            ticketCreated:
                "تم إنشاء التذكرة من قبل الزائر أو الروبوت الدردشة. كما يتم إرسال رسالة دون اتصال عند إرسالها من عنصر واجهة محادثة",
            notesActions: "تمت إضافة ملاحظة أو إزالتها من عميل.",
            visitorProfileUpdated: "تم تحديث ملف الزائر",
            chatStartedByAnyPlatform: "يتم بدء الدردشة على أي منصة من قبل جهة الاتصال أو الوكيل",
            userActions: "المستخدم تم إنشاؤه أو تحديثه أو حذفه",
            departmentActions: "القسم تم إنشاؤه أو تحديثه أو حذفه",
            settingsActions: "الإعدادات تم إنشاؤها أو تحديثها أو حذفها",
            integrationsActions: "تم إنشاء القناة المتكاملة أو تحديثها أو حذفها",
            loginFormActions: "تم تحديث نموذج تسجيل الدخول أو تنشيطه أو إلغاء تنشيطه",
            bannedWordActions: "تم إنشاء كلمة محظورة أو تحديثها أو حذفها",
            emailActions: "تم إنشاء حساب البريد الإلكتروني أو حذفه",
            preparedContentActions: "تم إنشاء المحتوى المعد أو حذفه",
            roleActions: "تم إنشاء الدور أو تحديثه أو حذفه",
            tagActions: "تم إنشاء العلامة أو تحديثها أو حذفها",
            welcomeMessageActions: "تم إنشاء رسالة الترحيب أو تحديثها أو حذفها",
            webhookActions: "تم إنشاء webhook أو تحديثه أو حذفه",
            billingEvents: "أحداث الفوترة",
            taskWorkflowCrud: "تم إنشاء سير عمل المهمة أو تحديثه أو حذفه",
            taskCrud: "تم إنشاء المهمة أو تحديثها أو حذفها",
            systemStatus: "تغيرات حالة النظام عبر الإنترنت أو دون اتصال",
            chatbotStoryCrud: "تم إنشاء قصة الروبوت الدردشة أو تحديثها أو حذفها",
            chatbotForwardAgent: "الروبوت الدردشة يحيل دردشة إلى وكيل",
            userSegmentCrud: "تم إنشاء قطاع المستخدم أو تحديثه أو حذفه",
            chatbotCreditLow: "عندما يكون رصيد الدردشة منخفضًا",
            wpCreditLow: "عندما يكون رصيد واتساب منخفضًا",
            wpCustomerGroupCrud: "عند إنشاء مجموعة عملاء واتساب أو تحديثها أو حذفها",
            wpBroadcastMessageStatus: "عند إرسال رسالة بث واتساب أو إكمالها أو إلغائها",
            wpTemplateMesssageCrud: "عند إنشاء رسالة قالب واتساب أو تحديثها أو حذفها",
            reservationMessageCrud: "تم إنشاء الحجز وتحديثه وإلغاؤه",
        },
        mail: {
            deleteMailDesc: "لا يمكن التراجع عن هذا الإجراء.",
            deleteMailTitle: "هل أنت متأكد أنك تريد حذف عنوان البريد الإلكتروني هذا؟",
            gmailForwardMail: "إعادة توجيه البريد الإلكتروني في Gmail",
            senderMailAddressDesc: "يرجى إدخال عنوان بريد الإلكتروني للمرسل",
            verified: "تم التحقق",
            notForwarded: "غير معاد توجيهه",
            notVerified: "غير مؤكد",
            default: "افتراضي",
            isVerified: "تم التحقق",
            forwarding: "إعادة التوجيه",
            mailAdress: "عنوان البريد الإلكتروني",
            addSenderAddress: "إضافة عنوان المُرسِل",
            outlookForward: "توجيه Microsoft (Outlook/Exchange)",
            gmailForward: "توجيه Google (Gmail)",
            senderMail: "بريد المُرسِل",
            mailDetail: "تفاصيل البريد",
            mailNotFound: "البريد غير موجود",
            mailSelecting: "اختيار البريد",
            newMail: "بريد جديد",
            myMails: "رسائلي البريدية",
            inbox: "صندوق الوارد",
            sent: "تم الإرسال",
            departmentMails: "رسائل البريد الإلكتروني للقسم",
            newTemplate: "قالب جديد",
            unread: "غير مقروء",
            unreply: "Unanswered",
            ly: "الرد",
            attachments: "مرفقات البريد",
            To: "إلى",
            From: "من",
            placeHolders: "عناصر البديل",
            attacheFiles: "إرفاق الملفات",
            replyAll: "الرد على الجميع",
            forward: "إعادة توجيه",
            deleteThread: "حذف المحادثة",
            markAsRead: "وضع علامة كمقروء",
            markAsAllRead: "وضع علامة على الكل كمقروء",
            emailEditor: "محرر البريد الإلكتروني",
            integrateYourMail: "ادمج بريدك الإلكتروني",
            connect: "اتصل",
            departmentMail: "البريد الإلكتروني للقسم",
            createMailAddress: "إنشاء عنوان بريد إلكتروني",
            createNewMail: "إنشاء بريد جديد",
        },
        visitor: {
            mail: "بريد",
            visitorDetail: "تفاصيل الزائر",
            selectedUser: "{selectedUser} من بين {totalUsers} مستخدم محدد",
            uncheck: "إلغاء تحديد الكل",
            checkAll: "تحديد الكل",
            matchedUsers: "{checkedCount} مستخدم مطابق",
            more: "المزيد",
            exportUsers: "تصدير المستخدمين المحددين",
            exportAllUsers: "تصدير جميع المستخدمين",
            addSegment: "إضافة قطاع",
            deleteCheckedUser: "حذف المستخدمين المحددين",
            deleteAllUser: "حذف جميع المستخدمين",
            matchedFilter: "مطابقة جميع الفلاتر",
            visitor: "الزائر",
            deleteUser: "حذف المستخدم",
            userData: "بيانات المستخدم",
            lastSession: "الجلسة الأخيرة",
            notUserData: "لا توجد بيانات مستخدم",
            segments: "الأقسام",
            tags: "العلامات",
            addTag: "إضافة علامة",
            userChats: "محادثات المستخدم",
            seeAll: "عرض الكل",
            confirm: "تأكيد",
            manageSegments: "إدارة الأقسام",
            search: "بحث",
            manageTags: "إدارة العلامات",
            allAttributes: "عرض جميع الخصائص",
            noData: "لا توجد بيانات",
            noEmail: "لا يوجد بريد إلكتروني",
            noIpAddress: "العنوان IP غير موجود.",
            noWpNumber: "الرقم غير موجود.",
            filterName: "اسم الفلتر..",
            matchedContacts: "{chechkedCount} الاتصالات المتطابقة",
        },
        chatbotv2: {
            selectedStory: "{count} قصة محددة",
            Instagram_Actions: "Instagram Actions",
            suppressionRemoved: "تمت إزالة القمع",
            suppressionAdded: "تمت إضافة القمع",
            didntSuppression: "لم تقم بأي قمع.",
            whatsappIntegrationTitle: "تكامل واتساب V1 وواتساب V2",
            whatsappApiIntegrationTitle: "تكامل واجهة برمجة تطبيقات واتساب للأعمال",
            ReadyTemplateBadge: "قالب جاهز",
            readyTemplates: "قوالب جاهزة",
            regex: "Regex",
            regexDescription: "Regex ile herşeyi yakala",
            chatbotLogo: "شعار الدردشة الآلية",
            chatbotName: "اسم الدردشة الآلية",
            allSecnario: "قائمة سيناريوهات Chatbot",
            ChatbotScenarioList: "قائمة سيناريوهات Chatbot",
            Scenario: "سيناريو",
            filters: {
                equal: "مساوي ل",
                not_equal: "ليس متساويًا",
                contain: "يحتوي",
                not_contain: "لا تحتوي",
                starts_with: "ابدا ب",
                ends_with: "ينتهي",
                empty: "فارغ",
                non_empty: "غير فارغ",
                longer_than: "اطول من",
                shorter_than: "اقصر من",
                less_than: "أقل من",
                less_or_equal: "أقل أو متساوية",
                greater_than: "أكثر من",
                greater_or_equal: "أكبر من أو يساوي",
            },
            planRequired: "{integratable} الخطة المطلوبة",
            noDefaultStoryTitle: "قصة افتراضية",
            noDefaultStory: "لا توجد قصة افتراضية.",
            noMessage: "لا توجد رسالة",
            loading: "تحميل",
            loadMore: "تحميل المزيد",
            hostname: "اسم المضيف",
            goToStory: "اذهب إلى القصة",
            noResultFound: "لم يتم العثور على نتائج",
            checkYourFilterCombination: "تحقق من مزيج المرشح الخاص بك",
            clearYourSearch: "امسح بحثك",
            andTryAgain: "وحاول مرة أخرى",
            allTemplates: "جميع القوالب",
            allAITemplates: "جميع قوالب الذكاء الاصطناعي",
            templatesFromTheIndustry: "قوالب من الصناعة",
            basicTemplate: "القالب الأساسي",
            proTemplate: "قالب متقدم",
            withBot: "& bot",
            userWithBot: "المستخدم والوبوت",
            chatDetail: "تفاصيل الدردشة",
            allUserDetail: "انظر كل تفاصيل المستخدم",
            sessionData: "بيانات الجلسة",
            supsisChatWidget: "supsis دردشة القطعة",
            integratedWith: "تتكامل مع :",
            botStory: "قصة الروبوت",
            integration: "اندماج",
            Users: "مستخدم",
            user_id: "معرف المستخدم",
            categories: "فئات",
            worksWith: "يعمل مع",
            importBot: "استيراد روبوت",
            keyFeatures: "دلائل الميزات",
            importing: "الاستيراد",
            comingSoon: "قريباً",
            pickStory: "اختر قصة",
            conversationId: "معرف المحادثة",
            integrateStoryWithSupsisWidget: "دمج أداة Supsis مع قصة chatbot",
            integrateStoryWithWhatsapp: "دمج WhatsApp مع قصة chatbot",
            integrateStoryWithInstagram: "دمج Instagram مع قصة chatbot",
            selectIntegratingStory: "حدد القصة التي سيتم دمجها",
            install: "ثَبَّتَ",
            attr: {
                weekday: "Weekday",
                channelId: "Channel",
                email: "بريد إلكتروني",
                phone: "هاتف",
                language: "لغة",
                timezone: "وحدة زمنية",
                gender: "جنس",
                country: "دولة",
                referrer: "المرجع",
                department: "قسم",
                url: "عنوان URL",
                ip: "IP",
                last_seen: "اخر ظهور",
                name: "اسم",
                user_id: "معرف المستخدم",
                message: "رسالة",
                akinon_brand: "ماركة",
                akinon_order_id: "رقم التعريف الخاص بالطلب",
                akinon_product_id: "معرف المنتج",
                akinon_user_id: "معرف المستخدم",
                akinon_user_name: "اسم المستخدم",
                akinon_user_email: "البريد الالكتروني للمستخدم",
                akinon_invoice_url: "عنوان URL فاتورة",
                akinon_order_status: "حالة الطلب",
                akinon_order_price: "سعر الطلب",
                akinon_shipper_name: "أسم المورد",
                akinon_product_size: "حجم المنتج",
                akinon_sku: "SKU",
                akinon_product_url: "عنوان URL للمنتج",
                akinon_product_title: "عنوان المنتج",
                akinon_product_image: "صورة المنتج",
                akinon_product_stock: "مخزون المنتج",
                akinon_order_date: "تاريخ الطلب",
                akinon_track_number: "رقم الشاحنة",
                akinon_track_url: "تتبع عنوان URL",
                akinon_latitude: "خط العرض",
                akinon_longitude: "خط الطول",
                idleUserTime: "User Last Action (Second)",
                ai_class_result: "AI Class Result",
                meta_comment_id: "Meta Comment ID",
                meta_comment: "Meta Comment",
                meta_post_id: "Meta Post ID",
                ideasoft_user_id: "Member Id",
                ideasoft_invoice_url: "Invoice Url",
                ideasoft_order_id: "Sipariş Numarası",
                ideasoft_order_status: "Order Status",
                ideasoft_order_price: "Order Price",
                ideasoft_shipper_name: "Shipper Name",
                ideasoft_product_size: "Product Size",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Product Url",
                ideasoft_product_title: "Product Title",
                ideasoft_product_image: "Product Image",
                ideasoft_product_stock: "Product Stock",
                ideasoft_order_date: "Order Date",
                ideasoft_track_number: "Track Number",
                ideasoft_track_url: "Track Url",

                offline_mode: "وضع غير متصل بالشبكة",
                available_agents: "الوكلاء المتاحين",
                platform: "منصة",
                hour: "ساعة",
                segments: "Segments",
                tags: "الوسوم",
                ticket: "تذكرة",
                metaReferrals: "إحالات ميتا",
            },
            storyList: "قائمة القصة",
            douYouWannaDeleteItem: "هل تريد حذف هذا البند؟",
            douYouWannaDeleteWithChildren: "هل تريد حذف هذا العنصر مع أطفاله؟",
            stories: "قصص",
            templates: "قوالب",
            aitemplates: "قوالب الذكاء الاصطناعي",
            integrations: "التكامل",
            all: "الجميع",
            installed: "المثبتة",
            installationOK: "المثبتة",
            uninstall: "الغاء التثبيت",
            remainingMessageDesc: "الرسائل المجانية المتبقية:",
            openAISiteRoutingDescStart: "يمكنك النقر على الرابط",
            openAISiteRoutingDescEnd: "للحصول على مفتاح API.",
            integrationOK: "مدمج",
            chatWidget: "supsis دردشة القطعة",
            artificialIntelligence: "الذكاء الاصطناعي",
            integratePlatform: "يمكن دمج chatbot مع {integretable}.",
            integrateOpenAIWithChatbot: "دمج الدردشة GPT-4 مع chatbot",
            integrateChatBotWithChatGPT3: "تكامل chatbot مع الدردشة GPT-4",
            integrateStoryWithTelegram: "دمج القصة مع Telegram",
            webhooks: "Webhooks",
            archive: "أرشيف",
            reports: "التقارير",
            uncheckAll: "الغاءالكل",
            userSegments: "شرائح المستخدم",
            addSegment: "إضافة الجزء",
            addToSegment: "أضف إلى المقطع",
            removeFromSegment: "ترفع من الجزء",
            plansVTippyContent:
                "سيتم الفوترة لهذه الحزمة في بداية كل شهر ، وفي حالة رغبتك في الإلغاء ، سيتم فرض رسوم على استخدامك حتى بداية الشهر وستنتهي حزمتك.<br><br>سعر الحزمة هو سعر خارجي لضريبة القيمة المضافة.<br><br>تظهر التغييرات في الحزمة في الفاتورة في اليوم التالي.",
            segmentName: "اسم الجزء",
            sameSegment: "هناك قطاع بنفس الاسم!",
            usersInSegment: "المستخدمون في المقطع",
            noUsersAdded: "لم يضف أي مستخدمين",
            updateSegment: "تحديث الجزء",
            newSegment: "شريحة جديدة",
            selectAll: "اختر الكل",
            queriesSelected: "الاستعلامات المحددة",
            noBlocksFound: "لم يتم العثور على كتل!",
            userQuery: "استعلام المستخدم",
            date: "تاريخ",
            unmatched: "لا مثيل له",
            goToChat: "اذهب للدردشة",
            selectStory: "حدد القصة",
            selectBlock: "حدد كتلة",
            training: "تمرين",
            trainingAlert:
                "لتنفيذ التغييرات التي أجريتها في صفحة تدريب الروبوت، يجب عليك نشر النسخة الجديدة من السيناريو الذي قمت بتعديله.",
            unmatchedPhrases: "عبارات لا مثيل لها",
            ignored: "تجاهل",
            story: "قصة",
            timePeriod: "فترة زمنية",
            wholeTimeSpan: "فترة زمنية كاملة",
            selectAStory: "حدد قصة",
            searchUserQuery: "البحث عن استعلام المستخدم",
            time: {
                today: "اليوم",
                yesterday: "أمس",
                last7: "اخر 7 ايام",
                last30: "آخر 30 يومًا",
                "this-month": "هذا الشهر",
                "last-month": "الشهر الماضي",
                "last-3-month": "آخر 3 أشهر",
                "this-year": "هذا العام",
                "last-year": "العام الماضي",
                custom: "اختر تاريخًا مختلفًا",
            },
            emailProvider: "مزوِّد بريد إلكتروني",
            triggerFromAnywhere: "الزناد من أي مكان",
            allIntegrations: "جميع التكامل",
            integrateYourCBwithChatWidget: "دمج chatbot الخاص بك مع القطعة الدردشة.",
            integrateYourCBwithChatGpt3: "يمكن دمج chatbot مع GPT-4. مفتاح GPT-4 API المطلوب.",
            integrateYourCBwithWebHook: "تمرير معلومات الدردشة بين chatbot وخدمات الويب الخاصة بك بسهولة.",
            integrateYourCBwithIntegratable: "تمرير معلومات الدردشة بين chatbot و {integratable} بسهولة.",
            addWebhook: "إضافة webhook",
            editWebhook: "تحرير webhook",
            newWebhook: "New Webhook",
            webhookTitle: "عنوان webhook",
            webhookUrl: "Webhook url",
            webhookToken: "رمز webhook",
            webhookUsername: "Webhook اسم المستخدم",
            webhookPassword: "كلمة مرور webhook",
            editBlock: "يحرر",
            moveBlock: "يتحرك",
            copyBlock: "ينسخ",
            addFilter: "إضافة مرشح",
            addFilterGroup: "إضافة مجموعة مرشح",
            in: "في",
            and: "و",
            or: "أو",
            chatbot: "روبوت الدردشة",
            allStories: "كل القصص",
            addBot: "إنشاء بوت",
            testBot: "اختبر روبوتك",
            publish: "ينشر",
            editName: "تعديل الاسم",
            search: "ابحث في قصتك ...",
            typeMoreThan3Char: "اكتب 3 حرف على الأقل",
            expand: "يوسع",
            expandAll: "توسيع الكل",
            noMatchingItem: "لا يوجد عنصر مطابق",
            hint: "تَلمِيح",
            select: "يختار",
            navigate: "التنقل",
            dismiss: "رفض",
            choseAttribute: "اختار السمة",
            selectReply: "حدد الرد",
            preview: "معاينة",
            draft: "مسودة",
            lastUpdate: "اخر تحديث",
            published: "نشرت",
            newStory: "قصة جديدة",
            updateStory: "تحديث القصة",
            storyDescription: "وصف القصة",
            storyTitle: "عنوان القصة",
            deleteSingleBlock: "حذف كتلة واحدة",
            deleteWithChildren: "حذف مع الأطفال",
            startTestFromHere: "ابدأ الاختبار من هنا",
            copyBlockId: "نسخ معرف الكتلة",
            gotoLiveLink: "اذهب إلى Live Link",
            copyBlockIdSuccessfull: "تم نسخ معرف الكتلة إلى الحافظة",
            collapse: "ينهار",
            collapseAll: "انهيار جميع",
            snDelay: "{delay} Sec Delay",
            blockUpdated: "كتلة تحديث",
            addPayload: "إضافة الحمولة",
            previewModeCaution: "أنت الآن تقوم بمعاينة أحد إصدارات قصتك. لا يمكنك حفظ التغييرات في وضع المعاينة!",
            enterText: "أدخل النص...",
            trackpad: "لوحة التتبع",
            navigation: "ملاحة",
            navigationDesc: "يرجى اختيار وضع التنقل الخاص بك. الأمر متروك لك إذا كان سيتم تتبعه أو الماوس.",
            botSetting: "إعداد الروبوت",
            botSettingDesc:
                "يرجى تعيين مستوى الثقة. هذه نسبة مئوية بين 0 و 100. يحدد المستوى صحة chatbot التي ترتبط بمدخلات المستخدم.",
            languageSettingsDesc: "يرجى التأكد من أن لغة الروبوت التي تستجيب لها هي لغتك المفضلة.",
            mouse: "الفأر",
            Interactions: "التفاعلات",
            Actions: "أجراءات",
            Supsis_Actions: "تصرفات supsis",
            Shopify_Actions: "الإجراءات المتسوق",
            Akinon_Actions: "أفعال أكينون",
            IdeaSoft_Actions: "Ideasoft Actions",
            START_POINT: "نقطة البداية",
            AI_ASSISTANT: "AI ASSISTANT",
            BOT_RESPONSE: "استجابة الروبوت",
            AI_BOT_RESPONSE: "استجابة منظمة العفو الدولية (GPT-4o)",
            AI_CLASSIFICATION: "AI CLASSIFICATION",
            Templates: "Template Blocks",
            AI_MENU_FLOW: "AI MENU",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "الافتراضي",
            FILTER: "منقي",
            addNewFilter: "إضافة مرشح جديد",
            FLOW: "تدفق",
            ATTACHMENT_INPUT: "إدخال المرفق",
            USER_INPUT: "إدخال المستخدم",
            GO_TO_STEP: "اذهب إلى الخطوة",
            WEBHOOK: "webhook",
            SET_ATTRIBUTE: "تعيين السمة",
            QUESTION: "سؤال",
            CLOSE_CHAT: "وثيق الدردشة",
            CREATE_TICKET: "إنشاء تذكرة",
            TRANSFER_CHAT: "نقل الدردشة",
            TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
            TAG_CHAT: "ADD TAG",
            REMOVE_TAG: "REMOVE TAG",
            SET_DEPARTMENT: "تعيين القسم",
            SEND_TRANSCRIPT: "إرسال النص",
            SEND_SMS: "SEND SMS", //todo translate
            SEND_MAIL: "SMS MAIL", //todo translate
            CREATE_EVENT: "CREATE EVENT", //todo translate
            CREATE_RESERVATION: "CREATE RESERVATION",
            RESERVATION_OPEN_URL: "Reservation Open Url",
            RESERVATION_SELECT_DAY: "Select reservation day",
            RESERVATION_SELECT_TIME: "Select reservation time",
            RESERVATION_EVENT_LIST: "Reservation list visitor",
            CREATE_TASK: "CREATE TASK",
            SHOPIFY_SHOW_PRODUCTS: "Shopify Show Products",
            SHOPIFY_PRODUCT_AVAILABILITY: "توافر المنتج المتسوق",
            SHOPIFY_ORDER_STATUS: "حالة الطلب المتسوق",
            AKINON_SHOW_PRODUCTS: "Akinon عرض المنتجات",
            AKINON_FIND_PRODUCT: "AKINON Find Product",
            AKINON_ORDER_STATUS: "حالة أمر AKINON",
            AKINON_SELECT_ORDER: "AKINON SELECT ORDER",
            AKINON_SELECT_SIZE: "AKINON SELECT SIZE",
            AKINON_FIND_NEAREST_STOCK: "عرض مخزن المتجر",
            AKINON_FIND_NEAREST_STORES: "عرض أقرب المتاجر",
            AKINON_SHOW_DISCOUNT_CODES: "عرض رموز الخصم",

            IDEASOFT_SELECT_ORDER: "SELECT ORDER",
            IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
            IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",
            INSTAGRAM_COMMENT_REPLY: "الرد على التعليق",
            INSTAGRAM_COMMENT_DELETE: "حذف التعليق",
            INSTAGRAM_COMMENT_SHOW: "عرض التعليق",
            INSTAGRAM_COMMENT_HIDE: "إخفاء التعليق",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "الرد بشكل خاص",
            followingAttributesFilled: "سوف تأتي السمات التالية مملوءة.",
            GET_LOCATION: "احصل على الموقع",
            FALLBACK: "تراجع",
            SUCCESS: "نجاح",
            FAILURE: "فشل",
            message: "رسالة",
            condition: "حالة",
            score: "نتيجة",
            equal: "متساوي",
            not_equal: "ليس متساويًا",
            contain: "يحتوي",
            not_contain: "لا تحتوي",
            starts_with: "ابدا ب",
            ends_with: "ينتهي",
            empty: "فارغ",
            longer_than: "اطول من",
            shorter_than: "اقصر من",
            less_than: "أقل من",
            less_than_equal: "أقل من متساوٍ",
            greater_than: "أكثر من",
            greater_than_equal: "أكبر من المتساوية",
            value: "قيمة",
            failures: "الفشل",
            email: "بريد إلكتروني",
            name: "اسم",
            username: "اسم المستخدم",
            source: "مصدر",
            language: "لغة",
            timezone: "وحدة زمنية",
            region: "منطقة",
            country: "دولة",
            referrer: "المرجع",
            url: "عنوان URL",
            ip: "IP",
            city: "مدينة",
            lastSeen: "اخر ظهور",
            userId: "معرف المستخدم",
            selectStep: "حدد الخطوة",
            keywords: "الكلمات الدالة",
            userSays: "يقول المستخدم",
            addKeyword: "أضف الكلمة الرئيسية",
            addUserMessage: "أضف رسالة المستخدم",
            set: "تعيين",
            to: "ل",
            gender: "جنس",
            go_to_failure: "اذهب إلى الفشل",
            go_to_success: "اذهب إلى النجاح",
            untilFilled: "حتى تملأ",
            time1: "مرة واحدة",
            time2: "2 مرات",
            time3: ".ثلاث مرات",
            time4: "4 مرات",
            time5: "5 مرات",
            any: "أي",
            anytext: "Any Text",
            anytextDescription: "Matches only words + spaces",
            alphanumeric: "أبجدي رقمي",
            integer: "عدد صحيح",
            no: "لا",
            number: "رقم",
            phone: "هاتف",
            yes: "نعم",
            yesNo: "نعم / لا",
            anyDescription: "يطابق أي شيء غير فارغ.",
            alphanumericDescription: "يطابق كل من الرسائل والأرقام",
            integerDescription: "يطابق رقم عدد صحيح",
            noDescription: "لا يطابق أي مرادفات",
            numberDescription: "يطابق الرقم الترتيبي والكارد",
            phoneDescription: "يطابق رقم الهاتف",
            yesDescription: "تطابق نعم المرادفات",
            yesNoDescription: "تطابق نعم ولا مرادفات",
            emailDescription: "تطابق البريد الإلكتروني",
            urlDescription: "يطابق عنوان URL",
            temperature: "درجة حرارة",
            askWhenInvalid: "اسأل عندما غير صالح",
            applyFilter: "تطبيق المرشح",
            RANDOM_TEXT: "نص عشوائي",
            QUICK_REPLY: "رد سريع",
            FILE: "ملف",
            notificationMessageStartSuccess: "الكتلة",
            notificationMessageEndSuccess: "تمت إضافة",
            notificationMessageStartError: "حدث خطأ ، الكتلة",
            notificationMessageEndError: "لم تتم إضافته",
            blockChangedWannaUpdate: "أريد التحديث تغيير",
            responses: "استجابات",
            TEXT: "نص",
            IMAGE: "صورة",
            GALLERY: "صالة عرض",
            BUTTON: "زر",
            flow: "تدفق",
            active: "نشيط",
            passive: "سلبي",
            chooseAttributeType: "اختر نوع السمة",
            imageAttachment: "مرفق الصورة",
            audioAttachment: "مرفق الصوت",
            videoAttachment: "مرفق الفيديو",
            documentAttachment: "مرفق المستند",
            anyAttachment: "أي ارتباط",
            typeAttributeValue: "اكتب قيمة السمة",
            typeSearchValue: "اكتب قيمة البحث",
            addAttribute: "اضف ميزة",
            addAttributeDescription:
                "لا يمكن أن يحتوي اسم السمة على أحرف أبجدية رقمية فقط هي الحروف A-Z أو NUMBERS 0-9 أو DASH أو SHOFSCORE.",
            male: "ذكر",
            USER_DATA: "بيانات المستخدم",
            CUSTOM_ATTRIBUTES: "سمات مخصصة",
            enterBotResponseHere: "أدخل استجابة الروبوت هنا ...",
            addCard: "إضافة بطاقة",
            addButton: "إضافة زر",
            typeCardTitle: "اكتب عنوان البطاقة",
            typeCardDescription: "اكتب وصف البطاقة",
            dragAndDropBrowse: "سحب وإسقاط تصفح",
            dragAndDropBrowseFile: "رفع ملف",
            button: "زر",
            enterYourMessage: "أدخل رسالتك",
            imageView: "عرض الصورة",
            imageUploading: "تحميل الصور",
            fileUploading: "تحميل الملف ...",
            clickToChooseNewImage: "انقر لاختيار صورة جديدة",
            clickToChooseNewFile: "انقر لاختيار ملف جديد",
            removeTheExistingOne: "إزالة واحد الموجود",
            validateResponseWithEntity: "التحقق من صحة الاستجابة مع الكيان",
            actionOnFailureInput: "عمل على مدخلات الفشل",
            askNextQuestion: "اطرح السؤال التالي",
            goToSuccessBlock: "اذهب إلى كتلة النجاح",
            goToFailureBlock: "اذهب إلى كتلة الفشل",
            saveResposeToAttribute: "حفظ respose ليعزو",
            selectReplyType: "حدد نوع الرد",
            questionVariants: "المتغيرات سؤال",
            systemEntities: "كيانات النظام",
            delay: "تأخير",
            retrySectionTextPart: "بسأل",
            retrySectionText: "، إذا كانت استجابة المستخدم غير صالحة",
            addNextQuestion: "أضف السؤال التالي",
            typeBlockTitle: "اكتب عنوان الكتلة",
            versionHistory: "تاريخ النسخة",
            restore: "يعيد",
            versionName: "اسم الإصدار",
            restoreModalText: "سيقوم هذا الإجراء بإعادة الإصدار المحدد. هل أنت متأكد من أنك تريد استعادة هذا الإصدار؟",
            restoreVersion: "استعادة النسخة",
            newVersion: "نسخة جديدة",
            synonymMustBeUnique: "يجب أن يكون المرادف فريدًا",
            save: "يحفظ",
            entries: "إدخالات",
            youHaveNoEntries: "ليس لديك إدخالات",
            inputsCantBeEmpty: "لا يمكن أن تكون المدخلات فارغة",
            entryNamesMustBeUnique: "يجب أن تكون أسماء الدخول فريدة من نوعها",
            entityNameMustBeUnique: "يجب أن يكون اسم الكيان فريدًا",
            synonyms: "المرادفات",
            entities: "جهات",
            title: "عنوان",
            entryName: "اسم الدخول",
            entityhasbeenUpdatedSuccessfully: "تم تحديث الكيان بنجاح",
            emptyError: "لا يمكن أن تكون الإدخالات فارغة",
            entityNameCantBeEmpty: "الكيان لا يمكن أن يكون فارغا",
            allChats: "كل الدردشات",
            paidChats: "دردشات مدفوعة الأجر",
            busiestPeriod: "فترة ازدحام",
            ratingDistribution: "توزيع التصنيف",
            allMessages: "جميع الرسائل",
            avarageMessages: "رسائل Avarage",
            popularity: "شعبية",
            allUsers: "جميع المستخدمين",
            interactionName: "اسم التفاعل",
            numberOfMessage: "عدد الرسالة",
            ofAllUsersMessage: "٪ من جميع رسائل المستخدمين",
            totalData: "إجمالي البيانات",
            avgData: "بيانات AVG",
            exportToCsv: "التصدير إلى CSV",
            exportToExcel: "تصدير إلى Excel",
            inMaintenance: "في الصيانة",
            ADD_TO_SEGMENT: "إضافة إلى الجزء",
            REMOVE_FROM_SEGMENT: "ترفع من الجزء",
            users: "المستخدمون",
            webhookName: "اسم webhook",
            webHookUrl: "Webhook url",
            webHookToken: "رمز webhook",
            delete: "يمسح",
            basicAuth: "مصادقة أساسية",
            requiredFieldsCannotBeLeftBlank: "لا يمكن ترك الحقول المطلوبة فارغة",
            headerValue: "قيمة",
            yourVerificationToken: "رمز",
            yourWebHookName: "اسم webhook الخاص بك",
            yourWebHookUrl: "عنوان URL الخاص بك webhook",
            enterKey: "مفتاح الادخال",
            password: "كلمة المرور",
            saveSuccessfully: "تم حفظ معاملتك بنجاح",
            urlTypeError: "يرجى ملء الحقل بشكل صحيح (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "Openai Chat GPT-4 API مفتاح مطلوب.",
                apiKeyDesc:
                    "يتطلب تكامل chatbot + الدردشة GPT-4 مفتاح API. يرجى الحصول على مفتاح API الخاص بك أو استخدام مفتاح API أدناه للتجربة. يمكنك استخدام 20 رسالة فقط للتجربة.",
                getApiKey: "احصل على مفتاح AI AI AI",
                typeApiKey: "اكتب مفتاح API",
                ownApiKey: "Own Openai API Key",
                trialApiKey: "مفتاح API التجريبي (مقيد بـ 20 رسالة)",
                useOurTrial: "استخدم تجريمنا المجاني",
                twentyMessages: "يمكنك المحاولة باستخدام 20 رسالة مجانية.",
                enableChatGpt3: "تمكين الدردشة GPT-4",
            },
        },
        "Would you like to make default this story?": "#VALUE!",
        coupon: {
            code: "شفرة",
            discount: "تخفيض",
            endDate: "تاريخ الانتهاء",
            name: "اسم",
            email: "بريد إلكتروني",
            phone: "هاتف",
            add: "أضف عرض",
            coupons: "كوبونات",
            couponDeleted: "حذف القسيمة",
            limit: "حد",
            visitorBan: "تم حظر الزائر.",
            visitorUnBlock: "تم رفع الحظر.",
        },
        instagramTitle: "انقر فوق الزر أدناه لتمكين ميزات Instagram.",
        instegramFunctionActive: "تمكين ميزة Instagram",
        ChatBOT: "روبوت الدردشة",
        WhatsappContacts: "جهات اتصال Whatsapp",
        InstagramContacts: "جهات اتصال Instagram",
        MessengerContacts: "Messenger Contacts",
        volumeUp: "رفع مستوى الصوت",
        minimize: "تقليل",
        maximize: "تحقيق أقصى قدر",
        auditLogs: {
            auditLogsTitle: "سجلات التدقيق",
            auditLogsSub: "تتيح لك سجلات التدقيق تتبع الأحداث التي وقعت في شركتك خلال الـ 30 يومًا الماضية.",
        },
        task: {
            workflow: "سير العمل",
            workflowDetail: "تفاصيل سير العمل",
            workflowPerm: "أذونات سير العمل",
            perm: "أذونات",
            detail: "التفاصيل",
            userPerm: "أذونات المستخدم",
            deleteCard: "حذف البطاقة",
            createCard: "إنشاء بطاقة",
            editCard: "تعديل البطاقة",
            dragCard: "سحب البطاقة",
            allWorkflow: "كل عمليات سير العمل",
            createworkflow: "إنشاء سير العمل",
            deleteWorkflow: "هل أنت متأكد أنك تريد حذف سير العمل هذا؟",
            permEditTask: "ليست لديك صلاحية تعديل هذه المهمة",
            permEditTaskDes: "اتصل بالمسؤول الخاص بك للحصول على أذونات التعديل.",
            createTaskError: "ليست لديك صلاحية إنشاء مهام",
            createTaskErrorDesc: "اتصل بالمسؤول الخاص بك للحصول على أذونات إنشاء المهام.",
            moveTaskError: "ليست لديك صلاحية تغيير حالة المهمة",
            moveTaskErrorDesc: "اتصل بالمسؤول الخاص بك للحصول على أذونات تغيير حالة المهمة.",
            deleteTaskError: "ليست لديك صلاحية حذف المهام",
            deleteTaskErrorDesc: "اتصل بالمسؤول الخاص بك للحصول على أذونات حذف المهام.",
            permissionError: "ليس لديك إذن بإنشاء المهام",
            permissionErrorDesc: "يرجى الاتصال بالمسؤول الخاص بك للحصول على إذن إنشاء المهام",
            whatsappContactProfileTitle: "ملف تعريف {name} / {number}",
            createTaskVisitor: "إنشاء مهمة (زائر)",
            editWorkflow: "تحرير سير العمل",
            visitor: "ملف الزائر",
            createTaskMessage: "إنشاء مهمة (رسالة)",
            createStage: "إنشاء مرحلة",
            stagesAndStatuses: "المراحل والحالات",
            workflowCreateDesc: "وصف التدفق العملي",
            subTasks: "المهام الفرعية",
            followers: "متابعون",
            collaborators: "المتعاونون",
            addRelations: "إضافة علاقات",
            relations: "العلاقات",
            main: "رئيسي",
            name: "الاسم",
            completedOfCheck: "تم إكمال {completed} من إجمالي {total} المهام",
            workflowUpdateMs: "تم تحديث سير العمل بنجاح",
            taskUpdateMs: "تم تحديث المهمة بنجاح",
            workflowCreatedMs: "تم إنشاء سير العمل بنجاح",
            workflowCreateError: "لا يمكن إنشاء سير العمل",
            taskCreatedMs: "تم إنشاء المهمة بنجاح",
            settingsDesc3:
                "بالإضافة إلى ذلك، يتيح لك موديل المهام Supsis إنشاء سير عمل خاص بك مع أتمتة قابلة للتخصيص، مما يتيح لك إدارة المهام بشكل أكثر فعالية وتعزيز التعاون داخل الفريق.",
            settingsDesc4:
                "بهذه الطريقة، يمكنك تتبع كل من مهامك بالتفصيل، وتعيين المهام لأعضاء الفريق، وإدارة عمليات الأعمال الخاصة بك بشكل أكثر كفاءة. يوفر لك موديل المهام Supsis حلاً شاملاً لإدارة المهام وتنسيق الفريق.",
            settingsDesc2:
                "يترك موديل المهام Supsis أي مهمة دون أن تلاحظ. يمكنك تصفية المهام بناءً على أي معلمة، وتتبع أعباء العمل لكل مرحلة من مراحل سير العمل، وتنظيم التقويم الخاص بك ليتماشى مع جداولك.",
            settingsDesc1:
                "يتيح لك موديل المهام تنظيم العمل التعاوني، وتفويض المهام، وتتبع تقدم فريقك. يمكنك تخصيص المهام الخاصة بك حسب احتياجاتك عن طريق تحديد أي عرض وإنشاء سير عمل مخصصة خاصة بك باستخدام الأتمتة.",
            taskModuleSettingsTitle: "إعدادات وحدة المهام",
            high: "مرتفع",
            medium: "متوسط",
            low: "منخفض",
            priority: "الأولوية",
            addExistsSubtask: "إضافة مهمة فرعية موجودة",
            addSubtask: "إضافة مهمة فرعية",
            add: "أضف",
            newCheckList: "قائمة مراجعة جديدة",
            subtaskTitle: "عنوان الوظيفة الفرعية",
            view: "عرض",
            attachFiles: "إرفاق الملفات",
            createTaskDesc: "وصف المهمة",
            title: "عنوان",
            createWorkflow: "إنشاء سير العمل",
            editTask: "تحرير المهمة",
            createTask: "إنشاء مهمة",
            deleteColumnCont: "هل أنت متأكد أنك تريد حذف هذا العمود؟",
            changeStage: "تغيير المرحلة",
            assignees: "المعينين",
            owner: "صاحب",
            stage: "مرحلة",
            writeSomething: "اكتب شيئًا",
            selectAssginee: "حدد المعين",
            assignee: "المعين",
            enterNewTaskDesc: "أدخل وصف المهمة الجديدة",
            enterNewTaskTitle: "أدخل عنوان المهمة الجديدة",
            task: "مهمة",
            deleteTaskCont: "هل أنت متأكد أنك تريد حذف هذه المهام؟",
            deleteWorkFlowCont: "هل أنت متأكد أنك تريد حذف سير العمل هذا؟",
            completed: "مكتمل",
            todo: "مهمة",
            kanbanBoard: "لوحة كانبان",
            listView: "عرض القائمة",
        },
        permissionErrors: {
            userCreate: "ليس لديك إذن لإضافة المستخدمين. يرجى استشارة المسؤول الخاص بك.",
            userRead: "ليس لديك إذن لعرض المستخدمين. يرجى استشارة المسؤول الخاص بك.",
            userUpdate: "ليس لديك إذن لتحديث المستخدمين. يرجى استشارة المسؤول الخاص بك.",
            userDelete: "ليس لديك إذن لحذف المستخدمين. يرجى استشارة المسؤول الخاص بك.",
            visitorBlock: "ليس لديك إذن لحظر الزوار. يرجى استشارة المسؤول الخاص بك.",
            visitorUnblock: "ليس لديك إذن لإلغاء حظر الزوار. يرجى استشارة المسؤول الخاص بك.",
            visitorDetailRead: "ليس لديك إذن لعرض تفاصيل الزوار. يرجى استشارة المسؤول الخاص بك.",
            visitorListRead: "ليس لديك إذن لعرض قائمة الزوار. يرجى استشارة المسؤول الخاص بك.",
            visitorDelete: "ليس لديك إذن لحذف الزوار. يرجى استشارة المسؤول الخاص بك.",
            visitorExcel: "ليس لديك إذن للحصول على مخرجات Excel. يرجى استشارة المسؤول الخاص بك.",
            visitorUpdate: "ليس لديك إذن لتحديث الزوار. يرجى استشارة المسؤول الخاص بك.",
            bannedVisitorRead: "ليس لديك إذن لعرض قائمة الزوار المحظورين. يرجى استشارة المسؤول الخاص بك.",
            bannedWordCreate: "ليس لديك إذن لإضافة كلمات محظورة. يرجى استشارة المسؤول الخاص بك.",
            bannedWordRead: "ليس لديك إذن لعرض الكلمات المحظورة. يرجى استشارة المسؤول الخاص بك.",
            bannedWordDelete: "ليس لديك إذن لحذف الكلمات المحظورة. يرجى استشارة المسؤول الخاص بك.",
            chatRead: "ليس لديك إذن لعرض الدردشات. يرجى استشارة المسؤول الخاص بك.",
            chatUpdate: "ليس لديك الإذن لتحرير المحادثات. يرجى التشاور مع المسؤول الخاص بك.",
            archiveRead: "ليس لديك الإذن لعرض الأرشيف. يرجى التشاور مع المسؤول الخاص بك.",
            roleCreate: "ليس لديك الإذن لإضافة الأدوار. يرجى التشاور مع المسؤول الخاص بك.",
            roleRead: "ليس لديك الإذن لعرض الأدوار. يرجى التشاور مع المسؤول الخاص بك.",
            roleUpdate: "ليس لديك الإذن لتحديث الأدوار. يرجى التشاور مع المسؤول الخاص بك.",
            roleDelete: "ليس لديك الإذن لحذف الأدوار. يرجى التشاور مع المسؤول الخاص بك.",
            departmentCreate: "ليس لديك الإذن لإضافة الأقسام. يرجى التشاور مع المسؤول الخاص بك.",
            departmentRead: "ليس لديك الإذن لعرض الأقسام. يرجى التشاور مع المسؤول الخاص بك.",
            departmentUpdate: "ليس لديك الإذن لتحديث الأقسام. يرجى التشاور مع المسؤول الخاص بك.",
            departmentDelete: "ليس لديك الإذن لحذف الأقسام. يرجى التشاور مع المسؤول الخاص بك.",
            preparedContentCreate: "ليس لديك الإذن لإنشاء المحتوى المعد. يرجى التشاور مع المسؤول الخاص بك.",
            preparedContentRead: "ليس لديك الإذن لعرض المحتوى المعد. يرجى التشاور مع المسؤول الخاص بك.",
            preparedContentUpdate: "ليس لديك الإذن لتحديث المحتوى المعد. يرجى التشاور مع المسؤول الخاص بك.",
            preparedContentDelete: "ليس لديك الإذن لحذف المحتوى المعد. يرجى التشاور مع المسؤول الخاص بك.",
            welcomeCreate: "ليس لديك الإذن لإنشاء رسائل الترحيب. يرجى التشاور مع المسؤول الخاص بك.",
            welcomeRead: "ليس لديك الإذن لعرض رسائل الترحيب. يرجى التشاور مع المسؤول الخاص بك.",
            welcomeUpdate: "ليس لديك الإذن لتحديث رسائل الترحيب. يرجى التشاور مع المسؤول الخاص بك.",
            welcomeDelete: "ليس لديك الإذن لحذف رسائل الترحيب. يرجى التشاور مع المسؤول الخاص بك.",
            settingCreate: "ليس لديك الإذن لإنشاء الإعدادات. يرجى التحدث مع المسؤول الخاص بك.",
            settingRead: "ليس لديك الإذن لعرض الإعدادات. يرجى التحدث مع المسؤول الخاص بك.",
            settingUpdate: "ليس لديك الإذن لتحديث الإعدادات. يرجى التحدث مع المسؤول الخاص بك.",
            settingDelete: "ليس لديك الإذن لحذف الإعدادات. يرجى التحدث مع المسؤول الخاص بك.",
            reportCreate: "ليس لديك الإذن لإنشاء التقارير. يرجى التحدث مع المسؤول الخاص بك.",
            reportRead: "ليس لديك الإذن لعرض التقارير. يرجى التحدث مع المسؤول الخاص بك.",
            reportUpdate: "ليس لديك الإذن لتحديث التقارير. يرجى التحدث مع المسؤول الخاص بك.",
            reportDelete: "ليس لديك الإذن لحذف التقارير. يرجى التحدث مع المسؤول الخاص بك.",
            offlineSupportRequestCreate:
                "ليس لديك الإذن لإنشاء طلبات الدعم غير المتصلة. يرجى التحدث مع المسؤول الخاص بك.",
            offlineSupportRequestRead: "ليس لديك الإذن لعرض طلبات الدعم غير المتصلة. يرجى التحدث مع المسؤول الخاص بك.",
            offlineSupportRequestUpdate:
                "ليس لديك الإذن للرد على طلبات الدعم غير المتصلة. يرجى التحدث مع المسؤول الخاص بك.",
            offlineSupportRequestDelete:
                "ليس لديك الإذن لحذف طلبات الدعم غير المتصلة. يرجى التحدث مع المسؤول الخاص بك.",
            catalogCreate: "ليس لديك الإذن لإنشاء الفهرس. يرجى التحدث مع المسؤول الخاص بك.",
            catalogRead: "ليس لديك الإذن لعرض الفهرس. يرجى التحدث مع المسؤول الخاص بك.",
            catalogUpdate: "ليس لديك الإذن لتحديث الفهرس. يرجى التحدث مع المسؤول الخاص بك.",
            catalogDelete: "ليس لديك الإذن لحذف الفهرس. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotStoryCreate: "ليس لديك الإذن لإنشاء قصص الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotStoryRead: "ليس لديك الإذن لعرض قصص الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotStoryUpdate: "ليس لديك الإذن لتحديث قصص الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotStoryDelete: "ليس لديك الإذن لحذف قصص الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotTemplateRead: "ليس لديك الإذن لعرض قوالب الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotTemplateAiRead: "ليس لديك الإذن لعرض قوالب الدردشة الذكية. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotIntegrationsRead: "ليس لديك الإذن لعرض تكاملات الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotArchiveRead: "ليس لديك الإذن لعرض أرشيف الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotEntitiesRead: "ليس لديك الإذن لعرض كيانات الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotEntitiesCreate: "ليس لديك الإذن لإنشاء كيانات الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotEntitiesUpdate: "ليس لديك الإذن لتحديث كيانات الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotEntitiesDelete: "ليس لديك الإذن لحذف كيانات الدردشة. يرجى التحدث مع المسؤول الخاص بك.",
            chatbotReportRead: "ليس لديك الإذن لعرض تقارير الدردشة الآلية. يرجى التواصل مع المسؤول الخاص بك.",
            chatbotTrainRead: "ليس لديك الإذن لعرض تدريب الدردشة الآلية. يرجى التواصل مع المسؤول الخاص بك.",
            chatbotSegmentCreate:
                "ليس لديك الإذن لإنشاء شرائح المستخدمين للدردشة الآلية. يرجى التواصل مع المسؤول الخاص بك.",
            chatbotSegmentRead:
                "ليس لديك الإذن لعرض شرائح المستخدمين للدردشة الآلية. يرجى التواصل مع المسؤول الخاص بك.",
            chatbotSegmentUpdate:
                "ليس لديك الإذن لتحديث شرائح المستخدمين للدردشة الآلية. يرجى التواصل مع المسؤول الخاص بك.",
            chatbotSegmentDelete:
                "ليس لديك الإذن لحذف شرائح المستخدمين للدردشة الآلية. يرجى التواصل مع المسؤول الخاص بك.",
            integrationsRead: "ليس لديك الإذن لعرض صفحة التكاملات. يرجى التواصل مع المسؤول الخاص بك.",
            whatsappIntegrationRead: "ليس لديك الإذن لعرض صفحة تكامل WhatsApp. يرجى التواصل مع المسؤول الخاص بك.",
            instagramIntegrationRead: "ليس لديك الإذن لعرض صفحة تكامل Instagram. يرجى التواصل مع المسؤول الخاص بك.",
            telegramIntegrationRead: "ليس لديك الإذن لعرض صفحة تكامل Telegram. يرجى التواصل مع المسؤول الخاص بك.",
            integrationCreate: "ليس لديك الإذن لتمكين التكاملات. يرجى التواصل مع المسؤول الخاص بك.",
            triggerCreate: "ليس لديك الإذن لإنشاء المشغلات. يرجى التواصل مع المسؤول الخاص بك.",
            triggerRead: "ليس لديك الإذن لعرض المشغلات. يرجى التواصل مع المسؤول الخاص بك.",
            triggerUpdate: "ليس لديك الإذن لتحديث المشغلات. يرجى التواصل مع المسؤول الخاص بك.",
            triggerDelete: "ليس لديك الإذن لحذف المشغلات. يرجى التواصل مع المسؤول الخاص بك.",
            billingRead: "ليس لديك إذن لعرض الفواتير. يرجى التواصل مع مسؤول النظام الخاص بك.",
            taskCreate: "ليس لديك إذن لإنشاء المهام. يرجى التواصل مع مسؤول النظام الخاص بك.",
            taskRead: "ليس لديك إذن لعرض المهام. يرجى التواصل مع مسؤول النظام الخاص بك.",
            taskUpdate: "ليس لديك إذن لتحديث المهام. يرجى التواصل مع مسؤول النظام الخاص بك.",
            taskDelete: "ليس لديك إذن لحذف المهام. يرجى التواصل مع مسؤول النظام الخاص بك.",
            calendarCreate: "ليس لديك إذن لإنشاء التقويم/الحجوزات. يرجى التواصل مع مسؤول النظام الخاص بك.",
            calendarRead: "ليس لديك إذن لعرض التقويم/الحجوزات. يرجى التواصل مع مسؤول النظام الخاص بك.",
            calendarUpdate: "ليس لديك إذن لتحديث التقويم/الحجوزات. يرجى التواصل مع مسؤول النظام الخاص بك.",
            calendarDelete: "ليس لديك إذن لحذف التقويم/الحجوزات. يرجى التواصل مع مسؤول النظام الخاص بك.",
            mailCreate: "ليس لديك إذن لإنشاء البريد الإلكتروني. يرجى التواصل مع مسؤول النظام الخاص بك.",
            mailRead: "ليس لديك إذن لعرض البريد الإلكتروني. يرجى التواصل مع مسؤول النظام الخاص بك.",
            mailUpdate: "ليس لديك إذن لتحديث البريد الإلكتروني. يرجى التواصل مع مسؤول النظام الخاص بك.",
            mailDelete: "ليس لديك إذن لحذف البريد الإلكتروني. يرجى التواصل مع مسؤول النظام الخاص بك.",
        },
        message: {
            noConversationDesc: "هنا يمكنك رؤية الدردشات النشطة والدردشات المخصصة لك.",
            forMe: "بالنسبة لي",
            unAssigned: "غير معين",
            agentDetails: "تفاصيل الوكيل",
            contactProperties: "خصائص الاتصال",
            goToProfile: "اذهب إلى الملف الشخصي",
            addNote: "أضف ملاحظة",
            noPreferredAgent: "لا يوجد وكيل مفضل بعد",
            toPrefer: "تفضيل",
            inChat: "في الدردشة",
            watching: "يشاهد",
            chatsTitle: "المحادثات",
            dealyTimeMaxValueError: "يمكن أن يكون وقت التأخير 15 كحد أقصى",
            dealyTimeTypeError: "يجب أن تكون قيمة وقت التأخير رقما",
            passedTimeHm: "{hour} ساعات {min} دقائق",
            passedTimeMs: "{min} دقائق {sec} ثانية",
            passedTimeSc: "{sec} ثانية",
            translateMessage: "تمت ترجمة رسالتك بواسطة الذكاء الاصطناعي.",
            toneChanged: "تم تغيير نبرة الرسالة إلى {tone}",
            aiResponseAdded: "تمت إضافة استجابة الذكاء الاصطناعي إلى الرسالة",
            messageLonger: "تم جعل الرسالة أطول",
            grammarFixed: "تم تصحيح القواعد",
            aiTranslate: "ترجمة",
            other: "آخر",
            yourLanguage: "لغتك",
            myLanguage: "لغتي",
            forwardToChatbot: "إرسال إلى الروبوت",
            friendly: "ودود",
            confident: "واثق",
            straightForward: "بسيط",
            casual: "غير رسمي",
            professional: "مهني",
            longSentence: "جملة طويلة",
            changeTone: "تغيير النبرة",
            fixGrammar: "تصحيح القواعد",
            aiResponse: "استجابة الذكاء الاصطناعي",
            templateButtonNote:
                "لحظر الاتصال، تأكد من استخدام النصوص التالية على زر الحظر. بغض النظر عن الأحرف الكبيرة أو الصغيرة",
            templateButtonTags: "#إلغاء الاشتراك# | #حظر# | #منع# | #إلغاء الاشتراك#",
            dashboard: "لوحة القيادة",
            calendarModule: "وحدة التقويم",
            taskModule: "وحدة إدارة المهام",
            maxUrlButtonMessage: "You can add a maximum of 2 URL buttons.",
            noPreferredDepartment: "لا يوجد قسم مفضل",
            searchForDepartment: "البحث عن القسم",
            departmentAssignedToTheVisitor: "حدد القسم الذي ترغب في تعيينه للزائر.",
            assignPreferredDepartment: "تعيين القسم المفضل",
            smsChannel: "قناة الرسائل القصيرة",
            whatsappv2Channel: "قناة واتساب V2",
            whatsappv1Channel: "قناة واتساب V1",
            wBChannel: "قناة واتساب للأعمال",
            messengerChannel: "قناة المراسل",
            instagramChannel: "قناة Instagram",
            allPlatforms: "جميع المنصات",
            cbStartMessage: "رسالة بدء الدردشة الآلية",
            cbStartMessageDesc:
                "تتم معالجة الرسالة الأولى التي يدخلها المستخدم تلقائيًا بواسطة الدردشة الآلية وتوجيهها إلى العنوان المناسب.",
            messengerUserProfile: "ملف تعريف مستخدم Messenger",
            instagramUserProfile: "ملف تعريف مستخدم Instagram",
            noEventFound: "لم يتم العثور على أحداث",
            visitorMails: "رسائل الزوار",
            visitorActions: "إجراءات الزائرين",
            notVerified: "غير مُتحقق",
            visitorEvents: "أحداث الزوار",
            assignedTasks: "المهام المعينة",
            mails: "رسائل البريد",
            prefferedAgents: "الوكلاء المفضلين",
            createEvent: "إنشاء حدث",
            blockManagement: "إدارة الحظر",
            deleteUser: "حذف المستخدم",
            blocked: "محظور",
            profiles: "الملفات الشخصية",
            similiarProfiles: "تم العثور على ملفات مماثلة",
            ReplyAsAPm: "الرد كرسالة خاصة والإغلاق",
            replyAsAComment: "الرد كتعليق والإغلاق",
            messengerAddDesc: "انقر على الزر الاتصال أدناه وقم بتسجيل الدخول إلى حساب الفيسبوك الخاص بك.",
            instaAddPrivacyCheckDesc: "لقد قرأت وأوافق على {Terms and Conditions} و {Privacy}",
            instaAddDesc5: "انقر على الزر الاتصال أدناه وقم بتسجيل الدخول إلى حساب الفيسبوك الخاص بك.",
            instaAddDesc4: "التسجيل كمطور فيسبوك",
            instaAddDesc3: "تأكد من تفعيل مفتاح <b>'السماح بالوصول إلى الرسائل'</b>",
            instaAddDesc2: "تأكد من أن حسابك المهني في Instagram متصل بصفحتك على الفيسبوك",
            instaAddDesc1: "تأكد من أن حسابك على Instagram هو حساب مهني (حساب تجاري) في Instagram.",
            selectedDepartment: "القسم المحدد",
            departmentForwardEnable: "تم تمكين قاعدة إعادة توجيه القسم",
            departmentForwardRule: "قاعدة إعادة توجيه القسم",
            departmentForwardDesc: "حدد القسم الذي ستُحيل إليه المحادثات الواردة إلى القناة.",
            channelName: "اسم القناة",
            forwardToLiveAgents: "إعادة توجيه إلى الوكلاء الحيين👉 ",
            manageIgChannel: "إدارة قناتك على Instagram",
            igDetail: "تفاصيل إنستجرام",
            manageVisibilityDesc: "إدارة من يمكن أن يرى هذه القناة",
            selectAnIgAccount: "اختر حساب Instagram",
            connectToInsta: "الاتصال بـ Instagram",
            connectToMetaLeads: "Connect to Meta Leads",
            deleteInstaChannelInfo: "هل أنت متأكد أنك تريد حذف قناة Instagram؟",
            instagramChannels: "قنوات إنستجرام",
            suspendedDescription: "لقد تم تعليق حسابك بسبب الفواتير غير المدفوعة.",
            onlyChatbot: "الدردشة فقط",
            onlyAgents: "الوكلاء فقط",
            checkboxWarning: "يجب تحديد هذا الحقل",
            sendingAllow: "إرسال",
            receiving: "استقبال",
            platform: "منصة",
            banModalTitle: "النافذة المنبثقة لحظر الزائر",
            selectDepartmentDesc: "حدد الأقسام التي ترغب في تغيير رؤيتها",
            selectAgentDesc: "حدد الوكلاء الذين ترغب في تغيير رؤيتهم",
            selectDepartment: "حدد القسم",
            selectAgent: "حدد الوكيل",
            visibleDepartments: "الأقسام المرئية",
            visibleAgents: "الوكلاء المرئيين",
            visibilityInfoCont: "يمكن لجميع الوكلاء والإدارات رؤية هذه القناة",
            editDepartmentVisibility: "تحرير رؤية الإدارة",
            editAgentVisibility: "تحرير رؤية الوكيل",
            typeSTToSearch: "اكتب شيئًا للبحث عن المستخدمين",
            exportToCSV: "تصدير إلى CSV",
            clear: "مسح",
            usedSessionCount: "عدد الجلسات المستخدمة",
            maxSessionCount: "الحد الأقصى لعدد الجلسات",
            leftSessionCount: "عدد الجلسات المتبقية",
            planManagement: "إدارة الخطط",
            teamChat: "دردشة الفريق",
            templateNameIsNotValid: "اسم القالب غير صالح",
            relatedAdvertisement: "إعلان ذو صلة",
            whatsappNumber: "رقم واتس اب",
            integrationsWhatsappV1: "يتطلب خطة واتساب لتحقيق تواصل سلس بين Supsis و WhatsApp.",
            integrationsWhatsappV2: "يمكنك نقل معلومات الدردشة بسهولة بين Supsis و WhatsApp.",
            integrationsWhatsappBusiness: "يمكنك نقل معلومات الدردشة بسرعة وبشكل ملائم بين Supsis و WhatsApp.",
            selectDays: "اختر الأيام",
            addTime: "اختر الوقت",
            instagramContactList: "قائمة جهات الاتصال على Instagram",
            archiveAllRated: "احصل على جميع المحادثات التي تم فيها إجراء تقييم.",
            allChannels: "جميع القنوات",
            comment: "تعليق",
            news: "ما الاخبار",
            conversation: "حديث الفريق",
            speechTermination: "إنهاء المحادثة",
            noSystemMessage: "لا توجد رسائل في النظام حتى الآن!",
            supsisCustomerService: "خدمات العملاء التي تقدمها Supsis ،",
            supsisClickExperience: "يمكنك تجربة التجربة من خلال النقر.",
            customerPage: "انتقل إلى صفحة العملاء",
            buttonTitle: "عنوان الزر",
            buttonType: "نوع الزر",
            buttonSendMessage: "ارسل رسالة",
            buttonGoToBlock: "اذهب إلى المدونة",
            buttonOpenUrl: "رابط مفتوح",
            buttonPhoneCall: "مكالمة هاتفية",
            buttonOpenMoment: "افتح لحظة",
            buttonCloseChat: "إغلاق الدردشة",
            buttonTransferChat: "نقل الدردشة",
            buttonCreateTicket: "إنشاء تذكرة",
            deleteVisitor: "هل أنت متأكد أنك تريد حذف المستخدم؟ لا يمكن التراجع عن هذا الإجراء.",
            userProfile: "الملف الشخصي",
            addCalendarEvent: "إضافة +",
            you: "أنت",
            and: "و",
            apiIntegration: "مطور",
            generateToken: "إنشاء رمز مميز",
            copyToken: "نسخ الرمز المميز",
            dndBlocked: "تم إيقاف تشغيل إعدادات إرسال الملف.",
            labels: "تسميات",
            noData: "لايوجد بيانات",
            color: "لون",
            titleColor: "لون العنوان",
            secondTitleColor: "لون العنوان الثاني",
            tag_name_indicator: "اسم العلامة",
            sendMessage: "إرسال رسالة",
            removeFromG: "إزالة من المجموعة",
            delChannel: "هل أنت متأكد أنك تريد حذف هذه القناة؟",
            new_name: "اسم جديد",
            set_group_info: "تحرير معلومات المجموعة",
            shortcut_desc_num: "التبديل بين المحادثات النشطة باستخدام الأرقام الرقمية",
            copilot_desc_num: "يسمح لك بفتح Copilot على شاشة الدردشة",
            typing_w_chat: "يكتب...",
            edit_group_info: "تحرير معلومات المجموعة",
            notif_sound: "قم بتشغيل أصوات الإشعارات",
            notif_mute: "كتم الإشعارات",
            leave: "انصرف",
            group: "مجموعة",
            updateTag: "تحديث العلامة",
            ordered_desc: "تخصيص الدردشات للممثلين بالترتيب.",
            random_desc: "تخصيص الدردشات للممثلين بشكل عشوائي.",
            Rrobin_desc: "تخصيص الدردشات للممثلين بأسلوب دوري دائري. (يعطي الأولوية للممثلين الأقل انشغالًا)",
            RrobinRev_desc: "تخصيص الدردشات للممثلين بأسلوب دوري دائري عكسي. (يعطي الأولوية للممثلين الأكثر انشغالًا)",
            algo_desc: "اختر الخوارزمية لتوزيع الدردشات تلقائيًا",
            algorithm: "خوارزمية",
            os_browser: "نظام التشغيل ومتصفح الويب",
            CHAT: "محادثة",
            addTag: "إضافة علامة",
            tags: "العلامات",
            searchRepresentative: "البحث عن مندوب",
            preferredRepresentative: "مندوب",
            voting: "التصويت",
            chatWidget: "supsis دردشة القطعة",
            webhooks: "Webhooks",
            selectHooks: "حدد خطاف الويب",
            planRequired: "{integratable} الخطة المطلوبة",
            allIntegrations: "جميع التكامل",
            disableAgentSystemMessages: "إخفاء رسائل نظام الوكيل",
            disableAgentSystemMessagesDesc: "إخفاء رسائل نظام الوكيل.",
            disableAutoTranslate: "Auto Translate",
            disableAutoTranslateDesc:
                "It automatically translates messages from different languages. So you can communicate with your customers more easily.",
            shouldAddMethod: "يجب عليك ملء طريقة الدفع وعنوان الفواتير!",
            approveSelection: "الموافقة على الاختيار",
            trialDaysEndSelectPlan: "تأكيد اختيار الخطة",
            trialDaysEndSelectPlanDesc: "لقد انتهى نسختك التجريبية. تحتاج إلى التأكيد من خلال اختيار الخطة أدناه.",
            infoAboutAnnouncement: "معلومات موجزة حول الإعلان",
            announcement: "إعلان",
            newAnnouncementForm: "نموذج إعلان جديد",
            newAnnouncement: "إعلان جديد",
            announcements: "الإعلانات",
            newTicketSound: "تذكرة جديدة",
            vtippyDepartmentNotification: "إعدادات الإشعار لرسائل محادثة القسم",
            vtippyGroupNotification: "إعدادات الإشعار لرسائل المجموعات التي تم إنشاؤها",
            vtippyTicketNotification: "إعدادات الإشعار لكل تذكرة جديدة تتلقاها",
            vtippyAnnouncemenNotification: "إعدادات الإشعار للإعلانات الجديدة",
            languageSelection: "اختيار اللغة",
            announcementTitle: "عنوان الإعلان",
            infinitePlay: "العب بشكل مستمر",
            hideBubbleOnMobile: "يختبئ على الهاتف المحمول",
            vtippyHideBubbleOnMobile: "يتم إخفاء فقاعة الدردشة من مستخدمي الأجهزة المحمولة.",
            deleteSystemLanguage: "حذف {code} لغة من النظام",
            assignedChat: "دردشة مخصصة",
            check: "خانة الاختيار",
            systemStatus: "حالة النظام",
            chatAssignedToUser: "محادثة جديدة مخصصة",
            inactiveThresholdTime: "وقت الدردشة غير النشط (دقيقة)",
            tippyInactiveThresholdTime:
                "إذا لم يتم إرسال أي رسالة خلال الوقت المحدد ، فإن المحادثة تعتبر غير نشطة. أدخل القيمة (الدقائق). يجب أن يكون المدى في 1 دقيقة - 120 دقيقة.",
            inactiveTerminateTime: "إنهاء الدردشة غير النشطة المدة (دقيقة)",
            tippyInactiveTerminateTime:
                "سيتم إنهاء الدردشة غير النشطة إذا لم يتم تحويلها إلى الوضع النشط خلال فترة زمنية معينة. أدخل القيمة (الدقائق). يجب أن يكون المدى في 1 دقيقة - 120 دقيقة.",
            removePendingMessage: "إلغاء إرسال الرسالة",
            disconnected: "انقطع الاتصال",
            visitorWriteEmptyChatTippy: "يمكن للعميل الكتابة إلى محادثة قبل اتصال الوكيل.",
            visitorWriteEmptyChat: "يمكن للعميل الكتابة بدون وكيل متصل.",
            visitorConnectionEventSystemMessageEnabled: "تمكين رسائل نظام حالة اتصال الزوار",
            visitorConnectionEventSystemMessageEnabledTippy: "غادر الزائر ورسائل نظام عودة الزوار تمكين",
            openBubble: "فقاعة مفتوحة",
            showHeaderImage: "عرض صورة الرأس",
            askQuestion: "طرح سؤال",
            locationPermsNeeded: "هناك حاجة إلى أذونات الموقع لاستخدام هذه الميزة",
            useMyLocation: "استخدم موقعي",
            acceptingChat: "قبول الدردشات",
            notAcceptingChat: "عدم قبول الدردشات",
            blockBy: "محظور من قبل",
            languageRemovalQuestion: "أنت على وشك حذف لغة {code} من النظام!",
            loggedOut: "تسجيل الخروج",
            vtippyNewVisitorNotification: "إشعار مسموع لكل زائر جديد إلى موقع الويب الخاص بك",
            vtippySelectnotification: "يمكنك اختيار صوت الإخطار.",
            vtippyVoiceLevel: "يمكنك ضبط مستوى الصوت",
            vtippyStartVoice: "يستمع",
            vtippyInfiniteNotification:
                "إذا لم تكن نشطًا في لوحة الدردشات الجديدة ، فستستمر في اللعب. يمكنك تحرير النقر النشط بالنقر.",
            vtippyTranslateButton: "يترجم اللغة المحددة إلى لغات أخرى",
            vtippyTranslateClearButton: "ينظف المحتوى بلغات أخرى.",
            vtippyNewChatNotification: "يمكنك تحديد إشعار الصوت للمحادثات الجديدة القادمة إلى النظام وضبط مستوى الصوت.",
            vtippyNewConversationNotification:
                "يمكنك اختيار إشعار الصوت وضبط مستوى الصوت عندما يتم تعيين محادثات واردة جديدة لك.",
            vtippyNewMessageNotification: "يمكنك تحديد إشعارات للرسائل الواردة لمحادثاتك وضبط مستوى الصوت.",
            vtippyPrivateMessageNotification: "يمكنك تحديد إشعار للرسالة الواردة إلى Talk Talk.",
            hideInactiveAgents: "إخفاء العوامل غير النشطة",
            hideMinorValues: "إخفاء القيم البسيطة",
            hashHintMessage: "يمكنك إدخال اختصارات الهاشتاج بسرعة مع #hash",
            pmHintMessage: "هل تعلم أنه يمكنك إرسال رسالة خاصة للكلمة الرئيسية؟ على سبيل المثال PM: مرحبًا",
            shortcutHintMessage: "هل تعلم أنه يمكنك إرسال رسائل بشكل أسرع مع الرسائل المختصرة؟",
            switchBetweenConversations: "هل تعلم أنه يمكنك التبديل بسرعة بين المحادثات مع اختصارات ABC؟",
            atNameHintMessage: "هل تعلم أنه يمكنك إدخال اسم الزائر بسرعة مع name؟",
            dndHintMessage: "يمكنك تحميل الملفات باستخدام السحب والإفلات.",
            pasteFile: "يمكنك إرسال الملفات.",
            atEmailHintMessage: "هل تعلم أنه يمكنك إدخال بريد الزائر بسرعة مع @mail؟",
            pastePlainText: "اللصق من الحافظة كنص عادي",
            pressAndTalk: "Press and talk",
            agentActivities: "أنشطة الوكيل",
            listStatuses: "الحالات",
            newHASHContent: "#add التجزئة",
            hash: "الوسم",
            hashText: "نص التجزئة",
            exampleHash: "تتبع الطلب",
            notValidHash: "يجب ألا تحتوي على مسافات.",
            websiteChatWidgetIntegration: "تكامل أداة الدردشة على الموقع",
            videoCallEnabledDesc: "تنشيط لتمكين ميزة مكالمة الفيديو.",
            videoCallEnabled: "ميزة مكالمة الفيديو",
            audioCallDesc: "تنشيط لتمكين ميزة البحث الصوتي.",
            audioCallEnabled: "ميزة البحث الصوتي",
            assignPreferredAgent: "تعيين وكيل مفضل",
            representativeAssignedToTheVisitor: "حدد الوكيل المفضل الذي تريد تعيينه للزائر.",
            agentFileSendEnabledDesc: "يتيح القدرة على إرسال الملفات إلى المندوبين",
            agentFileSendEnabled: "يمكن للممثلين إرسال الملفات",
            visitorFileSendEnabledDesc: "يتيح لك تشغيل ميزة إرسال ملف الزوار أو إيقاف تشغيلها",
            visitorFileSendEnabled: "يمكن للزوار إرسال الملفات",
            visitorAutoLogin: "زائر تسجيل الدخول للسيارات",
            visitorAutoLoginDesc: "بدء المحادثة التلقائية عندما انقر فوق الزائر على فقاعة الدردشة",
            agentVoiceRecordEnabledDesc: "يمكّن الوكلاء من تسجيل الصوت",
            agentVoiceRecordEnabled: "يمكن للوكلاء تسجيل الصوت",
            visitorVoiceRecordEnabledDesc: "يمكّن الزائرين من تسجيل الصوت",
            visitorVoiceRecordEnabled: "يمكن للزوار تسجيل الصوت",
            startVideoCall: "مكالمة فيديو",
            startAudioCall: "مكالمة صوتية",
            visitorGDPRDeleteEnabledDesc: "يتيح لك تبديل القدرة على حذف جميع معلومات الزوار",
            visitorGDPRDeleteEnabled: "يمكن للزوار حذف جميع معلوماتهم",
            visitorLocationEnabled: "يمكن للزوار مشاركة الموقع",
            visitorLocationEnabledDesc: "يسمح للزائرين بتشغيل مشاركة الموقع أو إيقاف تشغيله",
            customerLocationEnabled: "يمكن للممثلين مشاركة الموقع",
            customerAutoMergeEnabled: "يدمج تلقائيا نفس الأفراد",
            customerAutoMergeEnabledDesc:
                "تقوم هذه الميزة بتنفيذ عملية الدمج التلقائي لجمع بيانات تخص نفس الأفراد بفعالية. وبهذه الطريقة، يتم تمثيل المستخدمين ذوي الملامح المماثلة بشكل أكثر انتظاما وترتيبا في مجموعات البيانات.",
            chatAiCopilot: "مساعد الدردشة الذكية",
            chatAiCopilotDesc: "الرد التلقائي على أسئلة عملائك باستخدام مساعد الدردشة الذكية",
            customerLocationEnabledDesc: "يسمح للممثلين بتشغيل مشاركة الموقع أو إيقاف تشغيله",
            triggerAlreadyExists: "الزناد موجود بالفعل",
            ticketStatusForm: "نموذج حالة التذكرة",
            statusFormTitle: "عنوان حالة التذكرة",
            allStatus: "جميع الحالات",
            triggers: "محفزات",
            trigger: "مشغل",
            noTrigger: "لم تضيف أي مشغلات بعد",
            triggerSkipLoginForm: "نموذج تسجيل الدخول",
            triggerSkipLoginFormTrue: "إظهار نموذج تسجيل الدخول",
            triggerSkipLoginFormFalse: "تخطي نموذج تسجيل الدخول والانتقال مباشرة إلى الرسالة",
            noContent: "لا يوجد محتوى",
            toCreate: "لنصنع او لنبتكر",
            clickTheButton: "انقر فوق الزر",
            triggerContent:
                "اكتب الوصف الذي تريد ظهوره في الوسيط الذي يفتح. ما عليك سوى الكتابة بلغة واحدة ويتم الترجمة إلى لغات أخرى تلقائيًا.",
            triggerDrag: "يمكنك ضبط مدة الرسالة عن طريق سحب الشريط أو النقر عليه.",
            triggerNewCondition: "يمكنك إضافة حالة جديدة مع الزر.",
            triggerNoConditionDescription1:
                "يمكنك إنشاء الشروط التي تريدها من الخيارات. إذا لم تنشئ أي شروط لأي مشغل ، فسيكون المشغل الأول نشطًا.",
            triggerNoConditionDescription2: "يظهر واحد فقط من المشغلات مع نفس الشروط على صفحة الزوار.",
            triggerShowAndHide: "يمكنك إظهار أو إخفاء المشغلات وقتما تشاء.",
            countryLanguage: "لغة البلد",
            addTrigger: "إضافة الزناد",
            yesPlease: "نعم من فضلك!",
            noThanks: "ًلا شكرا.",
            firstAnswer: "تأكيد حوار السؤال الجواب",
            secondAnswer: "اسأل حوار استبعاد الإجابة",
            noTitle: "لا يوجد حاضر",
            sumChat_MediaFile: "الوسائط والوثائق",
            importantWarning: "تحذير مهم!",
            images: "الصور",
            URLS: "روابط",
            files: "دوسيلار",
            noCondition: "بدون شرط! يمكنك إضافة شروط بالنقر فوق أيقونة Plus.",
            showTriggers: "انقر لإظهار المشغلات",
            showThisTrigger: "انقر لإظهار هذا الزناد",
            hideTriggers: "انقر لإخفاء المشغلات",
            hideThisTrigger: "انقر لإخفاء هذا الزناد",
            updateTrigger: "تحديث الزناد",
            conditions: "شروط",
            messageDurationPerRow: "مدة الرسالة لكل صف",
            updateCompleted: "تحديث الانتهاء",
            CatalogUpdatedSuccessfully: "تم تحديث الكتالوج بنجاح",
            integrateSupsiswithIntegratable: "تمرير معلومات الدردشة بين supsis و {integratable} بسهولة.",
            installationOK: "المثبتة",
            dayTime: "ساعة",
            weekDay: "يوم من الأسبوع",
            spendTimePage: "قضيت الوقت على الصفحة",
            spendTimeSite: "قضيت الوقت في الموقع",
            pageUrl: "رابط الصفحة",
            pageTitle: "عنوان الصفحة",
            equal: "متساوي",
            not_equal: "غير متساوي",
            less_than: "أقل من",
            greater_than: "أكثر من",
            less_than_or_equal: "اصغر من او يساوي",
            greater_than_or_equal: "أكبر من أو يساوي",
            visitorName: "اسم الزائر",
            seconds10: "10 ثواني",
            seconds30: "30 ثانية",
            minute1: "1 دقيقة",
            minutes5: "5 دقائق",
            minutes10: "10 دقائق",
            minutes30: "30 دقيقة",
            hour1: "1 ساعة",
            hours2: "ساعاتين",
            hours4: "4 ساعات",
            hours8: "8 ساعات",
            hours12: "12 ساعة",
            hours24: "24 ساعة",
            maxCondition: "كحد أقصى",
            doYouWishToDeleteTrigger: "هل ترغب في حذف الزناد",
            contains: "يتضمن",
            not_contains: "لا يحتوي",
            chatLanguage: "لغة الدردشة",
            translating: "جار الترجمة",
            buyWhatsapp: "شراء تكامل WhatsApp",
            liveSupportStartingWait: "بدء الدعم المباشر ، يرجى الانتظار",
            noConnection: "لا يوجد اتصال!",
            integrations: "التكامل",
            refundInvoiceSure: "هل أنت متأكد من أنك تريد إعادة الفاتورة؟",
            invoiceMarkedAsPaidSuccess: "تم وضع علامة على الفاتورة بنجاح",
            invoiceMarkedAsPaidError: "خطأ ، لم يتم وضع علامة على الفاتورة",
            deleteConfirm: "هل تريد حذف هذا {object}؟",
            markPaidConfirm: "هل أنت متأكد من مارك مثل هذه الفاتورة؟",
            addLink: "وصلة",
            startChatDesc: "ابدأ المحادثة",
            selectStep: "حدد خطوة:",
            addGOTO: "اذهب إلى",
            sendFastLink: "إرسال رابط سريع",
            or: "أو",
            allTags: "جميع العلامات",
            showDetail: "أظهر تفاصيل",
            hideDetail: "إخفاء التفاصيل",
            weLlSendPhone: "سنرسل إلى هاتفك",
            weLlSendEmail: "سنرسل إلى بريدك الإلكتروني",
            linkSentToPhone: "تم إرسال الرابط كرسائل نصية",
            offerlinkSendToPhone: "سنرسل لك رابط تنزيل تطبيقنا عبر الرسائل القصيرة.",
            offerlinkSendToMail: "سنرسل لك رابط تنزيل تطبيقنا عبر البريد الإلكتروني.",
            theEmail: "بريدي الإلكتروني المسجل",
            differentEmail: "بريد إلكتروني آخر مختلف",
            linkSentToMailBox: "تم إرسال الرابط إلى Adress بريدك",
            errorOccurred: "حدث خطأ !",
            clickStoreIcon: "يمكنك الوصول إلى تطبيق الهاتف المحمول من خلال النقر على الرمز المناسب لهاتفك.",
            meetWithSupsis: "هل ترغب في مقابلة تطبيق Supsis Mobile الخاص بنا؟",
            downloadMobileApps: "قم بتنزيل تطبيق الجوال",
            getApps: "احصل على التطبيقات",
            info: "معلومة",
            conversationHistory: "تاريخ المحادثة",
            planInfoHeader: "تخطيط المعلومات",
            planInformation: "خطتك هي {selectedPlan} ({detailMaxAgentCount} Agent) ({freeAgent} Free Agent)",
            creditAvailable: "ائتمان وكيلك المتاح في خطتك:",
            upDownGradePlan: "إذا كنت ترغب في الترقية/خفض خطتك ، من فضلك",
            click: "انقر",
            autoStartChat: "بداية الدردشة التلقائية",
            bubbleColor: "لون فقاعة الدردشة",
            openFolder: "افتح المجلد",
            preDefined: "موضوعات",
            customIcon: "تثبيت من جهاز الكمبيوتر الخاص بك",
            theme: "سمة",
            themeSettings: "إعدادات الموضوع",
            chatThemeSettings: "إعدادات موضوع الدردشة",
            bubbleSettings: "إعدادات فقاعة الدردشة",
            inputHeightOfBubble: "حجم الفقاعة",
            inputPixelsOfChatBubble: "انقر لتحرير مسافات فقاعة الدردشة إلى الحواف",
            modalTitleIsMarginAsPixelInfo: "مسافات فقاعة الدردشة إلى الحواف:",
            inputPxOfXaxis: "الموقف الأفقي",
            inputPxOfYaxis: "الوضع الرأسي",
            inputPxOfMobileXaxis: "(موبيل) الموقف الأفقي",
            inputPxOfMobileYaxis: "(موبيل) الموقف الرأسي",
            animations: "الرسوم المتحركة",
            preferredAnimation: "الرسوم المتحركة المفضلة",
            selectAnAnimation: "حدد الرسوم المتحركة",
            inputOfBubbleMessage: " {contentOfChatBubble}\n{ أضف محتوى إلى فقاعات الدردشة الضخمة",
            showChatBubbleOnlyLoggedUserToolTip: "إنه الإعداد لإخفاء فقاعة الدردشة بناءً على حالة تسجيل الدخول.",
            showChatBubbleOnlyLoggedUser: "أظهر فقاعة لتسجيلها فقط في المستخدم. (Ideasoft)",
            helloDoUNeedHelp: "مرحبا هل تحتاج إلى مساعدة؟",
            bubbleIcon: "صورة فقاعة الدردشة",
            overrideMargins: "تخصيص الهوامش",
            autoHideBubble: "إخفاء فقاعة الدردشة",
            vtippyAutoHideBubble: "يخفيون فقاعة الدردشة عندما يكون الوكلاء في وضع عدم الاتصال",
            hideBubble: "تعطيل فقاعة الدردشة",
            vtippyHideBubble: "قم بإيقاف فقاعة الدردشة.",
            overrideMobileMargin: "تخصيص الهوامش للجوال",
            vtippyMobileMargin: "تخصيص الهوامش للجوال",
            isFabsActive: "إظهار زر الإجراء العائم",
            bubbleOpenableMenu: "دردشة فقاعة المنسدلة",
            vtippyIsFabsActive: "إعداد زر العرض / إخفاء الإجراء العائم",
            vtippyIsFabsAsIcon: "إنه إعداد ما إذا كانت الرموز ستظهر في القائمة المنسدلة.",
            isFabsAsIcon: "عرض أيقونات القائمة.",
            setMarginAsPixel: "تعيين بكسل",
            returnDefaultMargins: "إعدادات الهامش الافتراضية",
            deleteSite: 'هل تريد حذف الموقع "{siteName}"؟',
            deleteThisSite: "حذف الموقع",
            assetOversizeWithExt: "يجب أن يكون حجم الملف أقل من 10 ميغابايت وفي تنسيق JPG.",
            closeChat: "نهاية المراسلة",
            ticket: "تذكرة",
            formStep: "خطوة الشكل",
            menuStep: "خطوة القائمة",
            contentStep: "خطوة المحتوى",
            menuTitle: "عنوان القائمة",
            messageContent: "محتوى الرسالة",
            goToLive: "نقل إلى التمثيلي",
            prevStep: "العودة إلى الخطوة السابقة",
            button: "زر",
            addImage: "صورة",
            addText: "نص",
            stepTitle: "عنوان الخطوة",
            addTicket: "تذكرة",
            formDescription: "سؤال",
            addInput: "سؤال",
            addRandomText: "نص عشوائي",
            calendarPassedTimeMinSec: "{min} دقيقة {sec} الثانية {name}",
            calendarPassedTimeSec: "{ساعة} ساعة {min} دقيقة {sec} الثانية {name}",
            updateUserName: "تحديث اسم المستخدم",
            forgotPassword: "هل نسيت كلمة السر",
            osrFromMessageSaved: "تم حفظ الرسالة دون اتصال.",
            requiredField: "هذه الخانة مطلوبه.",
            nightModeOn: "وضع الليل على",
            catalogMenu: "قائمة طعام",
            catalogContent: "محتوى",
            all: "الجميع",
            allDepartments: "جميع الإدارات",
            preferredLanguage: "اللغة المفضلة",
            kmkAutoDepartmentBind: "اكتشاف kmk auto deparment",
            kmkAutoDepartmentBindDesc: "بحث بائع على مواقع عملاء KMK وقم بتعيين صفحة تسجيل الدخول كقسم",
            visitorEmailUpdated: "تم تحديث البريد الإلكتروني للزائر",
            visitorEmailIsNotValid: "البريد الإلكتروني للزوار غير صالح",
            visitorNameUpdated: "اسم الزائر تم تحديثه",
            clickToEdit: "إضغط للتعديل",
            addEmail: "+ إضافة بريد إلكتروني",
            addFullname: "+ إضافة fullname",
            partner: "المرجع؟",
            isIntegrated: "اندماج؟",
            agentCount: "عدد الوكيل",
            closePreviewColors: "إغلاق معاينة الموضوع",
            previewColors: "معاينة موضوع مفتوح",
            videoCalls: "مكالمات فيديو",
            filterLost: "الدردشات المفقودة",
            vtipyCustomLogin: "يمكنك تخصيص المعلومات التي سيتم طلبها في نموذج تسجيل الدخول عندما يتصل زوارك بالنظام.",
            vtipyLoginlessChat: "سيتم إخفاء نموذج تسجيل الدخول للزوار. يمكن للزائر الاتصال بالدردشة مباشرة.",
            loginlessChat: "نموذج تسجيل الدخول للزوار",
            imageUrl: "رابط الصورة",
            replied: "رد",
            solved: "تم حلها",
            openImage: "صورة مفتوحة",
            writeFeedback: "يمكنك كتابة ملاحظاتك حول supsis هنا.",
            feedbackFailed: "حدث خطأ أثناء إرسال الملاحظات.",
            feedbackSuccessful: "ردود الفعل تقديم ناجحة.",
            sendFeedback: "ارسل رأيك",
            errorReport: "يمكنك أن تعطينا ملاحظات حول المشكلات التي تواجهها حول supsis.",
            sendErrorFeedBack: "أعطنا ملاحظات حول القضية التي تواجهها.",
            successImgUpload: "تم تحميل صورتك بنجاح.",
            successImgDelete: "تم حذف الصورة بنجاح.",
            errorImgUpload: "حدث خطأ أثناء تحميل صورتك.",
            errorImgDelete: "حدث خطأ أثناء حذف الصورة",
            chatBotEndStatics: "معدل نجاح محادثة chatbot",
            videoCallDist: "توزيع مكالمات الفيديو",
            departmentInfo: "معلومات القسم",
            infoAboutDepartment: "قدم معلومات موجزة عن القسم",
            deleteDepartmentQuestion: "هل تريد حقًا حذف هذا القسم؟",
            departmentDeleted: "حذف القسم",
            departmentTitle: "لقب القسم",
            updateDepartmentForm: "نموذج تحديث القسم",
            newDepartmentForm: "نموذج قسم جديد",
            department: "قسم",
            newDepartment: "قسم جديد",
            departmentSaved: "أنقذ القسم",
            sameDepartment: "هناك قسم بنفس الاسم",
            sameValue: "هناك قيمة بنفس الاسم!",
            sameTag: "هناك وسم بهذا الاسم!",
            departments: "الإدارات",
            chatTimingSettings: "إعدادات توقيت الدردشة",
            assetOversize: "يجب ألا يتجاوز حجم الملف الذي تريد إرساله 2 ميجابايت.",
            assetOversizeMB: "لا يجب أن يتجاوز حجم الملف الذي تريد إرساله {mb} ميجابايت.",
            messageDeleted: "تم حذف هذه الرسالة",
            filterLostChat: "تصفية الدردشات المفقودة",
            filterClosedByAgent: "مرشح مغلق من قبل الوكيل",
            filterVideoCall: "مرشح مكالمة الفيديو",
            notificationText: "يحتاج Supsis إلى إذن لـ",
            notificationTitle: "الإخطارات معطلة",
            deniedText: "إن إشعاراتك مغلقة ، فأنت بحاجة إلى تشغيل إشعاراتك حتى لا تفوتك عملائك.",
            deniedTitle: "انقر لفتح الإخطارات الخاصة بك!",
            deniedHeader: "حتى لا تفوت عملائك ، تحتاج إلى تشغيل إشعاراتك!",
            showNotificationGuide: "انقر للاطلاع على التفاصيل",
            howToEnableNotification: "كيف يمكنني تمكين الإخطارات",
            notificationOK: "نعم",
            notificationUnderstood: "تم فهمه!",
            notificationCancel: "يلغي",
            howToEnableNotificationInstruction1: "انقر على أيقونة القفل في شريط العناوين للمتصفح",
            howToEnableNotificationInstruction2: 'إذا تم تعطيل "الإخطارات" في قسم الأذونات ، فقم بتمكينه',
            howToEnableNotificationInstruction3: 'إذا لم تظهر "الإشعارات" في قسم الأذونات ، فانقر فوق "إعدادات الموقع',
            howToEnableNotificationInstruction4: 'قم بتشغيل إذن "الإخطارات" من قسم "الأذونات" في صفحة إعدادات الموقع',
            checkPaymentMethod: "يرجى التحقق من طريقة الدفع الخاصة بك",
            pushNotificationEnabled: "تم تمكين إشعار الدفع الرائع",
            pushNotificationDenied: "لقد أنكرت إذن الإخطار",
            suspendedMessage: "تم تعليق حسابك",
            enableNotification: "تمكين إخطارات سطح المكتب.",
            languageSettings: "لغة مختارة",
            problemsSound:
                'إذا كانت لديك مشاكل في الإشعارات ، فيمكنك النقر فوق قفل صورة من مربع بحث المتصفح (الموضح في الصورة) انقر فوق "إعدادات الموقع" وتغيير "الصوت" للسماح',
            betweenRepresentative: "هناك رسالة جديدة من ممثل",
            desktopNotifications: "إخطارات سطح المكتب",
            notificationEnabled: "يتم تمكين إخطارات سطح المكتب Supsis.",
            newMessageAlert: "لديك رسالة جديدة.",
            notificationDisable: "يمكنك تعطيل الإخطار من الإعدادات التمثيلية",
            newConversationAlert: "لديك زائر جديد.",
            chatBot: "روبوت الدردشة",
            ticketResponse: "Temsilcinin Yanıtı:",
            archived: "أرشيف",
            chatbotChatCount: "روبوت الدردشة",
            changeTitle: "غير العنوان",
            changeVisitorTitle: "تغيير عنوان الزائر",
            catalog: "عنوان الكتالوج",
            openTheCatalog: "كتالوج مفتوح",
            catalogNotOpen: "تم تعطيل ميزة الكتالوج. يمكنك تشغيل ميزة الكتالوج لدعم عملائك بمحتوى مستعد مسبقًا.",
            showCatalogCategories: "اضبط ما إذا كانت قائمة الكتالوج ستظهر على فقاعة الدردشة",
            showChatBot: "اضبط ما إذا كان chatbot سيظهر على فقاعة الدردشة",
            openCatalog: "الرؤية كتالوج",
            unreadMessages: "رسائل غير مقروءة",
            personalFirstMsg: "الوكيل المتوسط ​​وقت الاستجابة (SEC)",
            personalRating: "نقاط الموظفين AVG",
            soundSettings: "إعدادات الإشعار",
            newPrivateMessage: "رسالة خاصة",
            addNewGroup: "إنشاء مجموعة جديدة",
            newMessage: "رسالة جديدة",
            newConversation: "دردشة جديدة",
            newVisitor: "زائر جديد",
            chatPosition: "موقف الدردشة",
            bottomLeftCorner: "الزاوية اليسرى السفلية",
            leftDocked: "رست على اليسار",
            bottomRightCorner: "الزاوية اليمنى السفلى",
            rightDocked: "رست الحق",
            chatPositionSelect: "اختر الموقف",
            teamChatGroup: "رسائل المجموعة",
            teamChatDepartment: "رسائل القسم",
            teamChatTeam: "رسائل الفريق",
            teamChatDm: "رسائل البريد المباشر",
            bottomLeft: "أسفل اليسار",
            left: "غادر",
            bottomRight: "أسفل اليمين",
            right: "يمين",
            mailorname: "البريد الإلكتروني أو الاسم",
            fieldName: "الاسم الرئيسي",
            value: "قيمة",
            addSetting: "إضافة إعدادات",
            globalSettings: "الاعدادات العامة",
            breaksByTime: "عداد الكسر حسب الوقت",
            clPlaceholder: "الاسم الذي سيظهر في نموذج العميل",
            target: "تحميل عنوان اختبار",
            duration: "مدة اختبار التحميل (ثانية)",
            arrivalCount: "عدد الدردشة",
            bootMaxLife: "دردشة أقصى وقت الحياة (SEC)",
            startLoadTest: "ابدأ اختبار التحميل",
            noClusterInstanceFound: "لا يوجد خادم",
            stopLoadTest: "توقف اختبار التحميل",
            integrationDesc: "فقط أضف رمز السطر الواحد أدناه إلى موقعك.",
            integrationDemoCode: "رمز تجريبي للتكامل البسيط",
            integrationWindow: "كيف يمكنني الاندماج في موقعي؟",
            notIntegrated: "اندماج",
            help: "يساعد",
            notIntegratedDesc:
                "لاحظنا أنك لم تضيف نظام الدردشة إلى موقعك. عندما تقوم بدمجه في موقعك وابدأ الدردشة الأولى ، ستقوم بإكمال التكامل. انقر للحصول على البرنامج النصي للتكامل",
            backToLogin: "ارجع إلى شاشة تسجيل الدخول",
            passwordlessLoginUnsuccessful: "تسجيل الدخول غير ناجح. يمكن انتهاء صلاحية أو استخدامها من قبل",
            passwordlessLogin: "تسجيل الدخول بدون كلمة مرور",
            loginWithEmail: "تسجيل الدخول مع البريد الإلكتروني",
            loginWithPassword: "تسجيل الدخول مع كلمة المرور",
            enteringPasswordless: "تسجيل الدخول بدون كلمة مرور ...",
            toMainPath: "إعادة التوجيه إلى الصفحة الرئيسية",
            userRoleChanged: "تغيرت أذوناتك. سيتم إعادة توجيهك إلى الصفحة الرئيسية.",
            passwordChangeSuccess: "تغيرت كلمة المرور الخاصة بك بنجاح",
            feedback: "إظهار ردود الفعل",
            showFeedbackHistory: "إظهار الرسائل التي تم إرسال ملاحظات",
            newSelfServiceSite: "موقع خدمة الذات الجديد",
            subdomain: "نطاق فرعي",
            rootUserEmail: "بريد إلكتروني",
            rootUserName: "اسم",
            newVersion: "نسخة جديدة متاحة",
            closeLiveSupport: "وثيق الدعم المباشر",
            newVersionShort: "نسخة جديدة",
            bannedWordRestrict: "حظر الكلمة المحظورة",
            ticketShow: "السماح للعملاء بإنشاء تذاكر",
            ticketShowDesc: "تمكين خيار إنشاء التذاكر في قائمة الدردشة",
            autoLoadIframe: "حركة المرور الحية",
            autoLoadIframeDesc: "تحميل التلقائي iframe ، مرر جميع حركة الزوار",
            bannedWordRestrictDesc:
                "عندما يتم تشغيل حظر الكلمة المحظورة ، يتم منع الممثلين من كتابة الكلمات المحظورة المحددة في النظام للزوار.",
            agentDown: "وكيل أسفل",
            delayChat: "دردشة تأخر",
            tableSettingTippy: "يمكنك تغيير المعلومات التي ستظهر في الجدول.",
            tableSettings: "إعدادات الجدول",
            tableSettingsInfo: "يمكنك تغيير المعلومات التي ستظهر في الجدول. يمكنك تحديد عمود 7 على الأكثر",
            privateParametry: "معلمات المستخدم المخصصة",
            systemOperetor: "معلومات النظام",
            cityAndDistrict: "مقاطعه المدينه",
            general: "عام",
            availability: "توافر",
            home: "بيت",
            successful: "نجح",
            forgetPasswordSent:
                "تم إرسال البريد الإلكتروني لإعادة تعيين البريد الإلكتروني ، تحقق من صندوق الوارد الخاص بك",
            saturday: "السبت",
            friday: "جمعة",
            thursday: "يوم الخميس",
            wednesday: "الأربعاء",
            tuesday: "يوم الثلاثاء",
            monday: "الاثنين",
            sunday: "الأحد",
            download: "تحميل الملف",
            calendarPassedTimeHour: "{name} لـ {hour} ساعة",
            calendarPassedTime: "{name} لـ {hour} ساعة {min} دقيقة",
            calendarPassedTimeMin: "{name} لـ {value} min",
            workScheduleOneDay: "جدول العمل {name} على {sDate}",
            workSchedule: "جدول العمل {name} بين {sDate} - {eDate}",
            calendar: "تقويم",
            noRating: "لا يوجد تصنيف للعرض",
            rateDist: "توزيع الأسعار",
            distConversation: "توزيع الكلام من قبل الممثلين",
            distributionConversa: "توزيع النقاط",
            distChatbotAgent: "قنوات الاتصال",
            distAgent: "وكيل شات بوت",
            distFugitive: "الكلام الفائت والكلام المستلم",
            distLive: "دردشة مباشرة",
            distChatbot: "الشات بوت",
            distComplex: "دردشة مباشرة & الشات بوت",
            distHandled: "أجاب الدردشة",
            distMissed: "دردشة غير مجاب عنها",
            distWeb: "موقع إلكتروني",
            distWhatsapp: "واتس اب",
            distTelegram: "برقية",
            distInstagram: "الانستغرام",
            totalWhatsappChatCount: "عدد دردشة Whatsapp",
            statsByTime: "عدد الدردشة حسب الوقت",
            selectRep: "حدد ممثل",
            allRepresentatives: "جميع الممثلين",
            avgRating: "درجة التقييم ({point}) ({count} تصنيف)",
            avgFirstMessageTime: "متوسط وقت الاستجابة",
            totalBreakTime: "وقت كسر النظام",
            totalBreakNum: "عداد الكسر",
            averageConTime: "متوسط وقت المحادثة",
            multiWpReportTitle: "رقم محادثة واتس اب متعدد",
            multiWpReport: "عدد محادثات الواتساب المتعددة",
            multiWpReportExplanation: "يمكنك رؤية مقدار الدردشة لقنوات Whatsapp المتعددة الخاصة بك.",
            longestConTime: "أطول وقت محادثة",
            shortestConTime: "أقصر وقت محادثة",
            refresh: "ينعش",
            waitingReply: "الرسائل المعلقة",
            organizationName: "اسم المنظمة",
            companySlogan: "الاسم الطويل للمنظمة",
            messageSentErr: "الرسالة لا ترسل ، حاول مرة أخرى.",
            messageSent: "تم الارسال.",
            openPrivateChat: "فتح الدردشة التمثيلية",
            escKey: "يخفي محادثة نشطة",
            archiveChatKey: "يسمح لك بالانضمام إلى الدردشة في أسفل صفحة الأرشيف.",
            chatCopilot: "يقوم بتشغيل برنامج Chat CoPilot",
            privateChat: "لوحة محادثة بين العوامل",
            multiModeAlertDesc: 'Supsis مفتوح في نافذة أخرى. انقر فوق "استخدم هنا" لاستخدام supsis في هذه النافذة.',
            useHereText: "استخدم هنا",
            brandVisibility: "تسمية العلامة التجارية Supsis تظهر على فقاعة الدردشة",
            focusInput: "حقل إدخال الدردشة النشطة للمؤشر",
            send: "يرسل",
            notYet: "ليس بعد",
            sending: "إرسال",
            onlyRepresentative: "لا يمكن أن يرى رسالتك إلا من قبل الممثلين",
            yourMessage: "رسالتك",
            liveFabListDescription: "الدعم المباشر",
            messengerIntegrationDesc: "تحدث مع عملائك عبر صفحة الفيسبوك، وأرسل رسائل آلية باستخدام الدردشة الآلية.",
            checkDepartmentToAgent: "التحقق من القسم للوكيل عبر الإنترنت",
            ifAllOfflineStory: "القصة لتوجيه إذا كان الجميع غير متصلين",
            AssignMessagesToAgents: "تعيين جميع الرسائل للوكلاء",
            firstChatbotAndAssign: "يُجيب Chatbot أولاً ثم يُسند إلى وكيل",
            hybridAssign:
                "يتحقق النظام من القسم لمعرفة ما إذا كان هناك وكيل عبر الإنترنت ، وإذا لم يكن هناك وكيل عبر الإنترنت ، فإنه يعينه إلى الشاتبوت.",
            ticketFabListDescription: "تذكرة",
            whatsappFabListDescription: "ال WhatsApp",
            phoneFabListDescription: "هاتف",
            emailFabListDescription: "بريد إلكتروني",
            facebookFabListDescription: "فيسبوك",
            twitterFabListDescription: "تويتر",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "موقع YouTube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "اكتب رابط قناة {channelLink} في هذا الحقل.",
            typeYourAccountLink: "اكتب رابط حساب {accountLink} في هذا الحقل.",
            typeYourMessage: "اكتب رسالتك هنا",
            typeYourMessageMail:
                "سيتم إرسال الرسالة التي تم إدخالها في هذا الحقل من قبل العميل إلى عنوان البريد أعلاه كرسالة أولى.",
            typeYourMessageDesc:
                "سيتم إرسال الرسالة التي تم إدخالها في هذا الحقل من قبل العميل إلى رقم الهاتف أعلاه كرسالة أولى.",
            sendNumber: "رقم الهاتف لإرسال الرسالة إلى: {path}",
            callNumber: "رقم الهاتف لعميلك للاتصال: {phoneNumber}",
            numberIsNotCorrect: "تم إدخال الرقم المفقود !!",
            emailIsNotCorrect: "البريد الإلكتروني غير صحيح!",
            selectFab: "حدد FAB",
            notValid: "يمكنك فقط إدخال الحروف. (حرف واحد) .e ، d ، f ، z ، a ، x ، c ، v ، w ، t ، n الحروف غير صالحة",
            forMacUsers: "يمكن لمستخدمي MAC استخدام اختصار التحكم (⌃)",
            basePriceValue: "السعر الأساسي",
            basePriceDiscount: "تخفيض",
            basePriceCurrency: "عملة",
            customerDBEnabled: "اختيار قاعدة البيانات: استخدم خادم قاعدة بيانات العملاء",
            customerDBDisabled: "اختيار قاعدة البيانات: استخدم SUPSIS Server",
            mongoConnectionString: "اتصال Mongo",
            whatsappBasePriceValue: "سعر قاعدة WhatsApp",
            whatsappPlusBasePriceValue: "WhatsApp Plus سعر الأساس",
            instagramBasePriceValue: "سعر قاعدة Instagram",
            instagramPlusBasePriceValue: "السعر الأساسي Instagram Plus",
            clientAddress: "عنوان العميل",
            customerClientAddress: "عنوان عميل العميل",
            apiAddress: "عنوان API",
            socketAddress: "عنوان المقبس",
            backendAddress: "عنوان الخلفية",
            panelLogoUrl: "عنوان شعار لوحة URL",
            panelCustomCssUrl: "لوحة عنوان URL المخصص CSS",
            customerLogoUrl: "عنوان URL شعار العميل",
            customerCssUrl: "عميل CSS URL",
            siteAlias: "الملقب الموقع",
            language: "لغة",
            features: "سمات",
            interactionPopularity: "شيوع التفاعلات",
            interactionCount: "عدد التفاعل",
            uniqueUserCount: "عدد المستخدم الفريد",
            allUserPercentage: "(٪) النسبة المئوية لكل المستخدمين",
            represantativeSettings: "الإعدادات التمثيلية",
            documentTitle: "نموذج مستند Supsis",
            supsisDocument: "وثيقة Supsis",
            ApiDoc: "وثائق الواجهة البرمجية للتطبيق",
            chatBalloonTehemeSettings: "إعدادات بالون وموضوع الدردشة",
            customLoginFormSettingsTitle: "تخصيص نموذج تسجيل الدخول للزوار",
            addNewField: "أضف حقلًا جديدًا",
            editField: "تحرير الحقل",
            typeHere: "اكتب المحتوى هنا!",
            pco: "cur",
            perPage: "/صفحة",
            perPageInFilter: "قطعة",
            noUserInfoFound: "لم يتم العثور على معلومات المستخدم",
            startFilter: "بدء مرشح",
            showMyChats: "أظهر الدردشات الخاصة بي",
            showOnlineAgents: "إظهار الوكلاء عبر الإنترنت فقط",
            showWaitingChats: "عرض الدردشات الانتظار",
            addNewStatus: "أضف الحالة",
            newTitleContent: "عنوان جديد",
            newCTRLContent: "محتوى CTRL جديد",
            newALTContent: "محتوى ALT جديد",
            newTABContent: "محتوى علامة تبويب جديدة",
            roleName: "اسم الدور",
            error: "خطأ",
            contentTitle: "عنوان المحتوى",
            contentType: "نوع المحتوى",
            cannotMoveFullParent: "لا يمكن تحريك هذا العنصر",
            newSiteForm: "نموذج تسجيل موقع جديد",
            updateSiteForm: "نموذج تحديث الموقع",
            newBannedWordForm: "نموذج تسجيل الكلمات المحظور الجديد",
            updateBannedWordForm: "نموذج تحديث الكلمات المحظور",
            newWelcomeMessageForm: "نموذج تسجيل رسالة ترحيب جديد",
            updateWelcomeMessageForm: "نموذج تحديث رسالة النظام",
            newDefaultContentForm: "نموذج تسجيل المحتوى الافتراضي الجديد",
            updateDefaultContentForm: "نموذج تحديث المحتوى الافتراضي",
            newSubjectForm: "نموذج تسجيل الموضوع الجديد",
            updateSubjectForm: "نموذج تحديث الموضوع",
            showChatColorMeaning: "ألوان الدردشة",
            showIntro: "عرض مقدمة",
            options: "خيارات",
            resetPassword: "إعادة تعيين كلمة المرور",
            audioLevel: "حجم تنبيه الصوت",
            privateChatNotificationSound: "صوت الإشعار",
            continue: "يكمل",
            newRoleForm: "نموذج تسجيل الدور الجديد",
            updateRoleForm: "نموذج تحديث الدور",
            newRolePlaceHolder: "انقر لدور جديد",
            newUserForm: "نموذج تسجيل مستخدم جديد",
            updateUserForm: "نموذج تحديث المستخدم",
            changeOSRForm: "رسالة تغيير في وضع عدم الاتصال",
            tooltipOSRForm: "يمكنك تغيير الرسالة دون اتصال.",
            newOSRForm: "نموذج الدعم في وضع عدم الاتصال",
            newOSRMessages: "أضف رسالة غير متصلة بالإنترنت",
            updateOSRForm: "نموذج التحديث في وضع عدم الاتصال",
            osrTitle: "عنوان",
            osrTitleDescription: "يمكنك إضافة عنوان نموذج الدعم في وضع عدم الاتصال",
            osrContent: "محتوى",
            osrContentDescription: "يمكنك إضافة محتوى نموذج الدعم في وضع عدم الاتصال",
            hello: "مرحبا بالعالم",
            date: "تاريخ",
            startDate: "تاريخ البدء",
            finish: "ينهي",
            start: "يبدأ",
            search: "يبحث",
            endDate: "تاريخ الانتهاء",
            representative: "مندوب",
            representative_: "ممثل",
            star: "نجمة",
            filter: "منقي",
            reset: "إعادة ضبط",
            dailyChatList: "قائمة الدردشة اليومية",
            dailyChatDuration: "مدة الدردشة اليومية",
            chatDuration: "مدة الدردشة",
            dailyChatGraph: "الرسم البياني للدردشة اليومية",
            ok: "نعم",
            cancel: "يلغي",
            chatCount: "عدد الدردشة",
            shortest: "أقصر",
            longest: "أطول",
            average: "متوسط",
            count: "عدد",
            averagePoint: "متوسط ​​النقطة",
            pointDist: "توزيع النقطة",
            point: "نقطة",
            filters: "المرشحات",
            totalCustomer: "إجمالي العميل",
            avResponseTime: "متوسط ​​وقت الاستجابة",
            breakDuration: "مدة كسر",
            breakCount: "عداد الكسر",
            lastLoginPlatform: "منصة",
            active: "نشيط",
            passive: "سلبي",
            userForm: "المستخدم",
            sender: "المُرسِل",
            profile: "حساب تعريفي",
            name: "اسم",
            number: "رقم",
            username: "اسم المستخدم",
            email: "بريد إلكتروني",
            password: "كلمة المرور",
            oldPassword: "كلمة المرور القديمة",
            newPassword: "كلمة المرور الجديدة",
            passwordAtLeast: "كلمة المرور (على الأقل {num})",
            passwordRepeat: "اعد كلمة السر",
            changePassword: "تغيير كلمة المرور",
            status: "حالة",
            enableState: "نشيط؟",
            douYouWishToDeleteUser: "دو ترغب في حذف هذا المستخدم؟",
            userDeleted: "تم حذف المستخدم",
            userSaved: "تم حفظ المستخدم.",
            oldPasswordError: "كلمة المرور القديمة غير صحيحة ، يرجى التحقق.",
            chooseAnOption: "الرجاء تحديد صوت الإخطار.",
            userVolumeUpdated: "تحديث إعدادات الصوت.",
            save: "يحفظ",
            update: "تحديث",
            addNewMenu: "أضف قائمة جديدة",
            addNewContent: "أضف محتوى جديد",
            pleaseTitleEnter: "الرجاء العنوان إدخال",
            like: "يحب",
            disLike: "لم يعجبنى",
            users: "المستخدمون",
            visitor: "الزائرين",
            allContacts: "كل الاتصالات",
            allUsers: "جميع الممثلين",
            allSites: "جميع المجالات",
            newUser: "مستخدم جديد",
            noNewUser: "لا يوجد مستخدم بعد.",
            noNewAdminUser: "لا يوجد مستخدم مسؤول حتى الآن.",
            noRoleFound: "لا يوجد دور حتى الآن.",
            noBannedWordFound: "لا توجد كلمة محظورة حتى الآن.",
            noWelcomeMessageFound: "لا توجد رسالة نظام حتى الآن.",
            noSubjectFound: "لا يوجد موضوع حتى الآن.",
            noVisitorFound: "لا يوجد زائر.",
            noContactFound: "لا يوجد اتصال.",
            sendResponse: "اكتب رد",
            delete: "يمسح",
            noLiveSupportFound: "لا يوجد زائر متصل بالدعم المباشر",
            noLiveSupportFoundWithDepartment: "لا يوجد خطاب ينتمي إلى القسم",
            duplicate: "ينسخ",
            makeDefault: "جعل الافتراضي",
            checkMore: "تحقق أكثر",
            useReadyTemplates: "استخدم قوالب جاهزة",
            noRePresentativeFound: "لا يوجد ممثل",
            noBannedVisitorFound: "لا يوجد زائر محظور حتى الآن.",
            removeBanDescription: "إزالة الحظر",
            editThisItem: "قم بتحديث هذا العنصر",
            removeThisItem: "أزل هذا البند",
            role: "دور",
            autoChatAssignLimit: "محادثة تلقائية تعيين الحد",
            chatAssignInfo: "-1 = افتراضي النظام ، 0 = لا يوجد تعيين ،> 0 = تعيين كقيمة معينة.",
            relatedDepartments: "الإدارات ذات الصلة",
            subjectInfo: "إذا لم يكن هناك موضوع محدد ، يُسمح بجميع الموضوعات.",
            archive: "أرشيف",
            offlineSupportRequests: "الدعم في وضع عدم الاتصال",
            first: "أولاً",
            last: "آخر",
            query: "بدء البحث",
            clean: "ينظف",
            loading: "تحميل",
            loadMore: "تحميل المزيد",
            noMessage: "ليست أي رسالة",
            selectChat: "اختر الدردشة",
            noMessageInChat: "لا توجد رسالة في هذه الدردشة",
            noMediaToShow: "لا توجد وسائط لعرضها",
            firstSeen: "ظهور أول مرة",
            userInfo: "معلومات المستخدم",
            chatId: "معرف الدردشة",
            visitorId: "معرف الزائر",
            visitingPage: "صفحة زيارة",
            osAndBrowser: "نظام التشغيل والمتصفح",
            customerClientVersion: "إصدار عميل العميل",
            visitorFeedback: "ردود الفعل الزائر",
            notes: "ملاحظات",
            nameSurname: "اسم اللقب",
            chats: "الدردشات",
            bannedVisitors: "الزوار المحظورون",
            country: "دولة",
            city: "مدينة",
            cityDistrict: "مقاطعه المدينه",
            browser: "متصفح",
            os: "نظام التشغيل",
            ipAddress: "عنوان IP",
            connectionDate: "تاريخ الاتصال",
            transaction: "عملية",
            banRemoved: "حظر إزالة.",
            bannedWords: "الكلمات المحظورة",
            newBannedWord: "كلمة محظورة جديدة",
            noBannedWord: "لا كلمة محظورة حتى الآن.",
            bannedWordForm: "نموذج العمل المحظور",
            word: "كلمة",
            bannedWordAndWordGroup: "مجموعة الكلمة / العمل المحظورة",
            doYouWishToDeleteBannedWord: "دو هل ترغب حقًا في حذف هذه الكلمة المحظورة؟",
            doYouWishToOfflineSupportRequest: "دو هل ترغب حقًا في حذف هذه الرسالة؟",
            bannedWordSaved: "الكلمة المحظورة المحفوظة",
            deletedSuccessfully: "حذف بنجاح",
            deleteErrorMsg: "خطأ: لم يتم حذفه ، حاول مرة أخرى",
            socketError: "خطأ في اتصال المقبس. الرجاء تحديث الصفحة وحاول مرة أخرى.",
            socketConnecting: "الاتصال بالخادم",
            offlineModeDescription: "النظام لأسفل ، لن يتمكن العملاء من الوصول إلى الدعم المباشر.",
            offlineModeSettingsDescription: "تحقق من ميزة الوضع غير المتصلة في قائمة الإعدادات.",
            offlineModeUser: "يجب أن يكون هناك ممثل واحد على الأقل عبر الإنترنت في النظام.",
            offlineModeMessage: "رسالة دون اتصال",
            offlineMode: "وضع غير متصل بالشبكة",
            adminCannotConnectSocket: "لا يمكن للمسؤول الاتصال بالمقبس.",
            liveSupport: "الدعم المباشر",
            siteVisitors: "زوار الموقع",
            visitors: "الزائرين",
            thoseConnectedToLiveSupport: "أولئك الذين يتصلون بدعم مباشر",
            visitorHistory: "تاريخ الزوار",
            visitorHistoryDescription: "يمكنك عرض وتحميل سجل دردشة الزائر.",
            privateMessage: "رسالة خاصة",
            addRepresentative: "إضافة ممثل",
            forwardRepresentative: "ممثل إلى الأمام",
            keyboardShortcuts: "اختصارات لوحة المفاتيح",
            chatColorMeanings: "معاني ألوان الدردشة",
            connLostCheckInternet: "الاتصال المفقود ، يرجى التحقق من اتصال الإنترنت الخاص بك.",
            wishToEndThisChat: "دو ترغب في إنهاء هذه الدردشة؟",
            defaultContents: "المحتوى الافتراضي",
            contents: "محتويات",
            newDefaultContent: "محتوى افتراضي جديد",
            title: "عنوان",
            shortcutChar: "الطابع الاختصار",
            pickOne: "إختر واحدة",
            writeSomething: "اكتب حرفًا (A-Z | 0-9)",
            letterSequence: "تسلسل الرسالة",
            exampleText: "مثال: SOC -> كرة القدم",
            anyChar: "أي شخصية",
            shorcutKey: "مفتاح الاختصار",
            content: "محتوى",
            shortcutName: "اسم الاختصار",
            type: "يكتب",
            shortcut: "الاختصار",
            defaultContentForm: "نموذج المحتوى الافتراضي",
            deleteContentQuestion: "هل ترغب حقًا في حذف هذا المحتوى الافتراضي؟",
            defaultContentDeleted: "المحتوى الافتراضي المحذوف",
            defaultContentSaved: "المحتوى الافتراضي المحفوظ.",
            contentMoved: "تحرك المحتوى.",
            yourEmail: "عنوان البريد الإلكتروني",
            yourName: "اسمك ولقبك",
            login: "تسجيل الدخول",
            lostPassword: "هل نسيت كلمة السر",
            multipleSession: "لقد وقعت في مكان آخر.",
            notAuthorizedToDisplayPage: "أنت غير مخول لرؤية هذه الصفحة!",
            permissions: "أذونات",
            newPermission: "إذن جديد",
            permissionForm: "شكل إذن",
            displayTitle: "عنوان العرض",
            key: "مفتاح",
            keyToUseInSystem: "القيمة الرئيسية للاستخدام في النظام",
            deletePermissionQuestion: "هل ترغب حقًا في حذف هذا الإذن؟",
            permissionDeleted: "تم حذف إذن.",
            permissionSaved: "إذن تم حفظه.",
            newRole: "دور جديد",
            selectARole: "حدد دورًا",
            yes: "نعم",
            no: "لا",
            fullAuth: "إذن كامل",
            roleDeleted: "دور تم حذفه.",
            roleSaved: "دور محفوظ.",
            roleForm: "شكل الدور",
            roles: "أدوار",
            settings: "إعدادات",
            selectTopic: "حدد قسم",
            autoCallTransfer: "نقل المكالمات التلقائية",
            customerTyping: "كتابة العملاء",
            typing: "الكتابة",
            agentTyping: "الكتابة التمثيلية",
            disconnectTime: "وقت إعادة الاتصال ماكس (ثانية)",
            tippyDissconnectTime: "عندما تكون الدردشة غير نشطة بعد عدد الثواني ستنتهي محادثة.",
            queueNumberVisibleFeature: "عرض رقم قائمة الانتظار للزائر",
            privateChatEnabled: "إظهار الدردشة بين الممثلين",
            delayedTalkTime: "وقت التأخير (ثانية)",
            employeeAverageChatCount: "متوسط ​​رقم الدردشة لمعدل دردشة الموظف",
            customerDownTimeWhenRepExit: "توقف العميل عندما يترك التمثيلي (SN.)",
            autoAssignLimit: "الحد الأقصى التلقائي التلقائي",
            wasted: "محادثة فقدت الوقت (ثانية)",
            settingFormWrong: "بيانات النموذج خاطئة ، حاول مرة أخرى بعد التحقق من ذلك",
            settingsSaved: "تم حفظ الإعدادات.",
            settingsCannotSaved: "لا يمكن حفظ الإعدادات",
            noAuthorization: "لا تخويل",
            warningBadInput: "يوصى بإدخال رقم بين 0 و 70.",
            warning: "تحذير!",
            warningBadInputMarginY: "تحذير من إدخال الهامش العمودي ⚠",
            warningBadInputMarginX: "تحذير من إدخال الهامش الأفقي ⚠",
            warningBadInputBubbleSize: "تحذير من إدخال فقاعة الدردشة ⚠",
            delayTime: "وقت التأخير (ثانية)",
            sites: "المواقع",
            newSite: "موقع جديد",
            noSiteYet: "لا يوجد موقع حتى الآن.",
            siteAddress: "عنوان الموقع",
            turnBack: "رجوع",
            customerRepLimit: "حد ممثل العميل",
            siteSaved: "تم حفظ الموقع.",
            siteSaveError: "حدث خطأ أثناء إنشاء الموقع",
            subjects: "المواضيع",
            newSubject: "موضوع جديد",
            noSubject: "لا موضوع حتى الآن.",
            subject: "موضوع",
            subjectTitle: "عنوان الموضوع",
            description: "وصف",
            infoAboutSubject: "معلومات حول الموضوع",
            deleteSubjectQuestion: "هل ترغب حقًا في حذف هذا الموضوع؟",
            subjectDeleted: "موضوع تم حذفه.",
            subjectSaved: "موضوع حفظ.",
            welcomeMessages: "رسائل النظام",
            newWelcomeMessages: "رسالة ترحيب جديدة",
            noWelcomeMessage: "لا توجد رسالة نظام.",
            welcomeMessageContent: "محتوى رسالة النظام",
            makeChoice: "أختار...",
            welcomeMessage: "ترحيب رسالة",
            repLoggedIn: "قام ممثل بتسجيل الدخول",
            loginMessage: "تسجيل الدخول",
            message: "رسالة",
            deleteWelcomeMessageQuestion: "هل ترغب حقًا في حذف رسالة النظام هذه؟",
            welcomeMessageDeleted: "تم حذف رسالة النظام",
            welcomeMessageSaved: "تم حفظ رسالة النظام.",
            welcomeMessageForm: "نموذج رسالة النظام",
            noRep: "لا يوجد ممثل حتى الآن.",
            addChat: "أضف الدردشة",
            forwardChat: "الدردشة إلى الأمام",
            ago: "منذ",
            repName: "اسم الممثل",
            lastOnline: "آخر اتصال/وقت عبر الإنترنت",
            lastStatusChange: "تغيير الحالة الأخيرة",
            activeChat: "دردشة نشطة",
            userMaxCapacity: "سعة الدردشة القصوى",
            noActiveChat: "لا دردشة نشطة",
            watch: "يشاهد",
            join: "ينضم",
            open: "فتح محادثة",
            directMessage: "رسالة خاصة",
            block: "حاجز",
            transactions: "المعاملات",
            informations: "المعلومات",
            visitStart: "قم بزيارة البداية",
            fullName: "الاسم الكامل",
            waitChatTime: "وقت الانتظار/الدردشة",
            blockUserConfirm: "هل تريد منع هذا المستخدم؟",
            messaging: "المراسلة",
            hideChat: "إخفاء الدردشة",
            block_: "حاجز",
            privateMessage_: "رسالة خاصة",
            assignRep: "تعيين ممثل",
            joinChat: "انضم للمحادثه",
            forwardRep: "إلى الأمام",
            leaveChat: "اترك الدردشة",
            endChat: "نهاية المحادثة",
            translatedTextDescription: "ترجم Amazon هذه الرسالة {from} -> {to}.",
            autoTranslate: "ترجمة السيارات",
            translateThisMessage: "ترجمة هذه الرسالة",
            autoTranslateDetectedDesc: "لغة الزائر هي {visitorLanguage}. انقر هنا لتفعيل الترجمة التلقائية",
            on: "على",
            off: "عن",
            copy: "ينسخ",
            prevChats: "الدردشات السابقة",
            noShortCut: "لا اختصار",
            leaveChartConfirm: "دو هل ترغب حقًا في مغادرة الدردشة؟",
            endChatConfirm: "دو ترغب في إنهاء الدردشة؟",
            endConversation: "نهاية المحادثة",
            onlyOneRep: "أنت الممثل الوحيد في هذه المحادثة!",
            chatList: "قائمة الدردشة",
            chatBar: "شريط الدردشة",
            unreadTitle: "غير مقروء",
            visitorLeftTitle: "غادر الزائر",
            activeChatTitle: "دردشة نشطة",
            autoAssignedTitle: "دردشة مخصصة تلقائية",
            watchModeTitle: "وضع الساعة",
            lostChat: "الاتصال التمثيلي فقد",
            chatWidthDelay: "الدردشة مع التأخير",
            repChatWidthDelay:
                "عندما لا يكون هناك ممثل نشط في النظام أو جميع ممثلينا ممتلئين بسبب ارتفاع حركة المرور ، ستكون خلفية الدردشة خضراء",
            repLostConn: "إذا فقد ممثل العميل الاتصال ، فستكون خلفية الدردشة وردية.",
            unreadMsg: "إذا كانت هناك رسائل غير مقروءة ، فستكون الخلفية زرقاء فاتحة.",
            visitorLeftChat: "إذا غادر الزائر المحادثة ، تصبح الخلفية رمادية داكنة.",
            activeChatMsg: "الخلفية خضراء إذا كانت الدردشة نشطة",
            autoAssignMsg:
                "تصبح الخلفية خردلًا إذا تم تعيينها عن طريق المهمة التلقائية ولم يتم النظر إلى المحادثة أبعد من ذلك",
            watchModeMsg: "إذا تم تشغيله في وضع التشغيل ، تصبح الخلفية حمراء",
            online: "متصل",
            beRightBack: "بعيد",
            away: "بعيد",
            busy: "مشغول",
            offline: "غير متصل على الانترنت",
            logout: "تسجيل خروج",
            forWindows: "للنوافذ",
            forMac: "لل ماك",
            nextChatFromActive: "التبديل من النشط إلى المحادثة التالية",
            previousChatFromActive: "التبديل من النشط إلى السابق",
            hideActiveChat: "إخفاء المحادثة النشطة",
            closeActiveChat: "إغلاق محادثة نشطة",
            firsthiddenChat: "انضم إلى أكثر دردشة العميل التي انتظرها",
            firstChatWaiting: "قم بالتبديل إلى المحادثة الانتظار",
            previousOpenedChat: "بغض النظر عن الترتيب ، انتقل إلى المحادثة التي تم فتحها مسبقًا",
            historyDetails: "تفاصيل التاريخ",
            chat: "محادثة",
            chatNotFound: "لم يتم العثور على كلام",
            dataNotFound: "لم يتم العثور على بيانات.",
            visitorInfo: "معلومات الزائر",
            timeSpent: "قضاء الوقت",
            noActiveVisitors: "لا زوار نشطين",
            totalConnected: "عدد المحادثة",
            missedChat: "عدد الدردشة الفائتة",
            workTime: "وقت العمل",
            closedChatCount: "دردشة مغلقة",
            activeConvo: "محادثة نشطة",
            notAnswered: "لم يرد بعد",
            delayedConvo: "تأخير",
            leavingRep: "ترك ممثل",
            staffRate: "معدل عمل الموظفين",
            select: "القائمة المنسدلة",
            fullname: "الاسم الكامل",
            text: "نص",
            numeric: "رقم",
            phone: "هاتف",
            optionsPlaceholder: "قيمة الخيار",
            selectField: "انقر إذا كنت تريد إضافة قائمة منسدلة",
            fullnameField: "انقر إذا كنت تريد إضافة حقل اسم كامل.",
            textField: "انقر إذا كنت تريد إضافة حقل نص.",
            labelField: "انقر إذا كنت تريد إضافة حقل وصف.",
            numericField: "انقر إذا كنت تريد إضافة حقل رقمي.",
            phoneField: "انقر إذا كنت ترغب في إضافة حقل هاتف.",
            departmentField: "انقر إذا كنت ترغب في إضافة حقل قسم.",
            emailField: "انقر إذا كنت ترغب في إضافة حقل بريد إلكتروني.",
            visible: "مرئي",
            required: "مطلوب",
            label: "تعليق",
            customLoginAlert: "يجب أن يحتوي نموذج تسجيل الدخول الخاص بك على حقل مرئي واحد على الأقل.",
            atLeastOneLanguage: "يجب أن تشعر بلغة واحدة على الأقل",
            requiredFieldField: "هذه الخانة مطلوبه",
            notRequiredField: "لا يشترط هذا المجال",
            visibleField: "هذا المجال مرئي",
            notVisibleField: "هذا الحقل لا يظهر في النموذج.",
            connectServer: "أنت متصل بالخادم",
            disconnectServer: "أنت غير متصل بالخادم",
            liveChatOff: "الدردشة الحية متوقفة",
            visitorScreen: "شاشة الزوار",
            viewOnTheSite: "عرض على الصفحة",
            viewOnTheSiteTippy: "انقر هنا لترى كيف تصمد التغييرات الخاصة بك.",
            showHint: "اظهر التلميح",
            dontShowHint: "لا تظهر تلميحًا",
            liveChatOn: "الدردشة الحية قيد التشغيل",
            nightModeOff: "وضع الليل قبالة",
            doubleClickEdit: "انقر نقرًا مزدوجًا أو اضغط على زر التحرير لتحريره.",
            edit: "يحرر",
            deleteField: "يمسح",
            arrow_upward: "السهم لأعلى",
            arrow_downward: "السهم لأسفل",
            newCatalogCategory: "فئة الكتالوج الجديدة",
            childCreate: "انقر نقرًا مزدوجًا لإنشاء طفل جديد",
            updateCatalogCategoryFrom: "تحديث نموذج فئة الكتالوج",
            newCatalogCategoryFrom: "نموذج فئة الكتالوج الجديدة",
            catalogCategoryMenu: "إضافة قائمة فئة الكتالوج",
            catalogCategoryLeaf: "إضافة القائمة الفرعية فئة الكتالوج",
            catalogCategoryName: "فئة الكتالوج اسم",
            newCatalogContentFrom: "نموذج محتوى الكتالوج الجديد",
            catalogContentName: "اسم محتوى الكتالوج",
            catalogCategorySaved: "فئة الكتالوج المحفوظة",
            catalogCategoryDeleted: "فئة الكتالوج المحذوفة",
            catalogCategoryRate: "معدل المحتوى",
            catalogContentFeature: "ميزة محتوى الكتالوج",
            vtipyAudioLevel: "تستخدم لكتم الصوت أو إلغاء كتم الأصوات.",
            vtipyOrganizationName: "يمكنك تغيير اسم المؤسسة وتحديثه.",
            vtipyBrandVisibility: "Supsis هو الإعداد ما إذا كان يمكن عرض العلامة في فقاعة الدردشة.",
            vtipyBrandVisibilityForced: "يمكن لمستخدمي بروبان فقط التغيير !!",
            vtipyClientDefault: "يمكنك تغيير لغة صفحة الوكيل هنا.",
            vtipyCustomerClientDefault: "يمكنك تغيير لغة صفحة العميل (الدردشة) هنا.",
            vtipyVisitorPreferredLang: "يمكن للعميل تحديد اللغة المنطوقة على صفحة (الدردشة).",
            vtipyCustomerClientLanguageDetect: "يمكنك تغيير لغة صفحة العميل (الدردشة) هنا.",
            vtipySelectTopic: "تحدث المهام التلقائية للممثلين الحاليين في القسم المحدد.",
            vtipyAutoCallTransfer: "يعين تلقائيا مكالمات الانتظار إلى الوكلاء المتاحين.",
            vtipyCustomerTyping: "يتيح لك معرفة ما كتبه العميل على شاشة الدردشة على شاشة الدردشة التمثيلية.",
            vtipyAgentTyping: "إنها تعطي معلومات عند كتابة التمثيلية للعميل في الدردشة bobble",
            vtipyQueueNumberVisibleFeature:
                "عندما يكون الممثلون مشغولين ، فإنه يوضح العملاء الذين يرغبون في الاتصال ، في أي ترتيب هم.",
            vtipyPrivateChatEnabled: "يظهر لوحة المحادثة بين العوامل.",
            vtipyDelayedTalkTime:
                'إذا لم يتم توصيل أي مندوبين بالمحادثة خلال هذا الوقت ، فسيتم تسميته \\ "الدردشة المتأخرة \\',
            vtipyOfflineMode: "يتيح لك وضع النظام في وضع عدم الاتصال.",
            vtipyAutoAssignLimit: "يحدد عدد العملاء (الدردشة) سيتم تعيينهم للممثل تلقائيًا.",
            vtipyCustomerDownTimeWhenRepExit: "وقت الخمول العميل عندما يخرج الممثل (ثانية)",
            tippyDisconnectTime: "إغلاق الدردشة بعد فصل العميل (SEC).",
            changeSettings: "تغيير الإعدادات العالمية",
            totalBg: "مجموع الدردشات",
            activeBg: "الدردشات النشطة",
            watchBg: "يشاهد",
            waitingBg: "محادثات عابرة",
            lateBg: "محادثات عابرة",
            freeBg: "حر",
            maxCapacityBg: "السعة القصوى",
            addNewSettings: "أضف إعدادات عالمية جديدة",
            darkMode: "الوضع المظلم",
            clientDefault: "لوحة الافتراضية اللوحة",
            customerClientDefault: "لغة العميل الافتراضية",
            customerClientLanguageDetect: "لغة العميل لاكتشاف تلقائي",
            visitorPreferredLang: "دع العميل يختار اللغة المنطوقة",
            preferredThemeColor: "لون السمة المفضل لشاشة دردشة العميل",
            detail: "التفاصيل",
            supportUs: "اتصل بنا (الدعم المباشر)",
            langSetting: "إعدادات اللغة",
            changeLang: "تغيير اللغة",
            fontSizeSetting: "إعداد تكبير الشاشة",
            changeLangDesc: "يغير لغة التطبيق إلى {code}",
            trLang: "اللغة التركية",
            enLang: "إنجليزي",
            fieldRequired: "{الحقل} مطلوب حقل",
            selectALanguage: "اختر لغة",
            selectATheme: "حدد موضوع",
            responseForm: "نموذج الاستجابة",
            clientRequestInfo: "معلومات طلب العميل",
            createdDate: "تاريخ الإنشاء",
            descMessage: "رسائل",
            new: "جديد",
            selectAllPermission: "اختر الكل",
            catalogCategories: "فهرس",
            copiedClipboard: "نسخ إلى الحافظة",
            changeLogo: "تغيير الشعار",
            changePhoto: "غير الصوره",
            addPhoto: "إضافة صورة",
            seePhoto: "انظر الصورة",
            deletePhoto: "احذف الصورة",
            organizationLogo: "شعار المنظمة",
            changePlan: "خطة التغيير",
            close: "يغلق",
            vtipyUploadLogo:
                "من خلال تحميل شعار شركتك من هذا المجال ، يمكنك استخدام شعارك الخاص في رسائل البريد الإلكتروني وصفحات العملاء.",
            tagName: "اسم العلامة",
            tagDescription: "وصف التسمية",
            tagColor: "لون التسمية",
            userInformations: "معلومات المستخدم",
            incomingChat: "محادثة واردة",
            support: "يدعم",
            team: "تعيين",
            groups: "مجموعات",
            newConversationStarted: "بدأت محادثة جديدة",
            allHistoryLoaded: "تم تحميل كل التاريخ",
            chatCreator: "منشئ الدردشة",
            enterGroupTitle: "أدخل عنوان المجموعة",
            requiredTitle: "لا يمكنك ترك حقل العنوان فارغًا",
            requiredChannel: "لا يمكن ترك اسم القناة فارغًا",
            next: "يتأكد",
            selectPeople: "حدد الأشخاص",
            textLimitAlertMessage:
                "الحد الأقصى لعدد الأحرف في WhatsApp هو 19 حرفًا ولن يتم عرضه بعد هذا الحد. ومع ذلك، على الويب، يتم نقل النصوص التي تتجاوز الحد المسموح به وهو 19 حرفًا تلقائيًا إلى السطر التالي ويتم عرضها.",
        },
        shouldAddMethod:
            "يجب عليك ملء حقل طريقة الدفع وعنوان الفواتير!\nلن يتم سحب أي أموال من حسابك..\n" +
            "في نهاية الشهر ، سيتم إنشاء فاتورة وفقًا لمبلغ استخدامك.",
        telegram: {
            typeInTelegramToken: "اكتب رمز برقية",
            token: "رمز",
            telegramTokenTitle: "تكامل Telegram Supsis",
            telegramAlertForm: "يمكنك الحصول على Telegram bot token منz",
            telegramAlertTitle: "هل تريد حقًا حذف الرمز المميز؟",
            telegramAlertText: "الرمز المميز سوف يختفي بشكل دائم!",
        },
        wp: {
            chatStarted: "بدأت الدردشة",
            chatNotStarted: "الدردشة لم تبدأ",
            contactSelected: "الاتصال المحدد",
            startChatWithAnyNo: "ابدأ الدردشة مع أي رقم",
            toLittleChar: "رقم مفقود !",
            typeInANumberDesc: "اكتب الرقم لبدء الدردشة مع:",
            wpPlusAndLicenceRequired: "WhatsApp Plus خطة وترخيص مطلوب.",
            wpPlusAndLicenceRequiredDesc:
                "قبل أن تتمكن من بدء الدردشات بأرقام غير مسجلة في جهات الاتصال الخاصة بك ، يجب عليك ترقية خطة WhatsApp والحصول على ترخيص ..",
            chatStartingWait: "بدء المحادثة ، يرجى الانتظار",
            whatsapp: "ال WhatsApp",
            agreement: "اتفاق",
            purchase: "شراء",
            activating: "تنشيط خدمة WhatsApp",
            authenticating: "مصادقة رمز الاستجابة السريعة",
            ready: "مستعد",
            enableFeature: "تمكين ميزة WhatsApp",
            readAndAgree: "لقد قرأت وأوافق",
            subscribe: "يشترك",
            subscribed: "مشترك",
            toEnableWpDescription: "لتمكين ميزات WhatsApp ، انقر فوق الزر أدناه.",
            waitForWpActivationDescription:
                "يتم تنشيط خدمة حساب WhatsApp الخاصة بك. يرجى الانتظار لبعض الوقت. يستغرق حوالي 10-30 ثانية.",
            greatWpActivatedDescription: "رائع ، يتم تنشيط خدمة حساب WhatsApp الخاصة بك!",
            unsubscribe: "إلغاء الاشتراك",
            planDetails: "سمات",
            sendReceiveMessage: "إرسال واستقبال الرسائل النصية",
            sendReceiveImage: "إرسال وتلقي ملفات الصور",
            sendReceiveAudio: "إرسال واستقبال ملفات الصوت",
            sendReceiveGif: "إرسال وتلقي ملفات GIF",
            startChat: "ابدأ الدردشة على supsis",
            supsisFunctionality: "وظائف دردشة Supsis مفيدة",
            onePhoneMultiAgent: "هاتف واحد ووكلاء متعددين",
            basicIntegration: "التكامل الأساسي وتكوين الصفر",
            activationTitle: "لتفعيل تكامل WhatsApp على supsis:",
            wpIntegrationInstruction1: "افتح WhatsApp على هاتفك",
            wpIntegrationInstruction2: "اضغط على القائمة أو الإعداد. انقر فوق الأجهزة المرتبطة",
            wpIntegrationInstruction3: "أشر هاتفك إلى هذه الشاشة لالتقاط الرمز",
            qrGeneratingWait: "توليد رمز الاستجابة السريعة من فضلك انتظر ...",
            pleaseContinueToWaitUntilCompleted:
                "بعد التحقق من رمز الاستجابة السريعة ، سيتم التبديل تلقائيًا إلى الحقل المكتمل. انتظر من فضلك...",
            authenticatingWait: "المصادقة ، من فضلك انتظر ...",
            unsubscribeWpInetgration: "إلغاء الاشتراك في تكامل WhatsApp",
            unsubscribeIGIntegration: "إلغاء الاشتراك في تكامل Instagram",
            wpBack: "خلف",
            terminatelWpInetgration: 'عند النقر فوق الزر "إلغاء الاشتراك" ، سيتم إنهاء تكامل WhatsApp الخاص بك',
            cancelWpInetgration: "هل تريد إلغاء تكامل WhatsApp؟",
            terminatelIGIntegration: 'عند النقر فوق الزر "إلغاء الاشتراك" ، سينتهي تكامل Instagram الخاص بك',
            cancelIGIntegration: "هل تريد إلغاء تكامل Instagram؟",
            startChatWp: "ابدأ الدردشة",
            purchaseHeader: "شراء تكامل supsis-whatsapp",
            wpServices: "خدمة WhatsApp",
            wpServicesIntegrationCompleted: "اكتمل تكامل WhatsApp الخاص بك. يمكنك الآن استخدام الخدمة.",
            purchasePaymentDescription:
                "ميزة WhatsApp التي تم إصدارها من شهر إلى شهر. سيتم تنشيط خدمة WhatsApp الخاصة بك بعد قبول الاشتراك.",
            wpIntegrationFeatures: "ميزات تكامل WhatsApp",
            saveChanges: "حفظ التغييرات",
            contactList: "قائمة الإتصال",
            broadcast: {
                broadcast: "إذاعة",
                detail: "تفاصيل البث",
                customer: "عميل",
                phoneNumbers: "ارقام التواصل",
                showMore: "أظهر المزيد",
                groupName: "أسم المجموعة",
                messages: "رسائل",
                status: "حالة",
                usageCost: "تكلفة الاستخدام",
                sendingTime: "إرسال الوقت",
                progress: "تقدم",
                groupDetail: "تفاصيل المجموعة",
                messagesPerContact: "رسائل لكل جهة اتصال",
                successRatio: "نسبة النجاح",
            },
            messages: "رسائل",
            broadcastRequests: "طلبات البث",
            customerGroups: "مجموعات العملاء",
            messageTemplates: "قوالب الرسائل",
            plans: "خطط",
            wpIntegrationRequired: "تكامل WhatsApp مطلوب",
            wpRequiredIntegrationDescription: "آسف ، سيتم تنشيط الصفحة التي قمت بزيارتها عند دمج WhatsApp الخاص بك.",
            integrateWp: "دعنا نذهب ، دمج whatsapp",
            active: "نشيط",
            archived: "أرشفة",
            createBroadcastMessage: "إنشاء رسالة بث",
            title: "عنوان",
            description: "وصف",
            createdAt: "أنشئت في",
            numbers: "أعداد",
            actions: "أجراءات",
            action: "فعل",
            createCustomerGroup: "إنشاء مجموعة عملاء مخصصة",
            search: "يبحث",
            name: "اسم",
            contacts: "جهات الاتصال",
            noContactFound: "لم يتم العثور على اتصال",
            broadcastTitle: "إعطاء عنوان البث الخاص بك.",
            recipients: "المستلمين",
            selectRecipients: "حدد المستلمين",
            writeYourMessage: "اكتب رسالتك.",
            schedule: "جدول",
            scheduleNowOrLater: "الجدول الزمني الآن أو بعد ذلك",
            summary: "ملخص",
            cancel: "يلغي",
            send: "يرسل",
            sending: "إرسال",
            deleteCustomerGroup: "هل أنت متأكد من حذف مجموعة العملاء هذه؟ {name}",
            customerGroupDeleting: "حذف مجموعة العملاء ...",
            customerGroupDeletingSuccess: "تم حذف مجموعة العملاء بنجاح",
            customerGroupDeletingError: "خطأ أثناء حذف مجموعة العملاء",
            wpPlusRequired: "الخطة WhatsApp Plus المطلوبة.",
            broadcastMessageArchived: "رسالة البث أرشفة",
            broadcastMessageNotArchived: "رسالة البث غير مؤرشفة",
            groupNameSearch: "اكتب اسم مجموعة العملاء",
            groupNameDesc: "اسم مجموعة العميل حدد مجموعات العملاء الخاصة بك",
            save: "يحفظ",
            number: "رقم",
            addColumn: "إضافة العمود",
            addColumnDesc: "أضف عمودًا إلى الجدول",
            addNewContact: "إضافة جهة اتصال جديدة",
            addNewContactDesc: "أضف جهة اتصال إلى الجدول",
            importFile: "استيراد من الملف",
            importFileDesc: "استيراد جهات الاتصال من ملف Excel أو CSV",
            contactAdded: "الاتصال المضافة",
            updateCustomerGroup: "تحديث مجموعة العملاء ...",
            updateCustomerGroupSuccess: "تم تحديث مجموعة العملاء بنجاح",
            sendBroadcastMessage: "إرسال رسالة البث",
            columnName: "اسم العمود",
            columnType: "نوع العمود",
            defaultValue: "القيمة الافتراضية",
            setDefaultValue: "اضبط القيمة الافتراضية على جهات الاتصال",
            age: "عمر",
            location: "موقع",
            gender: "جنس",
            selectContactFile: "حدد ملف الاتصال",
            selectContactCsvOrExcel: "حدد ملف CSV أو Excel.",
            importConfiguration: "تكوين استيراد",
            customizeFile: "تخصيص تكوين الاستيراد الخاص بك.",
            sendMessageTo: "من تريد إرسال الرسالة إلى؟",
            allContact: "كل الاتصال",
            messageTypes: "أنواع الرسائل",
            whenSendMessage: "متى تريد إرسال الرسالة إلى؟",
            instantlyRightNow: "على الفور الآن",
            completed: "مكتمل",
            scheduleFuture: "جدول زمني لتاريخ المستقبل",
            messageDesc: "سيتم إرسال رسالتك على الفور إلى جميع المستلمين",
            messageSendAt: "سيتم إرسال رسالتك إلى جميع المستفيدين في",
            estimatedPrice: "السعر المقدر",
            estimatedTime: "الوقت المقدر",
            now: "الآن",
            tenMinute: "10 دقائق",
            cancelled: "ألغيت",
            failed: "فشل",
            running: "جري",
            queued: "قائمة الانتظار",
            scheduled: "المقرر",
            noNumberAdded: "لم تتم إضافة أرقام",
            csvOrExcelFile: "ملف CSV أو Excel",
            broadcastMessagesToContactFile: "رسائل البث إلى قائمة الاتصال",
            broadcastMessageTemplates: "قوالب الرسائل البث",
            messageFlow: "تدفق الرسالة",
            textMessageSupport: "دعم الرسائل النصية",
            imageMessageSupport: "دعم رسالة الصورة",
            spamPreventions: "الوقاية من البريد العشوائي",
            includesAllBasicPlans: "يشمل كل شيء في الخطة الأساسية",
            chatbotIntegration: "تكامل chatbot",
            messageToNewNumbers: "رسالة إلى أرقام جديدة",
            broadcastMessageToEveryone: "بث رسائل للجميع",
            personalizedBroadcastMessage: "رسائل البث الشخصية",
            customerGroupSegmentation: "تجزئة مجموعة العملاء",
            scheduleBroadcastMessage: "جدولة رسالة البث",
            locationMessageSupport: "دعم رسالة الموقع",
            advancedSpamPreventions: "الوقاية من البريد العشوائي المتقدمة",
            whatsappPlans: "خطط WhatsApp",
            selectBestPlan: "اختر الخطة التي تناسبك",
            comingSoon: "قريباً...",
            selectFile: "حدد ملف",
            created: "مخلوق",
            message: "رسالة",
        },
        ig: {
            instagram: "Instagram",
        },
        ticket: {
            ticketTagFilter: "علامة تصفية التذاكر",
            ticketEmails: "قائمة البريد الإلكتروني لإعادة توجيه التذاكر",
            save: "يحفظ",
            delete: "يمسح",
            transactions: "خيارات",
            noEmailTicketNotifications: "ليس هنالك معلومات",
            emailIsNotValid: "البريد الإلكتروني غير صالح",
            emailNotificationDeleted: "تم حذف العنصر بنجاح",
            emailNotificationDeleteError: "حدث خطأ",
            tagFilterRequired: "علامة مرشح التذاكر المطلوبة ، استخدم *(Wildcard) علامة لجميع التذاكر",
            emailsRequired: "يجب ألا يكون إعادة توجيه رسائل البريد الإلكتروني لاغية",
            emailNotificationCreated: "تم إنشاء قاعدة التذاكر",
            emailNotificationCreateError: "حدث خطأ",
            ticketForwarding: "إعادة توجيه البريد الإلكتروني التذاكر",
            ticketTagFilterDesc:
                'يستخدم موضوعات التذاكر التي استخدمتها في تصميم chatbot لتصفية التذاكر. يمكنك كتابة علامة مختلفة واضغط على Enter لإضافتها. إذا قمت بتحديد علامة "*" ، فسيتم تحديد جميع التذاكر',
            ticketEmailsDesc:
                "قائمة البريد الإلكتروني التي سيتم إعادة توجيه التذاكر إليها. يمكنك إضافة عناوين الممثلين في النظام عن طريق اختيارها. يمكنك أيضًا إضافة بريد إلكتروني غير نظام/ق.",
            ticketList: "قواعد إعادة توجيه التذاكر",
            ticketTagFilterPlaceHolder: 'مرشح التذاكر ، حدد "*" للجميع',
            ticketEmailsPlaceHolder: "إعادة توجيه قائمة البريد الإلكتروني",
        },
        theme: {
            opacity: "الغضب",
            headerColor1: "لون قسم هادر 1",
            headerColor1A: "قسم هادر عتامة 1",
            headerColor2: "رأس قسم الرأس 2",
            headerColor2A: "رأس قسم العتامة 2",
            backgroundColor: "لون الخلفية 1",
            backgroundColorA: "عتامة الخلفية 1",
            backgroundColor2: "لون الخلفية 2",
            backgroundColor2A: "عتامة الخلفية 2",
            textColor: "لون الخط",
            errorTheme: "لون الخطأ",
            bubbleBackground: "تمثيلي لون الفقاعة",
            bubbleVisitorBackground: "لون فقاعة العملاء",
            bubbleBackgroundA: "تمثيلية الفقاعة العتامة",
            bubbleVisitorBackgroundA: "عتامة فقاعة العملاء",
            bubbleText: "لون النص التمثيلي",
            bubbleVisitorText: "لون نص العميل",
            textFormColor: "شكل اللون",
            selectCustom: "حدد موضوع مخصص",
            headerColorSecond: "رأس اللون العلوي",
            headerColorFirst: "لون أسفل العنوان",
            backgroundColorFirst: "لون الخلفية العلوي",
            formColor: "لون نص النموذج",
            buttonColor: "لون الزر",
            backgroundColorSecond: "لون الخلفية السفلي",
            chatBotButtonText: "لون زر Chatbot",
            chatBotButtonColor: "لون زر Chatbot",
        },
        billing: {
            paymentStatus: "حالة الدفع",
            amount: "المبلغ",
            invoiceID: "معرف الفاتورة",
            expected: "متوقع...",
            currentAmount: "المبلغ الحالي",
            monthlyEstimatedAmount: "المبلغ التقديري الشهري",
            creationDate: "تاريخ الإنشاء",
            invoiceStatus: "حالة الفاتورة",
            invoicePeriod: "فترة الفاتورة",
            newPaymentMethod: "طريقة دفع جديدة",
            channelCount: "عدد القنوات",
            remainingTime: "الوقت المتبقي",
            chatbotLimit: "حد الدردشة الآلية",
            free: "مجاني",
            maxChatbotSession: "الحد الأقصى لجلسات الدردشة الآلية",
            buyIt: "اشترِ",
            renewalDate: "تاريخ التجديد",
            monthly: "شهرياً",
            yearly: "سنوياً",
            packagePeriod: "فترة الحزمة",
            packageType: "نوع الحزمة",
            packageManagement: "إدارة الحزم",
            invoiceManagement: "إدارة الفواتير",
            futureInvoice: "الفاتورة المستقبلية",
            pastInvoices: "الفواتير السابقة",
            creditCard: "بطاقة الائتمان",
            invoice: "فاتورة",
            mustBeUpgradePlanForChatBot: "لتفعيل ميزة chatbot ، يجب عليك التبديل إلى خطة Pro!",
            cardInfo: "معلومات البطاقة",
            billingDetails: "تفاصيل الفاتورة",
            addCardIyzico:
                "ليس لديك بطاقة مسجلة. من أجل دفع رسوم الاستخدام الشهرية ، تحتاج إلى إضافة بطاقة. يتم توفير نظام الدفع بواسطة Iyzico.",
            billingPlanSettings: "فاتورة الفواتير",
            startWith: "{cardFamily} تبدأ بطاقة {binNumber}",
            paymentMethod: "طريقة الدفع او السداد",
            billingDate: "تاريخ الفواتير",
            isPaid: "مدفوع؟",
            paid: "مدفوع",
            markPaid: "مارك كما دفعت",
            paymentDate: "تاريخ الدفع",
            pay: "يدفع",
            newInvoice: "إنشاء فاتورة",
            updateBilling: "تحديث تفاصيل الفواتير",
            updateCard: "تغيير بطاقة الائتمان",
            paymentBilling: "طريقة الدفع وتفاصيل الفواتير",
            price: "سعر",
            billingAddress: "عنوان وصول الفواتير",
            billingCity: "مدينة",
            billingCountry: "دولة",
            contactName: "اسم الاتصال الفواتير",
            expireMonth: "تنتهي صلاحية الشهر",
            expireYear: "تنتهي صلاحيتها",
            cardNumber: "رقم البطاقة",
            cardHolderName: "إسم صاحب البطاقة",
            cardAlias: "اسم الاسم المستعار",
            identityNumber: "رقم الهوية",
            name: "اسم",
            surname: "اسم العائلة",
            email: "بريد إلكتروني",
            addCard: "إضافة بطاقة",
            update: "تحديث",
            cancel: "يلغي",
            save: "يحفظ",
            saving: "إنقاذ",
            noInvoiceFound: "لا توجد فاتورة",
            year: "سنة",
            updating: "تحديث ...",
            newInvoiceForm: "فاتورة جديدة إنشاء نموذج",
            error: "خطأ",
            transactions: "خيارات",
            paymentMethodAdded: "تمت إضافة طريقة الدفع بنجاح",
            paymentMethodAddError: "لم يتم إضافة طريقة الدفع ، حدث خطأ",
            creditCardChanged: "لقد تغيرت بطاقة الائتمان بنجاح",
            errorOccurred: "حدث خطأ ، حاول مرة أخرى",
            billingDetailUpdated: "تم تحديث تفاصيل الفواتير بنجاح",
            invoiceCreated: "تم إنشاء الفاتورة بنجاح",
            paymentSuccess: "الدفع بنجاح ، شكرا لك",
            paymentFail: "فشل الدفع ، حاول مرة أخرى",
            billingAddressChanged: "لقد تغير عنوان الفواتير بنجاح",
            hidePlan: "إخفاء الخطة",
            informationShopping:
                "يتم التحكم في معلومات الدفع الخاصة بك ومعلومات الفواتير ومعلومات بطاقة الائتمان بواسطة Shopify.",
            trialTimeInformation:
                "تنتهي المحاكمة {dayCount} بعد أيام. إذا لم تقم بإدخال طريقة الدفع حتى انتهاء هذه الفترة ، فسيتم تبديلك تلقائيًا إلى الخطة المجانية من قبل النظام.",
            trialTimeInformationShort: "التجربة: يوم آخر {dayCount}",
            currentPlanLabel: "الخطة الحالية: {planName} ({agentCount} Agent)",
            changeCancelPlan: "خطة تغيير/إلغاء",
            oneAgent: "عامل",
            agent: "عامل",
            yourCurrentPlan: "الخطة الحالية",
            month: "شهر",
            billedMonthToMonth: "(فواتير من شهر إلى شهر)",
            selectAgentCount: "حدد عدد الوكيل",
            selectFreePlan: "حدد خطة مجانية",
            planDetails: "تخطيط التفاصيل",
            multiAgent: "(وكيل متعدد)",
            selectProPlan: "حدد خطة Pro",
            foreverFree: "مجاني للابد",
            websiteIntegration: "تكامل الموقع",
            websiteIntegrationUnlimited: "تكامل الموقع",
            ChatBotUnlimited: "chatbot",
            videoCallUnlimited: "مكالمة فيديو",
            multiAgentUpTo: "وكيل متعدد (تصل إلى {agentCount} Agent)",
            audioCallUnlimited: "مكالمة صوتية",
            screenSharingUnlimited: "مشاركة الشاشة",
            fileTransferUnlimited: "نقل الملف",
            autoChatAssignerUnlimited: "محال الدردشة التلقائي",
            multiLanguageTranslationUnlimited: "ترجمة السيارات",
            detailedReporting: "الإبلاغ",
            days30TrialsAvailable: "30 يوم تجارب متاحة",
            limitedArchiveLookupLastMo: "البحث المحدود أرشيف (آخر {monthCount} -mo)",
            fullCustomizationUnlimited: "التخصيص",
            planUpdated: "رائع ، تم تحديث خطتك.",
            planUpdating: "خطتك يتم تحديث ...",
            planUpdatingDescription: "يرجى الانتظار أثناء تحديث خطتك",
            done: "منتهي",
            freePlanUpdated: "تم تحديث خطتك كخطة مجانية. (Max Agent Credit: 1)",
            proPlanUpdated: "تم تحديث خطتك كخطة محترفة. (Max Agent Credit: {AgentCount})",
            canNotDwnGrade:
                "لا يمكن تخفيض خطتك من Pro {agentCountSecond} Agent (s) إلى {valNewPlnToUppr} {agentCountFirst}. ائتمانات وكيلك قيد الاستخدام.",
            deleteWarning: "يجب عليك حذف أو تعطيل {valDif} الوكيل (s)",
            warnMessage: "يجب أن تكون الخطة المحددة مختلفة عن الخطة الحالية",
            add: "يضيف",
            cancelYourPlan: "إلغاء خطتك",
            upgradeYourPlan: "ترقية خطتك",
            downgradeYourPlan: "خفض خطتك",
            agree: "يوافق",
            disagree: "تعارض",
            invoices: "فواتير",
            priceIntervals: "الفاصل الزمني للسعر",
            selectSiteAlias: "حدد أو أدخل اسم الموقع",
            selectPriceInterval: "حدد أو أدخل الفاصل الزمني للسعر",
            isRefunded: "هل يتم استرداده؟",
            invoiceId: "رقم الفاتورة",
            siteId: "الموقع لا",
            createdDate: "تاريخ الإنشاء",
            failCount: "عدد محاولات جلب الدفع الفاشلة",
            failDate: "تاريخ الدفع الفاشل",
            Dashboard: "لوحة القيادة",
            Agents: "عملاء",
            Integration: "اندماج",
            Settings: "إعدادات",
            Contacts: "جهات الاتصال",
            Domain: "اِختِصاص",
            lastActivity: "النشاط الاخير",
            basePrice: "السعر الأساسي",
            packagePrice: "سعر الطرد",
            whatsappPrice: "سعر whatsapp",
            realtimeVisitorCount: "زائر الوقت الحقيقي",
            suspend: "تعليق",
            partner: "شريك",
            plan: "يخطط",
            trialDay: "أيام المحاكمة",
            mobile: "متحرك",
            webSite: "موقع إلكتروني",
            websiteOrigins: "أصل موقع الويب",
            ownerName: "اسم المالك",
            ownerEmailAddress: "البريد الإلكتروني للمالك",
            discount: "تخفيض",
            daysLeft: "ايام متبقية",
            newTrialPopUp: "كم يوما يجب أن تكون الفترة التجريبية الجديدة؟",
            newWpPricePopUp: "كم هي رسوم WhatsApp الجديدة؟",
            newIGPricePopUp: "كم هي رسوم Instagram الجديدة؟",
            newBasePricePopUp: "كم هو سعر الأساس الجديد؟",
            siteInfoUpdated: "معلومات الموقع المحدثة",
            siteInfoNotUpdated: "معلومات الموقع لم يتم تحديثها",
            siteInfoNotUpdatedErr: "حدث خطأ! معلومات الموقع لم يتم تحديثها.",
        },
        tour: {
            closeChat: "وثيق الدردشة",
            ticket: "تذكرة",
            formStep: "خطوة الشكل",
            menuStep: "خطوة القائمة",
            contentStep: "خطوة المحتوى",
            menuTitle: "عنوان القائمة",
            messageContent: "محتوى الرسالة",
            goToLive: "Connect stistative",
            stats: "لوحة الإحصاء",
            settings: "إعدادات",
            status: "حالة",
            prevStep: "خطوة سابقة",
            nextStep: "الخطوة التالية",
            finish: "ينهي",
            skip: "يتخطى",
            skip2: "تخطي ، أعرف النظام",
            startTour: "بدء جولة",
            firstTimeIntro: "أنت تدخل النظام لأول مرة ، أريد تقديم التطبيق إذا سمحت",
            hi: "أهلاً",
            welcomeTo: "مرحبًا بك في دعم Supsis Live",
            statsPanel: "إنه شريط الحالة الذي يوضح أرقام الدردشة الكلية والنشطة التي تنتظر على الفور مع النظام ..",
            sidebarMenu: "قائمة طعام",
            sidebarMenuContent: "يمكنك التبديل بين الصفحات هنا.",
            representativePrivateMessage: "لوحة محادثة بين التمثيل",
            representativePrivateMessageContent: "يمكنك رؤية المحادثات الخاصة بين الوكلاء هنا.",
            helpMenu: "قائمة المساعدة",
            helpMenuContent: "يمكنك العثور على معلومات مساعدة حول النظام هنا ..",
            settingsMenu: "قائمة الإعدادات",
            settingsMenuContent: "يمكنك القيام باللغة والوضع الليلي وخطوات تكبير الشاشة هنا ..",
            startChat: "ابدأ الدردشة",
            profileMenu: "قائمة ملف التعريف",
            profileMenuContent: "يمكنك تغيير توافرك وتعيين إعدادات الوكيل هنا ..",
            visitorsTab: "الزائرين",
            visitorsTabContent: "يمكنك رؤية الزوار هنا.",
            visitorTabHistory: "تاريخ الزوار",
            visitorTabHistoryContent: "يمكنك رؤية تاريخ الزائر هنا.",
            representativeTab: "مندوب",
            representativeTabContent: "يمكنك رؤية الممثلين هنا.",
            liveSupport: "الدعم المباشر",
            liveSupportContent: "يمكنك رؤية عدد العملاء الذين يتلقون الدعم المباشر هنا ..",
            siteVisitors: "زوار الموقع",
            siteVisitorsContent: "يمكنك رؤية عدد زوار الموقع هنا.",
            tableSettings: "إعدادات الجدول",
            tableSettingsContent: "يمكنك إظهار أو إخفاء الأعمدة في الجدول هنا.",
            watchModeButton: "زر العارض",
            watchModeContent: "يمكنك الانضمام هنا كوضع للعارض ويمكنك فقط عرض ما يتم نشره.",
            popoverInfo: "تفاصيل الزائر",
            popoverInfoContent: "يعطي معلومات حول الزائر.",
            popoverButton: "إعدادات الدردشة المتقدمة",
            popoverButtonContent: "يمكنك فتح المحادثة ، وإرسال رسالة مباشرة إلى الممثل أو حظر الزائر.",
            openChat: "انضم إلى زر المحادثة",
            openChatContent: "يمكنك فتح المحادثة هنا",
            pagination: "قائمة الترحيل.",
            paginationContent: "يمكنك زيادة عدد الصفحات هنا.",
            changeLang: "يمكن تغيير لغة النظام",
            changeTheme: "يمكن تبديل المظلمة والخفيفة",
            changeStatus: "يمكن أن تغير حالة توافرك",
            logout: "يمكن نظام تسجيل الدخول من هنا",
            chatwindow: {
                chatWindowActionButtons: "أزرار عمل نافذة الدردشة",
                chatPanelActions: "إجراءات لوحة الدردشة",
                otherPanels: "لوحات أخرى",
                chatColorButton: "إظهار معنى ألوان شريط الدردشة",
                keyboardShortcutButton: "إظهار وظائف اختصارات KeyBpard",
                hideButton: "قلل من الدردشة الحالية دون خروج",
                closeButton: "إغلاق القوة والخروج من الدردشة الحالية",
                ellipsisButton: "المزيد من إجراءات الدردشة. تقليل ، إغلاق ، حظر الزائر ، إرسال رسالة خاصة ، تعيين ممثل",
                userInfoWidget: "إظهار تفاصيل زائر المالك لمستخدم الدردشة الحالي",
                preparedContentWidget:
                    "عنصر واجهة مستخدمة رسائل معدّة ، يمكنك تحديد إدخال قالب رسالة إلى الدردشة الحالية",
                chatHistoryWidget: "إذا كان هناك بعض تاريخ الدردشة للزوار الحالي ، فبإمكانه مشاهدتها",
                chatWindowSettingsButtons: "زر إعدادات نافذة الحديث",
                settingsButton: "يمكنك حظر المحادثة ، والتقدم ، والرسالة السرية وتعيين المندوبين.",
                chatBarButton: "هنا يمكنك منع محادثة نشطة ، وإرسال رسالة خاصة إلى الوكيل وترك المحادثة ..",
            },
        },
        adminUser: {
            newAdminUserForm: "نموذج تسجيل مستخدم المسؤول الجديد",
            updateAdminUserForm: "نموذج تحديث مستخدم المسؤول",
            adminUsers: "مستخدمي المسؤول",
            newAdminUser: "مستخدم مسؤول جديد",
            noAdminUser: "لا يوجد مستخدمين للمسؤول حتى الآن",
            adminUserName: "اسم مستخدم المسؤول",
        },
        report: {
            hourly: "(ساعيا)",
            hourlyAverage: "متوسط ساعي",
            hourlyMax: "الحد الأقصى الساعي",
            hourlyMin: "الحد الأدنى الساعي",
            totalAmount: "المبلغ الإجمالي",
            averageAmount: "المبلغ المتوسط",
            minAmount: "المبلغ الأدنى",
            maxAmount: "المبلغ الأقصى",
            siteCount: "site Count",
            agentCount: "Agent Count",
            channelsTimeSeries: "سلاسل زمنية للقنوات",
            channelPies: "فطائر القنوات",
            pieView: "رسم بياني دائري",
            topVisitorCountry: "البلد الذي يأتي منه أكبر عدد من الزوار",
            websiteTrafficByCountry: "حركة مرور الموقع حسب البلد",
            visitorCount: "عدد الزوار",
            websiteVisitorTraffic: "حركة زوار الموقع",
            websiteTraffic: "حركة مرور الموقع",
            author: "المؤلف",
            topWorstComments: "أسوأ التعليقات",
            topBestComments: "أفضل التعليقات",
            topComments: "أفضل التعليقات",
            noComment: "لا توجد تعليقات بعد",
            minWaitingTime: "أقل وقت انتظار",
            maxWaitingTime: "أقصى وقت انتظار",
            averageWaitTime: "متوسط ​​وقت الانتظار",
            waitTime: "وقت الانتظار (ثواني)",
            agentWaitDurationTitle: "رسم بياني لمدة انتظار الوكيل",
            incomingMessage: "رسالة (رسائل) واردة",
            outgoingMessage: "رسالة (رسائل) صادرة",
            totalSpent: "إجمالي الإنفاق",
            avgSpent: "متوسط الإنفاق",
            totalPayment: "إجمالي الدفع",
            walletStatus: "حالة المحفظة",
            walletBalanceStatus: "حالة رصيد المحفظة",
            messageTraffic: "حركة الرسائل",
            breakCount: "عدد الفترات",
            agentBreakTime: "عدد فترات استراحة الوكلاء ☕",
            agentStatusHour: "ساعة حالة الوكيل",
            agentWorkTimeCalendar: "تقويم وقت عمل الوكيل",
            agentActivity: "نشاط الوكيل",
            noEnoughtData: "لا توجد بيانات كافية",
            averageFirstResponse: "متوسط ​​زمن الاستجابة الأولى",
            slowestResponser: "الأبطأ في الرد",
            fastestResponder: "الأسرع في الرد",
            firstAnswerTimeSec: "وقت الرسالة الأولى (بالثواني)",
            firstAnswerByAgent: "وقت الرسالة الأولى بواسطة الوكيل",
            averageSolutionTime: "متوسط ​​وقت الحل",
            slowestSolver: "أبطأ محلل",
            fastestSolver: "أسرع محلل",
            averageChat: "متوسط الدردشة",
            leastChatReceiver: "أقل مستقبل للدردشة",
            mostChatRecipients: "أكبر عدد من المستقبلين للدردشة",
            averageTicket: "Average Ticket",
            leastTicketReceiver: "Least Ticket Least",
            mostTicketRecipients: "Most Ticket Recipients",
            resolveTime: "وقت الحل (دق)",
            resolveTimeByUser: "وقت حل الدردشة من قبل المستخدم (بالدقائق)",
            chatResolveTimeByAgent: "وقت حل الدردشة من قبل الوكلاء",
            chatDistByHandleType: "توزيع الدردشات حسب المعالج",
            chatDistByHandDesc: "كم عدد الدردشات التي تم التعامل معها من قبل الوكلاء والروبوتات الدردشة والهجينة؟",
            chatCountsByHandleType: "عدد الدردشات حسب نوع المعالجة",
            missed: "تم التفويت",
            answered: "تم الرد",
            chatDistByAnsDesc: "كم عدد المحادثات التي تم الرد عليها أو تم تفويتها؟",
            chatCountsByAns: "عدد الدردشات حسب الإجابة",
            chatCountByPlatform: "عدد الدردشات حسب المنصة",
            chatDistByPDesc: "كم دردشة وصلت إلى أي منصة؟",
            chatDistByPlatform: "توزيع الدردشة حسب المنصة",
            ticketCountByUser: "Ticket Counts by Agents",
            ticketCountByStatus: "Ticket Counts by Response Status",
            user: "مستخدم",
            saveAsImage: "حفظ كصورة",
            fullScreen: "ملء الشاشة",
            download: "تحميل",
            tableView: "عرض الجدول",
            chartView: "عرض الرسم البياني",
            chatDistByUsers: "توزيع المحادثات حسب المستخدمين",
            chatCountsByUsers: "عدد المحادثات حسب المستخدمين",
            minDuration: "الحد الأدنى من المدة",
            maxDuration: "الحد الأقصى للمدة",
            totalDurationByAgent: "إجمالي مدة الجلسة حسب الوكيل",
            averageDurationByAgent: "المدة المتوسطة للجلسة حسب الوكيل",
            totalDurationByCB: "إجمالي مدة الجلسة حسب الدردشة الآلية",
            averageDurationByCB: "المدة المتوسطة للجلسة حسب الدردشة الآلية",
            viewUnitAs: "عرض الوحدة كـ",
            hybrid: "هجين",
            handledBy: "تمت المعالجة بواسطة",
            sessionDurationOverall: "مدة الجلسة الإجمالية",
            allChannels: "جميع القنوات",
            sessionsDurationOverall: "مدة الجلسات الإجمالية",
            sessionsOverall: "جلسات بشكل عام",
            calendarEvents: "أحداث التقويم",
            reservationEvents: "أحداث الحجز",
            incomingMails: "رسائل البريد الواردة",
            incomingMailCount: "عدد رسائل البريد الواردة",
            reservation: "حجز",
            event: "حدث",
            reservationEventCount: "عدد أحداث الحجز",
            channelBreakdown: "توزيع القنوات",
            websiteAnalysis: "تحليل الموقع الإلكتروني",
            customerSatisfaction: "رضا العملاء",
            teamBreakAnalysis: "تحليل فواصل الفريق",
            dailyAgentActivity: "نشاط الوكيل اليومي",
            agentPerformance: "أداء الوكيل",
            chatDistributions: "توزيع المحادثات",
            users: "المستخدمين",
            segmentTimeseries: "سلسلة زمنية للقطاع",
            segmentsOverall: "القطاعات بشكل عام",
            unmatchRatio: "نسبة عدم التطابق",
            totalMatchCount: "إجمالي عدد التطابقات",
            totalUnmatchCount: "إجمالي عدم التطابق",
            matchRatio: "نسبة التطابق",
            matched: "مطابق",
            trainingOverall: "التدريب الشامل",
            trainingStatusTimeseries: "سلسلة زمنية لحالة التدريب",
            duration: "المدة",
            totalSessionDuration: "مدة الجلسة الإجمالية",
            averageSessionDuration: "متوسط مدة الجلسة",
            second: "ثانية",
            minute: "دقيقة",
            hour: "ساعة",
            aggregateAs: "تجميع كـ",
            chatbotSessionDurationOverall: "مدة جلسة الدردشة الآلية بشكل عام",
            ratingTimeSeries: "رسم بياني زمني للتقييمات",
            chatCountTimeseries: "سلسلة زمنية لعدد الدردشات",
            notRated: "غير مقيّم",
            totalRatingCount: "إجمالي عدد التقييمات",
            averageRating: "متوسط التقييم",
            weightedAverageRating: "متوسط التقييم المرجح",
            rate: "تقييم",
            ratingOverall: "Customer Ratings Overall",
            session: "جلسة",
            total: "المجموع",
            average: "متوسط",
            max: "الحد الأقصى",
            min: "الحد الأدنى",
            sessionCount: "عدد الجلسات",
            uniqueUsers: "مستخدمون فريدون",
            viewAs: "عرض كـ",
            overall: "عام",
            detailReport: "تقرير مفصل",
            dailyReports: "التقارير اليومية",
            pointBasedReports: "التقارير القائمة على نقطة",
            personDateBasedPointReport: "تقرير النقطة القائمة على الشخص والتاريخ",
            personDateBasedReport: "التقرير القائم على الشخص والتاريخ",
            personBasedReport: "التقارير القائمة على الشخص",
            personAndDateBasedGraph: "الرسم البياني القائم على الشخص والتاريخ",
            noReport: "لايوجد تقرير",
            reports: "التقارير",
            totalBar: "المجموع",
            ticketCount: "Ticket Count",
        },
        stats: {
            total: "عدد جميع الدردشات المفتوحة",
            active: "عدد الدردشة النشطة المعينة لك",
            waiting: "عدد الزوار في انتظار دخول ممثل",
            late: "عدد الزوار ينتظرون أكثر من فترة معينة",
            free: "عدد الزوار المجانيين الذين ينتظرون للممثل الجديد للدخول",
            pco: "[معدل استخدام السعة] معدل حمل العمل في قدرة الدردشة التمثيلية النشطة",
            maxCapacity: "الحد الأقصى لعدد الدردشة التي يمكن للنظام تعيين ممثلين دون الانتظار",
            chatbot: "عدد الدردشة النشطة مع Chatbot",
        },
        time: {
            lastYear: "العام الماضي",
            thisYear: "هذا العام",
            last3Months: "آخر 3 أشهر",
            last7: "آخر 7 أيام",
            today: "اليوم",
            yesterday: "أمس",
            lastWeek: "الأسبوع الماضي",
            currentWeek: "هذا الاسبوع",
            currentMonth: "هذا الشهر",
            lastMonth: "الشهر الماضي",
            last30Day: "آخر 30 يومًا",
            allTime: "كل الأوقات",
            custom: "موعد مخصص",
        },
        fastWizard: {
            generalColors: "الألوان العامة",
            tellUsMore: "أخبرنا أكثر ، حتى نتمكن من تخصيص تجربتك",
            moreInfo: "مزيد من المعلومات",
            display: "عرض",
            availability: "توافر",
            preview: "معاينة",
            installCode: "تثبيت رمز",
            previous: "سابق",
            setupSupsisLiveChat: "الإعداد Supsis الدردشة المباشرة",
            continue: "الخطوة التالية",
            completeInitialize: "الإعداد الكامل",
            completedMessage: "Supsis Live Chat Setup قد اكتمل بنجاح.",
            websiteIntegration: "عنوان موقع الويب الخاص بك لدمج الدردشة المباشرة Supsis",
            customizeLiveChat: "تخصيص الدردشة المباشرة الخاصة بك",
            createBrandedExperience: "قم بإنشاء تجربة دردشة ذات علامة تجارية لزوارك.",
            chatColor: "لون الدردشة",
            chooseChatColor: "اختر لون لهجة.",
            chatBubble: "فقاعة الدردشة",
            selectBubble: "حدد فقاعة الدردشة",
            chatBubbleColor: "لون فقاعة الدردشة",
            selectChatBubbleColor: "حدد لون فقاعة الدردشة",
            customSelection: "الاختيار المخصص:",
            chatAvailability: "توافر الدردشة",
            onlineSupportVisitorTime: "متى تكون على الإنترنت لدعم زوارك؟",
            channelAvailability: "توافر القناة",
            availability724: "الدردشة متوفرة 7/24",
            basedOnTeam: "بناءً على حالة عضو الفريق",
            basedOnTeamExplanation: "ستظهر الدردشة عبر الإنترنت عندما يتم تعيين عضو واحد على الأقل إلى متاح",
            customHours: "ساعات عمل مخصصة",
            customHoursExplanation: "تكوين ساعات عملك",
            customHoursTimezone: "وحدة زمنية:",
            customHoursFrom: "من:",
            customHoursTo: "ل:",
            customHoursAddHours: "+إضافة ساعات",
            previewDesktop: "سطح المكتب",
            previewIpad: "اى باد",
            installationAndInstructions: "تعليمات التحميل",
            installationTrackingCode: "قم بتثبيت رمز التتبع على موقع الويب الخاص بك",
            installationTrackingCodePlease:
                "يرجى لصق الرمز وفقًا للتعليمات أدناه ، قبل نهاية علامة {bodyTag} في أي صفحة تريد تمكين الدردشة المباشرة Supsis.",
            installationInstructionsJavascript: "الصق رمز التكامل الوارد أعلاه في علامة {bodyTag} قبل الإغلاق مباشرة.",
            installationInstructionsCopy: "ينسخ",
            installationInstructionsCoppyMessage: "تم نسخ البرنامج النصي للتكامل إلى الحافظة",
            installationInstructionsShopify1: "1. تسجيل الدخول إلى لوحة Shopify الخاصة بك",
            installationInstructionsShopify2:
                "2. انتقل إلى المتجر عبر الإنترنت> الموضوعات> القائمة المنسدلة الإجراءات ضمن السمة الحالية> تحرير الرمز> السمة. liquid",
            installationInstructionsShopify3:
                "3. ضع لصق رمز التكامل المذكور أعلاه قبل علامة {bodyTag} مباشرة في نهاية البرنامج النصي.",
            installationInstructionsIdeaSoft1: "1. تسجيل الدخول إلى لوحة الوكيل الخاصة بك.",
            installationInstructionsIdeaSoft2: "2. انتقل إلى الإعدادات -> SEO -> خدمات محرك البحث.",
            installationInstructionsIdeaSoft3: '3. حدد "التحقق من الموقع باستخدام علامة التعريف" من قسم رمز التتبع.',
            installationInstructionsIdeaSoft4: "4. نسخ ولصق رمز التكامل أعلاه في المربع المفتوح وحفظ.",
            installationInstructionsIdeaSoft5:
                '5. داخل الإعدادات -> ، انقر على زر "مسح ذاكرة التخزين المؤقت". وبالتالي اكتمل التكامل.',
            installationInstructionsWordPress1: "1. تسجيل الدخول إلى لوحة مسؤول WordPress الخاص بك",
            installationInstructionsWordPress2: "2. اذهب إلى المظهر> محرر السمة",
            installationInstructionsWordPress3:
                "3. ضمن ملفات السمة (أقصى اليمين) ، ابحث عن تذييل السمة (footer.php) وحدده",
            installationInstructionsWordPress4: "4. قم بتعبير رمز التكامل أعلاه قبل علامة {bodyTag} في الأسفل.",
            installationInstructionsWordPress5: "5. انقر فوق تحديث الملف لحفظ التغييرات",
            installationInstructionsOpenCart1: "1. تسجيل الدخول إلى لوحة مسؤول OpenCart",
            installationInstructionsOpenCart2: "2. انتقل إلى التصميم> محرر السمة",
            installationInstructionsOpenCart3: '3. حدد ملف "مشترك" وفتح "ملف Header.twig".',
            installationInstructionsOpenCart4: "4. قم بتعبئة رمز التكامل أعلاه قبل علامة {headTag} في الأسفل.",
            installationInstructionsOpenCart5: "5. انقر فوق زر حفظ.",
            installationInstructionsTicimax1: "1. تسجيل الدخول إلى لوحة إدارة Ticimax الخاصة بك",
            installationInstructionsTicimax2: "2. تصميم مفتوح> تصميم> إعدادات تصميم تذييل الرأس",
            installationInstructionsTicimax3: '3. انقر فوق الزر "المصدر" في قسم تصميم الشعار.',
            installationInstructionsTicimax4: "4. الصق رمز التكامل أعلاه أسفل رمز HTML.",
            installationInstructionsEticaretteyim1: "1. تسجيل الدخول إلى لوحة إدارة التجارة الإلكترونية الخاصة بك",
            installationInstructionsEticaretteyim2: "2. قم ببساطة بتسمية SUPSIS من الإضافات> إنشاء HTML> وانسخ الكود.",
            installationInstructions: "تعليمات",
            installationVerify: "تحقق من تثبيت موقع الويب الخاص بك من supsis",
            installationVerifyChecking: "تدقيق",
            installationVerifyCheck: "يفحص",
            installationVerifyCheckingStatus: "التحقق من حالة تكامل SUPSIS على {website}",
            installationCheckingStatusMessageYes: "رائع ، تم دمج supsis في موقع {website} !!",
            installationCheckingStatusMessageNo:
                "SUPSIS غير مدمج حاليًا مع موقع الويب {website}. يمكنك إكمال عملية الاندماج الخاصة بك الآن أو في وقت لاحق.",
            vtippyPreferredLanguage: "اللغة المفضلة",
        },
        akinon: {
            typeOrSelectSKU: "اكتب أو حدد SKU",
            akinonUserId: "معرف المستخدم AKINON",
            userEmail: "البريد الالكتروني للمستخدم",
            userEmailDesc: "اكتب أو حدد بريد إلكتروني المستخدم ...",
            send: "يرسل",
            selectCity: "اختر مدينة",
            city: "مدينة",
            selectState: "اختر ولايه",
            state: "ولاية",
            useMap: "استخدم الخريطة",
            chooseAddress: "اختر العنوان",
            selectCountry: "حدد الدولة",
            country: "دولة",
            productIdDesc: "اكتب أو حدد المنتج ...",
            productId: "معرف المنتج",
            userIdDesc: "اكتب معرف المستخدم Akinon ...",
            productSKU: "منتج SKU",
            latitudeDesc: "اكتب أو حدد خط عرض الموقع الهدف ...",
            longitudeDesc: "اكتب أو حدد خط الطول المستهدف ...",
            orderNumber: "رقم طلبك",
            orderDesc: "اكتب رقم الطلب ...",
            longitude: "خط الطول",
            latitude: "خط العرض",
        },
        headBar: {
            email: "بريد إلكتروني",
            phone: "هاتف",
            name: "اسم",
            date: "تاريخ",
            subject: "موضوع",
            situation: "حالة",
            representative: "ممثل",
            transactions: "المعاملات",
        },
        login: {
            loginTitle1: "SUPSIS",
            loginTitle2: "مرحبا بكم في",
            email: "عنوان البريد الإلكتروني الخاص بك",
            emailPlaceholder: "الرجاء إدخال عنوان البريد الإلكتروني الخاص بك.",
            emailError: "الرجاء إدخال بريد إلكتروني صحيح",
            password: "كلمة السر خاصتك",
            passwordLogin: "كلمة مرور مجانية تسجيل الدخول",
            passwordAndLogin: "تسجيل الدخول باستخدام كلمة المرور",
            passwordNew: "إعادة تعيين كلمة المرور الخاصة بي",
            loginAnd: "أو",
            passwordPlaceholder: "من فضلك أدخل رقمك السري.",
            loginMemory: "تذكر هذا الجهاز",
            passwordForget: "لقد نسيت كلمة المرور",
            passwordNewAgain: "كلمة سر جديدة",
            passwordNewAgainTwo: "كرر كلمة المرور الجديدة",
            passwordNewAgainPlaceholder: "الرجاء إدخال كلمة المرور الجديدة الخاصة بك.",
            passwordNewAgainPlaceholderTwo: "الرجاء إعادة إدخال كلمة المرور الجديدة الخاصة بك.",
            login: "تسجيل الدخول",
            loginFooter: "أو قم بتسجيل الدخول باستخدام البريد الإلكتروني",
            emailLogin: "تسجيل الدخول باستخدام البريد الإلكتروني",
        },
        settings: {
            auditlogs: "Audit Logs",
            myaccount: "My Account",
            notifications: "Notifications",
            company: "شركة",
            features: "الميزات",
            general: "جنرال لواء",
            chat: "دردشة",
            timings: "توقيت",
            wallet: "محفظة",
            language: "لغة",
            "bubble-settings": "إعدادات الفقاعة",
            "bubble-actions": "إجراءات الفقاعة",
            "theme-settings": "إعدادات الموضوع",
            visitorLoginForm: "نموذج تسجيل الدخول للزائر",
            visitorAttribute: "معلومات ملف تعريف الزائر",
            timing_settings: "إعدادات التوقيت",
            auto_assign: "Auto Chat Assign",
            availability: "توفر",
            "website-integration": "تكامل الموقع",
            General: "جنرال لواء",
            Chat: "دردشة",
            Timings: "توقيت",
            Integration: "تكامل",
            developer: "مطور",
            visitorNew: "زائر جديد",
            companySubtitles: "إدارة شركتك.",
            featuresSubtitles: "إدارة ميزات شركتك.",
            languageSubtitles: "إدارة لغة شركتك.",
            bubbleSettings: "إعدادات الفقاعة",
            bubbleSettingsSubtitles: "إدارة إعدادات الفقاعة الخاصة بشركتك.",
            bubbleActionsSubtitles: "إدارة إجراءات الفقاعة الخاصة بشركتك.",
            chatThemeSettingsSubtitles: "إدارة إعدادات موضوع الدردشة الخاصة بشركتك.",
            visitorLoginFormSubtitles: "إدارة نموذج تسجيل الدخول للزائر الخاص بشركتك.",
            chatTimingSettingsSubtitles: "إدارة إعدادات توقيت الدردشة الخاصة بشركتك.",
            webSiteIntegrationSubtitles: "إدارة إعدادات تكامل موقع الويب الخاصة بشركتك.",
            apiAccessTitle: "وصول API",
            apiAccessSubtitles: "إدارة وصول API الخاص بشركتك.",
            youTubeActionForm: "أضف قناتك على YouTube",
            linkedinActionForm: "أضف حساب لينكد إن الخاص بك",
            telegramActionForm: "أضف حساب Telegram",
            facebookActionForm: "أضف صفحتك على Facebook",
            tiwitterActionForm: "أضف صفحتك على Twitter",
            instagramActionForm: "أضف صفحتك على Instagram",
            liveSupportDescription: "دعم العملاء على موقع الويب الخاص بك",
            ticketDescription: "إدارة تذاكر العملاء",
            whatsappDescription: "دعم العملاء على WhatsApp",
            phoneDescription: "دعم العملاء على الهاتف",
            emailDescription: "دعم العملاء عبر البريد الإلكتروني",
            facebookDescription: "دعم العملاء على Facebook",
            twitterDescription: "دعم العملاء على Twitter",
            instagramDescription: "دعم العملاء على Instagram",
            youtubeDescription: "دعم العملاء على YouTube",
            linkedinDescription: "اسمح لعملائك بالوصول إليك عبر LinkedIn",
            telegramDescription: "اسمح لعملائك بالوصول إلى الحجم باستخدام Telegram",
            whatsappModalTitle: "نموذج إجراء WhatsApp",
            whatsappModalDescription: "يرجى ملء النموذج أدناه لإضافة رقم WhatsApp الخاص بك.",
            phoneModalTitle: "نموذج إجراء الهاتف",
            phoneModalDescription: "يرجى ملء النموذج أدناه لإضافة رقم هاتفك.",
            emailModalTitle: "نموذج إجراء البريد الإلكتروني",
            emailModalDescription: "يرجى ملء النموذج أدناه لإضافة عنوان بريدك الإلكتروني.",
            facebookModalTitle: "نموذج إجراء Facebook",
            facebookModalDescription: "يرجى ملء النموذج أدناه لإضافة صفحة Facebook الخاصة بك.",
            twitterModalTitle: "نموذج إجراء Twitter",
            twitterModalDescription: "يرجى ملء النموذج أدناه لإضافة صفحة Twitter الخاصة بك.",
            instagramModalTitle: "نموذج إجراء Instagram",
            instagramModalDescription: "يرجى ملء النموذج أدناه لإضافة صفحة Instagram الخاصة بك.",
            youtubeModalTitle: "نموذج إجراء YouTube",
            youtubeModalDescription: "يرجى ملء النموذج أدناه لإضافة قناة YouTube الخاصة بك.",
            linkedinModalTitle: "نموذج معاملة LinkeIn",
            linkedinModalDescription: "يرجى ملء النموذج أدناه لربط حسابك على LinkedIn.",
            telegramModalTitle: "نموذج معاملة Telegram",
            telegramModalDescription:
                "أدخل رابط ملف تعريف Telegram الخاص بك في النموذج أدناه لربط حساب Telegram الخاص بك",
            instagramAlertTitle: "التكامل مع Instagram مطلوب",
            instagramAlertDesc: "عذرًا، سيتم تنشيط الصفحة التي زرتها عند تكامل Instagram الخاص بك.",
            instagramActivateText: "لنذهب، دمج Instagram",
            remove: "إزالة",
            edit: "تصحيح",
            connected: "متصل",
            add: "أضف",
            themeDescription: "إدارة موضوع شركتك.",
            fontDescription: "إدارة الخط الخاص بشركتك.",
            isFabsAsIcon: "إظهار نصوص رمز القائمة.",
            chatBubbleTextSetting: "إعداد نص فقاعة الدردشة",
            textOnChatBubble: "يمكنك ضبط إعدادات النص التي ستظهر في فقاعة الدردشة.",
            textToAppearOnChatBubble: "نص للظهور في فقاعة الدردشة",
            newVisitorProfileInformation: "معلومات ملف تعريف الزائر الجديد",
            newVisitorProfileInformationDescription: "يضيف قيمة جديدة لمعلومات ملف تعريف الزائر",
            create: "يخلق",
            newAdd: "اضف جديد",
            toInform: "لكي يعلم",
            toInformDescription: "يمكنك مطابقة القيم التي تضيفها في هذه الصفحة مع نموذج تسجيل دخول الزائر..",
            showVisitor: "إظهار الزائر",
            label: "تذكرة",
            text: "كتابة",
            email: "بريد إلكتروني",
            phone: "هاتف",
            number: "رقم",
            url: "URL",
            date: "وقت",
            dropdown: "اختيار",
            languageTimeZone: "اللغة والمنطقة",
            timeZoneTitle: "المنطقة والمنطقة الزمنية",
            timeZoneDescription: "إعدادات المنطقة الزمنية والمنطقة الزمنية",
        },
        userInfoWidget: {
            userInformation: "معلومات المستخدم",
            fullName: "الاسم الكنية",
            newValue: "قيمة جديدة",
            newProfileInfo: "معلومات الملف الشخصي الجديدة",
            affiliatedRepresentatives: "مندوب",
            preferredAgents: "الوكيل (الوكلاء) المفضل",
            labels: "تسميات",
            agentNotes: "ملاحظات الوكيل",
            newNote: "ملاحظة جديدة",
            note: "ملحوظة",
            available: "هناك ملاحظات متوفرة.",
            systemInformation: "معلومات النظام",
            speechID: "معرف الكلام",
            customerVersion: "معرف الكلام",
            IPAddress: "عنوان IP",
            pageVisited: "تمت زيارة الصفحة",
            systemAndBrowser: "نظام التشغيل والمتصفح",
            countryAndLanguage: "البلد واللغة",
            clickToEdit: "تحرير انقر داخل المنشور",
            adsYouAreInterestedIn: "الإعلانات التي تهتم بها",
            detail: "التفاصيل",
            adsTitle: "العنوان",
            adUrl: "رابط الإعلان",
            sourceID: "معرّف المصدر",
            resourceType: "نوع المصدر",
            adsBody: "المحتوى",
            adsCreateDate: "تاريخ الإنشاء",
            adsUpdateDate: "تاريخ التحديث",
        },
        newWizartV2: {
            generalSettings: "الاعدادات العامة",
            themeSettings: "إعدادات الموضوع",
            representativeWorkingHours: "ساعات عمل الممثل",
            preview: "معاينة",
            setup: "يثبت",
            formStepTitle: "قدم لنا المزيد من المعلومات حتى نتمكن من تخصيص تجربتك",
            supsisEntergation: "أين ستستخدم Supsis على موقع الويب الخاص بك؟",
            goToNextStep: "خذ الخطوة التالية",
            readytemplate: "استخدم قالب ألوان جاهز",
            customSettings: "إعدادات مخصصة",
            customerMessageView: "عرض رسالة العميل",
            backcgroundColor: "لون الخلفية",
            textColor: "لون الخط",
            agentMessageView: "عرض رسالة الوكيل",
            workingHours: "ما الفترات الزمنية التي تقدم فيها الخدمات للزائرين؟",
            continuousService: "الخدمة المستمرة",
            continuousServiceDescription: "فقاعة الدردشة نشطة دائمًا. حتى لو لم تكن في النظام.",
            vote: "قم باختيارك",
            representativeWorking: "ساعات عمل الممثل",
            representativeWorkingDescription:
                "تظهر الدردشة على الإنترنت عندما يكون هناك وكيل واحد على الأقل متصلاً بالإنترنت. إذا لم يكن هناك ممثل عبر الإنترنت ، فسيظهر على أنه غير متصل.",
            computer: "حاسوب",
            tablet: "لوح",
            uploadTrackingCodeToYourWebsite: "تحميل رمز التتبع على موقع الويب الخاص بك",
            password: "تعيين كلمة مرور جديدة",
        },
        whatsappChannel: {
            whatsappTitleV1: "قنوات Whatsapp V1 (QR)",
            whatsappTitleV2: "قنوات Whatsapp V2 (QR)",
            channelName: "اسم القناة",
            phoneNumber: "رقم الهاتف",
            forwardToChatbot: "إعادة توجيه إلى الروبوت الدردشة",
            forwardingChatbotOrLiveAgent: "إعادة توجيه (روبوت الدردشة أو وكيل مباشر)",
            addChannel: "إضافة قناة",
            newWhatsappChannel: "قناة جديدة على واتساب",
            newWhatsappChannelDescription: "أنشئ قناة واتساب جديدة عن طريق مسح رمز الاستجابة السريعة (QR)",
            editWhatsappChannel: "تحرير قناة واتساب",
            editWhatsappChannelDescription: "تحرير قناة واتساب",
            whatsappChannel: "قناة واتساب",
            deleteWhatsappChannelDescription: "هل أنت متأكد أنك تريد حذف هذه القناة؟",
            whatsappIntegration: "تكامل واتساب",
            deleteChannel: "حذف القناة",
            restartChannel: "إعادة تشغيل القناة",
            wantRestartChannel: "هل ترغب في إعادة تشغيل القناة؟",
            deleteSMSChannelDescription: "هل أنت متأكد أنك تريد حذف قناة الرسائل القصيرة؟",
            smsChannel: "قناة الرسائل القصيرة",
            maxChannelCount: "لا يمكنك إنشاء أكثر من قناة رسائل نصية واحدة!",
            smsModalText:
                "إن تكاملنا مع حلول الاتصالات الحديثة يمنحك الفرصة لإرسال الرسائل القصيرة بسهولة وفعالية. قم بإزالة الحدود في التواصل، وتواصل مباشرة مع عملائك!",
            smsModalBtn: "انقر لفتح قناة الرسائل القصيرة...",
            postaCellDetail: "تفاصيل قناة PostaCell",
        },
        noPermission: "ليس لديك إذن لأداء هذه العملية.",
        mail_integration_detail: {
            title: "تفاصيل البريد",
            integration: "التكامل",
            sender: "بريد المرسل",
            signature: "توقيع",
            inbox: "صندوق الوارد",
            medias: "وسائط",
            visibility: "الرؤية",
            settings_group: "الإعدادات",
            contacts: "جهات الاتصال",
        },
        whatsapp_business_api: {
            title: "قنوات واتساب Business API",
            integration: "التكامل",
            detail: "تفاصيل",
            visibility: "رؤية",
            templates: "جميع رسائل القوالب",
            settings_group: "إعدادات",
            template_message_group: "رسائل القوالب",
            chat_initiator_template: "قالب بدء الدردشة",
            contacts: "جهات الاتصال",
            numbers: "الأرقام",
            all_contacts: "كل الاتصالات",
            new_template: "إنشاء قالب جديد",
            broadcast_group: "بث",
            broadcast_requests: "طلبات البث",
            customer_groups: "مجموعات العملاء",
            businessChannelDetail: "تفاصيل قناة واتساب الأعمال",
            wallet: "Wallet",
            postacellMessage: "إرسال رسالة نصية",
            postacellAllMessage: "إرسال رسائل نصية جماعية",
            message_group: "رسالة",
            createNewTemplate: "إنشاء رسالة قالب جديدة",
            templateName: "اسم القالب",
            templateNameDesc: "قدم اسمًا لقالب الرسالة الخاص بك.",
            viewTemplates: "عرض القوالب",
            templateNameRules: "اسم القالب يمكن أن يحتوي فقط على حروف صغيرة وأرقام وشرطات سفلية.",
            category: "الفئة",
            categoryDesc: "حدد نوع القالب الذي تريد إنشاءه",
            categoryUtility: "الأداة",
            categoryUtilityDesc: "أرسل معلومات مفيدة مثل تحديثات الحساب، تحديثات الطلبات، التنبيهات وأكثر.",
            categoryMarketing: "تسويق",
            categoryMarketingDesc: "أرسل عروض ترويجية، عروض منتجات، وأكثر لزيادة الوعي والمشاركة.",
            categoryAuth: "المصادقة",
            categoryAuthDesc: "أرسل رموزًا لعملائك للوصول إلى حساباتهم.",
            optional: "اختياري",
            languageDesc: "حدد اللغة التي سيتم إرسال رسالتك النموذجية بها",
            header: "عنوان",
            headerRules: "أضف عنوانًا يتكون من 60 حرفًا إلى رسالتك. يتم دعم متغير واحد فقط في العنوان.",
            headerOptionMedia: "وسائط",
            headerOptionText: "نص",
            none: "لا شيء",
            headerType: "نوع العنوان",
            headerText: "نص العنوان",
            body: "الجسم",
            bodyRules: "أدخل النص باللغة التي اخترتها لرسالتك",
            addVariable: "إضافة متغير",
            variables: "المتغيرات",
            variable: "متغير",
            defaultVariableName: "اسم المتغير الافتراضي",
            defaultVariableToolTip:
                "تظهر متغيراتك في القالب بهذا الاسم. <br><br> بالإضافة إلى ذلك ، يتم إرسال هذا القيمة كقيمة افتراضية في حالة وجود حالات أخرى.",
            selectATemplate: "اختر قالب الرسالة",
            variableSettings: "إعدادات المتغيرات",
            example: "مثال",
            footer: "تذييل",
            footerDesc: "أضف تذييلًا بطول 60 حرفًا إلى رسالتك. لا يتم دعم المتغيرات في التذييل.",
            buttons: "أزرار",
            buttonType: "نوع الزر",
            buttonTypeReply: "الرد",
            submit: "حفظ",
            submitting: "جاري الإرسال",
            addButton: "إضافة زر",
            rejectWhatsapp: "تم رفضها من قبل واتساب.",
            approvedWhatsapp: "تمت الموافقة عليها من قبل واتساب.",
            pendingWhatsapp: "قيد الانتظار للموافقة",
        },
    },
    it: {
        chatWindow: {
            thereIsNoChatContent: "Nessun contenuto della chat disponibile.",
            thereIsNoChatContentDsc: "Qui puoi visualizzare il contenuto della chat e inviare messaggi.",
            interactions: "Interazioni:",
            departments: "Dipartimenti",
            channels: "Canali",
            date: "Data",
            lastChatStatus: "Ultimo stato della chat",
            all: "Tutti",
            queued: "In coda",
            open: "Aperto",
            closed: "Chiuso",
            private: "Privato",
            chatbot: "Chatbot",
            lostMissed: "Perso / Mancato",
            interaction: "Interazione",
            myActiveInbox: "La mia posta in arrivo attiva",
            activeQueueInbox: "Posta in arrivo attiva + in coda",
            chatbotActiveInbox: "Posta in arrivo attiva del chatbot",
            myDepartmentsActiveInbox: "Posta in arrivo attiva dei miei dipartimenti",
            notInteractedYesterday: "Nessuna interazione ieri",
            queueInbox: "Posta in arrivo in coda",
            whatsappActiveInbox: "Posta in arrivo attiva di WhatsApp",
            socialMediaActiveInbox: "Posta in arrivo attiva dei social media",
            missedThisMonth: "Chat perse questo mese",
            chooseAFileOrDragItHere: "Scegli un file o trascinalo qui!",
            watching: "Osservando",
            selectFilter: "Seleziona filtro",
            clearAll: "Cancella tutto",
            me: "Io",
            today: "Oggi",
            yesterday: "Ieri",
            thisWeek: "Questa settimana",
            lastWeek: "La scorsa settimana",
            last7Days: "Ultimi 7 giorni",
            last30Days: "Ultimi 30 giorni",
            thisMonth: "Questo mese",
            lastMonth: "Il mese scorso",
            last24h: "Ultime 24 ore",
            custom: "Personalizzato",
            startMessage: "Avvia messaggio",
            goToAgentReport: "Vai al rapporto dell'agente",
            agentDetail: "Dettagli agente",
            agentList: "Elenco agenti",
            selectedFilter: "Filtro selezionato",
            groupBy: "Raggruppa",
            none: "Nessun gruppo",
            agent: "Rappresentante",
            department: "Dipartimento",
            sortBy: "Ordina",
            lastPostAbove: "Ultimo post in alto",
            newChatsAbove: "Nuove chat in alto",
            oldChatsAbove: "Vecchie chat in alto",
            live: "Vivere",
            systemStatus: "Stato del sistema",
            refresh: "Aggiorna",
            close: "Chiudi",
            totalCustomers: "Totale clienti",
            totalAnswered: "Totale risposte",
            waitingAnswer: "In attesa di risposta",
            totalAgentInChat: "Numero totale di agenti in chat",
            onlineAgentCount: "Numero di agenti online",
            totalCustomer: "Totale cliente",
            answered: "Risposto",
            unanswered: "Senza risposta",
            noContactWasFoundMatchingTheCurrentFilters:
                "Nessun contatto corrispondente ai filtri attuali è stato trovato.",
            you: "Tu",
            others: "Altri",
            queue: "Coda",
            chatbotContact: "Chatbot",
            closedContact: "Chiuso",
            myInteractions: "Le mie interazioni",
            special: "Speciale",
            allInteractions: "Tutti i contatti",
            waiting: "In attesa",
            departmentToWhichItIsAffiliated: "Dipartimento a cui è affiliato",
        },
        plans: {
            manageWithChatbot: "Manage with Chatbot",
            manageInbox: "Manage Inbox",
            commentManage: "Manage Comments",
            privateReplyMessage: "Private Reply Comments",
            mentionTicket: "Convert Mentions to Tickets",
            week: "Settimana",
            readyContents: "Contenuti pronti",
            webhookIntegration: "Integrazione webhook",
            businessChannel: "Canale Business di WhatsApp",
            confirmationFeature: "Funzione di conferma",
            specialReporting: "Reporting speciale",
            aiAssistant: "Assistente IA",
            flexibleBilling: "Fatturazione flessibile",
            automaticReservation: "Prenotazione automatica",
            taskManagement: "Gestione attività",
            calendarIntegration: "Integrazione del calendario",
            activeChatbot: "Chatbot attivo",
            smsIntegration: "Integrazione SMS",
            mailIntegration: "Integrazione email",
            startChatWithVisitor: "Avvia chat con visitatore",
            whatsappManaging: "Gestione di Whatsapp",
            automaticChatbotButton: "Pulsante/Chatbot automatico",
            personalizedBroadcasts: "Trasmissioni personalizzate",
            chatWithNonContacts: "Chat con non contatti",
            broadcastMessaging: "Messaggistica di trasmissione",
            perBroadcast: "Per Broadcast",
            extraPricePerMessage: "Costo aggiuntivo per messaggio",
            smartTrigger: "Trigger intelligente",
            telegramIntegration: "Integrazione di Telegram",
            instagramIntegration: "Integrazione di Instagram",
            ticketFeature: "Funzione del biglietto",
            storage: "Archiviazione",
            onePanelManagement: "Gestione in un unico pannello",
            isolatedDatabaseConnection: "Connessione isolata al database",
            removeLogo: "Rimuovi il logo Supsis",
            chatBaloonCustomization: "Personalizzazione del palloncino della chat",
            chatAndNotifications: "Chat e Notifiche",
            unlimited: "Illimitato",
            specialCustomerSupport: "Supporto clienti speciale",
            softwareSupport: "Supporto software",
            standardSupport: "Supporto standard",
            teamChatIntegration: "Integrazione chat di gruppo",
            fileAndVoiceShare: "Condivisione file e voce",
            instantVisitor: "Tracciamento visitatori istantaneo",
            detailedReporting: "Segnalazione dettagliata",
            normalreporting: "Segnalazione normale",
            noExtraCosts: "Nessun costo extra",
            accessibleToAllAgents: "Accessibile a tutti gli agenti",
            dataSecurity: "Sicurezza dei dati",
            autoTranslate: "Traduzione automatica",
            chatbotVersionHistory: "Cronologia delle versioni del chatbot",
            chatbotStory: "Storia del chatbot",
            freeAgent: "Agente gratuito",
            stableAgentCount: "Numero di agenti stabili",
            stableChannelCount: "Stable Channel Count",
            chipPlans: "Piani convenienti",
            generalPlan: "Piano generale",
            specialPlan: "Piano speciale",
            currentPlan: "Piano attuale",
            selected: "Selezionato",
            popular: "Popolare",
            trialPkg: "Pacchetto di prova",
            support: "Supporto 24/7",
            flexiblePricing: "Prezzi flessibili",
            rightToCancel: "Diritto di annullare in qualsiasi momento",
            unlimitedCBScenario: "Scenari di chatbot illimitati",
            freeFirstScenario: "Primo scenario gratuito",
            unlimitedLearn: "Formazione illimitata per chatbot",
            allPlatformIntegration: "Integrazione con tutte le piattaforme",
            detailedReports: "Rapporti dettagliati",
            aiSupport: "Supporto IA",
            creativeAI: "Assistente chat IA veloce e realistico",
            unlimitedSession: "Sessioni illimitate contemporaneamente",
            assistantFromWebsite: "Creazione di assistente dal sito web",
            assistantFromDoc: "Creazione di chatbot dal documento",
            mobileApp: "Applicazione mobile",
        },
        messenger: {
            channel: "Canale Messenger",
            manageChannel: "Gestisci canale",
            channelDetail: "Dettaglio canale",
            integrationTitle: "Integrazione Messenger",
            deleteDesc: "Sei sicuro di voler eliminare il canale Messenger?",
            channels: "Canali Messenger",
            connectMessenger: "Collegati a Messenger",
            detail: "dettaglio",
            visibility: "Visibilità",
            settings_group: "Impostazioni",
            commentsettings: "Gestione dei commenti",
            commentSettingsTitle: "Gestione dei commenti di Messenger",
            commentSettingsDesc: "Gestisci i tuoi commenti su Messenger",
        },
        instagram: {
            channel: "Canale Instagram",
            detail: "dettaglio",
            visibility: "Visibilità",
            settings_group: "Impostazioni",
            commentsettings: "Gestione dei commenti",
            commentSettingsTitle: "Gestione dei commenti di Instagram",
            commentSettingsDesc: "Gestisci i tuoi commenti su Instagram",
            commentSettingsTicket: "Garantisce che i commenti in arrivo siano registrati nel sistema come ticket.",
            commentSettingsChatbot:
                "Seleziona a quale scenario di chatbot devono essere indirizzati i commenti in arrivo.",
            leads: "Leads",
            forms: "Forms",
        },
        calendar: {
            setting: "Impostazioni",
            delete: "Elimina",
            cancel: "Annulla",
            save: "Salva",
            close: "Chiudi",
            deleteRepeatEvent: "Elimina evento ricorrente",
            thisEvent: "Questo evento",
            thisAndOtherEvent: "Questo e altri eventi",
            allEvent: "Tutti gli eventi",
            ok: "OK",
            googleCalendarLink: "Aggiungi a Google Calendar",
            yahooCalendarLink: "Aggiungi a Yahoo Calendar",
            subject: "Oggetto",
            visitor: "Visitatore",
            allDay: "Tutto il giorno",
            title: "Titolo",
            deleteEvent: "Elimina evento",
            deleteEvents: "Elimina eventi",
            deleteEventsSure: "Sei sicuro di voler eliminare gli eventi da questo calendario?",
            deleteEventConfirm: "Sei sicuro di voler eliminare questo evento?",
            notEmptyTitle: "Il titolo non può essere vuoto!",
            tasks: "Attività",
            googleConnect: "Integrazione Google",
            googleDisconnect: "Disconnetti integrazione Google",
            sure: "Sei sicuro?",
            disconnectGoogleSure: "Sei sicuro di voler disconnettere Google?",
            yes: "Sì",
            no: "No",
            customRepeat: "Ripetizione personalizzata",
            recurrenceFrequency: "Frequenza di ripetizione",
            repeatDays: "Ripeti nei giorni:",
            never: "Mai",
            thisDate: "In questa data:",
            recurrenceCount: "Numero di ripetizioni:",
            end: "Fine",
            event: "Evento",
            calendars: "Calendari",
            newCalendar: "Crea nuovo calendario",
            changeColor: "Cambia colore",
            addCalendar: "Aggiungi calendario",
            nameCalendar: "Nome del calendario",
            description: "Descrizione",
            change: "Modifica",
            deleteCalendar: "Elimina calendario",
            deleteCalendarSure: "Sei sicuro di voler eliminare questo calendario?",
            notEmptyCalendarName: "Il nome del calendario non può essere vuoto",
            myEvents: "I miei eventi",
            everyoneEvents: "Tutti gli eventi",
            haveEvent: "eventi dell'agente",
            goCalendar: "Vai al calendario",
            goReservation: "Crea una prenotazione",
            agents: "Agenti",
            today: "Oggi",
            month: "Mese",
            week: "Settimana",
            day: "Giorno",
            list: "Lista",
        },
        ticimax: {
            segment: "Segmento",
            settings_group: "Gruppo di impostazioni",
            waitDayFromLastSend: "Giorno di attesa dall'ultimo messaggio inviato",
            automationRuleName: "Nome della regola di automazione",
            time: "Ora",
            year: "Anno",
            month: "Mese",
            dayOfMonth: "Giorno del mese",
            day: "Giorno",
            bySecond: "Per secondo",
            byMinute: "Per minuto",
            byHour: "Per ora",
            byWeekNo: "Per numero di settimana",
            byYearDay: "Per giorno dell'anno",
            byMonthDay: "Per giorno del mese",
            byMonth: "Per mese",
            december: "Dicembre",
            november: "Novembre",
            october: "Ottobre",
            september: "Settembre",
            august: "Agosto",
            july: "Luglio",
            june: "Giugno",
            may: "Maggio",
            april: "Aprile",
            march: "Marzo",
            february: "Febbraio",
            january: "Gennaio",
            byWeekDay: "Per giorno della settimana",
            interval: "Intervallo",
            seconds: "Secondi",
            minutes: "Minuti",
            hourly: "Ogni ora",
            daily: "Giornaliero",
            weekly: "Settimanale",
            monthly: "Mensile",
            yearly: "Annuale",
            frequency: "Frequenza",
            attributes: {
                vip: "VIP",
                segment: "Segmento",
                province: "Provincia",
                country: "Paese",
                phone: "Telefono",
                email: "E-mail",
                fullname: "Nome completo",
                couponPercent: "% del coupon",
                lastOrderDate: "Ultimo ordine",
                firstOrderDate: "Primo ordine",
                county: "Contea",
                lastSource: "Ultima fonte",
                firstSource: "Prima fonte",
                lastPaymentType: "Ultimo metodo di pagamento",
                firstPaymentType: "Primo metodo di pagamento",
                maxOrderAmount: "Importo massimo dell'ordine",
                minOrderAmount: "Importo minimo dell'ordine",
                totalOrderAmount: "Importo totale dell'ordine",
                totalOrderCount: "Numero totale degli ordini",
                usedCouponAmount: "Importo del coupon utilizzato",
                usedCouponCount: "Numero di coupon utilizzati",
                tookDayFromLastOrder: "Giorni dall'ultimo ordine",
                isCouponUser: "È un utente del coupon?",
            },
            createAutomation: "Crea automazione",
            previous: "Precedente",
            createAutomationDesc: "Crea e gestisci l'automazione dei messaggi",
            newTicimaxChannel: "Nuovo canale Ticimax",
            connextToTicimaxXml: "Collegati al servizio XML di Ticimax",
            connectTicimax: "Collegati a Ticimax",
            examplePreview: "Anteprima dell'esempio",
            completeAutomationRule: "Regola di automazione completa",
            configureMessage: "Configura il messaggio",
            automationTimer: "Timer di automazione",
            findTargetMembers: "Trova i membri target",
            createAutomationRule: "Crea regola di automazione",
            action: "Azione",
            status: "Stato",
            triggeredUserCount: "Numero di utenti attivati",
            nextScheduled: "Successivo programmato",
            timerRule: "Regola del timer",
            automationRules: "Regole di automazione",
            apply: "Applica",
            searchAMember: "Cerca un membro",
            segmentedMembersDesc: "Elenca e automatizza i membri segmentati",
            manageVisibilityDesc: "Gestisci la visibilità del canale",
            xmlOrderListURL: "URL dell'elenco ordini XML",
            manageIntegrationDesc: "Gestisci la tua integrazione Ticimax",
            detail: "Dettaglio",
            ticimaxChannelsTitle: "Canali Ticimax",
            ticimaxDetail: "Dettaglio Ticimax",
            settingsGroup: "Impostazioni",
            visibility: "Visibilità",
            members: "Membri",
            automation: "Automazione",
            integrationChannel: "Canale di integrazione",
            channelUpdated: "Canale aggiornato correttamente",
            channelUpdateFailed: "Aggiornamento del canale non riuscito",
        },
        notification: {
            mobileApp: "App Mobile",
            webPanel: "Pannello Web",
            notifications: "Notifiche",
            whatsappActions: "Azioni Whatsapp",
            chatbotActions: "Azioni del chatbot",
            companyActions: "Azioni dell'azienda",
            crmActions: "AZIONI CRM SUPSIS",
            basicActions: "Azioni di base",
            notificationSettingsDesc: "Scegli quali notifiche desideri ricevere e dove desideri riceverle.",
            noNotificationDesc2:
                "Qui vedrai tutte le notifiche relative alle offerte di lavoro, ai candidati e ai pool di talenti che stai seguendo. Puoi personalizzare le notifiche regolando le impostazioni.",
            noNotificationTitle2: "Ancora nessuna notifica.",
            noNotificationTitle1: "Nessuna notifica. Goditi il silenzio.",
            adjustSettings: "Regola impostazioni",
            showAll: "Mostra tutto",
            showOnlyUnread: "Mostra solo non letti",
            mailWasSent: "L'email è stata inviata.",
            mailAdressRemoved: "Indirizzo email rimosso.",
            chatbotPublished: "La versione <b>{version}</b> del chatbot è stata pubblicata da <b>{user}</b>.",
            chatbotDeleted: "Il chatbot <b>{chatbot}</b> è stato eliminato da <b>{user}</b>.",
            settingsUpdatedWoDetail: "Le impostazioni sono state aggiornate da <b>{user}</b>.",
            noActivityDesc: "Attualmente non ci sono attività nel sistema. Devono verificarsi alcuni eventi",
            noActivityTitle: "Ancora nessuna attività",
            actionType: "Tipo di azione",
            dateBetween: "Data compresa tra",
            selectActor: "Seleziona Utente",
            activities: "Attività",
            chatbotCreated: "Il chatbot di nome <b>{chatbot}</b> è stato creato da <b>{user}</b>.",
            taskStageChanged:
                "Lo stadio del compito <b>{task}</b> è stato cambiato da <b>{oldStage}</b> a <b>{newStage}</b> da <b>{user}</b>.",
            taskCreated: "Il compito <b>{task}</b> è stato creato da <b>{user}</b>.",
            contactPropRemoved: "La proprietà del visitatore <b>{prop}</b> è stata rimossa da <b>{user}</b>.",
            contactPropAdded: "La proprietà del visitatore <b>{prop}</b> è stata aggiunta da <b>{user}</b>.",
            userRemoved: "L'utente <b>{oldUser}</b> è stato rimosso da <b>{user}</b>.",
            loginFormUpdated: "Il modulo di accesso del visitatore è stato aggiornato da <b>{user}</b>.",
            loginFormDeactivated: "Il modulo di accesso dell'utente è stato disattivato da <b>{user}</b>.",
            loginFormActivated: "Il modulo di accesso dell'utente è stato attivato da <b>{user}</b>.",
            invoiceRefunded: "Il processo di rimborso è stato effettuato da <b>{user}</b>.",
            paymentMethodAdded: "Un nuovo metodo di pagamento è stato aggiunto da <b>{user}</b>.",
            invoicePaymentFailed: "Il pagamento della fattura non è stato accettato da <b>{user}</b>.",
            invoicePaymentReceived: "Il pagamento della fattura è stato accettato da <b>{user}</b>.",
            planStarted: "<b>{user}</b> L'utente ha avviato l'abbonamento per <b>{title}</b> (<b>{altTitle}</b>).",
            planStartedAgent:
                "<b>{user}</b> L'utente ha avviato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{details} Rappresentante</b>).",
            planStartedChatbot:
                "<b>{user}</b> L'utente ha avviato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Sessione</b>).",
            planStartedWhatsapp:
                "<b>{user}</b> L'utente ha avviato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Canali Whatsapp</b>).",
            planStartedWhatsappApi:
                "<b>{user}</b> L'utente ha avviato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Canali Business Whatsapp</b>).",
            PlanCanceled: "<b>{user}</b> L'utente ha annullato l'abbonamento per <b>{title}</b> (<b>{altTitle}</b>).",
            planCanceledAgent:
                "<b>{user}</b> L'utente ha annullato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{details} Rappresentante</b>).",
            planCanceledChatbot:
                "<b>{user}</b> L'utente ha annullato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Sessione</b>).",
            planCanceledWhatsapp:
                "<b>{user}</b> L'utente ha annullato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Canali Whatsapp</b>).",
            planCanceledWhatsappApi:
                "<b>{user}</b> L'utente ha annullato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Canali Business Whatsapp</b>).",
            invoiceCreated: "La fattura è stata creata da <b>{user}</b>.",
            billingAddressUpdated: "Le informazioni sull'indirizzo sono state aggiornate da <b>{user}</b>.",
            taskWorkflowDeleted: "Il workflow <b>{workflow}</b> è stato eliminato da <b>{user}</b>.",
            whatsappBroadcastFailed: "Invio del messaggio broadcast dal titolo <b>{title}</b> fallito.",
            whatsappBroadcastCancelled: "L'invio del messaggio broadcast dal titolo <b>{title}</b> è stato annullato.",
            whatsappBroadcastCompleted:
                "Un messaggio broadcast dal titolo <b>{title}</b> è stato inviato con successo a <b>{numbers}</b> destinatari.",
            whatsappBroadcastCreated:
                "Un messaggio broadcast dal titolo <b>{title}</b> è stato inviato a <b>{numbers}</b> destinatari da <b>{user}</b>.",
            ticketAssigned: "Un ticket è stato assegnato a <b>{user2}</b> da <b>{user1}</b>.",
            userLoggedIn: "<b>{user}</b> ha effettuato l'accesso a SUPSIS.",
            chatJoined: "<b>{agent}</b> si è unito alla chat con <b>{visitor}</b>.",
            chatForwarded: "La chat con <b>{visitor}</b> è stata inoltrata a <b>{agent}</b> da <b>{user}</b>.",
            chatAssigned: "La chat con <b>{visitor}</b> è stata assegnata a <b>{agent}</b> dal sistema.",
            customerGroupUpdated: "Il gruppo <b>{group}</b> è stato aggiornato da <b>{user}</b>.",
            customerGroupRemoved: "Il gruppo <b>{group}</b> è stato rimosso da <b>{user}</b>.",
            customerGroupAdded: "Il gruppo <b>{group}</b> è stato creato da <b>{user}</b>.",
            contentRemoved: "Il contenuto pronto <b>{content}</b> è stato rimosso da <b>{user}</b>.",
            contentAdded: "Il contenuto pronto <b>{content}</b> è stato aggiunto da <b>{user}</b>.",
            channelVisibilityChanged:
                "La visibilità del canale di integrazione <b>{channel}</b> è stata cambiata da <b>{user}</b>.",
            taskDeleted: "Il compito <b>{task}</b> è stato eliminato da <b>{user}</b>.",
            userRemovedToDepartment:
                "L'utente <b>{user2}</b> è stato rimosso dal dipartimento <b>{department}</b> da <b>{user1}</b>.",
            userAddedToDepartment:
                "L'utente <b>{user2}</b> è stato aggiunto al dipartimento <b>{department}</b> da <b>{user1}</b>.",
            mailAddressAdded: "Indirizzo email <b>{email}</b> aggiunto da <b>{user}</b>",
            settingUpdate: "Aggiornato da <b>{user}</b>:",
            taskWFlowCreated: "Flusso di lavoro delle attività <b>{Wflow}</b> creato da <b>{user}</b>.",
            bannedWordRemoved: "La parola vietata <b>{bWord}</b> è stata rimossa da <b>{user}</b>.",
            bannedWordCreated: "La parola vietata <b>{bWord}</b> è stata creata da <b>{user}</b>.",
            welcomeMessageRemoved: "Il messaggio di benvenuto <b>{welcome}</b> è stato rimosso da <b>{user}</b>.",
            welcomeMessageAdded: "Messaggio di benvenuto <b>{welcome}</b> creato da <b>{user}</b>.",
            tagRemoved: "Tag <b>{tag}</b> rimosso da <b>{user}</b>.",
            tagAdded: "Tag <b>{tag}</b> aggiunto da <b>{user}</b>.",
            roleRemoved: "Ruolo <b>{role}</b> rimosso da <b>{user}</b>.",
            roleAdded: "Ruolo <b>{role}</b> aggiunto da <b>{user}</b>.",
            departmentRemoved: "Dipartimento <b>{department}</b> rimosso da <b>{user}</b>.",
            departmentAdded: "Dipartimento <b>{department}</b> aggiunto da <b>{user}</b>.",
            triggerUpdated: "Un trigger aggiornato da <b>{user}</b>.",
            triggerRemoved: "Un trigger rimosso da <b>{user}</b>.",
            triggerAdded: "Un nuovo trigger creato da <b>{user}</b>.",
            webhookRemoved: "Webhook di <b>{user1}</b> rimosso da <b>{user2}</b>",
            webhookAdded: "Webhook aggiunto da <b>{user1}</b>, aggiunto da <b>{user2}</b>.",
            chatClosed: "La chat con <b>{visitor}</b> è stata chiusa da <b>{agent}</b>.",
            chatOpenedByAgent: "<b>{agent}</b> ha avviato una chat <b>{platform}</b> con <b>{visitor}</b>.",
            chatOpenedByVisitor: "Una chat <b>{platform}</b> è stata avviata da <b>{visitor}</b>.",
            channelRemoved: "Il canale <b>{channel}</b> è stato rimosso da <b>{agent}</b>.",
            userAdded: "<b>{agent}</b> ha creato un rappresentante di nome <b>{newAgent}</b>.",
            visitorUnblocked: "Il visitatore <b>{visitor}</b> sbloccato dall'utente <b>{agent}</b>.",
            visitorBlocked: "Il visitatore <b>{visitor}</b> bloccato da <b>{agent}</b>.",
            userStatusChanged: "L'utente <b>{name}</b> ha cambiato stato da <b>{oldStatus}</b> a <b>{newStatus}</b>.",
            channelCreated: "Il canale <b>{channel}</b> è stato creato da <b>{name}</b>.",
            reservationCreatedPlan:
                "<b>{name}</b> utente ha pianificato l'appuntamento chiamato <b>{title}</b> per il <b>{date}</b>.",
            reservationUpdatedPlan: "<b>{name}</b> utente ha aggiornato l'appuntamento chiamato <b>{title}</b>.",
            reservationDeletedPlan: "<b>{name}</b> utente ha eliminato l'appuntamento chiamato <b>{title}</b>.",
            reservationCreated:
                "Una prenotazione è stata creata per l'utente <b>{name}</b> e il visitatore <b>{visitor}</b> in data <b>{date}</b>.",
            reservationDeleted:
                "L'appuntamento pianificato tra l'utente <b>{name}</b> e il visitatore <b>{visitor}</b> in data <b>{date}</b> è stato cancellato.",
            chatAssignedMe: "Quando mi viene assegnata una chat",
            ticketAssignedMe: "Quando mi viene assegnato un ticket",
            taskAssignedMe: "Quando mi viene assegnato un compito",
            myChatClosed: "Quando la chat di cui sono proprietario viene chiusa",
            tagActionsToVisitor: "Tag aggiunti o rimossi da un contatto",
            ticketCreated:
                "Il ticket è creato dal visitatore o dal chatbot. Inoltre, quando viene inviato un messaggio offline dal widget di chat",
            notesActions: "Una nota è stata aggiunta o rimossa da un cliente.",
            visitorProfileUpdated: "Profilo del visitatore aggiornato",
            chatStartedByAnyPlatform: "La chat viene avviata su qualsiasi piattaforma da contatto o agente",
            userActions: "Utente creato, aggiornato o eliminato",
            departmentActions: "Dipartimento creato, aggiornato o eliminato",
            settingsActions: "Impostazioni create, aggiornate o eliminate",
            integrationsActions: "Canale di integrazione creato, aggiornato o eliminato",
            loginFormActions: "Modulo di accesso aggiornato, attivato o disattivato",
            bannedWordActions: "Parola vietata creata, aggiornata o eliminata",
            emailActions: "Account email creato o eliminato",
            preparedContentActions: "Contenuto preparato creato o eliminato",
            roleActions: "Ruolo creato, aggiornato o eliminato",
            tagActions: "Tag creato, aggiornato o eliminato",
            welcomeMessageActions: "Messaggio di benvenuto creato, aggiornato o eliminato",
            webhookActions: "Webhook creato, aggiornato o eliminato",
            billingEvents: "Eventi di fatturazione",
            taskWorkflowCrud: "Il workflow del compito viene creato, aggiornato o eliminato",
            taskCrud: "Il compito viene creato, aggiornato o eliminato",
            systemStatus: "Cambiamenti di stato online o offline del sistema",
            chatbotStoryCrud: "La storia del chatbot viene creata, aggiornata o eliminata",
            chatbotForwardAgent: "Il chatbot inoltra una chat a un agente",
            userSegmentCrud: "Il segmento utente viene creato, aggiornato o eliminato",
            chatbotCreditLow: "Quando il credito del chatbot è basso",
            wpCreditLow: "Quando il credito Whatsapp è basso",
            wpCustomerGroupCrud: "Quando viene creato, aggiornato o eliminato il gruppo clienti Whatsapp",
            wpBroadcastMessageStatus: "Quando viene inviato, completato o annullato un messaggio broadcast di Whatsapp",
            wpTemplateMesssageCrud: "Quando viene creato, aggiornato o eliminato un messaggio di modello Whatsapp",
            reservationMessageCrud: "Prenotazione creata, aggiornata, annullata",
        },
        mail: {
            deleteMailDesc: "Questa azione non può essere annullata.",
            deleteMailTitle: "Sei sicuro di voler eliminare questo indirizzo email?",
            gmailForwardMail: "Inoltro email Gmail",
            senderMailAddressDesc: "Si prega di inserire l'indirizzo email del mittente",
            verified: "Verificato",
            notForwarded: "Non inoltrato",
            notVerified: "Non verificato",
            default: "Predefinito",
            isVerified: "Verificato",
            forwarding: "Inoltro",
            mailAdress: "Indirizzo email",
            addSenderAddress: "Aggiungi indirizzo mittente",
            outlookForward: "Inoltra Microsoft (Outlook/Exchange)",
            gmailForward: "Inoltra Google (Gmail)",
            senderMail: "Mail del mittente",
            mailDetail: "Dettaglio della mail",
            mailNotFound: "Mail non trovata",
            mailSelecting: "Selezione mail",
            newMail: "Nuova e-mail",
            myMails: "Le mie email",
            inbox: "Posta in arrivo",
            sent: "Inviato",
            departmentMails: "Email del dipartimento",
            newTemplate: "Nuovo Modello",
            unread: "Non letto",
            unreply: "Unanswered",
            ply: "Rispondi",
            attachments: "Allegati alla mail",
            To: "A",
            From: "Da",
            placeHolders: "Segnaposto",
            attacheFiles: "Allega file",
            replyAll: "Rispondi a tutti",
            forward: "Inoltra",
            deleteThread: "Elimina conversazione",
            markAsRead: "Segna come letto",
            markAsAllRead: "Segna tutto come letto",
            emailEditor: "Editor email",
            integrateYourMail: "Integra la tua email",
            connect: "Collegare",
            departmentMail: "Email del dipartimento",
            createMailAddress: "Crea un indirizzo email",
            createNewMail: "Crea una nuova email",
        },
        visitor: {
            mail: "Posta",
            visitorDetail: "Dettagli del visitatore",
            selectedUser: "{selectedUser} di {totalUsers} utenti selezionati",
            uncheck: "Deseleziona tutto",
            checkAll: "Seleziona tutto",
            matchedUsers: "{checkedCount} utenti corrispondenti",
            more: "Di più",
            exportUsers: "Esporta utenti selezionati",
            exportAllUsers: "Esporta tutti gli utenti",
            addSegment: "Aggiungi segmento",
            deleteCheckedUser: "Elimina utenti selezionati",
            deleteAllUser: "Elimina tutti gli utenti",
            matchedFilter: "Corrispondi a tutti i filtri",
            visitor: "Visitatore",
            deleteUser: "Elimina utente",
            userData: "Dati utente",
            lastSession: "Ultima sessione",
            notUserData: "Nessun dato utente trovato",
            segments: "Segmenti",
            tags: "Tag",
            addTag: "Aggiungi tag",
            userChats: "Chat utente",
            seeAll: "Vedi tutti",
            confirm: "Conferma",
            manageSegments: "Gestisci segmenti",
            search: "Ricerca",
            manageTags: "Gestisci tag",
            allAttributes: "Vedi tutti gli attributi",
            noData: "Nessun dato",
            noEmail: "Nessuna email",
            noIpAddress: "Indirizzo IP non trovato.",
            noWpNumber: "Numero non trovato.",
            filterName: "nome del filtro...",
            matchedContacts: "{chechkedCount} contatti corrispondenti",
        },
        chatbotv2: {
            selectedStory: "{count} storia selezionata",
            Instagram_Actions: "Instagram Actions",
            suppressionRemoved: "Soppressione rimossa",
            suppressionAdded: "Soppressione aggiunta",
            didntSuppression: "Non hai fatto alcuna soppressione.",
            whatsappIntegrationTitle: "Integrazione di WhatsApp V1 e WhatsApp V2",
            whatsappApiIntegrationTitle: "Integrazione dell'API di WhatsApp Business",
            ReadyTemplateBadge: "Modello pronto",
            readyTemplates: "Modelli pronti",
            regex: "Regex",
            regexDescription: "Regex ile herşeyi yakala",
            chatbotLogo: "Logo del ChatBot",
            chatbotName: "Nome del ChatBot",
            allSecnario: "Elenco degli scenari di Chatbot",
            ChatbotScenarioList: "Elenco degli scenari di Chatbot",
            Scenario: "Scenari",
            filters: {
                equal: "uguale",
                not_equal: "non uguale",
                contain: "contiene",
                not_contain: "non contiene",
                starts_with: "inizia con",
                ends_with: "finisce con",
                empty: "vuoto",
                non_empty: "non vuoto",
                longer_than: "più lungo di",
                shorter_than: "più corto di",
                less_than: "minore di",
                less_or_equal: "minore o uguale a",
                greater_than: "maggiore di",
                greater_or_equal: "maggiore o uguale a",
            },
            planRequired: "{integratable} è disponibile solo con il piano.",
            noDefaultStoryTitle: "Nessuna storia predefinita",
            noDefaultStory: "Non hai una storia predefinita.\n Vuoi impostare questa storia come predefinita?",
            noMessage: "Nessun messaggio",
            loading: "Caricamento...",
            loadMore: "Carica altro",
            hostname: "Nome host",
            allTemplates: "Tutti i modelli",
            allAITemplates: "Tutti i modelli di IA",
            templatesFromTheIndustry: "Modelli dell'industria",
            basicTemplate: "Modello di base",
            proTemplate: "Modello avanzato",
            goToStory: "Vai alla storia",
            noResultFound: "Nessun risultato trovato",
            checkYourFilterCombination: "Controlla la combinazione del filtro",
            clearYourSearch: "Cancella la tua ricerca",
            andTryAgain: "e riprova",
            withBot: "& Bot",
            userWithBot: "Utente & Bot",
            chatDetail: "Dettaglio chat",
            allUserDetail: "Tutti i dettagli degli utenti",
            sessionData: "Dati di sessione",
            supsisChatWidget: "Supsis Chat Widget",
            integratedWith: "Integrato con: ",
            integration: "Integrazione",
            Users: "Utenti",
            user_id: "ID utente",
            botStory: "Storia del bot",
            categories: "Categorie",
            worksWith: "Funziona con",
            importBot: "Importa bot",
            keyFeatures: "Caratteristiche principali",
            importing: "Importazione",
            comingSoon: "Prossimamente",
            pickStory: "Scegli una storia",
            conversationId: "ID conversazione",
            integrateStoryWithSupsisWidget: "Integra la storia con Supsis Widget",
            integrateStoryWithWhatsapp: "Integra la storia con WhatsApp",
            integrateStoryWithInstagram: "Integra la storia con Instagram",
            selectIntegratingStory: "Seleziona la storia da integrare",
            install: "Installa",
            attr: {
                weekday: "Weekday",
                channelId: "Channel",
                email: "E-mail",
                phone: "Telefono",
                language: "Lingua",
                timezone: "Fuso orario",
                gender: "Genere",
                country: "Paese",
                referrer: "Referrer",
                url: "Indirizzo di visita",
                ip: "IP",
                last_seen: "Ultima visita",
                name: "Nome",
                user_id: "ID utente",
                department: "Dipartimento",
                message: "Messaggio",
                akinon_brand: "Nome del marchio",
                akinon_order_id: "ID ordine",
                akinon_product_id: "ID prodotto",
                akinon_user_id: "ID utente",
                akinon_user_name: "Nome utente",
                akinon_user_email: "E-mail utente",
                akinon_invoice_url: "URL fattura",
                akinon_order_status: "Stato ordine",
                akinon_order_price: "Prezzo ordine",
                akinon_shipper_name: "Nome spedizioniere",
                akinon_product_size: "Dimensione prodotto",
                akinon_sku: "SKU",
                akinon_product_url: "URL prodotto",
                akinon_product_title: "Titolo prodotto",
                akinon_product_image: "Immagine prodotto",
                akinon_product_stock: "Stock prodotto",
                akinon_order_date: "Data ordine",
                akinon_track_number: "Numero di tracciamento",
                akinon_track_url: "URL di tracciamento",
                akinon_latitude: "Latitudine (Posizione)",
                akinon_longitude: "Longitudine (Posizione)",

                ideasoft_user_id: "Member Id",
                ideasoft_invoice_url: "Invoice Url",
                ideasoft_order_id: "Sipariş Numarası",
                ideasoft_order_status: "Order Status",
                ideasoft_order_price: "Order Price",
                ideasoft_shipper_name: "Shipper Name",
                ideasoft_product_size: "Product Size",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Product Url",
                ideasoft_product_title: "Product Title",
                ideasoft_product_image: "Product Image",
                ideasoft_product_stock: "Product Stock",
                ideasoft_order_date: "Order Date",
                ideasoft_track_number: "Track Number",
                ideasoft_track_url: "Track Url",

                offline_mode: "Modalità offline",
                available_agents: "Agenti disponibili",
                platform: "Piattaforma",
                probel_sube_kodu: "Codice filiale",
                probel_brans_adi: "Nome del ramo",
                probel_brans_kodu: "Codice del ramo",
                probel_doktor_adi: "Nome del dottore",
                probel_doktor_kodu: "Codice del dottore",
                probel_poliklinik_adi: "Nome della poliambulatorio",
                probel_poliklinik_kodu: "Codice della poliambulatorio",
                probel_randevu_tarihi: "Data del appuntamento",
                probel_date: "Data",
                probel_randevu_saati: "Ora del appuntamento",
                probel_randevu_id: "ID del appuntamento",
                probel_hasta_token: "Token del paziente",
                probel_kimlik_tipi: "Tipo di identità",
                probel_kimlik_no: "Numero di identità",
                probel_hasta_adi: "Nome del paziente",
                probel_hasta_soyadi: "Cognome del paziente",
                probel_hasta_cinsiyet: "Genere",
                probel_hasta_dogum_tarihi: "Data di nascita",
                probel_hasta_telefon: "Telefono",
                hour: "Ora",
                segments: "Segments",
                ticket: "biglietto",
                tags: "Tag",
                metaReferrals: "Meta referral",
            },
            storyList: "Elenco delle storie",
            douYouWannaDeleteItem: "Vuoi eliminare questo elemento?",
            douYouWannaDeleteWithChildren: "Vuoi eliminare questo elemento e i suoi figli?",
            stories: "Storie",
            templates: "Modelli",
            aitemplates: "Modelli di IA",
            integrations: "Integrazioni",
            all: "Tutti",
            installed: "Installato",
            installationOK: "Installazione OK",
            uninstall: "Disinstalla",
            remainingMessageDesc: "Hai messaggi rimanenti : ",
            openAISiteRoutingDescStart: "Per ottenere un Apikey",
            openAISiteRoutingDescEnd: " è possibile fare clic sul collegamento.",
            integrationOK: "Integrazione OK",
            chatWidget: "Supsis Widget di chat",
            artificialIntelligence: "AI",
            integratePlatform: "Chatbot {integretable} può essere integrato con",
            integrateOpenAIWithChatbot: "Integra Chat GPT-4 con Chatbot",
            integrateChatBotWithChatGPT3: "Integrazione di ChatBot con Chat GPT-4",
            integrateStoryWithTelegram: "Integra la storia con Telegram",
            webhooks: "Webhooks",
            archive: "Archivio",
            reports: "Rapporti",
            uncheckAll: "Deseleziona tutto",
            userSegments: "Segmenti utente",
            addSegment: "Aggiungi segmento",
            addToSegment: "Aggiungi al segmento",
            removeFromSegment: "Rimuovi dal segmento",
            plansVTippyContent:
                "La fatturazione per questo pacchetto verrà effettuata all'inizio di ogni mese e, nel caso in cui desideriate annullare, il vostro utilizzo verrà addebitato fino all'inizio del mese e il vostro pacchetto scadrà.<br><br>Il prezzo del pacchetto è escluso dall'IVA.<br><br>Le modifiche al pacchetto vengono riflesse nella fattura il giorno successivo.",
            segmentName: "Nome del segmento",
            sameSegment: "C'è un segmento con lo stesso nome!",
            usersInSegment: "Utenti nel segmento",
            noUsersAdded: "Nessun utente aggiunto",
            updateSegment: "Aggiorna segmento",
            newSegment: "Nuovo segmento",
            selectAll: "Seleziona tutto",
            queriesSelected: "query selezionate",
            noBlocksFound: "Nessun blocco trovato",
            userQuery: "Query utente",
            date: "Data",
            unmatched: "Non corrispondente",
            goToChat: "Vai alla chat",
            selectStory: "Seleziona storia",
            selectBlock: "Seleziona blocco",
            training: "Formazione",
            trainingAlert:
                "Per implementare le modifiche apportate alla pagina di addestramento del bot, è necessario pubblicare la nuova versione dello scenario da voi modificato.",
            unmatchedPhrases: "Frasi non corrispondenti",
            ignored: "Ignorato",
            story: "Storia",
            timePeriod: "Periodo di tempo",
            wholeTimeSpan: "Tutto il periodo",
            selectAStory: "Seleziona una storia",
            searchUserQuery: "Cerca query utente",
            time: {
                today: "Oggi",
                yesterday: "Ieri",
                last7: "Ultimi 7 giorni",
                last30: "Ultimi 30 giorni",
                "this-month": "Questo mese",
                "last-month": "Ultimo mese",
                "last-3-month": "Ultimi 3 mesi",
                "this-year": "Quest'anno",
                "last-year": "L'anno scorso",
                custom: "Personalizzato",
            },
            emailProvider: "Provider di posta elettronica",
            triggerFromAnywhere: "Attiva da qualsiasi parte",
            editWebhook: "Modifica Webhook",
            newWebhook: "Nuovo Webhook",
            webhookTitle: "Webhook connesso",
            webhookUrl: "URL Webhook",
            webhookToken: "Token Webhook",
            webhookUsername: "Nome utente Webhook",
            webhookPassword: "Password Webhook",
            allIntegrations: "Tutte le integrazioni",
            integrateYourCBwithChatWidget: "Integra il chatbot con il Chat Widget.",
            integrateYourCBwithChatGpt3: "Chatbot può essere integrato con GPT-4. Chiave API GPT-4 richiesta.",
            integrateYourCBwithWebHook: "Passa facilmente le informazioni sulla chat tra ChatBot e i tuoi servizi web.",
            integrateYourCBwithIntegratable:
                "ChatBot e {integratable} Trasmetti facilmente le informazioni sulla chat tra",
            addWebhook: "Aggiungi Webhook",
            editBlock: "Modifica blocco",
            moveBlock: "Sposta blocco",
            copyBlock: "Copia blocco",
            chatbot: "Chatbot",
            addFilter: "Aggiungi filtro",
            addFilterGroup: "Aggiungi gruppo di filtri",
            in: "in",
            and: "e",
            or: "o",
            allStories: "Tutte le storie",
            addBot: "Aggiungi bot",
            testBot: "Test bot",
            publish: "Pubblica",
            editName: "Modifica nome",
            search: "Ricerca",
            typeMoreThan3Char: "Digita più di 3 caratteri ",
            expand: "Espandi",
            expandAll: "Espandi tutto",
            noMatchingItem: "Nessun elemento corrispondente",
            hint: "Suggerimento",
            select: "Seleziona",
            navigate: "Naviga",
            dismiss: "Ignora",
            choseAttribute: "Scegli attributo",
            selectReply: "Seleziona risposta",
            preview: "Anteprima",
            draft: "Bozza",
            lastUpdate: "Ultimo aggiornamento",
            published: "Pubblicato",
            newStory: "Nuova storia",
            updateStory: "Aggiorna storia",
            storyDescription: "Descrizione della storia",
            storyTitle: "Titolo della storia",
            deleteSingleBlock: "Elimina blocco",
            deleteWithChildren: "Elimina con figli",
            startTestFromHere: "Inizia il test da qui",
            copyBlockId: "Copia ID blocco",
            gotoLiveLink: "Vai al link dal vivo",
            copyBlockIdSuccessfull: "ID blocco copiato con successo",

            collapse: "Riduci",
            collapseAll: "Riduci tutto",
            snDelay: "{delay} ritardo sec",
            blockUpdated: "Blocco aggiornato",
            addPayload: "Aggiungi payload",
            previewModeCaution:
                "Sei in modalità anteprima. I cambiamenti apportati qui non verranno salvati. Per salvare, vai alla modalità modifica.",
            enterText: "Inserisci testo",
            trackpad: "Trackpad",
            navigation: "Navigazione",
            navigationDesc:
                "Seleziona questa opzione se vuoi che il chatbot risponda alle domande di navigazione come 'Torna indietro', 'Vai avanti', 'Vai alla home page' ecc.",
            botSetting: "Impostazioni bot",
            botSettingDesc:
                "Seleziona questa opzione se vuoi che il chatbot risponda alle domande di navigazione come 'Torna indietro', 'Vai avanti', 'Vai alla home page' ecc.",
            languageSettingsDesc: "Seleziona la lingua in cui vuoi che il chatbot risponda alle domande.",
            mouse: "Mouse",
            Interactions: "Interazioni",
            Actions: "Azioni",
            Supsis_Actions: "Supsis Azioni",
            Shopify_Actions: "Shopify Azioni",
            Akinon_Actions: "Akinon Azioni",
            IdeaSoft_Actions: "Ideasoft Actions",
            START_POINT: "PUNTO DI PARTENZA",
            AI_ASSISTANT: "AI ASSISTANT",
            BOT_RESPONSE: "RISPOSTA BOT",
            AI_BOT_RESPONSE: "RISPOSTA DI INTELLIGENZA ARTIFICIALE (GPT-4o)",
            AI_CLASSIFICATION: "AI CLASSIFICATION",
            Templates: "Template Blocks",
            AI_MENU_FLOW: "AI MENU",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "DEFAULT FALLBACK",
            FILTER: "FILTRO",
            addNewFilter: "Aggiungi nuovo filtro",
            FLOW: "FLUSSO",
            ATTACHMENT_INPUT: "INPUT ALLEGATO",
            USER_INPUT: "INPUT UTENTE",
            GO_TO_STEP: "VAI AL PASSO",
            WEBHOOK: "WEBHOOK",
            SET_ATTRIBUTE: "IMPOSTA ATTRIBUTO",
            QUESTION: "DOMANDA",
            CLOSE_CHAT: "CHIUDI CHAT",
            CREATE_TICKET: "CREA TICKET",
            TRANSFER_CHAT: "TRASFERISCI CHAT",
            TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
            TAG_CHAT: "ADD TAG",
            REMOVE_TAG: "REMOVE TAG",
            SET_DEPARTMENT: "IMPOSTA DIPARTIMENTO",
            SEND_TRANSCRIPT: "INVIA TRASCRIZIONE",
            SEND_SMS: "SEND SMS", //todo translate
            SEND_MAIL: "SMS MAIL", //todo translate
            CREATE_EVENT: "CREATE EVENT", //todo translate
            CREATE_RESERVATION: "CREATE RESERVATION",
            RESERVATION_OPEN_URL: "Reservation Open Url",
            RESERVATION_SELECT_DAY: "Select reservation day",
            RESERVATION_SELECT_TIME: "Select reservation time",
            RESERVATION_EVENT_LIST: "Reservation list visitor",
            CREATE_TASK: "CREATE TASK",
            SHOPIFY_SHOW_PRODUCTS: "SHOPIFY MOSTRA IL PRODOTTO",
            SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY STATO STOCK DEL PRODOTTO",
            SHOPIFY_ORDER_STATUS: "STATO ORDINE NEGOZIO",
            AKINON_SHOW_PRODUCTS: "MOSTRA DEL PRODOTTO AKINON",
            AKINON_FIND_PRODUCT: "TROVA IL PRODOTTO AKINON",
            AKINON_ORDER_STATUS: "STATO DELL'ORDINE AKINON",
            AKINON_SELECT_ORDER: "AKINON SELEZIONA ORDINE",
            AKINON_SELECT_SIZE: "AKINON SELEZIONA TAGLIA",
            AKINON_FIND_NEAREST_STOCK: "TROVA IL NEGOZIO PIÙ VICINO AKINON",
            AKINON_FIND_NEAREST_STORES: "TROVA I NEGOZI PIÙ VICINI AKINON",
            AKINON_SHOW_DISCOUNT_CODES: "MOSTRA CODICI SCONTO AKINON",

            IDEASOFT_SELECT_ORDER: "SELECT ORDER",
            IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
            IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",
            INSTAGRAM_COMMENT_REPLY: "RISPONDI AL COMMENTO",
            INSTAGRAM_COMMENT_DELETE: "ELIMINA COMMENTO",
            INSTAGRAM_COMMENT_SHOW: "MOSTRA COMMENTO",
            INSTAGRAM_COMMENT_HIDE: "NASCONDI COMMENTO",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "RISPONDERE IN PRIVATO",
            followingAttributesFilled: "I seguenti attributi sono stati compilati",
            GET_LOCATION: "OTTIENI LA POSIZIONE",
            FALLBACK: "FALLBACK",
            SUCCESS: "SUCCESSO",
            FAILURE: "FALLIMENTO",

            Probel_Actions: "Probel Azioni",
            PROBEL_SELECT_BRANCH: "Seleziona Filiale",
            PROBEL_SELECT_CLINIC: "Scegli Clinica",
            PROBEL_SELECT_DAY: "Selezionare Giorno dell'appuntamento",
            PROBEL_SELECT_HOUR: "Seleziona Ora appuntamento",
            PROBEL_MAKE_APPOINTMENT: "Fai un appuntamento",
            PROBEL_CANCEL_APPOINTMENT: "Annulla appuntamento",
            PROBEL_GET_PATIENT_TOKEN: "Ottieni token paziente",
            PROBEL_FILL_INFO: "MERNIS Fill Info",
            PROBEL_SELECT_APPOINTMENT: "Seleziona appuntamento",

            message: "Messaggio",
            condition: "Condizione",
            score: "Punteggio",
            equal: "uguale",
            not_equal: "non uguale",
            contain: "contiene",
            not_contain: "non contiene",
            starts_with: "inizia con",
            ends_with: "finisce con",
            empty: "vuoto",
            longer_than: "più lungo",
            shorter_than: "più corto",
            less_than: "minore di",
            less_than_equal: "minore o uguale a",
            greater_than: "maggiore di",
            greater_than_equal: "maggiore o uguale a",
            value: "Valore",
            failures: "Fallimenti",
            email: "E-mail",
            name: "Nome",
            username: "Nome utente",
            source: "Fonte",
            language: "Lingua",
            timezone: "Fuso orario",
            region: "Regione",
            country: "Paese",
            referrer: "Referrer",
            url: "URL",
            ip: "IP",
            city: "Città",
            lastSeen: "Ultima visita",
            userId: "ID utente",
            selectStep: "Seleziona Passo",
            keywords: "Parole chiave",
            userSays: "Utente dice",
            addKeyword: "Aggiungi parola chiave",
            addUserMessage: "Aggiungi messaggio utente",
            set: "Imposta",
            to: "a",
            gender: "Genere",

            go_to_failure: "Vai al passo di fallimento",
            go_to_success: "Vai al passo di successo",
            untilFilled: "Fino a quando non è riempito",
            time1: "1 volta",
            time2: "2 volte",
            time3: "3 volte",
            time4: "4 volte",
            time5: "5 volte",
            any: "Qualsiasi",
            anytext: "Any Text",
            anytextDescription: "Matches only words + spaces",
            alphanumeric: "Alfanumerico",
            integer: "Intero",
            no: "No",
            number: "Numero",
            phone: "Telefono",
            yes: "Sì",
            yesNo: "Si - No",
            anyDescription: "Corrisponde a tutto ciò che non è nullo.",
            alphanumericDescription: "Corrisponde a qualsiasi carattere alfanumerico.",
            integerDescription: "Corrisponde a qualsiasi numero intero.",
            noDescription: "Corrisponde a no, nope, nah, non,",
            numberDescription: "Corrisponde a qualsiasi numero.",
            phoneDescription: "Corrisponde a qualsiasi numero di telefono.",
            yesDescription: "Corrisponde ai sinonimi di sì.",
            yesNoDescription: "Corrisponde ai sinonimi di sì e no.",
            emailDescription: "Corrisponde a qualsiasi indirizzo email.",
            urlDescription: "Corrisponde a qualsiasi URL.",
            temperature: "Temperatura",
            askWhenInvalid: "Chiedi quando non valido",
            applyFilter: "Applica filtro",
            notificationMessageStartSuccess: "Blok ",
            notificationMessageEndSuccess: " Aggiunto",
            notificationMessageStartError: "Si è verificato un errore, blocco ",
            notificationMessageEndError: " non aggiunto",
            blockChangedWannaUpdate: "Il blocco è stato modificato, vuoi aggiornare?",
            TEXT: "Testo",
            IMAGE: "Immagine",
            GALLERY: "Galleria",
            BUTTON: "Pulsante",
            RANDOM_TEXT: "Testo casuale",
            QUICK_REPLY: "Risposta rapida",
            FILE: "File",
            responses: "Risposte",
            flow: "Flusso",
            active: "Attivo",
            passive: "Passivo",

            chooseAttributeType: "Seleziona tipo di attributo",
            imageAttachment: "Aggiungi immagine",
            audioAttachment: "Aggiungi audio",
            videoAttachment: "Aggiungi video",
            documentAttachment: "Aggiungi documento",
            anyAttachment: "Aggiungi allegato",
            typeAttributeValue: "Inserisci valore attributo",
            typeSearchValue: "Inserisci valore di ricerca",
            male: "Maschio",
            addAttribute: "Aggiungi attributo",
            addAttributeDescription:
                "Gli attributi sono utilizzati per memorizzare le informazioni dell'utente. Ad esempio, se si desidera memorizzare il nome dell'utente, è possibile creare un attributo con il nome 'nome' e il valore 'nome utente'.",
            USER_DATA: "Dati utente",
            CUSTOM_ATTRIBUTES: "Attributi personalizzati",
            enterBotResponseHere: "Inserisci qui la risposta del bot",

            addCard: "Aggiungi carta",
            addButton: "Aggiungi pulsante",
            typeCardTitle: "Titolo della carta",
            typeCardDescription: "Descrizione della carta",
            dragAndDropBrowse: "Trascina e rilascia / Sfoglia",
            dragAndDropBrowseFile: "Trascina e rilascia / Sfoglia file",
            button: "Pulsante",
            enterYourMessage: "Inserisci il tuo messaggio",
            imageView: "Visualizzazione immagine",
            imageUploading: "Caricamento immagine...",
            fileUploading: "Caricamento file...",
            clickToChooseNewImage: "Fai clic per scegliere una nuova immagine",
            clickToChooseNewFile: "Fai clic per scegliere un nuovo file",
            removeTheExistingOne: "Rimuovi quello esistente",
            validateResponseWithEntity: "Convalida la risposta con l'entità",
            actionOnFailureInput: "Azione in caso di input non valido",
            askNextQuestion: "Chiedi la prossima domanda",
            goToSuccessBlock: "Vai al blocco di successo",
            goToFailureBlock: "Vai al blocco di fallimento",
            saveResposeToAttribute: "Salva la risposta nell'attributo",
            selectReplyType: "Seleziona tipo di risposta",
            questionVariants: "Varianti di domande",
            systemEntities: "Entità di sistema",
            delay: "Ritardo",
            retrySectionTextPart: " e riprova dopo ",
            retrySectionText: "Riprova se l'utente ha fornito una risposta non valida",
            addNextQuestion: "Aggiungi la prossima domanda",
            typeBlockTitle: "Inserisci il titolo del blocco",
            versionHistory: "Cronologia delle versioni",
            restore: "Ripristina",
            versionName: "Nome della versione",
            restoreModalText:
                "Sei sicuro di voler ripristinare questa versione? Tutte le modifiche apportate alla versione corrente verranno perse.",
            restoreVersion: "Ripristina versione",
            newVersion: "Nuova versione",
            synonymMustBeUnique: "Il sinonimo deve essere univoco",
            save: "Salva",
            entries: "Voci",
            youHaveNoEntries: "Non hai voci",
            inputsCantBeEmpty: "Le voci non possono essere vuote",
            entryNamesMustBeUnique: "I nomi delle voci devono essere univoci",
            entityNameCantBeEmpty: "Il nome dell'entità non può essere vuoto",
            entityNameMustBeUnique: "Il nome dell'entità deve essere univoco",
            synonyms: "Sinonimi",
            title: "Titolo",
            entryName: "Nome della voce",
            entities: "Entità",
            entityhasbeenUpdatedSuccessfully: "L'entità è stata aggiornata con successo",
            emptyError: "Non può essere vuoto",

            allChats: "Tutte le chat",
            paidChats: "Chat a pagamento",
            busiestPeriod: "Periodo più trafficato",
            ratingDistribution: "Distribuzione del rating",
            allMessages: "Tutti i messaggi",
            avarageMessages: "Messaggi medi",
            popularity: "Popolarità",
            allUsers: "Tutti gli utenti",
            interactionName: "Nome interazione",
            numberOfMessage: "Numero di messaggi",
            ofAllUsersMessage: "% Messaggio da tutti gli utenti",

            totalData: "Dati totali",
            avgData: "Dati medi",
            exportToCsv: "Esporta in CSV",
            exportToExcel: "Esporta in Excel",
            inMaintenance: "In manutenzione",
            ADD_TO_SEGMENT: "Aggiungi al segmento",
            REMOVE_FROM_SEGMENT: "Rimuovi dal segmento",
            users: "Utenti",
            webhookName: "Nome webhook",
            webHookUrl: "URL webhook",
            webHookToken: "Token webhook",
            delete: "Elimina",
            basicAuth: "Autenticazione di base",
            requiredFieldsCannotBeLeftBlank: "I campi obbligatori non possono essere lasciati vuoti",

            yourVerificationToken: "Il tuo token di verifica",
            yourWebHookName: "Nome webhook",
            yourWebHookUrl: "URL webhook",
            enterKey: "Inserisci chiave",
            password: "Password",
            headerValue: "Valore",
            saveSuccessfully: "Salva con successo",
            urlTypeError: "Si prega di compilare correttamente il campo (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "Chiave API richiesta per OpenAI Chat GPT-4.",
                apiKeyDesc:
                    "La chiave API è necessaria per l'integrazione di Chatbot + Chat GPT-4. Si prega di ottenere la chiave API o utilizzare la chiave API sottostante per la prova. Puoi utilizzare solo 20 messaggi a scopo di prova.",
                getApiKey: "Ottieni la chiave API",
                typeApiKey: "Inserisci la chiave API",
                ownApiKey: "Ottieni la chiave API OpenAI",
                trialApiKey: "Chiave API di prova (limitata a 20 post)",
                useOurTrial: "Usa la nostra prova gratuita",
                twentyMessages: "Puoi provare e utilizzare 20 messaggi gratuitamente.",
                enableChatGpt3: "Attiva la chat GPT-4",
            },
        },
        coupon: {
            code: "codice",
            discount: "sconto",
            endDate: "Data di fine",
            name: "Nome",
            email: "E-mail",
            phone: "Telefono",
            add: "Aggiungi",
            coupons: "Coupon",
            couponDeleted: "Coupon eliminato",
            limit: "Limite",
            visitorBan: "Il visitatore è stato bloccato.",
            visitorUnBlock: "Il blocco è stato rimosso.",
        },
        instagramTitle: "Fai clic sul pulsante in basso per abilitare le funzionalità di Instagram.",
        instegramFunctionActive: "Funzione Instagram attiva",
        ChatBOT: "ChatBOT",
        WhatsappContacts: "Contatti Whatsapp",
        InstagramContacts: "Contatti Instagram",
        MessengerContacts: "Messenger Contacts",
        volumeUp: "Volume su",
        minimize: "Minimizza",
        maximize: "Massimizza",
        auditLogs: {
            auditLogsTitle: "Log di audit",
            auditLogsSub:
                "I log di audit ti consentono di tracciare gli eventi che sono avvenuti nella tua azienda negli ultimi 30 giorni.",
        },
        task: {
            workflow: "Flusso di lavoro",
            workflowDetail: "Dettagli del flusso di lavoro",
            workflowPerm: "Permessi del flusso di lavoro",
            perm: "Permessi",
            detail: "Dettagli",
            userPerm: "Permessi utente",
            deleteCard: "Elimina scheda",
            createCard: "Crea scheda",
            editCard: "Modifica scheda",
            dragCard: "Trascina scheda",
            allWorkflow: "Tutti i flussi di lavoro",
            createworkflow: "Crea flusso di lavoro",
            deleteWorkflow: "Sei sicuro di voler eliminare questo flusso di lavoro?",
            permEditTask: "Non hai il permesso di modificare questa attività",
            permEditTaskDes: "Contatta il tuo amministratore per ottenere i permessi di modifica.",
            createTaskError: "Non hai il permesso di creare attività",
            createTaskErrorDesc: "Contatta il tuo amministratore per ottenere i permessi per creare attività.",
            moveTaskError: "Non hai il permesso di cambiare lo stato dell'attività",
            moveTaskErrorDesc:
                "Contatta il tuo amministratore per ottenere i permessi per cambiare lo stato dell'attività.",
            deleteTaskError: "Non hai il permesso di eliminare attività",
            deleteTaskErrorDesc: "Contatta il tuo amministratore per ottenere i permessi per eliminare attività.",
            permissionError: "Non hai il permesso di creare attività",
            permissionErrorDesc:
                "Si prega di contattare l'amministratore per ottenere i permessi di creazione delle attività",
            whatsappContactProfileTitle: "Profilo di {name} / {number}",
            createTaskVisitor: "Crea attività (Visitatore)",
            editWorkflow: "Modifica Workflow",
            visitor: "Profilo del visitatore",
            createTaskMessage: "Crea Compito (Messaggio)",
            createStage: "Crea Stage",
            stagesAndStatuses: "Fasi e stati",
            workflowCreateDesc: "Descrizione del flusso di lavoro",
            subTasks: "Sottoattività",
            followers: "Seguaci",
            collaborators: "Collaboratori",
            addRelations: "Aggiungi relazioni",
            relations: "Relazioni",
            main: "Principale",
            name: "Nome",
            completedOfCheck: "{completed} di {total} compiti completati",
            workflowUpdateMs: "Workflow aggiornato con successo",
            taskUpdateMs: "Attività aggiornata con successo",
            workflowCreatedMs: "Workflow creato con successo",
            workflowCreateError: "Impossibile creare il flusso di lavoro",
            taskCreatedMs: "Attività creata con successo",
            settingsDesc3:
                "Inoltre, il modulo attività di Supsis consente di creare il proprio flusso di lavoro con automazione personalizzabile, consentendo di gestire le attività in modo più efficace e migliorare la collaborazione all'interno del team.",
            settingsDesc4:
                "In questo modo, puoi monitorare ogni singola tua attività in dettaglio, assegnare compiti ai membri del team e gestire complessivamente i tuoi processi aziendali in modo più efficiente. Il modulo attività di Supsis fornisce una soluzione completa per la gestione delle attività e il coordinamento del team.",
            settingsDesc2:
                "Il modulo attività di Supsis non lascia nessuna attività trascurata. Puoi filtrare le attività in base a qualsiasi parametro, monitorare i carichi di lavoro per ogni fase del flusso di lavoro e organizzare il tuo calendario per allinearti ai tuoi orari.",
            settingsDesc1:
                "Il modulo Attività ti consente di organizzare il lavoro collaborativo, delegare compiti e monitorare il progresso del tuo team. Puoi personalizzare le tue attività in base alle tue esigenze selezionando qualsiasi visualizzazione e creare i tuoi flussi di lavoro personalizzati con automazioni.",
            taskModuleSettingsTitle: "Impostazioni del modulo attività",
            high: "Alta",
            medium: "Media",
            low: "Bassa",
            priority: "Priorità",
            addExistsSubtask: "Aggiungi sottoattività esistente",
            addSubtask: "Aggiungi sottoattività",
            add: "Aggiungi",
            newCheckList: "Nuova checklist",
            subtaskTitle: "Titolo della sotto-attività",
            view: "Visualizza",
            attachFiles: "Allega file",
            createTaskDesc: "Descrizione del compito",
            createWorkflow: "Crea un flusso di lavoro",
            editTask: "Modifica attività",
            createTask: "Crea attività",
            deleteColumnCont: "Sei sicuro di voler eliminare questa colonna?",
            changeStage: "Cambia Stage",
            assignees: "Assegnatari",
            owner: "Proprietario",
            stage: "Fase",
            writeSomething: "Scrivi qualcosa",
            selectAssginee: "Seleziona assegnatario",
            assignee: "Assegnatario",
            enterNewTaskDesc: "Inserisci la descrizione del nuovo compito",
            enterNewTaskTitle: "Inserisci il titolo del nuovo compito",
            task: "Compito",
            deleteTaskCont: "Sei sicuro di voler eliminare questi compiti?",
            deleteWorkFlowCont: "Sei sicuro di voler eliminare questo flusso di lavoro?",
            completed: "Completato",
            todo: "Da fare",
            kanbanBoard: "Bacheca Kanban",
            listView: "Visualizzazione elenco",
        },
        permissionErrors: {
            userCreate: "Non hai il permesso di aggiungere utenti. Si prega di consultare l'amministratore.",
            userRead: "Non hai il permesso di visualizzare gli utenti. Si prega di consultare l'amministratore.",
            userUpdate: "Non hai il permesso di aggiornare gli utenti. Si prega di consultare l'amministratore.",
            userDelete: "Non hai il permesso di eliminare gli utenti. Si prega di consultare l'amministratore.",
            visitorBlock: "Non hai il permesso di bloccare i visitatori. Si prega di consultare l'amministratore.",
            visitorUnblock: "Non hai il permesso di sbloccare i visitatori. Si prega di consultare l'amministratore.",
            visitorDetailRead:
                "Non hai il permesso di visualizzare i dettagli dei visitatori. Si prega di consultare l'amministratore.",
            visitorListRead:
                "Non hai il permesso di visualizzare l'elenco dei visitatori. Si prega di consultare l'amministratore.",
            visitorDelete: "Non hai il permesso di eliminare i visitatori. Si prega di consultare l'amministratore.",
            visitorExcel: "Non hai il permesso di ottenere l'output Excel. Si prega di consultare l'amministratore.",
            visitorUpdate: "Non hai il permesso di aggiornare i visitatori. Si prega di consultare l'amministratore.",
            bannedVisitorRead:
                "Non hai il permesso di visualizzare l'elenco dei visitatori bannati. Si prega di consultare l'amministratore.",
            bannedWordCreate:
                "Non hai il permesso di aggiungere parole bannate. Si prega di consultare l'amministratore.",
            bannedWordRead:
                "Non hai il permesso di visualizzare le parole bannate. Si prega di consultare l'amministratore.",
            bannedWordDelete:
                "Non hai il permesso di eliminare le parole bannate. Si prega di consultare l'amministratore.",
            chatRead: "Non hai il permesso di visualizzare le chat. Si prega di consultare l'amministratore.",
            chatUpdate: "Non hai il permesso di modificare le chat. Si prega di consultare l'amministratore.",
            archiveRead: "Non hai il permesso di visualizzare gli archivi. Si prega di consultare l'amministratore.",
            roleCreate: "Non hai il permesso di aggiungere ruoli. Si prega di consultare l'amministratore.",
            roleRead: "Non hai il permesso di visualizzare i ruoli. Si prega di consultare l'amministratore.",
            roleUpdate: "Non hai il permesso di aggiornare i ruoli. Si prega di consultare l'amministratore.",
            roleDelete: "Non hai il permesso di eliminare i ruoli. Si prega di consultare l'amministratore.",
            departmentCreate:
                "Non hai il permesso di aggiungere dipartimenti. Si prega di consultare l'amministratore.",
            departmentRead:
                "Non hai il permesso di visualizzare i dipartimenti. Si prega di consultare l'amministratore.",
            departmentUpdate:
                "Non hai il permesso di aggiornare i dipartimenti. Si prega di consultare l'amministratore.",
            departmentDelete:
                "Non hai il permesso di eliminare i dipartimenti. Si prega di consultare l'amministratore.",
            preparedContentCreate:
                "Non hai il permesso di creare contenuti preparati. Si prega di consultare l'amministratore.",
            preparedContentRead:
                "Non hai il permesso di visualizzare i contenuti preparati. Si prega di consultare l'amministratore.",
            preparedContentUpdate:
                "Non hai il permesso di aggiornare i contenuti preparati. Si prega di consultare l'amministratore.",
            preparedContentDelete:
                "Non hai il permesso di eliminare i contenuti preparati. Si prega di consultare l'amministratore.",
            welcomeCreate:
                "Non hai il permesso di creare messaggi di benvenuto. Si prega di consultare l'amministratore.",
            welcomeRead:
                "Non hai il permesso di visualizzare i messaggi di benvenuto. Si prega di consultare l'amministratore.",
            welcomeUpdate:
                "Non hai il permesso di aggiornare i messaggi di benvenuto. Si prega di consultare l'amministratore.",
            welcomeDelete:
                "Non hai il permesso di eliminare i messaggi di benvenuto. Si prega di consultare l'amministratore.",
            settingCreate: "Non hai il permesso di creare impostazioni. Si prega di contattare l'amministratore.",
            settingRead:
                "Non hai il permesso di visualizzare le impostazioni. Si prega di contattare l'amministratore.",
            settingUpdate:
                "Non hai il permesso di aggiornare le impostazioni. Si prega di contattare l'amministratore.",
            settingDelete: "Non hai il permesso di eliminare le impostazioni. Si prega di contattare l'amministratore.",
            reportCreate: "Non hai il permesso di creare rapporti. Si prega di contattare l'amministratore.",
            reportRead: "Non hai il permesso di visualizzare i rapporti. Si prega di contattare l'amministratore.",
            reportUpdate: "Non hai il permesso di aggiornare i rapporti. Si prega di contattare l'amministratore.",
            reportDelete: "Non hai il permesso di eliminare i rapporti. Si prega di contattare l'amministratore.",
            offlineSupportRequestCreate:
                "Non hai il permesso di creare richieste di supporto offline. Si prega di contattare l'amministratore.",
            offlineSupportRequestRead:
                "Non hai il permesso di visualizzare le richieste di supporto offline. Si prega di contattare l'amministratore.",
            offlineSupportRequestUpdate:
                "Non hai il permesso di rispondere alle richieste di supporto offline. Si prega di contattare l'amministratore.",
            offlineSupportRequestDelete:
                "Non hai il permesso di eliminare le richieste di supporto offline. Si prega di contattare l'amministratore.",
            catalogCreate: "Non hai il permesso di creare cataloghi. Si prega di contattare l'amministratore.",
            catalogRead: "Non hai il permesso di visualizzare il catalogo. Si prega di contattare l'amministratore.",
            catalogUpdate: "Non hai il permesso di aggiornare il catalogo. Si prega di contattare l'amministratore.",
            catalogDelete: "Non hai il permesso di eliminare il catalogo. Si prega di contattare l'amministratore.",
            chatbotStoryCreate:
                "Non hai il permesso di creare storie del chatbot. Si prega di contattare l'amministratore.",
            chatbotStoryRead:
                "Non hai il permesso di visualizzare le storie del chatbot. Si prega di contattare l'amministratore.",
            chatbotStoryUpdate:
                "Non hai il permesso di aggiornare le storie del chatbot. Si prega di contattare l'amministratore.",
            chatbotStoryDelete:
                "Non hai il permesso di eliminare le storie del chatbot. Si prega di contattare l'amministratore.",
            chatbotTemplateRead:
                "Non hai il permesso di visualizzare i modelli del chatbot. Si prega di contattare l'amministratore.",
            chatbotTemplateAiRead:
                "Non hai il permesso di visualizzare i modelli di IA del chatbot. Si prega di contattare l'amministratore.",
            chatbotIntegrationsRead:
                "Non hai il permesso di visualizzare le integrazioni del chatbot. Si prega di contattare l'amministratore.",
            chatbotArchiveRead:
                "Non hai il permesso di visualizzare l'archivio del chatbot. Si prega di contattare l'amministratore.",
            chatbotEntitiesRead:
                "Non hai il permesso di visualizzare le entità del chatbot. Si prega di contattare l'amministratore.",
            chatbotEntitiesCreate:
                "Non hai il permesso di creare entità del chatbot. Si prega di contattare l'amministratore.",
            chatbotEntitiesUpdate:
                "Non hai il permesso di aggiornare le entità del chatbot. Si prega di contattare l'amministratore.",
            chatbotEntitiesDelete:
                "Non hai il permesso di eliminare le entità del chatbot. Si prega di contattare l'amministratore.",
            chatbotReportRead:
                "Non hai il permesso di visualizzare i report del chatbot. Contatta il tuo amministratore.",
            chatbotTrainRead:
                "Non hai il permesso di visualizzare la formazione del chatbot. Contatta il tuo amministratore.",
            chatbotSegmentCreate:
                "Non hai il permesso di creare segmenti utente del chatbot. Contatta il tuo amministratore.",
            chatbotSegmentRead:
                "Non hai il permesso di visualizzare i segmenti utente del chatbot. Contatta il tuo amministratore.",
            chatbotSegmentUpdate:
                "Non hai il permesso di aggiornare i segmenti utente del chatbot. Contatta il tuo amministratore.",
            chatbotSegmentDelete:
                "Non hai il permesso di eliminare i segmenti utente del chatbot. Contatta il tuo amministratore.",
            integrationsRead:
                "Non hai il permesso di visualizzare la pagina delle integrazioni. Contatta il tuo amministratore.",
            whatsappIntegrationRead:
                "Non hai il permesso di visualizzare la pagina di integrazione di WhatsApp. Contatta il tuo amministratore.",
            instagramIntegrationRead:
                "Non hai il permesso di visualizzare la pagina di integrazione di Instagram. Contatta il tuo amministratore.",
            telegramIntegrationRead:
                "Non hai il permesso di visualizzare la pagina di integrazione di Telegram. Contatta il tuo amministratore.",
            integrationCreate: "Non hai il permesso di attivare le integrazioni. Contatta il tuo amministratore.",
            triggerCreate: "Non hai il permesso di creare trigger. Contatta il tuo amministratore.",
            triggerRead: "Non hai il permesso di visualizzare i trigger. Contatta il tuo amministratore.",
            triggerUpdate: "Non hai il permesso di aggiornare i trigger. Contatta il tuo amministratore.",
            triggerDelete: "Non hai il permesso di eliminare i trigger. Contatta il tuo amministratore.",
            billingRead: "Non hai il permesso di visualizzare le fatture. Si prega di contattare l'amministratore.",
            taskCreate: "Non hai il permesso di creare attività. Si prega di contattare l'amministratore.",
            taskRead: "Non hai il permesso di visualizzare le attività. Si prega di contattare l'amministratore.",
            taskUpdate: "Non hai il permesso di aggiornare le attività. Si prega di contattare l'amministratore.",
            taskDelete: "Non hai il permesso di eliminare le attività. Si prega di contattare l'amministratore.",
            calendarCreate:
                "Non hai il permesso di creare calendari/prenotazioni. Si prega di contattare l'amministratore.",
            calendarRead:
                "Non hai il permesso di visualizzare calendari/prenotazioni. Si prega di contattare l'amministratore.",
            calendarUpdate:
                "Non hai il permesso di aggiornare calendari/prenotazioni. Si prega di contattare l'amministratore.",
            calendarDelete:
                "Non hai il permesso di eliminare calendari/prenotazioni. Si prega di contattare l'amministratore.",
            mailCreate: "Non hai il permesso di creare e-mail. Si prega di contattare l'amministratore.",
            mailRead: "Non hai il permesso di visualizzare le e-mail. Si prega di contattare l'amministratore.",
            mailUpdate: "Non hai il permesso di aggiornare le e-mail. Si prega di contattare l'amministratore.",
            mailDelete: "Non hai il permesso di eliminare le e-mail. Si prega di contattare l'amministratore.",
        },
        message: {
            noConversationDesc: "Qui puoi vedere le chat attive e le chat assegnate a te.",
            forMe: "Per me",
            unAssigned: "Non assegnato",
            agentDetails: "Dettagli dell'agente",
            contactProperties: "Proprietà di contatto",
            goToProfile: "Vai al profilo",
            addNote: "Aggiungi nota",
            noPreferredAgent: "Nessun agente preferito ancora",
            toPrefer: "Preferire",
            inChat: "Nella chat",
            watching: "Guardando",
            chatsTitle: "Chat",
            dealyTimeMaxValueError: "Il tempo di ritardo può essere al massimo 15",
            dealyTimeTypeError: "Il valore del tempo di ritardo deve essere un numero",
            passedTimeHm: "{hour} Ore {min} Minuti",
            passedTimeMs: "{min} Minuti {sec} secondi",
            passedTimeSc: "{sec} Secondi",
            translateMessage: "Il tuo messaggio è stato tradotto dall'intelligenza artificiale.",
            toneChanged: "Il tono del messaggio è stato cambiato in {tone}",
            aiResponseAdded: "Risposta AI aggiunta al messaggio",
            messageLonger: "Messaggio reso più lungo",
            grammarFixed: "Grammatica corretta",
            aiTranslate: "Traduzione",
            other: "Altro",
            yourLanguage: "La tua lingua",
            myLanguage: "La mia lingua",
            forwardToChatbot: "Inoltra al Chatbot",
            friendly: "Amichevole",
            confident: "Sicuro",
            straightForward: "Diretto",
            casual: "Casuale",
            professional: "Professionale",
            longSentence: "Frase Lunga",
            changeTone: "Cambia Tonalità",
            fixGrammar: "Correggi Grammatica",
            aiResponse: "Risposta AI",
            templateButtonNote:
                "Per vietare il contatto, fare attenzione a utilizzare i seguenti testi sul pulsante di divieto. Indipendentemente dalle lettere maiuscole o minuscole",
            templateButtonTags: "#Invia messaggio# | #Annulla iscrizione# | #Vieta# | #Blocca#",
            dashboard: "Dashboard",
            adminReports: "Admin Reports",
            calendarModule: "Modulo calendario",
            taskModule: "Modulo di gestione delle attività",
            maxUrlButtonMessage: "You can add a maximum of 2 URL buttons.",
            noPreferredDepartment: "Nessun dipartimento preferito",
            searchForDepartment: "Cerca dipartimento",
            departmentAssignedToTheVisitor: "Seleziona il dipartimento che desideri assegnare al visitatore.",
            assignPreferredDepartment: "Assegna il dipartimento preferito",
            smsChannel: "Canale SMS: ",
            whatsappv2Channel: "Canale Whatsapp V2: ",
            whatsappv1Channel: "Canale Whatsapp V1: ",
            wBChannel: "Canale Whatsapp Business: ",
            messengerChannel: "Canale Messenger: ",
            instagramChannel: "Canale Instagram: ",
            allPlatforms: "Tutte le piattaforme",
            cbStartMessage: "Messaggio di avvio del chatbot",
            cbStartMessageDesc:
                "Il primo messaggio inserito dall'utente viene elaborato automaticamente dal chatbot e indirizzato all'indirizzo rilevante.",
            messengerUserProfile: "Profilo utente di Messenger",
            instagramUserProfile: "Profilo utente Instagram",
            noEventFound: "Nessun evento trovato",
            visitorMails: "Mail dei visitatori",
            visitorActions: "Azioni dei visitatori",
            notVerified: "Non verificato",
            visitorEvents: "Eventi dei visitatori",
            assignedTasks: "Compiti assegnati",
            mails: "Mail",
            prefferedAgents: "Agenti preferiti",
            createEvent: "Crea evento",
            blockManagement: "Gestione del blocco",
            deleteUser: "Elimina utente",
            blocked: "Bloccato",
            profiles: "Profili",
            similiarProfiles: "Profili simili trovati",
            ReplyAsAPm: "Rispondi come messaggio privato e chiudi",
            replyAsAComment: "Rispondi come commento e chiudi",
            messengerAddDesc: "Fai clic sul pulsante Connetti qui sotto e accedi al tuo account Facebook.",
            instaAddPrivacyCheckDesc: "Ho letto e accetto la {Privacy} e i {Terms and Conditions}",
            instaAddDesc5: "Fai clic sul pulsante Connetti qui sotto e accedi al tuo account Facebook.",
            instaAddDesc4: "Registrati come sviluppatore Facebook",
            instaAddDesc3: "Assicurati che il commutatore <b>'Consenti l'accesso ai messaggi'</b> sia attivato",
            instaAddDesc2:
                "Assicurati che il tuo account professionale Instagram sia collegato alla tua pagina Facebook",
            instaAddDesc1:
                "Assicurati che il tuo account Instagram sia un account professionale Instagram (account aziendale).",
            selectedDepartment: "Dipartimento selezionato",
            departmentForwardEnable: "Regola di inoltro del dipartimento abilitata",
            departmentForwardRule: "Regola di inoltro del dipartimento",
            departmentForwardDesc: "Seleziona a quale dipartimento inoltrare le chat in arrivo al canale.",
            channelName: "Nome del canale",
            forwardToLiveAgents: "👉 Inoltra agli agenti in diretta",
            manageIgChannel: "Gestisci il tuo canale Instagram",
            igDetail: "Dettaglio Instagram",
            manageVisibilityDesc: "Gestisci chi può vedere questo canale",
            selectAnIgAccount: "Seleziona un account Instagram",
            connectToInsta: "Collegati a Instagram",
            connectToMetaLeads: "Connect to Meta Leads",
            deleteInstaChannelInfo: "Sei sicuro di voler eliminare il canale Instagram?",
            instagramChannels: "Canali Instagram",
            suspendedDescription: "Il tuo account è stato sospeso a causa di fatture non pagate.",
            onlyChatbot: "Solo Chatbot",
            onlyAgents: "Solo Agenti",
            checkboxWarning: "Questo campo deve essere obbligatoriamente selezionato",
            sendingAllow: "Invio",
            receiving: "Ricezione",
            platform: "Piattaforma",
            banModalTitle: "Finestra modale di divieto visitatori",
            selectDepartmentDesc: "Seleziona i dipartimenti di cui vuoi modificare la visibilità",
            selectAgentDesc: "Seleziona gli agenti di cui vuoi modificare la visibilità",
            selectDepartment: "Seleziona Dipartimento",
            selectAgent: "Seleziona Agente",
            visibleDepartments: "Dipartimenti visibili",
            visibleAgents: "Agenti visibili",
            visibilityInfoCont: "Tutti gli agenti e i dipartimenti possono vedere questo canale",
            editDepartmentVisibility: "Modifica visibilità del dipartimento",
            editAgentVisibility: "Modifica visibilità dell'agente",
            typeSTToSearch: "Digita qualcosa per cercare gli utenti",
            exportToCSV: "Esporta in CSV",
            clear: "Cancella",
            usedSessionCount: "Numero di sessioni utilizzate",
            maxSessionCount: "Numero massimo di sessioni",
            leftSessionCount: "Numero di sessioni rimanenti",
            planManagement: "Gestione del piano",
            teamChat: "Chat di squadra",
            templateNameIsNotValid: "Il nome del modello non è valido",
            relatedAdvertisement: "Pubblicità correlata",
            whatsappNumber: "Numero di Whatsapp",
            integrationsWhatsappV1:
                "È necessario un piano WhatsApp per una comunicazione senza problemi tra Supsis e WhatsApp.",
            integrationsWhatsappV2: "Puoi facilmente condividere le informazioni della chat tra Supsis e WhatsApp.",
            integrationsWhatsappBusiness:
                "Puoi trasmettere rapidamente e comodamente le informazioni della chat tra Supsis e WhatsApp.",
            selectDays: "Seleziona giorni",
            addTime: "Aggiungi ora",
            instagramContactList: "Lista contatti Instagram",
            archiveAllRated: "Recupera tutte le conversazioni con qualsiasi valutazione.",
            allChannels: "Tutti i canali",
            comment: "commento",
            news: "cosa c'è di nuovo",
            speechTermination: "Terminazione del discorso",
            noSystemMessage: "Nessun messaggio di sistema",
            supsisCustomerService: "Supsis Servizio Clienti,",
            supsisClickExperience: "Clicca per provare l'esperienza",
            customerPage: "Pagina cliente",
            buttonTitle: "Titolo del pulsante",
            buttonType: "Tipo di pulsante",
            buttonSendMessage: "Invia messaggio",
            buttonGoToBlock: "Vai al blocco",
            buttonOpenUrl: "Apri URL",
            buttonPhoneCall: "Chiamata telefonica",
            buttonOpenMoment: "Apri Momento",
            buttonCloseChat: "Chiudi chat",
            buttonTransferChat: "Trasferisci chat",
            buttonCreateTicket: "Crea ticket",
            you: "Tu",
            and: "e",
            deleteVisitor: "Elimina visitatore",
            dndBlocked: "Blocco DND",
            tokenCopied: "Token copiato",
            apiIntegration: "Integrazione API",
            generateToken: "Genera token",
            copyToken: "Copia token",
            labels: "Etichette",
            noData: "Nessun dato",
            color: "Colore",
            titleColor: "Colore del titolo",
            secondTitleColor: "Colore del secondo titolo",
            tag_name_indicator: "Nome dell'etichetta",
            sendMessage: "Invia messaggio",
            removeFromG: "Rimuovi dal gruppo",
            delChannel: "Sei sicuro di voler eliminare questo canale?",
            new_name: "Nuovo nome",
            set_group_info: "Modifica informazioni di gruppo",
            shortcut_desc_num: "Passa da una conversazione all'altra con cifre numeriche",
            copilot_desc_num: "Ti consente di aprire Copilot nella schermata della chat",
            typing_w_chat: "sta scrivendo...",
            edit_group_info: "Modifica informazioni del gruppo",
            notif_sound: "Attiva i suoni delle notifiche",
            notif_mute: "Silenzia le notifiche",
            leave: "Lasciare",
            group: "Gruppo",
            updateTag: "Aggiorna Tag",
            ordered_desc: "Assegna le chat ai rappresentanti in ordine.",
            random_desc: "Assegna le chat ai rappresentanti in modo casuale.",
            Rrobin_desc:
                "Assegna le chat ai rappresentanti in modo round robin. (Priorità ai rappresentanti meno occupati)",
            RrobinRev_desc:
                "Assegna le chat ai rappresentanti in modo round robin inverso. (Priorità ai rappresentanti più occupati)",
            algo_desc: "Seleziona l'algoritmo per l'assegnazione automatica delle chat",
            algorithm: "Algoritmo",
            os_browser: "Sistema operativo e browser",
            addTag: "Aggiungi tag",
            tags: "Tag",
            searchRepresentative: "Ricerca rappresentante",
            preferredRepresentative: "Rappresentante preferito",
            voting: "Votazione",
            chatWidget: "Widget chat",
            webhooks: "Webhooks",
            selectHooks: "Seleziona hooks",
            planRequired: "{integratable} Piano Obbligatorio.",
            allIntegrations: "Tutte le integrazioni",
            disableAgentSystemMessages: "Disabilita i messaggi di sistema dell'agente",
            disableAgentSystemMessagesDesc: "Nascondi messaggi di sistema dell'agente.",
            disableAutoTranslate: "Disabilita la traduzione automatica",
            disableAutoTranslateDesc:
                "Traduce automaticamente i messaggi da diverse lingue. In questo modo puoi comunicare più facilmente con i tuoi clienti.",
            shouldAddMethod:
                "È necessario compilare il campo Metodo di pagamento e indirizzo di fatturazione!\nNessun denaro verrà prelevato dal tuo conto.\n" +
                "Alla fine del mese, verrà creata una fattura in base all'importo dell'utilizzo.",
            approveSelection: "Approva selezione",

            trialDaysEndSelectPlan: "Conferma la selezione del piano",
            trialDaysEndSelectPlanDesc:
                "La tua versione di prova è terminata. Devi confermare selezionando il piano qui sotto.",
            infinitePlay: "Riproduzione infinita",
            hideBubbleOnMobile: "Nascondi la bolla sul cellulare",
            deleteSystemLanguage: "dal sistema {code} si asciuga la lingua",
            assignedChat: "Chat assegnata",
            check: "Controllo",
            systemStatus: "Stato del sistema",
            chatAssignedToUser: "Chat assegnata a {user}",
            inactiveThresholdTime: "Tempo limite inattivo (minuti)",
            tippyInactiveThresholdTime:
                "Se non viene inviato alcun messaggio entro il tempo stabilito, la conversazione è considerata passiva, inserire il valore (minuti). Minimo 1 minuto e massimo 120 minuti.",
            inactiveTerminateTime: "Tempo limite di inattività (minuti)",
            tippyInactiveTerminateTime:
                "Se non viene inviato alcun messaggio entro il tempo stabilito, la conversazione viene terminata, inserire il valore (minuti). Minimo 1 minuto e massimo 120 minuti.",
            removePendingMessage: "Rimuovi messaggio in sospeso",
            disconnected: "Disconnesso",
            visitorWriteEmptyChatTippy: "Il visitatore può scrivere senza che l'agente sia connesso.",
            visitorWriteEmptyChat: "Il visitatore può scrivere senza che l'agente sia connesso.",
            visitorConnectionEventSystemMessageEnabled:
                "Il visitatore è entrato e ha abilitato i messaggi di sistema del visitatore.",
            visitorConnectionEventSystemMessageEnabledTippy:
                "Il visitatore è entrato e ha abilitato i messaggi di sistema del visitatore.",
            openBubble: "Apri bolla",
            changeLogo: "Cambia logo",
            changePhoto: "Cambia foto",
            addPhoto: "Aggiungi una foto",
            seePhoto: "Guarda la foto",
            deletePhoto: "Eliminare la foto",
            askQuestion: "Fai una domanda",
            locationPermsNeeded:
                "Per utilizzare la funzione di condivisione della posizione, è necessario abilitare i permessi di posizione.",
            useMyLocation: "Usa la mia posizione",
            acceptingChat: "Accettazione chat",
            notAcceptingChat: "Non accettazione chat",
            websiteChatWidgetIntegration: "Integrazione del widget di chat del sito web",
            loggedOut: "Disconnesso",
            listStatuses: "Stati della lista",
            hideInactiveAgents: "Nascondi agenti inattivi",
            hideMinorValues: "Nascondi valori minori",
            agentActivities: "Attività dell'agente",
            newHASHContent: "Nuovo contenuto HASH",
            hash: "HASH",
            languageRemovalQuestion: "dal sistema {code} Stai per cancellare la tua lingua!",
            blockBy: "Rappresentante",
            hashText: "Biglietto",
            exampleHash: "tracciamento dell'ordine",
            notValidHash: "Non deve contenere spazi",
            videoCallEnabledDesc: "Attiva per abilitare la funzione di videochiamata",
            videoCallEnabled: "Videochiamata",
            audioCallDesc: "Attiva per abilitare la funzione di chiamata audio",
            audioCallEnabled: "Funzione di ricerca vocale",
            assignPreferredAgent: "Assegna agente preferito",
            representativeAssignedToTheVisitor: "Seleziona l'agente preferito che desideri assegnare al visitatore.",
            agentFileSendEnabledDesc: "Consente ai delegati di inviare file",
            agentFileSendEnabled: "I delegati possono inviare file",
            visitorFileSendEnabledDesc: "Consente ai visitatori di inviare file",
            visitorFileSendEnabled: "I visitatori possono inviare file",
            visitorAutoLogin: "Accesso automatico del visitatore",
            visitorAutoLoginDesc: "Il visitatore viene automaticamente connesso al sistema",
            agentVoiceRecordEnabledDesc: "I rappresentanti possono abilitare la funzione di registrazione vocale",
            agentVoiceRecordEnabled: "I rappresentanti possono registrare la voce",
            visitorVoiceRecordEnabledDesc: "I visitatori possono abilitare la funzione di registrazione vocale",
            visitorVoiceRecordEnabled: "I visitatori possono registrare la voce",
            startVideoCall: "Videochiamata",
            startAudioCall: "Chiamata audio",
            visitorGDPRDeleteEnabledDesc: "I visitatori possono eliminare tutte le informazioni",
            visitorGDPRDeleteEnabled: "I visitatori possono eliminare tutte le informazioni",
            visitorLocationEnabled: "I visitatori possono condividere la posizione",
            visitorLocationEnabledDesc: "I visitatori possono condividere la posizione",
            customerLocationEnabled: "I rappresentanti possono condividere la posizione",
            customerAutoMergeEnabled: "Unisce automaticamente le stesse persone",
            customerAutoMergeEnabledDesc:
                "Questa funzione effettua automaticamente l'unione dei dati relativi alle stesse persone in modo efficace. Ciò assicura che gli utenti con profili simili siano rappresentati in modo più coerente e ordinato nei set di dati.",
            chatAiCopilot: "Assistente chat AI",
            chatAiCopilotDesc:
                "Rispondi automaticamente alle domande dei tuoi clienti utilizzando l'Assistente chat AI",
            customerLocationEnabledDesc: "I rappresentanti possono condividere la posizione",
            triggerAlreadyExists: "Il trigger esiste già",
            ticketStatusForm: "Titolo dello stato del ticket",
            statusFormTitle: "Titolo",
            allStatus: "Tutti gli stati",
            triggers: "Trigger",
            trigger: "Trigger",
            noTrigger: "Nessun trigger",
            triggerSkipLoginForm: "Modulo di accesso",
            triggerSkipLoginFormTrue: "Mostra modulo di accesso",
            triggerSkipLoginFormFalse: "Salta il modulo di accesso e passa direttamente al messaggio",
            noContent: "Nessun contenuto",
            toCreate: " per creare",
            clickTheButton: "Clicca il pulsante",
            triggerContent:
                " per creare un trigger. I trigger sono utilizzati per inviare messaggi automatici ai visitatori in base alle condizioni impostate.",
            triggerDrag: "Trascina e rilascia i trigger per riordinarli.",
            triggerNewCondition: "Nuova condizione",
            triggerNoConditionDescription1:
                "Ziyaretçi sayfasında aynı koşullara sahip tetikleyicilerden yalnızca bir tanesi aktif olarak gözükür.",
            triggerNoConditionDescription2:
                "Eğer bir tetikleyiciyi aktif olarak görmek istiyorsanız, diğer tetikleyicilerin koşullarını değiştirmeniz gerekmektedir.",
            triggerShowAndHide: "Tetikleyiciyi göster/gizle",
            countryLanguage: "Paese/Lingua",
            addTrigger: "Aggiungi trigger",
            yesPlease: "Sì grazie!",
            noThanks: "No grazie.",
            firstAnswer: "Prima risposta",
            secondAnswer: "Seconda risposta",
            noTitle: "senza titolo",
            sumChat_MediaFile: "Media e documenti",
            importantWarning: "AVVERTENZA IMPORTANTE!",
            images: "Immagini",
            URLS: "Collegamenti",
            files: "File",
            warning: "Attenzione!",
            noCondition: "Nessuna condizione",
            showTriggers: "Mostra trigger",
            showThisTrigger: "Mostra questo trigger",
            hideTriggers: "Nascondi trigger",
            hideThisTrigger: "Nascondi questo trigger",
            updateTrigger: "Aggiorna trigger",
            conditions: "Condizioni",
            messageDurationPerRow: "Durata del messaggio (per riga)",
            dayTime: "Orario di lavoro",
            weekDay: "Giorno della settimana",
            spendTimePage: "Tempo trascorso sulla pagina",
            spendTimeSite: "Tempo trascorso sul sito",
            pageUrl: "URL della pagina",
            pageTitle: "Titolo della pagina",
            equal: "Uguale",
            not_equal: "Non uguale",
            less_than: "Minore di",
            greater_than: "Maggiore di",
            less_than_or_equal: "Minore o uguale",
            greater_than_or_equal: "Maggiore o uguale",
            visitorName: "Nome del visitatore",
            seconds10: "10 secondo",
            seconds30: "30 secondo",
            minute1: "1 minuto",
            minutes5: "5 minuto",
            minutes10: "10 minuto",
            minutes30: "30 minuto",
            hour1: "1 ora",
            hours2: "2 ora",
            hours4: "4 ora",
            hours8: "8 ora",
            hours12: "12 ora",
            hours24: "24 ora",
            maxCondition: "Massimo 5 condizioni",
            doYouWishToDeleteTrigger: "Vuoi eliminare il trigger?",
            contains: "Contiene",
            not_contains: "Non contiene",
            chatLanguage: "Lingua della chat",
            translating: "Traduzione",
            liveSupportStartingWait: "Live support starting, please wait...",
            noConnection: "No connection",
            buyWhatsapp: "Buy Whatsapp",
            integrations: "Integrations",
            refundInvoiceSure: "Are you sure you want to refund this invoice?",
            invoiceMarkedAsPaidSuccess: "Invoice marked as paid successfully.",
            invoiceMarkedAsPaidError: "Invoice marked as paid error.",
            deleteConfirm: "Questo {object} Vuoi davvero eliminare?",
            markPaidConfirm: "Sei sicuro di voler contrassegnare questa fattura come pagata?",
            startChatDesc: "Inizia una chat con i visitatori",
            addLink: "Aggiungi link",
            selectStep: "Seleziona passo: ",
            addGOTO: "Aggiungi GOTO",
            sendFastLink: "Invia link di accesso senza password",
            or: "o",
            allTags: "Tutti i tag",
            showDetail: "Mostra dettagli",
            hideDetail: "Nascondi dettagli",
            weLlSendPhone: "Invieremo un SMS",
            weLlSendEmail: "Invieremo un'e-mail",
            linkSentToPhone: "Link inviato al tuo telefono",
            offerlinkSendToPhone: "Invieremo un SMS con il link per scaricare l'applicazione.",
            offerlinkSendToMail: "Invieremo un'e-mail con il link per scaricare l'applicazione.",
            theEmail: "L'email",
            differentEmail: "diverso dall'email di registrazione",
            linkSentToMailBox: "Link inviato alla tua casella di posta",
            errorOccurred: "Si è verificato un errore !",
            clickStoreIcon: "Fai clic sull'icona del tuo negozio",
            meetWithSupsis: "Incontra Supsis",
            downloadMobileApps: "Scarica le app mobili",
            getApps: "Ottieni le app",
            info: "Informazioni",
            conversationHistory: "Cronologia della conversazione",
            planInfoHeader: "Informazioni sul piano",
            planInformation:
                "il tuo piano {selectedPlan} Piano ({detailMaxAgentCount} Rappresentante) ({freeAgent} agente libero)",
            creditAvailable: "Il tuo credito agente disponibile sul tuo piano: ",
            upDownGradePlan: "Se desideri eseguire l'upgrade/downgrade del tuo piano, per favore",
            click: "clicca",
            all: "Tutti",
            allDepartments: "Tutti i dipartimenti",
            preferredLanguage: "Lingua preferita",
            kmkAutoDepartmentBind: "KMK Auto Department Bind",
            kmkAutoDepartmentBindDesc: "KMK Auto Department Bind",
            visitorEmailUpdated: "Email del visitatore aggiornata",
            visitorEmailIsNotValid: "L'email del visitatore non è valida",
            visitorNameUpdated: "Nome del visitatore aggiornato",
            clickToEdit: "Clicca per modificare",
            addEmail: "+ Aggiungi e-mail",
            addFullname: "+ Aggiungi nome completo",
            partner: "Partner",
            isIntegrated: "Integrato",
            agentCount: "Conteggio agente",
            autoStartChat: "Chat di avvio automatico",
            bubbleColor: "Colore della bolla",
            openFolder: "Apri cartella",
            preDefined: "Predefinito",
            customIcon: "Icona personalizzata",
            theme: "Tema",
            themeSettings: "Impostazioni del tema",
            chatThemeSettings: "Impostazioni del tema della chat",
            bubbleSettings: "Impostazioni della bolla",
            inputHeightOfBubble: "Altezza della bolla",
            inputPixelsOfChatBubble: "Pixel della bolla di chat",
            modalTitleIsMarginAsPixelInfo: "Distanza della bolla della chat dai bordi :  ",
            inputPxOfXaxis: "Posizione orizzontale",
            inputPxOfYaxis: "Posizione verticale",
            inputPxOfMobileXaxis: "(Mobile) Posizione orizzontale",
            inputPxOfMobileYaxis: "(Mobile) Posizione verticale",
            animations: "Animazioni",
            preferredAnimation: "Animazione preferita",
            selectAnAnimation: "Seleziona un'animazione",
            inputOfBubbleMessage: "Aggiungi contenuto a enormi bolle di chat.\n{contentOfChatBubble}",
            showChatBubbleOnlyLoggedUserToolTip:
                "Impostazione per nascondere il fumetto della chat in base allo stato di accesso. Se è disattivato, verrà mostrato a tutti i visitatori.",
            showChatBubbleOnlyLoggedUser: "Mostra la bolla solo agli utenti che hanno effettuato l'accesso. (ideasoft)",
            helloDoUNeedHelp: "Ciao, posso aiutarti!",
            bubbleIcon: "Icona della bolla",
            overrideMargins: "Override Margins",
            autoHideBubble: "Nascondi automaticamente la bolla",
            vtippyAutoHideBubble: "Nasconde automaticamente la bolla dopo 5 secondi.",
            hideBubble: "Nascondi la bolla",
            vtippyHideBubble: "Nasconde la bolla.",
            overrideMobileMargin: "Override Mobile Margin",
            vtippyMobileMargin: "Mobile için margin değerini override eder.",
            vtippyHideBubbleOnMobile: "Il fumetto della chat è nascosto agli utenti mobili.",
            isFabsActive: "Mostra popup",
            bubbleOpenableMenu: "Menu a discesa della bolla della chat",
            vtippyIsFabsActive: "Impostazione per mostrare/nascondere i menu a comparsa",
            vtippyIsFabsAsIcon: "È l'impostazione della visualizzazione delle icone nel menu a discesa.",
            vtippyTranslateButton: "Traduce la lingua selezionata in altre lingue.",
            vtippyTranslateClearButton: "Pulisce la traduzione.",

            vtippySelectnotification: "Seleziona la notifica",
            vtippyVoiceLevel: "Impostazione del livello di volume",
            vtippyStartVoice: "Avvia la notifica vocale",
            vtippyInfiniteNotification:
                "Impostazione per riprodurre la notifica vocale in modo continuo. (Se è disattivato, verrà riprodotto solo una volta.)",

            vtippyNewVisitorNotification: "Impostazione per la notifica vocale dei nuovi visitatori.",
            vtippyNewChatNotification: "Impostazione per la notifica vocale dei nuovi chat.",
            vtippyNewConversationNotification: "Impostazione per la notifica vocale delle nuove conversazioni.",
            vtippyNewMessageNotification: "Impostazione per la notifica vocale dei nuovi messaggi.",
            vtippyPrivateMessageNotification: "Impostazione per la notifica vocale dei messaggi privati.",

            isFabsAsIcon: "Mostra icone",
            setMarginAsPixel: "Imposta margini come pixel",
            returnDefaultMargins: "Ripristina i margini predefiniti",
            closePreviewColors: "Chiudi anteprima colori",
            previewColors: "Anteprima colori",
            videoCalls: "Chiamate video",
            filterLost: "Filtro perso",
            vtipyCustomLogin:
                "Se è attivato, il sistema di accesso personalizzato verrà utilizzato per l'accesso. (Se è disattivato, il sistema di accesso predefinito verrà utilizzato per l'accesso.)",
            vtipyLoginlessChat:
                "Se è attivato, il sistema di accesso personalizzato verrà utilizzato per l'accesso. (Se è disattivato, il sistema di accesso predefinito verrà utilizzato per l'accesso.)",
            loginlessChat: "Chat senza accesso",
            imageUrl: "URL dell'immagine",
            replied: "Risposto",
            solved: "Risolto",
            openImage: "Apri immagine",
            writeFeedback: "Scrivi un feedback",
            feedbackFailed: "Invio del feedback non riuscito.",
            feedbackSuccessful: "Feedback inviato con successo.",
            sendFeedback: "Invia feedback",
            errorReport: "Segnala un errore",
            sendErrorFeedBack: "Invia feedback di errore",
            successImgUpload: "Immagine caricata con successo",
            successImgDelete: "Immagine eliminata con successo.",
            errorImgUpload: "Errore durante il caricamento dell'immagine",
            errorImgDelete: "Si è verificato un errore durante l'eliminazione dell'immagine",
            chatBotEndStatics: "Statistiche di fine chatbot",
            videoCallDist: "Distanza della chiamata video",
            deleteSite: '" {siteName} " Eliminare il sito?',
            deleteThisSite: "Elimina questo sito",
            departmentInfo: "Informazioni sul dipartimento",
            infoAboutDepartment: "Informazioni sul dipartimento",
            deleteDepartmentQuestion: "Eliminare il dipartimento?",
            departmentDeleted: "Dipartimento eliminato",
            departmentTitle: "Titolo del dipartimento",
            updateDepartmentForm: "Modulo di aggiornamento del dipartimento",
            updateCompleted: "Aggiornamento completato",
            CatalogUpdatedSuccessfully: "Catalogo aggiornato con successo",
            integrateSupsiswithIntegratable:
                "Supsis e {integratable} Trasmetti facilmente le informazioni sulla chat tra",
            installationOK: "Caricato",
            newDepartmentForm: "Nuovo modulo di registrazione del dipartimento",
            newDepartment: "Nuovo dipartimento",
            departmentSaved: "Dipartimento salvato",
            sameDepartment: "C'è un dipartimento con lo stesso nome",
            sameValue: "C'è un valore con lo stesso nome!",
            departments: "Dipartimenti",
            department: "Dipartimento",
            announcements: "Annunci",
            announcement: "Annuncio",
            newAnnouncement: "Nuovo annuncio",
            announcementInfo: "Informazioni sull'annuncio",
            infoAboutAnnouncement: "Informazioni sull'annuncio",
            deleteAnnouncementQuestion: "Eliminare l'annuncio?",
            announcementDeleted: "Annuncio eliminato",
            announcementTitle: "Titolo dell'annuncio",
            updateAnnouncementForm: "Modulo di aggiornamento dell'annuncio",
            newAnnouncementForm: "Nuovo modulo di registrazione dell'annuncio",
            announcementSaved: "Annuncio salvato",
            chatTimingSettings: "Impostazioni di temporizzazione della chat",
            assetOversize: "La dimensione del file deve essere inferiore a 10 MB",
            assetOversizeMB: "La dimensione del file che desideri inviare non deve superare i {mb} MB.",
            assetOversizeWithExt: "La dimensione del file deve essere inferiore a 10 MB. ({ext})",
            messageDeleted: "Messaggio eliminato",
            filterVideoCall: "Filtra le chiamate video",
            filterLostChat: "Filtra le chat perse",
            filterClosedByAgent: "Filtra le chat chiuse dall'agente",
            notificationText: "Testo della notifica ",
            notificationTitle: "Titolo della notifica",
            deniedText: "Le tue notifiche sono chiuse, devi attivarle per non perdere i tuoi clienti.",
            deniedTitle: "Per favore, attiva le notifiche",
            deniedHeader: "Notifiche disattivate",
            showNotificationGuide: "Clicca per vedere i dettagli",
            howToEnableNotification: "Come posso abilitare le notifiche",
            notificationOK: "OK",
            notificationUnderstood: "Compreso!",
            notificationCancel: "Annulla",
            howToEnableNotificationInstruction1:
                "Fare clic sull'icona del lucchetto nella barra degli indirizzi del browser",
            howToEnableNotificationInstruction2: "Se Notifiche è disabilitato nella sezione Autorizzazioni, abilitalo",
            howToEnableNotificationInstruction3:
                'Se "Notifiche" è disabilitato nella sezione "Autorizzazioni", abilitarlo',
            howToEnableNotificationInstruction4:
                'Se "Notifiche" è disabilitato nella sezione "Autorizzazioni", abilitarlo',
            checkPaymentMethod: "Controlla il metodo di pagamento",
            pushNotificationEnabled: "Notifiche push abilitate",
            pushNotificationDenied: "Notifiche push negate",
            suspendedMessage: "Il tuo account è stato sospeso",
            enableNotification: "Abilita notifiche",
            languageSettings: "Impostazioni della lingua",
            problemsSound:
                "Se non senti il suono, controlla le impostazioni del tuo browser. (Se il problema persiste, contatta il tuo amministratore.)",
            betweenRepresentative: "Tra rappresentante",
            desktopNotifications: "Notifiche desktop",
            notificationDisable: "Notifiche disabilitate",
            notificationEnabled: "Notifiche abilitate",
            newMessageAlert: "Nuovo messaggio",
            newConversationAlert: "Nuova conversazione",
            chatBot: "Chatbot",
            ticketResponse: "Risposta al ticket: ",
            archived: "Archiviato",
            chatbotChatCount: "CHATBOT",
            closeChat: "Chiudi chat",
            ticket: "Ticket",
            formStep: "Passaggio del modulo",
            menuStep: "Passaggio del menu",
            contentStep: "Passaggio del contenuto",
            menuTitle: "Titolo del menu",
            messageContent: "Contenuto del messaggio",
            goToLive: "Vai in diretta",
            prevStep: "Passaggio precedente",
            button: "Pulsante",
            addImage: "Immagine",
            addText: "Testo",
            stepTitle: "Titolo del passaggio",
            addTicket: "Ticket",
            formDescription: "Domanda",
            addInput: "Domanda",
            addRandomText: "Testo casuale",
            changeTitle: "Cambia titolo",
            changeVisitorTitle: "Cambia indirizzo visitatore",
            catalog: "Catalogo",
            openTheCatalog: "Apri il catalogo",
            catalogNotOpen:
                "Il catalogo non è aperto. Per aprire il catalogo, vai alla sezione Impostazioni e attiva il catalogo.",
            showCatalogCategories: "Mostra categorie",
            showChatBot: "Mostra chatbot",
            openCatalog: "Apri catalogo",
            unreadMessages: "Messaggi non letti",
            personalFirstMsg: "Primo messaggio personale",
            personalRating: "Valutazione personale",
            soundSettings: "Impostazioni audio",
            newPrivateMessage: "Nuovo messaggio privato",
            addNewGroup: "Creare un nuovo gruppo",
            newMessage: "Nuovo messaggio",
            newConversation: "Nuova conversazione",
            newVisitor: "Nuovo visitatore",
            chatPosition: "Posizione della chat",
            bottomLeftCorner: "angolo in basso a sinistra",
            leftDocked: "lasciato ancorato",
            bottomRightCorner: "nell'angolo in basso a destra",
            rightDocked: "agganciato a destra",
            chatPositionSelect: "Seleziona la posizione della chat",
            teamChatGroup: "Messaggi di gruppo",
            teamChatDepartment: "Messaggi del dipartimento",
            teamChatTeam: "Messaggi di squadra",
            teamChatDm: "Messaggi DM",
            bottomLeft: "In basso a sinistra",
            left: "Sinistra",
            bottomRight: "In basso a destra",
            right: "Destra",
            mailorname: "Email o nome",
            breaksByTime: "Interruzioni per tempo",
            clPlaceholder: "Scrivi un messaggio",
            fieldName: "Nome",
            value: "Valore",
            addSetting: "Aggiungi impostazione",
            globalSettings: "Impostazioni globali",
            target: "Target",
            duration: "Durata",
            arrivalCount: "Conteggio di arrivo",
            bootMaxLife: "Durata massima di avvio",
            startLoadTest: "Avvia test di carico",
            noClusterInstanceFound: "Nessuna istanza cluster trovata",
            stopLoadTest: "Ferma il test di carico",
            integrationDesc: "Descrizione dell'integrazione",
            integrationDemoCode: "Codice demo di integrazione",
            integrationWindow: "Finestra di integrazione",
            notIntegrated: "Non integrato",
            help: "Aiuto",
            notIntegratedDesc:
                "Non hai ancora integrato il tuo sito web. Per integrare il tuo sito web, vai alla sezione Impostazioni e segui le istruzioni.",
            backToLogin: "Torna al login",
            passwordlessLoginUnsuccessful: "Il login senza password non è riuscito. Per favore, riprova.",
            passwordlessLogin: "Login senza password",
            loginWithEmail: "Accedi con e-mail",
            loginWithPassword: "Accedi con password",
            enteringPasswordless: "Stai entrando nel tuo account senza password",
            toMainPath: "Vai al percorso principale",
            userRoleChanged: "Il ruolo dell'utente è stato modificato",
            passwordChangeSuccess: "La password è stata modificata con successo",
            feedback: "Feedback",
            showFeedbackHistory: "Mostra cronologia dei feedback",
            newSelfServiceSite: "Nuovo sito di self-service",
            subdomain: "Sottodominio",
            rootUserEmail: "Email",
            rootUserName: "Nome",
            newVersion: "Nuova versione",
            closeLiveSupport: "Chiudi supporto live",
            newVersionShort: "Nuova versione",
            bannedWordRestrict: "Restrizione parole vietate",
            ticketShow: "Consentire ai clienti di creare ticket",
            ticketShowDesc: "Attivare l'opzione di creazione ticket nel menu della chat",
            autoLoadIframe: "Iframe di caricamento automatico",
            autoLoadIframeDesc: "Carica automaticamente l'iframe sul tuo sito web",
            bannedWordRestrictDesc: "Se abilitato, i messaggi contenenti parole vietate non verranno inviati",
            agentDown: "Agente inattivo",
            delayChat: "Ritardo chat",
            tableSettingTippy: "Impostazioni tabella",
            tableSettings: "Impostazioni tabella",
            tableSettingsInfo:
                "Seleziona le colonne che desideri visualizzare nella tabella. Le impostazioni verranno salvate automaticamente.",
            privateParametry: "Parametri utente personalizzati",
            systemOperetor: "Informazioni di sistema",
            cityAndDistrict: "Città/Paese",
            general: "Generale",
            availability: "Disponibilità",
            home: "Home",
            successful: "Riuscito",
            forgetPasswordSent: "Ti abbiamo inviato un'e-mail per reimpostare la password.",
            saturday: "Sabato",
            friday: "Venerdì",
            thursday: "Giovedi",
            wednesday: "Mercoledì",
            tuesday: "Martedì",
            monday: "Lunedì",
            sunday: "Domenica",
            download: "Scarica",
            calendarPassedTimeHour: "{hour} ora {name}",
            calendarPassedTime: "{hour} ora {min} dk {name}",
            calendarPassedTimeMinSec: "{min} dk {sec} sn {name}",

            calendarPassedTimeMin: "{value} dk {name}",
            calendarPassedTimeSec: "{hour} ora {min} dk {sec} sn {name}",
            workScheduleOneDay: "{name} Dell'utente {sDate} Calendario del lavoro giornaliero",
            workSchedule: "{name} Il tuo nome utente {sDate} - {eDate} Tra orario di lavoro",
            calendar: "Calendario",
            noRating: "Nessuna valutazione",
            rateDist: "Distribuzione delle valutazioni",
            distConversation: "Distribuzione della conversazione",
            distributionConversa: "Distribuzione della conversazione",
            distChatbotAgent: "Chatbot & Agente",
            distAgent: "Agente",
            distFugitive: "Discorso mancato e discorso ricevuto",
            distLive: "Live Cha",
            distChatbot: "Chatbot",
            distComplex: "Complesso",
            distHandled: "Gestito",
            distMissed: "Mancato",
            distWeb: "Web",
            distWhatsapp: "Whatsapp",
            distTelegram: "Telegram",
            distInstagram: "Instagram",
            totalWhatsappChatCount: "Totale chat Whatsapp",
            statsByTime: "Statistiche per tempo",
            selectRep: "Seleziona rappresentante",
            allRepresentatives: "Tutti i rappresentanti",
            avgRating: "Distribuzione punti ({point}) ({count} valutazione)",
            avgFirstMessageTime: "Tempo medio del primo messaggio ",
            totalBreakTime: "Tempo totale di pausa",
            totalBreakNum: "Numero totale di pause",
            averageConTime: "Tempo medio di conversazione",
            multiWpReportTitle: "Conteggio conversazioni multiple Whatsapp",
            multiWpReport: "Numero di chat multiple di WhatsApp",
            multiWpReportExplanation: "Puoi vedere la quantità di chat dei tuoi canali  Whatsapp.",
            longestConTime: "Tempo di conversazione più lungo",
            shortestConTime: "Tempo di conversazione più breve",
            refresh: "Ricarica",
            waitingReply: "In attesa di risposta",
            organizationName: "Nome dell'organizzazione",
            companySlogan: "Nome lungo dell'organizzazione",
            messageSentErr: "Errore nell'invio del messaggio",
            messageSent: "Messaggio inviato",
            openPrivateChat: "Apri chat privata",
            escKey: "Premi Esc per chiudere",
            archiveChatKey: "Premi Ctrl + E per archiviare la chat",
            chatCopilot: "Attiva Chat CoPilot",
            privateChat: "Chat privata",
            multiModeAlertDesc:
                "Se abilitato, i rappresentanti possono gestire più chat contemporaneamente. Se disabilitato, i rappresentanti possono gestire solo una chat alla volta.",
            useHereText: "Usa qui",
            brandVisibility: "Visibilità del marchio",
            focusInput: " Inserisci il tuo messaggio qui",
            send: "Invia",
            notYet: "Non ancora",
            sending: "Invio",
            onlyRepresentative: "Solo rappresentante",
            yourMessage: "Il tuo messaggio",
            liveFabListDescription: "Live Chat",
            messengerIntegrationDesc:
                "Chatta con i tuoi clienti tramite la pagina Facebook, invia messaggi automatici con il chatbot.",
            checkDepartmentToAgent: "Controlla il Dipartimento per l'Agente Online",
            ifAllOfflineStory: "Storia per Indirizzare se Tutti Offline",
            AssignMessagesToAgents: "Assegna Tutti i Messaggi agli Agenti",
            firstChatbotAndAssign: "Prima risponde il Chatbot e poi viene assegnato a un agente",
            hybridAssign:
                "Il sistema controlla il dipartimento per vedere se c'è un agente online, e se non c'è un agente online, lo assegna al chatbot.",
            ticketFabListDescription: "Ticket",
            whatsappFabListDescription: "Whatsapp",
            phoneFabListDescription: "Telefono",
            emailFabListDescription: "E-mail",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Twitter",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "YouTube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "a questa zona {channelLink} Puoi mettere il link del tuo canale.",
            typeYourAccountLink: "a questa zona {accountLink} Puoi mettere il link del tuo canale.",
            typeYourMessage: "Il tuo messaggio",
            typeYourMessageMail:
                "Il messaggio inserito in questo campo verrà inviato dal Cliente come primo messaggio all'indirizzo e-mail sopra indicato.",
            typeYourMessageDesc:
                "Il messaggio inserito in questo campo verrà inviato dal Cliente come primo messaggio all'indirizzo e-mail sopra indicato.",
            sendNumber: "Numero di telefono a cui inviare il messaggio: {path}",
            callNumber: "Numero di telefono che il tuo cliente può chiamare: {phoneNumber}",
            numberIsNotCorrect: "Numero mancante inserito!!",
            emailIsNotCorrect: "E-mail non corretta!",
            selectFab: "Scegli un favoloso",
            notValid:
                "È possibile inserire solo lettere (carattere singolo). Le lettere e,d,f,z,a,x,c,v,w,t,n non sono valide",
            forMacUsers: " Gli utenti Mac possono usare il tasto Control(⌃)",
            basePriceValue: "Base Fiyat",
            basePriceDiscount: "Sconto",
            basePriceCurrency: "Valuta",
            customerDBEnabled: "Selezione del database: utilizzare il server del database del cliente",
            customerDBDisabled: "Selezione del database: utilizzare il server del database Supsis",
            mongoConnectionString: "Collegamento Mongo",
            whatsappBasePriceValue: "Prezzo base Whatsapp",
            whatsappPlusBasePriceValue: "Prezzo base Whatsapp Plus",
            instagramBasePriceValue: "Prezzo base Instagram",
            instagramPlusBasePriceValue: "Prezzo base di Instagram Plus",
            clientAddress: "Indirizzo del cliente",
            customerClientAddress: "Cliente Cliente Indirizzo",
            apiAddress: "Indirizzo API",
            socketAddress: "Indirizzo Socket",
            backendAddress: "Indirizzo Backend",
            panelLogoUrl: "URL del logo del pannello",
            panelCustomCssUrl: "URL CSS personalizzato del pannello",
            customerLogoUrl: "URL del logo del cliente",
            customerCssUrl: "URL CSS personalizzato del cliente",
            siteAlias: "Alias del sito",
            language: "Lingua",
            features: "Caratteristiche",
            interactionPopularity: "Popolarità dell'interazione",
            interactionCount: "Numero di interazioni",
            uniqueUserCount: "Numero di utenti unici",
            allUserPercentage: "(%) Percentuale di tutti gli utenti",
            represantativeSettings: "Impostazioni rappresentative",
            documentTitle: "Modulo documento supsis",
            supsisDocument: "Documento Supsis",
            ApiDoc: "Documentazione API",
            chatBalloonTehemeSettings: "Impostazioni del tema della bolla di chat",
            customLoginFormSettingsTitle: "Impostazioni del modulo di accesso personalizzato",
            addNewField: "Aggiungi nuovo campo",
            editField: "Modifica campo",
            typeHere: "Scrivi qui",
            pco: "PÇO",
            perPage: "/ pagina",
            perPageInFilter: "Pezzo",
            noUserInfoFound: "Nessuna informazione utente trovata",
            startFilter: "Filtro di avvio",
            CHAT: "CHAT",
            showMyChats: "Mostra le mie chat",
            showOnlineAgents: "Mostra agenti online",
            showWaitingChats: "Mostra chat in attesa",
            addNewStatus: "Aggiungi nuovo stato",
            newTitleContent: "Nuovo titolo",
            roleName: "Nome del ruolo",
            error: "Errore",
            contentType: "Tipo di contenuto",
            contentTitle: "Titolo del contenuto",
            newSiteForm: "Nuovo modulo di registrazione del sito",
            updateSiteForm: "Modulo di registrazione del sito di aggiornamento",
            newBannedWordForm: "Nuovo modulo di registrazione delle parole vietate",
            updateBannedWordForm: "Modulo di registrazione delle parole vietate di aggiornamento",
            newWelcomeMessageForm: "Nuovo modulo di registrazione del messaggio di benvenuto",
            updateWelcomeMessageForm: "Modulo di registrazione del messaggio di benvenuto di aggiornamento",
            newDefaultContentForm: "Nuovo modulo di registrazione del contenuto predefinito",
            updateDefaultContentForm: "Modulo di registrazione del contenuto predefinito di aggiornamento",
            newSubjectForm: "Nuovo modulo di registrazione dell'argomento",
            updateSubjectForm: "Modulo di registrazione dell'argomento di aggiornamento",
            showIntro: "Mostra introduzione",
            showChatColorMeaning: "Mostra significato del colore della chat",
            options: "Opzioni",
            resetPassword: "Resetta la password",
            audioLevel: "Livello audio",
            privateChatNotificationSound: "Suono di notifica della chat privata",
            continue: "Continua",
            newRoleForm: "Nuovo modulo di registrazione del ruolo",
            updateRoleForm: "Modulo di registrazione del ruolo di aggiornamento",
            newUserForm: "Nuovo modulo di registrazione utente",
            updateUserForm: "Modulo di registrazione utente di aggiornamento",
            changeOSRForm: "Modulo di registrazione del messaggio offline di aggiornamento",
            tooltipOSRForm: "Modulo di registrazione del messaggio offline di aggiornamento",
            newOSRForm: "Nuovo modulo di registrazione del messaggio offline",
            newOSRMessages: "Nuovo messaggio offline",
            newOsrMessageTitle: "Titolo del messaggio offline",
            updateOSRForm: "Modulo di registrazione del messaggio offline di aggiornamento",
            osrTitle: "Titolo",
            osrTitleDescription: "Il titolo del modulo di supporto offline",
            osrContent: "Contenuto",
            osrContentDescription: "Il contenuto del modulo di supporto offline",
            hello: "Ciao",
            date: "Data",
            startDate: "Data di inizio",
            finish: "Fine",
            start: "Inizio",
            search: "Ricerca",
            endDate: "Data di fine",
            representative: "Rappresentante",
            representative_: "Rappresentante",
            star: "Stella",
            filter: "Filtro",
            reset: "Reset",
            dailyChatList: "Elenco chat giornaliero",
            dailyChatDuration: "Durata della chat giornaliera",
            chatDuration: "Durata della chat",
            dailyChatGraph: "Grafico chat giornaliero",
            ok: "Ok",
            cancel: "Annulla",
            chatCount: "Numero di chat",
            shortest: "Il più breve",
            longest: "Il più lungo",
            average: "Media",
            count: "Contare",
            averagePoint: "Punto medio",
            pointDist: "Distribuzione dei punti",
            point: "Punto",
            filters: "Filtri",
            totalCustomer: "Totale clienti",
            avResponseTime: "Tempo di risposta medio",
            breakDuration: "Durata della pausa",
            breakCount: "Numero di pause",
            active: "Attivo",
            passive: "Passivo",
            userForm: "Modulo utente",
            startChat: "Inizia chat",
            sender: "Mittente",
            profile: "Profilo",
            name: "Nome",
            number: "Numero",
            username: "Nome utente",
            updateUserName: "Aggiorna nome utente",
            email: "E-mail",
            password: "Parola d'ordine",
            oldPassword: "Vecchia password",
            newPassword: "Nuova password",
            passwordAtLeast: "Password (almeno {num} caratteri)",
            passwordRepeat: "Ripeti la password",
            changePassword: "Cambia la password",
            status: "Stato",
            enableState: "Abilita stato",
            douYouWishToDeleteUser: "Vuoi davvero eliminare l'utente?",
            douYouWishToDeleteAnnouncement: "Vuoi davvero eliminare l'annuncio?",
            userDeleted: "Utente eliminato",
            userSaved: "Utente salvato",
            oldPasswordError: "La vecchia password non è corretta",
            chooseAnOption: "Scegli un'opzione",
            userVolumeUpdated: "Volume utente aggiornato",
            save: "Salva",
            update: "Aggiornare",
            addNewMenu: "Aggiungi nuovo menu",
            addNewContent: "Aggiungi nuovo contenuto",
            pleaseTitleEnter: "Inserisci il titolo",
            like: "Piace",
            disLike: "Non mi piace",
            users: "Utenti",
            visitor: "Visitatore",
            allContacts: "Tutti i contatti",
            allUsers: "Tutti gli utenti",
            allSites: "Tutti i siti",
            newUser: "Nuovo utente",
            noNewUser: "Non ci sono ancora nuovi utenti",
            noNewAdminUser: "Non ci sono ancora nuovi utenti amministratori",
            noNewAnnouncement: "Non ci sono ancora nuovi annunci",
            noRoleFound: "Nessun ruolo trovato",
            noBannedWordFound: "Nessuna parola vietata trovata",
            noWelcomeMessageFound: "Nessun messaggio di benvenuto trovato",
            noSubjectFound: "Nessun argomento trovato",
            noVisitorFound: "Nessun visitatore trovato",
            noContactFound: "Nessun contatto trovato",
            sendResponse: "Invia risposta",
            delete: "Elimina",
            duplicate: "Duplicare",
            makeDefault: "Rendi predefinito",
            checkMore: "Controlla di più",
            useReadyTemplates: "Usa modelli pronti",
            useAITemplates: "Usa modelli AI",
            noRePresentativeFound: "Nessun rappresentante trovato",
            noLiveSupportFound: "Nessun supporto live trovato",
            noLiveSupportFoundWithDepartment: " Nessun supporto live trovato con questo dipartimento",
            noBannedVisitorFound: "Nessun visitatore vietato trovato",
            removeBanDescription: "Vuoi davvero rimuovere il divieto?",
            editThisItem: "Modifica questo elemento",
            removeThisItem: "Rimuovi questo elemento",
            role: "Ruolo",
            newRolePlaceHolder: "Inserisci il nome del ruolo",
            autoChatAssignLimit: "Limite di assegnazione chat automatica",
            chatAssignInfo:
                "-1 = Predefinito di sistema, 0 = Nessuna assegnazione, >0 = Assegnazione tanto quanto il valore dato.",
            relatedDepartments: "Dipartimenti correlati",
            subjectInfo: "Seleziona i dipartimenti correlati per questo argomento",
            archive: "Archivio",
            offlineSupportRequests: "Richieste di supporto offline",
            offlineModeMessage: "Messaggio non in linea",
            offlineMode: "Modalità offline",
            first: "Primo",
            last: "Ultimo",
            query: "Query",
            clean: "Pulito",
            loading: "Caricamento",
            loadMore: "Carica altro",
            noMessage: "Nessun messaggio",
            selectChat: "Seleziona chat",
            noMessageInChat: "Nessun messaggio in chat",
            noMediaToShow: "Nessun contenuto multimediale da mostrare",
            firstSeen: "Prima Visione",
            userInfo: "Informazioni sull'utente",
            userProfile: "Profilo",
            addCalendarEvent: "Evento +",
            chatId: "ID chat",
            visitorId: "ID visitatore",
            visitingPage: "Pagina visitata",
            osAndBrowser: "Sistema operativo e browser",
            customerClientVersion: "Versione cliente",
            visitorFeedback: "Feedback del cliente",
            notes: "Note",
            nameSurname: "Nome cognome",
            chats: "Chat",
            bannedVisitors: "Visitatori vietati",
            country: "Nazione",
            city: "Città",
            cityDistrict: "Quartiere cittadino",
            browser: "Browser",
            os: "Sistema operativo",
            ipAddress: "Indirizzo IP",
            connectionDate: "Data di connessione",
            transaction: "Transazione",
            banRemoved: "Divieto rimosso",
            bannedWords: "Parole vietate",
            newBannedWord: "Nuova parola vietata",
            noBannedWord: "Nessuna parola vietata",
            bannedWordForm: "Modulo parola vietata",
            word: "Parola",
            bannedWordAndWordGroup: "Parola/frase vietata",
            doYouWishToDeleteBannedWord: "Vuoi davvero eliminare questa parola vietata?",
            doYouWishToOfflineSupportRequest: "Vuoi eliminare questo messaggio?",
            bannedWordSaved: "Parola vietata salvata",
            deletedSuccessfully: "Eliminato con successo",
            deleteErrorMsg: "Errore durante l'eliminazione",
            socketError: "Problema di connessione presa. Perfavore ricarica la pagina e riprova.",
            socketConnecting: "Connessione al server...",
            offlineModeDescription: "Il sistema è in modalità offline. I visitatori non possono inviare messaggi.",
            offlineModeSettingsDescription:
                "Se la modalità offline è attiva, i visitatori non possono inviare messaggi. Se la modalità offline è disattivata, i visitatori possono inviare messaggi.",
            offlineModeUser: "Modalità offline",
            adminCannotConnectSocket: "L'amministratore non può connettersi al socket. Controlla la connessione.",
            liveSupport: "Supporto dal vivo",
            siteVisitors: "Visitatori del sito",
            visitors: "Visitatori",
            thoseConnectedToLiveSupport: "Coloro che sono connessi al supporto dal vivo",
            visitorHistory: "Cronologia del visitatore",
            visitorHistoryDescription: "Puoi visualizzare e scaricare la cronologia delle chat dei visitatori.",
            privateMessage: "Messaggio privato",
            addRepresentative: "Aggiungi rappresentante",
            forwardRepresentative: "Inoltra rappresentante",
            keyboardShortcuts: "Tasti di scelta rapida",
            chatColorMeanings: "Significati dei colori della chat",
            connLostCheckInternet: "Connessione persa. Controlla la tua connessione a Internet.",
            wishToEndThisChat: "Vuoi davvero terminare questa chat?",
            defaultContents: "Contenuti predefiniti",
            contents: "Contenuti",
            newDefaultContent: "Nuovo contenuto predefinito",
            newCTRLContent: "Nuovo contenuto CTRL",
            newALTContent: "Nuovo contenuto ALT",
            newTABContent: "Nuovo contenuto TAB",
            title: "Titolo",
            shortcutChar: "Carattere di scelta rapida",
            pickOne: "Scegli uno",
            writeSomething: "Digita un carattere (a-z|0-9)",
            letterSequence: "Sequenza di lettere",
            exampleText: "Esempio: calcio -> calcio",
            anyChar: "Qualsiasi carattere",
            shorcutKey: "tasto di scelta rapida",
            content: "Contenuto",
            shortcutName: "Nome di scelta rapida",
            type: "Tipo",
            shortcut: "Scelta rapida",
            deleteContentQuestion: "Vuoi davvero eliminare questo contenuto?",
            defaultContentDeleted: "Contenuto predefinito eliminato",
            defaultContentSaved: "Contenuto predefinito salvato",
            defaultContentForm: "Modulo contenuto predefinito",
            titleContentForm: "Modulo contenuto titolo",
            contentMoved: "Contenuto spostato",
            cannotMoveFullParent: "Non puoi spostare un elemento completo sotto un altro elemento completo.",
            yourEmail: "La tua email",
            yourName: "Il tuo nome e cognome",
            lostPassword: "Hai perso la password?",
            login: "Accesso",
            forgotPassword: "Password dimenticata",
            multipleSession: "Sessione multipla",
            notAuthorizedToDisplayPage: "Non sei autorizzato a visualizzare questa pagina.",
            permissions: "Permessi",
            newPermission: "Nuovo permesso",
            permissionForm: "Modulo di autorizzazione",
            displayTitle: "Titolo visualizzato",
            key: "Chiave",
            keyToUseInSystem: "Chiave da utilizzare nel sistema",
            deletePermissionQuestion: "Vuoi davvero eliminare questo permesso?",
            permissionDeleted: "Permesso eliminato",
            permissionSaved: "Permesso salvato",
            newRole: "Nuovo ruolo",
            selectARole: "Seleziona un ruolo",
            yes: "Sì",
            no: "No",
            fullAuth: "Autorizzazione completa",
            roleDeleted: "Ruolo eliminato",
            sameRole: "C'è un ruolo con lo stesso nome.",
            roleSaved: "Ruolo salvato",
            roleForm: "Modulo ruolo",
            roles: "Ruoli",
            settings: "Impostazioni",
            selectTopic: "Seleziona un argomento",
            autoCallTransfer: "Trasferimento automatico della chiamata",
            customerTyping: "Digitazione del cliente",
            typing: "Digitazione",
            agentTyping: "Digitazione dell'agente",
            disconnectTime: "Tempo per terminare la conversazione (sec)",
            tippyDissconnectTime: "Imposta il numero di secondi dopo i quali la sintesi vocale viene disattivata.",
            queueNumberVisibleFeature: "Funzionalità di visualizzazione del numero di coda",
            privateChatEnabled: "Chat privata abilitata",
            delayedTalkTime: "Tempo di conversazione ritardato (sec)",
            employeeAverageChatCount: "Numero medio di chat per dipendente",
            customerDownTimeWhenRepExit: "Tempo di inattività del cliente quando l'agente esce (sec)",
            autoAssignLimit: "Limite di assegnazione automatica",
            wasted: "Perdere tempo (sec)",
            settingsSaved: "Impostazioni salvate",
            settingsCannotSaved: "Impostazioni non possono essere salvate",
            noAuthorization: "Nessuna autorizzazione",
            warningBadInput: "Si consiglia di inserire un numero compreso tra 0 e 70.",
            warningBadInputMarginY: "Avviso sull'inserimento del margine verticale ⚠️",
            warningBadInputMarginX: "Avviso sull'inserimento del margine orizzontale ⚠️",
            warningBadInputBubbleSize: "Avviso sull'immissione delle dimensioni del fumetto ⚠️",
            settingFormWrong: "I dati inseriti non sono corretti, controlla e riprova.",
            delayTime: "Tempo di ritardo",
            sites: "Siti",
            newSite: "Nuovo sito",
            noSiteYet: "Non hai ancora creato un sito.",
            siteAddress: "Indirizzo del sito",
            turnBack: "Torna indietro",
            customerRepLimit: "Limite cliente / rappresentante",
            siteSaved: "Sito salvato.",
            siteSaveError: "Si è verificato un errore durante il salvataggio del sito.",
            subjects: "Argomenti",
            newSubject: "Nuovo argomento",
            noSubject: "Non hai ancora creato un argomento.",
            subject: "Soggetto",
            subjectTitle: "Titolo dell'argomento",
            description: "Descrizione",
            infoAboutSubject: "Informazioni sull'argomento",
            deleteSubjectQuestion: "Vuoi davvero eliminare questo argomento?",
            subjectDeleted: "Argomento eliminato",
            subjectSaved: "Argomento salvato",
            osrFromMessageSaved: "OSR da messaggio salvato",
            welcomeMessages: "Messaggi di benvenuto",
            newWelcomeMessages: "Nuovo messaggio di benvenuto",
            noWelcomeMessage: "Non hai ancora creato un messaggio di benvenuto.",
            welcomeMessageContent: "Contenuto del messaggio di benvenuto",
            makeChoice: "Fai una scelta",
            welcomeMessage: "Messaggio di benvenuto",
            repLoggedIn: "Temsilci giriş yaptı",
            loginMessage: "Messaggio di disconnessione",
            message: "Messaggio",
            messageTitle: "Titolo del messaggio",
            deleteWelcomeMessageQuestion: "Vuoi davvero eliminare questo messaggio di benvenuto?",
            welcomeMessageDeleted: "Messaggio di benvenuto eliminato",
            welcomeMessageSaved: "Messaggio di benvenuto salvato",
            welcomeMessageForm: "Modulo messaggio di benvenuto",
            noRep: "Nessun rappresentante",
            addChat: "Aggiungi chat",
            forwardChat: "Inoltra chat",
            ago: "fa",
            repName: "Nome rappresentante",
            lastOnline: "Ultimo online",
            lastStatusChange: "Ultima modifica dello stato",
            activeChat: "Chat attiva",
            userMaxCapacity: "Capacità massima dell'utente",
            noActiveChat: "Nessuna chat attiva",
            watch: "Guarda",
            join: "Unisciti",
            open: "Aperto",
            directMessage: "Messaggio diretto",
            block: "Blocca",
            transactions: "Transazioni",
            informations: "Informazioni",
            visitStart: "Ziyaret Başlangıcı",
            fullName: "Nome completo",
            waitChatTime: "Tempo di attesa della chat",
            blockUserConfirm: "Vuoi davvero bloccare questo utente?",
            messaging: "Messaggistica",
            hideChat: "Nascondi chat",
            block_: "Blocca",
            privateMessage_: "Messaggio privato",
            assignRep: "Assegna rappresentante",
            joinChat: "Unisciti alla chat",
            forwardRep: "Inoltra rappresentante",
            leaveChat: "Lascia la chat",
            endChat: "Termina la chat",
            translatedTextDescription: "Amazon ha tradotto {from} -> {to} di questo messaggio.",
            autoTranslate: "Traduzione automatica",
            translateThisMessage: "Traduci questo messaggio",
            autoTranslateDetectedDesc:
                "Il visitatore parla {visitorLanguage}. Fare clic qui per abilitare la traduzione automatica",
            on: "Acceso",
            off: "Spento",
            copy: "Copia",
            prevChats: "Chat precedenti",
            noShortCut: "Nessuna scorciatoia",
            leaveChartConfirm: "Vuoi davvero lasciare questa chat?",
            endChatConfirm: "Vuoi davvero terminare questa chat?",
            chatBar: "Barra della chat",
            endConversation: "Termina la conversazione",
            onlyOneRep: "Solo un rappresentante",
            chatList: "Elenco chat",
            unreadTitle: "Non letto",
            visitorLeftTitle: "Visitatore lasciato",
            activeChatTitle: "Chat attiva",
            autoAssignedTitle: "Assegnato automaticamente",
            watchModeTitle: "Modalità di guardia",
            lostChat: "Chat persa",
            repLostConn: "Connessione persa",
            chatWidthDelay: "Larghezza della chat",
            repChatWidthDelay:
                "Se la larghezza della chat è impostata su 0, la larghezza della chat sarà la larghezza del contenitore della chat.",
            unreadMsg: "Se ci sono messaggi non letti, l'arco sarà rosso.",
            visitorLeftChat: "Se il visitatore lascia la chat, l'arco sarà rosso.",
            activeChatMsg: "Se la chat è attiva, l'arco sarà verde.",
            autoAssignMsg: "Se la chat è assegnata automaticamente, l'arco sarà blu.",
            watchModeMsg: "Se la modalità di guardia è attiva, l'arco sarà blu.",
            online: "Online",
            beRightBack: "Torno subito",
            away: "Assente",
            busy: "Occupato",
            offline: "Offline",
            logout: "Disconnettersi",
            forWindows: "Per Windows",
            forMac: "Per Mac",
            nextChatFromActive: "Passa alla chat successiva dall'attiva",
            previousChatFromActive: "Passa alla chat precedente dall'attiva",
            hideActiveChat: "Nascondi chat attiva",
            closeActiveChat: "Chiudi chat attiva",
            firsthiddenChat: "Connettiti alla conversazione del cliente che ha atteso di più",
            firstChatWaiting: "Connettiti alla prima conversazione in attesa",
            previousOpenedChat: "Connettiti alla conversazione del cliente che hai aperto per primo",
            hashHintMessage: "Con il tasto # puoi inviare un messaggio veloce (esempio: #ciao)",
            pmHintMessage: "Con il tasto @ puoi inviare un messaggio veloce (esempio: @nome)",
            vtippyTicketNotification: "Nuovo ticket",
            newTicketSound: "Suono nuovo ticket",
            vtippyDepartmentNotification:
                "Impostazioni di notifica per i messaggi dalla conversazione del dipartimento",
            vtippyGroupNotification: "Impostazioni di notifica per i messaggi dai gruppi creati",
            vtippyAnnouncemenNotification: "Impostazioni di notifica per i nuovi annunci",
            languageSelection: "Selezione della lingua",
            shortcutHintMessage: "Con il tasto / puoi inviare un messaggio veloce (esempio: /ciao) ",
            switchBetweenConversations: "Passa tra le conversazioni",
            atNameHintMessage: "Con il tasto @ puoi inviare un messaggio veloce (esempio: @nome)",
            dndHintMessage: "Non disturbare",
            pasteFile: "Incolla file",
            atEmailHintMessage: "Con il tasto @ puoi inviare un messaggio veloce (esempio: @email)",
            pastePlainText: "Incolla testo semplice",
            pressAndTalk: "Press and talk",
            historyDetails: "Dettagli cronologia",
            chat: "Chat",
            chatNotFound: "Chat non trovata",
            dataNotFound: "Dati non trovati",
            visitorInfo: "Informazioni sul visitatore",
            timeSpent: "Tempo trascorso",
            noActiveVisitors: "Nessun visitatore attivo",
            select: "Seleziona",
            fullname: "Nome completo",
            text: "Testo",
            numeric: "Numerico",
            phone: "Telefono",
            optionsPlaceholder: "Opzioni separate da virgola",
            selectField: "Seleziona campo",
            fullnameField: "Nome completo",
            textField: "Testo",
            labelField: "Etichetta",
            numericField: "Numerico",
            phoneField: "Telefono",
            departmentField: "Dipartimento",
            emailField: "Email",
            visible: "Visibile",
            required: "Richiesto",
            label: "Etichetta",
            totalConnected: "Totale connessi",
            missedChat: "Chat perse",
            workTime: "Tempo di lavoro",
            closedChatCount: "Numero di chat chiuse",
            activeConvo: "Conversazioni attive",
            notAnswered: "Non risposto",
            delayedConvo: "Conversazioni ritardate",
            leavingRep: "Rappresentante che lascia",
            staffRate: "Valutazione dello staff",
            customLoginAlert: "Accedi con il tuo account",
            atLeastOneLanguage: "Seleziona almeno una lingua",
            requiredField: "Questo campo è obbligatorio.",
            notRequiredField: "Questo campo non è obbligatorio.",
            visibleField: "Questo campo è visibile nel form.",
            notVisibleField: "Questo campo non è visibile nel form.",
            connectServer: "Connessione al server...",
            disconnectServer: "Disconnessione dal server...",
            liveChatOff: "Live chat disattivata",
            visitorScreen: "Schermo del visitatore",
            viewOnTheSite: "Visualizza sul sito",
            viewOnTheSiteTippy: "Visualizza sul sito",
            showHint: "Mostra suggerimento",
            dontShowHint: "Non mostrare suggerimento",
            liveChatOn: "Live chat attivata",
            nightModeOff: "Modalità notturna disattivata",
            nightModeOn: "Modalità notturna attivata",
            edit: "Modifica",
            deleteField: "Elimina campo",
            arrow_upward: "Sposta su",
            arrow_downward: "Sposta giù",
            doubleClickEdit: "Doppio click per modificare",
            newCatalogCategory: "Nuova categoria di catalogo",
            childCreate: "Crea figlio",
            updateCatalogCategoryFrom: "Aggiorna categoria di catalogo",
            newCatalogCategoryFrom: "Nuova categoria di catalogo",
            catalogMenu: "Menu catalogo",
            catalogContent: "Contenuto catalogo",
            catalogCategoryName: "Nome categoria catalogo",
            newCatalogContentFrom: "Nuovo contenuto catalogo",
            catalogContentName: "Nome contenuto catalogo",
            catalogCategorySaved: "Categoria di catalogo salvata.",
            catalogCategoryDeleted: "Categoria di catalogo eliminata.",
            catalogCategoryRate: "Valutazione categoria catalogo",
            catalogContentFeature: "Caratteristica contenuto catalogo",
            vtipyAudioLevel: "Utilizzato per disattivare o riattivare i suoni di notifica.",
            vtipyOrganizationName: "Nome dell'organizzazione.",
            vtipyBrandVisibility: "Seleziona se vuoi che il tuo marchio sia visibile o meno.",
            vtipyBrandVisibilityForced: "Seleziona se vuoi che il tuo marchio sia visibile o meno.",
            vtipyClientDefault: "Seleziona la lingua predefinita per la pagina del cliente.",
            vtipyCustomerClientDefault: "Seleziona la lingua predefinita per la pagina del cliente.",
            vtipyVisitorPreferredLang: "Seleziona la lingua predefinita per la pagina del cliente.",
            vtipyCustomerClientLanguageDetect:
                "Seleziona se vuoi che la lingua del cliente venga rilevata automaticamente.",
            vtipySelectTopic:
                "Seleziona l'argomento che vuoi che i tuoi clienti vedano quando aprono la pagina del cliente.",
            vtipyAutoCallTransfer: "Seleziona se vuoi che le chiamate vengano trasferite automaticamente.",
            vtipyCustomerTyping: "Mostra quando il cliente sta scrivendo.",
            vtipyAgentTyping: "Mostra quando l'agente sta scrivendo.",
            vtipyQueueNumberVisibleFeature:
                "Seleziona se vuoi che il numero di coda sia visibile o meno quando il cliente apre la pagina del cliente.",
            vtipyPrivateChatEnabled: "Seleziona se vuoi che il chat privata sia abilitata o meno.",
            vtipyDelayedTalkTime:
                'Se nessun agente è connesso alla conversazione durante questo periodo, verrà etichettata come "Parola ritardata".',
            vtipyOfflineMode: "Seleziona se vuoi che la modalità offline sia abilitata o meno.",
            vtipyAutoAssignLimit: "Seleziona il numero massimo di conversazioni che un agente può gestire.",
            vtipyCustomerDownTimeWhenRepExit: "Seleziona il tempo di inattività del cliente quando l'agente esce.",
            tippyDisconnectTime: "Seleziona il tempo di disconnessione.",
            changeSettings: "Cambia impostazioni",
            totalBg: "chat totali",
            activeBg: "chat attive",
            watchBg: "GUARDARE",
            waitingBg: "chat in sospeso",
            lateBg: "conversazioni di passaggio",
            freeBg: "GRATUITO",
            maxCapacityBg: "CAPACITÀ MASSIMA",
            addNewSettings: "Aggiungi nuove impostazioni",
            darkMode: "Modalità scura",
            clientDefault: "Lingua predefinita del cliente",
            customerClientDefault: "Lingua predefinita del cliente",
            customerClientLanguageDetect: "Rilevamento automatico della lingua del cliente",
            visitorPreferredLang: "Lingua preferita del visitatore",
            preferredThemeColor: "Colore del tema preferito",
            detail: "Dettaglio",
            langSetting: "Impostazione della lingua",
            supportUs: "Supportaci su Patreon",
            changeLang: "Cambia lingua",
            fontSizeSetting: "Impostazione della dimensione del carattere",
            changeLangDesc: "lingua dell'applicazione {code} come impostazioni.",
            trLang: "Turco",
            enLang: "Inglese",
            fieldRequired: "{field} il campo è obbligatiorio.",
            selectALanguage: "Scegli una lingua",
            selectATheme: "Scegli un tema",
            responseForm: "Modulo di risposta",
            clientRequestInfo: "Informazioni sulla richiesta del cliente",
            createdDate: "Data di creazione",
            descMessage: "Messaggio descrittivo",
            new: "Nuovo",
            lastLoginPlatform: "Ultima piattaforma di accesso",
            requiredFieldField: "il campo è obbligatiorio.",
            catalogCategoryMenu: "Menu categoria catalogo",
            catalogCategoryLeaf: "Foglia categoria catalogo",
            selectAllPermission: "Seleziona tutti i permessi",
            catalogCategories: "Categorie di catalogo",
            copiedClipboard: "Copiato negli appunti",
            organizationLogo: "Logo dell'organizzazione",
            changePlan: "Cambia piano",
            close: "Chiudi",
            vtipyUploadLogo:
                "Puoi caricare il logo dell'organizzazione. Il logo verrà visualizzato nella parte superiore della pagina del cliente.",
            tagName: "Nome del tag",
            tagDescription: "Descrizione del tag",
            tagColor: "Colore del tag",
            userInformations: "informazioni utente",
            incomingChat: "Chat in arrivo",
            support: "Supporto",
            team: "Impostato",
            groups: "Gruppi",
            newConversationStarted: "Nuova conversazione iniziata",
            allHistoryLoaded: "Tutta la cronologia caricata",
            chatCreator: "Creatore di chat",
            enterGroupTitle: "Inserisci il titolo del gruppo",
            requiredTitle: "Non puoi lasciare vuoto il campo del titolo",
            requiredChannel: "Il nome del canale non può essere vuoto",
            next: "Confermare",
            selectPeople: "Seleziona Persone",
            textLimitAlertMessage:
                "Il limite di caratteri in WhatsApp è di 19 caratteri e oltre questo limite non verrà visualizzato. Tuttavia, sul Web, i testi che superano il limite di 19 caratteri vengono automaticamente spostati nella riga successiva e visualizzati.",
        },
        telegram: {
            typeInTelegramToken: "Inserisci il token di Telegram",
            token: "Token",
            telegram: "Telegram",
            telegramTokenTitle: "Token di Telegram",
            telegramAlertForm: "Modulo di avviso di Telegram",
            telegramAlertTitle: "Titolo dell'avviso di Telegram",
            telegramAlertText: "Testo dell'avviso di Telegram",
        },
        wp: {
            whatsapp: "Whatsapp",
            chatStartingWait: "Avvio della chat, attendere prego...",
            chatStarted: "Chat avviata",
            chatNotStarted: "Chat non avviata",
            contactSelected: "Contatto selezionato",
            startChatWithAnyNo: "Avvia una chat con qualsiasi numero",
            toLittleChar: "Inserisci almeno 3 caratteri",
            typeInANumberDesc: "Digita un numero di telefono per avviare una chat",
            wpPlusAndLicenceRequired: "Piano Whatsapp Plus e licenza richiesti.",
            wpPlusAndLicenceRequiredDesc:
                "Per utilizzare il servizio Whatsapp, è necessario disporre di un piano Whatsapp Plus e di una licenza.",
            agreement: "Accordo",
            purchase: "Acquista",
            activating: "Attivazione",
            authenticating: "Autenticazione",
            ready: "Pronto",
            activationTitle: "Abilitare l'integrazione di Whatsapp su Supsis:",
            wpIntegrationInstruction1: "Apri Whatsapp sul tuo telefono e vai su Impostazioni.",
            wpIntegrationInstruction2: "Selezionare Menu o Impostazioni e fare clic su Dispositivi connessi. ",
            wpIntegrationInstruction3: "Punta il telefono su questa schermata per scansionare il codice",
            qrGeneratingWait: "Generazione del codice QR in corso, attendere...",
            pleaseContinueToWaitUntilCompleted:
                "Dopo che il codice QR è stato verificato, passerà automaticamente al campo completato. Attendere prego...",
            authenticatingWait: "Accesso, attendere prego...",

            enableFeature: "Abilita funzionalità",
            unsubscribeWpInetgration: "Annulla l'abbonamento all'integrazione di Whatsapp",
            unsubscribeIGIntegration: "Annulla l'abbonamento all'integrazione di Instagram",
            wpBack: "Torna a Whatsapp",
            terminatelWpInetgration:
                "Quando fai clic sul pulsante Annulla abbonamento, il tuo abbonamento verrà annullato e non potrai utilizzare il servizio Whatsapp.",
            cancelWpInetgration: "Vuoi annullare l'abbonamento all'integrazione di Whatsapp?",
            terminatelIGIntegration:
                "Quando fai clic sul pulsante Annulla abbonamento, il tuo abbonamento verrà annullato e non potrai utilizzare il servizio Instagram.",
            cancelIGIntgeration: "Vuoi annullare l'abbonamento all'integrazione di Instagram?",
            startChatWp: "Avvia chat su Whatsapp",
            readAndAgree: "Ho letto e accetto l'accordo",
            subscribe: "Abbonati",
            subscribed: "Abbonato",
            toEnableWpDescription:
                "Per abilitare l'integrazione di Whatsapp, è necessario disporre di un piano Whatsapp Plus e di una licenza.",
            waitForWpActivationDescription:
                "Attendere che il servizio Whatsapp venga attivato. Questo processo può richiedere fino a 24 ore. Riceverai una notifica quando il servizio verrà attivato.",
            greatWpActivatedDescription:
                "Grande! Il servizio Whatsapp è stato attivato. Puoi iniziare a utilizzare il servizio.",
            unsubscribe: "Annulla abbonamento",
            planDetails: "Dettagli del piano",
            sendReceiveMessage: "Invia & Ricevi Messaggio ",
            sendReceiveImage: "Invia & Ricevi Immagine",
            sendReceiveAudio: "Invia & Ricevi Audio ",
            sendReceiveGif: "Invia & Ricevi Gif ",
            startChat: "Supsis Avvia Chat",
            supsisFunctionality: "Funzionalità Supsis",
            onePhoneMultiAgent: "Un telefono, più agenti",
            basicIntegration: "Integrazione di base",
            purchaseHeader: "Acquistare Integrazione Supsis-Whatsapp",
            wpServices: "Servizi Whatsapp",
            wpServicesIntegrationCompleted: "Integrazione dei servizi Whatsapp completata",
            purchasePaymentDescription:
                "Per utilizzare il servizio Whatsapp, è necessario disporre di un piano Whatsapp Plus e di una licenza.",
            wpIntegrationFeatures: "Funzionalità di integrazione di Whatsapp",
            saveChanges: "Salva modifiche",
            contactList: "Elenco dei contatti",
            broadcast: {
                broadcast: "Trasmissione",
                detail: "Dettaglio",
                customer: "Cliente",
                phoneNumbers: "Numeri di telefono",
                showMore: "Mostra di più",
                showLess: "Mostra meno",
                groupName: "Nome del gruppo",
                messages: "Messaggi",
                status: "Stato",
                usageCost: "Costo di utilizzo",
                sendingTime: "Tempo di invio",
                progress: "Progresso",
                groupDetail: "Dettaglio del gruppo",
                messagesPerContact: "Messaggi per contatto",
                successRatio: "Rapporto di successo",
                message: "Messaggio",
            },
            messages: "Messaggi",
            broadcastRequests: "Richieste di trasmissione",
            customerGroups: "Gruppi di clienti",
            messageTemplates: "Modelli di messaggi",
            plans: "Piani",
            wpIntegrationRequired: "Integrazione di Whatsapp richiesta",
            wpRequiredIntegrationDescription:
                "Per utilizzare il servizio Whatsapp, è necessario disporre di un piano Whatsapp Plus e di una licenza.",
            integrateWp: "Integra Whatsapp",
            active: "Attivo",
            archived: "Archiviato",
            createBroadcastMessage: "Crea un messaggio di trasmissione",
            title: "Titolo",
            description: "Descrizione",
            createdAt: "Creato a",
            numbers: "Numeri",
            actions: "Azioni",
            action: "Azione",
            createCustomerGroup: "Crea un gruppo di clienti",
            search: "Ricerca",
            name: "Nome",
            contacts: "Contatti",
            noContactFound: "Nessun contatto trovato",
            broadcastTitle: "Titolo della trasmissione",
            recipients: "Destinatari",
            selectRecipients: "Seleziona i destinatari",
            writeYourMessage: "Scrivi il tuo messaggio",
            schedule: "Programma",
            scheduleNowOrLater: "Programma ora o più tardi",
            summary: "Sommario",
            cancel: "Annulla",
            send: "Invia",
            sending: "Invio",
            deleteCustomerGroup: "Sei sicuro di voler eliminare questo gruppo di clienti? {name}",
            customerGroupDeleting: "Eliminazione del gruppo di clienti in corso",
            customerGroupDeletingSuccess: "Gruppo di clienti eliminato con successo",
            customerGroupDeletingError: "Errore durante l'eliminazione del gruppo di clienti",
            wpPlusRequired: "Richiesto Whatsapp Plus",
            broadcastMessageArchived: "Messaggio di trasmissione archiviato",
            broadcastMessageNotArchived: "Il gruppo di messaggi broadcast non è stato archiviato",
            groupNameSearch: "Inserisci il nome del gruppo cliente",
            groupNameDesc: "Il nome del gruppo cliente identifica i tuoi gruppi di clienti",
            save: "Salva",
            number: "NUMERO",
            addColumn: "Aggiungi colonna",
            addColumnDesc: "Aggiungi una colonna alla tabella",
            addNewContact: "Aggiungi nuovo contatto",
            addNewContactDesc: "Aggiungi una persona alla tabella",
            importFile: "Importa da file",
            importFileDesc: "Importa i contatti da un file Excel o CSV",
            contactAdded: "Contatto aggiunto",
            updateCustomerGroup: "Aggiornamento gruppo cliente in corso...",
            updateCustomerGroupSuccess: "Gruppo cliente aggiornato con successo",
            sendBroadcastMessage: "Invia messaggio broadcast",
            columnName: "Nome colonna",
            columnType: "Tipo colonna",
            defaultValue: "Valore predefinito",
            setDefaultValue: "Imposta il valore predefinito per i contatti esistenti",
            age: "Età",
            location: "Posizione",
            gender: "Genere",
            selectContactFile: "Seleziona il file dei contatti",
            selectContactCsvOrExcel: "Seleziona un file CSV o Excel",
            importConfiguration: "Importa la tua configurazione",
            customizeFile: "Personalizza il file dei contatti aggiunti",
            sendMessageTo: "A chi desideri inviare il messaggio?",
            allContact: "Tutti i contatti",
            messageTypes: "Tipi di messaggio",
            whenSendMessage: "Quando desideri inviare il messaggio?",
            instantlyRightNow: "Immediatamente, adesso",
            completed: "Completato",
            scheduleFuture: "Pianifica per una data futura",
            messageDesc: "Il tuo messaggio sarà inviato istantaneamente a tutti i destinatari",
            messageSendAt: "Il tuo messaggio sarà inviato a tutti i destinatari in questa data: ",
            estimatedPrice: "Prezzo stimato",
            estimatedTime: "Tempo stimato",
            now: "Adesso",
            tenMinute: "10 minuti",
            cancelled: "Annullato",
            failed: "Fallito",
            running: "In esecuzione",
            queued: "In coda",
            scheduled: "Pianificato",
            noNumberAdded: "Nessun numero aggiunto",
            csvOrExcelFile: "File CSV o Excel",
            broadcastMessagesToContactFile: "Invia messaggi broadcast alla lista contatti",
            broadcastMessageTemplates: "Modelli di messaggi broadcast",
            messageFlow: "Flusso del messaggio",
            textMessageSupport: "Supporto messaggi di testo",
            imageMessageSupport: "Supporto messaggi con immagini",
            spamPreventions: "Prevenzione dello spam",
            includesAllBasicPlans: "Include tutte le funzionalità del pacchetto WhatsApp",
            chatbotIntegration: "Integrazione con chatbot",
            messageToNewNumbers: "Invio messaggi ai nuovi numeri",
            broadcastMessageToEveryone: "Invio messaggi broadcast a tutti",
            personalizedBroadcastMessage: "Messaggi broadcast personalizzati",
            customerGroupSegmentation: "Segmentazione del gruppo cliente",
            scheduleBroadcastMessage: "Pianificazione messaggi broadcast",
            locationMessageSupport: "Supporto messaggi di posizione",
            advancedSpamPreventions: "Prevenzione avanzata dello spam",
            whatsappPlans: "Piani WhatsApp",
            selectBestPlan: "Seleziona il piano migliore per te",
            comingSoon: "Disponibile a breve...",
            selectFile: "Seleziona un file",
            created: "Creato",
            message: "Messaggio",
        },
        ig: {
            instagram: "Instagram",
        },
        ticket: {
            ticketTagFilter: "Filtro Tag Ticket",
            ticketEmails: "Lista Indirizzi Email di Reindirizzamento Ticket",
            save: "Salva",
            delete: "Elimina",
            transactions: "Transazioni",
            noEmailTicketNotifications: "Nessuna notifica via email per il reindirizzamento dei ticket trovata",
            emailIsNotValid: "Indirizzo email non valido",
            emailNotificationDeleted: "Notifica via email per il reindirizzamento dei ticket eliminata",
            emailNotificationDeleteError:
                "Impossibile eliminare la notifica via email per il reindirizzamento dei ticket",
            tagFilterRequired:
                "È necessario specificare un filtro di tag per i ticket. Puoi utilizzare il carattere jolly '*' per tutti i ticket!",
            emailsRequired: "È necessario specificare almeno un indirizzo email per il reindirizzamento dei ticket",
            emailNotificationCreated: "Creata notifica via email per il reindirizzamento dei ticket",
            emailNotificationCreateError: "Impossibile creare la notifica via email per il reindirizzamento dei ticket",
            ticketForwarding: "Reindirizzamento Email dei Ticket",
            ticketTagFilterDesc:
                "Utilizza i tag dei ticket utilizzati nel design del chatbot per filtrare i ticket. Puoi inserire un tag diverso e premere Invio per aggiungerlo. Seleziona '*' per tutti i ticket.",
            ticketEmailsDesc:
                "Elenco degli indirizzi email a cui reindirizzare i ticket. Puoi selezionare gli indirizzi email dei rappresentanti del sistema o aggiungere indirizzi email esterni.",
            ticketList: "Regole di Reindirizzamento dei Ticket",
            ticketTagFilterPlaceHolder: "Filtro ticket, seleziona '*' per tutti",
            ticketEmailsPlaceHolder: "Elenco indirizzi email di reindirizzamento",
        },
        theme: {
            headerColor1: "Colore Intestazione (Sinistra)",
            headerColor1A: "Colore/Trasparenza dell'Intestazione",
            headerColor2: "Colore Intestazione (Destra)",
            headerColor2A: "Colore/Trasparenza dell'Intestazione 2",
            backgroundColor: "Colore di Sfondo (Sinistra)",
            backgroundColorA: "Colore/Trasparenza di Sfondo 1",
            backgroundColor2: "Colore di Sfondo (Destra)",
            backgroundColor2A: "Colore/Trasparenza di Sfondo 2",
            opacity: "Trasparenza",
            textColor: "Colore Testo Generale",
            errorTheme: "Colore Errore",
            bubbleBackground: "Colore Sfondo Bubble (Agente)",
            bubbleVisitorBackground: "Colore Sfondo Bubble (Visitatore)",
            bubbleBackgroundA: "Trasparenza Bubble (Agente)",
            bubbleVisitorBackgroundA: "Trasparenza Bubble (Visitatore)",
            bubbleText: "Colore Testo Bubble (Agente)",
            bubbleVisitorText: "Colore Testo Bubble (Visitatore)",
            textFormColor: "Colore Testo Form",
            selectCustom: "Seleziona Tema Personalizzato",
            font: "Carattere",
            headerColorSecond: "Colore Superiore Intestazione",
            headerColorFirst: "Colore Inferiore Intestazione",
            backgroundColorFirst: "Colore Superiore Sfondo",
            formColor: "Colore Testo Form",
            buttonColor: "Colore Pulsante",
            backgroundColorSecond: "Colore Inferiore Sfondo",
            chatBotButtonText: "Colore del carattere del chatbot",
            chatBotButtonColor: "Colore pulsante chatbot",
        },
        billing: {
            paymentStatus: "Stato pagamento",
            amount: "Importo",
            invoiceID: "ID Fattura",
            expected: "Previsto...",
            currentAmount: "Importo attuale",
            monthlyEstimatedAmount: "Importo mensile stimato",
            creationDate: "Data di creazione",
            invoiceStatus: "Stato della fattura",
            invoicePeriod: "Periodo di fatturazione",
            newPaymentMethod: "Nuovo metodo di pagamento",
            channelCount: "Numero di canali",
            remainingTime: "Tempo rimanente",
            chatbotLimit: "Limite chatbot",
            free: "Gratuito",
            maxChatbotSession: "Sessioni massime del chatbot",
            buyIt: "Acquista",
            renewalDate: "Data di rinnovo",
            monthly: "Mensile",
            yearly: "Annuale",
            packagePeriod: "Periodo del pacchetto",
            packageType: "Tipo di pacchetto",
            packageManagement: "Gestione pacchetti",
            invoiceManagement: "Gestione delle fatture",
            futureInvoice: "Fattura futura",
            pastInvoices: "Fatture passate",
            creditCard: "Carta di credito",
            invoice: "Fattura",
            mustBeUpgradePlanForChatBot: "Per attivare la funzione di Chatbot, è necessario passare al piano Pro!",
            cardInfo: "Informazioni sulla carta",
            billingDetails: "Dettagli di fatturazione",
            addCardIyzico:
                "Non hai una carta registrata. Per poter pagare le tue tariffe mensili, è necessario aggiungere una carta. Il sistema di pagamento è fornito da iyzico.",
            billingPlanSettings: "Impostazioni di fatturazione e metodo di pagamento",
            paymentMethod: "Metodo di pagamento",
            billingDate: "Data di fatturazione",
            isPaid: "È stato pagato?",
            paid: "Pagato",
            markPaid: "Contrassegna come pagato",
            paymentDate: "Data di pagamento",
            pay: "Paga Fattura",
            newInvoice: "Nuova Fattura",
            updateBilling: "Modifica Indirizzo di Fatturazione",
            updateCard: "Cambia Carta di Credito",
            paymentBilling: "Metodo di pagamento e indirizzo di fatturazione",
            price: "Importo Fattura",
            billingAddress: "Indirizzo di Fatturazione",
            billingCity: "Città di Fatturazione",
            billingCountry: "Paese di Fatturazione",
            contactName: "Nome del contatto per la fatturazione",
            expireMonth: "Mese di Scadenza",
            expireYear: "Anno di Scadenza",
            cardNumber: "Numero di Carta",
            cardHolderName: "Nome del Titolare della Carta",
            cardAlias: "Alias della Carta",
            identityNumber: "Numero di Identificazione/Fiscale",
            name: "Nome",
            surname: "Cognome",
            email: "Email",
            addCard: "Aggiungi Carta",
            update: "Aggiorna",
            cancel: "Annulla",
            save: "Salva",
            saving: "Salvataggio in corso",
            noInvoiceFound: "Nessuna fattura trovata",
            year: "Anno",
            updating: "Aggiornamento in corso",
            newInvoiceForm: "Nuovo Modulo di Creazione Fattura",
            error: "Errore",
            transactions: "Transazioni",
            paymentMethodAdded: "Metodo di pagamento aggiunto con successo",
            paymentMethodAddError: "Impossibile aggiungere il metodo di pagamento, si è verificato un errore",
            creditCardChanged: "La tua carta di credito è stata cambiata",
            errorOccurred: "Si è verificato un errore, riprova.",
            billingDetailUpdated: "Le tue informazioni di fatturazione sono state aggiornate",
            invoiceCreated: "La fattura è stata creata con successo",
            paymentSuccess: "La tua fattura è stata pagata con successo, grazie",
            paymentFail: "Si è verificato un errore durante il pagamento della fattura, riprova più tardi.",
            startWith: "Carta {binNumber} che inizia con {cardFamily}",
            billingAddressChanged: "Le informazioni sull'indirizzo di fatturazione sono state aggiornate",
            hidePlan: "Nascondi Piano",
            informationShopping:
                "Le tue informazioni di pagamento, di fatturazione e di carta di credito sono controllate da Shopify.",
            trialTimeInformation:
                "Restano {dayCount} giorni al termine della versione di prova. Se non inserisci un metodo di pagamento entro questo periodo, il sistema passerà automaticamente al piano GRATUITO.",
            trialTimeInformationShort: "{dayCount} giorni rimanenti",
            currentPlanLabel: "Piano attuale: Piano {planName} ({agentCount} Agenti)",
            changeCancelPlan: "Cambia/Annulla Piano",
            oneAgent: "Agente",
            agent: "Agente",
            yourCurrentPlan: "Il tuo Piano Attuale",
            month: "Mese",
            billedMonthToMonth: "(Fatturazione mensile)",
            selectAgentCount: "Seleziona il Numero di Agenti",
            selectFreePlan: "Seleziona il Piano Gratuito",
            planDetails: "Dettagli del Piano",
            multiAgent: "(Multi-agente)",
            selectProPlan: "Seleziona il Piano Pro",
            foreverFree: "Sempre Gratis",
            websiteIntegration: "Integrazione del Sito Web",
            websiteIntegrationUnlimited: "Integrazione del Sito Web",
            ChatBotUnlimited: "Chatbot",
            videoCallUnlimited: "Chiamata Video",
            multiAgentUpTo: "Multi-agente (fino a {agentCount} Agenti)",
            audioCallUnlimited: "Chiamata Audio",
            screenSharingUnlimited: "Condivisione Schermo",
            fileTransferUnlimited: "Trasferimento File",
            autoChatAssignerUnlimited: "Assegnazione Chat Automatica",
            multiLanguageTranslationUnlimited: "Traduzione Multilingue Automatica",
            detailedReporting: "Report Dettagliati",
            days30TrialsAvailable: "Versione di Prova di 30 Giorni",
            limitedArchiveLookupLastMo: "Ricerca Archivio Limitata (Ultimi {monthCount} mesi)",
            fullCustomizationUnlimited: "Personalizzazione Completa",
            planUpdated: "Il tuo piano è stato aggiornato con successo.",
            planUpdating: "Aggiornamento del piano in corso...",
            planUpdatingDescription: "Attendere durante l'aggiornamento!",
            done: "Fatto",
            freePlanUpdated: "Il tuo piano è stato aggiornato al Piano Gratuito. (Numero massimo di Agenti: 1)",
            proPlanUpdated:
                "Il tuo piano è stato aggiornato al Piano Pro. (Numero massimo di Agenti: {proPlanUpdated})",
            canNotDwnGrade:
                "Il tuo piano non può essere ridotto da {agentCountFirst} a {valNewPlnToUppr} {agentCountSecond}! I crediti degli Agenti sono in uso.",
            deleteWarning: "È necessario eliminare {valDif} Agenti.",
            warnMessage: "Il piano selezionato deve essere diverso dal piano attuale",
            add: "Aggiungi",
            cancelYourPlan: "Annulla il Tuo Piano",
            upgradeYourPlan: "Passa a un Piano Superiore",
            downgradeYourPlan: "Riduci il Tuo Piano",
            agree: "ACCETTA",
            disagree: "ANNULLA",
            invoices: "Fatture",
            priceIntervals: "Intervallo di Prezzo",
            selectSiteAlias: "Inserisci o Seleziona il Nome del Sito",
            selectPriceInterval: "Inserisci o Seleziona l'Intervallo di Prezzo",
            isRefunded: "Rimborsato",
            invoiceId: "ID Fattura",
            siteId: "ID Sito",
            createdDate: "Data di Creazione",
            failCount: "Numero di Tentativi di Pagamento Falliti",
            failDate: "Data di Pagamento Non Effettuato",
            Dashboard: "Dashboard",
            Agents: "Agenti",
            Integration: "Integrazione",
            Settings: "Impostazioni",
            Contacts: "Contatti",
            Domain: "Dominio",
            lastActivity: "Ultima Attività",
            basePrice: "Prezzo Base",
            packagePrice: "Prezzo Pacchetto",
            whatsappPrice: "Prezzo WhatsApp",
            realtimeVisitorCount: "Numero di Visitatori in Tempo Reale",
            suspend: "Sospendi",
            partner: "Partner",
            plan: "Piano",
            trialDay: "Giorno di Prova",
            mobile: "Mobile",
            webSite: "Sito Web",
            websiteOrigins: "Origini del Sito Web",
            ownerName: "Nome del Proprietario",
            ownerEmailAddress: "Indirizzo Email del Proprietario",
            discount: "Sconto",
            daysLeft: "Giorni Rimanenti",
            newTrialPopUp: "Quanti giorni dovrebbe durare la nuova prova gratuita?",
            newWpPricePopUp: "Quanto dovrebbe essere il nuovo prezzo di WhatsApp?",
            newIGPricePopUp: "Quanto dovrebbe essere il nuovo prezzo di Instagram?",
            newBasePricePopUp: "Quanto dovrebbe essere il nuovo prezzo di base di Supsis?",
            siteInfoUpdated: "Informazioni sul Sito Aggiornate",
            siteInfoNotUpdated: "Informazioni sul Sito Non Aggiornate",
            siteInfoNotUpdatedErr: "Errore durante l'aggiornamento delle informazioni sul sito.",
        },
        tour: {
            representativeTab: "Rappresentante Tabella",
            stats: "PANNELLO DI STATISTICHE",
            chats: "PANNELLO CHAT",
            settings: "IMPOSTAZIONI",
            status: "STATO",
            prevStep: "Passo Precedente",
            nextStep: "Passo Successivo",
            finish: "Fine",
            skip: "Salta",
            skip2: "Conosco già il sistema, non mostrare di nuovo",
            startTour: "Inizia Tour",
            firstTimeIntro:
                "Ho notato che è la tua prima volta nel sistema. Sei d'accordo se avvio un breve tour introduttivo?",
            hi: "Ciao",
            welcomeTo: "Benvenuto in Supsis Live Support",
            statsPanel: "È una barra di stato che mostra il numero di chat in attesa, totali e attive in tempo reale.",
            sidebarMenu: "Menu",
            sidebarMenuContent: "Puoi navigare tra le pagine da qui.",
            representativePrivateMessage: "Pannello Messaggi Privati Rappresentante",
            representativePrivateMessageContent: "Puoi visualizzare i messaggi privati tra i rappresentanti da qui.",
            helpMenu: "Menu di Aiuto",
            helpMenuContent: "Puoi accedere alle informazioni di aiuto sul sistema da qui.",
            settingsMenu: "Menu Impostazioni",
            settingsMenuContent:
                "Puoi impostare la lingua, la modalità notturna e il ridimensionamento dello schermo da qui.",
            startChat: "Inizia chat",
            profileMenu: "Menu Profilo",
            profileMenuContent: "Puoi modificare la tua disponibilità e le impostazioni del rappresentante da qui.",
            visitorsTab: "Visitatori",
            visitorsTabContent: "Puoi visualizzare i visitatori da qui.",
            visitorTabHistory: "Cronologia Visitatori",
            visitorTabHistoryContent: "Puoi visualizzare la cronologia dei visitatori da qui.",
            representativ_eTab: "Rappresentanti",
            representativeTabContent: "Puoi visualizzare i rappresentanti da qui.",
            liveSupport: "Supporto Live",
            liveSupportContent: "Puoi visualizzare il numero di clienti nel supporto live da qui.",
            siteVisitors: "Visitatori del Sito",
            siteVisitorsContent: "Puoi visualizzare il numero di visitatori del sito da qui.",
            tableSettings: "Impostazioni Tabella",
            tableSettingsContent: "Puoi mostrare o nascondere le colonne nella tabella da qui.",
            watchModeButton: "Pulsante Modalità Osservatore",
            watchModeContent: "Puoi partecipare come osservatore e vedere solo i messaggi inviati.",
            popoverInfo: "Dettagli Visitatore",
            popoverInfoContent: "Fornisce informazioni sul visitatore.",
            popoverButton: "Impostazioni Avanzate Chat",
            popoverButtonContent:
                "Puoi aprire la chat, inviare messaggi privati al rappresentante o bloccare il visitatore.",
            openChat: "Pulsante Apri Chat",
            openChatContent: "Puoi aprire la chat da qui.",
            pagination: "Menu di Paginazione",
            paginationContent: "Puoi aumentare il numero di pagine da qui.",
            chatwindow: {
                chatWindowSettingsButtons: "PULSANTI IMPOSTAZIONI FINESTRA DI CHAT",
                chatWindowActionButtons: "PULSANTI AZIONE GENERALE FINESTRA DI CHAT",
                chatPanelActions: "AZIONI PANNELLO DI CHAT",
                otherPanels: "ALTRI PANNELLI",
                settingsButton:
                    "Puoi bloccare la chat, instradarla, inviare messaggi privati e assegnare un rappresentante.",
                chatColorButton: "Puoi scoprire il significato dei colori delle bolle di chat da qui.",
                keyboardShortcutButton: "Puoi trovare le scorciatoie per le funzioni utili durante la scrittura.",
                hideButton: "Riduce la chat attiva in basso e rimane aperta sullo sfondo.",
                closeButton: "Termina la chat attiva e esci dalla conversazione.",
                ellipsisButton:
                    "Qui troverai altre opzioni come invio di messaggi privati, blocco del visitatore o assegnazione di un rappresentante.",
                userInfoWidget: "Fornisce informazioni dettagliate sul visitatore.",
                preparedContentWidget:
                    "Qui troverai modelli di contenuto predefiniti. Puoi aggiungerli rapidamente premendo o utilizzando la sequenza di tasti corrispondente nell'area di scrittura della chat.",
                chatHistoryWidget:
                    "Se il visitatore ha una cronologia di chat precedenti, verrà elencata qui. Puoi consultare le conversazioni passate da qui.",
                chatBarButton:
                    "Puoi bloccare la chat attiva, inviare messaggi privati al rappresentante e uscire dalla chat.",
            },
        },
        adminUser: {
            newAdminUserForm: "Nuovo Modulo Utente Admin",
            updateAdminUserForm: "Modulo di aggiornamento utente admin",
            adminUsers: "Utenti Admin",
            newAdminUser: "Nuovo Utente Admin",
            noAdminUser: "Nessun Utente Admin",
            adminUserName: "Nome Utente Admin",
        },
        report: {
            hourly: "(Orario)",
            hourlyAverage: "Media oraria",
            hourlyMax: "Massimo orario",
            hourlyMin: "Minimo orario",
            totalAmount: "Importo Totale",
            averageAmount: "Importo Medio",
            minAmount: "Importo Minimo",
            maxAmount: "Importo Massimo",
            siteCount: "site Count",
            agentCount: "Agent Count",
            channelsTimeSeries: "Serie temporali dei canali",
            channelPies: "Torte dei canali",
            pieView: "Grafico a torta",
            topVisitorCountry: "Paese con più visitatori",
            websiteTrafficByCountry: "Traffico del sito web per Paese",
            visitorCount: "Numero di visitatori",
            websiteVisitorTraffic: "Traffico visitatori del sito web",
            websiteTraffic: "Traffico del sito web",
            author: "Autore",
            topWorstComments: "Commenti Peggiori",
            topBestComments: "Commenti Migliori",
            topComments: "Commenti Migliori",
            noComment: "Nessun commento ancora",
            minWaitingTime: "Tempo di attesa minimo",
            maxWaitingTime: "Tempo di attesa massimo",
            averageWaitTime: "Tempo di attesa medio",
            waitTime: "Tempo di attesa (secondi)",
            agentWaitDurationTitle: "Grafico della durata di attesa dell'agente",
            incomingMessage: "Messaggio(i) in arrivo",
            outgoingMessage: "Messaggio(i) in uscita",
            totalSpent: "Totale speso",
            avgSpent: "Media spesa",
            totalPayment: "Pagamento totale",
            walletStatus: "Stato del portafoglio",
            walletBalanceStatus: "Stato del saldo del portafoglio",
            messageTraffic: "Traffico di messaggi",
            breakCount: "Conteggio delle pause",
            agentBreakTime: "Conteggi delle pause dell'agente ☕",
            agentStatusHour: "Ora dello stato dell'agente",
            agentWorkTimeCalendar: "Calendario del tempo di lavoro dell'agente",
            agentActivity: "Attività dell'agente",
            noEnoughtData: "Dati non sufficienti",
            averageFirstResponse: "Tempo medio di prima risposta",
            slowestResponser: "Più lento a rispondere",
            fastestResponder: "Più veloce a rispondere",
            firstAnswerTimeSec: "Tempo del primo messaggio (in secondi)",
            firstAnswerByAgent: "Tempo del primo messaggio da parte dell'agente",
            averageSolutionTime: "Tempo medio di soluzione",
            slowestSolver: "Risoluzione più lenta",
            fastestSolver: "Risoluzione più veloce",
            averageChat: "Chat media",
            leastChatReceiver: "Ricevitore di chat meno attivo",
            mostChatRecipients: "Il maggior numero di destinatari della chat",
            averageTicket: "Average Ticket",
            leastTicketReceiver: "Least Ticket Least",
            mostTicketRecipients: "Most Ticket Recipients",
            resolveTime: "Tempo di risoluzione (min)",
            resolveTimeByUser: "Tempo di risoluzione della chat per l'utente (in minuti)",
            chatResolveTimeByAgent: "Tempo di risoluzione della chat per gli agenti",
            chatDistByHandleType: "Distribuzione chat per handler",
            chatDistByHandDesc: "Quanti chat sono state gestite da agenti, chatbot e ibridi?",
            chatCountsByHandleType: "Numero di chat per tipo di gestione",
            missed: "Perso",
            answered: "Risposto",
            chatDistByAnsDesc: "Quante chat sono state risposte o perse?",
            chatCountsByAns: "Conteggio chat per risposta",
            chatCountByPlatform: "Conteggio chat per piattaforma",
            chatDistByPDesc: "Quanti chat sono arrivate su quale piattaforma?",
            chatDistByPlatform: "Distribuzione della chat per piattaforma",
            ticketCountByUser: "Ticket Counts by Agents",
            ticketCountByStatus: "Ticket Counts by Response Status",
            user: "Utente",
            saveAsImage: "Salva come immagine",
            fullScreen: "Schermo intero",
            download: "Scarica",
            tableView: "Vista tabella",
            chartView: "Vista grafico",
            chatDistByUsers: "Distribuzione delle chat per utenti",
            chatCountsByUsers: "Conteggio delle chat per utenti",
            minDuration: "Durata minima",
            maxDuration: "Durata massima",
            totalDurationByAgent: "Durata totale della sessione per agente",
            averageDurationByAgent: "Durata media della sessione per agente",
            totalDurationByCB: "Durata totale della sessione per chatbot",
            averageDurationByCB: "Durata media della sessione per chatbot",
            viewUnitAs: "Visualizza unità come",
            hybrid: "Ibrido",
            handledBy: "Gestito da",
            sessionDurationOverall: "Durata complessiva della sessione",
            allChannels: "Tutti i Canali",
            sessionsDurationOverall: "Durata complessiva delle sessioni",
            sessionsOverall: "Sessioni complessive",
            calendarEvents: "Eventi del calendario",
            reservationEvents: "Eventi di prenotazione",
            incomingMails: "Mail in arrivo",
            incomingMailCount: "Conteggio delle mail in arrivo",
            reservation: "Prenotazione",
            event: "Evento",
            reservationEventCount: "Numero di eventi di prenotazione",
            channelBreakdown: "Ripartizione dei canali",
            websiteAnalysis: "Analisi del sito web",
            customerSatisfaction: "Soddisfazione del cliente",
            teamBreakAnalysis: "Analisi delle pause del team",
            dailyAgentActivity: "Attività quotidiana dell'agente",
            agentPerformance: "Prestazioni dell'agente",
            chatDistributions: "Distribuzione delle chat",
            users: "Utenti",
            segmentTimeseries: "Serie temporale del segmento",
            segmentsOverall: "Segmenti Complessivi",
            unmatchRatio: "Rapporto di non corrispondenza",
            totalMatchCount: "Conteggio totale delle corrispondenze",
            totalUnmatchCount: "Conteggio totale delle non corrispondenze",
            matchRatio: "Rapporto di corrispondenza",
            matched: "Abbinato",
            trainingOverall: "Formazione Complessiva",
            trainingStatusTimeseries: "Serie temporale dello stato di formazione",
            duration: "Durata",
            totalSessionDuration: "Durata totale della sessione",
            averageSessionDuration: "Durata media della sessione",
            second: "secondo",
            minute: "minuto",
            hour: "ora",
            aggregateAs: "Aggrega come",
            chatbotSessionDurationOverall: "Durata complessiva della sessione del chatbot",
            ratingTimeSeries: "Serie temporale delle valutazioni",
            chatCountTimeseries: "Serie temporale del numero di chat",
            notRated: "Non valutato",
            totalRatingCount: "Numero totale di valutazioni",
            averageRating: "Valutazione media",
            weightedAverageRating: "Valutazione media ponderata",
            rate: "Valuta",
            ratingOverall: "Customer Ratings Overall",
            session: "Sessione",
            total: "Totale",
            average: "Media",
            max: "Massimo",
            min: "Minimo",
            sessionCount: "Conteggio sessioni",
            uniqueUsers: "Utenti Unici",
            viewAs: "Visualizza come:",
            overall: "Complessivo",
            detailReport: "Rapporto Dettagliato",
            dailyReports: "Rapporti Giornalieri",
            pointBasedReports: "Rapporti Basati su Punti",
            personDateBasedPointReport: "Rapporto Punti Basato su Persona e Data",
            personDateBasedReport: "Rapporto Basato su Persona e Data",
            personBasedReport: "Rapporto Basato su Persona",
            personAndDateBasedGraph: "Grafico Basato su Persona e Data",
            noReport: "Nessun Rapporto",
            reports: "Rapporti",
            totalBar: "Barra Totale",
            ticketCount: "Ticket Count",
        },
        announcements: {
            menu: "Annunci",
            newAnnouncementForm: "Nuovo Modulo di Annuncio",
            updateAnnouncementForm: "Modulo di aggiornamento annuncio",
        },
        stats: {
            total: "Totale: È il numero di conversazioni attive nel sistema.",
            active: "Attive: È il numero di conversazioni attive che ti appartengono.",
            waiting: "In attesa: È il numero di nuove conversazioni in attesa di assegnazione di un rappresentante.",
            late: "In ritardo: È il numero di nuove conversazioni in attesa di assegnazione di un rappresentante dopo un certo periodo di tempo.",
            free: "Libere: È il numero di conversazioni in attesa di assegnazione di un nuovo rappresentante dopo che il precedente ha terminato.",
            pco: "[Personel Çalışma Oranı]: È il tasso di occupazione delle conversazioni totali che i rappresentanti online possono gestire nel sistema.",
            maxCapacity:
                "Capacità massima: È il numero massimo di conversazioni che il sistema può gestire senza mettere in attesa.",
            chatbot: "Chatbot: È il numero di conversazioni attive gestite dal chatbot.",
        },
        time: {
            lastYear: "L'anno Scorso",
            thisYear: "Quest'anno",
            last3Months: "Ultimi 3 Mesi",
            last7: "Ultimi 7 Giorni",
            today: "Oggi",
            yesterday: "Ieri",
            lastWeek: "Settimana scorsa",
            currentWeek: "Questa settimana",
            currentMonth: "Questo mese",
            lastMonth: "Mese scorso",
            last30Day: "Ultimi 30 giorni",
            allTime: "Sempre",
            custom: "Periodo personalizzato",
        },
        fastWizard: {
            generalColors: "Colori generali",
            tellUsMore: "Forniscici ulteriori informazioni per personalizzare la tua esperienza",
            moreInfo: "Impostazioni generali",
            display: "Impostazioni del tema",
            availability: "Orari di disponibilità degli operatori",
            preview: "Anteprima",
            installCode: "Installazione",
            previous: "Passaggio precedente",
            setupSupsisLiveChat: "Configurazione rapida di SUPSIS LIVE Chat",
            continue: "Passaggio successivo",
            completeInitialize: "Completa l'inizializzazione rapida",
            completedMessage: "Configurazione rapida di SUPSIS Live Chat completata con successo.",

            websiteIntegration: "Indirizzo del tuo sito web per l'integrazione di SUPSIS Live",

            customizeLiveChat: "Personalizza la chat dal vivo",
            createBrandedExperience: "Crea un'esperienza di chat personalizzata per i visitatori.",
            chatColor: "Colore della chat",
            chooseChatColor: "Scegli un colore.",
            chatBubble: "Bolla di chat",
            selectBubble: "Seleziona una bolla di chat",
            chatBubbleColor: "Colore della bolla di chat",
            selectChatBubbleColor: "Seleziona il colore della bolla di chat",
            customSelection: "Selezione personalizzata:",

            onlineSupportVisitorTime: "In quali fasce orarie fornisci assistenza ai visitatori?",
            channelAvailability: "Disponibilità del canale",
            availability724: "Servizio continuativo 24/7",
            basedOnTeam: "In base agli orari di lavoro degli operatori",
            basedOnTeamExplanation:
                "La chat sarà disponibile online quando ci sarà almeno 1 operatore online. Se non ci sono operatori online, apparirà come offline",
            customHours: "Orari di lavoro personalizzati",
            customHoursExplanation: "Imposta i tuoi orari di lavoro",
            customHoursTimezone: "Fuso orario:",
            customHoursFrom: "Da:",
            customHoursTo: "A:",
            customHoursAddHours: "+ Aggiungi ora",

            previewDesktop: "Desktop",
            previewIpad: "Tablet",

            installationAndInstructions: "Installazione e istruzioni",
            installationTrackingCode: "Carica il codice di monitoraggio sul tuo sito web",
            installationTrackingCodePlease:
                "Incolla il codice sottostante subito prima della chiusura del tag {bodyTag} su qualsiasi pagina in cui desideri attivare SUPSIS Live Chat.",
            installationInstructionsJavascript:
                "Incolla il codice di integrazione fornito sopra all'interno del tag {bodyTag}, subito prima della chiusura.",
            installationInstructionsShopify1: "1. Accedi al pannello di controllo di Shopify",
            installationInstructionsCopy: "Copia",
            installationInstructionsCoppyMessage: "Le istruzioni di integrazione sono state copiate negli appunti",
            installationInstructionsShopify2:
                "2. Vai a Online Store > Temi > Azioni, seleziona Current Theme > Modifica codice > theme.liquid",
            installationInstructionsShopify3:
                "3. Incolla il codice di integrazione fornito sopra subito prima del tag {bodyTag} alla fine dello script theme.liquid.",
            installationInstructionsIdeaSoft1: "1. Accedi al pannello di amministrazione di IdeaSoft",
            installationInstructionsIdeaSoft2: "2. Vai su Impostazioni > SEO > Servizi per i motori di ricerca",
            installationInstructionsIdeaSoft3: '3. Seleziona l\'opzione "Convalida del sito tramite tag meta".',
            installationInstructionsIdeaSoft4:
                "4. Incolla il codice di integrazione fornito sopra nella casella aperta e salva.",
            installationInstructionsIdeaSoft5:
                '5. Vai su Impostazioni > Ottimizzazioni > "Cancella cache". L\'integrazione è completata.',
            installationInstructionsWordPress1: "1. Accedi al pannello di amministrazione di WordPress",
            installationInstructionsWordPress2: "2. Vai su Aspetto > Editor di Temi",
            installationInstructionsWordPress3:
                "3. Trova e seleziona il file del piè di pagina (footer.php) nella sezione File del tema (a destra)",
            installationInstructionsWordPress4:
                "4. Incolla il codice di integrazione fornito sopra prima del tag {bodyTag} nella parte inferiore del file.",
            installationInstructionsWordPress5: "5. Clicca su Aggiorna file per salvare le modifiche",
            installationInstructionsOpenCart1: "1. Accedi al pannello di amministrazione di OpenCart",
            installationInstructionsOpenCart2: "2. Vai su Design > Editor di Temi",
            installationInstructionsOpenCart3: "3. Seleziona la cartella 'common' e apri il file 'header.twig'",
            installationInstructionsOpenCart4:
                "4. Incolla il codice di integrazione fornito sopra prima del tag {headTag} nella parte superiore del file.",
            installationInstructionsOpenCart5: "5. Clicca su Salva",
            installationInstructionsTicimax1: "1. Accedi al pannello di amministrazione di Ticimax",
            installationInstructionsTicimax2: "2. Vai su Design > Impostazioni di design > Header/Footer Design",
            installationInstructionsTicimax3: "3. Fai clic sul pulsante 'Sorgente' nel design del logo.",
            installationInstructionsTicimax4:
                "4. Incolla il codice di integrazione fornito sopra sotto il codice HTML.",
            installationInstructionsEticaretteyim1: "1. Accedi al pannello di amministrazione di Eticaretteyim",
            installationInstructionsEticaretteyim2:
                "2. Vai su Moduli > Genera HTML > Dai un nome a SUPSIS e copia il codice.",
            installationInstructions: "Istruzioni",
            installationVerify: "Verifica l'installazione di SUPSIS sul tuo sito web",
            installationVerifyChecking: "Verifica in corso",
            installationVerifyCheck: "Verifica",
            installationVerifyCheckingStatus:
                "Controllo dello stato di integrazione di SUPSIS Live su {website} in corso",
            installationCheckingStatusMessageYes: "SUPSIS LIVE è integrato con successo su {website}.",
            installationCheckingStatusMessageNo:
                "SUPSIS non è attualmente integrato con il sito web {website}. Puoi completare il processo di integrazione ora o in seguito.",

            vtippyPreferredLanguage: "Lingua preferita:",
        },
        akinon: {
            typeOrSelectSKU: "Inserisci o seleziona l'SKU",
            akinonUserId: "ID utente Akinon",
            userEmail: "Email utente",
            userEmailDesc: "Inserisci o seleziona l'email dell'utente...",
            send: "Invia",
            selectCity: "Seleziona città",
            city: "Città",
            selectState: "Seleziona stato",
            state: "Stato",
            useMap: "Usa mappa",
            chooseAddress: "Seleziona indirizzo",
            selectCountry: "Seleziona Paese",
            country: "Paese",
            productIdDesc: "Inserisci o seleziona l'ID del prodotto...",
            productId: "ID prodotto",
            userIdDesc: "Inserisci l'ID utente Akinon...",
            productSKU: "SKU prodotto",
            latitudeDesc: "Inserisci o seleziona la latitudine della posizione di destinazione...",
            longitudeDesc: "Inserisci o seleziona la longitudine della posizione di destinazione...",
            orderNumber: "Numero d'ordine",
            orderDesc: "Inserisci il numero d'ordine...",
            longitude: "Longitudine",
            latitude: "Latitudine",
        },
        probel: {
            branchCode: "Codice filiale",
            branchCodeDesc: "Inserisci o seleziona il codice filiale...",
            hospitalBranchCode: "Codice del reparto ospedaliero",
            hospitalBranchCodeDesc: "Inserisci o seleziona il codice del reparto ospedaliero...",
            clinicCode: "Codice clinica",
            clinicCodeDesc: "Inserisci o seleziona il codice della clinica...",
            date: "Data appuntamento",
            dateDesc: "Inserisci o seleziona la data dell'appuntamento...",
            patientToken: "Token del paziente",
            patientTokenDesc: "Inserisci o seleziona il token del paziente...",
            appointmentId: "ID appuntamento",
            appointmentIdDesc: "Inserisci o seleziona l'ID dell'appuntamento...",
            identityType: "Tipo di documento d'identità",
            identityNumber: "Numero documento d'identità",
            name: "Nome del paziente",
            surname: "Cognome del paziente",
            gender: "Genere del paziente",
            birthDay: "Data di nascita del paziente",
            phoneNumber: "Numero di telefono del paziente",
            identityTypeDesc: "Inserisci o seleziona il tipo di documento d'identità...",
            identityNumberDesc: "Inserisci o seleziona il numero del documento d'identità...",
            nameDesc: "Inserisci o seleziona il nome del paziente...",
            surnameDesc: "Inserisci o seleziona il cognome del paziente...",
            genderDesc: "Inserisci o seleziona il genere del paziente...",
            birthDayDesc: "Inserisci o seleziona la data di nascita del paziente...",
            phoneNumberDesc: "Inserisci o seleziona il numero di telefono del paziente...",
        },
        headBar: {
            email: "Email",
            phone: "Telefono",
            name: "Nome",
            date: "Data",
            subject: "Oggetto",
            situation: "Situazione",
            representative: "Rappresentante",
            transactions: "Transazioni",
        },
        login: {
            loginTitle1: "Benvenuti alla",
            loginTitle2: "SUPSIS",
            email: "Indirizzo Email",
            emailPlaceholder: "Inserisci il tuo indirizzo email.",
            emailError: "Inserisci un indirizzo email valido",
            password: "Password",
            passwordLogin: "Accesso senza password",
            passwordAndLogin: "Accedi con password",
            passwordNew: "Resetta la mia password",
            loginAnd: "Oppure",
            passwordPlaceholder: "Inserisci la tua password.",
            loginMemory: "Ricorda questo dispositivo",
            passwordForget: "Ho dimenticato la password",
            passwordNewAgain: "Nuova password",
            passwordNewAgainTwo: "Conferma nuova password",
            passwordNewAgainPlaceholder: "Inserisci la tua nuova password.",
            passwordNewAgainPlaceholderTwo: "Conferma la tua nuova password.",
            login: "Accedi",
            loginFooter: "Oppure accedi tramite email",
            emailLogin: "Accedi tramite email",
        },
        settings: {
            auditlogs: "Audit Logs",
            myaccount: "My Account",
            notifications: "Notifications",
            company: "Azienda",
            features: "Caratteristiche",
            general: "Generale",
            chat: "Chat",
            wallet: "portafoglio",
            timings: "Impostazioni di orario",
            language: "Lingua",
            "bubble-settings": "Impostazioni del palloncino di chat",
            "bubble-actions": "Funzionalità del palloncino di chat",
            "theme-settings": "Impostazioni del tema di chat",
            visitorLoginForm: "Modulo di accesso visitatori",
            visitorAttribute: "Informazioni sul profilo del visitatore",
            timing_settings: "Impostazioni di orario",
            auto_assign: "Auto Chat Assign",
            availability: "Orari di disponibilità dell'operatore",
            "website-integration": "Integrazione del sito web",
            General: "Generale",
            Chat: "Chat",
            Timings: "Impostazioni di orario",
            Integration: "Integrazione",
            developer: "Sviluppatore",
            ıntegration: "Integrazione",
            visitorNew: "Passaggio al nuovo design visitatori",
            companySubtitles: "Gestisci le informazioni generali dell'azienda.",
            featuresSubtitles: "Gestisci le funzionalità intelligenti di Supsis.",
            languageSubtitles: "Gestisci la lingua preferita dell'azienda.",
            bubbleSettings: "Impostazioni del palloncino di chat",
            bubbleSettingsSubtitles: "Gestisci le impostazioni del palloncino di chat.",
            bubbleActionsSubtitles:
                "Espandi le funzionalità del palloncino di chat. Puoi condividere con i visitatori le informazioni relative a WhatsApp, email e telefono della tua azienda.",
            chatThemeSettingsSubtitles: "Gestisci le impostazioni del tema di chat.",
            visitorLoginFormSubtitles: "Gestisci le impostazioni del modulo di accesso visitatori.",
            chatTimingSettingsSubtitles:
                "Impostazioni di durata della chat: controlli e opzioni di durata della conversazione.",
            webSiteIntegrationSubtitles: "Aggiungi un palloncino di chat al tuo sito web.",
            apiAccessTitle: "Accesso API",
            apiAccessSubtitles: "Puoi accedere al tuo codice token da qui.",
            youTubeActionForm: "Aggiungi il tuo canale YouTube",
            linkedinActionForm: "Aggiungi il tuo account Linkedin",
            telegramActionForm: "Aggiungi un account Telegram",
            facebookActionForm: "Aggiungi la tua pagina Facebook",
            tiwitterActionForm: "Aggiungi il tuo account Twitter",
            instagramActionForm: "Aggiungi il tuo account Instagram",
            liveSupportDescription: "Apri una chat in diretta con i tuoi clienti",
            ticketDescription: "Apri una chat in diretta con i tuoi clienti",
            whatsappDescription: "Permetti ai tuoi clienti di contattarti tramite WhatsApp",
            phoneDescription: "Permetti ai tuoi clienti di contattarti telefonicamente",
            emailDescription: "Permetti ai tuoi clienti di contattarti via email",
            facebookDescription: "Permetti ai tuoi clienti di contattarti tramite Facebook",
            twitterDescription: "Permetti ai tuoi clienti di contattarti tramite Twitter",
            instagramDescription: "Permetti ai tuoi clienti di contattarti tramite Instagram",
            youtubeDescription: "Permetti ai tuoi clienti di contattarti tramite YouTube",
            linkedinDescription: "Consenti ai tuoi clienti di raggiungerti con LinkedIn",
            telegramDescription: "Consenti ai tuoi clienti di raggiungere le dimensioni con Telegram",
            whatsappModalTitle: "Modulo di azione di WhatsApp",
            whatsappModalDescription: "Compila il seguente modulo per collegare il tuo account WhatsApp.",

            phoneModalTitle: "Modulo di azione telefonica",
            phoneModalDescription: "Compila il seguente modulo per collegare il tuo numero di telefono.",
            emailModalTitle: "Modulo di azione email",
            emailModalDescription: "Compila il seguente modulo per collegare il tuo account email.",
            facebookModalTitle: "Modulo di azione di Facebook",
            facebookModalDescription: "Compila il seguente modulo per collegare il tuo account Facebook.",
            twitterModalTitle: "Modulo di azione di Twitter",
            twitterModalDescription: "Compila il seguente modulo per collegare il tuo account Twitter.",
            instagramModalTitle: "Modulo di azione di Instagram",
            instagramModalDescription: "Compila il seguente modulo per collegare il tuo account Instagram.",
            youtubeModalTitle: "Modulo di azione di YouTube",
            youtubeModalDescription: "Compila il seguente modulo per collegare il tuo account YouTube.",
            linkedinModalTitle: "Modulo di transazione LinkeIn",
            linkedinModalDescription: "Compila il modulo sottostante per collegare il tuo account LinkedIn.",
            telegramModalTitle: "Modulo di transazione Telegram",
            telegramModalDescription:
                "Inserisci il link del tuo profilo Telegram nel modulo sottostante per collegare il tuo account Telegram",
            instagramAlertTitle: "Integrazione Instagram richiesta",
            instagramAlertDesc: "Spiacente, la pagina che hai visitato verrà attivata quando integri il tuo Instagram.",
            instagramActivateText: "Andiamo, integriamo Instagram",
            remove: "Rimuovi",
            edit: "Modifica",
            connected: "Collegato",
            add: "Aggiungi",
            themeDescription: "Impostazioni del tema di chat.",
            fontDescription: "Impostazioni del carattere di chat.",
            emailTitle: "Inserisci il tuo indirizzo email",
            emailMessage: "Messaggio di invio email iniziale",
            isFabsAsIcon: "Mostra icone di menu.",
            chatBubbleTextSetting: "Impostazione del testo della bolla di chat",
            textOnChatBubble: "Puoi regolare le impostazioni del testo che appariranno nel fumetto della chat.",
            textToAppearOnChatBubble: "Testo da visualizzare nel fumetto della chat",
            newVisitorProfileInformation: "Nuove informazioni sul profilo del visitatore",
            newVisitorProfileInformationDescription:
                "Aggiunge nuovo valore alle informazioni del profilo del visitatore",
            create: "Creare",
            newAdd: "Aggiungere nuova",
            toInform: "Informare",
            toInformDescription:
                "Puoi abbinare i valori che aggiungi in questa pagina con il modulo di accesso del visitatore.",
            showVisitor: "Mostra visitatore",
            label: "Biglietto",
            text: "Scrivere",
            email: "E-mail",
            phone: "Telefono",
            number: "Numero",
            url: "URL",
            date: "Tempo",
            dropdown: "selezionabile",
            languageTimeZone: "Lingua e regione",
            timeZoneTitle: "Regione e fuso orario",
            timeZoneDescription: "Impostazioni di regione e fuso orario",
        },
        userInfoWidget: {
            userInformation: "Informazioni utente",
            fullName: "Nome e cognome",
            newValue: "Nuovo valore",
            newProfileInfo: "Nuove informazioni sul profilo",
            affiliatedRepresentatives: "Rappresentanti",
            preferredAgents: "Agente(i) preferito(i)",
            labels: "Etichette",
            agentNotes: "Note dell'agente",
            newNote: "Nuova Nota",
            note: "Nota",
            available: "nota disponibile.",
            systemInformation: "Informazioni di sistema",
            speechID: "ID vocale",
            customerVersion: "Versione cliente",
            IPAddress: "Indirizzo IP",
            pageVisited: "Pagina visitata",
            systemAndBrowser: "Sistema operativo e browser",
            countryAndLanguage: "Paese e lingua",
            clickToEdit: "Modifica Fare clic all'interno del post",
            adsYouAreInterestedIn: "Annunci di tuo interesse",
            detail: "Dettaglio",
            adsTitle: "Titolo",
            adUrl: "URL dell'annuncio",
            sourceID: "ID fonte",
            resourceType: "Tipo di risorsa",
            adsBody: "Contenuto",
            adsCreateDate: "Data di creazione",
            adsUpdateDate: "Data di aggiornamento",
        },
        newWizartV2: {
            generalSettings: "impostazioni generali",
            themeSettings: "Impostazioni tema",
            representativeWorkingHours: "Orario di lavoro rappresentativo",
            preview: "anteprima",
            setup: "Impostare",
            formStepTitle: "Forniscici maggiori informazioni in modo che possiamo personalizzare la tua esperienza",
            supsisEntergation: "Dove userai Supsis sul tuo sito web? :",
            goToNextStep: "Fai il prossimo passo",
            readytemplate: "Usa modello di colore pronto",
            customSettings: "Impostazioni personalizzate",
            customerMessageView: "Messaggio del cliente Visualizza",
            backcgroundColor: "Colore di sfondo",
            textColor: "Colore del carattere",
            agentMessageView: "Vista messaggio agente",
            workingHours: "Con quali intervalli di tempo fornisci servizi ai tuoi visitatori?",
            continuousService: "Servizio continuo",
            continuousServiceDescription: "La bolla della chat è sempre attiva. Anche se non sei nel sistema.",
            vote: "Fate la vostra scelta",
            representativeWorking: "Temsilci Çalışma Saatleri Dahilinde",
            representativeWorkingDescription:
                "La chat appare online quando almeno 1 agente è online. Se non è presente un rappresentante online, verrà visualizzato come offline.",
            computer: "Computer",
            tablet: "Tavoletta",
            uploadTrackingCodeToYourWebsite: "Carica il codice di monitoraggio sul tuo sito web",
            password: "Imposta nuova password",
        },
        whatsappChannel: {
            whatsappTitleV1: "Canali Whatsapp V1 (QR)",
            whatsappTitleV2: "Canali Whatsapp V2 (QR)",
            channelName: "Nome Canale",
            phoneNumber: "Numero di Telefono",
            forwardToChatbot: "Inoltra al Chatbot",
            forwardingChatbotOrLiveAgent: "Inoltro (Chatbot o Agente Live)",
            addChannel: "Aggiungi Canale",
            newWhatsappChannel: "Nuovo Canale WhatsApp",
            newWhatsappChannelDescription: "Crea un nuovo canale WhatsApp scansionando il codice QR",
            editWhatsappChannel: "Modifica Canale WhatsApp",
            editWhatsappChannelDescription: "Modifica canale WhatsApp",
            whatsappChannel: "Canale WhatsApp",
            deleteWhatsappChannelDescription: "Sei sicuro di voler eliminare questo canale?",
            whatsappIntegration: "Integrazione WhatsApp",
            deleteChannel: "Elimina Canale",
            restartChannel: "Riavvia Canale",
            wantRestartChannel: "Vuoi riavviare il canale?",
            deleteSMSChannelDescription: "Sei sicuro di voler eliminare il canale SMS?",
            smsChannel: "Canale SMS",
            maxChannelCount: "Non puoi creare più di un canale SMS!",
            smsModalText:
                "La nostra integrazione con le moderne soluzioni di comunicazione ti dà l'opportunità di inviare SMS in modo semplice ed efficace. Elimina i confini nella comunicazione, connettiti direttamente con i tuoi clienti!",
            smsModalBtn: "Fare clic per aprire il canale SMS...",
            postaCellDetail: "Dettagli canale PostaCell",
        },
        noPermission: "Non hai il permesso di eseguire questa operazione.",
        mail_integration_detail: {
            title: "Dettagli della posta",
            integration: "Integrazione",
            sender: "Email del mittente",
            signature: "Firma",
            inbox: "Posta in arrivo",
            medias: "Media",
            visibility: "Visibilità",
            settings_group: "Impostazioni",
            contacts: "Contatti",
        },
        whatsapp_business_api: {
            title: "Canali Whatsapp Business API",
            integration: "Integrazione",
            detail: "Dettaglio",
            visibility: "Visibilità",
            templates: "Tutti i Messaggi Modello",
            settings_group: "Impostazioni",
            template_message_group: "Messaggi Modello",
            chat_initiator_template: "Modello di inizio chat",
            contacts: "Contatti",
            numbers: "Numeri",
            all_contacts: "Tutti i contatti",
            new_template: "Crea nuovo Modello",
            broadcast_group: "Trasmissione",
            broadcast_requests: "Richieste di Trasmissione",
            customer_groups: "Gruppi Clienti",
            businessChannelDetail: "Dettagli del canale Whatsapp Business",
            wallet: "Wallet",
            postacellMessage: "Invia SMS",
            postacellAllMessage: "Invia SMS di massa",
            message_group: "Messaggio",
            createNewTemplate: "Crea nuovo messaggio modello",
            templateName: "Nome del modello",
            templateNameDesc: "Dai un nome al tuo modello di messaggio.",
            viewTemplates: "Visualizza modelli",
            templateNameRules: "Il nome del modello può includere solo lettere minuscole, numeri e trattini bassi.",
            category: "Categoria",
            categoryDesc: "Seleziona il tipo di modello che desideri creare",
            categoryUtility: "Utilità",
            categoryUtilityDesc:
                "Invia informazioni di utilità come aggiornamenti dell'account, aggiornamenti degli ordini, avvisi e altro.",
            categoryMarketing: "Marketing",
            categoryMarketingDesc:
                "Invia offerte promozionali, offerte di prodotti e altro per aumentare la consapevolezza e l'interazione.",
            categoryAuth: "Autenticazione",
            categoryAuthDesc: "Invia codici per consentire ai tuoi clienti di accedere ai loro account.",
            optional: "Opzionale",
            languageDesc: "Seleziona la lingua in cui verrà inviato il tuo messaggio di modello",
            header: "Intestazione",
            headerRules:
                "Aggiungi un'intestazione di 60 caratteri al tuo messaggio. Nell'intestazione è supportata solo una variabile.",
            headerOptionMedia: "Media",
            headerOptionText: "Testo",
            none: "Nessuno",
            headerType: "Tipo di intestazione",
            headerText: "Testo dell'intestazione",
            body: "Corpo",
            bodyRules: "Inserisci il testo nella lingua che hai scelto per il tuo messaggio",
            addVariable: "Aggiungi variabile",
            variables: "Variabili",
            variable: "Variabile",
            defaultVariableName: "Nome variabile predefinito",
            defaultVariableToolTip:
                "La tua variabile appare nel template con questo nome. <br><br> Inoltre, questo valore viene inviato come predefinito in caso di altre situazioni.",
            selectATemplate: "Seleziona un modello di messaggio",
            variableSettings: "Impostazioni variabili",
            example: "Esempio",
            footer: "Piè di pagina",
            footerDesc:
                "Aggiungi un piè di pagina di 60 caratteri al tuo messaggio. Le variabili non sono supportate nel piè di pagina.",
            buttons: "Pulsanti",
            buttonType: "Tipo di pulsante",
            buttonTypeReply: "Rispondi",
            submit: "Salva",
            submitting: "Invio in corso",
            addButton: "Aggiungi pulsante",
            rejectWhatsapp: "Respinto da Whatsapp.",
            approvedWhatsapp: "Approvato da Whatsapp.",
            pendingWhatsapp: "In attesa di approvazione",
        },
    },
};

export const langResources = messages;
// Create VueI18n instance with options
export const i18n = new VueI18n({
    locale: "en", // set locale
    fallbackLocale: "tr",
    messages, // set locale messages
});
